__meteor_runtime_config__ = Object.assign({
  "meteorEnv": {},
  "DDP_DEFAULT_CONNECTION_URL": ""
}, window.__meteor_runtime_config__);

//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Package-scope variables */
  var global, meteorEnv, Meteor;

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/global.js                                                                            //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Export a reliable global object for all Meteor code.
    global = this;

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/client_environment.js                                                                //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    var config = __meteor_runtime_config__;
    meteorEnv = config.meteorEnv;

    /**
     * @summary The Meteor namespace
     * @namespace Meteor
     */
    Meteor = {
      /**
       * @summary Boolean variable.  True if running in production environment.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isProduction: meteorEnv.NODE_ENV === "production",

      /**
       * @summary Boolean variable.  True if running in development environment.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isDevelopment: meteorEnv.NODE_ENV !== "production",

      /**
       * @summary Boolean variable.  True if running in client environment.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isClient: true,

      /**
       * @summary Boolean variable.  True if running in server environment.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isServer: false,

      /**
       * @summary Boolean variable.  True if running in Cordova environment.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isCordova: false,

      /**
       * @summary Boolean variable. True if running in a "modern" JS
       *          environment, as determined by the `modern` package.
       * @locus Anywhere
       * @static
       * @type {Boolean}
       */
      isModern: config.isModern
    };

    if (config.gitCommitHash) {
      /**
       * @summary Hexadecimal Git commit hash, if the application is using Git
       *          for version control. Undefined otherwise.
       * @locus Anywhere
       * @static
       * @type {String}
       */
      Meteor.gitCommitHash = config.gitCommitHash;
    }

    if (config.PUBLIC_SETTINGS) {
      /**
       * @summary `Meteor.settings` contains deployment-specific configuration options. You can initialize settings by passing the `--settings` option (which takes the name of a file containing JSON data) to `meteor run` or `meteor deploy`. When running your server directly (e.g. from a bundle), you instead specify settings by putting the JSON directly into the `METEOR_SETTINGS` environment variable. If the settings object contains a key named `public`, then `Meteor.settings.public` will be available on the client as well as the server.  All other properties of `Meteor.settings` are only defined on the server.  You can rely on `Meteor.settings` and `Meteor.settings.public` being defined objects (not undefined) on both client and server even if there are no settings specified.  Changes to `Meteor.settings.public` at runtime will be picked up by new client connections.
       * @locus Anywhere
       * @type {Object}
       */
      Meteor.settings = {
        "public": config.PUBLIC_SETTINGS
      };
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/define-package.js                                                                    //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    function PackageRegistry() {
      this._promiseInfoMap = Object.create(null);
    }

    var PRp = PackageRegistry.prototype;

    // Set global.Package[name] = pkg || {}. If additional arguments are
    // supplied, their keys will be copied into pkg if not already present.
    // This method is defined on the prototype of global.Package so that it
    // will not be included in Object.keys(Package).
    PRp._define = function definePackage(name, pkg) {
      pkg = pkg || {};

      var argc = arguments.length;
      for (var i = 2; i < argc; ++i) {
        var arg = arguments[i];
        for (var s in arg) {
          if (!(s in pkg)) {
            pkg[s] = arg[s];
          }
        }
      }

      this[name] = pkg;

      var info = this._promiseInfoMap[name];
      if (info) {
        info.resolve(pkg);
      }

      return pkg;
    };

    PRp._has = function has(name) {
      return Object.prototype.hasOwnProperty.call(this, name);
    };

    // Returns a Promise that will resolve to the exports of the named
    // package, or be rejected if the package is not installed.
    PRp._promise = function promise(name) {
      var self = this;
      var info = self._promiseInfoMap[name];

      if (!info) {
        info = self._promiseInfoMap[name] = {};
        info.promise = new Promise(function (resolve, reject) {
          info.resolve = resolve;
          if (self._has(name)) {
            resolve(self[name]);
          } else {
            Meteor.startup(function () {
              if (!self._has(name)) {
                reject(new Error("Package " + name + " not installed"));
              }
            });
          }
        });
      }

      return info.promise;
    };

    // Initialize the Package namespace used by all Meteor packages.
    global.Package = new PackageRegistry();

    if (typeof exports === "object") {
      // This code is also used by meteor/tools/isobuild/bundler.js.
      exports.PackageRegistry = PackageRegistry;
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/helpers.js                                                                           //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    if (Meteor.isServer) var Future = Npm.require('fibers/future');

    if (typeof __meteor_runtime_config__ === 'object' && __meteor_runtime_config__.meteorRelease) {
      /**
       * @summary `Meteor.release` is a string containing the name of the [release](#meteorupdate) with which the project was built (for example, `"1.2.3"`). It is `undefined` if the project was built using a git checkout of Meteor.
       * @locus Anywhere
       * @type {String}
       */
      Meteor.release = __meteor_runtime_config__.meteorRelease;
    }

    // XXX find a better home for these? Ideally they would be _.get,
    // _.ensure, _.delete..

    // _get(a,b,c,d) returns a[b][c][d], or else undefined if a[b] or
    // a[b][c] doesn't exist.
    //
    Meteor._get = function (obj /*, arguments */) {
      for (var i = 1; i < arguments.length; i++) {
        if (!(arguments[i] in obj)) return undefined;
        obj = obj[arguments[i]];
      }
      return obj;
    };

    // _ensure(a,b,c,d) ensures that a[b][c][d] exists. If it does not,
    // it is created and set to {}. Either way, it is returned.
    //
    Meteor._ensure = function (obj /*, arguments */) {
      for (var i = 1; i < arguments.length; i++) {
        var key = arguments[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
      }

      return obj;
    };

    // _delete(a, b, c, d) deletes a[b][c][d], then a[b][c] unless it
    // isn't empty, then a[b] unless it isn't empty.
    //
    Meteor._delete = function (obj /*, arguments */) {
      var stack = [obj];
      var leaf = true;
      for (var i = 1; i < arguments.length - 1; i++) {
        var key = arguments[i];
        if (!(key in obj)) {
          leaf = false;
          break;
        }
        obj = obj[key];
        if (typeof obj !== "object") break;
        stack.push(obj);
      }

      for (var i = stack.length - 1; i >= 0; i--) {
        var key = arguments[i + 1];

        if (leaf) leaf = false;else for (var other in stack[i][key]) return; // not empty -- we're done

        delete stack[i][key];
      }
    };

    // wrapAsync can wrap any function that takes some number of arguments that
    // can't be undefined, followed by some optional arguments, where the callback
    // is the last optional argument.
    // e.g. fs.readFile(pathname, [callback]),
    // fs.open(pathname, flags, [mode], [callback])
    // For maximum effectiveness and least confusion, wrapAsync should be used on
    // functions where the callback is the only argument of type Function.

    /**
     * @memberOf Meteor
     * @summary Wrap a function that takes a callback function as its final parameter. The signature of the callback of the wrapped function should be `function(error, result){}`. On the server, the wrapped function can be used either synchronously (without passing a callback) or asynchronously (when a callback is passed). On the client, a callback is always required; errors will be logged if there is no callback. If a callback is provided, the environment captured when the original function was called will be restored in the callback.
     * @locus Anywhere
     * @param {Function} func A function that takes a callback as its final parameter
     * @param {Object} [context] Optional `this` object against which the original function will be invoked
     */
    Meteor.wrapAsync = function (fn, context) {
      return function () /* arguments */{
        var self = context || this;
        var newArgs = Array.prototype.slice.call(arguments);
        var callback;

        for (var i = newArgs.length - 1; i >= 0; --i) {
          var arg = newArgs[i];
          var type = typeof arg;
          if (type !== "undefined") {
            if (type === "function") {
              callback = arg;
            }
            break;
          }
        }

        if (!callback) {
          if (Meteor.isClient) {
            callback = logErr;
          } else {
            var fut = new Future();
            callback = fut.resolver();
          }
          ++i; // Insert the callback just after arg.
        }

        newArgs[i] = Meteor.bindEnvironment(callback);
        var result = fn.apply(self, newArgs);
        return fut ? fut.wait() : result;
      };
    };

    // Sets child's prototype to a new object whose prototype is parent's
    // prototype. Used as:
    //   Meteor._inherits(ClassB, ClassA).
    //   _.extend(ClassB.prototype, { ... })
    // Inspired by CoffeeScript's `extend` and Google Closure's `goog.inherits`.
    var hasOwn = Object.prototype.hasOwnProperty;
    Meteor._inherits = function (Child, Parent) {
      // copy Parent static properties
      for (var key in Parent) {
        // make sure we only copy hasOwnProperty properties vs. prototype
        // properties
        if (hasOwn.call(Parent, key)) {
          Child[key] = Parent[key];
        }
      }

      // a middle member of prototype chain: takes the prototype from the Parent
      var Middle = function () {
        this.constructor = Child;
      };
      Middle.prototype = Parent.prototype;
      Child.prototype = new Middle();
      Child.__super__ = Parent.prototype;
      return Child;
    };

    var warnedAboutWrapAsync = false;

    /**
     * @deprecated in 0.9.3
     */
    Meteor._wrapAsync = function (fn, context) {
      if (!warnedAboutWrapAsync) {
        Meteor._debug("Meteor._wrapAsync has been renamed to Meteor.wrapAsync");
        warnedAboutWrapAsync = true;
      }
      return Meteor.wrapAsync.apply(Meteor, arguments);
    };

    function logErr(err) {
      if (err) {
        return Meteor._debug("Exception in callback of async function", err);
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    var global = this;

    // IE 10, Node >= 9.1

    function useSetImmediate() {
      if (!global.setImmediate) return null;else {
        var setImmediate = function (fn) {
          global.setImmediate(fn);
        };
        setImmediate.implementation = 'setImmediate';
        return setImmediate;
      }
    }

    // Android 2.3.6, Chrome 26, Firefox 20, IE 8-9, iOS 5.1.1 Safari

    function usePostMessage() {
      // The test against `importScripts` prevents this implementation
      // from being installed inside a web worker, where
      // `global.postMessage` means something completely different and
      // can't be used for this purpose.

      if (!global.postMessage || global.importScripts) {
        return null;
      }

      // Avoid synchronous post message implementations.

      var postMessageIsAsynchronous = true;
      var oldOnMessage = global.onmessage;
      global.onmessage = function () {
        postMessageIsAsynchronous = false;
      };
      global.postMessage("", "*");
      global.onmessage = oldOnMessage;

      if (!postMessageIsAsynchronous) return null;

      var funcIndex = 0;
      var funcs = {};

      // Installs an event handler on `global` for the `message` event: see
      // * https://developer.mozilla.org/en/DOM/window.postMessage
      // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

      // XXX use Random.id() here?
      var MESSAGE_PREFIX = "Meteor._setImmediate." + Math.random() + '.';

      function isStringAndStartsWith(string, putativeStart) {
        return typeof string === "string" && string.substring(0, putativeStart.length) === putativeStart;
      }

      function onGlobalMessage(event) {
        // This will catch all incoming messages (even from other
        // windows!), so we need to try reasonably hard to avoid letting
        // anyone else trick us into firing off. We test the origin is
        // still this window, and that a (randomly generated)
        // unpredictable identifying prefix is present.
        if (event.source === global && isStringAndStartsWith(event.data, MESSAGE_PREFIX)) {
          var index = event.data.substring(MESSAGE_PREFIX.length);
          try {
            if (funcs[index]) funcs[index]();
          } finally {
            delete funcs[index];
          }
        }
      }

      if (global.addEventListener) {
        global.addEventListener("message", onGlobalMessage, false);
      } else {
        global.attachEvent("onmessage", onGlobalMessage);
      }

      var setImmediate = function (fn) {
        // Make `global` post a message to itself with the handle and
        // identifying prefix, thus asynchronously invoking our
        // onGlobalMessage listener above.
        ++funcIndex;
        funcs[funcIndex] = fn;
        global.postMessage(MESSAGE_PREFIX + funcIndex, "*");
      };
      setImmediate.implementation = 'postMessage';
      return setImmediate;
    }

    function useTimeout() {
      var setImmediate = function (fn) {
        global.setTimeout(fn, 0);
      };
      setImmediate.implementation = 'setTimeout';
      return setImmediate;
    }

    Meteor._setImmediate = useSetImmediate() || usePostMessage() || useTimeout();

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/timers.js                                                                            //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    function withoutInvocation(f) {
      if (Package.ddp) {
        var DDP = Package.ddp.DDP;
        var CurrentInvocation = DDP._CurrentMethodInvocation ||
        // For backwards compatibility, as explained in this issue:
        // https://github.com/meteor/meteor/issues/8947
        DDP._CurrentInvocation;

        var invocation = CurrentInvocation.get();
        if (invocation && invocation.isSimulation) {
          throw new Error("Can't set timers inside simulations");
        }

        return function () {
          CurrentInvocation.withValue(null, f);
        };
      } else {
        return f;
      }
    }

    function bindAndCatch(context, f) {
      return Meteor.bindEnvironment(withoutInvocation(f), context);
    }

    // Meteor.setTimeout and Meteor.setInterval callbacks scheduled
    // inside a server method are not part of the method invocation and
    // should clear out the CurrentMethodInvocation environment variable.

    /**
     * @memberOf Meteor
     * @summary Call a function in the future after waiting for a specified delay.
     * @locus Anywhere
     * @param {Function} func The function to run
     * @param {Number} delay Number of milliseconds to wait before calling function
     */
    Meteor.setTimeout = function (f, duration) {
      return setTimeout(bindAndCatch("setTimeout callback", f), duration);
    };

    /**
     * @memberOf Meteor
     * @summary Call a function repeatedly, with a time delay between calls.
     * @locus Anywhere
     * @param {Function} func The function to run
     * @param {Number} delay Number of milliseconds to wait between each function call.
     */
    Meteor.setInterval = function (f, duration) {
      return setInterval(bindAndCatch("setInterval callback", f), duration);
    };

    /**
     * @memberOf Meteor
     * @summary Cancel a repeating function call scheduled by `Meteor.setInterval`.
     * @locus Anywhere
     * @param {Object} id The handle returned by `Meteor.setInterval`
     */
    Meteor.clearInterval = function (x) {
      return clearInterval(x);
    };

    /**
     * @memberOf Meteor
     * @summary Cancel a function call scheduled by `Meteor.setTimeout`.
     * @locus Anywhere
     * @param {Object} id The handle returned by `Meteor.setTimeout`
     */
    Meteor.clearTimeout = function (x) {
      return clearTimeout(x);
    };

    // XXX consider making this guarantee ordering of defer'd callbacks, like
    // Tracker.afterFlush or Node's nextTick (in practice). Then tests can do:
    //    callSomethingThatDefersSomeWork();
    //    Meteor.defer(expect(somethingThatValidatesThatTheWorkHappened));

    /**
     * @memberOf Meteor
     * @summary Defer execution of a function to run asynchronously in the background (similar to `Meteor.setTimeout(func, 0)`.
     * @locus Anywhere
     * @param {Function} func The function to run
     */
    Meteor.defer = function (f) {
      Meteor._setImmediate(bindAndCatch("defer callback", f));
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/errors.js                                                                            //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Makes an error subclass which properly contains a stack trace in most
    // environments. constructor can set fields on `this` (and should probably set
    // `message`, which is what gets displayed at the top of a stack trace).
    //
    Meteor.makeErrorType = function (name, constructor) {
      var errorClass = function () /*arguments*/{
        // Ensure we get a proper stack trace in most Javascript environments
        if (Error.captureStackTrace) {
          // V8 environments (Chrome and Node.js)
          Error.captureStackTrace(this, errorClass);
        } else {
          // Borrow the .stack property of a native Error object.
          this.stack = new Error().stack;
        }
        // Safari magically works.

        constructor.apply(this, arguments);

        this.errorType = name;
      };

      Meteor._inherits(errorClass, Error);

      return errorClass;
    };

    // This should probably be in the livedata package, but we don't want
    // to require you to use the livedata package to get it. Eventually we
    // should probably rename it to DDP.Error and put it back in the
    // 'livedata' package (which we should rename to 'ddp' also.)
    //
    // Note: The DDP server assumes that Meteor.Error EJSON-serializes as an object
    // containing 'error' and optionally 'reason' and 'details'.
    // The DDP client manually puts these into Meteor.Error objects. (We don't use
    // EJSON.addType here because the type is determined by location in the
    // protocol, not text on the wire.)

    /**
     * @summary This class represents a symbolic error thrown by a method.
     * @locus Anywhere
     * @class
     * @param {String} error A string code uniquely identifying this kind of error.
     * This string should be used by callers of the method to determine the
     * appropriate action to take, instead of attempting to parse the reason
     * or details fields. For example:
     *
     * ```
     * // on the server, pick a code unique to this error
     * // the reason field should be a useful debug message
     * throw new Meteor.Error("logged-out",
     *   "The user must be logged in to post a comment.");
     *
     * // on the client
     * Meteor.call("methodName", function (error) {
     *   // identify the error
     *   if (error && error.error === "logged-out") {
     *     // show a nice error message
     *     Session.set("errorMessage", "Please log in to post a comment.");
     *   }
     * });
     * ```
     *
     * For legacy reasons, some built-in Meteor functions such as `check` throw
     * errors with a number in this field.
     *
     * @param {String} [reason] Optional.  A short human-readable summary of the
     * error, like 'Not Found'.
     * @param {String} [details] Optional.  Additional information about the error,
     * like a textual stack trace.
     */
    Meteor.Error = Meteor.makeErrorType("Meteor.Error", function (error, reason, details) {
      var self = this;

      // Newer versions of DDP use this property to signify that an error
      // can be sent back and reconstructed on the calling client.
      self.isClientSafe = true;

      // String code uniquely identifying this kind of error.
      self.error = error;

      // Optional: A short human-readable summary of the error. Not
      // intended to be shown to end users, just developers. ("Not Found",
      // "Internal Server Error")
      self.reason = reason;

      // Optional: Additional information about the error, say for
      // debugging. It might be a (textual) stack trace if the server is
      // willing to provide one. The corresponding thing in HTTP would be
      // the body of a 404 or 500 response. (The difference is that we
      // never expect this to be shown to end users, only developers, so
      // it doesn't need to be pretty.)
      self.details = details;

      // This is what gets displayed at the top of a stack trace. Current
      // format is "[404]" (if no reason is set) or "File not found [404]"
      if (self.reason) self.message = self.reason + ' [' + self.error + ']';else self.message = '[' + self.error + ']';
    });

    // Meteor.Error is basically data and is sent over DDP, so you should be able to
    // properly EJSON-clone it. This is especially important because if a
    // Meteor.Error is thrown through a Future, the error, reason, and details
    // properties become non-enumerable so a standard Object clone won't preserve
    // them and they will be lost from DDP.
    Meteor.Error.prototype.clone = function () {
      var self = this;
      return new Meteor.Error(self.error, self.reason, self.details);
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/fiber_stubs_client.js                                                                //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // This file is a partial analogue to fiber_helpers.js, which allows the client
    // to use a queue too, and also to call noYieldsAllowed.

    // The client has no ability to yield, so noYieldsAllowed is a noop.
    //
    Meteor._noYieldsAllowed = function (f) {
      return f();
    };

    // An even simpler queue of tasks than the fiber-enabled one.  This one just
    // runs all the tasks when you call runTask or flush, synchronously.
    //
    Meteor._SynchronousQueue = function () {
      var self = this;
      self._tasks = [];
      self._running = false;
      self._runTimeout = null;
    };

    var SQp = Meteor._SynchronousQueue.prototype;

    SQp.runTask = function (task) {
      var self = this;
      if (!self.safeToRunTask()) throw new Error("Could not synchronously run a task from a running task");
      self._tasks.push(task);
      var tasks = self._tasks;
      self._tasks = [];
      self._running = true;

      if (self._runTimeout) {
        // Since we're going to drain the queue, we can forget about the timeout
        // which tries to run it.  (But if one of our tasks queues something else,
        // the timeout will be correctly re-created.)
        clearTimeout(self._runTimeout);
        self._runTimeout = null;
      }

      try {
        while (tasks.length > 0) {
          var t = tasks.shift();
          try {
            t();
          } catch (e) {
            if (tasks.length === 0) {
              // this was the last task, that is, the one we're calling runTask
              // for.
              throw e;
            }
            Meteor._debug("Exception in queued task", e);
          }
        }
      } finally {
        self._running = false;
      }
    };

    SQp.queueTask = function (task) {
      var self = this;
      self._tasks.push(task);
      // Intentionally not using Meteor.setTimeout, because it doesn't like runing
      // in stubs for now.
      if (!self._runTimeout) {
        self._runTimeout = setTimeout(function () {
          return self.flush.apply(self, arguments);
        }, 0);
      }
    };

    SQp.flush = function () {
      var self = this;
      self.runTask(function () {});
    };

    SQp.drain = function () {
      var self = this;
      if (!self.safeToRunTask()) {
        return;
      }
      while (self._tasks.length > 0) {
        self.flush();
      }
    };

    SQp.safeToRunTask = function () {
      var self = this;
      return !self._running;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/startup_client.js                                                                    //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    var callbackQueue = [];
    var isLoadingCompleted = false;
    var isReady = false;

    // Keeps track of how many events to wait for in addition to loading completing,
    // before we're considered ready.
    var readyHoldsCount = 0;

    var holdReady = function () {
      readyHoldsCount++;
    };

    var releaseReadyHold = function () {
      readyHoldsCount--;
      maybeReady();
    };

    var maybeReady = function () {
      if (isReady || !isLoadingCompleted || readyHoldsCount > 0) return;

      isReady = true;

      // Run startup callbacks
      while (callbackQueue.length) callbackQueue.shift()();

      if (Meteor.isCordova) {
        // Notify the WebAppLocalServer plugin that startup was completed successfully,
        // so we can roll back faulty versions if this doesn't happen
        WebAppLocalServer.startupDidComplete();
      }
    };

    var loadingCompleted = function () {
      if (!isLoadingCompleted) {
        isLoadingCompleted = true;
        maybeReady();
      }
    };

    if (Meteor.isCordova) {
      holdReady();
      document.addEventListener('deviceready', releaseReadyHold, false);
    }

    if (document.readyState === 'complete' || document.readyState === 'loaded') {
      // Loading has completed,
      // but allow other scripts the opportunity to hold ready
      window.setTimeout(loadingCompleted);
    } else {
      // Attach event listeners to wait for loading to complete
      if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', loadingCompleted, false);
        window.addEventListener('load', loadingCompleted, false);
      } else {
        // Use IE event model for < IE9
        document.attachEvent('onreadystatechange', function () {
          if (document.readyState === "complete") {
            loadingCompleted();
          }
        });
        window.attachEvent('load', loadingCompleted);
      }
    }

    /**
     * @summary Run code when a client or a server starts.
     * @locus Anywhere
     * @param {Function} func A function to run on startup.
     */
    Meteor.startup = function (callback) {
      // Fix for < IE9, see http://javascript.nwbox.com/IEContentLoaded/
      var doScroll = !document.addEventListener && document.documentElement.doScroll;

      if (!doScroll || window !== top) {
        if (isReady) callback();else callbackQueue.push(callback);
      } else {
        try {
          doScroll('left');
        } catch (error) {
          setTimeout(function () {
            Meteor.startup(callback);
          }, 50);
          return;
        };
        callback();
      }
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/debug.js                                                                             //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    var suppress = 0;

    // replacement for console.log. This is a temporary API. We should
    // provide a real logging API soon (possibly just a polyfill for
    // console?)
    //
    // NOTE: this is used on the server to print the warning about
    // having autopublish enabled when you probably meant to turn it
    // off. it's not really the proper use of something called
    // _debug. the intent is for this message to go to the terminal and
    // be very visible. if you change _debug to go someplace else, etc,
    // please fix the autopublish code to do something reasonable.
    //
    Meteor._debug = function () /* arguments */{
      if (suppress) {
        suppress--;
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
        if (arguments.length == 0) {
          // IE Companion breaks otherwise
          // IE10 PP4 requires at least one argument
          console.log('');
        } else {
          // IE doesn't have console.log.apply, it's not a real Object.
          // http://stackoverflow.com/questions/5538972/console-log-apply-not-working-in-ie9
          // http://patik.com/blog/complete-cross-browser-console-log/
          if (typeof console.log.apply === "function") {
            // Most browsers

            // Chrome and Safari only hyperlink URLs to source files in first argument of
            // console.log, so try to call it with one argument if possible.
            // Approach taken here: If all arguments are strings, join them on space.
            // See https://github.com/meteor/meteor/pull/732#issuecomment-13975991
            var allArgumentsOfTypeString = true;
            for (var i = 0; i < arguments.length; i++) if (typeof arguments[i] !== "string") allArgumentsOfTypeString = false;

            if (allArgumentsOfTypeString) console.log.apply(console, [Array.prototype.join.call(arguments, " ")]);else console.log.apply(console, arguments);
          } else if (typeof Function.prototype.bind === "function") {
            // IE9
            var log = Function.prototype.bind.call(console.log, console);
            log.apply(console, arguments);
          } else {
            // IE8
            Function.prototype.call.call(console.log, console, Array.prototype.slice.call(arguments));
          }
        }
      }
    };

    // Suppress the next 'count' Meteor._debug messsages. Use this to
    // stop tests from spamming the console.
    //
    Meteor._suppress_log = function (count) {
      suppress += count;
    };

    Meteor._suppressed_log_expected = function () {
      return suppress !== 0;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/string_utils.js                                                                      //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Like Perl's quotemeta: quotes all regexp metacharacters.
    // Code taken from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
    Meteor._escapeRegExp = function (string) {
      return String(string).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/test_environment.js                                                                  //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    var TEST_METADATA_STR;
    if (Meteor.isClient) {
      TEST_METADATA_STR = meteorEnv.TEST_METADATA;
    } else {
      TEST_METADATA_STR = process.env.TEST_METADATA;
    }

    var TEST_METADATA = JSON.parse(TEST_METADATA_STR || "{}");
    var testDriverPackageName = TEST_METADATA.driverPackage;

    // Note that if we are in test-packages mode neither of these will be set,
    // but we will have a test driver package
    Meteor.isTest = !!TEST_METADATA.isTest;
    Meteor.isAppTest = !!TEST_METADATA.isAppTest;
    Meteor.isPackageTest = !!testDriverPackageName && !Meteor.isTest && !Meteor.isAppTest;

    if (typeof testDriverPackageName === "string") {
      Meteor.startup(function () {
        var testDriverPackage = Package[testDriverPackageName];
        if (!testDriverPackage) {
          throw new Error("Can't find test driver package: " + testDriverPackageName);
        }

        // On the client, the test driver *must* define `runTests`
        if (Meteor.isClient) {
          if (typeof testDriverPackage.runTests !== "function") {
            throw new Error("Test driver package " + testDriverPackageName + " missing `runTests` export");
          }
          testDriverPackage.runTests();
        } else {
          // The server can optionally define `start`
          if (typeof testDriverPackage.start === "function") {
            testDriverPackage.start();
          }
        }
      });
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/dynamics_browser.js                                                                  //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Simple implementation of dynamic scoping, for use in browsers

    var nextSlot = 0;
    var currentValues = [];

    Meteor.EnvironmentVariable = function () {
      this.slot = nextSlot++;
    };

    var EVp = Meteor.EnvironmentVariable.prototype;

    EVp.get = function () {
      return currentValues[this.slot];
    };

    EVp.getOrNullIfOutsideFiber = function () {
      return this.get();
    };

    EVp.withValue = function (value, func) {
      var saved = currentValues[this.slot];
      try {
        currentValues[this.slot] = value;
        var ret = func();
      } finally {
        currentValues[this.slot] = saved;
      }
      return ret;
    };

    Meteor.bindEnvironment = function (func, onException, _this) {
      // needed in order to be able to create closures inside func and
      // have the closed variables not change back to their original
      // values
      var boundValues = currentValues.slice();

      if (!onException || typeof onException === 'string') {
        var description = onException || "callback of async function";
        onException = function (error) {
          Meteor._debug("Exception in " + description + ":", error);
        };
      }

      return function () /* arguments */{
        var savedValues = currentValues;
        try {
          currentValues = boundValues;
          var ret = func.apply(_this, arguments);
        } catch (e) {
          // note: callback-hook currently relies on the fact that if onException
          // throws in the browser, the wrapped call throws.
          onException(e);
        } finally {
          currentValues = savedValues;
        }
        return ret;
      };
    };

    Meteor._nodeCodeMustBeInFiber = function () {
      // no-op on browser
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                      //
    // packages/meteor/url_common.js                                                                        //
    //                                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    /**
     * @summary Generate an absolute URL pointing to the application. The server reads from the `ROOT_URL` environment variable to determine where it is running. This is taken care of automatically for apps deployed to Galaxy, but must be provided when using `meteor build`.
     * @locus Anywhere
     * @param {String} [path] A path to append to the root URL. Do not include a leading "`/`".
     * @param {Object} [options]
     * @param {Boolean} options.secure Create an HTTPS URL.
     * @param {Boolean} options.replaceLocalhost Replace localhost with 127.0.0.1. Useful for services that don't recognize localhost as a domain name.
     * @param {String} options.rootUrl Override the default ROOT_URL from the server environment. For example: "`http://foo.example.com`"
     */
    Meteor.absoluteUrl = function (path, options) {
      // path is optional
      if (!options && typeof path === 'object') {
        options = path;
        path = undefined;
      }
      // merge options with defaults
      options = Object.assign({}, Meteor.absoluteUrl.defaultOptions, options || {});

      var url = options.rootUrl;
      if (!url) throw new Error("Must pass options.rootUrl or set ROOT_URL in the server environment");

      if (!/^http[s]?:\/\//i.test(url)) // url starts with 'http://' or 'https://'
        url = 'http://' + url; // we will later fix to https if options.secure is set

      if (!url.endsWith("/")) {
        url += "/";
      }

      if (path) {
        // join url and path with a / separator
        while (path.startsWith("/")) {
          path = path.slice(1);
        }
        url += path;
      }

      // turn http to https if secure option is set, and we're not talking
      // to localhost.
      if (options.secure && /^http:/.test(url) && // url starts with 'http:'
      !/http:\/\/localhost[:\/]/.test(url) && // doesn't match localhost
      !/http:\/\/127\.0\.0\.1[:\/]/.test(url)) // or 127.0.0.1
        url = url.replace(/^http:/, 'https:');

      if (options.replaceLocalhost) url = url.replace(/^http:\/\/localhost([:\/].*)/, 'http://127.0.0.1$1');

      return url;
    };

    // allow later packages to override default options
    var defaultOptions = Meteor.absoluteUrl.defaultOptions = {};

    // available only in a browser environment
    var location = typeof window === "object" && window.location;

    if (typeof __meteor_runtime_config__ === "object" && __meteor_runtime_config__.ROOT_URL) {
      defaultOptions.rootUrl = __meteor_runtime_config__.ROOT_URL;
    } else if (location && location.protocol && location.host) {
      defaultOptions.rootUrl = location.protocol + "//" + location.host;
    }

    // Make absolute URLs use HTTPS by default if the current window.location
    // uses HTTPS. Since this is just a default, it can be overridden by
    // passing { secure: false } if necessary.
    if (location && location.protocol === "https:") {
      defaultOptions.secure = true;
    }

    Meteor._relativeToSiteRootUrl = function (link) {
      if (typeof __meteor_runtime_config__ === "object" && link.substr(0, 1) === "/") link = (__meteor_runtime_config__.ROOT_URL_PATH_PREFIX || "") + link;
      return link;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("meteor", {
    Meteor: Meteor,
    global: global,
    meteorEnv: meteorEnv
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("meteor-base");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;

  /* Package-scope variables */
  var makeInstaller, meteorInstall;

  ///////////////////////////////////////////////////////////////////////////////
  //                                                                           //
  // packages/modules-runtime/.npm/package/node_modules/install/install.js     //
  // This file is in bare mode and is not in its own closure.                  //
  //                                                                           //
  ///////////////////////////////////////////////////////////////////////////////
  //
  makeInstaller = function (options) {

    options = options || {};

    // These file extensions will be appended to required module identifiers
    // if they do not exactly match an installed module.
    var defaultExtensions = options.extensions || [".js", ".json"];

    // If defined, the options.fallback function will be called when no
    // installed module is found for a required module identifier. Often
    // options.fallback will be implemented in terms of the native Node
    // require function, which has the ability to load binary modules.
    var fallback = options.fallback;

    // List of fields to look for in package.json files to determine the
    // main entry module of the package. The first field listed here whose
    // value is a string will be used to resolve the entry module.
    var mainFields = options.mainFields || (
    // If options.mainFields is absent and options.browser is truthy,
    // package resolution will prefer the "browser" field of package.json
    // files to the "main" field. Note that this only supports
    // string-valued "browser" fields for now, though in the future it
    // might make sense to support the object version, a la browserify.
    options.browser ? ["browser", "main"] : ["main"]);

    var hasOwn = {}.hasOwnProperty;
    function strictHasOwn(obj, key) {
      return isObject(obj) && isString(key) && hasOwn.call(obj, key);
    }

    // Cache for looking up File objects given absolute module identifiers.
    // Invariants:
    //   filesByModuleId[module.id] === fileAppendId(root, module.id)
    //   filesByModuleId[module.id].module === module
    var filesByModuleId = {};

    // The file object representing the root directory of the installed
    // module tree.
    var root = new File("/", new File("/.."));
    var rootRequire = makeRequire(root);

    // Merges the given tree of directories and module factory functions
    // into the tree of installed modules and returns a require function
    // that behaves as if called from a module in the root directory.
    function install(tree, options) {
      if (isObject(tree)) {
        fileMergeContents(root, tree, options);
      }
      return rootRequire;
    }

    // Replace this function to enable Module.prototype.prefetch.
    install.fetch = function (ids) {
      throw new Error("fetch not implemented");
    };

    // This constructor will be used to instantiate the module objects
    // passed to module factory functions (i.e. the third argument after
    // require and exports), and is exposed as install.Module in case the
    // caller of makeInstaller wishes to modify Module.prototype.
    function Module(id) {
      this.id = id;

      // The Node implementation of module.children unfortunately includes
      // only those child modules that were imported for the first time by
      // this parent module (i.e., child.parent === this).
      this.children = [];

      // This object is an install.js extension that includes all child
      // modules imported by this module, even if this module is not the
      // first to import them.
      this.childrenById = {};
    }

    // Used to keep module.prefetch promise resolutions well-ordered.
    var lastPrefetchPromise;

    // May be shared by multiple sequential calls to module.prefetch.
    // Initialized to {} only when necessary.
    var missing;

    Module.prototype.prefetch = function (id) {
      var _module = this;
      var parentFile = getOwn(filesByModuleId, _module.id);

      lastPrefetchPromise = lastPrefetchPromise || Promise.resolve();
      var previousPromise = lastPrefetchPromise;

      function walk(_module2) {
        var file = getOwn(filesByModuleId, _module2.id);
        if (fileIsDynamic(file) && !file.pending) {
          file.pending = true;
          missing = missing || {};

          // These are the data that will be exposed to the install.fetch
          // callback, so it's worth documenting each item with a comment.
          missing[_module2.id] = {
            // The CommonJS module object that will be exposed to this
            // dynamic module when it is evaluated. Note that install.fetch
            // could decide to populate module.exports directly, instead of
            // fetching anything. In that case, install.fetch should omit
            // this module from the tree that it produces.
            module: file.module,
            // List of module identifier strings imported by this module.
            // Note that the missing object already contains all available
            // dependencies (including transitive dependencies), so
            // install.fetch should not need to traverse these dependencies
            // in most cases; however, they may be useful for other reasons.
            // Though the strings are unique, note that two different
            // strings could resolve to the same module.
            deps: Object.keys(file.deps),
            // The options (if any) that were passed as the second argument
            // to the install(tree, options) function when this stub was
            // first registered. Typically contains options.extensions, but
            // could contain any information appropriate for the entire tree
            // as originally installed. These options will be automatically
            // inherited by the newly fetched modules, so install.fetch
            // should not need to modify them.
            options: file.options,
            // Any stub data included in the array notation from the
            // original entry for this dynamic module. Typically contains
            // "main" and/or "browser" fields for package.json files, and is
            // otherwise undefined.
            stub: file.stub
          };

          each(file.deps, function (parentId, id) {
            fileResolve(file, id);
          });

          each(_module2.childrenById, walk);
        }
      }

      return lastPrefetchPromise = new Promise(function (resolve) {
        var absChildId = _module.resolve(id);
        each(_module.childrenById, walk);
        resolve(absChildId);
      }).then(function (absChildId) {
        // Grab the current missing object and fetch its contents.
        var toBeFetched = missing;
        missing = null;

        function clearPending() {
          if (toBeFetched) {
            Object.keys(toBeFetched).forEach(function (id) {
              getOwn(filesByModuleId, id).pending = false;
            });
          }
        }

        return new Promise(function (resolve) {
          // The install.fetch function takes an object mapping missing
          // dynamic module identifiers to options objects, and should
          // return a Promise that resolves to a module tree that can be
          // installed. As an optimization, if there were no missing dynamic
          // modules, then we can skip calling install.fetch entirely.
          resolve(toBeFetched && install.fetch(toBeFetched));
        }).then(function (tree) {
          function both() {
            install(tree);
            clearPending();
            return absChildId;
          }

          // Although we want multiple install.fetch calls to run in
          // parallel, it is important that the promises returned by
          // module.prefetch are resolved in the same order as the original
          // calls to module.prefetch, because previous fetches may include
          // modules assumed to exist by more recent module.prefetch calls.
          // Whether previousPromise was resolved or rejected, carry on with
          // the installation regardless.
          return previousPromise.then(both, both);
        }, function (error) {
          // Fixes https://github.com/meteor/meteor/issues/10182.
          clearPending();
          throw error;
        });
      });
    };

    install.Module = Module;

    function getOwn(obj, key) {
      return strictHasOwn(obj, key) && obj[key];
    }

    function isObject(value) {
      return value !== null && typeof value === "object";
    }

    function isFunction(value) {
      return typeof value === "function";
    }

    function isString(value) {
      return typeof value === "string";
    }

    function makeMissingError(id) {
      return new Error("Cannot find module '" + id + "'");
    }

    Module.prototype.resolve = function (id) {
      var file = fileResolve(filesByModuleId[this.id], id);
      if (file) return file.module.id;
      var error = makeMissingError(id);
      if (fallback && isFunction(fallback.resolve)) {
        return fallback.resolve(id, this.id, error);
      }
      throw error;
    };

    Module.prototype.require = function require(id) {
      var result = fileResolve(filesByModuleId[this.id], id);
      if (result) {
        return fileEvaluate(result, this);
      }

      var error = makeMissingError(id);

      if (isFunction(fallback)) {
        return fallback(id, // The missing module identifier.
        this.id, // ID of the parent module.
        error // The error we would have thrown.
        );
      }

      throw error;
    };

    function makeRequire(file) {
      var _module3 = file.module;

      function _require(id) {
        return _module3.require(id);
      }

      _require.extensions = fileGetExtensions(file).slice(0);

      _require.resolve = function resolve(id) {
        return _module3.resolve(id);
      };

      return _require;
    }

    // File objects represent either directories or modules that have been
    // installed. When a `File` respresents a directory, its `.contents`
    // property is an object containing the names of the files (or
    // directories) that it contains. When a `File` represents a module, its
    // `.contents` property is a function that can be invoked with the
    // appropriate `(require, exports, module)` arguments to evaluate the
    // module. If the `.contents` property is a string, that string will be
    // resolved as a module identifier, and the exports of the resulting
    // module will provide the exports of the original file. The `.parent`
    // property of a File is either a directory `File` or `null`. Note that
    // a child may claim another `File` as its parent even if the parent
    // does not have an entry for that child in its `.contents` object.
    // This is important for implementing anonymous files, and preventing
    // child modules from using `../relative/identifier` syntax to examine
    // unrelated modules.
    function File(moduleId, parent) {
      var file = this;

      // Link to the parent file.
      file.parent = parent = parent || null;

      // The module object for this File, which will eventually boast an
      // .exports property when/if the file is evaluated.
      file.module = new Module(moduleId);
      filesByModuleId[moduleId] = file;

      // The .contents of the file can be either (1) an object, if the file
      // represents a directory containing other files; (2) a factory
      // function, if the file represents a module that can be imported; (3)
      // a string, if the file is an alias for another file; or (4) null, if
      // the file's contents are not (yet) available.
      file.contents = null;

      // Set of module identifiers imported by this module. Note that this
      // set is not necessarily complete, so don't rely on it unless you
      // know what you're doing.
      file.deps = {};
    }

    function fileEvaluate(file, parentModule) {
      var _module4 = file.module;
      if (!strictHasOwn(_module4, "exports")) {
        var contents = file.contents;
        if (!contents) {
          // If this file was installed with array notation, and the array
          // contained one or more objects but no functions, then the combined
          // properties of the objects are treated as a temporary stub for
          // file.module.exports. This is particularly important for partial
          // package.json modules, so that the resolution logic can know the
          // value of the "main" and/or "browser" fields, at least, even if
          // the rest of the package.json file is not (yet) available.
          if (file.stub) {
            return file.stub;
          }

          throw makeMissingError(_module4.id);
        }

        if (parentModule) {
          _module4.parent = parentModule;
          var children = parentModule.children;
          if (Array.isArray(children)) {
            children.push(_module4);
          }
        }

        contents(makeRequire(file),
        // If the file had a .stub, reuse the same object for exports.
        _module4.exports = file.stub || {}, _module4, file.module.id, file.parent.module.id);

        _module4.loaded = true;
      }

      // The module.runModuleSetters method will be deprecated in favor of
      // just module.runSetters: https://github.com/benjamn/reify/pull/160
      var runSetters = _module4.runSetters || _module4.runModuleSetters;
      if (isFunction(runSetters)) {
        runSetters.call(_module4);
      }

      return _module4.exports;
    }

    function fileIsDirectory(file) {
      return file && isObject(file.contents);
    }

    function fileIsDynamic(file) {
      return file && file.contents === null;
    }

    function fileMergeContents(file, contents, options) {
      if (Array.isArray(contents)) {
        contents.forEach(function (item) {
          if (isString(item)) {
            file.deps[item] = file.module.id;
          } else if (isFunction(item)) {
            contents = item;
          } else if (isObject(item)) {
            file.stub = file.stub || {};
            each(item, function (value, key) {
              file.stub[key] = value;
            });
          }
        });

        if (!isFunction(contents)) {
          // If the array did not contain a function, merge nothing.
          contents = null;
        }
      } else if (!isFunction(contents) && !isString(contents) && !isObject(contents)) {
        // If contents is neither an array nor a function nor a string nor
        // an object, just give up and merge nothing.
        contents = null;
      }

      if (contents) {
        file.contents = file.contents || (isObject(contents) ? {} : contents);
        if (isObject(contents) && fileIsDirectory(file)) {
          each(contents, function (value, key) {
            if (key === "..") {
              child = file.parent;
            } else {
              var child = getOwn(file.contents, key);

              if (!child) {
                child = file.contents[key] = new File(file.module.id.replace(/\/*$/, "/") + key, file);

                child.options = options;
              }
            }

            fileMergeContents(child, value, options);
          });
        }
      }
    }

    function each(obj, callback, context) {
      Object.keys(obj).forEach(function (key) {
        callback.call(this, obj[key], key);
      }, context);
    }

    function fileGetExtensions(file) {
      return file.options && file.options.extensions || defaultExtensions;
    }

    function fileAppendIdPart(file, part, extensions) {
      // Always append relative to a directory.
      while (file && !fileIsDirectory(file)) {
        file = file.parent;
      }

      if (!file || !part || part === ".") {
        return file;
      }

      if (part === "..") {
        return file.parent;
      }

      var exactChild = getOwn(file.contents, part);

      // Only consider multiple file extensions if this part is the last
      // part of a module identifier and not equal to `.` or `..`, and there
      // was no exact match or the exact match was a directory.
      if (extensions && (!exactChild || fileIsDirectory(exactChild))) {
        for (var e = 0; e < extensions.length; ++e) {
          var child = getOwn(file.contents, part + extensions[e]);
          if (child && !fileIsDirectory(child)) {
            return child;
          }
        }
      }

      return exactChild;
    }

    function fileAppendId(file, id, extensions) {
      var parts = id.split("/");

      // Use `Array.prototype.every` to terminate iteration early if
      // `fileAppendIdPart` returns a falsy value.
      parts.every(function (part, i) {
        return file = i < parts.length - 1 ? fileAppendIdPart(file, part) : fileAppendIdPart(file, part, extensions);
      });

      return file;
    }

    function recordChild(parentModule, childFile) {
      var childModule = childFile && childFile.module;
      if (parentModule && childModule) {
        parentModule.childrenById[childModule.id] = childModule;
      }
    }

    function fileResolve(file, id, parentModule, seenDirFiles) {
      var parentModule = parentModule || file.module;
      var extensions = fileGetExtensions(file);

      file =
      // Absolute module identifiers (i.e. those that begin with a `/`
      // character) are interpreted relative to the root directory, which
      // is a slight deviation from Node, which has access to the entire
      // file system.
      id.charAt(0) === "/" ? fileAppendId(root, id, extensions) :
      // Relative module identifiers are interpreted relative to the
      // current file, naturally.
      id.charAt(0) === "." ? fileAppendId(file, id, extensions) :
      // Top-level module identifiers are interpreted as referring to
      // packages in `node_modules` directories.
      nodeModulesLookup(file, id, extensions);

      // If the identifier resolves to a directory, we use the same logic as
      // Node to find an `index.js` or `package.json` file to evaluate.
      while (fileIsDirectory(file)) {
        seenDirFiles = seenDirFiles || [];

        // If the "main" field of a `package.json` file resolves to a
        // directory we've already considered, then we should not attempt to
        // read the same `package.json` file again. Using an array as a set
        // is acceptable here because the number of directories to consider
        // is rarely greater than 1 or 2. Also, using indexOf allows us to
        // store File objects instead of strings.
        if (seenDirFiles.indexOf(file) < 0) {
          seenDirFiles.push(file);

          var pkgJsonFile = fileAppendIdPart(file, "package.json");
          var pkg = pkgJsonFile && fileEvaluate(pkgJsonFile, parentModule);
          var mainFile,
              resolved = pkg && mainFields.some(function (name) {
            var main = pkg[name];
            if (isString(main)) {
              // The "main" field of package.json does not have to begin
              // with ./ to be considered relative, so first we try
              // simply appending it to the directory path before
              // falling back to a full fileResolve, which might return
              // a package from a node_modules directory.
              return mainFile = fileAppendId(file, main, extensions) || fileResolve(file, main, parentModule, seenDirFiles);
            }
          });

          if (resolved && mainFile) {
            file = mainFile;
            recordChild(parentModule, pkgJsonFile);
            // The fileAppendId call above may have returned a directory,
            // so continue the loop to make sure we resolve it to a
            // non-directory file.
            continue;
          }
        }

        // If we didn't find a `package.json` file, or it didn't have a
        // resolvable `.main` property, the only possibility left to
        // consider is that this directory contains an `index.js` module.
        // This assignment almost always terminates the while loop, because
        // there's very little chance `fileIsDirectory(file)` will be true
        // for `fileAppendIdPart(file, "index", extensions)`. However, in
        // principle it is remotely possible that a file called `index.js`
        // could be a directory instead of a file.
        file = fileAppendIdPart(file, "index", extensions);
      }

      if (file && isString(file.contents)) {
        file = fileResolve(file, file.contents, parentModule, seenDirFiles);
      }

      recordChild(parentModule, file);

      return file;
    };

    function nodeModulesLookup(file, id, extensions) {
      for (var resolved; file && !resolved; file = file.parent) {
        resolved = fileIsDirectory(file) && fileAppendId(file, "node_modules/" + id, extensions);
      }
      return resolved;
    }

    return install;
  };

  if (typeof exports === "object") {
    exports.makeInstaller = makeInstaller;
  }

  ///////////////////////////////////////////////////////////////////////////////


  (function () {

    ///////////////////////////////////////////////////////////////////////////////
    //                                                                           //
    // packages/modules-runtime/modern.js                                        //
    //                                                                           //
    ///////////////////////////////////////////////////////////////////////////////
    //
    meteorInstall = makeInstaller({
      // On the client, make package resolution prefer the "browser" field of
      // package.json over the "module" field over the "main" field.
      browser: true,
      mainFields: ["browser", "module", "main"],

      fallback: function (id, parentId, error) {
        if (id && id.startsWith('meteor/')) {
          var packageName = id.split('/', 2)[1];
          throw new Error('Cannot find package "' + packageName + '". ' + 'Try "meteor add ' + packageName + '".');
        }

        throw error;
      }
    });

    ///////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    ///////////////////////////////////////////////////////////////////////////////
    //                                                                           //
    // packages/modules-runtime/profile.js                                       //
    //                                                                           //
    ///////////////////////////////////////////////////////////////////////////////
    //
    if (typeof Profile === "function" && process.env.METEOR_PROFILE) {
      var Mp = meteorInstall.Module.prototype;
      Mp.require = Profile(function (id) {
        return "require(" + JSON.stringify(id) + ")";
      }, Mp.require);
    }

    ///////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("modules-runtime", {
    meteorInstall: meteorInstall
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package['modules-runtime'].meteorInstall;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "modules": { "client.js": function _module(_require, _exports) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/client.js                                                                                          //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _require("./install-packages.js");
            _require("./stubs.js");
            _require("./process.js");
            _require("./reify.js");

            _exports.addStyles = _require("./css").addStyles;

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "css.js": function _module2(_require3, _exports3) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/css.js                                                                                             //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            var doc = document;
            var head = doc.getElementsByTagName("head").item(0);

            _exports3.addStyles = function (css) {
              var style = doc.createElement("style");

              style.setAttribute("type", "text/css");

              // https://msdn.microsoft.com/en-us/library/ms535871(v=vs.85).aspx
              var internetExplorerSheetObject = style.sheet || // Edge/IE11.
              style.styleSheet; // Older IEs.

              if (internetExplorerSheetObject) {
                internetExplorerSheetObject.cssText = css;
              } else {
                style.appendChild(doc.createTextNode(css));
              }

              return head.appendChild(style);
            };

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "install-packages.js": function module(_require4, _exports4, _module3) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/install-packages.js                                                                                //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            function install(name, mainModule) {
              var meteorDir = {};

              // Given a package name <name>, install a stub module in the
              // /node_modules/meteor directory called <name>.js, so that
              // require.resolve("meteor/<name>") will always return
              // /node_modules/meteor/<name>.js instead of something like
              // /node_modules/meteor/<name>/index.js, in the rare but possible event
              // that the package contains a file called index.js (#6590).

              if (typeof mainModule === "string") {
                // Set up an alias from /node_modules/meteor/<package>.js to the main
                // module, e.g. meteor/<package>/index.js.
                meteorDir[name + ".js"] = mainModule;
              } else {
                // back compat with old Meteor packages
                meteorDir[name + ".js"] = function (r, e, _module4) {
                  _module4.exports = Package[name];
                };
              }

              meteorInstall({
                node_modules: {
                  meteor: meteorDir
                }
              });
            }

            // This file will be modified during computeJsOutputFilesMap to include
            // install(<name>) calls for every Meteor package.

            install("meteor");
            install("meteor-base");
            install("modules-runtime");
            install("modules", "meteor/modules/client.js");
            install("modern-browsers");
            install("babel-compiler");
            install("react-fast-refresh");
            install("ecmascript");
            install("ecmascript-runtime");
            install("babel-runtime", "meteor/babel-runtime/babel-runtime.js");
            install("promise", "meteor/promise/client.js");
            install("fetch", "meteor/fetch/modern.js");
            install("dynamic-import", "meteor/dynamic-import/client.js");
            install("es5-shim");
            install("ecmascript-runtime-client", "meteor/ecmascript-runtime-client/modern.js");
            install("base64", "meteor/base64/base64.js");
            install("ejson", "meteor/ejson/ejson.js");
            install("diff-sequence", "meteor/diff-sequence/diff.js");
            install("geojson-utils", "meteor/geojson-utils/main.js");
            install("id-map", "meteor/id-map/id-map.js");
            install("random", "meteor/random/main_client.js");
            install("mongo-id", "meteor/mongo-id/id.js");
            install("ordered-dict", "meteor/ordered-dict/ordered_dict.js");
            install("tracker");
            install("minimongo", "meteor/minimongo/minimongo_client.js");
            install("check", "meteor/check/match.js");
            install("retry", "meteor/retry/retry.js");
            install("callback-hook", "meteor/callback-hook/hook.js");
            install("ddp-common");
            install("reload", "meteor/reload/reload.js");
            install("socket-stream-client", "meteor/socket-stream-client/browser.js");
            install("ddp-client", "meteor/ddp-client/client/client.js");
            install("ddp");
            install("ddp-server");
            install("allow-deny");
            install("mongo-dev-server");
            install("mongo");
            install("ddp-rate-limiter");
            install("localstorage");
            install("reactive-var");
            install("url", "meteor/url/modern.js");
            install("accounts-base", "meteor/accounts-base/client_main.js");
            install("sha");
            install("srp", "meteor/srp/srp.js");
            install("accounts-password");
            install("zodern:types");
            install("alanning:roles");
            install("http", "meteor/http/httpcall_client.js");
            install("jquery");
            install("underscore");
            install("mrt:external-file-loader");
            install("mdg:validation-error");
            install("jagi:astronomy", "meteor/jagi:astronomy/lib/main.js");
            install("jagi:astronomy-timestamp-behavior", "meteor/jagi:astronomy-timestamp-behavior/lib/main.js");
            install("grove:call-async");
            install("oauth");
            install("accounts-oauth");
            install("service-configuration");
            install("oauth2");
            install("facebook-oauth");
            install("accounts-facebook");
            install("ivadey:slingshot");
            install("webapp", "meteor/webapp/webapp_client.js");
            install("livedata");
            install("hot-code-push");
            install("autoupdate", "meteor/autoupdate/autoupdate_client.js");

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "process.js": function module(_require5, _exports5, _module5) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/process.js                                                                                         //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            if (!global.process) {
              try {
                // The application can run `npm install process` to provide its own
                // process stub; otherwise this module will provide a partial stub.
                global.process = _require5("process");
              } catch (missing) {
                global.process = {};
              }
            }

            var proc = global.process;

            if (Meteor.isServer) {
              // Make require("process") work on the server in all versions of Node.
              meteorInstall({
                node_modules: {
                  "process.js": function (r, e, _module6) {
                    _module6.exports = proc;
                  }
                }
              });
            } else {
              proc.platform = "browser";
              proc.nextTick = proc.nextTick || Meteor._setImmediate;
            }

            if (typeof proc.env !== "object") {
              proc.env = {};
            }

            var hasOwn = Object.prototype.hasOwnProperty;
            for (var key in meteorEnv) {
              if (hasOwn.call(meteorEnv, key)) {
                proc.env[key] = meteorEnv[key];
              }
            }

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "reify.js": function module(_require6, _exports6, _module7) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/reify.js                                                                                           //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _require6("reify/lib/runtime").enable(_module7.constructor.prototype);

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "stubs.js": function _module8(_require7) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/modules/stubs.js                                                                                           //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            var haveStubs = false;
            try {
              _require7.resolve("meteor-node-stubs");
              haveStubs = true;
            } catch (noStubs) {}

            if (haveStubs) {
              // When meteor-node-stubs is installed in the application's root
              // node_modules directory, requiring it here installs aliases for stubs
              // for all Node built-in modules, such as fs, util, and http.
              _require7("meteor-node-stubs");
            }

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "node_modules": { "reify": { "lib": { "runtime": { "index.js": function module(_require8, _exports7, _module9) {

                    // This module should be compatible with PhantomJS v1, just like the other files
                    // in reify/lib/runtime. Node 4+ features like const/let and arrow functions are
                    // not acceptable here, and importing any npm packages should be contemplated
                    // with extreme skepticism.

                    var utils = _require8("./utils.js");
                    var Entry = _require8("./entry.js");

                    // The exports.enable method can be used to enable the Reify runtime for
                    // specific module objects, or for Module.prototype (where implemented),
                    // to make the runtime available throughout the entire module system.
                    _exports7.enable = function (mod) {
                      if (mod.link !== moduleLink) {
                        mod.link = moduleLink;
                        mod["export"] = moduleExport;
                        mod.exportDefault = moduleExportDefault;
                        mod.exportAs = moduleExportAs;
                        mod.runSetters = runSetters;

                        // Legacy shorthand for mod.exportAs("*").
                        mod.makeNsSetter = moduleMakeNsSetter;

                        return true;
                      }

                      return false;
                    };

                    // Calling module.link(id, setters) resolves the given ID using
                    // module.resolve(id), which should return a canonical absolute module
                    // identifier string (like require.resolve); then creates an Entry object
                    // for the child module and evaluates its code (if this is the first time
                    // it has been imported) by calling module.require(id). Finally, the
                    // provided setter functions will be called with values exported by the
                    // module, possibly multiple times when/if those exported values change.
                    // The module.link name is intended to evoke the "liveness" of the
                    // exported bindings, since we are subscribing to all future exports of
                    // the child module, not just taking a snapshot of its current exports.
                    function moduleLink(id, setters, key) {
                      utils.setESModule(this.exports);
                      Entry.getOrCreate(this.id, this);

                      var absChildId = this.resolve(id);
                      var childEntry = Entry.getOrCreate(absChildId);

                      if (utils.isObject(setters)) {
                        childEntry.addSetters(this, setters, key);
                      }

                      var _exports8 = this.require(absChildId);

                      if (childEntry.module === null) {
                        childEntry.module = {
                          id: absChildId,
                          exports: _exports8
                        };
                      }

                      childEntry.runSetters();
                    }

                    // Register getter functions for local variables in the scope of an export
                    // statement. Pass true as the second argument to indicate that the getter
                    // functions always return the same values.
                    function moduleExport(getters, constant) {
                      utils.setESModule(this.exports);
                      var entry = Entry.getOrCreate(this.id, this);
                      entry.addGetters(getters, constant);
                      if (this.loaded) {
                        // If the module has already been evaluated, then we need to trigger
                        // another round of entry.runSetters calls, which begins by calling
                        // entry.runModuleGetters(module).
                        entry.runSetters();
                      }
                    }

                    // Register a getter function that always returns the given value.
                    function moduleExportDefault(value) {
                      return this["export"]({
                        "default": function () {
                          return value;
                        }
                      }, true);
                    }

                    // Returns a function suitable for passing as a setter callback to
                    // module.link. If name is an identifier, calling the function will set
                    // the export of that name to the given value. If the name is "*", all
                    // properties of the value object will be exported by name, except for
                    // "default" (use "*+" instead of "*" to include it). Why the "default"
                    // property is skipped: https://github.com/tc39/ecma262/issues/948
                    function moduleExportAs(name) {
                      var entry = this;
                      var includeDefault = name === "*+";
                      return function (value) {
                        if (name === "*" || name === "*+") {
                          Object.keys(value).forEach(function (key) {
                            if (includeDefault || key !== "default") {
                              utils.copyKey(key, entry.exports, value);
                            }
                          });
                        } else {
                          entry.exports[name] = value;
                        }
                      };
                    }

                    // Platform-specific code should find a way to call this method whenever
                    // the module system is about to return module.exports from require. This
                    // might happen more than once per module, in case of dependency cycles,
                    // so we want Module.prototype.runSetters to run each time.
                    function runSetters(valueToPassThrough) {
                      Entry.getOrCreate(this.id, this).runSetters();

                      // Assignments to exported local variables get wrapped with calls to
                      // module.runSetters, so module.runSetters returns the
                      // valueToPassThrough parameter to allow the value of the original
                      // expression to pass through. For example,
                      //
                      //   export var a = 1;
                      //   console.log(a += 3);
                      //
                      // becomes
                      //
                      //   module.export("a", () => a);
                      //   var a = 1;
                      //   console.log(module.runSetters(a += 3));
                      //
                      // This ensures module.runSetters runs immediately after the assignment,
                      // and does not interfere with the larger computation.
                      return valueToPassThrough;
                    }

                    // Legacy helper that returns a function that takes a namespace object and
                    // copies the properties of the namespace to module.exports, excluding any
                    // "default" property (unless includeDefault is true), which is useful for
                    // implementing `export * from "module"`.
                    //
                    // Instead of using this helper like so:
                    //
                    //   module.link(id, { "*": module.makeNsSetter() });
                    //
                    // non-legacy code should simply use a string-valued setter:
                    //
                    //   module.link(id, { "*": "*" });
                    //
                    // or, to include the "default" property:
                    //
                    //   module.link(id, { "*": "*+" });
                    //
                    // This helper may be removed in a future version of Reify.
                    function moduleMakeNsSetter(includeDefault) {
                      return this.exportAs(includeDefault ? "*+" : "*");
                    }

                    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "utils.js": function module(_require9, _exports9, _module10) {

                    // This module should be compatible with PhantomJS v1, just like the other files
                    // in reify/lib/runtime. Node 4+ features like const/let and arrow functions are
                    // not acceptable here, and importing any npm packages should be contemplated
                    // with extreme skepticism.

                    var useSetPrototypeOf = typeof Object.setPrototypeOf === "function";
                    var useSymbol = typeof Symbol === "function";

                    var esStrKey = "__esModule";
                    var esSymKey = useSymbol ? Symbol.for(esStrKey) : null;
                    var useToStringTag = useSymbol && typeof Symbol.toStringTag === "symbol";
                    var useGetOwnPropDesc = typeof Object.getOwnPropertyDescriptor === "function";
                    var hasOwn = Object.prototype.hasOwnProperty;

                    function copyKey(key, target, source) {
                      if (useGetOwnPropDesc) {
													if (key === 'frameElement') {return;}
                        var desc = Object.getOwnPropertyDescriptor(source, key);
                        desc.configurable = true; // Allow redefinition.
                        Object.defineProperty(target, key, desc);
                      } else {
                        target[key] = source[key];
                      }
                    }

                    _exports9.copyKey = copyKey;

                    // Returns obj[key] unless that property is defined by a getter function,
                    // in which case the getter function is returned.
                    _exports9.valueOrGetter = function (obj, key) {
                      if (useGetOwnPropDesc && hasOwn.call(obj, key)) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (typeof desc.get === "function") {
                          return desc.get;
                        }
                      }

                      return obj[key];
                    };

                    function getESModule(exported) {
                      if (isObjectLike(exported)) {
                        if (useSymbol && hasOwn.call(exported, esSymKey)) {
                          return !!exported[esSymKey];
                        }

                        if (hasOwn.call(exported, esStrKey)) {
                          return !!exported[esStrKey];
                        }
                      }

                      return false;
                    }

                    _exports9.getESModule = getESModule;

                    function setESModule(exported) {
                      if (isObjectLike(exported)) {
                        if (useSymbol) {
                          exported[esSymKey] = true;
                        }

                        if (!exported[esStrKey]) {
                          // Other module runtime systems may set exported.__esModule such
                          // that it can't be redefined, so we call Object.defineProperty only
                          // when exported.__esModule is not already true.
                          Object.defineProperty(exported, esStrKey, {
                            configurable: true,
                            enumerable: false,
                            value: true,
                            writable: false
                          });
                        }
                      }
                    }

                    _exports9.setESModule = setESModule;

                    function isObject(value) {
                      return typeof value === "object" && value !== null;
                    }

                    _exports9.isObject = isObject;

                    function isObjectLike(value) {
                      var type = typeof value;
                      return type === "function" || type === "object" && value !== null;
                    }

                    _exports9.isObjectLike = isObjectLike;

                    function createNamespace() {
                      var namespace = Object.create(null);

                      if (useToStringTag) {
                        Object.defineProperty(namespace, Symbol.toStringTag, {
                          value: "Module",
                          configurable: false,
                          enumerable: false,
                          writable: false
                        });
                      }

                      setESModule(namespace);

                      return namespace;
                    }

                    _exports9.createNamespace = createNamespace;

                    function setPrototypeOf(object, proto) {
                      if (useSetPrototypeOf) {
                        Object.setPrototypeOf(object, proto);
                      } else {
                        object.__proto__ = proto;
                      }
                      return object;
                    }

                    _exports9.setPrototypeOf = setPrototypeOf;

                    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "entry.js": function module(_require10, _exports10, _module11) {

                    // This module should be compatible with PhantomJS v1, just like the other files
                    // in reify/lib/runtime. Node 4+ features like const/let and arrow functions are
                    // not acceptable here, and importing any npm packages should be contemplated
                    // with extreme skepticism.

                    var utils = _require10("./utils.js");

                    var GETTER_ERROR = {};
                    var NAN = {};
                    var UNDEFINED = {};
                    var hasOwn = Object.prototype.hasOwnProperty;
                    var keySalt = 0;

                    function Entry(id) {
                      // The canonical absolute module ID of the module this Entry manages.
                      this.id = id;
                      // The Module object this Entry manages, unknown until module.export or
                      // module.link is called for the first time.
                      this.module = null;
                      // Getters for local variables exported from the managed module.
                      this.getters = Object.create(null);
                      // Setters for assigning to local variables in parent modules.
                      this.setters = Object.create(null);
                      // The normalized namespace object that importers receive when they use
                      // `import * as namespace from "..."` syntax.
                      this.namespace = utils.createNamespace();
                    }

                    var Ep = utils.setPrototypeOf(Entry.prototype, null);
                    var entryMap = Object.create(null);

                    Entry.getOrCreate = function (id, mod) {
                      var entry = hasOwn.call(entryMap, id) ? entryMap[id] : entryMap[id] = new Entry(id);

                      if (utils.isObject(mod) && mod.id === entry.id) {
                        entry.module = mod;
                      }

                      return entry;
                    };

                    function safeKeys(obj) {
                      var keys = Object.keys(obj);
                      var esModuleIndex = keys.indexOf("__esModule");
                      if (esModuleIndex >= 0) {
                        keys.splice(esModuleIndex, 1);
                      }
                      return keys;
                    }

                    Ep.addGetters = function (getters, constant) {
                      var names = safeKeys(getters);
                      var nameCount = names.length;
                      constant = !!constant;

                      for (var i = 0; i < nameCount; ++i) {
                        var name = names[i];
                        var getter = getters[name];

                        if (typeof getter === "function" &&
                        // Should this throw if this.getters[name] exists?
                        !(name in this.getters)) {
                          this.getters[name] = getter;
                          getter.constant = constant;
                          getter.runCount = 0;
                        }
                      }
                    };

                    Ep.addSetters = function (parent, setters, key) {
                      var names = safeKeys(setters);
                      var nameCount = names.length;

                      if (!nameCount) {
                        return;
                      }

                      // If no key is provided, make a unique key. Otherwise, make sure the key is
                      // distinct from keys provided by other parent modules.
                      key = key === void 0 ? makeUniqueKey() : parent.id + ":" + key;

                      var entry = this;

                      for (var i = 0; i < nameCount; ++i) {
                        var name = names[i];
                        var setter = normalizeSetterValue(parent, setters[name]);

                        if (typeof setter === "function") {
                          setter.parent = parent;
                          if (!(name in entry.setters)) {
                            entry.setters[name] = Object.create(null);
                          }
                          entry.setters[name][key] = setter;
                        }
                      }

                      entry.runSetters(names);
                    };

                    function normalizeSetterValue(_module12, setter) {
                      if (typeof setter === "function") {
                        return setter;
                      }

                      if (typeof setter === "string") {
                        // If the value of the setter property is a string, the setter will
                        // re-export the imported value using that string as the name of the
                        // exported value. If the string is "*", all properties of the value
                        // object will be re-exported as individual exports, except for the
                        // "default" property (use "*+" instead of "*" to include it).
                        return _module12.exportAs(setter);
                      }

                      if (Array.isArray(setter)) {
                        switch (setter.length) {
                          case 0:
                            return null;
                          case 1:
                            return normalizeSetterValue(_module12, setter[0]);
                          default:
                            var setterFns = setter.map(function (elem) {
                              return normalizeSetterValue(_module12, elem);
                            });

                            // Return a combined function that calls all of the nested setter
                            // functions with the same value.
                            return function (value) {
                              setterFns.forEach(function (fn) {
                                fn(value);
                              });
                            };
                        }
                      }

                      return null;
                    }

                    Ep.runGetters = function (names) {
                      // Before running getters, copy anything added to the exports object
                      // over to the namespace. Values returned by getters take precedence
                      // over these values, but we don't want to miss anything.
                      syncExportsToNamespace(this, names);

                      if (names === void 0 || names.indexOf("*") >= 0) {
                        names = Object.keys(this.getters);
                      }

                      var nameCount = names.length;

                      for (var i = 0; i < nameCount; ++i) {
                        var name = names[i];
                        var value = runGetter(this, name);

                        // If the getter is run without error, update both entry.namespace and
                        // module.exports with the current value so that CommonJS require
                        // calls remain consistent with module.watch.
                        if (value !== GETTER_ERROR) {
                          this.namespace[name] = value;
                          this.module.exports[name] = value;
                        }
                      }
                    };

                    function syncExportsToNamespace(entry, names) {
                      var setDefault = false;

                      if (entry.module === null) return;
                      var _exports11 = entry.module.exports;

                      if (!utils.getESModule(_exports11)) {
                        // If the module entry is managing overrides module.exports, that
                        // value should be exposed as the .default property of the namespace,
                        // unless module.exports is marked as an ECMASCript module.
                        entry.namespace.default = _exports11;
                        setDefault = true;
                      }

                      if (!utils.isObjectLike(_exports11)) {
                        return;
                      }

                      if (names === void 0 || names.indexOf("*") >= 0) {
                        names = Object.keys(_exports11);
                      }

                      names.forEach(function (key) {
                        // Don't set any properties for which a getter function exists in
                        // entry.getters, don't accidentally override entry.namespace.default,
                        // and only copy own properties from entry.module.exports.
                        if (!hasOwn.call(entry.getters, key) && !(setDefault && key === "default") && hasOwn.call(_exports11, key)) {
                          utils.copyKey(key, entry.namespace, _exports11);
                        }
                      });
                    }

                    // Called whenever module.exports might have changed, to trigger any
                    // setters associated with the newly exported values. The names parameter
                    // is optional; without it, all getters and setters will run.
                    Ep.runSetters = function (names) {
                      // Make sure entry.namespace and module.exports are up to date before we
                      // call getExportByName(entry, name).
                      this.runGetters(names);

                      // Lazily-initialized object mapping parent module identifiers to parent
                      // module objects whose setters we might need to run.
                      var parents;

                      forEachSetter(this, names, function (setter, name, value) {
                        if (parents === void 0) {
                          parents = Object.create(null);
                        }
                        parents[setter.parent.id] = setter.parent;

                        // The param order for setters is `value` then `name` because the `name`
                        // param is only used by namespace exports.
                        setter(value, name);
                      });

                      if (!parents) {
                        return;
                      }

                      // If any of the setters updated the module.exports of a parent module,
                      // or updated local variables that are exported by that parent module,
                      // then we must re-run any setters registered by that parent module.
                      var parentIDs = Object.keys(parents);
                      var parentIDCount = parentIDs.length;

                      for (var i = 0; i < parentIDCount; ++i) {
                        // What happens if parents[parentIDs[id]] === module, or if
                        // longer cycles exist in the parent chain? Thanks to our setter.last
                        // bookkeeping above, the runSetters broadcast will only proceed
                        // as far as there are any actual changes to report.
                        var parent = parents[parentIDs[i]];
                        var parentEntry = entryMap[parent.id];
                        if (parentEntry) {
                          parentEntry.runSetters();
                        }
                      }
                    };

                    function callSetterIfNecessary(setter, name, value, callback) {
                      if (name === "__esModule") {
                        // Ignore setters asking for module.exports.__esModule.
                        return;
                      }

                      var shouldCall = false;

                      if (setter.last === void 0) {
                        setter.last = Object.create(null);
                        // Always call the setter if it has never been called before.
                        shouldCall = true;
                      }

                      function changed(name, value) {
                        var valueToCompare = value;
                        if (valueToCompare !== valueToCompare) {
                          valueToCompare = NAN;
                        } else if (valueToCompare === void 0) {
                          valueToCompare = UNDEFINED;
                        }

                        if (setter.last[name] === valueToCompare) {
                          return false;
                        }

                        setter.last[name] = valueToCompare;
                        return true;
                      }

                      if (name === "*") {
                        var keys = safeKeys(value);
                        var keyCount = keys.length;
                        for (var i = 0; i < keyCount; ++i) {
                          var key = keys[i];
                          // Evaluating value[key] is risky because the property might be
                          // defined by a getter function that logs a deprecation warning (or
                          // worse) when evaluated. For example, Node uses this trick to
                          // display a deprecation warning whenever crypto.createCredentials
                          // is accessed. Fortunately, when value[key] is defined by a getter
                          // function, it's enough to check whether the getter function itself
                          // has changed, since we are careful elsewhere to preserve getters
                          // rather than prematurely evaluating them.
                          if (changed(key, utils.valueOrGetter(value, key))) {
                            shouldCall = true;
                          }
                        }
                      } else if (changed(name, value)) {
                        shouldCall = true;
                      }

                      if (shouldCall) {
                        // Only invoke the callback if we have not called this setter
                        // (with a value of this name) before, or the current value is
                        // different from the last value we passed to this setter.
                        return callback(setter, name, value);
                      }
                    }

                    // Invoke the given callback once for every (setter, name, value) that needs to
                    // be called. Note that forEachSetter does not call any setters itself, only the
                    // given callback.
                    function forEachSetter(entry, names, callback) {
                      var needToCheckNames = true;

                      if (names === void 0) {
                        names = Object.keys(entry.setters);
                        needToCheckNames = false;
                      }

                      var nameCount = names.length;

                      for (var i = 0; i < nameCount; ++i) {
                        var name = names[i];

                        if (needToCheckNames && !hasOwn.call(entry.setters, name)) {
                          continue;
                        }

                        var setters = entry.setters[name];
                        var keys = Object.keys(setters);
                        var keyCount = keys.length;

                        for (var j = 0; j < keyCount; ++j) {
                          var key = keys[j];
                          var value = getExportByName(entry, name);

                          callSetterIfNecessary(setters[key], name, value, callback);

                          var getter = entry.getters[name];
                          if (typeof getter === "function" &&
                          // Sometimes a getter function will throw because it's called
                          // before the variable it's supposed to return has been
                          // initialized, so we need to know that the getter function has
                          // run to completion at least once.
                          getter.runCount > 0 && getter.constant) {
                            // If we happen to know that this getter function has run
                            // successfully, and will never return a different value, then we
                            // can forget the corresponding setter, because we've already
                            // reported that constant value. Note that we can't forget the
                            // getter, because we need to remember the original value in case
                            // anyone tampers with entry.module.exports[name].
                            delete setters[key];
                          }
                        }
                      }
                    }

                    function getExportByName(entry, name) {
                      if (name === "*") {
                        return entry.namespace;
                      }

                      if (hasOwn.call(entry.namespace, name)) {
                        return entry.namespace[name];
                      }

                      if (entry.module === null) return;
                      var exports = entry.module.exports;

                      if (name === "default" && !(utils.getESModule(exports) && "default" in exports)) {
                        return exports;
                      }

                      if (exports == null) {
                        return;
                      }

                      return exports[name];
                    }

                    function makeUniqueKey() {
                      return Math.random().toString(36)
                      // Add an incrementing salt to help track key ordering and also
                      // absolutely guarantee we never return the same key twice.
                      .replace("0.", ++keySalt + "$");
                    }

                    function runGetter(entry, name) {
                      var getter = entry.getters[name];
                      try {
                        var result = getter();
                        ++getter.runCount;
                        return result;
                      } catch (e) {}
                      return GETTER_ERROR;
                    }

                    _module11.exports = Entry;

                    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } } } } } }, "meteor-node-stubs": { "package.json": function module(_require11, _exports12, _module13) {

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //                                                                                                                     //
          // node_modules/meteor-node-stubs/package.json                                                                         //
          //                                                                                                                     //
          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //
          _module13.exports = {
            "name": "meteor-node-stubs",
            "version": "1.2.27",
            "main": "index.js"
          };

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }, "index.js": function module(_require12, _exports13, _module14) {

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //                                                                                                                     //
          // node_modules/meteor-node-stubs/index.js                                                                             //
          //                                                                                                                     //
          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //
          var map = _require12("./map.json");
          var meteorAliases = {};

          Object.keys(map).forEach(function (id) {
            if (typeof map[id] === "string") {
              var aliasParts = _module14.id.split("/");
              aliasParts.pop();
              aliasParts.push("node_modules", map[id]);
              _exports13[id] = meteorAliases[id + ".js"] = meteorAliases["node:" + id] = aliasParts.join("/");
            } else {
              _exports13[id] = map[id];
              meteorAliases[id + ".js"] = meteorAliases["node:" + id] = function () {};
            }
          });

          if (typeof meteorInstall === "function") {
            meteorInstall({
              // Install the aliases into a node_modules directory one level up from
              // the root directory, so that they do not clutter the namespace
              // available to apps and packages.
              "..": {
                node_modules: meteorAliases
              }
            });
          }

          // If Buffer is not defined globally, but the "buffer" built-in stub is
          // installed and can be imported, use it to define global.Buffer so that
          // modules like core-util-is/lib/util.js can refer to Buffer without
          // crashing application startup.
          if (typeof global.Buffer !== "function") {
            try {
              // Use (0, require)(...) to avoid registering a dependency on the
              // "buffer" stub, in case it is not otherwise bundled.
              global.Buffer = (0, _require12)("buffer").Buffer;
            } catch (ok) {
              // Failure to import "buffer" is fine as long as the Buffer global
              // variable is not used.
            }
          }

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }, "map.json": function module(_require13, _exports14, _module15) {

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //                                                                                                                     //
          // node_modules/meteor-node-stubs/map.json                                                                             //
          //                                                                                                                     //
          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          //
          _module15.exports = {
            "assert": "assert/",
            "buffer": "buffer/",
            "child_process": null,
            "cluster": null,
            "console": "console-browserify",
            "constants": "constants-browserify",
            "crypto": "../wrappers/crypto.js",
            "dgram": null,
            "dns": null,
            "domain": "domain-browser",
            "events": "events/",
            "fs": null,
            "http": "stream-http",
            "https": "https-browserify",
            "module": "../wrappers/module.js",
            "net": null,
            "os": "os-browserify/browser.js",
            "path": "path-browserify",
            "process": "process/browser.js",
            "punycode": "punycode/",
            "querystring": "querystring-es3/",
            "readline": null,
            "repl": null,
            "stream": "stream-browserify",
            "_stream_duplex": "readable-stream/lib/_stream_duplex.js",
            "_stream_passthrough": "readable-stream/lib/_stream_passthrough.js",
            "_stream_readable": "readable-stream/lib/_stream_readable.js",
            "_stream_transform": "readable-stream/lib/_stream_transform.js",
            "_stream_writable": "readable-stream/lib/_stream_writable.js",
            "string_decoder": "string_decoder/",
            "sys": "util/util.js",
            "timers": "timers-browserify",
            "tls": null,
            "tty": "tty-browserify",
            "url": "url/",
            "util": "util/util.js",
            "vm": "vm-browserify",
            "zlib": "browserify-zlib"
          };

          /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        }, "deps": { "process.js": function _module16(_require14) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // node_modules/meteor-node-stubs/deps/process.js                                                                      //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _require14("process/browser.js");

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } }, "node_modules": { "process": { "browser.js": function module(_require15, _exports15, _module17) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/meteor-node-stubs/node_modules/process/browser.js                                                      //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              // shim for using process in browser
              var process = _module17.exports = {};

              // cached from whatever global is present so that test runners that stub it
              // don't break things.  But we need to wrap it in a try catch in case it is
              // wrapped in strict mode code which doesn't define any globals.  It's inside a
              // function because try/catches deoptimize in certain engines.

              var cachedSetTimeout;
              var cachedClearTimeout;

              function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
              }
              function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
              }
              (function () {
                try {
                  if (typeof setTimeout === 'function') {
                    cachedSetTimeout = setTimeout;
                  } else {
                    cachedSetTimeout = defaultSetTimout;
                  }
                } catch (e) {
                  cachedSetTimeout = defaultSetTimout;
                }
                try {
                  if (typeof clearTimeout === 'function') {
                    cachedClearTimeout = clearTimeout;
                  } else {
                    cachedClearTimeout = defaultClearTimeout;
                  }
                } catch (e) {
                  cachedClearTimeout = defaultClearTimeout;
                }
              })();
              function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) {
                  //normal enviroments in sane situations
                  return setTimeout(fun, 0);
                }
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                  cachedSetTimeout = setTimeout;
                  return setTimeout(fun, 0);
                }
                try {
                  // when when somebody has screwed with setTimeout but no I.E. maddness
                  return cachedSetTimeout(fun, 0);
                } catch (e) {
                  try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                    return cachedSetTimeout.call(null, fun, 0);
                  } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                    return cachedSetTimeout.call(this, fun, 0);
                  }
                }
              }
              function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) {
                  //normal enviroments in sane situations
                  return clearTimeout(marker);
                }
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                  cachedClearTimeout = clearTimeout;
                  return clearTimeout(marker);
                }
                try {
                  // when when somebody has screwed with setTimeout but no I.E. maddness
                  return cachedClearTimeout(marker);
                } catch (e) {
                  try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                    return cachedClearTimeout.call(null, marker);
                  } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                    // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                    return cachedClearTimeout.call(this, marker);
                  }
                }
              }
              var queue = [];
              var draining = false;
              var currentQueue;
              var queueIndex = -1;

              function cleanUpNextTick() {
                if (!draining || !currentQueue) {
                  return;
                }
                draining = false;
                if (currentQueue.length) {
                  queue = currentQueue.concat(queue);
                } else {
                  queueIndex = -1;
                }
                if (queue.length) {
                  drainQueue();
                }
              }

              function drainQueue() {
                if (draining) {
                  return;
                }
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;

                var len = queue.length;
                while (len) {
                  currentQueue = queue;
                  queue = [];
                  while (++queueIndex < len) {
                    if (currentQueue) {
                      currentQueue[queueIndex].run();
                    }
                  }
                  queueIndex = -1;
                  len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
              }

              process.nextTick = function (fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) {
                  for (var i = 1; i < arguments.length; i++) {
                    args[i - 1] = arguments[i];
                  }
                }
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) {
                  runTimeout(drainQueue);
                }
              };

              // v8 likes predictible objects
              function Item(fun, array) {
                this.fun = fun;
                this.array = array;
              }
              Item.prototype.run = function () {
                this.fun.apply(null, this.array);
              };
              process.title = 'browser';
              process.browser = true;
              process.env = {};
              process.argv = [];
              process.version = ''; // empty string to avoid regexp issues
              process.versions = {};

              function noop() {}

              process.on = noop;
              process.addListener = noop;
              process.once = noop;
              process.off = noop;
              process.removeListener = noop;
              process.removeAllListeners = noop;
              process.emit = noop;
              process.prependListener = noop;
              process.prependOnceListener = noop;

              process.listeners = function (name) {
                return [];
              };

              process.binding = function (name) {
                throw new Error('process.binding is not supported');
              };

              process.cwd = function () {
                return '/';
              };
              process.chdir = function (dir) {
                throw new Error('process.chdir is not supported');
              };
              process.umask = function () {
                return 0;
              };

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            } } } }, "@babel": { "runtime": { "package.json": function module(_require16, _exports16, _module18) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // node_modules/@babel/runtime/package.json                                                                            //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module18.exports = {
              "author": {
                "name": "The Babel Team",
                "url": "https://babel.dev/team"
              },
              "bugs": {
                "url": "https://github.com/babel/babel/issues"
              },
              "bundleDependencies": false,
              "deprecated": false,
              "description": "babel's modular runtime helpers",
              "engines": {
                "node": ">=6.9.0"
              },
              "exports": {
                "./helpers/OverloadYield": [{
                  "node": "./helpers/OverloadYield.js",
                  "import": "./helpers/esm/OverloadYield.js",
                  "default": "./helpers/OverloadYield.js"
                }, "./helpers/OverloadYield.js"],
                "./helpers/esm/OverloadYield": "./helpers/esm/OverloadYield.js",
                "./helpers/applyDecoratedDescriptor": [{
                  "node": "./helpers/applyDecoratedDescriptor.js",
                  "import": "./helpers/esm/applyDecoratedDescriptor.js",
                  "default": "./helpers/applyDecoratedDescriptor.js"
                }, "./helpers/applyDecoratedDescriptor.js"],
                "./helpers/esm/applyDecoratedDescriptor": "./helpers/esm/applyDecoratedDescriptor.js",
                "./helpers/applyDecs2311": [{
                  "node": "./helpers/applyDecs2311.js",
                  "import": "./helpers/esm/applyDecs2311.js",
                  "default": "./helpers/applyDecs2311.js"
                }, "./helpers/applyDecs2311.js"],
                "./helpers/esm/applyDecs2311": "./helpers/esm/applyDecs2311.js",
                "./helpers/arrayLikeToArray": [{
                  "node": "./helpers/arrayLikeToArray.js",
                  "import": "./helpers/esm/arrayLikeToArray.js",
                  "default": "./helpers/arrayLikeToArray.js"
                }, "./helpers/arrayLikeToArray.js"],
                "./helpers/esm/arrayLikeToArray": "./helpers/esm/arrayLikeToArray.js",
                "./helpers/arrayWithHoles": [{
                  "node": "./helpers/arrayWithHoles.js",
                  "import": "./helpers/esm/arrayWithHoles.js",
                  "default": "./helpers/arrayWithHoles.js"
                }, "./helpers/arrayWithHoles.js"],
                "./helpers/esm/arrayWithHoles": "./helpers/esm/arrayWithHoles.js",
                "./helpers/arrayWithoutHoles": [{
                  "node": "./helpers/arrayWithoutHoles.js",
                  "import": "./helpers/esm/arrayWithoutHoles.js",
                  "default": "./helpers/arrayWithoutHoles.js"
                }, "./helpers/arrayWithoutHoles.js"],
                "./helpers/esm/arrayWithoutHoles": "./helpers/esm/arrayWithoutHoles.js",
                "./helpers/assertClassBrand": [{
                  "node": "./helpers/assertClassBrand.js",
                  "import": "./helpers/esm/assertClassBrand.js",
                  "default": "./helpers/assertClassBrand.js"
                }, "./helpers/assertClassBrand.js"],
                "./helpers/esm/assertClassBrand": "./helpers/esm/assertClassBrand.js",
                "./helpers/assertThisInitialized": [{
                  "node": "./helpers/assertThisInitialized.js",
                  "import": "./helpers/esm/assertThisInitialized.js",
                  "default": "./helpers/assertThisInitialized.js"
                }, "./helpers/assertThisInitialized.js"],
                "./helpers/esm/assertThisInitialized": "./helpers/esm/assertThisInitialized.js",
                "./helpers/asyncGeneratorDelegate": [{
                  "node": "./helpers/asyncGeneratorDelegate.js",
                  "import": "./helpers/esm/asyncGeneratorDelegate.js",
                  "default": "./helpers/asyncGeneratorDelegate.js"
                }, "./helpers/asyncGeneratorDelegate.js"],
                "./helpers/esm/asyncGeneratorDelegate": "./helpers/esm/asyncGeneratorDelegate.js",
                "./helpers/asyncIterator": [{
                  "node": "./helpers/asyncIterator.js",
                  "import": "./helpers/esm/asyncIterator.js",
                  "default": "./helpers/asyncIterator.js"
                }, "./helpers/asyncIterator.js"],
                "./helpers/esm/asyncIterator": "./helpers/esm/asyncIterator.js",
                "./helpers/asyncToGenerator": [{
                  "node": "./helpers/asyncToGenerator.js",
                  "import": "./helpers/esm/asyncToGenerator.js",
                  "default": "./helpers/asyncToGenerator.js"
                }, "./helpers/asyncToGenerator.js"],
                "./helpers/esm/asyncToGenerator": "./helpers/esm/asyncToGenerator.js",
                "./helpers/awaitAsyncGenerator": [{
                  "node": "./helpers/awaitAsyncGenerator.js",
                  "import": "./helpers/esm/awaitAsyncGenerator.js",
                  "default": "./helpers/awaitAsyncGenerator.js"
                }, "./helpers/awaitAsyncGenerator.js"],
                "./helpers/esm/awaitAsyncGenerator": "./helpers/esm/awaitAsyncGenerator.js",
                "./helpers/callSuper": [{
                  "node": "./helpers/callSuper.js",
                  "import": "./helpers/esm/callSuper.js",
                  "default": "./helpers/callSuper.js"
                }, "./helpers/callSuper.js"],
                "./helpers/esm/callSuper": "./helpers/esm/callSuper.js",
                "./helpers/checkInRHS": [{
                  "node": "./helpers/checkInRHS.js",
                  "import": "./helpers/esm/checkInRHS.js",
                  "default": "./helpers/checkInRHS.js"
                }, "./helpers/checkInRHS.js"],
                "./helpers/esm/checkInRHS": "./helpers/esm/checkInRHS.js",
                "./helpers/checkPrivateRedeclaration": [{
                  "node": "./helpers/checkPrivateRedeclaration.js",
                  "import": "./helpers/esm/checkPrivateRedeclaration.js",
                  "default": "./helpers/checkPrivateRedeclaration.js"
                }, "./helpers/checkPrivateRedeclaration.js"],
                "./helpers/esm/checkPrivateRedeclaration": "./helpers/esm/checkPrivateRedeclaration.js",
                "./helpers/classCallCheck": [{
                  "node": "./helpers/classCallCheck.js",
                  "import": "./helpers/esm/classCallCheck.js",
                  "default": "./helpers/classCallCheck.js"
                }, "./helpers/classCallCheck.js"],
                "./helpers/esm/classCallCheck": "./helpers/esm/classCallCheck.js",
                "./helpers/classNameTDZError": [{
                  "node": "./helpers/classNameTDZError.js",
                  "import": "./helpers/esm/classNameTDZError.js",
                  "default": "./helpers/classNameTDZError.js"
                }, "./helpers/classNameTDZError.js"],
                "./helpers/esm/classNameTDZError": "./helpers/esm/classNameTDZError.js",
                "./helpers/classPrivateFieldGet2": [{
                  "node": "./helpers/classPrivateFieldGet2.js",
                  "import": "./helpers/esm/classPrivateFieldGet2.js",
                  "default": "./helpers/classPrivateFieldGet2.js"
                }, "./helpers/classPrivateFieldGet2.js"],
                "./helpers/esm/classPrivateFieldGet2": "./helpers/esm/classPrivateFieldGet2.js",
                "./helpers/classPrivateFieldInitSpec": [{
                  "node": "./helpers/classPrivateFieldInitSpec.js",
                  "import": "./helpers/esm/classPrivateFieldInitSpec.js",
                  "default": "./helpers/classPrivateFieldInitSpec.js"
                }, "./helpers/classPrivateFieldInitSpec.js"],
                "./helpers/esm/classPrivateFieldInitSpec": "./helpers/esm/classPrivateFieldInitSpec.js",
                "./helpers/classPrivateFieldLooseBase": [{
                  "node": "./helpers/classPrivateFieldLooseBase.js",
                  "import": "./helpers/esm/classPrivateFieldLooseBase.js",
                  "default": "./helpers/classPrivateFieldLooseBase.js"
                }, "./helpers/classPrivateFieldLooseBase.js"],
                "./helpers/esm/classPrivateFieldLooseBase": "./helpers/esm/classPrivateFieldLooseBase.js",
                "./helpers/classPrivateFieldLooseKey": [{
                  "node": "./helpers/classPrivateFieldLooseKey.js",
                  "import": "./helpers/esm/classPrivateFieldLooseKey.js",
                  "default": "./helpers/classPrivateFieldLooseKey.js"
                }, "./helpers/classPrivateFieldLooseKey.js"],
                "./helpers/esm/classPrivateFieldLooseKey": "./helpers/esm/classPrivateFieldLooseKey.js",
                "./helpers/classPrivateFieldSet2": [{
                  "node": "./helpers/classPrivateFieldSet2.js",
                  "import": "./helpers/esm/classPrivateFieldSet2.js",
                  "default": "./helpers/classPrivateFieldSet2.js"
                }, "./helpers/classPrivateFieldSet2.js"],
                "./helpers/esm/classPrivateFieldSet2": "./helpers/esm/classPrivateFieldSet2.js",
                "./helpers/classPrivateGetter": [{
                  "node": "./helpers/classPrivateGetter.js",
                  "import": "./helpers/esm/classPrivateGetter.js",
                  "default": "./helpers/classPrivateGetter.js"
                }, "./helpers/classPrivateGetter.js"],
                "./helpers/esm/classPrivateGetter": "./helpers/esm/classPrivateGetter.js",
                "./helpers/classPrivateMethodInitSpec": [{
                  "node": "./helpers/classPrivateMethodInitSpec.js",
                  "import": "./helpers/esm/classPrivateMethodInitSpec.js",
                  "default": "./helpers/classPrivateMethodInitSpec.js"
                }, "./helpers/classPrivateMethodInitSpec.js"],
                "./helpers/esm/classPrivateMethodInitSpec": "./helpers/esm/classPrivateMethodInitSpec.js",
                "./helpers/classPrivateSetter": [{
                  "node": "./helpers/classPrivateSetter.js",
                  "import": "./helpers/esm/classPrivateSetter.js",
                  "default": "./helpers/classPrivateSetter.js"
                }, "./helpers/classPrivateSetter.js"],
                "./helpers/esm/classPrivateSetter": "./helpers/esm/classPrivateSetter.js",
                "./helpers/classStaticPrivateMethodGet": [{
                  "node": "./helpers/classStaticPrivateMethodGet.js",
                  "import": "./helpers/esm/classStaticPrivateMethodGet.js",
                  "default": "./helpers/classStaticPrivateMethodGet.js"
                }, "./helpers/classStaticPrivateMethodGet.js"],
                "./helpers/esm/classStaticPrivateMethodGet": "./helpers/esm/classStaticPrivateMethodGet.js",
                "./helpers/construct": [{
                  "node": "./helpers/construct.js",
                  "import": "./helpers/esm/construct.js",
                  "default": "./helpers/construct.js"
                }, "./helpers/construct.js"],
                "./helpers/esm/construct": "./helpers/esm/construct.js",
                "./helpers/createClass": [{
                  "node": "./helpers/createClass.js",
                  "import": "./helpers/esm/createClass.js",
                  "default": "./helpers/createClass.js"
                }, "./helpers/createClass.js"],
                "./helpers/esm/createClass": "./helpers/esm/createClass.js",
                "./helpers/createForOfIteratorHelper": [{
                  "node": "./helpers/createForOfIteratorHelper.js",
                  "import": "./helpers/esm/createForOfIteratorHelper.js",
                  "default": "./helpers/createForOfIteratorHelper.js"
                }, "./helpers/createForOfIteratorHelper.js"],
                "./helpers/esm/createForOfIteratorHelper": "./helpers/esm/createForOfIteratorHelper.js",
                "./helpers/createForOfIteratorHelperLoose": [{
                  "node": "./helpers/createForOfIteratorHelperLoose.js",
                  "import": "./helpers/esm/createForOfIteratorHelperLoose.js",
                  "default": "./helpers/createForOfIteratorHelperLoose.js"
                }, "./helpers/createForOfIteratorHelperLoose.js"],
                "./helpers/esm/createForOfIteratorHelperLoose": "./helpers/esm/createForOfIteratorHelperLoose.js",
                "./helpers/createSuper": [{
                  "node": "./helpers/createSuper.js",
                  "import": "./helpers/esm/createSuper.js",
                  "default": "./helpers/createSuper.js"
                }, "./helpers/createSuper.js"],
                "./helpers/esm/createSuper": "./helpers/esm/createSuper.js",
                "./helpers/decorate": [{
                  "node": "./helpers/decorate.js",
                  "import": "./helpers/esm/decorate.js",
                  "default": "./helpers/decorate.js"
                }, "./helpers/decorate.js"],
                "./helpers/esm/decorate": "./helpers/esm/decorate.js",
                "./helpers/defaults": [{
                  "node": "./helpers/defaults.js",
                  "import": "./helpers/esm/defaults.js",
                  "default": "./helpers/defaults.js"
                }, "./helpers/defaults.js"],
                "./helpers/esm/defaults": "./helpers/esm/defaults.js",
                "./helpers/defineAccessor": [{
                  "node": "./helpers/defineAccessor.js",
                  "import": "./helpers/esm/defineAccessor.js",
                  "default": "./helpers/defineAccessor.js"
                }, "./helpers/defineAccessor.js"],
                "./helpers/esm/defineAccessor": "./helpers/esm/defineAccessor.js",
                "./helpers/defineProperty": [{
                  "node": "./helpers/defineProperty.js",
                  "import": "./helpers/esm/defineProperty.js",
                  "default": "./helpers/defineProperty.js"
                }, "./helpers/defineProperty.js"],
                "./helpers/esm/defineProperty": "./helpers/esm/defineProperty.js",
                "./helpers/extends": [{
                  "node": "./helpers/extends.js",
                  "import": "./helpers/esm/extends.js",
                  "default": "./helpers/extends.js"
                }, "./helpers/extends.js"],
                "./helpers/esm/extends": "./helpers/esm/extends.js",
                "./helpers/get": [{
                  "node": "./helpers/get.js",
                  "import": "./helpers/esm/get.js",
                  "default": "./helpers/get.js"
                }, "./helpers/get.js"],
                "./helpers/esm/get": "./helpers/esm/get.js",
                "./helpers/getPrototypeOf": [{
                  "node": "./helpers/getPrototypeOf.js",
                  "import": "./helpers/esm/getPrototypeOf.js",
                  "default": "./helpers/getPrototypeOf.js"
                }, "./helpers/getPrototypeOf.js"],
                "./helpers/esm/getPrototypeOf": "./helpers/esm/getPrototypeOf.js",
                "./helpers/identity": [{
                  "node": "./helpers/identity.js",
                  "import": "./helpers/esm/identity.js",
                  "default": "./helpers/identity.js"
                }, "./helpers/identity.js"],
                "./helpers/esm/identity": "./helpers/esm/identity.js",
                "./helpers/importDeferProxy": [{
                  "node": "./helpers/importDeferProxy.js",
                  "import": "./helpers/esm/importDeferProxy.js",
                  "default": "./helpers/importDeferProxy.js"
                }, "./helpers/importDeferProxy.js"],
                "./helpers/esm/importDeferProxy": "./helpers/esm/importDeferProxy.js",
                "./helpers/inherits": [{
                  "node": "./helpers/inherits.js",
                  "import": "./helpers/esm/inherits.js",
                  "default": "./helpers/inherits.js"
                }, "./helpers/inherits.js"],
                "./helpers/esm/inherits": "./helpers/esm/inherits.js",
                "./helpers/inheritsLoose": [{
                  "node": "./helpers/inheritsLoose.js",
                  "import": "./helpers/esm/inheritsLoose.js",
                  "default": "./helpers/inheritsLoose.js"
                }, "./helpers/inheritsLoose.js"],
                "./helpers/esm/inheritsLoose": "./helpers/esm/inheritsLoose.js",
                "./helpers/initializerDefineProperty": [{
                  "node": "./helpers/initializerDefineProperty.js",
                  "import": "./helpers/esm/initializerDefineProperty.js",
                  "default": "./helpers/initializerDefineProperty.js"
                }, "./helpers/initializerDefineProperty.js"],
                "./helpers/esm/initializerDefineProperty": "./helpers/esm/initializerDefineProperty.js",
                "./helpers/initializerWarningHelper": [{
                  "node": "./helpers/initializerWarningHelper.js",
                  "import": "./helpers/esm/initializerWarningHelper.js",
                  "default": "./helpers/initializerWarningHelper.js"
                }, "./helpers/initializerWarningHelper.js"],
                "./helpers/esm/initializerWarningHelper": "./helpers/esm/initializerWarningHelper.js",
                "./helpers/instanceof": [{
                  "node": "./helpers/instanceof.js",
                  "import": "./helpers/esm/instanceof.js",
                  "default": "./helpers/instanceof.js"
                }, "./helpers/instanceof.js"],
                "./helpers/esm/instanceof": "./helpers/esm/instanceof.js",
                "./helpers/interopRequireDefault": [{
                  "node": "./helpers/interopRequireDefault.js",
                  "import": "./helpers/esm/interopRequireDefault.js",
                  "default": "./helpers/interopRequireDefault.js"
                }, "./helpers/interopRequireDefault.js"],
                "./helpers/esm/interopRequireDefault": "./helpers/esm/interopRequireDefault.js",
                "./helpers/interopRequireWildcard": [{
                  "node": "./helpers/interopRequireWildcard.js",
                  "import": "./helpers/esm/interopRequireWildcard.js",
                  "default": "./helpers/interopRequireWildcard.js"
                }, "./helpers/interopRequireWildcard.js"],
                "./helpers/esm/interopRequireWildcard": "./helpers/esm/interopRequireWildcard.js",
                "./helpers/isNativeFunction": [{
                  "node": "./helpers/isNativeFunction.js",
                  "import": "./helpers/esm/isNativeFunction.js",
                  "default": "./helpers/isNativeFunction.js"
                }, "./helpers/isNativeFunction.js"],
                "./helpers/esm/isNativeFunction": "./helpers/esm/isNativeFunction.js",
                "./helpers/isNativeReflectConstruct": [{
                  "node": "./helpers/isNativeReflectConstruct.js",
                  "import": "./helpers/esm/isNativeReflectConstruct.js",
                  "default": "./helpers/isNativeReflectConstruct.js"
                }, "./helpers/isNativeReflectConstruct.js"],
                "./helpers/esm/isNativeReflectConstruct": "./helpers/esm/isNativeReflectConstruct.js",
                "./helpers/iterableToArray": [{
                  "node": "./helpers/iterableToArray.js",
                  "import": "./helpers/esm/iterableToArray.js",
                  "default": "./helpers/iterableToArray.js"
                }, "./helpers/iterableToArray.js"],
                "./helpers/esm/iterableToArray": "./helpers/esm/iterableToArray.js",
                "./helpers/iterableToArrayLimit": [{
                  "node": "./helpers/iterableToArrayLimit.js",
                  "import": "./helpers/esm/iterableToArrayLimit.js",
                  "default": "./helpers/iterableToArrayLimit.js"
                }, "./helpers/iterableToArrayLimit.js"],
                "./helpers/esm/iterableToArrayLimit": "./helpers/esm/iterableToArrayLimit.js",
                "./helpers/jsx": [{
                  "node": "./helpers/jsx.js",
                  "import": "./helpers/esm/jsx.js",
                  "default": "./helpers/jsx.js"
                }, "./helpers/jsx.js"],
                "./helpers/esm/jsx": "./helpers/esm/jsx.js",
                "./helpers/maybeArrayLike": [{
                  "node": "./helpers/maybeArrayLike.js",
                  "import": "./helpers/esm/maybeArrayLike.js",
                  "default": "./helpers/maybeArrayLike.js"
                }, "./helpers/maybeArrayLike.js"],
                "./helpers/esm/maybeArrayLike": "./helpers/esm/maybeArrayLike.js",
                "./helpers/newArrowCheck": [{
                  "node": "./helpers/newArrowCheck.js",
                  "import": "./helpers/esm/newArrowCheck.js",
                  "default": "./helpers/newArrowCheck.js"
                }, "./helpers/newArrowCheck.js"],
                "./helpers/esm/newArrowCheck": "./helpers/esm/newArrowCheck.js",
                "./helpers/nonIterableRest": [{
                  "node": "./helpers/nonIterableRest.js",
                  "import": "./helpers/esm/nonIterableRest.js",
                  "default": "./helpers/nonIterableRest.js"
                }, "./helpers/nonIterableRest.js"],
                "./helpers/esm/nonIterableRest": "./helpers/esm/nonIterableRest.js",
                "./helpers/nonIterableSpread": [{
                  "node": "./helpers/nonIterableSpread.js",
                  "import": "./helpers/esm/nonIterableSpread.js",
                  "default": "./helpers/nonIterableSpread.js"
                }, "./helpers/nonIterableSpread.js"],
                "./helpers/esm/nonIterableSpread": "./helpers/esm/nonIterableSpread.js",
                "./helpers/nullishReceiverError": [{
                  "node": "./helpers/nullishReceiverError.js",
                  "import": "./helpers/esm/nullishReceiverError.js",
                  "default": "./helpers/nullishReceiverError.js"
                }, "./helpers/nullishReceiverError.js"],
                "./helpers/esm/nullishReceiverError": "./helpers/esm/nullishReceiverError.js",
                "./helpers/objectDestructuringEmpty": [{
                  "node": "./helpers/objectDestructuringEmpty.js",
                  "import": "./helpers/esm/objectDestructuringEmpty.js",
                  "default": "./helpers/objectDestructuringEmpty.js"
                }, "./helpers/objectDestructuringEmpty.js"],
                "./helpers/esm/objectDestructuringEmpty": "./helpers/esm/objectDestructuringEmpty.js",
                "./helpers/objectSpread2": [{
                  "node": "./helpers/objectSpread2.js",
                  "import": "./helpers/esm/objectSpread2.js",
                  "default": "./helpers/objectSpread2.js"
                }, "./helpers/objectSpread2.js"],
                "./helpers/esm/objectSpread2": "./helpers/esm/objectSpread2.js",
                "./helpers/objectWithoutProperties": [{
                  "node": "./helpers/objectWithoutProperties.js",
                  "import": "./helpers/esm/objectWithoutProperties.js",
                  "default": "./helpers/objectWithoutProperties.js"
                }, "./helpers/objectWithoutProperties.js"],
                "./helpers/esm/objectWithoutProperties": "./helpers/esm/objectWithoutProperties.js",
                "./helpers/objectWithoutPropertiesLoose": [{
                  "node": "./helpers/objectWithoutPropertiesLoose.js",
                  "import": "./helpers/esm/objectWithoutPropertiesLoose.js",
                  "default": "./helpers/objectWithoutPropertiesLoose.js"
                }, "./helpers/objectWithoutPropertiesLoose.js"],
                "./helpers/esm/objectWithoutPropertiesLoose": "./helpers/esm/objectWithoutPropertiesLoose.js",
                "./helpers/possibleConstructorReturn": [{
                  "node": "./helpers/possibleConstructorReturn.js",
                  "import": "./helpers/esm/possibleConstructorReturn.js",
                  "default": "./helpers/possibleConstructorReturn.js"
                }, "./helpers/possibleConstructorReturn.js"],
                "./helpers/esm/possibleConstructorReturn": "./helpers/esm/possibleConstructorReturn.js",
                "./helpers/readOnlyError": [{
                  "node": "./helpers/readOnlyError.js",
                  "import": "./helpers/esm/readOnlyError.js",
                  "default": "./helpers/readOnlyError.js"
                }, "./helpers/readOnlyError.js"],
                "./helpers/esm/readOnlyError": "./helpers/esm/readOnlyError.js",
                "./helpers/regenerator": [{
                  "node": "./helpers/regenerator.js",
                  "import": "./helpers/esm/regenerator.js",
                  "default": "./helpers/regenerator.js"
                }, "./helpers/regenerator.js"],
                "./helpers/esm/regenerator": "./helpers/esm/regenerator.js",
                "./helpers/regeneratorAsync": [{
                  "node": "./helpers/regeneratorAsync.js",
                  "import": "./helpers/esm/regeneratorAsync.js",
                  "default": "./helpers/regeneratorAsync.js"
                }, "./helpers/regeneratorAsync.js"],
                "./helpers/esm/regeneratorAsync": "./helpers/esm/regeneratorAsync.js",
                "./helpers/regeneratorAsyncGen": [{
                  "node": "./helpers/regeneratorAsyncGen.js",
                  "import": "./helpers/esm/regeneratorAsyncGen.js",
                  "default": "./helpers/regeneratorAsyncGen.js"
                }, "./helpers/regeneratorAsyncGen.js"],
                "./helpers/esm/regeneratorAsyncGen": "./helpers/esm/regeneratorAsyncGen.js",
                "./helpers/regeneratorKeys": [{
                  "node": "./helpers/regeneratorKeys.js",
                  "import": "./helpers/esm/regeneratorKeys.js",
                  "default": "./helpers/regeneratorKeys.js"
                }, "./helpers/regeneratorKeys.js"],
                "./helpers/esm/regeneratorKeys": "./helpers/esm/regeneratorKeys.js",
                "./helpers/regeneratorValues": [{
                  "node": "./helpers/regeneratorValues.js",
                  "import": "./helpers/esm/regeneratorValues.js",
                  "default": "./helpers/regeneratorValues.js"
                }, "./helpers/regeneratorValues.js"],
                "./helpers/esm/regeneratorValues": "./helpers/esm/regeneratorValues.js",
                "./helpers/set": [{
                  "node": "./helpers/set.js",
                  "import": "./helpers/esm/set.js",
                  "default": "./helpers/set.js"
                }, "./helpers/set.js"],
                "./helpers/esm/set": "./helpers/esm/set.js",
                "./helpers/setFunctionName": [{
                  "node": "./helpers/setFunctionName.js",
                  "import": "./helpers/esm/setFunctionName.js",
                  "default": "./helpers/setFunctionName.js"
                }, "./helpers/setFunctionName.js"],
                "./helpers/esm/setFunctionName": "./helpers/esm/setFunctionName.js",
                "./helpers/setPrototypeOf": [{
                  "node": "./helpers/setPrototypeOf.js",
                  "import": "./helpers/esm/setPrototypeOf.js",
                  "default": "./helpers/setPrototypeOf.js"
                }, "./helpers/setPrototypeOf.js"],
                "./helpers/esm/setPrototypeOf": "./helpers/esm/setPrototypeOf.js",
                "./helpers/skipFirstGeneratorNext": [{
                  "node": "./helpers/skipFirstGeneratorNext.js",
                  "import": "./helpers/esm/skipFirstGeneratorNext.js",
                  "default": "./helpers/skipFirstGeneratorNext.js"
                }, "./helpers/skipFirstGeneratorNext.js"],
                "./helpers/esm/skipFirstGeneratorNext": "./helpers/esm/skipFirstGeneratorNext.js",
                "./helpers/slicedToArray": [{
                  "node": "./helpers/slicedToArray.js",
                  "import": "./helpers/esm/slicedToArray.js",
                  "default": "./helpers/slicedToArray.js"
                }, "./helpers/slicedToArray.js"],
                "./helpers/esm/slicedToArray": "./helpers/esm/slicedToArray.js",
                "./helpers/superPropBase": [{
                  "node": "./helpers/superPropBase.js",
                  "import": "./helpers/esm/superPropBase.js",
                  "default": "./helpers/superPropBase.js"
                }, "./helpers/superPropBase.js"],
                "./helpers/esm/superPropBase": "./helpers/esm/superPropBase.js",
                "./helpers/superPropGet": [{
                  "node": "./helpers/superPropGet.js",
                  "import": "./helpers/esm/superPropGet.js",
                  "default": "./helpers/superPropGet.js"
                }, "./helpers/superPropGet.js"],
                "./helpers/esm/superPropGet": "./helpers/esm/superPropGet.js",
                "./helpers/superPropSet": [{
                  "node": "./helpers/superPropSet.js",
                  "import": "./helpers/esm/superPropSet.js",
                  "default": "./helpers/superPropSet.js"
                }, "./helpers/superPropSet.js"],
                "./helpers/esm/superPropSet": "./helpers/esm/superPropSet.js",
                "./helpers/taggedTemplateLiteral": [{
                  "node": "./helpers/taggedTemplateLiteral.js",
                  "import": "./helpers/esm/taggedTemplateLiteral.js",
                  "default": "./helpers/taggedTemplateLiteral.js"
                }, "./helpers/taggedTemplateLiteral.js"],
                "./helpers/esm/taggedTemplateLiteral": "./helpers/esm/taggedTemplateLiteral.js",
                "./helpers/taggedTemplateLiteralLoose": [{
                  "node": "./helpers/taggedTemplateLiteralLoose.js",
                  "import": "./helpers/esm/taggedTemplateLiteralLoose.js",
                  "default": "./helpers/taggedTemplateLiteralLoose.js"
                }, "./helpers/taggedTemplateLiteralLoose.js"],
                "./helpers/esm/taggedTemplateLiteralLoose": "./helpers/esm/taggedTemplateLiteralLoose.js",
                "./helpers/tdz": [{
                  "node": "./helpers/tdz.js",
                  "import": "./helpers/esm/tdz.js",
                  "default": "./helpers/tdz.js"
                }, "./helpers/tdz.js"],
                "./helpers/esm/tdz": "./helpers/esm/tdz.js",
                "./helpers/temporalRef": [{
                  "node": "./helpers/temporalRef.js",
                  "import": "./helpers/esm/temporalRef.js",
                  "default": "./helpers/temporalRef.js"
                }, "./helpers/temporalRef.js"],
                "./helpers/esm/temporalRef": "./helpers/esm/temporalRef.js",
                "./helpers/temporalUndefined": [{
                  "node": "./helpers/temporalUndefined.js",
                  "import": "./helpers/esm/temporalUndefined.js",
                  "default": "./helpers/temporalUndefined.js"
                }, "./helpers/temporalUndefined.js"],
                "./helpers/esm/temporalUndefined": "./helpers/esm/temporalUndefined.js",
                "./helpers/toArray": [{
                  "node": "./helpers/toArray.js",
                  "import": "./helpers/esm/toArray.js",
                  "default": "./helpers/toArray.js"
                }, "./helpers/toArray.js"],
                "./helpers/esm/toArray": "./helpers/esm/toArray.js",
                "./helpers/toConsumableArray": [{
                  "node": "./helpers/toConsumableArray.js",
                  "import": "./helpers/esm/toConsumableArray.js",
                  "default": "./helpers/toConsumableArray.js"
                }, "./helpers/toConsumableArray.js"],
                "./helpers/esm/toConsumableArray": "./helpers/esm/toConsumableArray.js",
                "./helpers/toPrimitive": [{
                  "node": "./helpers/toPrimitive.js",
                  "import": "./helpers/esm/toPrimitive.js",
                  "default": "./helpers/toPrimitive.js"
                }, "./helpers/toPrimitive.js"],
                "./helpers/esm/toPrimitive": "./helpers/esm/toPrimitive.js",
                "./helpers/toPropertyKey": [{
                  "node": "./helpers/toPropertyKey.js",
                  "import": "./helpers/esm/toPropertyKey.js",
                  "default": "./helpers/toPropertyKey.js"
                }, "./helpers/toPropertyKey.js"],
                "./helpers/esm/toPropertyKey": "./helpers/esm/toPropertyKey.js",
                "./helpers/toSetter": [{
                  "node": "./helpers/toSetter.js",
                  "import": "./helpers/esm/toSetter.js",
                  "default": "./helpers/toSetter.js"
                }, "./helpers/toSetter.js"],
                "./helpers/esm/toSetter": "./helpers/esm/toSetter.js",
                "./helpers/tsRewriteRelativeImportExtensions": [{
                  "node": "./helpers/tsRewriteRelativeImportExtensions.js",
                  "import": "./helpers/esm/tsRewriteRelativeImportExtensions.js",
                  "default": "./helpers/tsRewriteRelativeImportExtensions.js"
                }, "./helpers/tsRewriteRelativeImportExtensions.js"],
                "./helpers/esm/tsRewriteRelativeImportExtensions": "./helpers/esm/tsRewriteRelativeImportExtensions.js",
                "./helpers/typeof": [{
                  "node": "./helpers/typeof.js",
                  "import": "./helpers/esm/typeof.js",
                  "default": "./helpers/typeof.js"
                }, "./helpers/typeof.js"],
                "./helpers/esm/typeof": "./helpers/esm/typeof.js",
                "./helpers/unsupportedIterableToArray": [{
                  "node": "./helpers/unsupportedIterableToArray.js",
                  "import": "./helpers/esm/unsupportedIterableToArray.js",
                  "default": "./helpers/unsupportedIterableToArray.js"
                }, "./helpers/unsupportedIterableToArray.js"],
                "./helpers/esm/unsupportedIterableToArray": "./helpers/esm/unsupportedIterableToArray.js",
                "./helpers/usingCtx": [{
                  "node": "./helpers/usingCtx.js",
                  "import": "./helpers/esm/usingCtx.js",
                  "default": "./helpers/usingCtx.js"
                }, "./helpers/usingCtx.js"],
                "./helpers/esm/usingCtx": "./helpers/esm/usingCtx.js",
                "./helpers/wrapAsyncGenerator": [{
                  "node": "./helpers/wrapAsyncGenerator.js",
                  "import": "./helpers/esm/wrapAsyncGenerator.js",
                  "default": "./helpers/wrapAsyncGenerator.js"
                }, "./helpers/wrapAsyncGenerator.js"],
                "./helpers/esm/wrapAsyncGenerator": "./helpers/esm/wrapAsyncGenerator.js",
                "./helpers/wrapNativeSuper": [{
                  "node": "./helpers/wrapNativeSuper.js",
                  "import": "./helpers/esm/wrapNativeSuper.js",
                  "default": "./helpers/wrapNativeSuper.js"
                }, "./helpers/wrapNativeSuper.js"],
                "./helpers/esm/wrapNativeSuper": "./helpers/esm/wrapNativeSuper.js",
                "./helpers/wrapRegExp": [{
                  "node": "./helpers/wrapRegExp.js",
                  "import": "./helpers/esm/wrapRegExp.js",
                  "default": "./helpers/wrapRegExp.js"
                }, "./helpers/wrapRegExp.js"],
                "./helpers/esm/wrapRegExp": "./helpers/esm/wrapRegExp.js",
                "./helpers/writeOnlyError": [{
                  "node": "./helpers/writeOnlyError.js",
                  "import": "./helpers/esm/writeOnlyError.js",
                  "default": "./helpers/writeOnlyError.js"
                }, "./helpers/writeOnlyError.js"],
                "./helpers/esm/writeOnlyError": "./helpers/esm/writeOnlyError.js",
                "./helpers/AwaitValue": [{
                  "node": "./helpers/AwaitValue.js",
                  "import": "./helpers/esm/AwaitValue.js",
                  "default": "./helpers/AwaitValue.js"
                }, "./helpers/AwaitValue.js"],
                "./helpers/esm/AwaitValue": "./helpers/esm/AwaitValue.js",
                "./helpers/applyDecs": [{
                  "node": "./helpers/applyDecs.js",
                  "import": "./helpers/esm/applyDecs.js",
                  "default": "./helpers/applyDecs.js"
                }, "./helpers/applyDecs.js"],
                "./helpers/esm/applyDecs": "./helpers/esm/applyDecs.js",
                "./helpers/applyDecs2203": [{
                  "node": "./helpers/applyDecs2203.js",
                  "import": "./helpers/esm/applyDecs2203.js",
                  "default": "./helpers/applyDecs2203.js"
                }, "./helpers/applyDecs2203.js"],
                "./helpers/esm/applyDecs2203": "./helpers/esm/applyDecs2203.js",
                "./helpers/applyDecs2203R": [{
                  "node": "./helpers/applyDecs2203R.js",
                  "import": "./helpers/esm/applyDecs2203R.js",
                  "default": "./helpers/applyDecs2203R.js"
                }, "./helpers/applyDecs2203R.js"],
                "./helpers/esm/applyDecs2203R": "./helpers/esm/applyDecs2203R.js",
                "./helpers/applyDecs2301": [{
                  "node": "./helpers/applyDecs2301.js",
                  "import": "./helpers/esm/applyDecs2301.js",
                  "default": "./helpers/applyDecs2301.js"
                }, "./helpers/applyDecs2301.js"],
                "./helpers/esm/applyDecs2301": "./helpers/esm/applyDecs2301.js",
                "./helpers/applyDecs2305": [{
                  "node": "./helpers/applyDecs2305.js",
                  "import": "./helpers/esm/applyDecs2305.js",
                  "default": "./helpers/applyDecs2305.js"
                }, "./helpers/applyDecs2305.js"],
                "./helpers/esm/applyDecs2305": "./helpers/esm/applyDecs2305.js",
                "./helpers/classApplyDescriptorDestructureSet": [{
                  "node": "./helpers/classApplyDescriptorDestructureSet.js",
                  "import": "./helpers/esm/classApplyDescriptorDestructureSet.js",
                  "default": "./helpers/classApplyDescriptorDestructureSet.js"
                }, "./helpers/classApplyDescriptorDestructureSet.js"],
                "./helpers/esm/classApplyDescriptorDestructureSet": "./helpers/esm/classApplyDescriptorDestructureSet.js",
                "./helpers/classApplyDescriptorGet": [{
                  "node": "./helpers/classApplyDescriptorGet.js",
                  "import": "./helpers/esm/classApplyDescriptorGet.js",
                  "default": "./helpers/classApplyDescriptorGet.js"
                }, "./helpers/classApplyDescriptorGet.js"],
                "./helpers/esm/classApplyDescriptorGet": "./helpers/esm/classApplyDescriptorGet.js",
                "./helpers/classApplyDescriptorSet": [{
                  "node": "./helpers/classApplyDescriptorSet.js",
                  "import": "./helpers/esm/classApplyDescriptorSet.js",
                  "default": "./helpers/classApplyDescriptorSet.js"
                }, "./helpers/classApplyDescriptorSet.js"],
                "./helpers/esm/classApplyDescriptorSet": "./helpers/esm/classApplyDescriptorSet.js",
                "./helpers/classCheckPrivateStaticAccess": [{
                  "node": "./helpers/classCheckPrivateStaticAccess.js",
                  "import": "./helpers/esm/classCheckPrivateStaticAccess.js",
                  "default": "./helpers/classCheckPrivateStaticAccess.js"
                }, "./helpers/classCheckPrivateStaticAccess.js"],
                "./helpers/esm/classCheckPrivateStaticAccess": "./helpers/esm/classCheckPrivateStaticAccess.js",
                "./helpers/classCheckPrivateStaticFieldDescriptor": [{
                  "node": "./helpers/classCheckPrivateStaticFieldDescriptor.js",
                  "import": "./helpers/esm/classCheckPrivateStaticFieldDescriptor.js",
                  "default": "./helpers/classCheckPrivateStaticFieldDescriptor.js"
                }, "./helpers/classCheckPrivateStaticFieldDescriptor.js"],
                "./helpers/esm/classCheckPrivateStaticFieldDescriptor": "./helpers/esm/classCheckPrivateStaticFieldDescriptor.js",
                "./helpers/classExtractFieldDescriptor": [{
                  "node": "./helpers/classExtractFieldDescriptor.js",
                  "import": "./helpers/esm/classExtractFieldDescriptor.js",
                  "default": "./helpers/classExtractFieldDescriptor.js"
                }, "./helpers/classExtractFieldDescriptor.js"],
                "./helpers/esm/classExtractFieldDescriptor": "./helpers/esm/classExtractFieldDescriptor.js",
                "./helpers/classPrivateFieldDestructureSet": [{
                  "node": "./helpers/classPrivateFieldDestructureSet.js",
                  "import": "./helpers/esm/classPrivateFieldDestructureSet.js",
                  "default": "./helpers/classPrivateFieldDestructureSet.js"
                }, "./helpers/classPrivateFieldDestructureSet.js"],
                "./helpers/esm/classPrivateFieldDestructureSet": "./helpers/esm/classPrivateFieldDestructureSet.js",
                "./helpers/classPrivateFieldGet": [{
                  "node": "./helpers/classPrivateFieldGet.js",
                  "import": "./helpers/esm/classPrivateFieldGet.js",
                  "default": "./helpers/classPrivateFieldGet.js"
                }, "./helpers/classPrivateFieldGet.js"],
                "./helpers/esm/classPrivateFieldGet": "./helpers/esm/classPrivateFieldGet.js",
                "./helpers/classPrivateFieldSet": [{
                  "node": "./helpers/classPrivateFieldSet.js",
                  "import": "./helpers/esm/classPrivateFieldSet.js",
                  "default": "./helpers/classPrivateFieldSet.js"
                }, "./helpers/classPrivateFieldSet.js"],
                "./helpers/esm/classPrivateFieldSet": "./helpers/esm/classPrivateFieldSet.js",
                "./helpers/classPrivateMethodGet": [{
                  "node": "./helpers/classPrivateMethodGet.js",
                  "import": "./helpers/esm/classPrivateMethodGet.js",
                  "default": "./helpers/classPrivateMethodGet.js"
                }, "./helpers/classPrivateMethodGet.js"],
                "./helpers/esm/classPrivateMethodGet": "./helpers/esm/classPrivateMethodGet.js",
                "./helpers/classPrivateMethodSet": [{
                  "node": "./helpers/classPrivateMethodSet.js",
                  "import": "./helpers/esm/classPrivateMethodSet.js",
                  "default": "./helpers/classPrivateMethodSet.js"
                }, "./helpers/classPrivateMethodSet.js"],
                "./helpers/esm/classPrivateMethodSet": "./helpers/esm/classPrivateMethodSet.js",
                "./helpers/classStaticPrivateFieldDestructureSet": [{
                  "node": "./helpers/classStaticPrivateFieldDestructureSet.js",
                  "import": "./helpers/esm/classStaticPrivateFieldDestructureSet.js",
                  "default": "./helpers/classStaticPrivateFieldDestructureSet.js"
                }, "./helpers/classStaticPrivateFieldDestructureSet.js"],
                "./helpers/esm/classStaticPrivateFieldDestructureSet": "./helpers/esm/classStaticPrivateFieldDestructureSet.js",
                "./helpers/classStaticPrivateFieldSpecGet": [{
                  "node": "./helpers/classStaticPrivateFieldSpecGet.js",
                  "import": "./helpers/esm/classStaticPrivateFieldSpecGet.js",
                  "default": "./helpers/classStaticPrivateFieldSpecGet.js"
                }, "./helpers/classStaticPrivateFieldSpecGet.js"],
                "./helpers/esm/classStaticPrivateFieldSpecGet": "./helpers/esm/classStaticPrivateFieldSpecGet.js",
                "./helpers/classStaticPrivateFieldSpecSet": [{
                  "node": "./helpers/classStaticPrivateFieldSpecSet.js",
                  "import": "./helpers/esm/classStaticPrivateFieldSpecSet.js",
                  "default": "./helpers/classStaticPrivateFieldSpecSet.js"
                }, "./helpers/classStaticPrivateFieldSpecSet.js"],
                "./helpers/esm/classStaticPrivateFieldSpecSet": "./helpers/esm/classStaticPrivateFieldSpecSet.js",
                "./helpers/classStaticPrivateMethodSet": [{
                  "node": "./helpers/classStaticPrivateMethodSet.js",
                  "import": "./helpers/esm/classStaticPrivateMethodSet.js",
                  "default": "./helpers/classStaticPrivateMethodSet.js"
                }, "./helpers/classStaticPrivateMethodSet.js"],
                "./helpers/esm/classStaticPrivateMethodSet": "./helpers/esm/classStaticPrivateMethodSet.js",
                "./helpers/defineEnumerableProperties": [{
                  "node": "./helpers/defineEnumerableProperties.js",
                  "import": "./helpers/esm/defineEnumerableProperties.js",
                  "default": "./helpers/defineEnumerableProperties.js"
                }, "./helpers/defineEnumerableProperties.js"],
                "./helpers/esm/defineEnumerableProperties": "./helpers/esm/defineEnumerableProperties.js",
                "./helpers/dispose": [{
                  "node": "./helpers/dispose.js",
                  "import": "./helpers/esm/dispose.js",
                  "default": "./helpers/dispose.js"
                }, "./helpers/dispose.js"],
                "./helpers/esm/dispose": "./helpers/esm/dispose.js",
                "./helpers/objectSpread": [{
                  "node": "./helpers/objectSpread.js",
                  "import": "./helpers/esm/objectSpread.js",
                  "default": "./helpers/objectSpread.js"
                }, "./helpers/objectSpread.js"],
                "./helpers/esm/objectSpread": "./helpers/esm/objectSpread.js",
                "./helpers/regeneratorRuntime": [{
                  "node": "./helpers/regeneratorRuntime.js",
                  "import": "./helpers/esm/regeneratorRuntime.js",
                  "default": "./helpers/regeneratorRuntime.js"
                }, "./helpers/regeneratorRuntime.js"],
                "./helpers/esm/regeneratorRuntime": "./helpers/esm/regeneratorRuntime.js",
                "./helpers/using": [{
                  "node": "./helpers/using.js",
                  "import": "./helpers/esm/using.js",
                  "default": "./helpers/using.js"
                }, "./helpers/using.js"],
                "./helpers/esm/using": "./helpers/esm/using.js",
                "./package": "./package.json",
                "./package.json": "./package.json",
                "./regenerator": "./regenerator/index.js",
                "./regenerator/*.js": "./regenerator/*.js",
                "./regenerator/": "./regenerator/"
              },
              "homepage": "https://babel.dev/docs/en/next/babel-runtime",
              "license": "MIT",
              "name": "@babel/runtime",
              "publishConfig": {
                "access": "public"
              },
              "repository": {
                "type": "git",
                "url": "git+https://github.com/babel/babel.git",
                "directory": "packages/babel-runtime"
              },
              "type": "commonjs",
              "version": "7.29.7"
            };

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "helpers": { "objectSpread2.js": function module(_require17, _exports17, _module19) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/@babel/runtime/helpers/objectSpread2.js                                                                //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              var defineProperty = _require17("./defineProperty.js");
              function ownKeys(e, r) {
                var t = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                  var o = Object.getOwnPropertySymbols(e);
                  r && (o = o.filter(function (r) {
                    return Object.getOwnPropertyDescriptor(e, r).enumerable;
                  })), t.push.apply(t, o);
                }
                return t;
              }
              function _objectSpread2(e) {
                for (var r = 1; r < arguments.length; r++) {
                  var t = null != arguments[r] ? arguments[r] : {};
                  r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
                    defineProperty(e, r, t[r]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
                    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                  });
                }
                return e;
              }
              _module19.exports = _objectSpread2, _module19.exports.__esModule = true, _module19.exports["default"] = _module19.exports;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "defineProperty.js": function module(_require18, _exports18, _module20) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/@babel/runtime/helpers/defineProperty.js                                                               //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              var toPropertyKey = _require18("./toPropertyKey.js");
              function _defineProperty(e, r, t) {
                return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
                  value: t,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : e[r] = t, e;
              }
              _module20.exports = _defineProperty, _module20.exports.__esModule = true, _module20.exports["default"] = _module20.exports;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "toPropertyKey.js": function module(_require19, _exports19, _module21) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/@babel/runtime/helpers/toPropertyKey.js                                                                //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              var _typeof = _require19("./typeof.js")["default"];
              var toPrimitive = _require19("./toPrimitive.js");
              function toPropertyKey(t) {
                var i = toPrimitive(t, "string");
                return "symbol" == _typeof(i) ? i : i + "";
              }
              _module21.exports = toPropertyKey, _module21.exports.__esModule = true, _module21.exports["default"] = _module21.exports;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "typeof.js": function module(_require20, _exports20, _module22) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/@babel/runtime/helpers/typeof.js                                                                       //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              function _typeof(o) {
                "@babel/helpers - typeof";

                return _module22.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
                  return typeof o;
                } : function (o) {
                  return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                }, _module22.exports.__esModule = true, _module22.exports["default"] = _module22.exports, _typeof(o);
              }
              _module22.exports = _typeof, _module22.exports.__esModule = true, _module22.exports["default"] = _module22.exports;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "toPrimitive.js": function module(_require21, _exports21, _module23) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // node_modules/@babel/runtime/helpers/toPrimitive.js                                                                  //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              var _typeof = _require21("./typeof.js")["default"];
              function toPrimitive(t, r) {
                if ("object" != _typeof(t) || !t) return t;
                var e = t[Symbol.toPrimitive];
                if (void 0 !== e) {
                  var i = e.call(t, r || "default");
                  if ("object" != _typeof(i)) return i;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === r ? String : Number)(t);
              }
              _module23.exports = toPrimitive, _module23.exports.__esModule = true, _module23.exports["default"] = _module23.exports;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/modules/client.js");

  /* Exports */
  Package._define("modules", _exports2, {
    meteorInstall: meteorInstall
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("modern-browsers");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("babel-compiler");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;

  /* Package-scope variables */
  var ReactFastRefresh;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "react-fast-refresh": { "client-runtime.js": function module(_require, _exports, _module) {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                              //
            // packages/react-fast-refresh/client-runtime.js                                                                //
            //                                                                                                              //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            const enabled = __meteor_runtime_config__.reactFastRefreshEnabled;

            if (enabled && process.env.NODE_ENV !== 'production' && _module.hot) {
              const runtime = _require('react-refresh/runtime');

              let timeout = null;
              function scheduleRefresh() {
                if (!timeout) {
                  timeout = setTimeout(function () {
                    timeout = null;
                    runtime.performReactRefresh();
                  }, 0);
                }
              }

              // The react refresh babel plugin only registers functions. For react
              // to update other types of exports (such as classes), we have to
              // register them
              function registerExportsForReactRefresh(moduleId, moduleExports) {
                runtime.register(moduleExports, moduleId + ' %exports%');

                if (moduleExports == null || typeof moduleExports !== 'object') {
                  // Exit if we can't iterate over exports.
                  return;
                }

                for (var key in moduleExports) {
                  var desc = Object.getOwnPropertyDescriptor(moduleExports, key);
                  if (desc && desc.get) {
                    // Don't invoke getters as they may have side effects.
                    continue;
                  }

                  var exportValue = moduleExports[key];
                  var typeID = moduleId + ' %exports% ' + key;
                  runtime.register(exportValue, typeID);
                }
              };

              // Modules that only export components become React Refresh boundaries.
              function isReactRefreshBoundary(moduleExports) {
                if (runtime.isLikelyComponentType(moduleExports)) {
                  return true;
                }
                if (moduleExports == null || typeof moduleExports !== 'object') {
                  // Exit if we can't iterate over exports.
                  return false;
                }

                var hasExports = false;
                var onlyExportComponents = true;

                for (var key in moduleExports) {
                  hasExports = true;

                  var desc = Object.getOwnPropertyDescriptor(moduleExports, key);
                  if (desc && desc.get) {
                    // Don't invoke getters as they may have side effects.
                    return false;
                  }

                  if (!runtime.isLikelyComponentType(moduleExports[key])) {
                    onlyExportComponents = false;
                  }
                }

                return hasExports && onlyExportComponents;
              };

              runtime.injectIntoGlobalHook(window);

              window.$RefreshReg$ = function () {};
              window.$RefreshSig$ = function () {
                return function (type) {
                  return type;
                };
              };

              _module.hot.onRequire({
                before: function (_module2) {
                  if (_module2.loaded) {
                    // The module was already executed
                    return;
                  }

                  var prevRefreshReg = window.$RefreshReg$;
                  var prevRefreshSig = window.$RefreshSig$;

                  window.RefreshRuntime = runtime;
                  window.$RefreshReg$ = function (type, _id) {
                    const fullId = _module2.id + ' ' + _id;
                    RefreshRuntime.register(type, fullId);
                  };
                  window.$RefreshSig$ = RefreshRuntime.createSignatureFunctionForTransform;

                  return {
                    prevRefreshReg: prevRefreshReg,
                    prevRefreshSig: prevRefreshSig
                  };
                },
                after: function (_module3, beforeData) {
                  // TODO: handle modules with errors
                  if (!beforeData) {
                    return;
                  }

                  window.$RefreshReg$ = beforeData.prevRefreshReg;
                  window.$RefreshSig$ = beforeData.prevRefreshSig;
                  if (isReactRefreshBoundary(_module3.exports)) {
                    registerExportsForReactRefresh(_module3.id, _module3.exports);
                    _module3.hot.accept();

                    scheduleRefresh();
                  }
                }
              });
            }

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "node_modules": { "react-refresh": { "runtime.js": function module(_require3, _exports2, _module4) {

                if (process.env.NODE_ENV === 'production') {
                  _module4.exports = _require3('./cjs/react-refresh-runtime.production.min.js');
                } else {
                  _module4.exports = _require3('./cjs/react-refresh-runtime.development.js');
                }

                //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "cjs": { "react-refresh-runtime.production.min.js": function module() {
                  throw Error("React Refresh runtime should not be included in the production bundle.");

                  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "react-refresh-runtime.development.js": function module(_require4, _exports3, _module5) {

                  if (process.env.NODE_ENV !== "production") {
                    (function () {

                      // ATTENTION
                      // When adding new symbols to this file,
                      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
                      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                      // nor polyfill, then a plain number is used for performance.
                      var REACT_ELEMENT_TYPE = 0xeac7;
                      var REACT_PORTAL_TYPE = 0xeaca;
                      var REACT_FRAGMENT_TYPE = 0xeacb;
                      var REACT_STRICT_MODE_TYPE = 0xeacc;
                      var REACT_PROFILER_TYPE = 0xead2;
                      var REACT_PROVIDER_TYPE = 0xeacd;
                      var REACT_CONTEXT_TYPE = 0xeace;
                      var REACT_FORWARD_REF_TYPE = 0xead0;
                      var REACT_SUSPENSE_TYPE = 0xead1;
                      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
                      var REACT_MEMO_TYPE = 0xead3;
                      var REACT_LAZY_TYPE = 0xead4;
                      var REACT_BLOCK_TYPE = 0xead9;
                      var REACT_SERVER_BLOCK_TYPE = 0xeada;
                      var REACT_FUNDAMENTAL_TYPE = 0xead5;
                      var REACT_SCOPE_TYPE = 0xead7;
                      var REACT_OPAQUE_ID_TYPE = 0xeae0;
                      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
                      var REACT_OFFSCREEN_TYPE = 0xeae2;
                      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

                      if (typeof Symbol === 'function' && Symbol.for) {
                        var symbolFor = Symbol.for;
                        REACT_ELEMENT_TYPE = symbolFor('react.element');
                        REACT_PORTAL_TYPE = symbolFor('react.portal');
                        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
                        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
                        REACT_PROFILER_TYPE = symbolFor('react.profiler');
                        REACT_PROVIDER_TYPE = symbolFor('react.provider');
                        REACT_CONTEXT_TYPE = symbolFor('react.context');
                        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
                        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
                        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
                        REACT_MEMO_TYPE = symbolFor('react.memo');
                        REACT_LAZY_TYPE = symbolFor('react.lazy');
                        REACT_BLOCK_TYPE = symbolFor('react.block');
                        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
                        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
                        REACT_SCOPE_TYPE = symbolFor('react.scope');
                        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
                        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
                        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
                        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
                      }

                      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map; // We never remove these associations.
                      // It's OK to reference families, but use WeakMap/Set for types.

                      var allFamiliesByID = new Map();
                      var allFamiliesByType = new PossiblyWeakMap();
                      var allSignaturesByType = new PossiblyWeakMap(); // This WeakMap is read by React, so we only put families
                      // that have actually been edited here. This keeps checks fast.
                      // $FlowIssue

                      var updatedFamiliesByType = new PossiblyWeakMap(); // This is cleared on every performReactRefresh() call.
                      // It is an array of [Family, NextType] tuples.

                      var pendingUpdates = []; // This is injected by the renderer via DevTools global hook.

                      var helpersByRendererID = new Map();
                      var helpersByRoot = new Map(); // We keep track of mounted roots so we can schedule updates.

                      var mountedRoots = new Set(); // If a root captures an error, we remember it so we can retry on edit.

                      var failedRoots = new Set(); // In environments that support WeakMap, we also remember the last element for every root.
                      // It needs to be weak because we do this even for roots that failed to mount.
                      // If there is no WeakMap, we won't attempt to do retrying.
                      // $FlowIssue

                      var rootElements = // $FlowIssue
                      typeof WeakMap === 'function' ? new WeakMap() : null;
                      var isPerformingRefresh = false;

                      function computeFullKey(signature) {
                        if (signature.fullKey !== null) {
                          return signature.fullKey;
                        }

                        var fullKey = signature.ownKey;
                        var hooks;

                        try {
                          hooks = signature.getCustomHooks();
                        } catch (err) {
                          // This can happen in an edge case, e.g. if expression like Foo.useSomething
                          // depends on Foo which is lazily initialized during rendering.
                          // In that case just assume we'll have to remount.
                          signature.forceReset = true;
                          signature.fullKey = fullKey;
                          return fullKey;
                        }

                        for (var i = 0; i < hooks.length; i++) {
                          var hook = hooks[i];

                          if (typeof hook !== 'function') {
                            // Something's wrong. Assume we need to remount.
                            signature.forceReset = true;
                            signature.fullKey = fullKey;
                            return fullKey;
                          }

                          var nestedHookSignature = allSignaturesByType.get(hook);

                          if (nestedHookSignature === undefined) {
                            // No signature means Hook wasn't in the source code, e.g. in a library.
                            // We'll skip it because we can assume it won't change during this session.
                            continue;
                          }

                          var nestedHookKey = computeFullKey(nestedHookSignature);

                          if (nestedHookSignature.forceReset) {
                            signature.forceReset = true;
                          }

                          fullKey += '\n---\n' + nestedHookKey;
                        }

                        signature.fullKey = fullKey;
                        return fullKey;
                      }

                      function haveEqualSignatures(prevType, nextType) {
                        var prevSignature = allSignaturesByType.get(prevType);
                        var nextSignature = allSignaturesByType.get(nextType);

                        if (prevSignature === undefined && nextSignature === undefined) {
                          return true;
                        }

                        if (prevSignature === undefined || nextSignature === undefined) {
                          return false;
                        }

                        if (computeFullKey(prevSignature) !== computeFullKey(nextSignature)) {
                          return false;
                        }

                        if (nextSignature.forceReset) {
                          return false;
                        }

                        return true;
                      }

                      function isReactClass(type) {
                        return type.prototype && type.prototype.isReactComponent;
                      }

                      function canPreserveStateBetween(prevType, nextType) {
                        if (isReactClass(prevType) || isReactClass(nextType)) {
                          return false;
                        }

                        if (haveEqualSignatures(prevType, nextType)) {
                          return true;
                        }

                        return false;
                      }

                      function resolveFamily(type) {
                        // Only check updated types to keep lookups fast.
                        return updatedFamiliesByType.get(type);
                      } // If we didn't care about IE11, we could use new Map/Set(iterable).


                      function cloneMap(map) {
                        var clone = new Map();
                        map.forEach(function (value, key) {
                          clone.set(key, value);
                        });
                        return clone;
                      }

                      function cloneSet(set) {
                        var clone = new Set();
                        set.forEach(function (value) {
                          clone.add(value);
                        });
                        return clone;
                      }

                      function performReactRefresh() {

                        if (pendingUpdates.length === 0) {
                          return null;
                        }

                        if (isPerformingRefresh) {
                          return null;
                        }

                        isPerformingRefresh = true;

                        try {
                          var staleFamilies = new Set();
                          var updatedFamilies = new Set();
                          var updates = pendingUpdates;
                          pendingUpdates = [];
                          updates.forEach(function (_ref) {
                            var family = _ref[0],
                                nextType = _ref[1];
                            // Now that we got a real edit, we can create associations
                            // that will be read by the React reconciler.
                            var prevType = family.current;
                            updatedFamiliesByType.set(prevType, family);
                            updatedFamiliesByType.set(nextType, family);
                            family.current = nextType; // Determine whether this should be a re-render or a re-mount.

                            if (canPreserveStateBetween(prevType, nextType)) {
                              updatedFamilies.add(family);
                            } else {
                              staleFamilies.add(family);
                            }
                          }); // TODO: rename these fields to something more meaningful.

                          var update = {
                            updatedFamilies: updatedFamilies,
                            // Families that will re-render preserving state
                            staleFamilies: staleFamilies // Families that will be remounted

                          };
                          helpersByRendererID.forEach(function (helpers) {
                            // Even if there are no roots, set the handler on first update.
                            // This ensures that if *new* roots are mounted, they'll use the resolve handler.
                            helpers.setRefreshHandler(resolveFamily);
                          });
                          var didError = false;
                          var firstError = null; // We snapshot maps and sets that are mutated during commits.
                          // If we don't do this, there is a risk they will be mutated while
                          // we iterate over them. For example, trying to recover a failed root
                          // may cause another root to be added to the failed list -- an infinite loop.

                          var failedRootsSnapshot = cloneSet(failedRoots);
                          var mountedRootsSnapshot = cloneSet(mountedRoots);
                          var helpersByRootSnapshot = cloneMap(helpersByRoot);
                          failedRootsSnapshot.forEach(function (root) {
                            var helpers = helpersByRootSnapshot.get(root);

                            if (helpers === undefined) {
                              throw new Error('Could not find helpers for a root. This is a bug in React Refresh.');
                            }

                            if (!failedRoots.has(root)) {// No longer failed.
                            }

                            if (rootElements === null) {
                              return;
                            }

                            if (!rootElements.has(root)) {
                              return;
                            }

                            var element = rootElements.get(root);

                            try {
                              helpers.scheduleRoot(root, element);
                            } catch (err) {
                              if (!didError) {
                                didError = true;
                                firstError = err;
                              } // Keep trying other roots.
                            }
                          });
                          mountedRootsSnapshot.forEach(function (root) {
                            var helpers = helpersByRootSnapshot.get(root);

                            if (helpers === undefined) {
                              throw new Error('Could not find helpers for a root. This is a bug in React Refresh.');
                            }

                            if (!mountedRoots.has(root)) {// No longer mounted.
                            }

                            try {
                              helpers.scheduleRefresh(root, update);
                            } catch (err) {
                              if (!didError) {
                                didError = true;
                                firstError = err;
                              } // Keep trying other roots.
                            }
                          });

                          if (didError) {
                            throw firstError;
                          }

                          return update;
                        } finally {
                          isPerformingRefresh = false;
                        }
                      }
                      function register(type, id) {
                        {
                          if (type === null) {
                            return;
                          }

                          if (typeof type !== 'function' && typeof type !== 'object') {
                            return;
                          } // This can happen in an edge case, e.g. if we register
                          // return value of a HOC but it returns a cached component.
                          // Ignore anything but the first registration for each type.


                          if (allFamiliesByType.has(type)) {
                            return;
                          } // Create family or remember to update it.
                          // None of this bookkeeping affects reconciliation
                          // until the first performReactRefresh() call above.


                          var family = allFamiliesByID.get(id);

                          if (family === undefined) {
                            family = {
                              current: type
                            };
                            allFamiliesByID.set(id, family);
                          } else {
                            pendingUpdates.push([family, type]);
                          }

                          allFamiliesByType.set(type, family); // Visit inner types because we might not have registered them.

                          if (typeof type === 'object' && type !== null) {
                            switch (type.$$typeof) {
                              case REACT_FORWARD_REF_TYPE:
                                register(type.render, id + '$render');
                                break;

                              case REACT_MEMO_TYPE:
                                register(type.type, id + '$type');
                                break;
                            }
                          }
                        }
                      }
                      function setSignature(type, key) {
                        var forceReset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var getCustomHooks = arguments.length > 3 ? arguments[3] : undefined;

                        {
                          allSignaturesByType.set(type, {
                            forceReset: forceReset,
                            ownKey: key,
                            fullKey: null,
                            getCustomHooks: getCustomHooks || function () {
                              return [];
                            }
                          });
                        }
                      } // This is lazily called during first render for a type.
                      // It captures Hook list at that time so inline requires don't break comparisons.

                      function collectCustomHooksForSignature(type) {
                        {
                          var signature = allSignaturesByType.get(type);

                          if (signature !== undefined) {
                            computeFullKey(signature);
                          }
                        }
                      }
                      function getFamilyByID(id) {
                        {
                          return allFamiliesByID.get(id);
                        }
                      }
                      function getFamilyByType(type) {
                        {
                          return allFamiliesByType.get(type);
                        }
                      }
                      function findAffectedHostInstances(families) {
                        {
                          var affectedInstances = new Set();
                          mountedRoots.forEach(function (root) {
                            var helpers = helpersByRoot.get(root);

                            if (helpers === undefined) {
                              throw new Error('Could not find helpers for a root. This is a bug in React Refresh.');
                            }

                            var instancesForRoot = helpers.findHostInstancesForRefresh(root, families);
                            instancesForRoot.forEach(function (inst) {
                              affectedInstances.add(inst);
                            });
                          });
                          return affectedInstances;
                        }
                      }
                      function injectIntoGlobalHook(globalObject) {
                        {
                          // For React Native, the global hook will be set up by require('react-devtools-core').
                          // That code will run before us. So we need to monkeypatch functions on existing hook.
                          // For React Web, the global hook will be set up by the extension.
                          // This will also run before us.
                          var hook = globalObject.__REACT_DEVTOOLS_GLOBAL_HOOK__;

                          if (hook === undefined) {
                            // However, if there is no DevTools extension, we'll need to set up the global hook ourselves.
                            // Note that in this case it's important that renderer code runs *after* this method call.
                            // Otherwise, the renderer will think that there is no global hook, and won't do the injection.
                            var nextID = 0;
                            globalObject.__REACT_DEVTOOLS_GLOBAL_HOOK__ = hook = {
                              renderers: new Map(),
                              supportsFiber: true,
                              inject: function (injected) {
                                return nextID++;
                              },
                              onScheduleFiberRoot: function (id, root, children) {},
                              onCommitFiberRoot: function (id, root, maybePriorityLevel, didError) {},
                              onCommitFiberUnmount: function () {}
                            };
                          } // Here, we just want to get a reference to scheduleRefresh.


                          var oldInject = hook.inject;

                          hook.inject = function (injected) {
                            var id = oldInject.apply(this, arguments);

                            if (typeof injected.scheduleRefresh === 'function' && typeof injected.setRefreshHandler === 'function') {
                              // This version supports React Refresh.
                              helpersByRendererID.set(id, injected);
                            }

                            return id;
                          }; // Do the same for any already injected roots.
                          // This is useful if ReactDOM has already been initialized.
                          // https://github.com/facebook/react/issues/17626


                          hook.renderers.forEach(function (injected, id) {
                            if (typeof injected.scheduleRefresh === 'function' && typeof injected.setRefreshHandler === 'function') {
                              // This version supports React Refresh.
                              helpersByRendererID.set(id, injected);
                            }
                          }); // We also want to track currently mounted roots.

                          var oldOnCommitFiberRoot = hook.onCommitFiberRoot;

                          var oldOnScheduleFiberRoot = hook.onScheduleFiberRoot || function () {};

                          hook.onScheduleFiberRoot = function (id, root, children) {
                            if (!isPerformingRefresh) {
                              // If it was intentionally scheduled, don't attempt to restore.
                              // This includes intentionally scheduled unmounts.
                              failedRoots.delete(root);

                              if (rootElements !== null) {
                                rootElements.set(root, children);
                              }
                            }

                            return oldOnScheduleFiberRoot.apply(this, arguments);
                          };

                          hook.onCommitFiberRoot = function (id, root, maybePriorityLevel, didError) {
                            var helpers = helpersByRendererID.get(id);

                            if (helpers === undefined) {
                              return;
                            }

                            helpersByRoot.set(root, helpers);
                            var current = root.current;
                            var alternate = current.alternate; // We need to determine whether this root has just (un)mounted.
                            // This logic is copy-pasted from similar logic in the DevTools backend.
                            // If this breaks with some refactoring, you'll want to update DevTools too.

                            if (alternate !== null) {
                              var wasMounted = alternate.memoizedState != null && alternate.memoizedState.element != null;
                              var isMounted = current.memoizedState != null && current.memoizedState.element != null;

                              if (!wasMounted && isMounted) {
                                // Mount a new root.
                                mountedRoots.add(root);
                                failedRoots.delete(root);
                              } else if (wasMounted && isMounted) ;else if (wasMounted && !isMounted) {
                                // Unmount an existing root.
                                mountedRoots.delete(root);

                                if (didError) {
                                  // We'll remount it on future edits.
                                  failedRoots.add(root);
                                } else {
                                  helpersByRoot.delete(root);
                                }
                              } else if (!wasMounted && !isMounted) {
                                if (didError) {
                                  // We'll remount it on future edits.
                                  failedRoots.add(root);
                                }
                              }
                            } else {
                              // Mount a new root.
                              mountedRoots.add(root);
                            }

                            return oldOnCommitFiberRoot.apply(this, arguments);
                          };
                        }
                      }
                      function hasUnrecoverableErrors() {
                        // TODO: delete this after removing dependency in RN.
                        return false;
                      } // Exposed for testing.

                      function _getMountedRootCount() {
                        {
                          return mountedRoots.size;
                        }
                      } // This is a wrapper over more primitive functions for setting signature.
                      // Signatures let us decide whether the Hook order has changed on refresh.
                      //
                      // This function is intended to be used as a transform target, e.g.:
                      // var _s = createSignatureFunctionForTransform()
                      //
                      // function Hello() {
                      //   const [foo, setFoo] = useState(0);
                      //   const value = useCustomHook();
                      //   _s(); /* Second call triggers collecting the custom Hook list.
                      //          * This doesn't happen during the module evaluation because we
                      //          * don't want to change the module order with inline requires.
                      //          * Next calls are noops. */
                      //   return <h1>Hi</h1>;
                      // }
                      //
                      // /* First call specifies the signature: */
                      // _s(
                      //   Hello,
                      //   'useState{[foo, setFoo]}(0)',
                      //   () => [useCustomHook], /* Lazy to avoid triggering inline requires */
                      // );

                      function createSignatureFunctionForTransform() {
                        {
                          // We'll fill in the signature in two steps.
                          // First, we'll know the signature itself. This happens outside the component.
                          // Then, we'll know the references to custom Hooks. This happens inside the component.
                          // After that, the returned function will be a fast path no-op.
                          var status = 'needsSignature';
                          var savedType;
                          var hasCustomHooks;
                          return function (type, key, forceReset, getCustomHooks) {
                            switch (status) {
                              case 'needsSignature':
                                if (type !== undefined) {
                                  // If we received an argument, this is the initial registration call.
                                  savedType = type;
                                  hasCustomHooks = typeof getCustomHooks === 'function';
                                  setSignature(type, key, forceReset, getCustomHooks); // The next call we expect is from inside a function, to fill in the custom Hooks.

                                  status = 'needsCustomHooks';
                                }

                                break;

                              case 'needsCustomHooks':
                                if (hasCustomHooks) {
                                  collectCustomHooksForSignature(savedType);
                                }

                                status = 'resolved';
                                break;
                            }

                            return type;
                          };
                        }
                      }
                      function isLikelyComponentType(type) {
                        {
                          switch (typeof type) {
                            case 'function':
                              {
                                // First, deal with classes.
                                if (type.prototype != null) {
                                  if (type.prototype.isReactComponent) {
                                    // React class.
                                    return true;
                                  }

                                  var ownNames = Object.getOwnPropertyNames(type.prototype);

                                  if (ownNames.length > 1 || ownNames[0] !== 'constructor') {
                                    // This looks like a class.
                                    return false;
                                  } // eslint-disable-next-line no-proto


                                  if (type.prototype.__proto__ !== Object.prototype) {
                                    // It has a superclass.
                                    return false;
                                  } // Pass through.
                                  // This looks like a regular function with empty prototype.
                                } // For plain functions and arrows, use name as a heuristic.


                                var name = type.name || type.displayName;
                                return typeof name === 'string' && /^[A-Z]/.test(name);
                              }

                            case 'object':
                              {
                                if (type != null) {
                                  switch (type.$$typeof) {
                                    case REACT_FORWARD_REF_TYPE:
                                    case REACT_MEMO_TYPE:
                                      // Definitely React components.
                                      return true;

                                    default:
                                      return false;
                                  }
                                }

                                return false;
                              }

                            default:
                              {
                                return false;
                              }
                          }
                        }
                      }

                      _exports3._getMountedRootCount = _getMountedRootCount;
                      _exports3.collectCustomHooksForSignature = collectCustomHooksForSignature;
                      _exports3.createSignatureFunctionForTransform = createSignatureFunctionForTransform;
                      _exports3.findAffectedHostInstances = findAffectedHostInstances;
                      _exports3.getFamilyByID = getFamilyByID;
                      _exports3.getFamilyByType = getFamilyByType;
                      _exports3.hasUnrecoverableErrors = hasUnrecoverableErrors;
                      _exports3.injectIntoGlobalHook = injectIntoGlobalHook;
                      _exports3.isLikelyComponentType = isLikelyComponentType;
                      _exports3.performReactRefresh = performReactRefresh;
                      _exports3.register = register;
                      _exports3.setSignature = setSignature;
                    })();
                  }

                  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                } } } } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require2("/node_modules/meteor/react-fast-refresh/client-runtime.js");

  /* Exports */
  Package._define("react-fast-refresh", {
    ReactFastRefresh: ReactFastRefresh
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("ecmascript");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("ecmascript-runtime");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "babel-runtime": { "babel-runtime.js": function _module(_require) {

            /////////////////////////////////////////////////////////////////////////////////////
            //                                                                                 //
            // packages/babel-runtime/babel-runtime.js                                         //
            //                                                                                 //
            /////////////////////////////////////////////////////////////////////////////////////
            //
            try {
              var babelRuntimeVersion = require("@babel/runtime/package.json").version;
            } catch (e) {
              throw new Error(["", "The @babel/runtime npm package could not be found in your node_modules ", "directory. Please run the following command to install it:", "", "  meteor npm install --save @babel/runtime", ""].join("\n"));
            }

            if (parseInt(babelRuntimeVersion, 10) < 7 || babelRuntimeVersion.indexOf("7.0.0-beta.") === 0 && parseInt(babelRuntimeVersion.split(".").pop(), 10) < 56) {
              console.error(["The version of @babel/runtime installed in your node_modules directory ", "(" + babelRuntimeVersion + ") is out of date. Please upgrade it by running ", "", "  meteor npm install --save @babel/runtime@latest", "", "in your application directory.", ""].join("\n"));
            }

            /////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports = _require2("/node_modules/meteor/babel-runtime/babel-runtime.js");

  /* Exports */
  Package._define("babel-runtime", _exports);
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;

  /* Package-scope variables */
  var Promise;

  var _require = meteorInstall({ "node_modules": { "meteor": { "promise": { "modern.js": function _module() {

            /////////////////////////////////////////////////////////////////////////////
            //                                                                         //
            // packages/promise/modern.js                                              //
            //                                                                         //
            /////////////////////////////////////////////////////////////////////////////
            //
            // Initialize the package-scoped Promise variable with global.Promise in
            // all environments, even if it's not defined.
            Promise = global.Promise;

            /////////////////////////////////////////////////////////////////////////////
          }, "client.js": function _module2(_require2) {

            /////////////////////////////////////////////////////////////////////////////
            //                                                                         //
            // packages/promise/client.js                                              //
            //                                                                         //
            /////////////////////////////////////////////////////////////////////////////
            //
            _require2("./extensions.js");
            _require2("meteor-promise").makeCompatible(Promise);

            /////////////////////////////////////////////////////////////////////////////
          }, "extensions.js": function _module3() {

            /////////////////////////////////////////////////////////////////////////////
            //                                                                         //
            // packages/promise/extensions.js                                          //
            //                                                                         //
            /////////////////////////////////////////////////////////////////////////////
            //
            var proto = Promise.prototype;
            var hasOwn = Object.prototype.hasOwnProperty;

            proto.done = function (onFulfilled, onRejected) {
              var self = this;

              if (arguments.length > 0) {
                self = this.then.apply(this, arguments);
              }

              self.then(null, function (err) {
                Meteor._setImmediate(function () {
                  throw err;
                });
              });
            };

            if (!hasOwn.call(proto, "finally")) {
              proto["finally"] = function (onFinally) {
                var threw = false,
                    result;
                return this.then(function (value) {
                  result = value;
                  // Most implementations of Promise.prototype.finally call
                  // Promise.resolve(onFinally()) (or this.constructor.resolve or even
                  // this.constructor[Symbol.species].resolve, depending on how spec
                  // compliant they're trying to be), but this implementation simply
                  // relies on the standard Promise behavior of resolving any value
                  // returned from a .then callback function.
                  return onFinally();
                }, function (error) {
                  // Make the final .then callback (below) re-throw the error instead
                  // of returning it.
                  threw = true;
                  result = error;
                  return onFinally();
                }).then(function () {
                  if (threw) throw result;
                  return result;
                });
              };
            }

            /////////////////////////////////////////////////////////////////////////////
          }, "node_modules": { "meteor-promise": { "package.json": function module(_require3, _exports2, _module4) {

                /////////////////////////////////////////////////////////////////////////////
                //                                                                         //
                // node_modules/meteor/promise/node_modules/meteor-promise/package.json    //
                //                                                                         //
                /////////////////////////////////////////////////////////////////////////////
                //
                _module4.exports = {
                  "name": "meteor-promise",
                  "version": "0.8.7",
                  "browser": "promise_client.js",
                  "main": "promise_server.js"
                };

                /////////////////////////////////////////////////////////////////////////////
              }, "promise_client.js": function _module5(_require4, _exports3) {

                /////////////////////////////////////////////////////////////////////////////
                //                                                                         //
                // node_modules/meteor/promise/node_modules/meteor-promise/promise_client. //
                //                                                                         //
                /////////////////////////////////////////////////////////////////////////////
                //
                _exports3.makeCompatible = function (Promise) {
                  var es6PromiseThen = Promise.prototype.then;

                  Promise.prototype.then = function (onResolved, onRejected) {
                    if (typeof Meteor === "object" && typeof Meteor.bindEnvironment === "function") {
                      return es6PromiseThen.call(this, onResolved && Meteor.bindEnvironment(onResolved, raise), onRejected && Meteor.bindEnvironment(onRejected, raise));
                    }

                    return es6PromiseThen.call(this, onResolved, onRejected);
                  };
                };

                function raise(exception) {
                  throw exception;
                }

                /////////////////////////////////////////////////////////////////////////////
              } } } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/promise/modern.js");
  var _exports = _require("/node_modules/meteor/promise/client.js");

  /* Exports */
  Package._define("promise", _exports, {
    Promise: Promise
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var fetch;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "fetch": { "modern.js": function _module(_require, _exports) {

            ///////////////////////////////////////////////////////////////////////
            //                                                                   //
            // packages/fetch/modern.js                                          //
            //                                                                   //
            ///////////////////////////////////////////////////////////////////////
            //
            _exports.fetch = global.fetch;
            _exports.Headers = global.Headers;
            _exports.Request = global.Request;
            _exports.Response = global.Response;

            ///////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/fetch/modern.js");

  /* Exports */
  Package._define("fetch", _exports2, {
    fetch: fetch
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;
  var fetch = Package.fetch.fetch;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "dynamic-import": { "client.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                     //
            // packages/dynamic-import/client.js                                                   //
            //                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////
            //
            var Module = _module.constructor;
            var cache = _require("./cache.js");
            var meteorInstall = _require("meteor/modules").meteorInstall;
            var dynamicVersions = _require("./dynamic-versions.js");

            var dynamicImportSettings = Meteor.settings && Meteor.settings.public && Meteor.settings.public.packages && Meteor.settings.public.packages['dynamic-import'] || {};

            // Call module.dynamicImport(id) to fetch a module and any/all of its
            // dependencies that have not already been fetched, and evaluate them as
            // soon as they arrive. This runtime API makes it very easy to implement
            // ECMAScript dynamic import(...) syntax.
            Module.prototype.dynamicImport = function (id) {
              var module = this;
              return module.prefetch(id).then(function () {
                return getNamespace(module, id);
              });
            };

            // Called by Module.prototype.prefetch if there are any missing dynamic
            // modules that need to be fetched.
            meteorInstall.fetch = function (ids) {
              var tree = Object.create(null);
              var versions = Object.create(null);
              var missing;

              function addSource(id, source) {
                addToTree(tree, id, makeModuleFunction(id, source, ids[id].options));
              }

              function addMissing(id) {
                addToTree(missing = missing || Object.create(null), id, 1);
              }

              Object.keys(ids).forEach(function (id) {
                var version = dynamicVersions.get(id);
                if (version) {
                  versions[id] = version;
                } else {
                  addMissing(id);
                }
              });

              return cache.checkMany(versions).then(function (sources) {
                Object.keys(sources).forEach(function (id) {
                  var source = sources[id];
                  if (source) {
                    addSource(id, source);
                  } else {
                    addMissing(id);
                  }
                });

                return missing && fetchMissing(missing).then(function (results) {
                  var versionsAndSourcesById = Object.create(null);
                  var flatResults = flattenModuleTree(results);

                  Object.keys(flatResults).forEach(function (id) {
                    var source = flatResults[id];
                    addSource(id, source);

                    var version = dynamicVersions.get(id);
                    if (version) {
                      versionsAndSourcesById[id] = {
                        version: version,
                        source: source
                      };
                    }
                  });

                  cache.setMany(versionsAndSourcesById);
                });
              }).then(function () {
                return tree;
              });
            };

            function flattenModuleTree(tree) {
              var parts = [""];
              var result = Object.create(null);

              function walk(t) {
                if (t && typeof t === "object") {
                  Object.keys(t).forEach(function (key) {
                    parts.push(key);
                    walk(t[key]);
                    parts.pop();
                  });
                } else if (typeof t === "string") {
                  result[parts.join("/")] = t;
                }
              }

              walk(tree);

              return result;
            }

            function makeModuleFunction(id, source, options) {
              // By calling (options && options.eval || eval) in a wrapper function,
              // we delay the cost of parsing and evaluating the module code until the
              // module is first imported.
              return function () {
                // If an options.eval function was provided in the second argument to
                // meteorInstall when this bundle was first installed, use that
                // function to parse and evaluate the dynamic module code in the scope
                // of the package. Otherwise fall back to indirect (global) eval.
                return (options && options.eval || eval)(
                // Wrap the function(require,exports,module){...} expression in
                // parentheses to force it to be parsed as an expression.
                "(" + source + ")\n//# sourceURL=" + id).apply(this, arguments);
              };
            }

            var secretKey = null;
            _exports.setSecretKey = function (key) {
              secretKey = key;
            };

            var fetchURL = _require("./common.js").fetchURL;

            function inIframe() {
              try {
                return window.self !== window.top;
              } catch (e) {
                return true;
              }
            }

            function fetchMissing(missingTree) {
              // If the hostname of the URL returned by Meteor.absoluteUrl differs
              // from location.host, then we'll be making a cross-origin request here,
              // but that's fine because the dynamic-import server sets appropriate
              // CORS headers to enable fetching dynamic modules from any
              // origin. Browsers that check CORS do so by sending an additional
              // preflight OPTIONS request, which may add latency to the first dynamic
              // import() request, so it's a good idea for ROOT_URL to match
              // location.host if possible, though not strictly necessary.

              var url = fetchURL;

              var useLocationOrigin = dynamicImportSettings.useLocationOrigin;

              var disableLocationOriginIframe = dynamicImportSettings.disableLocationOriginIframe;

              if (useLocationOrigin && location && !(disableLocationOriginIframe && inIframe())) {
                url = location.origin.concat(url);
              } else {
                url = Meteor.absoluteUrl(url);
              }

              if (secretKey) {
                url += "key=" + secretKey;
              }

              return fetch(url, {
                method: "POST",
                body: JSON.stringify(missingTree)
              }).then(function (res) {
                if (!res.ok) throw res;
                return res.json();
              });
            }

            function addToTree(tree, id, value) {
              var parts = id.split("/");
              var lastIndex = parts.length - 1;
              parts.forEach(function (part, i) {
                if (part) {
                  tree = tree[part] = tree[part] || (i < lastIndex ? Object.create(null) : value);
                }
              });
            }

            function getNamespace(_module2, id) {
              var namespace;

              _module2.link(id, {
                "*": function (ns) {
                  namespace = ns;
                }
              });

              // This helps with Babel interop, since we're not just returning the
              // module.exports object.
              Object.defineProperty(namespace, "__esModule", {
                value: true,
                enumerable: false
              });

              return namespace;
            }

            /////////////////////////////////////////////////////////////////////////////////////////
          }, "cache.js": function module(_require3, _exports3, _module3) {

            /////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                     //
            // packages/dynamic-import/cache.js                                                    //
            //                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////
            //
            var dbPromise;

            var canUseCache =
            // The server doesn't benefit from dynamic module fetching, and almost
            // certainly doesn't support IndexedDB.
            Meteor.isClient &&
            // Cordova bundles all modules into the monolithic initial bundle, so
            // the dynamic module cache won't be necessary.
            !Meteor.isCordova &&
            // Caching can be confusing in development, and is designed to be a
            // transparent optimization for production performance.
            Meteor.isProduction;

            function getIDB() {
              if (typeof indexedDB !== "undefined") return indexedDB;
              if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
              if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
              if (typeof OIndexedDB !== "undefined") return OIndexedDB;
              if (typeof msIndexedDB !== "undefined") return msIndexedDB;
            }

            function withDB(callback) {
              dbPromise = dbPromise || new Promise(function (resolve, reject) {
                var idb = getIDB();
                if (!idb) {
                  throw new Error("IndexedDB not available");
                }

                // Incrementing the version number causes all existing object stores
                // to be deleted and recreates those specified by objectStoreMap.
                var request = idb.open("MeteorDynamicImportCache", 2);

                request.onupgradeneeded = function (event) {
                  var db = event.target.result;

                  // It's fine to delete existing object stores since onupgradeneeded
                  // is only called when we change the DB version number, and the data
                  // we're storing is disposable/reconstructible.
                  Array.from(db.objectStoreNames).forEach(db.deleteObjectStore, db);

                  Object.keys(objectStoreMap).forEach(function (name) {
                    db.createObjectStore(name, objectStoreMap[name]);
                  });
                };

                request.onerror = makeOnError(reject, "indexedDB.open");
                request.onsuccess = function (event) {
                  resolve(event.target.result);
                };
              });

              return dbPromise.then(callback, function (error) {
                return callback(null);
              });
            }

            var objectStoreMap = {
              sourcesByVersion: { keyPath: "version" }
            };

            function makeOnError(reject, source) {
              return function (event) {
                reject(new Error("IndexedDB failure in " + source + " " + JSON.stringify(event.target)));

                // Returning true from an onerror callback function prevents an
                // InvalidStateError in Firefox during Private Browsing. Silencing
                // that error is safe because we handle the error more gracefully by
                // passing it to the Promise reject function above.
                // https://github.com/meteor/meteor/issues/8697
                return true;
              };
            }

            var checkCount = 0;

            _exports3.checkMany = function (versions) {
              var ids = Object.keys(versions);
              var sourcesById = Object.create(null);

              // Initialize sourcesById with null values to indicate all sources are
              // missing (unless replaced with actual sources below).
              ids.forEach(function (id) {
                sourcesById[id] = null;
              });

              if (!canUseCache) {
                return Promise.resolve(sourcesById);
              }

              return withDB(function (db) {
                if (!db) {
                  // We thought we could used IndexedDB, but something went wrong
                  // while opening the database, so err on the side of safety.
                  return sourcesById;
                }

                var txn = db.transaction(["sourcesByVersion"], "readonly");

                var sourcesByVersion = txn.objectStore("sourcesByVersion");

                ++checkCount;

                function finish() {
                  --checkCount;
                  return sourcesById;
                }

                return Promise.all(ids.map(function (id) {
                  return new Promise(function (resolve, reject) {
                    var version = versions[id];
                    if (version) {
                      var sourceRequest = sourcesByVersion.get(version);
                      sourceRequest.onerror = makeOnError(reject, "sourcesByVersion.get");
                      sourceRequest.onsuccess = function (event) {
                        var result = event.target.result;
                        if (result) {
                          sourcesById[id] = result.source;
                        }
                        resolve();
                      };
                    } else resolve();
                  });
                })).then(finish, finish);
              });
            };

            var pendingVersionsAndSourcesById = Object.create(null);

            _exports3.setMany = function (versionsAndSourcesById) {
              if (canUseCache) {
                Object.assign(pendingVersionsAndSourcesById, versionsAndSourcesById);

                // Delay the call to flushSetMany so that it doesn't contribute to the
                // amount of time it takes to call module.dynamicImport.
                if (!flushSetMany.timer) {
                  flushSetMany.timer = setTimeout(flushSetMany, 100);
                }
              }
            };

            function flushSetMany() {
              if (checkCount > 0) {
                // If checkMany is currently underway, postpone the flush until later,
                // since updating the cache is less important than reading from it.
                return flushSetMany.timer = setTimeout(flushSetMany, 100);
              }

              flushSetMany.timer = null;

              var versionsAndSourcesById = pendingVersionsAndSourcesById;
              pendingVersionsAndSourcesById = Object.create(null);

              return withDB(function (db) {
                if (!db) {
                  // We thought we could used IndexedDB, but something went wrong
                  // while opening the database, so err on the side of safety.
                  return;
                }

                var setTxn = db.transaction(["sourcesByVersion"], "readwrite");

                var sourcesByVersion = setTxn.objectStore("sourcesByVersion");

                return Promise.all(Object.keys(versionsAndSourcesById).map(function (id) {
                  var info = versionsAndSourcesById[id];
                  return new Promise(function (resolve, reject) {
                    var request = sourcesByVersion.put({
                      version: info.version,
                      source: info.source
                    });
                    request.onerror = makeOnError(reject, "sourcesByVersion.put");
                    request.onsuccess = resolve;
                  });
                }));
              });
            }

            /////////////////////////////////////////////////////////////////////////////////////////
          }, "common.js": function _module4(_require4, _exports4) {

            /////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                     //
            // packages/dynamic-import/common.js                                                   //
            //                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////
            //
            _exports4.fetchURL = "/__meteor__/dynamic-import/fetch";

            /////////////////////////////////////////////////////////////////////////////////////////
          }, "dynamic-versions.js": function module(_require5, _exports5, _module5) {

            /////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                     //
            // packages/dynamic-import/dynamic-versions.js                                         //
            //                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////
            //
            // This magic double-underscored identifier gets replaced in
            // tools/isobuild/bundler.js with a tree of hashes of all dynamic
            // modules, for use in client.js and cache.js.
            var versions = {};

            const METEOR_PREFIX = '/node_modules/meteor/';

            _exports5.get = function (id) {
              var tree = versions;
              var version = null;

              id.split("/").some(function (part) {
                if (part) {
                  // If the tree contains identifiers for Meteor packages with colons
                  // in their names, the colons should not have been replaced by
                  // underscores, but there's a bug that results in that behavior, so
                  // for now it seems safest to be tolerant of underscores here.
                  // https://github.com/meteor/meteor/pull/9103
                  tree = tree[part] || tree[part.replace(":", "_")];
                }

                if (!tree) {
                  // Terminate the search without reassigning version.
                  return true;
                }

                if (typeof tree === "string") {
                  version = tree;
                  return true;
                }
              });

              return version;
            };

            function getFlatModuleArray(tree) {
              var parts = [""];
              var result = [];

              function walk(t) {
                if (t && typeof t === "object") {
                  Object.keys(t).forEach(function (key) {
                    parts.push(key);
                    walk(t[key]);
                    parts.pop();
                  });
                } else if (typeof t === "string") {
                  result.push(parts.join("/"));
                }
              }

              walk(tree);

              return result;
            }

            // If Package.appcache is loaded, preload additional modules after the
            // core bundle has been loaded.
            function precacheOnLoad(event) {
              // Check inside onload to make sure Package.appcache has had a chance to
              // become available.
              if (!Package.appcache) {
                return;
              }

              // Prefetch in chunks to reduce overhead. If we call module.prefetch(id)
              // multiple times in the same tick of the event loop, all those modules
              // will be fetched in one HTTP POST request.
              function prefetchInChunks(modules, amount) {
                Promise.all(modules.splice(0, amount).map(function (id) {
                  return new Promise(function (resolve, reject) {
                    _module5.prefetch(id).then(resolve).catch(function (err) {
                      // we probably have a : _ mismatch
                      // what can get wrong if we do the replacement
                      // 1. a package with a name like a_b:package will not resolve
                      // 2. someone falsely imports a_package that does not exist but a
                      // package a:package exists, so this one gets imported and its usage
                      // will fail
                      if (id.indexOf(METEOR_PREFIX) === 0) {
                        _module5.prefetch(METEOR_PREFIX + id.replace(METEOR_PREFIX, '').replace('_', ':')).then(resolve).catch(reject);
                      } else {
                        reject(err);
                      }
                    });
                  });
                })).then(function () {
                  if (modules.length > 0) {
                    setTimeout(function () {
                      prefetchInChunks(modules, amount);
                    }, 0);
                  }
                });
              }

              // Get a flat array of modules and start prefetching.
              prefetchInChunks(getFlatModuleArray(versions), 50);
            }

            // Use window.onload to only prefetch after the main bundle has loaded.
            if (global.addEventListener) {
              global.addEventListener('load', precacheOnLoad, false);
            } else if (global.attachEvent) {
              global.attachEvent('onload', precacheOnLoad);
            }

            /////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/dynamic-import/client.js");

  /* Exports */
  Package._define("dynamic-import", _exports2);
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("es5-shim");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "ecmascript-runtime-client": { "modern.js": function _module(_require) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/ecmascript-runtime-client/modern.js                                                                        //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            try {
              _require("core-js/modules/es.object.get-own-property-descriptors");
            } catch (e) {
              throw new Error(["The core-js npm package could not be found in your node_modules ", "directory. Please run the following command to install it:", "", "  meteor npm install --save core-js", ""].join("\n"));
            }

            _require("core-js/modules/es.object.is");
            _require("core-js/modules/es.function.name");
            _require("core-js/modules/es.number.is-finite");
            _require("core-js/modules/es.number.is-nan");
            _require("core-js/modules/es.array.flat");
            _require("core-js/modules/es.array.flat-map");
            _require("core-js/modules/es.object.from-entries");
            _require("core-js/modules/es.string.pad-start");
            _require("core-js/modules/es.string.pad-end");
            _require("core-js/modules/es.string.trim-start");
            _require("core-js/modules/es.string.trim-end");
            _require("core-js/modules/es.symbol.async-iterator");

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "node_modules": { "core-js": { "modules": { "es.object.get-own-property-descriptors.js": function _module2(_require3) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.object.get-own-property-descriptors.j //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var $ = _require3('../internals/export');
                  var DESCRIPTORS = _require3('../internals/descriptors');
                  var ownKeys = _require3('../internals/own-keys');
                  var toIndexedObject = _require3('../internals/to-indexed-object');
                  var getOwnPropertyDescriptorModule = _require3('../internals/object-get-own-property-descriptor');
                  var createProperty = _require3('../internals/create-property');

                  // `Object.getOwnPropertyDescriptors` method
                  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                  $({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
                    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                      var O = toIndexedObject(object);
                      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                      var keys = ownKeys(O);
                      var result = {};
                      var index = 0;
                      var key, descriptor;
                      while (keys.length > index) {
                        descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                        if (descriptor !== undefined) createProperty(result, key, descriptor);
                      }
                      return result;
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.object.is.js": function _module3(_require4) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.object.is.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var $ = _require4('../internals/export');
                  var is = _require4('../internals/same-value');

                  // `Object.is` method
                  // https://tc39.es/ecma262/#sec-object.is
                  $({ target: 'Object', stat: true }, {
                    is: is
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.function.name.js": function _module4(_require5) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.function.name.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var DESCRIPTORS = _require5('../internals/descriptors');
                  var defineProperty = _require5('../internals/object-define-property').f;

                  var FunctionPrototype = Function.prototype;
                  var FunctionPrototypeToString = FunctionPrototype.toString;
                  var nameRE = /^\s*function ([^ (]*)/;
                  var NAME = 'name';

                  // Function instances `.name` property
                  // https://tc39.es/ecma262/#sec-function-instances-name
                  if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
                    defineProperty(FunctionPrototype, NAME, {
                      configurable: true,
                      get: function () {
                        try {
                          return FunctionPrototypeToString.call(this).match(nameRE)[1];
                        } catch (error) {
                          return '';
                        }
                      }
                    });
                  }

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.number.is-finite.js": function _module5(_require6) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.number.is-finite.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var $ = _require6('../internals/export');
                  var numberIsFinite = _require6('../internals/number-is-finite');

                  // `Number.isFinite` method
                  // https://tc39.es/ecma262/#sec-number.isfinite
                  $({ target: 'Number', stat: true }, { isFinite: numberIsFinite });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.number.is-nan.js": function _module6(_require7) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.number.is-nan.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var $ = _require7('../internals/export');

                  // `Number.isNaN` method
                  // https://tc39.es/ecma262/#sec-number.isnan
                  $({ target: 'Number', stat: true }, {
                    isNaN: function isNaN(number) {
                      // eslint-disable-next-line no-self-compare -- NaN check
                      return number != number;
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.array.flat.js": function _module7(_require8) {
                  var $ = _require8('../internals/export');
                  var flattenIntoArray = _require8('../internals/flatten-into-array');
                  var toObject = _require8('../internals/to-object');
                  var toLength = _require8('../internals/to-length');
                  var toInteger = _require8('../internals/to-integer');
                  var arraySpeciesCreate = _require8('../internals/array-species-create');

                  // `Array.prototype.flat` method
                  // https://tc39.es/ecma262/#sec-array.prototype.flat
                  $({ target: 'Array', proto: true }, {
                    flat: function flat() /* depthArg = 1 */{
                      var depthArg = arguments.length ? arguments[0] : undefined;
                      var O = toObject(this);
                      var sourceLen = toLength(O.length);
                      var A = arraySpeciesCreate(O, 0);
                      A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
                      return A;
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.array.flat-map.js": function _module8(_require9) {
                  var $ = _require9('../internals/export');
                  var flattenIntoArray = _require9('../internals/flatten-into-array');
                  var toObject = _require9('../internals/to-object');
                  var toLength = _require9('../internals/to-length');
                  var aFunction = _require9('../internals/a-function');
                  var arraySpeciesCreate = _require9('../internals/array-species-create');

                  // `Array.prototype.flatMap` method
                  // https://tc39.es/ecma262/#sec-array.prototype.flatmap
                  $({ target: 'Array', proto: true }, {
                    flatMap: function flatMap(callbackfn /* , thisArg */) {
                      var O = toObject(this);
                      var sourceLen = toLength(O.length);
                      var A;
                      aFunction(callbackfn);
                      A = arraySpeciesCreate(O, 0);
                      A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                      return A;
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.object.from-entries.js": function _module9(_require10) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.object.from-entries.js                //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var $ = _require10('../internals/export');
                  var iterate = _require10('../internals/iterate');
                  var createProperty = _require10('../internals/create-property');

                  // `Object.fromEntries` method
                  // https://github.com/tc39/proposal-object-from-entries
                  $({ target: 'Object', stat: true }, {
                    fromEntries: function fromEntries(iterable) {
                      var obj = {};
                      iterate(iterable, function (k, v) {
                        createProperty(obj, k, v);
                      }, { AS_ENTRIES: true });
                      return obj;
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.string.pad-start.js": function _module10(_require11) {
                  var $ = _require11('../internals/export');
                  var $padStart = _require11('../internals/string-pad').start;
                  var WEBKIT_BUG = _require11('../internals/string-pad-webkit-bug');

                  // `String.prototype.padStart` method
                  // https://tc39.es/ecma262/#sec-string.prototype.padstart
                  $({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
                    padStart: function padStart(maxLength /* , fillString = ' ' */) {
                      return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.string.pad-end.js": function _module11(_require12) {
                  var $ = _require12('../internals/export');
                  var $padEnd = _require12('../internals/string-pad').end;
                  var WEBKIT_BUG = _require12('../internals/string-pad-webkit-bug');

                  // `String.prototype.padEnd` method
                  // https://tc39.es/ecma262/#sec-string.prototype.padend
                  $({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
                    padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
                      return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
                    }
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.string.trim-start.js": function _module12(_require13) {
                  var $ = _require13('../internals/export');
                  var $trimStart = _require13('../internals/string-trim').start;
                  var forcedStringTrimMethod = _require13('../internals/string-trim-forced');

                  var FORCED = forcedStringTrimMethod('trimStart');

                  var trimStart = FORCED ? function trimStart() {
                    return $trimStart(this);
                    // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
                  } : ''.trimStart;

                  // `String.prototype.{ trimStart, trimLeft }` methods
                  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                  // https://tc39.es/ecma262/#String.prototype.trimleft
                  $({ target: 'String', proto: true, forced: FORCED }, {
                    trimStart: trimStart,
                    trimLeft: trimStart
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.string.trim-end.js": function _module13(_require14) {
                  var $ = _require14('../internals/export');
                  var $trimEnd = _require14('../internals/string-trim').end;
                  var forcedStringTrimMethod = _require14('../internals/string-trim-forced');

                  var FORCED = forcedStringTrimMethod('trimEnd');

                  var trimEnd = FORCED ? function trimEnd() {
                    return $trimEnd(this);
                    // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
                  } : ''.trimEnd;

                  // `String.prototype.{ trimEnd, trimRight }` methods
                  // https://tc39.es/ecma262/#sec-string.prototype.trimend
                  // https://tc39.es/ecma262/#String.prototype.trimright
                  $({ target: 'String', proto: true, forced: FORCED }, {
                    trimEnd: trimEnd,
                    trimRight: trimEnd
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "es.symbol.async-iterator.js": function _module14(_require15) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/modules/es.symbol.async-iterator.js              //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var defineWellKnownSymbol = _require15('../internals/define-well-known-symbol');

                  // `Symbol.asyncIterator` well-known symbol
                  // https://tc39.es/ecma262/#sec-symbol.asynciterator
                  defineWellKnownSymbol('asyncIterator');

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                } }, "internals": { "export.js": function module(_require16, _exports2, _module15) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/export.js                              //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require16('../internals/global');
                  var getOwnPropertyDescriptor = _require16('../internals/object-get-own-property-descriptor').f;
                  var createNonEnumerableProperty = _require16('../internals/create-non-enumerable-property');
                  var redefine = _require16('../internals/redefine');
                  var setGlobal = _require16('../internals/set-global');
                  var copyConstructorProperties = _require16('../internals/copy-constructor-properties');
                  var isForced = _require16('../internals/is-forced');

                  /*
                    options.target      - name of the target object
                    options.global      - target is the global object
                    options.stat        - export as static methods of target
                    options.proto       - export as prototype methods of target
                    options.real        - real prototype method for the `pure` version
                    options.forced      - export even if the native feature is available
                    options.bind        - bind methods to the target, required for the `pure` version
                    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
                    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
                    options.sham        - add a flag to not completely full polyfills
                    options.enumerable  - export as enumerable property
                    options.noTargetGet - prevent calling a getter on target
                  */
                  _module15.exports = function (options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) {
                      target = global;
                    } else if (STATIC) {
                      target = global[TARGET] || setGlobal(TARGET, {});
                    } else {
                      target = (global[TARGET] || {}).prototype;
                    }
                    if (target) for (key in source) {
                      sourceProperty = source[key];
                      if (options.noTargetGet) {
                        descriptor = getOwnPropertyDescriptor(target, key);
                        targetProperty = descriptor && descriptor.value;
                      } else targetProperty = target[key];
                      FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                      // contained in target
                      if (!FORCED && targetProperty !== undefined) {
                        if (typeof sourceProperty === typeof targetProperty) continue;
                        copyConstructorProperties(sourceProperty, targetProperty);
                      }
                      // add a flag to not completely full polyfills
                      if (options.sham || targetProperty && targetProperty.sham) {
                        createNonEnumerableProperty(sourceProperty, 'sham', true);
                      }
                      // extend global
                      redefine(target, key, sourceProperty, options);
                    }
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "global.js": function module(_require17, _exports3, _module16) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/global.js                              //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var check = function (it) {
                    return it && it.Math == Math && it;
                  };

                  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                  _module16.exports =
                  // eslint-disable-next-line es/no-global-this -- safe
                  check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
                  // eslint-disable-next-line no-restricted-globals -- safe
                  check(typeof self == 'object' && self) || check(typeof global == 'object' && global) ||
                  // eslint-disable-next-line no-new-func -- fallback
                  function () {
                    return this;
                  }() || Function('return this')();

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-get-own-property-descriptor.js": function _module17(_require18, _exports4) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/object-get-own-property-descriptor.js  //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var DESCRIPTORS = _require18('../internals/descriptors');
                  var propertyIsEnumerableModule = _require18('../internals/object-property-is-enumerable');
                  var createPropertyDescriptor = _require18('../internals/create-property-descriptor');
                  var toIndexedObject = _require18('../internals/to-indexed-object');
                  var toPrimitive = _require18('../internals/to-primitive');
                  var has = _require18('../internals/has');
                  var IE8_DOM_DEFINE = _require18('../internals/ie8-dom-define');

                  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                  var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

                  // `Object.getOwnPropertyDescriptor` method
                  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                  _exports4.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPrimitive(P, true);
                    if (IE8_DOM_DEFINE) try {
                      return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {/* empty */}
                    if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "descriptors.js": function module(_require19, _exports5, _module18) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/descriptors.js                         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var fails = _require19('../internals/fails');

                  // Detect IE8's incomplete defineProperty implementation
                  _module18.exports = !fails(function () {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty({}, 1, { get: function () {
                        return 7;
                      } })[1] != 7;
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "fails.js": function module(_require20, _exports6, _module19) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/fails.js                               //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module19.exports = function (exec) {
                    try {
                      return !!exec();
                    } catch (error) {
                      return true;
                    }
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-property-is-enumerable.js": function _module20(_require21, _exports7) {
                  var $propertyIsEnumerable = {}.propertyIsEnumerable;
                  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

                  // Nashorn ~ JDK8 bug
                  var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

                  // `Object.prototype.propertyIsEnumerable` method implementation
                  // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
                  _exports7.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                  } : $propertyIsEnumerable;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "create-property-descriptor.js": function module(_require22, _exports8, _module21) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/create-property-descriptor.js          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module21.exports = function (bitmap, value) {
                    return {
                      enumerable: !(bitmap & 1),
                      configurable: !(bitmap & 2),
                      writable: !(bitmap & 4),
                      value: value
                    };
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-indexed-object.js": function module(_require23, _exports9, _module22) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-indexed-object.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // toObject with fallback for non-array-like ES3 strings
                  var IndexedObject = _require23('../internals/indexed-object');
                  var requireObjectCoercible = _require23('../internals/require-object-coercible');

                  _module22.exports = function (it) {
                    return IndexedObject(requireObjectCoercible(it));
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "indexed-object.js": function module(_require24, _exports10, _module23) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/indexed-object.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var fails = _require24('../internals/fails');
                  var classof = _require24('../internals/classof-raw');

                  var split = ''.split;

                  // fallback for non-array-like ES3 and non-enumerable old V8 strings
                  _module23.exports = fails(function () {
                    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                    // eslint-disable-next-line no-prototype-builtins -- safe
                    return !Object('z').propertyIsEnumerable(0);
                  }) ? function (it) {
                    return classof(it) == 'String' ? split.call(it, '') : Object(it);
                  } : Object;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "classof-raw.js": function module(_require25, _exports11, _module24) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/classof-raw.js                         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var toString = {}.toString;

                  _module24.exports = function (it) {
                    return toString.call(it).slice(8, -1);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "require-object-coercible.js": function module(_require26, _exports12, _module25) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/require-object-coercible.js            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // `RequireObjectCoercible` abstract operation
                  // https://tc39.es/ecma262/#sec-requireobjectcoercible
                  _module25.exports = function (it) {
                    if (it == undefined) throw TypeError("Can't call method on " + it);
                    return it;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-primitive.js": function module(_require27, _exports13, _module26) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-primitive.js                        //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var isObject = _require27('../internals/is-object');

                  // `ToPrimitive` abstract operation
                  // https://tc39.es/ecma262/#sec-toprimitive
                  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
                  // and the second argument - flag - preferred type is a string
                  _module26.exports = function (input, PREFERRED_STRING) {
                    if (!isObject(input)) return input;
                    var fn, val;
                    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
                    if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
                    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
                    throw TypeError("Can't convert object to primitive value");
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "is-object.js": function module(_require28, _exports14, _module27) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/is-object.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module27.exports = function (it) {
                    return typeof it === 'object' ? it !== null : typeof it === 'function';
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "has.js": function module(_require29, _exports15, _module28) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/has.js                                 //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var toObject = _require29('../internals/to-object');

                  var hasOwnProperty = {}.hasOwnProperty;

                  _module28.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty.call(toObject(it), key);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-object.js": function module(_require30, _exports16, _module29) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-object.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var requireObjectCoercible = _require30('../internals/require-object-coercible');

                  // `ToObject` abstract operation
                  // https://tc39.es/ecma262/#sec-toobject
                  _module29.exports = function (argument) {
                    return Object(requireObjectCoercible(argument));
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "ie8-dom-define.js": function module(_require31, _exports17, _module30) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/ie8-dom-define.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var DESCRIPTORS = _require31('../internals/descriptors');
                  var fails = _require31('../internals/fails');
                  var createElement = _require31('../internals/document-create-element');

                  // Thank's IE8 for his funny defineProperty
                  _module30.exports = !DESCRIPTORS && !fails(function () {
                    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
                    return Object.defineProperty(createElement('div'), 'a', {
                      get: function () {
                        return 7;
                      }
                    }).a != 7;
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "document-create-element.js": function module(_require32, _exports18, _module31) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/document-create-element.js             //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require32('../internals/global');
                  var isObject = _require32('../internals/is-object');

                  var document = global.document;
                  // typeof document.createElement is 'object' in old IE
                  var EXISTS = isObject(document) && isObject(document.createElement);

                  _module31.exports = function (it) {
                    return EXISTS ? document.createElement(it) : {};
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "create-non-enumerable-property.js": function module(_require33, _exports19, _module32) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/create-non-enumerable-property.js      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var DESCRIPTORS = _require33('../internals/descriptors');
                  var definePropertyModule = _require33('../internals/object-define-property');
                  var createPropertyDescriptor = _require33('../internals/create-property-descriptor');

                  _module32.exports = DESCRIPTORS ? function (object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                  } : function (object, key, value) {
                    object[key] = value;
                    return object;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-define-property.js": function _module33(_require34, _exports20) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/object-define-property.js              //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var DESCRIPTORS = _require34('../internals/descriptors');
                  var IE8_DOM_DEFINE = _require34('../internals/ie8-dom-define');
                  var anObject = _require34('../internals/an-object');
                  var toPrimitive = _require34('../internals/to-primitive');

                  // eslint-disable-next-line es/no-object-defineproperty -- safe
                  var $defineProperty = Object.defineProperty;

                  // `Object.defineProperty` method
                  // https://tc39.es/ecma262/#sec-object.defineproperty
                  _exports20.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPrimitive(P, true);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                      return $defineProperty(O, P, Attributes);
                    } catch (error) {/* empty */}
                    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "an-object.js": function module(_require35, _exports21, _module34) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/an-object.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var isObject = _require35('../internals/is-object');

                  _module34.exports = function (it) {
                    if (!isObject(it)) {
                      throw TypeError(String(it) + ' is not an object');
                    }return it;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "redefine.js": function module(_require36, _exports22, _module35) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/redefine.js                            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require36('../internals/global');
                  var createNonEnumerableProperty = _require36('../internals/create-non-enumerable-property');
                  var has = _require36('../internals/has');
                  var setGlobal = _require36('../internals/set-global');
                  var inspectSource = _require36('../internals/inspect-source');
                  var InternalStateModule = _require36('../internals/internal-state');

                  var getInternalState = InternalStateModule.get;
                  var enforceInternalState = InternalStateModule.enforce;
                  var TEMPLATE = String(String).split('String');

                  (_module35.exports = function (O, key, value, options) {
                    var unsafe = options ? !!options.unsafe : false;
                    var simple = options ? !!options.enumerable : false;
                    var noTargetGet = options ? !!options.noTargetGet : false;
                    var state;
                    if (typeof value == 'function') {
                      if (typeof key == 'string' && !has(value, 'name')) {
                        createNonEnumerableProperty(value, 'name', key);
                      }
                      state = enforceInternalState(value);
                      if (!state.source) {
                        state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
                      }
                    }
                    if (O === global) {
                      if (simple) O[key] = value;else setGlobal(key, value);
                      return;
                    } else if (!unsafe) {
                      delete O[key];
                    } else if (!noTargetGet && O[key]) {
                      simple = true;
                    }
                    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value);
                    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                  })(Function.prototype, 'toString', function toString() {
                    return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "set-global.js": function module(_require37, _exports23, _module36) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/set-global.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require37('../internals/global');
                  var createNonEnumerableProperty = _require37('../internals/create-non-enumerable-property');

                  _module36.exports = function (key, value) {
                    try {
                      createNonEnumerableProperty(global, key, value);
                    } catch (error) {
                      global[key] = value;
                    }return value;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "inspect-source.js": function module(_require38, _exports24, _module37) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/inspect-source.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var store = _require38('../internals/shared-store');

                  var functionToString = Function.toString;

                  // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
                  if (typeof store.inspectSource != 'function') {
                    store.inspectSource = function (it) {
                      return functionToString.call(it);
                    };
                  }

                  _module37.exports = store.inspectSource;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "shared-store.js": function module(_require39, _exports25, _module38) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/shared-store.js                        //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require39('../internals/global');
                  var setGlobal = _require39('../internals/set-global');

                  var SHARED = '__core-js_shared__';
                  var store = global[SHARED] || setGlobal(SHARED, {});

                  _module38.exports = store;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "internal-state.js": function module(_require40, _exports26, _module39) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/internal-state.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var NATIVE_WEAK_MAP = _require40('../internals/native-weak-map');
                  var global = _require40('../internals/global');
                  var isObject = _require40('../internals/is-object');
                  var createNonEnumerableProperty = _require40('../internals/create-non-enumerable-property');
                  var objectHas = _require40('../internals/has');
                  var shared = _require40('../internals/shared-store');
                  var sharedKey = _require40('../internals/shared-key');
                  var hiddenKeys = _require40('../internals/hidden-keys');

                  var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
                  var WeakMap = global.WeakMap;
                  var set, get, has;

                  var enforce = function (it) {
                    return has(it) ? get(it) : set(it, {});
                  };

                  var getterFor = function (TYPE) {
                    return function (it) {
                      var state;
                      if (!isObject(it) || (state = get(it)).type !== TYPE) {
                        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
                      }return state;
                    };
                  };

                  if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap());
                    var wmget = store.get;
                    var wmhas = store.has;
                    var wmset = store.set;
                    set = function (it, metadata) {
                      if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
                      metadata.facade = it;
                      wmset.call(store, it, metadata);
                      return metadata;
                    };
                    get = function (it) {
                      return wmget.call(store, it) || {};
                    };
                    has = function (it) {
                      return wmhas.call(store, it);
                    };
                  } else {
                    var STATE = sharedKey('state');
                    hiddenKeys[STATE] = true;
                    set = function (it, metadata) {
                      if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
                      metadata.facade = it;
                      createNonEnumerableProperty(it, STATE, metadata);
                      return metadata;
                    };
                    get = function (it) {
                      return objectHas(it, STATE) ? it[STATE] : {};
                    };
                    has = function (it) {
                      return objectHas(it, STATE);
                    };
                  }

                  _module39.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "native-weak-map.js": function module(_require41, _exports27, _module40) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/native-weak-map.js                     //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require41('../internals/global');
                  var inspectSource = _require41('../internals/inspect-source');

                  var WeakMap = global.WeakMap;

                  _module40.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "shared-key.js": function module(_require42, _exports28, _module41) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/shared-key.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var shared = _require42('../internals/shared');
                  var uid = _require42('../internals/uid');

                  var keys = shared('keys');

                  _module41.exports = function (key) {
                    return keys[key] || (keys[key] = uid(key));
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "shared.js": function module(_require43, _exports29, _module42) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/shared.js                              //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var IS_PURE = _require43('../internals/is-pure');
                  var store = _require43('../internals/shared-store');

                  (_module42.exports = function (key, value) {
                    return store[key] || (store[key] = value !== undefined ? value : {});
                  })('versions', []).push({
                    version: '3.14.0',
                    mode: IS_PURE ? 'pure' : 'global',
                    copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "is-pure.js": function module(_require44, _exports30, _module43) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/is-pure.js                             //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module43.exports = false;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "uid.js": function module(_require45, _exports31, _module44) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/uid.js                                 //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var id = 0;
                  var postfix = Math.random();

                  _module44.exports = function (key) {
                    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "hidden-keys.js": function module(_require46, _exports32, _module45) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/hidden-keys.js                         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module45.exports = {};

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "copy-constructor-properties.js": function module(_require47, _exports33, _module46) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/copy-constructor-properties.js         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var has = _require47('../internals/has');
                  var ownKeys = _require47('../internals/own-keys');
                  var getOwnPropertyDescriptorModule = _require47('../internals/object-get-own-property-descriptor');
                  var definePropertyModule = _require47('../internals/object-define-property');

                  _module46.exports = function (target, source) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for (var i = 0; i < keys.length; i++) {
                      var key = keys[i];
                      if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "own-keys.js": function module(_require48, _exports34, _module47) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/own-keys.js                            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var getBuiltIn = _require48('../internals/get-built-in');
                  var getOwnPropertyNamesModule = _require48('../internals/object-get-own-property-names');
                  var getOwnPropertySymbolsModule = _require48('../internals/object-get-own-property-symbols');
                  var anObject = _require48('../internals/an-object');

                  // all object keys, includes non-enumerable and symbols
                  _module47.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "get-built-in.js": function module(_require49, _exports35, _module48) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/get-built-in.js                        //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var path = _require49('../internals/path');
                  var global = _require49('../internals/global');

                  var aFunction = function (variable) {
                    return typeof variable == 'function' ? variable : undefined;
                  };

                  _module48.exports = function (namespace, method) {
                    return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "path.js": function module(_require50, _exports36, _module49) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/path.js                                //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require50('../internals/global');

                  _module49.exports = global;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-get-own-property-names.js": function _module50(_require51, _exports37) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/object-get-own-property-names.js       //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var internalObjectKeys = _require51('../internals/object-keys-internal');
                  var enumBugKeys = _require51('../internals/enum-bug-keys');

                  var hiddenKeys = enumBugKeys.concat('length', 'prototype');

                  // `Object.getOwnPropertyNames` method
                  // https://tc39.es/ecma262/#sec-object.getownpropertynames
                  // eslint-disable-next-line es/no-object-getownpropertynames -- safe
                  _exports37.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-keys-internal.js": function module(_require52, _exports38, _module51) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/object-keys-internal.js                //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var has = _require52('../internals/has');
                  var toIndexedObject = _require52('../internals/to-indexed-object');
                  var indexOf = _require52('../internals/array-includes').indexOf;
                  var hiddenKeys = _require52('../internals/hidden-keys');

                  _module51.exports = function (object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
                    // Don't enum bug & hidden keys
                    while (names.length > i) if (has(O, key = names[i++])) {
                      ~indexOf(result, key) || result.push(key);
                    }
                    return result;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "array-includes.js": function module(_require53, _exports39, _module52) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/array-includes.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var toIndexedObject = _require53('../internals/to-indexed-object');
                  var toLength = _require53('../internals/to-length');
                  var toAbsoluteIndex = _require53('../internals/to-absolute-index');

                  // `Array.prototype.{ indexOf, includes }` methods implementation
                  var createMethod = function (IS_INCLUDES) {
                    return function ($this, el, fromIndex) {
                      var O = toIndexedObject($this);
                      var length = toLength(O.length);
                      var index = toAbsoluteIndex(fromIndex, length);
                      var value;
                      // Array#includes uses SameValueZero equality algorithm
                      // eslint-disable-next-line no-self-compare -- NaN check
                      if (IS_INCLUDES && el != el) while (length > index) {
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                      } else for (; length > index; index++) {
                        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                      }return !IS_INCLUDES && -1;
                    };
                  };

                  _module52.exports = {
                    // `Array.prototype.includes` method
                    // https://tc39.es/ecma262/#sec-array.prototype.includes
                    includes: createMethod(true),
                    // `Array.prototype.indexOf` method
                    // https://tc39.es/ecma262/#sec-array.prototype.indexof
                    indexOf: createMethod(false)
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-length.js": function module(_require54, _exports40, _module53) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-length.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var toInteger = _require54('../internals/to-integer');

                  var min = Math.min;

                  // `ToLength` abstract operation
                  // https://tc39.es/ecma262/#sec-tolength
                  _module53.exports = function (argument) {
                    return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-integer.js": function module(_require55, _exports41, _module54) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-integer.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var ceil = Math.ceil;
                  var floor = Math.floor;

                  // `ToInteger` abstract operation
                  // https://tc39.es/ecma262/#sec-tointeger
                  _module54.exports = function (argument) {
                    return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-absolute-index.js": function module(_require56, _exports42, _module55) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-absolute-index.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var toInteger = _require56('../internals/to-integer');

                  var max = Math.max;
                  var min = Math.min;

                  // Helper for a popular repeating case of the spec:
                  // Let integer be ? ToInteger(index).
                  // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
                  _module55.exports = function (index, length) {
                    var integer = toInteger(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "enum-bug-keys.js": function module(_require57, _exports43, _module56) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/enum-bug-keys.js                       //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // IE8- don't enum bug keys
                  _module56.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "object-get-own-property-symbols.js": function _module57(_require58, _exports44) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/object-get-own-property-symbols.js     //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
                  _exports44.f = Object.getOwnPropertySymbols;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "is-forced.js": function module(_require59, _exports45, _module58) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/is-forced.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var fails = _require59('../internals/fails');

                  var replacement = /#|\.prototype\./;

                  var isForced = function (feature, detection) {
                    var value = data[normalize(feature)];
                    return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
                  };

                  var normalize = isForced.normalize = function (string) {
                    return String(string).replace(replacement, '.').toLowerCase();
                  };

                  var data = isForced.data = {};
                  var NATIVE = isForced.NATIVE = 'N';
                  var POLYFILL = isForced.POLYFILL = 'P';

                  _module58.exports = isForced;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "create-property.js": function module(_require60, _exports46, _module59) {
                  var toPrimitive = _require60('../internals/to-primitive');
                  var definePropertyModule = _require60('../internals/object-define-property');
                  var createPropertyDescriptor = _require60('../internals/create-property-descriptor');

                  _module59.exports = function (object, key, value) {
                    var propertyKey = toPrimitive(key);
                    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "same-value.js": function module(_require61, _exports47, _module60) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/same-value.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // `SameValue` abstract operation
                  // https://tc39.es/ecma262/#sec-samevalue
                  // eslint-disable-next-line es/no-object-is -- safe
                  _module60.exports = Object.is || function is(x, y) {
                    // eslint-disable-next-line no-self-compare -- NaN check
                    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "number-is-finite.js": function module(_require62, _exports48, _module61) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/number-is-finite.js                    //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require62('../internals/global');

                  var globalIsFinite = global.isFinite;

                  // `Number.isFinite` method
                  // https://tc39.es/ecma262/#sec-number.isfinite
                  // eslint-disable-next-line es/no-number-isfinite -- safe
                  _module61.exports = Number.isFinite || function isFinite(it) {
                    return typeof it == 'number' && globalIsFinite(it);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "flatten-into-array.js": function module(_require63, _exports49, _module62) {
                  var isArray = _require63('../internals/is-array');
                  var toLength = _require63('../internals/to-length');
                  var bind = _require63('../internals/function-bind-context');

                  // `FlattenIntoArray` abstract operation
                  // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
                  var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
                    var targetIndex = start;
                    var sourceIndex = 0;
                    var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
                    var element;

                    while (sourceIndex < sourceLen) {
                      if (sourceIndex in source) {
                        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

                        if (depth > 0 && isArray(element)) {
                          targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                        } else {
                          if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
                          target[targetIndex] = element;
                        }

                        targetIndex++;
                      }
                      sourceIndex++;
                    }
                    return targetIndex;
                  };

                  _module62.exports = flattenIntoArray;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "is-array.js": function module(_require64, _exports50, _module63) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/is-array.js                            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var classof = _require64('../internals/classof-raw');

                  // `IsArray` abstract operation
                  // https://tc39.es/ecma262/#sec-isarray
                  // eslint-disable-next-line es/no-array-isarray -- safe
                  _module63.exports = Array.isArray || function isArray(arg) {
                    return classof(arg) == 'Array';
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "function-bind-context.js": function module(_require65, _exports51, _module64) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/function-bind-context.js               //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var aFunction = _require65('../internals/a-function');

                  // optional / simple context binding
                  _module64.exports = function (fn, that, length) {
                    aFunction(fn);
                    if (that === undefined) return fn;
                    switch (length) {
                      case 0:
                        return function () {
                          return fn.call(that);
                        };
                      case 1:
                        return function (a) {
                          return fn.call(that, a);
                        };
                      case 2:
                        return function (a, b) {
                          return fn.call(that, a, b);
                        };
                      case 3:
                        return function (a, b, c) {
                          return fn.call(that, a, b, c);
                        };
                    }
                    return function () /* ...args */{
                      return fn.apply(that, arguments);
                    };
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "a-function.js": function module(_require66, _exports52, _module65) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/a-function.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module65.exports = function (it) {
                    if (typeof it != 'function') {
                      throw TypeError(String(it) + ' is not a function');
                    }return it;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "array-species-create.js": function module(_require67, _exports53, _module66) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/array-species-create.js                //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var isObject = _require67('../internals/is-object');
                  var isArray = _require67('../internals/is-array');
                  var wellKnownSymbol = _require67('../internals/well-known-symbol');

                  var SPECIES = wellKnownSymbol('species');

                  // `ArraySpeciesCreate` abstract operation
                  // https://tc39.es/ecma262/#sec-arrayspeciescreate
                  _module66.exports = function (originalArray, length) {
                    var C;
                    if (isArray(originalArray)) {
                      C = originalArray.constructor;
                      // cross-realm fallback
                      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
                        C = C[SPECIES];
                        if (C === null) C = undefined;
                      }
                    }return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "well-known-symbol.js": function module(_require68, _exports54, _module67) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/well-known-symbol.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require68('../internals/global');
                  var shared = _require68('../internals/shared');
                  var has = _require68('../internals/has');
                  var uid = _require68('../internals/uid');
                  var NATIVE_SYMBOL = _require68('../internals/native-symbol');
                  var USE_SYMBOL_AS_UID = _require68('../internals/use-symbol-as-uid');

                  var WellKnownSymbolsStore = shared('wks');
                  var Symbol = global.Symbol;
                  var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

                  _module67.exports = function (name) {
                    if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
                      if (NATIVE_SYMBOL && has(Symbol, name)) {
                        WellKnownSymbolsStore[name] = Symbol[name];
                      } else {
                        WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
                      }
                    }return WellKnownSymbolsStore[name];
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "native-symbol.js": function module(_require69, _exports55, _module68) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/native-symbol.js                       //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  /* eslint-disable es/no-symbol -- required for testing */
                  var V8_VERSION = _require69('../internals/engine-v8-version');
                  var fails = _require69('../internals/fails');

                  // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
                  _module68.exports = !!Object.getOwnPropertySymbols && !fails(function () {
                    var symbol = Symbol();
                    // Chrome 38 Symbol has incorrect toString conversion
                    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
                    return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
                    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                  });

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "engine-v8-version.js": function module(_require70, _exports56, _module69) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/engine-v8-version.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var global = _require70('../internals/global');
                  var userAgent = _require70('../internals/engine-user-agent');

                  var process = global.process;
                  var versions = process && process.versions;
                  var v8 = versions && versions.v8;
                  var match, version;

                  if (v8) {
                    match = v8.split('.');
                    version = match[0] < 4 ? 1 : match[0] + match[1];
                  } else if (userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                      match = userAgent.match(/Chrome\/(\d+)/);
                      if (match) version = match[1];
                    }
                  }

                  _module69.exports = version && +version;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "engine-user-agent.js": function module(_require71, _exports57, _module70) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/engine-user-agent.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var getBuiltIn = _require71('../internals/get-built-in');

                  _module70.exports = getBuiltIn('navigator', 'userAgent') || '';

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "use-symbol-as-uid.js": function module(_require72, _exports58, _module71) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/use-symbol-as-uid.js                   //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  /* eslint-disable es/no-symbol -- required for testing */
                  var NATIVE_SYMBOL = _require72('../internals/native-symbol');

                  _module71.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "iterate.js": function module(_require73, _exports59, _module72) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/iterate.js                             //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var anObject = _require73('../internals/an-object');
                  var isArrayIteratorMethod = _require73('../internals/is-array-iterator-method');
                  var toLength = _require73('../internals/to-length');
                  var bind = _require73('../internals/function-bind-context');
                  var getIteratorMethod = _require73('../internals/get-iterator-method');
                  var iteratorClose = _require73('../internals/iterator-close');

                  var Result = function (stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                  };

                  _module72.exports = function (iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
                    var iterator, iterFn, index, length, result, next, step;

                    var stop = function (condition) {
                      if (iterator) iteratorClose(iterator);
                      return new Result(true, condition);
                    };

                    var callFn = function (value) {
                      if (AS_ENTRIES) {
                        anObject(value);
                        return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                      }return INTERRUPTED ? fn(value, stop) : fn(value);
                    };

                    if (IS_ITERATOR) {
                      iterator = iterable;
                    } else {
                      iterFn = getIteratorMethod(iterable);
                      if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
                      // optimisation for array iterators
                      if (isArrayIteratorMethod(iterFn)) {
                        for (index = 0, length = toLength(iterable.length); length > index; index++) {
                          result = callFn(iterable[index]);
                          if (result && result instanceof Result) return result;
                        }return new Result(false);
                      }
                      iterator = iterFn.call(iterable);
                    }

                    next = iterator.next;
                    while (!(step = next.call(iterator)).done) {
                      try {
                        result = callFn(step.value);
                      } catch (error) {
                        iteratorClose(iterator);
                        throw error;
                      }
                      if (typeof result == 'object' && result && result instanceof Result) return result;
                    }return new Result(false);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "is-array-iterator-method.js": function module(_require74, _exports60, _module73) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/is-array-iterator-method.js            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var wellKnownSymbol = _require74('../internals/well-known-symbol');
                  var Iterators = _require74('../internals/iterators');

                  var ITERATOR = wellKnownSymbol('iterator');
                  var ArrayPrototype = Array.prototype;

                  // check on default Array iterator
                  _module73.exports = function (it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "iterators.js": function module(_require75, _exports61, _module74) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/iterators.js                           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  _module74.exports = {};

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "get-iterator-method.js": function module(_require76, _exports62, _module75) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/get-iterator-method.js                 //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var classof = _require76('../internals/classof');
                  var Iterators = _require76('../internals/iterators');
                  var wellKnownSymbol = _require76('../internals/well-known-symbol');

                  var ITERATOR = wellKnownSymbol('iterator');

                  _module75.exports = function (it) {
                    if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "classof.js": function module(_require77, _exports63, _module76) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/classof.js                             //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var TO_STRING_TAG_SUPPORT = _require77('../internals/to-string-tag-support');
                  var classofRaw = _require77('../internals/classof-raw');
                  var wellKnownSymbol = _require77('../internals/well-known-symbol');

                  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                  // ES3 wrong here
                  var CORRECT_ARGUMENTS = classofRaw(function () {
                    return arguments;
                  }()) == 'Arguments';

                  // fallback for IE11 Script Access Denied error
                  var tryGet = function (it, key) {
                    try {
                      return it[key];
                    } catch (error) {/* empty */}
                  };

                  // getting tag from ES6+ `Object.prototype.toString`
                  _module76.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
                    var O, tag, result;
                    return it === undefined ? 'Undefined' : it === null ? 'Null'
                    // @@toStringTag case
                    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
                    // builtinTag case
                    : CORRECT_ARGUMENTS ? classofRaw(O)
                    // ES3 arguments fallback
                    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "to-string-tag-support.js": function module(_require78, _exports64, _module77) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/to-string-tag-support.js               //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var wellKnownSymbol = _require78('../internals/well-known-symbol');

                  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                  var test = {};

                  test[TO_STRING_TAG] = 'z';

                  _module77.exports = String(test) === '[object z]';

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "iterator-close.js": function module(_require79, _exports65, _module78) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/iterator-close.js                      //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var anObject = _require79('../internals/an-object');

                  _module78.exports = function (iterator) {
                    var returnMethod = iterator['return'];
                    if (returnMethod !== undefined) {
                      return anObject(returnMethod.call(iterator)).value;
                    }
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "string-pad.js": function module(_require80, _exports66, _module79) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/string-pad.js                          //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // https://github.com/tc39/proposal-string-pad-start-end
                  var toLength = _require80('../internals/to-length');
                  var repeat = _require80('../internals/string-repeat');
                  var requireObjectCoercible = _require80('../internals/require-object-coercible');

                  var ceil = Math.ceil;

                  // `String.prototype.{ padStart, padEnd }` methods implementation
                  var createMethod = function (IS_END) {
                    return function ($this, maxLength, fillString) {
                      var S = String(requireObjectCoercible($this));
                      var stringLength = S.length;
                      var fillStr = fillString === undefined ? ' ' : String(fillString);
                      var intMaxLength = toLength(maxLength);
                      var fillLen, stringFiller;
                      if (intMaxLength <= stringLength || fillStr == '') return S;
                      fillLen = intMaxLength - stringLength;
                      stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
                      if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
                      return IS_END ? S + stringFiller : stringFiller + S;
                    };
                  };

                  _module79.exports = {
                    // `String.prototype.padStart` method
                    // https://tc39.es/ecma262/#sec-string.prototype.padstart
                    start: createMethod(false),
                    // `String.prototype.padEnd` method
                    // https://tc39.es/ecma262/#sec-string.prototype.padend
                    end: createMethod(true)
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "string-repeat.js": function module(_require81, _exports67, _module80) {
                  var toInteger = _require81('../internals/to-integer');
                  var requireObjectCoercible = _require81('../internals/require-object-coercible');

                  // `String.prototype.repeat` method implementation
                  // https://tc39.es/ecma262/#sec-string.prototype.repeat
                  _module80.exports = function repeat(count) {
                    var str = String(requireObjectCoercible(this));
                    var result = '';
                    var n = toInteger(count);
                    if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
                    for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
                    return result;
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "string-pad-webkit-bug.js": function module(_require82, _exports68, _module81) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/string-pad-webkit-bug.js               //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // https://github.com/zloirock/core-js/issues/280
                  var userAgent = _require82('../internals/engine-user-agent');

                  // eslint-disable-next-line unicorn/no-unsafe-regex -- safe
                  _module81.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "string-trim.js": function module(_require83, _exports69, _module82) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/string-trim.js                         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var requireObjectCoercible = _require83('../internals/require-object-coercible');
                  var whitespaces = _require83('../internals/whitespaces');

                  var whitespace = '[' + whitespaces + ']';
                  var ltrim = RegExp('^' + whitespace + whitespace + '*');
                  var rtrim = RegExp(whitespace + whitespace + '*$');

                  // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
                  var createMethod = function (TYPE) {
                    return function ($this) {
                      var string = String(requireObjectCoercible($this));
                      if (TYPE & 1) string = string.replace(ltrim, '');
                      if (TYPE & 2) string = string.replace(rtrim, '');
                      return string;
                    };
                  };

                  _module82.exports = {
                    // `String.prototype.{ trimLeft, trimStart }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                    start: createMethod(1),
                    // `String.prototype.{ trimRight, trimEnd }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimend
                    end: createMethod(2),
                    // `String.prototype.trim` method
                    // https://tc39.es/ecma262/#sec-string.prototype.trim
                    trim: createMethod(3)
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "whitespaces.js": function module(_require84, _exports70, _module83) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/whitespaces.js                         //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  // a string of all valid unicode whitespaces
                  _module83.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "string-trim-forced.js": function module(_require85, _exports71, _module84) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/string-trim-forced.js                  //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var fails = _require85('../internals/fails');
                  var whitespaces = _require85('../internals/whitespaces');

                  var non = '\u200B\u0085\u180E';

                  // check that a method works with the correct list
                  // of whitespaces and has a correct name
                  _module84.exports = function (METHOD_NAME) {
                    return fails(function () {
                      return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
                    });
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "define-well-known-symbol.js": function module(_require86, _exports72, _module85) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/define-well-known-symbol.js            //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var path = _require86('../internals/path');
                  var has = _require86('../internals/has');
                  var wrappedWellKnownSymbolModule = _require86('../internals/well-known-symbol-wrapped');
                  var defineProperty = _require86('../internals/object-define-property').f;

                  _module85.exports = function (NAME) {
                    var Symbol = path.Symbol || (path.Symbol = {});
                    if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
                      value: wrappedWellKnownSymbolModule.f(NAME)
                    });
                  };

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "well-known-symbol-wrapped.js": function _module86(_require87, _exports73) {

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                     //
                  // node_modules/meteor/ecmascript-runtime-client/node_modules/core-js/internals/well-known-symbol-wrapped.js           //
                  //                                                                                                                     //
                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  var wellKnownSymbol = _require87('../internals/well-known-symbol');

                  _exports73.f = wellKnownSymbol;

                  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                } } } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports = _require2("/node_modules/meteor/ecmascript-runtime-client/modern.js");

  /* Exports */
  Package._define("ecmascript-runtime-client", _exports);
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Base64;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "base64": { "base64.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                        //
            // packages/base64/base64.js                                                              //
            //                                                                                        //
            ////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Base64: () => Base64
            });
            // Base 64 encoding
            const BASE_64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            const BASE_64_VALS = Object.create(null);

            const getChar = val => BASE_64_CHARS.charAt(val);

            const getVal = ch => ch === '=' ? -1 : BASE_64_VALS[ch];

            for (let i = 0; i < BASE_64_CHARS.length; i++) {
              BASE_64_VALS[getChar(i)] = i;
            }

            ;

            const encode = array => {
              if (typeof array === "string") {
                const str = array;
                array = newBinary(str.length);

                for (let i = 0; i < str.length; i++) {
                  const ch = str.charCodeAt(i);

                  if (ch > 0xFF) {
                    throw new Error("Not ascii. Base64.encode can only take ascii strings.");
                  }

                  array[i] = ch;
                }
              }

              const answer = [];
              let a = null;
              let b = null;
              let c = null;
              let d = null;

              for (let i = 0; i < array.length; i++) {
                switch (i % 3) {
                  case 0:
                    a = array[i] >> 2 & 0x3F;
                    b = (array[i] & 0x03) << 4;
                    break;

                  case 1:
                    b = b | array[i] >> 4 & 0xF;
                    c = (array[i] & 0xF) << 2;
                    break;

                  case 2:
                    c = c | array[i] >> 6 & 0x03;
                    d = array[i] & 0x3F;
                    answer.push(getChar(a));
                    answer.push(getChar(b));
                    answer.push(getChar(c));
                    answer.push(getChar(d));
                    a = null;
                    b = null;
                    c = null;
                    d = null;
                    break;
                }
              }

              if (a != null) {
                answer.push(getChar(a));
                answer.push(getChar(b));

                if (c == null) {
                  answer.push('=');
                } else {
                  answer.push(getChar(c));
                }

                if (d == null) {
                  answer.push('=');
                }
              }

              return answer.join("");
            }; // XXX This is a weird place for this to live, but it's used both by
            // this package and 'ejson', and we can't put it in 'ejson' without
            // introducing a circular dependency. It should probably be in its own
            // package or as a helper in a package that both 'base64' and 'ejson'
            // use.


            const newBinary = len => {
              if (typeof Uint8Array === 'undefined' || typeof ArrayBuffer === 'undefined') {
                const ret = [];

                for (let i = 0; i < len; i++) {
                  ret.push(0);
                }

                ret.$Uint8ArrayPolyfill = true;
                return ret;
              }

              return new Uint8Array(new ArrayBuffer(len));
            };

            const decode = str => {
              let len = Math.floor(str.length * 3 / 4);

              if (str.charAt(str.length - 1) == '=') {
                len--;

                if (str.charAt(str.length - 2) == '=') {
                  len--;
                }
              }

              const arr = newBinary(len);
              let one = null;
              let two = null;
              let three = null;
              let j = 0;

              for (let i = 0; i < str.length; i++) {
                const c = str.charAt(i);
                const v = getVal(c);

                switch (i % 4) {
                  case 0:
                    if (v < 0) {
                      throw new Error('invalid base64 string');
                    }

                    one = v << 2;
                    break;

                  case 1:
                    if (v < 0) {
                      throw new Error('invalid base64 string');
                    }

                    one = one | v >> 4;
                    arr[j++] = one;
                    two = (v & 0x0F) << 4;
                    break;

                  case 2:
                    if (v >= 0) {
                      two = two | v >> 2;
                      arr[j++] = two;
                      three = (v & 0x03) << 6;
                    }

                    break;

                  case 3:
                    if (v >= 0) {
                      arr[j++] = three | v;
                    }

                    break;
                }
              }

              return arr;
            };

            const Base64 = {
              encode,
              decode,
              newBinary
            };
            ////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/base64/base64.js");

  /* Exports */
  Package._define("base64", _exports2, {
    Base64: Base64
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Base64 = Package.base64.Base64;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var EJSON;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "ejson": { "ejson.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                             //
            // packages/ejson/ejson.js                                                                                     //
            //                                                                                                             //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              EJSON: () => EJSON
            });
            let isFunction, isObject, keysOf, lengthOf, hasOwn, convertMapToObject, isArguments, isInfOrNaN, handleError;
            _module.link("./utils", {
              isFunction(v) {
                isFunction = v;
              },

              isObject(v) {
                isObject = v;
              },

              keysOf(v) {
                keysOf = v;
              },

              lengthOf(v) {
                lengthOf = v;
              },

              hasOwn(v) {
                hasOwn = v;
              },

              convertMapToObject(v) {
                convertMapToObject = v;
              },

              isArguments(v) {
                isArguments = v;
              },

              isInfOrNaN(v) {
                isInfOrNaN = v;
              },

              handleError(v) {
                handleError = v;
              }

            }, 0);

            /**
             * @namespace
             * @summary Namespace for EJSON functions
             */
            const EJSON = {}; // Custom type interface definition

            /**
             * @class CustomType
             * @instanceName customType
             * @memberOf EJSON
             * @summary The interface that a class must satisfy to be able to become an
             * EJSON custom type via EJSON.addType.
             */

            /**
             * @function typeName
             * @memberOf EJSON.CustomType
             * @summary Return the tag used to identify this type.  This must match the
             *          tag used to register this type with
             *          [`EJSON.addType`](#ejson_add_type).
             * @locus Anywhere
             * @instance
             */

            /**
             * @function toJSONValue
             * @memberOf EJSON.CustomType
             * @summary Serialize this instance into a JSON-compatible value.
             * @locus Anywhere
             * @instance
             */

            /**
             * @function clone
             * @memberOf EJSON.CustomType
             * @summary Return a value `r` such that `this.equals(r)` is true, and
             *          modifications to `r` do not affect `this` and vice versa.
             * @locus Anywhere
             * @instance
             */

            /**
             * @function equals
             * @memberOf EJSON.CustomType
             * @summary Return `true` if `other` has a value equal to `this`; `false`
             *          otherwise.
             * @locus Anywhere
             * @param {Object} other Another object to compare this to.
             * @instance
             */

            const customTypes = new Map(); // Add a custom type, using a method of your choice to get to and
            // from a basic JSON-able representation.  The factory argument
            // is a function of JSON-able --> your object
            // The type you add must have:
            // - A toJSONValue() method, so that Meteor can serialize it
            // - a typeName() method, to show how to look it up in our type table.
            // It is okay if these methods are monkey-patched on.
            // EJSON.clone will use toJSONValue and the given factory to produce
            // a clone, but you may specify a method clone() that will be
            // used instead.
            // Similarly, EJSON.equals will use toJSONValue to make comparisons,
            // but you may provide a method equals() instead.

            /**
             * @summary Add a custom datatype to EJSON.
             * @locus Anywhere
             * @param {String} name A tag for your custom type; must be unique among
             *                      custom data types defined in your project, and must
             *                      match the result of your type's `typeName` method.
             * @param {Function} factory A function that deserializes a JSON-compatible
             *                           value into an instance of your type.  This should
             *                           match the serialization performed by your
             *                           type's `toJSONValue` method.
             */

            EJSON.addType = (name, factory) => {
              if (customTypes.has(name)) {
                throw new Error("Type ".concat(name, " already present"));
              }

              customTypes.set(name, factory);
            };

            const builtinConverters = [{
              // Date
              matchJSONValue(obj) {
                return hasOwn(obj, '$date') && lengthOf(obj) === 1;
              },

              matchObject(obj) {
                return obj instanceof Date;
              },

              toJSONValue(obj) {
                return {
                  $date: obj.getTime()
                };
              },

              fromJSONValue(obj) {
                return new Date(obj.$date);
              }

            }, {
              // RegExp
              matchJSONValue(obj) {
                return hasOwn(obj, '$regexp') && hasOwn(obj, '$flags') && lengthOf(obj) === 2;
              },

              matchObject(obj) {
                return obj instanceof RegExp;
              },

              toJSONValue(regexp) {
                return {
                  $regexp: regexp.source,
                  $flags: regexp.flags
                };
              },

              fromJSONValue(obj) {
                // Replaces duplicate / invalid flags.
                return new RegExp(obj.$regexp, obj.$flags // Cut off flags at 50 chars to avoid abusing RegExp for DOS.
                .slice(0, 50).replace(/[^gimuy]/g, '').replace(/(.)(?=.*\1)/g, ''));
              }

            }, {
              // NaN, Inf, -Inf. (These are the only objects with typeof !== 'object'
              // which we match.)
              matchJSONValue(obj) {
                return hasOwn(obj, '$InfNaN') && lengthOf(obj) === 1;
              },

              matchObject: isInfOrNaN,

              toJSONValue(obj) {
                let sign;

                if (Number.isNaN(obj)) {
                  sign = 0;
                } else if (obj === Infinity) {
                  sign = 1;
                } else {
                  sign = -1;
                }

                return {
                  $InfNaN: sign
                };
              },

              fromJSONValue(obj) {
                return obj.$InfNaN / 0;
              }

            }, {
              // Binary
              matchJSONValue(obj) {
                return hasOwn(obj, '$binary') && lengthOf(obj) === 1;
              },

              matchObject(obj) {
                return typeof Uint8Array !== 'undefined' && obj instanceof Uint8Array || obj && hasOwn(obj, '$Uint8ArrayPolyfill');
              },

              toJSONValue(obj) {
                return {
                  $binary: Base64.encode(obj)
                };
              },

              fromJSONValue(obj) {
                return Base64.decode(obj.$binary);
              }

            }, {
              // Escaping one level
              matchJSONValue(obj) {
                return hasOwn(obj, '$escape') && lengthOf(obj) === 1;
              },

              matchObject(obj) {
                let match = false;

                if (obj) {
                  const keyCount = lengthOf(obj);

                  if (keyCount === 1 || keyCount === 2) {
                    match = builtinConverters.some(converter => converter.matchJSONValue(obj));
                  }
                }

                return match;
              },

              toJSONValue(obj) {
                const newObj = {};
                keysOf(obj).forEach(key => {
                  newObj[key] = EJSON.toJSONValue(obj[key]);
                });
                return {
                  $escape: newObj
                };
              },

              fromJSONValue(obj) {
                const newObj = {};
                keysOf(obj.$escape).forEach(key => {
                  newObj[key] = EJSON.fromJSONValue(obj.$escape[key]);
                });
                return newObj;
              }

            }, {
              // Custom
              matchJSONValue(obj) {
                return hasOwn(obj, '$type') && hasOwn(obj, '$value') && lengthOf(obj) === 2;
              },

              matchObject(obj) {
                return EJSON._isCustomType(obj);
              },

              toJSONValue(obj) {
                const jsonValue = Meteor._noYieldsAllowed(() => obj.toJSONValue());

                return {
                  $type: obj.typeName(),
                  $value: jsonValue
                };
              },

              fromJSONValue(obj) {
                const typeName = obj.$type;

                if (!customTypes.has(typeName)) {
                  throw new Error("Custom EJSON type ".concat(typeName, " is not defined"));
                }

                const converter = customTypes.get(typeName);
                return Meteor._noYieldsAllowed(() => converter(obj.$value));
              }

            }];

            EJSON._isCustomType = obj => obj && isFunction(obj.toJSONValue) && isFunction(obj.typeName) && customTypes.has(obj.typeName());

            EJSON._getTypes = function () {
              let isOriginal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              return isOriginal ? customTypes : convertMapToObject(customTypes);
            };

            EJSON._getConverters = () => builtinConverters; // Either return the JSON-compatible version of the argument, or undefined (if
            // the item isn't itself replaceable, but maybe some fields in it are)


            const toJSONValueHelper = item => {
              for (let i = 0; i < builtinConverters.length; i++) {
                const converter = builtinConverters[i];

                if (converter.matchObject(item)) {
                  return converter.toJSONValue(item);
                }
              }

              return undefined;
            }; // for both arrays and objects, in-place modification.


            const adjustTypesToJSONValue = obj => {
              // Is it an atom that we need to adjust?
              if (obj === null) {
                return null;
              }

              const maybeChanged = toJSONValueHelper(obj);

              if (maybeChanged !== undefined) {
                return maybeChanged;
              } // Other atoms are unchanged.


              if (!isObject(obj)) {
                return obj;
              } // Iterate over array or object structure.


              keysOf(obj).forEach(key => {
                const value = obj[key];

                if (!isObject(value) && value !== undefined && !isInfOrNaN(value)) {
                  return; // continue
                }

                const changed = toJSONValueHelper(value);

                if (changed) {
                  obj[key] = changed;
                  return; // on to the next key
                } // if we get here, value is an object but not adjustable
                // at this level.  recurse.


                adjustTypesToJSONValue(value);
              });
              return obj;
            };

            EJSON._adjustTypesToJSONValue = adjustTypesToJSONValue;
            /**
             * @summary Serialize an EJSON-compatible value into its plain JSON
             *          representation.
             * @locus Anywhere
             * @param {EJSON} val A value to serialize to plain JSON.
             */

            EJSON.toJSONValue = item => {
              const changed = toJSONValueHelper(item);

              if (changed !== undefined) {
                return changed;
              }

              let newItem = item;

              if (isObject(item)) {
                newItem = EJSON.clone(item);
                adjustTypesToJSONValue(newItem);
              }

              return newItem;
            }; // Either return the argument changed to have the non-json
            // rep of itself (the Object version) or the argument itself.
            // DOES NOT RECURSE.  For actually getting the fully-changed value, use
            // EJSON.fromJSONValue


            const fromJSONValueHelper = value => {
              if (isObject(value) && value !== null) {
                const keys = keysOf(value);

                if (keys.length <= 2 && keys.every(k => typeof k === 'string' && k.substr(0, 1) === '$')) {
                  for (let i = 0; i < builtinConverters.length; i++) {
                    const converter = builtinConverters[i];

                    if (converter.matchJSONValue(value)) {
                      return converter.fromJSONValue(value);
                    }
                  }
                }
              }

              return value;
            }; // for both arrays and objects. Tries its best to just
            // use the object you hand it, but may return something
            // different if the object you hand it itself needs changing.


            const adjustTypesFromJSONValue = obj => {
              if (obj === null) {
                return null;
              }

              const maybeChanged = fromJSONValueHelper(obj);

              if (maybeChanged !== obj) {
                return maybeChanged;
              } // Other atoms are unchanged.


              if (!isObject(obj)) {
                return obj;
              }

              keysOf(obj).forEach(key => {
                const value = obj[key];

                if (isObject(value)) {
                  const changed = fromJSONValueHelper(value);

                  if (value !== changed) {
                    obj[key] = changed;
                    return;
                  } // if we get here, value is an object but not adjustable
                  // at this level.  recurse.


                  adjustTypesFromJSONValue(value);
                }
              });
              return obj;
            };

            EJSON._adjustTypesFromJSONValue = adjustTypesFromJSONValue;
            /**
             * @summary Deserialize an EJSON value from its plain JSON representation.
             * @locus Anywhere
             * @param {JSONCompatible} val A value to deserialize into EJSON.
             */

            EJSON.fromJSONValue = item => {
              let changed = fromJSONValueHelper(item);

              if (changed === item && isObject(item)) {
                changed = EJSON.clone(item);
                adjustTypesFromJSONValue(changed);
              }

              return changed;
            };
            /**
             * @summary Serialize a value to a string. For EJSON values, the serialization
             *          fully represents the value. For non-EJSON values, serializes the
             *          same way as `JSON.stringify`.
             * @locus Anywhere
             * @param {EJSON} val A value to stringify.
             * @param {Object} [options]
             * @param {Boolean | Integer | String} options.indent Indents objects and
             * arrays for easy readability.  When `true`, indents by 2 spaces; when an
             * integer, indents by that number of spaces; and when a string, uses the
             * string as the indentation pattern.
             * @param {Boolean} options.canonical When `true`, stringifies keys in an
             *                                    object in sorted order.
             */

            EJSON.stringify = handleError((item, options) => {
              let serialized;
              const json = EJSON.toJSONValue(item);

              if (options && (options.canonical || options.indent)) {
                let canonicalStringify;
                _module.link("./stringify", {
                  default(v) {
                    canonicalStringify = v;
                  }

                }, 1);
                serialized = canonicalStringify(json, options);
              } else {
                serialized = JSON.stringify(json);
              }

              return serialized;
            });
            /**
             * @summary Parse a string into an EJSON value. Throws an error if the string
             *          is not valid EJSON.
             * @locus Anywhere
             * @param {String} str A string to parse into an EJSON value.
             */

            EJSON.parse = item => {
              if (typeof item !== 'string') {
                throw new Error('EJSON.parse argument should be a string');
              }

              return EJSON.fromJSONValue(JSON.parse(item));
            };
            /**
             * @summary Returns true if `x` is a buffer of binary data, as returned from
             *          [`EJSON.newBinary`](#ejson_new_binary).
             * @param {Object} x The variable to check.
             * @locus Anywhere
             */

            EJSON.isBinary = obj => {
              return !!(typeof Uint8Array !== 'undefined' && obj instanceof Uint8Array || obj && obj.$Uint8ArrayPolyfill);
            };
            /**
             * @summary Return true if `a` and `b` are equal to each other.  Return false
             *          otherwise.  Uses the `equals` method on `a` if present, otherwise
             *          performs a deep comparison.
             * @locus Anywhere
             * @param {EJSON} a
             * @param {EJSON} b
             * @param {Object} [options]
             * @param {Boolean} options.keyOrderSensitive Compare in key sensitive order,
             * if supported by the JavaScript implementation.  For example, `{a: 1, b: 2}`
             * is equal to `{b: 2, a: 1}` only when `keyOrderSensitive` is `false`.  The
             * default is `false`.
             */

            EJSON.equals = (a, b, options) => {
              let i;
              const keyOrderSensitive = !!(options && options.keyOrderSensitive);

              if (a === b) {
                return true;
              } // This differs from the IEEE spec for NaN equality, b/c we don't want
              // anything ever with a NaN to be poisoned from becoming equal to anything.


              if (Number.isNaN(a) && Number.isNaN(b)) {
                return true;
              } // if either one is falsy, they'd have to be === to be equal


              if (!a || !b) {
                return false;
              }

              if (!(isObject(a) && isObject(b))) {
                return false;
              }

              if (a instanceof Date && b instanceof Date) {
                return a.valueOf() === b.valueOf();
              }

              if (EJSON.isBinary(a) && EJSON.isBinary(b)) {
                if (a.length !== b.length) {
                  return false;
                }

                for (i = 0; i < a.length; i++) {
                  if (a[i] !== b[i]) {
                    return false;
                  }
                }

                return true;
              }

              if (isFunction(a.equals)) {
                return a.equals(b, options);
              }

              if (isFunction(b.equals)) {
                return b.equals(a, options);
              }

              if (a instanceof Array) {
                if (!(b instanceof Array)) {
                  return false;
                }

                if (a.length !== b.length) {
                  return false;
                }

                for (i = 0; i < a.length; i++) {
                  if (!EJSON.equals(a[i], b[i], options)) {
                    return false;
                  }
                }

                return true;
              } // fallback for custom types that don't implement their own equals


              switch (EJSON._isCustomType(a) + EJSON._isCustomType(b)) {
                case 1:
                  return false;

                case 2:
                  return EJSON.equals(EJSON.toJSONValue(a), EJSON.toJSONValue(b));

                default: // Do nothing

              } // fall back to structural equality of objects


              let ret;
              const aKeys = keysOf(a);
              const bKeys = keysOf(b);

              if (keyOrderSensitive) {
                i = 0;
                ret = aKeys.every(key => {
                  if (i >= bKeys.length) {
                    return false;
                  }

                  if (key !== bKeys[i]) {
                    return false;
                  }

                  if (!EJSON.equals(a[key], b[bKeys[i]], options)) {
                    return false;
                  }

                  i++;
                  return true;
                });
              } else {
                i = 0;
                ret = aKeys.every(key => {
                  if (!hasOwn(b, key)) {
                    return false;
                  }

                  if (!EJSON.equals(a[key], b[key], options)) {
                    return false;
                  }

                  i++;
                  return true;
                });
              }

              return ret && i === bKeys.length;
            };
            /**
             * @summary Return a deep copy of `val`.
             * @locus Anywhere
             * @param {EJSON} val A value to copy.
             */

            EJSON.clone = v => {
              let ret;

              if (!isObject(v)) {
                return v;
              }

              if (v === null) {
                return null; // null has typeof "object"
              }

              if (v instanceof Date) {
                return new Date(v.getTime());
              } // RegExps are not really EJSON elements (eg we don't define a serialization
              // for them), but they're immutable anyway, so we can support them in clone.


              if (v instanceof RegExp) {
                return v;
              }

              if (EJSON.isBinary(v)) {
                ret = EJSON.newBinary(v.length);

                for (let i = 0; i < v.length; i++) {
                  ret[i] = v[i];
                }

                return ret;
              }

              if (Array.isArray(v)) {
                return v.map(EJSON.clone);
              }

              if (isArguments(v)) {
                return Array.from(v).map(EJSON.clone);
              } // handle general user-defined typed Objects if they have a clone method


              if (isFunction(v.clone)) {
                return v.clone();
              } // handle other custom types


              if (EJSON._isCustomType(v)) {
                return EJSON.fromJSONValue(EJSON.clone(EJSON.toJSONValue(v)), true);
              } // handle other objects


              ret = {};
              keysOf(v).forEach(key => {
                ret[key] = EJSON.clone(v[key]);
              });
              return ret;
            };
            /**
             * @summary Allocate a new buffer of binary data that EJSON can serialize.
             * @locus Anywhere
             * @param {Number} size The number of bytes of binary data to allocate.
             */
            // EJSON.newBinary is the public documented API for this functionality,
            // but the implementation is in the 'base64' package to avoid
            // introducing a circular dependency. (If the implementation were here,
            // then 'base64' would have to use EJSON.newBinary, and 'ejson' would
            // also have to use 'base64'.)


            EJSON.newBinary = Base64.newBinary;
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "stringify.js": function module(_require3, _exports3, _module2) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                             //
            // packages/ejson/stringify.js                                                                                 //
            //                                                                                                             //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // Based on json2.js from https://github.com/douglascrockford/JSON-js
            //
            //    json2.js
            //    2012-10-08
            //
            //    Public Domain.
            //
            //    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
            function quote(string) {
              return JSON.stringify(string);
            }

            const str = (key, holder, singleIndent, outerIndent, canonical) => {
              const value = holder[key]; // What happens next depends on the value's type.

              switch (typeof value) {
                case 'string':
                  return quote(value);

                case 'number':
                  // JSON numbers must be finite. Encode non-finite numbers as null.
                  return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                  return String(value);
                // If the type is 'object', we might be dealing with an object or an array or
                // null.

                case 'object':
                  {
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                      return 'null';
                    } // Make an array to hold the partial results of stringifying this object
                    // value.


                    const innerIndent = outerIndent + singleIndent;
                    const partial = [];
                    let v; // Is the value an array?

                    if (Array.isArray(value) || {}.hasOwnProperty.call(value, 'callee')) {
                      // The value is an array. Stringify every element. Use null as a
                      // placeholder for non-JSON values.
                      const length = value.length;

                      for (let i = 0; i < length; i += 1) {
                        partial[i] = str(i, value, singleIndent, innerIndent, canonical) || 'null';
                      } // Join all of the elements together, separated with commas, and wrap
                      // them in brackets.


                      if (partial.length === 0) {
                        v = '[]';
                      } else if (innerIndent) {
                        v = '[\n' + innerIndent + partial.join(',\n' + innerIndent) + '\n' + outerIndent + ']';
                      } else {
                        v = '[' + partial.join(',') + ']';
                      }

                      return v;
                    } // Iterate through all of the keys in the object.


                    let keys = Object.keys(value);

                    if (canonical) {
                      keys = keys.sort();
                    }

                    keys.forEach(k => {
                      v = str(k, value, singleIndent, innerIndent, canonical);

                      if (v) {
                        partial.push(quote(k) + (innerIndent ? ': ' : ':') + v);
                      }
                    }); // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.

                    if (partial.length === 0) {
                      v = '{}';
                    } else if (innerIndent) {
                      v = '{\n' + innerIndent + partial.join(',\n' + innerIndent) + '\n' + outerIndent + '}';
                    } else {
                      v = '{' + partial.join(',') + '}';
                    }

                    return v;
                  }

                default: // Do nothing

              }
            }; // If the JSON object does not yet have a stringify method, give it one.


            const canonicalStringify = (value, options) => {
              // Make a fake root object containing our value under the key of ''.
              // Return the result of stringifying the value.
              const allOptions = Object.assign({
                indent: '',
                canonical: false
              }, options);

              if (allOptions.indent === true) {
                allOptions.indent = '  ';
              } else if (typeof allOptions.indent === 'number') {
                let newIndent = '';

                for (let i = 0; i < allOptions.indent; i++) {
                  newIndent += ' ';
                }

                allOptions.indent = newIndent;
              }

              return str('', {
                '': value
              }, allOptions.indent, '', allOptions.canonical);
            };

            _module2.exportDefault(canonicalStringify);
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "utils.js": function module(_require4, _exports4, _module3) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                             //
            // packages/ejson/utils.js                                                                                     //
            //                                                                                                             //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module3.export({
              isFunction: () => isFunction,
              isObject: () => isObject,
              keysOf: () => keysOf,
              lengthOf: () => lengthOf,
              hasOwn: () => hasOwn,
              convertMapToObject: () => convertMapToObject,
              isArguments: () => isArguments,
              isInfOrNaN: () => isInfOrNaN,
              checkError: () => checkError,
              handleError: () => handleError
            });

            const isFunction = fn => typeof fn === 'function';

            const isObject = fn => typeof fn === 'object';

            const keysOf = obj => Object.keys(obj);

            const lengthOf = obj => Object.keys(obj).length;

            const hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

            const convertMapToObject = map => Array.from(map).reduce((acc, _ref) => {
              let [key, value] = _ref;
              // reassign to not create new object
              acc[key] = value;
              return acc;
            }, {});

            const isArguments = obj => obj != null && hasOwn(obj, 'callee');

            const isInfOrNaN = obj => Number.isNaN(obj) || obj === Infinity || obj === -Infinity;

            const checkError = {
              maxStack: msgError => new RegExp('Maximum call stack size exceeded', 'g').test(msgError)
            };

            const handleError = fn => function () {
              try {
                return fn.apply(this, arguments);
              } catch (error) {
                const isMaxStack = checkError.maxStack(error.message);

                if (isMaxStack) {
                  throw new Error('Converting circular structure to JSON');
                }

                throw error;
              }
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/ejson/ejson.js");

  /* Exports */
  Package._define("ejson", _exports2, {
    EJSON: EJSON
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var EJSON = Package.ejson.EJSON;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var DiffSequence;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "diff-sequence": { "diff.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                 //
            // packages/diff-sequence/diff.js                                                                  //
            //                                                                                                 //
            /////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              DiffSequence: () => DiffSequence
            });
            const DiffSequence = {};
            const hasOwn = Object.prototype.hasOwnProperty;

            function isObjEmpty(obj) {
              for (let key in Object(obj)) {
                if (hasOwn.call(obj, key)) {
                  return false;
                }
              }

              return true;
            } // ordered: bool.
            // old_results and new_results: collections of documents.
            //    if ordered, they are arrays.
            //    if unordered, they are IdMaps


            DiffSequence.diffQueryChanges = function (ordered, oldResults, newResults, observer, options) {
              if (ordered) DiffSequence.diffQueryOrderedChanges(oldResults, newResults, observer, options);else DiffSequence.diffQueryUnorderedChanges(oldResults, newResults, observer, options);
            };

            DiffSequence.diffQueryUnorderedChanges = function (oldResults, newResults, observer, options) {
              options = options || {};
              var projectionFn = options.projectionFn || EJSON.clone;

              if (observer.movedBefore) {
                throw new Error("_diffQueryUnordered called with a movedBefore observer!");
              }

              newResults.forEach(function (newDoc, id) {
                var oldDoc = oldResults.get(id);

                if (oldDoc) {
                  if (observer.changed && !EJSON.equals(oldDoc, newDoc)) {
                    var projectedNew = projectionFn(newDoc);
                    var projectedOld = projectionFn(oldDoc);
                    var changedFields = DiffSequence.makeChangedFields(projectedNew, projectedOld);

                    if (!isObjEmpty(changedFields)) {
                      observer.changed(id, changedFields);
                    }
                  }
                } else if (observer.added) {
                  var fields = projectionFn(newDoc);
                  delete fields._id;
                  observer.added(newDoc._id, fields);
                }
              });

              if (observer.removed) {
                oldResults.forEach(function (oldDoc, id) {
                  if (!newResults.has(id)) observer.removed(id);
                });
              }
            };

            DiffSequence.diffQueryOrderedChanges = function (old_results, new_results, observer, options) {
              options = options || {};
              var projectionFn = options.projectionFn || EJSON.clone;
              var new_presence_of_id = {};
              new_results.forEach(function (doc) {
                if (new_presence_of_id[doc._id]) Meteor._debug("Duplicate _id in new_results");
                new_presence_of_id[doc._id] = true;
              });
              var old_index_of_id = {};
              old_results.forEach(function (doc, i) {
                if (doc._id in old_index_of_id) Meteor._debug("Duplicate _id in old_results");
                old_index_of_id[doc._id] = i;
              }); // ALGORITHM:
              //
              // To determine which docs should be considered "moved" (and which
              // merely change position because of other docs moving) we run
              // a "longest common subsequence" (LCS) algorithm.  The LCS of the
              // old doc IDs and the new doc IDs gives the docs that should NOT be
              // considered moved.
              // To actually call the appropriate callbacks to get from the old state to the
              // new state:
              // First, we call removed() on all the items that only appear in the old
              // state.
              // Then, once we have the items that should not move, we walk through the new
              // results array group-by-group, where a "group" is a set of items that have
              // moved, anchored on the end by an item that should not move.  One by one, we
              // move each of those elements into place "before" the anchoring end-of-group
              // item, and fire changed events on them if necessary.  Then we fire a changed
              // event on the anchor, and move on to the next group.  There is always at
              // least one group; the last group is anchored by a virtual "null" id at the
              // end.
              // Asymptotically: O(N k) where k is number of ops, or potentially
              // O(N log N) if inner loop of LCS were made to be binary search.
              //////// LCS (longest common sequence, with respect to _id)
              // (see Wikipedia article on Longest Increasing Subsequence,
              // where the LIS is taken of the sequence of old indices of the
              // docs in new_results)
              //
              // unmoved: the output of the algorithm; members of the LCS,
              // in the form of indices into new_results

              var unmoved = []; // max_seq_len: length of LCS found so far

              var max_seq_len = 0; // seq_ends[i]: the index into new_results of the last doc in a
              // common subsequence of length of i+1 <= max_seq_len

              var N = new_results.length;
              var seq_ends = new Array(N); // ptrs:  the common subsequence ending with new_results[n] extends
              // a common subsequence ending with new_results[ptr[n]], unless
              // ptr[n] is -1.

              var ptrs = new Array(N); // virtual sequence of old indices of new results

              var old_idx_seq = function (i_new) {
                return old_index_of_id[new_results[i_new]._id];
              }; // for each item in new_results, use it to extend a common subsequence
              // of length j <= max_seq_len


              for (var i = 0; i < N; i++) {
                if (old_index_of_id[new_results[i]._id] !== undefined) {
                  var j = max_seq_len; // this inner loop would traditionally be a binary search,
                  // but scanning backwards we will likely find a subseq to extend
                  // pretty soon, bounded for example by the total number of ops.
                  // If this were to be changed to a binary search, we'd still want
                  // to scan backwards a bit as an optimization.

                  while (j > 0) {
                    if (old_idx_seq(seq_ends[j - 1]) < old_idx_seq(i)) break;
                    j--;
                  }

                  ptrs[i] = j === 0 ? -1 : seq_ends[j - 1];
                  seq_ends[j] = i;
                  if (j + 1 > max_seq_len) max_seq_len = j + 1;
                }
              } // pull out the LCS/LIS into unmoved


              var idx = max_seq_len === 0 ? -1 : seq_ends[max_seq_len - 1];

              while (idx >= 0) {
                unmoved.push(idx);
                idx = ptrs[idx];
              } // the unmoved item list is built backwards, so fix that


              unmoved.reverse(); // the last group is always anchored by the end of the result list, which is
              // an id of "null"

              unmoved.push(new_results.length);
              old_results.forEach(function (doc) {
                if (!new_presence_of_id[doc._id]) observer.removed && observer.removed(doc._id);
              }); // for each group of things in the new_results that is anchored by an unmoved
              // element, iterate through the things before it.

              var startOfGroup = 0;
              unmoved.forEach(function (endOfGroup) {
                var groupId = new_results[endOfGroup] ? new_results[endOfGroup]._id : null;
                var oldDoc, newDoc, fields, projectedNew, projectedOld;

                for (var i = startOfGroup; i < endOfGroup; i++) {
                  newDoc = new_results[i];

                  if (!hasOwn.call(old_index_of_id, newDoc._id)) {
                    fields = projectionFn(newDoc);
                    delete fields._id;
                    observer.addedBefore && observer.addedBefore(newDoc._id, fields, groupId);
                    observer.added && observer.added(newDoc._id, fields);
                  } else {
                    // moved
                    oldDoc = old_results[old_index_of_id[newDoc._id]];
                    projectedNew = projectionFn(newDoc);
                    projectedOld = projectionFn(oldDoc);
                    fields = DiffSequence.makeChangedFields(projectedNew, projectedOld);

                    if (!isObjEmpty(fields)) {
                      observer.changed && observer.changed(newDoc._id, fields);
                    }

                    observer.movedBefore && observer.movedBefore(newDoc._id, groupId);
                  }
                }

                if (groupId) {
                  newDoc = new_results[endOfGroup];
                  oldDoc = old_results[old_index_of_id[newDoc._id]];
                  projectedNew = projectionFn(newDoc);
                  projectedOld = projectionFn(oldDoc);
                  fields = DiffSequence.makeChangedFields(projectedNew, projectedOld);

                  if (!isObjEmpty(fields)) {
                    observer.changed && observer.changed(newDoc._id, fields);
                  }
                }

                startOfGroup = endOfGroup + 1;
              });
            }; // General helper for diff-ing two objects.
            // callbacks is an object like so:
            // { leftOnly: function (key, leftValue) {...},
            //   rightOnly: function (key, rightValue) {...},
            //   both: function (key, leftValue, rightValue) {...},
            // }


            DiffSequence.diffObjects = function (left, right, callbacks) {
              Object.keys(left).forEach(key => {
                const leftValue = left[key];

                if (hasOwn.call(right, key)) {
                  callbacks.both && callbacks.both(key, leftValue, right[key]);
                } else {
                  callbacks.leftOnly && callbacks.leftOnly(key, leftValue);
                }
              });

              if (callbacks.rightOnly) {
                Object.keys(right).forEach(key => {
                  const rightValue = right[key];

                  if (!hasOwn.call(left, key)) {
                    callbacks.rightOnly(key, rightValue);
                  }
                });
              }
            };

            DiffSequence.diffMaps = function (left, right, callbacks) {
              left.forEach(function (leftValue, key) {
                if (right.has(key)) {
                  callbacks.both && callbacks.both(key, leftValue, right.get(key));
                } else {
                  callbacks.leftOnly && callbacks.leftOnly(key, leftValue);
                }
              });

              if (callbacks.rightOnly) {
                right.forEach(function (rightValue, key) {
                  if (!left.has(key)) {
                    callbacks.rightOnly(key, rightValue);
                  }
                });
              }
            };

            DiffSequence.makeChangedFields = function (newDoc, oldDoc) {
              var fields = {};
              DiffSequence.diffObjects(oldDoc, newDoc, {
                leftOnly: function (key, value) {
                  fields[key] = undefined;
                },
                rightOnly: function (key, value) {
                  fields[key] = value;
                },
                both: function (key, leftValue, rightValue) {
                  if (!EJSON.equals(leftValue, rightValue)) fields[key] = rightValue;
                }
              });
              return fields;
            };

            DiffSequence.applyChanges = function (doc, changeFields) {
              Object.keys(changeFields).forEach(key => {
                const value = changeFields[key];

                if (typeof value === "undefined") {
                  delete doc[key];
                } else {
                  doc[key] = value;
                }
              });
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/diff-sequence/diff.js");

  /* Exports */
  Package._define("diff-sequence", _exports2, {
    DiffSequence: DiffSequence
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;

  /* Package-scope variables */
  var GeoJSON;

  var _require3 = meteorInstall({ "node_modules": { "meteor": { "geojson-utils": { "main.js": function _module(_require, _exports) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                         //
            // packages/geojson-utils/main.js                                                                          //
            //                                                                                                         //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _exports.GeoJSON = _require("./geojson-utils.js");

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "geojson-utils.js": function module(_require2, _exports2, _module2) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                         //
            // packages/geojson-utils/geojson-utils.js                                                                 //
            //                                                                                                         //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            (function () {
              var gju = {};

              // Export the geojson object for **CommonJS**
              if (typeof _module2 !== 'undefined' && _module2.exports) {
                _module2.exports = gju;
              }

              // adapted from http://www.kevlindev.com/gui/math/intersection/Intersection.js
              gju.lineStringsIntersect = function (l1, l2) {
                var intersects = [];
                for (var i = 0; i <= l1.coordinates.length - 2; ++i) {
                  for (var j = 0; j <= l2.coordinates.length - 2; ++j) {
                    var a1 = {
                      x: l1.coordinates[i][1],
                      y: l1.coordinates[i][0]
                    },
                        a2 = {
                      x: l1.coordinates[i + 1][1],
                      y: l1.coordinates[i + 1][0]
                    },
                        b1 = {
                      x: l2.coordinates[j][1],
                      y: l2.coordinates[j][0]
                    },
                        b2 = {
                      x: l2.coordinates[j + 1][1],
                      y: l2.coordinates[j + 1][0]
                    },
                        ua_t = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
                        ub_t = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
                        u_b = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
                    if (u_b != 0) {
                      var ua = ua_t / u_b,
                          ub = ub_t / u_b;
                      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
                        intersects.push({
                          'type': 'Point',
                          'coordinates': [a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)]
                        });
                      }
                    }
                  }
                }
                if (intersects.length == 0) intersects = false;
                return intersects;
              };

              // Bounding Box

              function boundingBoxAroundPolyCoords(coords) {
                var xAll = [],
                    yAll = [];

                for (var i = 0; i < coords[0].length; i++) {
                  xAll.push(coords[0][i][1]);
                  yAll.push(coords[0][i][0]);
                }

                xAll = xAll.sort(function (a, b) {
                  return a - b;
                });
                yAll = yAll.sort(function (a, b) {
                  return a - b;
                });

                return [[xAll[0], yAll[0]], [xAll[xAll.length - 1], yAll[yAll.length - 1]]];
              }

              gju.pointInBoundingBox = function (point, bounds) {
                return !(point.coordinates[1] < bounds[0][0] || point.coordinates[1] > bounds[1][0] || point.coordinates[0] < bounds[0][1] || point.coordinates[0] > bounds[1][1]);
              };

              // Point in Polygon
              // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html#Listing the Vertices

              function pnpoly(x, y, coords) {
                var vert = [[0, 0]];

                for (var i = 0; i < coords.length; i++) {
                  for (var j = 0; j < coords[i].length; j++) {
                    vert.push(coords[i][j]);
                  }
                  vert.push([0, 0]);
                }

                var inside = false;
                for (var i = 0, j = vert.length - 1; i < vert.length; j = i++) {
                  if (vert[i][0] > y != vert[j][0] > y && x < (vert[j][1] - vert[i][1]) * (y - vert[i][0]) / (vert[j][0] - vert[i][0]) + vert[i][1]) inside = !inside;
                }

                return inside;
              }

              gju.pointInPolygon = function (p, poly) {
                var coords = poly.type == "Polygon" ? [poly.coordinates] : poly.coordinates;

                var insideBox = false;
                for (var i = 0; i < coords.length; i++) {
                  if (gju.pointInBoundingBox(p, boundingBoxAroundPolyCoords(coords[i]))) insideBox = true;
                }
                if (!insideBox) return false;

                var insidePoly = false;
                for (var i = 0; i < coords.length; i++) {
                  if (pnpoly(p.coordinates[1], p.coordinates[0], coords[i])) insidePoly = true;
                }

                return insidePoly;
              };

              gju.numberToRadius = function (number) {
                return number * Math.PI / 180;
              };

              gju.numberToDegree = function (number) {
                return number * 180 / Math.PI;
              };

              // written with help from @tautologe
              gju.drawCircle = function (radiusInMeters, centerPoint, steps) {
                var center = [centerPoint.coordinates[1], centerPoint.coordinates[0]],
                    dist = radiusInMeters / 1000 / 6371,

                // convert meters to radiant
                radCenter = [gju.numberToRadius(center[0]), gju.numberToRadius(center[1])],
                    steps = steps || 15,

                // 15 sided circle
                poly = [[center[0], center[1]]];
                for (var i = 0; i < steps; i++) {
                  var brng = 2 * Math.PI * i / steps;
                  var lat = Math.asin(Math.sin(radCenter[0]) * Math.cos(dist) + Math.cos(radCenter[0]) * Math.sin(dist) * Math.cos(brng));
                  var lng = radCenter[1] + Math.atan2(Math.sin(brng) * Math.sin(dist) * Math.cos(radCenter[0]), Math.cos(dist) - Math.sin(radCenter[0]) * Math.sin(lat));
                  poly[i] = [];
                  poly[i][1] = gju.numberToDegree(lat);
                  poly[i][0] = gju.numberToDegree(lng);
                }
                return {
                  "type": "Polygon",
                  "coordinates": [poly]
                };
              };

              // assumes rectangle starts at lower left point
              gju.rectangleCentroid = function (rectangle) {
                var bbox = rectangle.coordinates[0];
                var xmin = bbox[0][0],
                    ymin = bbox[0][1],
                    xmax = bbox[2][0],
                    ymax = bbox[2][1];
                var xwidth = xmax - xmin;
                var ywidth = ymax - ymin;
                return {
                  'type': 'Point',
                  'coordinates': [xmin + xwidth / 2, ymin + ywidth / 2]
                };
              };

              // from http://www.movable-type.co.uk/scripts/latlong.html
              gju.pointDistance = function (pt1, pt2) {
                var lon1 = pt1.coordinates[0],
                    lat1 = pt1.coordinates[1],
                    lon2 = pt2.coordinates[0],
                    lat2 = pt2.coordinates[1],
                    dLat = gju.numberToRadius(lat2 - lat1),
                    dLon = gju.numberToRadius(lon2 - lon1),
                    a = Math.pow(Math.sin(dLat / 2), 2) + Math.cos(gju.numberToRadius(lat1)) * Math.cos(gju.numberToRadius(lat2)) * Math.pow(Math.sin(dLon / 2), 2),
                    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                // Earth radius is 6371 km
                return 6371 * c * 1000; // returns meters
              },

              // checks if geometry lies entirely within a circle
              // works with Point, LineString, Polygon
              gju.geometryWithinRadius = function (geometry, center, radius) {
                if (geometry.type == 'Point') {
                  return gju.pointDistance(geometry, center) <= radius;
                } else if (geometry.type == 'LineString' || geometry.type == 'Polygon') {
                  var point = {};
                  var coordinates;
                  if (geometry.type == 'Polygon') {
                    // it's enough to check the exterior ring of the Polygon
                    coordinates = geometry.coordinates[0];
                  } else {
                    coordinates = geometry.coordinates;
                  }
                  for (var i in coordinates) {
                    point.coordinates = coordinates[i];
                    if (gju.pointDistance(point, center) > radius) {
                      return false;
                    }
                  }
                }
                return true;
              };

              // adapted from http://paulbourke.net/geometry/polyarea/javascript.txt
              gju.area = function (polygon) {
                var area = 0;
                // TODO: polygon holes at coordinates[1]
                var points = polygon.coordinates[0];
                var j = points.length - 1;
                var p1, p2;

                for (var i = 0; i < points.length; j = i++) {
                  var p1 = {
                    x: points[i][1],
                    y: points[i][0]
                  };
                  var p2 = {
                    x: points[j][1],
                    y: points[j][0]
                  };
                  area += p1.x * p2.y;
                  area -= p1.y * p2.x;
                }

                area /= 2;
                return area;
              },

              // adapted from http://paulbourke.net/geometry/polyarea/javascript.txt
              gju.centroid = function (polygon) {
                var f,
                    x = 0,
                    y = 0;
                // TODO: polygon holes at coordinates[1]
                var points = polygon.coordinates[0];
                var j = points.length - 1;
                var p1, p2;

                for (var i = 0; i < points.length; j = i++) {
                  var p1 = {
                    x: points[i][1],
                    y: points[i][0]
                  };
                  var p2 = {
                    x: points[j][1],
                    y: points[j][0]
                  };
                  f = p1.x * p2.y - p2.x * p1.y;
                  x += (p1.x + p2.x) * f;
                  y += (p1.y + p2.y) * f;
                }

                f = gju.area(polygon) * 6;
                return {
                  'type': 'Point',
                  'coordinates': [y / f, x / f]
                };
              }, gju.simplify = function (source, kink) {
                /* source[] array of geojson points */
                /* kink	in metres, kinks above this depth kept  */
                /* kink depth is the height of the triangle abc where a-b and b-c are two consecutive line segments */
                kink = kink || 20;
                source = source.map(function (o) {
                  return {
                    lng: o.coordinates[0],
                    lat: o.coordinates[1]
                  };
                });

                var n_source, n_stack, n_dest, start, end, i, sig;
                var dev_sqr, max_dev_sqr, band_sqr;
                var x12, y12, d12, x13, y13, d13, x23, y23, d23;
                var F = Math.PI / 180.0 * 0.5;
                var index = new Array(); /* aray of indexes of source points to include in the reduced line */
                var sig_start = new Array(); /* indices of start & end of working section */
                var sig_end = new Array();

                /* check for simple cases */

                if (source.length < 3) return source; /* one or two points */

                /* more complex case. initialize stack */

                n_source = source.length;
                band_sqr = kink * 360.0 / (2.0 * Math.PI * 6378137.0); /* Now in degrees */
                band_sqr *= band_sqr;
                n_dest = 0;
                sig_start[0] = 0;
                sig_end[0] = n_source - 1;
                n_stack = 1;

                /* while the stack is not empty  ... */
                while (n_stack > 0) {

                  /* ... pop the top-most entries off the stacks */

                  start = sig_start[n_stack - 1];
                  end = sig_end[n_stack - 1];
                  n_stack--;

                  if (end - start > 1) {
                    /* any intermediate points ? */

                    /* ... yes, so find most deviant intermediate point to
                    either side of line joining start & end points */

                    x12 = source[end].lng() - source[start].lng();
                    y12 = source[end].lat() - source[start].lat();
                    if (Math.abs(x12) > 180.0) x12 = 360.0 - Math.abs(x12);
                    x12 *= Math.cos(F * (source[end].lat() + source[start].lat())); /* use avg lat to reduce lng */
                    d12 = x12 * x12 + y12 * y12;

                    for (i = start + 1, sig = start, max_dev_sqr = -1.0; i < end; i++) {

                      x13 = source[i].lng() - source[start].lng();
                      y13 = source[i].lat() - source[start].lat();
                      if (Math.abs(x13) > 180.0) x13 = 360.0 - Math.abs(x13);
                      x13 *= Math.cos(F * (source[i].lat() + source[start].lat()));
                      d13 = x13 * x13 + y13 * y13;

                      x23 = source[i].lng() - source[end].lng();
                      y23 = source[i].lat() - source[end].lat();
                      if (Math.abs(x23) > 180.0) x23 = 360.0 - Math.abs(x23);
                      x23 *= Math.cos(F * (source[i].lat() + source[end].lat()));
                      d23 = x23 * x23 + y23 * y23;

                      if (d13 >= d12 + d23) dev_sqr = d23;else if (d23 >= d12 + d13) dev_sqr = d13;else dev_sqr = (x13 * y12 - y13 * x12) * (x13 * y12 - y13 * x12) / d12; // solve triangle
                      if (dev_sqr > max_dev_sqr) {
                        sig = i;
                        max_dev_sqr = dev_sqr;
                      }
                    }

                    if (max_dev_sqr < band_sqr) {
                      /* is there a sig. intermediate point ? */
                      /* ... no, so transfer current start point */
                      index[n_dest] = start;
                      n_dest++;
                    } else {
                      /* ... yes, so push two sub-sections on stack for further processing */
                      n_stack++;
                      sig_start[n_stack - 1] = sig;
                      sig_end[n_stack - 1] = end;
                      n_stack++;
                      sig_start[n_stack - 1] = start;
                      sig_end[n_stack - 1] = sig;
                    }
                  } else {
                    /* ... no intermediate points, so transfer current start point */
                    index[n_dest] = start;
                    n_dest++;
                  }
                }

                /* transfer last point */
                index[n_dest] = n_source - 1;
                n_dest++;

                /* make return array */
                var r = new Array();
                for (var i = 0; i < n_dest; i++) r.push(source[index[i]]);

                return r.map(function (o) {
                  return {
                    type: "Point",
                    coordinates: [o.lng, o.lat]
                  };
                });
              };

              // http://www.movable-type.co.uk/scripts/latlong.html#destPoint
              gju.destinationPoint = function (pt, brng, dist) {
                dist = dist / 6371; // convert dist to angular distance in radians
                brng = gju.numberToRadius(brng);

                var lat1 = gju.numberToRadius(pt.coordinates[0]);
                var lon1 = gju.numberToRadius(pt.coordinates[1]);

                var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dist) + Math.cos(lat1) * Math.sin(dist) * Math.cos(brng));
                var lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dist) * Math.cos(lat1), Math.cos(dist) - Math.sin(lat1) * Math.sin(lat2));
                lon2 = (lon2 + 3 * Math.PI) % (2 * Math.PI) - Math.PI; // normalise to -180..+180º

                return {
                  'type': 'Point',
                  'coordinates': [gju.numberToDegree(lat2), gju.numberToDegree(lon2)]
                };
              };
            })();

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports3 = _require3("/node_modules/meteor/geojson-utils/main.js");

  /* Exports */
  Package._define("geojson-utils", _exports3, {
    GeoJSON: GeoJSON
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var EJSON = Package.ejson.EJSON;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var IdMap;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "id-map": { "id-map.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                //
            // packages/id-map/id-map.js                                                                                      //
            //                                                                                                                //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              IdMap: () => IdMap
            });

            class IdMap {
              constructor(idStringify, idParse) {
                this._map = new Map();
                this._idStringify = idStringify || JSON.stringify;
                this._idParse = idParse || JSON.parse;
              } // Some of these methods are designed to match methods on OrderedDict, since
              // (eg) ObserveMultiplex and _CachingChangeObserver use them interchangeably.
              // (Conceivably, this should be replaced with "UnorderedDict" with a specific
              // set of methods that overlap between the two.)


              get(id) {
                const key = this._idStringify(id);

                return this._map.get(key);
              }

              set(id, value) {
                const key = this._idStringify(id);

                this._map.set(key, value);
              }

              remove(id) {
                const key = this._idStringify(id);

                this._map.delete(key);
              }

              has(id) {
                const key = this._idStringify(id);

                return this._map.has(key);
              }

              empty() {
                return this._map.size === 0;
              }

              clear() {
                this._map.clear();
              } // Iterates over the items in the map. Return `false` to break the loop.


              forEach(iterator) {
                // don't use _.each, because we can't break out of it.
                for (let [key, value] of this._map) {
                  const breakIfFalse = iterator.call(null, value, this._idParse(key));

                  if (breakIfFalse === false) {
                    return;
                  }
                }
              }

              size() {
                return this._map.size;
              }

              setDefault(id, def) {
                const key = this._idStringify(id);

                if (this._map.has(key)) {
                  return this._map.get(key);
                }

                this._map.set(key, def);

                return def;
              } // Assumes that values are EJSON-cloneable, and that we don't need to clone
              // IDs (ie, that nobody is going to mutate an ObjectId).


              clone() {
                const clone = new IdMap(this._idStringify, this._idParse); // copy directly to avoid stringify/parse overhead

                this._map.forEach(function (value, key) {
                  clone._map.set(key, EJSON.clone(value));
                });

                return clone;
              }

            }
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/id-map/id-map.js");

  /* Exports */
  Package._define("id-map", _exports2, {
    IdMap: IdMap
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var charsCount, Random;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "random": { "main_client.js": function module(_require, _exports, _module) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/main_client.js                                                                //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Random: () => Random
            });
            let BrowserRandomGenerator;
            _module.link("./BrowserRandomGenerator", {
              default(v) {
                BrowserRandomGenerator = v;
              }

            }, 0);
            let createAleaGeneratorWithGeneratedSeed;
            _module.link("./createAleaGenerator", {
              default(v) {
                createAleaGeneratorWithGeneratedSeed = v;
              }

            }, 1);
            let createRandom;
            _module.link("./createRandom", {
              default(v) {
                createRandom = v;
              }

            }, 2);
            let generator;

            if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
              generator = new BrowserRandomGenerator();
            } else {
              // On IE 10 and below, there's no browser crypto API
              // available. Fall back to Alea
              //
              // XXX looks like at the moment, we use Alea in IE 11 as well,
              // which has `window.msCrypto` instead of `window.crypto`.
              generator = createAleaGeneratorWithGeneratedSeed();
            }

            const Random = createRandom(generator);
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          }, "AbstractRandomGenerator.js": function module(_require3, _exports3, _module2) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/AbstractRandomGenerator.js                                                    //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module2.export({
              default: () => RandomGenerator
            });
            let Meteor;
            _module2.link("meteor/meteor", {
              Meteor(v) {
                Meteor = v;
              }

            }, 0);
            const UNMISTAKABLE_CHARS = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz';
            const BASE64_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ' + '0123456789-_'; // `type` is one of `RandomGenerator.Type` as defined below.
            //
            // options:
            // - seeds: (required, only for RandomGenerator.Type.ALEA) an array
            //   whose items will be `toString`ed and used as the seed to the Alea
            //   algorithm

            class RandomGenerator {
              /**
               * @name Random.fraction
               * @summary Return a number between 0 and 1, like `Math.random`.
               * @locus Anywhere
               */
              fraction() {
                throw new Error("Unknown random generator type");
              }
              /**
               * @name Random.hexString
               * @summary Return a random string of `n` hexadecimal digits.
               * @locus Anywhere
               * @param {Number} n Length of the string
               */

              hexString(digits) {
                return this._randomString(digits, '0123456789abcdef');
              }

              _randomString(charsCount, alphabet) {
                let result = '';

                for (let i = 0; i < charsCount; i++) {
                  result += this.choice(alphabet);
                }

                return result;
              }
              /**
               * @name Random.id
               * @summary Return a unique identifier, such as `"Jjwjg6gouWLXhMGKW"`, that is
               * likely to be unique in the whole world.
               * @locus Anywhere
               * @param {Number} [n] Optional length of the identifier in characters
               *   (defaults to 17)
               */

              id(charsCount) {
                // 17 characters is around 96 bits of entropy, which is the amount of
                // state in the Alea PRNG.
                if (charsCount === undefined) {
                  charsCount = 17;
                }

                return this._randomString(charsCount, UNMISTAKABLE_CHARS);
              }
              /**
               * @name Random.secret
               * @summary Return a random string of printable characters with 6 bits of
               * entropy per character. Use `Random.secret` for security-critical secrets
               * that are intended for machine, rather than human, consumption.
               * @locus Anywhere
               * @param {Number} [n] Optional length of the secret string (defaults to 43
               *   characters, or 256 bits of entropy)
               */

              secret(charsCount) {
                // Default to 256 bits of entropy, or 43 characters at 6 bits per
                // character.
                if (charsCount === undefined) {
                  charsCount = 43;
                }

                return this._randomString(charsCount, BASE64_CHARS);
              }
              /**
               * @name Random.choice
               * @summary Return a random element of the given array or string.
               * @locus Anywhere
               * @param {Array|String} arrayOrString Array or string to choose from
               */

              choice(arrayOrString) {
                const index = Math.floor(this.fraction() * arrayOrString.length);

                if (typeof arrayOrString === 'string') {
                  return arrayOrString.substr(index, 1);
                }

                return arrayOrString[index];
              }

            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          }, "AleaRandomGenerator.js": function module(_require4, _exports4, _module3) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/AleaRandomGenerator.js                                                        //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module3.export({
              default: () => AleaRandomGenerator
            });
            let RandomGenerator;
            _module3.link("./AbstractRandomGenerator", {
              default(v) {
                RandomGenerator = v;
              }

            }, 0);

            // Alea PRNG, which is not cryptographically strong
            // see http://baagoe.org/en/wiki/Better_random_numbers_for_javascript
            // for a full discussion and Alea implementation.
            function Alea(seeds) {
              function Mash() {
                let n = 0xefc8249d;

                const mash = data => {
                  data = data.toString();

                  for (let i = 0; i < data.length; i++) {
                    n += data.charCodeAt(i);
                    let h = 0.02519603282416938 * n;
                    n = h >>> 0;
                    h -= n;
                    h *= n;
                    n = h >>> 0;
                    h -= n;
                    n += h * 0x100000000; // 2^32
                  }

                  return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
                };

                mash.version = 'Mash 0.9';
                return mash;
              }

              let s0 = 0;
              let s1 = 0;
              let s2 = 0;
              let c = 1;

              if (seeds.length === 0) {
                seeds = [+new Date()];
              }

              let mash = Mash();
              s0 = mash(' ');
              s1 = mash(' ');
              s2 = mash(' ');

              for (let i = 0; i < seeds.length; i++) {
                s0 -= mash(seeds[i]);

                if (s0 < 0) {
                  s0 += 1;
                }

                s1 -= mash(seeds[i]);

                if (s1 < 0) {
                  s1 += 1;
                }

                s2 -= mash(seeds[i]);

                if (s2 < 0) {
                  s2 += 1;
                }
              }

              mash = null;

              const random = () => {
                const t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32

                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
              };

              random.uint32 = () => random() * 0x100000000; // 2^32


              random.fract53 = () => random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53


              random.version = 'Alea 0.9';
              random.args = seeds;
              return random;
            } // options:
            // - seeds: an array
            //   whose items will be `toString`ed and used as the seed to the Alea
            //   algorithm


            class AleaRandomGenerator extends RandomGenerator {
              constructor() {
                let {
                  seeds = []
                } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                super();

                if (!seeds) {
                  throw new Error('No seeds were provided for Alea PRNG');
                }

                this.alea = Alea(seeds);
              }
              /**
               * @name Random.fraction
               * @summary Return a number between 0 and 1, like `Math.random`.
               * @locus Anywhere
               */

              fraction() {
                return this.alea();
              }

            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          }, "BrowserRandomGenerator.js": function module(_require5, _exports5, _module4) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/BrowserRandomGenerator.js                                                     //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module4.export({
              default: () => BrowserRandomGenerator
            });
            let RandomGenerator;
            _module4.link("./AbstractRandomGenerator", {
              default(v) {
                RandomGenerator = v;
              }

            }, 0);

            class BrowserRandomGenerator extends RandomGenerator {
              /**
               * @name Random.fraction
               * @summary Return a number between 0 and 1, like `Math.random`.
               * @locus Anywhere
               */
              fraction() {
                const array = new Uint32Array(1);
                window.crypto.getRandomValues(array);
                return array[0] * 2.3283064365386963e-10; // 2^-32
              }

            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          }, "createAleaGenerator.js": function module(_require6, _exports6, _module5) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/createAleaGenerator.js                                                        //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module5.export({
              default: () => createAleaGenerator
            });
            let AleaRandomGenerator;
            _module5.link("./AleaRandomGenerator", {
              default(v) {
                AleaRandomGenerator = v;
              }

            }, 0);
            // instantiate RNG.  Heuristically collect entropy from various sources when a
            // cryptographic PRNG isn't available.
            // client sources
            const height = typeof window !== 'undefined' && window.innerHeight || typeof document !== 'undefined' && document.documentElement && document.documentElement.clientHeight || typeof document !== 'undefined' && document.body && document.body.clientHeight || 1;
            const width = typeof window !== 'undefined' && window.innerWidth || typeof document !== 'undefined' && document.documentElement && document.documentElement.clientWidth || typeof document !== 'undefined' && document.body && document.body.clientWidth || 1;
            const agent = typeof navigator !== 'undefined' && navigator.userAgent || '';

            function createAleaGenerator() {
              return new AleaRandomGenerator({
                seeds: [new Date(), height, width, agent, Math.random()]
              });
            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          }, "createRandom.js": function module(_require7, _exports7, _module6) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                               //
            // packages/random/createRandom.js                                                               //
            //                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module6.export({
              default: () => createRandom
            });
            let AleaRandomGenerator;
            _module6.link("./AleaRandomGenerator", {
              default(v) {
                AleaRandomGenerator = v;
              }

            }, 0);
            let createAleaGeneratorWithGeneratedSeed;
            _module6.link("./createAleaGenerator", {
              default(v) {
                createAleaGeneratorWithGeneratedSeed = v;
              }

            }, 1);

            function createRandom(generator) {
              // Create a non-cryptographically secure PRNG with a given seed (using
              // the Alea algorithm)
              generator.createWithSeeds = function () {
                for (var _len = arguments.length, seeds = new Array(_len), _key = 0; _key < _len; _key++) {
                  seeds[_key] = arguments[_key];
                }

                if (seeds.length === 0) {
                  throw new Error('No seeds were provided');
                }

                return new AleaRandomGenerator({
                  seeds
                });
              }; // Used like `Random`, but much faster and not cryptographically
              // secure


              generator.insecure = createAleaGeneratorWithGeneratedSeed();
              return generator;
            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/random/main_client.js");

  /* Exports */
  Package._define("random", _exports2, {
    Random: Random
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var EJSON = Package.ejson.EJSON;
  var Random = Package.random.Random;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var hexString, MongoID;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "mongo-id": { "id.js": function module(_require, _exports, _module) {

            ///////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                           //
            // packages/mongo-id/id.js                                                                   //
            //                                                                                           //
            ///////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              MongoID: () => MongoID
            });
            let EJSON;
            _module.link("meteor/ejson", {
              EJSON(v) {
                EJSON = v;
              }

            }, 0);
            let Random;
            _module.link("meteor/random", {
              Random(v) {
                Random = v;
              }

            }, 1);
            const MongoID = {};

            MongoID._looksLikeObjectID = str => str.length === 24 && str.match(/^[0-9a-f]*$/);

            MongoID.ObjectID = class ObjectID {
              constructor(hexString) {
                //random-based impl of Mongo ObjectID
                if (hexString) {
                  hexString = hexString.toLowerCase();

                  if (!MongoID._looksLikeObjectID(hexString)) {
                    throw new Error('Invalid hexadecimal string for creating an ObjectID');
                  } // meant to work with _.isEqual(), which relies on structural equality


                  this._str = hexString;
                } else {
                  this._str = Random.hexString(24);
                }
              }

              equals(other) {
                return other instanceof MongoID.ObjectID && this.valueOf() === other.valueOf();
              }

              toString() {
                return "ObjectID(\"".concat(this._str, "\")");
              }

              clone() {
                return new MongoID.ObjectID(this._str);
              }

              typeName() {
                return 'oid';
              }

              getTimestamp() {
                return Number.parseInt(this._str.substr(0, 8), 16);
              }

              valueOf() {
                return this._str;
              }

              toJSONValue() {
                return this.valueOf();
              }

              toHexString() {
                return this.valueOf();
              }

            };
            EJSON.addType('oid', str => new MongoID.ObjectID(str));

            MongoID.idStringify = id => {
              if (id instanceof MongoID.ObjectID) {
                return id.valueOf();
              } else if (typeof id === 'string') {
                var firstChar = id.charAt(0);

                if (id === '') {
                  return id;
                } else if (firstChar === '-' || // escape previously dashed strings
                firstChar === '~' || // escape escaped numbers, true, false
                MongoID._looksLikeObjectID(id) || // escape object-id-form strings
                firstChar === '{') {
                  // escape object-form strings, for maybe implementing later
                  return "-".concat(id);
                } else {
                  return id; // other strings go through unchanged.
                }
              } else if (id === undefined) {
                return '-';
              } else if (typeof id === 'object' && id !== null) {
                throw new Error('Meteor does not currently support objects other than ObjectID as ids');
              } else {
                // Numbers, true, false, null
                return "~".concat(JSON.stringify(id));
              }
            };

            MongoID.idParse = id => {
              var firstChar = id.charAt(0);

              if (id === '') {
                return id;
              } else if (id === '-') {
                return undefined;
              } else if (firstChar === '-') {
                return id.substr(1);
              } else if (firstChar === '~') {
                return JSON.parse(id.substr(1));
              } else if (MongoID._looksLikeObjectID(id)) {
                return new MongoID.ObjectID(id);
              } else {
                return id;
              }
            };
            ///////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/mongo-id/id.js");

  /* Exports */
  Package._define("mongo-id", _exports2, {
    MongoID: MongoID
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var OrderedDict;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "ordered-dict": { "ordered_dict.js": function module(_require, _exports, _module) {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                      //
            // packages/ordered-dict/ordered_dict.js                                                                //
            //                                                                                                      //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              OrderedDict: () => OrderedDict
            });

            // This file defines an ordered dictionary abstraction that is useful for
            // maintaining a dataset backed by observeChanges.  It supports ordering items
            // by specifying the item they now come before.
            // The implementation is a dictionary that contains nodes of a doubly-linked
            // list as its values.
            // constructs a new element struct
            // next and prev are whole elements, not keys.
            function element(key, value, next, prev) {
              return {
                key: key,
                value: value,
                next: next,
                prev: prev
              };
            }

            class OrderedDict {
              constructor() {
                this._dict = Object.create(null);
                this._first = null;
                this._last = null;
                this._size = 0;

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                if (typeof args[0] === 'function') {
                  this._stringify = args.shift();
                } else {
                  this._stringify = function (x) {
                    return x;
                  };
                }

                args.forEach(kv => this.putBefore(kv[0], kv[1], null));
              } // the "prefix keys with a space" thing comes from here
              // https://github.com/documentcloud/underscore/issues/376#issuecomment-2815649


              _k(key) {
                return " " + this._stringify(key);
              }

              empty() {
                return !this._first;
              }

              size() {
                return this._size;
              }

              _linkEltIn(elt) {
                if (!elt.next) {
                  elt.prev = this._last;
                  if (this._last) this._last.next = elt;
                  this._last = elt;
                } else {
                  elt.prev = elt.next.prev;
                  elt.next.prev = elt;
                  if (elt.prev) elt.prev.next = elt;
                }

                if (this._first === null || this._first === elt.next) this._first = elt;
              }

              _linkEltOut(elt) {
                if (elt.next) elt.next.prev = elt.prev;
                if (elt.prev) elt.prev.next = elt.next;
                if (elt === this._last) this._last = elt.prev;
                if (elt === this._first) this._first = elt.next;
              }

              putBefore(key, item, before) {
                if (this._dict[this._k(key)]) throw new Error("Item " + key + " already present in OrderedDict");
                var elt = before ? element(key, item, this._dict[this._k(before)]) : element(key, item, null);
                if (typeof elt.next === "undefined") throw new Error("could not find item to put this one before");

                this._linkEltIn(elt);

                this._dict[this._k(key)] = elt;
                this._size++;
              }

              append(key, item) {
                this.putBefore(key, item, null);
              }

              remove(key) {
                var elt = this._dict[this._k(key)];

                if (typeof elt === "undefined") throw new Error("Item " + key + " not present in OrderedDict");

                this._linkEltOut(elt);

                this._size--;
                delete this._dict[this._k(key)];
                return elt.value;
              }

              get(key) {
                if (this.has(key)) {
                  return this._dict[this._k(key)].value;
                }
              }

              has(key) {
                return Object.prototype.hasOwnProperty.call(this._dict, this._k(key));
              } // Iterate through the items in this dictionary in order, calling
              // iter(value, key, index) on each one.
              // Stops whenever iter returns OrderedDict.BREAK, or after the last element.


              forEach(iter) {
                let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var i = 0;
                var elt = this._first;

                while (elt !== null) {
                  var b = iter.call(context, elt.value, elt.key, i);
                  if (b === OrderedDict.BREAK) return;
                  elt = elt.next;
                  i++;
                }
              }

              first() {
                if (this.empty()) {
                  return;
                }

                return this._first.key;
              }

              firstValue() {
                if (this.empty()) {
                  return;
                }

                return this._first.value;
              }

              last() {
                if (this.empty()) {
                  return;
                }

                return this._last.key;
              }

              lastValue() {
                if (this.empty()) {
                  return;
                }

                return this._last.value;
              }

              prev(key) {
                if (this.has(key)) {
                  var elt = this._dict[this._k(key)];

                  if (elt.prev) return elt.prev.key;
                }

                return null;
              }

              next(key) {
                if (this.has(key)) {
                  var elt = this._dict[this._k(key)];

                  if (elt.next) return elt.next.key;
                }

                return null;
              }

              moveBefore(key, before) {
                var elt = this._dict[this._k(key)];

                var eltBefore = before ? this._dict[this._k(before)] : null;

                if (typeof elt === "undefined") {
                  throw new Error("Item to move is not present");
                }

                if (typeof eltBefore === "undefined") {
                  throw new Error("Could not find element to move this one before");
                }

                if (eltBefore === elt.next) // no moving necessary
                  return; // remove from its old place

                this._linkEltOut(elt); // patch into its new place


                elt.next = eltBefore;

                this._linkEltIn(elt);
              } // Linear, sadly.


              indexOf(key) {
                var ret = null;
                this.forEach((v, k, i) => {
                  if (this._k(k) === this._k(key)) {
                    ret = i;
                    return OrderedDict.BREAK;
                  }

                  return;
                });
                return ret;
              }

              _checkRep() {
                Object.keys(this._dict).forEach(k => {
                  const v = this._dict[k];

                  if (v.next === v) {
                    throw new Error("Next is a loop");
                  }

                  if (v.prev === v) {
                    throw new Error("Prev is a loop");
                  }
                });
              }

            }

            OrderedDict.BREAK = {
              "break": true
            };
            //////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/ordered-dict/ordered_dict.js");

  /* Exports */
  Package._define("ordered-dict", _exports2, {
    OrderedDict: OrderedDict
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Tracker, Deps, computation;

  var _require = meteorInstall({ "node_modules": { "meteor": { "tracker": { "tracker.js": function _module() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/tracker/tracker.js                                                                                        //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            /////////////////////////////////////////////////////
            // Package docs at http://docs.meteor.com/#tracker //
            /////////////////////////////////////////////////////

            /**
             * @namespace Tracker
             * @summary The namespace for Tracker-related methods.
             */
            Tracker = {};
            /**
             * @namespace Deps
             * @deprecated
             */

            Deps = Tracker; // http://docs.meteor.com/#tracker_active

            /**
             * @summary True if there is a current computation, meaning that dependencies on reactive data sources will be tracked and potentially cause the current computation to be rerun.
             * @locus Client
             * @type {Boolean}
             */

            Tracker.active = false; // http://docs.meteor.com/#tracker_currentcomputation

            /**
             * @summary The current computation, or `null` if there isn't one.  The current computation is the [`Tracker.Computation`](#tracker_computation) object created by the innermost active call to `Tracker.autorun`, and it's the computation that gains dependencies when reactive data sources are accessed.
             * @locus Client
             * @type {Tracker.Computation}
             */

            Tracker.currentComputation = null;

            function setCurrentComputation(c) {
              Tracker.currentComputation = c;
              Tracker.active = !!c;
            }

            function _debugFunc() {
              // We want this code to work without Meteor, and also without
              // "console" (which is technically non-standard and may be missing
              // on some browser we come across, like it was on IE 7).
              //
              // Lazy evaluation because `Meteor` does not exist right away.(??)
              return typeof Meteor !== "undefined" ? Meteor._debug : typeof console !== "undefined" && console.error ? function () {
                console.error.apply(console, arguments);
              } : function () {};
            }

            function _maybeSuppressMoreLogs(messagesLength) {
              // Sometimes when running tests, we intentionally suppress logs on expected
              // printed errors. Since the current implementation of _throwOrLog can log
              // multiple separate log messages, suppress all of them if at least one suppress
              // is expected as we still want them to count as one.
              if (typeof Meteor !== "undefined") {
                if (Meteor._suppressed_log_expected()) {
                  Meteor._suppress_log(messagesLength - 1);
                }
              }
            }

            function _throwOrLog(from, e) {
              if (throwFirstError) {
                throw e;
              } else {
                var printArgs = ["Exception from Tracker " + from + " function:"];

                if (e.stack && e.message && e.name) {
                  var idx = e.stack.indexOf(e.message);

                  if (idx < 0 || idx > e.name.length + 2) {
                    // check for "Error: "
                    // message is not part of the stack
                    var message = e.name + ": " + e.message;
                    printArgs.push(message);
                  }
                }

                printArgs.push(e.stack);

                _maybeSuppressMoreLogs(printArgs.length);

                for (var i = 0; i < printArgs.length; i++) {
                  _debugFunc()(printArgs[i]);
                }
              }
            } // Takes a function `f`, and wraps it in a `Meteor._noYieldsAllowed`
            // block if we are running on the server. On the client, returns the
            // original function (since `Meteor._noYieldsAllowed` is a
            // no-op). This has the benefit of not adding an unnecessary stack
            // frame on the client.


            function withNoYieldsAllowed(f) {
              if (typeof Meteor === 'undefined' || Meteor.isClient) {
                return f;
              } else {
                return function () {
                  var args = arguments;

                  Meteor._noYieldsAllowed(function () {
                    f.apply(null, args);
                  });
                };
              }
            }

            var nextId = 1; // computations whose callbacks we should call at flush time

            var pendingComputations = []; // `true` if a Tracker.flush is scheduled, or if we are in Tracker.flush now

            var willFlush = false; // `true` if we are in Tracker.flush now

            var inFlush = false; // `true` if we are computing a computation now, either first time
            // or recompute.  This matches Tracker.active unless we are inside
            // Tracker.nonreactive, which nullfies currentComputation even though
            // an enclosing computation may still be running.

            var inCompute = false; // `true` if the `_throwFirstError` option was passed in to the call
            // to Tracker.flush that we are in. When set, throw rather than log the
            // first error encountered while flushing. Before throwing the error,
            // finish flushing (from a finally block), logging any subsequent
            // errors.

            var throwFirstError = false;
            var afterFlushCallbacks = [];

            function requireFlush() {
              if (!willFlush) {
                // We want this code to work without Meteor, see debugFunc above
                if (typeof Meteor !== "undefined") Meteor._setImmediate(Tracker._runFlush);else setTimeout(Tracker._runFlush, 0);
                willFlush = true;
              }
            } // Tracker.Computation constructor is visible but private
            // (throws an error if you try to call it)


            var constructingComputation = false; //
            // http://docs.meteor.com/#tracker_computation

            /**
             * @summary A Computation object represents code that is repeatedly rerun
             * in response to
             * reactive data changes. Computations don't have return values; they just
             * perform actions, such as rerendering a template on the screen. Computations
             * are created using Tracker.autorun. Use stop to prevent further rerunning of a
             * computation.
             * @instancename computation
             */

            Tracker.Computation = class Computation {
              constructor(f, parent, onError) {
                if (!constructingComputation) throw new Error("Tracker.Computation constructor is private; use Tracker.autorun");
                constructingComputation = false; // http://docs.meteor.com/#computation_stopped

                /**
                 * @summary True if this computation has been stopped.
                 * @locus Client
                 * @memberOf Tracker.Computation
                 * @instance
                 * @name  stopped
                 */

                this.stopped = false; // http://docs.meteor.com/#computation_invalidated

                /**
                 * @summary True if this computation has been invalidated (and not yet rerun), or if it has been stopped.
                 * @locus Client
                 * @memberOf Tracker.Computation
                 * @instance
                 * @name  invalidated
                 * @type {Boolean}
                 */

                this.invalidated = false; // http://docs.meteor.com/#computation_firstrun

                /**
                 * @summary True during the initial run of the computation at the time `Tracker.autorun` is called, and false on subsequent reruns and at other times.
                 * @locus Client
                 * @memberOf Tracker.Computation
                 * @instance
                 * @name  firstRun
                 * @type {Boolean}
                 */

                this.firstRun = true;
                this._id = nextId++;
                this._onInvalidateCallbacks = [];
                this._onStopCallbacks = []; // the plan is at some point to use the parent relation
                // to constrain the order that computations are processed

                this._parent = parent;
                this._func = f;
                this._onError = onError;
                this._recomputing = false;
                var errored = true;

                try {
                  this._compute();

                  errored = false;
                } finally {
                  this.firstRun = false;
                  if (errored) this.stop();
                }
              } // http://docs.meteor.com/#computation_oninvalidate

              /**
               * @summary Registers `callback` to run when this computation is next invalidated, or runs it immediately if the computation is already invalidated.  The callback is run exactly once and not upon future invalidations unless `onInvalidate` is called again after the computation becomes valid again.
               * @locus Client
               * @param {Function} callback Function to be called on invalidation. Receives one argument, the computation that was invalidated.
               */

              onInvalidate(f) {
                if (typeof f !== 'function') throw new Error("onInvalidate requires a function");

                if (this.invalidated) {
                  Tracker.nonreactive(() => {
                    withNoYieldsAllowed(f)(this);
                  });
                } else {
                  this._onInvalidateCallbacks.push(f);
                }
              }
              /**
               * @summary Registers `callback` to run when this computation is stopped, or runs it immediately if the computation is already stopped.  The callback is run after any `onInvalidate` callbacks.
               * @locus Client
               * @param {Function} callback Function to be called on stop. Receives one argument, the computation that was stopped.
               */

              onStop(f) {
                if (typeof f !== 'function') throw new Error("onStop requires a function");

                if (this.stopped) {
                  Tracker.nonreactive(() => {
                    withNoYieldsAllowed(f)(this);
                  });
                } else {
                  this._onStopCallbacks.push(f);
                }
              } // http://docs.meteor.com/#computation_invalidate

              /**
               * @summary Invalidates this computation so that it will be rerun.
               * @locus Client
               */

              invalidate() {
                if (!this.invalidated) {
                  // if we're currently in _recompute(), don't enqueue
                  // ourselves, since we'll rerun immediately anyway.
                  if (!this._recomputing && !this.stopped) {
                    requireFlush();
                    pendingComputations.push(this);
                  }

                  this.invalidated = true; // callbacks can't add callbacks, because
                  // this.invalidated === true.

                  for (var i = 0, f; f = this._onInvalidateCallbacks[i]; i++) {
                    Tracker.nonreactive(() => {
                      withNoYieldsAllowed(f)(this);
                    });
                  }

                  this._onInvalidateCallbacks = [];
                }
              } // http://docs.meteor.com/#computation_stop

              /**
               * @summary Prevents this computation from rerunning.
               * @locus Client
               */

              stop() {
                if (!this.stopped) {
                  this.stopped = true;
                  this.invalidate();

                  for (var i = 0, f; f = this._onStopCallbacks[i]; i++) {
                    Tracker.nonreactive(() => {
                      withNoYieldsAllowed(f)(this);
                    });
                  }

                  this._onStopCallbacks = [];
                }
              }

              _compute() {
                this.invalidated = false;
                var previous = Tracker.currentComputation;
                setCurrentComputation(this);
                var previousInCompute = inCompute;
                inCompute = true;

                try {
                  withNoYieldsAllowed(this._func)(this);
                } finally {
                  setCurrentComputation(previous);
                  inCompute = previousInCompute;
                }
              }

              _needsRecompute() {
                return this.invalidated && !this.stopped;
              }

              _recompute() {
                this._recomputing = true;

                try {
                  if (this._needsRecompute()) {
                    try {
                      this._compute();
                    } catch (e) {
                      if (this._onError) {
                        this._onError(e);
                      } else {
                        _throwOrLog("recompute", e);
                      }
                    }
                  }
                } finally {
                  this._recomputing = false;
                }
              }
              /**
               * @summary Process the reactive updates for this computation immediately
               * and ensure that the computation is rerun. The computation is rerun only
               * if it is invalidated.
               * @locus Client
               */

              flush() {
                if (this._recomputing) return;

                this._recompute();
              }
              /**
               * @summary Causes the function inside this computation to run and
               * synchronously process all reactive updtes.
               * @locus Client
               */

              run() {
                this.invalidate();
                this.flush();
              }

            }; //
            // http://docs.meteor.com/#tracker_dependency

            /**
             * @summary A Dependency represents an atomic unit of reactive data that a
             * computation might depend on. Reactive data sources such as Session or
             * Minimongo internally create different Dependency objects for different
             * pieces of data, each of which may be depended on by multiple computations.
             * When the data changes, the computations are invalidated.
             * @class
             * @instanceName dependency
             */

            Tracker.Dependency = class Dependency {
              constructor() {
                this._dependentsById = Object.create(null);
              } // http://docs.meteor.com/#dependency_depend
              //
              // Adds `computation` to this set if it is not already
              // present.  Returns true if `computation` is a new member of the set.
              // If no argument, defaults to currentComputation, or does nothing
              // if there is no currentComputation.

              /**
               * @summary Declares that the current computation (or `fromComputation` if given) depends on `dependency`.  The computation will be invalidated the next time `dependency` changes.
                If there is no current computation and `depend()` is called with no arguments, it does nothing and returns false.
                Returns true if the computation is a new dependent of `dependency` rather than an existing one.
               * @locus Client
               * @param {Tracker.Computation} [fromComputation] An optional computation declared to depend on `dependency` instead of the current computation.
               * @returns {Boolean}
               */

              depend(computation) {
                if (!computation) {
                  if (!Tracker.active) return false;
                  computation = Tracker.currentComputation;
                }

                var id = computation._id;

                if (!(id in this._dependentsById)) {
                  this._dependentsById[id] = computation;
                  computation.onInvalidate(() => {
                    delete this._dependentsById[id];
                  });
                  return true;
                }

                return false;
              } // http://docs.meteor.com/#dependency_changed

              /**
               * @summary Invalidate all dependent computations immediately and remove them as dependents.
               * @locus Client
               */

              changed() {
                for (var id in this._dependentsById) this._dependentsById[id].invalidate();
              } // http://docs.meteor.com/#dependency_hasdependents

              /**
               * @summary True if this Dependency has one or more dependent Computations, which would be invalidated if this Dependency were to change.
               * @locus Client
               * @returns {Boolean}
               */

              hasDependents() {
                for (var id in this._dependentsById) return true;

                return false;
              }

            }; // http://docs.meteor.com/#tracker_flush

            /**
             * @summary Process all reactive updates immediately and ensure that all invalidated computations are rerun.
             * @locus Client
             */

            Tracker.flush = function (options) {
              Tracker._runFlush({
                finishSynchronously: true,
                throwFirstError: options && options._throwFirstError
              });
            };
            /**
             * @summary True if we are computing a computation now, either first time or recompute.  This matches Tracker.active unless we are inside Tracker.nonreactive, which nullfies currentComputation even though an enclosing computation may still be running.
             * @locus Client
             * @returns {Boolean}
             */

            Tracker.inFlush = function () {
              return inFlush;
            }; // Run all pending computations and afterFlush callbacks.  If we were not called
            // directly via Tracker.flush, this may return before they're all done to allow
            // the event loop to run a little before continuing.


            Tracker._runFlush = function (options) {
              // XXX What part of the comment below is still true? (We no longer
              // have Spark)
              //
              // Nested flush could plausibly happen if, say, a flush causes
              // DOM mutation, which causes a "blur" event, which runs an
              // app event handler that calls Tracker.flush.  At the moment
              // Spark blocks event handlers during DOM mutation anyway,
              // because the LiveRange tree isn't valid.  And we don't have
              // any useful notion of a nested flush.
              //
              // https://app.asana.com/0/159908330244/385138233856
              if (Tracker.inFlush()) throw new Error("Can't call Tracker.flush while flushing");
              if (inCompute) throw new Error("Can't flush inside Tracker.autorun");
              options = options || {};
              inFlush = true;
              willFlush = true;
              throwFirstError = !!options.throwFirstError;
              var recomputedCount = 0;
              var finishedTry = false;

              try {
                while (pendingComputations.length || afterFlushCallbacks.length) {
                  // recompute all pending computations
                  while (pendingComputations.length) {
                    var comp = pendingComputations.shift();

                    comp._recompute();

                    if (comp._needsRecompute()) {
                      pendingComputations.unshift(comp);
                    }

                    if (!options.finishSynchronously && ++recomputedCount > 1000) {
                      finishedTry = true;
                      return;
                    }
                  }

                  if (afterFlushCallbacks.length) {
                    // call one afterFlush callback, which may
                    // invalidate more computations
                    var func = afterFlushCallbacks.shift();

                    try {
                      func();
                    } catch (e) {
                      _throwOrLog("afterFlush", e);
                    }
                  }
                }

                finishedTry = true;
              } finally {
                if (!finishedTry) {
                  // we're erroring due to throwFirstError being true.
                  inFlush = false; // needed before calling `Tracker.flush()` again
                  // finish flushing

                  Tracker._runFlush({
                    finishSynchronously: options.finishSynchronously,
                    throwFirstError: false
                  });
                }

                willFlush = false;
                inFlush = false;

                if (pendingComputations.length || afterFlushCallbacks.length) {
                  // We're yielding because we ran a bunch of computations and we aren't
                  // required to finish synchronously, so we'd like to give the event loop a
                  // chance. We should flush again soon.
                  if (options.finishSynchronously) {
                    throw new Error("still have more to do?"); // shouldn't happen
                  }

                  setTimeout(requireFlush, 10);
                }
              }
            }; // http://docs.meteor.com/#tracker_autorun
            //
            // Run f(). Record its dependencies. Rerun it whenever the
            // dependencies change.
            //
            // Returns a new Computation, which is also passed to f.
            //
            // Links the computation to the current computation
            // so that it is stopped if the current computation is invalidated.

            /**
             * @callback Tracker.ComputationFunction
             * @param {Tracker.Computation}
             */

            /**
             * @summary Run a function now and rerun it later whenever its dependencies
             * change. Returns a Computation object that can be used to stop or observe the
             * rerunning.
             * @locus Client
             * @param {Tracker.ComputationFunction} runFunc The function to run. It receives
             * one argument: the Computation object that will be returned.
             * @param {Object} [options]
             * @param {Function} options.onError Optional. The function to run when an error
             * happens in the Computation. The only argument it receives is the Error
             * thrown. Defaults to the error being logged to the console.
             * @returns {Tracker.Computation}
             */

            Tracker.autorun = function (f, options) {
              if (typeof f !== 'function') throw new Error('Tracker.autorun requires a function argument');
              options = options || {};
              constructingComputation = true;
              var c = new Tracker.Computation(f, Tracker.currentComputation, options.onError);
              if (Tracker.active) Tracker.onInvalidate(function () {
                c.stop();
              });
              return c;
            }; // http://docs.meteor.com/#tracker_nonreactive
            //
            // Run `f` with no current computation, returning the return value
            // of `f`.  Used to turn off reactivity for the duration of `f`,
            // so that reactive data sources accessed by `f` will not result in any
            // computations being invalidated.

            /**
             * @summary Run a function without tracking dependencies.
             * @locus Client
             * @param {Function} func A function to call immediately.
             */

            Tracker.nonreactive = function (f) {
              var previous = Tracker.currentComputation;
              setCurrentComputation(null);

              try {
                return f();
              } finally {
                setCurrentComputation(previous);
              }
            }; // http://docs.meteor.com/#tracker_oninvalidate

            /**
             * @summary Registers a new [`onInvalidate`](#computation_oninvalidate) callback on the current computation (which must exist), to be called immediately when the current computation is invalidated or stopped.
             * @locus Client
             * @param {Function} callback A callback function that will be invoked as `func(c)`, where `c` is the computation on which the callback is registered.
             */

            Tracker.onInvalidate = function (f) {
              if (!Tracker.active) throw new Error("Tracker.onInvalidate requires a currentComputation");
              Tracker.currentComputation.onInvalidate(f);
            }; // http://docs.meteor.com/#tracker_afterflush

            /**
             * @summary Schedules a function to be called during the next flush, or later in the current flush if one is in progress, after all invalidated computations have been rerun.  The function will be run once and not on subsequent flushes unless `afterFlush` is called again.
             * @locus Client
             * @param {Function} callback A function to call at flush time.
             */

            Tracker.afterFlush = function (f) {
              afterFlushCallbacks.push(f);
              requireFlush();
            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/tracker/tracker.js");

  /* Exports */
  Package._define("tracker", {
    Tracker: Tracker,
    Deps: Deps
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var DiffSequence = Package['diff-sequence'].DiffSequence;
  var EJSON = Package.ejson.EJSON;
  var GeoJSON = Package['geojson-utils'].GeoJSON;
  var IdMap = Package['id-map'].IdMap;
  var MongoID = Package['mongo-id'].MongoID;
  var OrderedDict = Package['ordered-dict'].OrderedDict;
  var Random = Package.random.Random;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var operand, selectorValue, MinimongoTest, MinimongoError, selector, doc, callback, options, oldResults, a, b, LocalCollection, Minimongo;

  var _require3 = meteorInstall({ "node_modules": { "meteor": { "minimongo": { "minimongo_client.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/minimongo_client.js                                                                              //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.link("./minimongo_common.js");
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "common.js": function module(_require2, _exports2, _module2) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/common.js                                                                                        //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module2.export({
              hasOwn: () => hasOwn,
              ELEMENT_OPERATORS: () => ELEMENT_OPERATORS,
              compileDocumentSelector: () => compileDocumentSelector,
              equalityElementMatcher: () => equalityElementMatcher,
              expandArraysInBranches: () => expandArraysInBranches,
              isIndexable: () => isIndexable,
              isNumericKey: () => isNumericKey,
              isOperatorObject: () => isOperatorObject,
              makeLookupFunction: () => makeLookupFunction,
              nothingMatcher: () => nothingMatcher,
              pathsToTree: () => pathsToTree,
              populateDocumentWithQueryFields: () => populateDocumentWithQueryFields,
              projectionDetails: () => projectionDetails,
              regexpElementMatcher: () => regexpElementMatcher
            });
            let LocalCollection;
            _module2.link("./local_collection.js", {
              default(v) {
                LocalCollection = v;
              }

            }, 0);
            const hasOwn = Object.prototype.hasOwnProperty;
            const ELEMENT_OPERATORS = {
              $lt: makeInequality(cmpValue => cmpValue < 0),
              $gt: makeInequality(cmpValue => cmpValue > 0),
              $lte: makeInequality(cmpValue => cmpValue <= 0),
              $gte: makeInequality(cmpValue => cmpValue >= 0),
              $mod: {
                compileElementSelector(operand) {
                  if (!(Array.isArray(operand) && operand.length === 2 && typeof operand[0] === 'number' && typeof operand[1] === 'number')) {
                    throw Error('argument to $mod must be an array of two numbers');
                  } // XXX could require to be ints or round or something


                  const divisor = operand[0];
                  const remainder = operand[1];
                  return value => typeof value === 'number' && value % divisor === remainder;
                }

              },
              $in: {
                compileElementSelector(operand) {
                  if (!Array.isArray(operand)) {
                    throw Error('$in needs an array');
                  }

                  const elementMatchers = operand.map(option => {
                    if (option instanceof RegExp) {
                      return regexpElementMatcher(option);
                    }

                    if (isOperatorObject(option)) {
                      throw Error('cannot nest $ under $in');
                    }

                    return equalityElementMatcher(option);
                  });
                  return value => {
                    // Allow {a: {$in: [null]}} to match when 'a' does not exist.
                    if (value === undefined) {
                      value = null;
                    }

                    return elementMatchers.some(matcher => matcher(value));
                  };
                }

              },
              $size: {
                // {a: [[5, 5]]} must match {a: {$size: 1}} but not {a: {$size: 2}}, so we
                // don't want to consider the element [5,5] in the leaf array [[5,5]] as a
                // possible value.
                dontExpandLeafArrays: true,

                compileElementSelector(operand) {
                  if (typeof operand === 'string') {
                    // Don't ask me why, but by experimentation, this seems to be what Mongo
                    // does.
                    operand = 0;
                  } else if (typeof operand !== 'number') {
                    throw Error('$size needs a number');
                  }

                  return value => Array.isArray(value) && value.length === operand;
                }

              },
              $type: {
                // {a: [5]} must not match {a: {$type: 4}} (4 means array), but it should
                // match {a: {$type: 1}} (1 means number), and {a: [[5]]} must match {$a:
                // {$type: 4}}. Thus, when we see a leaf array, we *should* expand it but
                // should *not* include it itself.
                dontIncludeLeafArrays: true,

                compileElementSelector(operand) {
                  if (typeof operand === 'string') {
                    const operandAliasMap = {
                      'double': 1,
                      'string': 2,
                      'object': 3,
                      'array': 4,
                      'binData': 5,
                      'undefined': 6,
                      'objectId': 7,
                      'bool': 8,
                      'date': 9,
                      'null': 10,
                      'regex': 11,
                      'dbPointer': 12,
                      'javascript': 13,
                      'symbol': 14,
                      'javascriptWithScope': 15,
                      'int': 16,
                      'timestamp': 17,
                      'long': 18,
                      'decimal': 19,
                      'minKey': -1,
                      'maxKey': 127
                    };

                    if (!hasOwn.call(operandAliasMap, operand)) {
                      throw Error("unknown string alias for $type: ".concat(operand));
                    }

                    operand = operandAliasMap[operand];
                  } else if (typeof operand === 'number') {
                    if (operand === 0 || operand < -1 || operand > 19 && operand !== 127) {
                      throw Error("Invalid numerical $type code: ".concat(operand));
                    }
                  } else {
                    throw Error('argument to $type is not a number or a string');
                  }

                  return value => value !== undefined && LocalCollection._f._type(value) === operand;
                }

              },
              $bitsAllSet: {
                compileElementSelector(operand) {
                  const mask = getOperandBitmask(operand, '$bitsAllSet');
                  return value => {
                    const bitmask = getValueBitmask(value, mask.length);
                    return bitmask && mask.every((byte, i) => (bitmask[i] & byte) === byte);
                  };
                }

              },
              $bitsAnySet: {
                compileElementSelector(operand) {
                  const mask = getOperandBitmask(operand, '$bitsAnySet');
                  return value => {
                    const bitmask = getValueBitmask(value, mask.length);
                    return bitmask && mask.some((byte, i) => (~bitmask[i] & byte) !== byte);
                  };
                }

              },
              $bitsAllClear: {
                compileElementSelector(operand) {
                  const mask = getOperandBitmask(operand, '$bitsAllClear');
                  return value => {
                    const bitmask = getValueBitmask(value, mask.length);
                    return bitmask && mask.every((byte, i) => !(bitmask[i] & byte));
                  };
                }

              },
              $bitsAnyClear: {
                compileElementSelector(operand) {
                  const mask = getOperandBitmask(operand, '$bitsAnyClear');
                  return value => {
                    const bitmask = getValueBitmask(value, mask.length);
                    return bitmask && mask.some((byte, i) => (bitmask[i] & byte) !== byte);
                  };
                }

              },
              $regex: {
                compileElementSelector(operand, valueSelector) {
                  if (!(typeof operand === 'string' || operand instanceof RegExp)) {
                    throw Error('$regex has to be a string or RegExp');
                  }

                  let regexp;

                  if (valueSelector.$options !== undefined) {
                    // Options passed in $options (even the empty string) always overrides
                    // options in the RegExp object itself.
                    // Be clear that we only support the JS-supported options, not extended
                    // ones (eg, Mongo supports x and s). Ideally we would implement x and s
                    // by transforming the regexp, but not today...
                    if (/[^gim]/.test(valueSelector.$options)) {
                      throw new Error('Only the i, m, and g regexp options are supported');
                    }

                    const source = operand instanceof RegExp ? operand.source : operand;
                    regexp = new RegExp(source, valueSelector.$options);
                  } else if (operand instanceof RegExp) {
                    regexp = operand;
                  } else {
                    regexp = new RegExp(operand);
                  }

                  return regexpElementMatcher(regexp);
                }

              },
              $elemMatch: {
                dontExpandLeafArrays: true,

                compileElementSelector(operand, valueSelector, matcher) {
                  if (!LocalCollection._isPlainObject(operand)) {
                    throw Error('$elemMatch need an object');
                  }

                  const isDocMatcher = !isOperatorObject(Object.keys(operand).filter(key => !hasOwn.call(LOGICAL_OPERATORS, key)).reduce((a, b) => Object.assign(a, {
                    [b]: operand[b]
                  }), {}), true);
                  let subMatcher;

                  if (isDocMatcher) {
                    // This is NOT the same as compileValueSelector(operand), and not just
                    // because of the slightly different calling convention.
                    // {$elemMatch: {x: 3}} means "an element has a field x:3", not
                    // "consists only of a field x:3". Also, regexps and sub-$ are allowed.
                    subMatcher = compileDocumentSelector(operand, matcher, {
                      inElemMatch: true
                    });
                  } else {
                    subMatcher = compileValueSelector(operand, matcher);
                  }

                  return value => {
                    if (!Array.isArray(value)) {
                      return false;
                    }

                    for (let i = 0; i < value.length; ++i) {
                      const arrayElement = value[i];
                      let arg;

                      if (isDocMatcher) {
                        // We can only match {$elemMatch: {b: 3}} against objects.
                        // (We can also match against arrays, if there's numeric indices,
                        // eg {$elemMatch: {'0.b': 3}} or {$elemMatch: {0: 3}}.)
                        if (!isIndexable(arrayElement)) {
                          return false;
                        }

                        arg = arrayElement;
                      } else {
                        // dontIterate ensures that {a: {$elemMatch: {$gt: 5}}} matches
                        // {a: [8]} but not {a: [[8]]}
                        arg = [{
                          value: arrayElement,
                          dontIterate: true
                        }];
                      } // XXX support $near in $elemMatch by propagating $distance?


                      if (subMatcher(arg).result) {
                        return i; // specially understood to mean "use as arrayIndices"
                      }
                    }

                    return false;
                  };
                }

              }
            };
            // Operators that appear at the top level of a document selector.
            const LOGICAL_OPERATORS = {
              $and(subSelector, matcher, inElemMatch) {
                return andDocumentMatchers(compileArrayOfDocumentSelectors(subSelector, matcher, inElemMatch));
              },

              $or(subSelector, matcher, inElemMatch) {
                const matchers = compileArrayOfDocumentSelectors(subSelector, matcher, inElemMatch); // Special case: if there is only one matcher, use it directly, *preserving*
                // any arrayIndices it returns.

                if (matchers.length === 1) {
                  return matchers[0];
                }

                return doc => {
                  const result = matchers.some(fn => fn(doc).result); // $or does NOT set arrayIndices when it has multiple
                  // sub-expressions. (Tested against MongoDB.)

                  return {
                    result
                  };
                };
              },

              $nor(subSelector, matcher, inElemMatch) {
                const matchers = compileArrayOfDocumentSelectors(subSelector, matcher, inElemMatch);
                return doc => {
                  const result = matchers.every(fn => !fn(doc).result); // Never set arrayIndices, because we only match if nothing in particular
                  // 'matched' (and because this is consistent with MongoDB).

                  return {
                    result
                  };
                };
              },

              $where(selectorValue, matcher) {
                // Record that *any* path may be used.
                matcher._recordPathUsed('');

                matcher._hasWhere = true;

                if (!(selectorValue instanceof Function)) {
                  // XXX MongoDB seems to have more complex logic to decide where or or not
                  // to add 'return'; not sure exactly what it is.
                  selectorValue = Function('obj', "return ".concat(selectorValue));
                } // We make the document available as both `this` and `obj`.
                // // XXX not sure what we should do if this throws


                return doc => ({
                  result: selectorValue.call(doc, doc)
                });
              },

              // This is just used as a comment in the query (in MongoDB, it also ends up in
              // query logs); it has no effect on the actual selection.
              $comment() {
                return () => ({
                  result: true
                });
              }

            }; // Operators that (unlike LOGICAL_OPERATORS) pertain to individual paths in a
            // document, but (unlike ELEMENT_OPERATORS) do not have a simple definition as
            // "match each branched value independently and combine with
            // convertElementMatcherToBranchedMatcher".

            const VALUE_OPERATORS = {
              $eq(operand) {
                return convertElementMatcherToBranchedMatcher(equalityElementMatcher(operand));
              },

              $not(operand, valueSelector, matcher) {
                return invertBranchedMatcher(compileValueSelector(operand, matcher));
              },

              $ne(operand) {
                return invertBranchedMatcher(convertElementMatcherToBranchedMatcher(equalityElementMatcher(operand)));
              },

              $nin(operand) {
                return invertBranchedMatcher(convertElementMatcherToBranchedMatcher(ELEMENT_OPERATORS.$in.compileElementSelector(operand)));
              },

              $exists(operand) {
                const exists = convertElementMatcherToBranchedMatcher(value => value !== undefined);
                return operand ? exists : invertBranchedMatcher(exists);
              },

              // $options just provides options for $regex; its logic is inside $regex
              $options(operand, valueSelector) {
                if (!hasOwn.call(valueSelector, '$regex')) {
                  throw Error('$options needs a $regex');
                }

                return everythingMatcher;
              },

              // $maxDistance is basically an argument to $near
              $maxDistance(operand, valueSelector) {
                if (!valueSelector.$near) {
                  throw Error('$maxDistance needs a $near');
                }

                return everythingMatcher;
              },

              $all(operand, valueSelector, matcher) {
                if (!Array.isArray(operand)) {
                  throw Error('$all requires array');
                } // Not sure why, but this seems to be what MongoDB does.


                if (operand.length === 0) {
                  return nothingMatcher;
                }

                const branchedMatchers = operand.map(criterion => {
                  // XXX handle $all/$elemMatch combination
                  if (isOperatorObject(criterion)) {
                    throw Error('no $ expressions in $all');
                  } // This is always a regexp or equality selector.


                  return compileValueSelector(criterion, matcher);
                }); // andBranchedMatchers does NOT require all selectors to return true on the
                // SAME branch.

                return andBranchedMatchers(branchedMatchers);
              },

              $near(operand, valueSelector, matcher, isRoot) {
                if (!isRoot) {
                  throw Error('$near can\'t be inside another $ operator');
                }

                matcher._hasGeoQuery = true; // There are two kinds of geodata in MongoDB: legacy coordinate pairs and
                // GeoJSON. They use different distance metrics, too. GeoJSON queries are
                // marked with a $geometry property, though legacy coordinates can be
                // matched using $geometry.

                let maxDistance, point, distance;

                if (LocalCollection._isPlainObject(operand) && hasOwn.call(operand, '$geometry')) {
                  // GeoJSON "2dsphere" mode.
                  maxDistance = operand.$maxDistance;
                  point = operand.$geometry;

                  distance = value => {
                    // XXX: for now, we don't calculate the actual distance between, say,
                    // polygon and circle. If people care about this use-case it will get
                    // a priority.
                    if (!value) {
                      return null;
                    }

                    if (!value.type) {
                      return GeoJSON.pointDistance(point, {
                        type: 'Point',
                        coordinates: pointToArray(value)
                      });
                    }

                    if (value.type === 'Point') {
                      return GeoJSON.pointDistance(point, value);
                    }

                    return GeoJSON.geometryWithinRadius(value, point, maxDistance) ? 0 : maxDistance + 1;
                  };
                } else {
                  maxDistance = valueSelector.$maxDistance;

                  if (!isIndexable(operand)) {
                    throw Error('$near argument must be coordinate pair or GeoJSON');
                  }

                  point = pointToArray(operand);

                  distance = value => {
                    if (!isIndexable(value)) {
                      return null;
                    }

                    return distanceCoordinatePairs(point, value);
                  };
                }

                return branchedValues => {
                  // There might be multiple points in the document that match the given
                  // field. Only one of them needs to be within $maxDistance, but we need to
                  // evaluate all of them and use the nearest one for the implicit sort
                  // specifier. (That's why we can't just use ELEMENT_OPERATORS here.)
                  //
                  // Note: This differs from MongoDB's implementation, where a document will
                  // actually show up *multiple times* in the result set, with one entry for
                  // each within-$maxDistance branching point.
                  const result = {
                    result: false
                  };
                  expandArraysInBranches(branchedValues).every(branch => {
                    // if operation is an update, don't skip branches, just return the first
                    // one (#3599)
                    let curDistance;

                    if (!matcher._isUpdate) {
                      if (!(typeof branch.value === 'object')) {
                        return true;
                      }

                      curDistance = distance(branch.value); // Skip branches that aren't real points or are too far away.

                      if (curDistance === null || curDistance > maxDistance) {
                        return true;
                      } // Skip anything that's a tie.


                      if (result.distance !== undefined && result.distance <= curDistance) {
                        return true;
                      }
                    }

                    result.result = true;
                    result.distance = curDistance;

                    if (branch.arrayIndices) {
                      result.arrayIndices = branch.arrayIndices;
                    } else {
                      delete result.arrayIndices;
                    }

                    return !matcher._isUpdate;
                  });
                  return result;
                };
              }

            }; // NB: We are cheating and using this function to implement 'AND' for both
            // 'document matchers' and 'branched matchers'. They both return result objects
            // but the argument is different: for the former it's a whole doc, whereas for
            // the latter it's an array of 'branched values'.

            function andSomeMatchers(subMatchers) {
              if (subMatchers.length === 0) {
                return everythingMatcher;
              }

              if (subMatchers.length === 1) {
                return subMatchers[0];
              }

              return docOrBranches => {
                const match = {};
                match.result = subMatchers.every(fn => {
                  const subResult = fn(docOrBranches); // Copy a 'distance' number out of the first sub-matcher that has
                  // one. Yes, this means that if there are multiple $near fields in a
                  // query, something arbitrary happens; this appears to be consistent with
                  // Mongo.

                  if (subResult.result && subResult.distance !== undefined && match.distance === undefined) {
                    match.distance = subResult.distance;
                  } // Similarly, propagate arrayIndices from sub-matchers... but to match
                  // MongoDB behavior, this time the *last* sub-matcher with arrayIndices
                  // wins.


                  if (subResult.result && subResult.arrayIndices) {
                    match.arrayIndices = subResult.arrayIndices;
                  }

                  return subResult.result;
                }); // If we didn't actually match, forget any extra metadata we came up with.

                if (!match.result) {
                  delete match.distance;
                  delete match.arrayIndices;
                }

                return match;
              };
            }

            const andDocumentMatchers = andSomeMatchers;
            const andBranchedMatchers = andSomeMatchers;

            function compileArrayOfDocumentSelectors(selectors, matcher, inElemMatch) {
              if (!Array.isArray(selectors) || selectors.length === 0) {
                throw Error('$and/$or/$nor must be nonempty array');
              }

              return selectors.map(subSelector => {
                if (!LocalCollection._isPlainObject(subSelector)) {
                  throw Error('$or/$and/$nor entries need to be full objects');
                }

                return compileDocumentSelector(subSelector, matcher, {
                  inElemMatch
                });
              });
            } // Takes in a selector that could match a full document (eg, the original
            // selector). Returns a function mapping document->result object.
            //
            // matcher is the Matcher object we are compiling.
            //
            // If this is the root document selector (ie, not wrapped in $and or the like),
            // then isRoot is true. (This is used by $near.)


            function compileDocumentSelector(docSelector, matcher) {
              let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              const docMatchers = Object.keys(docSelector).map(key => {
                const subSelector = docSelector[key];

                if (key.substr(0, 1) === '$') {
                  // Outer operators are either logical operators (they recurse back into
                  // this function), or $where.
                  if (!hasOwn.call(LOGICAL_OPERATORS, key)) {
                    throw new Error("Unrecognized logical operator: ".concat(key));
                  }

                  matcher._isSimple = false;
                  return LOGICAL_OPERATORS[key](subSelector, matcher, options.inElemMatch);
                } // Record this path, but only if we aren't in an elemMatcher, since in an
                // elemMatch this is a path inside an object in an array, not in the doc
                // root.


                if (!options.inElemMatch) {
                  matcher._recordPathUsed(key);
                } // Don't add a matcher if subSelector is a function -- this is to match
                // the behavior of Meteor on the server (inherited from the node mongodb
                // driver), which is to ignore any part of a selector which is a function.


                if (typeof subSelector === 'function') {
                  return undefined;
                }

                const lookUpByIndex = makeLookupFunction(key);
                const valueMatcher = compileValueSelector(subSelector, matcher, options.isRoot);
                return doc => valueMatcher(lookUpByIndex(doc));
              }).filter(Boolean);
              return andDocumentMatchers(docMatchers);
            }

            // Takes in a selector that could match a key-indexed value in a document; eg,
            // {$gt: 5, $lt: 9}, or a regular expression, or any non-expression object (to
            // indicate equality).  Returns a branched matcher: a function mapping
            // [branched value]->result object.
            function compileValueSelector(valueSelector, matcher, isRoot) {
              if (valueSelector instanceof RegExp) {
                matcher._isSimple = false;
                return convertElementMatcherToBranchedMatcher(regexpElementMatcher(valueSelector));
              }

              if (isOperatorObject(valueSelector)) {
                return operatorBranchedMatcher(valueSelector, matcher, isRoot);
              }

              return convertElementMatcherToBranchedMatcher(equalityElementMatcher(valueSelector));
            } // Given an element matcher (which evaluates a single value), returns a branched
            // value (which evaluates the element matcher on all the branches and returns a
            // more structured return value possibly including arrayIndices).


            function convertElementMatcherToBranchedMatcher(elementMatcher) {
              let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return branches => {
                const expanded = options.dontExpandLeafArrays ? branches : expandArraysInBranches(branches, options.dontIncludeLeafArrays);
                const match = {};
                match.result = expanded.some(element => {
                  let matched = elementMatcher(element.value); // Special case for $elemMatch: it means "true, and use this as an array
                  // index if I didn't already have one".

                  if (typeof matched === 'number') {
                    // XXX This code dates from when we only stored a single array index
                    // (for the outermost array). Should we be also including deeper array
                    // indices from the $elemMatch match?
                    if (!element.arrayIndices) {
                      element.arrayIndices = [matched];
                    }

                    matched = true;
                  } // If some element matched, and it's tagged with array indices, include
                  // those indices in our result object.


                  if (matched && element.arrayIndices) {
                    match.arrayIndices = element.arrayIndices;
                  }

                  return matched;
                });
                return match;
              };
            } // Helpers for $near.


            function distanceCoordinatePairs(a, b) {
              const pointA = pointToArray(a);
              const pointB = pointToArray(b);
              return Math.hypot(pointA[0] - pointB[0], pointA[1] - pointB[1]);
            } // Takes something that is not an operator object and returns an element matcher
            // for equality with that thing.


            function equalityElementMatcher(elementSelector) {
              if (isOperatorObject(elementSelector)) {
                throw Error('Can\'t create equalityValueSelector for operator object');
              } // Special-case: null and undefined are equal (if you got undefined in there
              // somewhere, or if you got it due to some branch being non-existent in the
              // weird special case), even though they aren't with EJSON.equals.
              // undefined or null


              if (elementSelector == null) {
                return value => value == null;
              }

              return value => LocalCollection._f._equal(elementSelector, value);
            }

            function everythingMatcher(docOrBranchedValues) {
              return {
                result: true
              };
            }

            function expandArraysInBranches(branches, skipTheArrays) {
              const branchesOut = [];
              branches.forEach(branch => {
                const thisIsArray = Array.isArray(branch.value); // We include the branch itself, *UNLESS* we it's an array that we're going
                // to iterate and we're told to skip arrays.  (That's right, we include some
                // arrays even skipTheArrays is true: these are arrays that were found via
                // explicit numerical indices.)

                if (!(skipTheArrays && thisIsArray && !branch.dontIterate)) {
                  branchesOut.push({
                    arrayIndices: branch.arrayIndices,
                    value: branch.value
                  });
                }

                if (thisIsArray && !branch.dontIterate) {
                  branch.value.forEach((value, i) => {
                    branchesOut.push({
                      arrayIndices: (branch.arrayIndices || []).concat(i),
                      value
                    });
                  });
                }
              });
              return branchesOut;
            }

            // Helpers for $bitsAllSet/$bitsAnySet/$bitsAllClear/$bitsAnyClear.
            function getOperandBitmask(operand, selector) {
              // numeric bitmask
              // You can provide a numeric bitmask to be matched against the operand field.
              // It must be representable as a non-negative 32-bit signed integer.
              // Otherwise, $bitsAllSet will return an error.
              if (Number.isInteger(operand) && operand >= 0) {
                return new Uint8Array(new Int32Array([operand]).buffer);
              } // bindata bitmask
              // You can also use an arbitrarily large BinData instance as a bitmask.


              if (EJSON.isBinary(operand)) {
                return new Uint8Array(operand.buffer);
              } // position list
              // If querying a list of bit positions, each <position> must be a non-negative
              // integer. Bit positions start at 0 from the least significant bit.


              if (Array.isArray(operand) && operand.every(x => Number.isInteger(x) && x >= 0)) {
                const buffer = new ArrayBuffer((Math.max(...operand) >> 3) + 1);
                const view = new Uint8Array(buffer);
                operand.forEach(x => {
                  view[x >> 3] |= 1 << (x & 0x7);
                });
                return view;
              } // bad operand


              throw Error("operand to ".concat(selector, " must be a numeric bitmask (representable as a ") + 'non-negative 32-bit signed integer), a bindata bitmask or an array with ' + 'bit positions (non-negative integers)');
            }

            function getValueBitmask(value, length) {
              // The field value must be either numerical or a BinData instance. Otherwise,
              // $bits... will not match the current document.
              // numerical
              if (Number.isSafeInteger(value)) {
                // $bits... will not match numerical values that cannot be represented as a
                // signed 64-bit integer. This can be the case if a value is either too
                // large or small to fit in a signed 64-bit integer, or if it has a
                // fractional component.
                const buffer = new ArrayBuffer(Math.max(length, 2 * Uint32Array.BYTES_PER_ELEMENT));
                let view = new Uint32Array(buffer, 0, 2);
                view[0] = value % ((1 << 16) * (1 << 16)) | 0;
                view[1] = value / ((1 << 16) * (1 << 16)) | 0; // sign extension

                if (value < 0) {
                  view = new Uint8Array(buffer, 2);
                  view.forEach((byte, i) => {
                    view[i] = 0xff;
                  });
                }

                return new Uint8Array(buffer);
              } // bindata


              if (EJSON.isBinary(value)) {
                return new Uint8Array(value.buffer);
              } // no match


              return false;
            } // Actually inserts a key value into the selector document
            // However, this checks there is no ambiguity in setting
            // the value for the given key, throws otherwise


            function insertIntoDocument(document, key, value) {
              Object.keys(document).forEach(existingKey => {
                if (existingKey.length > key.length && existingKey.indexOf("".concat(key, ".")) === 0 || key.length > existingKey.length && key.indexOf("".concat(existingKey, ".")) === 0) {
                  throw new Error("cannot infer query fields to set, both paths '".concat(existingKey, "' and ") + "'".concat(key, "' are matched"));
                } else if (existingKey === key) {
                  throw new Error("cannot infer query fields to set, path '".concat(key, "' is matched twice"));
                }
              });
              document[key] = value;
            } // Returns a branched matcher that matches iff the given matcher does not.
            // Note that this implicitly "deMorganizes" the wrapped function.  ie, it
            // means that ALL branch values need to fail to match innerBranchedMatcher.


            function invertBranchedMatcher(branchedMatcher) {
              return branchValues => {
                // We explicitly choose to strip arrayIndices here: it doesn't make sense to
                // say "update the array element that does not match something", at least
                // in mongo-land.
                return {
                  result: !branchedMatcher(branchValues).result
                };
              };
            }

            function isIndexable(obj) {
              return Array.isArray(obj) || LocalCollection._isPlainObject(obj);
            }

            function isNumericKey(s) {
              return (/^[0-9]+$/.test(s)
              );
            }

            function isOperatorObject(valueSelector, inconsistentOK) {
              if (!LocalCollection._isPlainObject(valueSelector)) {
                return false;
              }

              let theseAreOperators = undefined;
              Object.keys(valueSelector).forEach(selKey => {
                const thisIsOperator = selKey.substr(0, 1) === '$';

                if (theseAreOperators === undefined) {
                  theseAreOperators = thisIsOperator;
                } else if (theseAreOperators !== thisIsOperator) {
                  if (!inconsistentOK) {
                    throw new Error("Inconsistent operator: ".concat(JSON.stringify(valueSelector)));
                  }

                  theseAreOperators = false;
                }
              });
              return !!theseAreOperators; // {} has no operators
            }

            // Helper for $lt/$gt/$lte/$gte.
            function makeInequality(cmpValueComparator) {
              return {
                compileElementSelector(operand) {
                  // Arrays never compare false with non-arrays for any inequality.
                  // XXX This was behavior we observed in pre-release MongoDB 2.5, but
                  //     it seems to have been reverted.
                  //     See https://jira.mongodb.org/browse/SERVER-11444
                  if (Array.isArray(operand)) {
                    return () => false;
                  } // Special case: consider undefined and null the same (so true with
                  // $gte/$lte).


                  if (operand === undefined) {
                    operand = null;
                  }

                  const operandType = LocalCollection._f._type(operand);

                  return value => {
                    if (value === undefined) {
                      value = null;
                    } // Comparisons are never true among things of different type (except
                    // null vs undefined).


                    if (LocalCollection._f._type(value) !== operandType) {
                      return false;
                    }

                    return cmpValueComparator(LocalCollection._f._cmp(value, operand));
                  };
                }

              };
            } // makeLookupFunction(key) returns a lookup function.
            //
            // A lookup function takes in a document and returns an array of matching
            // branches.  If no arrays are found while looking up the key, this array will
            // have exactly one branches (possibly 'undefined', if some segment of the key
            // was not found).
            //
            // If arrays are found in the middle, this can have more than one element, since
            // we 'branch'. When we 'branch', if there are more key segments to look up,
            // then we only pursue branches that are plain objects (not arrays or scalars).
            // This means we can actually end up with no branches!
            //
            // We do *NOT* branch on arrays that are found at the end (ie, at the last
            // dotted member of the key). We just return that array; if you want to
            // effectively 'branch' over the array's values, post-process the lookup
            // function with expandArraysInBranches.
            //
            // Each branch is an object with keys:
            //  - value: the value at the branch
            //  - dontIterate: an optional bool; if true, it means that 'value' is an array
            //    that expandArraysInBranches should NOT expand. This specifically happens
            //    when there is a numeric index in the key, and ensures the
            //    perhaps-surprising MongoDB behavior where {'a.0': 5} does NOT
            //    match {a: [[5]]}.
            //  - arrayIndices: if any array indexing was done during lookup (either due to
            //    explicit numeric indices or implicit branching), this will be an array of
            //    the array indices used, from outermost to innermost; it is falsey or
            //    absent if no array index is used. If an explicit numeric index is used,
            //    the index will be followed in arrayIndices by the string 'x'.
            //
            //    Note: arrayIndices is used for two purposes. First, it is used to
            //    implement the '$' modifier feature, which only ever looks at its first
            //    element.
            //
            //    Second, it is used for sort key generation, which needs to be able to tell
            //    the difference between different paths. Moreover, it needs to
            //    differentiate between explicit and implicit branching, which is why
            //    there's the somewhat hacky 'x' entry: this means that explicit and
            //    implicit array lookups will have different full arrayIndices paths. (That
            //    code only requires that different paths have different arrayIndices; it
            //    doesn't actually 'parse' arrayIndices. As an alternative, arrayIndices
            //    could contain objects with flags like 'implicit', but I think that only
            //    makes the code surrounding them more complex.)
            //
            //    (By the way, this field ends up getting passed around a lot without
            //    cloning, so never mutate any arrayIndices field/var in this package!)
            //
            //
            // At the top level, you may only pass in a plain object or array.
            //
            // See the test 'minimongo - lookup' for some examples of what lookup functions
            // return.


            function makeLookupFunction(key) {
              let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              const parts = key.split('.');
              const firstPart = parts.length ? parts[0] : '';
              const lookupRest = parts.length > 1 && makeLookupFunction(parts.slice(1).join('.'), options);

              const omitUnnecessaryFields = result => {
                if (!result.dontIterate) {
                  delete result.dontIterate;
                }

                if (result.arrayIndices && !result.arrayIndices.length) {
                  delete result.arrayIndices;
                }

                return result;
              }; // Doc will always be a plain object or an array.
              // apply an explicit numeric index, an array.


              return function (doc) {
                let arrayIndices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

                if (Array.isArray(doc)) {
                  // If we're being asked to do an invalid lookup into an array (non-integer
                  // or out-of-bounds), return no results (which is different from returning
                  // a single undefined result, in that `null` equality checks won't match).
                  if (!(isNumericKey(firstPart) && firstPart < doc.length)) {
                    return [];
                  } // Remember that we used this array index. Include an 'x' to indicate that
                  // the previous index came from being considered as an explicit array
                  // index (not branching).


                  arrayIndices = arrayIndices.concat(+firstPart, 'x');
                } // Do our first lookup.


                const firstLevel = doc[firstPart]; // If there is no deeper to dig, return what we found.
                //
                // If what we found is an array, most value selectors will choose to treat
                // the elements of the array as matchable values in their own right, but
                // that's done outside of the lookup function. (Exceptions to this are $size
                // and stuff relating to $elemMatch.  eg, {a: {$size: 2}} does not match {a:
                // [[1, 2]]}.)
                //
                // That said, if we just did an *explicit* array lookup (on doc) to find
                // firstLevel, and firstLevel is an array too, we do NOT want value
                // selectors to iterate over it.  eg, {'a.0': 5} does not match {a: [[5]]}.
                // So in that case, we mark the return value as 'don't iterate'.

                if (!lookupRest) {
                  return [omitUnnecessaryFields({
                    arrayIndices,
                    dontIterate: Array.isArray(doc) && Array.isArray(firstLevel),
                    value: firstLevel
                  })];
                } // We need to dig deeper.  But if we can't, because what we've found is not
                // an array or plain object, we're done. If we just did a numeric index into
                // an array, we return nothing here (this is a change in Mongo 2.5 from
                // Mongo 2.4, where {'a.0.b': null} stopped matching {a: [5]}). Otherwise,
                // return a single `undefined` (which can, for example, match via equality
                // with `null`).


                if (!isIndexable(firstLevel)) {
                  if (Array.isArray(doc)) {
                    return [];
                  }

                  return [omitUnnecessaryFields({
                    arrayIndices,
                    value: undefined
                  })];
                }

                const result = [];

                const appendToResult = more => {
                  result.push(...more);
                }; // Dig deeper: look up the rest of the parts on whatever we've found.
                // (lookupRest is smart enough to not try to do invalid lookups into
                // firstLevel if it's an array.)


                appendToResult(lookupRest(firstLevel, arrayIndices)); // If we found an array, then in *addition* to potentially treating the next
                // part as a literal integer lookup, we should also 'branch': try to look up
                // the rest of the parts on each array element in parallel.
                //
                // In this case, we *only* dig deeper into array elements that are plain
                // objects. (Recall that we only got this far if we have further to dig.)
                // This makes sense: we certainly don't dig deeper into non-indexable
                // objects. And it would be weird to dig into an array: it's simpler to have
                // a rule that explicit integer indexes only apply to an outer array, not to
                // an array you find after a branching search.
                //
                // In the special case of a numeric part in a *sort selector* (not a query
                // selector), we skip the branching: we ONLY allow the numeric part to mean
                // 'look up this index' in that case, not 'also look up this index in all
                // the elements of the array'.

                if (Array.isArray(firstLevel) && !(isNumericKey(parts[1]) && options.forSort)) {
                  firstLevel.forEach((branch, arrayIndex) => {
                    if (LocalCollection._isPlainObject(branch)) {
                      appendToResult(lookupRest(branch, arrayIndices.concat(arrayIndex)));
                    }
                  });
                }

                return result;
              };
            }

            // Object exported only for unit testing.
            // Use it to export private functions to test in Tinytest.
            MinimongoTest = {
              makeLookupFunction
            };

            MinimongoError = function (message) {
              let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (typeof message === 'string' && options.field) {
                message += " for field '".concat(options.field, "'");
              }

              const error = new Error(message);
              error.name = 'MinimongoError';
              return error;
            };

            function nothingMatcher(docOrBranchedValues) {
              return {
                result: false
              };
            }

            // Takes an operator object (an object with $ keys) and returns a branched
            // matcher for it.
            function operatorBranchedMatcher(valueSelector, matcher, isRoot) {
              // Each valueSelector works separately on the various branches.  So one
              // operator can match one branch and another can match another branch.  This
              // is OK.
              const operatorMatchers = Object.keys(valueSelector).map(operator => {
                const operand = valueSelector[operator];
                const simpleRange = ['$lt', '$lte', '$gt', '$gte'].includes(operator) && typeof operand === 'number';
                const simpleEquality = ['$ne', '$eq'].includes(operator) && operand !== Object(operand);
                const simpleInclusion = ['$in', '$nin'].includes(operator) && Array.isArray(operand) && !operand.some(x => x === Object(x));

                if (!(simpleRange || simpleInclusion || simpleEquality)) {
                  matcher._isSimple = false;
                }

                if (hasOwn.call(VALUE_OPERATORS, operator)) {
                  return VALUE_OPERATORS[operator](operand, valueSelector, matcher, isRoot);
                }

                if (hasOwn.call(ELEMENT_OPERATORS, operator)) {
                  const options = ELEMENT_OPERATORS[operator];
                  return convertElementMatcherToBranchedMatcher(options.compileElementSelector(operand, valueSelector, matcher), options);
                }

                throw new Error("Unrecognized operator: ".concat(operator));
              });
              return andBranchedMatchers(operatorMatchers);
            } // paths - Array: list of mongo style paths
            // newLeafFn - Function: of form function(path) should return a scalar value to
            //                       put into list created for that path
            // conflictFn - Function: of form function(node, path, fullPath) is called
            //                        when building a tree path for 'fullPath' node on
            //                        'path' was already a leaf with a value. Must return a
            //                        conflict resolution.
            // initial tree - Optional Object: starting tree.
            // @returns - Object: tree represented as a set of nested objects


            function pathsToTree(paths, newLeafFn, conflictFn) {
              let root = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              paths.forEach(path => {
                const pathArray = path.split('.');
                let tree = root; // use .every just for iteration with break

                const success = pathArray.slice(0, -1).every((key, i) => {
                  if (!hasOwn.call(tree, key)) {
                    tree[key] = {};
                  } else if (tree[key] !== Object(tree[key])) {
                    tree[key] = conflictFn(tree[key], pathArray.slice(0, i + 1).join('.'), path); // break out of loop if we are failing for this path

                    if (tree[key] !== Object(tree[key])) {
                      return false;
                    }
                  }

                  tree = tree[key];
                  return true;
                });

                if (success) {
                  const lastKey = pathArray[pathArray.length - 1];

                  if (hasOwn.call(tree, lastKey)) {
                    tree[lastKey] = conflictFn(tree[lastKey], path, path);
                  } else {
                    tree[lastKey] = newLeafFn(path);
                  }
                }
              });
              return root;
            }

            // Makes sure we get 2 elements array and assume the first one to be x and
            // the second one to y no matter what user passes.
            // In case user passes { lon: x, lat: y } returns [x, y]
            function pointToArray(point) {
              return Array.isArray(point) ? point.slice() : [point.x, point.y];
            } // Creating a document from an upsert is quite tricky.
            // E.g. this selector: {"$or": [{"b.foo": {"$all": ["bar"]}}]}, should result
            // in: {"b.foo": "bar"}
            // But this selector: {"$or": [{"b": {"foo": {"$all": ["bar"]}}}]} should throw
            // an error
            // Some rules (found mainly with trial & error, so there might be more):
            // - handle all childs of $and (or implicit $and)
            // - handle $or nodes with exactly 1 child
            // - ignore $or nodes with more than 1 child
            // - ignore $nor and $not nodes
            // - throw when a value can not be set unambiguously
            // - every value for $all should be dealt with as separate $eq-s
            // - threat all children of $all as $eq setters (=> set if $all.length === 1,
            //   otherwise throw error)
            // - you can not mix '$'-prefixed keys and non-'$'-prefixed keys
            // - you can only have dotted keys on a root-level
            // - you can not have '$'-prefixed keys more than one-level deep in an object
            // Handles one key/value pair to put in the selector document


            function populateDocumentWithKeyValue(document, key, value) {
              if (value && Object.getPrototypeOf(value) === Object.prototype) {
                populateDocumentWithObject(document, key, value);
              } else if (!(value instanceof RegExp)) {
                insertIntoDocument(document, key, value);
              }
            } // Handles a key, value pair to put in the selector document
            // if the value is an object


            function populateDocumentWithObject(document, key, value) {
              const keys = Object.keys(value);
              const unprefixedKeys = keys.filter(op => op[0] !== '$');

              if (unprefixedKeys.length > 0 || !keys.length) {
                // Literal (possibly empty) object ( or empty object )
                // Don't allow mixing '$'-prefixed with non-'$'-prefixed fields
                if (keys.length !== unprefixedKeys.length) {
                  throw new Error("unknown operator: ".concat(unprefixedKeys[0]));
                }

                validateObject(value, key);
                insertIntoDocument(document, key, value);
              } else {
                Object.keys(value).forEach(op => {
                  const object = value[op];

                  if (op === '$eq') {
                    populateDocumentWithKeyValue(document, key, object);
                  } else if (op === '$all') {
                    // every value for $all should be dealt with as separate $eq-s
                    object.forEach(element => populateDocumentWithKeyValue(document, key, element));
                  }
                });
              }
            } // Fills a document with certain fields from an upsert selector


            function populateDocumentWithQueryFields(query) {
              let document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (Object.getPrototypeOf(query) === Object.prototype) {
                // handle implicit $and
                Object.keys(query).forEach(key => {
                  const value = query[key];

                  if (key === '$and') {
                    // handle explicit $and
                    value.forEach(element => populateDocumentWithQueryFields(element, document));
                  } else if (key === '$or') {
                    // handle $or nodes with exactly 1 child
                    if (value.length === 1) {
                      populateDocumentWithQueryFields(value[0], document);
                    }
                  } else if (key[0] !== '$') {
                    // Ignore other '$'-prefixed logical selectors
                    populateDocumentWithKeyValue(document, key, value);
                  }
                });
              } else {
                // Handle meteor-specific shortcut for selecting _id
                if (LocalCollection._selectorIsId(query)) {
                  insertIntoDocument(document, '_id', query);
                }
              }

              return document;
            }

            function projectionDetails(fields) {
              // Find the non-_id keys (_id is handled specially because it is included
              // unless explicitly excluded). Sort the keys, so that our code to detect
              // overlaps like 'foo' and 'foo.bar' can assume that 'foo' comes first.
              let fieldsKeys = Object.keys(fields).sort(); // If _id is the only field in the projection, do not remove it, since it is
              // required to determine if this is an exclusion or exclusion. Also keep an
              // inclusive _id, since inclusive _id follows the normal rules about mixing
              // inclusive and exclusive fields. If _id is not the only field in the
              // projection and is exclusive, remove it so it can be handled later by a
              // special case, since exclusive _id is always allowed.

              if (!(fieldsKeys.length === 1 && fieldsKeys[0] === '_id') && !(fieldsKeys.includes('_id') && fields._id)) {
                fieldsKeys = fieldsKeys.filter(key => key !== '_id');
              }

              let including = null; // Unknown

              fieldsKeys.forEach(keyPath => {
                const rule = !!fields[keyPath];

                if (including === null) {
                  including = rule;
                } // This error message is copied from MongoDB shell


                if (including !== rule) {
                  throw MinimongoError('You cannot currently mix including and excluding fields.');
                }
              });
              const projectionRulesTree = pathsToTree(fieldsKeys, path => including, (node, path, fullPath) => {
                // Check passed projection fields' keys: If you have two rules such as
                // 'foo.bar' and 'foo.bar.baz', then the result becomes ambiguous. If
                // that happens, there is a probability you are doing something wrong,
                // framework should notify you about such mistake earlier on cursor
                // compilation step than later during runtime.  Note, that real mongo
                // doesn't do anything about it and the later rule appears in projection
                // project, more priority it takes.
                //
                // Example, assume following in mongo shell:
                // > db.coll.insert({ a: { b: 23, c: 44 } })
                // > db.coll.find({}, { 'a': 1, 'a.b': 1 })
                // {"_id": ObjectId("520bfe456024608e8ef24af3"), "a": {"b": 23}}
                // > db.coll.find({}, { 'a.b': 1, 'a': 1 })
                // {"_id": ObjectId("520bfe456024608e8ef24af3"), "a": {"b": 23, "c": 44}}
                //
                // Note, how second time the return set of keys is different.
                const currentPath = fullPath;
                const anotherPath = path;
                throw MinimongoError("both ".concat(currentPath, " and ").concat(anotherPath, " found in fields option, ") + 'using both of them may trigger unexpected behavior. Did you mean to ' + 'use only one of them?');
              });
              return {
                including,
                tree: projectionRulesTree
              };
            }

            function regexpElementMatcher(regexp) {
              return value => {
                if (value instanceof RegExp) {
                  return value.toString() === regexp.toString();
                } // Regexps only work against strings.


                if (typeof value !== 'string') {
                  return false;
                } // Reset regexp's state to avoid inconsistent matching for objects with the
                // same value on consecutive calls of regexp.test. This happens only if the
                // regexp has the 'g' flag. Also note that ES6 introduces a new flag 'y' for
                // which we should *not* change the lastIndex but MongoDB doesn't support
                // either of these flags.


                regexp.lastIndex = 0;
                return regexp.test(value);
              };
            }

            // Validates the key in a path.
            // Objects that are nested more then 1 level cannot have dotted fields
            // or fields starting with '$'
            function validateKeyInPath(key, path) {
              if (key.includes('.')) {
                throw new Error("The dotted field '".concat(key, "' in '").concat(path, ".").concat(key, " is not valid for storage."));
              }

              if (key[0] === '$') {
                throw new Error("The dollar ($) prefixed field  '".concat(path, ".").concat(key, " is not valid for storage."));
              }
            } // Recursively validates an object that is nested more than one level deep


            function validateObject(object, path) {
              if (object && Object.getPrototypeOf(object) === Object.prototype) {
                Object.keys(object).forEach(key => {
                  validateKeyInPath(key, path);
                  validateObject(object[key], path + '.' + key);
                });
              }
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "cursor.js": function module(_require4, _exports4, _module3) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/cursor.js                                                                                        //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module3.export({
              default: () => Cursor
            });
            let LocalCollection;
            _module3.link("./local_collection.js", {
              default(v) {
                LocalCollection = v;
              }

            }, 0);
            let hasOwn;
            _module3.link("./common.js", {
              hasOwn(v) {
                hasOwn = v;
              }

            }, 1);

            class Cursor {
              // don't call this ctor directly.  use LocalCollection.find().
              constructor(collection, selector) {
                let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.collection = collection;
                this.sorter = null;
                this.matcher = new Minimongo.Matcher(selector);

                if (LocalCollection._selectorIsIdPerhapsAsObject(selector)) {
                  // stash for fast _id and { _id }
                  this._selectorId = hasOwn.call(selector, '_id') ? selector._id : selector;
                } else {
                  this._selectorId = undefined;

                  if (this.matcher.hasGeoQuery() || options.sort) {
                    this.sorter = new Minimongo.Sorter(options.sort || []);
                  }
                }

                this.skip = options.skip || 0;
                this.limit = options.limit;
                this.fields = options.fields;
                this._projectionFn = LocalCollection._compileProjection(this.fields || {});
                this._transform = LocalCollection.wrapTransform(options.transform); // by default, queries register w/ Tracker when it is available.

                if (typeof Tracker !== 'undefined') {
                  this.reactive = options.reactive === undefined ? true : options.reactive;
                }
              }
              /**
               * @summary Returns the number of documents that match a query.
               * @memberOf Mongo.Cursor
               * @method  count
               * @param {boolean} [applySkipLimit=true] If set to `false`, the value
               *                                         returned will reflect the total
               *                                         number of matching documents,
               *                                         ignoring any value supplied for
               *                                         limit
               * @instance
               * @locus Anywhere
               * @returns {Number}
               */

              count() {
                let applySkipLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                if (this.reactive) {
                  // allow the observe to be unordered
                  this._depend({
                    added: true,
                    removed: true
                  }, true);
                }

                return this._getRawObjects({
                  ordered: true,
                  applySkipLimit
                }).length;
              }
              /**
               * @summary Return all matching documents as an Array.
               * @memberOf Mongo.Cursor
               * @method  fetch
               * @instance
               * @locus Anywhere
               * @returns {Object[]}
               */

              fetch() {
                const result = [];
                this.forEach(doc => {
                  result.push(doc);
                });
                return result;
              }

              [Symbol.iterator]() {
                if (this.reactive) {
                  this._depend({
                    addedBefore: true,
                    removed: true,
                    changed: true,
                    movedBefore: true
                  });
                }

                let index = 0;

                const objects = this._getRawObjects({
                  ordered: true
                });

                return {
                  next: () => {
                    if (index < objects.length) {
                      // This doubles as a clone operation.
                      let element = this._projectionFn(objects[index++]);

                      if (this._transform) element = this._transform(element);
                      return {
                        value: element
                      };
                    }

                    return {
                      done: true
                    };
                  }
                };
              }
              /**
               * @callback IterationCallback
               * @param {Object} doc
               * @param {Number} index
               */

              /**
               * @summary Call `callback` once for each matching document, sequentially and
               *          synchronously.
               * @locus Anywhere
               * @method  forEach
               * @instance
               * @memberOf Mongo.Cursor
               * @param {IterationCallback} callback Function to call. It will be called
               *                                     with three arguments: the document, a
               *                                     0-based index, and <em>cursor</em>
               *                                     itself.
               * @param {Any} [thisArg] An object which will be the value of `this` inside
               *                        `callback`.
               */

              forEach(callback, thisArg) {
                if (this.reactive) {
                  this._depend({
                    addedBefore: true,
                    removed: true,
                    changed: true,
                    movedBefore: true
                  });
                }

                this._getRawObjects({
                  ordered: true
                }).forEach((element, i) => {
                  // This doubles as a clone operation.
                  element = this._projectionFn(element);

                  if (this._transform) {
                    element = this._transform(element);
                  }

                  callback.call(thisArg, element, i, this);
                });
              }

              getTransform() {
                return this._transform;
              }
              /**
               * @summary Map callback over all matching documents.  Returns an Array.
               * @locus Anywhere
               * @method map
               * @instance
               * @memberOf Mongo.Cursor
               * @param {IterationCallback} callback Function to call. It will be called
               *                                     with three arguments: the document, a
               *                                     0-based index, and <em>cursor</em>
               *                                     itself.
               * @param {Any} [thisArg] An object which will be the value of `this` inside
               *                        `callback`.
               */

              map(callback, thisArg) {
                const result = [];
                this.forEach((doc, i) => {
                  result.push(callback.call(thisArg, doc, i, this));
                });
                return result;
              } // options to contain:
              //  * callbacks for observe():
              //    - addedAt (document, atIndex)
              //    - added (document)
              //    - changedAt (newDocument, oldDocument, atIndex)
              //    - changed (newDocument, oldDocument)
              //    - removedAt (document, atIndex)
              //    - removed (document)
              //    - movedTo (document, oldIndex, newIndex)
              //
              // attributes available on returned query handle:
              //  * stop(): end updates
              //  * collection: the collection this query is querying
              //
              // iff x is a returned query handle, (x instanceof
              // LocalCollection.ObserveHandle) is true
              //
              // initial results delivered through added callback
              // XXX maybe callbacks should take a list of objects, to expose transactions?
              // XXX maybe support field limiting (to limit what you're notified on)

              /**
               * @summary Watch a query.  Receive callbacks as the result set changes.
               * @locus Anywhere
               * @memberOf Mongo.Cursor
               * @instance
               * @param {Object} callbacks Functions to call to deliver the result set as it
               *                           changes
               */

              observe(options) {
                return LocalCollection._observeFromObserveChanges(this, options);
              }
              /**
               * @summary Watch a query. Receive callbacks as the result set changes. Only
               *          the differences between the old and new documents are passed to
               *          the callbacks.
               * @locus Anywhere
               * @memberOf Mongo.Cursor
               * @instance
               * @param {Object} callbacks Functions to call to deliver the result set as it
               *                           changes
               */

              observeChanges(options) {
                const ordered = LocalCollection._observeChangesCallbacksAreOrdered(options); // there are several places that assume you aren't combining skip/limit with
                // unordered observe.  eg, update's EJSON.clone, and the "there are several"
                // comment in _modifyAndNotify
                // XXX allow skip/limit with unordered observe


                if (!options._allow_unordered && !ordered && (this.skip || this.limit)) {
                  throw new Error("Must use an ordered observe with skip or limit (i.e. 'addedBefore' " + "for observeChanges or 'addedAt' for observe, instead of 'added').");
                }

                if (this.fields && (this.fields._id === 0 || this.fields._id === false)) {
                  throw Error('You may not observe a cursor with {fields: {_id: 0}}');
                }

                const distances = this.matcher.hasGeoQuery() && ordered && new LocalCollection._IdMap();
                const query = {
                  cursor: this,
                  dirty: false,
                  distances,
                  matcher: this.matcher,
                  // not fast pathed
                  ordered,
                  projectionFn: this._projectionFn,
                  resultsSnapshot: null,
                  sorter: ordered && this.sorter
                };
                let qid; // Non-reactive queries call added[Before] and then never call anything
                // else.

                if (this.reactive) {
                  qid = this.collection.next_qid++;
                  this.collection.queries[qid] = query;
                }

                query.results = this._getRawObjects({
                  ordered,
                  distances: query.distances
                });

                if (this.collection.paused) {
                  query.resultsSnapshot = ordered ? [] : new LocalCollection._IdMap();
                } // wrap callbacks we were passed. callbacks only fire when not paused and
                // are never undefined
                // Filters out blacklisted fields according to cursor's projection.
                // XXX wrong place for this?
                // furthermore, callbacks enqueue until the operation we're working on is
                // done.


                const wrapCallback = fn => {
                  if (!fn) {
                    return () => {};
                  }

                  const self = this;
                  return function () {
                    if (self.collection.paused) {
                      return;
                    }

                    const args = arguments;

                    self.collection._observeQueue.queueTask(() => {
                      fn.apply(this, args);
                    });
                  };
                };

                query.added = wrapCallback(options.added);
                query.changed = wrapCallback(options.changed);
                query.removed = wrapCallback(options.removed);

                if (ordered) {
                  query.addedBefore = wrapCallback(options.addedBefore);
                  query.movedBefore = wrapCallback(options.movedBefore);
                }

                if (!options._suppress_initial && !this.collection.paused) {
                  query.results.forEach(doc => {
                    const fields = EJSON.clone(doc);
                    delete fields._id;

                    if (ordered) {
                      query.addedBefore(doc._id, this._projectionFn(fields), null);
                    }

                    query.added(doc._id, this._projectionFn(fields));
                  });
                }

                const handle = Object.assign(new LocalCollection.ObserveHandle(), {
                  collection: this.collection,
                  stop: () => {
                    if (this.reactive) {
                      delete this.collection.queries[qid];
                    }
                  }
                });

                if (this.reactive && Tracker.active) {
                  // XXX in many cases, the same observe will be recreated when
                  // the current autorun is rerun.  we could save work by
                  // letting it linger across rerun and potentially get
                  // repurposed if the same observe is performed, using logic
                  // similar to that of Meteor.subscribe.
                  Tracker.onInvalidate(() => {
                    handle.stop();
                  });
                } // run the observe callbacks resulting from the initial contents
                // before we leave the observe.


                this.collection._observeQueue.drain();

                return handle;
              } // Since we don't actually have a "nextObject" interface, there's really no
              // reason to have a "rewind" interface.  All it did was make multiple calls
              // to fetch/map/forEach return nothing the second time.
              // XXX COMPAT WITH 0.8.1


              rewind() {} // XXX Maybe we need a version of observe that just calls a callback if
              // anything changed.


              _depend(changers, _allow_unordered) {
                if (Tracker.active) {
                  const dependency = new Tracker.Dependency();
                  const notify = dependency.changed.bind(dependency);
                  dependency.depend();
                  const options = {
                    _allow_unordered,
                    _suppress_initial: true
                  };
                  ['added', 'addedBefore', 'changed', 'movedBefore', 'removed'].forEach(fn => {
                    if (changers[fn]) {
                      options[fn] = notify;
                    }
                  }); // observeChanges will stop() when this computation is invalidated

                  this.observeChanges(options);
                }
              }

              _getCollectionName() {
                return this.collection.name;
              } // Returns a collection of matching objects, but doesn't deep copy them.
              //
              // If ordered is set, returns a sorted array, respecting sorter, skip, and
              // limit properties of the query provided that options.applySkipLimit is
              // not set to false (#1201). If sorter is falsey, no sort -- you get the
              // natural order.
              //
              // If ordered is not set, returns an object mapping from ID to doc (sorter,
              // skip and limit should not be set).
              //
              // If ordered is set and this cursor is a $near geoquery, then this function
              // will use an _IdMap to track each distance from the $near argument point in
              // order to use it as a sort key. If an _IdMap is passed in the 'distances'
              // argument, this function will clear it and use it for this purpose
              // (otherwise it will just create its own _IdMap). The observeChanges
              // implementation uses this to remember the distances after this function
              // returns.


              _getRawObjects() {
                let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                // By default this method will respect skip and limit because .fetch(),
                // .forEach() etc... expect this behaviour. It can be forced to ignore
                // skip and limit by setting applySkipLimit to false (.count() does this,
                // for example)
                const applySkipLimit = options.applySkipLimit !== false; // XXX use OrderedDict instead of array, and make IdMap and OrderedDict
                // compatible

                const results = options.ordered ? [] : new LocalCollection._IdMap(); // fast path for single ID value

                if (this._selectorId !== undefined) {
                  // If you have non-zero skip and ask for a single id, you get nothing.
                  // This is so it matches the behavior of the '{_id: foo}' path.
                  if (applySkipLimit && this.skip) {
                    return results;
                  }

                  const selectedDoc = this.collection._docs.get(this._selectorId);

                  if (selectedDoc) {
                    if (options.ordered) {
                      results.push(selectedDoc);
                    } else {
                      results.set(this._selectorId, selectedDoc);
                    }
                  }

                  return results;
                } // slow path for arbitrary selector, sort, skip, limit
                // in the observeChanges case, distances is actually part of the "query"
                // (ie, live results set) object.  in other cases, distances is only used
                // inside this function.


                let distances;

                if (this.matcher.hasGeoQuery() && options.ordered) {
                  if (options.distances) {
                    distances = options.distances;
                    distances.clear();
                  } else {
                    distances = new LocalCollection._IdMap();
                  }
                }

                this.collection._docs.forEach((doc, id) => {
                  const matchResult = this.matcher.documentMatches(doc);

                  if (matchResult.result) {
                    if (options.ordered) {
                      results.push(doc);

                      if (distances && matchResult.distance !== undefined) {
                        distances.set(id, matchResult.distance);
                      }
                    } else {
                      results.set(id, doc);
                    }
                  } // Override to ensure all docs are matched if ignoring skip & limit


                  if (!applySkipLimit) {
                    return true;
                  } // Fast path for limited unsorted queries.
                  // XXX 'length' check here seems wrong for ordered


                  return !this.limit || this.skip || this.sorter || results.length !== this.limit;
                });

                if (!options.ordered) {
                  return results;
                }

                if (this.sorter) {
                  results.sort(this.sorter.getComparator({
                    distances
                  }));
                } // Return the full set of results if there is no skip or limit or if we're
                // ignoring them


                if (!applySkipLimit || !this.limit && !this.skip) {
                  return results;
                }

                return results.slice(this.skip, this.limit ? this.limit + this.skip : results.length);
              }

              _publishCursor(subscription) {
                // XXX minimongo should not depend on mongo-livedata!
                if (!Package.mongo) {
                  throw new Error('Can\'t publish from Minimongo without the `mongo` package.');
                }

                if (!this.collection.name) {
                  throw new Error('Can\'t publish a cursor from a collection without a name.');
                }

                return Package.mongo.Mongo.Collection._publishCursor(this, subscription, this.collection.name);
              }

            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "local_collection.js": function module(_require5, _exports5, _module4) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/local_collection.js                                                                              //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module4.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module4.export({
              default: () => LocalCollection
            });
            let Cursor;
            _module4.link("./cursor.js", {
              default(v) {
                Cursor = v;
              }

            }, 0);
            let ObserveHandle;
            _module4.link("./observe_handle.js", {
              default(v) {
                ObserveHandle = v;
              }

            }, 1);
            let hasOwn, isIndexable, isNumericKey, isOperatorObject, populateDocumentWithQueryFields, projectionDetails;
            _module4.link("./common.js", {
              hasOwn(v) {
                hasOwn = v;
              },

              isIndexable(v) {
                isIndexable = v;
              },

              isNumericKey(v) {
                isNumericKey = v;
              },

              isOperatorObject(v) {
                isOperatorObject = v;
              },

              populateDocumentWithQueryFields(v) {
                populateDocumentWithQueryFields = v;
              },

              projectionDetails(v) {
                projectionDetails = v;
              }

            }, 2);

            class LocalCollection {
              constructor(name) {
                this.name = name; // _id -> document (also containing id)

                this._docs = new LocalCollection._IdMap();
                this._observeQueue = new Meteor._SynchronousQueue();
                this.next_qid = 1; // live query id generator
                // qid -> live query object. keys:
                //  ordered: bool. ordered queries have addedBefore/movedBefore callbacks.
                //  results: array (ordered) or object (unordered) of current results
                //    (aliased with this._docs!)
                //  resultsSnapshot: snapshot of results. null if not paused.
                //  cursor: Cursor object for the query.
                //  selector, sorter, (callbacks): functions

                this.queries = Object.create(null); // null if not saving originals; an IdMap from id to original document value
                // if saving originals. See comments before saveOriginals().

                this._savedOriginals = null; // True when observers are paused and we should not send callbacks.

                this.paused = false;
              } // options may include sort, skip, limit, reactive
              // sort may be any of these forms:
              //     {a: 1, b: -1}
              //     [["a", "asc"], ["b", "desc"]]
              //     ["a", ["b", "desc"]]
              //   (in the first form you're beholden to key enumeration order in
              //   your javascript VM)
              //
              // reactive: if given, and false, don't register with Tracker (default
              // is true)
              //
              // XXX possibly should support retrieving a subset of fields? and
              // have it be a hint (ignored on the client, when not copying the
              // doc?)
              //
              // XXX sort does not yet support subkeys ('a.b') .. fix that!
              // XXX add one more sort form: "key"
              // XXX tests


              find(selector, options) {
                // default syntax for everything is to omit the selector argument.
                // but if selector is explicitly passed in as false or undefined, we
                // want a selector that matches nothing.
                if (arguments.length === 0) {
                  selector = {};
                }

                return new LocalCollection.Cursor(this, selector, options);
              }

              findOne(selector) {
                let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (arguments.length === 0) {
                  selector = {};
                } // NOTE: by setting limit 1 here, we end up using very inefficient
                // code that recomputes the whole query on each update. The upside is
                // that when you reactively depend on a findOne you only get
                // invalidated when the found object changes, not any object in the
                // collection. Most findOne will be by id, which has a fast path, so
                // this might not be a big deal. In most cases, invalidation causes
                // the called to re-query anyway, so this should be a net performance
                // improvement.


                options.limit = 1;
                return this.find(selector, options).fetch()[0];
              } // XXX possibly enforce that 'undefined' does not appear (we assume
              // this in our handling of null and $exists)


              insert(doc, callback) {
                doc = EJSON.clone(doc);
                assertHasValidFieldNames(doc); // if you really want to use ObjectIDs, set this global.
                // Mongo.Collection specifies its own ids and does not use this code.

                if (!hasOwn.call(doc, '_id')) {
                  doc._id = LocalCollection._useOID ? new MongoID.ObjectID() : Random.id();
                }

                const id = doc._id;

                if (this._docs.has(id)) {
                  throw MinimongoError("Duplicate _id '".concat(id, "'"));
                }

                this._saveOriginal(id, undefined);

                this._docs.set(id, doc);

                const queriesToRecompute = []; // trigger live queries that match

                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];

                  if (query.dirty) {
                    return;
                  }

                  const matchResult = query.matcher.documentMatches(doc);

                  if (matchResult.result) {
                    if (query.distances && matchResult.distance !== undefined) {
                      query.distances.set(id, matchResult.distance);
                    }

                    if (query.cursor.skip || query.cursor.limit) {
                      queriesToRecompute.push(qid);
                    } else {
                      LocalCollection._insertInResults(query, doc);
                    }
                  }
                });
                queriesToRecompute.forEach(qid => {
                  if (this.queries[qid]) {
                    this._recomputeResults(this.queries[qid]);
                  }
                });

                this._observeQueue.drain(); // Defer because the caller likely doesn't expect the callback to be run
                // immediately.


                if (callback) {
                  Meteor.defer(() => {
                    callback(null, id);
                  });
                }

                return id;
              } // Pause the observers. No callbacks from observers will fire until
              // 'resumeObservers' is called.


              pauseObservers() {
                // No-op if already paused.
                if (this.paused) {
                  return;
                } // Set the 'paused' flag such that new observer messages don't fire.


                this.paused = true; // Take a snapshot of the query results for each query.

                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];
                  query.resultsSnapshot = EJSON.clone(query.results);
                });
              }

              remove(selector, callback) {
                // Easy special case: if we're not calling observeChanges callbacks and
                // we're not saving originals and we got asked to remove everything, then
                // just empty everything directly.
                if (this.paused && !this._savedOriginals && EJSON.equals(selector, {})) {
                  const result = this._docs.size();

                  this._docs.clear();

                  Object.keys(this.queries).forEach(qid => {
                    const query = this.queries[qid];

                    if (query.ordered) {
                      query.results = [];
                    } else {
                      query.results.clear();
                    }
                  });

                  if (callback) {
                    Meteor.defer(() => {
                      callback(null, result);
                    });
                  }

                  return result;
                }

                const matcher = new Minimongo.Matcher(selector);
                const remove = [];

                this._eachPossiblyMatchingDoc(selector, (doc, id) => {
                  if (matcher.documentMatches(doc).result) {
                    remove.push(id);
                  }
                });

                const queriesToRecompute = [];
                const queryRemove = [];

                for (let i = 0; i < remove.length; i++) {
                  const removeId = remove[i];

                  const removeDoc = this._docs.get(removeId);

                  Object.keys(this.queries).forEach(qid => {
                    const query = this.queries[qid];

                    if (query.dirty) {
                      return;
                    }

                    if (query.matcher.documentMatches(removeDoc).result) {
                      if (query.cursor.skip || query.cursor.limit) {
                        queriesToRecompute.push(qid);
                      } else {
                        queryRemove.push({
                          qid,
                          doc: removeDoc
                        });
                      }
                    }
                  });

                  this._saveOriginal(removeId, removeDoc);

                  this._docs.remove(removeId);
                } // run live query callbacks _after_ we've removed the documents.


                queryRemove.forEach(remove => {
                  const query = this.queries[remove.qid];

                  if (query) {
                    query.distances && query.distances.remove(remove.doc._id);

                    LocalCollection._removeFromResults(query, remove.doc);
                  }
                });
                queriesToRecompute.forEach(qid => {
                  const query = this.queries[qid];

                  if (query) {
                    this._recomputeResults(query);
                  }
                });

                this._observeQueue.drain();

                const result = remove.length;

                if (callback) {
                  Meteor.defer(() => {
                    callback(null, result);
                  });
                }

                return result;
              } // Resume the observers. Observers immediately receive change
              // notifications to bring them to the current state of the
              // database. Note that this is not just replaying all the changes that
              // happened during the pause, it is a smarter 'coalesced' diff.


              resumeObservers() {
                // No-op if not paused.
                if (!this.paused) {
                  return;
                } // Unset the 'paused' flag. Make sure to do this first, otherwise
                // observer methods won't actually fire when we trigger them.


                this.paused = false;
                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];

                  if (query.dirty) {
                    query.dirty = false; // re-compute results will perform `LocalCollection._diffQueryChanges`
                    // automatically.

                    this._recomputeResults(query, query.resultsSnapshot);
                  } else {
                    // Diff the current results against the snapshot and send to observers.
                    // pass the query object for its observer callbacks.
                    LocalCollection._diffQueryChanges(query.ordered, query.resultsSnapshot, query.results, query, {
                      projectionFn: query.projectionFn
                    });
                  }

                  query.resultsSnapshot = null;
                });

                this._observeQueue.drain();
              }

              retrieveOriginals() {
                if (!this._savedOriginals) {
                  throw new Error('Called retrieveOriginals without saveOriginals');
                }

                const originals = this._savedOriginals;
                this._savedOriginals = null;
                return originals;
              } // To track what documents are affected by a piece of code, call
              // saveOriginals() before it and retrieveOriginals() after it.
              // retrieveOriginals returns an object whose keys are the ids of the documents
              // that were affected since the call to saveOriginals(), and the values are
              // equal to the document's contents at the time of saveOriginals. (In the case
              // of an inserted document, undefined is the value.) You must alternate
              // between calls to saveOriginals() and retrieveOriginals().


              saveOriginals() {
                if (this._savedOriginals) {
                  throw new Error('Called saveOriginals twice without retrieveOriginals');
                }

                this._savedOriginals = new LocalCollection._IdMap();
              } // XXX atomicity: if multi is true, and one modification fails, do
              // we rollback the whole operation, or what?


              update(selector, mod, options, callback) {
                if (!callback && options instanceof Function) {
                  callback = options;
                  options = null;
                }

                if (!options) {
                  options = {};
                }

                const matcher = new Minimongo.Matcher(selector, true); // Save the original results of any query that we might need to
                // _recomputeResults on, because _modifyAndNotify will mutate the objects in
                // it. (We don't need to save the original results of paused queries because
                // they already have a resultsSnapshot and we won't be diffing in
                // _recomputeResults.)

                const qidToOriginalResults = {}; // We should only clone each document once, even if it appears in multiple
                // queries

                const docMap = new LocalCollection._IdMap();

                const idsMatched = LocalCollection._idsMatchedBySelector(selector);

                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];

                  if ((query.cursor.skip || query.cursor.limit) && !this.paused) {
                    // Catch the case of a reactive `count()` on a cursor with skip
                    // or limit, which registers an unordered observe. This is a
                    // pretty rare case, so we just clone the entire result set with
                    // no optimizations for documents that appear in these result
                    // sets and other queries.
                    if (query.results instanceof LocalCollection._IdMap) {
                      qidToOriginalResults[qid] = query.results.clone();
                      return;
                    }

                    if (!(query.results instanceof Array)) {
                      throw new Error('Assertion failed: query.results not an array');
                    } // Clones a document to be stored in `qidToOriginalResults`
                    // because it may be modified before the new and old result sets
                    // are diffed. But if we know exactly which document IDs we're
                    // going to modify, then we only need to clone those.


                    const memoizedCloneIfNeeded = doc => {
                      if (docMap.has(doc._id)) {
                        return docMap.get(doc._id);
                      }

                      const docToMemoize = idsMatched && !idsMatched.some(id => EJSON.equals(id, doc._id)) ? doc : EJSON.clone(doc);
                      docMap.set(doc._id, docToMemoize);
                      return docToMemoize;
                    };

                    qidToOriginalResults[qid] = query.results.map(memoizedCloneIfNeeded);
                  }
                });
                const recomputeQids = {};
                let updateCount = 0;

                this._eachPossiblyMatchingDoc(selector, (doc, id) => {
                  const queryResult = matcher.documentMatches(doc);

                  if (queryResult.result) {
                    // XXX Should we save the original even if mod ends up being a no-op?
                    this._saveOriginal(id, doc);

                    this._modifyAndNotify(doc, mod, recomputeQids, queryResult.arrayIndices);

                    ++updateCount;

                    if (!options.multi) {
                      return false; // break
                    }
                  }

                  return true;
                });

                Object.keys(recomputeQids).forEach(qid => {
                  const query = this.queries[qid];

                  if (query) {
                    this._recomputeResults(query, qidToOriginalResults[qid]);
                  }
                });

                this._observeQueue.drain(); // If we are doing an upsert, and we didn't modify any documents yet, then
                // it's time to do an insert. Figure out what document we are inserting, and
                // generate an id for it.


                let insertedId;

                if (updateCount === 0 && options.upsert) {
                  const doc = LocalCollection._createUpsertDocument(selector, mod);

                  if (!doc._id && options.insertedId) {
                    doc._id = options.insertedId;
                  }

                  insertedId = this.insert(doc);
                  updateCount = 1;
                } // Return the number of affected documents, or in the upsert case, an object
                // containing the number of affected docs and the id of the doc that was
                // inserted, if any.


                let result;

                if (options._returnObject) {
                  result = {
                    numberAffected: updateCount
                  };

                  if (insertedId !== undefined) {
                    result.insertedId = insertedId;
                  }
                } else {
                  result = updateCount;
                }

                if (callback) {
                  Meteor.defer(() => {
                    callback(null, result);
                  });
                }

                return result;
              } // A convenience wrapper on update. LocalCollection.upsert(sel, mod) is
              // equivalent to LocalCollection.update(sel, mod, {upsert: true,
              // _returnObject: true}).


              upsert(selector, mod, options, callback) {
                if (!callback && typeof options === 'function') {
                  callback = options;
                  options = {};
                }

                return this.update(selector, mod, Object.assign({}, options, {
                  upsert: true,
                  _returnObject: true
                }), callback);
              } // Iterates over a subset of documents that could match selector; calls
              // fn(doc, id) on each of them.  Specifically, if selector specifies
              // specific _id's, it only looks at those.  doc is *not* cloned: it is the
              // same object that is in _docs.


              _eachPossiblyMatchingDoc(selector, fn) {
                const specificIds = LocalCollection._idsMatchedBySelector(selector);

                if (specificIds) {
                  specificIds.some(id => {
                    const doc = this._docs.get(id);

                    if (doc) {
                      return fn(doc, id) === false;
                    }
                  });
                } else {
                  this._docs.forEach(fn);
                }
              }

              _modifyAndNotify(doc, mod, recomputeQids, arrayIndices) {
                const matched_before = {};
                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];

                  if (query.dirty) {
                    return;
                  }

                  if (query.ordered) {
                    matched_before[qid] = query.matcher.documentMatches(doc).result;
                  } else {
                    // Because we don't support skip or limit (yet) in unordered queries, we
                    // can just do a direct lookup.
                    matched_before[qid] = query.results.has(doc._id);
                  }
                });
                const old_doc = EJSON.clone(doc);

                LocalCollection._modify(doc, mod, {
                  arrayIndices
                });

                Object.keys(this.queries).forEach(qid => {
                  const query = this.queries[qid];

                  if (query.dirty) {
                    return;
                  }

                  const afterMatch = query.matcher.documentMatches(doc);
                  const after = afterMatch.result;
                  const before = matched_before[qid];

                  if (after && query.distances && afterMatch.distance !== undefined) {
                    query.distances.set(doc._id, afterMatch.distance);
                  }

                  if (query.cursor.skip || query.cursor.limit) {
                    // We need to recompute any query where the doc may have been in the
                    // cursor's window either before or after the update. (Note that if skip
                    // or limit is set, "before" and "after" being true do not necessarily
                    // mean that the document is in the cursor's output after skip/limit is
                    // applied... but if they are false, then the document definitely is NOT
                    // in the output. So it's safe to skip recompute if neither before or
                    // after are true.)
                    if (before || after) {
                      recomputeQids[qid] = true;
                    }
                  } else if (before && !after) {
                    LocalCollection._removeFromResults(query, doc);
                  } else if (!before && after) {
                    LocalCollection._insertInResults(query, doc);
                  } else if (before && after) {
                    LocalCollection._updateInResults(query, doc, old_doc);
                  }
                });
              } // Recomputes the results of a query and runs observe callbacks for the
              // difference between the previous results and the current results (unless
              // paused). Used for skip/limit queries.
              //
              // When this is used by insert or remove, it can just use query.results for
              // the old results (and there's no need to pass in oldResults), because these
              // operations don't mutate the documents in the collection. Update needs to
              // pass in an oldResults which was deep-copied before the modifier was
              // applied.
              //
              // oldResults is guaranteed to be ignored if the query is not paused.


              _recomputeResults(query, oldResults) {
                if (this.paused) {
                  // There's no reason to recompute the results now as we're still paused.
                  // By flagging the query as "dirty", the recompute will be performed
                  // when resumeObservers is called.
                  query.dirty = true;
                  return;
                }

                if (!this.paused && !oldResults) {
                  oldResults = query.results;
                }

                if (query.distances) {
                  query.distances.clear();
                }

                query.results = query.cursor._getRawObjects({
                  distances: query.distances,
                  ordered: query.ordered
                });

                if (!this.paused) {
                  LocalCollection._diffQueryChanges(query.ordered, oldResults, query.results, query, {
                    projectionFn: query.projectionFn
                  });
                }
              }

              _saveOriginal(id, doc) {
                // Are we even trying to save originals?
                if (!this._savedOriginals) {
                  return;
                } // Have we previously mutated the original (and so 'doc' is not actually
                // original)?  (Note the 'has' check rather than truth: we store undefined
                // here for inserted docs!)


                if (this._savedOriginals.has(id)) {
                  return;
                }

                this._savedOriginals.set(id, EJSON.clone(doc));
              }

            }

            LocalCollection.Cursor = Cursor;
            LocalCollection.ObserveHandle = ObserveHandle; // XXX maybe move these into another ObserveHelpers package or something
            // _CachingChangeObserver is an object which receives observeChanges callbacks
            // and keeps a cache of the current cursor state up to date in this.docs. Users
            // of this class should read the docs field but not modify it. You should pass
            // the "applyChange" field as the callbacks to the underlying observeChanges
            // call. Optionally, you can specify your own observeChanges callbacks which are
            // invoked immediately before the docs field is updated; this object is made
            // available as `this` to those callbacks.

            LocalCollection._CachingChangeObserver = class _CachingChangeObserver {
              constructor() {
                let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                const orderedFromCallbacks = options.callbacks && LocalCollection._observeChangesCallbacksAreOrdered(options.callbacks);

                if (hasOwn.call(options, 'ordered')) {
                  this.ordered = options.ordered;

                  if (options.callbacks && options.ordered !== orderedFromCallbacks) {
                    throw Error('ordered option doesn\'t match callbacks');
                  }
                } else if (options.callbacks) {
                  this.ordered = orderedFromCallbacks;
                } else {
                  throw Error('must provide ordered or callbacks');
                }

                const callbacks = options.callbacks || {};

                if (this.ordered) {
                  this.docs = new OrderedDict(MongoID.idStringify);
                  this.applyChange = {
                    addedBefore: (id, fields, before) => {
                      // Take a shallow copy since the top-level properties can be changed
                      const doc = _objectSpread({}, fields);

                      doc._id = id;

                      if (callbacks.addedBefore) {
                        callbacks.addedBefore.call(this, id, EJSON.clone(fields), before);
                      } // This line triggers if we provide added with movedBefore.


                      if (callbacks.added) {
                        callbacks.added.call(this, id, EJSON.clone(fields));
                      } // XXX could `before` be a falsy ID?  Technically
                      // idStringify seems to allow for them -- though
                      // OrderedDict won't call stringify on a falsy arg.


                      this.docs.putBefore(id, doc, before || null);
                    },
                    movedBefore: (id, before) => {
                      const doc = this.docs.get(id);

                      if (callbacks.movedBefore) {
                        callbacks.movedBefore.call(this, id, before);
                      }

                      this.docs.moveBefore(id, before || null);
                    }
                  };
                } else {
                  this.docs = new LocalCollection._IdMap();
                  this.applyChange = {
                    added: (id, fields) => {
                      // Take a shallow copy since the top-level properties can be changed
                      const doc = _objectSpread({}, fields);

                      if (callbacks.added) {
                        callbacks.added.call(this, id, EJSON.clone(fields));
                      }

                      doc._id = id;
                      this.docs.set(id, doc);
                    }
                  };
                } // The methods in _IdMap and OrderedDict used by these callbacks are
                // identical.


                this.applyChange.changed = (id, fields) => {
                  const doc = this.docs.get(id);

                  if (!doc) {
                    throw new Error("Unknown id for changed: ".concat(id));
                  }

                  if (callbacks.changed) {
                    callbacks.changed.call(this, id, EJSON.clone(fields));
                  }

                  DiffSequence.applyChanges(doc, fields);
                };

                this.applyChange.removed = id => {
                  if (callbacks.removed) {
                    callbacks.removed.call(this, id);
                  }

                  this.docs.remove(id);
                };
              }

            };
            LocalCollection._IdMap = class _IdMap extends IdMap {
              constructor() {
                super(MongoID.idStringify, MongoID.idParse);
              }

            }; // Wrap a transform function to return objects that have the _id field
            // of the untransformed document. This ensures that subsystems such as
            // the observe-sequence package that call `observe` can keep track of
            // the documents identities.
            //
            // - Require that it returns objects
            // - If the return value has an _id field, verify that it matches the
            //   original _id field
            // - If the return value doesn't have an _id field, add it back.

            LocalCollection.wrapTransform = transform => {
              if (!transform) {
                return null;
              } // No need to doubly-wrap transforms.


              if (transform.__wrappedTransform__) {
                return transform;
              }

              const wrapped = doc => {
                if (!hasOwn.call(doc, '_id')) {
                  // XXX do we ever have a transform on the oplog's collection? because that
                  // collection has no _id.
                  throw new Error('can only transform documents with _id');
                }

                const id = doc._id; // XXX consider making tracker a weak dependency and checking
                // Package.tracker here

                const transformed = Tracker.nonreactive(() => transform(doc));

                if (!LocalCollection._isPlainObject(transformed)) {
                  throw new Error('transform must return object');
                }

                if (hasOwn.call(transformed, '_id')) {
                  if (!EJSON.equals(transformed._id, id)) {
                    throw new Error('transformed document can\'t have different _id');
                  }
                } else {
                  transformed._id = id;
                }

                return transformed;
              };

              wrapped.__wrappedTransform__ = true;
              return wrapped;
            }; // XXX the sorted-query logic below is laughably inefficient. we'll
            // need to come up with a better datastructure for this.
            //
            // XXX the logic for observing with a skip or a limit is even more
            // laughably inefficient. we recompute the whole results every time!
            // This binary search puts a value between any equal values, and the first
            // lesser value.


            LocalCollection._binarySearch = (cmp, array, value) => {
              let first = 0;
              let range = array.length;

              while (range > 0) {
                const halfRange = Math.floor(range / 2);

                if (cmp(value, array[first + halfRange]) >= 0) {
                  first += halfRange + 1;
                  range -= halfRange + 1;
                } else {
                  range = halfRange;
                }
              }

              return first;
            };

            LocalCollection._checkSupportedProjection = fields => {
              if (fields !== Object(fields) || Array.isArray(fields)) {
                throw MinimongoError('fields option must be an object');
              }

              Object.keys(fields).forEach(keyPath => {
                if (keyPath.split('.').includes('$')) {
                  throw MinimongoError('Minimongo doesn\'t support $ operator in projections yet.');
                }

                const value = fields[keyPath];

                if (typeof value === 'object' && ['$elemMatch', '$meta', '$slice'].some(key => hasOwn.call(value, key))) {
                  throw MinimongoError('Minimongo doesn\'t support operators in projections yet.');
                }

                if (![1, 0, true, false].includes(value)) {
                  throw MinimongoError('Projection values should be one of 1, 0, true, or false');
                }
              });
            }; // Knows how to compile a fields projection to a predicate function.
            // @returns - Function: a closure that filters out an object according to the
            //            fields projection rules:
            //            @param obj - Object: MongoDB-styled document
            //            @returns - Object: a document with the fields filtered out
            //                       according to projection rules. Doesn't retain subfields
            //                       of passed argument.


            LocalCollection._compileProjection = fields => {
              LocalCollection._checkSupportedProjection(fields);

              const _idProjection = fields._id === undefined ? true : fields._id;

              const details = projectionDetails(fields); // returns transformed doc according to ruleTree

              const transform = (doc, ruleTree) => {
                // Special case for "sets"
                if (Array.isArray(doc)) {
                  return doc.map(subdoc => transform(subdoc, ruleTree));
                }

                const result = details.including ? {} : EJSON.clone(doc);
                Object.keys(ruleTree).forEach(key => {
                  if (doc == null || !hasOwn.call(doc, key)) {
                    return;
                  }

                  const rule = ruleTree[key];

                  if (rule === Object(rule)) {
                    // For sub-objects/subsets we branch
                    if (doc[key] === Object(doc[key])) {
                      result[key] = transform(doc[key], rule);
                    }
                  } else if (details.including) {
                    // Otherwise we don't even touch this subfield
                    result[key] = EJSON.clone(doc[key]);
                  } else {
                    delete result[key];
                  }
                });
                return doc != null ? result : doc;
              };

              return doc => {
                const result = transform(doc, details.tree);

                if (_idProjection && hasOwn.call(doc, '_id')) {
                  result._id = doc._id;
                }

                if (!_idProjection && hasOwn.call(result, '_id')) {
                  delete result._id;
                }

                return result;
              };
            }; // Calculates the document to insert in case we're doing an upsert and the
            // selector does not match any elements


            LocalCollection._createUpsertDocument = (selector, modifier) => {
              const selectorDocument = populateDocumentWithQueryFields(selector);

              const isModify = LocalCollection._isModificationMod(modifier);

              const newDoc = {};

              if (selectorDocument._id) {
                newDoc._id = selectorDocument._id;
                delete selectorDocument._id;
              } // This double _modify call is made to help with nested properties (see issue
              // #8631). We do this even if it's a replacement for validation purposes (e.g.
              // ambiguous id's)


              LocalCollection._modify(newDoc, {
                $set: selectorDocument
              });

              LocalCollection._modify(newDoc, modifier, {
                isInsert: true
              });

              if (isModify) {
                return newDoc;
              } // Replacement can take _id from query document


              const replacement = Object.assign({}, modifier);

              if (newDoc._id) {
                replacement._id = newDoc._id;
              }

              return replacement;
            };

            LocalCollection._diffObjects = (left, right, callbacks) => {
              return DiffSequence.diffObjects(left, right, callbacks);
            }; // ordered: bool.
            // old_results and new_results: collections of documents.
            //    if ordered, they are arrays.
            //    if unordered, they are IdMaps


            LocalCollection._diffQueryChanges = (ordered, oldResults, newResults, observer, options) => DiffSequence.diffQueryChanges(ordered, oldResults, newResults, observer, options);

            LocalCollection._diffQueryOrderedChanges = (oldResults, newResults, observer, options) => DiffSequence.diffQueryOrderedChanges(oldResults, newResults, observer, options);

            LocalCollection._diffQueryUnorderedChanges = (oldResults, newResults, observer, options) => DiffSequence.diffQueryUnorderedChanges(oldResults, newResults, observer, options);

            LocalCollection._findInOrderedResults = (query, doc) => {
              if (!query.ordered) {
                throw new Error('Can\'t call _findInOrderedResults on unordered query');
              }

              for (let i = 0; i < query.results.length; i++) {
                if (query.results[i] === doc) {
                  return i;
                }
              }

              throw Error('object missing from query');
            }; // If this is a selector which explicitly constrains the match by ID to a finite
            // number of documents, returns a list of their IDs.  Otherwise returns
            // null. Note that the selector may have other restrictions so it may not even
            // match those document!  We care about $in and $and since those are generated
            // access-controlled update and remove.


            LocalCollection._idsMatchedBySelector = selector => {
              // Is the selector just an ID?
              if (LocalCollection._selectorIsId(selector)) {
                return [selector];
              }

              if (!selector) {
                return null;
              } // Do we have an _id clause?


              if (hasOwn.call(selector, '_id')) {
                // Is the _id clause just an ID?
                if (LocalCollection._selectorIsId(selector._id)) {
                  return [selector._id];
                } // Is the _id clause {_id: {$in: ["x", "y", "z"]}}?


                if (selector._id && Array.isArray(selector._id.$in) && selector._id.$in.length && selector._id.$in.every(LocalCollection._selectorIsId)) {
                  return selector._id.$in;
                }

                return null;
              } // If this is a top-level $and, and any of the clauses constrain their
              // documents, then the whole selector is constrained by any one clause's
              // constraint. (Well, by their intersection, but that seems unlikely.)


              if (Array.isArray(selector.$and)) {
                for (let i = 0; i < selector.$and.length; ++i) {
                  const subIds = LocalCollection._idsMatchedBySelector(selector.$and[i]);

                  if (subIds) {
                    return subIds;
                  }
                }
              }

              return null;
            };

            LocalCollection._insertInResults = (query, doc) => {
              const fields = EJSON.clone(doc);
              delete fields._id;

              if (query.ordered) {
                if (!query.sorter) {
                  query.addedBefore(doc._id, query.projectionFn(fields), null);
                  query.results.push(doc);
                } else {
                  const i = LocalCollection._insertInSortedList(query.sorter.getComparator({
                    distances: query.distances
                  }), query.results, doc);

                  let next = query.results[i + 1];

                  if (next) {
                    next = next._id;
                  } else {
                    next = null;
                  }

                  query.addedBefore(doc._id, query.projectionFn(fields), next);
                }

                query.added(doc._id, query.projectionFn(fields));
              } else {
                query.added(doc._id, query.projectionFn(fields));
                query.results.set(doc._id, doc);
              }
            };

            LocalCollection._insertInSortedList = (cmp, array, value) => {
              if (array.length === 0) {
                array.push(value);
                return 0;
              }

              const i = LocalCollection._binarySearch(cmp, array, value);

              array.splice(i, 0, value);
              return i;
            };

            LocalCollection._isModificationMod = mod => {
              let isModify = false;
              let isReplace = false;
              Object.keys(mod).forEach(key => {
                if (key.substr(0, 1) === '$') {
                  isModify = true;
                } else {
                  isReplace = true;
                }
              });

              if (isModify && isReplace) {
                throw new Error('Update parameter cannot have both modifier and non-modifier fields.');
              }

              return isModify;
            }; // XXX maybe this should be EJSON.isObject, though EJSON doesn't know about
            // RegExp
            // XXX note that _type(undefined) === 3!!!!


            LocalCollection._isPlainObject = x => {
              return x && LocalCollection._f._type(x) === 3;
            }; // XXX need a strategy for passing the binding of $ into this
            // function, from the compiled selector
            //
            // maybe just {key.up.to.just.before.dollarsign: array_index}
            //
            // XXX atomicity: if one modification fails, do we roll back the whole
            // change?
            //
            // options:
            //   - isInsert is set when _modify is being called to compute the document to
            //     insert as part of an upsert operation. We use this primarily to figure
            //     out when to set the fields in $setOnInsert, if present.


            LocalCollection._modify = function (doc, modifier) {
              let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

              if (!LocalCollection._isPlainObject(modifier)) {
                throw MinimongoError('Modifier must be an object');
              } // Make sure the caller can't mutate our data structures.


              modifier = EJSON.clone(modifier);
              const isModifier = isOperatorObject(modifier);
              const newDoc = isModifier ? EJSON.clone(doc) : modifier;

              if (isModifier) {
                // apply modifiers to the doc.
                Object.keys(modifier).forEach(operator => {
                  // Treat $setOnInsert as $set if this is an insert.
                  const setOnInsert = options.isInsert && operator === '$setOnInsert';
                  const modFunc = MODIFIERS[setOnInsert ? '$set' : operator];
                  const operand = modifier[operator];

                  if (!modFunc) {
                    throw MinimongoError("Invalid modifier specified ".concat(operator));
                  }

                  Object.keys(operand).forEach(keypath => {
                    const arg = operand[keypath];

                    if (keypath === '') {
                      throw MinimongoError('An empty update path is not valid.');
                    }

                    const keyparts = keypath.split('.');

                    if (!keyparts.every(Boolean)) {
                      throw MinimongoError("The update path '".concat(keypath, "' contains an empty field name, ") + 'which is not allowed.');
                    }

                    const target = findModTarget(newDoc, keyparts, {
                      arrayIndices: options.arrayIndices,
                      forbidArray: operator === '$rename',
                      noCreate: NO_CREATE_MODIFIERS[operator]
                    });
                    modFunc(target, keyparts.pop(), arg, keypath, newDoc);
                  });
                });

                if (doc._id && !EJSON.equals(doc._id, newDoc._id)) {
                  throw MinimongoError("After applying the update to the document {_id: \"".concat(doc._id, "\", ...},") + ' the (immutable) field \'_id\' was found to have been altered to ' + "_id: \"".concat(newDoc._id, "\""));
                }
              } else {
                if (doc._id && modifier._id && !EJSON.equals(doc._id, modifier._id)) {
                  throw MinimongoError("The _id field cannot be changed from {_id: \"".concat(doc._id, "\"} to ") + "{_id: \"".concat(modifier._id, "\"}"));
                } // replace the whole document


                assertHasValidFieldNames(modifier);
              } // move new document into place.


              Object.keys(doc).forEach(key => {
                // Note: this used to be for (var key in doc) however, this does not
                // work right in Opera. Deleting from a doc while iterating over it
                // would sometimes cause opera to skip some keys.
                if (key !== '_id') {
                  delete doc[key];
                }
              });
              Object.keys(newDoc).forEach(key => {
                doc[key] = newDoc[key];
              });
            };

            LocalCollection._observeFromObserveChanges = (cursor, observeCallbacks) => {
              const transform = cursor.getTransform() || (doc => doc);

              let suppressed = !!observeCallbacks._suppress_initial;
              let observeChangesCallbacks;

              if (LocalCollection._observeCallbacksAreOrdered(observeCallbacks)) {
                // The "_no_indices" option sets all index arguments to -1 and skips the
                // linear scans required to generate them.  This lets observers that don't
                // need absolute indices benefit from the other features of this API --
                // relative order, transforms, and applyChanges -- without the speed hit.
                const indices = !observeCallbacks._no_indices;
                observeChangesCallbacks = {
                  addedBefore(id, fields, before) {
                    if (suppressed || !(observeCallbacks.addedAt || observeCallbacks.added)) {
                      return;
                    }

                    const doc = transform(Object.assign(fields, {
                      _id: id
                    }));

                    if (observeCallbacks.addedAt) {
                      observeCallbacks.addedAt(doc, indices ? before ? this.docs.indexOf(before) : this.docs.size() : -1, before);
                    } else {
                      observeCallbacks.added(doc);
                    }
                  },

                  changed(id, fields) {
                    if (!(observeCallbacks.changedAt || observeCallbacks.changed)) {
                      return;
                    }

                    let doc = EJSON.clone(this.docs.get(id));

                    if (!doc) {
                      throw new Error("Unknown id for changed: ".concat(id));
                    }

                    const oldDoc = transform(EJSON.clone(doc));
                    DiffSequence.applyChanges(doc, fields);

                    if (observeCallbacks.changedAt) {
                      observeCallbacks.changedAt(transform(doc), oldDoc, indices ? this.docs.indexOf(id) : -1);
                    } else {
                      observeCallbacks.changed(transform(doc), oldDoc);
                    }
                  },

                  movedBefore(id, before) {
                    if (!observeCallbacks.movedTo) {
                      return;
                    }

                    const from = indices ? this.docs.indexOf(id) : -1;
                    let to = indices ? before ? this.docs.indexOf(before) : this.docs.size() : -1; // When not moving backwards, adjust for the fact that removing the
                    // document slides everything back one slot.

                    if (to > from) {
                      --to;
                    }

                    observeCallbacks.movedTo(transform(EJSON.clone(this.docs.get(id))), from, to, before || null);
                  },

                  removed(id) {
                    if (!(observeCallbacks.removedAt || observeCallbacks.removed)) {
                      return;
                    } // technically maybe there should be an EJSON.clone here, but it's about
                    // to be removed from this.docs!


                    const doc = transform(this.docs.get(id));

                    if (observeCallbacks.removedAt) {
                      observeCallbacks.removedAt(doc, indices ? this.docs.indexOf(id) : -1);
                    } else {
                      observeCallbacks.removed(doc);
                    }
                  }

                };
              } else {
                observeChangesCallbacks = {
                  added(id, fields) {
                    if (!suppressed && observeCallbacks.added) {
                      observeCallbacks.added(transform(Object.assign(fields, {
                        _id: id
                      })));
                    }
                  },

                  changed(id, fields) {
                    if (observeCallbacks.changed) {
                      const oldDoc = this.docs.get(id);
                      const doc = EJSON.clone(oldDoc);
                      DiffSequence.applyChanges(doc, fields);
                      observeCallbacks.changed(transform(doc), transform(EJSON.clone(oldDoc)));
                    }
                  },

                  removed(id) {
                    if (observeCallbacks.removed) {
                      observeCallbacks.removed(transform(this.docs.get(id)));
                    }
                  }

                };
              }

              const changeObserver = new LocalCollection._CachingChangeObserver({
                callbacks: observeChangesCallbacks
              }); // CachingChangeObserver clones all received input on its callbacks
              // So we can mark it as safe to reduce the ejson clones.
              // This is tested by the `mongo-livedata - (extended) scribbling` tests

              changeObserver.applyChange._fromObserve = true;
              const handle = cursor.observeChanges(changeObserver.applyChange, {
                nonMutatingCallbacks: true
              });
              suppressed = false;
              return handle;
            };

            LocalCollection._observeCallbacksAreOrdered = callbacks => {
              if (callbacks.added && callbacks.addedAt) {
                throw new Error('Please specify only one of added() and addedAt()');
              }

              if (callbacks.changed && callbacks.changedAt) {
                throw new Error('Please specify only one of changed() and changedAt()');
              }

              if (callbacks.removed && callbacks.removedAt) {
                throw new Error('Please specify only one of removed() and removedAt()');
              }

              return !!(callbacks.addedAt || callbacks.changedAt || callbacks.movedTo || callbacks.removedAt);
            };

            LocalCollection._observeChangesCallbacksAreOrdered = callbacks => {
              if (callbacks.added && callbacks.addedBefore) {
                throw new Error('Please specify only one of added() and addedBefore()');
              }

              return !!(callbacks.addedBefore || callbacks.movedBefore);
            };

            LocalCollection._removeFromResults = (query, doc) => {
              if (query.ordered) {
                const i = LocalCollection._findInOrderedResults(query, doc);

                query.removed(doc._id);
                query.results.splice(i, 1);
              } else {
                const id = doc._id; // in case callback mutates doc

                query.removed(doc._id);
                query.results.remove(id);
              }
            }; // Is this selector just shorthand for lookup by _id?


            LocalCollection._selectorIsId = selector => typeof selector === 'number' || typeof selector === 'string' || selector instanceof MongoID.ObjectID; // Is the selector just lookup by _id (shorthand or not)?


            LocalCollection._selectorIsIdPerhapsAsObject = selector => LocalCollection._selectorIsId(selector) || LocalCollection._selectorIsId(selector && selector._id) && Object.keys(selector).length === 1;

            LocalCollection._updateInResults = (query, doc, old_doc) => {
              if (!EJSON.equals(doc._id, old_doc._id)) {
                throw new Error('Can\'t change a doc\'s _id while updating');
              }

              const projectionFn = query.projectionFn;
              const changedFields = DiffSequence.makeChangedFields(projectionFn(doc), projectionFn(old_doc));

              if (!query.ordered) {
                if (Object.keys(changedFields).length) {
                  query.changed(doc._id, changedFields);
                  query.results.set(doc._id, doc);
                }

                return;
              }

              const old_idx = LocalCollection._findInOrderedResults(query, doc);

              if (Object.keys(changedFields).length) {
                query.changed(doc._id, changedFields);
              }

              if (!query.sorter) {
                return;
              } // just take it out and put it back in again, and see if the index changes


              query.results.splice(old_idx, 1);

              const new_idx = LocalCollection._insertInSortedList(query.sorter.getComparator({
                distances: query.distances
              }), query.results, doc);

              if (old_idx !== new_idx) {
                let next = query.results[new_idx + 1];

                if (next) {
                  next = next._id;
                } else {
                  next = null;
                }

                query.movedBefore && query.movedBefore(doc._id, next);
              }
            };

            const MODIFIERS = {
              $currentDate(target, field, arg) {
                if (typeof arg === 'object' && hasOwn.call(arg, '$type')) {
                  if (arg.$type !== 'date') {
                    throw MinimongoError('Minimongo does currently only support the date type in ' + '$currentDate modifiers', {
                      field
                    });
                  }
                } else if (arg !== true) {
                  throw MinimongoError('Invalid $currentDate modifier', {
                    field
                  });
                }

                target[field] = new Date();
              },

              $inc(target, field, arg) {
                if (typeof arg !== 'number') {
                  throw MinimongoError('Modifier $inc allowed for numbers only', {
                    field
                  });
                }

                if (field in target) {
                  if (typeof target[field] !== 'number') {
                    throw MinimongoError('Cannot apply $inc modifier to non-number', {
                      field
                    });
                  }

                  target[field] += arg;
                } else {
                  target[field] = arg;
                }
              },

              $min(target, field, arg) {
                if (typeof arg !== 'number') {
                  throw MinimongoError('Modifier $min allowed for numbers only', {
                    field
                  });
                }

                if (field in target) {
                  if (typeof target[field] !== 'number') {
                    throw MinimongoError('Cannot apply $min modifier to non-number', {
                      field
                    });
                  }

                  if (target[field] > arg) {
                    target[field] = arg;
                  }
                } else {
                  target[field] = arg;
                }
              },

              $max(target, field, arg) {
                if (typeof arg !== 'number') {
                  throw MinimongoError('Modifier $max allowed for numbers only', {
                    field
                  });
                }

                if (field in target) {
                  if (typeof target[field] !== 'number') {
                    throw MinimongoError('Cannot apply $max modifier to non-number', {
                      field
                    });
                  }

                  if (target[field] < arg) {
                    target[field] = arg;
                  }
                } else {
                  target[field] = arg;
                }
              },

              $mul(target, field, arg) {
                if (typeof arg !== 'number') {
                  throw MinimongoError('Modifier $mul allowed for numbers only', {
                    field
                  });
                }

                if (field in target) {
                  if (typeof target[field] !== 'number') {
                    throw MinimongoError('Cannot apply $mul modifier to non-number', {
                      field
                    });
                  }

                  target[field] *= arg;
                } else {
                  target[field] = 0;
                }
              },

              $rename(target, field, arg, keypath, doc) {
                // no idea why mongo has this restriction..
                if (keypath === arg) {
                  throw MinimongoError('$rename source must differ from target', {
                    field
                  });
                }

                if (target === null) {
                  throw MinimongoError('$rename source field invalid', {
                    field
                  });
                }

                if (typeof arg !== 'string') {
                  throw MinimongoError('$rename target must be a string', {
                    field
                  });
                }

                if (arg.includes('\0')) {
                  // Null bytes are not allowed in Mongo field names
                  // https://docs.mongodb.com/manual/reference/limits/#Restrictions-on-Field-Names
                  throw MinimongoError('The \'to\' field for $rename cannot contain an embedded null byte', {
                    field
                  });
                }

                if (target === undefined) {
                  return;
                }

                const object = target[field];
                delete target[field];
                const keyparts = arg.split('.');
                const target2 = findModTarget(doc, keyparts, {
                  forbidArray: true
                });

                if (target2 === null) {
                  throw MinimongoError('$rename target field invalid', {
                    field
                  });
                }

                target2[keyparts.pop()] = object;
              },

              $set(target, field, arg) {
                if (target !== Object(target)) {
                  // not an array or an object
                  const error = MinimongoError('Cannot set property on non-object field', {
                    field
                  });
                  error.setPropertyError = true;
                  throw error;
                }

                if (target === null) {
                  const error = MinimongoError('Cannot set property on null', {
                    field
                  });
                  error.setPropertyError = true;
                  throw error;
                }

                assertHasValidFieldNames(arg);
                target[field] = arg;
              },

              $setOnInsert(target, field, arg) {// converted to `$set` in `_modify`
              },

              $unset(target, field, arg) {
                if (target !== undefined) {
                  if (target instanceof Array) {
                    if (field in target) {
                      target[field] = null;
                    }
                  } else {
                    delete target[field];
                  }
                }
              },

              $push(target, field, arg) {
                if (target[field] === undefined) {
                  target[field] = [];
                }

                if (!(target[field] instanceof Array)) {
                  throw MinimongoError('Cannot apply $push modifier to non-array', {
                    field
                  });
                }

                if (!(arg && arg.$each)) {
                  // Simple mode: not $each
                  assertHasValidFieldNames(arg);
                  target[field].push(arg);
                  return;
                } // Fancy mode: $each (and maybe $slice and $sort and $position)


                const toPush = arg.$each;

                if (!(toPush instanceof Array)) {
                  throw MinimongoError('$each must be an array', {
                    field
                  });
                }

                assertHasValidFieldNames(toPush); // Parse $position

                let position = undefined;

                if ('$position' in arg) {
                  if (typeof arg.$position !== 'number') {
                    throw MinimongoError('$position must be a numeric value', {
                      field
                    });
                  } // XXX should check to make sure integer


                  if (arg.$position < 0) {
                    throw MinimongoError('$position in $push must be zero or positive', {
                      field
                    });
                  }

                  position = arg.$position;
                } // Parse $slice.


                let slice = undefined;

                if ('$slice' in arg) {
                  if (typeof arg.$slice !== 'number') {
                    throw MinimongoError('$slice must be a numeric value', {
                      field
                    });
                  } // XXX should check to make sure integer


                  slice = arg.$slice;
                } // Parse $sort.


                let sortFunction = undefined;

                if (arg.$sort) {
                  if (slice === undefined) {
                    throw MinimongoError('$sort requires $slice to be present', {
                      field
                    });
                  } // XXX this allows us to use a $sort whose value is an array, but that's
                  // actually an extension of the Node driver, so it won't work
                  // server-side. Could be confusing!
                  // XXX is it correct that we don't do geo-stuff here?


                  sortFunction = new Minimongo.Sorter(arg.$sort).getComparator();
                  toPush.forEach(element => {
                    if (LocalCollection._f._type(element) !== 3) {
                      throw MinimongoError('$push like modifiers using $sort require all elements to be ' + 'objects', {
                        field
                      });
                    }
                  });
                } // Actually push.


                if (position === undefined) {
                  toPush.forEach(element => {
                    target[field].push(element);
                  });
                } else {
                  const spliceArguments = [position, 0];
                  toPush.forEach(element => {
                    spliceArguments.push(element);
                  });
                  target[field].splice(...spliceArguments);
                } // Actually sort.


                if (sortFunction) {
                  target[field].sort(sortFunction);
                } // Actually slice.


                if (slice !== undefined) {
                  if (slice === 0) {
                    target[field] = []; // differs from Array.slice!
                  } else if (slice < 0) {
                    target[field] = target[field].slice(slice);
                  } else {
                    target[field] = target[field].slice(0, slice);
                  }
                }
              },

              $pushAll(target, field, arg) {
                if (!(typeof arg === 'object' && arg instanceof Array)) {
                  throw MinimongoError('Modifier $pushAll/pullAll allowed for arrays only');
                }

                assertHasValidFieldNames(arg);
                const toPush = target[field];

                if (toPush === undefined) {
                  target[field] = arg;
                } else if (!(toPush instanceof Array)) {
                  throw MinimongoError('Cannot apply $pushAll modifier to non-array', {
                    field
                  });
                } else {
                  toPush.push(...arg);
                }
              },

              $addToSet(target, field, arg) {
                let isEach = false;

                if (typeof arg === 'object') {
                  // check if first key is '$each'
                  const keys = Object.keys(arg);

                  if (keys[0] === '$each') {
                    isEach = true;
                  }
                }

                const values = isEach ? arg.$each : [arg];
                assertHasValidFieldNames(values);
                const toAdd = target[field];

                if (toAdd === undefined) {
                  target[field] = values;
                } else if (!(toAdd instanceof Array)) {
                  throw MinimongoError('Cannot apply $addToSet modifier to non-array', {
                    field
                  });
                } else {
                  values.forEach(value => {
                    if (toAdd.some(element => LocalCollection._f._equal(value, element))) {
                      return;
                    }

                    toAdd.push(value);
                  });
                }
              },

              $pop(target, field, arg) {
                if (target === undefined) {
                  return;
                }

                const toPop = target[field];

                if (toPop === undefined) {
                  return;
                }

                if (!(toPop instanceof Array)) {
                  throw MinimongoError('Cannot apply $pop modifier to non-array', {
                    field
                  });
                }

                if (typeof arg === 'number' && arg < 0) {
                  toPop.splice(0, 1);
                } else {
                  toPop.pop();
                }
              },

              $pull(target, field, arg) {
                if (target === undefined) {
                  return;
                }

                const toPull = target[field];

                if (toPull === undefined) {
                  return;
                }

                if (!(toPull instanceof Array)) {
                  throw MinimongoError('Cannot apply $pull/pullAll modifier to non-array', {
                    field
                  });
                }

                let out;

                if (arg != null && typeof arg === 'object' && !(arg instanceof Array)) {
                  // XXX would be much nicer to compile this once, rather than
                  // for each document we modify.. but usually we're not
                  // modifying that many documents, so we'll let it slide for
                  // now
                  // XXX Minimongo.Matcher isn't up for the job, because we need
                  // to permit stuff like {$pull: {a: {$gt: 4}}}.. something
                  // like {$gt: 4} is not normally a complete selector.
                  // same issue as $elemMatch possibly?
                  const matcher = new Minimongo.Matcher(arg);
                  out = toPull.filter(element => !matcher.documentMatches(element).result);
                } else {
                  out = toPull.filter(element => !LocalCollection._f._equal(element, arg));
                }

                target[field] = out;
              },

              $pullAll(target, field, arg) {
                if (!(typeof arg === 'object' && arg instanceof Array)) {
                  throw MinimongoError('Modifier $pushAll/pullAll allowed for arrays only', {
                    field
                  });
                }

                if (target === undefined) {
                  return;
                }

                const toPull = target[field];

                if (toPull === undefined) {
                  return;
                }

                if (!(toPull instanceof Array)) {
                  throw MinimongoError('Cannot apply $pull/pullAll modifier to non-array', {
                    field
                  });
                }

                target[field] = toPull.filter(object => !arg.some(element => LocalCollection._f._equal(object, element)));
              },

              $bit(target, field, arg) {
                // XXX mongo only supports $bit on integers, and we only support
                // native javascript numbers (doubles) so far, so we can't support $bit
                throw MinimongoError('$bit is not supported', {
                  field
                });
              },

              $v() {// As discussed in https://github.com/meteor/meteor/issues/9623,
                // the `$v` operator is not needed by Meteor, but problems can occur if
                // it's not at least callable (as of Mongo >= 3.6). It's defined here as
                // a no-op to work around these problems.
              }

            };
            const NO_CREATE_MODIFIERS = {
              $pop: true,
              $pull: true,
              $pullAll: true,
              $rename: true,
              $unset: true
            }; // Make sure field names do not contain Mongo restricted
            // characters ('.', '$', '\0').
            // https://docs.mongodb.com/manual/reference/limits/#Restrictions-on-Field-Names

            const invalidCharMsg = {
              $: 'start with \'$\'',
              '.': 'contain \'.\'',
              '\0': 'contain null bytes'
            }; // checks if all field names in an object are valid

            function assertHasValidFieldNames(doc) {
              if (doc && typeof doc === 'object') {
                JSON.stringify(doc, (key, value) => {
                  assertIsValidFieldName(key);
                  return value;
                });
              }
            }

            function assertIsValidFieldName(key) {
              let match;

              if (typeof key === 'string' && (match = key.match(/^\$|\.|\0/))) {
                throw MinimongoError("Key ".concat(key, " must not ").concat(invalidCharMsg[match[0]]));
              }
            } // for a.b.c.2.d.e, keyparts should be ['a', 'b', 'c', '2', 'd', 'e'],
            // and then you would operate on the 'e' property of the returned
            // object.
            //
            // if options.noCreate is falsey, creates intermediate levels of
            // structure as necessary, like mkdir -p (and raises an exception if
            // that would mean giving a non-numeric property to an array.) if
            // options.noCreate is true, return undefined instead.
            //
            // may modify the last element of keyparts to signal to the caller that it needs
            // to use a different value to index into the returned object (for example,
            // ['a', '01'] -> ['a', 1]).
            //
            // if forbidArray is true, return null if the keypath goes through an array.
            //
            // if options.arrayIndices is set, use its first element for the (first) '$' in
            // the path.


            function findModTarget(doc, keyparts) {
              let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              let usedArrayIndex = false;

              for (let i = 0; i < keyparts.length; i++) {
                const last = i === keyparts.length - 1;
                let keypart = keyparts[i];

                if (!isIndexable(doc)) {
                  if (options.noCreate) {
                    return undefined;
                  }

                  const error = MinimongoError("cannot use the part '".concat(keypart, "' to traverse ").concat(doc));
                  error.setPropertyError = true;
                  throw error;
                }

                if (doc instanceof Array) {
                  if (options.forbidArray) {
                    return null;
                  }

                  if (keypart === '$') {
                    if (usedArrayIndex) {
                      throw MinimongoError('Too many positional (i.e. \'$\') elements');
                    }

                    if (!options.arrayIndices || !options.arrayIndices.length) {
                      throw MinimongoError('The positional operator did not find the match needed from the ' + 'query');
                    }

                    keypart = options.arrayIndices[0];
                    usedArrayIndex = true;
                  } else if (isNumericKey(keypart)) {
                    keypart = parseInt(keypart);
                  } else {
                    if (options.noCreate) {
                      return undefined;
                    }

                    throw MinimongoError("can't append to array using string field name [".concat(keypart, "]"));
                  }

                  if (last) {
                    keyparts[i] = keypart; // handle 'a.01'
                  }

                  if (options.noCreate && keypart >= doc.length) {
                    return undefined;
                  }

                  while (doc.length < keypart) {
                    doc.push(null);
                  }

                  if (!last) {
                    if (doc.length === keypart) {
                      doc.push({});
                    } else if (typeof doc[keypart] !== 'object') {
                      throw MinimongoError("can't modify field '".concat(keyparts[i + 1], "' of list value ") + JSON.stringify(doc[keypart]));
                    }
                  }
                } else {
                  assertIsValidFieldName(keypart);

                  if (!(keypart in doc)) {
                    if (options.noCreate) {
                      return undefined;
                    }

                    if (!last) {
                      doc[keypart] = {};
                    }
                  }
                }

                if (last) {
                  return doc;
                }

                doc = doc[keypart];
              } // notreached
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "matcher.js": function module(_require6, _exports6, _module5) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/matcher.js                                                                                       //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            var _Package$mongoDecima;

            _module5.export({
              default: () => Matcher
            });
            let LocalCollection;
            _module5.link("./local_collection.js", {
              default(v) {
                LocalCollection = v;
              }

            }, 0);
            let compileDocumentSelector, hasOwn, nothingMatcher;
            _module5.link("./common.js", {
              compileDocumentSelector(v) {
                compileDocumentSelector = v;
              },

              hasOwn(v) {
                hasOwn = v;
              },

              nothingMatcher(v) {
                nothingMatcher = v;
              }

            }, 1);
            const Decimal = ((_Package$mongoDecima = Package['mongo-decimal']) === null || _Package$mongoDecima === void 0 ? void 0 : _Package$mongoDecima.Decimal) || class DecimalStub {}; // The minimongo selector compiler!
            // Terminology:
            //  - a 'selector' is the EJSON object representing a selector
            //  - a 'matcher' is its compiled form (whether a full Minimongo.Matcher
            //    object or one of the component lambdas that matches parts of it)
            //  - a 'result object' is an object with a 'result' field and maybe
            //    distance and arrayIndices.
            //  - a 'branched value' is an object with a 'value' field and maybe
            //    'dontIterate' and 'arrayIndices'.
            //  - a 'document' is a top-level object that can be stored in a collection.
            //  - a 'lookup function' is a function that takes in a document and returns
            //    an array of 'branched values'.
            //  - a 'branched matcher' maps from an array of branched values to a result
            //    object.
            //  - an 'element matcher' maps from a single value to a bool.
            // Main entry point.
            //   var matcher = new Minimongo.Matcher({a: {$gt: 5}});
            //   if (matcher.documentMatches({a: 7})) ...

            class Matcher {
              constructor(selector, isUpdate) {
                // A set (object mapping string -> *) of all of the document paths looked
                // at by the selector. Also includes the empty string if it may look at any
                // path (eg, $where).
                this._paths = {}; // Set to true if compilation finds a $near.

                this._hasGeoQuery = false; // Set to true if compilation finds a $where.

                this._hasWhere = false; // Set to false if compilation finds anything other than a simple equality
                // or one or more of '$gt', '$gte', '$lt', '$lte', '$ne', '$in', '$nin' used
                // with scalars as operands.

                this._isSimple = true; // Set to a dummy document which always matches this Matcher. Or set to null
                // if such document is too hard to find.

                this._matchingDocument = undefined; // A clone of the original selector. It may just be a function if the user
                // passed in a function; otherwise is definitely an object (eg, IDs are
                // translated into {_id: ID} first. Used by canBecomeTrueByModifier and
                // Sorter._useWithMatcher.

                this._selector = null;
                this._docMatcher = this._compileSelector(selector); // Set to true if selection is done for an update operation
                // Default is false
                // Used for $near array update (issue #3599)

                this._isUpdate = isUpdate;
              }

              documentMatches(doc) {
                if (doc !== Object(doc)) {
                  throw Error('documentMatches needs a document');
                }

                return this._docMatcher(doc);
              }

              hasGeoQuery() {
                return this._hasGeoQuery;
              }

              hasWhere() {
                return this._hasWhere;
              }

              isSimple() {
                return this._isSimple;
              } // Given a selector, return a function that takes one argument, a
              // document. It returns a result object.


              _compileSelector(selector) {
                // you can pass a literal function instead of a selector
                if (selector instanceof Function) {
                  this._isSimple = false;
                  this._selector = selector;

                  this._recordPathUsed('');

                  return doc => ({
                    result: !!selector.call(doc)
                  });
                } // shorthand -- scalar _id


                if (LocalCollection._selectorIsId(selector)) {
                  this._selector = {
                    _id: selector
                  };

                  this._recordPathUsed('_id');

                  return doc => ({
                    result: EJSON.equals(doc._id, selector)
                  });
                } // protect against dangerous selectors.  falsey and {_id: falsey} are both
                // likely programmer error, and not what you want, particularly for
                // destructive operations.


                if (!selector || hasOwn.call(selector, '_id') && !selector._id) {
                  this._isSimple = false;
                  return nothingMatcher;
                } // Top level can't be an array or true or binary.


                if (Array.isArray(selector) || EJSON.isBinary(selector) || typeof selector === 'boolean') {
                  throw new Error("Invalid selector: ".concat(selector));
                }

                this._selector = EJSON.clone(selector);
                return compileDocumentSelector(selector, this, {
                  isRoot: true
                });
              } // Returns a list of key paths the given selector is looking for. It includes
              // the empty string if there is a $where.


              _getPaths() {
                return Object.keys(this._paths);
              }

              _recordPathUsed(path) {
                this._paths[path] = true;
              }

            }

            // helpers used by compiled selector code
            LocalCollection._f = {
              // XXX for _all and _in, consider building 'inquery' at compile time..
              _type(v) {
                if (typeof v === 'number') {
                  return 1;
                }

                if (typeof v === 'string') {
                  return 2;
                }

                if (typeof v === 'boolean') {
                  return 8;
                }

                if (Array.isArray(v)) {
                  return 4;
                }

                if (v === null) {
                  return 10;
                } // note that typeof(/x/) === "object"


                if (v instanceof RegExp) {
                  return 11;
                }

                if (typeof v === 'function') {
                  return 13;
                }

                if (v instanceof Date) {
                  return 9;
                }

                if (EJSON.isBinary(v)) {
                  return 5;
                }

                if (v instanceof MongoID.ObjectID) {
                  return 7;
                }

                if (v instanceof Decimal) {
                  return 1;
                } // object


                return 3; // XXX support some/all of these:
                // 14, symbol
                // 15, javascript code with scope
                // 16, 18: 32-bit/64-bit integer
                // 17, timestamp
                // 255, minkey
                // 127, maxkey
              },

              // deep equality test: use for literal document and array matches
              _equal(a, b) {
                return EJSON.equals(a, b, {
                  keyOrderSensitive: true
                });
              },

              // maps a type code to a value that can be used to sort values of different
              // types
              _typeorder(t) {
                // http://www.mongodb.org/display/DOCS/What+is+the+Compare+Order+for+BSON+Types
                // XXX what is the correct sort position for Javascript code?
                // ('100' in the matrix below)
                // XXX minkey/maxkey
                return [-1, // (not a type)
                1, // number
                2, // string
                3, // object
                4, // array
                5, // binary
                -1, // deprecated
                6, // ObjectID
                7, // bool
                8, // Date
                0, // null
                9, // RegExp
                -1, // deprecated
                100, // JS code
                2, // deprecated (symbol)
                100, // JS code
                1, // 32-bit int
                8, // Mongo timestamp
                1 // 64-bit int
                ][t];
              },

              // compare two values of unknown type according to BSON ordering
              // semantics. (as an extension, consider 'undefined' to be less than
              // any other value.) return negative if a is less, positive if b is
              // less, or 0 if equal
              _cmp(a, b) {
                if (a === undefined) {
                  return b === undefined ? 0 : -1;
                }

                if (b === undefined) {
                  return 1;
                }

                let ta = LocalCollection._f._type(a);

                let tb = LocalCollection._f._type(b);

                const oa = LocalCollection._f._typeorder(ta);

                const ob = LocalCollection._f._typeorder(tb);

                if (oa !== ob) {
                  return oa < ob ? -1 : 1;
                } // XXX need to implement this if we implement Symbol or integers, or
                // Timestamp


                if (ta !== tb) {
                  throw Error('Missing type coercion logic in _cmp');
                }

                if (ta === 7) {
                  // ObjectID
                  // Convert to string.
                  ta = tb = 2;
                  a = a.toHexString();
                  b = b.toHexString();
                }

                if (ta === 9) {
                  // Date
                  // Convert to millis.
                  ta = tb = 1;
                  a = a.getTime();
                  b = b.getTime();
                }

                if (ta === 1) {
                  // double
                  if (a instanceof Decimal) {
                    return a.minus(b).toNumber();
                  } else {
                    return a - b;
                  }
                }

                if (tb === 2) // string
                  return a < b ? -1 : a === b ? 0 : 1;

                if (ta === 3) {
                  // Object
                  // this could be much more efficient in the expected case ...
                  const toArray = object => {
                    const result = [];
                    Object.keys(object).forEach(key => {
                      result.push(key, object[key]);
                    });
                    return result;
                  };

                  return LocalCollection._f._cmp(toArray(a), toArray(b));
                }

                if (ta === 4) {
                  // Array
                  for (let i = 0;; i++) {
                    if (i === a.length) {
                      return i === b.length ? 0 : -1;
                    }

                    if (i === b.length) {
                      return 1;
                    }

                    const s = LocalCollection._f._cmp(a[i], b[i]);

                    if (s !== 0) {
                      return s;
                    }
                  }
                }

                if (ta === 5) {
                  // binary
                  // Surprisingly, a small binary blob is always less than a large one in
                  // Mongo.
                  if (a.length !== b.length) {
                    return a.length - b.length;
                  }

                  for (let i = 0; i < a.length; i++) {
                    if (a[i] < b[i]) {
                      return -1;
                    }

                    if (a[i] > b[i]) {
                      return 1;
                    }
                  }

                  return 0;
                }

                if (ta === 8) {
                  // boolean
                  if (a) {
                    return b ? 0 : 1;
                  }

                  return b ? -1 : 0;
                }

                if (ta === 10) // null
                  return 0;
                if (ta === 11) // regexp
                  throw Error('Sorting not supported on regular expression'); // XXX
                // 13: javascript code
                // 14: symbol
                // 15: javascript code with scope
                // 16: 32-bit integer
                // 17: timestamp
                // 18: 64-bit integer
                // 255: minkey
                // 127: maxkey

                if (ta === 13) // javascript code
                  throw Error('Sorting not supported on Javascript code'); // XXX

                throw Error('Unknown type to sort');
              }

            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "minimongo_common.js": function module(_require7, _exports7, _module6) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/minimongo_common.js                                                                              //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let LocalCollection_;
            _module6.link("./local_collection.js", {
              default(v) {
                LocalCollection_ = v;
              }

            }, 0);
            let Matcher;
            _module6.link("./matcher.js", {
              default(v) {
                Matcher = v;
              }

            }, 1);
            let Sorter;
            _module6.link("./sorter.js", {
              default(v) {
                Sorter = v;
              }

            }, 2);
            LocalCollection = LocalCollection_;
            Minimongo = {
              LocalCollection: LocalCollection_,
              Matcher,
              Sorter
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "observe_handle.js": function module(_require8, _exports8, _module7) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/observe_handle.js                                                                                //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module7.export({
              default: () => ObserveHandle
            });

            class ObserveHandle {}
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "sorter.js": function module(_require9, _exports9, _module8) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/minimongo/sorter.js                                                                                        //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module8.export({
              default: () => Sorter
            });
            let ELEMENT_OPERATORS, equalityElementMatcher, expandArraysInBranches, hasOwn, isOperatorObject, makeLookupFunction, regexpElementMatcher;
            _module8.link("./common.js", {
              ELEMENT_OPERATORS(v) {
                ELEMENT_OPERATORS = v;
              },

              equalityElementMatcher(v) {
                equalityElementMatcher = v;
              },

              expandArraysInBranches(v) {
                expandArraysInBranches = v;
              },

              hasOwn(v) {
                hasOwn = v;
              },

              isOperatorObject(v) {
                isOperatorObject = v;
              },

              makeLookupFunction(v) {
                makeLookupFunction = v;
              },

              regexpElementMatcher(v) {
                regexpElementMatcher = v;
              }

            }, 0);

            class Sorter {
              constructor(spec) {
                this._sortSpecParts = [];
                this._sortFunction = null;

                const addSpecPart = (path, ascending) => {
                  if (!path) {
                    throw Error('sort keys must be non-empty');
                  }

                  if (path.charAt(0) === '$') {
                    throw Error("unsupported sort key: ".concat(path));
                  }

                  this._sortSpecParts.push({
                    ascending,
                    lookup: makeLookupFunction(path, {
                      forSort: true
                    }),
                    path
                  });
                };

                if (spec instanceof Array) {
                  spec.forEach(element => {
                    if (typeof element === 'string') {
                      addSpecPart(element, true);
                    } else {
                      addSpecPart(element[0], element[1] !== 'desc');
                    }
                  });
                } else if (typeof spec === 'object') {
                  Object.keys(spec).forEach(key => {
                    addSpecPart(key, spec[key] >= 0);
                  });
                } else if (typeof spec === 'function') {
                  this._sortFunction = spec;
                } else {
                  throw Error("Bad sort specification: ".concat(JSON.stringify(spec)));
                } // If a function is specified for sorting, we skip the rest.


                if (this._sortFunction) {
                  return;
                } // To implement affectedByModifier, we piggy-back on top of Matcher's
                // affectedByModifier code; we create a selector that is affected by the
                // same modifiers as this sort order. This is only implemented on the
                // server.


                if (this.affectedByModifier) {
                  const selector = {};

                  this._sortSpecParts.forEach(spec => {
                    selector[spec.path] = 1;
                  });

                  this._selectorForAffectedByModifier = new Minimongo.Matcher(selector);
                }

                this._keyComparator = composeComparators(this._sortSpecParts.map((spec, i) => this._keyFieldComparator(i)));
              }

              getComparator(options) {
                // If sort is specified or have no distances, just use the comparator from
                // the source specification (which defaults to "everything is equal".
                // issue #3599
                // https://docs.mongodb.com/manual/reference/operator/query/near/#sort-operation
                // sort effectively overrides $near
                if (this._sortSpecParts.length || !options || !options.distances) {
                  return this._getBaseComparator();
                }

                const distances = options.distances; // Return a comparator which compares using $near distances.

                return (a, b) => {
                  if (!distances.has(a._id)) {
                    throw Error("Missing distance for ".concat(a._id));
                  }

                  if (!distances.has(b._id)) {
                    throw Error("Missing distance for ".concat(b._id));
                  }

                  return distances.get(a._id) - distances.get(b._id);
                };
              } // Takes in two keys: arrays whose lengths match the number of spec
              // parts. Returns negative, 0, or positive based on using the sort spec to
              // compare fields.


              _compareKeys(key1, key2) {
                if (key1.length !== this._sortSpecParts.length || key2.length !== this._sortSpecParts.length) {
                  throw Error('Key has wrong length');
                }

                return this._keyComparator(key1, key2);
              } // Iterates over each possible "key" from doc (ie, over each branch), calling
              // 'cb' with the key.


              _generateKeysFromDoc(doc, cb) {
                if (this._sortSpecParts.length === 0) {
                  throw new Error('can\'t generate keys without a spec');
                }

                const pathFromIndices = indices => "".concat(indices.join(','), ",");

                let knownPaths = null; // maps index -> ({'' -> value} or {path -> value})

                const valuesByIndexAndPath = this._sortSpecParts.map(spec => {
                  // Expand any leaf arrays that we find, and ignore those arrays
                  // themselves.  (We never sort based on an array itself.)
                  let branches = expandArraysInBranches(spec.lookup(doc), true); // If there are no values for a key (eg, key goes to an empty array),
                  // pretend we found one undefined value.

                  if (!branches.length) {
                    branches = [{
                      value: void 0
                    }];
                  }

                  const element = Object.create(null);
                  let usedPaths = false;
                  branches.forEach(branch => {
                    if (!branch.arrayIndices) {
                      // If there are no array indices for a branch, then it must be the
                      // only branch, because the only thing that produces multiple branches
                      // is the use of arrays.
                      if (branches.length > 1) {
                        throw Error('multiple branches but no array used?');
                      }

                      element[''] = branch.value;
                      return;
                    }

                    usedPaths = true;
                    const path = pathFromIndices(branch.arrayIndices);

                    if (hasOwn.call(element, path)) {
                      throw Error("duplicate path: ".concat(path));
                    }

                    element[path] = branch.value; // If two sort fields both go into arrays, they have to go into the
                    // exact same arrays and we have to find the same paths.  This is
                    // roughly the same condition that makes MongoDB throw this strange
                    // error message.  eg, the main thing is that if sort spec is {a: 1,
                    // b:1} then a and b cannot both be arrays.
                    //
                    // (In MongoDB it seems to be OK to have {a: 1, 'a.x.y': 1} where 'a'
                    // and 'a.x.y' are both arrays, but we don't allow this for now.
                    // #NestedArraySort
                    // XXX achieve full compatibility here

                    if (knownPaths && !hasOwn.call(knownPaths, path)) {
                      throw Error('cannot index parallel arrays');
                    }
                  });

                  if (knownPaths) {
                    // Similarly to above, paths must match everywhere, unless this is a
                    // non-array field.
                    if (!hasOwn.call(element, '') && Object.keys(knownPaths).length !== Object.keys(element).length) {
                      throw Error('cannot index parallel arrays!');
                    }
                  } else if (usedPaths) {
                    knownPaths = {};
                    Object.keys(element).forEach(path => {
                      knownPaths[path] = true;
                    });
                  }

                  return element;
                });

                if (!knownPaths) {
                  // Easy case: no use of arrays.
                  const soleKey = valuesByIndexAndPath.map(values => {
                    if (!hasOwn.call(values, '')) {
                      throw Error('no value in sole key case?');
                    }

                    return values[''];
                  });
                  cb(soleKey);
                  return;
                }

                Object.keys(knownPaths).forEach(path => {
                  const key = valuesByIndexAndPath.map(values => {
                    if (hasOwn.call(values, '')) {
                      return values[''];
                    }

                    if (!hasOwn.call(values, path)) {
                      throw Error('missing path?');
                    }

                    return values[path];
                  });
                  cb(key);
                });
              } // Returns a comparator that represents the sort specification (but not
              // including a possible geoquery distance tie-breaker).


              _getBaseComparator() {
                if (this._sortFunction) {
                  return this._sortFunction;
                } // If we're only sorting on geoquery distance and no specs, just say
                // everything is equal.


                if (!this._sortSpecParts.length) {
                  return (doc1, doc2) => 0;
                }

                return (doc1, doc2) => {
                  const key1 = this._getMinKeyFromDoc(doc1);

                  const key2 = this._getMinKeyFromDoc(doc2);

                  return this._compareKeys(key1, key2);
                };
              } // Finds the minimum key from the doc, according to the sort specs.  (We say
              // "minimum" here but this is with respect to the sort spec, so "descending"
              // sort fields mean we're finding the max for that field.)
              //
              // Note that this is NOT "find the minimum value of the first field, the
              // minimum value of the second field, etc"... it's "choose the
              // lexicographically minimum value of the key vector, allowing only keys which
              // you can find along the same paths".  ie, for a doc {a: [{x: 0, y: 5}, {x:
              // 1, y: 3}]} with sort spec {'a.x': 1, 'a.y': 1}, the only keys are [0,5] and
              // [1,3], and the minimum key is [0,5]; notably, [0,3] is NOT a key.


              _getMinKeyFromDoc(doc) {
                let minKey = null;

                this._generateKeysFromDoc(doc, key => {
                  if (minKey === null) {
                    minKey = key;
                    return;
                  }

                  if (this._compareKeys(key, minKey) < 0) {
                    minKey = key;
                  }
                });

                return minKey;
              }

              _getPaths() {
                return this._sortSpecParts.map(part => part.path);
              } // Given an index 'i', returns a comparator that compares two key arrays based
              // on field 'i'.


              _keyFieldComparator(i) {
                const invert = !this._sortSpecParts[i].ascending;
                return (key1, key2) => {
                  const compare = LocalCollection._f._cmp(key1[i], key2[i]);

                  return invert ? -compare : compare;
                };
              }

            }

            // Given an array of comparators
            // (functions (a,b)->(negative or positive or zero)), returns a single
            // comparator which uses each comparator in order and returns the first
            // non-zero value.
            function composeComparators(comparatorArray) {
              return (a, b) => {
                for (let i = 0; i < comparatorArray.length; ++i) {
                  const compare = comparatorArray[i](a, b);

                  if (compare !== 0) {
                    return compare;
                  }
                }

                return 0;
              };
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports3 = _require3("/node_modules/meteor/minimongo/minimongo_client.js");

  /* Exports */
  Package._define("minimongo", _exports3, {
    LocalCollection: LocalCollection,
    Minimongo: Minimongo,
    MinimongoTest: MinimongoTest,
    MinimongoError: MinimongoError
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var EJSON = Package.ejson.EJSON;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var check, Match;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "check": { "match.js": function module(_require, _exports, _module) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                               //
            // packages/check/match.js                                                                                       //
            //                                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              check: () => check,
              Match: () => Match
            });
            let isPlainObject;
            _module.link("./isPlainObject", {
              isPlainObject(v) {
                isPlainObject = v;
              }

            }, 0);
            // Things we explicitly do NOT support:
            //    - heterogenous arrays
            const currentArgumentChecker = new Meteor.EnvironmentVariable();
            const hasOwn = Object.prototype.hasOwnProperty;
            /**
             * @summary Check that a value matches a [pattern](#matchpatterns).
             * If the value does not match the pattern, throw a `Match.Error`.
             *
             * Particularly useful to assert that arguments to a function have the right
             * types and structure.
             * @locus Anywhere
             * @param {Any} value The value to check
             * @param {MatchPattern} pattern The pattern to match `value` against
             */

            function check(value, pattern) {
              // Record that check got called, if somebody cared.
              //
              // We use getOrNullIfOutsideFiber so that it's OK to call check()
              // from non-Fiber server contexts; the downside is that if you forget to
              // bindEnvironment on some random callback in your method/publisher,
              // it might not find the argumentChecker and you'll get an error about
              // not checking an argument that it looks like you're checking (instead
              // of just getting a "Node code must run in a Fiber" error).
              const argChecker = currentArgumentChecker.getOrNullIfOutsideFiber();

              if (argChecker) {
                argChecker.checking(value);
              }

              const result = testSubtree(value, pattern);

              if (result) {
                const err = new Match.Error(result.message);

                if (result.path) {
                  err.message += " in field ".concat(result.path);
                  err.path = result.path;
                }

                throw err;
              }
            }

            ;
            /**
             * @namespace Match
             * @summary The namespace for all Match types and methods.
             */

            const Match = {
              Optional: function (pattern) {
                return new Optional(pattern);
              },
              Maybe: function (pattern) {
                return new Maybe(pattern);
              },
              OneOf: function () {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                return new OneOf(args);
              },
              Any: ['__any__'],
              Where: function (condition) {
                return new Where(condition);
              },
              ObjectIncluding: function (pattern) {
                return new ObjectIncluding(pattern);
              },
              ObjectWithValues: function (pattern) {
                return new ObjectWithValues(pattern);
              },
              // Matches only signed 32-bit integers
              Integer: ['__integer__'],
              // XXX matchers should know how to describe themselves for errors
              Error: Meteor.makeErrorType('Match.Error', function (msg) {
                this.message = "Match error: ".concat(msg); // The path of the value that failed to match. Initially empty, this gets
                // populated by catching and rethrowing the exception as it goes back up the
                // stack.
                // E.g.: "vals[3].entity.created"

                this.path = ''; // If this gets sent over DDP, don't give full internal details but at least
                // provide something better than 500 Internal server error.

                this.sanitizedError = new Meteor.Error(400, 'Match failed');
              }),

              // Tests to see if value matches pattern. Unlike check, it merely returns true
              // or false (unless an error other than Match.Error was thrown). It does not
              // interact with _failIfArgumentsAreNotAllChecked.
              // XXX maybe also implement a Match.match which returns more information about
              //     failures but without using exception handling or doing what check()
              //     does with _failIfArgumentsAreNotAllChecked and Meteor.Error conversion

              /**
               * @summary Returns true if the value matches the pattern.
               * @locus Anywhere
               * @param {Any} value The value to check
               * @param {MatchPattern} pattern The pattern to match `value` against
               */
              test(value, pattern) {
                return !testSubtree(value, pattern);
              },

              // Runs `f.apply(context, args)`. If check() is not called on every element of
              // `args` (either directly or in the first level of an array), throws an error
              // (using `description` in the message).
              _failIfArgumentsAreNotAllChecked(f, context, args, description) {
                const argChecker = new ArgumentChecker(args, description);
                const result = currentArgumentChecker.withValue(argChecker, () => f.apply(context, args)); // If f didn't itself throw, make sure it checked all of its arguments.

                argChecker.throwUnlessAllArgumentsHaveBeenChecked();
                return result;
              }

            };

            class Optional {
              constructor(pattern) {
                this.pattern = pattern;
              }

            }

            class Maybe {
              constructor(pattern) {
                this.pattern = pattern;
              }

            }

            class OneOf {
              constructor(choices) {
                if (!choices || choices.length === 0) {
                  throw new Error('Must provide at least one choice to Match.OneOf');
                }

                this.choices = choices;
              }

            }

            class Where {
              constructor(condition) {
                this.condition = condition;
              }

            }

            class ObjectIncluding {
              constructor(pattern) {
                this.pattern = pattern;
              }

            }

            class ObjectWithValues {
              constructor(pattern) {
                this.pattern = pattern;
              }

            }

            const stringForErrorMessage = function (value) {
              let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (value === null) {
                return 'null';
              }

              if (options.onlyShowType) {
                return typeof value;
              } // Your average non-object things.  Saves from doing the try/catch below for.


              if (typeof value !== 'object') {
                return EJSON.stringify(value);
              }

              try {
                // Find objects with circular references since EJSON doesn't support them yet (Issue #4778 + Unaccepted PR)
                // If the native stringify is going to choke, EJSON.stringify is going to choke too.
                JSON.stringify(value);
              } catch (stringifyError) {
                if (stringifyError.name === 'TypeError') {
                  return typeof value;
                }
              }

              return EJSON.stringify(value);
            };

            const typeofChecks = [[String, 'string'], [Number, 'number'], [Boolean, 'boolean'], // While we don't allow undefined/function in EJSON, this is good for optional
            // arguments with OneOf.
            [Function, 'function'], [undefined, 'undefined']]; // Return `false` if it matches. Otherwise, return an object with a `message` and a `path` field.

            const testSubtree = (value, pattern) => {
              // Match anything!
              if (pattern === Match.Any) {
                return false;
              } // Basic atomic types.
              // Do not match boxed objects (e.g. String, Boolean)


              for (let i = 0; i < typeofChecks.length; ++i) {
                if (pattern === typeofChecks[i][0]) {
                  if (typeof value === typeofChecks[i][1]) {
                    return false;
                  }

                  return {
                    message: "Expected ".concat(typeofChecks[i][1], ", got ").concat(stringForErrorMessage(value, {
                      onlyShowType: true
                    })),
                    path: ''
                  };
                }
              }

              if (pattern === null) {
                if (value === null) {
                  return false;
                }

                return {
                  message: "Expected null, got ".concat(stringForErrorMessage(value)),
                  path: ''
                };
              } // Strings, numbers, and booleans match literally. Goes well with Match.OneOf.


              if (typeof pattern === 'string' || typeof pattern === 'number' || typeof pattern === 'boolean') {
                if (value === pattern) {
                  return false;
                }

                return {
                  message: "Expected ".concat(pattern, ", got ").concat(stringForErrorMessage(value)),
                  path: ''
                };
              } // Match.Integer is special type encoded with array


              if (pattern === Match.Integer) {
                // There is no consistent and reliable way to check if variable is a 64-bit
                // integer. One of the popular solutions is to get reminder of division by 1
                // but this method fails on really large floats with big precision.
                // E.g.: 1.348192308491824e+23 % 1 === 0 in V8
                // Bitwise operators work consistantly but always cast variable to 32-bit
                // signed integer according to JavaScript specs.
                if (typeof value === 'number' && (value | 0) === value) {
                  return false;
                }

                return {
                  message: "Expected Integer, got ".concat(stringForErrorMessage(value)),
                  path: ''
                };
              } // 'Object' is shorthand for Match.ObjectIncluding({});


              if (pattern === Object) {
                pattern = Match.ObjectIncluding({});
              } // Array (checked AFTER Any, which is implemented as an Array).


              if (pattern instanceof Array) {
                if (pattern.length !== 1) {
                  return {
                    message: "Bad pattern: arrays must have one type element ".concat(stringForErrorMessage(pattern)),
                    path: ''
                  };
                }

                if (!Array.isArray(value) && !isArguments(value)) {
                  return {
                    message: "Expected array, got ".concat(stringForErrorMessage(value)),
                    path: ''
                  };
                }

                for (let i = 0, length = value.length; i < length; i++) {
                  const result = testSubtree(value[i], pattern[0]);

                  if (result) {
                    result.path = _prependPath(i, result.path);
                    return result;
                  }
                }

                return false;
              } // Arbitrary validation checks. The condition can return false or throw a
              // Match.Error (ie, it can internally use check()) to fail.


              if (pattern instanceof Where) {
                let result;

                try {
                  result = pattern.condition(value);
                } catch (err) {
                  if (!(err instanceof Match.Error)) {
                    throw err;
                  }

                  return {
                    message: err.message,
                    path: err.path
                  };
                }

                if (result) {
                  return false;
                } // XXX this error is terrible


                return {
                  message: 'Failed Match.Where validation',
                  path: ''
                };
              }

              if (pattern instanceof Maybe) {
                pattern = Match.OneOf(undefined, null, pattern.pattern);
              } else if (pattern instanceof Optional) {
                pattern = Match.OneOf(undefined, pattern.pattern);
              }

              if (pattern instanceof OneOf) {
                for (let i = 0; i < pattern.choices.length; ++i) {
                  const result = testSubtree(value, pattern.choices[i]);

                  if (!result) {
                    // No error? Yay, return.
                    return false;
                  } // Match errors just mean try another choice.
                } // XXX this error is terrible


                return {
                  message: 'Failed Match.OneOf, Match.Maybe or Match.Optional validation',
                  path: ''
                };
              } // A function that isn't something we special-case is assumed to be a
              // constructor.


              if (pattern instanceof Function) {
                if (value instanceof pattern) {
                  return false;
                }

                return {
                  message: "Expected ".concat(pattern.name || 'particular constructor'),
                  path: ''
                };
              }

              let unknownKeysAllowed = false;
              let unknownKeyPattern;

              if (pattern instanceof ObjectIncluding) {
                unknownKeysAllowed = true;
                pattern = pattern.pattern;
              }

              if (pattern instanceof ObjectWithValues) {
                unknownKeysAllowed = true;
                unknownKeyPattern = [pattern.pattern];
                pattern = {}; // no required keys
              }

              if (typeof pattern !== 'object') {
                return {
                  message: 'Bad pattern: unknown pattern type',
                  path: ''
                };
              } // An object, with required and optional keys. Note that this does NOT do
              // structural matches against objects of special types that happen to match
              // the pattern: this really needs to be a plain old {Object}!


              if (typeof value !== 'object') {
                return {
                  message: "Expected object, got ".concat(typeof value),
                  path: ''
                };
              }

              if (value === null) {
                return {
                  message: "Expected object, got null",
                  path: ''
                };
              }

              if (!isPlainObject(value)) {
                return {
                  message: "Expected plain object",
                  path: ''
                };
              }

              const requiredPatterns = Object.create(null);
              const optionalPatterns = Object.create(null);
              Object.keys(pattern).forEach(key => {
                const subPattern = pattern[key];

                if (subPattern instanceof Optional || subPattern instanceof Maybe) {
                  optionalPatterns[key] = subPattern.pattern;
                } else {
                  requiredPatterns[key] = subPattern;
                }
              });

              for (let key in Object(value)) {
                const subValue = value[key];

                if (hasOwn.call(requiredPatterns, key)) {
                  const result = testSubtree(subValue, requiredPatterns[key]);

                  if (result) {
                    result.path = _prependPath(key, result.path);
                    return result;
                  }

                  delete requiredPatterns[key];
                } else if (hasOwn.call(optionalPatterns, key)) {
                  const result = testSubtree(subValue, optionalPatterns[key]);

                  if (result) {
                    result.path = _prependPath(key, result.path);
                    return result;
                  }
                } else {
                  if (!unknownKeysAllowed) {
                    return {
                      message: 'Unknown key',
                      path: key
                    };
                  }

                  if (unknownKeyPattern) {
                    const result = testSubtree(subValue, unknownKeyPattern[0]);

                    if (result) {
                      result.path = _prependPath(key, result.path);
                      return result;
                    }
                  }
                }
              }

              const keys = Object.keys(requiredPatterns);

              if (keys.length) {
                return {
                  message: "Missing key '".concat(keys[0], "'"),
                  path: ''
                };
              }
            };

            class ArgumentChecker {
              constructor(args, description) {
                // Make a SHALLOW copy of the arguments. (We'll be doing identity checks
                // against its contents.)
                this.args = [...args]; // Since the common case will be to check arguments in order, and we splice
                // out arguments when we check them, make it so we splice out from the end
                // rather than the beginning.

                this.args.reverse();
                this.description = description;
              }

              checking(value) {
                if (this._checkingOneValue(value)) {
                  return;
                } // Allow check(arguments, [String]) or check(arguments.slice(1), [String])
                // or check([foo, bar], [String]) to count... but only if value wasn't
                // itself an argument.


                if (Array.isArray(value) || isArguments(value)) {
                  Array.prototype.forEach.call(value, this._checkingOneValue.bind(this));
                }
              }

              _checkingOneValue(value) {
                for (let i = 0; i < this.args.length; ++i) {
                  // Is this value one of the arguments? (This can have a false positive if
                  // the argument is an interned primitive, but it's still a good enough
                  // check.)
                  // (NaN is not === to itself, so we have to check specially.)
                  if (value === this.args[i] || Number.isNaN(value) && Number.isNaN(this.args[i])) {
                    this.args.splice(i, 1);
                    return true;
                  }
                }

                return false;
              }

              throwUnlessAllArgumentsHaveBeenChecked() {
                if (this.args.length > 0) throw new Error("Did not check() all arguments during ".concat(this.description));
              }

            }

            const _jsKeywords = ['do', 'if', 'in', 'for', 'let', 'new', 'try', 'var', 'case', 'else', 'enum', 'eval', 'false', 'null', 'this', 'true', 'void', 'with', 'break', 'catch', 'class', 'const', 'super', 'throw', 'while', 'yield', 'delete', 'export', 'import', 'public', 'return', 'static', 'switch', 'typeof', 'default', 'extends', 'finally', 'package', 'private', 'continue', 'debugger', 'function', 'arguments', 'interface', 'protected', 'implements', 'instanceof']; // Assumes the base of path is already escaped properly
            // returns key + base

            const _prependPath = (key, base) => {
              if (typeof key === 'number' || key.match(/^[0-9]+$/)) {
                key = "[".concat(key, "]");
              } else if (!key.match(/^[a-z_$][0-9a-z_$]*$/i) || _jsKeywords.indexOf(key) >= 0) {
                key = JSON.stringify([key]);
              }

              if (base && base[0] !== '[') {
                return "".concat(key, ".").concat(base);
              }

              return key + base;
            };

            const isObject = value => typeof value === 'object' && value !== null;

            const baseIsArguments = item => isObject(item) && Object.prototype.toString.call(item) === '[object Arguments]';

            const isArguments = baseIsArguments(function () {
              return arguments;
            }()) ? baseIsArguments : value => isObject(value) && typeof value.callee === 'function';
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "isPlainObject.js": function module(_require3, _exports3, _module2) {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                               //
            // packages/check/isPlainObject.js                                                                               //
            //                                                                                                               //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module2.export({
              isPlainObject: () => isPlainObject
            });
            // Copy of jQuery.isPlainObject for the server side from jQuery v3.1.1.
            const class2type = {};
            const toString = class2type.toString;
            const hasOwn = Object.prototype.hasOwnProperty;
            const fnToString = hasOwn.toString;
            const ObjectFunctionString = fnToString.call(Object);
            const getProto = Object.getPrototypeOf;

            const isPlainObject = obj => {
              let proto;
              let Ctor; // Detect obvious negatives
              // Use toString instead of jQuery.type to catch host objects

              if (!obj || toString.call(obj) !== '[object Object]') {
                return false;
              }

              proto = getProto(obj); // Objects with no prototype (e.g., `Object.create( null )`) are plain

              if (!proto) {
                return true;
              } // Objects with prototype are plain iff they were constructed by a global Object function


              Ctor = hasOwn.call(proto, 'constructor') && proto.constructor;
              return typeof Ctor === 'function' && fnToString.call(Ctor) === ObjectFunctionString;
            };
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/check/match.js");

  /* Exports */
  Package._define("check", _exports2, {
    check: check,
    Match: Match
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Random = Package.random.Random;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Retry;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "retry": { "retry.js": function module(_require, _exports, _module) {

            //////////////////////////////////////////////////////////////////////////////////
            //                                                                              //
            // packages/retry/retry.js                                                      //
            //                                                                              //
            //////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Retry: () => Retry
            });

            class Retry {
              constructor() {
                let {
                  baseTimeout = 1000,
                  exponent = 2.2,
                  // The default is high-ish to ensure a server can recover from a
                  // failure caused by load.
                  maxTimeout = 5 * 60 * 1000,
                  minTimeout = 10,
                  minCount = 2,
                  fuzz = 0.5
                } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.baseTimeout = baseTimeout;
                this.exponent = exponent;
                this.maxTimeout = maxTimeout;
                this.minTimeout = minTimeout;
                this.minCount = minCount;
                this.fuzz = fuzz;
                this.retryTimer = null;
              } // Reset a pending retry, if any.


              clear() {
                if (this.retryTimer) {
                  clearTimeout(this.retryTimer);
                }

                this.retryTimer = null;
              } // Calculate how long to wait in milliseconds to retry, based on the
              // `count` of which retry this is.


              _timeout(count) {
                if (count < this.minCount) {
                  return this.minTimeout;
                } // fuzz the timeout randomly, to avoid reconnect storms when a
                // server goes down.


                var timeout = Math.min(this.maxTimeout, this.baseTimeout * Math.pow(this.exponent, count)) * (Random.fraction() * this.fuzz + (1 - this.fuzz / 2));
                return timeout;
              } // Call `fn` after a delay, based on the `count` of which retry this is.


              retryLater(count, fn) {
                var timeout = this._timeout(count);

                if (this.retryTimer) clearTimeout(this.retryTimer);
                this.retryTimer = Meteor.setTimeout(fn, timeout);
                return timeout;
              }

            }
            //////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/retry/retry.js");

  /* Exports */
  Package._define("retry", _exports2, {
    Retry: Retry
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var options, callback, Hook;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "callback-hook": { "hook.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                 //
            // packages/callback-hook/hook.js                                                                  //
            //                                                                                                 //
            /////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Hook: () => Hook
            });
            // XXX This pattern is under development. Do not add more callsites
            // using this package for now. See:
            // https://meteor.hackpad.com/Design-proposal-Hooks-YxvgEW06q6f
            //
            // Encapsulates the pattern of registering callbacks on a hook.
            //
            // The `each` method of the hook calls its iterator function argument
            // with each registered callback.  This allows the hook to
            // conditionally decide not to call the callback (if, for example, the
            // observed object has been closed or terminated).
            //
            // By default, callbacks are bound with `Meteor.bindEnvironment`, so they will be
            // called with the Meteor environment of the calling code that
            // registered the callback. Override by passing { bindEnvironment: false }
            // to the constructor.
            //
            // Registering a callback returns an object with a single `stop`
            // method which unregisters the callback.
            //
            // The code is careful to allow a callback to be safely unregistered
            // while the callbacks are being iterated over.
            //
            // If the hook is configured with the `exceptionHandler` option, the
            // handler will be called if a called callback throws an exception.
            // By default (if the exception handler doesn't itself throw an
            // exception, or if the iterator function doesn't return a falsy value
            // to terminate the calling of callbacks), the remaining callbacks
            // will still be called.
            //
            // Alternatively, the `debugPrintExceptions` option can be specified
            // as string describing the callback.  On an exception the string and
            // the exception will be printed to the console log with
            // `Meteor._debug`, and the exception otherwise ignored.
            //
            // If an exception handler isn't specified, exceptions thrown in the
            // callback will propagate up to the iterator function, and will
            // terminate calling the remaining callbacks if not caught.
            const hasOwn = Object.prototype.hasOwnProperty;

            class Hook {
              constructor(options) {
                options = options || {};
                this.nextCallbackId = 0;
                this.callbacks = Object.create(null); // Whether to wrap callbacks with Meteor.bindEnvironment

                this.bindEnvironment = true;

                if (options.bindEnvironment === false) {
                  this.bindEnvironment = false;
                }

                if (options.exceptionHandler) {
                  this.exceptionHandler = options.exceptionHandler;
                } else if (options.debugPrintExceptions) {
                  if (typeof options.debugPrintExceptions !== "string") {
                    throw new Error("Hook option debugPrintExceptions should be a string");
                  }

                  this.exceptionHandler = options.debugPrintExceptions;
                }
              }

              register(callback) {
                const exceptionHandler = this.exceptionHandler || function (exception) {
                  // Note: this relies on the undocumented fact that if bindEnvironment's
                  // onException throws, and you are invoking the callback either in the
                  // browser or from within a Fiber in Node, the exception is propagated.
                  throw exception;
                };

                if (this.bindEnvironment) {
                  callback = Meteor.bindEnvironment(callback, exceptionHandler);
                } else {
                  callback = dontBindEnvironment(callback, exceptionHandler);
                }

                const id = this.nextCallbackId++;
                this.callbacks[id] = callback;
                return {
                  callback,
                  stop: () => {
                    delete this.callbacks[id];
                  }
                };
              } // For each registered callback, call the passed iterator function
              // with the callback.
              //
              // The iterator function can choose whether or not to call the
              // callback.  (For example, it might not call the callback if the
              // observed object has been closed or terminated).
              //
              // The iteration is stopped if the iterator function returns a falsy
              // value or throws an exception.
              //


              each(iterator) {
                // Invoking bindEnvironment'd callbacks outside of a Fiber in Node doesn't
                // run them to completion (and exceptions thrown from onException are not
                // propagated), so we need to be in a Fiber.
                Meteor._nodeCodeMustBeInFiber();

                const ids = Object.keys(this.callbacks);

                for (let i = 0; i < ids.length; ++i) {
                  const id = ids[i]; // check to see if the callback was removed during iteration

                  if (hasOwn.call(this.callbacks, id)) {
                    const callback = this.callbacks[id];

                    if (!iterator(callback)) {
                      break;
                    }
                  }
                }
              }

            }

            // Copied from Meteor.bindEnvironment and removed all the env stuff.
            function dontBindEnvironment(func, onException, _this) {
              if (!onException || typeof onException === 'string') {
                const description = onException || "callback of async function";

                onException = function (error) {
                  Meteor._debug("Exception in " + description, error);
                };
              }

              return function () {
                let ret;

                try {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  ret = func.apply(_this, args);
                } catch (e) {
                  onException(e);
                }

                return ret;
              };
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/callback-hook/hook.js");

  /* Exports */
  Package._define("callback-hook", _exports2, {
    Hook: Hook
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var Random = Package.random.Random;
  var EJSON = Package.ejson.EJSON;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var Retry = Package.retry.Retry;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var DDPCommon;

  var _require = meteorInstall({ "node_modules": { "meteor": { "ddp-common": { "namespace.js": function _module() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/ddp-common/namespace.js                                                                                   //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            /**
             * @namespace DDPCommon
             * @summary Namespace for DDPCommon-related methods/classes. Shared between 
             * `ddp-client` and `ddp-server`, where the ddp-client is the implementation
             * of a ddp client for both client AND server; and the ddp server is the
             * implementation of the livedata server and stream server. Common 
             * functionality shared between both can be shared under this namespace
             */
            DDPCommon = {};
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "heartbeat.js": function _module2() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/ddp-common/heartbeat.js                                                                                   //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // Heartbeat options:
            //   heartbeatInterval: interval to send pings, in milliseconds.
            //   heartbeatTimeout: timeout to close the connection if a reply isn't
            //     received, in milliseconds.
            //   sendPing: function to call to send a ping on the connection.
            //   onTimeout: function to call to close the connection.
            DDPCommon.Heartbeat = class Heartbeat {
              constructor(options) {
                this.heartbeatInterval = options.heartbeatInterval;
                this.heartbeatTimeout = options.heartbeatTimeout;
                this._sendPing = options.sendPing;
                this._onTimeout = options.onTimeout;
                this._seenPacket = false;
                this._heartbeatIntervalHandle = null;
                this._heartbeatTimeoutHandle = null;
              }

              stop() {
                this._clearHeartbeatIntervalTimer();

                this._clearHeartbeatTimeoutTimer();
              }

              start() {
                this.stop();

                this._startHeartbeatIntervalTimer();
              }

              _startHeartbeatIntervalTimer() {
                this._heartbeatIntervalHandle = Meteor.setInterval(() => this._heartbeatIntervalFired(), this.heartbeatInterval);
              }

              _startHeartbeatTimeoutTimer() {
                this._heartbeatTimeoutHandle = Meteor.setTimeout(() => this._heartbeatTimeoutFired(), this.heartbeatTimeout);
              }

              _clearHeartbeatIntervalTimer() {
                if (this._heartbeatIntervalHandle) {
                  Meteor.clearInterval(this._heartbeatIntervalHandle);
                  this._heartbeatIntervalHandle = null;
                }
              }

              _clearHeartbeatTimeoutTimer() {
                if (this._heartbeatTimeoutHandle) {
                  Meteor.clearTimeout(this._heartbeatTimeoutHandle);
                  this._heartbeatTimeoutHandle = null;
                }
              } // The heartbeat interval timer is fired when we should send a ping.


              _heartbeatIntervalFired() {
                // don't send ping if we've seen a packet since we last checked,
                // *or* if we have already sent a ping and are awaiting a timeout.
                // That shouldn't happen, but it's possible if
                // `this.heartbeatInterval` is smaller than
                // `this.heartbeatTimeout`.
                if (!this._seenPacket && !this._heartbeatTimeoutHandle) {
                  this._sendPing(); // Set up timeout, in case a pong doesn't arrive in time.


                  this._startHeartbeatTimeoutTimer();
                }

                this._seenPacket = false;
              } // The heartbeat timeout timer is fired when we sent a ping, but we
              // timed out waiting for the pong.


              _heartbeatTimeoutFired() {
                this._heartbeatTimeoutHandle = null;

                this._onTimeout();
              }

              messageReceived() {
                // Tell periodic checkin that we have seen a packet, and thus it
                // does not need to send a ping this cycle.
                this._seenPacket = true; // If we were waiting for a pong, we got it.

                if (this._heartbeatTimeoutHandle) {
                  this._clearHeartbeatTimeoutTimer();
                }
              }

            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "utils.js": function module(_require2, _exports, _module3) {

            _module3.export({
              hasOwn: () => hasOwn,
              slice: () => slice,
              keys: () => keys,
              isEmpty: () => isEmpty,
              last: () => last
            });
            const hasOwn = Object.prototype.hasOwnProperty;
            const slice = Array.prototype.slice;

            function keys(obj) {
              return Object.keys(Object(obj));
            }

            function isEmpty(obj) {
              if (obj == null) {
                return true;
              }

              if (Array.isArray(obj) || typeof obj === "string") {
                return obj.length === 0;
              }

              for (const key in obj) {
                if (hasOwn.call(obj, key)) {
                  return false;
                }
              }

              return true;
            }

            function last(array, n, guard) {
              if (array == null) {
                return;
              }

              if (n == null || guard) {
                return array[array.length - 1];
              }

              return slice.call(array, Math.max(array.length - n, 0));
            }

            DDPCommon.SUPPORTED_DDP_VERSIONS = ['1', 'pre2', 'pre1'];

            DDPCommon.parseDDP = function (stringMessage) {
              try {
                var msg = JSON.parse(stringMessage);
              } catch (e) {
                Meteor._debug("Discarding message with invalid JSON", stringMessage);

                return null;
              } // DDP messages must be objects.


              if (msg === null || typeof msg !== 'object') {
                Meteor._debug("Discarding non-object DDP message", stringMessage);

                return null;
              } // massage msg to get it into "abstract ddp" rather than "wire ddp" format.
              // switch between "cleared" rep of unsetting fields and "undefined"
              // rep of same


              if (hasOwn.call(msg, 'cleared')) {
                if (!hasOwn.call(msg, 'fields')) {
                  msg.fields = {};
                }

                msg.cleared.forEach(clearKey => {
                  msg.fields[clearKey] = undefined;
                });
                delete msg.cleared;
              }

              ['fields', 'params', 'result'].forEach(field => {
                if (hasOwn.call(msg, field)) {
                  msg[field] = EJSON._adjustTypesFromJSONValue(msg[field]);
                }
              });
              return msg;
            };

            DDPCommon.stringifyDDP = function (msg) {
              const copy = EJSON.clone(msg); // swizzle 'changed' messages from 'fields undefined' rep to 'fields
              // and cleared' rep

              if (hasOwn.call(msg, 'fields')) {
                const cleared = [];
                Object.keys(msg.fields).forEach(key => {
                  const value = msg.fields[key];

                  if (typeof value === "undefined") {
                    cleared.push(key);
                    delete copy.fields[key];
                  }
                });

                if (!isEmpty(cleared)) {
                  copy.cleared = cleared;
                }

                if (isEmpty(copy.fields)) {
                  delete copy.fields;
                }
              } // adjust types to basic


              ['fields', 'params', 'result'].forEach(field => {
                if (hasOwn.call(copy, field)) {
                  copy[field] = EJSON._adjustTypesToJSONValue(copy[field]);
                }
              });

              if (msg.id && typeof msg.id !== 'string') {
                throw new Error("Message id is not a string");
              }

              return JSON.stringify(copy);
            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "method_invocation.js": function _module4() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/ddp-common/method_invocation.js                                                                           //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // Instance name is this because it is usually referred to as this inside a
            // method definition

            /**
             * @summary The state for a single invocation of a method, referenced by this
             * inside a method definition.
             * @param {Object} options
             * @instanceName this
             * @showInstanceName true
             */
            DDPCommon.MethodInvocation = class MethodInvocation {
              constructor(options) {
                // true if we're running not the actual method, but a stub (that is,
                // if we're on a client (which may be a browser, or in the future a
                // server connecting to another server) and presently running a
                // simulation of a server-side method for latency compensation
                // purposes). not currently true except in a client such as a browser,
                // since there's usually no point in running stubs unless you have a
                // zero-latency connection to the user.

                /**
                 * @summary Access inside a method invocation.  Boolean value, true if this invocation is a stub.
                 * @locus Anywhere
                 * @name  isSimulation
                 * @memberOf DDPCommon.MethodInvocation
                 * @instance
                 * @type {Boolean}
                 */
                this.isSimulation = options.isSimulation; // call this function to allow other method invocations (from the
                // same client) to continue running without waiting for this one to
                // complete.

                this._unblock = options.unblock || function () {};

                this._calledUnblock = false; // current user id

                /**
                 * @summary The id of the user that made this method call, or `null` if no user was logged in.
                 * @locus Anywhere
                 * @name  userId
                 * @memberOf DDPCommon.MethodInvocation
                 * @instance
                 */

                this.userId = options.userId; // sets current user id in all appropriate server contexts and
                // reruns subscriptions

                this._setUserId = options.setUserId || function () {}; // On the server, the connection this method call came in on.

                /**
                 * @summary Access inside a method invocation. The [connection](#meteor_onconnection) that this method was received on. `null` if the method is not associated with a connection, eg. a server initiated method call. Calls to methods made from a server method which was in turn initiated from the client share the same `connection`.
                 * @locus Server
                 * @name  connection
                 * @memberOf DDPCommon.MethodInvocation
                 * @instance
                 */

                this.connection = options.connection; // The seed for randomStream value generation

                this.randomSeed = options.randomSeed; // This is set by RandomStream.get; and holds the random stream state

                this.randomStream = null;
              }
              /**
               * @summary Call inside a method invocation.  Allow subsequent method from this client to begin running in a new fiber.
               * @locus Server
               * @memberOf DDPCommon.MethodInvocation
               * @instance
               */

              unblock() {
                this._calledUnblock = true;

                this._unblock();
              }
              /**
               * @summary Set the logged in user.
               * @locus Server
               * @memberOf DDPCommon.MethodInvocation
               * @instance
               * @param {String | null} userId The value that should be returned by `userId` on this connection.
               */

              setUserId(userId) {
                if (this._calledUnblock) {
                  throw new Error("Can't call setUserId in a method after calling unblock");
                }

                this.userId = userId;

                this._setUserId(userId);
              }

            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "random_stream.js": function _module5() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/ddp-common/random_stream.js                                                                               //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // RandomStream allows for generation of pseudo-random values, from a seed.
            //
            // We use this for consistent 'random' numbers across the client and server.
            // We want to generate probably-unique IDs on the client, and we ideally want
            // the server to generate the same IDs when it executes the method.
            //
            // For generated values to be the same, we must seed ourselves the same way,
            // and we must keep track of the current state of our pseudo-random generators.
            // We call this state the scope. By default, we use the current DDP method
            // invocation as our scope.  DDP now allows the client to specify a randomSeed.
            // If a randomSeed is provided it will be used to seed our random sequences.
            // In this way, client and server method calls will generate the same values.
            //
            // We expose multiple named streams; each stream is independent
            // and is seeded differently (but predictably from the name).
            // By using multiple streams, we support reordering of requests,
            // as long as they occur on different streams.
            //
            // @param options {Optional Object}
            //   seed: Array or value - Seed value(s) for the generator.
            //                          If an array, will be used as-is
            //                          If a value, will be converted to a single-value array
            //                          If omitted, a random array will be used as the seed.
            DDPCommon.RandomStream = class RandomStream {
              constructor(options) {
                this.seed = [].concat(options.seed || randomToken());
                this.sequences = Object.create(null);
              } // Get a random sequence with the specified name, creating it if does not exist.
              // New sequences are seeded with the seed concatenated with the name.
              // By passing a seed into Random.create, we use the Alea generator.


              _sequence(name) {
                var self = this;
                var sequence = self.sequences[name] || null;

                if (sequence === null) {
                  var sequenceSeed = self.seed.concat(name);

                  for (var i = 0; i < sequenceSeed.length; i++) {
                    if (typeof sequenceSeed[i] === "function") {
                      sequenceSeed[i] = sequenceSeed[i]();
                    }
                  }

                  self.sequences[name] = sequence = Random.createWithSeeds.apply(null, sequenceSeed);
                }

                return sequence;
              }

            }; // Returns a random string of sufficient length for a random seed.
            // This is a placeholder function; a similar function is planned
            // for Random itself; when that is added we should remove this function,
            // and call Random's randomToken instead.

            function randomToken() {
              return Random.hexString(20);
            }

            ; // Returns the random stream with the specified name, in the specified
            // scope. If a scope is passed, then we use that to seed a (not
            // cryptographically secure) PRNG using the fast Alea algorithm.  If
            // scope is null (or otherwise falsey) then we use a generated seed.
            //
            // However, scope will normally be the current DDP method invocation,
            // so we'll use the stream with the specified name, and we should get
            // consistent values on the client and server sides of a method call.

            DDPCommon.RandomStream.get = function (scope, name) {
              if (!name) {
                name = "default";
              }

              if (!scope) {
                // There was no scope passed in; the sequence won't actually be
                // reproducible. but make it fast (and not cryptographically
                // secure) anyways, so that the behavior is similar to what you'd
                // get by passing in a scope.
                return Random.insecure;
              }

              var randomStream = scope.randomStream;

              if (!randomStream) {
                scope.randomStream = randomStream = new DDPCommon.RandomStream({
                  seed: scope.randomSeed
                });
              }

              return randomStream._sequence(name);
            }; // Creates a randomSeed for passing to a method call.
            // Note that we take enclosing as an argument,
            // though we expect it to be DDP._CurrentMethodInvocation.get()
            // However, we often evaluate makeRpcSeed lazily, and thus the relevant
            // invocation may not be the one currently in scope.
            // If enclosing is null, we'll use Random and values won't be repeatable.


            DDPCommon.makeRpcSeed = function (enclosing, methodName) {
              var stream = DDPCommon.RandomStream.get(enclosing, '/rpc/' + methodName);
              return stream.hexString(20);
            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/ddp-common/namespace.js");
  _require("/node_modules/meteor/ddp-common/heartbeat.js");
  _require("/node_modules/meteor/ddp-common/utils.js");
  _require("/node_modules/meteor/ddp-common/method_invocation.js");
  _require("/node_modules/meteor/ddp-common/random_stream.js");

  /* Exports */
  Package._define("ddp-common", {
    DDPCommon: DDPCommon
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Reload;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "reload": { "reload.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                             //
            // packages/reload/reload.js                                                                                   //
            //                                                                                                             //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Reload: () => Reload
            });
            const Reload = {};
            const reloadSettings = Meteor.settings && Meteor.settings.public && Meteor.settings.public.packages && Meteor.settings.public.packages.reload || {};

            function debug(message, context) {
              if (!reloadSettings.debug) {
                return;
              } // eslint-disable-next-line no-console


              console.log("[reload] ".concat(message), JSON.stringify(context));
            }

            const KEY_NAME = 'Meteor_Reload';
            let old_data = {}; // read in old data at startup.

            let old_json; // This logic for sessionStorage detection is based on browserstate/history.js

            let safeSessionStorage = null;

            try {
              // This throws a SecurityError on Chrome if cookies & localStorage are
              // explicitly disabled
              //
              // On Firefox with dom.storage.enabled set to false, sessionStorage is null
              //
              // We can't even do (typeof sessionStorage) on Chrome, it throws.  So we rely
              // on the throw if sessionStorage == null; the alternative is browser
              // detection, but this seems better.
              safeSessionStorage = window.sessionStorage; // Check we can actually use it

              if (safeSessionStorage) {
                safeSessionStorage.setItem('__dummy__', '1');
                safeSessionStorage.removeItem('__dummy__');
              } else {
                // Be consistently null, for safety
                safeSessionStorage = null;
              }
            } catch (e) {
              // Expected on chrome with strict security, or if sessionStorage not supported
              safeSessionStorage = null;
            } // Exported for test.


            Reload._getData = function () {
              return safeSessionStorage && safeSessionStorage.getItem(KEY_NAME);
            };

            if (safeSessionStorage) {
              old_json = Reload._getData();
              safeSessionStorage.removeItem(KEY_NAME);
            } else {// Unsupported browser (IE 6,7) or locked down security settings.
              // No session resumption.
              // Meteor._debug("XXX UNSUPPORTED BROWSER/SETTINGS");
            }

            if (!old_json) old_json = '{}';
            let old_parsed = {};

            try {
              old_parsed = JSON.parse(old_json);

              if (typeof old_parsed !== 'object') {
                Meteor._debug('Got bad data on reload. Ignoring.');

                old_parsed = {};
              }
            } catch (err) {
              Meteor._debug('Got invalid JSON on reload. Ignoring.');
            }

            if (old_parsed.reload && typeof old_parsed.data === 'object') {
              // Meteor._debug("Restoring reload data.");
              old_data = old_parsed.data;
            }

            let providers = []; ////////// External API //////////
            // Packages that support migration should register themselves by calling
            // this function. When it's time to migrate, callback will be called
            // with one argument, the "retry function," and an optional 'option'
            // argument (containing a key 'immediateMigration'). If the package
            // is ready to migrate, it should return [true, data], where data is
            // its migration data, an arbitrary JSON value (or [true] if it has
            // no migration data this time). If the package needs more time
            // before it is ready to migrate, it should return false. Then, once
            // it is ready to migrating again, it should call the retry
            // function. The retry function will return immediately, but will
            // schedule the migration to be retried, meaning that every package
            // will be polled once again for its migration data. If they are all
            // ready this time, then the migration will happen. name must be set if there
            // is migration data. If 'immediateMigration' is set in the options
            // argument, then it doesn't matter whether the package is ready to
            // migrate or not; the reload will happen immediately without waiting
            // (used for OAuth redirect login).
            //

            Reload._onMigrate = function (name, callback) {
              debug('_onMigrate', {
                name
              });

              if (!callback) {
                // name not provided, so first arg is callback.
                callback = name;
                name = undefined;
                debug('_onMigrate no callback');
              }

              providers.push({
                name: name,
                callback: callback
              });
            }; // Called by packages when they start up.
            // Returns the object that was saved, or undefined if none saved.
            //


            Reload._migrationData = function (name) {
              debug('_migrationData', {
                name
              });
              return old_data[name];
            }; // Options are the same as for `Reload._migrate`.


            const pollProviders = function (tryReload, options) {
              debug('pollProviders', {
                options
              });

              tryReload = tryReload || function () {};

              options = options || {};
              const {
                immediateMigration
              } = options;
              debug("pollProviders is ".concat(immediateMigration ? '' : 'NOT ', "immediateMigration"), {
                options
              });
              const migrationData = {};
              let allReady = true;
              providers.forEach(p => {
                const {
                  callback,
                  name
                } = p || {};
                const [ready, data] = callback(tryReload, options) || [];
                debug("pollProviders provider ".concat(name || 'unknown', " is ").concat(ready ? 'ready' : 'NOT ready'), {
                  options
                });

                if (!ready) {
                  allReady = false;
                }

                if (data !== undefined && name) {
                  migrationData[name] = data;
                }
              });

              if (allReady) {
                debug('pollProviders allReady', {
                  options,
                  migrationData
                });
                return migrationData;
              }

              if (immediateMigration) {
                debug('pollProviders immediateMigration', {
                  options,
                  migrationData
                });
                return migrationData;
              }

              return null;
            }; // Options are:
            //  - immediateMigration: true if the page will be reloaded immediately
            //    regardless of whether packages report that they are ready or not.


            Reload._migrate = function (tryReload, options) {
              debug('_migrate', {
                options
              }); // Make sure each package is ready to go, and collect their
              // migration data

              const migrationData = pollProviders(tryReload, options);

              if (migrationData === null) {
                return false; // not ready yet..
              }

              let json;

              try {
                // Persist the migration data
                json = JSON.stringify({
                  data: migrationData,
                  reload: true
                });
              } catch (err) {
                Meteor._debug("Couldn't serialize data for migration", migrationData);

                throw err;
              }

              if (safeSessionStorage) {
                try {
                  safeSessionStorage.setItem(KEY_NAME, json);
                } catch (err) {
                  // We should have already checked this, but just log - don't throw
                  Meteor._debug("Couldn't save data for migration to sessionStorage", err);
                }
              } else {
                Meteor._debug('Browser does not support sessionStorage. Not saving migration state.');
              }

              return true;
            }; // Allows tests to isolate the list of providers.


            Reload._withFreshProvidersForTest = function (f) {
              const originalProviders = providers.slice(0);
              providers = [];

              try {
                f();
              } finally {
                providers = originalProviders;
              }
            }; // Migrating reload: reload this page (presumably to pick up a new
            // version of the code or assets), but save the program state and
            // migrate it over. This function returns immediately. The reload
            // will happen at some point in the future once all of the packages
            // are ready to migrate.
            //


            let reloading = false;

            Reload._reload = function (options) {
              debug('_reload', {
                options
              });
              options = options || {};

              if (reloading) {
                debug('reloading in progress already', {
                  options
                });
                return;
              }

              reloading = true;

              function tryReload() {
                debug('tryReload');
                setTimeout(reload, 1);
              }

              function forceBrowserReload() {
                debug('forceBrowserReload'); // We'd like to make the browser reload the page using location.replace()
                // instead of location.reload(), because this avoids validating assets
                // with the server if we still have a valid cached copy. This doesn't work
                // when the location contains a hash however, because that wouldn't reload
                // the page and just scroll to the hash location instead.

                if (window.location.hash || window.location.href.endsWith('#')) {
                  window.location.reload();
                  return;
                }

                window.location.replace(window.location.href);
              }

              function reload() {
                debug('reload');

                if (!Reload._migrate(tryReload, options)) {
                  return;
                }

                if (Meteor.isCordova) {
                  WebAppLocalServer.switchToPendingVersion(() => {
                    forceBrowserReload();
                  });
                  return;
                }

                forceBrowserReload();
              }

              tryReload();
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/reload/reload.js");

  /* Exports */
  Package._define("reload", _exports2, {
    Reload: Reload
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Retry = Package.retry.Retry;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var options, SockJS;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "socket-stream-client": { "browser.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/socket-stream-client/browser.js                                                                            //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module.export({
              ClientStream: () => ClientStream
            });
            let toSockjsUrl, toWebsocketUrl;
            _module.link("./urls.js", {
              toSockjsUrl(v) {
                toSockjsUrl = v;
              },

              toWebsocketUrl(v) {
                toWebsocketUrl = v;
              }

            }, 0);
            let StreamClientCommon;
            _module.link("./common.js", {
              StreamClientCommon(v) {
                StreamClientCommon = v;
              }

            }, 1);
            _module.link("./sockjs-0.3.4.js");

            class ClientStream extends StreamClientCommon {
              // @param url {String} URL to Meteor app
              //   "http://subdomain.meteor.com/" or "/" or
              //   "ddp+sockjs://foo-**.meteor.com/sockjs"
              constructor(url, options) {
                super(options);

                this._initCommon(this.options); //// Constants
                // how long between hearing heartbeat from the server until we declare
                // the connection dead. heartbeats come every 45s (stream_server.js)
                //
                // NOTE: this is a older timeout mechanism. We now send heartbeats at
                // the DDP level (https://github.com/meteor/meteor/pull/1865), and
                // expect those timeouts to kill a non-responsive connection before
                // this timeout fires. This is kept around for compatibility (when
                // talking to a server that doesn't support DDP heartbeats) and can be
                // removed later.


                this.HEARTBEAT_TIMEOUT = 100 * 1000;
                this.rawUrl = url;
                this.socket = null;
                this.lastError = null;
                this.heartbeatTimer = null; // Listen to global 'online' event if we are running in a browser.
                // (IE8 does not support addEventListener)

                if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('online', this._online.bind(this), false
                /* useCapture. make FF3.6 happy. */
                ); //// Kickoff!

                this._launchConnection();
              } // data is a utf8 string. Data sent while not connected is dropped on
              // the floor, and it is up the user of this API to retransmit lost
              // messages on 'reset'


              send(data) {
                if (this.currentStatus.connected) {
                  this.socket.send(data);
                }
              } // Changes where this connection points


              _changeUrl(url) {
                this.rawUrl = url;
              }

              _connected() {
                if (this.connectionTimer) {
                  clearTimeout(this.connectionTimer);
                  this.connectionTimer = null;
                }

                if (this.currentStatus.connected) {
                  // already connected. do nothing. this probably shouldn't happen.
                  return;
                } // update status


                this.currentStatus.status = 'connected';
                this.currentStatus.connected = true;
                this.currentStatus.retryCount = 0;
                this.statusChanged(); // fire resets. This must come after status change so that clients
                // can call send from within a reset callback.

                this.forEachCallback('reset', callback => {
                  callback();
                });
              }

              _cleanup(maybeError) {
                this._clearConnectionAndHeartbeatTimers();

                if (this.socket) {
                  this.socket.onmessage = this.socket.onclose = this.socket.onerror = this.socket.onheartbeat = () => {};

                  this.socket.close();
                  this.socket = null;
                }

                this.forEachCallback('disconnect', callback => {
                  callback(maybeError);
                });
              }

              _clearConnectionAndHeartbeatTimers() {
                if (this.connectionTimer) {
                  clearTimeout(this.connectionTimer);
                  this.connectionTimer = null;
                }

                if (this.heartbeatTimer) {
                  clearTimeout(this.heartbeatTimer);
                  this.heartbeatTimer = null;
                }
              }

              _heartbeat_timeout() {
                console.log('Connection timeout. No sockjs heartbeat received.');

                this._lostConnection(new this.ConnectionError("Heartbeat timed out"));
              }

              _heartbeat_received() {
                // If we've already permanently shut down this stream, the timeout is
                // already cleared, and we don't need to set it again.
                if (this._forcedToDisconnect) return;
                if (this.heartbeatTimer) clearTimeout(this.heartbeatTimer);
                this.heartbeatTimer = setTimeout(this._heartbeat_timeout.bind(this), this.HEARTBEAT_TIMEOUT);
              }

              _sockjsProtocolsWhitelist() {
                // only allow polling protocols. no streaming.  streaming
                // makes safari spin.
                var protocolsWhitelist = ['xdr-polling', 'xhr-polling', 'iframe-xhr-polling', 'jsonp-polling']; // iOS 4 and 5 and below crash when using websockets over certain
                // proxies. this seems to be resolved with iOS 6. eg
                // https://github.com/LearnBoost/socket.io/issues/193#issuecomment-7308865.
                //
                // iOS <4 doesn't support websockets at all so sockjs will just
                // immediately fall back to http

                var noWebsockets = navigator && /iPhone|iPad|iPod/.test(navigator.userAgent) && /OS 4_|OS 5_/.test(navigator.userAgent);
                if (!noWebsockets) protocolsWhitelist = ['websocket'].concat(protocolsWhitelist);
                return protocolsWhitelist;
              }

              _launchConnection() {
                this._cleanup(); // cleanup the old socket, if there was one.


                var options = _objectSpread({
                  protocols_whitelist: this._sockjsProtocolsWhitelist()
                }, this.options._sockjsOptions);

                const hasSockJS = typeof SockJS === "function";
                this.socket = hasSockJS // Convert raw URL to SockJS URL each time we open a connection, so
                // that we can connect to random hostnames and get around browser
                // per-host connection limits.
                ? new SockJS(toSockjsUrl(this.rawUrl), undefined, options) : new WebSocket(toWebsocketUrl(this.rawUrl));

                this.socket.onopen = data => {
                  this.lastError = null;

                  this._connected();
                };

                this.socket.onmessage = data => {
                  this.lastError = null;

                  this._heartbeat_received();

                  if (this.currentStatus.connected) {
                    this.forEachCallback('message', callback => {
                      callback(data.data);
                    });
                  }
                };

                this.socket.onclose = () => {
                  this._lostConnection();
                };

                this.socket.onerror = error => {
                  const {
                    lastError
                  } = this;
                  this.lastError = error;
                  if (lastError) return;
                  console.log('stream error', error, new Date().toDateString());
                };

                this.socket.onheartbeat = () => {
                  this.lastError = null;

                  this._heartbeat_received();
                };

                if (this.connectionTimer) clearTimeout(this.connectionTimer);
                this.connectionTimer = setTimeout(() => {
                  this._lostConnection(new this.ConnectionError("DDP connection timed out"));
                }, this.CONNECT_TIMEOUT);
              }

            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "common.js": function module(_require3, _exports2, _module2) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/socket-stream-client/common.js                                                                             //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module2.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module2.export({
              StreamClientCommon: () => StreamClientCommon
            });
            let Retry;
            _module2.link("meteor/retry", {
              Retry(v) {
                Retry = v;
              }

            }, 0);
            const forcedReconnectError = new Error("forced reconnect");

            class StreamClientCommon {
              constructor(options) {
                this.options = _objectSpread({
                  retry: true
                }, options || null);
                this.ConnectionError = options && options.ConnectionError || Error;
              } // Register for callbacks.


              on(name, callback) {
                if (name !== 'message' && name !== 'reset' && name !== 'disconnect') throw new Error('unknown event type: ' + name);
                if (!this.eventCallbacks[name]) this.eventCallbacks[name] = [];
                this.eventCallbacks[name].push(callback);
              }

              forEachCallback(name, cb) {
                if (!this.eventCallbacks[name] || !this.eventCallbacks[name].length) {
                  return;
                }

                this.eventCallbacks[name].forEach(cb);
              }

              _initCommon(options) {
                options = options || Object.create(null); //// Constants
                // how long to wait until we declare the connection attempt
                // failed.

                this.CONNECT_TIMEOUT = options.connectTimeoutMs || 10000;
                this.eventCallbacks = Object.create(null); // name -> [callback]

                this._forcedToDisconnect = false; //// Reactive status

                this.currentStatus = {
                  status: 'connecting',
                  connected: false,
                  retryCount: 0
                };

                if (Package.tracker) {
                  this.statusListeners = new Package.tracker.Tracker.Dependency();
                }

                this.statusChanged = () => {
                  if (this.statusListeners) {
                    this.statusListeners.changed();
                  }
                }; //// Retry logic


                this._retry = new Retry();
                this.connectionTimer = null;
              } // Trigger a reconnect.


              reconnect(options) {
                options = options || Object.create(null);

                if (options.url) {
                  this._changeUrl(options.url);
                }

                if (options._sockjsOptions) {
                  this.options._sockjsOptions = options._sockjsOptions;
                }

                if (this.currentStatus.connected) {
                  if (options._force || options.url) {
                    this._lostConnection(forcedReconnectError);
                  }

                  return;
                } // if we're mid-connection, stop it.


                if (this.currentStatus.status === 'connecting') {
                  // Pretend it's a clean close.
                  this._lostConnection();
                }

                this._retry.clear();

                this.currentStatus.retryCount -= 1; // don't count manual retries

                this._retryNow();
              }

              disconnect(options) {
                options = options || Object.create(null); // Failed is permanent. If we're failed, don't let people go back
                // online by calling 'disconnect' then 'reconnect'.

                if (this._forcedToDisconnect) return; // If _permanent is set, permanently disconnect a stream. Once a stream
                // is forced to disconnect, it can never reconnect. This is for
                // error cases such as ddp version mismatch, where trying again
                // won't fix the problem.

                if (options._permanent) {
                  this._forcedToDisconnect = true;
                }

                this._cleanup();

                this._retry.clear();

                this.currentStatus = {
                  status: options._permanent ? 'failed' : 'offline',
                  connected: false,
                  retryCount: 0
                };
                if (options._permanent && options._error) this.currentStatus.reason = options._error;
                this.statusChanged();
              } // maybeError is set unless it's a clean protocol-level close.


              _lostConnection(maybeError) {
                this._cleanup(maybeError);

                this._retryLater(maybeError); // sets status. no need to do it here.
              } // fired when we detect that we've gone online. try to reconnect
              // immediately.


              _online() {
                // if we've requested to be offline by disconnecting, don't reconnect.
                if (this.currentStatus.status != 'offline') this.reconnect();
              }

              _retryLater(maybeError) {
                var timeout = 0;

                if (this.options.retry || maybeError === forcedReconnectError) {
                  timeout = this._retry.retryLater(this.currentStatus.retryCount, this._retryNow.bind(this));
                  this.currentStatus.status = 'waiting';
                  this.currentStatus.retryTime = new Date().getTime() + timeout;
                } else {
                  this.currentStatus.status = 'failed';
                  delete this.currentStatus.retryTime;
                }

                this.currentStatus.connected = false;
                this.statusChanged();
              }

              _retryNow() {
                if (this._forcedToDisconnect) return;
                this.currentStatus.retryCount += 1;
                this.currentStatus.status = 'connecting';
                this.currentStatus.connected = false;
                delete this.currentStatus.retryTime;
                this.statusChanged();

                this._launchConnection();
              } // Get current status. Reactive.


              status() {
                if (this.statusListeners) {
                  this.statusListeners.depend();
                }

                return this.currentStatus;
              }

            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "sockjs-0.3.4.js": function _module3(_require4) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/socket-stream-client/sockjs-0.3.4.js                                                                       //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // XXX METEOR changes in <METEOR>

            /* SockJS client, version 0.3.4, http://sockjs.org, MIT License
            
            Copyright (c) 2011-2012 VMware, Inc.
            
            Permission is hereby granted, free of charge, to any person obtaining a copy
            of this software and associated documentation files (the "Software"), to deal
            in the Software without restriction, including without limitation the rights
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software is
            furnished to do so, subject to the following conditions:
            
            The above copyright notice and this permission notice shall be included in
            all copies or substantial portions of the Software.
            
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
            THE SOFTWARE.
            */
            // <METEOR> Commented out JSO implementation (use json package instead).
            // JSON2 by Douglas Crockford (minified).
            // var JSON;JSON||(JSON={}),function(){function str(a,b){var c,d,e,f,g=gap,h,i=b[a];i&&typeof i=="object"&&typeof i.toJSON=="function"&&(i=i.toJSON(a)),typeof rep=="function"&&(i=rep.call(b,a,i));switch(typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";gap+=indent,h=[];if(Object.prototype.toString.apply(i)==="[object Array]"){f=i.length;for(c=0;c<f;c+=1)h[c]=str(c,i)||"null";e=h.length===0?"[]":gap?"[\n"+gap+h.join(",\n"+gap)+"\n"+g+"]":"["+h.join(",")+"]",gap=g;return e}if(rep&&typeof rep=="object"){f=rep.length;for(c=0;c<f;c+=1)typeof rep[c]=="string"&&(d=rep[c],e=str(d,i),e&&h.push(quote(d)+(gap?": ":":")+e))}else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&h.push(quote(d)+(gap?": ":":")+e));e=h.length===0?"{}":gap?"{\n"+gap+h.join(",\n"+gap)+"\n"+g+"}":"{"+h.join(",")+"}",gap=g;return e}}function quote(a){escapable.lastIndex=0;return escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return typeof b=="string"?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function f(a){return a<10?"0"+a:a}"use strict",typeof Date.prototype.toJSON!="function"&&(Date.prototype.toJSON=function(a){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(a){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;typeof JSON.stringify!="function"&&(JSON.stringify=function(a,b,c){var d;gap="",indent="";if(typeof c=="number")for(d=0;d<c;d+=1)indent+=" ";else typeof c=="string"&&(indent=c);rep=b;if(!b||typeof b=="function"||typeof b=="object"&&typeof b.length=="number")return str("",{"":a});throw new Error("JSON.stringify")}),typeof JSON.parse!="function"&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&typeof e=="object")for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),d!==undefined?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)}));if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,""))){j=eval("("+text+")");return typeof reviver=="function"?walk({"":j},""):j}throw new SyntaxError("JSON.parse")})}()
            // </METEOR>
            //     [*] Including lib/index.js
            // Public object
            SockJS = function () {
              var _document = document;
              var _window = window;
              var utils = {}; //         [*] Including lib/reventtarget.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              /* Simplified implementation of DOM2 EventTarget.
               *   http://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget
               */

              var REventTarget = function () {};

              REventTarget.prototype.addEventListener = function (eventType, listener) {
                if (!this._listeners) {
                  this._listeners = {};
                }

                if (!(eventType in this._listeners)) {
                  this._listeners[eventType] = [];
                }

                var arr = this._listeners[eventType];

                if (utils.arrIndexOf(arr, listener) === -1) {
                  arr.push(listener);
                }

                return;
              };

              REventTarget.prototype.removeEventListener = function (eventType, listener) {
                if (!(this._listeners && eventType in this._listeners)) {
                  return;
                }

                var arr = this._listeners[eventType];
                var idx = utils.arrIndexOf(arr, listener);

                if (idx !== -1) {
                  if (arr.length > 1) {
                    this._listeners[eventType] = arr.slice(0, idx).concat(arr.slice(idx + 1));
                  } else {
                    delete this._listeners[eventType];
                  }

                  return;
                }

                return;
              };

              REventTarget.prototype.dispatchEvent = function (event) {
                var t = event.type;
                var args = Array.prototype.slice.call(arguments, 0);

                if (this['on' + t]) {
                  this['on' + t].apply(this, args);
                }

                if (this._listeners && t in this._listeners) {
                  for (var i = 0; i < this._listeners[t].length; i++) {
                    this._listeners[t][i].apply(this, args);
                  }
                }
              }; //         [*] End of lib/reventtarget.js
              //         [*] Including lib/simpleevent.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var SimpleEvent = function (type, obj) {
                this.type = type;

                if (typeof obj !== 'undefined') {
                  for (var k in obj) {
                    if (!obj.hasOwnProperty(k)) continue;
                    this[k] = obj[k];
                  }
                }
              };

              SimpleEvent.prototype.toString = function () {
                var r = [];

                for (var k in this) {
                  if (!this.hasOwnProperty(k)) continue;
                  var v = this[k];
                  if (typeof v === 'function') v = '[function]';
                  r.push(k + '=' + v);
                }

                return 'SimpleEvent(' + r.join(', ') + ')';
              }; //         [*] End of lib/simpleevent.js
              //         [*] Including lib/eventemitter.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var EventEmitter = function (events) {
                var that = this;
                that._events = events || [];
                that._listeners = {};
              };

              EventEmitter.prototype.emit = function (type) {
                var that = this;

                that._verifyType(type);

                if (that._nuked) return;
                var args = Array.prototype.slice.call(arguments, 1);

                if (that['on' + type]) {
                  that['on' + type].apply(that, args);
                }

                if (type in that._listeners) {
                  for (var i = 0; i < that._listeners[type].length; i++) {
                    that._listeners[type][i].apply(that, args);
                  }
                }
              };

              EventEmitter.prototype.on = function (type, callback) {
                var that = this;

                that._verifyType(type);

                if (that._nuked) return;

                if (!(type in that._listeners)) {
                  that._listeners[type] = [];
                }

                that._listeners[type].push(callback);
              };

              EventEmitter.prototype._verifyType = function (type) {
                var that = this;

                if (utils.arrIndexOf(that._events, type) === -1) {
                  utils.log('Event ' + JSON.stringify(type) + ' not listed ' + JSON.stringify(that._events) + ' in ' + that);
                }
              };

              EventEmitter.prototype.nuke = function () {
                var that = this;
                that._nuked = true;

                for (var i = 0; i < that._events.length; i++) {
                  delete that[that._events[i]];
                }

                that._listeners = {};
              }; //         [*] End of lib/eventemitter.js
              //         [*] Including lib/utils.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var random_string_chars = 'abcdefghijklmnopqrstuvwxyz0123456789_';

              utils.random_string = function (length, max) {
                max = max || random_string_chars.length;
                var i,
                    ret = [];

                for (i = 0; i < length; i++) {
                  ret.push(random_string_chars.substr(Math.floor(Math.random() * max), 1));
                }

                return ret.join('');
              };

              utils.random_number = function (max) {
                return Math.floor(Math.random() * max);
              };

              utils.random_number_string = function (max) {
                var t = ('' + (max - 1)).length;
                var p = Array(t + 1).join('0');
                return (p + utils.random_number(max)).slice(-t);
              }; // Assuming that url looks like: http://asdasd:111/asd


              utils.getOrigin = function (url) {
                url += '/';
                var parts = url.split('/').slice(0, 3);
                return parts.join('/');
              };

              utils.isSameOriginUrl = function (url_a, url_b) {
                // location.origin would do, but it's not always available.
                if (!url_b) url_b = _window.location.href;
                return url_a.split('/').slice(0, 3).join('/') === url_b.split('/').slice(0, 3).join('/');
              }; // <METEOR>
              // https://github.com/sockjs/sockjs-client/issues/79


              utils.isSameOriginScheme = function (url_a, url_b) {
                if (!url_b) url_b = _window.location.href;
                return url_a.split(':')[0] === url_b.split(':')[0];
              }; // </METEOR>


              utils.getParentDomain = function (url) {
                // ipv4 ip address
                if (/^[0-9.]*$/.test(url)) return url; // ipv6 ip address

                if (/^\[/.test(url)) return url; // no dots

                if (!/[.]/.test(url)) return url;
                var parts = url.split('.').slice(1);
                return parts.join('.');
              };

              utils.objectExtend = function (dst, src) {
                for (var k in src) {
                  if (src.hasOwnProperty(k)) {
                    dst[k] = src[k];
                  }
                }

                return dst;
              };

              var WPrefix = '_jp';

              utils.polluteGlobalNamespace = function () {
                if (!(WPrefix in _window)) {
                  _window[WPrefix] = {};
                }
              };

              utils.closeFrame = function (code, reason) {
                return 'c' + JSON.stringify([code, reason]);
              };

              utils.userSetCode = function (code) {
                return code === 1000 || code >= 3000 && code <= 4999;
              }; // See: http://www.erg.abdn.ac.uk/~gerrit/dccp/notes/ccid2/rto_estimator/
              // and RFC 2988.


              utils.countRTO = function (rtt) {
                var rto;

                if (rtt > 100) {
                  rto = 3 * rtt; // rto > 300msec
                } else {
                  rto = rtt + 200; // 200msec < rto <= 300msec
                }

                return rto;
              };

              utils.log = function () {
                if (_window.console && console.log && console.log.apply) {
                  console.log.apply(console, arguments);
                }
              };

              utils.debug = function () {
                if (_window.console && console.debug && console.debug.apply) {
                  console.debug.apply(console, arguments);
                }
              };

              utils.bind = function (fun, that) {
                if (fun.bind) {
                  return fun.bind(that);
                } else {
                  return function () {
                    return fun.apply(that, arguments);
                  };
                }
              };

              utils.flatUrl = function (url) {
                return url.indexOf('?') === -1 && url.indexOf('#') === -1;
              }; // `relativeTo` is an optional absolute URL. If provided, `url` will be
              // interpreted relative to `relativeTo`. Defaults to `document.location`.
              // <METEOR>


              utils.amendUrl = function (url, relativeTo) {
                var baseUrl;

                if (relativeTo === undefined) {
                  baseUrl = _document.location;
                } else {
                  var protocolMatch = /^([a-z0-9.+-]+:)/i.exec(relativeTo);

                  if (protocolMatch) {
                    var protocol = protocolMatch[0].toLowerCase();
                    var rest = relativeTo.substring(protocol.length);
                    var hostMatch = /[a-z0-9\.-]+(:[0-9]+)?/.exec(rest);
                    if (hostMatch) var host = hostMatch[0];
                  }

                  if (!protocol || !host) throw new Error("relativeTo must be an absolute url");
                  baseUrl = {
                    protocol: protocol,
                    host: host
                  };
                }

                if (!url) {
                  throw new Error('Wrong url for SockJS');
                }

                if (!utils.flatUrl(url)) {
                  throw new Error('Only basic urls are supported in SockJS');
                } //  '//abc' --> 'http://abc'


                if (url.indexOf('//') === 0) {
                  url = baseUrl.protocol + url;
                } // '/abc' --> 'http://localhost:1234/abc'


                if (url.indexOf('/') === 0) {
                  url = baseUrl.protocol + '//' + baseUrl.host + url;
                } // </METEOR>
                // strip trailing slashes


                url = url.replace(/[/]+$/, ''); // We have a full url here, with proto and host. For some browsers
                // http://localhost:80/ is not in the same origin as http://localhost/
                // Remove explicit :80 or :443 in such cases. See #74

                var parts = url.split("/");

                if (parts[0] === "http:" && /:80$/.test(parts[2]) || parts[0] === "https:" && /:443$/.test(parts[2])) {
                  parts[2] = parts[2].replace(/:(80|443)$/, "");
                }

                url = parts.join("/");
                return url;
              }; // IE doesn't support [].indexOf.


              utils.arrIndexOf = function (arr, obj) {
                for (var i = 0; i < arr.length; i++) {
                  if (arr[i] === obj) {
                    return i;
                  }
                }

                return -1;
              };

              utils.arrSkip = function (arr, obj) {
                var idx = utils.arrIndexOf(arr, obj);

                if (idx === -1) {
                  return arr.slice();
                } else {
                  var dst = arr.slice(0, idx);
                  return dst.concat(arr.slice(idx + 1));
                }
              }; // Via: https://gist.github.com/1133122/2121c601c5549155483f50be3da5305e83b8c5df


              utils.isArray = Array.isArray || function (value) {
                return {}.toString.call(value).indexOf('Array') >= 0;
              };

              utils.delay = function (t, fun) {
                if (typeof t === 'function') {
                  fun = t;
                  t = 0;
                }

                return setTimeout(fun, t);
              }; // Chars worth escaping, as defined by Douglas Crockford:
              //   https://github.com/douglascrockford/JSON-js/blob/47a9882cddeb1e8529e07af9736218075372b8ac/json2.js#L196


              var json_escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
                  json_lookup = {
                "\0": "\\u0000",
                "\x01": "\\u0001",
                "\x02": "\\u0002",
                "\x03": "\\u0003",
                "\x04": "\\u0004",
                "\x05": "\\u0005",
                "\x06": "\\u0006",
                "\x07": "\\u0007",
                "\b": "\\b",
                "\t": "\\t",
                "\n": "\\n",
                "\x0B": "\\u000b",
                "\f": "\\f",
                "\r": "\\r",
                "\x0E": "\\u000e",
                "\x0F": "\\u000f",
                "\x10": "\\u0010",
                "\x11": "\\u0011",
                "\x12": "\\u0012",
                "\x13": "\\u0013",
                "\x14": "\\u0014",
                "\x15": "\\u0015",
                "\x16": "\\u0016",
                "\x17": "\\u0017",
                "\x18": "\\u0018",
                "\x19": "\\u0019",
                "\x1A": "\\u001a",
                "\x1B": "\\u001b",
                "\x1C": "\\u001c",
                "\x1D": "\\u001d",
                "\x1E": "\\u001e",
                "\x1F": "\\u001f",
                "\"": "\\\"",
                "\\": "\\\\",
                "\x7F": "\\u007f",
                "\x80": "\\u0080",
                "\x81": "\\u0081",
                "\x82": "\\u0082",
                "\x83": "\\u0083",
                "\x84": "\\u0084",
                "\x85": "\\u0085",
                "\x86": "\\u0086",
                "\x87": "\\u0087",
                "\x88": "\\u0088",
                "\x89": "\\u0089",
                "\x8A": "\\u008a",
                "\x8B": "\\u008b",
                "\x8C": "\\u008c",
                "\x8D": "\\u008d",
                "\x8E": "\\u008e",
                "\x8F": "\\u008f",
                "\x90": "\\u0090",
                "\x91": "\\u0091",
                "\x92": "\\u0092",
                "\x93": "\\u0093",
                "\x94": "\\u0094",
                "\x95": "\\u0095",
                "\x96": "\\u0096",
                "\x97": "\\u0097",
                "\x98": "\\u0098",
                "\x99": "\\u0099",
                "\x9A": "\\u009a",
                "\x9B": "\\u009b",
                "\x9C": "\\u009c",
                "\x9D": "\\u009d",
                "\x9E": "\\u009e",
                "\x9F": "\\u009f",
                "\xAD": "\\u00ad",
                "\u0600": "\\u0600",
                "\u0601": "\\u0601",
                "\u0602": "\\u0602",
                "\u0603": "\\u0603",
                "\u0604": "\\u0604",
                "\u070F": "\\u070f",
                "\u17B4": "\\u17b4",
                "\u17B5": "\\u17b5",
                "\u200C": "\\u200c",
                "\u200D": "\\u200d",
                "\u200E": "\\u200e",
                "\u200F": "\\u200f",
                "\u2028": "\\u2028",
                "\u2029": "\\u2029",
                "\u202A": "\\u202a",
                "\u202B": "\\u202b",
                "\u202C": "\\u202c",
                "\u202D": "\\u202d",
                "\u202E": "\\u202e",
                "\u202F": "\\u202f",
                "\u2060": "\\u2060",
                "\u2061": "\\u2061",
                "\u2062": "\\u2062",
                "\u2063": "\\u2063",
                "\u2064": "\\u2064",
                "\u2065": "\\u2065",
                "\u2066": "\\u2066",
                "\u2067": "\\u2067",
                "\u2068": "\\u2068",
                "\u2069": "\\u2069",
                "\u206A": "\\u206a",
                "\u206B": "\\u206b",
                "\u206C": "\\u206c",
                "\u206D": "\\u206d",
                "\u206E": "\\u206e",
                "\u206F": "\\u206f",
                "\uFEFF": "\\ufeff",
                "\uFFF0": "\\ufff0",
                "\uFFF1": "\\ufff1",
                "\uFFF2": "\\ufff2",
                "\uFFF3": "\\ufff3",
                "\uFFF4": "\\ufff4",
                "\uFFF5": "\\ufff5",
                "\uFFF6": "\\ufff6",
                "\uFFF7": "\\ufff7",
                "\uFFF8": "\\ufff8",
                "\uFFF9": "\\ufff9",
                "\uFFFA": "\\ufffa",
                "\uFFFB": "\\ufffb",
                "\uFFFC": "\\ufffc",
                "\uFFFD": "\\ufffd",
                "\uFFFE": "\\ufffe",
                "\uFFFF": "\\uffff"
              }; // Some extra characters that Chrome gets wrong, and substitutes with
              // something else on the wire.

              var extra_escapable = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g,
                  extra_lookup; // JSON Quote string. Use native implementation when possible.

              var JSONQuote = JSON && JSON.stringify || function (string) {
                json_escapable.lastIndex = 0;

                if (json_escapable.test(string)) {
                  string = string.replace(json_escapable, function (a) {
                    return json_lookup[a];
                  });
                }

                return '"' + string + '"';
              }; // This may be quite slow, so let's delay until user actually uses bad
              // characters.


              var unroll_lookup = function (escapable) {
                var i;
                var unrolled = {};
                var c = [];

                for (i = 0; i < 65536; i++) {
                  c.push(String.fromCharCode(i));
                }

                escapable.lastIndex = 0;
                c.join('').replace(escapable, function (a) {
                  unrolled[a] = "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                  return '';
                });
                escapable.lastIndex = 0;
                return unrolled;
              }; // Quote string, also taking care of unicode characters that browsers
              // often break. Especially, take care of unicode surrogates:
              //    http://en.wikipedia.org/wiki/Mapping_of_Unicode_characters#Surrogates


              utils.quote = function (string) {
                var quoted = JSONQuote(string); // In most cases this should be very fast and good enough.

                extra_escapable.lastIndex = 0;

                if (!extra_escapable.test(quoted)) {
                  return quoted;
                }

                if (!extra_lookup) extra_lookup = unroll_lookup(extra_escapable);
                return quoted.replace(extra_escapable, function (a) {
                  return extra_lookup[a];
                });
              };

              var _all_protocols = ['websocket', 'xdr-streaming', 'xhr-streaming', 'iframe-eventsource', 'iframe-htmlfile', 'xdr-polling', 'xhr-polling', 'iframe-xhr-polling', 'jsonp-polling'];

              utils.probeProtocols = function () {
                var probed = {};

                for (var i = 0; i < _all_protocols.length; i++) {
                  var protocol = _all_protocols[i]; // User can have a typo in protocol name.

                  probed[protocol] = SockJS[protocol] && SockJS[protocol].enabled();
                }

                return probed;
              };

              utils.detectProtocols = function (probed, protocols_whitelist, info) {
                var pe = {},
                    protocols = [];
                if (!protocols_whitelist) protocols_whitelist = _all_protocols;

                for (var i = 0; i < protocols_whitelist.length; i++) {
                  var protocol = protocols_whitelist[i];
                  pe[protocol] = probed[protocol];
                }

                var maybe_push = function (protos) {
                  var proto = protos.shift();

                  if (pe[proto]) {
                    protocols.push(proto);
                  } else {
                    if (protos.length > 0) {
                      maybe_push(protos);
                    }
                  }
                }; // 1. Websocket


                if (info.websocket !== false) {
                  maybe_push(['websocket']);
                } // 2. Streaming


                if (pe['xhr-streaming'] && !info.null_origin) {
                  protocols.push('xhr-streaming');
                } else {
                  if (pe['xdr-streaming'] && !info.cookie_needed && !info.null_origin) {
                    protocols.push('xdr-streaming');
                  } else {
                    maybe_push(['iframe-eventsource', 'iframe-htmlfile']);
                  }
                } // 3. Polling


                if (pe['xhr-polling'] && !info.null_origin) {
                  protocols.push('xhr-polling');
                } else {
                  if (pe['xdr-polling'] && !info.cookie_needed && !info.null_origin) {
                    protocols.push('xdr-polling');
                  } else {
                    maybe_push(['iframe-xhr-polling', 'jsonp-polling']);
                  }
                }

                return protocols;
              }; //         [*] End of lib/utils.js
              //         [*] Including lib/dom.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // May be used by htmlfile jsonp and transports.


              var MPrefix = '_sockjs_global';

              utils.createHook = function () {
                var window_id = 'a' + utils.random_string(8);

                if (!(MPrefix in _window)) {
                  var map = {};

                  _window[MPrefix] = function (window_id) {
                    if (!(window_id in map)) {
                      map[window_id] = {
                        id: window_id,
                        del: function () {
                          delete map[window_id];
                        }
                      };
                    }

                    return map[window_id];
                  };
                }

                return _window[MPrefix](window_id);
              };

              utils.attachMessage = function (listener) {
                utils.attachEvent('message', listener);
              };

              utils.attachEvent = function (event, listener) {
                if (typeof _window.addEventListener !== 'undefined') {
                  _window.addEventListener(event, listener, false);
                } else {
                  // IE quirks.
                  // According to: http://stevesouders.com/misc/test-postmessage.php
                  // the message gets delivered only to 'document', not 'window'.
                  _document.attachEvent("on" + event, listener); // I get 'window' for ie8.


                  _window.attachEvent("on" + event, listener);
                }
              };

              utils.detachMessage = function (listener) {
                utils.detachEvent('message', listener);
              };

              utils.detachEvent = function (event, listener) {
                if (typeof _window.addEventListener !== 'undefined') {
                  _window.removeEventListener(event, listener, false);
                } else {
                  _document.detachEvent("on" + event, listener);

                  _window.detachEvent("on" + event, listener);
                }
              };

              var on_unload = {}; // Things registered after beforeunload are to be called immediately.

              var after_unload = false;

              var trigger_unload_callbacks = function () {
                for (var ref in on_unload) {
                  on_unload[ref]();
                  delete on_unload[ref];
                }

                ;
              };

              var unload_triggered = function () {
                if (after_unload) return;
                after_unload = true;
                trigger_unload_callbacks();
              }; // 'unload' alone is not reliable in opera within an iframe, but we
              // can't use `beforeunload` as IE fires it on javascript: links.


              utils.attachEvent('unload', unload_triggered);

              utils.unload_add = function (listener) {
                var ref = utils.random_string(8);
                on_unload[ref] = listener;

                if (after_unload) {
                  utils.delay(trigger_unload_callbacks);
                }

                return ref;
              };

              utils.unload_del = function (ref) {
                if (ref in on_unload) delete on_unload[ref];
              };

              utils.createIframe = function (iframe_url, error_callback) {
                var iframe = _document.createElement('iframe');

                var tref, unload_ref;

                var unattach = function () {
                  clearTimeout(tref); // Explorer had problems with that.

                  try {
                    iframe.onload = null;
                  } catch (x) {}

                  iframe.onerror = null;
                };

                var cleanup = function () {
                  if (iframe) {
                    unattach(); // This timeout makes chrome fire onbeforeunload event
                    // within iframe. Without the timeout it goes straight to
                    // onunload.

                    setTimeout(function () {
                      if (iframe) {
                        iframe.parentNode.removeChild(iframe);
                      }

                      iframe = null;
                    }, 0);
                    utils.unload_del(unload_ref);
                  }
                };

                var onerror = function (r) {
                  if (iframe) {
                    cleanup();
                    error_callback(r);
                  }
                };

                var post = function (msg, origin) {
                  try {
                    // When the iframe is not loaded, IE raises an exception
                    // on 'contentWindow'.
                    if (iframe && iframe.contentWindow) {
                      iframe.contentWindow.postMessage(msg, origin);
                    }
                  } catch (x) {}

                  ;
                };

                iframe.src = iframe_url;
                iframe.style.display = 'none';
                iframe.style.position = 'absolute';

                iframe.onerror = function () {
                  onerror('onerror');
                };

                iframe.onload = function () {
                  // `onload` is triggered before scripts on the iframe are
                  // executed. Give it few seconds to actually load stuff.
                  clearTimeout(tref);
                  tref = setTimeout(function () {
                    onerror('onload timeout');
                  }, 2000);
                };

                _document.body.appendChild(iframe);

                tref = setTimeout(function () {
                  onerror('timeout');
                }, 15000);
                unload_ref = utils.unload_add(cleanup);
                return {
                  post: post,
                  cleanup: cleanup,
                  loaded: unattach
                };
              };

              utils.createHtmlfile = function (iframe_url, error_callback) {
                var doc = new ActiveXObject('htmlfile');
                var tref, unload_ref;
                var iframe;

                var unattach = function () {
                  clearTimeout(tref);
                };

                var cleanup = function () {
                  if (doc) {
                    unattach();
                    utils.unload_del(unload_ref);
                    iframe.parentNode.removeChild(iframe);
                    iframe = doc = null;
                    CollectGarbage();
                  }
                };

                var onerror = function (r) {
                  if (doc) {
                    cleanup();
                    error_callback(r);
                  }
                };

                var post = function (msg, origin) {
                  try {
                    // When the iframe is not loaded, IE raises an exception
                    // on 'contentWindow'.
                    if (iframe && iframe.contentWindow) {
                      iframe.contentWindow.postMessage(msg, origin);
                    }
                  } catch (x) {}

                  ;
                };

                doc.open();
                doc.write('<html><s' + 'cript>' + 'document.domain="' + document.domain + '";' + '</s' + 'cript></html>');
                doc.close();
                doc.parentWindow[WPrefix] = _window[WPrefix];
                var c = doc.createElement('div');
                doc.body.appendChild(c);
                iframe = doc.createElement('iframe');
                c.appendChild(iframe);
                iframe.src = iframe_url;
                tref = setTimeout(function () {
                  onerror('timeout');
                }, 15000);
                unload_ref = utils.unload_add(cleanup);
                return {
                  post: post,
                  cleanup: cleanup,
                  loaded: unattach
                };
              }; //         [*] End of lib/dom.js
              //         [*] Including lib/dom2.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var AbstractXHRObject = function () {};

              AbstractXHRObject.prototype = new EventEmitter(['chunk', 'finish']);

              AbstractXHRObject.prototype._start = function (method, url, payload, opts) {
                var that = this;

                try {
                  that.xhr = new XMLHttpRequest();
                } catch (x) {}

                ;

                if (!that.xhr) {
                  try {
                    that.xhr = new _window.ActiveXObject('Microsoft.XMLHTTP');
                  } catch (x) {}

                  ;
                }

                if (_window.ActiveXObject || _window.XDomainRequest) {
                  // IE8 caches even POSTs
                  url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + +new Date();
                } // Explorer tends to keep connection open, even after the
                // tab gets closed: http://bugs.jquery.com/ticket/5280


                that.unload_ref = utils.unload_add(function () {
                  that._cleanup(true);
                });

                try {
                  that.xhr.open(method, url, true);
                } catch (e) {
                  // IE raises an exception on wrong port.
                  that.emit('finish', 0, '');

                  that._cleanup();

                  return;
                }

                ;

                if (!opts || !opts.no_credentials) {
                  // Mozilla docs says https://developer.mozilla.org/en/XMLHttpRequest :
                  // "This never affects same-site requests."
                  that.xhr.withCredentials = 'true';
                }

                if (opts && opts.headers) {
                  for (var key in opts.headers) {
                    that.xhr.setRequestHeader(key, opts.headers[key]);
                  }
                }

                that.xhr.onreadystatechange = function () {
                  if (that.xhr) {
                    var x = that.xhr;

                    switch (x.readyState) {
                      case 3:
                        // IE doesn't like peeking into responseText or status
                        // on Microsoft.XMLHTTP and readystate=3
                        try {
                          var status = x.status;
                          var text = x.responseText;
                        } catch (x) {}

                        ; // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450

                        if (status === 1223) status = 204; // IE does return readystate == 3 for 404 answers.

                        if (text && text.length > 0) {
                          that.emit('chunk', status, text);
                        }

                        break;

                      case 4:
                        var status = x.status; // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450

                        if (status === 1223) status = 204;
                        that.emit('finish', status, x.responseText);

                        that._cleanup(false);

                        break;
                    }
                  }
                };

                that.xhr.send(payload);
              };

              AbstractXHRObject.prototype._cleanup = function (abort) {
                var that = this;
                if (!that.xhr) return;
                utils.unload_del(that.unload_ref); // IE needs this field to be a function

                that.xhr.onreadystatechange = function () {};

                if (abort) {
                  try {
                    that.xhr.abort();
                  } catch (x) {}

                  ;
                }

                that.unload_ref = that.xhr = null;
              };

              AbstractXHRObject.prototype.close = function () {
                var that = this;
                that.nuke();

                that._cleanup(true);
              };

              var XHRCorsObject = utils.XHRCorsObject = function () {
                var that = this,
                    args = arguments;
                utils.delay(function () {
                  that._start.apply(that, args);
                });
              };

              XHRCorsObject.prototype = new AbstractXHRObject();

              var XHRLocalObject = utils.XHRLocalObject = function (method, url, payload) {
                var that = this;
                utils.delay(function () {
                  that._start(method, url, payload, {
                    no_credentials: true
                  });
                });
              };

              XHRLocalObject.prototype = new AbstractXHRObject(); // References:
              //   http://ajaxian.com/archives/100-line-ajax-wrapper
              //   http://msdn.microsoft.com/en-us/library/cc288060(v=VS.85).aspx

              var XDRObject = utils.XDRObject = function (method, url, payload) {
                var that = this;
                utils.delay(function () {
                  that._start(method, url, payload);
                });
              };

              XDRObject.prototype = new EventEmitter(['chunk', 'finish']);

              XDRObject.prototype._start = function (method, url, payload) {
                var that = this;
                var xdr = new XDomainRequest(); // IE caches even POSTs

                url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + +new Date();

                var onerror = xdr.ontimeout = xdr.onerror = function () {
                  that.emit('finish', 0, '');

                  that._cleanup(false);
                };

                xdr.onprogress = function () {
                  that.emit('chunk', 200, xdr.responseText);
                };

                xdr.onload = function () {
                  that.emit('finish', 200, xdr.responseText);

                  that._cleanup(false);
                };

                that.xdr = xdr;
                that.unload_ref = utils.unload_add(function () {
                  that._cleanup(true);
                });

                try {
                  // Fails with AccessDenied if port number is bogus
                  that.xdr.open(method, url);
                  that.xdr.send(payload);
                } catch (x) {
                  onerror();
                }
              };

              XDRObject.prototype._cleanup = function (abort) {
                var that = this;
                if (!that.xdr) return;
                utils.unload_del(that.unload_ref);
                that.xdr.ontimeout = that.xdr.onerror = that.xdr.onprogress = that.xdr.onload = null;

                if (abort) {
                  try {
                    that.xdr.abort();
                  } catch (x) {}

                  ;
                }

                that.unload_ref = that.xdr = null;
              };

              XDRObject.prototype.close = function () {
                var that = this;
                that.nuke();

                that._cleanup(true);
              }; // 1. Is natively via XHR
              // 2. Is natively via XDR
              // 3. Nope, but postMessage is there so it should work via the Iframe.
              // 4. Nope, sorry.


              utils.isXHRCorsCapable = function () {
                if (_window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest()) {
                  return 1;
                } // XDomainRequest doesn't work if page is served from file://


                if (_window.XDomainRequest && _document.domain) {
                  return 2;
                }

                if (IframeTransport.enabled()) {
                  return 3;
                }

                return 4;
              }; //         [*] End of lib/dom2.js
              //         [*] Including lib/sockjs.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var SockJS = function (url, dep_protocols_whitelist, options) {
                if (!(this instanceof SockJS)) {
                  // makes `new` optional
                  return new SockJS(url, dep_protocols_whitelist, options);
                }

                var that = this,
                    protocols_whitelist;
                that._options = {
                  devel: false,
                  debug: false,
                  protocols_whitelist: [],
                  info: undefined,
                  rtt: undefined
                };

                if (options) {
                  utils.objectExtend(that._options, options);
                }

                that._base_url = utils.amendUrl(url);
                that._server = that._options.server || utils.random_number_string(1000);

                if (that._options.protocols_whitelist && that._options.protocols_whitelist.length) {
                  protocols_whitelist = that._options.protocols_whitelist;
                } else {
                  // Deprecated API
                  if (typeof dep_protocols_whitelist === 'string' && dep_protocols_whitelist.length > 0) {
                    protocols_whitelist = [dep_protocols_whitelist];
                  } else if (utils.isArray(dep_protocols_whitelist)) {
                    protocols_whitelist = dep_protocols_whitelist;
                  } else {
                    protocols_whitelist = null;
                  }

                  if (protocols_whitelist) {
                    that._debug('Deprecated API: Use "protocols_whitelist" option ' + 'instead of supplying protocol list as a second ' + 'parameter to SockJS constructor.');
                  }
                }

                that._protocols = [];
                that.protocol = null;
                that.readyState = SockJS.CONNECTING;
                that._ir = createInfoReceiver(that._base_url);

                that._ir.onfinish = function (info, rtt) {
                  that._ir = null;

                  if (info) {
                    if (that._options.info) {
                      // Override if user supplies the option
                      info = utils.objectExtend(info, that._options.info);
                    }

                    if (that._options.rtt) {
                      rtt = that._options.rtt;
                    }

                    that._applyInfo(info, rtt, protocols_whitelist);

                    that._didClose();
                  } else {
                    that._didClose(1002, 'Can\'t connect to server', true);
                  }
                };
              }; // Inheritance


              SockJS.prototype = new REventTarget();
              SockJS.version = "0.3.4";
              SockJS.CONNECTING = 0;
              SockJS.OPEN = 1;
              SockJS.CLOSING = 2;
              SockJS.CLOSED = 3;

              SockJS.prototype._debug = function () {
                if (this._options.debug) utils.log.apply(utils, arguments);
              };

              SockJS.prototype._dispatchOpen = function () {
                var that = this;

                if (that.readyState === SockJS.CONNECTING) {
                  if (that._transport_tref) {
                    clearTimeout(that._transport_tref);
                    that._transport_tref = null;
                  }

                  that.readyState = SockJS.OPEN;
                  that.dispatchEvent(new SimpleEvent("open"));
                } else {
                  // The server might have been restarted, and lost track of our
                  // connection.
                  that._didClose(1006, "Server lost session");
                }
              };

              SockJS.prototype._dispatchMessage = function (data) {
                var that = this;
                if (that.readyState !== SockJS.OPEN) return;
                that.dispatchEvent(new SimpleEvent("message", {
                  data: data
                }));
              };

              SockJS.prototype._dispatchHeartbeat = function (data) {
                var that = this;
                if (that.readyState !== SockJS.OPEN) return;
                that.dispatchEvent(new SimpleEvent('heartbeat', {}));
              };

              SockJS.prototype._didClose = function (code, reason, force) {
                var that = this;

                if (that.readyState !== SockJS.CONNECTING && that.readyState !== SockJS.OPEN && that.readyState !== SockJS.CLOSING) {
                  utils.debug('INVALID_STATE_ERR', that.readyState);
                  return;
                }

                if (that._ir) {
                  that._ir.nuke();

                  that._ir = null;
                }

                if (that._transport) {
                  that._transport.doCleanup();

                  that._transport = null;
                }

                var close_event = new SimpleEvent("close", {
                  code: code,
                  reason: reason,
                  wasClean: utils.userSetCode(code)
                });

                if (!utils.userSetCode(code) && that.readyState === SockJS.CONNECTING && !force) {
                  if (that._try_next_protocol(close_event)) {
                    return;
                  }

                  close_event = new SimpleEvent("close", {
                    code: 2000,
                    reason: "All transports failed",
                    wasClean: false,
                    last_event: close_event
                  });
                }

                that.readyState = SockJS.CLOSED;
                utils.delay(function () {
                  that.dispatchEvent(close_event);
                });
              };

              SockJS.prototype._didMessage = function (data) {
                var that = this;
                var type = data.slice(0, 1);

                switch (type) {
                  case 'o':
                    that._dispatchOpen();

                    break;

                  case 'a':
                    var payload = JSON.parse(data.slice(1) || '[]');

                    for (var i = 0; i < payload.length; i++) {
                      that._dispatchMessage(payload[i]);
                    }

                    break;

                  case 'm':
                    var payload = JSON.parse(data.slice(1) || 'null');

                    that._dispatchMessage(payload);

                    break;

                  case 'c':
                    var payload = JSON.parse(data.slice(1) || '[]');

                    that._didClose(payload[0], payload[1]);

                    break;

                  case 'h':
                    that._dispatchHeartbeat();

                    break;
                }
              };

              SockJS.prototype._try_next_protocol = function (close_event) {
                var that = this;

                if (that.protocol) {
                  that._debug('Closed transport:', that.protocol, '' + close_event);

                  that.protocol = null;
                }

                if (that._transport_tref) {
                  clearTimeout(that._transport_tref);
                  that._transport_tref = null;
                }

                while (1) {
                  var protocol = that.protocol = that._protocols.shift();

                  if (!protocol) {
                    return false;
                  } // Some protocols require access to `body`, what if were in
                  // the `head`?


                  if (SockJS[protocol] && SockJS[protocol].need_body === true && (!_document.body || typeof _document.readyState !== 'undefined' && _document.readyState !== 'complete')) {
                    that._protocols.unshift(protocol);

                    that.protocol = 'waiting-for-load';
                    utils.attachEvent('load', function () {
                      that._try_next_protocol();
                    });
                    return true;
                  }

                  if (!SockJS[protocol] || !SockJS[protocol].enabled(that._options)) {
                    that._debug('Skipping transport:', protocol);
                  } else {
                    var roundTrips = SockJS[protocol].roundTrips || 1;
                    var to = (that._options.rto || 0) * roundTrips || 5000;
                    that._transport_tref = utils.delay(to, function () {
                      if (that.readyState === SockJS.CONNECTING) {
                        // I can't understand how it is possible to run
                        // this timer, when the state is CLOSED, but
                        // apparently in IE everythin is possible.
                        that._didClose(2007, "Transport timeouted");
                      }
                    });
                    var connid = utils.random_string(8);
                    var trans_url = that._base_url + '/' + that._server + '/' + connid;

                    that._debug('Opening transport:', protocol, ' url:' + trans_url, ' RTO:' + that._options.rto);

                    that._transport = new SockJS[protocol](that, trans_url, that._base_url);
                    return true;
                  }
                }
              };

              SockJS.prototype.close = function (code, reason) {
                var that = this;
                if (code && !utils.userSetCode(code)) throw new Error("INVALID_ACCESS_ERR");

                if (that.readyState !== SockJS.CONNECTING && that.readyState !== SockJS.OPEN) {
                  return false;
                }

                that.readyState = SockJS.CLOSING;

                that._didClose(code || 1000, reason || "Normal closure");

                return true;
              };

              SockJS.prototype.send = function (data) {
                var that = this;
                if (that.readyState === SockJS.CONNECTING) throw new Error('INVALID_STATE_ERR');

                if (that.readyState === SockJS.OPEN) {
                  that._transport.doSend(utils.quote('' + data));
                }

                return true;
              };

              SockJS.prototype._applyInfo = function (info, rtt, protocols_whitelist) {
                var that = this;
                that._options.info = info;
                that._options.rtt = rtt;
                that._options.rto = utils.countRTO(rtt);
                that._options.info.null_origin = !_document.domain; // Servers can override base_url, eg to provide a randomized domain name and
                // avoid browser per-domain connection limits.

                if (info.base_url) // <METEOR>
                  that._base_url = utils.amendUrl(info.base_url, that._base_url); // </METEOR>

                var probed = utils.probeProtocols();
                that._protocols = utils.detectProtocols(probed, protocols_whitelist, info); // <METEOR>
                // https://github.com/sockjs/sockjs-client/issues/79
                // Hack to avoid XDR when using different protocols
                // We're on IE trying to do cross-protocol. jsonp only.

                if (!utils.isSameOriginScheme(that._base_url) && 2 === utils.isXHRCorsCapable()) {
                  that._protocols = ['jsonp-polling'];
                } // </METEOR>
              }; //         [*] End of lib/sockjs.js
              //         [*] Including lib/trans-websocket.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var WebSocketTransport = SockJS.websocket = function (ri, trans_url) {
                var that = this;
                var url = trans_url + '/websocket';

                if (url.slice(0, 5) === 'https') {
                  url = 'wss' + url.slice(5);
                } else {
                  url = 'ws' + url.slice(4);
                }

                that.ri = ri;
                that.url = url;
                var Constructor = _window.WebSocket || _window.MozWebSocket;
                that.ws = new Constructor(that.url);

                that.ws.onmessage = function (e) {
                  that.ri._didMessage(e.data);
                }; // Firefox has an interesting bug. If a websocket connection is
                // created after onunload, it stays alive even when user
                // navigates away from the page. In such situation let's lie -
                // let's not open the ws connection at all. See:
                // https://github.com/sockjs/sockjs-client/issues/28
                // https://bugzilla.mozilla.org/show_bug.cgi?id=696085


                that.unload_ref = utils.unload_add(function () {
                  that.ws.close();
                });

                that.ws.onclose = function () {
                  that.ri._didMessage(utils.closeFrame(1006, "WebSocket connection broken"));
                };
              };

              WebSocketTransport.prototype.doSend = function (data) {
                this.ws.send('[' + data + ']');
              };

              WebSocketTransport.prototype.doCleanup = function () {
                var that = this;
                var ws = that.ws;

                if (ws) {
                  ws.onmessage = ws.onclose = null;
                  ws.close();
                  utils.unload_del(that.unload_ref);
                  that.unload_ref = that.ri = that.ws = null;
                }
              };

              WebSocketTransport.enabled = function () {
                return !!(_window.WebSocket || _window.MozWebSocket);
              }; // In theory, ws should require 1 round trip. But in chrome, this is
              // not very stable over SSL. Most likely a ws connection requires a
              // separate SSL connection, in which case 2 round trips are an
              // absolute minumum.


              WebSocketTransport.roundTrips = 2; //         [*] End of lib/trans-websocket.js
              //         [*] Including lib/trans-sender.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var BufferedSender = function () {};

              BufferedSender.prototype.send_constructor = function (sender) {
                var that = this;
                that.send_buffer = [];
                that.sender = sender;
              };

              BufferedSender.prototype.doSend = function (message) {
                var that = this;
                that.send_buffer.push(message);

                if (!that.send_stop) {
                  that.send_schedule();
                }
              }; // For polling transports in a situation when in the message callback,
              // new message is being send. If the sending connection was started
              // before receiving one, it is possible to saturate the network and
              // timeout due to the lack of receiving socket. To avoid that we delay
              // sending messages by some small time, in order to let receiving
              // connection be started beforehand. This is only a halfmeasure and
              // does not fix the big problem, but it does make the tests go more
              // stable on slow networks.


              BufferedSender.prototype.send_schedule_wait = function () {
                var that = this;
                var tref;

                that.send_stop = function () {
                  that.send_stop = null;
                  clearTimeout(tref);
                };

                tref = utils.delay(25, function () {
                  that.send_stop = null;
                  that.send_schedule();
                });
              };

              BufferedSender.prototype.send_schedule = function () {
                var that = this;

                if (that.send_buffer.length > 0) {
                  var payload = '[' + that.send_buffer.join(',') + ']';
                  that.send_stop = that.sender(that.trans_url, payload, function (success, abort_reason) {
                    that.send_stop = null;

                    if (success === false) {
                      that.ri._didClose(1006, 'Sending error ' + abort_reason);
                    } else {
                      that.send_schedule_wait();
                    }
                  });
                  that.send_buffer = [];
                }
              };

              BufferedSender.prototype.send_destructor = function () {
                var that = this;

                if (that._send_stop) {
                  that._send_stop();
                }

                that._send_stop = null;
              };

              var jsonPGenericSender = function (url, payload, callback) {
                var that = this;

                if (!('_send_form' in that)) {
                  var form = that._send_form = _document.createElement('form');

                  var area = that._send_area = _document.createElement('textarea');

                  area.name = 'd';
                  form.style.display = 'none';
                  form.style.position = 'absolute';
                  form.method = 'POST';
                  form.enctype = 'application/x-www-form-urlencoded';
                  form.acceptCharset = "UTF-8";
                  form.appendChild(area);

                  _document.body.appendChild(form);
                }

                var form = that._send_form;
                var area = that._send_area;
                var id = 'a' + utils.random_string(8);
                form.target = id;
                form.action = url + '/jsonp_send?i=' + id;
                var iframe;

                try {
                  // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
                  iframe = _document.createElement('<iframe name="' + id + '">');
                } catch (x) {
                  iframe = _document.createElement('iframe');
                  iframe.name = id;
                }

                iframe.id = id;
                form.appendChild(iframe);
                iframe.style.display = 'none';

                try {
                  area.value = payload;
                } catch (e) {
                  utils.log('Your browser is seriously broken. Go home! ' + e.message);
                }

                form.submit();

                var completed = function (e) {
                  if (!iframe.onerror) return;
                  iframe.onreadystatechange = iframe.onerror = iframe.onload = null; // Opera mini doesn't like if we GC iframe
                  // immediately, thus this timeout.

                  utils.delay(500, function () {
                    iframe.parentNode.removeChild(iframe);
                    iframe = null;
                  });
                  area.value = ''; // It is not possible to detect if the iframe succeeded or
                  // failed to submit our form.

                  callback(true);
                };

                iframe.onerror = iframe.onload = completed;

                iframe.onreadystatechange = function (e) {
                  if (iframe.readyState == 'complete') completed();
                };

                return completed;
              };

              var createAjaxSender = function (AjaxObject) {
                return function (url, payload, callback) {
                  var xo = new AjaxObject('POST', url + '/xhr_send', payload);

                  xo.onfinish = function (status, text) {
                    callback(status === 200 || status === 204, 'http status ' + status);
                  };

                  return function (abort_reason) {
                    callback(false, abort_reason);
                  };
                };
              }; //         [*] End of lib/trans-sender.js
              //         [*] Including lib/trans-jsonp-receiver.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // Parts derived from Socket.io:
              //    https://github.com/LearnBoost/socket.io/blob/0.6.17/lib/socket.io/transports/jsonp-polling.js
              // and jQuery-JSONP:
              //    https://code.google.com/p/jquery-jsonp/source/browse/trunk/core/jquery.jsonp.js


              var jsonPGenericReceiver = function (url, callback) {
                var tref;

                var script = _document.createElement('script');

                var script2; // Opera synchronous load trick.

                var close_script = function (frame) {
                  if (script2) {
                    script2.parentNode.removeChild(script2);
                    script2 = null;
                  }

                  if (script) {
                    clearTimeout(tref); // Unfortunately, you can't really abort script loading of
                    // the script.

                    script.parentNode.removeChild(script);
                    script.onreadystatechange = script.onerror = script.onload = script.onclick = null;
                    script = null;
                    callback(frame);
                    callback = null;
                  }
                }; // IE9 fires 'error' event after orsc or before, in random order.


                var loaded_okay = false;
                var error_timer = null;
                script.id = 'a' + utils.random_string(8);
                script.src = url;
                script.type = 'text/javascript';
                script.charset = 'UTF-8';

                script.onerror = function (e) {
                  if (!error_timer) {
                    // Delay firing close_script.
                    error_timer = setTimeout(function () {
                      if (!loaded_okay) {
                        close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (onerror)"));
                      }
                    }, 1000);
                  }
                };

                script.onload = function (e) {
                  close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (onload)"));
                };

                script.onreadystatechange = function (e) {
                  if (/loaded|closed/.test(script.readyState)) {
                    if (script && script.htmlFor && script.onclick) {
                      loaded_okay = true;

                      try {
                        // In IE, actually execute the script.
                        script.onclick();
                      } catch (x) {}
                    }

                    if (script) {
                      close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (onreadystatechange)"));
                    }
                  }
                }; // IE: event/htmlFor/onclick trick.
                // One can't rely on proper order for onreadystatechange. In order to
                // make sure, set a 'htmlFor' and 'event' properties, so that
                // script code will be installed as 'onclick' handler for the
                // script object. Later, onreadystatechange, manually execute this
                // code. FF and Chrome doesn't work with 'event' and 'htmlFor'
                // set. For reference see:
                //   http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
                // Also, read on that about script ordering:
                //   http://wiki.whatwg.org/wiki/Dynamic_Script_Execution_Order


                if (typeof script.async === 'undefined' && _document.attachEvent) {
                  // According to mozilla docs, in recent browsers script.async defaults
                  // to 'true', so we may use it to detect a good browser:
                  // https://developer.mozilla.org/en/HTML/Element/script
                  if (!/opera/i.test(navigator.userAgent)) {
                    // Naively assume we're in IE
                    try {
                      script.htmlFor = script.id;
                      script.event = "onclick";
                    } catch (x) {}

                    script.async = true;
                  } else {
                    // Opera, second sync script hack
                    script2 = _document.createElement('script');
                    script2.text = "try{var a = document.getElementById('" + script.id + "'); if(a)a.onerror();}catch(x){};";
                    script.async = script2.async = false;
                  }
                }

                if (typeof script.async !== 'undefined') {
                  script.async = true;
                } // Fallback mostly for Konqueror - stupid timer, 35 seconds shall be plenty.


                tref = setTimeout(function () {
                  close_script(utils.closeFrame(1006, "JSONP script loaded abnormally (timeout)"));
                }, 35000);

                var head = _document.getElementsByTagName('head')[0];

                head.insertBefore(script, head.firstChild);

                if (script2) {
                  head.insertBefore(script2, head.firstChild);
                }

                return close_script;
              }; //         [*] End of lib/trans-jsonp-receiver.js
              //         [*] Including lib/trans-jsonp-polling.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // The simplest and most robust transport, using the well-know cross
              // domain hack - JSONP. This transport is quite inefficient - one
              // mssage could use up to one http request. But at least it works almost
              // everywhere.
              // Known limitations:
              //   o you will get a spinning cursor
              //   o for Konqueror a dumb timer is needed to detect errors


              var JsonPTransport = SockJS['jsonp-polling'] = function (ri, trans_url) {
                utils.polluteGlobalNamespace();
                var that = this;
                that.ri = ri;
                that.trans_url = trans_url;
                that.send_constructor(jsonPGenericSender);

                that._schedule_recv();
              }; // Inheritnace


              JsonPTransport.prototype = new BufferedSender();

              JsonPTransport.prototype._schedule_recv = function () {
                var that = this;

                var callback = function (data) {
                  that._recv_stop = null;

                  if (data) {
                    // no data - heartbeat;
                    if (!that._is_closing) {
                      that.ri._didMessage(data);
                    }
                  } // The message can be a close message, and change is_closing state.


                  if (!that._is_closing) {
                    that._schedule_recv();
                  }
                };

                that._recv_stop = jsonPReceiverWrapper(that.trans_url + '/jsonp', jsonPGenericReceiver, callback);
              };

              JsonPTransport.enabled = function () {
                return true;
              };

              JsonPTransport.need_body = true;

              JsonPTransport.prototype.doCleanup = function () {
                var that = this;
                that._is_closing = true;

                if (that._recv_stop) {
                  that._recv_stop();
                }

                that.ri = that._recv_stop = null;
                that.send_destructor();
              }; // Abstract away code that handles global namespace pollution.


              var jsonPReceiverWrapper = function (url, constructReceiver, user_callback) {
                var id = 'a' + utils.random_string(6);
                var url_id = url + '?c=' + escape(WPrefix + '.' + id); // Unfortunately it is not possible to abort loading of the
                // script. We need to keep track of frake close frames.

                var aborting = 0; // Callback will be called exactly once.

                var callback = function (frame) {
                  switch (aborting) {
                    case 0:
                      // Normal behaviour - delete hook _and_ emit message.
                      delete _window[WPrefix][id];
                      user_callback(frame);
                      break;

                    case 1:
                      // Fake close frame - emit but don't delete hook.
                      user_callback(frame);
                      aborting = 2;
                      break;

                    case 2:
                      // Got frame after connection was closed, delete hook, don't emit.
                      delete _window[WPrefix][id];
                      break;
                  }
                };

                var close_script = constructReceiver(url_id, callback);
                _window[WPrefix][id] = close_script;

                var stop = function () {
                  if (_window[WPrefix][id]) {
                    aborting = 1;

                    _window[WPrefix][id](utils.closeFrame(1000, "JSONP user aborted read"));
                  }
                };

                return stop;
              }; //         [*] End of lib/trans-jsonp-polling.js
              //         [*] Including lib/trans-xhr.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var AjaxBasedTransport = function () {};

              AjaxBasedTransport.prototype = new BufferedSender();

              AjaxBasedTransport.prototype.run = function (ri, trans_url, url_suffix, Receiver, AjaxObject) {
                var that = this;
                that.ri = ri;
                that.trans_url = trans_url;
                that.send_constructor(createAjaxSender(AjaxObject));
                that.poll = new Polling(ri, Receiver, trans_url + url_suffix, AjaxObject);
              };

              AjaxBasedTransport.prototype.doCleanup = function () {
                var that = this;

                if (that.poll) {
                  that.poll.abort();
                  that.poll = null;
                }
              }; // xhr-streaming


              var XhrStreamingTransport = SockJS['xhr-streaming'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/xhr_streaming', XhrReceiver, utils.XHRCorsObject);
              };

              XhrStreamingTransport.prototype = new AjaxBasedTransport();

              XhrStreamingTransport.enabled = function () {
                // Support for CORS Ajax aka Ajax2? Opera 12 claims CORS but
                // doesn't do streaming.
                return _window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest() && !/opera/i.test(navigator.userAgent);
              };

              XhrStreamingTransport.roundTrips = 2; // preflight, ajax
              // Safari gets confused when a streaming ajax request is started
              // before onload. This causes the load indicator to spin indefinetely.

              XhrStreamingTransport.need_body = true; // According to:
              //   http://stackoverflow.com/questions/1641507/detect-browser-support-for-cross-domain-xmlhttprequests
              //   http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
              // xdr-streaming

              var XdrStreamingTransport = SockJS['xdr-streaming'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/xhr_streaming', XhrReceiver, utils.XDRObject);
              };

              XdrStreamingTransport.prototype = new AjaxBasedTransport();

              XdrStreamingTransport.enabled = function () {
                return !!_window.XDomainRequest;
              };

              XdrStreamingTransport.roundTrips = 2; // preflight, ajax
              // xhr-polling

              var XhrPollingTransport = SockJS['xhr-polling'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XHRCorsObject);
              };

              XhrPollingTransport.prototype = new AjaxBasedTransport();
              XhrPollingTransport.enabled = XhrStreamingTransport.enabled;
              XhrPollingTransport.roundTrips = 2; // preflight, ajax
              // xdr-polling

              var XdrPollingTransport = SockJS['xdr-polling'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XDRObject);
              };

              XdrPollingTransport.prototype = new AjaxBasedTransport();
              XdrPollingTransport.enabled = XdrStreamingTransport.enabled;
              XdrPollingTransport.roundTrips = 2; // preflight, ajax
              //         [*] End of lib/trans-xhr.js
              //         [*] Including lib/trans-iframe.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // Few cool transports do work only for same-origin. In order to make
              // them working cross-domain we shall use iframe, served form the
              // remote domain. New browsers, have capabilities to communicate with
              // cross domain iframe, using postMessage(). In IE it was implemented
              // from IE 8+, but of course, IE got some details wrong:
              //    http://msdn.microsoft.com/en-us/library/cc197015(v=VS.85).aspx
              //    http://stevesouders.com/misc/test-postmessage.php

              var IframeTransport = function () {};

              IframeTransport.prototype.i_constructor = function (ri, trans_url, base_url) {
                var that = this;
                that.ri = ri;
                that.origin = utils.getOrigin(base_url);
                that.base_url = base_url;
                that.trans_url = trans_url;
                var iframe_url = base_url + '/iframe.html';

                if (that.ri._options.devel) {
                  iframe_url += '?t=' + +new Date();
                }

                that.window_id = utils.random_string(8);
                iframe_url += '#' + that.window_id;
                that.iframeObj = utils.createIframe(iframe_url, function (r) {
                  that.ri._didClose(1006, "Unable to load an iframe (" + r + ")");
                });
                that.onmessage_cb = utils.bind(that.onmessage, that);
                utils.attachMessage(that.onmessage_cb);
              };

              IframeTransport.prototype.doCleanup = function () {
                var that = this;

                if (that.iframeObj) {
                  utils.detachMessage(that.onmessage_cb);

                  try {
                    // When the iframe is not loaded, IE raises an exception
                    // on 'contentWindow'.
                    if (that.iframeObj.iframe.contentWindow) {
                      that.postMessage('c');
                    }
                  } catch (x) {}

                  that.iframeObj.cleanup();
                  that.iframeObj = null;
                  that.onmessage_cb = that.iframeObj = null;
                }
              };

              IframeTransport.prototype.onmessage = function (e) {
                var that = this;
                if (e.origin !== that.origin) return;
                var window_id = e.data.slice(0, 8);
                var type = e.data.slice(8, 9);
                var data = e.data.slice(9);
                if (window_id !== that.window_id) return;

                switch (type) {
                  case 's':
                    that.iframeObj.loaded();
                    that.postMessage('s', JSON.stringify([SockJS.version, that.protocol, that.trans_url, that.base_url]));
                    break;

                  case 't':
                    that.ri._didMessage(data);

                    break;
                }
              };

              IframeTransport.prototype.postMessage = function (type, data) {
                var that = this;
                that.iframeObj.post(that.window_id + type + (data || ''), that.origin);
              };

              IframeTransport.prototype.doSend = function (message) {
                this.postMessage('m', message);
              };

              IframeTransport.enabled = function () {
                // postMessage misbehaves in konqueror 4.6.5 - the messages are delivered with
                // huge delay, or not at all.
                var konqueror = navigator && navigator.userAgent && navigator.userAgent.indexOf('Konqueror') !== -1;
                return (typeof _window.postMessage === 'function' || typeof _window.postMessage === 'object') && !konqueror;
              }; //         [*] End of lib/trans-iframe.js
              //         [*] Including lib/trans-iframe-within.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var curr_window_id;

              var postMessage = function (type, data) {
                if (parent !== _window) {
                  parent.postMessage(curr_window_id + type + (data || ''), '*');
                } else {
                  utils.log("Can't postMessage, no parent window.", type, data);
                }
              };

              var FacadeJS = function () {};

              FacadeJS.prototype._didClose = function (code, reason) {
                postMessage('t', utils.closeFrame(code, reason));
              };

              FacadeJS.prototype._didMessage = function (frame) {
                postMessage('t', frame);
              };

              FacadeJS.prototype._doSend = function (data) {
                this._transport.doSend(data);
              };

              FacadeJS.prototype._doCleanup = function () {
                this._transport.doCleanup();
              };

              utils.parent_origin = undefined;

              SockJS.bootstrap_iframe = function () {
                var facade;
                curr_window_id = _document.location.hash.slice(1);

                var onMessage = function (e) {
                  if (e.source !== parent) return;
                  if (typeof utils.parent_origin === 'undefined') utils.parent_origin = e.origin;
                  if (e.origin !== utils.parent_origin) return;
                  var window_id = e.data.slice(0, 8);
                  var type = e.data.slice(8, 9);
                  var data = e.data.slice(9);
                  if (window_id !== curr_window_id) return;

                  switch (type) {
                    case 's':
                      var p = JSON.parse(data);
                      var version = p[0];
                      var protocol = p[1];
                      var trans_url = p[2];
                      var base_url = p[3];

                      if (version !== SockJS.version) {
                        utils.log("Incompatibile SockJS! Main site uses:" + " \"" + version + "\", the iframe:" + " \"" + SockJS.version + "\".");
                      }

                      if (!utils.flatUrl(trans_url) || !utils.flatUrl(base_url)) {
                        utils.log("Only basic urls are supported in SockJS");
                        return;
                      }

                      if (!utils.isSameOriginUrl(trans_url) || !utils.isSameOriginUrl(base_url)) {
                        utils.log("Can't connect to different domain from within an " + "iframe. (" + JSON.stringify([_window.location.href, trans_url, base_url]) + ")");
                        return;
                      }

                      facade = new FacadeJS();
                      facade._transport = new FacadeJS[protocol](facade, trans_url, base_url);
                      break;

                    case 'm':
                      facade._doSend(data);

                      break;

                    case 'c':
                      if (facade) facade._doCleanup();
                      facade = null;
                      break;
                  }
                }; // alert('test ticker');
                // facade = new FacadeJS();
                // facade._transport = new FacadeJS['w-iframe-xhr-polling'](facade, 'http://host.com:9999/ticker/12/basd');


                utils.attachMessage(onMessage); // Start

                postMessage('s');
              }; //         [*] End of lib/trans-iframe-within.js
              //         [*] Including lib/info.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var InfoReceiver = function (base_url, AjaxObject) {
                var that = this;
                utils.delay(function () {
                  that.doXhr(base_url, AjaxObject);
                });
              };

              InfoReceiver.prototype = new EventEmitter(['finish']);

              InfoReceiver.prototype.doXhr = function (base_url, AjaxObject) {
                var that = this;
                var t0 = new Date().getTime(); // <METEOR>
                // https://github.com/sockjs/sockjs-client/pull/129
                // var xo = new AjaxObject('GET', base_url + '/info');

                var xo = new AjaxObject( // add cachebusting parameter to url to work around a chrome bug:
                // https://code.google.com/p/chromium/issues/detail?id=263981
                // or misbehaving proxies.
                'GET', base_url + '/info?cb=' + utils.random_string(10)); // </METEOR>

                var tref = utils.delay(8000, function () {
                  xo.ontimeout();
                });

                xo.onfinish = function (status, text) {
                  clearTimeout(tref);
                  tref = null;

                  if (status === 200) {
                    var rtt = new Date().getTime() - t0;
                    var info = JSON.parse(text);
                    if (typeof info !== 'object') info = {};
                    that.emit('finish', info, rtt);
                  } else {
                    that.emit('finish');
                  }
                };

                xo.ontimeout = function () {
                  xo.close();
                  that.emit('finish');
                };
              };

              var InfoReceiverIframe = function (base_url) {
                var that = this;

                var go = function () {
                  var ifr = new IframeTransport();
                  ifr.protocol = 'w-iframe-info-receiver';

                  var fun = function (r) {
                    if (typeof r === 'string' && r.substr(0, 1) === 'm') {
                      var d = JSON.parse(r.substr(1));
                      var info = d[0],
                          rtt = d[1];
                      that.emit('finish', info, rtt);
                    } else {
                      that.emit('finish');
                    }

                    ifr.doCleanup();
                    ifr = null;
                  };

                  var mock_ri = {
                    _options: {},
                    _didClose: fun,
                    _didMessage: fun
                  };
                  ifr.i_constructor(mock_ri, base_url, base_url);
                };

                if (!_document.body) {
                  utils.attachEvent('load', go);
                } else {
                  go();
                }
              };

              InfoReceiverIframe.prototype = new EventEmitter(['finish']);

              var InfoReceiverFake = function () {
                // It may not be possible to do cross domain AJAX to get the info
                // data, for example for IE7. But we want to run JSONP, so let's
                // fake the response, with rtt=2s (rto=6s).
                var that = this;
                utils.delay(function () {
                  that.emit('finish', {}, 2000);
                });
              };

              InfoReceiverFake.prototype = new EventEmitter(['finish']);

              var createInfoReceiver = function (base_url) {
                if (utils.isSameOriginUrl(base_url)) {
                  // If, for some reason, we have SockJS locally - there's no
                  // need to start up the complex machinery. Just use ajax.
                  return new InfoReceiver(base_url, utils.XHRLocalObject);
                }

                switch (utils.isXHRCorsCapable()) {
                  case 1:
                    // XHRLocalObject -> no_credentials=true
                    return new InfoReceiver(base_url, utils.XHRLocalObject);

                  case 2:
                    // <METEOR>
                    // https://github.com/sockjs/sockjs-client/issues/79
                    // XDR doesn't work across different schemes
                    // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
                    if (utils.isSameOriginScheme(base_url)) return new InfoReceiver(base_url, utils.XDRObject);else return new InfoReceiverFake();
                  // </METEOR>

                  case 3:
                    // Opera
                    return new InfoReceiverIframe(base_url);

                  default:
                    // IE 7
                    return new InfoReceiverFake();
                }

                ;
              };

              var WInfoReceiverIframe = FacadeJS['w-iframe-info-receiver'] = function (ri, _trans_url, base_url) {
                var ir = new InfoReceiver(base_url, utils.XHRLocalObject);

                ir.onfinish = function (info, rtt) {
                  ri._didMessage('m' + JSON.stringify([info, rtt]));

                  ri._didClose();
                };
              };

              WInfoReceiverIframe.prototype.doCleanup = function () {}; //         [*] End of lib/info.js
              //         [*] Including lib/trans-iframe-eventsource.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var EventSourceIframeTransport = SockJS['iframe-eventsource'] = function () {
                var that = this;
                that.protocol = 'w-iframe-eventsource';
                that.i_constructor.apply(that, arguments);
              };

              EventSourceIframeTransport.prototype = new IframeTransport();

              EventSourceIframeTransport.enabled = function () {
                return 'EventSource' in _window && IframeTransport.enabled();
              };

              EventSourceIframeTransport.need_body = true;
              EventSourceIframeTransport.roundTrips = 3; // html, javascript, eventsource
              // w-iframe-eventsource

              var EventSourceTransport = FacadeJS['w-iframe-eventsource'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/eventsource', EventSourceReceiver, utils.XHRLocalObject);
              };

              EventSourceTransport.prototype = new AjaxBasedTransport(); //         [*] End of lib/trans-iframe-eventsource.js
              //         [*] Including lib/trans-iframe-xhr-polling.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var XhrPollingIframeTransport = SockJS['iframe-xhr-polling'] = function () {
                var that = this;
                that.protocol = 'w-iframe-xhr-polling';
                that.i_constructor.apply(that, arguments);
              };

              XhrPollingIframeTransport.prototype = new IframeTransport();

              XhrPollingIframeTransport.enabled = function () {
                return _window.XMLHttpRequest && IframeTransport.enabled();
              };

              XhrPollingIframeTransport.need_body = true;
              XhrPollingIframeTransport.roundTrips = 3; // html, javascript, xhr
              // w-iframe-xhr-polling

              var XhrPollingITransport = FacadeJS['w-iframe-xhr-polling'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/xhr', XhrReceiver, utils.XHRLocalObject);
              };

              XhrPollingITransport.prototype = new AjaxBasedTransport(); //         [*] End of lib/trans-iframe-xhr-polling.js
              //         [*] Including lib/trans-iframe-htmlfile.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // This transport generally works in any browser, but will cause a
              // spinning cursor to appear in any browser other than IE.
              // We may test this transport in all browsers - why not, but in
              // production it should be only run in IE.

              var HtmlFileIframeTransport = SockJS['iframe-htmlfile'] = function () {
                var that = this;
                that.protocol = 'w-iframe-htmlfile';
                that.i_constructor.apply(that, arguments);
              }; // Inheritance.


              HtmlFileIframeTransport.prototype = new IframeTransport();

              HtmlFileIframeTransport.enabled = function () {
                return IframeTransport.enabled();
              };

              HtmlFileIframeTransport.need_body = true;
              HtmlFileIframeTransport.roundTrips = 3; // html, javascript, htmlfile
              // w-iframe-htmlfile

              var HtmlFileTransport = FacadeJS['w-iframe-htmlfile'] = function (ri, trans_url) {
                this.run(ri, trans_url, '/htmlfile', HtmlfileReceiver, utils.XHRLocalObject);
              };

              HtmlFileTransport.prototype = new AjaxBasedTransport(); //         [*] End of lib/trans-iframe-htmlfile.js
              //         [*] Including lib/trans-polling.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var Polling = function (ri, Receiver, recv_url, AjaxObject) {
                var that = this;
                that.ri = ri;
                that.Receiver = Receiver;
                that.recv_url = recv_url;
                that.AjaxObject = AjaxObject;

                that._scheduleRecv();
              };

              Polling.prototype._scheduleRecv = function () {
                var that = this;
                var poll = that.poll = new that.Receiver(that.recv_url, that.AjaxObject);
                var msg_counter = 0;

                poll.onmessage = function (e) {
                  msg_counter += 1;

                  that.ri._didMessage(e.data);
                };

                poll.onclose = function (e) {
                  that.poll = poll = poll.onmessage = poll.onclose = null;

                  if (!that.poll_is_closing) {
                    if (e.reason === 'permanent') {
                      that.ri._didClose(1006, 'Polling error (' + e.reason + ')');
                    } else {
                      that._scheduleRecv();
                    }
                  }
                };
              };

              Polling.prototype.abort = function () {
                var that = this;
                that.poll_is_closing = true;

                if (that.poll) {
                  that.poll.abort();
                }
              }; //         [*] End of lib/trans-polling.js
              //         [*] Including lib/trans-receiver-eventsource.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var EventSourceReceiver = function (url) {
                var that = this;
                var es = new EventSource(url);

                es.onmessage = function (e) {
                  that.dispatchEvent(new SimpleEvent('message', {
                    'data': unescape(e.data)
                  }));
                };

                that.es_close = es.onerror = function (e, abort_reason) {
                  // ES on reconnection has readyState = 0 or 1.
                  // on network error it's CLOSED = 2
                  var reason = abort_reason ? 'user' : es.readyState !== 2 ? 'network' : 'permanent';
                  that.es_close = es.onmessage = es.onerror = null; // EventSource reconnects automatically.

                  es.close();
                  es = null; // Safari and chrome < 15 crash if we close window before
                  // waiting for ES cleanup. See:
                  //   https://code.google.com/p/chromium/issues/detail?id=89155

                  utils.delay(200, function () {
                    that.dispatchEvent(new SimpleEvent('close', {
                      reason: reason
                    }));
                  });
                };
              };

              EventSourceReceiver.prototype = new REventTarget();

              EventSourceReceiver.prototype.abort = function () {
                var that = this;

                if (that.es_close) {
                  that.es_close({}, true);
                }
              }; //         [*] End of lib/trans-receiver-eventsource.js
              //         [*] Including lib/trans-receiver-htmlfile.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var _is_ie_htmlfile_capable;

              var isIeHtmlfileCapable = function () {
                if (_is_ie_htmlfile_capable === undefined) {
                  if ('ActiveXObject' in _window) {
                    try {
                      _is_ie_htmlfile_capable = !!new ActiveXObject('htmlfile');
                    } catch (x) {}
                  } else {
                    _is_ie_htmlfile_capable = false;
                  }
                }

                return _is_ie_htmlfile_capable;
              };

              var HtmlfileReceiver = function (url) {
                var that = this;
                utils.polluteGlobalNamespace();
                that.id = 'a' + utils.random_string(6, 26);
                url += (url.indexOf('?') === -1 ? '?' : '&') + 'c=' + escape(WPrefix + '.' + that.id);
                var constructor = isIeHtmlfileCapable() ? utils.createHtmlfile : utils.createIframe;
                var iframeObj;
                _window[WPrefix][that.id] = {
                  start: function () {
                    iframeObj.loaded();
                  },
                  message: function (data) {
                    that.dispatchEvent(new SimpleEvent('message', {
                      'data': data
                    }));
                  },
                  stop: function () {
                    that.iframe_close({}, 'network');
                  }
                };

                that.iframe_close = function (e, abort_reason) {
                  iframeObj.cleanup();
                  that.iframe_close = iframeObj = null;
                  delete _window[WPrefix][that.id];
                  that.dispatchEvent(new SimpleEvent('close', {
                    reason: abort_reason
                  }));
                };

                iframeObj = constructor(url, function (e) {
                  that.iframe_close({}, 'permanent');
                });
              };

              HtmlfileReceiver.prototype = new REventTarget();

              HtmlfileReceiver.prototype.abort = function () {
                var that = this;

                if (that.iframe_close) {
                  that.iframe_close({}, 'user');
                }
              }; //         [*] End of lib/trans-receiver-htmlfile.js
              //         [*] Including lib/trans-receiver-xhr.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */

              var XhrReceiver = function (url, AjaxObject) {
                var that = this;
                var buf_pos = 0;
                that.xo = new AjaxObject('POST', url, null);

                that.xo.onchunk = function (status, text) {
                  if (status !== 200) return;

                  while (1) {
                    var buf = text.slice(buf_pos);
                    var p = buf.indexOf('\n');
                    if (p === -1) break;
                    buf_pos += p + 1;
                    var msg = buf.slice(0, p);
                    that.dispatchEvent(new SimpleEvent('message', {
                      data: msg
                    }));
                  }
                };

                that.xo.onfinish = function (status, text) {
                  that.xo.onchunk(status, text);
                  that.xo = null;
                  var reason = status === 200 ? 'network' : 'permanent';
                  that.dispatchEvent(new SimpleEvent('close', {
                    reason: reason
                  }));
                };
              };

              XhrReceiver.prototype = new REventTarget();

              XhrReceiver.prototype.abort = function () {
                var that = this;

                if (that.xo) {
                  that.xo.close();
                  that.dispatchEvent(new SimpleEvent('close', {
                    reason: 'user'
                  }));
                  that.xo = null;
                }
              }; //         [*] End of lib/trans-receiver-xhr.js
              //         [*] Including lib/test-hooks.js

              /*
               * ***** BEGIN LICENSE BLOCK *****
               * Copyright (c) 2011-2012 VMware, Inc.
               *
               * For the license see COPYING.
               * ***** END LICENSE BLOCK *****
               */
              // For testing


              SockJS.getUtils = function () {
                return utils;
              };

              SockJS.getIframeTransport = function () {
                return IframeTransport;
              }; //         [*] End of lib/test-hooks.js


              return SockJS;
            }();

            if ('_sockjs_onload' in window) setTimeout(_sockjs_onload, 1); // AMD compliance

            if (typeof define === 'function' && define.amd) {
              define('sockjs', [], function () {
                return SockJS;
              });
            } //     [*] End of lib/index.js
            // [*] End of lib/all.js
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "urls.js": function module(_require5, _exports3, _module4) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/socket-stream-client/urls.js                                                                               //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module4.export({
              toSockjsUrl: () => toSockjsUrl,
              toWebsocketUrl: () => toWebsocketUrl
            });

            // @param url {String} URL to Meteor app, eg:
            //   "/" or "madewith.meteor.com" or "https://foo.meteor.com"
            //   or "ddp+sockjs://ddp--****-foo.meteor.com/sockjs"
            // @returns {String} URL to the endpoint with the specific scheme and subPath, e.g.
            // for scheme "http" and subPath "sockjs"
            //   "http://subdomain.meteor.com/sockjs" or "/sockjs"
            //   or "https://ddp--1234-foo.meteor.com/sockjs"
            function translateUrl(url, newSchemeBase, subPath) {
              if (!newSchemeBase) {
                newSchemeBase = 'http';
              }

              if (subPath !== "sockjs" && url.startsWith("/")) {
                url = Meteor.absoluteUrl(url.substr(1));
              }

              var ddpUrlMatch = url.match(/^ddp(i?)\+sockjs:\/\//);
              var httpUrlMatch = url.match(/^http(s?):\/\//);
              var newScheme;

              if (ddpUrlMatch) {
                // Remove scheme and split off the host.
                var urlAfterDDP = url.substr(ddpUrlMatch[0].length);
                newScheme = ddpUrlMatch[1] === 'i' ? newSchemeBase : newSchemeBase + 's';
                var slashPos = urlAfterDDP.indexOf('/');
                var host = slashPos === -1 ? urlAfterDDP : urlAfterDDP.substr(0, slashPos);
                var rest = slashPos === -1 ? '' : urlAfterDDP.substr(slashPos); // In the host (ONLY!), change '*' characters into random digits. This
                // allows different stream connections to connect to different hostnames
                // and avoid browser per-hostname connection limits.

                host = host.replace(/\*/g, () => Math.floor(Math.random() * 10));
                return newScheme + '://' + host + rest;
              } else if (httpUrlMatch) {
                newScheme = !httpUrlMatch[1] ? newSchemeBase : newSchemeBase + 's';
                var urlAfterHttp = url.substr(httpUrlMatch[0].length);
                url = newScheme + '://' + urlAfterHttp;
              } // Prefix FQDNs but not relative URLs


              if (url.indexOf('://') === -1 && !url.startsWith('/')) {
                url = newSchemeBase + '://' + url;
              } // XXX This is not what we should be doing: if I have a site
              // deployed at "/foo", then DDP.connect("/") should actually connect
              // to "/", not to "/foo". "/" is an absolute path. (Contrast: if
              // deployed at "/foo", it would be reasonable for DDP.connect("bar")
              // to connect to "/foo/bar").
              //
              // We should make this properly honor absolute paths rather than
              // forcing the path to be relative to the site root. Simultaneously,
              // we should set DDP_DEFAULT_CONNECTION_URL to include the site
              // root. See also client_convenience.js #RationalizingRelativeDDPURLs


              url = Meteor._relativeToSiteRootUrl(url);
              if (url.endsWith('/')) return url + subPath;else return url + '/' + subPath;
            }

            function toSockjsUrl(url) {
              return translateUrl(url, 'http', 'sockjs');
            }

            function toWebsocketUrl(url) {
              return translateUrl(url, 'ws', 'websocket');
            }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  /* Exports */
  Package._define("socket-stream-client");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var Random = Package.random.Random;
  var EJSON = Package.ejson.EJSON;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var Retry = Package.retry.Retry;
  var IdMap = Package['id-map'].IdMap;
  var Hook = Package['callback-hook'].Hook;
  var DDPCommon = Package['ddp-common'].DDPCommon;
  var Reload = Package.reload.Reload;
  var DiffSequence = Package['diff-sequence'].DiffSequence;
  var MongoID = Package['mongo-id'].MongoID;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var options, args, callback, DDP;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "ddp-client": { "client": { "client.js": function module(_require, _exports, _module) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/ddp-client/client/client.js                                                                                //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              _module.link("../common/namespace.js", {
                DDP: "DDP"
              }, 0);
              _module.link("../common/livedata_connection");
              _module.link("./client_convenience");
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "client_convenience.js": function module(_require3, _exports3, _module2) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/ddp-client/client/client_convenience.js                                                                    //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              let DDP;
              _module2.link("../common/namespace.js", {
                DDP(v) {
                  DDP = v;
                }

              }, 0);
              let Meteor;
              _module2.link("meteor/meteor", {
                Meteor(v) {
                  Meteor = v;
                }

              }, 1);

              // Meteor.refresh can be called on the client (if you're in common code) but it
              // only has an effect on the server.
              Meteor.refresh = () => {}; // By default, try to connect back to the same endpoint as the page
              // was served from.
              //
              // XXX We should be doing this a different way. Right now we don't
              // include ROOT_URL_PATH_PREFIX when computing ddpUrl. (We don't
              // include it on the server when computing
              // DDP_DEFAULT_CONNECTION_URL, and we don't include it in our
              // default, '/'.) We get by with this because DDP.connect then
              // forces the URL passed to it to be interpreted relative to the
              // app's deploy path, even if it is absolute. Instead, we should
              // make DDP_DEFAULT_CONNECTION_URL, if set, include the path prefix;
              // make the default ddpUrl be '' rather that '/'; and make
              // _translateUrl in stream_client_common.js not force absolute paths
              // to be treated like relative paths. See also
              // stream_client_common.js #RationalizingRelativeDDPURLs


              const runtimeConfig = typeof __meteor_runtime_config__ !== 'undefined' ? __meteor_runtime_config__ : Object.create(null);
              const ddpUrl = runtimeConfig.DDP_DEFAULT_CONNECTION_URL || '/';
              const retry = new Retry();

              function onDDPVersionNegotiationFailure(description) {
                Meteor._debug(description);

                if (Package.reload) {
                  const migrationData = Package.reload.Reload._migrationData('livedata') || Object.create(null);
                  let failures = migrationData.DDPVersionNegotiationFailures || 0;
                  ++failures;

                  Package.reload.Reload._onMigrate('livedata', () => [true, {
                    DDPVersionNegotiationFailures: failures
                  }]);

                  retry.retryLater(failures, () => {
                    Package.reload.Reload._reload({
                      immediateMigration: true
                    });
                  });
                }
              }

              Meteor.connection = DDP.connect(ddpUrl, {
                onDDPVersionNegotiationFailure: onDDPVersionNegotiationFailure
              }); // Proxy the public methods of Meteor.connection so they can
              // be called directly on Meteor.

              ['subscribe', 'methods', 'call', 'apply', 'status', 'reconnect', 'disconnect'].forEach(name => {
                Meteor[name] = Meteor.connection[name].bind(Meteor.connection);
              }); // Meteor.connection used to be called
              // Meteor.default_connection. Provide backcompat as a courtesy even
              // though it was never documented.
              // XXX COMPAT WITH 0.6.4

              Meteor.default_connection = Meteor.connection; // We should transition from Meteor.connect to DDP.connect.
              // XXX COMPAT WITH 0.6.4

              Meteor.connect = DDP.connect;
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            } }, "common": { "MethodInvoker.js": function module(_require4, _exports4, _module3) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/ddp-client/common/MethodInvoker.js                                                                         //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              _module3.export({
                default: () => MethodInvoker
              });

              class MethodInvoker {
                constructor(options) {
                  // Public (within this file) fields.
                  this.methodId = options.methodId;
                  this.sentMessage = false;
                  this._callback = options.callback;
                  this._connection = options.connection;
                  this._message = options.message;

                  this._onResultReceived = options.onResultReceived || (() => {});

                  this._wait = options.wait;
                  this.noRetry = options.noRetry;
                  this._methodResult = null;
                  this._dataVisible = false; // Register with the connection.

                  this._connection._methodInvokers[this.methodId] = this;
                } // Sends the method message to the server. May be called additional times if
                // we lose the connection and reconnect before receiving a result.


                sendMessage() {
                  // This function is called before sending a method (including resending on
                  // reconnect). We should only (re)send methods where we don't already have a
                  // result!
                  if (this.gotResult()) throw new Error('sendingMethod is called on method with result'); // If we're re-sending it, it doesn't matter if data was written the first
                  // time.

                  this._dataVisible = false;
                  this.sentMessage = true; // If this is a wait method, make all data messages be buffered until it is
                  // done.

                  if (this._wait) this._connection._methodsBlockingQuiescence[this.methodId] = true; // Actually send the message.

                  this._connection._send(this._message);
                } // Invoke the callback, if we have both a result and know that all data has
                // been written to the local cache.


                _maybeInvokeCallback() {
                  if (this._methodResult && this._dataVisible) {
                    // Call the callback. (This won't throw: the callback was wrapped with
                    // bindEnvironment.)
                    this._callback(this._methodResult[0], this._methodResult[1]); // Forget about this method.


                    delete this._connection._methodInvokers[this.methodId]; // Let the connection know that this method is finished, so it can try to
                    // move on to the next block of methods.

                    this._connection._outstandingMethodFinished();
                  }
                } // Call with the result of the method from the server. Only may be called
                // once; once it is called, you should not call sendMessage again.
                // If the user provided an onResultReceived callback, call it immediately.
                // Then invoke the main callback if data is also visible.


                receiveResult(err, result) {
                  if (this.gotResult()) throw new Error('Methods should only receive results once');
                  this._methodResult = [err, result];

                  this._onResultReceived(err, result);

                  this._maybeInvokeCallback();
                } // Call this when all data written by the method is visible. This means that
                // the method has returns its "data is done" message *AND* all server
                // documents that are buffered at that time have been written to the local
                // cache. Invokes the main callback if the result has been received.


                dataVisible() {
                  this._dataVisible = true;

                  this._maybeInvokeCallback();
                } // True if receiveResult has been called.


                gotResult() {
                  return !!this._methodResult;
                }

              }
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "livedata_connection.js": function module(_require5, _exports5, _module4) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/ddp-client/common/livedata_connection.js                                                                   //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              let _objectSpread;

              _module4.link("@babel/runtime/helpers/objectSpread2", {
                default(v) {
                  _objectSpread = v;
                }

              }, 0);
              _module4.export({
                Connection: () => Connection
              });
              let Meteor;
              _module4.link("meteor/meteor", {
                Meteor(v) {
                  Meteor = v;
                }

              }, 0);
              let DDPCommon;
              _module4.link("meteor/ddp-common", {
                DDPCommon(v) {
                  DDPCommon = v;
                }

              }, 1);
              let Tracker;
              _module4.link("meteor/tracker", {
                Tracker(v) {
                  Tracker = v;
                }

              }, 2);
              let EJSON;
              _module4.link("meteor/ejson", {
                EJSON(v) {
                  EJSON = v;
                }

              }, 3);
              let Random;
              _module4.link("meteor/random", {
                Random(v) {
                  Random = v;
                }

              }, 4);
              let Hook;
              _module4.link("meteor/callback-hook", {
                Hook(v) {
                  Hook = v;
                }

              }, 5);
              let MongoID;
              _module4.link("meteor/mongo-id", {
                MongoID(v) {
                  MongoID = v;
                }

              }, 6);
              let DDP;
              _module4.link("./namespace.js", {
                DDP(v) {
                  DDP = v;
                }

              }, 7);
              let MethodInvoker;
              _module4.link("./MethodInvoker.js", {
                default(v) {
                  MethodInvoker = v;
                }

              }, 8);
              let hasOwn, slice, keys, isEmpty, last;
              _module4.link("meteor/ddp-common/utils.js", {
                hasOwn(v) {
                  hasOwn = v;
                },

                slice(v) {
                  slice = v;
                },

                keys(v) {
                  keys = v;
                },

                isEmpty(v) {
                  isEmpty = v;
                },

                last(v) {
                  last = v;
                }

              }, 9);
              let Fiber;
              let Future;

              if (Meteor.isServer) {
                Fiber = Npm.require('fibers');
                Future = Npm.require('fibers/future');
              }

              class MongoIDMap extends IdMap {
                constructor() {
                  super(MongoID.idStringify, MongoID.idParse);
                }

              } // @param url {String|Object} URL to Meteor app,
              //   or an object as a test hook (see code)
              // Options:
              //   reloadWithOutstanding: is it OK to reload if there are outstanding methods?
              //   headers: extra headers to send on the websockets connection, for
              //     server-to-server DDP only
              //   _sockjsOptions: Specifies options to pass through to the sockjs client
              //   onDDPNegotiationVersionFailure: callback when version negotiation fails.
              //
              // XXX There should be a way to destroy a DDP connection, causing all
              // outstanding method calls to fail.
              //
              // XXX Our current way of handling failure and reconnection is great
              // for an app (where we want to tolerate being disconnected as an
              // expect state, and keep trying forever to reconnect) but cumbersome
              // for something like a command line tool that wants to make a
              // connection, call a method, and print an error if connection
              // fails. We should have better usability in the latter case (while
              // still transparently reconnecting if it's just a transient failure
              // or the server migrating us).


              class Connection {
                constructor(url, options) {
                  const self = this;
                  this.options = options = _objectSpread({
                    onConnected() {},

                    onDDPVersionNegotiationFailure(description) {
                      Meteor._debug(description);
                    },

                    heartbeatInterval: 17500,
                    heartbeatTimeout: 15000,
                    npmFayeOptions: Object.create(null),
                    // These options are only for testing.
                    reloadWithOutstanding: false,
                    supportedDDPVersions: DDPCommon.SUPPORTED_DDP_VERSIONS,
                    retry: true,
                    respondToPings: true,
                    // When updates are coming within this ms interval, batch them together.
                    bufferedWritesInterval: 5,
                    // Flush buffers immediately if writes are happening continuously for more than this many ms.
                    bufferedWritesMaxAge: 500
                  }, options); // If set, called when we reconnect, queuing method calls _before_ the
                  // existing outstanding ones.
                  // NOTE: This feature has been preserved for backwards compatibility. The
                  // preferred method of setting a callback on reconnect is to use
                  // DDP.onReconnect.

                  self.onReconnect = null; // as a test hook, allow passing a stream instead of a url.

                  if (typeof url === 'object') {
                    self._stream = url;
                  } else {
                    const {
                      ClientStream
                    } = _require5("meteor/socket-stream-client");

                    self._stream = new ClientStream(url, {
                      retry: options.retry,
                      ConnectionError: DDP.ConnectionError,
                      headers: options.headers,
                      _sockjsOptions: options._sockjsOptions,
                      // Used to keep some tests quiet, or for other cases in which
                      // the right thing to do with connection errors is to silently
                      // fail (e.g. sending package usage stats). At some point we
                      // should have a real API for handling client-stream-level
                      // errors.
                      _dontPrintErrors: options._dontPrintErrors,
                      connectTimeoutMs: options.connectTimeoutMs,
                      npmFayeOptions: options.npmFayeOptions
                    });
                  }

                  self._lastSessionId = null;
                  self._versionSuggestion = null; // The last proposed DDP version.

                  self._version = null; // The DDP version agreed on by client and server.

                  self._stores = Object.create(null); // name -> object with methods

                  self._methodHandlers = Object.create(null); // name -> func

                  self._nextMethodId = 1;
                  self._supportedDDPVersions = options.supportedDDPVersions;
                  self._heartbeatInterval = options.heartbeatInterval;
                  self._heartbeatTimeout = options.heartbeatTimeout; // Tracks methods which the user has tried to call but which have not yet
                  // called their user callback (ie, they are waiting on their result or for all
                  // of their writes to be written to the local cache). Map from method ID to
                  // MethodInvoker object.

                  self._methodInvokers = Object.create(null); // Tracks methods which the user has called but whose result messages have not
                  // arrived yet.
                  //
                  // _outstandingMethodBlocks is an array of blocks of methods. Each block
                  // represents a set of methods that can run at the same time. The first block
                  // represents the methods which are currently in flight; subsequent blocks
                  // must wait for previous blocks to be fully finished before they can be sent
                  // to the server.
                  //
                  // Each block is an object with the following fields:
                  // - methods: a list of MethodInvoker objects
                  // - wait: a boolean; if true, this block had a single method invoked with
                  //         the "wait" option
                  //
                  // There will never be adjacent blocks with wait=false, because the only thing
                  // that makes methods need to be serialized is a wait method.
                  //
                  // Methods are removed from the first block when their "result" is
                  // received. The entire first block is only removed when all of the in-flight
                  // methods have received their results (so the "methods" list is empty) *AND*
                  // all of the data written by those methods are visible in the local cache. So
                  // it is possible for the first block's methods list to be empty, if we are
                  // still waiting for some objects to quiesce.
                  //
                  // Example:
                  //  _outstandingMethodBlocks = [
                  //    {wait: false, methods: []},
                  //    {wait: true, methods: [<MethodInvoker for 'login'>]},
                  //    {wait: false, methods: [<MethodInvoker for 'foo'>,
                  //                            <MethodInvoker for 'bar'>]}]
                  // This means that there were some methods which were sent to the server and
                  // which have returned their results, but some of the data written by
                  // the methods may not be visible in the local cache. Once all that data is
                  // visible, we will send a 'login' method. Once the login method has returned
                  // and all the data is visible (including re-running subs if userId changes),
                  // we will send the 'foo' and 'bar' methods in parallel.

                  self._outstandingMethodBlocks = []; // method ID -> array of objects with keys 'collection' and 'id', listing
                  // documents written by a given method's stub. keys are associated with
                  // methods whose stub wrote at least one document, and whose data-done message
                  // has not yet been received.

                  self._documentsWrittenByStub = Object.create(null); // collection -> IdMap of "server document" object. A "server document" has:
                  // - "document": the version of the document according the
                  //   server (ie, the snapshot before a stub wrote it, amended by any changes
                  //   received from the server)
                  //   It is undefined if we think the document does not exist
                  // - "writtenByStubs": a set of method IDs whose stubs wrote to the document
                  //   whose "data done" messages have not yet been processed

                  self._serverDocuments = Object.create(null); // Array of callbacks to be called after the next update of the local
                  // cache. Used for:
                  //  - Calling methodInvoker.dataVisible and sub ready callbacks after
                  //    the relevant data is flushed.
                  //  - Invoking the callbacks of "half-finished" methods after reconnect
                  //    quiescence. Specifically, methods whose result was received over the old
                  //    connection (so we don't re-send it) but whose data had not been made
                  //    visible.

                  self._afterUpdateCallbacks = []; // In two contexts, we buffer all incoming data messages and then process them
                  // all at once in a single update:
                  //   - During reconnect, we buffer all data messages until all subs that had
                  //     been ready before reconnect are ready again, and all methods that are
                  //     active have returned their "data done message"; then
                  //   - During the execution of a "wait" method, we buffer all data messages
                  //     until the wait method gets its "data done" message. (If the wait method
                  //     occurs during reconnect, it doesn't get any special handling.)
                  // all data messages are processed in one update.
                  //
                  // The following fields are used for this "quiescence" process.
                  // This buffers the messages that aren't being processed yet.

                  self._messagesBufferedUntilQuiescence = []; // Map from method ID -> true. Methods are removed from this when their
                  // "data done" message is received, and we will not quiesce until it is
                  // empty.

                  self._methodsBlockingQuiescence = Object.create(null); // map from sub ID -> true for subs that were ready (ie, called the sub
                  // ready callback) before reconnect but haven't become ready again yet

                  self._subsBeingRevived = Object.create(null); // map from sub._id -> true
                  // if true, the next data update should reset all stores. (set during
                  // reconnect.)

                  self._resetStores = false; // name -> array of updates for (yet to be created) collections

                  self._updatesForUnknownStores = Object.create(null); // if we're blocking a migration, the retry func

                  self._retryMigrate = null;
                  self.__flushBufferedWrites = Meteor.bindEnvironment(self._flushBufferedWrites, 'flushing DDP buffered writes', self); // Collection name -> array of messages.

                  self._bufferedWrites = Object.create(null); // When current buffer of updates must be flushed at, in ms timestamp.

                  self._bufferedWritesFlushAt = null; // Timeout handle for the next processing of all pending writes

                  self._bufferedWritesFlushHandle = null;
                  self._bufferedWritesInterval = options.bufferedWritesInterval;
                  self._bufferedWritesMaxAge = options.bufferedWritesMaxAge; // metadata for subscriptions.  Map from sub ID to object with keys:
                  //   - id
                  //   - name
                  //   - params
                  //   - inactive (if true, will be cleaned up if not reused in re-run)
                  //   - ready (has the 'ready' message been received?)
                  //   - readyCallback (an optional callback to call when ready)
                  //   - errorCallback (an optional callback to call if the sub terminates with
                  //                    an error, XXX COMPAT WITH 1.0.3.1)
                  //   - stopCallback (an optional callback to call when the sub terminates
                  //     for any reason, with an error argument if an error triggered the stop)

                  self._subscriptions = Object.create(null); // Reactive userId.

                  self._userId = null;
                  self._userIdDeps = new Tracker.Dependency(); // Block auto-reload while we're waiting for method responses.

                  if (Meteor.isClient && Package.reload && !options.reloadWithOutstanding) {
                    Package.reload.Reload._onMigrate(retry => {
                      if (!self._readyToMigrate()) {
                        self._retryMigrate = retry;
                        return [false];
                      } else {
                        return [true];
                      }
                    });
                  }

                  const onDisconnect = () => {
                    if (self._heartbeat) {
                      self._heartbeat.stop();

                      self._heartbeat = null;
                    }
                  };

                  if (Meteor.isServer) {
                    self._stream.on('message', Meteor.bindEnvironment(this.onMessage.bind(this), 'handling DDP message'));

                    self._stream.on('reset', Meteor.bindEnvironment(this.onReset.bind(this), 'handling DDP reset'));

                    self._stream.on('disconnect', Meteor.bindEnvironment(onDisconnect, 'handling DDP disconnect'));
                  } else {
                    self._stream.on('message', this.onMessage.bind(this));

                    self._stream.on('reset', this.onReset.bind(this));

                    self._stream.on('disconnect', onDisconnect);
                  }
                } // 'name' is the name of the data on the wire that should go in the
                // store. 'wrappedStore' should be an object with methods beginUpdate, update,
                // endUpdate, saveOriginals, retrieveOriginals. see Collection for an example.


                registerStore(name, wrappedStore) {
                  const self = this;
                  if (name in self._stores) return false; // Wrap the input object in an object which makes any store method not
                  // implemented by 'store' into a no-op.

                  const store = Object.create(null);
                  const keysOfStore = ['update', 'beginUpdate', 'endUpdate', 'saveOriginals', 'retrieveOriginals', 'getDoc', '_getCollection'];
                  keysOfStore.forEach(method => {
                    store[method] = function () {
                      if (wrappedStore[method]) {
                        return wrappedStore[method](...arguments);
                      }
                    };
                  });
                  self._stores[name] = store;
                  const queued = self._updatesForUnknownStores[name];

                  if (Array.isArray(queued)) {
                    store.beginUpdate(queued.length, false);
                    queued.forEach(msg => {
                      store.update(msg);
                    });
                    store.endUpdate();
                    delete self._updatesForUnknownStores[name];
                  }

                  return true;
                }
                /**
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.subscribe
                 * @summary Subscribe to a record set.  Returns a handle that provides
                 * `stop()` and `ready()` methods.
                 * @locus Client
                 * @param {String} name Name of the subscription.  Matches the name of the
                 * server's `publish()` call.
                 * @param {EJSONable} [arg1,arg2...] Optional arguments passed to publisher
                 * function on server.
                 * @param {Function|Object} [callbacks] Optional. May include `onStop`
                 * and `onReady` callbacks. If there is an error, it is passed as an
                 * argument to `onStop`. If a function is passed instead of an object, it
                 * is interpreted as an `onReady` callback.
                 */

                subscribe(name
                /* .. [arguments] .. (callback|callbacks) */
                ) {
                  const self = this;
                  const params = slice.call(arguments, 1);
                  let callbacks = Object.create(null);

                  if (params.length) {
                    const lastParam = params[params.length - 1];

                    if (typeof lastParam === 'function') {
                      callbacks.onReady = params.pop();
                    } else if (lastParam && [lastParam.onReady, // XXX COMPAT WITH 1.0.3.1 onError used to exist, but now we use
                    // onStop with an error callback instead.
                    lastParam.onError, lastParam.onStop].some(f => typeof f === "function")) {
                      callbacks = params.pop();
                    }
                  } // Is there an existing sub with the same name and param, run in an
                  // invalidated Computation? This will happen if we are rerunning an
                  // existing computation.
                  //
                  // For example, consider a rerun of:
                  //
                  //     Tracker.autorun(function () {
                  //       Meteor.subscribe("foo", Session.get("foo"));
                  //       Meteor.subscribe("bar", Session.get("bar"));
                  //     });
                  //
                  // If "foo" has changed but "bar" has not, we will match the "bar"
                  // subcribe to an existing inactive subscription in order to not
                  // unsub and resub the subscription unnecessarily.
                  //
                  // We only look for one such sub; if there are N apparently-identical subs
                  // being invalidated, we will require N matching subscribe calls to keep
                  // them all active.


                  const existing = Object.values(self._subscriptions).find(sub => sub.inactive && sub.name === name && EJSON.equals(sub.params, params));
                  let id;

                  if (existing) {
                    id = existing.id;
                    existing.inactive = false; // reactivate

                    if (callbacks.onReady) {
                      // If the sub is not already ready, replace any ready callback with the
                      // one provided now. (It's not really clear what users would expect for
                      // an onReady callback inside an autorun; the semantics we provide is
                      // that at the time the sub first becomes ready, we call the last
                      // onReady callback provided, if any.)
                      // If the sub is already ready, run the ready callback right away.
                      // It seems that users would expect an onReady callback inside an
                      // autorun to trigger once the the sub first becomes ready and also
                      // when re-subs happens.
                      if (existing.ready) {
                        callbacks.onReady();
                      } else {
                        existing.readyCallback = callbacks.onReady;
                      }
                    } // XXX COMPAT WITH 1.0.3.1 we used to have onError but now we call
                    // onStop with an optional error argument


                    if (callbacks.onError) {
                      // Replace existing callback if any, so that errors aren't
                      // double-reported.
                      existing.errorCallback = callbacks.onError;
                    }

                    if (callbacks.onStop) {
                      existing.stopCallback = callbacks.onStop;
                    }
                  } else {
                    // New sub! Generate an id, save it locally, and send message.
                    id = Random.id();
                    self._subscriptions[id] = {
                      id: id,
                      name: name,
                      params: EJSON.clone(params),
                      inactive: false,
                      ready: false,
                      readyDeps: new Tracker.Dependency(),
                      readyCallback: callbacks.onReady,
                      // XXX COMPAT WITH 1.0.3.1 #errorCallback
                      errorCallback: callbacks.onError,
                      stopCallback: callbacks.onStop,
                      connection: self,

                      remove() {
                        delete this.connection._subscriptions[this.id];
                        this.ready && this.readyDeps.changed();
                      },

                      stop() {
                        this.connection._send({
                          msg: 'unsub',
                          id: id
                        });

                        this.remove();

                        if (callbacks.onStop) {
                          callbacks.onStop();
                        }
                      }

                    };

                    self._send({
                      msg: 'sub',
                      id: id,
                      name: name,
                      params: params
                    });
                  } // return a handle to the application.


                  const handle = {
                    stop() {
                      if (!hasOwn.call(self._subscriptions, id)) {
                        return;
                      }

                      self._subscriptions[id].stop();
                    },

                    ready() {
                      // return false if we've unsubscribed.
                      if (!hasOwn.call(self._subscriptions, id)) {
                        return false;
                      }

                      const record = self._subscriptions[id];
                      record.readyDeps.depend();
                      return record.ready;
                    },

                    subscriptionId: id
                  };

                  if (Tracker.active) {
                    // We're in a reactive computation, so we'd like to unsubscribe when the
                    // computation is invalidated... but not if the rerun just re-subscribes
                    // to the same subscription!  When a rerun happens, we use onInvalidate
                    // as a change to mark the subscription "inactive" so that it can
                    // be reused from the rerun.  If it isn't reused, it's killed from
                    // an afterFlush.
                    Tracker.onInvalidate(c => {
                      if (hasOwn.call(self._subscriptions, id)) {
                        self._subscriptions[id].inactive = true;
                      }

                      Tracker.afterFlush(() => {
                        if (hasOwn.call(self._subscriptions, id) && self._subscriptions[id].inactive) {
                          handle.stop();
                        }
                      });
                    });
                  }

                  return handle;
                } // options:
                // - onLateError {Function(error)} called if an error was received after the ready event.
                //     (errors received before ready cause an error to be thrown)


                _subscribeAndWait(name, args, options) {
                  const self = this;
                  const f = new Future();
                  let ready = false;
                  args = args || [];
                  args.push({
                    onReady() {
                      ready = true;
                      f['return']();
                    },

                    onError(e) {
                      if (!ready) f['throw'](e);else options && options.onLateError && options.onLateError(e);
                    }

                  });
                  const handle = self.subscribe.apply(self, [name].concat(args));
                  f.wait();
                  return handle;
                }

                methods(methods) {
                  Object.entries(methods).forEach(_ref => {
                    let [name, func] = _ref;

                    if (typeof func !== 'function') {
                      throw new Error("Method '" + name + "' must be a function");
                    }

                    if (this._methodHandlers[name]) {
                      throw new Error("A method named '" + name + "' is already defined");
                    }

                    this._methodHandlers[name] = func;
                  });
                }
                /**
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.call
                 * @summary Invokes a method passing any number of arguments.
                 * @locus Anywhere
                 * @param {String} name Name of method to invoke
                 * @param {EJSONable} [arg1,arg2...] Optional method arguments
                 * @param {Function} [asyncCallback] Optional callback, which is called asynchronously with the error or result after the method is complete. If not provided, the method runs synchronously if possible (see below).
                 */

                call(name
                /* .. [arguments] .. callback */
                ) {
                  // if it's a function, the last argument is the result callback,
                  // not a parameter to the remote method.
                  const args = slice.call(arguments, 1);
                  let callback;

                  if (args.length && typeof args[args.length - 1] === 'function') {
                    callback = args.pop();
                  }

                  return this.apply(name, args, callback);
                }
                /**
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.apply
                 * @summary Invoke a method passing an array of arguments.
                 * @locus Anywhere
                 * @param {String} name Name of method to invoke
                 * @param {EJSONable[]} args Method arguments
                 * @param {Object} [options]
                 * @param {Boolean} options.wait (Client only) If true, don't send this method until all previous method calls have completed, and don't send any subsequent method calls until this one is completed.
                 * @param {Function} options.onResultReceived (Client only) This callback is invoked with the error or result of the method (just like `asyncCallback`) as soon as the error or result is available. The local cache may not yet reflect the writes performed by the method.
                 * @param {Boolean} options.noRetry (Client only) if true, don't send this method again on reload, simply call the callback an error with the error code 'invocation-failed'.
                 * @param {Boolean} options.throwStubExceptions (Client only) If true, exceptions thrown by method stubs will be thrown instead of logged, and the method will not be invoked on the server.
                 * @param {Boolean} options.returnStubValue (Client only) If true then in cases where we would have otherwise discarded the stub's return value and returned undefined, instead we go ahead and return it. Specifically, this is any time other than when (a) we are already inside a stub or (b) we are in Node and no callback was provided. Currently we require this flag to be explicitly passed to reduce the likelihood that stub return values will be confused with server return values; we may improve this in future.
                 * @param {Function} [asyncCallback] Optional callback; same semantics as in [`Meteor.call`](#meteor_call).
                 */

                apply(name, args, options, callback) {
                  const self = this; // We were passed 3 arguments. They may be either (name, args, options)
                  // or (name, args, callback)

                  if (!callback && typeof options === 'function') {
                    callback = options;
                    options = Object.create(null);
                  }

                  options = options || Object.create(null);

                  if (callback) {
                    // XXX would it be better form to do the binding in stream.on,
                    // or caller, instead of here?
                    // XXX improve error message (and how we report it)
                    callback = Meteor.bindEnvironment(callback, "delivering result of invoking '" + name + "'");
                  } // Keep our args safe from mutation (eg if we don't send the message for a
                  // while because of a wait method).


                  args = EJSON.clone(args);

                  const enclosing = DDP._CurrentMethodInvocation.get();

                  const alreadyInSimulation = enclosing && enclosing.isSimulation; // Lazily generate a randomSeed, only if it is requested by the stub.
                  // The random streams only have utility if they're used on both the client
                  // and the server; if the client doesn't generate any 'random' values
                  // then we don't expect the server to generate any either.
                  // Less commonly, the server may perform different actions from the client,
                  // and may in fact generate values where the client did not, but we don't
                  // have any client-side values to match, so even here we may as well just
                  // use a random seed on the server.  In that case, we don't pass the
                  // randomSeed to save bandwidth, and we don't even generate it to save a
                  // bit of CPU and to avoid consuming entropy.

                  let randomSeed = null;

                  const randomSeedGenerator = () => {
                    if (randomSeed === null) {
                      randomSeed = DDPCommon.makeRpcSeed(enclosing, name);
                    }

                    return randomSeed;
                  }; // Run the stub, if we have one. The stub is supposed to make some
                  // temporary writes to the database to give the user a smooth experience
                  // until the actual result of executing the method comes back from the
                  // server (whereupon the temporary writes to the database will be reversed
                  // during the beginUpdate/endUpdate process.)
                  //
                  // Normally, we ignore the return value of the stub (even if it is an
                  // exception), in favor of the real return value from the server. The
                  // exception is if the *caller* is a stub. In that case, we're not going
                  // to do a RPC, so we use the return value of the stub as our return
                  // value.


                  let stubReturnValue;
                  let exception;
                  const stub = self._methodHandlers[name];

                  if (stub) {
                    const setUserId = userId => {
                      self.setUserId(userId);
                    };

                    const invocation = new DDPCommon.MethodInvocation({
                      isSimulation: true,
                      userId: self.userId(),
                      setUserId: setUserId,

                      randomSeed() {
                        return randomSeedGenerator();
                      }

                    });
                    if (!alreadyInSimulation) self._saveOriginals();

                    try {
                      // Note that unlike in the corresponding server code, we never audit
                      // that stubs check() their arguments.
                      stubReturnValue = DDP._CurrentMethodInvocation.withValue(invocation, () => {
                        if (Meteor.isServer) {
                          // Because saveOriginals and retrieveOriginals aren't reentrant,
                          // don't allow stubs to yield.
                          return Meteor._noYieldsAllowed(() => {
                            // re-clone, so that the stub can't affect our caller's values
                            return stub.apply(invocation, EJSON.clone(args));
                          });
                        } else {
                          return stub.apply(invocation, EJSON.clone(args));
                        }
                      });
                    } catch (e) {
                      exception = e;
                    }
                  } // If we're in a simulation, stop and return the result we have,
                  // rather than going on to do an RPC. If there was no stub,
                  // we'll end up returning undefined.


                  if (alreadyInSimulation) {
                    if (callback) {
                      callback(exception, stubReturnValue);
                      return undefined;
                    }

                    if (exception) throw exception;
                    return stubReturnValue;
                  } // We only create the methodId here because we don't actually need one if
                  // we're already in a simulation


                  const methodId = '' + self._nextMethodId++;

                  if (stub) {
                    self._retrieveAndStoreOriginals(methodId);
                  } // Generate the DDP message for the method call. Note that on the client,
                  // it is important that the stub have finished before we send the RPC, so
                  // that we know we have a complete list of which local documents the stub
                  // wrote.


                  const message = {
                    msg: 'method',
                    id: methodId,
                    method: name,
                    params: args
                  }; // If an exception occurred in a stub, and we're ignoring it
                  // because we're doing an RPC and want to use what the server
                  // returns instead, log it so the developer knows
                  // (unless they explicitly ask to see the error).
                  //
                  // Tests can set the '_expectedByTest' flag on an exception so it won't
                  // go to log.

                  if (exception) {
                    if (options.throwStubExceptions) {
                      throw exception;
                    } else if (!exception._expectedByTest) {
                      Meteor._debug("Exception while simulating the effect of invoking '" + name + "'", exception);
                    }
                  } // At this point we're definitely doing an RPC, and we're going to
                  // return the value of the RPC to the caller.
                  // If the caller didn't give a callback, decide what to do.


                  let future;

                  if (!callback) {
                    if (Meteor.isClient) {
                      // On the client, we don't have fibers, so we can't block. The
                      // only thing we can do is to return undefined and discard the
                      // result of the RPC. If an error occurred then print the error
                      // to the console.
                      callback = err => {
                        err && Meteor._debug("Error invoking Method '" + name + "'", err);
                      };
                    } else {
                      // On the server, make the function synchronous. Throw on
                      // errors, return on success.
                      future = new Future();
                      callback = future.resolver();
                    }
                  } // Send the randomSeed only if we used it


                  if (randomSeed !== null) {
                    message.randomSeed = randomSeed;
                  }

                  const methodInvoker = new MethodInvoker({
                    methodId,
                    callback: callback,
                    connection: self,
                    onResultReceived: options.onResultReceived,
                    wait: !!options.wait,
                    message: message,
                    noRetry: !!options.noRetry
                  });

                  if (options.wait) {
                    // It's a wait method! Wait methods go in their own block.
                    self._outstandingMethodBlocks.push({
                      wait: true,
                      methods: [methodInvoker]
                    });
                  } else {
                    // Not a wait method. Start a new block if the previous block was a wait
                    // block, and add it to the last block of methods.
                    if (isEmpty(self._outstandingMethodBlocks) || last(self._outstandingMethodBlocks).wait) {
                      self._outstandingMethodBlocks.push({
                        wait: false,
                        methods: []
                      });
                    }

                    last(self._outstandingMethodBlocks).methods.push(methodInvoker);
                  } // If we added it to the first block, send it out now.


                  if (self._outstandingMethodBlocks.length === 1) methodInvoker.sendMessage(); // If we're using the default callback on the server,
                  // block waiting for the result.

                  if (future) {
                    return future.wait();
                  }

                  return options.returnStubValue ? stubReturnValue : undefined;
                } // Before calling a method stub, prepare all stores to track changes and allow
                // _retrieveAndStoreOriginals to get the original versions of changed
                // documents.


                _saveOriginals() {
                  if (!this._waitingForQuiescence()) {
                    this._flushBufferedWrites();
                  }

                  Object.values(this._stores).forEach(store => {
                    store.saveOriginals();
                  });
                } // Retrieves the original versions of all documents modified by the stub for
                // method 'methodId' from all stores and saves them to _serverDocuments (keyed
                // by document) and _documentsWrittenByStub (keyed by method ID).


                _retrieveAndStoreOriginals(methodId) {
                  const self = this;
                  if (self._documentsWrittenByStub[methodId]) throw new Error('Duplicate methodId in _retrieveAndStoreOriginals');
                  const docsWritten = [];
                  Object.entries(self._stores).forEach(_ref2 => {
                    let [collection, store] = _ref2;
                    const originals = store.retrieveOriginals(); // not all stores define retrieveOriginals

                    if (!originals) return;
                    originals.forEach((doc, id) => {
                      docsWritten.push({
                        collection,
                        id
                      });

                      if (!hasOwn.call(self._serverDocuments, collection)) {
                        self._serverDocuments[collection] = new MongoIDMap();
                      }

                      const serverDoc = self._serverDocuments[collection].setDefault(id, Object.create(null));

                      if (serverDoc.writtenByStubs) {
                        // We're not the first stub to write this doc. Just add our method ID
                        // to the record.
                        serverDoc.writtenByStubs[methodId] = true;
                      } else {
                        // First stub! Save the original value and our method ID.
                        serverDoc.document = doc;
                        serverDoc.flushCallbacks = [];
                        serverDoc.writtenByStubs = Object.create(null);
                        serverDoc.writtenByStubs[methodId] = true;
                      }
                    });
                  });

                  if (!isEmpty(docsWritten)) {
                    self._documentsWrittenByStub[methodId] = docsWritten;
                  }
                } // This is very much a private function we use to make the tests
                // take up fewer server resources after they complete.


                _unsubscribeAll() {
                  Object.values(this._subscriptions).forEach(sub => {
                    // Avoid killing the autoupdate subscription so that developers
                    // still get hot code pushes when writing tests.
                    //
                    // XXX it's a hack to encode knowledge about autoupdate here,
                    // but it doesn't seem worth it yet to have a special API for
                    // subscriptions to preserve after unit tests.
                    if (sub.name !== 'meteor_autoupdate_clientVersions') {
                      sub.stop();
                    }
                  });
                } // Sends the DDP stringification of the given message object


                _send(obj) {
                  this._stream.send(DDPCommon.stringifyDDP(obj));
                } // We detected via DDP-level heartbeats that we've lost the
                // connection.  Unlike `disconnect` or `close`, a lost connection
                // will be automatically retried.


                _lostConnection(error) {
                  this._stream._lostConnection(error);
                }
                /**
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.status
                 * @summary Get the current connection status. A reactive data source.
                 * @locus Client
                 */

                status() {
                  return this._stream.status(...arguments);
                }
                /**
                 * @summary Force an immediate reconnection attempt if the client is not connected to the server.
                 This method does nothing if the client is already connected.
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.reconnect
                 * @locus Client
                 */

                reconnect() {
                  return this._stream.reconnect(...arguments);
                }
                /**
                 * @memberOf Meteor
                 * @importFromPackage meteor
                 * @alias Meteor.disconnect
                 * @summary Disconnect the client from the server.
                 * @locus Client
                 */

                disconnect() {
                  return this._stream.disconnect(...arguments);
                }

                close() {
                  return this._stream.disconnect({
                    _permanent: true
                  });
                } ///
                /// Reactive user system
                ///


                userId() {
                  if (this._userIdDeps) this._userIdDeps.depend();
                  return this._userId;
                }

                setUserId(userId) {
                  // Avoid invalidating dependents if setUserId is called with current value.
                  if (this._userId === userId) return;
                  this._userId = userId;
                  if (this._userIdDeps) this._userIdDeps.changed();
                } // Returns true if we are in a state after reconnect of waiting for subs to be
                // revived or early methods to finish their data, or we are waiting for a
                // "wait" method to finish.


                _waitingForQuiescence() {
                  return !isEmpty(this._subsBeingRevived) || !isEmpty(this._methodsBlockingQuiescence);
                } // Returns true if any method whose message has been sent to the server has
                // not yet invoked its user callback.


                _anyMethodsAreOutstanding() {
                  const invokers = this._methodInvokers;
                  return Object.values(invokers).some(invoker => !!invoker.sentMessage);
                }

                _livedata_connected(msg) {
                  const self = this;

                  if (self._version !== 'pre1' && self._heartbeatInterval !== 0) {
                    self._heartbeat = new DDPCommon.Heartbeat({
                      heartbeatInterval: self._heartbeatInterval,
                      heartbeatTimeout: self._heartbeatTimeout,

                      onTimeout() {
                        self._lostConnection(new DDP.ConnectionError('DDP heartbeat timed out'));
                      },

                      sendPing() {
                        self._send({
                          msg: 'ping'
                        });
                      }

                    });

                    self._heartbeat.start();
                  } // If this is a reconnect, we'll have to reset all stores.


                  if (self._lastSessionId) self._resetStores = true;
                  let reconnectedToPreviousSession;

                  if (typeof msg.session === 'string') {
                    reconnectedToPreviousSession = self._lastSessionId === msg.session;
                    self._lastSessionId = msg.session;
                  }

                  if (reconnectedToPreviousSession) {
                    // Successful reconnection -- pick up where we left off.  Note that right
                    // now, this never happens: the server never connects us to a previous
                    // session, because DDP doesn't provide enough data for the server to know
                    // what messages the client has processed. We need to improve DDP to make
                    // this possible, at which point we'll probably need more code here.
                    return;
                  } // Server doesn't have our data any more. Re-sync a new session.
                  // Forget about messages we were buffering for unknown collections. They'll
                  // be resent if still relevant.


                  self._updatesForUnknownStores = Object.create(null);

                  if (self._resetStores) {
                    // Forget about the effects of stubs. We'll be resetting all collections
                    // anyway.
                    self._documentsWrittenByStub = Object.create(null);
                    self._serverDocuments = Object.create(null);
                  } // Clear _afterUpdateCallbacks.


                  self._afterUpdateCallbacks = []; // Mark all named subscriptions which are ready (ie, we already called the
                  // ready callback) as needing to be revived.
                  // XXX We should also block reconnect quiescence until unnamed subscriptions
                  //     (eg, autopublish) are done re-publishing to avoid flicker!

                  self._subsBeingRevived = Object.create(null);
                  Object.entries(self._subscriptions).forEach(_ref3 => {
                    let [id, sub] = _ref3;

                    if (sub.ready) {
                      self._subsBeingRevived[id] = true;
                    }
                  }); // Arrange for "half-finished" methods to have their callbacks run, and
                  // track methods that were sent on this connection so that we don't
                  // quiesce until they are all done.
                  //
                  // Start by clearing _methodsBlockingQuiescence: methods sent before
                  // reconnect don't matter, and any "wait" methods sent on the new connection
                  // that we drop here will be restored by the loop below.

                  self._methodsBlockingQuiescence = Object.create(null);

                  if (self._resetStores) {
                    const invokers = self._methodInvokers;
                    keys(invokers).forEach(id => {
                      const invoker = invokers[id];

                      if (invoker.gotResult()) {
                        // This method already got its result, but it didn't call its callback
                        // because its data didn't become visible. We did not resend the
                        // method RPC. We'll call its callback when we get a full quiesce,
                        // since that's as close as we'll get to "data must be visible".
                        self._afterUpdateCallbacks.push(function () {
                          return invoker.dataVisible(...arguments);
                        });
                      } else if (invoker.sentMessage) {
                        // This method has been sent on this connection (maybe as a resend
                        // from the last connection, maybe from onReconnect, maybe just very
                        // quickly before processing the connected message).
                        //
                        // We don't need to do anything special to ensure its callbacks get
                        // called, but we'll count it as a method which is preventing
                        // reconnect quiescence. (eg, it might be a login method that was run
                        // from onReconnect, and we don't want to see flicker by seeing a
                        // logged-out state.)
                        self._methodsBlockingQuiescence[invoker.methodId] = true;
                      }
                    });
                  }

                  self._messagesBufferedUntilQuiescence = []; // If we're not waiting on any methods or subs, we can reset the stores and
                  // call the callbacks immediately.

                  if (!self._waitingForQuiescence()) {
                    if (self._resetStores) {
                      Object.values(self._stores).forEach(store => {
                        store.beginUpdate(0, true);
                        store.endUpdate();
                      });
                      self._resetStores = false;
                    }

                    self._runAfterUpdateCallbacks();
                  }
                }

                _processOneDataMessage(msg, updates) {
                  const messageType = msg.msg; // msg is one of ['added', 'changed', 'removed', 'ready', 'updated']

                  if (messageType === 'added') {
                    this._process_added(msg, updates);
                  } else if (messageType === 'changed') {
                    this._process_changed(msg, updates);
                  } else if (messageType === 'removed') {
                    this._process_removed(msg, updates);
                  } else if (messageType === 'ready') {
                    this._process_ready(msg, updates);
                  } else if (messageType === 'updated') {
                    this._process_updated(msg, updates);
                  } else if (messageType === 'nosub') {// ignore this
                  } else {
                    Meteor._debug('discarding unknown livedata data message type', msg);
                  }
                }

                _livedata_data(msg) {
                  const self = this;

                  if (self._waitingForQuiescence()) {
                    self._messagesBufferedUntilQuiescence.push(msg);

                    if (msg.msg === 'nosub') {
                      delete self._subsBeingRevived[msg.id];
                    }

                    if (msg.subs) {
                      msg.subs.forEach(subId => {
                        delete self._subsBeingRevived[subId];
                      });
                    }

                    if (msg.methods) {
                      msg.methods.forEach(methodId => {
                        delete self._methodsBlockingQuiescence[methodId];
                      });
                    }

                    if (self._waitingForQuiescence()) {
                      return;
                    } // No methods or subs are blocking quiescence!
                    // We'll now process and all of our buffered messages, reset all stores,
                    // and apply them all at once.


                    const bufferedMessages = self._messagesBufferedUntilQuiescence;
                    Object.values(bufferedMessages).forEach(bufferedMessage => {
                      self._processOneDataMessage(bufferedMessage, self._bufferedWrites);
                    });
                    self._messagesBufferedUntilQuiescence = [];
                  } else {
                    self._processOneDataMessage(msg, self._bufferedWrites);
                  } // Immediately flush writes when:
                  //  1. Buffering is disabled. Or;
                  //  2. any non-(added/changed/removed) message arrives.


                  const standardWrite = msg.msg === "added" || msg.msg === "changed" || msg.msg === "removed";

                  if (self._bufferedWritesInterval === 0 || !standardWrite) {
                    self._flushBufferedWrites();

                    return;
                  }

                  if (self._bufferedWritesFlushAt === null) {
                    self._bufferedWritesFlushAt = new Date().valueOf() + self._bufferedWritesMaxAge;
                  } else if (self._bufferedWritesFlushAt < new Date().valueOf()) {
                    self._flushBufferedWrites();

                    return;
                  }

                  if (self._bufferedWritesFlushHandle) {
                    clearTimeout(self._bufferedWritesFlushHandle);
                  }

                  self._bufferedWritesFlushHandle = setTimeout(self.__flushBufferedWrites, self._bufferedWritesInterval);
                }

                _flushBufferedWrites() {
                  const self = this;

                  if (self._bufferedWritesFlushHandle) {
                    clearTimeout(self._bufferedWritesFlushHandle);
                    self._bufferedWritesFlushHandle = null;
                  }

                  self._bufferedWritesFlushAt = null; // We need to clear the buffer before passing it to
                  //  performWrites. As there's no guarantee that it
                  //  will exit cleanly.

                  const writes = self._bufferedWrites;
                  self._bufferedWrites = Object.create(null);

                  self._performWrites(writes);
                }

                _performWrites(updates) {
                  const self = this;

                  if (self._resetStores || !isEmpty(updates)) {
                    // Begin a transactional update of each store.
                    Object.entries(self._stores).forEach(_ref4 => {
                      let [storeName, store] = _ref4;
                      store.beginUpdate(hasOwn.call(updates, storeName) ? updates[storeName].length : 0, self._resetStores);
                    });
                    self._resetStores = false;
                    Object.entries(updates).forEach(_ref5 => {
                      let [storeName, updateMessages] = _ref5;
                      const store = self._stores[storeName];

                      if (store) {
                        updateMessages.forEach(updateMessage => {
                          store.update(updateMessage);
                        });
                      } else {
                        // Nobody's listening for this data. Queue it up until
                        // someone wants it.
                        // XXX memory use will grow without bound if you forget to
                        // create a collection or just don't care about it... going
                        // to have to do something about that.
                        const updates = self._updatesForUnknownStores;

                        if (!hasOwn.call(updates, storeName)) {
                          updates[storeName] = [];
                        }

                        updates[storeName].push(...updateMessages);
                      }
                    }); // End update transaction.

                    Object.values(self._stores).forEach(store => {
                      store.endUpdate();
                    });
                  }

                  self._runAfterUpdateCallbacks();
                } // Call any callbacks deferred with _runWhenAllServerDocsAreFlushed whose
                // relevant docs have been flushed, as well as dataVisible callbacks at
                // reconnect-quiescence time.


                _runAfterUpdateCallbacks() {
                  const self = this;
                  const callbacks = self._afterUpdateCallbacks;
                  self._afterUpdateCallbacks = [];
                  callbacks.forEach(c => {
                    c();
                  });
                }

                _pushUpdate(updates, collection, msg) {
                  if (!hasOwn.call(updates, collection)) {
                    updates[collection] = [];
                  }

                  updates[collection].push(msg);
                }

                _getServerDoc(collection, id) {
                  const self = this;

                  if (!hasOwn.call(self._serverDocuments, collection)) {
                    return null;
                  }

                  const serverDocsForCollection = self._serverDocuments[collection];
                  return serverDocsForCollection.get(id) || null;
                }

                _process_added(msg, updates) {
                  const self = this;
                  const id = MongoID.idParse(msg.id);

                  const serverDoc = self._getServerDoc(msg.collection, id);

                  if (serverDoc) {
                    // Some outstanding stub wrote here.
                    const isExisting = serverDoc.document !== undefined;
                    serverDoc.document = msg.fields || Object.create(null);
                    serverDoc.document._id = id;

                    if (self._resetStores) {
                      // During reconnect the server is sending adds for existing ids.
                      // Always push an update so that document stays in the store after
                      // reset. Use current version of the document for this update, so
                      // that stub-written values are preserved.
                      const currentDoc = self._stores[msg.collection].getDoc(msg.id);

                      if (currentDoc !== undefined) msg.fields = currentDoc;

                      self._pushUpdate(updates, msg.collection, msg);
                    } else if (isExisting) {
                      throw new Error('Server sent add for existing id: ' + msg.id);
                    }
                  } else {
                    self._pushUpdate(updates, msg.collection, msg);
                  }
                }

                _process_changed(msg, updates) {
                  const self = this;

                  const serverDoc = self._getServerDoc(msg.collection, MongoID.idParse(msg.id));

                  if (serverDoc) {
                    if (serverDoc.document === undefined) throw new Error('Server sent changed for nonexisting id: ' + msg.id);
                    DiffSequence.applyChanges(serverDoc.document, msg.fields);
                  } else {
                    self._pushUpdate(updates, msg.collection, msg);
                  }
                }

                _process_removed(msg, updates) {
                  const self = this;

                  const serverDoc = self._getServerDoc(msg.collection, MongoID.idParse(msg.id));

                  if (serverDoc) {
                    // Some outstanding stub wrote here.
                    if (serverDoc.document === undefined) throw new Error('Server sent removed for nonexisting id:' + msg.id);
                    serverDoc.document = undefined;
                  } else {
                    self._pushUpdate(updates, msg.collection, {
                      msg: 'removed',
                      collection: msg.collection,
                      id: msg.id
                    });
                  }
                }

                _process_updated(msg, updates) {
                  const self = this; // Process "method done" messages.

                  msg.methods.forEach(methodId => {
                    const docs = self._documentsWrittenByStub[methodId] || {};
                    Object.values(docs).forEach(written => {
                      const serverDoc = self._getServerDoc(written.collection, written.id);

                      if (!serverDoc) {
                        throw new Error('Lost serverDoc for ' + JSON.stringify(written));
                      }

                      if (!serverDoc.writtenByStubs[methodId]) {
                        throw new Error('Doc ' + JSON.stringify(written) + ' not written by  method ' + methodId);
                      }

                      delete serverDoc.writtenByStubs[methodId];

                      if (isEmpty(serverDoc.writtenByStubs)) {
                        // All methods whose stubs wrote this method have completed! We can
                        // now copy the saved document to the database (reverting the stub's
                        // change if the server did not write to this object, or applying the
                        // server's writes if it did).
                        // This is a fake ddp 'replace' message.  It's just for talking
                        // between livedata connections and minimongo.  (We have to stringify
                        // the ID because it's supposed to look like a wire message.)
                        self._pushUpdate(updates, written.collection, {
                          msg: 'replace',
                          id: MongoID.idStringify(written.id),
                          replace: serverDoc.document
                        }); // Call all flush callbacks.


                        serverDoc.flushCallbacks.forEach(c => {
                          c();
                        }); // Delete this completed serverDocument. Don't bother to GC empty
                        // IdMaps inside self._serverDocuments, since there probably aren't
                        // many collections and they'll be written repeatedly.

                        self._serverDocuments[written.collection].remove(written.id);
                      }
                    });
                    delete self._documentsWrittenByStub[methodId]; // We want to call the data-written callback, but we can't do so until all
                    // currently buffered messages are flushed.

                    const callbackInvoker = self._methodInvokers[methodId];

                    if (!callbackInvoker) {
                      throw new Error('No callback invoker for method ' + methodId);
                    }

                    self._runWhenAllServerDocsAreFlushed(function () {
                      return callbackInvoker.dataVisible(...arguments);
                    });
                  });
                }

                _process_ready(msg, updates) {
                  const self = this; // Process "sub ready" messages. "sub ready" messages don't take effect
                  // until all current server documents have been flushed to the local
                  // database. We can use a write fence to implement this.

                  msg.subs.forEach(subId => {
                    self._runWhenAllServerDocsAreFlushed(() => {
                      const subRecord = self._subscriptions[subId]; // Did we already unsubscribe?

                      if (!subRecord) return; // Did we already receive a ready message? (Oops!)

                      if (subRecord.ready) return;
                      subRecord.ready = true;
                      subRecord.readyCallback && subRecord.readyCallback();
                      subRecord.readyDeps.changed();
                    });
                  });
                } // Ensures that "f" will be called after all documents currently in
                // _serverDocuments have been written to the local cache. f will not be called
                // if the connection is lost before then!


                _runWhenAllServerDocsAreFlushed(f) {
                  const self = this;

                  const runFAfterUpdates = () => {
                    self._afterUpdateCallbacks.push(f);
                  };

                  let unflushedServerDocCount = 0;

                  const onServerDocFlush = () => {
                    --unflushedServerDocCount;

                    if (unflushedServerDocCount === 0) {
                      // This was the last doc to flush! Arrange to run f after the updates
                      // have been applied.
                      runFAfterUpdates();
                    }
                  };

                  Object.values(self._serverDocuments).forEach(serverDocuments => {
                    serverDocuments.forEach(serverDoc => {
                      const writtenByStubForAMethodWithSentMessage = keys(serverDoc.writtenByStubs).some(methodId => {
                        const invoker = self._methodInvokers[methodId];
                        return invoker && invoker.sentMessage;
                      });

                      if (writtenByStubForAMethodWithSentMessage) {
                        ++unflushedServerDocCount;
                        serverDoc.flushCallbacks.push(onServerDocFlush);
                      }
                    });
                  });

                  if (unflushedServerDocCount === 0) {
                    // There aren't any buffered docs --- we can call f as soon as the current
                    // round of updates is applied!
                    runFAfterUpdates();
                  }
                }

                _livedata_nosub(msg) {
                  const self = this; // First pass it through _livedata_data, which only uses it to help get
                  // towards quiescence.

                  self._livedata_data(msg); // Do the rest of our processing immediately, with no
                  // buffering-until-quiescence.
                  // we weren't subbed anyway, or we initiated the unsub.


                  if (!hasOwn.call(self._subscriptions, msg.id)) {
                    return;
                  } // XXX COMPAT WITH 1.0.3.1 #errorCallback


                  const errorCallback = self._subscriptions[msg.id].errorCallback;
                  const stopCallback = self._subscriptions[msg.id].stopCallback;

                  self._subscriptions[msg.id].remove();

                  const meteorErrorFromMsg = msgArg => {
                    return msgArg && msgArg.error && new Meteor.Error(msgArg.error.error, msgArg.error.reason, msgArg.error.details);
                  }; // XXX COMPAT WITH 1.0.3.1 #errorCallback


                  if (errorCallback && msg.error) {
                    errorCallback(meteorErrorFromMsg(msg));
                  }

                  if (stopCallback) {
                    stopCallback(meteorErrorFromMsg(msg));
                  }
                }

                _livedata_result(msg) {
                  // id, result or error. error has error (code), reason, details
                  const self = this; // Lets make sure there are no buffered writes before returning result.

                  if (!isEmpty(self._bufferedWrites)) {
                    self._flushBufferedWrites();
                  } // find the outstanding request
                  // should be O(1) in nearly all realistic use cases


                  if (isEmpty(self._outstandingMethodBlocks)) {
                    Meteor._debug('Received method result but no methods outstanding');

                    return;
                  }

                  const currentMethodBlock = self._outstandingMethodBlocks[0].methods;
                  let i;
                  const m = currentMethodBlock.find((method, idx) => {
                    const found = method.methodId === msg.id;
                    if (found) i = idx;
                    return found;
                  });

                  if (!m) {
                    Meteor._debug("Can't match method response to original method call", msg);

                    return;
                  } // Remove from current method block. This may leave the block empty, but we
                  // don't move on to the next block until the callback has been delivered, in
                  // _outstandingMethodFinished.


                  currentMethodBlock.splice(i, 1);

                  if (hasOwn.call(msg, 'error')) {
                    m.receiveResult(new Meteor.Error(msg.error.error, msg.error.reason, msg.error.details));
                  } else {
                    // msg.result may be undefined if the method didn't return a
                    // value
                    m.receiveResult(undefined, msg.result);
                  }
                } // Called by MethodInvoker after a method's callback is invoked.  If this was
                // the last outstanding method in the current block, runs the next block. If
                // there are no more methods, consider accepting a hot code push.


                _outstandingMethodFinished() {
                  const self = this;
                  if (self._anyMethodsAreOutstanding()) return; // No methods are outstanding. This should mean that the first block of
                  // methods is empty. (Or it might not exist, if this was a method that
                  // half-finished before disconnect/reconnect.)

                  if (!isEmpty(self._outstandingMethodBlocks)) {
                    const firstBlock = self._outstandingMethodBlocks.shift();

                    if (!isEmpty(firstBlock.methods)) throw new Error('No methods outstanding but nonempty block: ' + JSON.stringify(firstBlock)); // Send the outstanding methods now in the first block.

                    if (!isEmpty(self._outstandingMethodBlocks)) self._sendOutstandingMethods();
                  } // Maybe accept a hot code push.


                  self._maybeMigrate();
                } // Sends messages for all the methods in the first block in
                // _outstandingMethodBlocks.


                _sendOutstandingMethods() {
                  const self = this;

                  if (isEmpty(self._outstandingMethodBlocks)) {
                    return;
                  }

                  self._outstandingMethodBlocks[0].methods.forEach(m => {
                    m.sendMessage();
                  });
                }

                _livedata_error(msg) {
                  Meteor._debug('Received error from server: ', msg.reason);

                  if (msg.offendingMessage) Meteor._debug('For: ', msg.offendingMessage);
                }

                _callOnReconnectAndSendAppropriateOutstandingMethods() {
                  const self = this;
                  const oldOutstandingMethodBlocks = self._outstandingMethodBlocks;
                  self._outstandingMethodBlocks = [];
                  self.onReconnect && self.onReconnect();

                  DDP._reconnectHook.each(callback => {
                    callback(self);
                    return true;
                  });

                  if (isEmpty(oldOutstandingMethodBlocks)) return; // We have at least one block worth of old outstanding methods to try
                  // again. First: did onReconnect actually send anything? If not, we just
                  // restore all outstanding methods and run the first block.

                  if (isEmpty(self._outstandingMethodBlocks)) {
                    self._outstandingMethodBlocks = oldOutstandingMethodBlocks;

                    self._sendOutstandingMethods();

                    return;
                  } // OK, there are blocks on both sides. Special case: merge the last block of
                  // the reconnect methods with the first block of the original methods, if
                  // neither of them are "wait" blocks.


                  if (!last(self._outstandingMethodBlocks).wait && !oldOutstandingMethodBlocks[0].wait) {
                    oldOutstandingMethodBlocks[0].methods.forEach(m => {
                      last(self._outstandingMethodBlocks).methods.push(m); // If this "last block" is also the first block, send the message.

                      if (self._outstandingMethodBlocks.length === 1) {
                        m.sendMessage();
                      }
                    });
                    oldOutstandingMethodBlocks.shift();
                  } // Now add the rest of the original blocks on.


                  self._outstandingMethodBlocks.push(...oldOutstandingMethodBlocks);
                } // We can accept a hot code push if there are no methods in flight.


                _readyToMigrate() {
                  return isEmpty(this._methodInvokers);
                } // If we were blocking a migration, see if it's now possible to continue.
                // Call whenever the set of outstanding/blocked methods shrinks.


                _maybeMigrate() {
                  const self = this;

                  if (self._retryMigrate && self._readyToMigrate()) {
                    self._retryMigrate();

                    self._retryMigrate = null;
                  }
                }

                onMessage(raw_msg) {
                  let msg;

                  try {
                    msg = DDPCommon.parseDDP(raw_msg);
                  } catch (e) {
                    Meteor._debug('Exception while parsing DDP', e);

                    return;
                  } // Any message counts as receiving a pong, as it demonstrates that
                  // the server is still alive.


                  if (this._heartbeat) {
                    this._heartbeat.messageReceived();
                  }

                  if (msg === null || !msg.msg) {
                    // XXX COMPAT WITH 0.6.6. ignore the old welcome message for back
                    // compat.  Remove this 'if' once the server stops sending welcome
                    // messages (stream_server.js).
                    if (!(msg && msg.server_id)) Meteor._debug('discarding invalid livedata message', msg);
                    return;
                  }

                  if (msg.msg === 'connected') {
                    this._version = this._versionSuggestion;

                    this._livedata_connected(msg);

                    this.options.onConnected();
                  } else if (msg.msg === 'failed') {
                    if (this._supportedDDPVersions.indexOf(msg.version) >= 0) {
                      this._versionSuggestion = msg.version;

                      this._stream.reconnect({
                        _force: true
                      });
                    } else {
                      const description = 'DDP version negotiation failed; server requested version ' + msg.version;

                      this._stream.disconnect({
                        _permanent: true,
                        _error: description
                      });

                      this.options.onDDPVersionNegotiationFailure(description);
                    }
                  } else if (msg.msg === 'ping' && this.options.respondToPings) {
                    this._send({
                      msg: 'pong',
                      id: msg.id
                    });
                  } else if (msg.msg === 'pong') {// noop, as we assume everything's a pong
                  } else if (['added', 'changed', 'removed', 'ready', 'updated'].includes(msg.msg)) {
                    this._livedata_data(msg);
                  } else if (msg.msg === 'nosub') {
                    this._livedata_nosub(msg);
                  } else if (msg.msg === 'result') {
                    this._livedata_result(msg);
                  } else if (msg.msg === 'error') {
                    this._livedata_error(msg);
                  } else {
                    Meteor._debug('discarding unknown livedata message type', msg);
                  }
                }

                onReset() {
                  // Send a connect message at the beginning of the stream.
                  // NOTE: reset is called even on the first connection, so this is
                  // the only place we send this message.
                  const msg = {
                    msg: 'connect'
                  };
                  if (this._lastSessionId) msg.session = this._lastSessionId;
                  msg.version = this._versionSuggestion || this._supportedDDPVersions[0];
                  this._versionSuggestion = msg.version;
                  msg.support = this._supportedDDPVersions;

                  this._send(msg); // Mark non-retry calls as failed. This has to be done early as getting these methods out of the
                  // current block is pretty important to making sure that quiescence is properly calculated, as
                  // well as possibly moving on to another useful block.
                  // Only bother testing if there is an outstandingMethodBlock (there might not be, especially if
                  // we are connecting for the first time.


                  if (this._outstandingMethodBlocks.length > 0) {
                    // If there is an outstanding method block, we only care about the first one as that is the
                    // one that could have already sent messages with no response, that are not allowed to retry.
                    const currentMethodBlock = this._outstandingMethodBlocks[0].methods;
                    this._outstandingMethodBlocks[0].methods = currentMethodBlock.filter(methodInvoker => {
                      // Methods with 'noRetry' option set are not allowed to re-send after
                      // recovering dropped connection.
                      if (methodInvoker.sentMessage && methodInvoker.noRetry) {
                        // Make sure that the method is told that it failed.
                        methodInvoker.receiveResult(new Meteor.Error('invocation-failed', 'Method invocation might have failed due to dropped connection. ' + 'Failing because `noRetry` option was passed to Meteor.apply.'));
                      } // Only keep a method if it wasn't sent or it's allowed to retry.
                      // This may leave the block empty, but we don't move on to the next
                      // block until the callback has been delivered, in _outstandingMethodFinished.


                      return !(methodInvoker.sentMessage && methodInvoker.noRetry);
                    });
                  } // Now, to minimize setup latency, go ahead and blast out all of
                  // our pending methods ands subscriptions before we've even taken
                  // the necessary RTT to know if we successfully reconnected. (1)
                  // They're supposed to be idempotent, and where they are not,
                  // they can block retry in apply; (2) even if we did reconnect,
                  // we're not sure what messages might have gotten lost
                  // (in either direction) since we were disconnected (TCP being
                  // sloppy about that.)
                  // If the current block of methods all got their results (but didn't all get
                  // their data visible), discard the empty block now.


                  if (this._outstandingMethodBlocks.length > 0 && this._outstandingMethodBlocks[0].methods.length === 0) {
                    this._outstandingMethodBlocks.shift();
                  } // Mark all messages as unsent, they have not yet been sent on this
                  // connection.


                  keys(this._methodInvokers).forEach(id => {
                    this._methodInvokers[id].sentMessage = false;
                  }); // If an `onReconnect` handler is set, call it first. Go through
                  // some hoops to ensure that methods that are called from within
                  // `onReconnect` get executed _before_ ones that were originally
                  // outstanding (since `onReconnect` is used to re-establish auth
                  // certificates)

                  this._callOnReconnectAndSendAppropriateOutstandingMethods(); // add new subscriptions at the end. this way they take effect after
                  // the handlers and we don't see flicker.


                  Object.entries(this._subscriptions).forEach(_ref6 => {
                    let [id, sub] = _ref6;

                    this._send({
                      msg: 'sub',
                      id: id,
                      name: sub.name,
                      params: sub.params
                    });
                  });
                }

              }
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "namespace.js": function module(_require6, _exports6, _module5) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/ddp-client/common/namespace.js                                                                             //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              _module5.export({
                DDP: () => DDP
              });
              let DDPCommon;
              _module5.link("meteor/ddp-common", {
                DDPCommon(v) {
                  DDPCommon = v;
                }

              }, 0);
              let Meteor;
              _module5.link("meteor/meteor", {
                Meteor(v) {
                  Meteor = v;
                }

              }, 1);
              let keys;
              _module5.link("meteor/ddp-common/utils.js", {
                keys(v) {
                  keys = v;
                }

              }, 2);
              let Connection;
              _module5.link("./livedata_connection.js", {
                Connection(v) {
                  Connection = v;
                }

              }, 3);
              // This array allows the `_allSubscriptionsReady` method below, which
              // is used by the `spiderable` package, to keep track of whether all
              // data is ready.
              const allConnections = [];
              /**
               * @namespace DDP
               * @summary Namespace for DDP-related methods/classes.
               */

              const DDP = {};
              // This is private but it's used in a few places. accounts-base uses
              // it to get the current user. Meteor.setTimeout and friends clear
              // it. We can probably find a better way to factor this.
              DDP._CurrentMethodInvocation = new Meteor.EnvironmentVariable();
              DDP._CurrentPublicationInvocation = new Meteor.EnvironmentVariable(); // XXX: Keep DDP._CurrentInvocation for backwards-compatibility.

              DDP._CurrentInvocation = DDP._CurrentMethodInvocation; // This is passed into a weird `makeErrorType` function that expects its thing
              // to be a constructor

              function connectionErrorConstructor(message) {
                this.message = message;
              }

              DDP.ConnectionError = Meteor.makeErrorType('DDP.ConnectionError', connectionErrorConstructor);
              DDP.ForcedReconnectError = Meteor.makeErrorType('DDP.ForcedReconnectError', () => {}); // Returns the named sequence of pseudo-random values.
              // The scope will be DDP._CurrentMethodInvocation.get(), so the stream will produce
              // consistent values for method calls on the client and server.

              DDP.randomStream = name => {
                const scope = DDP._CurrentMethodInvocation.get();

                return DDPCommon.RandomStream.get(scope, name);
              }; // @param url {String} URL to Meteor app,
              //     e.g.:
              //     "subdomain.meteor.com",
              //     "http://subdomain.meteor.com",
              //     "/",
              //     "ddp+sockjs://ddp--****-foo.meteor.com/sockjs"

              /**
               * @summary Connect to the server of a different Meteor application to subscribe to its document sets and invoke its remote methods.
               * @locus Anywhere
               * @param {String} url The URL of another Meteor application.
               */

              DDP.connect = (url, options) => {
                const ret = new Connection(url, options);
                allConnections.push(ret); // hack. see below.

                return ret;
              };

              DDP._reconnectHook = new Hook({
                bindEnvironment: false
              });
              /**
               * @summary Register a function to call as the first step of
               * reconnecting. This function can call methods which will be executed before
               * any other outstanding methods. For example, this can be used to re-establish
               * the appropriate authentication context on the connection.
               * @locus Anywhere
               * @param {Function} callback The function to call. It will be called with a
               * single argument, the [connection object](#ddp_connect) that is reconnecting.
               */

              DDP.onReconnect = callback => DDP._reconnectHook.register(callback); // Hack for `spiderable` package: a way to see if the page is done
              // loading all the data it needs.
              //


              DDP._allSubscriptionsReady = () => allConnections.every(conn => Object.values(conn._subscriptions).every(sub => sub.ready));
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/ddp-client/client/client.js");

  /* Exports */
  Package._define("ddp-client", _exports2, {
    DDP: DDP
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var DDP = Package['ddp-client'].DDP;

  /* Exports */
  Package._define("ddp", {
    DDP: DDP
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("ddp-server");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var LocalCollection = Package.minimongo.LocalCollection;
  var Minimongo = Package.minimongo.Minimongo;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var EJSON = Package.ejson.EJSON;
  var DDP = Package['ddp-client'].DDP;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var AllowDeny;

  var _require = meteorInstall({ "node_modules": { "meteor": { "allow-deny": { "allow-deny.js": function _module() {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/allow-deny/allow-deny.js                                                                                  //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            ///
            /// Remote methods and access control.
            ///
            const hasOwn = Object.prototype.hasOwnProperty; // Restrict default mutators on collection. allow() and deny() take the
            // same options:
            //
            // options.insert {Function(userId, doc)}
            //   return true to allow/deny adding this document
            //
            // options.update {Function(userId, docs, fields, modifier)}
            //   return true to allow/deny updating these documents.
            //   `fields` is passed as an array of fields that are to be modified
            //
            // options.remove {Function(userId, docs)}
            //   return true to allow/deny removing these documents
            //
            // options.fetch {Array}
            //   Fields to fetch for these validators. If any call to allow or deny
            //   does not have this option then all fields are loaded.
            //
            // allow and deny can be called multiple times. The validators are
            // evaluated as follows:
            // - If neither deny() nor allow() has been called on the collection,
            //   then the request is allowed if and only if the "insecure" smart
            //   package is in use.
            // - Otherwise, if any deny() function returns true, the request is denied.
            // - Otherwise, if any allow() function returns true, the request is allowed.
            // - Otherwise, the request is denied.
            //
            // Meteor may call your deny() and allow() functions in any order, and may not
            // call all of them if it is able to make a decision without calling them all
            // (so don't include side effects).

            AllowDeny = {
              CollectionPrototype: {}
            }; // In the `mongo` package, we will extend Mongo.Collection.prototype with these
            // methods

            const CollectionPrototype = AllowDeny.CollectionPrototype;
            /**
             * @summary Allow users to write directly to this collection from client code, subject to limitations you define.
             * @locus Server
             * @method allow
             * @memberOf Mongo.Collection
             * @instance
             * @param {Object} options
             * @param {Function} options.insert,update,remove Functions that look at a proposed modification to the database and return true if it should be allowed.
             * @param {String[]} options.fetch Optional performance enhancement. Limits the fields that will be fetched from the database for inspection by your `update` and `remove` functions.
             * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections).  Pass `null` to disable transformation.
             */

            CollectionPrototype.allow = function (options) {
              addValidator(this, 'allow', options);
            };
            /**
             * @summary Override `allow` rules.
             * @locus Server
             * @method deny
             * @memberOf Mongo.Collection
             * @instance
             * @param {Object} options
             * @param {Function} options.insert,update,remove Functions that look at a proposed modification to the database and return true if it should be denied, even if an [allow](#allow) rule says otherwise.
             * @param {String[]} options.fetch Optional performance enhancement. Limits the fields that will be fetched from the database for inspection by your `update` and `remove` functions.
             * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections).  Pass `null` to disable transformation.
             */

            CollectionPrototype.deny = function (options) {
              addValidator(this, 'deny', options);
            };

            CollectionPrototype._defineMutationMethods = function (options) {
              const self = this;
              options = options || {}; // set to true once we call any allow or deny methods. If true, use
              // allow/deny semantics. If false, use insecure mode semantics.

              self._restricted = false; // Insecure mode (default to allowing writes). Defaults to 'undefined' which
              // means insecure iff the insecure package is loaded. This property can be
              // overriden by tests or packages wishing to change insecure mode behavior of
              // their collections.

              self._insecure = undefined;
              self._validators = {
                insert: {
                  allow: [],
                  deny: []
                },
                update: {
                  allow: [],
                  deny: []
                },
                remove: {
                  allow: [],
                  deny: []
                },
                upsert: {
                  allow: [],
                  deny: []
                },
                // dummy arrays; can't set these!
                fetch: [],
                fetchAllFields: false
              };
              if (!self._name) return; // anonymous collection
              // XXX Think about method namespacing. Maybe methods should be
              // "Meteor:Mongo:insert/NAME"?

              self._prefix = '/' + self._name + '/'; // Mutation Methods
              // Minimongo on the server gets no stubs; instead, by default
              // it wait()s until its result is ready, yielding.
              // This matches the behavior of macromongo on the server better.
              // XXX see #MeteorServerNull

              if (self._connection && (self._connection === Meteor.server || Meteor.isClient)) {
                const m = {};
                ['insert', 'update', 'remove'].forEach(method => {
                  const methodName = self._prefix + method;

                  if (options.useExisting) {
                    const handlerPropName = Meteor.isClient ? '_methodHandlers' : 'method_handlers'; // Do not try to create additional methods if this has already been called.
                    // (Otherwise the .methods() call below will throw an error.)

                    if (self._connection[handlerPropName] && typeof self._connection[handlerPropName][methodName] === 'function') return;
                  }

                  m[methodName] = function () {
                    // All the methods do their own validation, instead of using check().
                    check(arguments, [Match.Any]);
                    const args = Array.from(arguments);

                    try {
                      // For an insert, if the client didn't specify an _id, generate one
                      // now; because this uses DDP.randomStream, it will be consistent with
                      // what the client generated. We generate it now rather than later so
                      // that if (eg) an allow/deny rule does an insert to the same
                      // collection (not that it really should), the generated _id will
                      // still be the first use of the stream and will be consistent.
                      //
                      // However, we don't actually stick the _id onto the document yet,
                      // because we want allow/deny rules to be able to differentiate
                      // between arbitrary client-specified _id fields and merely
                      // client-controlled-via-randomSeed fields.
                      let generatedId = null;

                      if (method === "insert" && !hasOwn.call(args[0], '_id')) {
                        generatedId = self._makeNewID();
                      }

                      if (this.isSimulation) {
                        // In a client simulation, you can do any mutation (even with a
                        // complex selector).
                        if (generatedId !== null) args[0]._id = generatedId;
                        return self._collection[method].apply(self._collection, args);
                      } // This is the server receiving a method call from the client.
                      // We don't allow arbitrary selectors in mutations from the client: only
                      // single-ID selectors.


                      if (method !== 'insert') throwIfSelectorIsNotId(args[0], method);

                      if (self._restricted) {
                        // short circuit if there is no way it will pass.
                        if (self._validators[method].allow.length === 0) {
                          throw new Meteor.Error(403, "Access denied. No allow validators set on restricted " + "collection for method '" + method + "'.");
                        }

                        const validatedMethodName = '_validated' + method.charAt(0).toUpperCase() + method.slice(1);
                        args.unshift(this.userId);
                        method === 'insert' && args.push(generatedId);
                        return self[validatedMethodName].apply(self, args);
                      } else if (self._isInsecure()) {
                        if (generatedId !== null) args[0]._id = generatedId; // In insecure mode, allow any mutation (with a simple selector).
                        // XXX This is kind of bogus.  Instead of blindly passing whatever
                        //     we get from the network to this function, we should actually
                        //     know the correct arguments for the function and pass just
                        //     them.  For example, if you have an extraneous extra null
                        //     argument and this is Mongo on the server, the .wrapAsync'd
                        //     functions like update will get confused and pass the
                        //     "fut.resolver()" in the wrong slot, where _update will never
                        //     invoke it. Bam, broken DDP connection.  Probably should just
                        //     take this whole method and write it three times, invoking
                        //     helpers for the common code.

                        return self._collection[method].apply(self._collection, args);
                      } else {
                        // In secure mode, if we haven't called allow or deny, then nothing
                        // is permitted.
                        throw new Meteor.Error(403, "Access denied");
                      }
                    } catch (e) {
                      if (e.name === 'MongoError' || e.name === 'MinimongoError') {
                        throw new Meteor.Error(409, e.toString());
                      } else {
                        throw e;
                      }
                    }
                  };
                });

                self._connection.methods(m);
              }
            };

            CollectionPrototype._updateFetch = function (fields) {
              const self = this;

              if (!self._validators.fetchAllFields) {
                if (fields) {
                  const union = Object.create(null);

                  const add = names => names && names.forEach(name => union[name] = 1);

                  add(self._validators.fetch);
                  add(fields);
                  self._validators.fetch = Object.keys(union);
                } else {
                  self._validators.fetchAllFields = true; // clear fetch just to make sure we don't accidentally read it

                  self._validators.fetch = null;
                }
              }
            };

            CollectionPrototype._isInsecure = function () {
              const self = this;
              if (self._insecure === undefined) return !!Package.insecure;
              return self._insecure;
            };

            CollectionPrototype._validatedInsert = function (userId, doc, generatedId) {
              const self = this; // call user validators.
              // Any deny returns true means denied.

              if (self._validators.insert.deny.some(validator => {
                return validator(userId, docToValidate(validator, doc, generatedId));
              })) {
                throw new Meteor.Error(403, "Access denied");
              } // Any allow returns true means proceed. Throw error if they all fail.


              if (self._validators.insert.allow.every(validator => {
                return !validator(userId, docToValidate(validator, doc, generatedId));
              })) {
                throw new Meteor.Error(403, "Access denied");
              } // If we generated an ID above, insert it now: after the validation, but
              // before actually inserting.


              if (generatedId !== null) doc._id = generatedId;

              self._collection.insert.call(self._collection, doc);
            }; // Simulate a mongo `update` operation while validating that the access
            // control rules set by calls to `allow/deny` are satisfied. If all
            // pass, rewrite the mongo operation to use $in to set the list of
            // document ids to change ##ValidatedChange


            CollectionPrototype._validatedUpdate = function (userId, selector, mutator, options) {
              const self = this;
              check(mutator, Object);
              options = Object.assign(Object.create(null), options);
              if (!LocalCollection._selectorIsIdPerhapsAsObject(selector)) throw new Error("validated update should be of a single ID"); // We don't support upserts because they don't fit nicely into allow/deny
              // rules.

              if (options.upsert) throw new Meteor.Error(403, "Access denied. Upserts not " + "allowed in a restricted collection.");
              const noReplaceError = "Access denied. In a restricted collection you can only" + " update documents, not replace them. Use a Mongo update operator, such " + "as '$set'.";
              const mutatorKeys = Object.keys(mutator); // compute modified fields

              const modifiedFields = {};

              if (mutatorKeys.length === 0) {
                throw new Meteor.Error(403, noReplaceError);
              }

              mutatorKeys.forEach(op => {
                const params = mutator[op];

                if (op.charAt(0) !== '$') {
                  throw new Meteor.Error(403, noReplaceError);
                } else if (!hasOwn.call(ALLOWED_UPDATE_OPERATIONS, op)) {
                  throw new Meteor.Error(403, "Access denied. Operator " + op + " not allowed in a restricted collection.");
                } else {
                  Object.keys(params).forEach(field => {
                    // treat dotted fields as if they are replacing their
                    // top-level part
                    if (field.indexOf('.') !== -1) field = field.substring(0, field.indexOf('.')); // record the field we are trying to change

                    modifiedFields[field] = true;
                  });
                }
              });
              const fields = Object.keys(modifiedFields);
              const findOptions = {
                transform: null
              };

              if (!self._validators.fetchAllFields) {
                findOptions.fields = {};

                self._validators.fetch.forEach(fieldName => {
                  findOptions.fields[fieldName] = 1;
                });
              }

              const doc = self._collection.findOne(selector, findOptions);

              if (!doc) // none satisfied!
                return 0; // call user validators.
              // Any deny returns true means denied.

              if (self._validators.update.deny.some(validator => {
                const factoriedDoc = transformDoc(validator, doc);
                return validator(userId, factoriedDoc, fields, mutator);
              })) {
                throw new Meteor.Error(403, "Access denied");
              } // Any allow returns true means proceed. Throw error if they all fail.


              if (self._validators.update.allow.every(validator => {
                const factoriedDoc = transformDoc(validator, doc);
                return !validator(userId, factoriedDoc, fields, mutator);
              })) {
                throw new Meteor.Error(403, "Access denied");
              }

              options._forbidReplace = true; // Back when we supported arbitrary client-provided selectors, we actually
              // rewrote the selector to include an _id clause before passing to Mongo to
              // avoid races, but since selector is guaranteed to already just be an ID, we
              // don't have to any more.

              return self._collection.update.call(self._collection, selector, mutator, options);
            }; // Only allow these operations in validated updates. Specifically
            // whitelist operations, rather than blacklist, so new complex
            // operations that are added aren't automatically allowed. A complex
            // operation is one that does more than just modify its target
            // field. For now this contains all update operations except '$rename'.
            // http://docs.mongodb.org/manual/reference/operators/#update


            const ALLOWED_UPDATE_OPERATIONS = {
              $inc: 1,
              $set: 1,
              $unset: 1,
              $addToSet: 1,
              $pop: 1,
              $pullAll: 1,
              $pull: 1,
              $pushAll: 1,
              $push: 1,
              $bit: 1
            }; // Simulate a mongo `remove` operation while validating access control
            // rules. See #ValidatedChange

            CollectionPrototype._validatedRemove = function (userId, selector) {
              const self = this;
              const findOptions = {
                transform: null
              };

              if (!self._validators.fetchAllFields) {
                findOptions.fields = {};

                self._validators.fetch.forEach(fieldName => {
                  findOptions.fields[fieldName] = 1;
                });
              }

              const doc = self._collection.findOne(selector, findOptions);

              if (!doc) return 0; // call user validators.
              // Any deny returns true means denied.

              if (self._validators.remove.deny.some(validator => {
                return validator(userId, transformDoc(validator, doc));
              })) {
                throw new Meteor.Error(403, "Access denied");
              } // Any allow returns true means proceed. Throw error if they all fail.


              if (self._validators.remove.allow.every(validator => {
                return !validator(userId, transformDoc(validator, doc));
              })) {
                throw new Meteor.Error(403, "Access denied");
              } // Back when we supported arbitrary client-provided selectors, we actually
              // rewrote the selector to {_id: {$in: [ids that we found]}} before passing to
              // Mongo to avoid races, but since selector is guaranteed to already just be
              // an ID, we don't have to any more.


              return self._collection.remove.call(self._collection, selector);
            };

            CollectionPrototype._callMutatorMethod = function _callMutatorMethod(name, args, callback) {
              if (Meteor.isClient && !callback && !alreadyInSimulation()) {
                // Client can't block, so it can't report errors by exception,
                // only by callback. If they forget the callback, give them a
                // default one that logs the error, so they aren't totally
                // baffled if their writes don't work because their database is
                // down.
                // Don't give a default callback in simulation, because inside stubs we
                // want to return the results from the local collection immediately and
                // not force a callback.
                callback = function (err) {
                  if (err) Meteor._debug(name + " failed: " + (err.reason || err.stack));
                };
              } // For two out of three mutator methods, the first argument is a selector


              const firstArgIsSelector = name === "update" || name === "remove";

              if (firstArgIsSelector && !alreadyInSimulation()) {
                // If we're about to actually send an RPC, we should throw an error if
                // this is a non-ID selector, because the mutation methods only allow
                // single-ID selectors. (If we don't throw here, we'll see flicker.)
                throwIfSelectorIsNotId(args[0], name);
              }

              const mutatorMethodName = this._prefix + name;
              return this._connection.apply(mutatorMethodName, args, {
                returnStubValue: true
              }, callback);
            };

            function transformDoc(validator, doc) {
              if (validator.transform) return validator.transform(doc);
              return doc;
            }

            function docToValidate(validator, doc, generatedId) {
              let ret = doc;

              if (validator.transform) {
                ret = EJSON.clone(doc); // If you set a server-side transform on your collection, then you don't get
                // to tell the difference between "client specified the ID" and "server
                // generated the ID", because transforms expect to get _id.  If you want to
                // do that check, you can do it with a specific
                // `C.allow({insert: f, transform: null})` validator.

                if (generatedId !== null) {
                  ret._id = generatedId;
                }

                ret = validator.transform(ret);
              }

              return ret;
            }

            function addValidator(collection, allowOrDeny, options) {
              // validate keys
              const validKeysRegEx = /^(?:insert|update|remove|fetch|transform)$/;
              Object.keys(options).forEach(key => {
                if (!validKeysRegEx.test(key)) throw new Error(allowOrDeny + ": Invalid key: " + key);
              });
              collection._restricted = true;
              ['insert', 'update', 'remove'].forEach(name => {
                if (hasOwn.call(options, name)) {
                  if (!(options[name] instanceof Function)) {
                    throw new Error(allowOrDeny + ": Value for `" + name + "` must be a function");
                  } // If the transform is specified at all (including as 'null') in this
                  // call, then take that; otherwise, take the transform from the
                  // collection.


                  if (options.transform === undefined) {
                    options[name].transform = collection._transform; // already wrapped
                  } else {
                    options[name].transform = LocalCollection.wrapTransform(options.transform);
                  }

                  collection._validators[name][allowOrDeny].push(options[name]);
                }
              }); // Only update the fetch fields if we're passed things that affect
              // fetching. This way allow({}) and allow({insert: f}) don't result in
              // setting fetchAllFields

              if (options.update || options.remove || options.fetch) {
                if (options.fetch && !(options.fetch instanceof Array)) {
                  throw new Error(allowOrDeny + ": Value for `fetch` must be an array");
                }

                collection._updateFetch(options.fetch);
              }
            }

            function throwIfSelectorIsNotId(selector, methodName) {
              if (!LocalCollection._selectorIsIdPerhapsAsObject(selector)) {
                throw new Meteor.Error(403, "Not permitted. Untrusted code may only " + methodName + " documents by ID.");
              }
            }

            ; // Determine if we are in a DDP method simulation

            function alreadyInSimulation() {
              var CurrentInvocation = DDP._CurrentMethodInvocation || // For backwards compatibility, as explained in this issue:
              // https://github.com/meteor/meteor/issues/8947
              DDP._CurrentInvocation;
              const enclosing = CurrentInvocation.get();
              return enclosing && enclosing.isSimulation;
            }
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/allow-deny/allow-deny.js");

  /* Exports */
  Package._define("allow-deny", {
    AllowDeny: AllowDeny
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("mongo-dev-server");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var AllowDeny = Package['allow-deny'].AllowDeny;
  var Random = Package.random.Random;
  var EJSON = Package.ejson.EJSON;
  var LocalCollection = Package.minimongo.LocalCollection;
  var Minimongo = Package.minimongo.Minimongo;
  var DDP = Package['ddp-client'].DDP;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var DiffSequence = Package['diff-sequence'].DiffSequence;
  var MongoID = Package['mongo-id'].MongoID;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Mongo, selector, callback, options;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "mongo": { "local_collection_driver.js": function module(_require, _exports, _module) {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                  //
            // packages/mongo/local_collection_driver.js                                                                        //
            //                                                                                                                  //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              LocalCollectionDriver: () => LocalCollectionDriver
            });
            const LocalCollectionDriver = new class LocalCollectionDriver {
              constructor() {
                this.noConnCollections = Object.create(null);
              }

              open(name, conn) {
                if (!name) {
                  return new LocalCollection();
                }

                if (!conn) {
                  return ensureCollection(name, this.noConnCollections);
                }

                if (!conn._mongo_livedata_collections) {
                  conn._mongo_livedata_collections = Object.create(null);
                } // XXX is there a way to keep track of a connection's collections without
                // dangling it off the connection object?


                return ensureCollection(name, conn._mongo_livedata_collections);
              }

            }();

            function ensureCollection(name, collections) {
              return name in collections ? collections[name] : collections[name] = new LocalCollection(name);
            }
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "collection.js": function module(_require3, _exports2, _module2) {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                  //
            // packages/mongo/collection.js                                                                                     //
            //                                                                                                                  //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            !function (module1) {
              let _objectSpread;

              module1.link("@babel/runtime/helpers/objectSpread2", {
                default(v) {
                  _objectSpread = v;
                }

              }, 0);
              // options.connection, if given, is a LivedataClient or LivedataServer
              // XXX presently there is no way to destroy/clean up a Collection

              /**
               * @summary Namespace for MongoDB-related items
               * @namespace
               */
              Mongo = {};
              /**
               * @summary Constructor for a Collection
               * @locus Anywhere
               * @instancename collection
               * @class
               * @param {String} name The name of the collection.  If null, creates an unmanaged (unsynchronized) local collection.
               * @param {Object} [options]
               * @param {Object} options.connection The server connection that will manage this collection. Uses the default connection if not specified.  Pass the return value of calling [`DDP.connect`](#ddp_connect) to specify a different server. Pass `null` to specify no connection. Unmanaged (`name` is null) collections cannot specify a connection.
               * @param {String} options.idGeneration The method of generating the `_id` fields of new documents in this collection.  Possible values:
              
               - **`'STRING'`**: random strings
               - **`'MONGO'`**:  random [`Mongo.ObjectID`](#mongo_object_id) values
              
              The default id generation technique is `'STRING'`.
               * @param {Function} options.transform An optional transformation function. Documents will be passed through this function before being returned from `fetch` or `findOne`, and before being passed to callbacks of `observe`, `map`, `forEach`, `allow`, and `deny`. Transforms are *not* applied for the callbacks of `observeChanges` or to cursors returned from publish functions.
               * @param {Boolean} options.defineMutationMethods Set to `false` to skip setting up the mutation methods that enable insert/update/remove from client code. Default `true`.
               */

              Mongo.Collection = function Collection(name, options) {
                if (!name && name !== null) {
                  Meteor._debug("Warning: creating anonymous collection. It will not be " + "saved or synchronized over the network. (Pass null for " + "the collection name to turn off this warning.)");

                  name = null;
                }

                if (name !== null && typeof name !== "string") {
                  throw new Error("First argument to new Mongo.Collection must be a string or null");
                }

                if (options && options.methods) {
                  // Backwards compatibility hack with original signature (which passed
                  // "connection" directly instead of in options. (Connections must have a "methods"
                  // method.)
                  // XXX remove before 1.0
                  options = {
                    connection: options
                  };
                } // Backwards compatibility: "connection" used to be called "manager".


                if (options && options.manager && !options.connection) {
                  options.connection = options.manager;
                }

                options = _objectSpread({
                  connection: undefined,
                  idGeneration: 'STRING',
                  transform: null,
                  _driver: undefined,
                  _preventAutopublish: false
                }, options);

                switch (options.idGeneration) {
                  case 'MONGO':
                    this._makeNewID = function () {
                      var src = name ? DDP.randomStream('/collection/' + name) : Random.insecure;
                      return new Mongo.ObjectID(src.hexString(24));
                    };

                    break;

                  case 'STRING':
                  default:
                    this._makeNewID = function () {
                      var src = name ? DDP.randomStream('/collection/' + name) : Random.insecure;
                      return src.id();
                    };

                    break;
                }

                this._transform = LocalCollection.wrapTransform(options.transform);
                if (!name || options.connection === null) // note: nameless collections never have a connection
                  this._connection = null;else if (options.connection) this._connection = options.connection;else if (Meteor.isClient) this._connection = Meteor.connection;else this._connection = Meteor.server;

                if (!options._driver) {
                  // XXX This check assumes that webapp is loaded so that Meteor.server !==
                  // null. We should fully support the case of "want to use a Mongo-backed
                  // collection from Node code without webapp", but we don't yet.
                  // #MeteorServerNull
                  if (name && this._connection === Meteor.server && typeof MongoInternals !== "undefined" && MongoInternals.defaultRemoteCollectionDriver) {
                    options._driver = MongoInternals.defaultRemoteCollectionDriver();
                  } else {
                    const {
                      LocalCollectionDriver
                    } = _require3("./local_collection_driver.js");

                    options._driver = LocalCollectionDriver;
                  }
                }

                this._collection = options._driver.open(name, this._connection);
                this._name = name;
                this._driver = options._driver;

                this._maybeSetUpReplication(name, options); // XXX don't define these until allow or deny is actually used for this
                // collection. Could be hard if the security rules are only defined on the
                // server.


                if (options.defineMutationMethods !== false) {
                  try {
                    this._defineMutationMethods({
                      useExisting: options._suppressSameNameError === true
                    });
                  } catch (error) {
                    // Throw a more understandable error on the server for same collection name
                    if (error.message === "A method named '/".concat(name, "/insert' is already defined")) throw new Error("There is already a collection named \"".concat(name, "\""));
                    throw error;
                  }
                } // autopublish


                if (Package.autopublish && !options._preventAutopublish && this._connection && this._connection.publish) {
                  this._connection.publish(null, () => this.find(), {
                    is_auto: true
                  });
                }
              };

              Object.assign(Mongo.Collection.prototype, {
                _maybeSetUpReplication(name, _ref) {
                  let {
                    _suppressSameNameError = false
                  } = _ref;
                  const self = this;

                  if (!(self._connection && self._connection.registerStore)) {
                    return;
                  } // OK, we're going to be a slave, replicating some remote
                  // database, except possibly with some temporary divergence while
                  // we have unacknowledged RPC's.


                  const ok = self._connection.registerStore(name, {
                    // Called at the beginning of a batch of updates. batchSize is the number
                    // of update calls to expect.
                    //
                    // XXX This interface is pretty janky. reset probably ought to go back to
                    // being its own function, and callers shouldn't have to calculate
                    // batchSize. The optimization of not calling pause/remove should be
                    // delayed until later: the first call to update() should buffer its
                    // message, and then we can either directly apply it at endUpdate time if
                    // it was the only update, or do pauseObservers/apply/apply at the next
                    // update() if there's another one.
                    beginUpdate(batchSize, reset) {
                      // pause observers so users don't see flicker when updating several
                      // objects at once (including the post-reconnect reset-and-reapply
                      // stage), and so that a re-sorting of a query can take advantage of the
                      // full _diffQuery moved calculation instead of applying change one at a
                      // time.
                      if (batchSize > 1 || reset) self._collection.pauseObservers();
                      if (reset) self._collection.remove({});
                    },

                    // Apply an update.
                    // XXX better specify this interface (not in terms of a wire message)?
                    update(msg) {
                      var mongoId = MongoID.idParse(msg.id);

                      var doc = self._collection._docs.get(mongoId); // Is this a "replace the whole doc" message coming from the quiescence
                      // of method writes to an object? (Note that 'undefined' is a valid
                      // value meaning "remove it".)


                      if (msg.msg === 'replace') {
                        var replace = msg.replace;

                        if (!replace) {
                          if (doc) self._collection.remove(mongoId);
                        } else if (!doc) {
                          self._collection.insert(replace);
                        } else {
                          // XXX check that replace has no $ ops
                          self._collection.update(mongoId, replace);
                        }

                        return;
                      } else if (msg.msg === 'added') {
                        if (doc) {
                          throw new Error("Expected not to find a document already present for an add");
                        }

                        self._collection.insert(_objectSpread({
                          _id: mongoId
                        }, msg.fields));
                      } else if (msg.msg === 'removed') {
                        if (!doc) throw new Error("Expected to find a document already present for removed");

                        self._collection.remove(mongoId);
                      } else if (msg.msg === 'changed') {
                        if (!doc) throw new Error("Expected to find a document to change");
                        const keys = Object.keys(msg.fields);

                        if (keys.length > 0) {
                          var modifier = {};
                          keys.forEach(key => {
                            const value = msg.fields[key];

                            if (EJSON.equals(doc[key], value)) {
                              return;
                            }

                            if (typeof value === "undefined") {
                              if (!modifier.$unset) {
                                modifier.$unset = {};
                              }

                              modifier.$unset[key] = 1;
                            } else {
                              if (!modifier.$set) {
                                modifier.$set = {};
                              }

                              modifier.$set[key] = value;
                            }
                          });

                          if (Object.keys(modifier).length > 0) {
                            self._collection.update(mongoId, modifier);
                          }
                        }
                      } else {
                        throw new Error("I don't know how to deal with this message");
                      }
                    },

                    // Called at the end of a batch of updates.
                    endUpdate() {
                      self._collection.resumeObservers();
                    },

                    // Called around method stub invocations to capture the original versions
                    // of modified documents.
                    saveOriginals() {
                      self._collection.saveOriginals();
                    },

                    retrieveOriginals() {
                      return self._collection.retrieveOriginals();
                    },

                    // Used to preserve current versions of documents across a store reset.
                    getDoc(id) {
                      return self.findOne(id);
                    },

                    // To be able to get back to the collection from the store.
                    _getCollection() {
                      return self;
                    }

                  });

                  if (!ok) {
                    const message = "There is already a collection named \"".concat(name, "\"");

                    if (_suppressSameNameError === true) {
                      // XXX In theory we do not have to throw when `ok` is falsy. The
                      // store is already defined for this collection name, but this
                      // will simply be another reference to it and everything should
                      // work. However, we have historically thrown an error here, so
                      // for now we will skip the error only when _suppressSameNameError
                      // is `true`, allowing people to opt in and give this some real
                      // world testing.
                      console.warn ? console.warn(message) : console.log(message);
                    } else {
                      throw new Error(message);
                    }
                  }
                },

                ///
                /// Main collection API
                ///
                _getFindSelector(args) {
                  if (args.length == 0) return {};else return args[0];
                },

                _getFindOptions(args) {
                  var self = this;

                  if (args.length < 2) {
                    return {
                      transform: self._transform
                    };
                  } else {
                    check(args[1], Match.Optional(Match.ObjectIncluding({
                      fields: Match.Optional(Match.OneOf(Object, undefined)),
                      sort: Match.Optional(Match.OneOf(Object, Array, Function, undefined)),
                      limit: Match.Optional(Match.OneOf(Number, undefined)),
                      skip: Match.Optional(Match.OneOf(Number, undefined))
                    })));
                    return _objectSpread({
                      transform: self._transform
                    }, args[1]);
                  }
                },

                /**
                 * @summary Find the documents in a collection that match the selector.
                 * @locus Anywhere
                 * @method find
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {MongoSelector} [selector] A query describing the documents to find
                 * @param {Object} [options]
                 * @param {MongoSortSpecifier} options.sort Sort order (default: natural order)
                 * @param {Number} options.skip Number of results to skip at the beginning
                 * @param {Number} options.limit Maximum number of results to return
                 * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.
                 * @param {Boolean} options.reactive (Client only) Default `true`; pass `false` to disable reactivity
                 * @param {Function} options.transform Overrides `transform` on the  [`Collection`](#collections) for this cursor.  Pass `null` to disable transformation.
                 * @param {Boolean} options.disableOplog (Server only) Pass true to disable oplog-tailing on this query. This affects the way server processes calls to `observe` on this query. Disabling the oplog can be useful when working with data that updates in large batches.
                 * @param {Number} options.pollingIntervalMs (Server only) When oplog is disabled (through the use of `disableOplog` or when otherwise not available), the frequency (in milliseconds) of how often to poll this query when observing on the server. Defaults to 10000ms (10 seconds).
                 * @param {Number} options.pollingThrottleMs (Server only) When oplog is disabled (through the use of `disableOplog` or when otherwise not available), the minimum time (in milliseconds) to allow between re-polling when observing on the server. Increasing this will save CPU and mongo load at the expense of slower updates to users. Decreasing this is not recommended. Defaults to 50ms.
                 * @param {Number} options.maxTimeMs (Server only) If set, instructs MongoDB to set a time limit for this cursor's operations. If the operation reaches the specified time limit (in milliseconds) without the having been completed, an exception will be thrown. Useful to prevent an (accidental or malicious) unoptimized query from causing a full collection scan that would disrupt other database users, at the expense of needing to handle the resulting error.
                 * @param {String|Object} options.hint (Server only) Overrides MongoDB's default index selection and query optimization process. Specify an index to force its use, either by its name or index specification. You can also specify `{ $natural : 1 }` to force a forwards collection scan, or `{ $natural : -1 }` for a reverse collection scan. Setting this is only recommended for advanced users.
                 * @param {String} options.readPreference (Server only) Specifies a custom MongoDB [`readPreference`](https://docs.mongodb.com/manual/core/read-preference) for this particular cursor. Possible values are `primary`, `primaryPreferred`, `secondary`, `secondaryPreferred` and `nearest`.
                 * @returns {Mongo.Cursor}
                 */
                find() {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  // Collection.find() (return all docs) behaves differently
                  // from Collection.find(undefined) (return 0 docs).  so be
                  // careful about the length of arguments.
                  return this._collection.find(this._getFindSelector(args), this._getFindOptions(args));
                },

                /**
                 * @summary Finds the first document that matches the selector, as ordered by sort and skip options. Returns `undefined` if no matching document is found.
                 * @locus Anywhere
                 * @method findOne
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {MongoSelector} [selector] A query describing the documents to find
                 * @param {Object} [options]
                 * @param {MongoSortSpecifier} options.sort Sort order (default: natural order)
                 * @param {Number} options.skip Number of results to skip at the beginning
                 * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.
                 * @param {Boolean} options.reactive (Client only) Default true; pass false to disable reactivity
                 * @param {Function} options.transform Overrides `transform` on the [`Collection`](#collections) for this cursor.  Pass `null` to disable transformation.
                 * @param {String} options.readPreference (Server only) Specifies a custom MongoDB [`readPreference`](https://docs.mongodb.com/manual/core/read-preference) for fetching the document. Possible values are `primary`, `primaryPreferred`, `secondary`, `secondaryPreferred` and `nearest`.
                 * @returns {Object}
                 */
                findOne() {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }

                  return this._collection.findOne(this._getFindSelector(args), this._getFindOptions(args));
                }

              });
              Object.assign(Mongo.Collection, {
                _publishCursor(cursor, sub, collection) {
                  var observeHandle = cursor.observeChanges({
                    added: function (id, fields) {
                      sub.added(collection, id, fields);
                    },
                    changed: function (id, fields) {
                      sub.changed(collection, id, fields);
                    },
                    removed: function (id) {
                      sub.removed(collection, id);
                    }
                  }, // Publications don't mutate the documents
                  // This is tested by the `livedata - publish callbacks clone` test
                  {
                    nonMutatingCallbacks: true
                  }); // We don't call sub.ready() here: it gets called in livedata_server, after
                  // possibly calling _publishCursor on multiple returned cursors.
                  // register stop callback (expects lambda w/ no args).

                  sub.onStop(function () {
                    observeHandle.stop();
                  }); // return the observeHandle in case it needs to be stopped early

                  return observeHandle;
                },

                // protect against dangerous selectors.  falsey and {_id: falsey} are both
                // likely programmer error, and not what you want, particularly for destructive
                // operations. If a falsey _id is sent in, a new string _id will be
                // generated and returned; if a fallbackId is provided, it will be returned
                // instead.
                _rewriteSelector(selector) {
                  let {
                    fallbackId
                  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  // shorthand -- scalars match _id
                  if (LocalCollection._selectorIsId(selector)) selector = {
                    _id: selector
                  };

                  if (Array.isArray(selector)) {
                    // This is consistent with the Mongo console itself; if we don't do this
                    // check passing an empty array ends up selecting all items
                    throw new Error("Mongo selector can't be an array.");
                  }

                  if (!selector || '_id' in selector && !selector._id) {
                    // can't match anything
                    return {
                      _id: fallbackId || Random.id()
                    };
                  }

                  return selector;
                }

              });
              Object.assign(Mongo.Collection.prototype, {
                // 'insert' immediately returns the inserted document's new _id.
                // The others return values immediately if you are in a stub, an in-memory
                // unmanaged collection, or a mongo-backed collection and you don't pass a
                // callback. 'update' and 'remove' return the number of affected
                // documents. 'upsert' returns an object with keys 'numberAffected' and, if an
                // insert happened, 'insertedId'.
                //
                // Otherwise, the semantics are exactly like other methods: they take
                // a callback as an optional last argument; if no callback is
                // provided, they block until the operation is complete, and throw an
                // exception if it fails; if a callback is provided, then they don't
                // necessarily block, and they call the callback when they finish with error and
                // result arguments.  (The insert method provides the document ID as its result;
                // update and remove provide the number of affected docs as the result; upsert
                // provides an object with numberAffected and maybe insertedId.)
                //
                // On the client, blocking is impossible, so if a callback
                // isn't provided, they just return immediately and any error
                // information is lost.
                //
                // There's one more tweak. On the client, if you don't provide a
                // callback, then if there is an error, a message will be logged with
                // Meteor._debug.
                //
                // The intent (though this is actually determined by the underlying
                // drivers) is that the operations should be done synchronously, not
                // generating their result until the database has acknowledged
                // them. In the future maybe we should provide a flag to turn this
                // off.

                /**
                 * @summary Insert a document in the collection.  Returns its unique _id.
                 * @locus Anywhere
                 * @method  insert
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {Object} doc The document to insert. May not yet have an _id attribute, in which case Meteor will generate one for you.
                 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the _id as the second.
                 */
                insert(doc, callback) {
                  // Make sure we were passed a document to insert
                  if (!doc) {
                    throw new Error("insert requires an argument");
                  } // Make a shallow clone of the document, preserving its prototype.


                  doc = Object.create(Object.getPrototypeOf(doc), Object.getOwnPropertyDescriptors(doc));

                  if ('_id' in doc) {
                    if (!doc._id || !(typeof doc._id === 'string' || doc._id instanceof Mongo.ObjectID)) {
                      throw new Error("Meteor requires document _id fields to be non-empty strings or ObjectIDs");
                    }
                  } else {
                    let generateId = true; // Don't generate the id if we're the client and the 'outermost' call
                    // This optimization saves us passing both the randomSeed and the id
                    // Passing both is redundant.

                    if (this._isRemoteCollection()) {
                      const enclosing = DDP._CurrentMethodInvocation.get();

                      if (!enclosing) {
                        generateId = false;
                      }
                    }

                    if (generateId) {
                      doc._id = this._makeNewID();
                    }
                  } // On inserts, always return the id that we generated; on all other
                  // operations, just return the result from the collection.


                  var chooseReturnValueFromCollectionResult = function (result) {
                    if (doc._id) {
                      return doc._id;
                    } // XXX what is this for??
                    // It's some iteraction between the callback to _callMutatorMethod and
                    // the return value conversion


                    doc._id = result;
                    return result;
                  };

                  const wrappedCallback = wrapCallback(callback, chooseReturnValueFromCollectionResult);

                  if (this._isRemoteCollection()) {
                    const result = this._callMutatorMethod("insert", [doc], wrappedCallback);

                    return chooseReturnValueFromCollectionResult(result);
                  } // it's my collection.  descend into the collection object
                  // and propagate any exception.


                  try {
                    // If the user provided a callback and the collection implements this
                    // operation asynchronously, then queryRet will be undefined, and the
                    // result will be returned through the callback instead.
                    const result = this._collection.insert(doc, wrappedCallback);

                    return chooseReturnValueFromCollectionResult(result);
                  } catch (e) {
                    if (callback) {
                      callback(e);
                      return null;
                    }

                    throw e;
                  }
                },

                /**
                 * @summary Modify one or more documents in the collection. Returns the number of matched documents.
                 * @locus Anywhere
                 * @method update
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {MongoSelector} selector Specifies which documents to modify
                 * @param {MongoModifier} modifier Specifies how to modify the documents
                 * @param {Object} [options]
                 * @param {Boolean} options.multi True to modify all matching documents; false to only modify one of the matching documents (the default).
                 * @param {Boolean} options.upsert True to insert a document if no matching documents are found.
                 * @param {Array} options.arrayFilters Optional. Used in combination with MongoDB [filtered positional operator](https://docs.mongodb.com/manual/reference/operator/update/positional-filtered/) to specify which elements to modify in an array field.
                 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the number of affected documents as the second.
                 */
                update(selector, modifier) {
                  for (var _len3 = arguments.length, optionsAndCallback = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                    optionsAndCallback[_key3 - 2] = arguments[_key3];
                  }

                  const callback = popCallbackFromArgs(optionsAndCallback); // We've already popped off the callback, so we are left with an array
                  // of one or zero items

                  const options = _objectSpread({}, optionsAndCallback[0] || null);

                  let insertedId;

                  if (options && options.upsert) {
                    // set `insertedId` if absent.  `insertedId` is a Meteor extension.
                    if (options.insertedId) {
                      if (!(typeof options.insertedId === 'string' || options.insertedId instanceof Mongo.ObjectID)) throw new Error("insertedId must be string or ObjectID");
                      insertedId = options.insertedId;
                    } else if (!selector || !selector._id) {
                      insertedId = this._makeNewID();
                      options.generatedId = true;
                      options.insertedId = insertedId;
                    }
                  }

                  selector = Mongo.Collection._rewriteSelector(selector, {
                    fallbackId: insertedId
                  });
                  const wrappedCallback = wrapCallback(callback);

                  if (this._isRemoteCollection()) {
                    const args = [selector, modifier, options];
                    return this._callMutatorMethod("update", args, wrappedCallback);
                  } // it's my collection.  descend into the collection object
                  // and propagate any exception.


                  try {
                    // If the user provided a callback and the collection implements this
                    // operation asynchronously, then queryRet will be undefined, and the
                    // result will be returned through the callback instead.
                    return this._collection.update(selector, modifier, options, wrappedCallback);
                  } catch (e) {
                    if (callback) {
                      callback(e);
                      return null;
                    }

                    throw e;
                  }
                },

                /**
                 * @summary Remove documents from the collection
                 * @locus Anywhere
                 * @method remove
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {MongoSelector} selector Specifies which documents to remove
                 * @param {Function} [callback] Optional.  If present, called with an error object as its argument.
                 */
                remove(selector, callback) {
                  selector = Mongo.Collection._rewriteSelector(selector);
                  const wrappedCallback = wrapCallback(callback);

                  if (this._isRemoteCollection()) {
                    return this._callMutatorMethod("remove", [selector], wrappedCallback);
                  } // it's my collection.  descend into the collection object
                  // and propagate any exception.


                  try {
                    // If the user provided a callback and the collection implements this
                    // operation asynchronously, then queryRet will be undefined, and the
                    // result will be returned through the callback instead.
                    return this._collection.remove(selector, wrappedCallback);
                  } catch (e) {
                    if (callback) {
                      callback(e);
                      return null;
                    }

                    throw e;
                  }
                },

                // Determine if this collection is simply a minimongo representation of a real
                // database on another server
                _isRemoteCollection() {
                  // XXX see #MeteorServerNull
                  return this._connection && this._connection !== Meteor.server;
                },

                /**
                 * @summary Modify one or more documents in the collection, or insert one if no matching documents were found. Returns an object with keys `numberAffected` (the number of documents modified)  and `insertedId` (the unique _id of the document that was inserted, if any).
                 * @locus Anywhere
                 * @method upsert
                 * @memberof Mongo.Collection
                 * @instance
                 * @param {MongoSelector} selector Specifies which documents to modify
                 * @param {MongoModifier} modifier Specifies how to modify the documents
                 * @param {Object} [options]
                 * @param {Boolean} options.multi True to modify all matching documents; false to only modify one of the matching documents (the default).
                 * @param {Function} [callback] Optional.  If present, called with an error object as the first argument and, if no error, the number of affected documents as the second.
                 */
                upsert(selector, modifier, options, callback) {
                  if (!callback && typeof options === "function") {
                    callback = options;
                    options = {};
                  }

                  return this.update(selector, modifier, _objectSpread(_objectSpread({}, options), {}, {
                    _returnObject: true,
                    upsert: true
                  }), callback);
                },

                // We'll actually design an index API later. For now, we just pass through to
                // Mongo's, but make it synchronous.
                _ensureIndex(index, options) {
                  var self = this;
                  if (!self._collection._ensureIndex) throw new Error("Can only call _ensureIndex on server collections");

                  self._collection._ensureIndex(index, options);
                },

                _dropIndex(index) {
                  var self = this;
                  if (!self._collection._dropIndex) throw new Error("Can only call _dropIndex on server collections");

                  self._collection._dropIndex(index);
                },

                _dropCollection() {
                  var self = this;
                  if (!self._collection.dropCollection) throw new Error("Can only call _dropCollection on server collections");

                  self._collection.dropCollection();
                },

                _createCappedCollection(byteSize, maxDocuments) {
                  var self = this;
                  if (!self._collection._createCappedCollection) throw new Error("Can only call _createCappedCollection on server collections");

                  self._collection._createCappedCollection(byteSize, maxDocuments);
                },

                /**
                 * @summary Returns the [`Collection`](http://mongodb.github.io/node-mongodb-native/3.0/api/Collection.html) object corresponding to this collection from the [npm `mongodb` driver module](https://www.npmjs.com/package/mongodb) which is wrapped by `Mongo.Collection`.
                 * @locus Server
                 * @memberof Mongo.Collection
                 * @instance
                 */
                rawCollection() {
                  var self = this;

                  if (!self._collection.rawCollection) {
                    throw new Error("Can only call rawCollection on server collections");
                  }

                  return self._collection.rawCollection();
                },

                /**
                 * @summary Returns the [`Db`](http://mongodb.github.io/node-mongodb-native/3.0/api/Db.html) object corresponding to this collection's database connection from the [npm `mongodb` driver module](https://www.npmjs.com/package/mongodb) which is wrapped by `Mongo.Collection`.
                 * @locus Server
                 * @memberof Mongo.Collection
                 * @instance
                 */
                rawDatabase() {
                  var self = this;

                  if (!(self._driver.mongo && self._driver.mongo.db)) {
                    throw new Error("Can only call rawDatabase on server collections");
                  }

                  return self._driver.mongo.db;
                }

              }); // Convert the callback to not return a result if there is an error

              function wrapCallback(callback, convertResult) {
                return callback && function (error, result) {
                  if (error) {
                    callback(error);
                  } else if (typeof convertResult === "function") {
                    callback(error, convertResult(result));
                  } else {
                    callback(error, result);
                  }
                };
              }
              /**
               * @summary Create a Mongo-style `ObjectID`.  If you don't specify a `hexString`, the `ObjectID` will generated randomly (not using MongoDB's ID construction rules).
               * @locus Anywhere
               * @class
               * @param {String} [hexString] Optional.  The 24-character hexadecimal contents of the ObjectID to create
               */

              Mongo.ObjectID = MongoID.ObjectID;
              /**
               * @summary To create a cursor, use find. To access the documents in a cursor, use forEach, map, or fetch.
               * @class
               * @instanceName cursor
               */

              Mongo.Cursor = LocalCollection.Cursor;
              /**
               * @deprecated in 0.9.1
               */

              Mongo.Collection.Cursor = Mongo.Cursor;
              /**
               * @deprecated in 0.9.1
               */

              Mongo.Collection.ObjectID = Mongo.ObjectID;
              /**
               * @deprecated in 0.9.1
               */

              Meteor.Collection = Mongo.Collection; // Allow deny stuff is now in the allow-deny package

              Object.assign(Meteor.Collection.prototype, AllowDeny.CollectionPrototype);

              function popCallbackFromArgs(args) {
                // Pull off any callback (or perhaps a 'callback' variable that was passed
                // in undefined, like how 'upsert' does it).
                if (args.length && (args[args.length - 1] === undefined || args[args.length - 1] instanceof Function)) {
                  return args.pop();
                }
              }
            }.call(this, _module2);
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require2("/node_modules/meteor/mongo/local_collection_driver.js");
  _require2("/node_modules/meteor/mongo/collection.js");

  /* Exports */
  Package._define("mongo", {
    Mongo: Mongo
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("ddp-rate-limiter");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Random = Package.random.Random;

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////
    //                                                                                  //
    // packages/localstorage/localstorage.js                                            //
    //                                                                                  //
    //////////////////////////////////////////////////////////////////////////////////////
    //
    // Meteor._localStorage is not an ideal name, but we can change it later.

    // Let's test to make sure that localStorage actually works. For example, in
    // Safari with private browsing on, window.localStorage exists but actually
    // trying to use it throws.
    // Accessing window.localStorage can also immediately throw an error in IE (#1291).

    var hasOwn = Object.prototype.hasOwnProperty;
    var key = '_localstorage_test_' + Random.id();
    var retrieved;
    var storage;

    try {
      storage = global.localStorage;

      if (storage) {
        storage.setItem(key, key);
        retrieved = storage.getItem(key);
        storage.removeItem(key);
      }
    } catch (ignored) {}

    if (key === retrieved) {
      if (Meteor.isServer) {
        Meteor._localStorage = storage;
      } else {
        // Some browsers (e.g. IE11) don't properly handle attempts to change
        // window.localStorage methods. By using proxy methods to expose
        // window.localStorage functionality, developers can change the
        // behavior of Meteor._localStorage methods without breaking
        // window.localStorage.
        ["getItem", "setItem", "removeItem"].forEach(function (name) {
          this[name] = function () {
            return storage[name].apply(storage, arguments);
          };
        }, Meteor._localStorage = {});
      }
    }

    if (!Meteor._localStorage) {
      if (Meteor.isClient) {
        Meteor._debug("You are running a browser with no localStorage or userData " + "support. Logging in from one tab will not cause another " + "tab to be logged in.");
      }

      Meteor._localStorage = Object.create({
        setItem: function (key, val) {
          this[key] = val;
        },

        removeItem: function (key) {
          delete this[key];
        },

        getItem: function (key) {
          return hasOwn.call(this, key) ? this[key] : null;
        }
      });
    }

    //////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("localstorage");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;

  /* Package-scope variables */
  var ReactiveVar;

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                              //
    // packages/reactive-var/reactive-var.js                                                                        //
    //                                                                                                              //
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    /*
     * ## [new] ReactiveVar(initialValue, [equalsFunc])
     *
     * A ReactiveVar holds a single value that can be get and set,
     * such that calling `set` will invalidate any Computations that
     * called `get`, according to the usual contract for reactive
     * data sources.
     *
     * A ReactiveVar is much like a Session variable -- compare `foo.get()`
     * to `Session.get("foo")` -- but it doesn't have a global name and isn't
     * automatically migrated across hot code pushes.  Also, while Session
     * variables can only hold JSON or EJSON, ReactiveVars can hold any value.
     *
     * An important property of ReactiveVars, which is sometimes the reason
     * to use one, is that setting the value to the same value as before has
     * no effect, meaning ReactiveVars can be used to absorb extra
     * invalidations that wouldn't serve a purpose.  However, by default,
     * ReactiveVars are extremely conservative about what changes they
     * absorb.  Calling `set` with an object argument will *always* trigger
     * invalidations, because even if the new value is `===` the old value,
     * the object may have been mutated.  You can change the default behavior
     * by passing a function of two arguments, `oldValue` and `newValue`,
     * to the constructor as `equalsFunc`.
     *
     * This class is extremely basic right now, but the idea is to evolve
     * it into the ReactiveVar of Geoff's Lickable Forms proposal.
     */

    /**
     * @class 
     * @instanceName reactiveVar
     * @summary Constructor for a ReactiveVar, which represents a single reactive variable.
     * @locus Client
     * @param {Any} initialValue The initial value to set.  `equalsFunc` is ignored when setting the initial value.
     * @param {Function} [equalsFunc] Optional.  A function of two arguments, called on the old value and the new value whenever the ReactiveVar is set.  If it returns true, no set is performed.  If omitted, the default `equalsFunc` returns true if its arguments are `===` and are of type number, boolean, string, undefined, or null.
     */
    ReactiveVar = function (initialValue, equalsFunc) {
      if (!(this instanceof ReactiveVar))
        // called without `new`
        return new ReactiveVar(initialValue, equalsFunc);

      this.curValue = initialValue;
      this.equalsFunc = equalsFunc;
      this.dep = new Tracker.Dependency();
    };

    ReactiveVar._isEqual = function (oldValue, newValue) {
      var a = oldValue,
          b = newValue;
      // Two values are "equal" here if they are `===` and are
      // number, boolean, string, undefined, or null.
      if (a !== b) return false;else return !a || typeof a === 'number' || typeof a === 'boolean' || typeof a === 'string';
    };

    /**
     * @summary Returns the current value of the ReactiveVar, establishing a reactive dependency.
     * @locus Client
     */
    ReactiveVar.prototype.get = function () {
      if (Tracker.active) this.dep.depend();

      return this.curValue;
    };

    /**
     * @summary Sets the current value of the ReactiveVar, invalidating the Computations that called `get` if `newValue` is different from the old value.
     * @locus Client
     * @param {Any} newValue
     */
    ReactiveVar.prototype.set = function (newValue) {
      var oldValue = this.curValue;

      if ((this.equalsFunc || ReactiveVar._isEqual)(oldValue, newValue))
        // value is same as last time
        return;

      this.curValue = newValue;
      this.dep.changed();
    };

    ReactiveVar.prototype.toString = function () {
      return 'ReactiveVar{' + this.get() + '}';
    };

    ReactiveVar.prototype._numListeners = function () {
      // Tests want to know.
      // Accesses a private field of Tracker.Dependency.
      var count = 0;
      for (var id in this.dep._dependentsById) count++;
      return count;
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("reactive-var", {
    ReactiveVar: ReactiveVar
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;

  /* Package-scope variables */
  var URL, URLSearchParams;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "url": { "modern.js": function _module(_require, _exports) {

            /////////////////////////////////////////////////////////////////////////////////
            //                                                                             //
            // packages/url/modern.js                                                      //
            //                                                                             //
            /////////////////////////////////////////////////////////////////////////////////
            //
            URL = global.URL;
            URLSearchParams = global.URLSearchParams;

            _exports.URL = URL;
            _exports.URLSearchParams = URLSearchParams;

            // backwards compatibility
            Object.assign(URL, _require('./bc/url_client'));

            /////////////////////////////////////////////////////////////////////////////////
          }, "bc": { "url_client.js": function _module2(_require3, _exports3) {

              /////////////////////////////////////////////////////////////////////////////////
              //                                                                             //
              // packages/url/bc/url_client.js                                               //
              //                                                                             //
              /////////////////////////////////////////////////////////////////////////////////
              //
              var common = _require3("./url_common.js");

              _exports3._constructUrl = function (url, query, params) {
                var query_match = /^(.*?)(\?.*)?$/.exec(url);
                return common.buildUrl(query_match[1], query_match[2], query, params);
              };

              _exports3._encodeParams = common._encodeParams;
              /////////////////////////////////////////////////////////////////////////////////
            }, "url_common.js": function _module3(_require4, _exports4) {

              /////////////////////////////////////////////////////////////////////////////////
              //                                                                             //
              // packages/url/bc/url_common.js                                               //
              //                                                                             //
              /////////////////////////////////////////////////////////////////////////////////
              //
              function encodeString(str) {
                return encodeURIComponent(str).replace(/\*/g, '%2A');
              }

              // Encode URL parameters into a query string, handling nested objects and
              // arrays properly.
              var _encodeParams = function (params, prefix) {
                var str = [];
                var isParamsArray = Array.isArray(params);
                for (var p in params) {
                  if (Object.prototype.hasOwnProperty.call(params, p)) {
                    var k = prefix ? prefix + '[' + (isParamsArray ? '' : p) + ']' : p;
                    var v = params[p];
                    if (typeof v === 'object') {
                      str.push(_encodeParams(v, k));
                    } else {
                      var encodedKey = encodeString(k).replace('%5B', '[').replace('%5D', ']');
                      str.push(encodedKey + '=' + encodeString(v));
                    }
                  }
                }
                return str.join('&').replace(/%20/g, '+');
              };

              _exports4._encodeParams = _encodeParams;

              _exports4.buildUrl = function (before_qmark, from_qmark, opt_query, opt_params) {
                var url_without_query = before_qmark;
                var query = from_qmark ? from_qmark.slice(1) : null;

                if (typeof opt_query === "string") query = String(opt_query);

                if (opt_params) {
                  query = query || "";
                  var prms = _encodeParams(opt_params);
                  if (query && prms) query += '&';
                  query += prms;
                }

                var url = url_without_query;
                if (query !== null) url += "?" + query;

                return url;
              };

              /////////////////////////////////////////////////////////////////////////////////
            } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/url/modern.js");

  /* Exports */
  Package._define("url", _exports2, {
    URL: URL,
    URLSearchParams: URLSearchParams
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var Random = Package.random.Random;
  var Hook = Package['callback-hook'].Hook;
  var ReactiveVar = Package['reactive-var'].ReactiveVar;
  var URL = Package.url.URL;
  var URLSearchParams = Package.url.URLSearchParams;
  var DDP = Package['ddp-client'].DDP;
  var Mongo = Package.mongo.Mongo;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Accounts, options, tokenExpires;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "accounts-base": { "client_main.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/accounts-base/client_main.js                                                                              //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Accounts: () => Accounts,
              AccountsClient: () => AccountsClient,
              AccountsTest: () => AccountsTest,
              default: () => _exports
            });
            let AccountsClient, AccountsTest;
            _module.link("./accounts_client.js", {
              AccountsClient(v) {
                AccountsClient = v;
              },

              AccountsTest(v) {
                AccountsTest = v;
              }

            }, 0);

            /**
             * @namespace Accounts
             * @summary The namespace for all client-side accounts-related methods.
             */
            _module.runSetters(Accounts = new AccountsClient());
            /**
             * @summary A [Mongo.Collection](#collections) containing user documents.
             * @locus Anywhere
             * @type {Mongo.Collection}
             * @importFromPackage meteor
             */

            Meteor.users = Accounts.users;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "accounts_client.js": function module(_require3, _exports3, _module2) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/accounts-base/accounts_client.js                                                                          //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module2.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module2.export({
              AccountsClient: () => AccountsClient,
              AccountsTest: () => AccountsTest
            });
            let AccountsCommon;
            _module2.link("./accounts_common.js", {
              AccountsCommon(v) {
                AccountsCommon = v;
              }

            }, 0);

            class AccountsClient extends AccountsCommon {
              constructor(options) {
                super(options);
                this._loggingIn = new ReactiveVar(false);
                this._loggingOut = new ReactiveVar(false);
                this._loginServicesHandle = this.connection.subscribe("meteor.loginServiceConfiguration");
                this._pageLoadLoginCallbacks = [];
                this._pageLoadLoginAttemptInfo = null;
                this.savedHash = window.location.hash;

                this._initUrlMatching(); // Defined in localstorage_token.js.


                this._initLocalStorage(); // This is for .registerClientLoginFunction & .callLoginFunction.


                this._loginFuncs = {};
              } ///
              /// CURRENT USER
              ///
              // @override


              userId() {
                return this.connection.userId();
              } // This is mostly just called within this file, but Meteor.loginWithPassword
              // also uses it to make loggingIn() be true during the beginPasswordExchange
              // method call too.


              _setLoggingIn(x) {
                this._loggingIn.set(x);
              }
              /**
               * @summary True if a login method (such as `Meteor.loginWithPassword`, `Meteor.loginWithFacebook`, or `Accounts.createUser`) is currently in progress. A reactive data source.
               * @locus Client
               */

              loggingIn() {
                return this._loggingIn.get();
              }
              /**
               * @summary True if a logout method (such as `Meteor.logout`) is currently in progress. A reactive data source.
               * @locus Client
               */

              loggingOut() {
                return this._loggingOut.get();
              }
              /**
               * @summary Register a new login function on the client. Intended for OAuth package authors. You can call the login function by using
               `Accounts.callLoginFunction` or `Accounts.callLoginFunction`.
               * @locus Client
               * @param {String} funcName The name of your login function. Used by `Accounts.callLoginFunction` and `Accounts.applyLoginFunction`.
               Should be the OAuth provider name accordingly.
               * @param {Function} func The actual function you want to call. Just write it in the manner of `loginWithFoo`.
               */

              registerClientLoginFunction(funcName, func) {
                if (this._loginFuncs[funcName]) {
                  throw new Error("".concat(funcName, " has been defined already"));
                }

                this._loginFuncs[funcName] = func;
              }
              /**
               * @summary Call a login function defined using `Accounts.registerClientLoginFunction`. Excluding the first argument, all remaining
               arguments are passed to the login function accordingly. Use `applyLoginFunction` if you want to pass in an arguments array that contains
               all arguments for the login function.
               * @locus Client
               * @param {String} funcName The name of the login function you wanted to call.
               */

              callLoginFunction(funcName) {
                if (!this._loginFuncs[funcName]) {
                  throw new Error("".concat(funcName, " was not defined"));
                }

                for (var _len = arguments.length, funcArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  funcArgs[_key - 1] = arguments[_key];
                }

                return this._loginFuncs[funcName].apply(this, funcArgs);
              }
              /**
               * @summary Same as ``callLoginFunction` but accept an `arguments` which contains all arguments for the login
               function.
               * @locus Client
               * @param {String} funcName The name of the login function you wanted to call.
               * @param {Array} funcArgs The `arguments` for the login function.
               */

              applyLoginFunction(funcName, funcArgs) {
                if (!this._loginFuncs[funcName]) {
                  throw new Error("".concat(funcName, " was not defined"));
                }

                return this._loginFuncs[funcName].apply(this, funcArgs);
              }
              /**
               * @summary Log the user out.
               * @locus Client
               * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
               */

              logout(callback) {
                this._loggingOut.set(true);

                this.connection.apply('logout', [], {
                  wait: true
                }, (error, result) => {
                  this._loggingOut.set(false);

                  if (error) {
                    callback && callback(error);
                  } else {
                    this.makeClientLoggedOut();
                    callback && callback();
                  }
                });
              }
              /**
               * @summary Log out other clients logged in as the current user, but does not log out the client that calls this function.
               * @locus Client
               * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
               */

              logoutOtherClients(callback) {
                // We need to make two method calls: one to replace our current token,
                // and another to remove all tokens except the current one. We want to
                // call these two methods one after the other, without any other
                // methods running between them. For example, we don't want `logout`
                // to be called in between our two method calls (otherwise the second
                // method call would return an error). Another example: we don't want
                // logout to be called before the callback for `getNewToken`;
                // otherwise we would momentarily log the user out and then write a
                // new token to localStorage.
                //
                // To accomplish this, we make both calls as wait methods, and queue
                // them one after the other, without spinning off the event loop in
                // between. Even though we queue `removeOtherTokens` before
                // `getNewToken`, we won't actually send the `removeOtherTokens` call
                // until the `getNewToken` callback has finished running, because they
                // are both wait methods.
                this.connection.apply('getNewToken', [], {
                  wait: true
                }, (err, result) => {
                  if (!err) {
                    this._storeLoginToken(this.userId(), result.token, result.tokenExpires);
                  }
                });
                this.connection.apply('removeOtherTokens', [], {
                  wait: true
                }, err => callback && callback(err));
              } ///
              /// LOGIN METHODS
              ///
              // Call a login method on the server.
              //
              // A login method is a method which on success calls `this.setUserId(id)` and
              // `Accounts._setLoginToken` on the server and returns an object with fields
              // 'id' (containing the user id), 'token' (containing a resume token), and
              // optionally `tokenExpires`.
              //
              // This function takes care of:
              //   - Updating the Meteor.loggingIn() reactive data source
              //   - Calling the method in 'wait' mode
              //   - On success, saving the resume token to localStorage
              //   - On success, calling Accounts.connection.setUserId()
              //   - Setting up an onReconnect handler which logs in with
              //     the resume token
              //
              // Options:
              // - methodName: The method to call (default 'login')
              // - methodArguments: The arguments for the method
              // - validateResult: If provided, will be called with the result of the
              //                 method. If it throws, the client will not be logged in (and
              //                 its error will be passed to the callback).
              // - userCallback: Will be called with no arguments once the user is fully
              //                 logged in, or with the error on error.
              //


              callLoginMethod(options) {
                options = _objectSpread({
                  methodName: 'login',
                  methodArguments: [{}],
                  _suppressLoggingIn: false
                }, options); // Set defaults for callback arguments to no-op functions; make sure we
                // override falsey values too.

                ['validateResult', 'userCallback'].forEach(f => {
                  if (!options[f]) options[f] = () => null;
                }); // Prepare callbacks: user provided and onLogin/onLoginFailure hooks.

                let called;

                const loginCallbacks = _ref => {
                  let {
                    error,
                    loginDetails
                  } = _ref;

                  if (!called) {
                    called = true;

                    if (!error) {
                      this._onLoginHook.each(callback => {
                        callback(loginDetails);
                        return true;
                      });
                    } else {
                      this._onLoginFailureHook.each(callback => {
                        callback({
                          error
                        });
                        return true;
                      });
                    }

                    options.userCallback(error, loginDetails);
                  }
                };

                let reconnected = false; // We want to set up onReconnect as soon as we get a result token back from
                // the server, without having to wait for subscriptions to rerun. This is
                // because if we disconnect and reconnect between getting the result and
                // getting the results of subscription rerun, we WILL NOT re-send this
                // method (because we never re-send methods whose results we've received)
                // but we WILL call loggedInAndDataReadyCallback at "reconnect quiesce"
                // time. This will lead to makeClientLoggedIn(result.id) even though we
                // haven't actually sent a login method!
                //
                // But by making sure that we send this "resume" login in that case (and
                // calling makeClientLoggedOut if it fails), we'll end up with an accurate
                // client-side userId. (It's important that livedata_connection guarantees
                // that the "reconnect quiesce"-time call to loggedInAndDataReadyCallback
                // will occur before the callback from the resume login call.)

                const onResultReceived = (err, result) => {
                  if (err || !result || !result.token) {// Leave onReconnect alone if there was an error, so that if the user was
                    // already logged in they will still get logged in on reconnect.
                    // See issue #4970.
                  } else {
                    // First clear out any previously set Acccounts login onReconnect
                    // callback (to make sure we don't keep piling up duplicate callbacks,
                    // which would then all be triggered when reconnecting).
                    if (this._reconnectStopper) {
                      this._reconnectStopper.stop();
                    }

                    this._reconnectStopper = DDP.onReconnect(conn => {
                      if (conn != this.connection) {
                        return;
                      }

                      reconnected = true; // If our token was updated in storage, use the latest one.

                      const storedToken = this._storedLoginToken();

                      if (storedToken) {
                        result = {
                          token: storedToken,
                          tokenExpires: this._storedLoginTokenExpires()
                        };
                      }

                      if (!result.tokenExpires) result.tokenExpires = this._tokenExpiration(new Date());

                      if (this._tokenExpiresSoon(result.tokenExpires)) {
                        this.makeClientLoggedOut();
                      } else {
                        this.callLoginMethod({
                          methodArguments: [{
                            resume: result.token
                          }],
                          // Reconnect quiescence ensures that the user doesn't see an
                          // intermediate state before the login method finishes. So we don't
                          // need to show a logging-in animation.
                          _suppressLoggingIn: true,
                          userCallback: (error, loginDetails) => {
                            const storedTokenNow = this._storedLoginToken();

                            if (error) {
                              // If we had a login error AND the current stored token is the
                              // one that we tried to log in with, then declare ourselves
                              // logged out. If there's a token in storage but it's not the
                              // token that we tried to log in with, we don't know anything
                              // about whether that token is valid or not, so do nothing. The
                              // periodic localStorage poll will decide if we are logged in or
                              // out with this token, if it hasn't already. Of course, even
                              // with this check, another tab could insert a new valid token
                              // immediately before we clear localStorage here, which would
                              // lead to both tabs being logged out, but by checking the token
                              // in storage right now we hope to make that unlikely to happen.
                              //
                              // If there is no token in storage right now, we don't have to
                              // do anything; whatever code removed the token from storage was
                              // responsible for calling `makeClientLoggedOut()`, or the
                              // periodic localStorage poll will call `makeClientLoggedOut`
                              // eventually if another tab wiped the token from storage.
                              if (storedTokenNow && storedTokenNow === result.token) {
                                this.makeClientLoggedOut();
                              }
                            } // Possibly a weird callback to call, but better than nothing if
                            // there is a reconnect between "login result received" and "data
                            // ready".


                            loginCallbacks({
                              error,
                              loginDetails
                            });
                          }
                        });
                      }
                    });
                  }
                }; // This callback is called once the local cache of the current-user
                // subscription (and all subscriptions, in fact) are guaranteed to be up to
                // date.


                const loggedInAndDataReadyCallback = (error, result) => {
                  // If the login method returns its result but the connection is lost
                  // before the data is in the local cache, it'll set an onReconnect (see
                  // above). The onReconnect will try to log in using the token, and *it*
                  // will call userCallback via its own version of this
                  // loggedInAndDataReadyCallback. So we don't have to do anything here.
                  if (reconnected) return; // Note that we need to call this even if _suppressLoggingIn is true,
                  // because it could be matching a _setLoggingIn(true) from a
                  // half-completed pre-reconnect login method.

                  this._setLoggingIn(false);

                  if (error || !result) {
                    error = error || new Error("No result from call to ".concat(options.methodName));
                    loginCallbacks({
                      error
                    });
                    return;
                  }

                  try {
                    options.validateResult(result);
                  } catch (e) {
                    loginCallbacks({
                      error: e
                    });
                    return;
                  } // Make the client logged in. (The user data should already be loaded!)


                  this.makeClientLoggedIn(result.id, result.token, result.tokenExpires);
                  loginCallbacks({
                    loginDetails: {
                      type: result.type
                    }
                  });
                };

                if (!options._suppressLoggingIn) {
                  this._setLoggingIn(true);
                }

                this.connection.apply(options.methodName, options.methodArguments, {
                  wait: true,
                  onResultReceived: onResultReceived
                }, loggedInAndDataReadyCallback);
              }

              makeClientLoggedOut() {
                // Ensure client was successfully logged in before running logout hooks.
                if (this.connection._userId) {
                  this._onLogoutHook.each(callback => {
                    callback();
                    return true;
                  });
                }

                this._unstoreLoginToken();

                this.connection.setUserId(null);
                this._reconnectStopper && this._reconnectStopper.stop();
              }

              makeClientLoggedIn(userId, token, tokenExpires) {
                this._storeLoginToken(userId, token, tokenExpires);

                this.connection.setUserId(userId);
              } ///
              /// LOGIN SERVICES
              ///
              // A reactive function returning whether the loginServiceConfiguration
              // subscription is ready. Used by accounts-ui to hide the login button
              // until we have all the configuration loaded
              //


              loginServicesConfigured() {
                return this._loginServicesHandle.ready();
              }

              // Some login services such as the redirect login flow or the resume
              // login handler can log the user in at page load time.  The
              // Meteor.loginWithX functions have a callback argument, but the
              // callback function instance won't be in memory any longer if the
              // page was reloaded.  The `onPageLoadLogin` function allows a
              // callback to be registered for the case where the login was
              // initiated in a previous VM, and we now have the result of the login
              // attempt in a new VM.
              // Register a callback to be called if we have information about a
              // login attempt at page load time.  Call the callback immediately if
              // we already have the page load login attempt info, otherwise stash
              // the callback to be called if and when we do get the attempt info.
              //
              onPageLoadLogin(f) {
                if (this._pageLoadLoginAttemptInfo) {
                  f(this._pageLoadLoginAttemptInfo);
                } else {
                  this._pageLoadLoginCallbacks.push(f);
                }
              }

              // Receive the information about the login attempt at page load time.
              // Call registered callbacks, and also record the info in case
              // someone's callback hasn't been registered yet.
              //
              _pageLoadLogin(attemptInfo) {
                if (this._pageLoadLoginAttemptInfo) {
                  Meteor._debug('Ignoring unexpected duplicate page load login attempt info');

                  return;
                }

                this._pageLoadLoginCallbacks.forEach(callback => callback(attemptInfo));

                this._pageLoadLoginCallbacks = [];
                this._pageLoadLoginAttemptInfo = attemptInfo;
              } // _startupCallback executes on onLogin callbacks
              // at registration time if already logged in
              // this can happen when new AccountsClient is created
              // before callbacks are registered see #10157


              _startupCallback(callback) {
                // Are we already logged in?
                if (this.connection._userId) {
                  // If already logged in before handler is registered, it's safe to
                  // assume type is a 'resume', so we execute the callback at the end
                  // of the queue so that Meteor.startup can complete before any
                  // embedded onLogin callbacks would execute.
                  Meteor.setTimeout(() => callback({
                    type: 'resume'
                  }), 0);
                }
              } ///
              /// LOGIN TOKENS
              ///
              // These methods deal with storing a login token and user id in the
              // browser's localStorage facility. It polls local storage every few
              // seconds to synchronize login state between multiple tabs in the same
              // browser.


              loginWithToken(token, callback) {
                this.callLoginMethod({
                  methodArguments: [{
                    resume: token
                  }],
                  userCallback: callback
                });
              }

              // Semi-internal API. Call this function to re-enable auto login after
              // if it was disabled at startup.
              _enableAutoLogin() {
                this._autoLoginEnabled = true;

                this._pollStoredLoginToken();
              }

              ///
              /// STORING
              ///
              // Call this from the top level of the test file for any test that does
              // logging in and out, to protect multiple tabs running the same tests
              // simultaneously from interfering with each others' localStorage.
              _isolateLoginTokenForTest() {
                this.LOGIN_TOKEN_KEY = this.LOGIN_TOKEN_KEY + Random.id();
                this.USER_ID_KEY = this.USER_ID_KEY + Random.id();
              }

              _storeLoginToken(userId, token, tokenExpires) {
                Meteor._localStorage.setItem(this.USER_ID_KEY, userId);

                Meteor._localStorage.setItem(this.LOGIN_TOKEN_KEY, token);

                if (!tokenExpires) tokenExpires = this._tokenExpiration(new Date());

                Meteor._localStorage.setItem(this.LOGIN_TOKEN_EXPIRES_KEY, tokenExpires); // to ensure that the localstorage poller doesn't end up trying to
                // connect a second time


                this._lastLoginTokenWhenPolled = token;
              }

              _unstoreLoginToken() {
                Meteor._localStorage.removeItem(this.USER_ID_KEY);

                Meteor._localStorage.removeItem(this.LOGIN_TOKEN_KEY);

                Meteor._localStorage.removeItem(this.LOGIN_TOKEN_EXPIRES_KEY); // to ensure that the localstorage poller doesn't end up trying to
                // connect a second time


                this._lastLoginTokenWhenPolled = null;
              }

              // This is private, but it is exported for now because it is used by a
              // test in accounts-password.
              _storedLoginToken() {
                return Meteor._localStorage.getItem(this.LOGIN_TOKEN_KEY);
              }

              _storedLoginTokenExpires() {
                return Meteor._localStorage.getItem(this.LOGIN_TOKEN_EXPIRES_KEY);
              }

              _storedUserId() {
                return Meteor._localStorage.getItem(this.USER_ID_KEY);
              }

              _unstoreLoginTokenIfExpiresSoon() {
                const tokenExpires = this._storedLoginTokenExpires();

                if (tokenExpires && this._tokenExpiresSoon(new Date(tokenExpires))) {
                  this._unstoreLoginToken();
                }
              }

              ///
              /// AUTO-LOGIN
              ///
              _initLocalStorage() {
                // Key names to use in localStorage
                this.LOGIN_TOKEN_KEY = "Meteor.loginToken";
                this.LOGIN_TOKEN_EXPIRES_KEY = "Meteor.loginTokenExpires";
                this.USER_ID_KEY = "Meteor.userId";
                const rootUrlPathPrefix = __meteor_runtime_config__.ROOT_URL_PATH_PREFIX;

                if (rootUrlPathPrefix || this.connection !== Meteor.connection) {
                  // We want to keep using the same keys for existing apps that do not
                  // set a custom ROOT_URL_PATH_PREFIX, so that most users will not have
                  // to log in again after an app updates to a version of Meteor that
                  // contains this code, but it's generally preferable to namespace the
                  // keys so that connections from distinct apps to distinct DDP URLs
                  // will be distinct in Meteor._localStorage.
                  let namespace = ":".concat(this.connection._stream.rawUrl);

                  if (rootUrlPathPrefix) {
                    namespace += ":".concat(rootUrlPathPrefix);
                  }

                  this.LOGIN_TOKEN_KEY += namespace;
                  this.LOGIN_TOKEN_EXPIRES_KEY += namespace;
                  this.USER_ID_KEY += namespace;
                }

                let token;

                if (this._autoLoginEnabled) {
                  // Immediately try to log in via local storage, so that any DDP
                  // messages are sent after we have established our user account
                  this._unstoreLoginTokenIfExpiresSoon();

                  token = this._storedLoginToken();

                  if (token) {
                    // On startup, optimistically present us as logged in while the
                    // request is in flight. This reduces page flicker on startup.
                    const userId = this._storedUserId();

                    userId && this.connection.setUserId(userId);
                    this.loginWithToken(token, err => {
                      if (err) {
                        Meteor._debug("Error logging in with token: ".concat(err));

                        this.makeClientLoggedOut();
                      }

                      this._pageLoadLogin({
                        type: "resume",
                        allowed: !err,
                        error: err,
                        methodName: "login",
                        // XXX This is duplicate code with loginWithToken, but
                        // loginWithToken can also be called at other times besides
                        // page load.
                        methodArguments: [{
                          resume: token
                        }]
                      });
                    });
                  }
                } // Poll local storage every 3 seconds to login if someone logged in in
                // another tab


                this._lastLoginTokenWhenPolled = token;

                if (this._pollIntervalTimer) {
                  // Unlikely that _initLocalStorage will be called more than once for
                  // the same AccountsClient instance, but just in case...
                  clearInterval(this._pollIntervalTimer);
                }

                this._pollIntervalTimer = setInterval(() => {
                  this._pollStoredLoginToken();
                }, 3000);
              }

              _pollStoredLoginToken() {
                if (!this._autoLoginEnabled) {
                  return;
                }

                const currentLoginToken = this._storedLoginToken(); // != instead of !== just to make sure undefined and null are treated the same


                if (this._lastLoginTokenWhenPolled != currentLoginToken) {
                  if (currentLoginToken) {
                    this.loginWithToken(currentLoginToken, err => {
                      if (err) {
                        this.makeClientLoggedOut();
                      }
                    });
                  } else {
                    this.logout();
                  }
                }

                this._lastLoginTokenWhenPolled = currentLoginToken;
              }

              ///
              /// URLS
              ///
              _initUrlMatching() {
                // By default, allow the autologin process to happen.
                this._autoLoginEnabled = true; // We only support one callback per URL.

                this._accountsCallbacks = {}; // Try to match the saved value of window.location.hash.

                this._attemptToMatchHash();
              }

              // Separate out this functionality for testing
              _attemptToMatchHash() {
                attemptToMatchHash(this, this.savedHash, defaultSuccessHandler);
              }

              /**
               * @summary Register a function to call when a reset password link is clicked
               * in an email sent by
               * [`Accounts.sendResetPasswordEmail`](#accounts_sendresetpasswordemail).
               * This function should be called in top-level code, not inside
               * `Meteor.startup()`.
               * @memberof! Accounts
               * @name onResetPasswordLink
               * @param  {Function} callback The function to call. It is given two arguments:
               *
               * 1. `token`: A password reset token that can be passed to
               * [`Accounts.resetPassword`](#accounts_resetpassword).
               * 2. `done`: A function to call when the password reset UI flow is complete. The normal
               * login process is suspended until this function is called, so that the
               * password for user A can be reset even if user B was logged in.
               * @locus Client
               */
              onResetPasswordLink(callback) {
                if (this._accountsCallbacks["reset-password"]) {
                  Meteor._debug("Accounts.onResetPasswordLink was called more than once. " + "Only one callback added will be executed.");
                }

                this._accountsCallbacks["reset-password"] = callback;
              }

              /**
               * @summary Register a function to call when an email verification link is
               * clicked in an email sent by
               * [`Accounts.sendVerificationEmail`](#accounts_sendverificationemail).
               * This function should be called in top-level code, not inside
               * `Meteor.startup()`.
               * @memberof! Accounts
               * @name onEmailVerificationLink
               * @param  {Function} callback The function to call. It is given two arguments:
               *
               * 1. `token`: An email verification token that can be passed to
               * [`Accounts.verifyEmail`](#accounts_verifyemail).
               * 2. `done`: A function to call when the email verification UI flow is complete.
               * The normal login process is suspended until this function is called, so
               * that the user can be notified that they are verifying their email before
               * being logged in.
               * @locus Client
               */
              onEmailVerificationLink(callback) {
                if (this._accountsCallbacks["verify-email"]) {
                  Meteor._debug("Accounts.onEmailVerificationLink was called more than once. " + "Only one callback added will be executed.");
                }

                this._accountsCallbacks["verify-email"] = callback;
              }

              /**
               * @summary Register a function to call when an account enrollment link is
               * clicked in an email sent by
               * [`Accounts.sendEnrollmentEmail`](#accounts_sendenrollmentemail).
               * This function should be called in top-level code, not inside
               * `Meteor.startup()`.
               * @memberof! Accounts
               * @name onEnrollmentLink
               * @param  {Function} callback The function to call. It is given two arguments:
               *
               * 1. `token`: A password reset token that can be passed to
               * [`Accounts.resetPassword`](#accounts_resetpassword) to give the newly
               * enrolled account a password.
               * 2. `done`: A function to call when the enrollment UI flow is complete.
               * The normal login process is suspended until this function is called, so that
               * user A can be enrolled even if user B was logged in.
               * @locus Client
               */
              onEnrollmentLink(callback) {
                if (this._accountsCallbacks["enroll-account"]) {
                  Meteor._debug("Accounts.onEnrollmentLink was called more than once. " + "Only one callback added will be executed.");
                }

                this._accountsCallbacks["enroll-account"] = callback;
              }

            }

            ;
            /**
             * @summary True if a login method (such as `Meteor.loginWithPassword`, 
             * `Meteor.loginWithFacebook`, or `Accounts.createUser`) is currently in 
             * progress. A reactive data source.
             * @locus Client
             * @importFromPackage meteor
             */

            Meteor.loggingIn = () => Accounts.loggingIn();
            /**
             * @summary True if a logout method (such as `Meteor.logout`) is currently in 
             * progress. A reactive data source.
             * @locus Client
             * @importFromPackage meteor
             */

            Meteor.loggingOut = () => Accounts.loggingOut();
            /**
             * @summary Log the user out.
             * @locus Client
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage meteor
             */

            Meteor.logout = callback => Accounts.logout(callback);
            /**
             * @summary Log out other clients logged in as the current user, but does not log out the client that calls this function.
             * @locus Client
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage meteor
             */

            Meteor.logoutOtherClients = callback => Accounts.logoutOtherClients(callback);
            /**
             * @summary Login with a Meteor access token.
             * @locus Client
             * @param {Object} [token] Local storage token for use with login across 
             * multiple tabs in the same browser.
             * @param {Function} [callback] Optional callback. Called with no arguments on
             * success.
             * @importFromPackage meteor
             */

            Meteor.loginWithToken = (token, callback) => Accounts.loginWithToken(token, callback); ///
            /// HANDLEBARS HELPERS
            ///
            // If our app has a Blaze, register the {{currentUser}} and {{loggingIn}}
            // global helpers.


            if (Package.blaze) {
              const {
                Template
              } = Package.blaze.Blaze;
              /**
               * @global
               * @name  currentUser
               * @isHelper true
               * @summary Calls [Meteor.user()](#meteor_user). Use `{{#if currentUser}}` to check whether the user is logged in.
               */

              Template.registerHelper('currentUser', () => Meteor.user());
              /**
               * @global
               * @name  loggingIn
               * @isHelper true
               * @summary Calls [Meteor.loggingIn()](#meteor_loggingin).
               */

              Template.registerHelper('loggingIn', () => Meteor.loggingIn());
              /**
               * @global
               * @name  loggingOut
               * @isHelper true
               * @summary Calls [Meteor.loggingOut()](#meteor_loggingout).
               */

              Template.registerHelper('loggingOut', () => Meteor.loggingOut());
              /**
               * @global
               * @name  loggingInOrOut
               * @isHelper true
               * @summary Calls [Meteor.loggingIn()](#meteor_loggingin) or [Meteor.loggingOut()](#meteor_loggingout).
               */

              Template.registerHelper('loggingInOrOut', () => Meteor.loggingIn() || Meteor.loggingOut());
            }

            const defaultSuccessHandler = function (token, urlPart) {
              // put login in a suspended state to wait for the interaction to finish
              this._autoLoginEnabled = false; // wait for other packages to register callbacks

              Meteor.startup(() => {
                // if a callback has been registered for this kind of token, call it
                if (this._accountsCallbacks[urlPart]) {
                  this._accountsCallbacks[urlPart](token, () => this._enableAutoLogin());
                }
              });
            }; // Note that both arguments are optional and are currently only passed by
            // accounts_url_tests.js.


            const attemptToMatchHash = (accounts, hash, success) => {
              // All of the special hash URLs we support for accounts interactions
              ["reset-password", "verify-email", "enroll-account"].forEach(urlPart => {
                let token;
                const tokenRegex = new RegExp("^\\#\\/".concat(urlPart, "\\/(.*)$"));
                const match = hash.match(tokenRegex);

                if (match) {
                  token = match[1]; // XXX COMPAT WITH 0.9.3

                  if (urlPart === "reset-password") {
                    accounts._resetPasswordToken = token;
                  } else if (urlPart === "verify-email") {
                    accounts._verifyEmailToken = token;
                  } else if (urlPart === "enroll-account") {
                    accounts._enrollAccountToken = token;
                  }
                } else {
                  return;
                } // If no handlers match the hash, then maybe it's meant to be consumed
                // by some entirely different code, so we only clear it the first time
                // a handler successfully matches. Note that later handlers reuse the
                // savedHash, so clearing window.location.hash here will not interfere
                // with their needs.


                window.location.hash = ""; // Do some stuff with the token we matched

                success.call(accounts, token, urlPart);
              });
            }; // Export for testing


            const AccountsTest = {
              attemptToMatchHash: (hash, success) => attemptToMatchHash(Accounts, hash, success)
            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "accounts_common.js": function module(_require4, _exports4, _module3) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/accounts-base/accounts_common.js                                                                          //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module3.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module3.export({
              AccountsCommon: () => AccountsCommon,
              EXPIRE_TOKENS_INTERVAL_MS: () => EXPIRE_TOKENS_INTERVAL_MS,
              CONNECTION_CLOSE_DELAY_MS: () => CONNECTION_CLOSE_DELAY_MS
            });

            class AccountsCommon {
              constructor(options) {
                // Currently this is read directly by packages like accounts-password
                // and accounts-ui-unstyled.
                this._options = {}; // Note that setting this.connection = null causes this.users to be a
                // LocalCollection, which is not what we want.

                this.connection = undefined;

                this._initConnection(options || {}); // There is an allow call in accounts_server.js that restricts writes to
                // this collection.


                this.users = new Mongo.Collection("users", {
                  _preventAutopublish: true,
                  connection: this.connection
                }); // Callback exceptions are printed with Meteor._debug and ignored.

                this._onLoginHook = new Hook({
                  bindEnvironment: false,
                  debugPrintExceptions: "onLogin callback"
                });
                this._onLoginFailureHook = new Hook({
                  bindEnvironment: false,
                  debugPrintExceptions: "onLoginFailure callback"
                });
                this._onLogoutHook = new Hook({
                  bindEnvironment: false,
                  debugPrintExceptions: "onLogout callback"
                }); // Expose for testing.

                this.DEFAULT_LOGIN_EXPIRATION_DAYS = DEFAULT_LOGIN_EXPIRATION_DAYS;
                this.LOGIN_UNEXPIRING_TOKEN_DAYS = LOGIN_UNEXPIRING_TOKEN_DAYS; // Thrown when the user cancels the login process (eg, closes an oauth
                // popup, declines retina scan, etc)

                const lceName = 'Accounts.LoginCancelledError';
                this.LoginCancelledError = Meteor.makeErrorType(lceName, function (description) {
                  this.message = description;
                });
                this.LoginCancelledError.prototype.name = lceName; // This is used to transmit specific subclass errors over the wire. We
                // should come up with a more generic way to do this (eg, with some sort of
                // symbolic error code rather than a number).

                this.LoginCancelledError.numericError = 0x8acdc2f; // loginServiceConfiguration and ConfigError are maintained for backwards compatibility

                Meteor.startup(() => {
                  const {
                    ServiceConfiguration
                  } = Package['service-configuration'];
                  this.loginServiceConfiguration = ServiceConfiguration.configurations;
                  this.ConfigError = ServiceConfiguration.ConfigError;
                });
              }
              /**
               * @summary Get the current user id, or `null` if no user is logged in. A reactive data source.
               * @locus Anywhere
               */

              userId() {
                throw new Error("userId method not implemented");
              } // merge the defaultFieldSelector with an existing options object


              _addDefaultFieldSelector() {
                let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                // this will be the most common case for most people, so make it quick
                if (!this._options.defaultFieldSelector) return options; // if no field selector then just use defaultFieldSelector

                if (!options.fields) return _objectSpread(_objectSpread({}, options), {}, {
                  fields: this._options.defaultFieldSelector
                }); // if empty field selector then the full user object is explicitly requested, so obey

                const keys = Object.keys(options.fields);
                if (!keys.length) return options; // if the requested fields are +ve then ignore defaultFieldSelector
                // assume they are all either +ve or -ve because Mongo doesn't like mixed

                if (!!options.fields[keys[0]]) return options; // The requested fields are -ve.
                // If the defaultFieldSelector is +ve then use requested fields, otherwise merge them

                const keys2 = Object.keys(this._options.defaultFieldSelector);
                return this._options.defaultFieldSelector[keys2[0]] ? options : _objectSpread(_objectSpread({}, options), {}, {
                  fields: _objectSpread(_objectSpread({}, options.fields), this._options.defaultFieldSelector)
                });
              }
              /**
               * @summary Get the current user record, or `null` if no user is logged in. A reactive data source.
               * @locus Anywhere
               * @param {Object} [options]
               * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.
               */

              user(options) {
                const userId = this.userId();
                return userId ? this.users.findOne(userId, this._addDefaultFieldSelector(options)) : null;
              } // Set up config for the accounts system. Call this on both the client
              // and the server.
              //
              // Note that this method gets overridden on AccountsServer.prototype, but
              // the overriding method calls the overridden method.
              //
              // XXX we should add some enforcement that this is called on both the
              // client and the server. Otherwise, a user can
              // 'forbidClientAccountCreation' only on the client and while it looks
              // like their app is secure, the server will still accept createUser
              // calls. https://github.com/meteor/meteor/issues/828
              //
              // @param options {Object} an object with fields:
              // - sendVerificationEmail {Boolean}
              //     Send email address verification emails to new users created from
              //     client signups.
              // - forbidClientAccountCreation {Boolean}
              //     Do not allow clients to create accounts directly.
              // - restrictCreationByEmailDomain {Function or String}
              //     Require created users to have an email matching the function or
              //     having the string as domain.
              // - loginExpirationInDays {Number}
              //     Number of days since login until a user is logged out (login token
              //     expires).
              // - passwordResetTokenExpirationInDays {Number}
              //     Number of days since password reset token creation until the
              //     token cannt be used any longer (password reset token expires).
              // - ambiguousErrorMessages {Boolean}
              //     Return ambiguous error messages from login failures to prevent
              //     user enumeration.
              // - bcryptRounds {Number}
              //     Allows override of number of bcrypt rounds (aka work factor) used
              //     to store passwords.

              /**
               * @summary Set global accounts options.
               * @locus Anywhere
               * @param {Object} options
               * @param {Boolean} options.sendVerificationEmail New users with an email address will receive an address verification email.
               * @param {Boolean} options.forbidClientAccountCreation Calls to [`createUser`](#accounts_createuser) from the client will be rejected. In addition, if you are using [accounts-ui](#accountsui), the "Create account" link will not be available.
               * @param {String | Function} options.restrictCreationByEmailDomain If set to a string, only allows new users if the domain part of their email address matches the string. If set to a function, only allows new users if the function returns true.  The function is passed the full email address of the proposed new user.  Works with password-based sign-in and external services that expose email addresses (Google, Facebook, GitHub). All existing users still can log in after enabling this option. Example: `Accounts.config({ restrictCreationByEmailDomain: 'school.edu' })`.
               * @param {Number} options.loginExpirationInDays The number of days from when a user logs in until their token expires and they are logged out. Defaults to 90. Set to `null` to disable login expiration.
               * @param {Number} options.loginExpiration The number of milliseconds from when a user logs in until their token expires and they are logged out, for a more granular control. If `loginExpirationInDays` is set, it takes precedent.
               * @param {String} options.oauthSecretKey When using the `oauth-encryption` package, the 16 byte key using to encrypt sensitive account credentials in the database, encoded in base64.  This option may only be specified on the server.  See packages/oauth-encryption/README.md for details.
               * @param {Number} options.passwordResetTokenExpirationInDays The number of days from when a link to reset password is sent until token expires and user can't reset password with the link anymore. Defaults to 3.
               * @param {Number} options.passwordResetTokenExpiration The number of milliseconds from when a link to reset password is sent until token expires and user can't reset password with the link anymore. If `passwordResetTokenExpirationInDays` is set, it takes precedent.
               * @param {Number} options.passwordEnrollTokenExpirationInDays The number of days from when a link to set initial password is sent until token expires and user can't set password with the link anymore. Defaults to 30.
               * @param {Number} options.passwordEnrollTokenExpiration The number of milliseconds from when a link to set initial password is sent until token expires and user can't set password with the link anymore. If `passwordEnrollTokenExpirationInDays` is set, it takes precedent.
               * @param {Boolean} options.ambiguousErrorMessages Return ambiguous error messages from login failures to prevent user enumeration. Defaults to false.
               * @param {MongoFieldSpecifier} options.defaultFieldSelector To exclude by default large custom fields from `Meteor.user()` and `Meteor.findUserBy...()` functions when called without a field selector, and all `onLogin`, `onLoginFailure` and `onLogout` callbacks.  Example: `Accounts.config({ defaultFieldSelector: { myBigArray: 0 }})`.
               */

              config(options) {
                // We don't want users to accidentally only call Accounts.config on the
                // client, where some of the options will have partial effects (eg removing
                // the "create account" button from accounts-ui if forbidClientAccountCreation
                // is set, or redirecting Google login to a specific-domain page) without
                // having their full effects.
                if (Meteor.isServer) {
                  __meteor_runtime_config__.accountsConfigCalled = true;
                } else if (!__meteor_runtime_config__.accountsConfigCalled) {
                  // XXX would be nice to "crash" the client and replace the UI with an error
                  // message, but there's no trivial way to do this.
                  Meteor._debug("Accounts.config was called on the client but not on the " + "server; some configuration options may not take effect.");
                } // We need to validate the oauthSecretKey option at the time
                // Accounts.config is called. We also deliberately don't store the
                // oauthSecretKey in Accounts._options.


                if (Object.prototype.hasOwnProperty.call(options, 'oauthSecretKey')) {
                  if (Meteor.isClient) {
                    throw new Error("The oauthSecretKey option may only be specified on the server");
                  }

                  if (!Package["oauth-encryption"]) {
                    throw new Error("The oauth-encryption package must be loaded to set oauthSecretKey");
                  }

                  Package["oauth-encryption"].OAuthEncryption.loadKey(options.oauthSecretKey);
                  options = _objectSpread({}, options);
                  delete options.oauthSecretKey;
                } // validate option keys


                const VALID_KEYS = ["sendVerificationEmail", "forbidClientAccountCreation", "passwordEnrollTokenExpiration", "passwordEnrollTokenExpirationInDays", "restrictCreationByEmailDomain", "loginExpirationInDays", "loginExpiration", "passwordResetTokenExpirationInDays", "passwordResetTokenExpiration", "ambiguousErrorMessages", "bcryptRounds", "defaultFieldSelector"];
                Object.keys(options).forEach(key => {
                  if (!VALID_KEYS.includes(key)) {
                    throw new Error("Accounts.config: Invalid key: ".concat(key));
                  }
                }); // set values in Accounts._options

                VALID_KEYS.forEach(key => {
                  if (key in options) {
                    if (key in this._options) {
                      throw new Error("Can't set `".concat(key, "` more than once"));
                    }

                    this._options[key] = options[key];
                  }
                });
              }
              /**
               * @summary Register a callback to be called after a login attempt succeeds.
               * @locus Anywhere
               * @param {Function} func The callback to be called when login is successful.
               *                        The callback receives a single object that
               *                        holds login details. This object contains the login
               *                        result type (password, resume, etc.) on both the
               *                        client and server. `onLogin` callbacks registered
               *                        on the server also receive extra data, such
               *                        as user details, connection information, etc.
               */

              onLogin(func) {
                let ret = this._onLoginHook.register(func); // call the just registered callback if already logged in


                this._startupCallback(ret.callback);

                return ret;
              }
              /**
               * @summary Register a callback to be called after a login attempt fails.
               * @locus Anywhere
               * @param {Function} func The callback to be called after the login has failed.
               */

              onLoginFailure(func) {
                return this._onLoginFailureHook.register(func);
              }
              /**
               * @summary Register a callback to be called after a logout attempt succeeds.
               * @locus Anywhere
               * @param {Function} func The callback to be called when logout is successful.
               */

              onLogout(func) {
                return this._onLogoutHook.register(func);
              }

              _initConnection(options) {
                if (!Meteor.isClient) {
                  return;
                } // The connection used by the Accounts system. This is the connection
                // that will get logged in by Meteor.login(), and this is the
                // connection whose login state will be reflected by Meteor.userId().
                //
                // It would be much preferable for this to be in accounts_client.js,
                // but it has to be here because it's needed to create the
                // Meteor.users collection.


                if (options.connection) {
                  this.connection = options.connection;
                } else if (options.ddpUrl) {
                  this.connection = DDP.connect(options.ddpUrl);
                } else if (typeof __meteor_runtime_config__ !== "undefined" && __meteor_runtime_config__.ACCOUNTS_CONNECTION_URL) {
                  // Temporary, internal hook to allow the server to point the client
                  // to a different authentication server. This is for a very
                  // particular use case that comes up when implementing a oauth
                  // server. Unsupported and may go away at any point in time.
                  //
                  // We will eventually provide a general way to use account-base
                  // against any DDP connection, not just one special one.
                  this.connection = DDP.connect(__meteor_runtime_config__.ACCOUNTS_CONNECTION_URL);
                } else {
                  this.connection = Meteor.connection;
                }
              }

              _getTokenLifetimeMs() {
                // When loginExpirationInDays is set to null, we'll use a really high
                // number of days (LOGIN_UNEXPIRABLE_TOKEN_DAYS) to simulate an
                // unexpiring token.
                const loginExpirationInDays = this._options.loginExpirationInDays === null ? LOGIN_UNEXPIRING_TOKEN_DAYS : this._options.loginExpirationInDays;
                return this._options.loginExpiration || (loginExpirationInDays || DEFAULT_LOGIN_EXPIRATION_DAYS) * 86400000;
              }

              _getPasswordResetTokenLifetimeMs() {
                return this._options.passwordResetTokenExpiration || (this._options.passwordResetTokenExpirationInDays || DEFAULT_PASSWORD_RESET_TOKEN_EXPIRATION_DAYS) * 86400000;
              }

              _getPasswordEnrollTokenLifetimeMs() {
                return this._options.passwordEnrollTokenExpiration || (this._options.passwordEnrollTokenExpirationInDays || DEFAULT_PASSWORD_ENROLL_TOKEN_EXPIRATION_DAYS) * 86400000;
              }

              _tokenExpiration(when) {
                // We pass when through the Date constructor for backwards compatibility;
                // `when` used to be a number.
                return new Date(new Date(when).getTime() + this._getTokenLifetimeMs());
              }

              _tokenExpiresSoon(when) {
                let minLifetimeMs = .1 * this._getTokenLifetimeMs();

                const minLifetimeCapMs = MIN_TOKEN_LIFETIME_CAP_SECS * 1000;

                if (minLifetimeMs > minLifetimeCapMs) {
                  minLifetimeMs = minLifetimeCapMs;
                }

                return new Date() > new Date(when) - minLifetimeMs;
              } // No-op on the server, overridden on the client.


              _startupCallback(callback) {}

            }

            // Note that Accounts is defined separately in accounts_client.js and
            // accounts_server.js.

            /**
             * @summary Get the current user id, or `null` if no user is logged in. A reactive data source.
             * @locus Anywhere but publish functions
             * @importFromPackage meteor
             */
            Meteor.userId = () => Accounts.userId();
            /**
             * @summary Get the current user record, or `null` if no user is logged in. A reactive data source.
             * @locus Anywhere but publish functions
             * @importFromPackage meteor
             * @param {Object} [options]
             * @param {MongoFieldSpecifier} options.fields Dictionary of fields to return or exclude.
             */

            Meteor.user = options => Accounts.user(options); // how long (in days) until a login token expires


            const DEFAULT_LOGIN_EXPIRATION_DAYS = 90; // how long (in days) until reset password token expires

            const DEFAULT_PASSWORD_RESET_TOKEN_EXPIRATION_DAYS = 3; // how long (in days) until enrol password token expires

            const DEFAULT_PASSWORD_ENROLL_TOKEN_EXPIRATION_DAYS = 30; // Clients don't try to auto-login with a token that is going to expire within
            // .1 * DEFAULT_LOGIN_EXPIRATION_DAYS, capped at MIN_TOKEN_LIFETIME_CAP_SECS.
            // Tries to avoid abrupt disconnects from expiring tokens.

            const MIN_TOKEN_LIFETIME_CAP_SECS = 3600; // one hour
            // how often (in milliseconds) we check for expired tokens

            const EXPIRE_TOKENS_INTERVAL_MS = 600 * 1000;
            const CONNECTION_CLOSE_DELAY_MS = 10 * 1000;
            // A large number of expiration days (approximately 100 years worth) that is
            // used when creating unexpiring tokens.
            const LOGIN_UNEXPIRING_TOKEN_DAYS = 365 * 100;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/accounts-base/client_main.js");

  /* Exports */
  Package._define("accounts-base", _exports2, {
    Accounts: Accounts
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;

	/* Package-scope variables */
	var SHA256;

	(function () {

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		//                                                                                                            //
		// packages/sha/sha256.js                                                                                     //
		//                                                                                                            //
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		//
		/// METEOR WRAPPER
		//
		SHA256 = function () {

			/**
   *
   *  Secure Hash Algorithm (SHA256)
   *  http://www.webtoolkit.info/javascript-sha256.html
   *  http://anmar.eu.org/projects/jssha2/
   *
   *  Original code by Angel Marin, Paul Johnston.
   *
   **/

			function SHA256(s) {

				var chrsz = 8;
				var hexcase = 0;

				function safe_add(x, y) {
					var lsw = (x & 0xFFFF) + (y & 0xFFFF);
					var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
					return msw << 16 | lsw & 0xFFFF;
				}

				function S(X, n) {
					return X >>> n | X << 32 - n;
				}
				function R(X, n) {
					return X >>> n;
				}
				function Ch(x, y, z) {
					return x & y ^ ~x & z;
				}
				function Maj(x, y, z) {
					return x & y ^ x & z ^ y & z;
				}
				function Sigma0256(x) {
					return S(x, 2) ^ S(x, 13) ^ S(x, 22);
				}
				function Sigma1256(x) {
					return S(x, 6) ^ S(x, 11) ^ S(x, 25);
				}
				function Gamma0256(x) {
					return S(x, 7) ^ S(x, 18) ^ R(x, 3);
				}
				function Gamma1256(x) {
					return S(x, 17) ^ S(x, 19) ^ R(x, 10);
				}

				function core_sha256(m, l) {
					var K = new Array(0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0xFC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x6CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2);
					var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
					var W = new Array(64);
					var a, b, c, d, e, f, g, h, i, j;
					var T1, T2;

					m[l >> 5] |= 0x80 << 24 - l % 32;
					m[(l + 64 >> 9 << 4) + 15] = l;

					for (var i = 0; i < m.length; i += 16) {
						a = HASH[0];
						b = HASH[1];
						c = HASH[2];
						d = HASH[3];
						e = HASH[4];
						f = HASH[5];
						g = HASH[6];
						h = HASH[7];

						for (var j = 0; j < 64; j++) {
							if (j < 16) W[j] = m[j + i];else W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);

							T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
							T2 = safe_add(Sigma0256(a), Maj(a, b, c));

							h = g;
							g = f;
							f = e;
							e = safe_add(d, T1);
							d = c;
							c = b;
							b = a;
							a = safe_add(T1, T2);
						}

						HASH[0] = safe_add(a, HASH[0]);
						HASH[1] = safe_add(b, HASH[1]);
						HASH[2] = safe_add(c, HASH[2]);
						HASH[3] = safe_add(d, HASH[3]);
						HASH[4] = safe_add(e, HASH[4]);
						HASH[5] = safe_add(f, HASH[5]);
						HASH[6] = safe_add(g, HASH[6]);
						HASH[7] = safe_add(h, HASH[7]);
					}
					return HASH;
				}

				function str2binb(str) {
					var bin = Array();
					var mask = (1 << chrsz) - 1;
					for (var i = 0; i < str.length * chrsz; i += chrsz) {
						bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << 24 - i % 32;
					}
					return bin;
				}

				function Utf8Encode(string) {
					// METEOR change:
					// The webtoolkit.info version of this code added this
					// Utf8Encode function (which does seem necessary for dealing
					// with arbitrary Unicode), but the following line seems
					// problematic:
					//
					// string = string.replace(/\r\n/g,"\n");
					var utftext = "";

					for (var n = 0; n < string.length; n++) {

						var c = string.charCodeAt(n);

						if (c < 128) {
							utftext += String.fromCharCode(c);
						} else if (c > 127 && c < 2048) {
							utftext += String.fromCharCode(c >> 6 | 192);
							utftext += String.fromCharCode(c & 63 | 128);
						} else {
							utftext += String.fromCharCode(c >> 12 | 224);
							utftext += String.fromCharCode(c >> 6 & 63 | 128);
							utftext += String.fromCharCode(c & 63 | 128);
						}
					}

					return utftext;
				}

				function binb2hex(binarray) {
					var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
					var str = "";
					for (var i = 0; i < binarray.length * 4; i++) {
						str += hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xF);
					}
					return str;
				}

				s = Utf8Encode(s);
				return binb2hex(core_sha256(str2binb(s), s.length * chrsz));
			}

			/// METEOR WRAPPER
			return SHA256;
		}();

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	}).call(this);

	/* Exports */
	Package._define("sha", {
		SHA256: SHA256
	});
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Random = Package.random.Random;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var SHA256 = Package.sha.SHA256;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var BigInteger, SRP;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "srp": { "srp.js": function module(_require, _exports, _module) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/srp/srp.js                                                                                                 //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module.export({
              SRP: () => SRP
            });
            let Random;
            _module.link("meteor/random", {
              Random(v) {
                Random = v;
              }

            }, 0);
            let BigInteger;
            _module.link("./biginteger", {
              default(v) {
                BigInteger = v;
              }

            }, 1);
            const SRP = {};

            /**
             * Generate a new SRP verifier. Password is the plaintext password.
             *
             * options is optional and can include:
             * - identity: String. The SRP username to user. Mostly this is passed
             *   in for testing.  Random UUID if not provided.
             * - hashedIdentityAndPassword: combined identity and password, already hashed, for the SRP to bcrypt upgrade path.
             * - salt: String. A salt to use.  Mostly this is passed in for
             *   testing.  Random UUID if not provided.
             * - SRP parameters (see _defaults and paramsFromOptions below)
             */
            SRP.generateVerifier = function (password, options) {
              const params = paramsFromOptions(options);
              const salt = options && options.salt || Random.secret();
              let identity;
              let hashedIdentityAndPassword = options && options.hashedIdentityAndPassword;

              if (!hashedIdentityAndPassword) {
                identity = options && options.identity || Random.secret();
                hashedIdentityAndPassword = params.hash(identity + ":" + password);
              }

              const x = params.hash(salt + hashedIdentityAndPassword);
              const xi = new BigInteger(x, 16);
              const v = params.g.modPow(xi, params.N);
              return {
                identity,
                salt,
                verifier: v.toString(16)
              };
            }; // For use with check().


            SRP.matchVerifier = {
              identity: String,
              salt: String,
              verifier: String
            };
            /**
             * Default parameter values for SRP.
             *
             */

            const _defaults = {
              hash: x => SHA256(x).toLowerCase(),
              N: new BigInteger("EEAF0AB9ADB38DD69C33F80AFA8FC5E86072618775FF3C0B9EA2314C9C256576D674DF7496EA81D3383B4813D692C6E0E0D5D8E250B98BE48E495C1D6089DAD15DC7D7B46154D6B6CE8EF4AD69B15D4982559B297BCF1885C529F566660E57EC68EDBC3C05726CC02FD4CBF4976EAA9AFD5138FE8376435B9FC61D2FC0EB06E3", 16),
              g: new BigInteger("2")
            };
            _defaults.k = new BigInteger(_defaults.hash(_defaults.N.toString(16) + _defaults.g.toString(16)), 16);
            /**
             * Process an options hash to create SRP parameters.
             *
             * Options can include:
             * - hash: Function. Defaults to SHA256.
             * - N: String or BigInteger. Defaults to 1024 bit value from RFC 5054
             * - g: String or BigInteger. Defaults to 2.
             * - k: String or BigInteger. Defaults to hash(N, g)
             */

            const paramsFromOptions = function (options) {
              if (!options) // fast path
                return _defaults;

              var ret = _objectSpread({}, _defaults);

              ['N', 'g', 'k'].forEach(p => {
                if (options[p]) {
                  if (typeof options[p] === "string") ret[p] = new BigInteger(options[p], 16);else if (options[p] instanceof BigInteger) ret[p] = options[p];else throw new Error("Invalid parameter: " + p);
                }
              });
              if (options.hash) ret.hash = x => options.hash(x).toLowerCase();

              if (!options.k && (options.N || options.g || options.hash)) {
                ret.k = ret.hash(ret.N.toString(16) + ret.g.toString(16));
              }

              return ret;
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "biginteger.js": function module(_require3, _exports3, _module2) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/srp/biginteger.js                                                                                          //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module2.exportDefault(BigInteger = function () {
              /// BEGIN jsbn.js

              /*
               * Copyright (c) 2003-2005  Tom Wu
               * All Rights Reserved.
               *
               * Permission is hereby granted, free of charge, to any person obtaining
               * a copy of this software and associated documentation files (the
               * "Software"), to deal in the Software without restriction, including
               * without limitation the rights to use, copy, modify, merge, publish,
               * distribute, sublicense, and/or sell copies of the Software, and to
               * permit persons to whom the Software is furnished to do so, subject to
               * the following conditions:
               *
               * The above copyright notice and this permission notice shall be
               * included in all copies or substantial portions of the Software.
               *
               * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND, 
               * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY 
               * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.  
               *
               * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
               * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
               * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
               * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
               * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
               *
               * In addition, the following condition applies:
               *
               * All redistributions must retain an intact copy of this copyright notice
               * and disclaimer.
               */
              // Basic JavaScript BN library - subset useful for RSA encryption.
              // Bits per digit
              var dbits; // JavaScript engine analysis

              var canary = 0xdeadbeefcafe;
              var j_lm = (canary & 0xffffff) == 0xefcafe; // (public) Constructor

              function BigInteger(a, b, c) {
                if (a != null) if ("number" == typeof a) this.fromNumber(a, b, c);else if (b == null && "string" != typeof a) this.fromString(a, 256);else this.fromString(a, b);
              } // return new, unset BigInteger


              function nbi() {
                return new BigInteger(null);
              } // am: Compute w_j += (x*this_i), propagate carries,
              // c is initial carry, returns final carry.
              // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
              // We need to select the fastest one that works in this environment.
              // am1: use a single mult and divide to get the high bits,
              // max digit bits should be 26 because
              // max internal value = 2*dvalue^2-2*dvalue (< 2^53)


              function am1(i, x, w, j, c, n) {
                while (--n >= 0) {
                  var v = x * this[i++] + w[j] + c;
                  c = Math.floor(v / 0x4000000);
                  w[j++] = v & 0x3ffffff;
                }

                return c;
              } // am2 avoids a big mult-and-extract completely.
              // Max digit bits should be <= 30 because we do bitwise ops
              // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)


              function am2(i, x, w, j, c, n) {
                var xl = x & 0x7fff,
                    xh = x >> 15;

                while (--n >= 0) {
                  var l = this[i] & 0x7fff;
                  var h = this[i++] >> 15;
                  var m = xh * l + h * xl;
                  l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
                  c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
                  w[j++] = l & 0x3fffffff;
                }

                return c;
              } // Alternately, set max digit bits to 28 since some
              // browsers slow down when dealing with 32-bit numbers.


              function am3(i, x, w, j, c, n) {
                var xl = x & 0x3fff,
                    xh = x >> 14;

                while (--n >= 0) {
                  var l = this[i] & 0x3fff;
                  var h = this[i++] >> 14;
                  var m = xh * l + h * xl;
                  l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
                  c = (l >> 28) + (m >> 14) + xh * h;
                  w[j++] = l & 0xfffffff;
                }

                return c;
              }
              /* XXX METEOR XXX
              if(j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
                BigInteger.prototype.am = am2;
                dbits = 30;
              }
              else if(j_lm && (navigator.appName != "Netscape")) {
                BigInteger.prototype.am = am1;
                dbits = 26;
              }
              else 
              */

              {
                // Mozilla/Netscape seems to prefer am3
                BigInteger.prototype.am = am3;
                dbits = 28;
              }
              BigInteger.prototype.DB = dbits;
              BigInteger.prototype.DM = (1 << dbits) - 1;
              BigInteger.prototype.DV = 1 << dbits;
              var BI_FP = 52;
              BigInteger.prototype.FV = Math.pow(2, BI_FP);
              BigInteger.prototype.F1 = BI_FP - dbits;
              BigInteger.prototype.F2 = 2 * dbits - BI_FP; // Digit conversions

              var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
              var BI_RC = new Array();
              var rr, vv;
              rr = "0".charCodeAt(0);

              for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;

              rr = "a".charCodeAt(0);

              for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

              rr = "A".charCodeAt(0);

              for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

              function int2char(n) {
                return BI_RM.charAt(n);
              }

              function intAt(s, i) {
                var c = BI_RC[s.charCodeAt(i)];
                return c == null ? -1 : c;
              } // (protected) copy this to r


              function bnpCopyTo(r) {
                for (var i = this.t - 1; i >= 0; --i) r[i] = this[i];

                r.t = this.t;
                r.s = this.s;
              } // (protected) set from integer value x, -DV <= x < DV


              function bnpFromInt(x) {
                this.t = 1;
                this.s = x < 0 ? -1 : 0;
                if (x > 0) this[0] = x;else if (x < -1) this[0] = x + DV;else this.t = 0;
              } // return bigint initialized to value


              function nbv(i) {
                var r = nbi();
                r.fromInt(i);
                return r;
              } // (protected) set from string and radix


              function bnpFromString(s, b) {
                var k;
                if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 256) k = 8; // byte array
                else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else {
                    this.fromRadix(s, b);
                    return;
                  }
                this.t = 0;
                this.s = 0;
                var i = s.length,
                    mi = false,
                    sh = 0;

                while (--i >= 0) {
                  var x = k == 8 ? s[i] & 0xff : intAt(s, i);

                  if (x < 0) {
                    if (s.charAt(i) == "-") mi = true;
                    continue;
                  }

                  mi = false;
                  if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
                    this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                    this[this.t++] = x >> this.DB - sh;
                  } else this[this.t - 1] |= x << sh;
                  sh += k;
                  if (sh >= this.DB) sh -= this.DB;
                }

                if (k == 8 && (s[0] & 0x80) != 0) {
                  this.s = -1;
                  if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
                }

                this.clamp();
                if (mi) BigInteger.ZERO.subTo(this, this);
              } // (protected) clamp off excess high words


              function bnpClamp() {
                var c = this.s & this.DM;

                while (this.t > 0 && this[this.t - 1] == c) --this.t;
              } // (public) return string representation in given radix


              function bnToString(b) {
                if (this.s < 0) return "-" + this.negate().toString(b);
                var k;
                if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else return this.toRadix(b);
                var km = (1 << k) - 1,
                    d,
                    m = false,
                    r = "",
                    i = this.t;
                var p = this.DB - i * this.DB % k;

                if (i-- > 0) {
                  if (p < this.DB && (d = this[i] >> p) > 0) {
                    m = true;
                    r = int2char(d);
                  }

                  while (i >= 0) {
                    if (p < k) {
                      d = (this[i] & (1 << p) - 1) << k - p;
                      d |= this[--i] >> (p += this.DB - k);
                    } else {
                      d = this[i] >> (p -= k) & km;

                      if (p <= 0) {
                        p += this.DB;
                        --i;
                      }
                    }

                    if (d > 0) m = true;
                    if (m) r += int2char(d);
                  }
                }

                return m ? r : "0";
              } // (public) -this


              function bnNegate() {
                var r = nbi();
                BigInteger.ZERO.subTo(this, r);
                return r;
              } // (public) |this|


              function bnAbs() {
                return this.s < 0 ? this.negate() : this;
              } // (public) return + if this > a, - if this < a, 0 if equal


              function bnCompareTo(a) {
                var r = this.s - a.s;
                if (r != 0) return r;
                var i = this.t;
                r = i - a.t;
                if (r != 0) return r;

                while (--i >= 0) if ((r = this[i] - a[i]) != 0) return r;

                return 0;
              } // returns bit length of the integer x


              function nbits(x) {
                var r = 1,
                    t;

                if ((t = x >>> 16) != 0) {
                  x = t;
                  r += 16;
                }

                if ((t = x >> 8) != 0) {
                  x = t;
                  r += 8;
                }

                if ((t = x >> 4) != 0) {
                  x = t;
                  r += 4;
                }

                if ((t = x >> 2) != 0) {
                  x = t;
                  r += 2;
                }

                if ((t = x >> 1) != 0) {
                  x = t;
                  r += 1;
                }

                return r;
              } // (public) return the number of bits in "this"


              function bnBitLength() {
                if (this.t <= 0) return 0;
                return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
              } // (protected) r = this << n*DB


              function bnpDLShiftTo(n, r) {
                var i;

                for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i];

                for (i = n - 1; i >= 0; --i) r[i] = 0;

                r.t = this.t + n;
                r.s = this.s;
              } // (protected) r = this >> n*DB


              function bnpDRShiftTo(n, r) {
                for (var i = n; i < this.t; ++i) r[i - n] = this[i];

                r.t = Math.max(this.t - n, 0);
                r.s = this.s;
              } // (protected) r = this << n


              function bnpLShiftTo(n, r) {
                var bs = n % this.DB;
                var cbs = this.DB - bs;
                var bm = (1 << cbs) - 1;
                var ds = Math.floor(n / this.DB),
                    c = this.s << bs & this.DM,
                    i;

                for (i = this.t - 1; i >= 0; --i) {
                  r[i + ds + 1] = this[i] >> cbs | c;
                  c = (this[i] & bm) << bs;
                }

                for (i = ds - 1; i >= 0; --i) r[i] = 0;

                r[ds] = c;
                r.t = this.t + ds + 1;
                r.s = this.s;
                r.clamp();
              } // (protected) r = this >> n


              function bnpRShiftTo(n, r) {
                r.s = this.s;
                var ds = Math.floor(n / this.DB);

                if (ds >= this.t) {
                  r.t = 0;
                  return;
                }

                var bs = n % this.DB;
                var cbs = this.DB - bs;
                var bm = (1 << bs) - 1;
                r[0] = this[ds] >> bs;

                for (var i = ds + 1; i < this.t; ++i) {
                  r[i - ds - 1] |= (this[i] & bm) << cbs;
                  r[i - ds] = this[i] >> bs;
                }

                if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
                r.t = this.t - ds;
                r.clamp();
              } // (protected) r = this - a


              function bnpSubTo(a, r) {
                var i = 0,
                    c = 0,
                    m = Math.min(a.t, this.t);

                while (i < m) {
                  c += this[i] - a[i];
                  r[i++] = c & this.DM;
                  c >>= this.DB;
                }

                if (a.t < this.t) {
                  c -= a.s;

                  while (i < this.t) {
                    c += this[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                  }

                  c += this.s;
                } else {
                  c += this.s;

                  while (i < a.t) {
                    c -= a[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                  }

                  c -= a.s;
                }

                r.s = c < 0 ? -1 : 0;
                if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
                r.t = i;
                r.clamp();
              } // (protected) r = this * a, r != this,a (HAC 14.12)
              // "this" should be the larger one if appropriate.


              function bnpMultiplyTo(a, r) {
                var x = this.abs(),
                    y = a.abs();
                var i = x.t;
                r.t = i + y.t;

                while (--i >= 0) r[i] = 0;

                for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);

                r.s = 0;
                r.clamp();
                if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
              } // (protected) r = this^2, r != this (HAC 14.16)


              function bnpSquareTo(r) {
                var x = this.abs();
                var i = r.t = 2 * x.t;

                while (--i >= 0) r[i] = 0;

                for (i = 0; i < x.t - 1; ++i) {
                  var c = x.am(i, x[i], r, 2 * i, 0, 1);

                  if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                    r[i + x.t] -= x.DV;
                    r[i + x.t + 1] = 1;
                  }
                }

                if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
                r.s = 0;
                r.clamp();
              } // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
              // r != q, this != m.  q or r may be null.


              function bnpDivRemTo(m, q, r) {
                var pm = m.abs();
                if (pm.t <= 0) return;
                var pt = this.abs();

                if (pt.t < pm.t) {
                  if (q != null) q.fromInt(0);
                  if (r != null) this.copyTo(r);
                  return;
                }

                if (r == null) r = nbi();
                var y = nbi(),
                    ts = this.s,
                    ms = m.s;
                var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus

                if (nsh > 0) {
                  pm.lShiftTo(nsh, y);
                  pt.lShiftTo(nsh, r);
                } else {
                  pm.copyTo(y);
                  pt.copyTo(r);
                }

                var ys = y.t;
                var y0 = y[ys - 1];
                if (y0 == 0) return;
                var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
                var d1 = this.FV / yt,
                    d2 = (1 << this.F1) / yt,
                    e = 1 << this.F2;
                var i = r.t,
                    j = i - ys,
                    t = q == null ? nbi() : q;
                y.dlShiftTo(j, t);

                if (r.compareTo(t) >= 0) {
                  r[r.t++] = 1;
                  r.subTo(t, r);
                }

                BigInteger.ONE.dlShiftTo(ys, t);
                t.subTo(y, y); // "negative" y so we can replace sub with am later

                while (y.t < ys) y[y.t++] = 0;

                while (--j >= 0) {
                  // Estimate quotient digit
                  var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);

                  if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                    // Try it out
                    y.dlShiftTo(j, t);
                    r.subTo(t, r);

                    while (r[i] < --qd) r.subTo(t, r);
                  }
                }

                if (q != null) {
                  r.drShiftTo(ys, q);
                  if (ts != ms) BigInteger.ZERO.subTo(q, q);
                }

                r.t = ys;
                r.clamp();
                if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder

                if (ts < 0) BigInteger.ZERO.subTo(r, r);
              } // (public) this mod a


              function bnMod(a) {
                var r = nbi();
                this.abs().divRemTo(a, null, r);
                if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
                return r;
              } // Modular reduction using "classic" algorithm


              function Classic(m) {
                this.m = m;
              }

              function cConvert(x) {
                if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);else return x;
              }

              function cRevert(x) {
                return x;
              }

              function cReduce(x) {
                x.divRemTo(this.m, null, x);
              }

              function cMulTo(x, y, r) {
                x.multiplyTo(y, r);
                this.reduce(r);
              }

              function cSqrTo(x, r) {
                x.squareTo(r);
                this.reduce(r);
              }

              Classic.prototype.convert = cConvert;
              Classic.prototype.revert = cRevert;
              Classic.prototype.reduce = cReduce;
              Classic.prototype.mulTo = cMulTo;
              Classic.prototype.sqrTo = cSqrTo; // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
              // justification:
              //         xy == 1 (mod m)
              //         xy =  1+km
              //   xy(2-xy) = (1+km)(1-km)
              // x[y(2-xy)] = 1-k^2m^2
              // x[y(2-xy)] == 1 (mod m^2)
              // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
              // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
              // JS multiply "overflows" differently from C/C++, so care is needed here.

              function bnpInvDigit() {
                if (this.t < 1) return 0;
                var x = this[0];
                if ((x & 1) == 0) return 0;
                var y = x & 3; // y == 1/x mod 2^2

                y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4

                y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8

                y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
                // last step - calculate inverse mod DV directly;
                // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints

                y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
                // we really want the negative inverse, and -DV < y < DV

                return y > 0 ? this.DV - y : -y;
              } // Montgomery reduction


              function Montgomery(m) {
                this.m = m;
                this.mp = m.invDigit();
                this.mpl = this.mp & 0x7fff;
                this.mph = this.mp >> 15;
                this.um = (1 << m.DB - 15) - 1;
                this.mt2 = 2 * m.t;
              } // xR mod m


              function montConvert(x) {
                var r = nbi();
                x.abs().dlShiftTo(this.m.t, r);
                r.divRemTo(this.m, null, r);
                if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
                return r;
              } // x/R mod m


              function montRevert(x) {
                var r = nbi();
                x.copyTo(r);
                this.reduce(r);
                return r;
              } // x = x/R mod m (HAC 14.32)


              function montReduce(x) {
                while (x.t <= this.mt2) // pad x so am has enough room later
                x[x.t++] = 0;

                for (var i = 0; i < this.m.t; ++i) {
                  // faster way of calculating u0 = x[i]*mp mod DV
                  var j = x[i] & 0x7fff;
                  var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call

                  j = i + this.m.t;
                  x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry

                  while (x[j] >= x.DV) {
                    x[j] -= x.DV;
                    x[++j]++;
                  }
                }

                x.clamp();
                x.drShiftTo(this.m.t, x);
                if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
              } // r = "x^2/R mod m"; x != r


              function montSqrTo(x, r) {
                x.squareTo(r);
                this.reduce(r);
              } // r = "xy/R mod m"; x,y != r


              function montMulTo(x, y, r) {
                x.multiplyTo(y, r);
                this.reduce(r);
              }

              Montgomery.prototype.convert = montConvert;
              Montgomery.prototype.revert = montRevert;
              Montgomery.prototype.reduce = montReduce;
              Montgomery.prototype.mulTo = montMulTo;
              Montgomery.prototype.sqrTo = montSqrTo; // (protected) true iff this is even

              function bnpIsEven() {
                return (this.t > 0 ? this[0] & 1 : this.s) == 0;
              } // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)


              function bnpExp(e, z) {
                if (e > 0xffffffff || e < 1) return BigInteger.ONE;
                var r = nbi(),
                    r2 = nbi(),
                    g = z.convert(this),
                    i = nbits(e) - 1;
                g.copyTo(r);

                while (--i >= 0) {
                  z.sqrTo(r, r2);
                  if ((e & 1 << i) > 0) z.mulTo(r2, g, r);else {
                    var t = r;
                    r = r2;
                    r2 = t;
                  }
                }

                return z.revert(r);
              } // (public) this^e % m, 0 <= e < 2^32


              function bnModPowInt(e, m) {
                var z;
                if (e < 256 || m.isEven()) z = new Classic(m);else z = new Montgomery(m);
                return this.exp(e, z);
              } // protected


              BigInteger.prototype.copyTo = bnpCopyTo;
              BigInteger.prototype.fromInt = bnpFromInt;
              BigInteger.prototype.fromString = bnpFromString;
              BigInteger.prototype.clamp = bnpClamp;
              BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
              BigInteger.prototype.drShiftTo = bnpDRShiftTo;
              BigInteger.prototype.lShiftTo = bnpLShiftTo;
              BigInteger.prototype.rShiftTo = bnpRShiftTo;
              BigInteger.prototype.subTo = bnpSubTo;
              BigInteger.prototype.multiplyTo = bnpMultiplyTo;
              BigInteger.prototype.squareTo = bnpSquareTo;
              BigInteger.prototype.divRemTo = bnpDivRemTo;
              BigInteger.prototype.invDigit = bnpInvDigit;
              BigInteger.prototype.isEven = bnpIsEven;
              BigInteger.prototype.exp = bnpExp; // public

              BigInteger.prototype.toString = bnToString;
              BigInteger.prototype.negate = bnNegate;
              BigInteger.prototype.abs = bnAbs;
              BigInteger.prototype.compareTo = bnCompareTo;
              BigInteger.prototype.bitLength = bnBitLength;
              BigInteger.prototype.mod = bnMod;
              BigInteger.prototype.modPowInt = bnModPowInt; // "constants"

              BigInteger.ZERO = nbv(0);
              BigInteger.ONE = nbv(1); /// BEGIN jsbn2.js

              /*
               * Copyright (c) 2003-2005  Tom Wu
               * All Rights Reserved.
               *
               * Permission is hereby granted, free of charge, to any person obtaining
               * a copy of this software and associated documentation files (the
               * "Software"), to deal in the Software without restriction, including
               * without limitation the rights to use, copy, modify, merge, publish,
               * distribute, sublicense, and/or sell copies of the Software, and to
               * permit persons to whom the Software is furnished to do so, subject to
               * the following conditions:
               *
               * The above copyright notice and this permission notice shall be
               * included in all copies or substantial portions of the Software.
               *
               * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND, 
               * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY 
               * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.  
               *
               * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
               * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
               * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
               * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
               * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
               *
               * In addition, the following condition applies:
               *
               * All redistributions must retain an intact copy of this copyright notice
               * and disclaimer.
               */
              // Extended JavaScript BN functions, required for RSA private ops.
              // (public)

              function bnClone() {
                var r = nbi();
                this.copyTo(r);
                return r;
              } // (public) return value as integer


              function bnIntValue() {
                if (this.s < 0) {
                  if (this.t == 1) return this[0] - this.DV;else if (this.t == 0) return -1;
                } else if (this.t == 1) return this[0];else if (this.t == 0) return 0; // assumes 16 < DB < 32


                return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
              } // (public) return value as byte


              function bnByteValue() {
                return this.t == 0 ? this.s : this[0] << 24 >> 24;
              } // (public) return value as short (assumes DB>=16)


              function bnShortValue() {
                return this.t == 0 ? this.s : this[0] << 16 >> 16;
              } // (protected) return x s.t. r^x < DV


              function bnpChunkSize(r) {
                return Math.floor(Math.LN2 * this.DB / Math.log(r));
              } // (public) 0 if this == 0, 1 if this > 0


              function bnSigNum() {
                if (this.s < 0) return -1;else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;else return 1;
              } // (protected) convert to radix string


              function bnpToRadix(b) {
                if (b == null) b = 10;
                if (this.signum() == 0 || b < 2 || b > 36) return "0";
                var cs = this.chunkSize(b);
                var a = Math.pow(b, cs);
                var d = nbv(a),
                    y = nbi(),
                    z = nbi(),
                    r = "";
                this.divRemTo(d, y, z);

                while (y.signum() > 0) {
                  r = (a + z.intValue()).toString(b).substr(1) + r;
                  y.divRemTo(d, y, z);
                }

                return z.intValue().toString(b) + r;
              } // (protected) convert from radix string


              function bnpFromRadix(s, b) {
                this.fromInt(0);
                if (b == null) b = 10;
                var cs = this.chunkSize(b);
                var d = Math.pow(b, cs),
                    mi = false,
                    j = 0,
                    w = 0;

                for (var i = 0; i < s.length; ++i) {
                  var x = intAt(s, i);

                  if (x < 0) {
                    if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                    continue;
                  }

                  w = b * w + x;

                  if (++j >= cs) {
                    this.dMultiply(d);
                    this.dAddOffset(w, 0);
                    j = 0;
                    w = 0;
                  }
                }

                if (j > 0) {
                  this.dMultiply(Math.pow(b, j));
                  this.dAddOffset(w, 0);
                }

                if (mi) BigInteger.ZERO.subTo(this, this);
              } // (protected) alternate constructor


              function bnpFromNumber(a, b, c) {
                if ("number" == typeof b) {
                  // new BigInteger(int,int,RNG)
                  if (a < 2) this.fromInt(1);else {
                    this.fromNumber(a, c);
                    if (!this.testBit(a - 1)) // force MSB set
                      this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                    if (this.isEven()) this.dAddOffset(1, 0); // force odd

                    while (!this.isProbablePrime(b)) {
                      this.dAddOffset(2, 0);
                      if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                    }
                  }
                } else {
                  // new BigInteger(int,RNG)
                  var x = new Array(),
                      t = a & 7;
                  x.length = (a >> 3) + 1;
                  b.nextBytes(x);
                  if (t > 0) x[0] &= (1 << t) - 1;else x[0] = 0;
                  this.fromString(x, 256);
                }
              } // (public) convert to bigendian byte array


              function bnToByteArray() {
                var i = this.t,
                    r = new Array();
                r[0] = this.s;
                var p = this.DB - i * this.DB % 8,
                    d,
                    k = 0;

                if (i-- > 0) {
                  if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;

                  while (i >= 0) {
                    if (p < 8) {
                      d = (this[i] & (1 << p) - 1) << 8 - p;
                      d |= this[--i] >> (p += this.DB - 8);
                    } else {
                      d = this[i] >> (p -= 8) & 0xff;

                      if (p <= 0) {
                        p += this.DB;
                        --i;
                      }
                    }

                    if ((d & 0x80) != 0) d |= -256;
                    if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                    if (k > 0 || d != this.s) r[k++] = d;
                  }
                }

                return r;
              }

              function bnEquals(a) {
                return this.compareTo(a) == 0;
              }

              function bnMin(a) {
                return this.compareTo(a) < 0 ? this : a;
              }

              function bnMax(a) {
                return this.compareTo(a) > 0 ? this : a;
              } // (protected) r = this op a (bitwise)


              function bnpBitwiseTo(a, op, r) {
                var i,
                    f,
                    m = Math.min(a.t, this.t);

                for (i = 0; i < m; ++i) r[i] = op(this[i], a[i]);

                if (a.t < this.t) {
                  f = a.s & this.DM;

                  for (i = m; i < this.t; ++i) r[i] = op(this[i], f);

                  r.t = this.t;
                } else {
                  f = this.s & this.DM;

                  for (i = m; i < a.t; ++i) r[i] = op(f, a[i]);

                  r.t = a.t;
                }

                r.s = op(this.s, a.s);
                r.clamp();
              } // (public) this & a


              function op_and(x, y) {
                return x & y;
              }

              function bnAnd(a) {
                var r = nbi();
                this.bitwiseTo(a, op_and, r);
                return r;
              } // (public) this | a


              function op_or(x, y) {
                return x | y;
              }

              function bnOr(a) {
                var r = nbi();
                this.bitwiseTo(a, op_or, r);
                return r;
              } // (public) this ^ a


              function op_xor(x, y) {
                return x ^ y;
              }

              function bnXor(a) {
                var r = nbi();
                this.bitwiseTo(a, op_xor, r);
                return r;
              } // (public) this & ~a


              function op_andnot(x, y) {
                return x & ~y;
              }

              function bnAndNot(a) {
                var r = nbi();
                this.bitwiseTo(a, op_andnot, r);
                return r;
              } // (public) ~this


              function bnNot() {
                var r = nbi();

                for (var i = 0; i < this.t; ++i) r[i] = this.DM & ~this[i];

                r.t = this.t;
                r.s = ~this.s;
                return r;
              } // (public) this << n


              function bnShiftLeft(n) {
                var r = nbi();
                if (n < 0) this.rShiftTo(-n, r);else this.lShiftTo(n, r);
                return r;
              } // (public) this >> n


              function bnShiftRight(n) {
                var r = nbi();
                if (n < 0) this.lShiftTo(-n, r);else this.rShiftTo(n, r);
                return r;
              } // return index of lowest 1-bit in x, x < 2^31


              function lbit(x) {
                if (x == 0) return -1;
                var r = 0;

                if ((x & 0xffff) == 0) {
                  x >>= 16;
                  r += 16;
                }

                if ((x & 0xff) == 0) {
                  x >>= 8;
                  r += 8;
                }

                if ((x & 0xf) == 0) {
                  x >>= 4;
                  r += 4;
                }

                if ((x & 3) == 0) {
                  x >>= 2;
                  r += 2;
                }

                if ((x & 1) == 0) ++r;
                return r;
              } // (public) returns index of lowest 1-bit (or -1 if none)


              function bnGetLowestSetBit() {
                for (var i = 0; i < this.t; ++i) if (this[i] != 0) return i * this.DB + lbit(this[i]);

                if (this.s < 0) return this.t * this.DB;
                return -1;
              } // return number of 1 bits in x


              function cbit(x) {
                var r = 0;

                while (x != 0) {
                  x &= x - 1;
                  ++r;
                }

                return r;
              } // (public) return number of set bits


              function bnBitCount() {
                var r = 0,
                    x = this.s & this.DM;

                for (var i = 0; i < this.t; ++i) r += cbit(this[i] ^ x);

                return r;
              } // (public) true iff nth bit is set


              function bnTestBit(n) {
                var j = Math.floor(n / this.DB);
                if (j >= this.t) return this.s != 0;
                return (this[j] & 1 << n % this.DB) != 0;
              } // (protected) this op (1<<n)


              function bnpChangeBit(n, op) {
                var r = BigInteger.ONE.shiftLeft(n);
                this.bitwiseTo(r, op, r);
                return r;
              } // (public) this | (1<<n)


              function bnSetBit(n) {
                return this.changeBit(n, op_or);
              } // (public) this & ~(1<<n)


              function bnClearBit(n) {
                return this.changeBit(n, op_andnot);
              } // (public) this ^ (1<<n)


              function bnFlipBit(n) {
                return this.changeBit(n, op_xor);
              } // (protected) r = this + a


              function bnpAddTo(a, r) {
                var i = 0,
                    c = 0,
                    m = Math.min(a.t, this.t);

                while (i < m) {
                  c += this[i] + a[i];
                  r[i++] = c & this.DM;
                  c >>= this.DB;
                }

                if (a.t < this.t) {
                  c += a.s;

                  while (i < this.t) {
                    c += this[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                  }

                  c += this.s;
                } else {
                  c += this.s;

                  while (i < a.t) {
                    c += a[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                  }

                  c += a.s;
                }

                r.s = c < 0 ? -1 : 0;
                if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
                r.t = i;
                r.clamp();
              } // (public) this + a


              function bnAdd(a) {
                var r = nbi();
                this.addTo(a, r);
                return r;
              } // (public) this - a


              function bnSubtract(a) {
                var r = nbi();
                this.subTo(a, r);
                return r;
              } // (public) this * a


              function bnMultiply(a) {
                var r = nbi();
                this.multiplyTo(a, r);
                return r;
              } // (public) this / a


              function bnDivide(a) {
                var r = nbi();
                this.divRemTo(a, r, null);
                return r;
              } // (public) this % a


              function bnRemainder(a) {
                var r = nbi();
                this.divRemTo(a, null, r);
                return r;
              } // (public) [this/a,this%a]


              function bnDivideAndRemainder(a) {
                var q = nbi(),
                    r = nbi();
                this.divRemTo(a, q, r);
                return new Array(q, r);
              } // (protected) this *= n, this >= 0, 1 < n < DV


              function bnpDMultiply(n) {
                this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
                ++this.t;
                this.clamp();
              } // (protected) this += n << w words, this >= 0


              function bnpDAddOffset(n, w) {
                while (this.t <= w) this[this.t++] = 0;

                this[w] += n;

                while (this[w] >= this.DV) {
                  this[w] -= this.DV;
                  if (++w >= this.t) this[this.t++] = 0;
                  ++this[w];
                }
              } // A "null" reducer


              function NullExp() {}

              function nNop(x) {
                return x;
              }

              function nMulTo(x, y, r) {
                x.multiplyTo(y, r);
              }

              function nSqrTo(x, r) {
                x.squareTo(r);
              }

              NullExp.prototype.convert = nNop;
              NullExp.prototype.revert = nNop;
              NullExp.prototype.mulTo = nMulTo;
              NullExp.prototype.sqrTo = nSqrTo; // (public) this^e

              function bnPow(e) {
                return this.exp(e, new NullExp());
              } // (protected) r = lower n words of "this * a", a.t <= n
              // "this" should be the larger one if appropriate.


              function bnpMultiplyLowerTo(a, n, r) {
                var i = Math.min(this.t + a.t, n);
                r.s = 0; // assumes a,this >= 0

                r.t = i;

                while (i > 0) r[--i] = 0;

                var j;

                for (j = r.t - this.t; i < j; ++i) r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);

                for (j = Math.min(a.t, n); i < j; ++i) this.am(0, a[i], r, i, 0, n - i);

                r.clamp();
              } // (protected) r = "this * a" without lower n words, n > 0
              // "this" should be the larger one if appropriate.


              function bnpMultiplyUpperTo(a, n, r) {
                --n;
                var i = r.t = this.t + a.t - n;
                r.s = 0; // assumes a,this >= 0

                while (--i >= 0) r[i] = 0;

                for (i = Math.max(n - this.t, 0); i < a.t; ++i) r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);

                r.clamp();
                r.drShiftTo(1, r);
              } // Barrett modular reduction


              function Barrett(m) {
                // setup Barrett
                this.r2 = nbi();
                this.q3 = nbi();
                BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
                this.mu = this.r2.divide(m);
                this.m = m;
              }

              function barrettConvert(x) {
                if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);else if (x.compareTo(this.m) < 0) return x;else {
                  var r = nbi();
                  x.copyTo(r);
                  this.reduce(r);
                  return r;
                }
              }

              function barrettRevert(x) {
                return x;
              } // x = x mod m (HAC 14.42)


              function barrettReduce(x) {
                x.drShiftTo(this.m.t - 1, this.r2);

                if (x.t > this.m.t + 1) {
                  x.t = this.m.t + 1;
                  x.clamp();
                }

                this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
                this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);

                while (x.compareTo(this.r2) < 0) x.dAddOffset(1, this.m.t + 1);

                x.subTo(this.r2, x);

                while (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
              } // r = x^2 mod m; x != r


              function barrettSqrTo(x, r) {
                x.squareTo(r);
                this.reduce(r);
              } // r = x*y mod m; x,y != r


              function barrettMulTo(x, y, r) {
                x.multiplyTo(y, r);
                this.reduce(r);
              }

              Barrett.prototype.convert = barrettConvert;
              Barrett.prototype.revert = barrettRevert;
              Barrett.prototype.reduce = barrettReduce;
              Barrett.prototype.mulTo = barrettMulTo;
              Barrett.prototype.sqrTo = barrettSqrTo; // (public) this^e % m (HAC 14.85)

              function bnModPow(e, m) {
                var i = e.bitLength(),
                    k,
                    r = nbv(1),
                    z;
                if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;
                if (i < 8) z = new Classic(m);else if (m.isEven()) z = new Barrett(m);else z = new Montgomery(m); // precomputation

                var g = new Array(),
                    n = 3,
                    k1 = k - 1,
                    km = (1 << k) - 1;
                g[1] = z.convert(this);

                if (k > 1) {
                  var g2 = nbi();
                  z.sqrTo(g[1], g2);

                  while (n <= km) {
                    g[n] = nbi();
                    z.mulTo(g2, g[n - 2], g[n]);
                    n += 2;
                  }
                }

                var j = e.t - 1,
                    w,
                    is1 = true,
                    r2 = nbi(),
                    t;
                i = nbits(e[j]) - 1;

                while (j >= 0) {
                  if (i >= k1) w = e[j] >> i - k1 & km;else {
                    w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                    if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
                  }
                  n = k;

                  while ((w & 1) == 0) {
                    w >>= 1;
                    --n;
                  }

                  if ((i -= n) < 0) {
                    i += this.DB;
                    --j;
                  }

                  if (is1) {
                    // ret == 1, don't bother squaring or multiplying it
                    g[w].copyTo(r);
                    is1 = false;
                  } else {
                    while (n > 1) {
                      z.sqrTo(r, r2);
                      z.sqrTo(r2, r);
                      n -= 2;
                    }

                    if (n > 0) z.sqrTo(r, r2);else {
                      t = r;
                      r = r2;
                      r2 = t;
                    }
                    z.mulTo(r2, g[w], r);
                  }

                  while (j >= 0 && (e[j] & 1 << i) == 0) {
                    z.sqrTo(r, r2);
                    t = r;
                    r = r2;
                    r2 = t;

                    if (--i < 0) {
                      i = this.DB - 1;
                      --j;
                    }
                  }
                }

                return z.revert(r);
              } // (public) gcd(this,a) (HAC 14.54)


              function bnGCD(a) {
                var x = this.s < 0 ? this.negate() : this.clone();
                var y = a.s < 0 ? a.negate() : a.clone();

                if (x.compareTo(y) < 0) {
                  var t = x;
                  x = y;
                  y = t;
                }

                var i = x.getLowestSetBit(),
                    g = y.getLowestSetBit();
                if (g < 0) return x;
                if (i < g) g = i;

                if (g > 0) {
                  x.rShiftTo(g, x);
                  y.rShiftTo(g, y);
                }

                while (x.signum() > 0) {
                  if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
                  if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);

                  if (x.compareTo(y) >= 0) {
                    x.subTo(y, x);
                    x.rShiftTo(1, x);
                  } else {
                    y.subTo(x, y);
                    y.rShiftTo(1, y);
                  }
                }

                if (g > 0) y.lShiftTo(g, y);
                return y;
              } // (protected) this % n, n < 2^26


              function bnpModInt(n) {
                if (n <= 0) return 0;
                var d = this.DV % n,
                    r = this.s < 0 ? n - 1 : 0;
                if (this.t > 0) if (d == 0) r = this[0] % n;else for (var i = this.t - 1; i >= 0; --i) r = (d * r + this[i]) % n;
                return r;
              } // (public) 1/this % m (HAC 14.61)


              function bnModInverse(m) {
                var ac = m.isEven();
                if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
                var u = m.clone(),
                    v = this.clone();
                var a = nbv(1),
                    b = nbv(0),
                    c = nbv(0),
                    d = nbv(1);

                while (u.signum() != 0) {
                  while (u.isEven()) {
                    u.rShiftTo(1, u);

                    if (ac) {
                      if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                      }

                      a.rShiftTo(1, a);
                    } else if (!b.isEven()) b.subTo(m, b);

                    b.rShiftTo(1, b);
                  }

                  while (v.isEven()) {
                    v.rShiftTo(1, v);

                    if (ac) {
                      if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                      }

                      c.rShiftTo(1, c);
                    } else if (!d.isEven()) d.subTo(m, d);

                    d.rShiftTo(1, d);
                  }

                  if (u.compareTo(v) >= 0) {
                    u.subTo(v, u);
                    if (ac) a.subTo(c, a);
                    b.subTo(d, b);
                  } else {
                    v.subTo(u, v);
                    if (ac) c.subTo(a, c);
                    d.subTo(b, d);
                  }
                }

                if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
                if (d.compareTo(m) >= 0) return d.subtract(m);
                if (d.signum() < 0) d.addTo(m, d);else return d;
                if (d.signum() < 0) return d.add(m);else return d;
              }

              var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509];
              var lplim = (1 << 26) / lowprimes[lowprimes.length - 1]; // (public) test primality with certainty >= 1-.5^t

              function bnIsProbablePrime(t) {
                var i,
                    x = this.abs();

                if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
                  for (i = 0; i < lowprimes.length; ++i) if (x[0] == lowprimes[i]) return true;

                  return false;
                }

                if (x.isEven()) return false;
                i = 1;

                while (i < lowprimes.length) {
                  var m = lowprimes[i],
                      j = i + 1;

                  while (j < lowprimes.length && m < lplim) m *= lowprimes[j++];

                  m = x.modInt(m);

                  while (i < j) if (m % lowprimes[i++] == 0) return false;
                }

                return x.millerRabin(t);
              } // (protected) true if probably prime (HAC 4.24, Miller-Rabin)


              function bnpMillerRabin(t) {
                var n1 = this.subtract(BigInteger.ONE);
                var k = n1.getLowestSetBit();
                if (k <= 0) return false;
                var r = n1.shiftRight(k);
                t = t + 1 >> 1;
                if (t > lowprimes.length) t = lowprimes.length;
                var a = nbi();

                for (var i = 0; i < t; ++i) {
                  a.fromInt(lowprimes[i]);
                  var y = a.modPow(r, this);

                  if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                    var j = 1;

                    while (j++ < k && y.compareTo(n1) != 0) {
                      y = y.modPowInt(2, this);
                      if (y.compareTo(BigInteger.ONE) == 0) return false;
                    }

                    if (y.compareTo(n1) != 0) return false;
                  }
                }

                return true;
              } // protected


              BigInteger.prototype.chunkSize = bnpChunkSize;
              BigInteger.prototype.toRadix = bnpToRadix;
              BigInteger.prototype.fromRadix = bnpFromRadix;
              BigInteger.prototype.fromNumber = bnpFromNumber;
              BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
              BigInteger.prototype.changeBit = bnpChangeBit;
              BigInteger.prototype.addTo = bnpAddTo;
              BigInteger.prototype.dMultiply = bnpDMultiply;
              BigInteger.prototype.dAddOffset = bnpDAddOffset;
              BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
              BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
              BigInteger.prototype.modInt = bnpModInt;
              BigInteger.prototype.millerRabin = bnpMillerRabin; // public

              BigInteger.prototype.clone = bnClone;
              BigInteger.prototype.intValue = bnIntValue;
              BigInteger.prototype.byteValue = bnByteValue;
              BigInteger.prototype.shortValue = bnShortValue;
              BigInteger.prototype.signum = bnSigNum;
              BigInteger.prototype.toByteArray = bnToByteArray;
              BigInteger.prototype.equals = bnEquals;
              BigInteger.prototype.min = bnMin;
              BigInteger.prototype.max = bnMax;
              BigInteger.prototype.and = bnAnd;
              BigInteger.prototype.or = bnOr;
              BigInteger.prototype.xor = bnXor;
              BigInteger.prototype.andNot = bnAndNot;
              BigInteger.prototype.not = bnNot;
              BigInteger.prototype.shiftLeft = bnShiftLeft;
              BigInteger.prototype.shiftRight = bnShiftRight;
              BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
              BigInteger.prototype.bitCount = bnBitCount;
              BigInteger.prototype.testBit = bnTestBit;
              BigInteger.prototype.setBit = bnSetBit;
              BigInteger.prototype.clearBit = bnClearBit;
              BigInteger.prototype.flipBit = bnFlipBit;
              BigInteger.prototype.add = bnAdd;
              BigInteger.prototype.subtract = bnSubtract;
              BigInteger.prototype.multiply = bnMultiply;
              BigInteger.prototype.divide = bnDivide;
              BigInteger.prototype.remainder = bnRemainder;
              BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
              BigInteger.prototype.modPow = bnModPow;
              BigInteger.prototype.modInverse = bnModInverse;
              BigInteger.prototype.pow = bnPow;
              BigInteger.prototype.gcd = bnGCD;
              BigInteger.prototype.isProbablePrime = bnIsProbablePrime; // BigInteger interfaces not implemented in jsbn:
              // BigInteger(int signum, byte[] magnitude)
              // double doubleValue()
              // float floatValue()
              // int hashCode()
              // long longValue()
              // static BigInteger valueOf(long val)
              /// METEOR WRAPPER

              return BigInteger;
            }());
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/srp/srp.js");

  /* Exports */
  Package._define("srp", _exports2, {
    SRP: SRP
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Accounts = Package['accounts-base'].Accounts;
  var SRP = Package.srp.SRP;
  var SHA256 = Package.sha.SHA256;
  var EJSON = Package.ejson.EJSON;
  var DDP = Package['ddp-client'].DDP;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "accounts-password": { "password_client.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                            //
            // packages/accounts-password/password_client.js                                                              //
            //                                                                                                            //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);

            // Used in the various functions below to handle errors consistently
            const reportError = (error, callback) => {
              if (callback) {
                callback(error);
              } else {
                throw error;
              }
            }; // Attempt to log in with a password.
            //
            // @param selector {String|Object} One of the following:
            //   - {username: (username)}
            //   - {email: (email)}
            //   - a string which may be a username or email, depending on whether
            //     it contains "@".
            // @param password {String}
            // @param callback {Function(error|undefined)}

            /**
             * @summary Log the user in with a password.
             * @locus Client
             * @param {Object | String} selector
             *   Either a string interpreted as a username or an email; or an object with a
             *   single key: `email`, `username` or `id`. Username or email match in a case
             *   insensitive manner.
             * @param {String} password The user's password.
             * @param {Function} [callback] Optional callback.
             *   Called with no arguments on success, or with a single `Error` argument
             *   on failure.
             * @importFromPackage meteor
             */

            Meteor.loginWithPassword = (selector, password, callback) => {
              if (typeof selector === 'string') if (!selector.includes('@')) selector = {
                username: selector
              };else selector = {
                email: selector
              };
              Accounts.callLoginMethod({
                methodArguments: [{
                  user: selector,
                  password: Accounts._hashPassword(password)
                }],
                userCallback: (error, result) => {
                  if (error && error.error === 400 && error.reason === 'old password format') {
                    // The "reason" string should match the error thrown in the
                    // password login handler in password_server.js.
                    // XXX COMPAT WITH 0.8.1.3
                    // If this user's last login was with a previous version of
                    // Meteor that used SRP, then the server throws this error to
                    // indicate that we should try again. The error includes the
                    // user's SRP identity. We provide a value derived from the
                    // identity and the password to prove to the server that we know
                    // the password without requiring a full SRP flow, as well as
                    // SHA256(password), which the server bcrypts and stores in
                    // place of the old SRP information for this user.
                    srpUpgradePath({
                      upgradeError: error,
                      userSelector: selector,
                      plaintextPassword: password
                    }, callback);
                  } else if (error) {
                    reportError(error, callback);
                  } else {
                    callback && callback();
                  }
                }
              });
            };

            Accounts._hashPassword = password => ({
              digest: SHA256(password),
              algorithm: "sha-256"
            }); // XXX COMPAT WITH 0.8.1.3
            // The server requested an upgrade from the old SRP password format,
            // so supply the needed SRP identity to login. Options:
            //   - upgradeError: the error object that the server returned to tell
            //     us to upgrade from SRP to bcrypt.
            //   - userSelector: selector to retrieve the user object
            //   - plaintextPassword: the password as a string


            const srpUpgradePath = (options, callback) => {
              let details;

              try {
                details = EJSON.parse(options.upgradeError.details);
              } catch (e) {}

              if (!(details && details.format === 'srp')) {
                reportError(new Meteor.Error(400, "Password is old. Please reset your " + "password."), callback);
              } else {
                Accounts.callLoginMethod({
                  methodArguments: [{
                    user: options.userSelector,
                    srp: SHA256("".concat(details.identity, ":").concat(options.plaintextPassword)),
                    password: Accounts._hashPassword(options.plaintextPassword)
                  }],
                  userCallback: callback
                });
              }
            }; // Attempt to log in as a new user.

            /**
             * @summary Create a new user.
             * @locus Anywhere
             * @param {Object} options
             * @param {String} options.username A unique name for this user.
             * @param {String} options.email The user's email address.
             * @param {String} options.password The user's password. This is __not__ sent in plain text over the wire.
             * @param {Object} options.profile The user's profile, typically including the `name` field.
             * @param {Function} [callback] Client only, optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage accounts-base
             */

            Accounts.createUser = (options, callback) => {
              options = _objectSpread({}, options); // we'll be modifying options

              if (typeof options.password !== 'string') throw new Error("options.password must be a string");

              if (!options.password) {
                return reportError(new Meteor.Error(400, "Password may not be empty"), callback);
              } // Replace password with the hashed password.


              options.password = Accounts._hashPassword(options.password);
              Accounts.callLoginMethod({
                methodName: 'createUser',
                methodArguments: [options],
                userCallback: callback
              });
            }; // Change password. Must be logged in.
            //
            // @param oldPassword {String|null} By default servers no longer allow
            //   changing password without the old password, but they could so we
            //   support passing no password to the server and letting it decide.
            // @param newPassword {String}
            // @param callback {Function(error|undefined)}

            /**
             * @summary Change the current user's password. Must be logged in.
             * @locus Client
             * @param {String} oldPassword The user's current password. This is __not__ sent in plain text over the wire.
             * @param {String} newPassword A new password for the user. This is __not__ sent in plain text over the wire.
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage accounts-base
             */

            Accounts.changePassword = (oldPassword, newPassword, callback) => {
              if (!Meteor.user()) {
                return reportError(new Error("Must be logged in to change password."), callback);
              }

              if (!newPassword instanceof String) {
                return reportError(new Meteor.Error(400, "Password must be a string"), callback);
              }

              if (!newPassword) {
                return reportError(new Meteor.Error(400, "Password may not be empty"), callback);
              }

              Accounts.connection.apply('changePassword', [oldPassword ? Accounts._hashPassword(oldPassword) : null, Accounts._hashPassword(newPassword)], (error, result) => {
                if (error || !result) {
                  if (error && error.error === 400 && error.reason === 'old password format') {
                    // XXX COMPAT WITH 0.8.1.3
                    // The server is telling us to upgrade from SRP to bcrypt, as
                    // in Meteor.loginWithPassword.
                    srpUpgradePath({
                      upgradeError: error,
                      userSelector: {
                        id: Meteor.userId()
                      },
                      plaintextPassword: oldPassword
                    }, err => {
                      if (err) {
                        reportError(err, callback);
                      } else {
                        // Now that we've successfully migrated from srp to
                        // bcrypt, try changing the password again.
                        Accounts.changePassword(oldPassword, newPassword, callback);
                      }
                    });
                  } else {
                    // A normal error, not an error telling us to upgrade to bcrypt
                    reportError(error || new Error("No result from changePassword."), callback);
                  }
                } else {
                  callback && callback();
                }
              });
            }; // Sends an email to a user with a link that can be used to reset
            // their password
            //
            // @param options {Object}
            //   - email: (email)
            // @param callback (optional) {Function(error|undefined)}

            /**
             * @summary Request a forgot password email.
             * @locus Client
             * @param {Object} options
             * @param {String} options.email The email address to send a password reset link.
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage accounts-base
             */

            Accounts.forgotPassword = (options, callback) => {
              if (!options.email) {
                return reportError(new Meteor.Error(400, "Must pass options.email"), callback);
              }

              if (callback) {
                Accounts.connection.call("forgotPassword", options, callback);
              } else {
                Accounts.connection.call("forgotPassword", options);
              }
            }; // Resets a password based on a token originally created by
            // Accounts.forgotPassword, and then logs in the matching user.
            //
            // @param token {String}
            // @param newPassword {String}
            // @param callback (optional) {Function(error|undefined)}

            /**
             * @summary Reset the password for a user using a token received in email. Logs the user in afterwards.
             * @locus Client
             * @param {String} token The token retrieved from the reset password URL.
             * @param {String} newPassword A new password for the user. This is __not__ sent in plain text over the wire.
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage accounts-base
             */

            Accounts.resetPassword = (token, newPassword, callback) => {
              if (!token instanceof String) {
                return reportError(new Meteor.Error(400, "Token must be a string"), callback);
              }

              if (!newPassword instanceof String) {
                return reportError(new Meteor.Error(400, "Password must be a string"), callback);
              }

              if (!newPassword) {
                return reportError(new Meteor.Error(400, "Password may not be empty"), callback);
              }

              Accounts.callLoginMethod({
                methodName: 'resetPassword',
                methodArguments: [token, Accounts._hashPassword(newPassword)],
                userCallback: callback
              });
            }; // Verifies a user's email address based on a token originally
            // created by Accounts.sendVerificationEmail
            //
            // @param token {String}
            // @param callback (optional) {Function(error|undefined)}

            /**
             * @summary Marks the user's email address as verified. Logs the user in afterwards.
             * @locus Client
             * @param {String} token The token retrieved from the verification URL.
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure.
             * @importFromPackage accounts-base
             */

            Accounts.verifyEmail = (token, callback) => {
              if (!token) {
                return reportError(new Meteor.Error(400, "Need to pass token"), callback);
              }

              Accounts.callLoginMethod({
                methodName: 'verifyEmail',
                methodArguments: [token],
                userCallback: callback
              });
            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require2("/node_modules/meteor/accounts-password/password_client.js");

  /* Exports */
  Package._define("accounts-password");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("zodern:types");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Accounts = Package['accounts-base'].Accounts;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var Mongo = Package.mongo.Mongo;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Roles;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "alanning:roles": { "roles": { "roles_common.js": function module(_require, _exports, _module) {

              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                     //
              // packages/alanning_roles/roles/roles_common.js                                                                       //
              //                                                                                                                     //
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              !function (module1) {
                /* global Meteor, Roles, Mongo */

                /**
                 * Provides functions related to user authorization. Compatible with built-in Meteor accounts packages.
                 *
                 * Roles are accessible throgh `Meteor.roles` collection and documents consist of:
                 *  - `_id`: role name
                 *  - `children`: list of subdocuments:
                 *    - `_id`
                 *
                 * Children list elements are subdocuments so that they can be easier extended in the future or by plugins.
                 *
                 * Roles can have multiple parents and can be children (subroles) of multiple roles.
                 *
                 * Example: `{_id: 'admin', children: [{_id: 'editor'}]}`
                 *
                 * The assignment of a role to a user is stored in a collection, accessible through `Meteor.roleAssignment`.
                 * It's documents consist of
                 *  - `_id`: Internal MongoDB id
                 *  - `role`: A role object which got assigned. Usually only contains the `_id` property
                 *  - `user`: A user object, usually only contains the `_id` property
                 *  - `scope`: scope name
                 *  - `inheritedRoles`: A list of all the roles objects inherited by the assigned role.
                 *
                 * @module Roles
                 */
                if (!Meteor.roles) {
                  Meteor.roles = new Mongo.Collection('roles');
                }

                if (!Meteor.roleAssignment) {
                  Meteor.roleAssignment = new Mongo.Collection('role-assignment');
                }
                /**
                 * @class Roles
                 */

                if (typeof Roles === 'undefined') {
                  Roles = {}; // eslint-disable-line no-global-assign
                }

                var getGroupsForUserDeprecationWarning = false;
                Object.assign(Roles, {
                  /**
                   * Used as a global group (now scope) name. Not used anymore.
                   *
                   * @property GLOBAL_GROUP
                   * @static
                   * @deprecated
                   */
                  GLOBAL_GROUP: null,

                  /**
                   * Create a new role.
                   *
                   * @method createRole
                   * @param {String} roleName Name of role.
                   * @param {Object} [options] Options:
                   *   - `unlessExists`: if `true`, exception will not be thrown in the role already exists
                   * @return {String} ID of the new role or null.
                   * @static
                   */
                  createRole: function (roleName, options) {
                    Roles._checkRoleName(roleName);

                    options = Object.assign({
                      unlessExists: false
                    }, options);
                    var result = Meteor.roles.upsert({
                      _id: roleName
                    }, {
                      $setOnInsert: {
                        children: []
                      }
                    });

                    if (!result.insertedId) {
                      if (options.unlessExists) return null;
                      throw new Error('Role \'' + roleName + '\' already exists.');
                    }

                    return result.insertedId;
                  },

                  /**
                   * Delete an existing role.
                   *
                   * If the role is set for any user, it is automatically unset.
                   *
                   * @method deleteRole
                   * @param {String} roleName Name of role.
                   * @static
                   */
                  deleteRole: function (roleName) {
                    var roles;
                    var inheritedRoles;

                    Roles._checkRoleName(roleName); // Remove all assignments


                    Meteor.roleAssignment.remove({
                      'role._id': roleName
                    });

                    do {
                      // For all roles who have it as a dependency ...
                      roles = Roles._getParentRoleNames(Meteor.roles.findOne({
                        _id: roleName
                      }));
                      Meteor.roles.find({
                        _id: {
                          $in: roles
                        }
                      }).fetch().forEach(r => {
                        Meteor.roles.update({
                          _id: r._id
                        }, {
                          $pull: {
                            children: {
                              _id: roleName
                            }
                          }
                        });
                        inheritedRoles = Roles._getInheritedRoleNames(Meteor.roles.findOne({
                          _id: r._id
                        }));
                        Meteor.roleAssignment.update({
                          'role._id': r._id
                        }, {
                          $set: {
                            inheritedRoles: [r._id, ...inheritedRoles].map(r2 => ({
                              _id: r2
                            }))
                          }
                        }, {
                          multi: true
                        });
                      });
                    } while (roles.length > 0); // And finally remove the role itself


                    Meteor.roles.remove({
                      _id: roleName
                    });
                  },

                  /**
                   * Rename an existing role.
                   *
                   * @method renameRole
                   * @param {String} oldName Old name of a role.
                   * @param {String} newName New name of a role.
                   * @static
                   */
                  renameRole: function (oldName, newName) {
                    var role;
                    var count;

                    Roles._checkRoleName(oldName);

                    Roles._checkRoleName(newName);

                    if (oldName === newName) return;
                    role = Meteor.roles.findOne({
                      _id: oldName
                    });

                    if (!role) {
                      throw new Error('Role \'' + oldName + '\' does not exist.');
                    }

                    role._id = newName;
                    Meteor.roles.insert(role);

                    do {
                      count = Meteor.roleAssignment.update({
                        'role._id': oldName
                      }, {
                        $set: {
                          'role._id': newName
                        }
                      }, {
                        multi: true
                      });
                    } while (count > 0);

                    do {
                      count = Meteor.roleAssignment.update({
                        'inheritedRoles._id': oldName
                      }, {
                        $set: {
                          'inheritedRoles.$._id': newName
                        }
                      }, {
                        multi: true
                      });
                    } while (count > 0);

                    do {
                      count = Meteor.roles.update({
                        'children._id': oldName
                      }, {
                        $set: {
                          'children.$._id': newName
                        }
                      }, {
                        multi: true
                      });
                    } while (count > 0);

                    Meteor.roles.remove({
                      _id: oldName
                    });
                  },

                  /**
                   * Add role parent to roles.
                   *
                   * Previous parents are kept (role can have multiple parents). For users which have the
                   * parent role set, new subroles are added automatically.
                   *
                   * @method addRolesToParent
                   * @param {Array|String} rolesNames Name(s) of role(s).
                   * @param {String} parentName Name of parent role.
                   * @static
                   */
                  addRolesToParent: function (rolesNames, parentName) {
                    // ensure arrays
                    if (!Array.isArray(rolesNames)) rolesNames = [rolesNames];
                    rolesNames.forEach(function (roleName) {
                      Roles._addRoleToParent(roleName, parentName);
                    });
                  },

                  /**
                   * @method _addRoleToParent
                   * @param {String} roleName Name of role.
                   * @param {String} parentName Name of parent role.
                   * @private
                   * @static
                   */
                  _addRoleToParent: function (roleName, parentName) {
                    var role;
                    var count;

                    Roles._checkRoleName(roleName);

                    Roles._checkRoleName(parentName); // query to get role's children


                    role = Meteor.roles.findOne({
                      _id: roleName
                    });

                    if (!role) {
                      throw new Error('Role \'' + roleName + '\' does not exist.');
                    } // detect cycles


                    if (Roles._getInheritedRoleNames(role).includes(parentName)) {
                      throw new Error('Roles \'' + roleName + '\' and \'' + parentName + '\' would form a cycle.');
                    }

                    count = Meteor.roles.update({
                      _id: parentName,
                      'children._id': {
                        $ne: role._id
                      }
                    }, {
                      $push: {
                        children: {
                          _id: role._id
                        }
                      }
                    }); // if there was no change, parent role might not exist, or role is
                    // already a subrole; in any case we do not have anything more to do

                    if (!count) return;
                    Meteor.roleAssignment.update({
                      'inheritedRoles._id': parentName
                    }, {
                      $push: {
                        inheritedRoles: {
                          $each: [role._id, ...Roles._getInheritedRoleNames(role)].map(r => ({
                            _id: r
                          }))
                        }
                      }
                    }, {
                      multi: true
                    });
                  },

                  /**
                   * Remove role parent from roles.
                   *
                   * Other parents are kept (role can have multiple parents). For users which have the
                   * parent role set, removed subrole is removed automatically.
                   *
                   * @method removeRolesFromParent
                   * @param {Array|String} rolesNames Name(s) of role(s).
                   * @param {String} parentName Name of parent role.
                   * @static
                   */
                  removeRolesFromParent: function (rolesNames, parentName) {
                    // ensure arrays
                    if (!Array.isArray(rolesNames)) rolesNames = [rolesNames];
                    rolesNames.forEach(function (roleName) {
                      Roles._removeRoleFromParent(roleName, parentName);
                    });
                  },

                  /**
                   * @method _removeRoleFromParent
                   * @param {String} roleName Name of role.
                   * @param {String} parentName Name of parent role.
                   * @private
                   * @static
                   */
                  _removeRoleFromParent: function (roleName, parentName) {
                    Roles._checkRoleName(roleName);

                    Roles._checkRoleName(parentName); // check for role existence
                    // this would not really be needed, but we are trying to match addRolesToParent


                    let role = Meteor.roles.findOne({
                      _id: roleName
                    }, {
                      fields: {
                        _id: 1
                      }
                    });

                    if (!role) {
                      throw new Error('Role \'' + roleName + '\' does not exist.');
                    }

                    const count = Meteor.roles.update({
                      _id: parentName
                    }, {
                      $pull: {
                        children: {
                          _id: role._id
                        }
                      }
                    }); // if there was no change, parent role might not exist, or role was
                    // already not a subrole; in any case we do not have anything more to do

                    if (!count) return; // For all roles who have had it as a dependency ...

                    const roles = [...Roles._getParentRoleNames(Meteor.roles.findOne({
                      _id: parentName
                    })), parentName];
                    Meteor.roles.find({
                      _id: {
                        $in: roles
                      }
                    }).fetch().forEach(r => {
                      const inheritedRoles = Roles._getInheritedRoleNames(Meteor.roles.findOne({
                        _id: r._id
                      }));

                      Meteor.roleAssignment.update({
                        'role._id': r._id,
                        'inheritedRoles._id': role._id
                      }, {
                        $set: {
                          inheritedRoles: [r._id, ...inheritedRoles].map(r2 => ({
                            _id: r2
                          }))
                        }
                      }, {
                        multi: true
                      });
                    });
                  },

                  /**
                   * Add users to roles.
                   *
                   * Adds roles to existing roles for each user.
                   *
                   * @example
                   *     Roles.addUsersToRoles(userId, 'admin')
                   *     Roles.addUsersToRoles(userId, ['view-secrets'], 'example.com')
                   *     Roles.addUsersToRoles([user1, user2], ['user','editor'])
                   *     Roles.addUsersToRoles([user1, user2], ['glorious-admin', 'perform-action'], 'example.org')
                   *
                   * @method addUsersToRoles
                   * @param {Array|String} users User ID(s) or object(s) with an `_id` field.
                   * @param {Array|String} roles Name(s) of roles to add users to. Roles have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope, or `null` for the global role
                   *   - `ifExists`: if `true`, do not throw an exception if the role does not exist
                   *
                   * Alternatively, it can be a scope name string.
                   * @static
                   */
                  addUsersToRoles: function (users, roles, options) {
                    var id;
                    if (!users) throw new Error('Missing \'users\' param.');
                    if (!roles) throw new Error('Missing \'roles\' param.');
                    options = Roles._normalizeOptions(options); // ensure arrays

                    if (!Array.isArray(users)) users = [users];
                    if (!Array.isArray(roles)) roles = [roles];

                    Roles._checkScopeName(options.scope);

                    options = Object.assign({
                      ifExists: false
                    }, options);
                    users.forEach(function (user) {
                      if (typeof user === 'object') {
                        id = user._id;
                      } else {
                        id = user;
                      }

                      roles.forEach(function (role) {
                        Roles._addUserToRole(id, role, options);
                      });
                    });
                  },

                  /**
                   * Set users' roles.
                   *
                   * Replaces all existing roles with a new set of roles.
                   *
                   * @example
                   *     Roles.setUserRoles(userId, 'admin')
                   *     Roles.setUserRoles(userId, ['view-secrets'], 'example.com')
                   *     Roles.setUserRoles([user1, user2], ['user','editor'])
                   *     Roles.setUserRoles([user1, user2], ['glorious-admin', 'perform-action'], 'example.org')
                   *
                   * @method setUserRoles
                   * @param {Array|String} users User ID(s) or object(s) with an `_id` field.
                   * @param {Array|String} roles Name(s) of roles to add users to. Roles have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope, or `null` for the global role
                   *   - `anyScope`: if `true`, remove all roles the user has, of any scope, if `false`, only the one in the same scope
                   *   - `ifExists`: if `true`, do not throw an exception if the role does not exist
                   *
                   * Alternatively, it can be a scope name string.
                   * @static
                   */
                  setUserRoles: function (users, roles, options) {
                    var id;
                    if (!users) throw new Error('Missing \'users\' param.');
                    if (!roles) throw new Error('Missing \'roles\' param.');
                    options = Roles._normalizeOptions(options); // ensure arrays

                    if (!Array.isArray(users)) users = [users];
                    if (!Array.isArray(roles)) roles = [roles];

                    Roles._checkScopeName(options.scope);

                    options = Object.assign({
                      ifExists: false,
                      anyScope: false
                    }, options);
                    users.forEach(function (user) {
                      if (typeof user === 'object') {
                        id = user._id;
                      } else {
                        id = user;
                      } // we first clear all roles for the user


                      const selector = {
                        'user._id': id
                      };

                      if (!options.anyScope) {
                        selector.scope = options.scope;
                      }

                      Meteor.roleAssignment.remove(selector); // and then add all

                      roles.forEach(function (role) {
                        Roles._addUserToRole(id, role, options);
                      });
                    });
                  },

                  /**
                   * Add one user to one role.
                   *
                   * @method _addUserToRole
                   * @param {String} userId The user ID.
                   * @param {String} roleName Name of the role to add the user to. The role have to exist.
                   * @param {Object} options Options:
                   *   - `scope`: name of the scope, or `null` for the global role
                   *   - `ifExists`: if `true`, do not throw an exception if the role does not exist
                   * @private
                   * @static
                   */
                  _addUserToRole: function (userId, roleName, options) {
                    Roles._checkRoleName(roleName);

                    Roles._checkScopeName(options.scope);

                    if (!userId) {
                      return;
                    }

                    const role = Meteor.roles.findOne({
                      _id: roleName
                    }, {
                      fields: {
                        children: 1
                      }
                    });

                    if (!role) {
                      if (options.ifExists) {
                        return [];
                      } else {
                        throw new Error('Role \'' + roleName + '\' does not exist.');
                      }
                    } // This might create duplicates, because we don't have a unique index, but that's all right. In case there are two, withdrawing the role will effectively kill them both.


                    const res = Meteor.roleAssignment.upsert({
                      'user._id': userId,
                      'role._id': roleName,
                      scope: options.scope
                    }, {
                      $setOnInsert: {
                        user: {
                          _id: userId
                        },
                        role: {
                          _id: roleName
                        },
                        scope: options.scope
                      }
                    });

                    if (res.insertedId) {
                      Meteor.roleAssignment.update({
                        _id: res.insertedId
                      }, {
                        $set: {
                          inheritedRoles: [roleName, ...Roles._getInheritedRoleNames(role)].map(r => ({
                            _id: r
                          }))
                        }
                      });
                    }

                    return res;
                  },

                  /**
                   * Returns an array of role names the given role name is a child of.
                   *
                   * @example
                   *     Roles._getParentRoleNames({ _id: 'admin', children; [] })
                   *
                   * @method _getParentRoleNames
                   * @param {object} role The role object
                   * @private
                   * @static
                   */
                  _getParentRoleNames: function (role) {
                    var parentRoles;

                    if (!role) {
                      return [];
                    }

                    parentRoles = new Set([role._id]);
                    parentRoles.forEach(roleName => {
                      Meteor.roles.find({
                        'children._id': roleName
                      }).fetch().forEach(parentRole => {
                        parentRoles.add(parentRole._id);
                      });
                    });
                    parentRoles.delete(role._id);
                    return [...parentRoles];
                  },

                  /**
                   * Returns an array of role names the given role name is a parent of.
                   *
                   * @example
                   *     Roles._getInheritedRoleNames({ _id: 'admin', children; [] })
                   *
                   * @method _getInheritedRoleNames
                   * @param {object} role The role object
                   * @private
                   * @static
                   */
                  _getInheritedRoleNames: function (role) {
                    const inheritedRoles = new Set();
                    const nestedRoles = new Set([role]);
                    nestedRoles.forEach(r => {
                      const roles = Meteor.roles.find({
                        _id: {
                          $in: r.children.map(r => r._id)
                        }
                      }, {
                        fields: {
                          children: 1
                        }
                      }).fetch();
                      roles.forEach(r2 => {
                        inheritedRoles.add(r2._id);
                        nestedRoles.add(r2);
                      });
                    });
                    return [...inheritedRoles];
                  },

                  /**
                   * Remove users from assigned roles.
                   *
                   * @example
                   *     Roles.removeUsersFromRoles(userId, 'admin')
                   *     Roles.removeUsersFromRoles([userId, user2], ['editor'])
                   *     Roles.removeUsersFromRoles(userId, ['user'], 'group1')
                   *
                   * @method removeUsersFromRoles
                   * @param {Array|String} users User ID(s) or object(s) with an `_id` field.
                   * @param {Array|String} roles Name(s) of roles to remove users from. Roles have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope, or `null` for the global role
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   *
                   * Alternatively, it can be a scope name string.
                   * @static
                   */
                  removeUsersFromRoles: function (users, roles, options) {
                    if (!users) throw new Error('Missing \'users\' param.');
                    if (!roles) throw new Error('Missing \'roles\' param.');
                    options = Roles._normalizeOptions(options); // ensure arrays

                    if (!Array.isArray(users)) users = [users];
                    if (!Array.isArray(roles)) roles = [roles];

                    Roles._checkScopeName(options.scope);

                    users.forEach(function (user) {
                      if (!user) return;
                      roles.forEach(function (role) {
                        let id;

                        if (typeof user === 'object') {
                          id = user._id;
                        } else {
                          id = user;
                        }

                        Roles._removeUserFromRole(id, role, options);
                      });
                    });
                  },

                  /**
                   * Remove one user from one role.
                   *
                   * @method _removeUserFromRole
                   * @param {String} userId The user ID.
                   * @param {String} roleName Name of the role to add the user to. The role have to exist.
                   * @param {Object} options Options:
                   *   - `scope`: name of the scope, or `null` for the global role
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   * @private
                   * @static
                   */
                  _removeUserFromRole: function (userId, roleName, options) {
                    Roles._checkRoleName(roleName);

                    Roles._checkScopeName(options.scope);

                    if (!userId) return;
                    const selector = {
                      'user._id': userId,
                      'role._id': roleName
                    };

                    if (!options.anyScope) {
                      selector.scope = options.scope;
                    }

                    Meteor.roleAssignment.remove(selector);
                  },

                  /**
                   * Check if user has specified roles.
                   *
                   * @example
                   *     // global roles
                   *     Roles.userIsInRole(user, 'admin')
                   *     Roles.userIsInRole(user, ['admin','editor'])
                   *     Roles.userIsInRole(userId, 'admin')
                   *     Roles.userIsInRole(userId, ['admin','editor'])
                   *
                   *     // scope roles (global roles are still checked)
                   *     Roles.userIsInRole(user, 'admin', 'group1')
                   *     Roles.userIsInRole(userId, ['admin','editor'], 'group1')
                   *     Roles.userIsInRole(userId, ['admin','editor'], {scope: 'group1'})
                   *
                   * @method userIsInRole
                   * @param {String|Object} user User ID or an actual user object.
                   * @param {Array|String} roles Name of role or an array of roles to check against. If array,
                   *                             will return `true` if user is in _any_ role.
                   *                             Roles do not have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope; if supplied, limits check to just that scope
                   *     the user's global roles will always be checked whether scope is specified or not
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   *
                   * Alternatively, it can be a scope name string.
                   * @return {Boolean} `true` if user is in _any_ of the target roles
                   * @static
                   */
                  userIsInRole: function (user, roles, options) {
                    var id;
                    var selector;
                    options = Roles._normalizeOptions(options); // ensure array to simplify code

                    if (!Array.isArray(roles)) roles = [roles];
                    roles = roles.filter(r => r != null);
                    if (!roles.length) return false;

                    Roles._checkScopeName(options.scope);

                    options = Object.assign({
                      anyScope: false
                    }, options);

                    if (user && typeof user === 'object') {
                      id = user._id;
                    } else {
                      id = user;
                    }

                    if (!id) return false;
                    if (typeof id !== 'string') return false;
                    selector = {
                      'user._id': id
                    };

                    if (!options.anyScope) {
                      selector.scope = {
                        $in: [options.scope, null]
                      };
                    }

                    return roles.some(roleName => {
                      selector['inheritedRoles._id'] = roleName;
                      return Meteor.roleAssignment.find(selector, {
                        limit: 1
                      }).count() > 0;
                    });
                  },

                  /**
                   * Retrieve user's roles.
                   *
                   * @method getRolesForUser
                   * @param {String|Object} user User ID or an actual user object.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of scope to provide roles for; if not specified, global roles are returned
                   *   - `anyScope`: if set, role can be in any scope (`scope` and `onlyAssigned` options are ignored)
                   *   - `onlyScoped`: if set, only roles in the specified scope are returned
                   *   - `onlyAssigned`: return only assigned roles and not automatically inferred (like subroles)
                   *   - `fullObjects`: return full roles objects (`true`) or just names (`false`) (`onlyAssigned` option is ignored) (default `false`)
                   *     If you have a use-case for this option, please file a feature-request. You shouldn't need to use it as it's
                   *     result strongly dependant on the internal data structure of this plugin.
                   *
                   * Alternatively, it can be a scope name string.
                   * @return {Array} Array of user's roles, unsorted.
                   * @static
                   */
                  getRolesForUser: function (user, options) {
                    var id;
                    var selector;
                    var filter;
                    var roles;
                    options = Roles._normalizeOptions(options);

                    Roles._checkScopeName(options.scope);

                    options = Object.assign({
                      fullObjects: false,
                      onlyAssigned: false,
                      anyScope: false,
                      onlyScoped: false
                    }, options);

                    if (user && typeof user === 'object') {
                      id = user._id;
                    } else {
                      id = user;
                    }

                    if (!id) return [];
                    selector = {
                      'user._id': id
                    };
                    filter = {
                      fields: {
                        'inheritedRoles._id': 1
                      }
                    };

                    if (!options.anyScope) {
                      selector.scope = {
                        $in: [options.scope]
                      };

                      if (!options.onlyScoped) {
                        selector.scope.$in.push(null);
                      }
                    }

                    if (options.onlyAssigned) {
                      delete filter.fields['inheritedRoles._id'];
                      filter.fields['role._id'] = 1;
                    }

                    if (options.fullObjects) {
                      delete filter.fields;
                    }

                    roles = Meteor.roleAssignment.find(selector, filter).fetch();

                    if (options.fullObjects) {
                      return roles;
                    }

                    return [...new Set(roles.reduce((rev, current) => {
                      if (current.inheritedRoles) {
                        return rev.concat(current.inheritedRoles.map(r => r._id));
                      } else if (current.role) {
                        rev.push(current.role._id);
                      }

                      return rev;
                    }, []))];
                  },

                  /**
                   * Retrieve cursor of all existing roles.
                   *
                   * @method getAllRoles
                   * @param {Object} queryOptions Options which are passed directly
                   *                                through to `Meteor.roles.find(query, options)`.
                   * @return {Cursor} Cursor of existing roles.
                   * @static
                   */
                  getAllRoles: function (queryOptions) {
                    queryOptions = queryOptions || {
                      sort: {
                        _id: 1
                      }
                    };
                    return Meteor.roles.find({}, queryOptions);
                  },

                  /**
                   * Retrieve all users who are in target role.
                   *
                   * Options:
                   *
                   * @method getUsersInRole
                   * @param {Array|String} roles Name of role or an array of roles. If array, users
                   *                             returned will have at least one of the roles
                   *                             specified but need not have _all_ roles.
                   *                             Roles do not have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope to restrict roles to; user's global
                   *     roles will also be checked
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   *   - `onlyScoped`: if set, only roles in the specified scope are returned
                   *   - `queryOptions`: options which are passed directly
                   *     through to `Meteor.users.find(query, options)`
                   *
                   * Alternatively, it can be a scope name string.
                   * @param {Object} [queryOptions] Options which are passed directly
                   *                                through to `Meteor.users.find(query, options)`
                   * @return {Cursor} Cursor of users in roles.
                   * @static
                   */
                  getUsersInRole: function (roles, options, queryOptions) {
                    var ids;
                    ids = Roles.getUserAssignmentsForRole(roles, options).fetch().map(a => a.user._id);
                    return Meteor.users.find({
                      _id: {
                        $in: ids
                      }
                    }, options && options.queryOptions || queryOptions || {});
                  },

                  /**
                   * Retrieve all assignments of a user which are for the target role.
                   *
                   * Options:
                   *
                   * @method getUserAssignmentsForRole
                   * @param {Array|String} roles Name of role or an array of roles. If array, users
                   *                             returned will have at least one of the roles
                   *                             specified but need not have _all_ roles.
                   *                             Roles do not have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope to restrict roles to; user's global
                   *     roles will also be checked
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   *   - `queryOptions`: options which are passed directly
                   *     through to `Meteor.roleAssignment.find(query, options)`
                   *
                   * Alternatively, it can be a scope name string.
                   * @return {Cursor} Cursor of user assignments for roles.
                   * @static
                   */
                  getUserAssignmentsForRole: function (roles, options) {
                    options = Roles._normalizeOptions(options);
                    options = Object.assign({
                      anyScope: false,
                      queryOptions: {}
                    }, options);
                    return Roles._getUsersInRoleCursor(roles, options, options.queryOptions);
                  },

                  /**
                   * @method _getUsersInRoleCursor
                   * @param {Array|String} roles Name of role or an array of roles. If array, ids of users are
                   *                             returned which have at least one of the roles
                   *                             assigned but need not have _all_ roles.
                   *                             Roles do not have to exist.
                   * @param {Object|String} [options] Options:
                   *   - `scope`: name of the scope to restrict roles to; user's global
                   *     roles will also be checked
                   *   - `anyScope`: if set, role can be in any scope (`scope` option is ignored)
                   *
                   * Alternatively, it can be a scope name string.
                   * @param {Object} [filter] Options which are passed directly
                   *                                through to `Meteor.roleAssignment.find(query, options)`
                   * @return {Object} Cursor to the assignment documents
                   * @private
                   * @static
                   */
                  _getUsersInRoleCursor: function (roles, options, filter) {
                    var selector;
                    options = Roles._normalizeOptions(options);
                    options = Object.assign({
                      anyScope: false,
                      onlyScoped: false
                    }, options); // ensure array to simplify code

                    if (!Array.isArray(roles)) roles = [roles];

                    Roles._checkScopeName(options.scope);

                    filter = Object.assign({
                      fields: {
                        'user._id': 1
                      }
                    }, filter);
                    selector = {
                      'inheritedRoles._id': {
                        $in: roles
                      }
                    };

                    if (!options.anyScope) {
                      selector.scope = {
                        $in: [options.scope]
                      };

                      if (!options.onlyScoped) {
                        selector.scope.$in.push(null);
                      }
                    }

                    return Meteor.roleAssignment.find(selector, filter);
                  },

                  /**
                   * Deprecated. Use `getScopesForUser` instead.
                   *
                   * @method getGroupsForUser
                   * @static
                   * @deprecated
                   */
                  getGroupsForUser: function () {
                    if (!getGroupsForUserDeprecationWarning) {
                      getGroupsForUserDeprecationWarning = true;
                      console && console.warn('getGroupsForUser has been deprecated. Use getScopesForUser instead.');
                    }

                    return Roles.getScopesForUser(...arguments);
                  },

                  /**
                   * Retrieve users scopes, if any.
                   *
                   * @method getScopesForUser
                   * @param {String|Object} user User ID or an actual user object.
                   * @param {Array|String} [roles] Name of roles to restrict scopes to.
                   *
                   * @return {Array} Array of user's scopes, unsorted.
                   * @static
                   */
                  getScopesForUser: function (user, roles) {
                    var scopes;
                    var id;
                    if (roles && !Array.isArray(roles)) roles = [roles];

                    if (user && typeof user === 'object') {
                      id = user._id;
                    } else {
                      id = user;
                    }

                    if (!id) return [];
                    const selector = {
                      'user._id': id,
                      scope: {
                        $ne: null
                      }
                    };

                    if (roles) {
                      selector['inheritedRoles._id'] = {
                        $in: roles
                      };
                    }

                    scopes = Meteor.roleAssignment.find(selector, {
                      fields: {
                        scope: 1
                      }
                    }).fetch().map(obi => obi.scope);
                    return [...new Set(scopes)];
                  },

                  /**
                   * Rename a scope.
                   *
                   * Roles assigned with a given scope are changed to be under the new scope.
                   *
                   * @method renameScope
                   * @param {String} oldName Old name of a scope.
                   * @param {String} newName New name of a scope.
                   * @static
                   */
                  renameScope: function (oldName, newName) {
                    var count;

                    Roles._checkScopeName(oldName);

                    Roles._checkScopeName(newName);

                    if (oldName === newName) return;

                    do {
                      count = Meteor.roleAssignment.update({
                        scope: oldName
                      }, {
                        $set: {
                          scope: newName
                        }
                      }, {
                        multi: true
                      });
                    } while (count > 0);
                  },

                  /**
                   * Remove a scope.
                   *
                   * Roles assigned with a given scope are removed.
                   *
                   * @method removeScope
                   * @param {String} name The name of a scope.
                   * @static
                   */
                  removeScope: function (name) {
                    Roles._checkScopeName(name);

                    Meteor.roleAssignment.remove({
                      scope: name
                    });
                  },

                  /**
                   * Throw an exception if `roleName` is an invalid role name.
                   *
                   * @method _checkRoleName
                   * @param {String} roleName A role name to match against.
                   * @private
                   * @static
                   */
                  _checkRoleName: function (roleName) {
                    if (!roleName || typeof roleName !== 'string' || roleName.trim() !== roleName) {
                      throw new Error('Invalid role name \'' + roleName + '\'.');
                    }
                  },

                  /**
                   * Find out if a role is an ancestor of another role.
                   *
                   * WARNING: If you check this on the client, please make sure all roles are published.
                   *
                   * @method isParentOf
                   * @param {String} parentRoleName The role you want to research.
                   * @param {String} childRoleName The role you expect to be among the children of parentRoleName.
                   * @static
                   */
                  isParentOf: function (parentRoleName, childRoleName) {
                    if (parentRoleName === childRoleName) {
                      return true;
                    }

                    if (parentRoleName == null || childRoleName == null) {
                      return false;
                    }

                    Roles._checkRoleName(parentRoleName);

                    Roles._checkRoleName(childRoleName);

                    var rolesToCheck = [parentRoleName];

                    while (rolesToCheck.length !== 0) {
                      var roleName = rolesToCheck.pop();

                      if (roleName === childRoleName) {
                        return true;
                      }

                      var role = Meteor.roles.findOne({
                        _id: roleName
                      }); // This should not happen, but this is a problem to address at some other time.

                      if (!role) continue;
                      rolesToCheck = rolesToCheck.concat(role.children.map(r => r._id));
                    }

                    return false;
                  },

                  /**
                   * Normalize options.
                   *
                   * @method _normalizeOptions
                   * @param {Object} options Options to normalize.
                   * @return {Object} Normalized options.
                   * @private
                   * @static
                   */
                  _normalizeOptions: function (options) {
                    options = options === undefined ? {} : options;

                    if (options === null || typeof options === 'string') {
                      options = {
                        scope: options
                      };
                    }

                    options.scope = Roles._normalizeScopeName(options.scope);
                    return options;
                  },

                  /**
                   * Normalize scope name.
                   *
                   * @method _normalizeScopeName
                   * @param {String} scopeName A scope name to normalize.
                   * @return {String} Normalized scope name.
                   * @private
                   * @static
                   */
                  _normalizeScopeName: function (scopeName) {
                    // map undefined and null to null
                    if (scopeName == null) {
                      return null;
                    } else {
                      return scopeName;
                    }
                  },

                  /**
                   * Throw an exception if `scopeName` is an invalid scope name.
                   *
                   * @method _checkRoleName
                   * @param {String} scopeName A scope name to match against.
                   * @private
                   * @static
                   */
                  _checkScopeName: function (scopeName) {
                    if (scopeName === null) return;

                    if (!scopeName || typeof scopeName !== 'string' || scopeName.trim() !== scopeName) {
                      throw new Error('Invalid scope name \'' + scopeName + '\'.');
                    }
                  }
                });
              }.call(this, _module);
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "client": { "debug.js": function _module2() {

                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                     //
                // packages/alanning_roles/roles/client/debug.js                                                                       //
                //                                                                                                                     //
                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /* global Roles, localStorage */
                // //////////////////////////////////////////////////////////
                // Debugging helpers
                //
                // Run this in your browser console to turn on debugging
                // for this package:
                //
                //   localstorage.setItem('Roles.debug', true)
                //
                Roles.debug = false;

                try {
                  if (localStorage) {
                    var temp = localStorage.getItem('Roles.debug');

                    if (typeof temp !== 'undefined') {
                      Roles.debug = !!temp;
                    }
                  }
                } catch (ex) {} // ignore: accessing localStorage when its disabled throws
                // https://github.com/meteor/meteor/issues/5759

                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "uiHelpers.js": function module(_require3, _exports2, _module3) {

                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                     //
                // packages/alanning_roles/roles/client/uiHelpers.js                                                                   //
                //                                                                                                                     //
                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                !function (module1) {
                  /* global Meteor, Roles, Match, Package */

                  /**
                   * Convenience functions for use on client.
                   *
                   * NOTE: You must restrict user actions on the server-side; any
                   * client-side checks are strictly for convenience and must not be
                   * trusted.
                   *
                   * @module UIHelpers
                   */
                  // //////////////////////////////////////////////////////////
                  // UI helpers
                  //
                  // Use a semi-private variable rather than declaring UI
                  // helpers directly so that we can unit test the helpers.
                  // XXX For some reason, the UI helpers are not registered
                  // before the tests run.
                  //
                  Roles._uiHelpers = {
                    /**
                     * UI helper to check if current user is in at least one
                     * of the target roles.  For use in client-side templates.
                     *
                     * @example
                     *     {{#if isInRole 'admin'}}
                     *     {{/if}}
                     *
                     *     {{#if isInRole 'editor,user'}}
                     *     {{/if}}
                     *
                     *     {{#if isInRole 'editor,user' 'scope1'}}
                     *     {{/if}}
                     *
                     * @method isInRole
                     * @param {String} role Name of role or comma-seperated list of roles.
                     * @param {String} [scope] Optional, name of scope to check.
                     * @return {Boolean} `true` if current user is in at least one of the target roles.
                     * @static
                     * @for UIHelpers
                     */
                    isInRole: function (role, scope) {
                      var user = Meteor.user();
                      var comma = (role || '').indexOf(',');
                      var roles;
                      if (!user) return false;
                      if (!Match.test(role, String)) return false;

                      if (comma !== -1) {
                        roles = role.split(',').reduce(function (memo, r) {
                          if (!r) {
                            return memo;
                          }

                          memo.push(r);
                          return memo;
                        }, []);
                      } else {
                        roles = [role];
                      }

                      if (Match.test(scope, String)) {
                        return Roles.userIsInRole(user, roles, scope);
                      }

                      return Roles.userIsInRole(user, roles);
                    }
                  }; // //////////////////////////////////////////////////////////
                  // Register UI helpers
                  //

                  if (Roles.debug && console.log) {
                    console.log('[roles] Roles.debug =', Roles.debug);
                  }

                  if (typeof Package.blaze !== 'undefined' && typeof Package.blaze.Blaze !== 'undefined' && typeof Package.blaze.Blaze.registerHelper === 'function') {
                    Object.entries(Roles._uiHelpers).forEach(_ref => {
                      let [name, func] = _ref;

                      if (Roles.debug && console.log) {
                        console.log('[roles] registering Blaze helper \'' + name + '\'');
                      }

                      Package.blaze.Blaze.registerHelper(name, func);
                    });
                  }
                }.call(this, _module3);
                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "subscriptions.js": function _module4() {

                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                     //
                // packages/alanning_roles/roles/client/subscriptions.js                                                               //
                //                                                                                                                     //
                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /* global Meteor, Roles, Tracker */

                /**
                 * Subscription handle for the collection of all existing roles.
                 *
                 * @example
                 *
                 *     Roles.subscription.ready(); // true if roles have been loaded
                 *
                 * @property subscription
                 * @type Object
                 * @for Roles
                 * @static
                 */
                Tracker.autorun(function () {
                  Roles.subscription = Meteor.subscribe('_roles');
                });
                /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              } } } } } } }, {
    "extensions": [".js", ".json", ".d.ts", ".css", ".mjs", ".d.ts.map"]
  });

  _require2("/node_modules/meteor/alanning:roles/roles/roles_common.js");
  _require2("/node_modules/meteor/alanning:roles/roles/client/debug.js");
  _require2("/node_modules/meteor/alanning:roles/roles/client/uiHelpers.js");
  _require2("/node_modules/meteor/alanning:roles/roles/client/subscriptions.js");

  /* Exports */
  Package._define("alanning:roles", {
    Roles: Roles
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var URL = Package.url.URL;
  var URLSearchParams = Package.url.URLSearchParams;
  var meteorInstall = Package.modules.meteorInstall;

  /* Package-scope variables */
  var HTTP;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "http": { "httpcall_client.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/http/httpcall_client.js                                                                                   //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            var URL = _require("meteor/url").URL;
            var common = _require("./httpcall_common.js");
            var HTTP = _exports.HTTP = common.HTTP;
            var hasOwn = Object.prototype.hasOwnProperty;

            /**
             * @summary Perform an outbound HTTP request.
             * @locus Anywhere
             * @deprecated
             * @param {String} method The [HTTP method](http://en.wikipedia.org/wiki/HTTP_method) to use, such as "`GET`", "`POST`", or "`HEAD`".
             * @param {String} url The URL to retrieve.
             * @param {Object} [options]
             * @param {String} options.content String to use as the HTTP request body.
             * @param {Object} options.data JSON-able object to stringify and use as the HTTP request body. Overwrites `content`.
             * @param {String} options.query Query string to go in the URL. Overwrites any query string in `url`.
             * @param {Object} options.params Dictionary of request parameters to be encoded and placed in the URL (for GETs) or request body (for POSTs).  If `content` or `data` is specified, `params` will always be placed in the URL.
             * @param {String} options.auth HTTP basic authentication string of the form `"username:password"`
             * @param {Object} options.headers Dictionary of strings, headers to add to the HTTP request.
             * @param {Number} options.timeout Maximum time in milliseconds to wait for the request before failing.  There is no timeout by default.
             * @param {Boolean} options.followRedirects If `true`, transparently follow HTTP redirects. Cannot be set to `false` on the client. Default `true`.
             * @param {Object} options.npmRequestOptions On the server, `HTTP.call` is implemented by using the [npm `request` module](https://www.npmjs.com/package/request). Any options in this object will be passed directly to the `request` invocation.
             * @param {Function} options.beforeSend On the client, this will be called before the request is sent to allow for more direct manipulation of the underlying XMLHttpRequest object, which will be passed as the first argument. If the callback returns `false`, the request will be not be sent.
             * @param {Function} [asyncCallback] Optional callback.  If passed, the method runs asynchronously, instead of synchronously, and calls asyncCallback.  On the client, this callback is required.
             */
            HTTP.call = function (method, url, options, callback) {

              ////////// Process arguments //////////

              if (!callback && typeof options === "function") {
                // support (method, url, callback) argument list
                callback = options;
                options = null;
              }

              options = options || {};

              if (typeof callback !== "function") throw new Error("Can't make a blocking HTTP call from the client; callback required.");

              method = (method || "").toUpperCase();

              var headers = {};

              var content = options.content;
              if (options.data) {
                content = JSON.stringify(options.data);
                headers['Content-Type'] = 'application/json';
              }

              var params_for_url, params_for_body;
              if (content || method === "GET" || method === "HEAD") params_for_url = options.params;else params_for_body = options.params;

              url = URL._constructUrl(url, options.query, params_for_url);

              if (options.followRedirects === false) throw new Error("Option followRedirects:false not supported on client.");

              if (hasOwn.call(options, 'npmRequestOptions')) {
                throw new Error("Option npmRequestOptions not supported on client.");
              }

              var username, password;
              if (options.auth) {
                var colonLoc = options.auth.indexOf(':');
                if (colonLoc < 0) throw new Error('Option auth should be of the form "username:password"');
                username = options.auth.substring(0, colonLoc);
                password = options.auth.substring(colonLoc + 1);
              }

              if (params_for_body) {
                content = URL._encodeParams(params_for_body);
              }

              if (options.headers) {
                Object.keys(options.headers).forEach(function (key) {
                  headers[key] = options.headers[key];
                });
              }

              ////////// Callback wrapping //////////

              // wrap callback to add a 'response' property on an error, in case
              // we have both (http 4xx/5xx error, which has a response payload)
              callback = function (callback) {
                var called = false;
                return function (error, response) {
                  if (!called) {
                    called = true;
                    if (error && response) {
                      error.response = response;
                    }
                    callback(error, response);
                  }
                };
              }(callback);

              ////////// Kickoff! //////////

              // from this point on, errors are because of something remote, not
              // something we should check in advance. Turn exceptions into error
              // results.
              try {
                // setup XHR object
                var xhr;
                if (typeof XMLHttpRequest !== "undefined") xhr = new XMLHttpRequest();else if (typeof ActiveXObject !== "undefined") xhr = new ActiveXObject("Microsoft.XMLHttp"); // IE6
                else throw new Error("Can't create XMLHttpRequest"); // ???

                xhr.open(method, url, true, username, password);

                for (var k in headers) xhr.setRequestHeader(k, headers[k]);

                // setup timeout
                var timed_out = false;
                var timer;
                if (options.timeout) {
                  timer = Meteor.setTimeout(function () {
                    timed_out = true;
                    xhr.abort();
                  }, options.timeout);
                };

                // callback on complete
                xhr.onreadystatechange = function (evt) {
                  if (xhr.readyState === 4) {
                    // COMPLETE
                    if (timer) Meteor.clearTimeout(timer);

                    if (timed_out) {
                      callback(new Error("Connection timeout"));
                    } else if (!xhr.status) {
                      // no HTTP response
                      callback(new Error("Connection lost"));
                    } else {

                      var response = {};
                      response.statusCode = xhr.status;
                      response.content = xhr.responseText;

                      response.headers = {};
                      var header_str = xhr.getAllResponseHeaders();

                      // https://github.com/meteor/meteor/issues/553
                      //
                      // In Firefox there is a weird issue, sometimes
                      // getAllResponseHeaders returns the empty string, but
                      // getResponseHeader returns correct results. Possibly this
                      // issue:
                      // https://bugzilla.mozilla.org/show_bug.cgi?id=608735
                      //
                      // If this happens we can't get a full list of headers, but
                      // at least get content-type so our JSON decoding happens
                      // correctly. In theory, we could try and rescue more header
                      // values with a list of common headers, but content-type is
                      // the only vital one for now.
                      if ("" === header_str && xhr.getResponseHeader("content-type")) header_str = "content-type: " + xhr.getResponseHeader("content-type");

                      var headers_raw = header_str.split(/\r?\n/);
                      headers_raw.forEach(function (h) {
                        var m = /^(.*?):(?:\s+)(.*)$/.exec(h);
                        if (m && m.length === 3) {
                          response.headers[m[1].toLowerCase()] = m[2];
                        }
                      });

                      common.populateData(response);

                      var error = null;
                      if (response.statusCode >= 400) {
                        error = common.makeErrorByStatus(response.statusCode, response.content);
                      }

                      callback(error, response);
                    }
                  }
                };

                // Allow custom control over XHR and abort early.
                if (typeof options.beforeSend === "function") {
                  // Call the callback and check to see if the request was aborted
                  if (false === options.beforeSend.call(null, xhr, options)) {
                    return xhr.abort();
                  }
                }

                // send it on its way
                xhr.send(content);
              } catch (err) {
                callback(err);
              }
            };

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "httpcall_common.js": function _module2(_require3, _exports3) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/http/httpcall_common.js                                                                                   //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            var MAX_LENGTH = 500; // if you change this, also change the appropriate test
            var slice = Array.prototype.slice;

            _exports3.makeErrorByStatus = function (statusCode, content) {
              var message = "failed [" + statusCode + "]";

              if (content) {
                var stringContent = typeof content == "string" ? content : content.toString();

                message += ' ' + truncate(stringContent.replace(/\n/g, ' '), MAX_LENGTH);
              }

              return new Error(message);
            };

            function truncate(str, length) {
              return str.length > length ? str.slice(0, length) + '...' : str;
            }

            // Fill in `response.data` if the content-type is JSON.
            _exports3.populateData = function (response) {
              // Read Content-Type header, up to a ';' if there is one.
              // A typical header might be "application/json; charset=utf-8"
              // or just "application/json".
              var contentType = (response.headers['content-type'] || ';').split(';')[0];

              // Only try to parse data as JSON if server sets correct content type.
              if (['application/json', 'text/javascript', 'application/javascript', 'application/x-javascript'].indexOf(contentType) >= 0) {
                try {
                  response.data = JSON.parse(response.content);
                } catch (err) {
                  response.data = null;
                }
              } else {
                response.data = null;
              }
            };

            var HTTP = _exports3.HTTP = {};

            /**
             * @summary Send an HTTP `GET` request. Equivalent to calling [`HTTP.call`](#http_call) with "GET" as the first argument.
             * @param {String} url The URL to which the request should be sent.
             * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).
             * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.
             * @locus Anywhere
             * @deprecated
             */
            HTTP.get = function () /* varargs */{
              return HTTP.call.apply(this, ["GET"].concat(slice.call(arguments)));
            };

            /**
             * @summary Send an HTTP `POST` request. Equivalent to calling [`HTTP.call`](#http_call) with "POST" as the first argument.
             * @param {String} url The URL to which the request should be sent.
             * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).
             * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.
             * @locus Anywhere
             * @deprecated
             */
            HTTP.post = function () /* varargs */{
              return HTTP.call.apply(this, ["POST"].concat(slice.call(arguments)));
            };

            /**
             * @summary Send an HTTP `PUT` request. Equivalent to calling [`HTTP.call`](#http_call) with "PUT" as the first argument.
             * @param {String} url The URL to which the request should be sent.
             * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).
             * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.
             * @locus Anywhere
             * @deprecated
             */
            HTTP.put = function () /* varargs */{
              return HTTP.call.apply(this, ["PUT"].concat(slice.call(arguments)));
            };

            /**
             * @summary Send an HTTP `DELETE` request. Equivalent to calling [`HTTP.call`](#http_call) with "DELETE" as the first argument. (Named `del` to avoid conflict with the Javascript keyword `delete`)
             * @param {String} url The URL to which the request should be sent.
             * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).
             * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.
             * @locus Anywhere
             * @deprecated
             */
            HTTP.del = function () /* varargs */{
              return HTTP.call.apply(this, ["DELETE"].concat(slice.call(arguments)));
            };

            /**
             * @summary Send an HTTP `PATCH` request. Equivalent to calling [`HTTP.call`](#http_call) with "PATCH" as the first argument.
             * @param {String} url The URL to which the request should be sent.
             * @param {Object} [callOptions] Options passed on to [`HTTP.call`](#http_call).
             * @param {Function} [asyncCallback] Callback that is called when the request is completed. Required on the client.
             * @locus Anywhere
             * @deprecated
             */
            HTTP.patch = function () /* varargs */{
              return HTTP.call.apply(this, ["PATCH"].concat(slice.call(arguments)));
            };

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/http/httpcall_client.js");

  /* Exports */
  Package._define("http", _exports2, {
    HTTP: HTTP
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;

	/* Package-scope variables */
	var $, jQuery;

	(function () {

		///////////////////////////////////////////////////////////////////////
		//                                                                   //
		// packages/jquery/packages/jquery.js                                //
		//                                                                   //
		///////////////////////////////////////////////////////////////////////
		//
		(function () {

			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
			//                                                                                                                   //
			// packages/jquery/jquery.js                                                                                         //
			//                                                                                                                   //
			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
			//
			/*!                                                                                                                  // 1
    * jQuery JavaScript Library v1.11.0                                                                                 // 2
    * http://jquery.com/                                                                                                // 3
    *                                                                                                                   // 4
    * Includes Sizzle.js                                                                                                // 5
    * http://sizzlejs.com/                                                                                              // 6
    *                                                                                                                   // 7
    * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors                                               // 8
    * Released under the MIT license                                                                                    // 9
    * http://jquery.org/license                                                                                         // 10
    *                                                                                                                   // 11
    * Date: 2014-01-23T21:02Z                                                                                           // 12
    */ // 13
			// 14
			(function (global, factory) {
				// 15
				// 16
				if (typeof module === "object" && typeof module.exports === "object") {
					// 17
					// For CommonJS and CommonJS-like environments where a proper window is present,                                   // 18
					// execute the factory and get jQuery                                                                              // 19
					// For environments that do not inherently posses a window with a document                                         // 20
					// (such as Node.js), expose a jQuery-making factory as module.exports                                             // 21
					// This accentuates the need for the creation of a real window                                                     // 22
					// e.g. var jQuery = require("jquery")(window);                                                                    // 23
					// See ticket #14549 for more info                                                                                 // 24
					module.exports = global.document ? // 25
					factory(global, true) : // 26
					function (w) {
						// 27
						if (!w.document) {
							// 28
							throw new Error("jQuery requires a window with a document"); // 29
						} // 30
						return factory(w); // 31
					}; // 32
				} else {
					// 33
					factory(global); // 34
				} // 35
				// 36
				// Pass this if window is not defined yet                                                                            // 37
			})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
				// 38
				// 39
				// Can't do this because several apps including ASP.NET trace                                                        // 40
				// the stack via arguments.caller.callee and Firefox dies if                                                         // 41
				// you try to trace through "use strict" call chains. (#13335)                                                       // 42
				// Support: Firefox 18+                                                                                              // 43
				//                                                                                                                   // 44
				// 45
				var deletedIds = []; // 46
				// 47
				var slice = deletedIds.slice; // 48
				// 49
				var concat = deletedIds.concat; // 50
				// 51
				var push = deletedIds.push; // 52
				// 53
				var indexOf = deletedIds.indexOf; // 54
				// 55
				var class2type = {}; // 56
				// 57
				var toString = class2type.toString; // 58
				// 59
				var hasOwn = class2type.hasOwnProperty; // 60
				// 61
				var trim = "".trim; // 62
				// 63
				var support = {}; // 64
				// 65
				// 66
				// 67
				var // 68
				version = "1.11.0",
				    // 69
				// 70
				// Define a local copy of jQuery                                                                                    // 71
				jQuery = function (selector, context) {
					// 72
					// The jQuery object is actually just the init constructor 'enhanced'                                              // 73
					// Need init if jQuery is called (just allow error to be thrown if not included)                                   // 74
					return new jQuery.fn.init(selector, context); // 75
				},
				    // 76
				// 77
				// Make sure we trim BOM and NBSP (here's looking at you, Safari 5.0 and IE)                                        // 78
				rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
				    // 79
				// 80
				// Matches dashed string for camelizing                                                                             // 81
				rmsPrefix = /^-ms-/,
				    // 82
				rdashAlpha = /-([\da-z])/gi,
				    // 83
				// 84
				// Used by jQuery.camelCase as callback to replace()                                                                // 85
				fcamelCase = function (all, letter) {
					// 86
					return letter.toUpperCase(); // 87
				}; // 88
				// 89
				jQuery.fn = jQuery.prototype = { // 90
					// The current version of jQuery being used                                                                         // 91
					jquery: version, // 92
					// 93
					constructor: jQuery, // 94
					// 95
					// Start with an empty selector                                                                                     // 96
					selector: "", // 97
					// 98
					// The default length of a jQuery object is 0                                                                       // 99
					length: 0, // 100
					// 101
					toArray: function () {
						// 102
						return slice.call(this); // 103
					}, // 104
					// 105
					// Get the Nth element in the matched element set OR                                                                // 106
					// Get the whole matched element set as a clean array                                                               // 107
					get: function (num) {
						// 108
						return num != null ? // 109
						// 110
						// Return a 'clean' array                                                                                         // 111
						num < 0 ? this[num + this.length] : this[num] : // 112
						// 113
						// Return just the object                                                                                         // 114
						slice.call(this); // 115
					}, // 116
					// 117
					// Take an array of elements and push it onto the stack                                                             // 118
					// (returning the new matched element set)                                                                          // 119
					pushStack: function (elems) {
						// 120
						// 121
						// Build a new jQuery matched element set                                                                          // 122
						var ret = jQuery.merge(this.constructor(), elems); // 123
						// 124
						// Add the old object onto the stack (as a reference)                                                              // 125
						ret.prevObject = this; // 126
						ret.context = this.context; // 127
						// 128
						// Return the newly-formed element set                                                                             // 129
						return ret; // 130
					}, // 131
					// 132
					// Execute a callback for every element in the matched set.                                                         // 133
					// (You can seed the arguments with an array of args, but this is                                                   // 134
					// only used internally.)                                                                                           // 135
					each: function (callback, args) {
						// 136
						return jQuery.each(this, callback, args); // 137
					}, // 138
					// 139
					map: function (callback) {
						// 140
						return this.pushStack(jQuery.map(this, function (elem, i) {
							// 141
							return callback.call(elem, i, elem); // 142
						})); // 143
					}, // 144
					// 145
					slice: function () {
						// 146
						return this.pushStack(slice.apply(this, arguments)); // 147
					}, // 148
					// 149
					first: function () {
						// 150
						return this.eq(0); // 151
					}, // 152
					// 153
					last: function () {
						// 154
						return this.eq(-1); // 155
					}, // 156
					// 157
					eq: function (i) {
						// 158
						var len = this.length,
						    // 159
						j = +i + (i < 0 ? len : 0); // 160
						return this.pushStack(j >= 0 && j < len ? [this[j]] : []); // 161
					}, // 162
					// 163
					end: function () {
						// 164
						return this.prevObject || this.constructor(null); // 165
					}, // 166
					// 167
					// For internal use only.                                                                                           // 168
					// Behaves like an Array's method, not like a jQuery method.                                                        // 169
					push: push, // 170
					sort: deletedIds.sort, // 171
					splice: deletedIds.splice // 172
				}; // 173
				// 174
				jQuery.extend = jQuery.fn.extend = function () {
					// 175
					var src,
					    copyIsArray,
					    copy,
					    name,
					    options,
					    clone,
					    // 176
					target = arguments[0] || {},
					    // 177
					i = 1,
					    // 178
					length = arguments.length,
					    // 179
					deep = false; // 180
					// 181
					// Handle a deep copy situation                                                                                     // 182
					if (typeof target === "boolean") {
						// 183
						deep = target; // 184
						// 185
						// skip the boolean and the target                                                                                 // 186
						target = arguments[i] || {}; // 187
						i++; // 188
					} // 189
					// 190
					// Handle case when target is a string or something (possible in deep copy)                                         // 191
					if (typeof target !== "object" && !jQuery.isFunction(target)) {
						// 192
						target = {}; // 193
					} // 194
					// 195
					// extend jQuery itself if only one argument is passed                                                              // 196
					if (i === length) {
						// 197
						target = this; // 198
						i--; // 199
					} // 200
					// 201
					for (; i < length; i++) {
						// 202
						// Only deal with non-null/undefined values                                                                        // 203
						if ((options = arguments[i]) != null) {
							// 204
							// Extend the base object                                                                                         // 205
							for (name in options) {
								// 206
								src = target[name]; // 207
								copy = options[name]; // 208
								// 209
								// Prevent never-ending loop                                                                                     // 210
								if (target === copy) {
									// 211
									continue; // 212
								} // 213
								// 214
								// Recurse if we're merging plain objects or arrays                                                              // 215
								if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
									// 216
									if (copyIsArray) {
										// 217
										copyIsArray = false; // 218
										clone = src && jQuery.isArray(src) ? src : []; // 219
										// 220
									} else {
										// 221
										clone = src && jQuery.isPlainObject(src) ? src : {}; // 222
									} // 223
									// 224
									// Never move original objects, clone them                                                                      // 225
									target[name] = jQuery.extend(deep, clone, copy); // 226
									// 227
									// Don't bring in undefined values                                                                               // 228
								} else if (copy !== undefined) {
									// 229
									target[name] = copy; // 230
								} // 231
							} // 232
						} // 233
					} // 234
					// 235
					// Return the modified object                                                                                       // 236
					return target; // 237
				}; // 238
				// 239
				jQuery.extend({ // 240
					// Unique for each copy of jQuery on the page                                                                       // 241
					expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""), // 242
					// 243
					// Assume jQuery is ready without the ready module                                                                  // 244
					isReady: true, // 245
					// 246
					error: function (msg) {
						// 247
						throw new Error(msg); // 248
					}, // 249
					// 250
					noop: function () {}, // 251
					// 252
					// See test/unit/core.js for details concerning isFunction.                                                         // 253
					// Since version 1.3, DOM methods and functions like alert                                                          // 254
					// aren't supported. They return false on IE (#2968).                                                               // 255
					isFunction: function (obj) {
						// 256
						return jQuery.type(obj) === "function"; // 257
					}, // 258
					// 259
					isArray: Array.isArray || function (obj) {
						// 260
						return jQuery.type(obj) === "array"; // 261
					}, // 262
					// 263
					isWindow: function (obj) {
						// 264
						/* jshint eqeqeq: false */ // 265
						return obj != null && obj == obj.window; // 266
					}, // 267
					// 268
					isNumeric: function (obj) {
						// 269
						// parseFloat NaNs numeric-cast false positives (null|true|false|"")                                               // 270
						// ...but misinterprets leading-number strings, particularly hex literals ("0x...")                                // 271
						// subtraction forces infinities to NaN                                                                            // 272
						return obj - parseFloat(obj) >= 0; // 273
					}, // 274
					// 275
					isEmptyObject: function (obj) {
						// 276
						var name; // 277
						for (name in obj) {
							// 278
							return false; // 279
						} // 280
						return true; // 281
					}, // 282
					// 283
					isPlainObject: function (obj) {
						// 284
						var key; // 285
						// 286
						// Must be an Object.                                                                                              // 287
						// Because of IE, we also have to check the presence of the constructor property.                                  // 288
						// Make sure that DOM nodes and window objects don't pass through, as well                                         // 289
						if (!obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) {
							// 290
							return false; // 291
						} // 292
						// 293
						try {
							// 294
							// Not own constructor property must be Object                                                                    // 295
							if (obj.constructor && // 296
							!hasOwn.call(obj, "constructor") && // 297
							!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
								// 298
								return false; // 299
							} // 300
						} catch (e) {
							// 301
							// IE8,9 Will throw exceptions on certain host objects #9897                                                      // 302
							return false; // 303
						} // 304
						// 305
						// Support: IE<9                                                                                                   // 306
						// Handle iteration over inherited properties before own properties.                                               // 307
						if (support.ownLast) {
							// 308
							for (key in obj) {
								// 309
								return hasOwn.call(obj, key); // 310
							} // 311
						} // 312
						// 313
						// Own properties are enumerated firstly, so to speed up,                                                          // 314
						// if last one is own, then all properties are own.                                                                // 315
						for (key in obj) {} // 316
						// 317
						return key === undefined || hasOwn.call(obj, key); // 318
					}, // 319
					// 320
					type: function (obj) {
						// 321
						if (obj == null) {
							// 322
							return obj + ""; // 323
						} // 324
						return typeof obj === "object" || typeof obj === "function" ? // 325
						class2type[toString.call(obj)] || "object" : // 326
						typeof obj; // 327
					}, // 328
					// 329
					// Evaluates a script in a global context                                                                           // 330
					// Workarounds based on findings by Jim Driscoll                                                                    // 331
					// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context                          // 332
					globalEval: function (data) {
						// 333
						if (data && jQuery.trim(data)) {
							// 334
							// We use execScript on Internet Explorer                                                                         // 335
							// We use an anonymous function so that context is window                                                         // 336
							// rather than jQuery in Firefox                                                                                  // 337
							(window.execScript || function (data) {
								// 338
								window["eval"].call(window, data); // 339
							})(data); // 340
						} // 341
					}, // 342
					// 343
					// Convert dashed to camelCase; used by the css and data modules                                                    // 344
					// Microsoft forgot to hump their vendor prefix (#9572)                                                             // 345
					camelCase: function (string) {
						// 346
						return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase); // 347
					}, // 348
					// 349
					nodeName: function (elem, name) {
						// 350
						return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase(); // 351
					}, // 352
					// 353
					// args is for internal usage only                                                                                  // 354
					each: function (obj, callback, args) {
						// 355
						var value,
						    // 356
						i = 0,
						    // 357
						length = obj.length,
						    // 358
						isArray = isArraylike(obj); // 359
						// 360
						if (args) {
							// 361
							if (isArray) {
								// 362
								for (; i < length; i++) {
									// 363
									value = callback.apply(obj[i], args); // 364
									// 365
									if (value === false) {
										// 366
										break; // 367
									} // 368
								} // 369
							} else {
								// 370
								for (i in obj) {
									// 371
									value = callback.apply(obj[i], args); // 372
									// 373
									if (value === false) {
										// 374
										break; // 375
									} // 376
								} // 377
							} // 378
							// 379
							// A special, fast, case for the most common use of each                                                           // 380
						} else {
							// 381
							if (isArray) {
								// 382
								for (; i < length; i++) {
									// 383
									value = callback.call(obj[i], i, obj[i]); // 384
									// 385
									if (value === false) {
										// 386
										break; // 387
									} // 388
								} // 389
							} else {
								// 390
								for (i in obj) {
									// 391
									value = callback.call(obj[i], i, obj[i]); // 392
									// 393
									if (value === false) {
										// 394
										break; // 395
									} // 396
								} // 397
							} // 398
						} // 399
						// 400
						return obj; // 401
					}, // 402
					// 403
					// Use native String.trim function wherever possible                                                                // 404
					trim: trim && !trim.call("\uFEFF\xA0") ? // 405
					function (text) {
						// 406
						return text == null ? // 407
						"" : // 408
						trim.call(text); // 409
					} : // 410
					// 411
					// Otherwise use our own trimming functionality                                                                    // 412
					function (text) {
						// 413
						return text == null ? // 414
						"" : // 415
						(text + "").replace(rtrim, ""); // 416
					}, // 417
					// 418
					// results is for internal usage only                                                                               // 419
					makeArray: function (arr, results) {
						// 420
						var ret = results || []; // 421
						// 422
						if (arr != null) {
							// 423
							if (isArraylike(Object(arr))) {
								// 424
								jQuery.merge(ret, // 425
								typeof arr === "string" ? // 426
								[arr] : arr // 427
								); // 428
							} else {
								// 429
								push.call(ret, arr); // 430
							} // 431
						} // 432
						// 433
						return ret; // 434
					}, // 435
					// 436
					inArray: function (elem, arr, i) {
						// 437
						var len; // 438
						// 439
						if (arr) {
							// 440
							if (indexOf) {
								// 441
								return indexOf.call(arr, elem, i); // 442
							} // 443
							// 444
							len = arr.length; // 445
							i = i ? i < 0 ? Math.max(0, len + i) : i : 0; // 446
							// 447
							for (; i < len; i++) {
								// 448
								// Skip accessing in sparse arrays                                                                               // 449
								if (i in arr && arr[i] === elem) {
									// 450
									return i; // 451
								} // 452
							} // 453
						} // 454
						// 455
						return -1; // 456
					}, // 457
					// 458
					merge: function (first, second) {
						// 459
						var len = +second.length,
						    // 460
						j = 0,
						    // 461
						i = first.length; // 462
						// 463
						while (j < len) {
							// 464
							first[i++] = second[j++]; // 465
						} // 466
						// 467
						// Support: IE<9                                                                                                   // 468
						// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)                           // 469
						if (len !== len) {
							// 470
							while (second[j] !== undefined) {
								// 471
								first[i++] = second[j++]; // 472
							} // 473
						} // 474
						// 475
						first.length = i; // 476
						// 477
						return first; // 478
					}, // 479
					// 480
					grep: function (elems, callback, invert) {
						// 481
						var callbackInverse,
						    // 482
						matches = [],
						    // 483
						i = 0,
						    // 484
						length = elems.length,
						    // 485
						callbackExpect = !invert; // 486
						// 487
						// Go through the array, only saving the items                                                                     // 488
						// that pass the validator function                                                                                // 489
						for (; i < length; i++) {
							// 490
							callbackInverse = !callback(elems[i], i); // 491
							if (callbackInverse !== callbackExpect) {
								// 492
								matches.push(elems[i]); // 493
							} // 494
						} // 495
						// 496
						return matches; // 497
					}, // 498
					// 499
					// arg is for internal usage only                                                                                   // 500
					map: function (elems, callback, arg) {
						// 501
						var value,
						    // 502
						i = 0,
						    // 503
						length = elems.length,
						    // 504
						isArray = isArraylike(elems),
						    // 505
						ret = []; // 506
						// 507
						// Go through the array, translating each of the items to their new values                                         // 508
						if (isArray) {
							// 509
							for (; i < length; i++) {
								// 510
								value = callback(elems[i], i, arg); // 511
								// 512
								if (value != null) {
									// 513
									ret.push(value); // 514
								} // 515
							} // 516
							// 517
							// Go through every key on the object,                                                                             // 518
						} else {
							// 519
							for (i in elems) {
								// 520
								value = callback(elems[i], i, arg); // 521
								// 522
								if (value != null) {
									// 523
									ret.push(value); // 524
								} // 525
							} // 526
						} // 527
						// 528
						// Flatten any nested arrays                                                                                       // 529
						return concat.apply([], ret); // 530
					}, // 531
					// 532
					// A global GUID counter for objects                                                                                // 533
					guid: 1, // 534
					// 535
					// Bind a function to a context, optionally partially applying any                                                  // 536
					// arguments.                                                                                                       // 537
					proxy: function (fn, context) {
						// 538
						var args, proxy, tmp; // 539
						// 540
						if (typeof context === "string") {
							// 541
							tmp = fn[context]; // 542
							context = fn; // 543
							fn = tmp; // 544
						} // 545
						// 546
						// Quick check to determine if target is callable, in the spec                                                     // 547
						// this throws a TypeError, but we will just return undefined.                                                     // 548
						if (!jQuery.isFunction(fn)) {
							// 549
							return undefined; // 550
						} // 551
						// 552
						// Simulated bind                                                                                                  // 553
						args = slice.call(arguments, 2); // 554
						proxy = function () {
							// 555
							return fn.apply(context || this, args.concat(slice.call(arguments))); // 556
						}; // 557
						// 558
						// Set the guid of unique handler to the same of original handler, so it can be removed                            // 559
						proxy.guid = fn.guid = fn.guid || jQuery.guid++; // 560
						// 561
						return proxy; // 562
					}, // 563
					// 564
					now: function () {
						// 565
						return +new Date(); // 566
					}, // 567
					// 568
					// jQuery.support is not used in Core but other projects attach their                                               // 569
					// properties to it so it needs to exist.                                                                           // 570
					support: support // 571
				}); // 572
				// 573
				// Populate the class2type map                                                                                       // 574
				jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
					// 575
					class2type["[object " + name + "]"] = name.toLowerCase(); // 576
				}); // 577
				// 578
				function isArraylike(obj) {
					// 579
					var length = obj.length,
					    // 580
					type = jQuery.type(obj); // 581
					// 582
					if (type === "function" || jQuery.isWindow(obj)) {
						// 583
						return false; // 584
					} // 585
					// 586
					if (obj.nodeType === 1 && length) {
						// 587
						return true; // 588
					} // 589
					// 590
					return type === "array" || length === 0 || // 591
					typeof length === "number" && length > 0 && length - 1 in obj; // 592
				} // 593
				var Sizzle = // 594
				/*!                                                                                                                  // 595
     * Sizzle CSS Selector Engine v1.10.16                                                                               // 596
     * http://sizzlejs.com/                                                                                              // 597
     *                                                                                                                   // 598
     * Copyright 2013 jQuery Foundation, Inc. and other contributors                                                     // 599
     * Released under the MIT license                                                                                    // 600
     * http://jquery.org/license                                                                                         // 601
     *                                                                                                                   // 602
     * Date: 2014-01-13                                                                                                  // 603
     */ // 604
				function (window) {
					// 605
					// 606
					var i,
					    // 607
					support,
					    // 608
					Expr,
					    // 609
					getText,
					    // 610
					isXML,
					    // 611
					compile,
					    // 612
					outermostContext,
					    // 613
					sortInput,
					    // 614
					hasDuplicate,
					    // 615
					// 616
					// Local document vars                                                                                              // 617
					setDocument,
					    // 618
					document,
					    // 619
					docElem,
					    // 620
					documentIsHTML,
					    // 621
					rbuggyQSA,
					    // 622
					rbuggyMatches,
					    // 623
					matches,
					    // 624
					contains,
					    // 625
					// 626
					// Instance-specific data                                                                                           // 627
					expando = "sizzle" + -new Date(),
					    // 628
					preferredDoc = window.document,
					    // 629
					dirruns = 0,
					    // 630
					done = 0,
					    // 631
					classCache = createCache(),
					    // 632
					tokenCache = createCache(),
					    // 633
					compilerCache = createCache(),
					    // 634
					sortOrder = function (a, b) {
						// 635
						if (a === b) {
							// 636
							hasDuplicate = true; // 637
						} // 638
						return 0; // 639
					},
					    // 640
					// 641
					// General-purpose constants                                                                                        // 642
					strundefined = typeof undefined,
					    // 643
					MAX_NEGATIVE = 1 << 31,
					    // 644
					// 645
					// Instance methods                                                                                                 // 646
					hasOwn = {}.hasOwnProperty,
					    // 647
					arr = [],
					    // 648
					pop = arr.pop,
					    // 649
					push_native = arr.push,
					    // 650
					push = arr.push,
					    // 651
					slice = arr.slice,
					    // 652
					// Use a stripped-down indexOf if we can't use a native one                                                         // 653
					indexOf = arr.indexOf || function (elem) {
						// 654
						var i = 0,
						    // 655
						len = this.length; // 656
						for (; i < len; i++) {
							// 657
							if (this[i] === elem) {
								// 658
								return i; // 659
							} // 660
						} // 661
						return -1; // 662
					},
					    // 663
					// 664
					booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

					// 666
					// Regular expressions                                                                                              // 667
					// 668
					// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace                                            // 669
					whitespace = "[\\x20\\t\\r\\n\\f]",
					    // 670
					// http://www.w3.org/TR/css3-syntax/#characters                                                                     // 671
					characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
					    // 672
					// 673
					// Loosely modeled on CSS identifier characters                                                                     // 674
					// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors            // 675
					// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier                                      // 676
					identifier = characterEncoding.replace("w", "w#"),
					    // 677
					// 678
					// Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors                                         // 679
					attributes = "\\[" + whitespace + "*(" + characterEncoding + ")" + whitespace + // 680
					"*(?:([*^$|!~]?=)" + whitespace + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + identifier + ")|)|)" + whitespace + "*\\]",

					// 682
					// Prefer arguments quoted,                                                                                         // 683
					//   then not containing pseudos/brackets,                                                                          // 684
					//   then attribute selectors/non-parenthetical expressions,                                                        // 685
					//   then anything else                                                                                             // 686
					// These preferences are here to reduce the number of selectors                                                     // 687
					//   needing tokenize in the PSEUDO preFilter                                                                       // 688
					pseudos = ":(" + characterEncoding + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + attributes.replace(3, 8) + ")*)|.*)\\)|)",

					// 690
					// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter       // 691
					rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
					    // 692
					// 693
					rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
					    // 694
					rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
					    // 695
					// 696
					rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
					    // 697
					// 698
					rpseudo = new RegExp(pseudos),
					    // 699
					ridentifier = new RegExp("^" + identifier + "$"),
					    // 700
					// 701
					matchExpr = { // 702
						"ID": new RegExp("^#(" + characterEncoding + ")"), // 703
						"CLASS": new RegExp("^\\.(" + characterEncoding + ")"), // 704
						"TAG": new RegExp("^(" + characterEncoding.replace("w", "w*") + ")"), // 705
						"ATTR": new RegExp("^" + attributes), // 706
						"PSEUDO": new RegExp("^" + pseudos), // 707
						"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + // 708
						"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + // 709
						"*(\\d+)|))" + whitespace + "*\\)|)", "i"), // 710
						"bool": new RegExp("^(?:" + booleans + ")$", "i"), // 711
						// For use in libraries implementing .is()                                                                         // 712
						// We use this for POS matching in `select`                                                                        // 713
						"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + // 714
						whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i") // 715
					},
					    // 716
					// 717
					rinputs = /^(?:input|select|textarea|button)$/i,
					    // 718
					rheader = /^h\d$/i,
					    // 719
					// 720
					rnative = /^[^{]+\{\s*\[native \w/,
					    // 721
					// 722
					// Easily-parseable/retrievable ID or TAG or CLASS selectors                                                        // 723
					rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
					    // 724
					// 725
					rsibling = /[+~]/,
					    // 726
					rescape = /'|\\/g,
					    // 727
					// 728
					// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters                                           // 729
					runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
					    // 730
					funescape = function (_, escaped, escapedWhitespace) {
						// 731
						var high = "0x" + escaped - 0x10000; // 732
						// NaN means non-codepoint                                                                                         // 733
						// Support: Firefox                                                                                                // 734
						// Workaround erroneous numeric interpretation of +"0x"                                                            // 735
						return high !== high || escapedWhitespace ? // 736
						escaped : // 737
						high < 0 ? // 738
						// BMP codepoint                                                                                                 // 739
						String.fromCharCode(high + 0x10000) : // 740
						// Supplemental Plane codepoint (surrogate pair)                                                                 // 741
						String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00); // 742
					}; // 743
					// 744
					// Optimize for push.apply( _, NodeList )                                                                            // 745
					try {
						// 746
						push.apply( // 747
						arr = slice.call(preferredDoc.childNodes), // 748
						preferredDoc.childNodes // 749
						); // 750
						// Support: Android<4.0                                                                                             // 751
						// Detect silently failing push.apply                                                                               // 752
						arr[preferredDoc.childNodes.length].nodeType; // 753
					} catch (e) {
						// 754
						push = { apply: arr.length ? // 755
							// 756
							// Leverage slice if possible                                                                                      // 757
							function (target, els) {
								// 758
								push_native.apply(target, slice.call(els)); // 759
							} : // 760
							// 761
							// Support: IE<9                                                                                                   // 762
							// Otherwise append directly                                                                                       // 763
							function (target, els) {
								// 764
								var j = target.length,
								    // 765
								i = 0; // 766
								// Can't trust NodeList.length                                                                                    // 767
								while (target[j++] = els[i++]) {} // 768
								target.length = j - 1; // 769
							} // 770
						}; // 771
					} // 772
					// 773
					function Sizzle(selector, context, results, seed) {
						// 774
						var match, elem, m, nodeType, // 775
						// QSA vars                                                                                                        // 776
						i, groups, old, nid, newContext, newSelector; // 777
						// 778
						if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
							// 779
							setDocument(context); // 780
						} // 781
						// 782
						context = context || document; // 783
						results = results || []; // 784
						// 785
						if (!selector || typeof selector !== "string") {
							// 786
							return results; // 787
						} // 788
						// 789
						if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
							// 790
							return []; // 791
						} // 792
						// 793
						if (documentIsHTML && !seed) {
							// 794
							// 795
							// Shortcuts                                                                                                       // 796
							if (match = rquickExpr.exec(selector)) {
								// 797
								// Speed-up: Sizzle("#ID")                                                                                        // 798
								if (m = match[1]) {
									// 799
									if (nodeType === 9) {
										// 800
										elem = context.getElementById(m); // 801
										// Check parentNode to catch when Blackberry 4.6 returns                                                        // 802
										// nodes that are no longer in the document (jQuery #6963)                                                      // 803
										if (elem && elem.parentNode) {
											// 804
											// Handle the case where IE, Opera, and Webkit return items                                                    // 805
											// by name instead of ID                                                                                       // 806
											if (elem.id === m) {
												// 807
												results.push(elem); // 808
												return results; // 809
											} // 810
										} else {
											// 811
											return results; // 812
										} // 813
									} else {
										// 814
										// Context is not a document                                                                                    // 815
										if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && // 816
										contains(context, elem) && elem.id === m) {
											// 817
											results.push(elem); // 818
											return results; // 819
										} // 820
									} // 821
									// 822
									// Speed-up: Sizzle("TAG")                                                                                        // 823
								} else if (match[2]) {
									// 824
									push.apply(results, context.getElementsByTagName(selector)); // 825
									return results; // 826
									// 827
									// Speed-up: Sizzle(".CLASS")                                                                                     // 828
								} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
									// 829
									push.apply(results, context.getElementsByClassName(m)); // 830
									return results; // 831
								} // 832
							} // 833
							// 834
							// QSA path                                                                                                        // 835
							if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
								// 836
								nid = old = expando; // 837
								newContext = context; // 838
								newSelector = nodeType === 9 && selector; // 839
								// 840
								// qSA works strangely on Element-rooted queries                                                                  // 841
								// We can work around this by specifying an extra ID on the root                                                  // 842
								// and working up from there (Thanks to Andrew Dupont for the technique)                                          // 843
								// IE 8 doesn't work on object elements                                                                           // 844
								if (nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
									// 845
									groups = tokenize(selector); // 846
									// 847
									if (old = context.getAttribute("id")) {
										// 848
										nid = old.replace(rescape, "\\$&"); // 849
									} else {
										// 850
										context.setAttribute("id", nid); // 851
									} // 852
									nid = "[id='" + nid + "'] "; // 853
									// 854
									i = groups.length; // 855
									while (i--) {
										// 856
										groups[i] = nid + toSelector(groups[i]); // 857
									} // 858
									newContext = rsibling.test(selector) && testContext(context.parentNode) || context; // 859
									newSelector = groups.join(","); // 860
								} // 861
								// 862
								if (newSelector) {
									// 863
									try {
										// 864
										push.apply(results, // 865
										newContext.querySelectorAll(newSelector) // 866
										); // 867
										return results; // 868
									} catch (qsaError) {// 869
									} finally {
										// 870
										if (!old) {
											// 871
											context.removeAttribute("id"); // 872
										} // 873
									} // 874
								} // 875
							} // 876
						} // 877
						// 878
						// All others                                                                                                       // 879
						return select(selector.replace(rtrim, "$1"), context, results, seed); // 880
					} // 881
					// 882
					/**                                                                                                                  // 883
      * Create key-value caches of limited size                                                                           // 884
      * @returns {Function(string, Object)} Returns the Object data after storing it on itself with                       // 885
      *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)                      // 886
      *	deleting the oldest entry                                                                                         // 887
      */ // 888
					function createCache() {
						// 889
						var keys = []; // 890
						// 891
						function cache(key, value) {
							// 892
							// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)                            // 893
							if (keys.push(key + " ") > Expr.cacheLength) {
								// 894
								// Only keep the most recent entries                                                                              // 895
								delete cache[keys.shift()]; // 896
							} // 897
							return cache[key + " "] = value; // 898
						} // 899
						return cache; // 900
					} // 901
					// 902
					/**                                                                                                                  // 903
      * Mark a function for special use by Sizzle                                                                         // 904
      * @param {Function} fn The function to mark                                                                         // 905
      */ // 906
					function markFunction(fn) {
						// 907
						fn[expando] = true; // 908
						return fn; // 909
					} // 910
					// 911
					/**                                                                                                                  // 912
      * Support testing using an element                                                                                  // 913
      * @param {Function} fn Passed the created div and expects a boolean result                                          // 914
      */ // 915
					function assert(fn) {
						// 916
						var div = document.createElement("div"); // 917
						// 918
						try {
							// 919
							return !!fn(div); // 920
						} catch (e) {
							// 921
							return false; // 922
						} finally {
							// 923
							// Remove from its parent by default                                                                               // 924
							if (div.parentNode) {
								// 925
								div.parentNode.removeChild(div); // 926
							} // 927
							// release memory in IE                                                                                            // 928
							div = null; // 929
						} // 930
					} // 931
					// 932
					/**                                                                                                                  // 933
      * Adds the same handler for all of the specified attrs                                                              // 934
      * @param {String} attrs Pipe-separated list of attributes                                                           // 935
      * @param {Function} handler The method that will be applied                                                         // 936
      */ // 937
					function addHandle(attrs, handler) {
						// 938
						var arr = attrs.split("|"),
						    // 939
						i = attrs.length; // 940
						// 941
						while (i--) {
							// 942
							Expr.attrHandle[arr[i]] = handler; // 943
						} // 944
					} // 945
					// 946
					/**                                                                                                                  // 947
      * Checks document order of two siblings                                                                             // 948
      * @param {Element} a                                                                                                // 949
      * @param {Element} b                                                                                                // 950
      * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b                              // 951
      */ // 952
					function siblingCheck(a, b) {
						// 953
						var cur = b && a,
						    // 954
						diff = cur && a.nodeType === 1 && b.nodeType === 1 && // 955
						(~b.sourceIndex || MAX_NEGATIVE) - ( // 956
						~a.sourceIndex || MAX_NEGATIVE); // 957
						// 958
						// Use IE sourceIndex if available on both nodes                                                                    // 959
						if (diff) {
							// 960
							return diff; // 961
						} // 962
						// 963
						// Check if b follows a                                                                                             // 964
						if (cur) {
							// 965
							while (cur = cur.nextSibling) {
								// 966
								if (cur === b) {
									// 967
									return -1; // 968
								} // 969
							} // 970
						} // 971
						// 972
						return a ? 1 : -1; // 973
					} // 974
					// 975
					/**                                                                                                                  // 976
      * Returns a function to use in pseudos for input types                                                              // 977
      * @param {String} type                                                                                              // 978
      */ // 979
					function createInputPseudo(type) {
						// 980
						return function (elem) {
							// 981
							var name = elem.nodeName.toLowerCase(); // 982
							return name === "input" && elem.type === type; // 983
						}; // 984
					} // 985
					// 986
					/**                                                                                                                  // 987
      * Returns a function to use in pseudos for buttons                                                                  // 988
      * @param {String} type                                                                                              // 989
      */ // 990
					function createButtonPseudo(type) {
						// 991
						return function (elem) {
							// 992
							var name = elem.nodeName.toLowerCase(); // 993
							return (name === "input" || name === "button") && elem.type === type; // 994
						}; // 995
					} // 996
					// 997
					/**                                                                                                                  // 998
      * Returns a function to use in pseudos for positionals                                                              // 999
      * @param {Function} fn                                                                                              // 1000
      */ // 1001
					function createPositionalPseudo(fn) {
						// 1002
						return markFunction(function (argument) {
							// 1003
							argument = +argument; // 1004
							return markFunction(function (seed, matches) {
								// 1005
								var j,
								    // 1006
								matchIndexes = fn([], seed.length, argument),
								    // 1007
								i = matchIndexes.length; // 1008
								// 1009
								// Match elements found at the specified indexes                                                                  // 1010
								while (i--) {
									// 1011
									if (seed[j = matchIndexes[i]]) {
										// 1012
										seed[j] = !(matches[j] = seed[j]); // 1013
									} // 1014
								} // 1015
							}); // 1016
						}); // 1017
					} // 1018
					// 1019
					/**                                                                                                                  // 1020
      * Checks a node for validity as a Sizzle context                                                                    // 1021
      * @param {Element|Object=} context                                                                                  // 1022
      * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value                           // 1023
      */ // 1024
					function testContext(context) {
						// 1025
						return context && typeof context.getElementsByTagName !== strundefined && context; // 1026
					} // 1027
					// 1028
					// Expose support vars for convenience                                                                               // 1029
					support = Sizzle.support = {}; // 1030
					// 1031
					/**                                                                                                                  // 1032
      * Detects XML nodes                                                                                                 // 1033
      * @param {Element|Object} elem An element or a document                                                             // 1034
      * @returns {Boolean} True iff elem is a non-HTML XML node                                                           // 1035
      */ // 1036
					isXML = Sizzle.isXML = function (elem) {
						// 1037
						// documentElement is verified for cases where it doesn't yet exist                                                 // 1038
						// (such as loading iframes in IE - #4833)                                                                          // 1039
						var documentElement = elem && (elem.ownerDocument || elem).documentElement; // 1040
						return documentElement ? documentElement.nodeName !== "HTML" : false; // 1041
					}; // 1042
					// 1043
					/**                                                                                                                  // 1044
      * Sets document-related variables once based on the current document                                                // 1045
      * @param {Element|Object} [doc] An element or document object to use to set the document                            // 1046
      * @returns {Object} Returns the current document                                                                    // 1047
      */ // 1048
					setDocument = Sizzle.setDocument = function (node) {
						// 1049
						var hasCompare,
						    // 1050
						doc = node ? node.ownerDocument || node : preferredDoc,
						    // 1051
						parent = doc.defaultView; // 1052
						// 1053
						// If no document and documentElement is available, return                                                          // 1054
						if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
							// 1055
							return document; // 1056
						} // 1057
						// 1058
						// Set our document                                                                                                 // 1059
						document = doc; // 1060
						docElem = doc.documentElement; // 1061
						// 1062
						// Support tests                                                                                                    // 1063
						documentIsHTML = !isXML(doc); // 1064
						// 1065
						// Support: IE>8                                                                                                    // 1066
						// If iframe document is assigned to "document" variable and if iframe has been reloaded,                           // 1067
						// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936                    // 1068
						// IE6-8 do not support the defaultView property so parent will be undefined                                        // 1069
						if (parent && parent !== parent.top) {
							// 1070
							// IE11 does not have attachEvent, so all must suffer                                                              // 1071
							if (parent.addEventListener) {
								// 1072
								parent.addEventListener("unload", function () {
									// 1073
									setDocument(); // 1074
								}, false); // 1075
							} else if (parent.attachEvent) {
								// 1076
								parent.attachEvent("onunload", function () {
									// 1077
									setDocument(); // 1078
								}); // 1079
							} // 1080
						} // 1081
						// 1082
						/* Attributes                                                                                                       // 1083
      ---------------------------------------------------------------------- */ // 1084
						// 1085
						// Support: IE<8                                                                                                    // 1086
						// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)                   // 1087
						support.attributes = assert(function (div) {
							// 1088
							div.className = "i"; // 1089
							return !div.getAttribute("className"); // 1090
						}); // 1091
						// 1092
						/* getElement(s)By*                                                                                                 // 1093
      ---------------------------------------------------------------------- */ // 1094
						// 1095
						// Check if getElementsByTagName("*") returns only elements                                                         // 1096
						support.getElementsByTagName = assert(function (div) {
							// 1097
							div.appendChild(doc.createComment("")); // 1098
							return !div.getElementsByTagName("*").length; // 1099
						}); // 1100
						// 1101
						// Check if getElementsByClassName can be trusted                                                                   // 1102
						support.getElementsByClassName = rnative.test(doc.getElementsByClassName) && assert(function (div) {
							// 1103
							div.innerHTML = "<div class='a'></div><div class='a i'></div>"; // 1104
							// 1105
							// Support: Safari<4                                                                                               // 1106
							// Catch class over-caching                                                                                        // 1107
							div.firstChild.className = "i"; // 1108
							// Support: Opera<10                                                                                               // 1109
							// Catch gEBCN failure to find non-leading classes                                                                 // 1110
							return div.getElementsByClassName("i").length === 2; // 1111
						}); // 1112
						// 1113
						// Support: IE<10                                                                                                   // 1114
						// Check if getElementById returns elements by name                                                                 // 1115
						// The broken getElementById methods don't pick up programatically-set names,                                       // 1116
						// so use a roundabout getElementsByName test                                                                       // 1117
						support.getById = assert(function (div) {
							// 1118
							docElem.appendChild(div).id = expando; // 1119
							return !doc.getElementsByName || !doc.getElementsByName(expando).length; // 1120
						}); // 1121
						// 1122
						// ID find and filter                                                                                               // 1123
						if (support.getById) {
							// 1124
							Expr.find["ID"] = function (id, context) {
								// 1125
								if (typeof context.getElementById !== strundefined && documentIsHTML) {
									// 1126
									var m = context.getElementById(id); // 1127
									// Check parentNode to catch when Blackberry 4.6 returns                                                         // 1128
									// nodes that are no longer in the document #6963                                                                // 1129
									return m && m.parentNode ? [m] : []; // 1130
								} // 1131
							}; // 1132
							Expr.filter["ID"] = function (id) {
								// 1133
								var attrId = id.replace(runescape, funescape); // 1134
								return function (elem) {
									// 1135
									return elem.getAttribute("id") === attrId; // 1136
								}; // 1137
							}; // 1138
						} else {
							// 1139
							// Support: IE6/7                                                                                                  // 1140
							// getElementById is not reliable as a find shortcut                                                               // 1141
							delete Expr.find["ID"]; // 1142
							// 1143
							Expr.filter["ID"] = function (id) {
								// 1144
								var attrId = id.replace(runescape, funescape); // 1145
								return function (elem) {
									// 1146
									var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id"); // 1147
									return node && node.value === attrId; // 1148
								}; // 1149
							}; // 1150
						} // 1151
						// 1152
						// Tag                                                                                                              // 1153
						Expr.find["TAG"] = support.getElementsByTagName ? // 1154
						function (tag, context) {
							// 1155
							if (typeof context.getElementsByTagName !== strundefined) {
								// 1156
								return context.getElementsByTagName(tag); // 1157
							} // 1158
						} : // 1159
						function (tag, context) {
							// 1160
							var elem,
							    // 1161
							tmp = [],
							    // 1162
							i = 0,
							    // 1163
							results = context.getElementsByTagName(tag); // 1164
							// 1165
							// Filter out possible comments                                                                                   // 1166
							if (tag === "*") {
								// 1167
								while (elem = results[i++]) {
									// 1168
									if (elem.nodeType === 1) {
										// 1169
										tmp.push(elem); // 1170
									} // 1171
								} // 1172
								// 1173
								return tmp; // 1174
							} // 1175
							return results; // 1176
						}; // 1177
						// 1178
						// Class                                                                                                            // 1179
						Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
							// 1180
							if (typeof context.getElementsByClassName !== strundefined && documentIsHTML) {
								// 1181
								return context.getElementsByClassName(className); // 1182
							} // 1183
						}; // 1184
						// 1185
						/* QSA/matchesSelector                                                                                              // 1186
      ---------------------------------------------------------------------- */ // 1187
						// 1188
						// QSA and matchesSelector support                                                                                  // 1189
						// 1190
						// matchesSelector(:active) reports false when true (IE9/Opera 11.5)                                                // 1191
						rbuggyMatches = []; // 1192
						// 1193
						// qSa(:focus) reports false when true (Chrome 21)                                                                  // 1194
						// We allow this because of a bug in IE8/9 that throws an error                                                     // 1195
						// whenever `document.activeElement` is accessed on an iframe                                                       // 1196
						// So, we allow :focus to pass through QSA all the time to avoid the IE error                                       // 1197
						// See http://bugs.jquery.com/ticket/13378                                                                          // 1198
						rbuggyQSA = []; // 1199
						// 1200
						if (support.qsa = rnative.test(doc.querySelectorAll)) {
							// 1201
							// Build QSA regex                                                                                                 // 1202
							// Regex strategy adopted from Diego Perini                                                                        // 1203
							assert(function (div) {
								// 1204
								// Select is set to empty string on purpose                                                                       // 1205
								// This is to test IE's treatment of not explicitly                                                               // 1206
								// setting a boolean content attribute,                                                                           // 1207
								// since its presence should be enough                                                                            // 1208
								// http://bugs.jquery.com/ticket/12359                                                                            // 1209
								div.innerHTML = "<select t=''><option selected=''></option></select>"; // 1210
								// 1211
								// Support: IE8, Opera 10-12                                                                                      // 1212
								// Nothing should be selected when empty strings follow ^= or $= or *=                                            // 1213
								if (div.querySelectorAll("[t^='']").length) {
									// 1214
									rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")"); // 1215
								} // 1216
								// 1217
								// Support: IE8                                                                                                   // 1218
								// Boolean attributes and "value" are not treated correctly                                                       // 1219
								if (!div.querySelectorAll("[selected]").length) {
									// 1220
									rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")"); // 1221
								} // 1222
								// 1223
								// Webkit/Opera - :checked should return selected option elements                                                 // 1224
								// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked                                                 // 1225
								// IE8 throws error here and will not see later tests                                                             // 1226
								if (!div.querySelectorAll(":checked").length) {
									// 1227
									rbuggyQSA.push(":checked"); // 1228
								} // 1229
							}); // 1230
							// 1231
							assert(function (div) {
								// 1232
								// Support: Windows 8 Native Apps                                                                                 // 1233
								// The type and name attributes are restricted during .innerHTML assignment                                       // 1234
								var input = doc.createElement("input"); // 1235
								input.setAttribute("type", "hidden"); // 1236
								div.appendChild(input).setAttribute("name", "D"); // 1237
								// 1238
								// Support: IE8                                                                                                   // 1239
								// Enforce case-sensitivity of name attribute                                                                     // 1240
								if (div.querySelectorAll("[name=d]").length) {
									// 1241
									rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?="); // 1242
								} // 1243
								// 1244
								// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)                            // 1245
								// IE8 throws error here and will not see later tests                                                             // 1246
								if (!div.querySelectorAll(":enabled").length) {
									// 1247
									rbuggyQSA.push(":enabled", ":disabled"); // 1248
								} // 1249
								// 1250
								// Opera 10-11 does not throw on post-comma invalid pseudos                                                       // 1251
								div.querySelectorAll("*,:x"); // 1252
								rbuggyQSA.push(",.*:"); // 1253
							}); // 1254
						} // 1255
						// 1256
						if (support.matchesSelector = rnative.test(matches = docElem.webkitMatchesSelector || // 1257
						docElem.mozMatchesSelector || // 1258
						docElem.oMatchesSelector || // 1259
						docElem.msMatchesSelector)) {
							// 1260
							// 1261
							assert(function (div) {
								// 1262
								// Check to see if it's possible to do matchesSelector                                                            // 1263
								// on a disconnected node (IE 9)                                                                                  // 1264
								support.disconnectedMatch = matches.call(div, "div"); // 1265
								// 1266
								// This should fail with an exception                                                                             // 1267
								// Gecko does not error, returns false instead                                                                    // 1268
								matches.call(div, "[s!='']:x"); // 1269
								rbuggyMatches.push("!=", pseudos); // 1270
							}); // 1271
						} // 1272
						// 1273
						rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|")); // 1274
						rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|")); // 1275
						// 1276
						/* Contains                                                                                                         // 1277
      ---------------------------------------------------------------------- */ // 1278
						hasCompare = rnative.test(docElem.compareDocumentPosition); // 1279
						// 1280
						// Element contains another                                                                                         // 1281
						// Purposefully does not implement inclusive descendent                                                             // 1282
						// As in, an element does not contain itself                                                                        // 1283
						contains = hasCompare || rnative.test(docElem.contains) ? // 1284
						function (a, b) {
							// 1285
							var adown = a.nodeType === 9 ? a.documentElement : a,
							    // 1286
							bup = b && b.parentNode; // 1287
							return a === bup || !!(bup && bup.nodeType === 1 && ( // 1288
							adown.contains ? // 1289
							adown.contains(bup) : // 1290
							a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16 // 1291
							)); // 1292
						} : // 1293
						function (a, b) {
							// 1294
							if (b) {
								// 1295
								while (b = b.parentNode) {
									// 1296
									if (b === a) {
										// 1297
										return true; // 1298
									} // 1299
								} // 1300
							} // 1301
							return false; // 1302
						}; // 1303
						// 1304
						/* Sorting                                                                                                          // 1305
      ---------------------------------------------------------------------- */ // 1306
						// 1307
						// Document order sorting                                                                                           // 1308
						sortOrder = hasCompare ? // 1309
						function (a, b) {
							// 1310
							// 1311
							// Flag for duplicate removal                                                                                      // 1312
							if (a === b) {
								// 1313
								hasDuplicate = true; // 1314
								return 0; // 1315
							} // 1316
							// 1317
							// Sort on method existence if only one input has compareDocumentPosition                                          // 1318
							var compare = !a.compareDocumentPosition - !b.compareDocumentPosition; // 1319
							if (compare) {
								// 1320
								return compare; // 1321
							} // 1322
							// 1323
							// Calculate position if both inputs belong to the same document                                                   // 1324
							compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? // 1325
							a.compareDocumentPosition(b) : // 1326
							// 1327
							// Otherwise we know they are disconnected                                                                        // 1328
							1; // 1329
							// 1330
							// Disconnected nodes                                                                                              // 1331
							if (compare & 1 || // 1332
							!support.sortDetached && b.compareDocumentPosition(a) === compare) {
								// 1333
								// 1334
								// Choose the first element that is related to our preferred document                                             // 1335
								if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
									// 1336
									return -1; // 1337
								} // 1338
								if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
									// 1339
									return 1; // 1340
								} // 1341
								// 1342
								// Maintain original order                                                                                        // 1343
								return sortInput ? // 1344
								indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : // 1345
								0; // 1346
							} // 1347
							// 1348
							return compare & 4 ? -1 : 1; // 1349
						} : // 1350
						function (a, b) {
							// 1351
							// Exit early if the nodes are identical                                                                           // 1352
							if (a === b) {
								// 1353
								hasDuplicate = true; // 1354
								return 0; // 1355
							} // 1356
							// 1357
							var cur,
							    // 1358
							i = 0,
							    // 1359
							aup = a.parentNode,
							    // 1360
							bup = b.parentNode,
							    // 1361
							ap = [a],
							    // 1362
							bp = [b]; // 1363
							// 1364
							// Parentless nodes are either documents or disconnected                                                           // 1365
							if (!aup || !bup) {
								// 1366
								return a === doc ? -1 : // 1367
								b === doc ? 1 : // 1368
								aup ? -1 : // 1369
								bup ? 1 : // 1370
								sortInput ? // 1371
								indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : // 1372
								0; // 1373
								// 1374
								// If the nodes are siblings, we can do a quick check                                                              // 1375
							} else if (aup === bup) {
								// 1376
								return siblingCheck(a, b); // 1377
							} // 1378
							// 1379
							// Otherwise we need full lists of their ancestors for comparison                                                  // 1380
							cur = a; // 1381
							while (cur = cur.parentNode) {
								// 1382
								ap.unshift(cur); // 1383
							} // 1384
							cur = b; // 1385
							while (cur = cur.parentNode) {
								// 1386
								bp.unshift(cur); // 1387
							} // 1388
							// 1389
							// Walk down the tree looking for a discrepancy                                                                    // 1390
							while (ap[i] === bp[i]) {
								// 1391
								i++; // 1392
							} // 1393
							// 1394
							return i ? // 1395
							// Do a sibling check if the nodes have a common ancestor                                                         // 1396
							siblingCheck(ap[i], bp[i]) : // 1397
							// 1398
							// Otherwise nodes in our document sort first                                                                     // 1399
							ap[i] === preferredDoc ? -1 : // 1400
							bp[i] === preferredDoc ? 1 : // 1401
							0; // 1402
						}; // 1403
						// 1404
						return doc; // 1405
					}; // 1406
					// 1407
					Sizzle.matches = function (expr, elements) {
						// 1408
						return Sizzle(expr, null, null, elements); // 1409
					}; // 1410
					// 1411
					Sizzle.matchesSelector = function (elem, expr) {
						// 1412
						// Set document vars if needed                                                                                      // 1413
						if ((elem.ownerDocument || elem) !== document) {
							// 1414
							setDocument(elem); // 1415
						} // 1416
						// 1417
						// Make sure that attribute selectors are quoted                                                                    // 1418
						expr = expr.replace(rattributeQuotes, "='$1']"); // 1419
						// 1420
						if (support.matchesSelector && documentIsHTML && ( // 1421
						!rbuggyMatches || !rbuggyMatches.test(expr)) && ( // 1422
						!rbuggyQSA || !rbuggyQSA.test(expr))) {
							// 1423
							// 1424
							try {
								// 1425
								var ret = matches.call(elem, expr); // 1426
								// 1427
								// IE 9's matchesSelector returns false on disconnected nodes                                                     // 1428
								if (ret || support.disconnectedMatch || // 1429
								// As well, disconnected nodes are said to be in a document                                                     // 1430
								// fragment in IE 9                                                                                             // 1431
								elem.document && elem.document.nodeType !== 11) {
									// 1432
									return ret; // 1433
								} // 1434
							} catch (e) {} // 1435
						} // 1436
						// 1437
						return Sizzle(expr, document, null, [elem]).length > 0; // 1438
					}; // 1439
					// 1440
					Sizzle.contains = function (context, elem) {
						// 1441
						// Set document vars if needed                                                                                      // 1442
						if ((context.ownerDocument || context) !== document) {
							// 1443
							setDocument(context); // 1444
						} // 1445
						return contains(context, elem); // 1446
					}; // 1447
					// 1448
					Sizzle.attr = function (elem, name) {
						// 1449
						// Set document vars if needed                                                                                      // 1450
						if ((elem.ownerDocument || elem) !== document) {
							// 1451
							setDocument(elem); // 1452
						} // 1453
						// 1454
						var fn = Expr.attrHandle[name.toLowerCase()],
						    // 1455
						// Don't get fooled by Object.prototype properties (jQuery #13807)                                                 // 1456
						val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? // 1457
						fn(elem, name, !documentIsHTML) : // 1458
						undefined; // 1459
						// 1460
						return val !== undefined ? // 1461
						val : // 1462
						support.attributes || !documentIsHTML ? // 1463
						elem.getAttribute(name) : // 1464
						(val = elem.getAttributeNode(name)) && val.specified ? // 1465
						val.value : // 1466
						null; // 1467
					}; // 1468
					// 1469
					Sizzle.error = function (msg) {
						// 1470
						throw new Error("Syntax error, unrecognized expression: " + msg); // 1471
					}; // 1472
					// 1473
					/**                                                                                                                  // 1474
      * Document sorting and removing duplicates                                                                          // 1475
      * @param {ArrayLike} results                                                                                        // 1476
      */ // 1477
					Sizzle.uniqueSort = function (results) {
						// 1478
						var elem,
						    // 1479
						duplicates = [],
						    // 1480
						j = 0,
						    // 1481
						i = 0; // 1482
						// 1483
						// Unless we *know* we can detect duplicates, assume their presence                                                 // 1484
						hasDuplicate = !support.detectDuplicates; // 1485
						sortInput = !support.sortStable && results.slice(0); // 1486
						results.sort(sortOrder); // 1487
						// 1488
						if (hasDuplicate) {
							// 1489
							while (elem = results[i++]) {
								// 1490
								if (elem === results[i]) {
									// 1491
									j = duplicates.push(i); // 1492
								} // 1493
							} // 1494
							while (j--) {
								// 1495
								results.splice(duplicates[j], 1); // 1496
							} // 1497
						} // 1498
						// 1499
						// Clear input after sorting to release objects                                                                     // 1500
						// See https://github.com/jquery/sizzle/pull/225                                                                    // 1501
						sortInput = null; // 1502
						// 1503
						return results; // 1504
					}; // 1505
					// 1506
					/**                                                                                                                  // 1507
      * Utility function for retrieving the text value of an array of DOM nodes                                           // 1508
      * @param {Array|Element} elem                                                                                       // 1509
      */ // 1510
					getText = Sizzle.getText = function (elem) {
						// 1511
						var node,
						    // 1512
						ret = "",
						    // 1513
						i = 0,
						    // 1514
						nodeType = elem.nodeType; // 1515
						// 1516
						if (!nodeType) {
							// 1517
							// If no nodeType, this is expected to be an array                                                                 // 1518
							while (node = elem[i++]) {
								// 1519
								// Do not traverse comment nodes                                                                                  // 1520
								ret += getText(node); // 1521
							} // 1522
						} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
							// 1523
							// Use textContent for elements                                                                                    // 1524
							// innerText usage removed for consistency of new lines (jQuery #11153)                                            // 1525
							if (typeof elem.textContent === "string") {
								// 1526
								return elem.textContent; // 1527
							} else {
								// 1528
								// Traverse its children                                                                                          // 1529
								for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
									// 1530
									ret += getText(elem); // 1531
								} // 1532
							} // 1533
						} else if (nodeType === 3 || nodeType === 4) {
							// 1534
							return elem.nodeValue; // 1535
						} // 1536
						// Do not include comment or processing instruction nodes                                                           // 1537
						// 1538
						return ret; // 1539
					}; // 1540
					// 1541
					Expr = Sizzle.selectors = { // 1542
						// 1543
						// Can be adjusted by the user                                                                                      // 1544
						cacheLength: 50, // 1545
						// 1546
						createPseudo: markFunction, // 1547
						// 1548
						match: matchExpr, // 1549
						// 1550
						attrHandle: {}, // 1551
						// 1552
						find: {}, // 1553
						// 1554
						relative: { // 1555
							">": { dir: "parentNode", first: true }, // 1556
							" ": { dir: "parentNode" }, // 1557
							"+": { dir: "previousSibling", first: true }, // 1558
							"~": { dir: "previousSibling" // 1559
							} }, // 1560
						// 1561
						preFilter: { // 1562
							"ATTR": function (match) {
								// 1563
								match[1] = match[1].replace(runescape, funescape); // 1564
								// 1565
								// Move the given value to match[3] whether quoted or unquoted                                                    // 1566
								match[3] = (match[4] || match[5] || "").replace(runescape, funescape); // 1567
								// 1568
								if (match[2] === "~=") {
									// 1569
									match[3] = " " + match[3] + " "; // 1570
								} // 1571
								// 1572
								return match.slice(0, 4); // 1573
							}, // 1574
							// 1575
							"CHILD": function (match) {
								// 1576
								/* matches from matchExpr["CHILD"]                                                                                // 1577
        	1 type (only|nth|...)                                                                                            // 1578
        	2 what (child|of-type)                                                                                           // 1579
        	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)                                                                     // 1580
        	4 xn-component of xn+y argument ([+-]?\d*n|)                                                                     // 1581
        	5 sign of xn-component                                                                                           // 1582
        	6 x of xn-component                                                                                              // 1583
        	7 sign of y-component                                                                                            // 1584
        	8 y of y-component                                                                                               // 1585
        */ // 1586
								match[1] = match[1].toLowerCase(); // 1587
								// 1588
								if (match[1].slice(0, 3) === "nth") {
									// 1589
									// nth-* requires argument                                                                                       // 1590
									if (!match[3]) {
										// 1591
										Sizzle.error(match[0]); // 1592
									} // 1593
									// 1594
									// numeric x and y parameters for Expr.filter.CHILD                                                              // 1595
									// remember that false/true cast respectively to 0/1                                                             // 1596
									match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd")); // 1597
									match[5] = +(match[7] + match[8] || match[3] === "odd"); // 1598
									// 1599
									// other types prohibit arguments                                                                                 // 1600
								} else if (match[3]) {
									// 1601
									Sizzle.error(match[0]); // 1602
								} // 1603
								// 1604
								return match; // 1605
							}, // 1606
							// 1607
							"PSEUDO": function (match) {
								// 1608
								var excess,
								    // 1609
								unquoted = !match[5] && match[2]; // 1610
								// 1611
								if (matchExpr["CHILD"].test(match[0])) {
									// 1612
									return null; // 1613
								} // 1614
								// 1615
								// Accept quoted arguments as-is                                                                                  // 1616
								if (match[3] && match[4] !== undefined) {
									// 1617
									match[2] = match[4]; // 1618
									// 1619
									// Strip excess characters from unquoted arguments                                                                // 1620
								} else if (unquoted && rpseudo.test(unquoted) && ( // 1621
								// Get excess from tokenize (recursively)                                                                        // 1622
								excess = tokenize(unquoted, true)) && ( // 1623
								// advance to the next closing parenthesis                                                                       // 1624
								excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
									// 1625
									// 1626
									// excess is a negative index                                                                                    // 1627
									match[0] = match[0].slice(0, excess); // 1628
									match[2] = unquoted.slice(0, excess); // 1629
								} // 1630
								// 1631
								// Return only captures needed by the pseudo filter method (type and argument)                                    // 1632
								return match.slice(0, 3); // 1633
							} // 1634
						}, // 1635
						// 1636
						filter: { // 1637
							// 1638
							"TAG": function (nodeNameSelector) {
								// 1639
								var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase(); // 1640
								return nodeNameSelector === "*" ? // 1641
								function () {
									return true;
								} : // 1642
								function (elem) {
									// 1643
									return elem.nodeName && elem.nodeName.toLowerCase() === nodeName; // 1644
								}; // 1645
							}, // 1646
							// 1647
							"CLASS": function (className) {
								// 1648
								var pattern = classCache[className + " "]; // 1649
								// 1650
								return pattern || // 1651
								(pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && // 1652
								classCache(className, function (elem) {
									// 1653
									return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "");
								}); // 1655
							}, // 1656
							// 1657
							"ATTR": function (name, operator, check) {
								// 1658
								return function (elem) {
									// 1659
									var result = Sizzle.attr(elem, name); // 1660
									// 1661
									if (result == null) {
										// 1662
										return operator === "!="; // 1663
									} // 1664
									if (!operator) {
										// 1665
										return true; // 1666
									} // 1667
									// 1668
									result += ""; // 1669
									// 1670
									return operator === "=" ? result === check : // 1671
									operator === "!=" ? result !== check : // 1672
									operator === "^=" ? check && result.indexOf(check) === 0 : // 1673
									operator === "*=" ? check && result.indexOf(check) > -1 : // 1674
									operator === "$=" ? check && result.slice(-check.length) === check : // 1675
									operator === "~=" ? (" " + result + " ").indexOf(check) > -1 : // 1676
									operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : // 1677
									false; // 1678
								}; // 1679
							}, // 1680
							// 1681
							"CHILD": function (type, what, argument, first, last) {
								// 1682
								var simple = type.slice(0, 3) !== "nth",
								    // 1683
								forward = type.slice(-4) !== "last",
								    // 1684
								ofType = what === "of-type"; // 1685
								// 1686
								return first === 1 && last === 0 ? // 1687
								// 1688
								// Shortcut for :nth-*(n)                                                                                        // 1689
								function (elem) {
									// 1690
									return !!elem.parentNode; // 1691
								} : // 1692
								// 1693
								function (elem, context, xml) {
									// 1694
									var cache,
									    outerCache,
									    node,
									    diff,
									    nodeIndex,
									    start,
									    // 1695
									dir = simple !== forward ? "nextSibling" : "previousSibling",
									    // 1696
									parent = elem.parentNode,
									    // 1697
									name = ofType && elem.nodeName.toLowerCase(),
									    // 1698
									useCache = !xml && !ofType; // 1699
									// 1700
									if (parent) {
										// 1701
										// 1702
										// :(first|last|only)-(child|of-type)                                                                          // 1703
										if (simple) {
											// 1704
											while (dir) {
												// 1705
												node = elem; // 1706
												while (node = node[dir]) {
													// 1707
													if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
														// 1708
														return false; // 1709
													} // 1710
												} // 1711
												// Reverse direction for :only-* (if we haven't yet done so)                                                 // 1712
												start = dir = type === "only" && !start && "nextSibling"; // 1713
											} // 1714
											return true; // 1715
										} // 1716
										// 1717
										start = [forward ? parent.firstChild : parent.lastChild]; // 1718
										// 1719
										// non-xml :nth-child(...) stores cache data on `parent`                                                       // 1720
										if (forward && useCache) {
											// 1721
											// Seek `elem` from a previously-cached index                                                                 // 1722
											outerCache = parent[expando] || (parent[expando] = {}); // 1723
											cache = outerCache[type] || []; // 1724
											nodeIndex = cache[0] === dirruns && cache[1]; // 1725
											diff = cache[0] === dirruns && cache[2]; // 1726
											node = nodeIndex && parent.childNodes[nodeIndex]; // 1727
											// 1728
											while (node = ++nodeIndex && node && node[dir] || ( // 1729
											// 1730
											// Fallback to seeking `elem` from the start                                                                 // 1731
											diff = nodeIndex = 0) || start.pop()) {
												// 1732
												// 1733
												// When found, cache indexes on `parent` and break                                                           // 1734
												if (node.nodeType === 1 && ++diff && node === elem) {
													// 1735
													outerCache[type] = [dirruns, nodeIndex, diff]; // 1736
													break; // 1737
												} // 1738
											} // 1739
											// 1740
											// Use previously-cached element index if available                                                            // 1741
										} else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
											diff = cache[1]; // 1743
											// 1744
											// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)                                    // 1745
										} else {
											// 1746
											// Use the same loop as above to seek `elem` from the start                                                   // 1747
											while (node = ++nodeIndex && node && node[dir] || ( // 1748
											diff = nodeIndex = 0) || start.pop()) {
												// 1749
												// 1750
												if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
													// 1751
													// Cache the index of each encountered element                                                              // 1752
													if (useCache) {
														// 1753
														(node[expando] || (node[expando] = {}))[type] = [dirruns, diff]; // 1754
													} // 1755
													// 1756
													if (node === elem) {
														// 1757
														break; // 1758
													} // 1759
												} // 1760
											} // 1761
										} // 1762
										// 1763
										// Incorporate the offset, then check against cycle size                                                       // 1764
										diff -= last; // 1765
										return diff === first || diff % first === 0 && diff / first >= 0; // 1766
									} // 1767
								}; // 1768
							}, // 1769
							// 1770
							"PSEUDO": function (pseudo, argument) {
								// 1771
								// pseudo-class names are case-insensitive                                                                        // 1772
								// http://www.w3.org/TR/selectors/#pseudo-classes                                                                 // 1773
								// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters                         // 1774
								// Remember that setFilters inherits from pseudos                                                                 // 1775
								var args,
								    // 1776
								fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || // 1777
								Sizzle.error("unsupported pseudo: " + pseudo); // 1778
								// 1779
								// The user may use createPseudo to indicate that                                                                 // 1780
								// arguments are needed to create the filter function                                                             // 1781
								// just as Sizzle does                                                                                            // 1782
								if (fn[expando]) {
									// 1783
									return fn(argument); // 1784
								} // 1785
								// 1786
								// But maintain support for old signatures                                                                        // 1787
								if (fn.length > 1) {
									// 1788
									args = [pseudo, pseudo, "", argument]; // 1789
									return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? // 1790
									markFunction(function (seed, matches) {
										// 1791
										var idx,
										    // 1792
										matched = fn(seed, argument),
										    // 1793
										i = matched.length; // 1794
										while (i--) {
											// 1795
											idx = indexOf.call(seed, matched[i]); // 1796
											seed[idx] = !(matches[idx] = matched[i]); // 1797
										} // 1798
									}) : // 1799
									function (elem) {
										// 1800
										return fn(elem, 0, args); // 1801
									}; // 1802
								} // 1803
								// 1804
								return fn; // 1805
							} // 1806
						}, // 1807
						// 1808
						pseudos: { // 1809
							// Potentially complex pseudos                                                                                     // 1810
							"not": markFunction(function (selector) {
								// 1811
								// Trim the selector passed to compile                                                                            // 1812
								// to avoid treating leading and trailing                                                                         // 1813
								// spaces as combinators                                                                                          // 1814
								var input = [],
								    // 1815
								results = [],
								    // 1816
								matcher = compile(selector.replace(rtrim, "$1")); // 1817
								// 1818
								return matcher[expando] ? // 1819
								markFunction(function (seed, matches, context, xml) {
									// 1820
									var elem,
									    // 1821
									unmatched = matcher(seed, null, xml, []),
									    // 1822
									i = seed.length; // 1823
									// 1824
									// Match elements unmatched by `matcher`                                                                        // 1825
									while (i--) {
										// 1826
										if (elem = unmatched[i]) {
											// 1827
											seed[i] = !(matches[i] = elem); // 1828
										} // 1829
									} // 1830
								}) : // 1831
								function (elem, context, xml) {
									// 1832
									input[0] = elem; // 1833
									matcher(input, null, xml, results); // 1834
									return !results.pop(); // 1835
								}; // 1836
							}), // 1837
							// 1838
							"has": markFunction(function (selector) {
								// 1839
								return function (elem) {
									// 1840
									return Sizzle(selector, elem).length > 0; // 1841
								}; // 1842
							}), // 1843
							// 1844
							"contains": markFunction(function (text) {
								// 1845
								return function (elem) {
									// 1846
									return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1; // 1847
								}; // 1848
							}), // 1849
							// 1850
							// "Whether an element is represented by a :lang() selector                                                        // 1851
							// is based solely on the element's language value                                                                 // 1852
							// being equal to the identifier C,                                                                                // 1853
							// or beginning with the identifier C immediately followed by "-".                                                 // 1854
							// The matching of C against the element's language value is performed case-insensitively.                         // 1855
							// The identifier C does not have to be a valid language name."                                                    // 1856
							// http://www.w3.org/TR/selectors/#lang-pseudo                                                                     // 1857
							"lang": markFunction(function (lang) {
								// 1858
								// lang value must be a valid identifier                                                                          // 1859
								if (!ridentifier.test(lang || "")) {
									// 1860
									Sizzle.error("unsupported lang: " + lang); // 1861
								} // 1862
								lang = lang.replace(runescape, funescape).toLowerCase(); // 1863
								return function (elem) {
									// 1864
									var elemLang; // 1865
									do {
										// 1866
										if (elemLang = documentIsHTML ? // 1867
										elem.lang : // 1868
										elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
											// 1869
											// 1870
											elemLang = elemLang.toLowerCase(); // 1871
											return elemLang === lang || elemLang.indexOf(lang + "-") === 0; // 1872
										} // 1873
									} while ((elem = elem.parentNode) && elem.nodeType === 1); // 1874
									return false; // 1875
								}; // 1876
							}), // 1877
							// 1878
							// Miscellaneous                                                                                                   // 1879
							"target": function (elem) {
								// 1880
								var hash = window.location && window.location.hash; // 1881
								return hash && hash.slice(1) === elem.id; // 1882
							}, // 1883
							// 1884
							"root": function (elem) {
								// 1885
								return elem === docElem; // 1886
							}, // 1887
							// 1888
							"focus": function (elem) {
								// 1889
								return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
							}, // 1891
							// 1892
							// Boolean properties                                                                                              // 1893
							"enabled": function (elem) {
								// 1894
								return elem.disabled === false; // 1895
							}, // 1896
							// 1897
							"disabled": function (elem) {
								// 1898
								return elem.disabled === true; // 1899
							}, // 1900
							// 1901
							"checked": function (elem) {
								// 1902
								// In CSS3, :checked should return both checked and selected elements                                             // 1903
								// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked                                                 // 1904
								var nodeName = elem.nodeName.toLowerCase(); // 1905
								return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected; // 1906
							}, // 1907
							// 1908
							"selected": function (elem) {
								// 1909
								// Accessing this property makes selected-by-default                                                              // 1910
								// options in Safari work properly                                                                                // 1911
								if (elem.parentNode) {
									// 1912
									elem.parentNode.selectedIndex; // 1913
								} // 1914
								// 1915
								return elem.selected === true; // 1916
							}, // 1917
							// 1918
							// Contents                                                                                                        // 1919
							"empty": function (elem) {
								// 1920
								// http://www.w3.org/TR/selectors/#empty-pseudo                                                                   // 1921
								// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),                          // 1922
								//   but not by others (comment: 8; processing instruction: 7; etc.)                                              // 1923
								// nodeType < 6 works because attributes (2) do not appear as children                                            // 1924
								for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
									// 1925
									if (elem.nodeType < 6) {
										// 1926
										return false; // 1927
									} // 1928
								} // 1929
								return true; // 1930
							}, // 1931
							// 1932
							"parent": function (elem) {
								// 1933
								return !Expr.pseudos["empty"](elem); // 1934
							}, // 1935
							// 1936
							// Element/input types                                                                                             // 1937
							"header": function (elem) {
								// 1938
								return rheader.test(elem.nodeName); // 1939
							}, // 1940
							// 1941
							"input": function (elem) {
								// 1942
								return rinputs.test(elem.nodeName); // 1943
							}, // 1944
							// 1945
							"button": function (elem) {
								// 1946
								var name = elem.nodeName.toLowerCase(); // 1947
								return name === "input" && elem.type === "button" || name === "button"; // 1948
							}, // 1949
							// 1950
							"text": function (elem) {
								// 1951
								var attr; // 1952
								return elem.nodeName.toLowerCase() === "input" && // 1953
								elem.type === "text" && ( // 1954
								// 1955
								// Support: IE<8                                                                                                 // 1956
								// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"                                  // 1957
								(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text"); // 1958
							}, // 1959
							// 1960
							// Position-in-collection                                                                                          // 1961
							"first": createPositionalPseudo(function () {
								// 1962
								return [0]; // 1963
							}), // 1964
							// 1965
							"last": createPositionalPseudo(function (matchIndexes, length) {
								// 1966
								return [length - 1]; // 1967
							}), // 1968
							// 1969
							"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
								// 1970
								return [argument < 0 ? argument + length : argument]; // 1971
							}), // 1972
							// 1973
							"even": createPositionalPseudo(function (matchIndexes, length) {
								// 1974
								var i = 0; // 1975
								for (; i < length; i += 2) {
									// 1976
									matchIndexes.push(i); // 1977
								} // 1978
								return matchIndexes; // 1979
							}), // 1980
							// 1981
							"odd": createPositionalPseudo(function (matchIndexes, length) {
								// 1982
								var i = 1; // 1983
								for (; i < length; i += 2) {
									// 1984
									matchIndexes.push(i); // 1985
								} // 1986
								return matchIndexes; // 1987
							}), // 1988
							// 1989
							"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
								// 1990
								var i = argument < 0 ? argument + length : argument; // 1991
								for (; --i >= 0;) {
									// 1992
									matchIndexes.push(i); // 1993
								} // 1994
								return matchIndexes; // 1995
							}), // 1996
							// 1997
							"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
								// 1998
								var i = argument < 0 ? argument + length : argument; // 1999
								for (; ++i < length;) {
									// 2000
									matchIndexes.push(i); // 2001
								} // 2002
								return matchIndexes; // 2003
							}) // 2004
							// 2005
						} }; // 2006
					// 2007
					Expr.pseudos["nth"] = Expr.pseudos["eq"]; // 2008
					// 2009
					// Add button/input type pseudos                                                                                     // 2010
					for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
						// 2011
						Expr.pseudos[i] = createInputPseudo(i); // 2012
					} // 2013
					for (i in { submit: true, reset: true }) {
						// 2014
						Expr.pseudos[i] = createButtonPseudo(i); // 2015
					} // 2016
					// 2017
					// Easy API for creating new setFilters                                                                              // 2018
					function setFilters() {} // 2019
					setFilters.prototype = Expr.filters = Expr.pseudos; // 2020
					Expr.setFilters = new setFilters(); // 2021
					// 2022
					function tokenize(selector, parseOnly) {
						// 2023
						var matched,
						    match,
						    tokens,
						    type,
						    // 2024
						soFar,
						    groups,
						    preFilters,
						    // 2025
						cached = tokenCache[selector + " "]; // 2026
						// 2027
						if (cached) {
							// 2028
							return parseOnly ? 0 : cached.slice(0); // 2029
						} // 2030
						// 2031
						soFar = selector; // 2032
						groups = []; // 2033
						preFilters = Expr.preFilter; // 2034
						// 2035
						while (soFar) {
							// 2036
							// 2037
							// Comma and first run                                                                                             // 2038
							if (!matched || (match = rcomma.exec(soFar))) {
								// 2039
								if (match) {
									// 2040
									// Don't consume trailing commas as valid                                                                        // 2041
									soFar = soFar.slice(match[0].length) || soFar; // 2042
								} // 2043
								groups.push(tokens = []); // 2044
							} // 2045
							// 2046
							matched = false; // 2047
							// 2048
							// Combinators                                                                                                     // 2049
							if (match = rcombinators.exec(soFar)) {
								// 2050
								matched = match.shift(); // 2051
								tokens.push({ // 2052
									value: matched, // 2053
									// Cast descendant combinators to space                                                                          // 2054
									type: match[0].replace(rtrim, " ") // 2055
								}); // 2056
								soFar = soFar.slice(matched.length); // 2057
							} // 2058
							// 2059
							// Filters                                                                                                         // 2060
							for (type in Expr.filter) {
								// 2061
								if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || ( // 2062
								match = preFilters[type](match)))) {
									// 2063
									matched = match.shift(); // 2064
									tokens.push({ // 2065
										value: matched, // 2066
										type: type, // 2067
										matches: match // 2068
									}); // 2069
									soFar = soFar.slice(matched.length); // 2070
								} // 2071
							} // 2072
							// 2073
							if (!matched) {
								// 2074
								break; // 2075
							} // 2076
						} // 2077
						// 2078
						// Return the length of the invalid excess                                                                          // 2079
						// if we're just parsing                                                                                            // 2080
						// Otherwise, throw an error or return tokens                                                                       // 2081
						return parseOnly ? // 2082
						soFar.length : // 2083
						soFar ? // 2084
						Sizzle.error(selector) : // 2085
						// Cache the tokens                                                                                               // 2086
						tokenCache(selector, groups).slice(0); // 2087
					} // 2088
					// 2089
					function toSelector(tokens) {
						// 2090
						var i = 0,
						    // 2091
						len = tokens.length,
						    // 2092
						selector = ""; // 2093
						for (; i < len; i++) {
							// 2094
							selector += tokens[i].value; // 2095
						} // 2096
						return selector; // 2097
					} // 2098
					// 2099
					function addCombinator(matcher, combinator, base) {
						// 2100
						var dir = combinator.dir,
						    // 2101
						checkNonElements = base && dir === "parentNode",
						    // 2102
						doneName = done++; // 2103
						// 2104
						return combinator.first ? // 2105
						// Check against closest ancestor/preceding element                                                                // 2106
						function (elem, context, xml) {
							// 2107
							while (elem = elem[dir]) {
								// 2108
								if (elem.nodeType === 1 || checkNonElements) {
									// 2109
									return matcher(elem, context, xml); // 2110
								} // 2111
							} // 2112
						} : // 2113
						// 2114
						// Check against all ancestor/preceding elements                                                                   // 2115
						function (elem, context, xml) {
							// 2116
							var oldCache,
							    outerCache,
							    // 2117
							newCache = [dirruns, doneName]; // 2118
							// 2119
							// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching                               // 2120
							if (xml) {
								// 2121
								while (elem = elem[dir]) {
									// 2122
									if (elem.nodeType === 1 || checkNonElements) {
										// 2123
										if (matcher(elem, context, xml)) {
											// 2124
											return true; // 2125
										} // 2126
									} // 2127
								} // 2128
							} else {
								// 2129
								while (elem = elem[dir]) {
									// 2130
									if (elem.nodeType === 1 || checkNonElements) {
										// 2131
										outerCache = elem[expando] || (elem[expando] = {}); // 2132
										if ((oldCache = outerCache[dir]) && // 2133
										oldCache[0] === dirruns && oldCache[1] === doneName) {
											// 2134
											// 2135
											// Assign to newCache so results back-propagate to previous elements                                          // 2136
											return newCache[2] = oldCache[2]; // 2137
										} else {
											// 2138
											// Reuse newcache so results back-propagate to previous elements                                              // 2139
											outerCache[dir] = newCache; // 2140
											// 2141
											// A match means we're done; a fail means we have to keep checking                                            // 2142
											if (newCache[2] = matcher(elem, context, xml)) {
												// 2143
												return true; // 2144
											} // 2145
										} // 2146
									} // 2147
								} // 2148
							} // 2149
						}; // 2150
					} // 2151
					// 2152
					function elementMatcher(matchers) {
						// 2153
						return matchers.length > 1 ? // 2154
						function (elem, context, xml) {
							// 2155
							var i = matchers.length; // 2156
							while (i--) {
								// 2157
								if (!matchers[i](elem, context, xml)) {
									// 2158
									return false; // 2159
								} // 2160
							} // 2161
							return true; // 2162
						} : // 2163
						matchers[0]; // 2164
					} // 2165
					// 2166
					function condense(unmatched, map, filter, context, xml) {
						// 2167
						var elem,
						    // 2168
						newUnmatched = [],
						    // 2169
						i = 0,
						    // 2170
						len = unmatched.length,
						    // 2171
						mapped = map != null; // 2172
						// 2173
						for (; i < len; i++) {
							// 2174
							if (elem = unmatched[i]) {
								// 2175
								if (!filter || filter(elem, context, xml)) {
									// 2176
									newUnmatched.push(elem); // 2177
									if (mapped) {
										// 2178
										map.push(i); // 2179
									} // 2180
								} // 2181
							} // 2182
						} // 2183
						// 2184
						return newUnmatched; // 2185
					} // 2186
					// 2187
					function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
						// 2188
						if (postFilter && !postFilter[expando]) {
							// 2189
							postFilter = setMatcher(postFilter); // 2190
						} // 2191
						if (postFinder && !postFinder[expando]) {
							// 2192
							postFinder = setMatcher(postFinder, postSelector); // 2193
						} // 2194
						return markFunction(function (seed, results, context, xml) {
							// 2195
							var temp,
							    i,
							    elem,
							    // 2196
							preMap = [],
							    // 2197
							postMap = [],
							    // 2198
							preexisting = results.length,
							    // 2199
							// 2200
							// Get initial elements from seed or context                                                                      // 2201
							elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
							    // 2202
							// 2203
							// Prefilter to get matcher input, preserving a map for seed-results synchronization                              // 2204
							matcherIn = preFilter && (seed || !selector) ? // 2205
							condense(elems, preMap, preFilter, context, xml) : // 2206
							elems,
							    // 2207
							// 2208
							matcherOut = matcher ? // 2209
							// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,                     // 2210
							postFinder || (seed ? preFilter : preexisting || postFilter) ? // 2211
							// 2212
							// ...intermediate processing is necessary                                                                      // 2213
							[] : // 2214
							// 2215
							// ...otherwise use results directly                                                                            // 2216
							results : // 2217
							matcherIn; // 2218
							// 2219
							// Find primary matches                                                                                            // 2220
							if (matcher) {
								// 2221
								matcher(matcherIn, matcherOut, context, xml); // 2222
							} // 2223
							// 2224
							// Apply postFilter                                                                                                // 2225
							if (postFilter) {
								// 2226
								temp = condense(matcherOut, postMap); // 2227
								postFilter(temp, [], context, xml); // 2228
								// 2229
								// Un-match failing elements by moving them back to matcherIn                                                     // 2230
								i = temp.length; // 2231
								while (i--) {
									// 2232
									if (elem = temp[i]) {
										// 2233
										matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem); // 2234
									} // 2235
								} // 2236
							} // 2237
							// 2238
							if (seed) {
								// 2239
								if (postFinder || preFilter) {
									// 2240
									if (postFinder) {
										// 2241
										// Get the final matcherOut by condensing this intermediate into postFinder contexts                            // 2242
										temp = []; // 2243
										i = matcherOut.length; // 2244
										while (i--) {
											// 2245
											if (elem = matcherOut[i]) {
												// 2246
												// Restore matcherIn since elem is not yet a final match                                                      // 2247
												temp.push(matcherIn[i] = elem); // 2248
											} // 2249
										} // 2250
										postFinder(null, matcherOut = [], temp, xml); // 2251
									} // 2252
									// 2253
									// Move matched elements from seed to results to keep them synchronized                                          // 2254
									i = matcherOut.length; // 2255
									while (i--) {
										// 2256
										if ((elem = matcherOut[i]) && // 2257
										(temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
											// 2258
											// 2259
											seed[temp] = !(results[temp] = elem); // 2260
										} // 2261
									} // 2262
								} // 2263
								// 2264
								// Add elements to results, through postFinder if defined                                                          // 2265
							} else {
								// 2266
								matcherOut = condense( // 2267
								matcherOut === results ? // 2268
								matcherOut.splice(preexisting, matcherOut.length) : // 2269
								matcherOut // 2270
								); // 2271
								if (postFinder) {
									// 2272
									postFinder(null, results, matcherOut, xml); // 2273
								} else {
									// 2274
									push.apply(results, matcherOut); // 2275
								} // 2276
							} // 2277
						}); // 2278
					} // 2279
					// 2280
					function matcherFromTokens(tokens) {
						// 2281
						var checkContext,
						    matcher,
						    j,
						    // 2282
						len = tokens.length,
						    // 2283
						leadingRelative = Expr.relative[tokens[0].type],
						    // 2284
						implicitRelative = leadingRelative || Expr.relative[" "],
						    // 2285
						i = leadingRelative ? 1 : 0,
						    // 2286
						// 2287
						// The foundational matcher ensures that elements are reachable from top-level context(s)                          // 2288
						matchContext = addCombinator(function (elem) {
							// 2289
							return elem === checkContext; // 2290
						}, implicitRelative, true),
						    // 2291
						matchAnyContext = addCombinator(function (elem) {
							// 2292
							return indexOf.call(checkContext, elem) > -1; // 2293
						}, implicitRelative, true),
						    // 2294
						matchers = [function (elem, context, xml) {
							// 2295
							return !leadingRelative && (xml || context !== outermostContext) || ( // 2296
							(checkContext = context).nodeType ? // 2297
							matchContext(elem, context, xml) : // 2298
							matchAnyContext(elem, context, xml)); // 2299
						}]; // 2300
						// 2301
						for (; i < len; i++) {
							// 2302
							if (matcher = Expr.relative[tokens[i].type]) {
								// 2303
								matchers = [addCombinator(elementMatcher(matchers), matcher)]; // 2304
							} else {
								// 2305
								matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches); // 2306
								// 2307
								// Return special upon seeing a positional matcher                                                                // 2308
								if (matcher[expando]) {
									// 2309
									// Find the next relative operator (if any) for proper handling                                                  // 2310
									j = ++i; // 2311
									for (; j < len; j++) {
										// 2312
										if (Expr.relative[tokens[j].type]) {
											// 2313
											break; // 2314
										} // 2315
									} // 2316
									return setMatcher( // 2317
									i > 1 && elementMatcher(matchers), // 2318
									i > 1 && toSelector( // 2319
									// If the preceding token was a descendant combinator, insert an implicit any-element `*`                      // 2320
									tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" }) // 2321
									).replace(rtrim, "$1"), // 2322
									matcher, // 2323
									i < j && matcherFromTokens(tokens.slice(i, j)), // 2324
									j < len && matcherFromTokens(tokens = tokens.slice(j)), // 2325
									j < len && toSelector(tokens) // 2326
									); // 2327
								} // 2328
								matchers.push(matcher); // 2329
							} // 2330
						} // 2331
						// 2332
						return elementMatcher(matchers); // 2333
					} // 2334
					// 2335
					function matcherFromGroupMatchers(elementMatchers, setMatchers) {
						// 2336
						var bySet = setMatchers.length > 0,
						    // 2337
						byElement = elementMatchers.length > 0,
						    // 2338
						superMatcher = function (seed, context, xml, results, outermost) {
							// 2339
							var elem,
							    j,
							    matcher,
							    // 2340
							matchedCount = 0,
							    // 2341
							i = "0",
							    // 2342
							unmatched = seed && [],
							    // 2343
							setMatched = [],
							    // 2344
							contextBackup = outermostContext,
							    // 2345
							// We must always have either seed elements or outermost context                                                 // 2346
							elems = seed || byElement && Expr.find["TAG"]("*", outermost),
							    // 2347
							// Use integer dirruns iff this is the outermost matcher                                                         // 2348
							dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
							    // 2349
							len = elems.length; // 2350
							// 2351
							if (outermost) {
								// 2352
								outermostContext = context !== document && context; // 2353
							} // 2354
							// 2355
							// Add elements passing elementMatchers directly to results                                                       // 2356
							// Keep `i` a string if there are no elements so `matchedCount` will be "00" below                                // 2357
							// Support: IE<9, Safari                                                                                          // 2358
							// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id                          // 2359
							for (; i !== len && (elem = elems[i]) != null; i++) {
								// 2360
								if (byElement && elem) {
									// 2361
									j = 0; // 2362
									while (matcher = elementMatchers[j++]) {
										// 2363
										if (matcher(elem, context, xml)) {
											// 2364
											results.push(elem); // 2365
											break; // 2366
										} // 2367
									} // 2368
									if (outermost) {
										// 2369
										dirruns = dirrunsUnique; // 2370
									} // 2371
								} // 2372
								// 2373
								// Track unmatched elements for set filters                                                                      // 2374
								if (bySet) {
									// 2375
									// They will have gone through all possible matchers                                                            // 2376
									if (elem = !matcher && elem) {
										// 2377
										matchedCount--; // 2378
									} // 2379
									// 2380
									// Lengthen the array for every element, matched or not                                                         // 2381
									if (seed) {
										// 2382
										unmatched.push(elem); // 2383
									} // 2384
								} // 2385
							} // 2386
							// 2387
							// Apply set filters to unmatched elements                                                                        // 2388
							matchedCount += i; // 2389
							if (bySet && i !== matchedCount) {
								// 2390
								j = 0; // 2391
								while (matcher = setMatchers[j++]) {
									// 2392
									matcher(unmatched, setMatched, context, xml); // 2393
								} // 2394
								// 2395
								if (seed) {
									// 2396
									// Reintegrate element matches to eliminate the need for sorting                                                // 2397
									if (matchedCount > 0) {
										// 2398
										while (i--) {
											// 2399
											if (!(unmatched[i] || setMatched[i])) {
												// 2400
												setMatched[i] = pop.call(results); // 2401
											} // 2402
										} // 2403
									} // 2404
									// 2405
									// Discard index placeholder values to get only actual matches                                                  // 2406
									setMatched = condense(setMatched); // 2407
								} // 2408
								// 2409
								// Add matches to results                                                                                        // 2410
								push.apply(results, setMatched); // 2411
								// 2412
								// Seedless set matches succeeding multiple successful matchers stipulate sorting                                // 2413
								if (outermost && !seed && setMatched.length > 0 && // 2414
								matchedCount + setMatchers.length > 1) {
									// 2415
									// 2416
									Sizzle.uniqueSort(results); // 2417
								} // 2418
							} // 2419
							// 2420
							// Override manipulation of globals by nested matchers                                                            // 2421
							if (outermost) {
								// 2422
								dirruns = dirrunsUnique; // 2423
								outermostContext = contextBackup; // 2424
							} // 2425
							// 2426
							return unmatched; // 2427
						}; // 2428
						// 2429
						return bySet ? // 2430
						markFunction(superMatcher) : // 2431
						superMatcher; // 2432
					} // 2433
					// 2434
					compile = Sizzle.compile = function (selector, group /* Internal Use Only */) {
						// 2435
						var i,
						    // 2436
						setMatchers = [],
						    // 2437
						elementMatchers = [],
						    // 2438
						cached = compilerCache[selector + " "]; // 2439
						// 2440
						if (!cached) {
							// 2441
							// Generate a function of recursive functions that can be used to check each element                               // 2442
							if (!group) {
								// 2443
								group = tokenize(selector); // 2444
							} // 2445
							i = group.length; // 2446
							while (i--) {
								// 2447
								cached = matcherFromTokens(group[i]); // 2448
								if (cached[expando]) {
									// 2449
									setMatchers.push(cached); // 2450
								} else {
									// 2451
									elementMatchers.push(cached); // 2452
								} // 2453
							} // 2454
							// 2455
							// Cache the compiled function                                                                                     // 2456
							cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers)); // 2457
						} // 2458
						return cached; // 2459
					}; // 2460
					// 2461
					function multipleContexts(selector, contexts, results) {
						// 2462
						var i = 0,
						    // 2463
						len = contexts.length; // 2464
						for (; i < len; i++) {
							// 2465
							Sizzle(selector, contexts[i], results); // 2466
						} // 2467
						return results; // 2468
					} // 2469
					// 2470
					function select(selector, context, results, seed) {
						// 2471
						var i,
						    tokens,
						    token,
						    type,
						    find,
						    // 2472
						match = tokenize(selector); // 2473
						// 2474
						if (!seed) {
							// 2475
							// Try to minimize operations if there is only one group                                                           // 2476
							if (match.length === 1) {
								// 2477
								// 2478
								// Take a shortcut and set the context if the root selector is an ID                                              // 2479
								tokens = match[0] = match[0].slice(0); // 2480
								if (tokens.length > 2 && (token = tokens[0]).type === "ID" && // 2481
								support.getById && context.nodeType === 9 && documentIsHTML && // 2482
								Expr.relative[tokens[1].type]) {
									// 2483
									// 2484
									context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0]; // 2485
									if (!context) {
										// 2486
										return results; // 2487
									} // 2488
									selector = selector.slice(tokens.shift().value.length); // 2489
								} // 2490
								// 2491
								// Fetch a seed set for right-to-left matching                                                                    // 2492
								i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length; // 2493
								while (i--) {
									// 2494
									token = tokens[i]; // 2495
									// 2496
									// Abort if we hit a combinator                                                                                  // 2497
									if (Expr.relative[type = token.type]) {
										// 2498
										break; // 2499
									} // 2500
									if (find = Expr.find[type]) {
										// 2501
										// Search, expanding context for leading sibling combinators                                                    // 2502
										if (seed = find( // 2503
										token.matches[0].replace(runescape, funescape), // 2504
										rsibling.test(tokens[0].type) && testContext(context.parentNode) || context // 2505
										)) {
											// 2506
											// 2507
											// If seed is empty or no tokens remain, we can return early                                                   // 2508
											tokens.splice(i, 1); // 2509
											selector = seed.length && toSelector(tokens); // 2510
											if (!selector) {
												// 2511
												push.apply(results, seed); // 2512
												return results; // 2513
											} // 2514
											// 2515
											break; // 2516
										} // 2517
									} // 2518
								} // 2519
							} // 2520
						} // 2521
						// 2522
						// Compile and execute a filtering function                                                                         // 2523
						// Provide `match` to avoid retokenization if we modified the selector above                                        // 2524
						compile(selector, match)( // 2525
						seed, // 2526
						context, // 2527
						!documentIsHTML, // 2528
						results, // 2529
						rsibling.test(selector) && testContext(context.parentNode) || context // 2530
						); // 2531
						return results; // 2532
					} // 2533
					// 2534
					// One-time assignments                                                                                              // 2535
					// 2536
					// Sort stability                                                                                                    // 2537
					support.sortStable = expando.split("").sort(sortOrder).join("") === expando; // 2538
					// 2539
					// Support: Chrome<14                                                                                                // 2540
					// Always assume duplicates if they aren't passed to the comparison function                                         // 2541
					support.detectDuplicates = !!hasDuplicate; // 2542
					// 2543
					// Initialize against the default document                                                                           // 2544
					setDocument(); // 2545
					// 2546
					// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)                                              // 2547
					// Detached nodes confoundingly follow *each other*                                                                  // 2548
					support.sortDetached = assert(function (div1) {
						// 2549
						// Should return 1, but returns 4 (following)                                                                       // 2550
						return div1.compareDocumentPosition(document.createElement("div")) & 1; // 2551
					}); // 2552
					// 2553
					// Support: IE<8                                                                                                     // 2554
					// Prevent attribute/property "interpolation"                                                                        // 2555
					// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx                                                  // 2556
					if (!assert(function (div) {
						// 2557
						div.innerHTML = "<a href='#'></a>"; // 2558
						return div.firstChild.getAttribute("href") === "#"; // 2559
					})) {
						// 2560
						addHandle("type|href|height|width", function (elem, name, isXML) {
							// 2561
							if (!isXML) {
								// 2562
								return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2); // 2563
							} // 2564
						}); // 2565
					} // 2566
					// 2567
					// Support: IE<9                                                                                                     // 2568
					// Use defaultValue in place of getAttribute("value")                                                                // 2569
					if (!support.attributes || !assert(function (div) {
						// 2570
						div.innerHTML = "<input/>"; // 2571
						div.firstChild.setAttribute("value", ""); // 2572
						return div.firstChild.getAttribute("value") === ""; // 2573
					})) {
						// 2574
						addHandle("value", function (elem, name, isXML) {
							// 2575
							if (!isXML && elem.nodeName.toLowerCase() === "input") {
								// 2576
								return elem.defaultValue; // 2577
							} // 2578
						}); // 2579
					} // 2580
					// 2581
					// Support: IE<9                                                                                                     // 2582
					// Use getAttributeNode to fetch booleans when getAttribute lies                                                     // 2583
					if (!assert(function (div) {
						// 2584
						return div.getAttribute("disabled") == null; // 2585
					})) {
						// 2586
						addHandle(booleans, function (elem, name, isXML) {
							// 2587
							var val; // 2588
							if (!isXML) {
								// 2589
								return elem[name] === true ? name.toLowerCase() : // 2590
								(val = elem.getAttributeNode(name)) && val.specified ? // 2591
								val.value : // 2592
								null; // 2593
							} // 2594
						}); // 2595
					} // 2596
					// 2597
					return Sizzle; // 2598
					// 2599
				}(window); // 2600
				// 2601
				// 2602
				// 2603
				jQuery.find = Sizzle; // 2604
				jQuery.expr = Sizzle.selectors; // 2605
				jQuery.expr[":"] = jQuery.expr.pseudos; // 2606
				jQuery.unique = Sizzle.uniqueSort; // 2607
				jQuery.text = Sizzle.getText; // 2608
				jQuery.isXMLDoc = Sizzle.isXML; // 2609
				jQuery.contains = Sizzle.contains; // 2610
				// 2611
				// 2612
				// 2613
				var rneedsContext = jQuery.expr.match.needsContext; // 2614
				// 2615
				var rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>|)$/; // 2616
				// 2617
				// 2618
				// 2619
				var risSimple = /^.[^:#\[\.,]*$/; // 2620
				// 2621
				// Implement the identical functionality for filter and not                                                          // 2622
				function winnow(elements, qualifier, not) {
					// 2623
					if (jQuery.isFunction(qualifier)) {
						// 2624
						return jQuery.grep(elements, function (elem, i) {
							// 2625
							/* jshint -W018 */ // 2626
							return !!qualifier.call(elem, i, elem) !== not; // 2627
						}); // 2628
						// 2629
					} // 2630
					// 2631
					if (qualifier.nodeType) {
						// 2632
						return jQuery.grep(elements, function (elem) {
							// 2633
							return elem === qualifier !== not; // 2634
						}); // 2635
						// 2636
					} // 2637
					// 2638
					if (typeof qualifier === "string") {
						// 2639
						if (risSimple.test(qualifier)) {
							// 2640
							return jQuery.filter(qualifier, elements, not); // 2641
						} // 2642
						// 2643
						qualifier = jQuery.filter(qualifier, elements); // 2644
					} // 2645
					// 2646
					return jQuery.grep(elements, function (elem) {
						// 2647
						return jQuery.inArray(elem, qualifier) >= 0 !== not; // 2648
					}); // 2649
				} // 2650
				// 2651
				jQuery.filter = function (expr, elems, not) {
					// 2652
					var elem = elems[0]; // 2653
					// 2654
					if (not) {
						// 2655
						expr = ":not(" + expr + ")"; // 2656
					} // 2657
					// 2658
					return elems.length === 1 && elem.nodeType === 1 ? // 2659
					jQuery.find.matchesSelector(elem, expr) ? [elem] : [] : // 2660
					jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
						// 2661
						return elem.nodeType === 1; // 2662
					})); // 2663
				}; // 2664
				// 2665
				jQuery.fn.extend({ // 2666
					find: function (selector) {
						// 2667
						var i,
						    // 2668
						ret = [],
						    // 2669
						self = this,
						    // 2670
						len = self.length; // 2671
						// 2672
						if (typeof selector !== "string") {
							// 2673
							return this.pushStack(jQuery(selector).filter(function () {
								// 2674
								for (i = 0; i < len; i++) {
									// 2675
									if (jQuery.contains(self[i], this)) {
										// 2676
										return true; // 2677
									} // 2678
								} // 2679
							})); // 2680
						} // 2681
						// 2682
						for (i = 0; i < len; i++) {
							// 2683
							jQuery.find(selector, self[i], ret); // 2684
						} // 2685
						// 2686
						// Needed because $( selector, context ) becomes $( context ).find( selector )                                     // 2687
						ret = this.pushStack(len > 1 ? jQuery.unique(ret) : ret); // 2688
						ret.selector = this.selector ? this.selector + " " + selector : selector; // 2689
						return ret; // 2690
					}, // 2691
					filter: function (selector) {
						// 2692
						return this.pushStack(winnow(this, selector || [], false)); // 2693
					}, // 2694
					not: function (selector) {
						// 2695
						return this.pushStack(winnow(this, selector || [], true)); // 2696
					}, // 2697
					is: function (selector) {
						// 2698
						return !!winnow( // 2699
						this, // 2700
						// 2701
						// If this is a positional/relative selector, check membership in the returned set                                // 2702
						// so $("p:first").is("p:last") won't return true for a doc with two "p".                                         // 2703
						typeof selector === "string" && rneedsContext.test(selector) ? // 2704
						jQuery(selector) : // 2705
						selector || [], // 2706
						false // 2707
						).length; // 2708
					} // 2709
				}); // 2710
				// 2711
				// 2712
				// Initialize a jQuery object                                                                                        // 2713
				// 2714
				// 2715
				// A central reference to the root jQuery(document)                                                                  // 2716
				var rootjQuery,
				    // 2717
				// 2718
				// Use the correct document accordingly with window argument (sandbox)                                              // 2719
				document = window.document,
				    // 2720
				// 2721
				// A simple way to check for HTML strings                                                                           // 2722
				// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)                                                 // 2723
				// Strict HTML recognition (#11290: must start with <)                                                              // 2724
				rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
				    // 2725
				// 2726
				init = jQuery.fn.init = function (selector, context) {
					// 2727
					var match, elem; // 2728
					// 2729
					// HANDLE: $(""), $(null), $(undefined), $(false)                                                                  // 2730
					if (!selector) {
						// 2731
						return this; // 2732
					} // 2733
					// 2734
					// Handle HTML strings                                                                                             // 2735
					if (typeof selector === "string") {
						// 2736
						if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
							// 2737
							// Assume that strings that start and end with <> are HTML and skip the regex check                              // 2738
							match = [null, selector, null]; // 2739
							// 2740
						} else {
							// 2741
							match = rquickExpr.exec(selector); // 2742
						} // 2743
						// 2744
						// Match html or make sure no context is specified for #id                                                        // 2745
						if (match && (match[1] || !context)) {
							// 2746
							// 2747
							// HANDLE: $(html) -> $(array)                                                                                   // 2748
							if (match[1]) {
								// 2749
								context = context instanceof jQuery ? context[0] : context; // 2750
								// 2751
								// scripts is true for back-compat                                                                              // 2752
								// Intentionally let the error be thrown if parseHTML is not present                                            // 2753
								jQuery.merge(this, jQuery.parseHTML( // 2754
								match[1], // 2755
								context && context.nodeType ? context.ownerDocument || context : document, // 2756
								true // 2757
								)); // 2758
								// 2759
								// HANDLE: $(html, props)                                                                                       // 2760
								if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
									// 2761
									for (match in context) {
										// 2762
										// Properties of context are called as methods if possible                                                    // 2763
										if (jQuery.isFunction(this[match])) {
											// 2764
											this[match](context[match]); // 2765
											// 2766
											// ...and otherwise set as attributes                                                                         // 2767
										} else {
											// 2768
											this.attr(match, context[match]); // 2769
										} // 2770
									} // 2771
								} // 2772
								// 2773
								return this; // 2774
								// 2775
								// HANDLE: $(#id)                                                                                                // 2776
							} else {
								// 2777
								elem = document.getElementById(match[2]); // 2778
								// 2779
								// Check parentNode to catch when Blackberry 4.6 returns                                                        // 2780
								// nodes that are no longer in the document #6963                                                               // 2781
								if (elem && elem.parentNode) {
									// 2782
									// Handle the case where IE and Opera return items                                                             // 2783
									// by name instead of ID                                                                                       // 2784
									if (elem.id !== match[2]) {
										// 2785
										return rootjQuery.find(selector); // 2786
									} // 2787
									// 2788
									// Otherwise, we inject the element directly into the jQuery object                                            // 2789
									this.length = 1; // 2790
									this[0] = elem; // 2791
								} // 2792
								// 2793
								this.context = document; // 2794
								this.selector = selector; // 2795
								return this; // 2796
							} // 2797
							// 2798
							// HANDLE: $(expr, $(...))                                                                                        // 2799
						} else if (!context || context.jquery) {
							// 2800
							return (context || rootjQuery).find(selector); // 2801
							// 2802
							// HANDLE: $(expr, context)                                                                                       // 2803
							// (which is just equivalent to: $(context).find(expr)                                                            // 2804
						} else {
							// 2805
							return this.constructor(context).find(selector); // 2806
						} // 2807
						// 2808
						// HANDLE: $(DOMElement)                                                                                           // 2809
					} else if (selector.nodeType) {
						// 2810
						this.context = this[0] = selector; // 2811
						this.length = 1; // 2812
						return this; // 2813
						// 2814
						// HANDLE: $(function)                                                                                             // 2815
						// Shortcut for document ready                                                                                     // 2816
					} else if (jQuery.isFunction(selector)) {
						// 2817
						return typeof rootjQuery.ready !== "undefined" ? // 2818
						rootjQuery.ready(selector) : // 2819
						// Execute immediately if ready is not present                                                                   // 2820
						selector(jQuery); // 2821
					} // 2822
					// 2823
					if (selector.selector !== undefined) {
						// 2824
						this.selector = selector.selector; // 2825
						this.context = selector.context; // 2826
					} // 2827
					// 2828
					return jQuery.makeArray(selector, this); // 2829
				}; // 2830
				// 2831
				// Give the init function the jQuery prototype for later instantiation                                               // 2832
				init.prototype = jQuery.fn; // 2833
				// 2834
				// Initialize central reference                                                                                      // 2835
				rootjQuery = jQuery(document); // 2836
				// 2837
				// 2838
				var rparentsprev = /^(?:parents|prev(?:Until|All))/,
				    // 2839
				// methods guaranteed to produce a unique set when starting from a unique set                                       // 2840
				guaranteedUnique = { // 2841
					children: true, // 2842
					contents: true, // 2843
					next: true, // 2844
					prev: true // 2845
				}; // 2846
				// 2847
				jQuery.extend({ // 2848
					dir: function (elem, dir, until) {
						// 2849
						var matched = [],
						    // 2850
						cur = elem[dir]; // 2851
						// 2852
						while (cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery(cur).is(until))) {
							// 2853
							if (cur.nodeType === 1) {
								// 2854
								matched.push(cur); // 2855
							} // 2856
							cur = cur[dir]; // 2857
						} // 2858
						return matched; // 2859
					}, // 2860
					// 2861
					sibling: function (n, elem) {
						// 2862
						var r = []; // 2863
						// 2864
						for (; n; n = n.nextSibling) {
							// 2865
							if (n.nodeType === 1 && n !== elem) {
								// 2866
								r.push(n); // 2867
							} // 2868
						} // 2869
						// 2870
						return r; // 2871
					} // 2872
				}); // 2873
				// 2874
				jQuery.fn.extend({ // 2875
					has: function (target) {
						// 2876
						var i,
						    // 2877
						targets = jQuery(target, this),
						    // 2878
						len = targets.length; // 2879
						// 2880
						return this.filter(function () {
							// 2881
							for (i = 0; i < len; i++) {
								// 2882
								if (jQuery.contains(this, targets[i])) {
									// 2883
									return true; // 2884
								} // 2885
							} // 2886
						}); // 2887
					}, // 2888
					// 2889
					closest: function (selectors, context) {
						// 2890
						var cur,
						    // 2891
						i = 0,
						    // 2892
						l = this.length,
						    // 2893
						matched = [],
						    // 2894
						pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? // 2895
						jQuery(selectors, context || this.context) : // 2896
						0; // 2897
						// 2898
						for (; i < l; i++) {
							// 2899
							for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
								// 2900
								// Always skip document fragments                                                                                // 2901
								if (cur.nodeType < 11 && (pos ? // 2902
								pos.index(cur) > -1 : // 2903
								// 2904
								// Don't pass non-elements to Sizzle                                                                            // 2905
								cur.nodeType === 1 && // 2906
								jQuery.find.matchesSelector(cur, selectors))) {
									// 2907
									// 2908
									matched.push(cur); // 2909
									break; // 2910
								} // 2911
							} // 2912
						} // 2913
						// 2914
						return this.pushStack(matched.length > 1 ? jQuery.unique(matched) : matched); // 2915
					}, // 2916
					// 2917
					// Determine the position of an element within                                                                      // 2918
					// the matched set of elements                                                                                      // 2919
					index: function (elem) {
						// 2920
						// 2921
						// No argument, return index in parent                                                                             // 2922
						if (!elem) {
							// 2923
							return this[0] && this[0].parentNode ? this.first().prevAll().length : -1; // 2924
						} // 2925
						// 2926
						// index in selector                                                                                               // 2927
						if (typeof elem === "string") {
							// 2928
							return jQuery.inArray(this[0], jQuery(elem)); // 2929
						} // 2930
						// 2931
						// Locate the position of the desired element                                                                      // 2932
						return jQuery.inArray( // 2933
						// If it receives a jQuery object, the first element is used                                                      // 2934
						elem.jquery ? elem[0] : elem, this); // 2935
					}, // 2936
					// 2937
					add: function (selector, context) {
						// 2938
						return this.pushStack( // 2939
						jQuery.unique( // 2940
						jQuery.merge(this.get(), jQuery(selector, context)) // 2941
						) // 2942
						); // 2943
					}, // 2944
					// 2945
					addBack: function (selector) {
						// 2946
						return this.add(selector == null ? // 2947
						this.prevObject : this.prevObject.filter(selector) // 2948
						); // 2949
					} // 2950
				}); // 2951
				// 2952
				function sibling(cur, dir) {
					// 2953
					do {
						// 2954
						cur = cur[dir]; // 2955
					} while (cur && cur.nodeType !== 1); // 2956
					// 2957
					return cur; // 2958
				} // 2959
				// 2960
				jQuery.each({ // 2961
					parent: function (elem) {
						// 2962
						var parent = elem.parentNode; // 2963
						return parent && parent.nodeType !== 11 ? parent : null; // 2964
					}, // 2965
					parents: function (elem) {
						// 2966
						return jQuery.dir(elem, "parentNode"); // 2967
					}, // 2968
					parentsUntil: function (elem, i, until) {
						// 2969
						return jQuery.dir(elem, "parentNode", until); // 2970
					}, // 2971
					next: function (elem) {
						// 2972
						return sibling(elem, "nextSibling"); // 2973
					}, // 2974
					prev: function (elem) {
						// 2975
						return sibling(elem, "previousSibling"); // 2976
					}, // 2977
					nextAll: function (elem) {
						// 2978
						return jQuery.dir(elem, "nextSibling"); // 2979
					}, // 2980
					prevAll: function (elem) {
						// 2981
						return jQuery.dir(elem, "previousSibling"); // 2982
					}, // 2983
					nextUntil: function (elem, i, until) {
						// 2984
						return jQuery.dir(elem, "nextSibling", until); // 2985
					}, // 2986
					prevUntil: function (elem, i, until) {
						// 2987
						return jQuery.dir(elem, "previousSibling", until); // 2988
					}, // 2989
					siblings: function (elem) {
						// 2990
						return jQuery.sibling((elem.parentNode || {}).firstChild, elem); // 2991
					}, // 2992
					children: function (elem) {
						// 2993
						return jQuery.sibling(elem.firstChild); // 2994
					}, // 2995
					contents: function (elem) {
						// 2996
						return jQuery.nodeName(elem, "iframe") ? // 2997
						elem.contentDocument || elem.contentWindow.document : // 2998
						jQuery.merge([], elem.childNodes); // 2999
					} // 3000
				}, function (name, fn) {
					// 3001
					jQuery.fn[name] = function (until, selector) {
						// 3002
						var ret = jQuery.map(this, fn, until); // 3003
						// 3004
						if (name.slice(-5) !== "Until") {
							// 3005
							selector = until; // 3006
						} // 3007
						// 3008
						if (selector && typeof selector === "string") {
							// 3009
							ret = jQuery.filter(selector, ret); // 3010
						} // 3011
						// 3012
						if (this.length > 1) {
							// 3013
							// Remove duplicates                                                                                              // 3014
							if (!guaranteedUnique[name]) {
								// 3015
								ret = jQuery.unique(ret); // 3016
							} // 3017
							// 3018
							// Reverse order for parents* and prev-derivatives                                                                // 3019
							if (rparentsprev.test(name)) {
								// 3020
								ret = ret.reverse(); // 3021
							} // 3022
						} // 3023
						// 3024
						return this.pushStack(ret); // 3025
					}; // 3026
				}); // 3027
				var rnotwhite = /\S+/g; // 3028
				// 3029
				// 3030
				// 3031
				// String to Object options format cache                                                                             // 3032
				var optionsCache = {}; // 3033
				// 3034
				// Convert String-formatted options into Object-formatted ones and store in cache                                    // 3035
				function createOptions(options) {
					// 3036
					var object = optionsCache[options] = {}; // 3037
					jQuery.each(options.match(rnotwhite) || [], function (_, flag) {
						// 3038
						object[flag] = true; // 3039
					}); // 3040
					return object; // 3041
				} // 3042
				// 3043
				/*                                                                                                                   // 3044
     * Create a callback list using the following parameters:                                                            // 3045
     *                                                                                                                   // 3046
     *	options: an optional list of space-separated options that will change how                                         // 3047
     *			the callback list behaves or a more traditional option object                                                   // 3048
     *                                                                                                                   // 3049
     * By default a callback list will act like an event callback list and can be                                        // 3050
     * "fired" multiple times.                                                                                           // 3051
     *                                                                                                                   // 3052
     * Possible options:                                                                                                 // 3053
     *                                                                                                                   // 3054
     *	once:			will ensure the callback list can only be fired once (like a Deferred)                                    // 3055
     *                                                                                                                   // 3056
     *	memory:			will keep track of previous values and will call any callback added                                     // 3057
     *					after the list has been fired right away with the latest "memorized"                                          // 3058
     *					values (like a Deferred)                                                                                      // 3059
     *                                                                                                                   // 3060
     *	unique:			will ensure a callback can only be added once (no duplicate in the list)                                // 3061
     *                                                                                                                   // 3062
     *	stopOnFalse:	interrupt callings when a callback returns false                                                     // 3063
     *                                                                                                                   // 3064
     */ // 3065
				jQuery.Callbacks = function (options) {
					// 3066
					// 3067
					// Convert options from String-formatted to Object-formatted if needed                                              // 3068
					// (we check in cache first)                                                                                        // 3069
					options = typeof options === "string" ? // 3070
					optionsCache[options] || createOptions(options) : // 3071
					jQuery.extend({}, options); // 3072
					// 3073
					var // Flag to know if list is currently firing                                                                     // 3074
					firing,
					    // 3075
					// Last fire value (for non-forgettable lists)                                                                     // 3076
					memory,
					    // 3077
					// Flag to know if list was already fired                                                                          // 3078
					fired,
					    // 3079
					// End of the loop when firing                                                                                     // 3080
					firingLength,
					    // 3081
					// Index of currently firing callback (modified by remove if needed)                                               // 3082
					firingIndex,
					    // 3083
					// First callback to fire (used internally by add and fireWith)                                                    // 3084
					firingStart,
					    // 3085
					// Actual callback list                                                                                            // 3086
					list = [],
					    // 3087
					// Stack of fire calls for repeatable lists                                                                        // 3088
					stack = !options.once && [],
					    // 3089
					// Fire callbacks                                                                                                  // 3090
					fire = function (data) {
						// 3091
						memory = options.memory && data; // 3092
						fired = true; // 3093
						firingIndex = firingStart || 0; // 3094
						firingStart = 0; // 3095
						firingLength = list.length; // 3096
						firing = true; // 3097
						for (; list && firingIndex < firingLength; firingIndex++) {
							// 3098
							if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
								// 3099
								memory = false; // To prevent further calls using add                                                           // 3100
								break; // 3101
							} // 3102
						} // 3103
						firing = false; // 3104
						if (list) {
							// 3105
							if (stack) {
								// 3106
								if (stack.length) {
									// 3107
									fire(stack.shift()); // 3108
								} // 3109
							} else if (memory) {
								// 3110
								list = []; // 3111
							} else {
								// 3112
								self.disable(); // 3113
							} // 3114
						} // 3115
					},
					    // 3116
					// Actual Callbacks object                                                                                         // 3117
					self = { // 3118
						// Add a callback or a collection of callbacks to the list                                                        // 3119
						add: function () {
							// 3120
							if (list) {
								// 3121
								// First, we save the current length                                                                            // 3122
								var start = list.length; // 3123
								(function add(args) {
									// 3124
									jQuery.each(args, function (_, arg) {
										// 3125
										var type = jQuery.type(arg); // 3126
										if (type === "function") {
											// 3127
											if (!options.unique || !self.has(arg)) {
												// 3128
												list.push(arg); // 3129
											} // 3130
										} else if (arg && arg.length && type !== "string") {
											// 3131
											// Inspect recursively                                                                                       // 3132
											add(arg); // 3133
										} // 3134
									}); // 3135
								})(arguments); // 3136
								// Do we need to add the callbacks to the                                                                       // 3137
								// current firing batch?                                                                                        // 3138
								if (firing) {
									// 3139
									firingLength = list.length; // 3140
									// With memory, if we're not firing then                                                                        // 3141
									// we should call right away                                                                                    // 3142
								} else if (memory) {
									// 3143
									firingStart = start; // 3144
									fire(memory); // 3145
								} // 3146
							} // 3147
							return this; // 3148
						}, // 3149
						// Remove a callback from the list                                                                                // 3150
						remove: function () {
							// 3151
							if (list) {
								// 3152
								jQuery.each(arguments, function (_, arg) {
									// 3153
									var index; // 3154
									while ((index = jQuery.inArray(arg, list, index)) > -1) {
										// 3155
										list.splice(index, 1); // 3156
										// Handle firing indexes                                                                                      // 3157
										if (firing) {
											// 3158
											if (index <= firingLength) {
												// 3159
												firingLength--; // 3160
											} // 3161
											if (index <= firingIndex) {
												// 3162
												firingIndex--; // 3163
											} // 3164
										} // 3165
									} // 3166
								}); // 3167
							} // 3168
							return this; // 3169
						}, // 3170
						// Check if a given callback is in the list.                                                                      // 3171
						// If no argument is given, return whether or not list has callbacks attached.                                    // 3172
						has: function (fn) {
							// 3173
							return fn ? jQuery.inArray(fn, list) > -1 : !!(list && list.length); // 3174
						}, // 3175
						// Remove all callbacks from the list                                                                             // 3176
						empty: function () {
							// 3177
							list = []; // 3178
							firingLength = 0; // 3179
							return this; // 3180
						}, // 3181
						// Have the list do nothing anymore                                                                               // 3182
						disable: function () {
							// 3183
							list = stack = memory = undefined; // 3184
							return this; // 3185
						}, // 3186
						// Is it disabled?                                                                                                // 3187
						disabled: function () {
							// 3188
							return !list; // 3189
						}, // 3190
						// Lock the list in its current state                                                                             // 3191
						lock: function () {
							// 3192
							stack = undefined; // 3193
							if (!memory) {
								// 3194
								self.disable(); // 3195
							} // 3196
							return this; // 3197
						}, // 3198
						// Is it locked?                                                                                                  // 3199
						locked: function () {
							// 3200
							return !stack; // 3201
						}, // 3202
						// Call all callbacks with the given context and arguments                                                        // 3203
						fireWith: function (context, args) {
							// 3204
							if (list && (!fired || stack)) {
								// 3205
								args = args || []; // 3206
								args = [context, args.slice ? args.slice() : args]; // 3207
								if (firing) {
									// 3208
									stack.push(args); // 3209
								} else {
									// 3210
									fire(args); // 3211
								} // 3212
							} // 3213
							return this; // 3214
						}, // 3215
						// Call all the callbacks with the given arguments                                                                // 3216
						fire: function () {
							// 3217
							self.fireWith(this, arguments); // 3218
							return this; // 3219
						}, // 3220
						// To know if the callbacks have already been called at least once                                                // 3221
						fired: function () {
							// 3222
							return !!fired; // 3223
						} // 3224
					}; // 3225
					// 3226
					return self; // 3227
				}; // 3228
				// 3229
				// 3230
				jQuery.extend({ // 3231
					// 3232
					Deferred: function (func) {
						// 3233
						var tuples = [// 3234
						// action, add listener, listener list, final state                                                              // 3235
						["resolve", "done", jQuery.Callbacks("once memory"), "resolved"], // 3236
						["reject", "fail", jQuery.Callbacks("once memory"), "rejected"], // 3237
						["notify", "progress", jQuery.Callbacks("memory")] // 3238
						],
						    // 3239
						state = "pending",
						    // 3240
						promise = { // 3241
							state: function () {
								// 3242
								return state; // 3243
							}, // 3244
							always: function () {
								// 3245
								deferred.done(arguments).fail(arguments); // 3246
								return this; // 3247
							}, // 3248
							then: function () /* fnDone, fnFail, fnProgress */{
								// 3249
								var fns = arguments; // 3250
								return jQuery.Deferred(function (newDefer) {
									// 3251
									jQuery.each(tuples, function (i, tuple) {
										// 3252
										var fn = jQuery.isFunction(fns[i]) && fns[i]; // 3253
										// deferred[ done | fail | progress ] for forwarding actions to newDefer                                      // 3254
										deferred[tuple[1]](function () {
											// 3255
											var returned = fn && fn.apply(this, arguments); // 3256
											if (returned && jQuery.isFunction(returned.promise)) {
												// 3257
												returned.promise() // 3258
												.done(newDefer.resolve) // 3259
												.fail(newDefer.reject) // 3260
												.progress(newDefer.notify); // 3261
											} else {
												// 3262
												newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
											} // 3264
										}); // 3265
									}); // 3266
									fns = null; // 3267
								}).promise(); // 3268
							}, // 3269
							// Get a promise for this deferred                                                                               // 3270
							// If obj is provided, the promise aspect is added to the object                                                 // 3271
							promise: function (obj) {
								// 3272
								return obj != null ? jQuery.extend(obj, promise) : promise; // 3273
							} // 3274
						},
						    // 3275
						deferred = {}; // 3276
						// 3277
						// Keep pipe for back-compat                                                                                       // 3278
						promise.pipe = promise.then; // 3279
						// 3280
						// Add list-specific methods                                                                                       // 3281
						jQuery.each(tuples, function (i, tuple) {
							// 3282
							var list = tuple[2],
							    // 3283
							stateString = tuple[3]; // 3284
							// 3285
							// promise[ done | fail | progress ] = list.add                                                                   // 3286
							promise[tuple[1]] = list.add; // 3287
							// 3288
							// Handle state                                                                                                   // 3289
							if (stateString) {
								// 3290
								list.add(function () {
									// 3291
									// state = [ resolved | rejected ]                                                                              // 3292
									state = stateString; // 3293
									// 3294
									// [ reject_list | resolve_list ].disable; progress_list.lock                                                    // 3295
								}, tuples[i ^ 1][2].disable, tuples[2][2].lock); // 3296
							} // 3297
							// 3298
							// deferred[ resolve | reject | notify ]                                                                          // 3299
							deferred[tuple[0]] = function () {
								// 3300
								deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments); // 3301
								return this; // 3302
							}; // 3303
							deferred[tuple[0] + "With"] = list.fireWith; // 3304
						}); // 3305
						// 3306
						// Make the deferred a promise                                                                                     // 3307
						promise.promise(deferred); // 3308
						// 3309
						// Call given func if any                                                                                          // 3310
						if (func) {
							// 3311
							func.call(deferred, deferred); // 3312
						} // 3313
						// 3314
						// All done!                                                                                                       // 3315
						return deferred; // 3316
					}, // 3317
					// 3318
					// Deferred helper                                                                                                  // 3319
					when: function (subordinate /* , ..., subordinateN */) {
						// 3320
						var i = 0,
						    // 3321
						resolveValues = slice.call(arguments),
						    // 3322
						length = resolveValues.length,
						    // 3323
						// 3324
						// the count of uncompleted subordinates                                                                          // 3325
						remaining = length !== 1 || subordinate && jQuery.isFunction(subordinate.promise) ? length : 0,
						    // 3326
						// 3327
						// the master Deferred. If resolveValues consist of only a single Deferred, just use that.                        // 3328
						deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
						    // 3329
						// 3330
						// Update function for both resolve and progress values                                                           // 3331
						updateFunc = function (i, contexts, values) {
							// 3332
							return function (value) {
								// 3333
								contexts[i] = this; // 3334
								values[i] = arguments.length > 1 ? slice.call(arguments) : value; // 3335
								if (values === progressValues) {
									// 3336
									deferred.notifyWith(contexts, values); // 3337
									// 3338
								} else if (! --remaining) {
									// 3339
									deferred.resolveWith(contexts, values); // 3340
								} // 3341
							}; // 3342
						},
						    // 3343
						// 3344
						progressValues,
						    progressContexts,
						    resolveContexts; // 3345
						// 3346
						// add listeners to Deferred subordinates; treat others as resolved                                                // 3347
						if (length > 1) {
							// 3348
							progressValues = new Array(length); // 3349
							progressContexts = new Array(length); // 3350
							resolveContexts = new Array(length); // 3351
							for (; i < length; i++) {
								// 3352
								if (resolveValues[i] && jQuery.isFunction(resolveValues[i].promise)) {
									// 3353
									resolveValues[i].promise() // 3354
									.done(updateFunc(i, resolveContexts, resolveValues)) // 3355
									.fail(deferred.reject) // 3356
									.progress(updateFunc(i, progressContexts, progressValues)); // 3357
								} else {
									// 3358
									--remaining; // 3359
								} // 3360
							} // 3361
						} // 3362
						// 3363
						// if we're not waiting on anything, resolve the master                                                            // 3364
						if (!remaining) {
							// 3365
							deferred.resolveWith(resolveContexts, resolveValues); // 3366
						} // 3367
						// 3368
						return deferred.promise(); // 3369
					} // 3370
				}); // 3371
				// 3372
				// 3373
				// The deferred used on DOM ready                                                                                    // 3374
				var readyList; // 3375
				// 3376
				jQuery.fn.ready = function (fn) {
					// 3377
					// Add the callback                                                                                                 // 3378
					jQuery.ready.promise().done(fn); // 3379
					// 3380
					return this; // 3381
				}; // 3382
				// 3383
				jQuery.extend({ // 3384
					// Is the DOM ready to be used? Set to true once it occurs.                                                         // 3385
					isReady: false, // 3386
					// 3387
					// A counter to track how many items to wait for before                                                             // 3388
					// the ready event fires. See #6781                                                                                 // 3389
					readyWait: 1, // 3390
					// 3391
					// Hold (or release) the ready event                                                                                // 3392
					holdReady: function (hold) {
						// 3393
						if (hold) {
							// 3394
							jQuery.readyWait++; // 3395
						} else {
							// 3396
							jQuery.ready(true); // 3397
						} // 3398
					}, // 3399
					// 3400
					// Handle when the DOM is ready                                                                                     // 3401
					ready: function (wait) {
						// 3402
						// 3403
						// Abort if there are pending holds or we're already ready                                                         // 3404
						if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
							// 3405
							return; // 3406
						} // 3407
						// 3408
						// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).                           // 3409
						if (!document.body) {
							// 3410
							return setTimeout(jQuery.ready); // 3411
						} // 3412
						// 3413
						// Remember that the DOM is ready                                                                                  // 3414
						jQuery.isReady = true; // 3415
						// 3416
						// If a normal DOM Ready event fired, decrement, and wait if need be                                               // 3417
						if (wait !== true && --jQuery.readyWait > 0) {
							// 3418
							return; // 3419
						} // 3420
						// 3421
						// If there are functions bound, to execute                                                                        // 3422
						readyList.resolveWith(document, [jQuery]); // 3423
						// 3424
						// Trigger any bound ready events                                                                                  // 3425
						if (jQuery.fn.trigger) {
							// 3426
							jQuery(document).trigger("ready").off("ready"); // 3427
						} // 3428
					} // 3429
				}); // 3430
				// 3431
				/**                                                                                                                  // 3432
     * Clean-up method for dom ready events                                                                              // 3433
     */ // 3434
				function detach() {
					// 3435
					if (document.addEventListener) {
						// 3436
						document.removeEventListener("DOMContentLoaded", completed, false); // 3437
						window.removeEventListener("load", completed, false); // 3438
						// 3439
					} else {
						// 3440
						document.detachEvent("onreadystatechange", completed); // 3441
						window.detachEvent("onload", completed); // 3442
					} // 3443
				} // 3444
				// 3445
				/**                                                                                                                  // 3446
     * The ready event handler and self cleanup method                                                                   // 3447
     */ // 3448
				function completed() {
					// 3449
					// readyState === "complete" is good enough for us to call the dom ready in oldIE                                   // 3450
					if (document.addEventListener || event.type === "load" || document.readyState === "complete") {
						// 3451
						detach(); // 3452
						jQuery.ready(); // 3453
					} // 3454
				} // 3455
				// 3456
				jQuery.ready.promise = function (obj) {
					// 3457
					if (!readyList) {
						// 3458
						// 3459
						readyList = jQuery.Deferred(); // 3460
						// 3461
						// Catch cases where $(document).ready() is called after the browser event has already occurred.                   // 3462
						// we once tried to use readyState "interactive" here, but it caused issues like the one                           // 3463
						// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15                                       // 3464
						if (document.readyState === "complete") {
							// 3465
							// Handle it asynchronously to allow scripts the opportunity to delay ready                                       // 3466
							setTimeout(jQuery.ready); // 3467
							// 3468
							// Standards-based browsers support DOMContentLoaded                                                               // 3469
						} else if (document.addEventListener) {
							// 3470
							// Use the handy event callback                                                                                   // 3471
							document.addEventListener("DOMContentLoaded", completed, false); // 3472
							// 3473
							// A fallback to window.onload, that will always work                                                             // 3474
							window.addEventListener("load", completed, false); // 3475
							// 3476
							// If IE event model is used                                                                                       // 3477
						} else {
							// 3478
							// Ensure firing before onload, maybe late but safe also for iframes                                              // 3479
							document.attachEvent("onreadystatechange", completed); // 3480
							// 3481
							// A fallback to window.onload, that will always work                                                             // 3482
							window.attachEvent("onload", completed); // 3483
							// 3484
							// If IE and not a frame                                                                                          // 3485
							// continually check to see if the document is ready                                                              // 3486
							var top = false; // 3487
							// 3488
							try {
								// 3489
								top = window.frameElement == null && document.documentElement; // 3490
							} catch (e) {} // 3491
							// 3492
							if (top && top.doScroll) {
								// 3493
								(function doScrollCheck() {
									// 3494
									if (!jQuery.isReady) {
										// 3495
										// 3496
										try {
											// 3497
											// Use the trick by Diego Perini                                                                              // 3498
											// http://javascript.nwbox.com/IEContentLoaded/                                                               // 3499
											top.doScroll("left"); // 3500
										} catch (e) {
											// 3501
											return setTimeout(doScrollCheck, 50); // 3502
										} // 3503
										// 3504
										// detach all dom ready events                                                                                 // 3505
										detach(); // 3506
										// 3507
										// and execute any waiting functions                                                                           // 3508
										jQuery.ready(); // 3509
									} // 3510
								})(); // 3511
							} // 3512
						} // 3513
					} // 3514
					return readyList.promise(obj); // 3515
				}; // 3516
				// 3517
				// 3518
				var strundefined = typeof undefined; // 3519
				// 3520
				// 3521
				// 3522
				// Support: IE<9                                                                                                     // 3523
				// Iteration over object's inherited properties before its own                                                       // 3524
				var i; // 3525
				for (i in jQuery(support)) {
					// 3526
					break; // 3527
				} // 3528
				support.ownLast = i !== "0"; // 3529
				// 3530
				// Note: most support tests are defined in their respective modules.                                                 // 3531
				// false until the test is run                                                                                       // 3532
				support.inlineBlockNeedsLayout = false; // 3533
				// 3534
				jQuery(function () {
					// 3535
					// We need to execute this one support test ASAP because we need to know                                            // 3536
					// if body.style.zoom needs to be set.                                                                              // 3537
					// 3538
					var container,
					    div,
					    // 3539
					body = document.getElementsByTagName("body")[0]; // 3540
					// 3541
					if (!body) {
						// 3542
						// Return for frameset docs that don't have a body                                                                 // 3543
						return; // 3544
					} // 3545
					// 3546
					// Setup                                                                                                            // 3547
					container = document.createElement("div"); // 3548
					container.style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px"; // 3549
					// 3550
					div = document.createElement("div"); // 3551
					body.appendChild(container).appendChild(div); // 3552
					// 3553
					if (typeof div.style.zoom !== strundefined) {
						// 3554
						// Support: IE<8                                                                                                   // 3555
						// Check if natively block-level elements act like inline-block                                                    // 3556
						// elements when setting their display to 'inline' and giving                                                      // 3557
						// them layout                                                                                                     // 3558
						div.style.cssText = "border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1"; // 3559
						// 3560
						if (support.inlineBlockNeedsLayout = div.offsetWidth === 3) {
							// 3561
							// Prevent IE 6 from affecting layout for positioned elements #11048                                              // 3562
							// Prevent IE from shrinking the body in IE 7 mode #12869                                                         // 3563
							// Support: IE<8                                                                                                  // 3564
							body.style.zoom = 1; // 3565
						} // 3566
					} // 3567
					// 3568
					body.removeChild(container); // 3569
					// 3570
					// Null elements to avoid leaks in IE                                                                               // 3571
					container = div = null; // 3572
				}); // 3573
				// 3574
				// 3575
				// 3576
				// 3577
				(function () {
					// 3578
					var div = document.createElement("div"); // 3579
					// 3580
					// Execute the test only if not already executed in another module.                                                 // 3581
					if (support.deleteExpando == null) {
						// 3582
						// Support: IE<9                                                                                                   // 3583
						support.deleteExpando = true; // 3584
						try {
							// 3585
							delete div.test; // 3586
						} catch (e) {
							// 3587
							support.deleteExpando = false; // 3588
						} // 3589
					} // 3590
					// 3591
					// Null elements to avoid leaks in IE.                                                                              // 3592
					div = null; // 3593
				})(); // 3594
				// 3595
				// 3596
				/**                                                                                                                  // 3597
     * Determines whether an object can have data                                                                        // 3598
     */ // 3599
				jQuery.acceptData = function (elem) {
					// 3600
					var noData = jQuery.noData[(elem.nodeName + " ").toLowerCase()],
					    // 3601
					nodeType = +elem.nodeType || 1; // 3602
					// 3603
					// Do not set data on non-element DOM nodes because it will not be cleared (#8335).                                 // 3604
					return nodeType !== 1 && nodeType !== 9 ? // 3605
					false : // 3606
					// 3607
					// Nodes accept data unless otherwise specified; rejection can be conditional                                      // 3608
					!noData || noData !== true && elem.getAttribute("classid") === noData; // 3609
				}; // 3610
				// 3611
				// 3612
				var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
				    // 3613
				rmultiDash = /([A-Z])/g; // 3614
				// 3615
				function dataAttr(elem, key, data) {
					// 3616
					// If nothing was found internally, try to fetch any                                                                // 3617
					// data from the HTML5 data-* attribute                                                                             // 3618
					if (data === undefined && elem.nodeType === 1) {
						// 3619
						// 3620
						var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase(); // 3621
						// 3622
						data = elem.getAttribute(name); // 3623
						// 3624
						if (typeof data === "string") {
							// 3625
							try {
								// 3626
								data = data === "true" ? true : // 3627
								data === "false" ? false : // 3628
								data === "null" ? null : // 3629
								// Only convert to a number if it doesn't change the string                                                     // 3630
								+data + "" === data ? +data : // 3631
								rbrace.test(data) ? jQuery.parseJSON(data) : // 3632
								data; // 3633
							} catch (e) {} // 3634
							// 3635
							// Make sure we set the data so it isn't changed later                                                            // 3636
							jQuery.data(elem, key, data); // 3637
							// 3638
						} else {
							// 3639
							data = undefined; // 3640
						} // 3641
					} // 3642
					// 3643
					return data; // 3644
				} // 3645
				// 3646
				// checks a cache object for emptiness                                                                               // 3647
				function isEmptyDataObject(obj) {
					// 3648
					var name; // 3649
					for (name in obj) {
						// 3650
						// 3651
						// if the public data object is empty, the private is still empty                                                  // 3652
						if (name === "data" && jQuery.isEmptyObject(obj[name])) {
							// 3653
							continue; // 3654
						} // 3655
						if (name !== "toJSON") {
							// 3656
							return false; // 3657
						} // 3658
					} // 3659
					// 3660
					return true; // 3661
				} // 3662
				// 3663
				function internalData(elem, name, data, pvt /* Internal Use Only */) {
					// 3664
					if (!jQuery.acceptData(elem)) {
						// 3665
						return; // 3666
					} // 3667
					// 3668
					var ret,
					    thisCache,
					    // 3669
					internalKey = jQuery.expando,
					    // 3670
					// 3671
					// We have to handle DOM nodes and JS objects differently because IE6-7                                            // 3672
					// can't GC object references properly across the DOM-JS boundary                                                  // 3673
					isNode = elem.nodeType,
					    // 3674
					// 3675
					// Only DOM nodes need the global jQuery cache; JS object data is                                                  // 3676
					// attached directly to the object so GC can occur automatically                                                   // 3677
					cache = isNode ? jQuery.cache : elem,
					    // 3678
					// 3679
					// Only defining an ID for JS objects if its cache already exists allows                                           // 3680
					// the code to shortcut on the same path as a DOM node with no cache                                               // 3681
					id = isNode ? elem[internalKey] : elem[internalKey] && internalKey; // 3682
					// 3683
					// Avoid doing any more work than we need to when trying to get data on an                                          // 3684
					// object that has no data at all                                                                                   // 3685
					if ((!id || !cache[id] || !pvt && !cache[id].data) && data === undefined && typeof name === "string") {
						// 3686
						return; // 3687
					} // 3688
					// 3689
					if (!id) {
						// 3690
						// Only DOM nodes need a new unique ID for each element since their data                                           // 3691
						// ends up in the global cache                                                                                     // 3692
						if (isNode) {
							// 3693
							id = elem[internalKey] = deletedIds.pop() || jQuery.guid++; // 3694
						} else {
							// 3695
							id = internalKey; // 3696
						} // 3697
					} // 3698
					// 3699
					if (!cache[id]) {
						// 3700
						// Avoid exposing jQuery metadata on plain JS objects when the object                                              // 3701
						// is serialized using JSON.stringify                                                                              // 3702
						cache[id] = isNode ? {} : { toJSON: jQuery.noop }; // 3703
					} // 3704
					// 3705
					// An object can be passed to jQuery.data instead of a key/value pair; this gets                                    // 3706
					// shallow copied over onto the existing cache                                                                      // 3707
					if (typeof name === "object" || typeof name === "function") {
						// 3708
						if (pvt) {
							// 3709
							cache[id] = jQuery.extend(cache[id], name); // 3710
						} else {
							// 3711
							cache[id].data = jQuery.extend(cache[id].data, name); // 3712
						} // 3713
					} // 3714
					// 3715
					thisCache = cache[id]; // 3716
					// 3717
					// jQuery data() is stored in a separate object inside the object's internal data                                   // 3718
					// cache in order to avoid key collisions between internal data and user-defined                                    // 3719
					// data.                                                                                                            // 3720
					if (!pvt) {
						// 3721
						if (!thisCache.data) {
							// 3722
							thisCache.data = {}; // 3723
						} // 3724
						// 3725
						thisCache = thisCache.data; // 3726
					} // 3727
					// 3728
					if (data !== undefined) {
						// 3729
						thisCache[jQuery.camelCase(name)] = data; // 3730
					} // 3731
					// 3732
					// Check for both converted-to-camel and non-converted data property names                                          // 3733
					// If a data property was specified                                                                                 // 3734
					if (typeof name === "string") {
						// 3735
						// 3736
						// First Try to find as-is property data                                                                           // 3737
						ret = thisCache[name]; // 3738
						// 3739
						// Test for null|undefined property data                                                                           // 3740
						if (ret == null) {
							// 3741
							// 3742
							// Try to find the camelCased property                                                                            // 3743
							ret = thisCache[jQuery.camelCase(name)]; // 3744
						} // 3745
					} else {
						// 3746
						ret = thisCache; // 3747
					} // 3748
					// 3749
					return ret; // 3750
				} // 3751
				// 3752
				function internalRemoveData(elem, name, pvt) {
					// 3753
					if (!jQuery.acceptData(elem)) {
						// 3754
						return; // 3755
					} // 3756
					// 3757
					var thisCache,
					    i,
					    // 3758
					isNode = elem.nodeType,
					    // 3759
					// 3760
					// See jQuery.data for more information                                                                            // 3761
					cache = isNode ? jQuery.cache : elem,
					    // 3762
					id = isNode ? elem[jQuery.expando] : jQuery.expando; // 3763
					// 3764
					// If there is already no cache entry for this object, there is no                                                  // 3765
					// purpose in continuing                                                                                            // 3766
					if (!cache[id]) {
						// 3767
						return; // 3768
					} // 3769
					// 3770
					if (name) {
						// 3771
						// 3772
						thisCache = pvt ? cache[id] : cache[id].data; // 3773
						// 3774
						if (thisCache) {
							// 3775
							// 3776
							// Support array or space separated string names for data keys                                                    // 3777
							if (!jQuery.isArray(name)) {
								// 3778
								// 3779
								// try the string as a key before any manipulation                                                               // 3780
								if (name in thisCache) {
									// 3781
									name = [name]; // 3782
								} else {
									// 3783
									// 3784
									// split the camel cased version by spaces unless a key with the spaces exists                                  // 3785
									name = jQuery.camelCase(name); // 3786
									if (name in thisCache) {
										// 3787
										name = [name]; // 3788
									} else {
										// 3789
										name = name.split(" "); // 3790
									} // 3791
								} // 3792
							} else {
								// 3793
								// If "name" is an array of keys...                                                                              // 3794
								// When data is initially created, via ("key", "val") signature,                                                 // 3795
								// keys will be converted to camelCase.                                                                          // 3796
								// Since there is no way to tell _how_ a key was added, remove                                                   // 3797
								// both plain key and camelCase key. #12786                                                                      // 3798
								// This will only penalize the array argument path.                                                              // 3799
								name = name.concat(jQuery.map(name, jQuery.camelCase)); // 3800
							} // 3801
							// 3802
							i = name.length; // 3803
							while (i--) {
								// 3804
								delete thisCache[name[i]]; // 3805
							} // 3806
							// 3807
							// If there is no data left in the cache, we want to continue                                                     // 3808
							// and let the cache object itself get destroyed                                                                  // 3809
							if (pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache)) {
								// 3810
								return; // 3811
							} // 3812
						} // 3813
					} // 3814
					// 3815
					// See jQuery.data for more information                                                                             // 3816
					if (!pvt) {
						// 3817
						delete cache[id].data; // 3818
						// 3819
						// Don't destroy the parent cache unless the internal data object                                                  // 3820
						// had been the only thing left in it                                                                              // 3821
						if (!isEmptyDataObject(cache[id])) {
							// 3822
							return; // 3823
						} // 3824
					} // 3825
					// 3826
					// Destroy the cache                                                                                                // 3827
					if (isNode) {
						// 3828
						jQuery.cleanData([elem], true); // 3829
						// 3830
						// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)                          // 3831
						/* jshint eqeqeq: false */ // 3832
					} else if (support.deleteExpando || cache != cache.window) {
						// 3833
						/* jshint eqeqeq: true */ // 3834
						delete cache[id]; // 3835
						// 3836
						// When all else fails, null                                                                                        // 3837
					} else {
						// 3838
						cache[id] = null; // 3839
					} // 3840
				} // 3841
				// 3842
				jQuery.extend({ // 3843
					cache: {}, // 3844
					// 3845
					// The following elements (space-suffixed to avoid Object.prototype collisions)                                     // 3846
					// throw uncatchable exceptions if you attempt to set expando properties                                            // 3847
					noData: { // 3848
						"applet ": true, // 3849
						"embed ": true, // 3850
						// ...but Flash objects (which have this classid) *can* handle expandos                                            // 3851
						"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" // 3852
					}, // 3853
					// 3854
					hasData: function (elem) {
						// 3855
						elem = elem.nodeType ? jQuery.cache[elem[jQuery.expando]] : elem[jQuery.expando]; // 3856
						return !!elem && !isEmptyDataObject(elem); // 3857
					}, // 3858
					// 3859
					data: function (elem, name, data) {
						// 3860
						return internalData(elem, name, data); // 3861
					}, // 3862
					// 3863
					removeData: function (elem, name) {
						// 3864
						return internalRemoveData(elem, name); // 3865
					}, // 3866
					// 3867
					// For internal use only.                                                                                           // 3868
					_data: function (elem, name, data) {
						// 3869
						return internalData(elem, name, data, true); // 3870
					}, // 3871
					// 3872
					_removeData: function (elem, name) {
						// 3873
						return internalRemoveData(elem, name, true); // 3874
					} // 3875
				}); // 3876
				// 3877
				jQuery.fn.extend({ // 3878
					data: function (key, value) {
						// 3879
						var i,
						    name,
						    data,
						    // 3880
						elem = this[0],
						    // 3881
						attrs = elem && elem.attributes; // 3882
						// 3883
						// Special expections of .data basically thwart jQuery.access,                                                     // 3884
						// so implement the relevant behavior ourselves                                                                    // 3885
						// 3886
						// Gets all values                                                                                                 // 3887
						if (key === undefined) {
							// 3888
							if (this.length) {
								// 3889
								data = jQuery.data(elem); // 3890
								// 3891
								if (elem.nodeType === 1 && !jQuery._data(elem, "parsedAttrs")) {
									// 3892
									i = attrs.length; // 3893
									while (i--) {
										// 3894
										name = attrs[i].name; // 3895
										// 3896
										if (name.indexOf("data-") === 0) {
											// 3897
											name = jQuery.camelCase(name.slice(5)); // 3898
											// 3899
											dataAttr(elem, name, data[name]); // 3900
										} // 3901
									} // 3902
									jQuery._data(elem, "parsedAttrs", true); // 3903
								} // 3904
							} // 3905
							// 3906
							return data; // 3907
						} // 3908
						// 3909
						// Sets multiple values                                                                                            // 3910
						if (typeof key === "object") {
							// 3911
							return this.each(function () {
								// 3912
								jQuery.data(this, key); // 3913
							}); // 3914
						} // 3915
						// 3916
						return arguments.length > 1 ? // 3917
						// 3918
						// Sets one value                                                                                                 // 3919
						this.each(function () {
							// 3920
							jQuery.data(this, key, value); // 3921
						}) : // 3922
						// 3923
						// Gets one value                                                                                                 // 3924
						// Try to fetch any internally stored data first                                                                  // 3925
						elem ? dataAttr(elem, key, jQuery.data(elem, key)) : undefined; // 3926
					}, // 3927
					// 3928
					removeData: function (key) {
						// 3929
						return this.each(function () {
							// 3930
							jQuery.removeData(this, key); // 3931
						}); // 3932
					} // 3933
				}); // 3934
				// 3935
				// 3936
				jQuery.extend({ // 3937
					queue: function (elem, type, data) {
						// 3938
						var queue; // 3939
						// 3940
						if (elem) {
							// 3941
							type = (type || "fx") + "queue"; // 3942
							queue = jQuery._data(elem, type); // 3943
							// 3944
							// Speed up dequeue by getting out quickly if this is just a lookup                                               // 3945
							if (data) {
								// 3946
								if (!queue || jQuery.isArray(data)) {
									// 3947
									queue = jQuery._data(elem, type, jQuery.makeArray(data)); // 3948
								} else {
									// 3949
									queue.push(data); // 3950
								} // 3951
							} // 3952
							return queue || []; // 3953
						} // 3954
					}, // 3955
					// 3956
					dequeue: function (elem, type) {
						// 3957
						type = type || "fx"; // 3958
						// 3959
						var queue = jQuery.queue(elem, type),
						    // 3960
						startLength = queue.length,
						    // 3961
						fn = queue.shift(),
						    // 3962
						hooks = jQuery._queueHooks(elem, type),
						    // 3963
						next = function () {
							// 3964
							jQuery.dequeue(elem, type); // 3965
						}; // 3966
						// 3967
						// If the fx queue is dequeued, always remove the progress sentinel                                                // 3968
						if (fn === "inprogress") {
							// 3969
							fn = queue.shift(); // 3970
							startLength--; // 3971
						} // 3972
						// 3973
						if (fn) {
							// 3974
							// 3975
							// Add a progress sentinel to prevent the fx queue from being                                                     // 3976
							// automatically dequeued                                                                                         // 3977
							if (type === "fx") {
								// 3978
								queue.unshift("inprogress"); // 3979
							} // 3980
							// 3981
							// clear up the last queue stop function                                                                          // 3982
							delete hooks.stop; // 3983
							fn.call(elem, next, hooks); // 3984
						} // 3985
						// 3986
						if (!startLength && hooks) {
							// 3987
							hooks.empty.fire(); // 3988
						} // 3989
					}, // 3990
					// 3991
					// not intended for public consumption - generates a queueHooks object, or returns the current one                  // 3992
					_queueHooks: function (elem, type) {
						// 3993
						var key = type + "queueHooks"; // 3994
						return jQuery._data(elem, key) || jQuery._data(elem, key, { // 3995
							empty: jQuery.Callbacks("once memory").add(function () {
								// 3996
								jQuery._removeData(elem, type + "queue"); // 3997
								jQuery._removeData(elem, key); // 3998
							}) // 3999
						}); // 4000
					} // 4001
				}); // 4002
				// 4003
				jQuery.fn.extend({ // 4004
					queue: function (type, data) {
						// 4005
						var setter = 2; // 4006
						// 4007
						if (typeof type !== "string") {
							// 4008
							data = type; // 4009
							type = "fx"; // 4010
							setter--; // 4011
						} // 4012
						// 4013
						if (arguments.length < setter) {
							// 4014
							return jQuery.queue(this[0], type); // 4015
						} // 4016
						// 4017
						return data === undefined ? // 4018
						this : // 4019
						this.each(function () {
							// 4020
							var queue = jQuery.queue(this, type, data); // 4021
							// 4022
							// ensure a hooks for this queue                                                                                 // 4023
							jQuery._queueHooks(this, type); // 4024
							// 4025
							if (type === "fx" && queue[0] !== "inprogress") {
								// 4026
								jQuery.dequeue(this, type); // 4027
							} // 4028
						}); // 4029
					}, // 4030
					dequeue: function (type) {
						// 4031
						return this.each(function () {
							// 4032
							jQuery.dequeue(this, type); // 4033
						}); // 4034
					}, // 4035
					clearQueue: function (type) {
						// 4036
						return this.queue(type || "fx", []); // 4037
					}, // 4038
					// Get a promise resolved when queues of a certain type                                                             // 4039
					// are emptied (fx is the type by default)                                                                          // 4040
					promise: function (type, obj) {
						// 4041
						var tmp,
						    // 4042
						count = 1,
						    // 4043
						defer = jQuery.Deferred(),
						    // 4044
						elements = this,
						    // 4045
						i = this.length,
						    // 4046
						resolve = function () {
							// 4047
							if (! --count) {
								// 4048
								defer.resolveWith(elements, [elements]); // 4049
							} // 4050
						}; // 4051
						// 4052
						if (typeof type !== "string") {
							// 4053
							obj = type; // 4054
							type = undefined; // 4055
						} // 4056
						type = type || "fx"; // 4057
						// 4058
						while (i--) {
							// 4059
							tmp = jQuery._data(elements[i], type + "queueHooks"); // 4060
							if (tmp && tmp.empty) {
								// 4061
								count++; // 4062
								tmp.empty.add(resolve); // 4063
							} // 4064
						} // 4065
						resolve(); // 4066
						return defer.promise(obj); // 4067
					} // 4068
				}); // 4069
				var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source; // 4070
				// 4071
				var cssExpand = ["Top", "Right", "Bottom", "Left"]; // 4072
				// 4073
				var isHidden = function (elem, el) {
					// 4074
					// isHidden might be called from jQuery#filter function;                                                           // 4075
					// in that case, element will be second argument                                                                   // 4076
					elem = el || elem; // 4077
					return jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument, elem); // 4078
				}; // 4079
				// 4080
				// 4081
				// 4082
				// Multifunctional method to get and set values of a collection                                                      // 4083
				// The value/s can optionally be executed if it's a function                                                         // 4084
				var access = jQuery.access = function (elems, fn, key, value, chainable, emptyGet, raw) {
					// 4085
					var i = 0,
					    // 4086
					length = elems.length,
					    // 4087
					bulk = key == null; // 4088
					// 4089
					// Sets many values                                                                                                 // 4090
					if (jQuery.type(key) === "object") {
						// 4091
						chainable = true; // 4092
						for (i in key) {
							// 4093
							jQuery.access(elems, fn, i, key[i], true, emptyGet, raw); // 4094
						} // 4095
						// 4096
						// Sets one value                                                                                                   // 4097
					} else if (value !== undefined) {
						// 4098
						chainable = true; // 4099
						// 4100
						if (!jQuery.isFunction(value)) {
							// 4101
							raw = true; // 4102
						} // 4103
						// 4104
						if (bulk) {
							// 4105
							// Bulk operations run against the entire set                                                                     // 4106
							if (raw) {
								// 4107
								fn.call(elems, value); // 4108
								fn = null; // 4109
								// 4110
								// ...except when executing function values                                                                       // 4111
							} else {
								// 4112
								bulk = fn; // 4113
								fn = function (elem, key, value) {
									// 4114
									return bulk.call(jQuery(elem), value); // 4115
								}; // 4116
							} // 4117
						} // 4118
						// 4119
						if (fn) {
							// 4120
							for (; i < length; i++) {
								// 4121
								fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key))); // 4122
							} // 4123
						} // 4124
					} // 4125
					// 4126
					return chainable ? // 4127
					elems : // 4128
					// 4129
					// Gets                                                                                                            // 4130
					bulk ? // 4131
					fn.call(elems) : // 4132
					length ? fn(elems[0], key) : emptyGet; // 4133
				}; // 4134
				var rcheckableType = /^(?:checkbox|radio)$/i; // 4135
				// 4136
				// 4137
				// 4138
				(function () {
					// 4139
					var fragment = document.createDocumentFragment(),
					    // 4140
					div = document.createElement("div"),
					    // 4141
					input = document.createElement("input"); // 4142
					// 4143
					// Setup                                                                                                            // 4144
					div.setAttribute("className", "t"); // 4145
					div.innerHTML = "  <link/><table></table><a href='/a'>a</a>"; // 4146
					// 4147
					// IE strips leading whitespace when .innerHTML is used                                                             // 4148
					support.leadingWhitespace = div.firstChild.nodeType === 3; // 4149
					// 4150
					// Make sure that tbody elements aren't automatically inserted                                                      // 4151
					// IE will insert them into empty tables                                                                            // 4152
					support.tbody = !div.getElementsByTagName("tbody").length; // 4153
					// 4154
					// Make sure that link elements get serialized correctly by innerHTML                                               // 4155
					// This requires a wrapper element in IE                                                                            // 4156
					support.htmlSerialize = !!div.getElementsByTagName("link").length; // 4157
					// 4158
					// Makes sure cloning an html5 element does not cause problems                                                      // 4159
					// Where outerHTML is undefined, this still works                                                                   // 4160
					support.html5Clone = // 4161
					document.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>"; // 4162
					// 4163
					// Check if a disconnected checkbox will retain its checked                                                         // 4164
					// value of true after appended to the DOM (IE6/7)                                                                  // 4165
					input.type = "checkbox"; // 4166
					input.checked = true; // 4167
					fragment.appendChild(input); // 4168
					support.appendChecked = input.checked; // 4169
					// 4170
					// Make sure textarea (and checkbox) defaultValue is properly cloned                                                // 4171
					// Support: IE6-IE11+                                                                                               // 4172
					div.innerHTML = "<textarea>x</textarea>"; // 4173
					support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue; // 4174
					// 4175
					// #11217 - WebKit loses check when the name is after the checked attribute                                         // 4176
					fragment.appendChild(div); // 4177
					div.innerHTML = "<input type='radio' checked='checked' name='t'/>"; // 4178
					// 4179
					// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3                                                           // 4180
					// old WebKit doesn't clone checked state correctly in fragments                                                    // 4181
					support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked; // 4182
					// 4183
					// Support: IE<9                                                                                                    // 4184
					// Opera does not clone events (and typeof div.attachEvent === undefined).                                          // 4185
					// IE9-10 clones events bound via attachEvent, but they don't trigger with .click()                                 // 4186
					support.noCloneEvent = true; // 4187
					if (div.attachEvent) {
						// 4188
						div.attachEvent("onclick", function () {
							// 4189
							support.noCloneEvent = false; // 4190
						}); // 4191
						// 4192
						div.cloneNode(true).click(); // 4193
					} // 4194
					// 4195
					// Execute the test only if not already executed in another module.                                                 // 4196
					if (support.deleteExpando == null) {
						// 4197
						// Support: IE<9                                                                                                   // 4198
						support.deleteExpando = true; // 4199
						try {
							// 4200
							delete div.test; // 4201
						} catch (e) {
							// 4202
							support.deleteExpando = false; // 4203
						} // 4204
					} // 4205
					// 4206
					// Null elements to avoid leaks in IE.                                                                              // 4207
					fragment = div = input = null; // 4208
				})(); // 4209
				// 4210
				// 4211
				(function () {
					// 4212
					var i,
					    eventName,
					    // 4213
					div = document.createElement("div"); // 4214
					// 4215
					// Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)                                      // 4216
					for (i in { submit: true, change: true, focusin: true }) {
						// 4217
						eventName = "on" + i; // 4218
						// 4219
						if (!(support[i + "Bubbles"] = eventName in window)) {
							// 4220
							// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)                                     // 4221
							div.setAttribute(eventName, "t"); // 4222
							support[i + "Bubbles"] = div.attributes[eventName].expando === false; // 4223
						} // 4224
					} // 4225
					// 4226
					// Null elements to avoid leaks in IE.                                                                              // 4227
					div = null; // 4228
				})(); // 4229
				// 4230
				// 4231
				var rformElems = /^(?:input|select|textarea)$/i,
				    // 4232
				rkeyEvent = /^key/,
				    // 4233
				rmouseEvent = /^(?:mouse|contextmenu)|click/,
				    // 4234
				rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
				    // 4235
				rtypenamespace = /^([^.]*)(?:\.(.+)|)$/; // 4236
				// 4237
				function returnTrue() {
					// 4238
					return true; // 4239
				} // 4240
				// 4241
				function returnFalse() {
					// 4242
					return false; // 4243
				} // 4244
				// 4245
				function safeActiveElement() {
					// 4246
					try {
						// 4247
						return document.activeElement; // 4248
					} catch (err) {} // 4249
				} // 4250
				// 4251
				/*                                                                                                                   // 4252
     * Helper functions for managing events -- not part of the public interface.                                         // 4253
     * Props to Dean Edwards' addEvent library for many of the ideas.                                                    // 4254
     */ // 4255
				jQuery.event = { // 4256
					// 4257
					global: {}, // 4258
					// 4259
					add: function (elem, types, handler, data, selector) {
						// 4260
						var tmp,
						    events,
						    t,
						    handleObjIn,
						    // 4261
						special,
						    eventHandle,
						    handleObj,
						    // 4262
						handlers,
						    type,
						    namespaces,
						    origType,
						    // 4263
						elemData = jQuery._data(elem); // 4264
						// 4265
						// Don't attach events to noData or text/comment nodes (but allow plain objects)                                   // 4266
						if (!elemData) {
							// 4267
							return; // 4268
						} // 4269
						// 4270
						// Caller can pass in an object of custom data in lieu of the handler                                              // 4271
						if (handler.handler) {
							// 4272
							handleObjIn = handler; // 4273
							handler = handleObjIn.handler; // 4274
							selector = handleObjIn.selector; // 4275
						} // 4276
						// 4277
						// Make sure that the handler has a unique ID, used to find/remove it later                                        // 4278
						if (!handler.guid) {
							// 4279
							handler.guid = jQuery.guid++; // 4280
						} // 4281
						// 4282
						// Init the element's event structure and main handler, if this is the first                                       // 4283
						if (!(events = elemData.events)) {
							// 4284
							events = elemData.events = {}; // 4285
						} // 4286
						if (!(eventHandle = elemData.handle)) {
							// 4287
							eventHandle = elemData.handle = function (e) {
								// 4288
								// Discard the second event of a jQuery.event.trigger() and                                                      // 4289
								// when an event is called after a page has unloaded                                                             // 4290
								return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ? // 4291
								jQuery.event.dispatch.apply(eventHandle.elem, arguments) : // 4292
								undefined; // 4293
							}; // 4294
							// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events                     // 4295
							eventHandle.elem = elem; // 4296
						} // 4297
						// 4298
						// Handle multiple events separated by a space                                                                     // 4299
						types = (types || "").match(rnotwhite) || [""]; // 4300
						t = types.length; // 4301
						while (t--) {
							// 4302
							tmp = rtypenamespace.exec(types[t]) || []; // 4303
							type = origType = tmp[1]; // 4304
							namespaces = (tmp[2] || "").split(".").sort(); // 4305
							// 4306
							// There *must* be a type, no attaching namespace-only handlers                                                   // 4307
							if (!type) {
								// 4308
								continue; // 4309
							} // 4310
							// 4311
							// If event changes its type, use the special event handlers for the changed type                                 // 4312
							special = jQuery.event.special[type] || {}; // 4313
							// 4314
							// If selector defined, determine special event api type, otherwise given type                                    // 4315
							type = (selector ? special.delegateType : special.bindType) || type; // 4316
							// 4317
							// Update special based on newly reset type                                                                       // 4318
							special = jQuery.event.special[type] || {}; // 4319
							// 4320
							// handleObj is passed to all event handlers                                                                      // 4321
							handleObj = jQuery.extend({ // 4322
								type: type, // 4323
								origType: origType, // 4324
								data: data, // 4325
								handler: handler, // 4326
								guid: handler.guid, // 4327
								selector: selector, // 4328
								needsContext: selector && jQuery.expr.match.needsContext.test(selector), // 4329
								namespace: namespaces.join(".") // 4330
							}, handleObjIn); // 4331
							// 4332
							// Init the event handler queue if we're the first                                                                // 4333
							if (!(handlers = events[type])) {
								// 4334
								handlers = events[type] = []; // 4335
								handlers.delegateCount = 0; // 4336
								// 4337
								// Only use addEventListener/attachEvent if the special events handler returns false                             // 4338
								if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
									// 4339
									// Bind the global event handler to the element                                                                 // 4340
									if (elem.addEventListener) {
										// 4341
										elem.addEventListener(type, eventHandle, false); // 4342
										// 4343
									} else if (elem.attachEvent) {
										// 4344
										elem.attachEvent("on" + type, eventHandle); // 4345
									} // 4346
								} // 4347
							} // 4348
							// 4349
							if (special.add) {
								// 4350
								special.add.call(elem, handleObj); // 4351
								// 4352
								if (!handleObj.handler.guid) {
									// 4353
									handleObj.handler.guid = handler.guid; // 4354
								} // 4355
							} // 4356
							// 4357
							// Add to the element's handler list, delegates in front                                                          // 4358
							if (selector) {
								// 4359
								handlers.splice(handlers.delegateCount++, 0, handleObj); // 4360
							} else {
								// 4361
								handlers.push(handleObj); // 4362
							} // 4363
							// 4364
							// Keep track of which events have ever been used, for event optimization                                         // 4365
							jQuery.event.global[type] = true; // 4366
						} // 4367
						// 4368
						// Nullify elem to prevent memory leaks in IE                                                                      // 4369
						elem = null; // 4370
					}, // 4371
					// 4372
					// Detach an event or set of events from an element                                                                 // 4373
					remove: function (elem, types, handler, selector, mappedTypes) {
						// 4374
						var j,
						    handleObj,
						    tmp,
						    // 4375
						origCount,
						    t,
						    events,
						    // 4376
						special,
						    handlers,
						    type,
						    // 4377
						namespaces,
						    origType,
						    // 4378
						elemData = jQuery.hasData(elem) && jQuery._data(elem); // 4379
						// 4380
						if (!elemData || !(events = elemData.events)) {
							// 4381
							return; // 4382
						} // 4383
						// 4384
						// Once for each type.namespace in types; type may be omitted                                                      // 4385
						types = (types || "").match(rnotwhite) || [""]; // 4386
						t = types.length; // 4387
						while (t--) {
							// 4388
							tmp = rtypenamespace.exec(types[t]) || []; // 4389
							type = origType = tmp[1]; // 4390
							namespaces = (tmp[2] || "").split(".").sort(); // 4391
							// 4392
							// Unbind all events (on this namespace, if provided) for the element                                             // 4393
							if (!type) {
								// 4394
								for (type in events) {
									// 4395
									jQuery.event.remove(elem, type + types[t], handler, selector, true); // 4396
								} // 4397
								continue; // 4398
							} // 4399
							// 4400
							special = jQuery.event.special[type] || {}; // 4401
							type = (selector ? special.delegateType : special.bindType) || type; // 4402
							handlers = events[type] || []; // 4403
							tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"); // 4404
							// 4405
							// Remove matching events                                                                                         // 4406
							origCount = j = handlers.length; // 4407
							while (j--) {
								// 4408
								handleObj = handlers[j]; // 4409
								// 4410
								if ((mappedTypes || origType === handleObj.origType) && ( // 4411
								!handler || handler.guid === handleObj.guid) && ( // 4412
								!tmp || tmp.test(handleObj.namespace)) && ( // 4413
								!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
									// 4414
									handlers.splice(j, 1); // 4415
									// 4416
									if (handleObj.selector) {
										// 4417
										handlers.delegateCount--; // 4418
									} // 4419
									if (special.remove) {
										// 4420
										special.remove.call(elem, handleObj); // 4421
									} // 4422
								} // 4423
							} // 4424
							// 4425
							// Remove generic event handler if we removed something and no more handlers exist                                // 4426
							// (avoids potential for endless recursion during removal of special event handlers)                              // 4427
							if (origCount && !handlers.length) {
								// 4428
								if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
									// 4429
									jQuery.removeEvent(elem, type, elemData.handle); // 4430
								} // 4431
								// 4432
								delete events[type]; // 4433
							} // 4434
						} // 4435
						// 4436
						// Remove the expando if it's no longer used                                                                       // 4437
						if (jQuery.isEmptyObject(events)) {
							// 4438
							delete elemData.handle; // 4439
							// 4440
							// removeData also checks for emptiness and clears the expando if empty                                           // 4441
							// so use it instead of delete                                                                                    // 4442
							jQuery._removeData(elem, "events"); // 4443
						} // 4444
					}, // 4445
					// 4446
					trigger: function (event, data, elem, onlyHandlers) {
						// 4447
						var handle,
						    ontype,
						    cur,
						    // 4448
						bubbleType,
						    special,
						    tmp,
						    i,
						    // 4449
						eventPath = [elem || document],
						    // 4450
						type = hasOwn.call(event, "type") ? event.type : event,
						    // 4451
						namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : []; // 4452
						// 4453
						cur = tmp = elem = elem || document; // 4454
						// 4455
						// Don't do events on text and comment nodes                                                                       // 4456
						if (elem.nodeType === 3 || elem.nodeType === 8) {
							// 4457
							return; // 4458
						} // 4459
						// 4460
						// focus/blur morphs to focusin/out; ensure we're not firing them right now                                        // 4461
						if (rfocusMorph.test(type + jQuery.event.triggered)) {
							// 4462
							return; // 4463
						} // 4464
						// 4465
						if (type.indexOf(".") >= 0) {
							// 4466
							// Namespaced trigger; create a regexp to match event type in handle()                                            // 4467
							namespaces = type.split("."); // 4468
							type = namespaces.shift(); // 4469
							namespaces.sort(); // 4470
						} // 4471
						ontype = type.indexOf(":") < 0 && "on" + type; // 4472
						// 4473
						// Caller can pass in a jQuery.Event object, Object, or just an event type string                                  // 4474
						event = event[jQuery.expando] ? // 4475
						event : // 4476
						new jQuery.Event(type, typeof event === "object" && event); // 4477
						// 4478
						// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)                                          // 4479
						event.isTrigger = onlyHandlers ? 2 : 3; // 4480
						event.namespace = namespaces.join("."); // 4481
						event.namespace_re = event.namespace ? // 4482
						new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : // 4483
						null; // 4484
						// 4485
						// Clean up the event in case it is being reused                                                                   // 4486
						event.result = undefined; // 4487
						if (!event.target) {
							// 4488
							event.target = elem; // 4489
						} // 4490
						// 4491
						// Clone any incoming data and prepend the event, creating the handler arg list                                    // 4492
						data = data == null ? // 4493
						[event] : // 4494
						jQuery.makeArray(data, [event]); // 4495
						// 4496
						// Allow special events to draw outside the lines                                                                  // 4497
						special = jQuery.event.special[type] || {}; // 4498
						if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
							// 4499
							return; // 4500
						} // 4501
						// 4502
						// Determine event propagation path in advance, per W3C events spec (#9951)                                        // 4503
						// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)                             // 4504
						if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
							// 4505
							// 4506
							bubbleType = special.delegateType || type; // 4507
							if (!rfocusMorph.test(bubbleType + type)) {
								// 4508
								cur = cur.parentNode; // 4509
							} // 4510
							for (; cur; cur = cur.parentNode) {
								// 4511
								eventPath.push(cur); // 4512
								tmp = cur; // 4513
							} // 4514
							// 4515
							// Only add window if we got to document (e.g., not plain obj or detached DOM)                                    // 4516
							if (tmp === (elem.ownerDocument || document)) {
								// 4517
								eventPath.push(tmp.defaultView || tmp.parentWindow || window); // 4518
							} // 4519
						} // 4520
						// 4521
						// Fire handlers on the event path                                                                                 // 4522
						i = 0; // 4523
						while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
							// 4524
							// 4525
							event.type = i > 1 ? // 4526
							bubbleType : // 4527
							special.bindType || type; // 4528
							// 4529
							// jQuery handler                                                                                                 // 4530
							handle = (jQuery._data(cur, "events") || {})[event.type] && jQuery._data(cur, "handle"); // 4531
							if (handle) {
								// 4532
								handle.apply(cur, data); // 4533
							} // 4534
							// 4535
							// Native handler                                                                                                 // 4536
							handle = ontype && cur[ontype]; // 4537
							if (handle && handle.apply && jQuery.acceptData(cur)) {
								// 4538
								event.result = handle.apply(cur, data); // 4539
								if (event.result === false) {
									// 4540
									event.preventDefault(); // 4541
								} // 4542
							} // 4543
						} // 4544
						event.type = type; // 4545
						// 4546
						// If nobody prevented the default action, do it now                                                               // 4547
						if (!onlyHandlers && !event.isDefaultPrevented()) {
							// 4548
							// 4549
							if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && // 4550
							jQuery.acceptData(elem)) {
								// 4551
								// 4552
								// Call a native DOM method on the target with the same name name as the event.                                  // 4553
								// Can't use an .isFunction() check here because IE6/7 fails that test.                                          // 4554
								// Don't do default actions on window, that's where global variables be (#6170)                                  // 4555
								if (ontype && elem[type] && !jQuery.isWindow(elem)) {
									// 4556
									// 4557
									// Don't re-trigger an onFOO event when we call its FOO() method                                                // 4558
									tmp = elem[ontype]; // 4559
									// 4560
									if (tmp) {
										// 4561
										elem[ontype] = null; // 4562
									} // 4563
									// 4564
									// Prevent re-triggering of the same event, since we already bubbled it above                                   // 4565
									jQuery.event.triggered = type; // 4566
									try {
										// 4567
										elem[type](); // 4568
									} catch (e) {} // 4569
									// IE<9 dies on focus/blur to hidden element (#1486,#12518)                                                    // 4570
									// only reproducible on winXP IE8 native, not IE9 in IE8 mode                                                  // 4571
									// 4572
									jQuery.event.triggered = undefined; // 4573
									// 4574
									if (tmp) {
										// 4575
										elem[ontype] = tmp; // 4576
									} // 4577
								} // 4578
							} // 4579
						} // 4580
						// 4581
						return event.result; // 4582
					}, // 4583
					// 4584
					dispatch: function (event) {
						// 4585
						// 4586
						// Make a writable jQuery.Event from the native event object                                                       // 4587
						event = jQuery.event.fix(event); // 4588
						// 4589
						var i,
						    ret,
						    handleObj,
						    matched,
						    j,
						    // 4590
						handlerQueue = [],
						    // 4591
						args = slice.call(arguments),
						    // 4592
						handlers = (jQuery._data(this, "events") || {})[event.type] || [],
						    // 4593
						special = jQuery.event.special[event.type] || {}; // 4594
						// 4595
						// Use the fix-ed jQuery.Event rather than the (read-only) native event                                            // 4596
						args[0] = event; // 4597
						event.delegateTarget = this; // 4598
						// 4599
						// Call the preDispatch hook for the mapped type, and let it bail if desired                                       // 4600
						if (special.preDispatch && special.preDispatch.call(this, event) === false) {
							// 4601
							return; // 4602
						} // 4603
						// 4604
						// Determine handlers                                                                                              // 4605
						handlerQueue = jQuery.event.handlers.call(this, event, handlers); // 4606
						// 4607
						// Run delegates first; they may want to stop propagation beneath us                                               // 4608
						i = 0; // 4609
						while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
							// 4610
							event.currentTarget = matched.elem; // 4611
							// 4612
							j = 0; // 4613
							while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
								// 4614
								// 4615
								// Triggered event must either 1) have no namespace, or                                                          // 4616
								// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).              // 4617
								if (!event.namespace_re || event.namespace_re.test(handleObj.namespace)) {
									// 4618
									// 4619
									event.handleObj = handleObj; // 4620
									event.data = handleObj.data; // 4621
									// 4622
									ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler). // 4623
									apply(matched.elem, args); // 4624
									// 4625
									if (ret !== undefined) {
										// 4626
										if ((event.result = ret) === false) {
											// 4627
											event.preventDefault(); // 4628
											event.stopPropagation(); // 4629
										} // 4630
									} // 4631
								} // 4632
							} // 4633
						} // 4634
						// 4635
						// Call the postDispatch hook for the mapped type                                                                  // 4636
						if (special.postDispatch) {
							// 4637
							special.postDispatch.call(this, event); // 4638
						} // 4639
						// 4640
						return event.result; // 4641
					}, // 4642
					// 4643
					handlers: function (event, handlers) {
						// 4644
						var sel,
						    handleObj,
						    matches,
						    i,
						    // 4645
						handlerQueue = [],
						    // 4646
						delegateCount = handlers.delegateCount,
						    // 4647
						cur = event.target; // 4648
						// 4649
						// Find delegate handlers                                                                                          // 4650
						// Black-hole SVG <use> instance trees (#13180)                                                                    // 4651
						// Avoid non-left-click bubbling in Firefox (#3861)                                                                // 4652
						if (delegateCount && cur.nodeType && (!event.button || event.type !== "click")) {
							// 4653
							// 4654
							/* jshint eqeqeq: false */ // 4655
							for (; cur != this; cur = cur.parentNode || this) {
								// 4656
								/* jshint eqeqeq: true */ // 4657
								// 4658
								// Don't check non-elements (#13208)                                                                             // 4659
								// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)                                      // 4660
								if (cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click")) {
									// 4661
									matches = []; // 4662
									for (i = 0; i < delegateCount; i++) {
										// 4663
										handleObj = handlers[i]; // 4664
										// 4665
										// Don't conflict with Object.prototype properties (#13203)                                                    // 4666
										sel = handleObj.selector + " "; // 4667
										// 4668
										if (matches[sel] === undefined) {
											// 4669
											matches[sel] = handleObj.needsContext ? // 4670
											jQuery(sel, this).index(cur) >= 0 : // 4671
											jQuery.find(sel, this, null, [cur]).length; // 4672
										} // 4673
										if (matches[sel]) {
											// 4674
											matches.push(handleObj); // 4675
										} // 4676
									} // 4677
									if (matches.length) {
										// 4678
										handlerQueue.push({ elem: cur, handlers: matches }); // 4679
									} // 4680
								} // 4681
							} // 4682
						} // 4683
						// 4684
						// Add the remaining (directly-bound) handlers                                                                     // 4685
						if (delegateCount < handlers.length) {
							// 4686
							handlerQueue.push({ elem: this, handlers: handlers.slice(delegateCount) }); // 4687
						} // 4688
						// 4689
						return handlerQueue; // 4690
					}, // 4691
					// 4692
					fix: function (event) {
						// 4693
						if (event[jQuery.expando]) {
							// 4694
							return event; // 4695
						} // 4696
						// 4697
						// Create a writable copy of the event object and normalize some properties                                        // 4698
						var i,
						    prop,
						    copy,
						    // 4699
						type = event.type,
						    // 4700
						originalEvent = event,
						    // 4701
						fixHook = this.fixHooks[type]; // 4702
						// 4703
						if (!fixHook) {
							// 4704
							this.fixHooks[type] = fixHook = // 4705
							rmouseEvent.test(type) ? this.mouseHooks : // 4706
							rkeyEvent.test(type) ? this.keyHooks : // 4707
							{}; // 4708
						} // 4709
						copy = fixHook.props ? this.props.concat(fixHook.props) : this.props; // 4710
						// 4711
						event = new jQuery.Event(originalEvent); // 4712
						// 4713
						i = copy.length; // 4714
						while (i--) {
							// 4715
							prop = copy[i]; // 4716
							event[prop] = originalEvent[prop]; // 4717
						} // 4718
						// 4719
						// Support: IE<9                                                                                                   // 4720
						// Fix target property (#1925)                                                                                     // 4721
						if (!event.target) {
							// 4722
							event.target = originalEvent.srcElement || document; // 4723
						} // 4724
						// 4725
						// Support: Chrome 23+, Safari?                                                                                    // 4726
						// Target should not be a text node (#504, #13143)                                                                 // 4727
						if (event.target.nodeType === 3) {
							// 4728
							event.target = event.target.parentNode; // 4729
						} // 4730
						// 4731
						// Support: IE<9                                                                                                   // 4732
						// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)                                          // 4733
						event.metaKey = !!event.metaKey; // 4734
						// 4735
						return fixHook.filter ? fixHook.filter(event, originalEvent) : event; // 4736
					}, // 4737
					// 4738
					// Includes some event props shared by KeyEvent and MouseEvent                                                      // 4739
					props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
					// 4741
					fixHooks: {}, // 4742
					// 4743
					keyHooks: { // 4744
						props: "char charCode key keyCode".split(" "), // 4745
						filter: function (event, original) {
							// 4746
							// 4747
							// Add which for key events                                                                                       // 4748
							if (event.which == null) {
								// 4749
								event.which = original.charCode != null ? original.charCode : original.keyCode; // 4750
							} // 4751
							// 4752
							return event; // 4753
						} // 4754
					}, // 4755
					// 4756
					mouseHooks: { // 4757
						props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
						filter: function (event, original) {
							// 4759
							var body,
							    eventDoc,
							    doc,
							    // 4760
							button = original.button,
							    // 4761
							fromElement = original.fromElement; // 4762
							// 4763
							// Calculate pageX/Y if missing and clientX/Y available                                                           // 4764
							if (event.pageX == null && original.clientX != null) {
								// 4765
								eventDoc = event.target.ownerDocument || document; // 4766
								doc = eventDoc.documentElement; // 4767
								body = eventDoc.body; // 4768
								// 4769
								event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
								event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
							} // 4772
							// 4773
							// Add relatedTarget, if necessary                                                                                // 4774
							if (!event.relatedTarget && fromElement) {
								// 4775
								event.relatedTarget = fromElement === event.target ? original.toElement : fromElement; // 4776
							} // 4777
							// 4778
							// Add which for click: 1 === left; 2 === middle; 3 === right                                                     // 4779
							// Note: button is not normalized, so don't use it                                                                // 4780
							if (!event.which && button !== undefined) {
								// 4781
								event.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0; // 4782
							} // 4783
							// 4784
							return event; // 4785
						} // 4786
					}, // 4787
					// 4788
					special: { // 4789
						load: { // 4790
							// Prevent triggered image.load events from bubbling to window.load                                               // 4791
							noBubble: true // 4792
						}, // 4793
						focus: { // 4794
							// Fire native event if possible so blur/focus sequence is correct                                                // 4795
							trigger: function () {
								// 4796
								if (this !== safeActiveElement() && this.focus) {
									// 4797
									try {
										// 4798
										this.focus(); // 4799
										return false; // 4800
									} catch (e) {} // 4801
									// Support: IE<9                                                                                               // 4802
									// If we error on focus to hidden element (#1486, #12518),                                                     // 4803
									// let .trigger() run the handlers                                                                             // 4804
									// 4805
								} // 4806
							}, // 4807
							delegateType: "focusin" // 4808
						}, // 4809
						blur: { // 4810
							trigger: function () {
								// 4811
								if (this === safeActiveElement() && this.blur) {
									// 4812
									this.blur(); // 4813
									return false; // 4814
								} // 4815
							}, // 4816
							delegateType: "focusout" // 4817
						}, // 4818
						click: { // 4819
							// For checkbox, fire native event so checked state will be right                                                 // 4820
							trigger: function () {
								// 4821
								if (jQuery.nodeName(this, "input") && this.type === "checkbox" && this.click) {
									// 4822
									this.click(); // 4823
									return false; // 4824
								} // 4825
							}, // 4826
							// 4827
							// For cross-browser consistency, don't fire native .click() on links                                             // 4828
							_default: function (event) {
								// 4829
								return jQuery.nodeName(event.target, "a"); // 4830
							} // 4831
						}, // 4832
						// 4833
						beforeunload: { // 4834
							postDispatch: function (event) {
								// 4835
								// 4836
								// Even when returnValue equals to undefined Firefox will still show alert                                       // 4837
								if (event.result !== undefined) {
									// 4838
									event.originalEvent.returnValue = event.result; // 4839
								} // 4840
							} // 4841
							// 4842
						} }, // 4843
					// 4844
					simulate: function (type, elem, event, bubble) {
						// 4845
						// Piggyback on a donor event to simulate a different one.                                                         // 4846
						// Fake originalEvent to avoid donor's stopPropagation, but if the                                                 // 4847
						// simulated event prevents default then we do the same on the donor.                                              // 4848
						var e = jQuery.extend( // 4849
						new jQuery.Event(), // 4850
						event, // 4851
						{ // 4852
							type: type, // 4853
							isSimulated: true, // 4854
							originalEvent: {} // 4855
							// 4856
						}); // 4857
						if (bubble) {
							// 4858
							jQuery.event.trigger(e, null, elem); // 4859
						} else {
							// 4860
							jQuery.event.dispatch.call(elem, e); // 4861
						} // 4862
						if (e.isDefaultPrevented()) {
							// 4863
							event.preventDefault(); // 4864
						} // 4865
					} // 4866
				}; // 4867
				// 4868
				jQuery.removeEvent = document.removeEventListener ? // 4869
				function (elem, type, handle) {
					// 4870
					if (elem.removeEventListener) {
						// 4871
						elem.removeEventListener(type, handle, false); // 4872
					} // 4873
				} : // 4874
				function (elem, type, handle) {
					// 4875
					var name = "on" + type; // 4876
					// 4877
					if (elem.detachEvent) {
						// 4878
						// 4879
						// #8545, #7054, preventing memory leaks for custom events in IE6-8                                               // 4880
						// detachEvent needed property on element, by name of that event, to properly expose it to GC                     // 4881
						if (typeof elem[name] === strundefined) {
							// 4882
							elem[name] = null; // 4883
						} // 4884
						// 4885
						elem.detachEvent(name, handle); // 4886
					} // 4887
				}; // 4888
				// 4889
				jQuery.Event = function (src, props) {
					// 4890
					// Allow instantiation without the 'new' keyword                                                                    // 4891
					if (!(this instanceof jQuery.Event)) {
						// 4892
						return new jQuery.Event(src, props); // 4893
					} // 4894
					// 4895
					// Event object                                                                                                     // 4896
					if (src && src.type) {
						// 4897
						this.originalEvent = src; // 4898
						this.type = src.type; // 4899
						// 4900
						// Events bubbling up the document may have been marked as prevented                                               // 4901
						// by a handler lower down the tree; reflect the correct value.                                                    // 4902
						this.isDefaultPrevented = src.defaultPrevented || // 4903
						src.defaultPrevented === undefined && ( // 4904
						// Support: IE < 9                                                                                               // 4905
						src.returnValue === false || // 4906
						// Support: Android < 4.0                                                                                        // 4907
						src.getPreventDefault && src.getPreventDefault()) ? // 4908
						returnTrue : // 4909
						returnFalse; // 4910
						// 4911
						// Event type                                                                                                       // 4912
					} else {
						// 4913
						this.type = src; // 4914
					} // 4915
					// 4916
					// Put explicitly provided properties onto the event object                                                         // 4917
					if (props) {
						// 4918
						jQuery.extend(this, props); // 4919
					} // 4920
					// 4921
					// Create a timestamp if incoming event doesn't have one                                                            // 4922
					this.timeStamp = src && src.timeStamp || jQuery.now(); // 4923
					// 4924
					// Mark it as fixed                                                                                                 // 4925
					this[jQuery.expando] = true; // 4926
				}; // 4927
				// 4928
				// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding                              // 4929
				// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html                                 // 4930
				jQuery.Event.prototype = { // 4931
					isDefaultPrevented: returnFalse, // 4932
					isPropagationStopped: returnFalse, // 4933
					isImmediatePropagationStopped: returnFalse, // 4934
					// 4935
					preventDefault: function () {
						// 4936
						var e = this.originalEvent; // 4937
						// 4938
						this.isDefaultPrevented = returnTrue; // 4939
						if (!e) {
							// 4940
							return; // 4941
						} // 4942
						// 4943
						// If preventDefault exists, run it on the original event                                                          // 4944
						if (e.preventDefault) {
							// 4945
							e.preventDefault(); // 4946
							// 4947
							// Support: IE                                                                                                     // 4948
							// Otherwise set the returnValue property of the original event to false                                           // 4949
						} else {
							// 4950
							e.returnValue = false; // 4951
						} // 4952
					}, // 4953
					stopPropagation: function () {
						// 4954
						var e = this.originalEvent; // 4955
						// 4956
						this.isPropagationStopped = returnTrue; // 4957
						if (!e) {
							// 4958
							return; // 4959
						} // 4960
						// If stopPropagation exists, run it on the original event                                                         // 4961
						if (e.stopPropagation) {
							// 4962
							e.stopPropagation(); // 4963
						} // 4964
						// 4965
						// Support: IE                                                                                                     // 4966
						// Set the cancelBubble property of the original event to true                                                     // 4967
						e.cancelBubble = true; // 4968
					}, // 4969
					stopImmediatePropagation: function () {
						// 4970
						this.isImmediatePropagationStopped = returnTrue; // 4971
						this.stopPropagation(); // 4972
					} // 4973
				}; // 4974
				// 4975
				// Create mouseenter/leave events using mouseover/out and event-time checks                                          // 4976
				jQuery.each({ // 4977
					mouseenter: "mouseover", // 4978
					mouseleave: "mouseout" // 4979
				}, function (orig, fix) {
					// 4980
					jQuery.event.special[orig] = { // 4981
						delegateType: fix, // 4982
						bindType: fix, // 4983
						// 4984
						handle: function (event) {
							// 4985
							var ret,
							    // 4986
							target = this,
							    // 4987
							related = event.relatedTarget,
							    // 4988
							handleObj = event.handleObj; // 4989
							// 4990
							// For mousenter/leave call the handler if related is outside the target.                                         // 4991
							// NB: No relatedTarget if the mouse left/entered the browser window                                              // 4992
							if (!related || related !== target && !jQuery.contains(target, related)) {
								// 4993
								event.type = handleObj.origType; // 4994
								ret = handleObj.handler.apply(this, arguments); // 4995
								event.type = fix; // 4996
							} // 4997
							return ret; // 4998
						} // 4999
					}; // 5000
				}); // 5001
				// 5002
				// IE submit delegation                                                                                              // 5003
				if (!support.submitBubbles) {
					// 5004
					// 5005
					jQuery.event.special.submit = { // 5006
						setup: function () {
							// 5007
							// Only need this for delegated form submit events                                                                // 5008
							if (jQuery.nodeName(this, "form")) {
								// 5009
								return false; // 5010
							} // 5011
							// 5012
							// Lazy-add a submit handler when a descendant form may potentially be submitted                                  // 5013
							jQuery.event.add(this, "click._submit keypress._submit", function (e) {
								// 5014
								// Node name check avoids a VML-related crash in IE (#9807)                                                      // 5015
								var elem = e.target,
								    // 5016
								form = jQuery.nodeName(elem, "input") || jQuery.nodeName(elem, "button") ? elem.form : undefined; // 5017
								if (form && !jQuery._data(form, "submitBubbles")) {
									// 5018
									jQuery.event.add(form, "submit._submit", function (event) {
										// 5019
										event._submit_bubble = true; // 5020
									}); // 5021
									jQuery._data(form, "submitBubbles", true); // 5022
								} // 5023
							}); // 5024
							// return undefined since we don't need an event listener                                                         // 5025
						}, // 5026
						// 5027
						postDispatch: function (event) {
							// 5028
							// If form was submitted by the user, bubble the event up the tree                                                // 5029
							if (event._submit_bubble) {
								// 5030
								delete event._submit_bubble; // 5031
								if (this.parentNode && !event.isTrigger) {
									// 5032
									jQuery.event.simulate("submit", this.parentNode, event, true); // 5033
								} // 5034
							} // 5035
						}, // 5036
						// 5037
						teardown: function () {
							// 5038
							// Only need this for delegated form submit events                                                                // 5039
							if (jQuery.nodeName(this, "form")) {
								// 5040
								return false; // 5041
							} // 5042
							// 5043
							// Remove delegated handlers; cleanData eventually reaps submit handlers attached above                           // 5044
							jQuery.event.remove(this, "._submit"); // 5045
						} // 5046
					}; // 5047
				} // 5048
				// 5049
				// IE change delegation and checkbox/radio fix                                                                       // 5050
				if (!support.changeBubbles) {
					// 5051
					// 5052
					jQuery.event.special.change = { // 5053
						// 5054
						setup: function () {
							// 5055
							// 5056
							if (rformElems.test(this.nodeName)) {
								// 5057
								// IE doesn't fire change on a check/radio until blur; trigger it on click                                       // 5058
								// after a propertychange. Eat the blur-change in special.change.handle.                                         // 5059
								// This still fires onchange a second time for check/radio after blur.                                           // 5060
								if (this.type === "checkbox" || this.type === "radio") {
									// 5061
									jQuery.event.add(this, "propertychange._change", function (event) {
										// 5062
										if (event.originalEvent.propertyName === "checked") {
											// 5063
											this._just_changed = true; // 5064
										} // 5065
									}); // 5066
									jQuery.event.add(this, "click._change", function (event) {
										// 5067
										if (this._just_changed && !event.isTrigger) {
											// 5068
											this._just_changed = false; // 5069
										} // 5070
										// Allow triggered, simulated change events (#11500)                                                           // 5071
										jQuery.event.simulate("change", this, event, true); // 5072
									}); // 5073
								} // 5074
								return false; // 5075
							} // 5076
							// Delegated event; lazy-add a change handler on descendant inputs                                                // 5077
							jQuery.event.add(this, "beforeactivate._change", function (e) {
								// 5078
								var elem = e.target; // 5079
								// 5080
								if (rformElems.test(elem.nodeName) && !jQuery._data(elem, "changeBubbles")) {
									// 5081
									jQuery.event.add(elem, "change._change", function (event) {
										// 5082
										if (this.parentNode && !event.isSimulated && !event.isTrigger) {
											// 5083
											jQuery.event.simulate("change", this.parentNode, event, true); // 5084
										} // 5085
									}); // 5086
									jQuery._data(elem, "changeBubbles", true); // 5087
								} // 5088
							}); // 5089
						}, // 5090
						// 5091
						handle: function (event) {
							// 5092
							var elem = event.target; // 5093
							// 5094
							// Swallow native change events from checkbox/radio, we already triggered them above                              // 5095
							if (this !== elem || event.isSimulated || event.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") {
								return event.handleObj.handler.apply(this, arguments); // 5097
							} // 5098
						}, // 5099
						// 5100
						teardown: function () {
							// 5101
							jQuery.event.remove(this, "._change"); // 5102
							// 5103
							return !rformElems.test(this.nodeName); // 5104
						} // 5105
					}; // 5106
				} // 5107
				// 5108
				// Create "bubbling" focus and blur events                                                                           // 5109
				if (!support.focusinBubbles) {
					// 5110
					jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
						// 5111
						// 5112
						// Attach a single capturing handler on the document while someone wants focusin/focusout                          // 5113
						var handler = function (event) {
							// 5114
							jQuery.event.simulate(fix, event.target, jQuery.event.fix(event), true); // 5115
						}; // 5116
						// 5117
						jQuery.event.special[fix] = { // 5118
							setup: function () {
								// 5119
								var doc = this.ownerDocument || this,
								    // 5120
								attaches = jQuery._data(doc, fix); // 5121
								// 5122
								if (!attaches) {
									// 5123
									doc.addEventListener(orig, handler, true); // 5124
								} // 5125
								jQuery._data(doc, fix, (attaches || 0) + 1); // 5126
							}, // 5127
							teardown: function () {
								// 5128
								var doc = this.ownerDocument || this,
								    // 5129
								attaches = jQuery._data(doc, fix) - 1; // 5130
								// 5131
								if (!attaches) {
									// 5132
									doc.removeEventListener(orig, handler, true); // 5133
									jQuery._removeData(doc, fix); // 5134
								} else {
									// 5135
									jQuery._data(doc, fix, attaches); // 5136
								} // 5137
							} // 5138
						}; // 5139
					}); // 5140
				} // 5141
				// 5142
				jQuery.fn.extend({ // 5143
					// 5144
					on: function (types, selector, data, fn, /*INTERNAL*/one) {
						// 5145
						var type, origFn; // 5146
						// 5147
						// Types can be a map of types/handlers                                                                            // 5148
						if (typeof types === "object") {
							// 5149
							// ( types-Object, selector, data )                                                                               // 5150
							if (typeof selector !== "string") {
								// 5151
								// ( types-Object, data )                                                                                        // 5152
								data = data || selector; // 5153
								selector = undefined; // 5154
							} // 5155
							for (type in types) {
								// 5156
								this.on(type, selector, data, types[type], one); // 5157
							} // 5158
							return this; // 5159
						} // 5160
						// 5161
						if (data == null && fn == null) {
							// 5162
							// ( types, fn )                                                                                                  // 5163
							fn = selector; // 5164
							data = selector = undefined; // 5165
						} else if (fn == null) {
							// 5166
							if (typeof selector === "string") {
								// 5167
								// ( types, selector, fn )                                                                                       // 5168
								fn = data; // 5169
								data = undefined; // 5170
							} else {
								// 5171
								// ( types, data, fn )                                                                                           // 5172
								fn = data; // 5173
								data = selector; // 5174
								selector = undefined; // 5175
							} // 5176
						} // 5177
						if (fn === false) {
							// 5178
							fn = returnFalse; // 5179
						} else if (!fn) {
							// 5180
							return this; // 5181
						} // 5182
						// 5183
						if (one === 1) {
							// 5184
							origFn = fn; // 5185
							fn = function (event) {
								// 5186
								// Can use an empty set, since event contains the info                                                           // 5187
								jQuery().off(event); // 5188
								return origFn.apply(this, arguments); // 5189
							}; // 5190
							// Use same guid so caller can remove using origFn                                                                // 5191
							fn.guid = origFn.guid || (origFn.guid = jQuery.guid++); // 5192
						} // 5193
						return this.each(function () {
							// 5194
							jQuery.event.add(this, types, fn, data, selector); // 5195
						}); // 5196
					}, // 5197
					one: function (types, selector, data, fn) {
						// 5198
						return this.on(types, selector, data, fn, 1); // 5199
					}, // 5200
					off: function (types, selector, fn) {
						// 5201
						var handleObj, type; // 5202
						if (types && types.preventDefault && types.handleObj) {
							// 5203
							// ( event )  dispatched jQuery.Event                                                                             // 5204
							handleObj = types.handleObj; // 5205
							jQuery(types.delegateTarget).off( // 5206
							handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, // 5207
							handleObj.selector, // 5208
							handleObj.handler // 5209
							); // 5210
							return this; // 5211
						} // 5212
						if (typeof types === "object") {
							// 5213
							// ( types-object [, selector] )                                                                                  // 5214
							for (type in types) {
								// 5215
								this.off(type, selector, types[type]); // 5216
							} // 5217
							return this; // 5218
						} // 5219
						if (selector === false || typeof selector === "function") {
							// 5220
							// ( types [, fn] )                                                                                               // 5221
							fn = selector; // 5222
							selector = undefined; // 5223
						} // 5224
						if (fn === false) {
							// 5225
							fn = returnFalse; // 5226
						} // 5227
						return this.each(function () {
							// 5228
							jQuery.event.remove(this, types, fn, selector); // 5229
						}); // 5230
					}, // 5231
					// 5232
					trigger: function (type, data) {
						// 5233
						return this.each(function () {
							// 5234
							jQuery.event.trigger(type, data, this); // 5235
						}); // 5236
					}, // 5237
					triggerHandler: function (type, data) {
						// 5238
						var elem = this[0]; // 5239
						if (elem) {
							// 5240
							return jQuery.event.trigger(type, data, elem, true); // 5241
						} // 5242
					} // 5243
				}); // 5244
				// 5245
				// 5246
				function createSafeFragment(document) {
					// 5247
					var list = nodeNames.split("|"),
					    // 5248
					safeFrag = document.createDocumentFragment(); // 5249
					// 5250
					if (safeFrag.createElement) {
						// 5251
						while (list.length) {
							// 5252
							safeFrag.createElement( // 5253
							list.pop() // 5254
							); // 5255
						} // 5256
					} // 5257
					return safeFrag; // 5258
				} // 5259
				// 5260
				var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" + // 5261
				"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
				    // 5262
				rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
				    // 5263
				rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
				    // 5264
				rleadingWhitespace = /^\s+/,
				    // 5265
				rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
				    // 5266
				rtagName = /<([\w:]+)/,
				    // 5267
				rtbody = /<tbody/i,
				    // 5268
				rhtml = /<|&#?\w+;/,
				    // 5269
				rnoInnerhtml = /<(?:script|style|link)/i,
				    // 5270
				// checked="checked" or checked                                                                                     // 5271
				rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
				    // 5272
				rscriptType = /^$|\/(?:java|ecma)script/i,
				    // 5273
				rscriptTypeMasked = /^true\/(.*)/,
				    // 5274
				rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
				    // 5275
				// 5276
				// We have to close these tags to support XHTML (#13200)                                                            // 5277
				wrapMap = { // 5278
					option: [1, "<select multiple='multiple'>", "</select>"], // 5279
					legend: [1, "<fieldset>", "</fieldset>"], // 5280
					area: [1, "<map>", "</map>"], // 5281
					param: [1, "<object>", "</object>"], // 5282
					thead: [1, "<table>", "</table>"], // 5283
					tr: [2, "<table><tbody>", "</tbody></table>"], // 5284
					col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"], // 5285
					td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], // 5286
					// 5287
					// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,                                         // 5288
					// unless wrapped in a div with non-breaking characters in front of it.                                            // 5289
					_default: support.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"] // 5290
				},
				    // 5291
				safeFragment = createSafeFragment(document),
				    // 5292
				fragmentDiv = safeFragment.appendChild(document.createElement("div")); // 5293
				// 5294
				wrapMap.optgroup = wrapMap.option; // 5295
				wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead; // 5296
				wrapMap.th = wrapMap.td; // 5297
				// 5298
				function getAll(context, tag) {
					// 5299
					var elems,
					    elem,
					    // 5300
					i = 0,
					    // 5301
					found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName(tag || "*") : // 5302
					typeof context.querySelectorAll !== strundefined ? context.querySelectorAll(tag || "*") : // 5303
					undefined; // 5304
					// 5305
					if (!found) {
						// 5306
						for (found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++) {
							// 5307
							if (!tag || jQuery.nodeName(elem, tag)) {
								// 5308
								found.push(elem); // 5309
							} else {
								// 5310
								jQuery.merge(found, getAll(elem, tag)); // 5311
							} // 5312
						} // 5313
					} // 5314
					// 5315
					return tag === undefined || tag && jQuery.nodeName(context, tag) ? // 5316
					jQuery.merge([context], found) : // 5317
					found; // 5318
				} // 5319
				// 5320
				// Used in buildFragment, fixes the defaultChecked property                                                          // 5321
				function fixDefaultChecked(elem) {
					// 5322
					if (rcheckableType.test(elem.type)) {
						// 5323
						elem.defaultChecked = elem.checked; // 5324
					} // 5325
				} // 5326
				// 5327
				// Support: IE<8                                                                                                     // 5328
				// Manipulating tables requires a tbody                                                                              // 5329
				function manipulationTarget(elem, content) {
					// 5330
					return jQuery.nodeName(elem, "table") && // 5331
					jQuery.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? // 5332
					// 5333
					elem.getElementsByTagName("tbody")[0] || // 5334
					elem.appendChild(elem.ownerDocument.createElement("tbody")) : // 5335
					elem; // 5336
				} // 5337
				// 5338
				// Replace/restore the type attribute of script elements for safe DOM manipulation                                   // 5339
				function disableScript(elem) {
					// 5340
					elem.type = (jQuery.find.attr(elem, "type") !== null) + "/" + elem.type; // 5341
					return elem; // 5342
				} // 5343
				function restoreScript(elem) {
					// 5344
					var match = rscriptTypeMasked.exec(elem.type); // 5345
					if (match) {
						// 5346
						elem.type = match[1]; // 5347
					} else {
						// 5348
						elem.removeAttribute("type"); // 5349
					} // 5350
					return elem; // 5351
				} // 5352
				// 5353
				// Mark scripts as having already been evaluated                                                                     // 5354
				function setGlobalEval(elems, refElements) {
					// 5355
					var elem,
					    // 5356
					i = 0; // 5357
					for (; (elem = elems[i]) != null; i++) {
						// 5358
						jQuery._data(elem, "globalEval", !refElements || jQuery._data(refElements[i], "globalEval")); // 5359
					} // 5360
				} // 5361
				// 5362
				function cloneCopyEvent(src, dest) {
					// 5363
					// 5364
					if (dest.nodeType !== 1 || !jQuery.hasData(src)) {
						// 5365
						return; // 5366
					} // 5367
					// 5368
					var type,
					    i,
					    l,
					    // 5369
					oldData = jQuery._data(src),
					    // 5370
					curData = jQuery._data(dest, oldData),
					    // 5371
					events = oldData.events; // 5372
					// 5373
					if (events) {
						// 5374
						delete curData.handle; // 5375
						curData.events = {}; // 5376
						// 5377
						for (type in events) {
							// 5378
							for (i = 0, l = events[type].length; i < l; i++) {
								// 5379
								jQuery.event.add(dest, type, events[type][i]); // 5380
							} // 5381
						} // 5382
					} // 5383
					// 5384
					// make the cloned public data object a copy from the original                                                      // 5385
					if (curData.data) {
						// 5386
						curData.data = jQuery.extend({}, curData.data); // 5387
					} // 5388
				} // 5389
				// 5390
				function fixCloneNodeIssues(src, dest) {
					// 5391
					var nodeName, e, data; // 5392
					// 5393
					// We do not need to do anything for non-Elements                                                                   // 5394
					if (dest.nodeType !== 1) {
						// 5395
						return; // 5396
					} // 5397
					// 5398
					nodeName = dest.nodeName.toLowerCase(); // 5399
					// 5400
					// IE6-8 copies events bound via attachEvent when using cloneNode.                                                  // 5401
					if (!support.noCloneEvent && dest[jQuery.expando]) {
						// 5402
						data = jQuery._data(dest); // 5403
						// 5404
						for (e in data.events) {
							// 5405
							jQuery.removeEvent(dest, e, data.handle); // 5406
						} // 5407
						// 5408
						// Event data gets referenced instead of copied if the expando gets copied too                                     // 5409
						dest.removeAttribute(jQuery.expando); // 5410
					} // 5411
					// 5412
					// IE blanks contents when cloning scripts, and tries to evaluate newly-set text                                    // 5413
					if (nodeName === "script" && dest.text !== src.text) {
						// 5414
						disableScript(dest).text = src.text; // 5415
						restoreScript(dest); // 5416
						// 5417
						// IE6-10 improperly clones children of object elements using classid.                                              // 5418
						// IE10 throws NoModificationAllowedError if parent is null, #12132.                                                // 5419
					} else if (nodeName === "object") {
						// 5420
						if (dest.parentNode) {
							// 5421
							dest.outerHTML = src.outerHTML; // 5422
						} // 5423
						// 5424
						// This path appears unavoidable for IE9. When cloning an object                                                   // 5425
						// element in IE9, the outerHTML strategy above is not sufficient.                                                 // 5426
						// If the src has innerHTML and the destination does not,                                                          // 5427
						// copy the src.innerHTML into the dest.innerHTML. #10324                                                          // 5428
						if (support.html5Clone && src.innerHTML && !jQuery.trim(dest.innerHTML)) {
							// 5429
							dest.innerHTML = src.innerHTML; // 5430
						} // 5431
						// 5432
					} else if (nodeName === "input" && rcheckableType.test(src.type)) {
						// 5433
						// IE6-8 fails to persist the checked state of a cloned checkbox                                                   // 5434
						// or radio button. Worse, IE6-7 fail to give the cloned element                                                   // 5435
						// a checked appearance if the defaultChecked value isn't also set                                                 // 5436
						// 5437
						dest.defaultChecked = dest.checked = src.checked; // 5438
						// 5439
						// IE6-7 get confused and end up setting the value of a cloned                                                     // 5440
						// checkbox/radio button to an empty string instead of "on"                                                        // 5441
						if (dest.value !== src.value) {
							// 5442
							dest.value = src.value; // 5443
						} // 5444
						// 5445
						// IE6-8 fails to return the selected option to the default selected                                                // 5446
						// state when cloning options                                                                                       // 5447
					} else if (nodeName === "option") {
						// 5448
						dest.defaultSelected = dest.selected = src.defaultSelected; // 5449
						// 5450
						// IE6-8 fails to set the defaultValue to the correct value when                                                    // 5451
						// cloning other types of input fields                                                                              // 5452
					} else if (nodeName === "input" || nodeName === "textarea") {
						// 5453
						dest.defaultValue = src.defaultValue; // 5454
					} // 5455
				} // 5456
				// 5457
				jQuery.extend({ // 5458
					clone: function (elem, dataAndEvents, deepDataAndEvents) {
						// 5459
						var destElements,
						    node,
						    clone,
						    i,
						    srcElements,
						    // 5460
						inPage = jQuery.contains(elem.ownerDocument, elem); // 5461
						// 5462
						if (support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">")) {
							// 5463
							clone = elem.cloneNode(true); // 5464
							// 5465
							// IE<=8 does not properly clone detached, unknown element nodes                                                   // 5466
						} else {
							// 5467
							fragmentDiv.innerHTML = elem.outerHTML; // 5468
							fragmentDiv.removeChild(clone = fragmentDiv.firstChild); // 5469
						} // 5470
						// 5471
						if ((!support.noCloneEvent || !support.noCloneChecked) && ( // 5472
						elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
							// 5473
							// 5474
							// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2                            // 5475
							destElements = getAll(clone); // 5476
							srcElements = getAll(elem); // 5477
							// 5478
							// Fix all IE cloning issues                                                                                      // 5479
							for (i = 0; (node = srcElements[i]) != null; ++i) {
								// 5480
								// Ensure that the destination node is not null; Fixes #9587                                                     // 5481
								if (destElements[i]) {
									// 5482
									fixCloneNodeIssues(node, destElements[i]); // 5483
								} // 5484
							} // 5485
						} // 5486
						// 5487
						// Copy the events from the original to the clone                                                                  // 5488
						if (dataAndEvents) {
							// 5489
							if (deepDataAndEvents) {
								// 5490
								srcElements = srcElements || getAll(elem); // 5491
								destElements = destElements || getAll(clone); // 5492
								// 5493
								for (i = 0; (node = srcElements[i]) != null; i++) {
									// 5494
									cloneCopyEvent(node, destElements[i]); // 5495
								} // 5496
							} else {
								// 5497
								cloneCopyEvent(elem, clone); // 5498
							} // 5499
						} // 5500
						// 5501
						// Preserve script evaluation history                                                                              // 5502
						destElements = getAll(clone, "script"); // 5503
						if (destElements.length > 0) {
							// 5504
							setGlobalEval(destElements, !inPage && getAll(elem, "script")); // 5505
						} // 5506
						// 5507
						destElements = srcElements = node = null; // 5508
						// 5509
						// Return the cloned set                                                                                           // 5510
						return clone; // 5511
					}, // 5512
					// 5513
					buildFragment: function (elems, context, scripts, selection) {
						// 5514
						var j,
						    elem,
						    contains,
						    // 5515
						tmp,
						    tag,
						    tbody,
						    wrap,
						    // 5516
						l = elems.length,
						    // 5517
						// 5518
						// Ensure a safe fragment                                                                                         // 5519
						safe = createSafeFragment(context),
						    // 5520
						// 5521
						nodes = [],
						    // 5522
						i = 0; // 5523
						// 5524
						for (; i < l; i++) {
							// 5525
							elem = elems[i]; // 5526
							// 5527
							if (elem || elem === 0) {
								// 5528
								// 5529
								// Add nodes directly                                                                                            // 5530
								if (jQuery.type(elem) === "object") {
									// 5531
									jQuery.merge(nodes, elem.nodeType ? [elem] : elem); // 5532
									// 5533
									// Convert non-html into a text node                                                                             // 5534
								} else if (!rhtml.test(elem)) {
									// 5535
									nodes.push(context.createTextNode(elem)); // 5536
									// 5537
									// Convert html into DOM nodes                                                                                   // 5538
								} else {
									// 5539
									tmp = tmp || safe.appendChild(context.createElement("div")); // 5540
									// 5541
									// Deserialize a standard representation                                                                        // 5542
									tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase(); // 5543
									wrap = wrapMap[tag] || wrapMap._default; // 5544
									// 5545
									tmp.innerHTML = wrap[1] + elem.replace(rxhtmlTag, "<$1></$2>") + wrap[2]; // 5546
									// 5547
									// Descend through wrappers to the right content                                                                // 5548
									j = wrap[0]; // 5549
									while (j--) {
										// 5550
										tmp = tmp.lastChild; // 5551
									} // 5552
									// 5553
									// Manually add leading whitespace removed by IE                                                                // 5554
									if (!support.leadingWhitespace && rleadingWhitespace.test(elem)) {
										// 5555
										nodes.push(context.createTextNode(rleadingWhitespace.exec(elem)[0])); // 5556
									} // 5557
									// 5558
									// Remove IE's autoinserted <tbody> from table fragments                                                        // 5559
									if (!support.tbody) {
										// 5560
										// 5561
										// String was a <table>, *may* have spurious <tbody>                                                           // 5562
										elem = tag === "table" && !rtbody.test(elem) ? // 5563
										tmp.firstChild : // 5564
										// 5565
										// String was a bare <thead> or <tfoot>                                                                       // 5566
										wrap[1] === "<table>" && !rtbody.test(elem) ? // 5567
										tmp : // 5568
										0; // 5569
										// 5570
										j = elem && elem.childNodes.length; // 5571
										while (j--) {
											// 5572
											if (jQuery.nodeName(tbody = elem.childNodes[j], "tbody") && !tbody.childNodes.length) {
												// 5573
												elem.removeChild(tbody); // 5574
											} // 5575
										} // 5576
									} // 5577
									// 5578
									jQuery.merge(nodes, tmp.childNodes); // 5579
									// 5580
									// Fix #12392 for WebKit and IE > 9                                                                             // 5581
									tmp.textContent = ""; // 5582
									// 5583
									// Fix #12392 for oldIE                                                                                         // 5584
									while (tmp.firstChild) {
										// 5585
										tmp.removeChild(tmp.firstChild); // 5586
									} // 5587
									// 5588
									// Remember the top-level container for proper cleanup                                                          // 5589
									tmp = safe.lastChild; // 5590
								} // 5591
							} // 5592
						} // 5593
						// 5594
						// Fix #11356: Clear elements from fragment                                                                        // 5595
						if (tmp) {
							// 5596
							safe.removeChild(tmp); // 5597
						} // 5598
						// 5599
						// Reset defaultChecked for any radios and checkboxes                                                              // 5600
						// about to be appended to the DOM in IE 6/7 (#8060)                                                               // 5601
						if (!support.appendChecked) {
							// 5602
							jQuery.grep(getAll(nodes, "input"), fixDefaultChecked); // 5603
						} // 5604
						// 5605
						i = 0; // 5606
						while (elem = nodes[i++]) {
							// 5607
							// 5608
							// #4087 - If origin and destination elements are the same, and this is                                           // 5609
							// that element, do not do anything                                                                               // 5610
							if (selection && jQuery.inArray(elem, selection) !== -1) {
								// 5611
								continue; // 5612
							} // 5613
							// 5614
							contains = jQuery.contains(elem.ownerDocument, elem); // 5615
							// 5616
							// Append to fragment                                                                                             // 5617
							tmp = getAll(safe.appendChild(elem), "script"); // 5618
							// 5619
							// Preserve script evaluation history                                                                             // 5620
							if (contains) {
								// 5621
								setGlobalEval(tmp); // 5622
							} // 5623
							// 5624
							// Capture executables                                                                                            // 5625
							if (scripts) {
								// 5626
								j = 0; // 5627
								while (elem = tmp[j++]) {
									// 5628
									if (rscriptType.test(elem.type || "")) {
										// 5629
										scripts.push(elem); // 5630
									} // 5631
								} // 5632
							} // 5633
						} // 5634
						// 5635
						tmp = null; // 5636
						// 5637
						return safe; // 5638
					}, // 5639
					// 5640
					cleanData: function (elems, /* internal */acceptData) {
						// 5641
						var elem,
						    type,
						    id,
						    data,
						    // 5642
						i = 0,
						    // 5643
						internalKey = jQuery.expando,
						    // 5644
						cache = jQuery.cache,
						    // 5645
						deleteExpando = support.deleteExpando,
						    // 5646
						special = jQuery.event.special; // 5647
						// 5648
						for (; (elem = elems[i]) != null; i++) {
							// 5649
							if (acceptData || jQuery.acceptData(elem)) {
								// 5650
								// 5651
								id = elem[internalKey]; // 5652
								data = id && cache[id]; // 5653
								// 5654
								if (data) {
									// 5655
									if (data.events) {
										// 5656
										for (type in data.events) {
											// 5657
											if (special[type]) {
												// 5658
												jQuery.event.remove(elem, type); // 5659
												// 5660
												// This is a shortcut to avoid jQuery.event.remove's overhead                                                 // 5661
											} else {
												// 5662
												jQuery.removeEvent(elem, type, data.handle); // 5663
											} // 5664
										} // 5665
									} // 5666
									// 5667
									// Remove cache only if it was not already removed by jQuery.event.remove                                       // 5668
									if (cache[id]) {
										// 5669
										// 5670
										delete cache[id]; // 5671
										// 5672
										// IE does not allow us to delete expando properties from nodes,                                               // 5673
										// nor does it have a removeAttribute function on Document nodes;                                              // 5674
										// we must handle all of these cases                                                                           // 5675
										if (deleteExpando) {
											// 5676
											delete elem[internalKey]; // 5677
											// 5678
										} else if (typeof elem.removeAttribute !== strundefined) {
											// 5679
											elem.removeAttribute(internalKey); // 5680
											// 5681
										} else {
											// 5682
											elem[internalKey] = null; // 5683
										} // 5684
										// 5685
										deletedIds.push(id); // 5686
									} // 5687
								} // 5688
							} // 5689
						} // 5690
					} // 5691
				}); // 5692
				// 5693
				jQuery.fn.extend({ // 5694
					text: function (value) {
						// 5695
						return access(this, function (value) {
							// 5696
							return value === undefined ? // 5697
							jQuery.text(this) : // 5698
							this.empty().append((this[0] && this[0].ownerDocument || document).createTextNode(value)); // 5699
						}, null, value, arguments.length); // 5700
					}, // 5701
					// 5702
					append: function () {
						// 5703
						return this.domManip(arguments, function (elem) {
							// 5704
							if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
								// 5705
								var target = manipulationTarget(this, elem); // 5706
								target.appendChild(elem); // 5707
							} // 5708
						}); // 5709
					}, // 5710
					// 5711
					prepend: function () {
						// 5712
						return this.domManip(arguments, function (elem) {
							// 5713
							if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
								// 5714
								var target = manipulationTarget(this, elem); // 5715
								target.insertBefore(elem, target.firstChild); // 5716
							} // 5717
						}); // 5718
					}, // 5719
					// 5720
					before: function () {
						// 5721
						return this.domManip(arguments, function (elem) {
							// 5722
							if (this.parentNode) {
								// 5723
								this.parentNode.insertBefore(elem, this); // 5724
							} // 5725
						}); // 5726
					}, // 5727
					// 5728
					after: function () {
						// 5729
						return this.domManip(arguments, function (elem) {
							// 5730
							if (this.parentNode) {
								// 5731
								this.parentNode.insertBefore(elem, this.nextSibling); // 5732
							} // 5733
						}); // 5734
					}, // 5735
					// 5736
					remove: function (selector, keepData /* Internal Use Only */) {
						// 5737
						var elem,
						    // 5738
						elems = selector ? jQuery.filter(selector, this) : this,
						    // 5739
						i = 0; // 5740
						// 5741
						for (; (elem = elems[i]) != null; i++) {
							// 5742
							// 5743
							if (!keepData && elem.nodeType === 1) {
								// 5744
								jQuery.cleanData(getAll(elem)); // 5745
							} // 5746
							// 5747
							if (elem.parentNode) {
								// 5748
								if (keepData && jQuery.contains(elem.ownerDocument, elem)) {
									// 5749
									setGlobalEval(getAll(elem, "script")); // 5750
								} // 5751
								elem.parentNode.removeChild(elem); // 5752
							} // 5753
						} // 5754
						// 5755
						return this; // 5756
					}, // 5757
					// 5758
					empty: function () {
						// 5759
						var elem,
						    // 5760
						i = 0; // 5761
						// 5762
						for (; (elem = this[i]) != null; i++) {
							// 5763
							// Remove element nodes and prevent memory leaks                                                                  // 5764
							if (elem.nodeType === 1) {
								// 5765
								jQuery.cleanData(getAll(elem, false)); // 5766
							} // 5767
							// 5768
							// Remove any remaining nodes                                                                                     // 5769
							while (elem.firstChild) {
								// 5770
								elem.removeChild(elem.firstChild); // 5771
							} // 5772
							// 5773
							// If this is a select, ensure that it displays empty (#12336)                                                    // 5774
							// Support: IE<9                                                                                                  // 5775
							if (elem.options && jQuery.nodeName(elem, "select")) {
								// 5776
								elem.options.length = 0; // 5777
							} // 5778
						} // 5779
						// 5780
						return this; // 5781
					}, // 5782
					// 5783
					clone: function (dataAndEvents, deepDataAndEvents) {
						// 5784
						dataAndEvents = dataAndEvents == null ? false : dataAndEvents; // 5785
						deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents; // 5786
						// 5787
						return this.map(function () {
							// 5788
							return jQuery.clone(this, dataAndEvents, deepDataAndEvents); // 5789
						}); // 5790
					}, // 5791
					// 5792
					html: function (value) {
						// 5793
						return access(this, function (value) {
							// 5794
							var elem = this[0] || {},
							    // 5795
							i = 0,
							    // 5796
							l = this.length; // 5797
							// 5798
							if (value === undefined) {
								// 5799
								return elem.nodeType === 1 ? // 5800
								elem.innerHTML.replace(rinlinejQuery, "") : // 5801
								undefined; // 5802
							} // 5803
							// 5804
							// See if we can take a shortcut and just use innerHTML                                                           // 5805
							if (typeof value === "string" && !rnoInnerhtml.test(value) && ( // 5806
							support.htmlSerialize || !rnoshimcache.test(value)) && ( // 5807
							support.leadingWhitespace || !rleadingWhitespace.test(value)) && // 5808
							!wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
								// 5809
								// 5810
								value = value.replace(rxhtmlTag, "<$1></$2>"); // 5811
								// 5812
								try {
									// 5813
									for (; i < l; i++) {
										// 5814
										// Remove element nodes and prevent memory leaks                                                               // 5815
										elem = this[i] || {}; // 5816
										if (elem.nodeType === 1) {
											// 5817
											jQuery.cleanData(getAll(elem, false)); // 5818
											elem.innerHTML = value; // 5819
										} // 5820
									} // 5821
									// 5822
									elem = 0; // 5823
									// 5824
									// If using innerHTML throws an exception, use the fallback method                                               // 5825
								} catch (e) {} // 5826
							} // 5827
							// 5828
							if (elem) {
								// 5829
								this.empty().append(value); // 5830
							} // 5831
						}, null, value, arguments.length); // 5832
					}, // 5833
					// 5834
					replaceWith: function () {
						// 5835
						var arg = arguments[0]; // 5836
						// 5837
						// Make the changes, replacing each context element with the new content                                           // 5838
						this.domManip(arguments, function (elem) {
							// 5839
							arg = this.parentNode; // 5840
							// 5841
							jQuery.cleanData(getAll(this)); // 5842
							// 5843
							if (arg) {
								// 5844
								arg.replaceChild(elem, this); // 5845
							} // 5846
						}); // 5847
						// 5848
						// Force removal if there was no new content (e.g., from empty arguments)                                          // 5849
						return arg && (arg.length || arg.nodeType) ? this : this.remove(); // 5850
					}, // 5851
					// 5852
					detach: function (selector) {
						// 5853
						return this.remove(selector, true); // 5854
					}, // 5855
					// 5856
					domManip: function (args, callback) {
						// 5857
						// 5858
						// Flatten any nested arrays                                                                                       // 5859
						args = concat.apply([], args); // 5860
						// 5861
						var first,
						    node,
						    hasScripts,
						    // 5862
						scripts,
						    doc,
						    fragment,
						    // 5863
						i = 0,
						    // 5864
						l = this.length,
						    // 5865
						set = this,
						    // 5866
						iNoClone = l - 1,
						    // 5867
						value = args[0],
						    // 5868
						isFunction = jQuery.isFunction(value); // 5869
						// 5870
						// We can't cloneNode fragments that contain checked, in WebKit                                                    // 5871
						if (isFunction || // 5872
						l > 1 && typeof value === "string" && // 5873
						!support.checkClone && rchecked.test(value)) {
							// 5874
							return this.each(function (index) {
								// 5875
								var self = set.eq(index); // 5876
								if (isFunction) {
									// 5877
									args[0] = value.call(this, index, self.html()); // 5878
								} // 5879
								self.domManip(args, callback); // 5880
							}); // 5881
						} // 5882
						// 5883
						if (l) {
							// 5884
							fragment = jQuery.buildFragment(args, this[0].ownerDocument, false, this); // 5885
							first = fragment.firstChild; // 5886
							// 5887
							if (fragment.childNodes.length === 1) {
								// 5888
								fragment = first; // 5889
							} // 5890
							// 5891
							if (first) {
								// 5892
								scripts = jQuery.map(getAll(fragment, "script"), disableScript); // 5893
								hasScripts = scripts.length; // 5894
								// 5895
								// Use the original fragment for the last item instead of the first because it can end up                        // 5896
								// being emptied incorrectly in certain situations (#8070).                                                      // 5897
								for (; i < l; i++) {
									// 5898
									node = fragment; // 5899
									// 5900
									if (i !== iNoClone) {
										// 5901
										node = jQuery.clone(node, true, true); // 5902
										// 5903
										// Keep references to cloned scripts for later restoration                                                     // 5904
										if (hasScripts) {
											// 5905
											jQuery.merge(scripts, getAll(node, "script")); // 5906
										} // 5907
									} // 5908
									// 5909
									callback.call(this[i], node, i); // 5910
								} // 5911
								// 5912
								if (hasScripts) {
									// 5913
									doc = scripts[scripts.length - 1].ownerDocument; // 5914
									// 5915
									// Reenable scripts                                                                                             // 5916
									jQuery.map(scripts, restoreScript); // 5917
									// 5918
									// Evaluate executable scripts on first document insertion                                                      // 5919
									for (i = 0; i < hasScripts; i++) {
										// 5920
										node = scripts[i]; // 5921
										if (rscriptType.test(node.type || "") && // 5922
										!jQuery._data(node, "globalEval") && jQuery.contains(doc, node)) {
											// 5923
											// 5924
											if (node.src) {
												// 5925
												// Optional AJAX dependency, but won't run scripts if not present                                            // 5926
												if (jQuery._evalUrl) {
													// 5927
													jQuery._evalUrl(node.src); // 5928
												} // 5929
											} else {
												// 5930
												jQuery.globalEval((node.text || node.textContent || node.innerHTML || "").replace(rcleanScript, "")); // 5931
											} // 5932
										} // 5933
									} // 5934
								} // 5935
								// 5936
								// Fix #11809: Avoid leaking memory                                                                              // 5937
								fragment = first = null; // 5938
							} // 5939
						} // 5940
						// 5941
						return this; // 5942
					} // 5943
				}); // 5944
				// 5945
				jQuery.each({ // 5946
					appendTo: "append", // 5947
					prependTo: "prepend", // 5948
					insertBefore: "before", // 5949
					insertAfter: "after", // 5950
					replaceAll: "replaceWith" // 5951
				}, function (name, original) {
					// 5952
					jQuery.fn[name] = function (selector) {
						// 5953
						var elems,
						    // 5954
						i = 0,
						    // 5955
						ret = [],
						    // 5956
						insert = jQuery(selector),
						    // 5957
						last = insert.length - 1; // 5958
						// 5959
						for (; i <= last; i++) {
							// 5960
							elems = i === last ? this : this.clone(true); // 5961
							jQuery(insert[i])[original](elems); // 5962
							// 5963
							// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()                               // 5964
							push.apply(ret, elems.get()); // 5965
						} // 5966
						// 5967
						return this.pushStack(ret); // 5968
					}; // 5969
				}); // 5970
				// 5971
				// 5972
				var iframe,
				    // 5973
				elemdisplay = {}; // 5974
				// 5975
				/**                                                                                                                  // 5976
     * Retrieve the actual display of a element                                                                          // 5977
     * @param {String} name nodeName of the element                                                                      // 5978
     * @param {Object} doc Document object                                                                               // 5979
     */ // 5980
				// Called only from within defaultDisplay                                                                            // 5981
				function actualDisplay(name, doc) {
					// 5982
					var elem = jQuery(doc.createElement(name)).appendTo(doc.body),
					    // 5983
					// 5984
					// getDefaultComputedStyle might be reliably used only on attached element                                         // 5985
					display = window.getDefaultComputedStyle ? // 5986
					// 5987
					// Use of this method is a temporary fix (more like optmization) until something better comes along,              // 5988
					// since it was removed from specification and supported only in FF                                               // 5989
					window.getDefaultComputedStyle(elem[0]).display : jQuery.css(elem[0], "display"); // 5990
					// 5991
					// We don't have any data stored on the element,                                                                    // 5992
					// so use "detach" method as fast way to get rid of the element                                                     // 5993
					elem.detach(); // 5994
					// 5995
					return display; // 5996
				} // 5997
				// 5998
				/**                                                                                                                  // 5999
     * Try to determine the default display value of an element                                                          // 6000
     * @param {String} nodeName                                                                                          // 6001
     */ // 6002
				function defaultDisplay(nodeName) {
					// 6003
					var doc = document,
					    // 6004
					display = elemdisplay[nodeName]; // 6005
					// 6006
					if (!display) {
						// 6007
						display = actualDisplay(nodeName, doc); // 6008
						// 6009
						// If the simple way fails, read from inside an iframe                                                             // 6010
						if (display === "none" || !display) {
							// 6011
							// 6012
							// Use the already-created iframe if possible                                                                     // 6013
							iframe = (iframe || jQuery("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement); // 6014
							// 6015
							// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse                                    // 6016
							doc = (iframe[0].contentWindow || iframe[0].contentDocument).document; // 6017
							// 6018
							// Support: IE                                                                                                    // 6019
							doc.write(); // 6020
							doc.close(); // 6021
							// 6022
							display = actualDisplay(nodeName, doc); // 6023
							iframe.detach(); // 6024
						} // 6025
						// 6026
						// Store the correct default display                                                                               // 6027
						elemdisplay[nodeName] = display; // 6028
					} // 6029
					// 6030
					return display; // 6031
				} // 6032
				// 6033
				// 6034
				(function () {
					// 6035
					var a,
					    shrinkWrapBlocksVal,
					    // 6036
					div = document.createElement("div"),
					    // 6037
					divReset = // 6038
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;" + // 6039
					"display:block;padding:0;margin:0;border:0"; // 6040
					// 6041
					// Setup                                                                                                            // 6042
					div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"; // 6043
					a = div.getElementsByTagName("a")[0]; // 6044
					// 6045
					a.style.cssText = "float:left;opacity:.5"; // 6046
					// 6047
					// Make sure that element opacity exists                                                                            // 6048
					// (IE uses filter instead)                                                                                         // 6049
					// Use a regex to work around a WebKit issue. See #5145                                                             // 6050
					support.opacity = /^0.5/.test(a.style.opacity); // 6051
					// 6052
					// Verify style float existence                                                                                     // 6053
					// (IE uses styleFloat instead of cssFloat)                                                                         // 6054
					support.cssFloat = !!a.style.cssFloat; // 6055
					// 6056
					div.style.backgroundClip = "content-box"; // 6057
					div.cloneNode(true).style.backgroundClip = ""; // 6058
					support.clearCloneStyle = div.style.backgroundClip === "content-box"; // 6059
					// 6060
					// Null elements to avoid leaks in IE.                                                                              // 6061
					a = div = null; // 6062
					// 6063
					support.shrinkWrapBlocks = function () {
						// 6064
						var body, container, div, containerStyles; // 6065
						// 6066
						if (shrinkWrapBlocksVal == null) {
							// 6067
							body = document.getElementsByTagName("body")[0]; // 6068
							if (!body) {
								// 6069
								// Test fired too early or in an unsupported environment, exit.                                                  // 6070
								return; // 6071
							} // 6072
							// 6073
							containerStyles = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px"; // 6074
							container = document.createElement("div"); // 6075
							div = document.createElement("div"); // 6076
							// 6077
							body.appendChild(container).appendChild(div); // 6078
							// 6079
							// Will be changed later if needed.                                                                               // 6080
							shrinkWrapBlocksVal = false; // 6081
							// 6082
							if (typeof div.style.zoom !== strundefined) {
								// 6083
								// Support: IE6                                                                                                  // 6084
								// Check if elements with layout shrink-wrap their children                                                      // 6085
								div.style.cssText = divReset + ";width:1px;padding:1px;zoom:1"; // 6086
								div.innerHTML = "<div></div>"; // 6087
								div.firstChild.style.width = "5px"; // 6088
								shrinkWrapBlocksVal = div.offsetWidth !== 3; // 6089
							} // 6090
							// 6091
							body.removeChild(container); // 6092
							// 6093
							// Null elements to avoid leaks in IE.                                                                            // 6094
							body = container = div = null; // 6095
						} // 6096
						// 6097
						return shrinkWrapBlocksVal; // 6098
					}; // 6099
					// 6100
				})(); // 6101
				var rmargin = /^margin/; // 6102
				// 6103
				var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i"); // 6104
				// 6105
				// 6106
				// 6107
				var getStyles,
				    curCSS,
				    // 6108
				rposition = /^(top|right|bottom|left)$/; // 6109
				// 6110
				if (window.getComputedStyle) {
					// 6111
					getStyles = function (elem) {
						// 6112
						return elem.ownerDocument.defaultView.getComputedStyle(elem, null); // 6113
					}; // 6114
					// 6115
					curCSS = function (elem, name, computed) {
						// 6116
						var width,
						    minWidth,
						    maxWidth,
						    ret,
						    // 6117
						style = elem.style; // 6118
						// 6119
						computed = computed || getStyles(elem); // 6120
						// 6121
						// getPropertyValue is only needed for .css('filter') in IE9, see #12537                                           // 6122
						ret = computed ? computed.getPropertyValue(name) || computed[name] : undefined; // 6123
						// 6124
						if (computed) {
							// 6125
							// 6126
							if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
								// 6127
								ret = jQuery.style(elem, name); // 6128
							} // 6129
							// 6130
							// A tribute to the "awesome hack by Dean Edwards"                                                                // 6131
							// Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right                      // 6132
							// Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels   // 6133
							// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values                           // 6134
							if (rnumnonpx.test(ret) && rmargin.test(name)) {
								// 6135
								// 6136
								// Remember the original values                                                                                  // 6137
								width = style.width; // 6138
								minWidth = style.minWidth; // 6139
								maxWidth = style.maxWidth; // 6140
								// 6141
								// Put in the new values to get a computed value out                                                             // 6142
								style.minWidth = style.maxWidth = style.width = ret; // 6143
								ret = computed.width; // 6144
								// 6145
								// Revert the changed values                                                                                     // 6146
								style.width = width; // 6147
								style.minWidth = minWidth; // 6148
								style.maxWidth = maxWidth; // 6149
							} // 6150
						} // 6151
						// 6152
						// Support: IE                                                                                                     // 6153
						// IE returns zIndex value as an integer.                                                                          // 6154
						return ret === undefined ? // 6155
						ret : // 6156
						ret + ""; // 6157
					}; // 6158
				} else if (document.documentElement.currentStyle) {
					// 6159
					getStyles = function (elem) {
						// 6160
						return elem.currentStyle; // 6161
					}; // 6162
					// 6163
					curCSS = function (elem, name, computed) {
						// 6164
						var left,
						    rs,
						    rsLeft,
						    ret,
						    // 6165
						style = elem.style; // 6166
						// 6167
						computed = computed || getStyles(elem); // 6168
						ret = computed ? computed[name] : undefined; // 6169
						// 6170
						// Avoid setting ret to empty string here                                                                          // 6171
						// so we don't default to auto                                                                                     // 6172
						if (ret == null && style && style[name]) {
							// 6173
							ret = style[name]; // 6174
						} // 6175
						// 6176
						// From the awesome hack by Dean Edwards                                                                           // 6177
						// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291                                                // 6178
						// 6179
						// If we're not dealing with a regular pixel number                                                                // 6180
						// but a number that has a weird ending, we need to convert it to pixels                                           // 6181
						// but not position css attributes, as those are proportional to the parent element instead                        // 6182
						// and we can't measure the parent instead because it might trigger a "stacking dolls" problem                     // 6183
						if (rnumnonpx.test(ret) && !rposition.test(name)) {
							// 6184
							// 6185
							// Remember the original values                                                                                   // 6186
							left = style.left; // 6187
							rs = elem.runtimeStyle; // 6188
							rsLeft = rs && rs.left; // 6189
							// 6190
							// Put in the new values to get a computed value out                                                              // 6191
							if (rsLeft) {
								// 6192
								rs.left = elem.currentStyle.left; // 6193
							} // 6194
							style.left = name === "fontSize" ? "1em" : ret; // 6195
							ret = style.pixelLeft + "px"; // 6196
							// 6197
							// Revert the changed values                                                                                      // 6198
							style.left = left; // 6199
							if (rsLeft) {
								// 6200
								rs.left = rsLeft; // 6201
							} // 6202
						} // 6203
						// 6204
						// Support: IE                                                                                                     // 6205
						// IE returns zIndex value as an integer.                                                                          // 6206
						return ret === undefined ? // 6207
						ret : // 6208
						ret + "" || "auto"; // 6209
					}; // 6210
				} // 6211
				// 6212
				// 6213
				// 6214
				// 6215
				function addGetHookIf(conditionFn, hookFn) {
					// 6216
					// Define the hook, we'll check on the first run if it's really needed.                                             // 6217
					return { // 6218
						get: function () {
							// 6219
							var condition = conditionFn(); // 6220
							// 6221
							if (condition == null) {
								// 6222
								// The test was not ready at this point; screw the hook this time                                                // 6223
								// but check again when needed next time.                                                                        // 6224
								return; // 6225
							} // 6226
							// 6227
							if (condition) {
								// 6228
								// Hook not needed (or it's not possible to use it due to missing dependency),                                   // 6229
								// remove it.                                                                                                    // 6230
								// Since there are no other hooks for marginRight, remove the whole object.                                      // 6231
								delete this.get; // 6232
								return; // 6233
							} // 6234
							// 6235
							// Hook needed; redefine it so that the support test is not executed again.                                       // 6236
							// 6237
							return (this.get = hookFn).apply(this, arguments); // 6238
						} // 6239
					}; // 6240
				} // 6241
				// 6242
				// 6243
				(function () {
					// 6244
					var a,
					    reliableHiddenOffsetsVal,
					    boxSizingVal,
					    boxSizingReliableVal,
					    // 6245
					pixelPositionVal,
					    reliableMarginRightVal,
					    // 6246
					div = document.createElement("div"),
					    // 6247
					containerStyles = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px",
					    // 6248
					divReset = // 6249
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;" + // 6250
					"display:block;padding:0;margin:0;border:0"; // 6251
					// 6252
					// Setup                                                                                                            // 6253
					div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"; // 6254
					a = div.getElementsByTagName("a")[0]; // 6255
					// 6256
					a.style.cssText = "float:left;opacity:.5"; // 6257
					// 6258
					// Make sure that element opacity exists                                                                            // 6259
					// (IE uses filter instead)                                                                                         // 6260
					// Use a regex to work around a WebKit issue. See #5145                                                             // 6261
					support.opacity = /^0.5/.test(a.style.opacity); // 6262
					// 6263
					// Verify style float existence                                                                                     // 6264
					// (IE uses styleFloat instead of cssFloat)                                                                         // 6265
					support.cssFloat = !!a.style.cssFloat; // 6266
					// 6267
					div.style.backgroundClip = "content-box"; // 6268
					div.cloneNode(true).style.backgroundClip = ""; // 6269
					support.clearCloneStyle = div.style.backgroundClip === "content-box"; // 6270
					// 6271
					// Null elements to avoid leaks in IE.                                                                              // 6272
					a = div = null; // 6273
					// 6274
					jQuery.extend(support, { // 6275
						reliableHiddenOffsets: function () {
							// 6276
							if (reliableHiddenOffsetsVal != null) {
								// 6277
								return reliableHiddenOffsetsVal; // 6278
							} // 6279
							// 6280
							var container,
							    tds,
							    isSupported,
							    // 6281
							div = document.createElement("div"),
							    // 6282
							body = document.getElementsByTagName("body")[0]; // 6283
							// 6284
							if (!body) {
								// 6285
								// Return for frameset docs that don't have a body                                                               // 6286
								return; // 6287
							} // 6288
							// 6289
							// Setup                                                                                                          // 6290
							div.setAttribute("className", "t"); // 6291
							div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"; // 6292
							// 6293
							container = document.createElement("div"); // 6294
							container.style.cssText = containerStyles; // 6295
							// 6296
							body.appendChild(container).appendChild(div); // 6297
							// 6298
							// Support: IE8                                                                                                   // 6299
							// Check if table cells still have offsetWidth/Height when they are set                                           // 6300
							// to display:none and there are still other visible table cells in a                                             // 6301
							// table row; if so, offsetWidth/Height are not reliable for use when                                             // 6302
							// determining if an element has been hidden directly using                                                       // 6303
							// display:none (it is still safe to use offsets if a parent element is                                           // 6304
							// hidden; don safety goggles and see bug #4512 for more information).                                            // 6305
							div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"; // 6306
							tds = div.getElementsByTagName("td"); // 6307
							tds[0].style.cssText = "padding:0;margin:0;border:0;display:none"; // 6308
							isSupported = tds[0].offsetHeight === 0; // 6309
							// 6310
							tds[0].style.display = ""; // 6311
							tds[1].style.display = "none"; // 6312
							// 6313
							// Support: IE8                                                                                                   // 6314
							// Check if empty table cells still have offsetWidth/Height                                                       // 6315
							reliableHiddenOffsetsVal = isSupported && tds[0].offsetHeight === 0; // 6316
							// 6317
							body.removeChild(container); // 6318
							// 6319
							// Null elements to avoid leaks in IE.                                                                            // 6320
							div = body = null; // 6321
							// 6322
							return reliableHiddenOffsetsVal; // 6323
						}, // 6324
						// 6325
						boxSizing: function () {
							// 6326
							if (boxSizingVal == null) {
								// 6327
								computeStyleTests(); // 6328
							} // 6329
							return boxSizingVal; // 6330
						}, // 6331
						// 6332
						boxSizingReliable: function () {
							// 6333
							if (boxSizingReliableVal == null) {
								// 6334
								computeStyleTests(); // 6335
							} // 6336
							return boxSizingReliableVal; // 6337
						}, // 6338
						// 6339
						pixelPosition: function () {
							// 6340
							if (pixelPositionVal == null) {
								// 6341
								computeStyleTests(); // 6342
							} // 6343
							return pixelPositionVal; // 6344
						}, // 6345
						// 6346
						reliableMarginRight: function () {
							// 6347
							var body, container, div, marginDiv; // 6348
							// 6349
							// Use window.getComputedStyle because jsdom on node.js will break without it.                                    // 6350
							if (reliableMarginRightVal == null && window.getComputedStyle) {
								// 6351
								body = document.getElementsByTagName("body")[0]; // 6352
								if (!body) {
									// 6353
									// Test fired too early or in an unsupported environment, exit.                                                 // 6354
									return; // 6355
								} // 6356
								// 6357
								container = document.createElement("div"); // 6358
								div = document.createElement("div"); // 6359
								container.style.cssText = containerStyles; // 6360
								// 6361
								body.appendChild(container).appendChild(div); // 6362
								// 6363
								// Check if div with explicit width and no margin-right incorrectly                                              // 6364
								// gets computed margin-right based on width of container. (#3333)                                               // 6365
								// Fails in WebKit before Feb 2011 nightlies                                                                     // 6366
								// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right                                      // 6367
								marginDiv = div.appendChild(document.createElement("div")); // 6368
								marginDiv.style.cssText = div.style.cssText = divReset; // 6369
								marginDiv.style.marginRight = marginDiv.style.width = "0"; // 6370
								div.style.width = "1px"; // 6371
								// 6372
								reliableMarginRightVal = // 6373
								!parseFloat((window.getComputedStyle(marginDiv, null) || {}).marginRight); // 6374
								// 6375
								body.removeChild(container); // 6376
							} // 6377
							// 6378
							return reliableMarginRightVal; // 6379
						} // 6380
					}); // 6381
					// 6382
					function computeStyleTests() {
						// 6383
						var container,
						    div,
						    // 6384
						body = document.getElementsByTagName("body")[0]; // 6385
						// 6386
						if (!body) {
							// 6387
							// Test fired too early or in an unsupported environment, exit.                                                   // 6388
							return; // 6389
						} // 6390
						// 6391
						container = document.createElement("div"); // 6392
						div = document.createElement("div"); // 6393
						container.style.cssText = containerStyles; // 6394
						// 6395
						body.appendChild(container).appendChild(div); // 6396
						// 6397
						div.style.cssText = // 6398
						"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" + // 6399
						"position:absolute;display:block;padding:1px;border:1px;width:4px;" + // 6400
						"margin-top:1%;top:1%"; // 6401
						// 6402
						// Workaround failing boxSizing test due to offsetWidth returning wrong value                                      // 6403
						// with some non-1 values of body zoom, ticket #13543                                                              // 6404
						jQuery.swap(body, body.style.zoom != null ? { zoom: 1 } : {}, function () {
							// 6405
							boxSizingVal = div.offsetWidth === 4; // 6406
						}); // 6407
						// 6408
						// Will be changed later if needed.                                                                                // 6409
						boxSizingReliableVal = true; // 6410
						pixelPositionVal = false; // 6411
						reliableMarginRightVal = true; // 6412
						// 6413
						// Use window.getComputedStyle because jsdom on node.js will break without it.                                     // 6414
						if (window.getComputedStyle) {
							// 6415
							pixelPositionVal = (window.getComputedStyle(div, null) || {}).top !== "1%"; // 6416
							boxSizingReliableVal = // 6417
							(window.getComputedStyle(div, null) || { width: "4px" }).width === "4px"; // 6418
						} // 6419
						// 6420
						body.removeChild(container); // 6421
						// 6422
						// Null elements to avoid leaks in IE.                                                                             // 6423
						div = body = null; // 6424
					} // 6425
					// 6426
				})(); // 6427
				// 6428
				// 6429
				// A method for quickly swapping in/out CSS properties to get correct calculations.                                  // 6430
				jQuery.swap = function (elem, options, callback, args) {
					// 6431
					var ret,
					    name,
					    // 6432
					old = {}; // 6433
					// 6434
					// Remember the old values, and insert the new ones                                                                 // 6435
					for (name in options) {
						// 6436
						old[name] = elem.style[name]; // 6437
						elem.style[name] = options[name]; // 6438
					} // 6439
					// 6440
					ret = callback.apply(elem, args || []); // 6441
					// 6442
					// Revert the old values                                                                                            // 6443
					for (name in options) {
						// 6444
						elem.style[name] = old[name]; // 6445
					} // 6446
					// 6447
					return ret; // 6448
				}; // 6449
				// 6450
				// 6451
				var // 6452
				ralpha = /alpha\([^)]*\)/i,
				    // 6453
				ropacity = /opacity\s*=\s*([^)]*)/,
				    // 6454
				// 6455
				// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"               // 6456
				// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display                                // 6457
				rdisplayswap = /^(none|table(?!-c[ea]).+)/,
				    // 6458
				rnumsplit = new RegExp("^(" + pnum + ")(.*)$", "i"),
				    // 6459
				rrelNum = new RegExp("^([+-])=(" + pnum + ")", "i"),
				    // 6460
				// 6461
				cssShow = { position: "absolute", visibility: "hidden", display: "block" },
				    // 6462
				cssNormalTransform = { // 6463
					letterSpacing: 0, // 6464
					fontWeight: 400 // 6465
				},
				    // 6466
				// 6467
				cssPrefixes = ["Webkit", "O", "Moz", "ms"]; // 6468
				// 6469
				// 6470
				// return a css property mapped to a potentially vendor prefixed property                                            // 6471
				function vendorPropName(style, name) {
					// 6472
					// 6473
					// shortcut for names that are not vendor prefixed                                                                  // 6474
					if (name in style) {
						// 6475
						return name; // 6476
					} // 6477
					// 6478
					// check for vendor prefixed names                                                                                  // 6479
					var capName = name.charAt(0).toUpperCase() + name.slice(1),
					    // 6480
					origName = name,
					    // 6481
					i = cssPrefixes.length; // 6482
					// 6483
					while (i--) {
						// 6484
						name = cssPrefixes[i] + capName; // 6485
						if (name in style) {
							// 6486
							return name; // 6487
						} // 6488
					} // 6489
					// 6490
					return origName; // 6491
				} // 6492
				// 6493
				function showHide(elements, show) {
					// 6494
					var display,
					    elem,
					    hidden,
					    // 6495
					values = [],
					    // 6496
					index = 0,
					    // 6497
					length = elements.length; // 6498
					// 6499
					for (; index < length; index++) {
						// 6500
						elem = elements[index]; // 6501
						if (!elem.style) {
							// 6502
							continue; // 6503
						} // 6504
						// 6505
						values[index] = jQuery._data(elem, "olddisplay"); // 6506
						display = elem.style.display; // 6507
						if (show) {
							// 6508
							// Reset the inline display of this element to learn if it is                                                     // 6509
							// being hidden by cascaded rules or not                                                                          // 6510
							if (!values[index] && display === "none") {
								// 6511
								elem.style.display = ""; // 6512
							} // 6513
							// 6514
							// Set elements which have been overridden with display: none                                                     // 6515
							// in a stylesheet to whatever the default browser style is                                                       // 6516
							// for such an element                                                                                            // 6517
							if (elem.style.display === "" && isHidden(elem)) {
								// 6518
								values[index] = jQuery._data(elem, "olddisplay", defaultDisplay(elem.nodeName)); // 6519
							} // 6520
						} else {
							// 6521
							// 6522
							if (!values[index]) {
								// 6523
								hidden = isHidden(elem); // 6524
								// 6525
								if (display && display !== "none" || !hidden) {
									// 6526
									jQuery._data(elem, "olddisplay", hidden ? display : jQuery.css(elem, "display")); // 6527
								} // 6528
							} // 6529
						} // 6530
					} // 6531
					// 6532
					// Set the display of most of the elements in a second loop                                                         // 6533
					// to avoid the constant reflow                                                                                     // 6534
					for (index = 0; index < length; index++) {
						// 6535
						elem = elements[index]; // 6536
						if (!elem.style) {
							// 6537
							continue; // 6538
						} // 6539
						if (!show || elem.style.display === "none" || elem.style.display === "") {
							// 6540
							elem.style.display = show ? values[index] || "" : "none"; // 6541
						} // 6542
					} // 6543
					// 6544
					return elements; // 6545
				} // 6546
				// 6547
				function setPositiveNumber(elem, value, subtract) {
					// 6548
					var matches = rnumsplit.exec(value); // 6549
					return matches ? // 6550
					// Guard against undefined "subtract", e.g., when used as in cssHooks                                              // 6551
					Math.max(0, matches[1] - (subtract || 0)) + (matches[2] || "px") : // 6552
					value; // 6553
				} // 6554
				// 6555
				function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
					// 6556
					var i = extra === (isBorderBox ? "border" : "content") ? // 6557
					// If we already have the right measurement, avoid augmentation                                                    // 6558
					4 : // 6559
					// Otherwise initialize for horizontal or vertical properties                                                      // 6560
					name === "width" ? 1 : 0,
					    // 6561
					// 6562
					val = 0; // 6563
					// 6564
					for (; i < 4; i += 2) {
						// 6565
						// both box models exclude margin, so add it if we want it                                                         // 6566
						if (extra === "margin") {
							// 6567
							val += jQuery.css(elem, extra + cssExpand[i], true, styles); // 6568
						} // 6569
						// 6570
						if (isBorderBox) {
							// 6571
							// border-box includes padding, so remove it if we want content                                                   // 6572
							if (extra === "content") {
								// 6573
								val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles); // 6574
							} // 6575
							// 6576
							// at this point, extra isn't border nor margin, so remove border                                                 // 6577
							if (extra !== "margin") {
								// 6578
								val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles); // 6579
							} // 6580
						} else {
							// 6581
							// at this point, extra isn't content, so add padding                                                             // 6582
							val += jQuery.css(elem, "padding" + cssExpand[i], true, styles); // 6583
							// 6584
							// at this point, extra isn't content nor padding, so add border                                                  // 6585
							if (extra !== "padding") {
								// 6586
								val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles); // 6587
							} // 6588
						} // 6589
					} // 6590
					// 6591
					return val; // 6592
				} // 6593
				// 6594
				function getWidthOrHeight(elem, name, extra) {
					// 6595
					// 6596
					// Start with offset property, which is equivalent to the border-box value                                          // 6597
					var valueIsBorderBox = true,
					    // 6598
					val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
					    // 6599
					styles = getStyles(elem),
					    // 6600
					isBorderBox = support.boxSizing() && jQuery.css(elem, "boxSizing", false, styles) === "border-box"; // 6601
					// 6602
					// some non-html elements return undefined for offsetWidth, so check for null/undefined                             // 6603
					// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285                                                        // 6604
					// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668                                                     // 6605
					if (val <= 0 || val == null) {
						// 6606
						// Fall back to computed then uncomputed css if necessary                                                          // 6607
						val = curCSS(elem, name, styles); // 6608
						if (val < 0 || val == null) {
							// 6609
							val = elem.style[name]; // 6610
						} // 6611
						// 6612
						// Computed unit is not pixels. Stop here and return.                                                              // 6613
						if (rnumnonpx.test(val)) {
							// 6614
							return val; // 6615
						} // 6616
						// 6617
						// we need the check for style in case a browser which returns unreliable values                                   // 6618
						// for getComputedStyle silently falls back to the reliable elem.style                                             // 6619
						valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]); // 6620
						// 6621
						// Normalize "", auto, and prepare for extra                                                                       // 6622
						val = parseFloat(val) || 0; // 6623
					} // 6624
					// 6625
					// use the active box-sizing model to add/subtract irrelevant styles                                                // 6626
					return val + // 6627
					augmentWidthOrHeight( // 6628
					elem, // 6629
					name, // 6630
					extra || (isBorderBox ? "border" : "content"), // 6631
					valueIsBorderBox, // 6632
					styles // 6633
					) // 6634
					+ "px"; // 6635
				} // 6636
				// 6637
				jQuery.extend({ // 6638
					// Add in style property hooks for overriding the default                                                           // 6639
					// behavior of getting and setting a style property                                                                 // 6640
					cssHooks: { // 6641
						opacity: { // 6642
							get: function (elem, computed) {
								// 6643
								if (computed) {
									// 6644
									// We should always get a number back from opacity                                                              // 6645
									var ret = curCSS(elem, "opacity"); // 6646
									return ret === "" ? "1" : ret; // 6647
								} // 6648
							} // 6649
							// 6650
						} }, // 6651
					// 6652
					// Don't automatically add "px" to these possibly-unitless properties                                               // 6653
					cssNumber: { // 6654
						"columnCount": true, // 6655
						"fillOpacity": true, // 6656
						"fontWeight": true, // 6657
						"lineHeight": true, // 6658
						"opacity": true, // 6659
						"order": true, // 6660
						"orphans": true, // 6661
						"widows": true, // 6662
						"zIndex": true, // 6663
						"zoom": true // 6664
					}, // 6665
					// 6666
					// Add in properties whose names you wish to fix before                                                             // 6667
					// setting or getting the value                                                                                     // 6668
					cssProps: { // 6669
						// normalize float css property                                                                                    // 6670
						"float": support.cssFloat ? "cssFloat" : "styleFloat" // 6671
					}, // 6672
					// 6673
					// Get and set the style property on a DOM Node                                                                     // 6674
					style: function (elem, name, value, extra) {
						// 6675
						// Don't set styles on text and comment nodes                                                                      // 6676
						if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
							// 6677
							return; // 6678
						} // 6679
						// 6680
						// Make sure that we're working with the right name                                                                // 6681
						var ret,
						    type,
						    hooks,
						    // 6682
						origName = jQuery.camelCase(name),
						    // 6683
						style = elem.style; // 6684
						// 6685
						name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(style, origName)); // 6686
						// 6687
						// gets hook for the prefixed version                                                                              // 6688
						// followed by the unprefixed version                                                                              // 6689
						hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // 6690
						// 6691
						// Check if we're setting a value                                                                                  // 6692
						if (value !== undefined) {
							// 6693
							type = typeof value; // 6694
							// 6695
							// convert relative number strings (+= or -=) to relative numbers. #7345                                          // 6696
							if (type === "string" && (ret = rrelNum.exec(value))) {
								// 6697
								value = (ret[1] + 1) * ret[2] + parseFloat(jQuery.css(elem, name)); // 6698
								// Fixes bug #9237                                                                                               // 6699
								type = "number"; // 6700
							} // 6701
							// 6702
							// Make sure that null and NaN values aren't set. See: #7116                                                      // 6703
							if (value == null || value !== value) {
								// 6704
								return; // 6705
							} // 6706
							// 6707
							// If a number was passed in, add 'px' to the (except for certain CSS properties)                                 // 6708
							if (type === "number" && !jQuery.cssNumber[origName]) {
								// 6709
								value += "px"; // 6710
							} // 6711
							// 6712
							// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,                                   // 6713
							// but it would mean to define eight (for every problematic property) identical functions                         // 6714
							if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
								// 6715
								style[name] = "inherit"; // 6716
							} // 6717
							// 6718
							// If a hook was provided, use that value, otherwise just set the specified value                                 // 6719
							if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
								// 6720
								// 6721
								// Support: IE                                                                                                   // 6722
								// Swallow errors from 'invalid' CSS values (#5509)                                                              // 6723
								try {
									// 6724
									// Support: Chrome, Safari                                                                                      // 6725
									// Setting style to blank string required to delete "style: x !important;"                                      // 6726
									style[name] = ""; // 6727
									style[name] = value; // 6728
								} catch (e) {} // 6729
							} // 6730
							// 6731
						} else {
							// 6732
							// If a hook was provided get the non-computed value from there                                                   // 6733
							if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
								// 6734
								return ret; // 6735
							} // 6736
							// 6737
							// Otherwise just get the value from the style object                                                             // 6738
							return style[name]; // 6739
						} // 6740
					}, // 6741
					// 6742
					css: function (elem, name, extra, styles) {
						// 6743
						var num,
						    val,
						    hooks,
						    // 6744
						origName = jQuery.camelCase(name); // 6745
						// 6746
						// Make sure that we're working with the right name                                                                // 6747
						name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(elem.style, origName)); // 6748
						// 6749
						// gets hook for the prefixed version                                                                              // 6750
						// followed by the unprefixed version                                                                              // 6751
						hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // 6752
						// 6753
						// If a hook was provided get the computed value from there                                                        // 6754
						if (hooks && "get" in hooks) {
							// 6755
							val = hooks.get(elem, true, extra); // 6756
						} // 6757
						// 6758
						// Otherwise, if a way to get the computed value exists, use that                                                  // 6759
						if (val === undefined) {
							// 6760
							val = curCSS(elem, name, styles); // 6761
						} // 6762
						// 6763
						//convert "normal" to computed value                                                                               // 6764
						if (val === "normal" && name in cssNormalTransform) {
							// 6765
							val = cssNormalTransform[name]; // 6766
						} // 6767
						// 6768
						// Return, converting to number if forced or a qualifier was provided and val looks numeric                        // 6769
						if (extra === "" || extra) {
							// 6770
							num = parseFloat(val); // 6771
							return extra === true || jQuery.isNumeric(num) ? num || 0 : val; // 6772
						} // 6773
						return val; // 6774
					} // 6775
				}); // 6776
				// 6777
				jQuery.each(["height", "width"], function (i, name) {
					// 6778
					jQuery.cssHooks[name] = { // 6779
						get: function (elem, computed, extra) {
							// 6780
							if (computed) {
								// 6781
								// certain elements can have dimension info if we invisibly show them                                            // 6782
								// however, it must have a current display style that would benefit from this                                    // 6783
								return elem.offsetWidth === 0 && rdisplayswap.test(jQuery.css(elem, "display")) ? // 6784
								jQuery.swap(elem, cssShow, function () {
									// 6785
									return getWidthOrHeight(elem, name, extra); // 6786
								}) : // 6787
								getWidthOrHeight(elem, name, extra); // 6788
							} // 6789
						}, // 6790
						// 6791
						set: function (elem, value, extra) {
							// 6792
							var styles = extra && getStyles(elem); // 6793
							return setPositiveNumber(elem, value, extra ? // 6794
							augmentWidthOrHeight( // 6795
							elem, // 6796
							name, // 6797
							extra, // 6798
							support.boxSizing() && jQuery.css(elem, "boxSizing", false, styles) === "border-box", // 6799
							styles // 6800
							) : 0 // 6801
							); // 6802
						} // 6803
					}; // 6804
				}); // 6805
				// 6806
				if (!support.opacity) {
					// 6807
					jQuery.cssHooks.opacity = { // 6808
						get: function (elem, computed) {
							// 6809
							// IE uses filters for opacity                                                                                    // 6810
							return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? // 6811
							0.01 * parseFloat(RegExp.$1) + "" : // 6812
							computed ? "1" : ""; // 6813
						}, // 6814
						// 6815
						set: function (elem, value) {
							// 6816
							var style = elem.style,
							    // 6817
							currentStyle = elem.currentStyle,
							    // 6818
							opacity = jQuery.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "",
							    // 6819
							filter = currentStyle && currentStyle.filter || style.filter || ""; // 6820
							// 6821
							// IE has trouble with opacity if it does not have layout                                                         // 6822
							// Force it by setting the zoom level                                                                             // 6823
							style.zoom = 1; // 6824
							// 6825
							// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652                 // 6826
							// if value === "", then remove inline opacity #12685                                                             // 6827
							if ((value >= 1 || value === "") && // 6828
							jQuery.trim(filter.replace(ralpha, "")) === "" && // 6829
							style.removeAttribute) {
								// 6830
								// 6831
								// Setting style.filter to null, "" & " " still leave "filter:" in the cssText                                   // 6832
								// if "filter:" is present at all, clearType is disabled, we want to avoid this                                  // 6833
								// style.removeAttribute is IE Only, but so apparently is this code path...                                      // 6834
								style.removeAttribute("filter"); // 6835
								// 6836
								// if there is no filter style applied in a css rule or unset inline opacity, we are done                        // 6837
								if (value === "" || currentStyle && !currentStyle.filter) {
									// 6838
									return; // 6839
								} // 6840
							} // 6841
							// 6842
							// otherwise, set new filter values                                                                               // 6843
							style.filter = ralpha.test(filter) ? // 6844
							filter.replace(ralpha, opacity) : // 6845
							filter + " " + opacity; // 6846
						} // 6847
					}; // 6848
				} // 6849
				// 6850
				jQuery.cssHooks.marginRight = addGetHookIf(support.reliableMarginRight, // 6851
				function (elem, computed) {
					// 6852
					if (computed) {
						// 6853
						// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right                                       // 6854
						// Work around by temporarily setting element display to inline-block                                             // 6855
						return jQuery.swap(elem, { "display": "inline-block" }, // 6856
						curCSS, [elem, "marginRight"]); // 6857
					} // 6858
				} // 6859
				); // 6860
				// 6861
				// These hooks are used by animate to expand properties                                                              // 6862
				jQuery.each({ // 6863
					margin: "", // 6864
					padding: "", // 6865
					border: "Width" // 6866
				}, function (prefix, suffix) {
					// 6867
					jQuery.cssHooks[prefix + suffix] = { // 6868
						expand: function (value) {
							// 6869
							var i = 0,
							    // 6870
							expanded = {},
							    // 6871
							// 6872
							// assumes a single number if not a string                                                                       // 6873
							parts = typeof value === "string" ? value.split(" ") : [value]; // 6874
							// 6875
							for (; i < 4; i++) {
								// 6876
								expanded[prefix + cssExpand[i] + suffix] = // 6877
								parts[i] || parts[i - 2] || parts[0]; // 6878
							} // 6879
							// 6880
							return expanded; // 6881
						} // 6882
					}; // 6883
					// 6884
					if (!rmargin.test(prefix)) {
						// 6885
						jQuery.cssHooks[prefix + suffix].set = setPositiveNumber; // 6886
					} // 6887
				}); // 6888
				// 6889
				jQuery.fn.extend({ // 6890
					css: function (name, value) {
						// 6891
						return access(this, function (elem, name, value) {
							// 6892
							var styles,
							    len,
							    // 6893
							map = {},
							    // 6894
							i = 0; // 6895
							// 6896
							if (jQuery.isArray(name)) {
								// 6897
								styles = getStyles(elem); // 6898
								len = name.length; // 6899
								// 6900
								for (; i < len; i++) {
									// 6901
									map[name[i]] = jQuery.css(elem, name[i], false, styles); // 6902
								} // 6903
								// 6904
								return map; // 6905
							} // 6906
							// 6907
							return value !== undefined ? // 6908
							jQuery.style(elem, name, value) : // 6909
							jQuery.css(elem, name); // 6910
						}, name, value, arguments.length > 1); // 6911
					}, // 6912
					show: function () {
						// 6913
						return showHide(this, true); // 6914
					}, // 6915
					hide: function () {
						// 6916
						return showHide(this); // 6917
					}, // 6918
					toggle: function (state) {
						// 6919
						if (typeof state === "boolean") {
							// 6920
							return state ? this.show() : this.hide(); // 6921
						} // 6922
						// 6923
						return this.each(function () {
							// 6924
							if (isHidden(this)) {
								// 6925
								jQuery(this).show(); // 6926
							} else {
								// 6927
								jQuery(this).hide(); // 6928
							} // 6929
						}); // 6930
					} // 6931
				}); // 6932
				// 6933
				// 6934
				function Tween(elem, options, prop, end, easing) {
					// 6935
					return new Tween.prototype.init(elem, options, prop, end, easing); // 6936
				} // 6937
				jQuery.Tween = Tween; // 6938
				// 6939
				Tween.prototype = { // 6940
					constructor: Tween, // 6941
					init: function (elem, options, prop, end, easing, unit) {
						// 6942
						this.elem = elem; // 6943
						this.prop = prop; // 6944
						this.easing = easing || "swing"; // 6945
						this.options = options; // 6946
						this.start = this.now = this.cur(); // 6947
						this.end = end; // 6948
						this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px"); // 6949
					}, // 6950
					cur: function () {
						// 6951
						var hooks = Tween.propHooks[this.prop]; // 6952
						// 6953
						return hooks && hooks.get ? // 6954
						hooks.get(this) : // 6955
						Tween.propHooks._default.get(this); // 6956
					}, // 6957
					run: function (percent) {
						// 6958
						var eased,
						    // 6959
						hooks = Tween.propHooks[this.prop]; // 6960
						// 6961
						if (this.options.duration) {
							// 6962
							this.pos = eased = jQuery.easing[this.easing]( // 6963
							percent, this.options.duration * percent, 0, 1, this.options.duration // 6964
							); // 6965
						} else {
							// 6966
							this.pos = eased = percent; // 6967
						} // 6968
						this.now = (this.end - this.start) * eased + this.start; // 6969
						// 6970
						if (this.options.step) {
							// 6971
							this.options.step.call(this.elem, this.now, this); // 6972
						} // 6973
						// 6974
						if (hooks && hooks.set) {
							// 6975
							hooks.set(this); // 6976
						} else {
							// 6977
							Tween.propHooks._default.set(this); // 6978
						} // 6979
						return this; // 6980
					} // 6981
				}; // 6982
				// 6983
				Tween.prototype.init.prototype = Tween.prototype; // 6984
				// 6985
				Tween.propHooks = { // 6986
					_default: { // 6987
						get: function (tween) {
							// 6988
							var result; // 6989
							// 6990
							if (tween.elem[tween.prop] != null && ( // 6991
							!tween.elem.style || tween.elem.style[tween.prop] == null)) {
								// 6992
								return tween.elem[tween.prop]; // 6993
							} // 6994
							// 6995
							// passing an empty string as a 3rd parameter to .css will automatically                                          // 6996
							// attempt a parseFloat and fallback to a string if the parse fails                                               // 6997
							// so, simple values such as "10px" are parsed to Float.                                                          // 6998
							// complex values such as "rotate(1rad)" are returned as is.                                                      // 6999
							result = jQuery.css(tween.elem, tween.prop, ""); // 7000
							// Empty strings, null, undefined and "auto" are converted to 0.                                                  // 7001
							return !result || result === "auto" ? 0 : result; // 7002
						}, // 7003
						set: function (tween) {
							// 7004
							// use step hook for back compat - use cssHook if its there - use .style if its                                   // 7005
							// available and use plain properties where available                                                             // 7006
							if (jQuery.fx.step[tween.prop]) {
								// 7007
								jQuery.fx.step[tween.prop](tween); // 7008
							} else if (tween.elem.style && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
								jQuery.style(tween.elem, tween.prop, tween.now + tween.unit); // 7010
							} else {
								// 7011
								tween.elem[tween.prop] = tween.now; // 7012
							} // 7013
						} // 7014
						// 7015
					} }; // 7016
				// 7017
				// Support: IE <=9                                                                                                   // 7018
				// Panic based approach to setting things on disconnected nodes                                                      // 7019
				// 7020
				Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = { // 7021
					set: function (tween) {
						// 7022
						if (tween.elem.nodeType && tween.elem.parentNode) {
							// 7023
							tween.elem[tween.prop] = tween.now; // 7024
						} // 7025
					} // 7026
				}; // 7027
				// 7028
				jQuery.easing = { // 7029
					linear: function (p) {
						// 7030
						return p; // 7031
					}, // 7032
					swing: function (p) {
						// 7033
						return 0.5 - Math.cos(p * Math.PI) / 2; // 7034
					} // 7035
				}; // 7036
				// 7037
				jQuery.fx = Tween.prototype.init; // 7038
				// 7039
				// Back Compat <1.8 extension point                                                                                  // 7040
				jQuery.fx.step = {}; // 7041
				// 7042
				// 7043
				// 7044
				// 7045
				var // 7046
				fxNow,
				    timerId,
				    // 7047
				rfxtypes = /^(?:toggle|show|hide)$/,
				    // 7048
				rfxnum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i"),
				    // 7049
				rrun = /queueHooks$/,
				    // 7050
				animationPrefilters = [defaultPrefilter],
				    // 7051
				tweeners = { // 7052
					"*": [function (prop, value) {
						// 7053
						var tween = this.createTween(prop, value),
						    // 7054
						target = tween.cur(),
						    // 7055
						parts = rfxnum.exec(value),
						    // 7056
						unit = parts && parts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
						    // 7057
						// 7058
						// Starting value computation is required for potential unit mismatches                                          // 7059
						start = (jQuery.cssNumber[prop] || unit !== "px" && +target) && // 7060
						rfxnum.exec(jQuery.css(tween.elem, prop)),
						    // 7061
						scale = 1,
						    // 7062
						maxIterations = 20; // 7063
						// 7064
						if (start && start[3] !== unit) {
							// 7065
							// Trust units reported by jQuery.css                                                                            // 7066
							unit = unit || start[3]; // 7067
							// 7068
							// Make sure we update the tween properties later on                                                             // 7069
							parts = parts || []; // 7070
							// 7071
							// Iteratively approximate from a nonzero starting point                                                         // 7072
							start = +target || 1; // 7073
							// 7074
							do {
								// 7075
								// If previous iteration zeroed out, double until we get *something*                                            // 7076
								// Use a string for doubling factor so we don't accidentally see scale as unchanged below                       // 7077
								scale = scale || ".5"; // 7078
								// 7079
								// Adjust and apply                                                                                             // 7080
								start = start / scale; // 7081
								jQuery.style(tween.elem, prop, start + unit); // 7082
								// 7083
								// Update scale, tolerating zero or NaN from tween.cur()                                                         // 7084
								// And breaking the loop if scale is unchanged or perfect, or if we've just had enough                           // 7085
							} while (scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations); // 7086
						} // 7087
						// 7088
						// Update tween properties                                                                                        // 7089
						if (parts) {
							// 7090
							start = tween.start = +start || +target || 0; // 7091
							tween.unit = unit; // 7092
							// If a +=/-= token was provided, we're doing a relative animation                                               // 7093
							tween.end = parts[1] ? // 7094
							start + (parts[1] + 1) * parts[2] : // 7095
							+parts[2]; // 7096
						} // 7097
						// 7098
						return tween; // 7099
					}] // 7100
				}; // 7101
				// 7102
				// Animations created synchronously will run synchronously                                                           // 7103
				function createFxNow() {
					// 7104
					setTimeout(function () {
						// 7105
						fxNow = undefined; // 7106
					}); // 7107
					return fxNow = jQuery.now(); // 7108
				} // 7109
				// 7110
				// Generate parameters to create a standard animation                                                                // 7111
				function genFx(type, includeWidth) {
					// 7112
					var which,
					    // 7113
					attrs = { height: type },
					    // 7114
					i = 0; // 7115
					// 7116
					// if we include width, step value is 1 to do all cssExpand values,                                                 // 7117
					// if we don't include width, step value is 2 to skip over Left and Right                                           // 7118
					includeWidth = includeWidth ? 1 : 0; // 7119
					for (; i < 4; i += 2 - includeWidth) {
						// 7120
						which = cssExpand[i]; // 7121
						attrs["margin" + which] = attrs["padding" + which] = type; // 7122
					} // 7123
					// 7124
					if (includeWidth) {
						// 7125
						attrs.opacity = attrs.width = type; // 7126
					} // 7127
					// 7128
					return attrs; // 7129
				} // 7130
				// 7131
				function createTween(value, prop, animation) {
					// 7132
					var tween,
					    // 7133
					collection = (tweeners[prop] || []).concat(tweeners["*"]),
					    // 7134
					index = 0,
					    // 7135
					length = collection.length; // 7136
					for (; index < length; index++) {
						// 7137
						if (tween = collection[index].call(animation, prop, value)) {
							// 7138
							// 7139
							// we're done with this property                                                                                  // 7140
							return tween; // 7141
						} // 7142
					} // 7143
				} // 7144
				// 7145
				function defaultPrefilter(elem, props, opts) {
					// 7146
					/* jshint validthis: true */ // 7147
					var prop,
					    value,
					    toggle,
					    tween,
					    hooks,
					    oldfire,
					    display,
					    dDisplay,
					    // 7148
					anim = this,
					    // 7149
					orig = {},
					    // 7150
					style = elem.style,
					    // 7151
					hidden = elem.nodeType && isHidden(elem),
					    // 7152
					dataShow = jQuery._data(elem, "fxshow"); // 7153
					// 7154
					// handle queue: false promises                                                                                     // 7155
					if (!opts.queue) {
						// 7156
						hooks = jQuery._queueHooks(elem, "fx"); // 7157
						if (hooks.unqueued == null) {
							// 7158
							hooks.unqueued = 0; // 7159
							oldfire = hooks.empty.fire; // 7160
							hooks.empty.fire = function () {
								// 7161
								if (!hooks.unqueued) {
									// 7162
									oldfire(); // 7163
								} // 7164
							}; // 7165
						} // 7166
						hooks.unqueued++; // 7167
						// 7168
						anim.always(function () {
							// 7169
							// doing this makes sure that the complete handler will be called                                                 // 7170
							// before this completes                                                                                          // 7171
							anim.always(function () {
								// 7172
								hooks.unqueued--; // 7173
								if (!jQuery.queue(elem, "fx").length) {
									// 7174
									hooks.empty.fire(); // 7175
								} // 7176
							}); // 7177
						}); // 7178
					} // 7179
					// 7180
					// height/width overflow pass                                                                                       // 7181
					if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
						// 7182
						// Make sure that nothing sneaks out                                                                               // 7183
						// Record all 3 overflow attributes because IE does not                                                            // 7184
						// change the overflow attribute when overflowX and                                                                // 7185
						// overflowY are set to the same value                                                                             // 7186
						opts.overflow = [style.overflow, style.overflowX, style.overflowY]; // 7187
						// 7188
						// Set display property to inline-block for height/width                                                           // 7189
						// animations on inline elements that are having width/height animated                                             // 7190
						display = jQuery.css(elem, "display"); // 7191
						dDisplay = defaultDisplay(elem.nodeName); // 7192
						if (display === "none") {
							// 7193
							display = dDisplay; // 7194
						} // 7195
						if (display === "inline" && // 7196
						jQuery.css(elem, "float") === "none") {
							// 7197
							// 7198
							// inline-level elements accept inline-block;                                                                     // 7199
							// block-level elements need to be inline with layout                                                             // 7200
							if (!support.inlineBlockNeedsLayout || dDisplay === "inline") {
								// 7201
								style.display = "inline-block"; // 7202
							} else {
								// 7203
								style.zoom = 1; // 7204
							} // 7205
						} // 7206
					} // 7207
					// 7208
					if (opts.overflow) {
						// 7209
						style.overflow = "hidden"; // 7210
						if (!support.shrinkWrapBlocks()) {
							// 7211
							anim.always(function () {
								// 7212
								style.overflow = opts.overflow[0]; // 7213
								style.overflowX = opts.overflow[1]; // 7214
								style.overflowY = opts.overflow[2]; // 7215
							}); // 7216
						} // 7217
					} // 7218
					// 7219
					// show/hide pass                                                                                                   // 7220
					for (prop in props) {
						// 7221
						value = props[prop]; // 7222
						if (rfxtypes.exec(value)) {
							// 7223
							delete props[prop]; // 7224
							toggle = toggle || value === "toggle"; // 7225
							if (value === (hidden ? "hide" : "show")) {
								// 7226
								// 7227
								// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
								if (value === "show" && dataShow && dataShow[prop] !== undefined) {
									// 7229
									hidden = true; // 7230
								} else {
										// 7231
										continue; // 7232
									} // 7233
							} // 7234
							orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop); // 7235
						} // 7236
					} // 7237
					// 7238
					if (!jQuery.isEmptyObject(orig)) {
						// 7239
						if (dataShow) {
							// 7240
							if ("hidden" in dataShow) {
								// 7241
								hidden = dataShow.hidden; // 7242
							} // 7243
						} else {
							// 7244
							dataShow = jQuery._data(elem, "fxshow", {}); // 7245
						} // 7246
						// 7247
						// store state if its toggle - enables .stop().toggle() to "reverse"                                               // 7248
						if (toggle) {
							// 7249
							dataShow.hidden = !hidden; // 7250
						} // 7251
						if (hidden) {
							// 7252
							jQuery(elem).show(); // 7253
						} else {
							// 7254
							anim.done(function () {
								// 7255
								jQuery(elem).hide(); // 7256
							}); // 7257
						} // 7258
						anim.done(function () {
							// 7259
							var prop; // 7260
							jQuery._removeData(elem, "fxshow"); // 7261
							for (prop in orig) {
								// 7262
								jQuery.style(elem, prop, orig[prop]); // 7263
							} // 7264
						}); // 7265
						for (prop in orig) {
							// 7266
							tween = createTween(hidden ? dataShow[prop] : 0, prop, anim); // 7267
							// 7268
							if (!(prop in dataShow)) {
								// 7269
								dataShow[prop] = tween.start; // 7270
								if (hidden) {
									// 7271
									tween.end = tween.start; // 7272
									tween.start = prop === "width" || prop === "height" ? 1 : 0; // 7273
								} // 7274
							} // 7275
						} // 7276
					} // 7277
				} // 7278
				// 7279
				function propFilter(props, specialEasing) {
					// 7280
					var index, name, easing, value, hooks; // 7281
					// 7282
					// camelCase, specialEasing and expand cssHook pass                                                                 // 7283
					for (index in props) {
						// 7284
						name = jQuery.camelCase(index); // 7285
						easing = specialEasing[name]; // 7286
						value = props[index]; // 7287
						if (jQuery.isArray(value)) {
							// 7288
							easing = value[1]; // 7289
							value = props[index] = value[0]; // 7290
						} // 7291
						// 7292
						if (index !== name) {
							// 7293
							props[name] = value; // 7294
							delete props[index]; // 7295
						} // 7296
						// 7297
						hooks = jQuery.cssHooks[name]; // 7298
						if (hooks && "expand" in hooks) {
							// 7299
							value = hooks.expand(value); // 7300
							delete props[name]; // 7301
							// 7302
							// not quite $.extend, this wont overwrite keys already present.                                                  // 7303
							// also - reusing 'index' from above because we have the correct "name"                                           // 7304
							for (index in value) {
								// 7305
								if (!(index in props)) {
									// 7306
									props[index] = value[index]; // 7307
									specialEasing[index] = easing; // 7308
								} // 7309
							} // 7310
						} else {
							// 7311
							specialEasing[name] = easing; // 7312
						} // 7313
					} // 7314
				} // 7315
				// 7316
				function Animation(elem, properties, options) {
					// 7317
					var result,
					    // 7318
					stopped,
					    // 7319
					index = 0,
					    // 7320
					length = animationPrefilters.length,
					    // 7321
					deferred = jQuery.Deferred().always(function () {
						// 7322
						// don't match elem in the :animated selector                                                                     // 7323
						delete tick.elem; // 7324
					}),
					    // 7325
					tick = function () {
						// 7326
						if (stopped) {
							// 7327
							return false; // 7328
						} // 7329
						var currentTime = fxNow || createFxNow(),
						    // 7330
						remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
						    // 7331
						// archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)                                             // 7332
						temp = remaining / animation.duration || 0,
						    // 7333
						percent = 1 - temp,
						    // 7334
						index = 0,
						    // 7335
						length = animation.tweens.length; // 7336
						// 7337
						for (; index < length; index++) {
							// 7338
							animation.tweens[index].run(percent); // 7339
						} // 7340
						// 7341
						deferred.notifyWith(elem, [animation, percent, remaining]); // 7342
						// 7343
						if (percent < 1 && length) {
							// 7344
							return remaining; // 7345
						} else {
							// 7346
							deferred.resolveWith(elem, [animation]); // 7347
							return false; // 7348
						} // 7349
					},
					    // 7350
					animation = deferred.promise({ // 7351
						elem: elem, // 7352
						props: jQuery.extend({}, properties), // 7353
						opts: jQuery.extend(true, { specialEasing: {} }, options), // 7354
						originalProperties: properties, // 7355
						originalOptions: options, // 7356
						startTime: fxNow || createFxNow(), // 7357
						duration: options.duration, // 7358
						tweens: [], // 7359
						createTween: function (prop, end) {
							// 7360
							var tween = jQuery.Tween(elem, animation.opts, prop, end, // 7361
							animation.opts.specialEasing[prop] || animation.opts.easing); // 7362
							animation.tweens.push(tween); // 7363
							return tween; // 7364
						}, // 7365
						stop: function (gotoEnd) {
							// 7366
							var index = 0,
							    // 7367
							// if we are going to the end, we want to run all the tweens                                                    // 7368
							// otherwise we skip this part                                                                                  // 7369
							length = gotoEnd ? animation.tweens.length : 0; // 7370
							if (stopped) {
								// 7371
								return this; // 7372
							} // 7373
							stopped = true; // 7374
							for (; index < length; index++) {
								// 7375
								animation.tweens[index].run(1); // 7376
							} // 7377
							// 7378
							// resolve when we played the last frame                                                                         // 7379
							// otherwise, reject                                                                                             // 7380
							if (gotoEnd) {
								// 7381
								deferred.resolveWith(elem, [animation, gotoEnd]); // 7382
							} else {
								// 7383
								deferred.rejectWith(elem, [animation, gotoEnd]); // 7384
							} // 7385
							return this; // 7386
						} // 7387
					}),
					    // 7388
					props = animation.props; // 7389
					// 7390
					propFilter(props, animation.opts.specialEasing); // 7391
					// 7392
					for (; index < length; index++) {
						// 7393
						result = animationPrefilters[index].call(animation, elem, props, animation.opts); // 7394
						if (result) {
							// 7395
							return result; // 7396
						} // 7397
					} // 7398
					// 7399
					jQuery.map(props, createTween, animation); // 7400
					// 7401
					if (jQuery.isFunction(animation.opts.start)) {
						// 7402
						animation.opts.start.call(elem, animation); // 7403
					} // 7404
					// 7405
					jQuery.fx.timer( // 7406
					jQuery.extend(tick, { // 7407
						elem: elem, // 7408
						anim: animation, // 7409
						queue: animation.opts.queue // 7410
					}) // 7411
					); // 7412
					// 7413
					// attach callbacks from options                                                                                    // 7414
					return animation.progress(animation.opts.progress) // 7415
					.done(animation.opts.done, animation.opts.complete) // 7416
					.fail(animation.opts.fail) // 7417
					.always(animation.opts.always); // 7418
				} // 7419
				// 7420
				jQuery.Animation = jQuery.extend(Animation, { // 7421
					tweener: function (props, callback) {
						// 7422
						if (jQuery.isFunction(props)) {
							// 7423
							callback = props; // 7424
							props = ["*"]; // 7425
						} else {
							// 7426
							props = props.split(" "); // 7427
						} // 7428
						// 7429
						var prop,
						    // 7430
						index = 0,
						    // 7431
						length = props.length; // 7432
						// 7433
						for (; index < length; index++) {
							// 7434
							prop = props[index]; // 7435
							tweeners[prop] = tweeners[prop] || []; // 7436
							tweeners[prop].unshift(callback); // 7437
						} // 7438
					}, // 7439
					// 7440
					prefilter: function (callback, prepend) {
						// 7441
						if (prepend) {
							// 7442
							animationPrefilters.unshift(callback); // 7443
						} else {
							// 7444
							animationPrefilters.push(callback); // 7445
						} // 7446
					} // 7447
				}); // 7448
				// 7449
				jQuery.speed = function (speed, easing, fn) {
					// 7450
					var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : { // 7451
						complete: fn || !fn && easing || // 7452
						jQuery.isFunction(speed) && speed, // 7453
						duration: speed, // 7454
						easing: fn && easing || easing && !jQuery.isFunction(easing) && easing // 7455
					}; // 7456
					// 7457
					opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : // 7458
					opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default; // 7459
					// 7460
					// normalize opt.queue - true/undefined/null -> "fx"                                                                // 7461
					if (opt.queue == null || opt.queue === true) {
						// 7462
						opt.queue = "fx"; // 7463
					} // 7464
					// 7465
					// Queueing                                                                                                         // 7466
					opt.old = opt.complete; // 7467
					// 7468
					opt.complete = function () {
						// 7469
						if (jQuery.isFunction(opt.old)) {
							// 7470
							opt.old.call(this); // 7471
						} // 7472
						// 7473
						if (opt.queue) {
							// 7474
							jQuery.dequeue(this, opt.queue); // 7475
						} // 7476
					}; // 7477
					// 7478
					return opt; // 7479
				}; // 7480
				// 7481
				jQuery.fn.extend({ // 7482
					fadeTo: function (speed, to, easing, callback) {
						// 7483
						// 7484
						// show any hidden elements after setting opacity to 0                                                             // 7485
						return this.filter(isHidden).css("opacity", 0).show() // 7486
						// 7487
						// animate to the value specified                                                                                 // 7488
						.end().animate({ opacity: to }, speed, easing, callback); // 7489
					}, // 7490
					animate: function (prop, speed, easing, callback) {
						// 7491
						var empty = jQuery.isEmptyObject(prop),
						    // 7492
						optall = jQuery.speed(speed, easing, callback),
						    // 7493
						doAnimation = function () {
							// 7494
							// Operate on a copy of prop so per-property easing won't be lost                                                // 7495
							var anim = Animation(this, jQuery.extend({}, prop), optall); // 7496
							// 7497
							// Empty animations, or finishing resolves immediately                                                           // 7498
							if (empty || jQuery._data(this, "finish")) {
								// 7499
								anim.stop(true); // 7500
							} // 7501
						}; // 7502
						doAnimation.finish = doAnimation; // 7503
						// 7504
						return empty || optall.queue === false ? // 7505
						this.each(doAnimation) : // 7506
						this.queue(optall.queue, doAnimation); // 7507
					}, // 7508
					stop: function (type, clearQueue, gotoEnd) {
						// 7509
						var stopQueue = function (hooks) {
							// 7510
							var stop = hooks.stop; // 7511
							delete hooks.stop; // 7512
							stop(gotoEnd); // 7513
						}; // 7514
						// 7515
						if (typeof type !== "string") {
							// 7516
							gotoEnd = clearQueue; // 7517
							clearQueue = type; // 7518
							type = undefined; // 7519
						} // 7520
						if (clearQueue && type !== false) {
							// 7521
							this.queue(type || "fx", []); // 7522
						} // 7523
						// 7524
						return this.each(function () {
							// 7525
							var dequeue = true,
							    // 7526
							index = type != null && type + "queueHooks",
							    // 7527
							timers = jQuery.timers,
							    // 7528
							data = jQuery._data(this); // 7529
							// 7530
							if (index) {
								// 7531
								if (data[index] && data[index].stop) {
									// 7532
									stopQueue(data[index]); // 7533
								} // 7534
							} else {
								// 7535
								for (index in data) {
									// 7536
									if (data[index] && data[index].stop && rrun.test(index)) {
										// 7537
										stopQueue(data[index]); // 7538
									} // 7539
								} // 7540
							} // 7541
							// 7542
							for (index = timers.length; index--;) {
								// 7543
								if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
									// 7544
									timers[index].anim.stop(gotoEnd); // 7545
									dequeue = false; // 7546
									timers.splice(index, 1); // 7547
								} // 7548
							} // 7549
							// 7550
							// start the next in the queue if the last step wasn't forced                                                     // 7551
							// timers currently will call their complete callbacks, which will dequeue                                        // 7552
							// but only if they were gotoEnd                                                                                  // 7553
							if (dequeue || !gotoEnd) {
								// 7554
								jQuery.dequeue(this, type); // 7555
							} // 7556
						}); // 7557
					}, // 7558
					finish: function (type) {
						// 7559
						if (type !== false) {
							// 7560
							type = type || "fx"; // 7561
						} // 7562
						return this.each(function () {
							// 7563
							var index,
							    // 7564
							data = jQuery._data(this),
							    // 7565
							queue = data[type + "queue"],
							    // 7566
							hooks = data[type + "queueHooks"],
							    // 7567
							timers = jQuery.timers,
							    // 7568
							length = queue ? queue.length : 0; // 7569
							// 7570
							// enable finishing flag on private data                                                                          // 7571
							data.finish = true; // 7572
							// 7573
							// empty the queue first                                                                                          // 7574
							jQuery.queue(this, type, []); // 7575
							// 7576
							if (hooks && hooks.stop) {
								// 7577
								hooks.stop.call(this, true); // 7578
							} // 7579
							// 7580
							// look for any active animations, and finish them                                                                // 7581
							for (index = timers.length; index--;) {
								// 7582
								if (timers[index].elem === this && timers[index].queue === type) {
									// 7583
									timers[index].anim.stop(true); // 7584
									timers.splice(index, 1); // 7585
								} // 7586
							} // 7587
							// 7588
							// look for any animations in the old queue and finish them                                                       // 7589
							for (index = 0; index < length; index++) {
								// 7590
								if (queue[index] && queue[index].finish) {
									// 7591
									queue[index].finish.call(this); // 7592
								} // 7593
							} // 7594
							// 7595
							// turn off finishing flag                                                                                        // 7596
							delete data.finish; // 7597
						}); // 7598
					} // 7599
				}); // 7600
				// 7601
				jQuery.each(["toggle", "show", "hide"], function (i, name) {
					// 7602
					var cssFn = jQuery.fn[name]; // 7603
					jQuery.fn[name] = function (speed, easing, callback) {
						// 7604
						return speed == null || typeof speed === "boolean" ? // 7605
						cssFn.apply(this, arguments) : // 7606
						this.animate(genFx(name, true), speed, easing, callback); // 7607
					}; // 7608
				}); // 7609
				// 7610
				// Generate shortcuts for custom animations                                                                          // 7611
				jQuery.each({ // 7612
					slideDown: genFx("show"), // 7613
					slideUp: genFx("hide"), // 7614
					slideToggle: genFx("toggle"), // 7615
					fadeIn: { opacity: "show" }, // 7616
					fadeOut: { opacity: "hide" }, // 7617
					fadeToggle: { opacity: "toggle" // 7618
					} }, function (name, props) {
					// 7619
					jQuery.fn[name] = function (speed, easing, callback) {
						// 7620
						return this.animate(props, speed, easing, callback); // 7621
					}; // 7622
				}); // 7623
				// 7624
				jQuery.timers = []; // 7625
				jQuery.fx.tick = function () {
					// 7626
					var timer,
					    // 7627
					timers = jQuery.timers,
					    // 7628
					i = 0; // 7629
					// 7630
					fxNow = jQuery.now(); // 7631
					// 7632
					for (; i < timers.length; i++) {
						// 7633
						timer = timers[i]; // 7634
						// Checks the timer has not already been removed                                                                   // 7635
						if (!timer() && timers[i] === timer) {
							// 7636
							timers.splice(i--, 1); // 7637
						} // 7638
					} // 7639
					// 7640
					if (!timers.length) {
						// 7641
						jQuery.fx.stop(); // 7642
					} // 7643
					fxNow = undefined; // 7644
				}; // 7645
				// 7646
				jQuery.fx.timer = function (timer) {
					// 7647
					jQuery.timers.push(timer); // 7648
					if (timer()) {
						// 7649
						jQuery.fx.start(); // 7650
					} else {
						// 7651
						jQuery.timers.pop(); // 7652
					} // 7653
				}; // 7654
				// 7655
				jQuery.fx.interval = 13; // 7656
				// 7657
				jQuery.fx.start = function () {
					// 7658
					if (!timerId) {
						// 7659
						timerId = setInterval(jQuery.fx.tick, jQuery.fx.interval); // 7660
					} // 7661
				}; // 7662
				// 7663
				jQuery.fx.stop = function () {
					// 7664
					clearInterval(timerId); // 7665
					timerId = null; // 7666
				}; // 7667
				// 7668
				jQuery.fx.speeds = { // 7669
					slow: 600, // 7670
					fast: 200, // 7671
					// Default speed                                                                                                    // 7672
					_default: 400 // 7673
				}; // 7674
				// 7675
				// 7676
				// Based off of the plugin by Clint Helfers, with permission.                                                        // 7677
				// http://blindsignals.com/index.php/2009/07/jquery-delay/                                                           // 7678
				jQuery.fn.delay = function (time, type) {
					// 7679
					time = jQuery.fx ? jQuery.fx.speeds[time] || time : time; // 7680
					type = type || "fx"; // 7681
					// 7682
					return this.queue(type, function (next, hooks) {
						// 7683
						var timeout = setTimeout(next, time); // 7684
						hooks.stop = function () {
							// 7685
							clearTimeout(timeout); // 7686
						}; // 7687
					}); // 7688
				}; // 7689
				// 7690
				// 7691
				(function () {
					// 7692
					var a,
					    input,
					    select,
					    opt,
					    // 7693
					div = document.createElement("div"); // 7694
					// 7695
					// Setup                                                                                                            // 7696
					div.setAttribute("className", "t"); // 7697
					div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"; // 7698
					a = div.getElementsByTagName("a")[0]; // 7699
					// 7700
					// First batch of tests.                                                                                            // 7701
					select = document.createElement("select"); // 7702
					opt = select.appendChild(document.createElement("option")); // 7703
					input = div.getElementsByTagName("input")[0]; // 7704
					// 7705
					a.style.cssText = "top:1px"; // 7706
					// 7707
					// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)         // 7708
					support.getSetAttribute = div.className !== "t"; // 7709
					// 7710
					// Get the style information from getAttribute                                                                      // 7711
					// (IE uses .cssText instead)                                                                                       // 7712
					support.style = /top/.test(a.getAttribute("style")); // 7713
					// 7714
					// Make sure that URLs aren't manipulated                                                                           // 7715
					// (IE normalizes it by default)                                                                                    // 7716
					support.hrefNormalized = a.getAttribute("href") === "/a"; // 7717
					// 7718
					// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)                                            // 7719
					support.checkOn = !!input.value; // 7720
					// 7721
					// Make sure that a selected-by-default option has a working selected property.                                     // 7722
					// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)                                       // 7723
					support.optSelected = opt.selected; // 7724
					// 7725
					// Tests for enctype support on a form (#6743)                                                                      // 7726
					support.enctype = !!document.createElement("form").enctype; // 7727
					// 7728
					// Make sure that the options inside disabled selects aren't marked as disabled                                     // 7729
					// (WebKit marks them as disabled)                                                                                  // 7730
					select.disabled = true; // 7731
					support.optDisabled = !opt.disabled; // 7732
					// 7733
					// Support: IE8 only                                                                                                // 7734
					// Check if we can trust getAttribute("value")                                                                      // 7735
					input = document.createElement("input"); // 7736
					input.setAttribute("value", ""); // 7737
					support.input = input.getAttribute("value") === ""; // 7738
					// 7739
					// Check if an input maintains its value after becoming a radio                                                     // 7740
					input.value = "t"; // 7741
					input.setAttribute("type", "radio"); // 7742
					support.radioValue = input.value === "t"; // 7743
					// 7744
					// Null elements to avoid leaks in IE.                                                                              // 7745
					a = input = select = opt = div = null; // 7746
				})(); // 7747
				// 7748
				// 7749
				var rreturn = /\r/g; // 7750
				// 7751
				jQuery.fn.extend({ // 7752
					val: function (value) {
						// 7753
						var hooks,
						    ret,
						    isFunction,
						    // 7754
						elem = this[0]; // 7755
						// 7756
						if (!arguments.length) {
							// 7757
							if (elem) {
								// 7758
								hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()]; // 7759
								// 7760
								if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
									// 7761
									return ret; // 7762
								} // 7763
								// 7764
								ret = elem.value; // 7765
								// 7766
								return typeof ret === "string" ? // 7767
								// handle most common string cases                                                                              // 7768
								ret.replace(rreturn, "") : // 7769
								// handle cases where value is null/undef or number                                                             // 7770
								ret == null ? "" : ret; // 7771
							} // 7772
							// 7773
							return; // 7774
						} // 7775
						// 7776
						isFunction = jQuery.isFunction(value); // 7777
						// 7778
						return this.each(function (i) {
							// 7779
							var val; // 7780
							// 7781
							if (this.nodeType !== 1) {
								// 7782
								return; // 7783
							} // 7784
							// 7785
							if (isFunction) {
								// 7786
								val = value.call(this, i, jQuery(this).val()); // 7787
							} else {
								// 7788
								val = value; // 7789
							} // 7790
							// 7791
							// Treat null/undefined as ""; convert numbers to string                                                          // 7792
							if (val == null) {
								// 7793
								val = ""; // 7794
							} else if (typeof val === "number") {
								// 7795
								val += ""; // 7796
							} else if (jQuery.isArray(val)) {
								// 7797
								val = jQuery.map(val, function (value) {
									// 7798
									return value == null ? "" : value + ""; // 7799
								}); // 7800
							} // 7801
							// 7802
							hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()]; // 7803
							// 7804
							// If set returns undefined, fall back to normal setting                                                          // 7805
							if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
								// 7806
								this.value = val; // 7807
							} // 7808
						}); // 7809
					} // 7810
				}); // 7811
				// 7812
				jQuery.extend({ // 7813
					valHooks: { // 7814
						option: { // 7815
							get: function (elem) {
								// 7816
								var val = jQuery.find.attr(elem, "value"); // 7817
								return val != null ? // 7818
								val : // 7819
								jQuery.text(elem); // 7820
							} // 7821
						}, // 7822
						select: { // 7823
							get: function (elem) {
								// 7824
								var value,
								    option,
								    // 7825
								options = elem.options,
								    // 7826
								index = elem.selectedIndex,
								    // 7827
								one = elem.type === "select-one" || index < 0,
								    // 7828
								values = one ? null : [],
								    // 7829
								max = one ? index + 1 : options.length,
								    // 7830
								i = index < 0 ? // 7831
								max : // 7832
								one ? index : 0; // 7833
								// 7834
								// Loop through all the selected options                                                                         // 7835
								for (; i < max; i++) {
									// 7836
									option = options[i]; // 7837
									// 7838
									// oldIE doesn't update selected after form reset (#2551)                                                       // 7839
									if ((option.selected || i === index) && ( // 7840
									// Don't return options that are disabled or in a disabled optgroup                                           // 7841
									support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && ( // 7842
									!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {
										// 7843
										// 7844
										// Get the specific value for the option                                                                       // 7845
										value = jQuery(option).val(); // 7846
										// 7847
										// We don't need an array for one selects                                                                      // 7848
										if (one) {
											// 7849
											return value; // 7850
										} // 7851
										// 7852
										// Multi-Selects return an array                                                                               // 7853
										values.push(value); // 7854
									} // 7855
								} // 7856
								// 7857
								return values; // 7858
							}, // 7859
							// 7860
							set: function (elem, value) {
								// 7861
								var optionSet,
								    option,
								    // 7862
								options = elem.options,
								    // 7863
								values = jQuery.makeArray(value),
								    // 7864
								i = options.length; // 7865
								// 7866
								while (i--) {
									// 7867
									option = options[i]; // 7868
									// 7869
									if (jQuery.inArray(jQuery.valHooks.option.get(option), values) >= 0) {
										// 7870
										// 7871
										// Support: IE6                                                                                                // 7872
										// When new option element is added to select box we need to                                                   // 7873
										// force reflow of newly added node in order to workaround delay                                               // 7874
										// of initialization properties                                                                                // 7875
										try {
											// 7876
											option.selected = optionSet = true; // 7877
											// 7878
										} catch (_) {
											// 7879
											// 7880
											// Will be executed only in IE6                                                                               // 7881
											option.scrollHeight; // 7882
										} // 7883
										// 7884
									} else {
										// 7885
										option.selected = false; // 7886
									} // 7887
								} // 7888
								// 7889
								// Force browsers to behave consistently when non-matching value is set                                          // 7890
								if (!optionSet) {
									// 7891
									elem.selectedIndex = -1; // 7892
								} // 7893
								// 7894
								return options; // 7895
							} // 7896
							// 7897
						} // 7898
					} }); // 7899
				// 7900
				// Radios and checkboxes getter/setter                                                                               // 7901
				jQuery.each(["radio", "checkbox"], function () {
					// 7902
					jQuery.valHooks[this] = { // 7903
						set: function (elem, value) {
							// 7904
							if (jQuery.isArray(value)) {
								// 7905
								return elem.checked = jQuery.inArray(jQuery(elem).val(), value) >= 0; // 7906
							} // 7907
						} // 7908
					}; // 7909
					if (!support.checkOn) {
						// 7910
						jQuery.valHooks[this].get = function (elem) {
							// 7911
							// Support: Webkit                                                                                                // 7912
							// "" is returned instead of "on" if a value isn't specified                                                      // 7913
							return elem.getAttribute("value") === null ? "on" : elem.value; // 7914
						}; // 7915
					} // 7916
				}); // 7917
				// 7918
				// 7919
				// 7920
				// 7921
				var nodeHook,
				    boolHook,
				    // 7922
				attrHandle = jQuery.expr.attrHandle,
				    // 7923
				ruseDefault = /^(?:checked|selected)$/i,
				    // 7924
				getSetAttribute = support.getSetAttribute,
				    // 7925
				getSetInput = support.input; // 7926
				// 7927
				jQuery.fn.extend({ // 7928
					attr: function (name, value) {
						// 7929
						return access(this, jQuery.attr, name, value, arguments.length > 1); // 7930
					}, // 7931
					// 7932
					removeAttr: function (name) {
						// 7933
						return this.each(function () {
							// 7934
							jQuery.removeAttr(this, name); // 7935
						}); // 7936
					} // 7937
				}); // 7938
				// 7939
				jQuery.extend({ // 7940
					attr: function (elem, name, value) {
						// 7941
						var hooks,
						    ret,
						    // 7942
						nType = elem.nodeType; // 7943
						// 7944
						// don't get/set attributes on text, comment and attribute nodes                                                   // 7945
						if (!elem || nType === 3 || nType === 8 || nType === 2) {
							// 7946
							return; // 7947
						} // 7948
						// 7949
						// Fallback to prop when attributes are not supported                                                              // 7950
						if (typeof elem.getAttribute === strundefined) {
							// 7951
							return jQuery.prop(elem, name, value); // 7952
						} // 7953
						// 7954
						// All attributes are lowercase                                                                                    // 7955
						// Grab necessary hook if one is defined                                                                           // 7956
						if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
							// 7957
							name = name.toLowerCase(); // 7958
							hooks = jQuery.attrHooks[name] || ( // 7959
							jQuery.expr.match.bool.test(name) ? boolHook : nodeHook); // 7960
						} // 7961
						// 7962
						if (value !== undefined) {
							// 7963
							// 7964
							if (value === null) {
								// 7965
								jQuery.removeAttr(elem, name); // 7966
								// 7967
							} else if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
								// 7968
								return ret; // 7969
								// 7970
							} else {
								// 7971
								elem.setAttribute(name, value + ""); // 7972
								return value; // 7973
							} // 7974
							// 7975
						} else if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
							// 7976
							return ret; // 7977
							// 7978
						} else {
							// 7979
							ret = jQuery.find.attr(elem, name); // 7980
							// 7981
							// Non-existent attributes return null, we normalize to undefined                                                 // 7982
							return ret == null ? // 7983
							undefined : // 7984
							ret; // 7985
						} // 7986
					}, // 7987
					// 7988
					removeAttr: function (elem, value) {
						// 7989
						var name,
						    propName,
						    // 7990
						i = 0,
						    // 7991
						attrNames = value && value.match(rnotwhite); // 7992
						// 7993
						if (attrNames && elem.nodeType === 1) {
							// 7994
							while (name = attrNames[i++]) {
								// 7995
								propName = jQuery.propFix[name] || name; // 7996
								// 7997
								// Boolean attributes get special treatment (#10870)                                                             // 7998
								if (jQuery.expr.match.bool.test(name)) {
									// 7999
									// Set corresponding property to false                                                                          // 8000
									if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
										// 8001
										elem[propName] = false; // 8002
										// Support: IE<9                                                                                                // 8003
										// Also clear defaultChecked/defaultSelected (if appropriate)                                                   // 8004
									} else {
										// 8005
										elem[jQuery.camelCase("default-" + name)] = // 8006
										elem[propName] = false; // 8007
									} // 8008
									// 8009
									// See #9699 for explanation of this approach (setting first, then removal)                                      // 8010
								} else {
									// 8011
									jQuery.attr(elem, name, ""); // 8012
								} // 8013
								// 8014
								elem.removeAttribute(getSetAttribute ? name : propName); // 8015
							} // 8016
						} // 8017
					}, // 8018
					// 8019
					attrHooks: { // 8020
						type: { // 8021
							set: function (elem, value) {
								// 8022
								if (!support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
									// 8023
									// Setting the type on a radio button after the value resets the value in IE6-9                                 // 8024
									// Reset value to default in case type is set after value during creation                                       // 8025
									var val = elem.value; // 8026
									elem.setAttribute("type", value); // 8027
									if (val) {
										// 8028
										elem.value = val; // 8029
									} // 8030
									return value; // 8031
								} // 8032
							} // 8033
							// 8034
						} // 8035
					} }); // 8036
				// 8037
				// Hook for boolean attributes                                                                                       // 8038
				boolHook = { // 8039
					set: function (elem, value, name) {
						// 8040
						if (value === false) {
							// 8041
							// Remove boolean attributes when set to false                                                                    // 8042
							jQuery.removeAttr(elem, name); // 8043
						} else if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
							// 8044
							// IE<8 needs the *property* name                                                                                 // 8045
							elem.setAttribute(!getSetAttribute && jQuery.propFix[name] || name, name); // 8046
							// 8047
							// Use defaultChecked and defaultSelected for oldIE                                                                // 8048
						} else {
							// 8049
							elem[jQuery.camelCase("default-" + name)] = elem[name] = true; // 8050
						} // 8051
						// 8052
						return name; // 8053
					} // 8054
				}; // 8055
				// 8056
				// Retrieve booleans specially                                                                                       // 8057
				jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
					// 8058
					// 8059
					var getter = attrHandle[name] || jQuery.find.attr; // 8060
					// 8061
					attrHandle[name] = getSetInput && getSetAttribute || !ruseDefault.test(name) ? // 8062
					function (elem, name, isXML) {
						// 8063
						var ret, handle; // 8064
						if (!isXML) {
							// 8065
							// Avoid an infinite loop by temporarily removing this function from the getter                                  // 8066
							handle = attrHandle[name]; // 8067
							attrHandle[name] = ret; // 8068
							ret = getter(elem, name, isXML) != null ? // 8069
							name.toLowerCase() : // 8070
							null; // 8071
							attrHandle[name] = handle; // 8072
						} // 8073
						return ret; // 8074
					} : // 8075
					function (elem, name, isXML) {
						// 8076
						if (!isXML) {
							// 8077
							return elem[jQuery.camelCase("default-" + name)] ? // 8078
							name.toLowerCase() : // 8079
							null; // 8080
						} // 8081
					}; // 8082
				}); // 8083
				// 8084
				// fix oldIE attroperties                                                                                            // 8085
				if (!getSetInput || !getSetAttribute) {
					// 8086
					jQuery.attrHooks.value = { // 8087
						set: function (elem, value, name) {
							// 8088
							if (jQuery.nodeName(elem, "input")) {
								// 8089
								// Does not return so that setAttribute is also used                                                             // 8090
								elem.defaultValue = value; // 8091
							} else {
								// 8092
								// Use nodeHook if defined (#1954); otherwise setAttribute is fine                                               // 8093
								return nodeHook && nodeHook.set(elem, value, name); // 8094
							} // 8095
						} // 8096
					}; // 8097
				} // 8098
				// 8099
				// IE6/7 do not support getting/setting some attributes with get/setAttribute                                        // 8100
				if (!getSetAttribute) {
					// 8101
					// 8102
					// Use this for any attribute in IE6/7                                                                              // 8103
					// This fixes almost every IE6/7 issue                                                                              // 8104
					nodeHook = { // 8105
						set: function (elem, value, name) {
							// 8106
							// Set the existing or create a new attribute node                                                                // 8107
							var ret = elem.getAttributeNode(name); // 8108
							if (!ret) {
								// 8109
								elem.setAttributeNode( // 8110
								ret = elem.ownerDocument.createAttribute(name) // 8111
								); // 8112
							} // 8113
							// 8114
							ret.value = value += ""; // 8115
							// 8116
							// Break association with cloned elements by also using setAttribute (#9646)                                      // 8117
							if (name === "value" || value === elem.getAttribute(name)) {
								// 8118
								return value; // 8119
							} // 8120
						} // 8121
					}; // 8122
					// 8123
					// Some attributes are constructed with empty-string values when not defined                                        // 8124
					attrHandle.id = attrHandle.name = attrHandle.coords = // 8125
					function (elem, name, isXML) {
						// 8126
						var ret; // 8127
						if (!isXML) {
							// 8128
							return (ret = elem.getAttributeNode(name)) && ret.value !== "" ? // 8129
							ret.value : // 8130
							null; // 8131
						} // 8132
					}; // 8133
					// 8134
					// Fixing value retrieval on a button requires this module                                                          // 8135
					jQuery.valHooks.button = { // 8136
						get: function (elem, name) {
							// 8137
							var ret = elem.getAttributeNode(name); // 8138
							if (ret && ret.specified) {
								// 8139
								return ret.value; // 8140
							} // 8141
						}, // 8142
						set: nodeHook.set // 8143
					}; // 8144
					// 8145
					// Set contenteditable to false on removals(#10429)                                                                 // 8146
					// Setting to empty string throws an error as an invalid value                                                      // 8147
					jQuery.attrHooks.contenteditable = { // 8148
						set: function (elem, value, name) {
							// 8149
							nodeHook.set(elem, value === "" ? false : value, name); // 8150
						} // 8151
					}; // 8152
					// 8153
					// Set width and height to auto instead of 0 on empty string( Bug #8150 )                                           // 8154
					// This is for removals                                                                                             // 8155
					jQuery.each(["width", "height"], function (i, name) {
						// 8156
						jQuery.attrHooks[name] = { // 8157
							set: function (elem, value) {
								// 8158
								if (value === "") {
									// 8159
									elem.setAttribute(name, "auto"); // 8160
									return value; // 8161
								} // 8162
							} // 8163
						}; // 8164
					}); // 8165
				} // 8166
				// 8167
				if (!support.style) {
					// 8168
					jQuery.attrHooks.style = { // 8169
						get: function (elem) {
							// 8170
							// Return undefined in the case of empty string                                                                   // 8171
							// Note: IE uppercases css property names, but if we were to .toLowerCase()                                       // 8172
							// .cssText, that would destroy case senstitivity in URL's, like in "background"                                  // 8173
							return elem.style.cssText || undefined; // 8174
						}, // 8175
						set: function (elem, value) {
							// 8176
							return elem.style.cssText = value + ""; // 8177
						} // 8178
					}; // 8179
				} // 8180
				// 8181
				// 8182
				// 8183
				// 8184
				var rfocusable = /^(?:input|select|textarea|button|object)$/i,
				    // 8185
				rclickable = /^(?:a|area)$/i; // 8186
				// 8187
				jQuery.fn.extend({ // 8188
					prop: function (name, value) {
						// 8189
						return access(this, jQuery.prop, name, value, arguments.length > 1); // 8190
					}, // 8191
					// 8192
					removeProp: function (name) {
						// 8193
						name = jQuery.propFix[name] || name; // 8194
						return this.each(function () {
							// 8195
							// try/catch handles cases where IE balks (such as removing a property on window)                                 // 8196
							try {
								// 8197
								this[name] = undefined; // 8198
								delete this[name]; // 8199
							} catch (e) {} // 8200
						}); // 8201
					} // 8202
				}); // 8203
				// 8204
				jQuery.extend({ // 8205
					propFix: { // 8206
						"for": "htmlFor", // 8207
						"class": "className" // 8208
					}, // 8209
					// 8210
					prop: function (elem, name, value) {
						// 8211
						var ret,
						    hooks,
						    notxml,
						    // 8212
						nType = elem.nodeType; // 8213
						// 8214
						// don't get/set properties on text, comment and attribute nodes                                                   // 8215
						if (!elem || nType === 3 || nType === 8 || nType === 2) {
							// 8216
							return; // 8217
						} // 8218
						// 8219
						notxml = nType !== 1 || !jQuery.isXMLDoc(elem); // 8220
						// 8221
						if (notxml) {
							// 8222
							// Fix name and attach hooks                                                                                      // 8223
							name = jQuery.propFix[name] || name; // 8224
							hooks = jQuery.propHooks[name]; // 8225
						} // 8226
						// 8227
						if (value !== undefined) {
							// 8228
							return hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined ? // 8229
							ret : // 8230
							elem[name] = value; // 8231
							// 8232
						} else {
							// 8233
							return hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null ? // 8234
							ret : // 8235
							elem[name]; // 8236
						} // 8237
					}, // 8238
					// 8239
					propHooks: { // 8240
						tabIndex: { // 8241
							get: function (elem) {
								// 8242
								// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set                      // 8243
								// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/         // 8244
								// Use proper attribute retrieval(#12072)                                                                        // 8245
								var tabindex = jQuery.find.attr(elem, "tabindex"); // 8246
								// 8247
								return tabindex ? // 8248
								parseInt(tabindex, 10) : // 8249
								rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? // 8250
								0 : // 8251
								-1; // 8252
							} // 8253
							// 8254
						} // 8255
					} }); // 8256
				// 8257
				// Some attributes require a special call on IE                                                                      // 8258
				// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx                                                  // 8259
				if (!support.hrefNormalized) {
					// 8260
					// href/src property should get the full normalized URL (#10299/#12915)                                             // 8261
					jQuery.each(["href", "src"], function (i, name) {
						// 8262
						jQuery.propHooks[name] = { // 8263
							get: function (elem) {
								// 8264
								return elem.getAttribute(name, 4); // 8265
							} // 8266
						}; // 8267
					}); // 8268
				} // 8269
				// 8270
				// Support: Safari, IE9+                                                                                             // 8271
				// mis-reports the default selected property of an option                                                            // 8272
				// Accessing the parent's selectedIndex property fixes it                                                            // 8273
				if (!support.optSelected) {
					// 8274
					jQuery.propHooks.selected = { // 8275
						get: function (elem) {
							// 8276
							var parent = elem.parentNode; // 8277
							// 8278
							if (parent) {
								// 8279
								parent.selectedIndex; // 8280
								// 8281
								// Make sure that it also works with optgroups, see #5701                                                        // 8282
								if (parent.parentNode) {
									// 8283
									parent.parentNode.selectedIndex; // 8284
								} // 8285
							} // 8286
							return null; // 8287
						} // 8288
					}; // 8289
				} // 8290
				// 8291
				jQuery.each([// 8292
				"tabIndex", // 8293
				"readOnly", // 8294
				"maxLength", // 8295
				"cellSpacing", // 8296
				"cellPadding", // 8297
				"rowSpan", // 8298
				"colSpan", // 8299
				"useMap", // 8300
				"frameBorder", // 8301
				"contentEditable" // 8302
				], function () {
					// 8303
					jQuery.propFix[this.toLowerCase()] = this; // 8304
				}); // 8305
				// 8306
				// IE6/7 call enctype encoding                                                                                       // 8307
				if (!support.enctype) {
					// 8308
					jQuery.propFix.enctype = "encoding"; // 8309
				} // 8310
				// 8311
				// 8312
				// 8313
				// 8314
				var rclass = /[\t\r\n\f]/g; // 8315
				// 8316
				jQuery.fn.extend({ // 8317
					addClass: function (value) {
						// 8318
						var classes,
						    elem,
						    cur,
						    clazz,
						    j,
						    finalValue,
						    // 8319
						i = 0,
						    // 8320
						len = this.length,
						    // 8321
						proceed = typeof value === "string" && value; // 8322
						// 8323
						if (jQuery.isFunction(value)) {
							// 8324
							return this.each(function (j) {
								// 8325
								jQuery(this).addClass(value.call(this, j, this.className)); // 8326
							}); // 8327
						} // 8328
						// 8329
						if (proceed) {
							// 8330
							// The disjunction here is for better compressibility (see removeClass)                                           // 8331
							classes = (value || "").match(rnotwhite) || []; // 8332
							// 8333
							for (; i < len; i++) {
								// 8334
								elem = this[i]; // 8335
								cur = elem.nodeType === 1 && (elem.className ? // 8336
								(" " + elem.className + " ").replace(rclass, " ") : // 8337
								" " // 8338
								); // 8339
								// 8340
								if (cur) {
									// 8341
									j = 0; // 8342
									while (clazz = classes[j++]) {
										// 8343
										if (cur.indexOf(" " + clazz + " ") < 0) {
											// 8344
											cur += clazz + " "; // 8345
										} // 8346
									} // 8347
									// 8348
									// only assign if different to avoid unneeded rendering.                                                        // 8349
									finalValue = jQuery.trim(cur); // 8350
									if (elem.className !== finalValue) {
										// 8351
										elem.className = finalValue; // 8352
									} // 8353
								} // 8354
							} // 8355
						} // 8356
						// 8357
						return this; // 8358
					}, // 8359
					// 8360
					removeClass: function (value) {
						// 8361
						var classes,
						    elem,
						    cur,
						    clazz,
						    j,
						    finalValue,
						    // 8362
						i = 0,
						    // 8363
						len = this.length,
						    // 8364
						proceed = arguments.length === 0 || typeof value === "string" && value; // 8365
						// 8366
						if (jQuery.isFunction(value)) {
							// 8367
							return this.each(function (j) {
								// 8368
								jQuery(this).removeClass(value.call(this, j, this.className)); // 8369
							}); // 8370
						} // 8371
						if (proceed) {
							// 8372
							classes = (value || "").match(rnotwhite) || []; // 8373
							// 8374
							for (; i < len; i++) {
								// 8375
								elem = this[i]; // 8376
								// This expression is here for better compressibility (see addClass)                                             // 8377
								cur = elem.nodeType === 1 && (elem.className ? // 8378
								(" " + elem.className + " ").replace(rclass, " ") : // 8379
								"" // 8380
								); // 8381
								// 8382
								if (cur) {
									// 8383
									j = 0; // 8384
									while (clazz = classes[j++]) {
										// 8385
										// Remove *all* instances                                                                                      // 8386
										while (cur.indexOf(" " + clazz + " ") >= 0) {
											// 8387
											cur = cur.replace(" " + clazz + " ", " "); // 8388
										} // 8389
									} // 8390
									// 8391
									// only assign if different to avoid unneeded rendering.                                                        // 8392
									finalValue = value ? jQuery.trim(cur) : ""; // 8393
									if (elem.className !== finalValue) {
										// 8394
										elem.className = finalValue; // 8395
									} // 8396
								} // 8397
							} // 8398
						} // 8399
						// 8400
						return this; // 8401
					}, // 8402
					// 8403
					toggleClass: function (value, stateVal) {
						// 8404
						var type = typeof value; // 8405
						// 8406
						if (typeof stateVal === "boolean" && type === "string") {
							// 8407
							return stateVal ? this.addClass(value) : this.removeClass(value); // 8408
						} // 8409
						// 8410
						if (jQuery.isFunction(value)) {
							// 8411
							return this.each(function (i) {
								// 8412
								jQuery(this).toggleClass(value.call(this, i, this.className, stateVal), stateVal); // 8413
							}); // 8414
						} // 8415
						// 8416
						return this.each(function () {
							// 8417
							if (type === "string") {
								// 8418
								// toggle individual class names                                                                                 // 8419
								var className,
								    // 8420
								i = 0,
								    // 8421
								self = jQuery(this),
								    // 8422
								classNames = value.match(rnotwhite) || []; // 8423
								// 8424
								while (className = classNames[i++]) {
									// 8425
									// check each className given, space separated list                                                             // 8426
									if (self.hasClass(className)) {
										// 8427
										self.removeClass(className); // 8428
									} else {
										// 8429
										self.addClass(className); // 8430
									} // 8431
								} // 8432
								// 8433
								// Toggle whole class name                                                                                        // 8434
							} else if (type === strundefined || type === "boolean") {
								// 8435
								if (this.className) {
									// 8436
									// store className if set                                                                                       // 8437
									jQuery._data(this, "__className__", this.className); // 8438
								} // 8439
								// 8440
								// If the element has a class name or if we're passed "false",                                                   // 8441
								// then remove the whole classname (if there was one, the above saved it).                                       // 8442
								// Otherwise bring back whatever was previously saved (if anything),                                             // 8443
								// falling back to the empty string if nothing was stored.                                                       // 8444
								this.className = this.className || value === false ? "" : jQuery._data(this, "__className__") || ""; // 8445
							} // 8446
						}); // 8447
					}, // 8448
					// 8449
					hasClass: function (selector) {
						// 8450
						var className = " " + selector + " ",
						    // 8451
						i = 0,
						    // 8452
						l = this.length; // 8453
						for (; i < l; i++) {
							// 8454
							if (this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf(className) >= 0) {
								// 8455
								return true; // 8456
							} // 8457
						} // 8458
						// 8459
						return false; // 8460
					} // 8461
				}); // 8462
				// 8463
				// 8464
				// 8465
				// 8466
				// Return jQuery for attributes-only inclusion                                                                       // 8467
				// 8468
				// 8469
				jQuery.each(("blur focus focusin focusout load resize scroll unload click dblclick " + // 8470
				"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + // 8471
				"change select submit keydown keypress keyup error contextmenu").split(" "), function (i, name) {
					// 8472
					// 8473
					// Handle event binding                                                                                             // 8474
					jQuery.fn[name] = function (data, fn) {
						// 8475
						return arguments.length > 0 ? // 8476
						this.on(name, null, data, fn) : // 8477
						this.trigger(name); // 8478
					}; // 8479
				}); // 8480
				// 8481
				jQuery.fn.extend({ // 8482
					hover: function (fnOver, fnOut) {
						// 8483
						return this.mouseenter(fnOver).mouseleave(fnOut || fnOver); // 8484
					}, // 8485
					// 8486
					bind: function (types, data, fn) {
						// 8487
						return this.on(types, null, data, fn); // 8488
					}, // 8489
					unbind: function (types, fn) {
						// 8490
						return this.off(types, null, fn); // 8491
					}, // 8492
					// 8493
					delegate: function (selector, types, data, fn) {
						// 8494
						return this.on(types, selector, data, fn); // 8495
					}, // 8496
					undelegate: function (selector, types, fn) {
						// 8497
						// ( namespace ) or ( selector, types [, fn] )                                                                     // 8498
						return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn); // 8499
					} // 8500
				}); // 8501
				// 8502
				// 8503
				var nonce = jQuery.now(); // 8504
				// 8505
				var rquery = /\?/; // 8506
				// 8507
				// 8508
				// 8509
				var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
				// 8511
				jQuery.parseJSON = function (data) {
					// 8512
					// Attempt to parse using the native JSON parser first                                                              // 8513
					if (window.JSON && window.JSON.parse) {
						// 8514
						// Support: Android 2.3                                                                                            // 8515
						// Workaround failure to string-cast null input                                                                    // 8516
						return window.JSON.parse(data + ""); // 8517
					} // 8518
					// 8519
					var requireNonComma,
					    // 8520
					depth = null,
					    // 8521
					str = jQuery.trim(data + ""); // 8522
					// 8523
					// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains                            // 8524
					// after removing valid tokens                                                                                      // 8525
					return str && !jQuery.trim(str.replace(rvalidtokens, function (token, comma, open, close) {
						// 8526
						// 8527
						// Force termination if we see a misplaced comma                                                                   // 8528
						if (requireNonComma && comma) {
							// 8529
							depth = 0; // 8530
						} // 8531
						// 8532
						// Perform no more replacements after returning to outermost depth                                                 // 8533
						if (depth === 0) {
							// 8534
							return token; // 8535
						} // 8536
						// 8537
						// Commas must not follow "[", "{", or ","                                                                         // 8538
						requireNonComma = open || comma; // 8539
						// 8540
						// Determine new depth                                                                                             // 8541
						// array/object open ("[" or "{"): depth += true - false (increment)                                               // 8542
						// array/object close ("]" or "}"): depth += false - true (decrement)                                              // 8543
						// other cases ("," or primitive): depth += true - true (numeric cast)                                             // 8544
						depth += !close - !open; // 8545
						// 8546
						// Remove this token                                                                                               // 8547
						return ""; // 8548
					})) ? // 8549
					Function("return " + str)() : // 8550
					jQuery.error("Invalid JSON: " + data); // 8551
				}; // 8552
				// 8553
				// 8554
				// Cross-browser xml parsing                                                                                         // 8555
				jQuery.parseXML = function (data) {
					// 8556
					var xml, tmp; // 8557
					if (!data || typeof data !== "string") {
						// 8558
						return null; // 8559
					} // 8560
					try {
						// 8561
						if (window.DOMParser) {
							// Standard                                                                              // 8562
							tmp = new DOMParser(); // 8563
							xml = tmp.parseFromString(data, "text/xml"); // 8564
						} else {
							// IE                                                                                                     // 8565
							xml = new ActiveXObject("Microsoft.XMLDOM"); // 8566
							xml.async = "false"; // 8567
							xml.loadXML(data); // 8568
						} // 8569
					} catch (e) {
						// 8570
						xml = undefined; // 8571
					} // 8572
					if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) {
						// 8573
						jQuery.error("Invalid XML: " + data); // 8574
					} // 8575
					return xml; // 8576
				}; // 8577
				// 8578
				// 8579
				var // 8580
				// Document location                                                                                                // 8581
				ajaxLocParts,
				    // 8582
				ajaxLocation,
				    // 8583
				// 8584
				rhash = /#.*$/,
				    // 8585
				rts = /([?&])_=[^&]*/,
				    // 8586
				rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
				    // IE leaves an \r character at EOL                                     // 8587
				// #7653, #8125, #8152: local protocol detection                                                                    // 8588
				rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
				    // 8589
				rnoContent = /^(?:GET|HEAD)$/,
				    // 8590
				rprotocol = /^\/\//,
				    // 8591
				rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
				    // 8592
				// 8593
				/* Prefilters                                                                                                       // 8594
     * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)                              // 8595
     * 2) These are called:                                                                                             // 8596
     *    - BEFORE asking for a transport                                                                               // 8597
     *    - AFTER param serialization (s.data is a string if s.processData is true)                                     // 8598
     * 3) key is the dataType                                                                                           // 8599
     * 4) the catchall symbol "*" can be used                                                                           // 8600
     * 5) execution will start with transport dataType and THEN continue down to "*" if needed                          // 8601
     */ // 8602
				prefilters = {},
				    // 8603
				// 8604
				/* Transports bindings                                                                                              // 8605
     * 1) key is the dataType                                                                                           // 8606
     * 2) the catchall symbol "*" can be used                                                                           // 8607
     * 3) selection will start with transport dataType and THEN go to "*" if needed                                     // 8608
     */ // 8609
				transports = {},
				    // 8610
				// 8611
				// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression                             // 8612
				allTypes = "*/".concat("*"); // 8613
				// 8614
				// #8138, IE may throw an exception when accessing                                                                   // 8615
				// a field from window.location if document.domain has been set                                                      // 8616
				try {
					// 8617
					ajaxLocation = location.href; // 8618
				} catch (e) {
					// 8619
					// Use the href attribute of an A element                                                                           // 8620
					// since IE will modify it given document.location                                                                  // 8621
					ajaxLocation = document.createElement("a"); // 8622
					ajaxLocation.href = ""; // 8623
					ajaxLocation = ajaxLocation.href; // 8624
				} // 8625
				// 8626
				// Segment location into parts                                                                                       // 8627
				ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || []; // 8628
				// 8629
				// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport                                              // 8630
				function addToPrefiltersOrTransports(structure) {
					// 8631
					// 8632
					// dataTypeExpression is optional and defaults to "*"                                                               // 8633
					return function (dataTypeExpression, func) {
						// 8634
						// 8635
						if (typeof dataTypeExpression !== "string") {
							// 8636
							func = dataTypeExpression; // 8637
							dataTypeExpression = "*"; // 8638
						} // 8639
						// 8640
						var dataType,
						    // 8641
						i = 0,
						    // 8642
						dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || []; // 8643
						// 8644
						if (jQuery.isFunction(func)) {
							// 8645
							// For each dataType in the dataTypeExpression                                                                    // 8646
							while (dataType = dataTypes[i++]) {
								// 8647
								// Prepend if requested                                                                                          // 8648
								if (dataType.charAt(0) === "+") {
									// 8649
									dataType = dataType.slice(1) || "*"; // 8650
									(structure[dataType] = structure[dataType] || []).unshift(func); // 8651
									// 8652
									// Otherwise append                                                                                              // 8653
								} else {
									// 8654
									(structure[dataType] = structure[dataType] || []).push(func); // 8655
								} // 8656
							} // 8657
						} // 8658
					}; // 8659
				} // 8660
				// 8661
				// Base inspection function for prefilters and transports                                                            // 8662
				function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
					// 8663
					// 8664
					var inspected = {},
					    // 8665
					seekingTransport = structure === transports; // 8666
					// 8667
					function inspect(dataType) {
						// 8668
						var selected; // 8669
						inspected[dataType] = true; // 8670
						jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
							// 8671
							var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR); // 8672
							if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
								// 8673
								options.dataTypes.unshift(dataTypeOrTransport); // 8674
								inspect(dataTypeOrTransport); // 8675
								return false; // 8676
							} else if (seekingTransport) {
								// 8677
								return !(selected = dataTypeOrTransport); // 8678
							} // 8679
						}); // 8680
						return selected; // 8681
					} // 8682
					// 8683
					return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*"); // 8684
				} // 8685
				// 8686
				// A special extend for ajax options                                                                                 // 8687
				// that takes "flat" options (not to be deep extended)                                                               // 8688
				// Fixes #9887                                                                                                       // 8689
				function ajaxExtend(target, src) {
					// 8690
					var deep,
					    key,
					    // 8691
					flatOptions = jQuery.ajaxSettings.flatOptions || {}; // 8692
					// 8693
					for (key in src) {
						// 8694
						if (src[key] !== undefined) {
							// 8695
							(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key]; // 8696
						} // 8697
					} // 8698
					if (deep) {
						// 8699
						jQuery.extend(true, target, deep); // 8700
					} // 8701
					// 8702
					return target; // 8703
				} // 8704
				// 8705
				/* Handles responses to an ajax request:                                                                             // 8706
     * - finds the right dataType (mediates between content-type and expected dataType)                                  // 8707
     * - returns the corresponding response                                                                              // 8708
     */ // 8709
				function ajaxHandleResponses(s, jqXHR, responses) {
					// 8710
					var firstDataType,
					    ct,
					    finalDataType,
					    type,
					    // 8711
					contents = s.contents,
					    // 8712
					dataTypes = s.dataTypes; // 8713
					// 8714
					// Remove auto dataType and get content-type in the process                                                         // 8715
					while (dataTypes[0] === "*") {
						// 8716
						dataTypes.shift(); // 8717
						if (ct === undefined) {
							// 8718
							ct = s.mimeType || jqXHR.getResponseHeader("Content-Type"); // 8719
						} // 8720
					} // 8721
					// 8722
					// Check if we're dealing with a known content-type                                                                 // 8723
					if (ct) {
						// 8724
						for (type in contents) {
							// 8725
							if (contents[type] && contents[type].test(ct)) {
								// 8726
								dataTypes.unshift(type); // 8727
								break; // 8728
							} // 8729
						} // 8730
					} // 8731
					// 8732
					// Check to see if we have a response for the expected dataType                                                     // 8733
					if (dataTypes[0] in responses) {
						// 8734
						finalDataType = dataTypes[0]; // 8735
					} else {
						// 8736
						// Try convertible dataTypes                                                                                       // 8737
						for (type in responses) {
							// 8738
							if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
								// 8739
								finalDataType = type; // 8740
								break; // 8741
							} // 8742
							if (!firstDataType) {
								// 8743
								firstDataType = type; // 8744
							} // 8745
						} // 8746
						// Or just use first one                                                                                           // 8747
						finalDataType = finalDataType || firstDataType; // 8748
					} // 8749
					// 8750
					// If we found a dataType                                                                                           // 8751
					// We add the dataType to the list if needed                                                                        // 8752
					// and return the corresponding response                                                                            // 8753
					if (finalDataType) {
						// 8754
						if (finalDataType !== dataTypes[0]) {
							// 8755
							dataTypes.unshift(finalDataType); // 8756
						} // 8757
						return responses[finalDataType]; // 8758
					} // 8759
				} // 8760
				// 8761
				/* Chain conversions given the request and the original response                                                     // 8762
     * Also sets the responseXXX fields on the jqXHR instance                                                            // 8763
     */ // 8764
				function ajaxConvert(s, response, jqXHR, isSuccess) {
					// 8765
					var conv2,
					    current,
					    conv,
					    tmp,
					    prev,
					    // 8766
					converters = {},
					    // 8767
					// Work with a copy of dataTypes in case we need to modify it for conversion                                       // 8768
					dataTypes = s.dataTypes.slice(); // 8769
					// 8770
					// Create converters map with lowercased keys                                                                       // 8771
					if (dataTypes[1]) {
						// 8772
						for (conv in s.converters) {
							// 8773
							converters[conv.toLowerCase()] = s.converters[conv]; // 8774
						} // 8775
					} // 8776
					// 8777
					current = dataTypes.shift(); // 8778
					// 8779
					// Convert to each sequential dataType                                                                              // 8780
					while (current) {
						// 8781
						// 8782
						if (s.responseFields[current]) {
							// 8783
							jqXHR[s.responseFields[current]] = response; // 8784
						} // 8785
						// 8786
						// Apply the dataFilter if provided                                                                                // 8787
						if (!prev && isSuccess && s.dataFilter) {
							// 8788
							response = s.dataFilter(response, s.dataType); // 8789
						} // 8790
						// 8791
						prev = current; // 8792
						current = dataTypes.shift(); // 8793
						// 8794
						if (current) {
							// 8795
							// 8796
							// There's only work to do if current dataType is non-auto                                                        // 8797
							if (current === "*") {
								// 8798
								// 8799
								current = prev; // 8800
								// 8801
								// Convert response if prev dataType is non-auto and differs from current                                         // 8802
							} else if (prev !== "*" && prev !== current) {
								// 8803
								// 8804
								// Seek a direct converter                                                                                       // 8805
								conv = converters[prev + " " + current] || converters["* " + current]; // 8806
								// 8807
								// If none found, seek a pair                                                                                    // 8808
								if (!conv) {
									// 8809
									for (conv2 in converters) {
										// 8810
										// 8811
										// If conv2 outputs current                                                                                    // 8812
										tmp = conv2.split(" "); // 8813
										if (tmp[1] === current) {
											// 8814
											// 8815
											// If prev can be converted to accepted input                                                                 // 8816
											conv = converters[prev + " " + tmp[0]] || // 8817
											converters["* " + tmp[0]]; // 8818
											if (conv) {
												// 8819
												// Condense equivalence converters                                                                           // 8820
												if (conv === true) {
													// 8821
													conv = converters[conv2]; // 8822
													// 8823
													// Otherwise, insert the intermediate dataType                                                               // 8824
												} else if (converters[conv2] !== true) {
													// 8825
													current = tmp[0]; // 8826
													dataTypes.unshift(tmp[1]); // 8827
												} // 8828
												break; // 8829
											} // 8830
										} // 8831
									} // 8832
								} // 8833
								// 8834
								// Apply converter (if not an equivalence)                                                                       // 8835
								if (conv !== true) {
									// 8836
									// 8837
									// Unless errors are allowed to bubble, catch and return them                                                   // 8838
									if (conv && s["throws"]) {
										// 8839
										response = conv(response); // 8840
									} else {
										// 8841
										try {
											// 8842
											response = conv(response); // 8843
										} catch (e) {
											// 8844
											return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current }; // 8845
										} // 8846
									} // 8847
								} // 8848
							} // 8849
						} // 8850
					} // 8851
					// 8852
					return { state: "success", data: response }; // 8853
				} // 8854
				// 8855
				jQuery.extend({ // 8856
					// 8857
					// Counter for holding the number of active queries                                                                 // 8858
					active: 0, // 8859
					// 8860
					// Last-Modified header cache for next request                                                                      // 8861
					lastModified: {}, // 8862
					etag: {}, // 8863
					// 8864
					ajaxSettings: { // 8865
						url: ajaxLocation, // 8866
						type: "GET", // 8867
						isLocal: rlocalProtocol.test(ajaxLocParts[1]), // 8868
						global: true, // 8869
						processData: true, // 8870
						async: true, // 8871
						contentType: "application/x-www-form-urlencoded; charset=UTF-8", // 8872
						/*                                                                                                                 // 8873
      timeout: 0,                                                                                                        // 8874
      data: null,                                                                                                        // 8875
      dataType: null,                                                                                                    // 8876
      username: null,                                                                                                    // 8877
      password: null,                                                                                                    // 8878
      cache: null,                                                                                                       // 8879
      throws: false,                                                                                                     // 8880
      traditional: false,                                                                                                // 8881
      headers: {},                                                                                                       // 8882
      */ // 8883
						// 8884
						accepts: { // 8885
							"*": allTypes, // 8886
							text: "text/plain", // 8887
							html: "text/html", // 8888
							xml: "application/xml, text/xml", // 8889
							json: "application/json, text/javascript" // 8890
						}, // 8891
						// 8892
						contents: { // 8893
							xml: /xml/, // 8894
							html: /html/, // 8895
							json: /json/ // 8896
						}, // 8897
						// 8898
						responseFields: { // 8899
							xml: "responseXML", // 8900
							text: "responseText", // 8901
							json: "responseJSON" // 8902
						}, // 8903
						// 8904
						// Data converters                                                                                                 // 8905
						// Keys separate source (or catchall "*") and destination types with a single space                                // 8906
						converters: { // 8907
							// 8908
							// Convert anything to text                                                                                       // 8909
							"* text": String, // 8910
							// 8911
							// Text to html (true = no transformation)                                                                        // 8912
							"text html": true, // 8913
							// 8914
							// Evaluate text as a json expression                                                                             // 8915
							"text json": jQuery.parseJSON, // 8916
							// 8917
							// Parse text as xml                                                                                              // 8918
							"text xml": jQuery.parseXML // 8919
						}, // 8920
						// 8921
						// For options that shouldn't be deep extended:                                                                    // 8922
						// you can add your own custom options here if                                                                     // 8923
						// and when you create one that shouldn't be                                                                       // 8924
						// deep extended (see ajaxExtend)                                                                                  // 8925
						flatOptions: { // 8926
							url: true, // 8927
							context: true // 8928
							// 8929
						} }, // 8930
					// 8931
					// Creates a full fledged settings object into target                                                               // 8932
					// with both ajaxSettings and settings fields.                                                                      // 8933
					// If target is omitted, writes into ajaxSettings.                                                                  // 8934
					ajaxSetup: function (target, settings) {
						// 8935
						return settings ? // 8936
						// 8937
						// Building a settings object                                                                                     // 8938
						ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // 8939
						// 8940
						// Extending ajaxSettings                                                                                         // 8941
						ajaxExtend(jQuery.ajaxSettings, target); // 8942
					}, // 8943
					// 8944
					ajaxPrefilter: addToPrefiltersOrTransports(prefilters), // 8945
					ajaxTransport: addToPrefiltersOrTransports(transports), // 8946
					// 8947
					// Main method                                                                                                      // 8948
					ajax: function (url, options) {
						// 8949
						// 8950
						// If url is an object, simulate pre-1.5 signature                                                                 // 8951
						if (typeof url === "object") {
							// 8952
							options = url; // 8953
							url = undefined; // 8954
						} // 8955
						// 8956
						// Force options to be an object                                                                                   // 8957
						options = options || {}; // 8958
						// 8959
						var // Cross-domain detection vars                                                                                 // 8960
						parts,
						    // 8961
						// Loop variable                                                                                                  // 8962
						i,
						    // 8963
						// URL without anti-cache param                                                                                   // 8964
						cacheURL,
						    // 8965
						// Response headers as string                                                                                     // 8966
						responseHeadersString,
						    // 8967
						// timeout handle                                                                                                 // 8968
						timeoutTimer,
						    // 8969
						// 8970
						// To know if global events are to be dispatched                                                                  // 8971
						fireGlobals,
						    // 8972
						// 8973
						transport,
						    // 8974
						// Response headers                                                                                               // 8975
						responseHeaders,
						    // 8976
						// Create the final options object                                                                                // 8977
						s = jQuery.ajaxSetup({}, options),
						    // 8978
						// Callbacks context                                                                                              // 8979
						callbackContext = s.context || s,
						    // 8980
						// Context for global events is callbackContext if it is a DOM node or jQuery collection                          // 8981
						globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? // 8982
						jQuery(callbackContext) : // 8983
						jQuery.event,
						    // 8984
						// Deferreds                                                                                                      // 8985
						deferred = jQuery.Deferred(),
						    // 8986
						completeDeferred = jQuery.Callbacks("once memory"),
						    // 8987
						// Status-dependent callbacks                                                                                     // 8988
						statusCode = s.statusCode || {},
						    // 8989
						// Headers (they are sent all at once)                                                                            // 8990
						requestHeaders = {},
						    // 8991
						requestHeadersNames = {},
						    // 8992
						// The jqXHR state                                                                                                // 8993
						state = 0,
						    // 8994
						// Default abort message                                                                                          // 8995
						strAbort = "canceled",
						    // 8996
						// Fake xhr                                                                                                       // 8997
						jqXHR = { // 8998
							readyState: 0, // 8999
							// 9000
							// Builds headers hashtable if needed                                                                            // 9001
							getResponseHeader: function (key) {
								// 9002
								var match; // 9003
								if (state === 2) {
									// 9004
									if (!responseHeaders) {
										// 9005
										responseHeaders = {}; // 9006
										while (match = rheaders.exec(responseHeadersString)) {
											// 9007
											responseHeaders[match[1].toLowerCase()] = match[2]; // 9008
										} // 9009
									} // 9010
									match = responseHeaders[key.toLowerCase()]; // 9011
								} // 9012
								return match == null ? null : match; // 9013
							}, // 9014
							// 9015
							// Raw string                                                                                                    // 9016
							getAllResponseHeaders: function () {
								// 9017
								return state === 2 ? responseHeadersString : null; // 9018
							}, // 9019
							// 9020
							// Caches the header                                                                                             // 9021
							setRequestHeader: function (name, value) {
								// 9022
								var lname = name.toLowerCase(); // 9023
								if (!state) {
									// 9024
									name = requestHeadersNames[lname] = requestHeadersNames[lname] || name; // 9025
									requestHeaders[name] = value; // 9026
								} // 9027
								return this; // 9028
							}, // 9029
							// 9030
							// Overrides response content-type header                                                                        // 9031
							overrideMimeType: function (type) {
								// 9032
								if (!state) {
									// 9033
									s.mimeType = type; // 9034
								} // 9035
								return this; // 9036
							}, // 9037
							// 9038
							// Status-dependent callbacks                                                                                    // 9039
							statusCode: function (map) {
								// 9040
								var code; // 9041
								if (map) {
									// 9042
									if (state < 2) {
										// 9043
										for (code in map) {
											// 9044
											// Lazy-add the new callback in a way that preserves old ones                                                // 9045
											statusCode[code] = [statusCode[code], map[code]]; // 9046
										} // 9047
									} else {
										// 9048
										// Execute the appropriate callbacks                                                                          // 9049
										jqXHR.always(map[jqXHR.status]); // 9050
									} // 9051
								} // 9052
								return this; // 9053
							}, // 9054
							// 9055
							// Cancel the request                                                                                            // 9056
							abort: function (statusText) {
								// 9057
								var finalText = statusText || strAbort; // 9058
								if (transport) {
									// 9059
									transport.abort(finalText); // 9060
								} // 9061
								done(0, finalText); // 9062
								return this; // 9063
							} // 9064
						}; // 9065
						// 9066
						// Attach deferreds                                                                                                // 9067
						deferred.promise(jqXHR).complete = completeDeferred.add; // 9068
						jqXHR.success = jqXHR.done; // 9069
						jqXHR.error = jqXHR.fail; // 9070
						// 9071
						// Remove hash character (#7531: and string promotion)                                                             // 9072
						// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)                                         // 9073
						// Handle falsy url in the settings object (#10093: consistency with old signature)                                // 9074
						// We also use the url parameter if available                                                                      // 9075
						s.url = ((url || s.url || ajaxLocation) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//");
						// 9077
						// Alias method option to type as per ticket #12004                                                                // 9078
						s.type = options.method || options.type || s.method || s.type; // 9079
						// 9080
						// Extract dataTypes list                                                                                          // 9081
						s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [""]; // 9082
						// 9083
						// A cross-domain request is in order when we have a protocol:host:port mismatch                                   // 9084
						if (s.crossDomain == null) {
							// 9085
							parts = rurl.exec(s.url.toLowerCase()); // 9086
							s.crossDomain = !!(parts && ( // 9087
							parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] || // 9088
							(parts[3] || (parts[1] === "http:" ? "80" : "443")) !== ( // 9089
							ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? "80" : "443"))) // 9090
							); // 9091
						} // 9092
						// 9093
						// Convert data if not already a string                                                                            // 9094
						if (s.data && s.processData && typeof s.data !== "string") {
							// 9095
							s.data = jQuery.param(s.data, s.traditional); // 9096
						} // 9097
						// 9098
						// Apply prefilters                                                                                                // 9099
						inspectPrefiltersOrTransports(prefilters, s, options, jqXHR); // 9100
						// 9101
						// If request was aborted inside a prefilter, stop there                                                           // 9102
						if (state === 2) {
							// 9103
							return jqXHR; // 9104
						} // 9105
						// 9106
						// We can fire global events as of now if asked to                                                                 // 9107
						fireGlobals = s.global; // 9108
						// 9109
						// Watch for a new set of requests                                                                                 // 9110
						if (fireGlobals && jQuery.active++ === 0) {
							// 9111
							jQuery.event.trigger("ajaxStart"); // 9112
						} // 9113
						// 9114
						// Uppercase the type                                                                                              // 9115
						s.type = s.type.toUpperCase(); // 9116
						// 9117
						// Determine if request has content                                                                                // 9118
						s.hasContent = !rnoContent.test(s.type); // 9119
						// 9120
						// Save the URL in case we're toying with the If-Modified-Since                                                    // 9121
						// and/or If-None-Match header later on                                                                            // 9122
						cacheURL = s.url; // 9123
						// 9124
						// More options handling for requests with no content                                                              // 9125
						if (!s.hasContent) {
							// 9126
							// 9127
							// If data is available, append data to url                                                                       // 9128
							if (s.data) {
								// 9129
								cacheURL = s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data; // 9130
								// #9682: remove data so that it's not used in an eventual retry                                                 // 9131
								delete s.data; // 9132
							} // 9133
							// 9134
							// Add anti-cache in url if needed                                                                                // 9135
							if (s.cache === false) {
								// 9136
								s.url = rts.test(cacheURL) ? // 9137
								// 9138
								// If there is already a '_' parameter, set its value                                                           // 9139
								cacheURL.replace(rts, "$1_=" + nonce++) : // 9140
								// 9141
								// Otherwise add one to the end                                                                                 // 9142
								cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++; // 9143
							} // 9144
						} // 9145
						// 9146
						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.                                   // 9147
						if (s.ifModified) {
							// 9148
							if (jQuery.lastModified[cacheURL]) {
								// 9149
								jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]); // 9150
							} // 9151
							if (jQuery.etag[cacheURL]) {
								// 9152
								jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]); // 9153
							} // 9154
						} // 9155
						// 9156
						// Set the correct header, if data is being sent                                                                   // 9157
						if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
							// 9158
							jqXHR.setRequestHeader("Content-Type", s.contentType); // 9159
						} // 9160
						// 9161
						// Set the Accepts header for the server, depending on the dataType                                                // 9162
						jqXHR.setRequestHeader( // 9163
						"Accept", // 9164
						s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? // 9165
						s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : // 9166
						s.accepts["*"] // 9167
						); // 9168
						// 9169
						// Check for headers option                                                                                        // 9170
						for (i in s.headers) {
							// 9171
							jqXHR.setRequestHeader(i, s.headers[i]); // 9172
						} // 9173
						// 9174
						// Allow custom headers/mimetypes and early abort                                                                  // 9175
						if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
							// 9176
							// Abort if not done already and return                                                                           // 9177
							return jqXHR.abort(); // 9178
						} // 9179
						// 9180
						// aborting is no longer a cancellation                                                                            // 9181
						strAbort = "abort"; // 9182
						// 9183
						// Install callbacks on deferreds                                                                                  // 9184
						for (i in { success: 1, error: 1, complete: 1 }) {
							// 9185
							jqXHR[i](s[i]); // 9186
						} // 9187
						// 9188
						// Get transport                                                                                                   // 9189
						transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR); // 9190
						// 9191
						// If no transport, we auto-abort                                                                                  // 9192
						if (!transport) {
							// 9193
							done(-1, "No Transport"); // 9194
						} else {
							// 9195
							jqXHR.readyState = 1; // 9196
							// 9197
							// Send global event                                                                                              // 9198
							if (fireGlobals) {
								// 9199
								globalEventContext.trigger("ajaxSend", [jqXHR, s]); // 9200
							} // 9201
							// Timeout                                                                                                        // 9202
							if (s.async && s.timeout > 0) {
								// 9203
								timeoutTimer = setTimeout(function () {
									// 9204
									jqXHR.abort("timeout"); // 9205
								}, s.timeout); // 9206
							} // 9207
							// 9208
							try {
								// 9209
								state = 1; // 9210
								transport.send(requestHeaders, done); // 9211
							} catch (e) {
								// 9212
								// Propagate exception as error if not done                                                                      // 9213
								if (state < 2) {
									// 9214
									done(-1, e); // 9215
									// Simply rethrow otherwise                                                                                      // 9216
								} else {
									// 9217
									throw e; // 9218
								} // 9219
							} // 9220
						} // 9221
						// 9222
						// Callback for when everything is done                                                                            // 9223
						function done(status, nativeStatusText, responses, headers) {
							// 9224
							var isSuccess,
							    success,
							    error,
							    response,
							    modified,
							    // 9225
							statusText = nativeStatusText; // 9226
							// 9227
							// Called once                                                                                                    // 9228
							if (state === 2) {
								// 9229
								return; // 9230
							} // 9231
							// 9232
							// State is "done" now                                                                                            // 9233
							state = 2; // 9234
							// 9235
							// Clear timeout if it exists                                                                                     // 9236
							if (timeoutTimer) {
								// 9237
								clearTimeout(timeoutTimer); // 9238
							} // 9239
							// 9240
							// Dereference transport for early garbage collection                                                             // 9241
							// (no matter how long the jqXHR object will be used)                                                             // 9242
							transport = undefined; // 9243
							// 9244
							// Cache response headers                                                                                         // 9245
							responseHeadersString = headers || ""; // 9246
							// 9247
							// Set readyState                                                                                                 // 9248
							jqXHR.readyState = status > 0 ? 4 : 0; // 9249
							// 9250
							// Determine if successful                                                                                        // 9251
							isSuccess = status >= 200 && status < 300 || status === 304; // 9252
							// 9253
							// Get response data                                                                                              // 9254
							if (responses) {
								// 9255
								response = ajaxHandleResponses(s, jqXHR, responses); // 9256
							} // 9257
							// 9258
							// Convert no matter what (that way responseXXX fields are always set)                                            // 9259
							response = ajaxConvert(s, response, jqXHR, isSuccess); // 9260
							// 9261
							// If successful, handle type chaining                                                                            // 9262
							if (isSuccess) {
								// 9263
								// 9264
								// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.                                 // 9265
								if (s.ifModified) {
									// 9266
									modified = jqXHR.getResponseHeader("Last-Modified"); // 9267
									if (modified) {
										// 9268
										jQuery.lastModified[cacheURL] = modified; // 9269
									} // 9270
									modified = jqXHR.getResponseHeader("etag"); // 9271
									if (modified) {
										// 9272
										jQuery.etag[cacheURL] = modified; // 9273
									} // 9274
								} // 9275
								// 9276
								// if no content                                                                                                 // 9277
								if (status === 204 || s.type === "HEAD") {
									// 9278
									statusText = "nocontent"; // 9279
									// 9280
									// if not modified                                                                                               // 9281
								} else if (status === 304) {
									// 9282
									statusText = "notmodified"; // 9283
									// 9284
									// If we have data, let's convert it                                                                             // 9285
								} else {
									// 9286
									statusText = response.state; // 9287
									success = response.data; // 9288
									error = response.error; // 9289
									isSuccess = !error; // 9290
								} // 9291
							} else {
								// 9292
								// We extract error from statusText                                                                              // 9293
								// then normalize statusText and status for non-aborts                                                           // 9294
								error = statusText; // 9295
								if (status || !statusText) {
									// 9296
									statusText = "error"; // 9297
									if (status < 0) {
										// 9298
										status = 0; // 9299
									} // 9300
								} // 9301
							} // 9302
							// 9303
							// Set data for the fake xhr object                                                                               // 9304
							jqXHR.status = status; // 9305
							jqXHR.statusText = (nativeStatusText || statusText) + ""; // 9306
							// 9307
							// Success/Error                                                                                                  // 9308
							if (isSuccess) {
								// 9309
								deferred.resolveWith(callbackContext, [success, statusText, jqXHR]); // 9310
							} else {
								// 9311
								deferred.rejectWith(callbackContext, [jqXHR, statusText, error]); // 9312
							} // 9313
							// 9314
							// Status-dependent callbacks                                                                                     // 9315
							jqXHR.statusCode(statusCode); // 9316
							statusCode = undefined; // 9317
							// 9318
							if (fireGlobals) {
								// 9319
								globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", // 9320
								[jqXHR, s, isSuccess ? success : error]); // 9321
							} // 9322
							// 9323
							// Complete                                                                                                       // 9324
							completeDeferred.fireWith(callbackContext, [jqXHR, statusText]); // 9325
							// 9326
							if (fireGlobals) {
								// 9327
								globalEventContext.trigger("ajaxComplete", [jqXHR, s]); // 9328
								// Handle the global AJAX counter                                                                                // 9329
								if (! --jQuery.active) {
									// 9330
									jQuery.event.trigger("ajaxStop"); // 9331
								} // 9332
							} // 9333
						} // 9334
						// 9335
						return jqXHR; // 9336
					}, // 9337
					// 9338
					getJSON: function (url, data, callback) {
						// 9339
						return jQuery.get(url, data, callback, "json"); // 9340
					}, // 9341
					// 9342
					getScript: function (url, callback) {
						// 9343
						return jQuery.get(url, undefined, callback, "script"); // 9344
					} // 9345
				}); // 9346
				// 9347
				jQuery.each(["get", "post"], function (i, method) {
					// 9348
					jQuery[method] = function (url, data, callback, type) {
						// 9349
						// shift arguments if data argument was omitted                                                                    // 9350
						if (jQuery.isFunction(data)) {
							// 9351
							type = type || callback; // 9352
							callback = data; // 9353
							data = undefined; // 9354
						} // 9355
						// 9356
						return jQuery.ajax({ // 9357
							url: url, // 9358
							type: method, // 9359
							dataType: type, // 9360
							data: data, // 9361
							success: callback // 9362
						}); // 9363
					}; // 9364
				}); // 9365
				// 9366
				// Attach a bunch of functions for handling common AJAX events                                                       // 9367
				jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
					jQuery.fn[type] = function (fn) {
						// 9369
						return this.on(type, fn); // 9370
					}; // 9371
				}); // 9372
				// 9373
				// 9374
				jQuery._evalUrl = function (url) {
					// 9375
					return jQuery.ajax({ // 9376
						url: url, // 9377
						type: "GET", // 9378
						dataType: "script", // 9379
						async: false, // 9380
						global: false, // 9381
						"throws": true // 9382
					}); // 9383
				}; // 9384
				// 9385
				// 9386
				jQuery.fn.extend({ // 9387
					wrapAll: function (html) {
						// 9388
						if (jQuery.isFunction(html)) {
							// 9389
							return this.each(function (i) {
								// 9390
								jQuery(this).wrapAll(html.call(this, i)); // 9391
							}); // 9392
						} // 9393
						// 9394
						if (this[0]) {
							// 9395
							// The elements to wrap the target around                                                                         // 9396
							var wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true); // 9397
							// 9398
							if (this[0].parentNode) {
								// 9399
								wrap.insertBefore(this[0]); // 9400
							} // 9401
							// 9402
							wrap.map(function () {
								// 9403
								var elem = this; // 9404
								// 9405
								while (elem.firstChild && elem.firstChild.nodeType === 1) {
									// 9406
									elem = elem.firstChild; // 9407
								} // 9408
								// 9409
								return elem; // 9410
							}).append(this); // 9411
						} // 9412
						// 9413
						return this; // 9414
					}, // 9415
					// 9416
					wrapInner: function (html) {
						// 9417
						if (jQuery.isFunction(html)) {
							// 9418
							return this.each(function (i) {
								// 9419
								jQuery(this).wrapInner(html.call(this, i)); // 9420
							}); // 9421
						} // 9422
						// 9423
						return this.each(function () {
							// 9424
							var self = jQuery(this),
							    // 9425
							contents = self.contents(); // 9426
							// 9427
							if (contents.length) {
								// 9428
								contents.wrapAll(html); // 9429
								// 9430
							} else {
								// 9431
								self.append(html); // 9432
							} // 9433
						}); // 9434
					}, // 9435
					// 9436
					wrap: function (html) {
						// 9437
						var isFunction = jQuery.isFunction(html); // 9438
						// 9439
						return this.each(function (i) {
							// 9440
							jQuery(this).wrapAll(isFunction ? html.call(this, i) : html); // 9441
						}); // 9442
					}, // 9443
					// 9444
					unwrap: function () {
						// 9445
						return this.parent().each(function () {
							// 9446
							if (!jQuery.nodeName(this, "body")) {
								// 9447
								jQuery(this).replaceWith(this.childNodes); // 9448
							} // 9449
						}).end(); // 9450
					} // 9451
				}); // 9452
				// 9453
				// 9454
				jQuery.expr.filters.hidden = function (elem) {
					// 9455
					// Support: Opera <= 12.12                                                                                          // 9456
					// Opera reports offsetWidths and offsetHeights less than zero on some elements                                     // 9457
					return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 || // 9458
					!support.reliableHiddenOffsets() && // 9459
					(elem.style && elem.style.display || jQuery.css(elem, "display")) === "none"; // 9460
				}; // 9461
				// 9462
				jQuery.expr.filters.visible = function (elem) {
					// 9463
					return !jQuery.expr.filters.hidden(elem); // 9464
				}; // 9465
				// 9466
				// 9467
				// 9468
				// 9469
				var r20 = /%20/g,
				    // 9470
				rbracket = /\[\]$/,
				    // 9471
				rCRLF = /\r?\n/g,
				    // 9472
				rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
				    // 9473
				rsubmittable = /^(?:input|select|textarea|keygen)/i; // 9474
				// 9475
				function buildParams(prefix, obj, traditional, add) {
					// 9476
					var name; // 9477
					// 9478
					if (jQuery.isArray(obj)) {
						// 9479
						// Serialize array item.                                                                                           // 9480
						jQuery.each(obj, function (i, v) {
							// 9481
							if (traditional || rbracket.test(prefix)) {
								// 9482
								// Treat each array item as a scalar.                                                                            // 9483
								add(prefix, v); // 9484
								// 9485
							} else {
								// 9486
								// Item is non-scalar (array or object), encode its numeric index.                                               // 9487
								buildParams(prefix + "[" + (typeof v === "object" ? i : "") + "]", v, traditional, add); // 9488
							} // 9489
						}); // 9490
						// 9491
					} else if (!traditional && jQuery.type(obj) === "object") {
						// 9492
						// Serialize object item.                                                                                          // 9493
						for (name in obj) {
							// 9494
							buildParams(prefix + "[" + name + "]", obj[name], traditional, add); // 9495
						} // 9496
						// 9497
					} else {
						// 9498
						// Serialize scalar item.                                                                                          // 9499
						add(prefix, obj); // 9500
					} // 9501
				} // 9502
				// 9503
				// Serialize an array of form elements or a set of                                                                   // 9504
				// key/values into a query string                                                                                    // 9505
				jQuery.param = function (a, traditional) {
					// 9506
					var prefix,
					    // 9507
					s = [],
					    // 9508
					add = function (key, value) {
						// 9509
						// If value is a function, invoke it and return its value                                                         // 9510
						value = jQuery.isFunction(value) ? value() : value == null ? "" : value; // 9511
						s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value); // 9512
					}; // 9513
					// 9514
					// Set traditional to true for jQuery <= 1.3.2 behavior.                                                            // 9515
					if (traditional === undefined) {
						// 9516
						traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional; // 9517
					} // 9518
					// 9519
					// If an array was passed in, assume that it is an array of form elements.                                          // 9520
					if (jQuery.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
						// 9521
						// Serialize the form elements                                                                                     // 9522
						jQuery.each(a, function () {
							// 9523
							add(this.name, this.value); // 9524
						}); // 9525
						// 9526
					} else {
						// 9527
						// If traditional, encode the "old" way (the way 1.3.2 or older                                                    // 9528
						// did it), otherwise encode params recursively.                                                                   // 9529
						for (prefix in a) {
							// 9530
							buildParams(prefix, a[prefix], traditional, add); // 9531
						} // 9532
					} // 9533
					// 9534
					// Return the resulting serialization                                                                               // 9535
					return s.join("&").replace(r20, "+"); // 9536
				}; // 9537
				// 9538
				jQuery.fn.extend({ // 9539
					serialize: function () {
						// 9540
						return jQuery.param(this.serializeArray()); // 9541
					}, // 9542
					serializeArray: function () {
						// 9543
						return this.map(function () {
							// 9544
							// Can add propHook for "elements" to filter or add form elements                                                 // 9545
							var elements = jQuery.prop(this, "elements"); // 9546
							return elements ? jQuery.makeArray(elements) : this; // 9547
						}) // 9548
						.filter(function () {
							// 9549
							var type = this.type; // 9550
							// Use .is(":disabled") so that fieldset[disabled] works                                                          // 9551
							return this.name && !jQuery(this).is(":disabled") && // 9552
							rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && ( // 9553
							this.checked || !rcheckableType.test(type)); // 9554
						}) // 9555
						.map(function (i, elem) {
							// 9556
							var val = jQuery(this).val(); // 9557
							// 9558
							return val == null ? // 9559
							null : // 9560
							jQuery.isArray(val) ? // 9561
							jQuery.map(val, function (val) {
								// 9562
								return { name: elem.name, value: val.replace(rCRLF, "\r\n") }; // 9563
							}) : // 9564
							{ name: elem.name, value: val.replace(rCRLF, "\r\n") }; // 9565
						}).get(); // 9566
					} // 9567
				}); // 9568
				// 9569
				// 9570
				// Create the request object                                                                                         // 9571
				// (This is still attached to ajaxSettings for backward compatibility)                                               // 9572
				jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ? // 9573
				// Support: IE6+                                                                                                    // 9574
				function () {
					// 9575
					// 9576
					// XHR cannot access local files, always use ActiveX for that case                                                 // 9577
					return !this.isLocal && // 9578
					// 9579
					// Support: IE7-8                                                                                                 // 9580
					// oldIE XHR does not support non-RFC2616 methods (#13240)                                                        // 9581
					// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx                                          // 9582
					// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9                                                 // 9583
					// Although this check for six methods instead of eight                                                           // 9584
					// since IE also does not support "trace" and "connect"                                                           // 9585
					/^(get|post|head|put|delete|options)$/i.test(this.type) && // 9586
					// 9587
					createStandardXHR() || createActiveXHR(); // 9588
				} : // 9589
				// For all other browsers, use the standard XMLHttpRequest object                                                   // 9590
				createStandardXHR; // 9591
				// 9592
				var xhrId = 0,
				    // 9593
				xhrCallbacks = {},
				    // 9594
				xhrSupported = jQuery.ajaxSettings.xhr(); // 9595
				// 9596
				// Support: IE<10                                                                                                    // 9597
				// Open requests must be manually aborted on unload (#5280)                                                          // 9598
				if (window.ActiveXObject) {
					// 9599
					jQuery(window).on("unload", function () {
						// 9600
						for (var key in xhrCallbacks) {
							// 9601
							xhrCallbacks[key](undefined, true); // 9602
						} // 9603
					}); // 9604
				} // 9605
				// 9606
				// Determine support properties                                                                                      // 9607
				support.cors = !!xhrSupported && "withCredentials" in xhrSupported; // 9608
				xhrSupported = support.ajax = !!xhrSupported; // 9609
				// 9610
				// Create transport if the browser can provide an xhr                                                                // 9611
				if (xhrSupported) {
					// 9612
					// 9613
					jQuery.ajaxTransport(function (options) {
						// 9614
						// Cross domain only allowed if supported through XMLHttpRequest                                                   // 9615
						if (!options.crossDomain || support.cors) {
							// 9616
							// 9617
							var callback; // 9618
							// 9619
							return { // 9620
								send: function (headers, complete) {
									// 9621
									var i,
									    // 9622
									xhr = options.xhr(),
									    // 9623
									id = ++xhrId; // 9624
									// 9625
									// Open the socket                                                                                              // 9626
									xhr.open(options.type, options.url, options.async, options.username, options.password); // 9627
									// 9628
									// Apply custom fields if provided                                                                              // 9629
									if (options.xhrFields) {
										// 9630
										for (i in options.xhrFields) {
											// 9631
											xhr[i] = options.xhrFields[i]; // 9632
										} // 9633
									} // 9634
									// 9635
									// Override mime type if needed                                                                                 // 9636
									if (options.mimeType && xhr.overrideMimeType) {
										// 9637
										xhr.overrideMimeType(options.mimeType); // 9638
									} // 9639
									// 9640
									// X-Requested-With header                                                                                      // 9641
									// For cross-domain requests, seeing as conditions for a preflight are                                          // 9642
									// akin to a jigsaw puzzle, we simply never set it to be sure.                                                  // 9643
									// (it can always be set on a per-request basis or even using ajaxSetup)                                        // 9644
									// For same-domain requests, won't change header if already provided.                                           // 9645
									if (!options.crossDomain && !headers["X-Requested-With"]) {
										// 9646
										headers["X-Requested-With"] = "XMLHttpRequest"; // 9647
									} // 9648
									// 9649
									// Set headers                                                                                                  // 9650
									for (i in headers) {
										// 9651
										// Support: IE<9                                                                                               // 9652
										// IE's ActiveXObject throws a 'Type Mismatch' exception when setting                                          // 9653
										// request header to a null-value.                                                                             // 9654
										//                                                                                                             // 9655
										// To keep consistent with other XHR implementations, cast the value                                           // 9656
										// to string and ignore `undefined`.                                                                           // 9657
										if (headers[i] !== undefined) {
											// 9658
											xhr.setRequestHeader(i, headers[i] + ""); // 9659
										} // 9660
									} // 9661
									// 9662
									// Do send the request                                                                                          // 9663
									// This may raise an exception which is actually                                                                // 9664
									// handled in jQuery.ajax (so no try/catch here)                                                                // 9665
									xhr.send(options.hasContent && options.data || null); // 9666
									// 9667
									// Listener                                                                                                     // 9668
									callback = function (_, isAbort) {
										// 9669
										var status, statusText, responses; // 9670
										// 9671
										// Was never called and is aborted or complete                                                                 // 9672
										if (callback && (isAbort || xhr.readyState === 4)) {
											// 9673
											// Clean up                                                                                                   // 9674
											delete xhrCallbacks[id]; // 9675
											callback = undefined; // 9676
											xhr.onreadystatechange = jQuery.noop; // 9677
											// 9678
											// Abort manually if needed                                                                                   // 9679
											if (isAbort) {
												// 9680
												if (xhr.readyState !== 4) {
													// 9681
													xhr.abort(); // 9682
												} // 9683
											} else {
												// 9684
												responses = {}; // 9685
												status = xhr.status; // 9686
												// 9687
												// Support: IE<10                                                                                            // 9688
												// Accessing binary-data responseText throws an exception                                                    // 9689
												// (#11426)                                                                                                  // 9690
												if (typeof xhr.responseText === "string") {
													// 9691
													responses.text = xhr.responseText; // 9692
												} // 9693
												// 9694
												// Firefox throws an exception when accessing                                                                // 9695
												// statusText for faulty cross-domain requests                                                               // 9696
												try {
													// 9697
													statusText = xhr.statusText; // 9698
												} catch (e) {
													// 9699
													// We normalize with Webkit giving an empty statusText                                                      // 9700
													statusText = ""; // 9701
												} // 9702
												// 9703
												// Filter status for non standard behaviors                                                                  // 9704
												// 9705
												// If the request is local and we have data: assume a success                                                // 9706
												// (success with no data won't get notified, that's the best we                                              // 9707
												// can do given current implementations)                                                                     // 9708
												if (!status && options.isLocal && !options.crossDomain) {
													// 9709
													status = responses.text ? 200 : 404; // 9710
													// IE - #1450: sometimes returns 1223 when it should be 204                                                  // 9711
												} else if (status === 1223) {
													// 9712
													status = 204; // 9713
												} // 9714
											} // 9715
										} // 9716
										// 9717
										// Call complete if needed                                                                                     // 9718
										if (responses) {
											// 9719
											complete(status, statusText, responses, xhr.getAllResponseHeaders()); // 9720
										} // 9721
									}; // 9722
									// 9723
									if (!options.async) {
										// 9724
										// if we're in sync mode we fire the callback                                                                  // 9725
										callback(); // 9726
									} else if (xhr.readyState === 4) {
										// 9727
										// (IE6 & IE7) if it's in cache and has been                                                                   // 9728
										// retrieved directly we need to fire the callback                                                             // 9729
										setTimeout(callback); // 9730
									} else {
										// 9731
										// Add to the list of active xhr callbacks                                                                     // 9732
										xhr.onreadystatechange = xhrCallbacks[id] = callback; // 9733
									} // 9734
								}, // 9735
								// 9736
								abort: function () {
									// 9737
									if (callback) {
										// 9738
										callback(undefined, true); // 9739
									} // 9740
								} // 9741
							}; // 9742
						} // 9743
					}); // 9744
				} // 9745
				// 9746
				// Functions to create xhrs                                                                                          // 9747
				function createStandardXHR() {
					// 9748
					try {
						// 9749
						return new window.XMLHttpRequest(); // 9750
					} catch (e) {} // 9751
				} // 9752
				// 9753
				function createActiveXHR() {
					// 9754
					try {
						// 9755
						return new window.ActiveXObject("Microsoft.XMLHTTP"); // 9756
					} catch (e) {} // 9757
				} // 9758
				// 9759
				// 9760
				// 9761
				// 9762
				// Install script dataType                                                                                           // 9763
				jQuery.ajaxSetup({ // 9764
					accepts: { // 9765
						script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" // 9766
					}, // 9767
					contents: { // 9768
						script: /(?:java|ecma)script/ // 9769
					}, // 9770
					converters: { // 9771
						"text script": function (text) {
							// 9772
							jQuery.globalEval(text); // 9773
							return text; // 9774
						} // 9775
						// 9776
					} }); // 9777
				// 9778
				// Handle cache's special case and global                                                                            // 9779
				jQuery.ajaxPrefilter("script", function (s) {
					// 9780
					if (s.cache === undefined) {
						// 9781
						s.cache = false; // 9782
					} // 9783
					if (s.crossDomain) {
						// 9784
						s.type = "GET"; // 9785
						s.global = false; // 9786
					} // 9787
				}); // 9788
				// 9789
				// Bind script tag hack transport                                                                                    // 9790
				jQuery.ajaxTransport("script", function (s) {
					// 9791
					// 9792
					// This transport only deals with cross domain requests                                                             // 9793
					if (s.crossDomain) {
						// 9794
						// 9795
						var script,
						    // 9796
						head = document.head || jQuery("head")[0] || document.documentElement; // 9797
						// 9798
						return { // 9799
							// 9800
							send: function (_, callback) {
								// 9801
								// 9802
								script = document.createElement("script"); // 9803
								// 9804
								script.async = true; // 9805
								// 9806
								if (s.scriptCharset) {
									// 9807
									script.charset = s.scriptCharset; // 9808
								} // 9809
								// 9810
								script.src = s.url; // 9811
								// 9812
								// Attach handlers for all browsers                                                                              // 9813
								script.onload = script.onreadystatechange = function (_, isAbort) {
									// 9814
									// 9815
									if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
										// 9816
										// 9817
										// Handle memory leak in IE                                                                                    // 9818
										script.onload = script.onreadystatechange = null; // 9819
										// 9820
										// Remove the script                                                                                           // 9821
										if (script.parentNode) {
											// 9822
											script.parentNode.removeChild(script); // 9823
										} // 9824
										// 9825
										// Dereference the script                                                                                      // 9826
										script = null; // 9827
										// 9828
										// Callback if not abort                                                                                       // 9829
										if (!isAbort) {
											// 9830
											callback(200, "success"); // 9831
										} // 9832
									} // 9833
								}; // 9834
								// 9835
								// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending                                        // 9836
								// Use native DOM manipulation to avoid our domManip AJAX trickery                                               // 9837
								head.insertBefore(script, head.firstChild); // 9838
							}, // 9839
							// 9840
							abort: function () {
								// 9841
								if (script) {
									// 9842
									script.onload(undefined, true); // 9843
								} // 9844
							} // 9845
						}; // 9846
					} // 9847
				}); // 9848
				// 9849
				// 9850
				// 9851
				// 9852
				var oldCallbacks = [],
				    // 9853
				rjsonp = /(=)\?(?=&|$)|\?\?/; // 9854
				// 9855
				// Default jsonp settings                                                                                            // 9856
				jQuery.ajaxSetup({ // 9857
					jsonp: "callback", // 9858
					jsonpCallback: function () {
						// 9859
						var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++; // 9860
						this[callback] = true; // 9861
						return callback; // 9862
					} // 9863
				}); // 9864
				// 9865
				// Detect, normalize options and install callbacks for jsonp requests                                                // 9866
				jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
					// 9867
					// 9868
					var callbackName,
					    overwritten,
					    responseContainer,
					    // 9869
					jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? // 9870
					"url" : // 9871
					typeof s.data === "string" && !(s.contentType || "").indexOf("application/x-www-form-urlencoded") && rjsonp.test(s.data) && "data"); // 9873
					// 9874
					// Handle iff the expected data type is "jsonp" or we have a parameter to set                                       // 9875
					if (jsonProp || s.dataTypes[0] === "jsonp") {
						// 9876
						// 9877
						// Get callback name, remembering preexisting value associated with it                                             // 9878
						callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? // 9879
						s.jsonpCallback() : // 9880
						s.jsonpCallback; // 9881
						// 9882
						// Insert callback into url or form data                                                                           // 9883
						if (jsonProp) {
							// 9884
							s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName); // 9885
						} else if (s.jsonp !== false) {
							// 9886
							s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName; // 9887
						} // 9888
						// 9889
						// Use data converter to retrieve json after script execution                                                      // 9890
						s.converters["script json"] = function () {
							// 9891
							if (!responseContainer) {
								// 9892
								jQuery.error(callbackName + " was not called"); // 9893
							} // 9894
							return responseContainer[0]; // 9895
						}; // 9896
						// 9897
						// force json dataType                                                                                             // 9898
						s.dataTypes[0] = "json"; // 9899
						// 9900
						// Install callback                                                                                                // 9901
						overwritten = window[callbackName]; // 9902
						window[callbackName] = function () {
							// 9903
							responseContainer = arguments; // 9904
						}; // 9905
						// 9906
						// Clean-up function (fires after converters)                                                                      // 9907
						jqXHR.always(function () {
							// 9908
							// Restore preexisting value                                                                                      // 9909
							window[callbackName] = overwritten; // 9910
							// 9911
							// Save back as free                                                                                              // 9912
							if (s[callbackName]) {
								// 9913
								// make sure that re-using the options doesn't screw things around                                               // 9914
								s.jsonpCallback = originalSettings.jsonpCallback; // 9915
								// 9916
								// save the callback name for future use                                                                         // 9917
								oldCallbacks.push(callbackName); // 9918
							} // 9919
							// 9920
							// Call if it was a function and we have a response                                                               // 9921
							if (responseContainer && jQuery.isFunction(overwritten)) {
								// 9922
								overwritten(responseContainer[0]); // 9923
							} // 9924
							// 9925
							responseContainer = overwritten = undefined; // 9926
						}); // 9927
						// 9928
						// Delegate to script                                                                                              // 9929
						return "script"; // 9930
					} // 9931
				}); // 9932
				// 9933
				// 9934
				// 9935
				// 9936
				// data: string of html                                                                                              // 9937
				// context (optional): If specified, the fragment will be created in this context, defaults to document              // 9938
				// keepScripts (optional): If true, will include scripts passed in the html string                                   // 9939
				jQuery.parseHTML = function (data, context, keepScripts) {
					// 9940
					if (!data || typeof data !== "string") {
						// 9941
						return null; // 9942
					} // 9943
					if (typeof context === "boolean") {
						// 9944
						keepScripts = context; // 9945
						context = false; // 9946
					} // 9947
					context = context || document; // 9948
					// 9949
					var parsed = rsingleTag.exec(data),
					    // 9950
					scripts = !keepScripts && []; // 9951
					// 9952
					// Single tag                                                                                                       // 9953
					if (parsed) {
						// 9954
						return [context.createElement(parsed[1])]; // 9955
					} // 9956
					// 9957
					parsed = jQuery.buildFragment([data], context, scripts); // 9958
					// 9959
					if (scripts && scripts.length) {
						// 9960
						jQuery(scripts).remove(); // 9961
					} // 9962
					// 9963
					return jQuery.merge([], parsed.childNodes); // 9964
				}; // 9965
				// 9966
				// 9967
				// Keep a copy of the old load method                                                                                // 9968
				var _load = jQuery.fn.load; // 9969
				// 9970
				/**                                                                                                                  // 9971
     * Load a url into a page                                                                                            // 9972
     */ // 9973
				jQuery.fn.load = function (url, params, callback) {
					// 9974
					if (typeof url !== "string" && _load) {
						// 9975
						return _load.apply(this, arguments); // 9976
					} // 9977
					// 9978
					var selector,
					    response,
					    type,
					    // 9979
					self = this,
					    // 9980
					off = url.indexOf(" "); // 9981
					// 9982
					if (off >= 0) {
						// 9983
						selector = url.slice(off, url.length); // 9984
						url = url.slice(0, off); // 9985
					} // 9986
					// 9987
					// If it's a function                                                                                               // 9988
					if (jQuery.isFunction(params)) {
						// 9989
						// 9990
						// We assume that it's the callback                                                                                // 9991
						callback = params; // 9992
						params = undefined; // 9993
						// 9994
						// Otherwise, build a param string                                                                                  // 9995
					} else if (params && typeof params === "object") {
						// 9996
						type = "POST"; // 9997
					} // 9998
					// 9999
					// If we have elements to modify, make the request                                                                  // 10000
					if (self.length > 0) {
						// 10001
						jQuery.ajax({ // 10002
							url: url, // 10003
							// 10004
							// if "type" variable is undefined, then "GET" method will be used                                                // 10005
							type: type, // 10006
							dataType: "html", // 10007
							data: params // 10008
						}).done(function (responseText) {
							// 10009
							// 10010
							// Save response for use in complete callback                                                                     // 10011
							response = arguments; // 10012
							// 10013
							self.html(selector ? // 10014
							// 10015
							// If a selector was specified, locate the right elements in a dummy div                                         // 10016
							// Exclude scripts to avoid IE 'Permission Denied' errors                                                        // 10017
							jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // 10018
							// 10019
							// Otherwise use the full result                                                                                 // 10020
							responseText); // 10021
							// 10022
						}).complete(callback && function (jqXHR, status) {
							// 10023
							self.each(callback, response || [jqXHR.responseText, status, jqXHR]); // 10024
						}); // 10025
					} // 10026
					// 10027
					return this; // 10028
				}; // 10029
				// 10030
				// 10031
				// 10032
				// 10033
				jQuery.expr.filters.animated = function (elem) {
					// 10034
					return jQuery.grep(jQuery.timers, function (fn) {
						// 10035
						return elem === fn.elem; // 10036
					}).length; // 10037
				}; // 10038
				// 10039
				// 10040
				// 10041
				// 10042
				// 10043
				var docElem = window.document.documentElement; // 10044
				// 10045
				/**                                                                                                                  // 10046
     * Gets a window from an element                                                                                     // 10047
     */ // 10048
				function getWindow(elem) {
					// 10049
					return jQuery.isWindow(elem) ? // 10050
					elem : // 10051
					elem.nodeType === 9 ? // 10052
					elem.defaultView || elem.parentWindow : // 10053
					false; // 10054
				} // 10055
				// 10056
				jQuery.offset = { // 10057
					setOffset: function (elem, options, i) {
						// 10058
						var curPosition,
						    curLeft,
						    curCSSTop,
						    curTop,
						    curOffset,
						    curCSSLeft,
						    calculatePosition,
						    // 10059
						position = jQuery.css(elem, "position"),
						    // 10060
						curElem = jQuery(elem),
						    // 10061
						props = {}; // 10062
						// 10063
						// set position first, in-case top/left are set even on static elem                                                // 10064
						if (position === "static") {
							// 10065
							elem.style.position = "relative"; // 10066
						} // 10067
						// 10068
						curOffset = curElem.offset(); // 10069
						curCSSTop = jQuery.css(elem, "top"); // 10070
						curCSSLeft = jQuery.css(elem, "left"); // 10071
						calculatePosition = (position === "absolute" || position === "fixed") && // 10072
						jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1; // 10073
						// 10074
						// need to be able to calculate position if either top or left is auto and position is either absolute or fixed    // 10075
						if (calculatePosition) {
							// 10076
							curPosition = curElem.position(); // 10077
							curTop = curPosition.top; // 10078
							curLeft = curPosition.left; // 10079
						} else {
							// 10080
							curTop = parseFloat(curCSSTop) || 0; // 10081
							curLeft = parseFloat(curCSSLeft) || 0; // 10082
						} // 10083
						// 10084
						if (jQuery.isFunction(options)) {
							// 10085
							options = options.call(elem, i, curOffset); // 10086
						} // 10087
						// 10088
						if (options.top != null) {
							// 10089
							props.top = options.top - curOffset.top + curTop; // 10090
						} // 10091
						if (options.left != null) {
							// 10092
							props.left = options.left - curOffset.left + curLeft; // 10093
						} // 10094
						// 10095
						if ("using" in options) {
							// 10096
							options.using.call(elem, props); // 10097
						} else {
							// 10098
							curElem.css(props); // 10099
						} // 10100
					} // 10101
				}; // 10102
				// 10103
				jQuery.fn.extend({ // 10104
					offset: function (options) {
						// 10105
						if (arguments.length) {
							// 10106
							return options === undefined ? // 10107
							this : // 10108
							this.each(function (i) {
								// 10109
								jQuery.offset.setOffset(this, options, i); // 10110
							}); // 10111
						} // 10112
						// 10113
						var docElem,
						    win,
						    // 10114
						box = { top: 0, left: 0 },
						    // 10115
						elem = this[0],
						    // 10116
						doc = elem && elem.ownerDocument; // 10117
						// 10118
						if (!doc) {
							// 10119
							return; // 10120
						} // 10121
						// 10122
						docElem = doc.documentElement; // 10123
						// 10124
						// Make sure it's not a disconnected DOM node                                                                      // 10125
						if (!jQuery.contains(docElem, elem)) {
							// 10126
							return box; // 10127
						} // 10128
						// 10129
						// If we don't have gBCR, just use 0,0 rather than error                                                           // 10130
						// BlackBerry 5, iOS 3 (original iPhone)                                                                           // 10131
						if (typeof elem.getBoundingClientRect !== strundefined) {
							// 10132
							box = elem.getBoundingClientRect(); // 10133
						} // 10134
						win = getWindow(doc); // 10135
						return { // 10136
							top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0), // 10137
							left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0) // 10138
						}; // 10139
					}, // 10140
					// 10141
					position: function () {
						// 10142
						if (!this[0]) {
							// 10143
							return; // 10144
						} // 10145
						// 10146
						var offsetParent,
						    offset,
						    // 10147
						parentOffset = { top: 0, left: 0 },
						    // 10148
						elem = this[0]; // 10149
						// 10150
						// fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent    // 10151
						if (jQuery.css(elem, "position") === "fixed") {
							// 10152
							// we assume that getBoundingClientRect is available when computed position is fixed                              // 10153
							offset = elem.getBoundingClientRect(); // 10154
						} else {
							// 10155
							// Get *real* offsetParent                                                                                        // 10156
							offsetParent = this.offsetParent(); // 10157
							// 10158
							// Get correct offsets                                                                                            // 10159
							offset = this.offset(); // 10160
							if (!jQuery.nodeName(offsetParent[0], "html")) {
								// 10161
								parentOffset = offsetParent.offset(); // 10162
							} // 10163
							// 10164
							// Add offsetParent borders                                                                                       // 10165
							parentOffset.top += jQuery.css(offsetParent[0], "borderTopWidth", true); // 10166
							parentOffset.left += jQuery.css(offsetParent[0], "borderLeftWidth", true); // 10167
						} // 10168
						// 10169
						// Subtract parent offsets and element margins                                                                     // 10170
						// note: when an element has margin: auto the offsetLeft and marginLeft                                            // 10171
						// are the same in Safari causing offset.left to incorrectly be 0                                                  // 10172
						return { // 10173
							top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true), // 10174
							left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true) // 10175
						}; // 10176
					}, // 10177
					// 10178
					offsetParent: function () {
						// 10179
						return this.map(function () {
							// 10180
							var offsetParent = this.offsetParent || docElem; // 10181
							// 10182
							while (offsetParent && !jQuery.nodeName(offsetParent, "html") && jQuery.css(offsetParent, "position") === "static") {
								offsetParent = offsetParent.offsetParent; // 10184
							} // 10185
							return offsetParent || docElem; // 10186
						}); // 10187
					} // 10188
				}); // 10189
				// 10190
				// Create scrollLeft and scrollTop methods                                                                           // 10191
				jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
					// 10192
					var top = /Y/.test(prop); // 10193
					// 10194
					jQuery.fn[method] = function (val) {
						// 10195
						return access(this, function (elem, method, val) {
							// 10196
							var win = getWindow(elem); // 10197
							// 10198
							if (val === undefined) {
								// 10199
								return win ? prop in win ? win[prop] : // 10200
								win.document.documentElement[method] : // 10201
								elem[method]; // 10202
							} // 10203
							// 10204
							if (win) {
								// 10205
								win.scrollTo( // 10206
								!top ? val : jQuery(win).scrollLeft(), // 10207
								top ? val : jQuery(win).scrollTop() // 10208
								); // 10209
								// 10210
							} else {
								// 10211
								elem[method] = val; // 10212
							} // 10213
						}, method, val, arguments.length, null); // 10214
					}; // 10215
				}); // 10216
				// 10217
				// Add the top/left cssHooks using jQuery.fn.position                                                                // 10218
				// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084                                                         // 10219
				// getComputedStyle returns percent when specified for top/left/bottom/right                                         // 10220
				// rather than make the css module depend on the offset module, we just check for it here                            // 10221
				jQuery.each(["top", "left"], function (i, prop) {
					// 10222
					jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, // 10223
					function (elem, computed) {
						// 10224
						if (computed) {
							// 10225
							computed = curCSS(elem, prop); // 10226
							// if curCSS returns percentage, fallback to offset                                                              // 10227
							return rnumnonpx.test(computed) ? // 10228
							jQuery(elem).position()[prop] + "px" : // 10229
							computed; // 10230
						} // 10231
					} // 10232
					); // 10233
				}); // 10234
				// 10235
				// 10236
				// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods                                 // 10237
				jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
					// 10238
					jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {
						// 10239
						// margin is only for outerHeight, outerWidth                                                                      // 10240
						jQuery.fn[funcName] = function (margin, value) {
							// 10241
							var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
							    // 10242
							extra = defaultExtra || (margin === true || value === true ? "margin" : "border"); // 10243
							// 10244
							return access(this, function (elem, type, value) {
								// 10245
								var doc; // 10246
								// 10247
								if (jQuery.isWindow(elem)) {
									// 10248
									// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there                                // 10249
									// isn't a whole lot we can do. See pull request at this URL for discussion:                                    // 10250
									// https://github.com/jquery/jquery/pull/764                                                                    // 10251
									return elem.document.documentElement["client" + name]; // 10252
								} // 10253
								// 10254
								// Get document width or height                                                                                  // 10255
								if (elem.nodeType === 9) {
									// 10256
									doc = elem.documentElement; // 10257
									// 10258
									// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest           // 10259
									// unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.     // 10260
									return Math.max( // 10261
									elem.body["scroll" + name], doc["scroll" + name], // 10262
									elem.body["offset" + name], doc["offset" + name], // 10263
									doc["client" + name] // 10264
									); // 10265
								} // 10266
								// 10267
								return value === undefined ? // 10268
								// Get width or height on the element, requesting but not forcing parseFloat                                    // 10269
								jQuery.css(elem, type, extra) : // 10270
								// 10271
								// Set width or height on the element                                                                           // 10272
								jQuery.style(elem, type, value, extra); // 10273
							}, type, chainable ? margin : undefined, chainable, null); // 10274
						}; // 10275
					}); // 10276
				}); // 10277
				// 10278
				// 10279
				// The number of elements contained in the matched element set                                                       // 10280
				jQuery.fn.size = function () {
					// 10281
					return this.length; // 10282
				}; // 10283
				// 10284
				jQuery.fn.andSelf = jQuery.fn.addBack; // 10285
				// 10286
				// 10287
				// 10288
				// 10289
				// Register as a named AMD module, since jQuery can be concatenated with other                                       // 10290
				// files that may use define, but not via a proper concatenation script that                                         // 10291
				// understands anonymous AMD modules. A named AMD is safest and most robust                                          // 10292
				// way to register. Lowercase jquery is used because AMD module names are                                            // 10293
				// derived from file names, and jQuery is normally delivered in a lowercase                                          // 10294
				// file name. Do this after creating the global so that if an AMD module wants                                       // 10295
				// to call noConflict to hide this version of jQuery, it will work.                                                  // 10296
				if (typeof define === "function" && define.amd) {
					// 10297
					define("jquery", [], function () {
						// 10298
						return jQuery; // 10299
					}); // 10300
				} // 10301
				// 10302
				// 10303
				// 10304
				// 10305
				var // 10306
				// Map over jQuery in case of overwrite                                                                             // 10307
				_jQuery = window.jQuery,
				    // 10308
				// 10309
				// Map over the $ in case of overwrite                                                                              // 10310
				_$ = window.$; // 10311
				// 10312
				jQuery.noConflict = function (deep) {
					// 10313
					if (window.$ === jQuery) {
						// 10314
						window.$ = _$; // 10315
					} // 10316
					// 10317
					if (deep && window.jQuery === jQuery) {
						// 10318
						window.jQuery = _jQuery; // 10319
					} // 10320
					// 10321
					return jQuery; // 10322
				}; // 10323
				// 10324
				// Expose jQuery and $ identifiers, even in                                                                          // 10325
				// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)                                                 // 10326
				// and CommonJS for browser emulators (#13566)                                                                       // 10327
				if (typeof noGlobal === strundefined) {
					// 10328
					window.jQuery = window.$ = jQuery; // 10329
				} // 10330
				// 10331
				// 10332
				// 10333
				// 10334
				return jQuery; // 10335
				// 10336
			}); // 10337
			// 10338
			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		}).call(this);

		(function () {

			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
			//                                                                                                                   //
			// packages/jquery/post.js                                                                                           //
			//                                                                                                                   //
			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
			//
			// Put jQuery and $ in our exported package-scope variables and remove window.$.                                     // 1
			// (Sadly, we don't call noConflict(true), which would also remove                                                   // 2
			// window.jQuery, because bootstrap very specifically relies on window.jQuery.)                                      // 3
			$ = jQuery = window.jQuery.noConflict(); // 4
			// 5
			///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		}).call(this);

		///////////////////////////////////////////////////////////////////////
	}).call(this);

	/* Exports */
	Package._define("jquery", {
		$: $,
		jQuery: jQuery
	});
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Package-scope variables */
  var _exports, _;

  (function () {

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                       //
    // packages/underscore/pre.js                                                                            //
    //                                                                                                       //
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Define an object named exports. This will cause underscore.js to put `_` as a
    // field on it, instead of in the global namespace.  See also post.js.
    _exports = {};

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                       //
    // packages/underscore/underscore.js                                                                     //
    //                                                                                                       //
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //     Underscore.js 1.5.2
    //     http://underscorejs.org
    //     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
    //     Underscore may be freely distributed under the MIT license.

    (function () {

      // Baseline setup
      // --------------

      // Establish the root object, `window` in the browser, or `exports` on the server.
      var root = this;

      // Save the previous value of the `_` variable.
      var previousUnderscore = root._;

      // Establish the object that gets returned to break out of a loop iteration.
      var breaker = {};

      // Save bytes in the minified (but not gzipped) version:
      var ArrayProto = Array.prototype,
          ObjProto = Object.prototype,
          FuncProto = Function.prototype;

      // Create quick reference variables for speed access to core prototypes.
      var push = ArrayProto.push,
          slice = ArrayProto.slice,
          concat = ArrayProto.concat,
          toString = ObjProto.toString,
          hasOwnProperty = ObjProto.hasOwnProperty;

      // All **ECMAScript 5** native function implementations that we hope to use
      // are declared here.
      var nativeForEach = ArrayProto.forEach,
          nativeMap = ArrayProto.map,
          nativeReduce = ArrayProto.reduce,
          nativeReduceRight = ArrayProto.reduceRight,
          nativeFilter = ArrayProto.filter,
          nativeEvery = ArrayProto.every,
          nativeSome = ArrayProto.some,
          nativeIndexOf = ArrayProto.indexOf,
          nativeLastIndexOf = ArrayProto.lastIndexOf,
          nativeIsArray = Array.isArray,
          nativeKeys = Object.keys,
          nativeBind = FuncProto.bind;

      // Create a safe reference to the Underscore object for use below.
      var _ = function (obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
      };

      // Export the Underscore object for **Node.js**, with
      // backwards-compatibility for the old `require()` API. If we're in
      // the browser, add `_` as a global object via a string identifier,
      // for Closure Compiler "advanced" mode.
      if (typeof _exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
          _exports = module.exports = _;
        }
        _exports._ = _;
      } else {
        root._ = _;
      }

      // Current version.
      _.VERSION = '1.5.2';

      // Collection Functions
      // --------------------

      // METEOR CHANGE: Define _isArguments instead of depending on
      // _.isArguments which is defined using each. In looksLikeArray
      // (which each depends on), we then use _isArguments instead of
      // _.isArguments.
      var _isArguments = function (obj) {
        return toString.call(obj) === '[object Arguments]';
      };
      // Define a fallback version of the method in browsers (ahem, IE), where
      // there isn't any inspectable "Arguments" type.
      if (!_isArguments(arguments)) {
        _isArguments = function (obj) {
          return !!(obj && hasOwnProperty.call(obj, 'callee') && typeof obj.callee === 'function');
        };
      }

      // METEOR CHANGE: _.each({length: 5}) should be treated like an object, not an
      // array. This looksLikeArray function is introduced by Meteor, and replaces
      // all instances of `obj.length === +obj.length`.
      // https://github.com/meteor/meteor/issues/594
      // https://github.com/jashkenas/underscore/issues/770
      var looksLikeArray = function (obj) {
        return obj.length === +obj.length
        // _.isArguments not yet necessarily defined here
        && (_isArguments(obj) || obj.constructor !== Object);
      };

      // The cornerstone, an `each` implementation, aka `forEach`.
      // Handles objects with the built-in `forEach`, arrays, and raw objects.
      // Delegates to **ECMAScript 5**'s native `forEach` if available.
      var each = _.each = _.forEach = function (obj, iterator, context) {
        if (obj == null) return;
        if (nativeForEach && obj.forEach === nativeForEach) {
          obj.forEach(iterator, context);
        } else if (looksLikeArray(obj)) {
          for (var i = 0, length = obj.length; i < length; i++) {
            if (iterator.call(context, obj[i], i, obj) === breaker) return;
          }
        } else {
          var keys = _.keys(obj);
          for (var i = 0, length = keys.length; i < length; i++) {
            if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
          }
        }
      };

      // Return the results of applying the iterator to each element.
      // Delegates to **ECMAScript 5**'s native `map` if available.
      _.map = _.collect = function (obj, iterator, context) {
        var results = [];
        if (obj == null) return results;
        if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
        each(obj, function (value, index, list) {
          results.push(iterator.call(context, value, index, list));
        });
        return results;
      };

      var reduceError = 'Reduce of empty array with no initial value';

      // **Reduce** builds up a single result from a list of values, aka `inject`,
      // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
      _.reduce = _.foldl = _.inject = function (obj, iterator, memo, context) {
        var initial = arguments.length > 2;
        if (obj == null) obj = [];
        if (nativeReduce && obj.reduce === nativeReduce) {
          if (context) iterator = _.bind(iterator, context);
          return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
        }
        each(obj, function (value, index, list) {
          if (!initial) {
            memo = value;
            initial = true;
          } else {
            memo = iterator.call(context, memo, value, index, list);
          }
        });
        if (!initial) throw new TypeError(reduceError);
        return memo;
      };

      // The right-associative version of reduce, also known as `foldr`.
      // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
      _.reduceRight = _.foldr = function (obj, iterator, memo, context) {
        var initial = arguments.length > 2;
        if (obj == null) obj = [];
        if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
          if (context) iterator = _.bind(iterator, context);
          return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
        }
        var length = obj.length;
        if (!looksLikeArray(obj)) {
          var keys = _.keys(obj);
          length = keys.length;
        }
        each(obj, function (value, index, list) {
          index = keys ? keys[--length] : --length;
          if (!initial) {
            memo = obj[index];
            initial = true;
          } else {
            memo = iterator.call(context, memo, obj[index], index, list);
          }
        });
        if (!initial) throw new TypeError(reduceError);
        return memo;
      };

      // Return the first value which passes a truth test. Aliased as `detect`.
      _.find = _.detect = function (obj, iterator, context) {
        var result;
        any(obj, function (value, index, list) {
          if (iterator.call(context, value, index, list)) {
            result = value;
            return true;
          }
        });
        return result;
      };

      // Return all the elements that pass a truth test.
      // Delegates to **ECMAScript 5**'s native `filter` if available.
      // Aliased as `select`.
      _.filter = _.select = function (obj, iterator, context) {
        var results = [];
        if (obj == null) return results;
        if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
        each(obj, function (value, index, list) {
          if (iterator.call(context, value, index, list)) results.push(value);
        });
        return results;
      };

      // Return all the elements for which a truth test fails.
      _.reject = function (obj, iterator, context) {
        return _.filter(obj, function (value, index, list) {
          return !iterator.call(context, value, index, list);
        }, context);
      };

      // Determine whether all of the elements match a truth test.
      // Delegates to **ECMAScript 5**'s native `every` if available.
      // Aliased as `all`.
      _.every = _.all = function (obj, iterator, context) {
        iterator || (iterator = _.identity);
        var result = true;
        if (obj == null) return result;
        if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
        each(obj, function (value, index, list) {
          if (!(result = result && iterator.call(context, value, index, list))) return breaker;
        });
        return !!result;
      };

      // Determine if at least one element in the object matches a truth test.
      // Delegates to **ECMAScript 5**'s native `some` if available.
      // Aliased as `any`.
      var any = _.some = _.any = function (obj, iterator, context) {
        iterator || (iterator = _.identity);
        var result = false;
        if (obj == null) return result;
        if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
        each(obj, function (value, index, list) {
          if (result || (result = iterator.call(context, value, index, list))) return breaker;
        });
        return !!result;
      };

      // Determine if the array or object contains a given value (using `===`).
      // Aliased as `include`.
      _.contains = _.include = function (obj, target) {
        if (obj == null) return false;
        if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
        return any(obj, function (value) {
          return value === target;
        });
      };

      // Invoke a method (with arguments) on every item in a collection.
      _.invoke = function (obj, method) {
        var args = slice.call(arguments, 2);
        var isFunc = _.isFunction(method);
        return _.map(obj, function (value) {
          return (isFunc ? method : value[method]).apply(value, args);
        });
      };

      // Convenience version of a common use case of `map`: fetching a property.
      _.pluck = function (obj, key) {
        return _.map(obj, function (value) {
          return value[key];
        });
      };

      // Convenience version of a common use case of `filter`: selecting only objects
      // containing specific `key:value` pairs.
      _.where = function (obj, attrs, first) {
        if (_.isEmpty(attrs)) return first ? void 0 : [];
        return _[first ? 'find' : 'filter'](obj, function (value) {
          for (var key in attrs) {
            if (attrs[key] !== value[key]) return false;
          }
          return true;
        });
      };

      // Convenience version of a common use case of `find`: getting the first object
      // containing specific `key:value` pairs.
      _.findWhere = function (obj, attrs) {
        return _.where(obj, attrs, true);
      };

      // Return the maximum element or (element-based computation).
      // Can't optimize arrays of integers longer than 65,535 elements.
      // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
      _.max = function (obj, iterator, context) {
        if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
          return Math.max.apply(Math, obj);
        }
        if (!iterator && _.isEmpty(obj)) return -Infinity;
        var result = { computed: -Infinity, value: -Infinity };
        each(obj, function (value, index, list) {
          var computed = iterator ? iterator.call(context, value, index, list) : value;
          computed > result.computed && (result = { value: value, computed: computed });
        });
        return result.value;
      };

      // Return the minimum element (or element-based computation).
      _.min = function (obj, iterator, context) {
        if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
          return Math.min.apply(Math, obj);
        }
        if (!iterator && _.isEmpty(obj)) return Infinity;
        var result = { computed: Infinity, value: Infinity };
        each(obj, function (value, index, list) {
          var computed = iterator ? iterator.call(context, value, index, list) : value;
          computed < result.computed && (result = { value: value, computed: computed });
        });
        return result.value;
      };

      // Shuffle an array, using the modern version of the 
      // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
      _.shuffle = function (obj) {
        var rand;
        var index = 0;
        var shuffled = [];
        each(obj, function (value) {
          rand = _.random(index++);
          shuffled[index - 1] = shuffled[rand];
          shuffled[rand] = value;
        });
        return shuffled;
      };

      // Sample **n** random values from an array.
      // If **n** is not specified, returns a single random element from the array.
      // The internal `guard` argument allows it to work with `map`.
      _.sample = function (obj, n, guard) {
        if (arguments.length < 2 || guard) {
          return obj[_.random(obj.length - 1)];
        }
        return _.shuffle(obj).slice(0, Math.max(0, n));
      };

      // An internal function to generate lookup iterators.
      var lookupIterator = function (value) {
        return _.isFunction(value) ? value : function (obj) {
          return obj[value];
        };
      };

      // Sort the object's values by a criterion produced by an iterator.
      _.sortBy = function (obj, value, context) {
        var iterator = lookupIterator(value);
        return _.pluck(_.map(obj, function (value, index, list) {
          return {
            value: value,
            index: index,
            criteria: iterator.call(context, value, index, list)
          };
        }).sort(function (left, right) {
          var a = left.criteria;
          var b = right.criteria;
          if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
          }
          return left.index - right.index;
        }), 'value');
      };

      // An internal function used for aggregate "group by" operations.
      var group = function (behavior) {
        return function (obj, value, context) {
          var result = {};
          var iterator = value == null ? _.identity : lookupIterator(value);
          each(obj, function (value, index) {
            var key = iterator.call(context, value, index, obj);
            behavior(result, key, value);
          });
          return result;
        };
      };

      // Groups the object's values by a criterion. Pass either a string attribute
      // to group by, or a function that returns the criterion.
      _.groupBy = group(function (result, key, value) {
        (_.has(result, key) ? result[key] : result[key] = []).push(value);
      });

      // Indexes the object's values by a criterion, similar to `groupBy`, but for
      // when you know that your index values will be unique.
      _.indexBy = group(function (result, key, value) {
        result[key] = value;
      });

      // Counts instances of an object that group by a certain criterion. Pass
      // either a string attribute to count by, or a function that returns the
      // criterion.
      _.countBy = group(function (result, key) {
        _.has(result, key) ? result[key]++ : result[key] = 1;
      });

      // Use a comparator function to figure out the smallest index at which
      // an object should be inserted so as to maintain order. Uses binary search.
      _.sortedIndex = function (array, obj, iterator, context) {
        iterator = iterator == null ? _.identity : lookupIterator(iterator);
        var value = iterator.call(context, obj);
        var low = 0,
            high = array.length;
        while (low < high) {
          var mid = low + high >>> 1;
          iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
        }
        return low;
      };

      // Safely create a real, live array from anything iterable.
      _.toArray = function (obj) {
        if (!obj) return [];
        if (_.isArray(obj)) return slice.call(obj);
        if (looksLikeArray(obj)) return _.map(obj, _.identity);
        return _.values(obj);
      };

      // Return the number of elements in an object.
      _.size = function (obj) {
        if (obj == null) return 0;
        return looksLikeArray(obj) ? obj.length : _.keys(obj).length;
      };

      // Array Functions
      // ---------------

      // Get the first element of an array. Passing **n** will return the first N
      // values in the array. Aliased as `head` and `take`. The **guard** check
      // allows it to work with `_.map`.
      _.first = _.head = _.take = function (array, n, guard) {
        if (array == null) return void 0;
        return n == null || guard ? array[0] : slice.call(array, 0, n);
      };

      // Returns everything but the last entry of the array. Especially useful on
      // the arguments object. Passing **n** will return all the values in
      // the array, excluding the last N. The **guard** check allows it to work with
      // `_.map`.
      _.initial = function (array, n, guard) {
        return slice.call(array, 0, array.length - (n == null || guard ? 1 : n));
      };

      // Get the last element of an array. Passing **n** will return the last N
      // values in the array. The **guard** check allows it to work with `_.map`.
      _.last = function (array, n, guard) {
        if (array == null) return void 0;
        if (n == null || guard) {
          return array[array.length - 1];
        } else {
          return slice.call(array, Math.max(array.length - n, 0));
        }
      };

      // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
      // Especially useful on the arguments object. Passing an **n** will return
      // the rest N values in the array. The **guard**
      // check allows it to work with `_.map`.
      _.rest = _.tail = _.drop = function (array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
      };

      // Trim out all falsy values from an array.
      _.compact = function (array) {
        return _.filter(array, _.identity);
      };

      // Internal implementation of a recursive `flatten` function.
      var flatten = function (input, shallow, output) {
        if (shallow && _.every(input, _.isArray)) {
          return concat.apply(output, input);
        }
        each(input, function (value) {
          if (_.isArray(value) || _.isArguments(value)) {
            shallow ? push.apply(output, value) : flatten(value, shallow, output);
          } else {
            output.push(value);
          }
        });
        return output;
      };

      // Flatten out an array, either recursively (by default), or just one level.
      _.flatten = function (array, shallow) {
        return flatten(array, shallow, []);
      };

      // Return a version of the array that does not contain the specified value(s).
      _.without = function (array) {
        return _.difference(array, slice.call(arguments, 1));
      };

      // Produce a duplicate-free version of the array. If the array has already
      // been sorted, you have the option of using a faster algorithm.
      // Aliased as `unique`.
      _.uniq = _.unique = function (array, isSorted, iterator, context) {
        if (_.isFunction(isSorted)) {
          context = iterator;
          iterator = isSorted;
          isSorted = false;
        }
        var initial = iterator ? _.map(array, iterator, context) : array;
        var results = [];
        var seen = [];
        each(initial, function (value, index) {
          if (isSorted ? !index || seen[seen.length - 1] !== value : !_.contains(seen, value)) {
            seen.push(value);
            results.push(array[index]);
          }
        });
        return results;
      };

      // Produce an array that contains the union: each distinct element from all of
      // the passed-in arrays.
      _.union = function () {
        return _.uniq(_.flatten(arguments, true));
      };

      // Produce an array that contains every item shared between all the
      // passed-in arrays.
      _.intersection = function (array) {
        var rest = slice.call(arguments, 1);
        return _.filter(_.uniq(array), function (item) {
          return _.every(rest, function (other) {
            return _.indexOf(other, item) >= 0;
          });
        });
      };

      // Take the difference between one array and a number of other arrays.
      // Only the elements present in just the first array will remain.
      _.difference = function (array) {
        var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
        return _.filter(array, function (value) {
          return !_.contains(rest, value);
        });
      };

      // Zip together multiple lists into a single array -- elements that share
      // an index go together.
      _.zip = function () {
        var length = _.max(_.pluck(arguments, "length").concat(0));
        var results = new Array(length);
        for (var i = 0; i < length; i++) {
          results[i] = _.pluck(arguments, '' + i);
        }
        return results;
      };

      // Converts lists into objects. Pass either a single array of `[key, value]`
      // pairs, or two parallel arrays of the same length -- one of keys, and one of
      // the corresponding values.
      _.object = function (list, values) {
        if (list == null) return {};
        var result = {};
        for (var i = 0, length = list.length; i < length; i++) {
          if (values) {
            result[list[i]] = values[i];
          } else {
            result[list[i][0]] = list[i][1];
          }
        }
        return result;
      };

      // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
      // we need this function. Return the position of the first occurrence of an
      // item in an array, or -1 if the item is not included in the array.
      // Delegates to **ECMAScript 5**'s native `indexOf` if available.
      // If the array is large and already in sort order, pass `true`
      // for **isSorted** to use binary search.
      _.indexOf = function (array, item, isSorted) {
        if (array == null) return -1;
        var i = 0,
            length = array.length;
        if (isSorted) {
          if (typeof isSorted == 'number') {
            i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
          } else {
            i = _.sortedIndex(array, item);
            return array[i] === item ? i : -1;
          }
        }
        if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
        for (; i < length; i++) if (array[i] === item) return i;
        return -1;
      };

      // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
      _.lastIndexOf = function (array, item, from) {
        if (array == null) return -1;
        var hasIndex = from != null;
        if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
          return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
        }
        var i = hasIndex ? from : array.length;
        while (i--) if (array[i] === item) return i;
        return -1;
      };

      // Generate an integer Array containing an arithmetic progression. A port of
      // the native Python `range()` function. See
      // [the Python documentation](http://docs.python.org/library/functions.html#range).
      _.range = function (start, stop, step) {
        if (arguments.length <= 1) {
          stop = start || 0;
          start = 0;
        }
        step = arguments[2] || 1;

        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var idx = 0;
        var range = new Array(length);

        while (idx < length) {
          range[idx++] = start;
          start += step;
        }

        return range;
      };

      // Function (ahem) Functions
      // ------------------

      // Reusable constructor function for prototype setting.
      var ctor = function () {};

      // Create a function bound to a given object (assigning `this`, and arguments,
      // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
      // available.
      _.bind = function (func, context) {
        var args, bound;
        if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
        if (!_.isFunction(func)) throw new TypeError();
        args = slice.call(arguments, 2);
        return bound = function () {
          if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
          ctor.prototype = func.prototype;
          var self = new ctor();
          ctor.prototype = null;
          var result = func.apply(self, args.concat(slice.call(arguments)));
          if (Object(result) === result) return result;
          return self;
        };
      };

      // Partially apply a function by creating a version that has had some of its
      // arguments pre-filled, without changing its dynamic `this` context.
      _.partial = function (func) {
        var args = slice.call(arguments, 1);
        return function () {
          return func.apply(this, args.concat(slice.call(arguments)));
        };
      };

      // Bind all of an object's methods to that object. Useful for ensuring that
      // all callbacks defined on an object belong to it.
      _.bindAll = function (obj) {
        var funcs = slice.call(arguments, 1);
        if (funcs.length === 0) throw new Error("bindAll must be passed function names");
        each(funcs, function (f) {
          obj[f] = _.bind(obj[f], obj);
        });
        return obj;
      };

      // Memoize an expensive function by storing its results.
      _.memoize = function (func, hasher) {
        var memo = {};
        hasher || (hasher = _.identity);
        return function () {
          var key = hasher.apply(this, arguments);
          return _.has(memo, key) ? memo[key] : memo[key] = func.apply(this, arguments);
        };
      };

      // Delays a function for the given number of milliseconds, and then calls
      // it with the arguments supplied.
      _.delay = function (func, wait) {
        var args = slice.call(arguments, 2);
        return setTimeout(function () {
          return func.apply(null, args);
        }, wait);
      };

      // Defers a function, scheduling it to run after the current call stack has
      // cleared.
      _.defer = function (func) {
        return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
      };

      // Returns a function, that, when invoked, will only be triggered at most once
      // during a given window of time. Normally, the throttled function will run
      // as much as it can, without ever going more than once per `wait` duration;
      // but if you'd like to disable the execution on the leading edge, pass
      // `{leading: false}`. To disable execution on the trailing edge, ditto.
      _.throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        options || (options = {});
        var later = function () {
          previous = options.leading === false ? 0 : new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date();
          if (!previous && options.leading === false) previous = now;
          var remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      };

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.
      _.debounce = function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;
        return function () {
          context = this;
          args = arguments;
          timestamp = new Date();
          var later = function () {
            var last = new Date() - timestamp;
            if (last < wait) {
              timeout = setTimeout(later, wait - last);
            } else {
              timeout = null;
              if (!immediate) result = func.apply(context, args);
            }
          };
          var callNow = immediate && !timeout;
          if (!timeout) {
            timeout = setTimeout(later, wait);
          }
          if (callNow) result = func.apply(context, args);
          return result;
        };
      };

      // Returns a function that will be executed at most one time, no matter how
      // often you call it. Useful for lazy initialization.
      _.once = function (func) {
        var ran = false,
            memo;
        return function () {
          if (ran) return memo;
          ran = true;
          memo = func.apply(this, arguments);
          func = null;
          return memo;
        };
      };

      // Returns the first function passed as an argument to the second,
      // allowing you to adjust arguments, run code before and after, and
      // conditionally execute the original function.
      _.wrap = function (func, wrapper) {
        return function () {
          var args = [func];
          push.apply(args, arguments);
          return wrapper.apply(this, args);
        };
      };

      // Returns a function that is the composition of a list of functions, each
      // consuming the return value of the function that follows.
      _.compose = function () {
        var funcs = arguments;
        return function () {
          var args = arguments;
          for (var i = funcs.length - 1; i >= 0; i--) {
            args = [funcs[i].apply(this, args)];
          }
          return args[0];
        };
      };

      // Returns a function that will only be executed after being called N times.
      _.after = function (times, func) {
        return function () {
          if (--times < 1) {
            return func.apply(this, arguments);
          }
        };
      };

      // Object Functions
      // ----------------

      // Retrieve the names of an object's properties.
      // Delegates to **ECMAScript 5**'s native `Object.keys`
      _.keys = nativeKeys || function (obj) {
        if (obj !== Object(obj)) throw new TypeError('Invalid object');
        var keys = [];
        for (var key in obj) if (_.has(obj, key)) keys.push(key);
        return keys;
      };

      // Retrieve the values of an object's properties.
      _.values = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = new Array(length);
        for (var i = 0; i < length; i++) {
          values[i] = obj[keys[i]];
        }
        return values;
      };

      // Convert an object into a list of `[key, value]` pairs.
      _.pairs = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = new Array(length);
        for (var i = 0; i < length; i++) {
          pairs[i] = [keys[i], obj[keys[i]]];
        }
        return pairs;
      };

      // Invert the keys and values of an object. The values must be serializable.
      _.invert = function (obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
          result[obj[keys[i]]] = keys[i];
        }
        return result;
      };

      // Return a sorted list of the function names available on the object.
      // Aliased as `methods`
      _.functions = _.methods = function (obj) {
        var names = [];
        for (var key in obj) {
          if (_.isFunction(obj[key])) names.push(key);
        }
        return names.sort();
      };

      // Extend a given object with all the properties in passed-in object(s).
      _.extend = function (obj) {
        each(slice.call(arguments, 1), function (source) {
          if (source) {
            for (var prop in source) {
              obj[prop] = source[prop];
            }
          }
        });
        return obj;
      };

      // Return a copy of the object only containing the whitelisted properties.
      _.pick = function (obj) {
        var copy = {};
        var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
        each(keys, function (key) {
          if (key in obj) copy[key] = obj[key];
        });
        return copy;
      };

      // Return a copy of the object without the blacklisted properties.
      _.omit = function (obj) {
        var copy = {};
        var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
        for (var key in obj) {
          if (!_.contains(keys, key)) copy[key] = obj[key];
        }
        return copy;
      };

      // Fill in a given object with default properties.
      _.defaults = function (obj) {
        each(slice.call(arguments, 1), function (source) {
          if (source) {
            for (var prop in source) {
              if (obj[prop] === void 0) obj[prop] = source[prop];
            }
          }
        });
        return obj;
      };

      // Create a (shallow-cloned) duplicate of an object.
      _.clone = function (obj) {
        if (!_.isObject(obj)) return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
      };

      // Invokes interceptor with the obj, and then returns obj.
      // The primary purpose of this method is to "tap into" a method chain, in
      // order to perform operations on intermediate results within the chain.
      _.tap = function (obj, interceptor) {
        interceptor(obj);
        return obj;
      };

      // Internal recursive comparison function for `isEqual`.
      var eq = function (a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a == 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;
        // Unwrap any wrapped objects.
        if (a instanceof _) a = a._wrapped;
        if (b instanceof _) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = toString.call(a);
        if (className != toString.call(b)) return false;
        switch (className) {
          // Strings, numbers, dates, and booleans are compared by value.
          case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return a == String(b);
          case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
            // other numeric values.
            return a != +a ? b != +b : a == 0 ? 1 / a == 1 / b : a == +b;
          case '[object Date]':
          case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a == +b;
          // RegExps are compared by their source patterns and flags.
          case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
        }
        if (typeof a != 'object' || typeof b != 'object') return false;
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        var length = aStack.length;
        while (length--) {
          // Linear search. Performance is inversely proportional to the number of
          // unique nested structures.
          if (aStack[length] == a) return bStack[length] == b;
        }
        // Objects with different constructors are not equivalent, but `Object`s
        // from different frames are.
        var aCtor = a.constructor,
            bCtor = b.constructor;
        if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor)) {
          return false;
        }
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        var size = 0,
            result = true;
        // Recursively compare objects and arrays.
        if (className == '[object Array]') {
          // Compare array lengths to determine if a deep comparison is necessary.
          size = a.length;
          result = size == b.length;
          if (result) {
            // Deep compare the contents, ignoring non-numeric properties.
            while (size--) {
              if (!(result = eq(a[size], b[size], aStack, bStack))) break;
            }
          }
        } else {
          // Deep compare objects.
          for (var key in a) {
            if (_.has(a, key)) {
              // Count the expected number of properties.
              size++;
              // Deep compare each member.
              if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
            }
          }
          // Ensure that both objects contain the same number of properties.
          if (result) {
            for (key in b) {
              if (_.has(b, key) && !size--) break;
            }
            result = !size;
          }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return result;
      };

      // Perform a deep comparison to check if two objects are equal.
      _.isEqual = function (a, b) {
        return eq(a, b, [], []);
      };

      // Is a given array, string, or object empty?
      // An "empty" object has no enumerable own-properties.
      _.isEmpty = function (obj) {
        if (obj == null) return true;
        if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
        for (var key in obj) if (_.has(obj, key)) return false;
        return true;
      };

      // Is a given value a DOM element?
      _.isElement = function (obj) {
        return !!(obj && obj.nodeType === 1);
      };

      // Is a given value an array?
      // Delegates to ECMA5's native Array.isArray
      _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) == '[object Array]';
      };

      // Is a given variable an object?
      _.isObject = function (obj) {
        return obj === Object(obj);
      };

      // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
      each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function (name) {
        _['is' + name] = function (obj) {
          return toString.call(obj) == '[object ' + name + ']';
        };
      });

      // Define a fallback version of the method in browsers (ahem, IE), where
      // there isn't any inspectable "Arguments" type.
      if (!_.isArguments(arguments)) {
        _.isArguments = function (obj) {
          return !!(obj && _.has(obj, 'callee'));
        };
      }

      // Optimize `isFunction` if appropriate.
      if (typeof /./ !== 'function') {
        _.isFunction = function (obj) {
          return typeof obj === 'function';
        };
      }

      // Is a given object a finite number?
      _.isFinite = function (obj) {
        return isFinite(obj) && !isNaN(parseFloat(obj));
      };

      // Is the given value `NaN`? (NaN is the only number which does not equal itself).
      _.isNaN = function (obj) {
        return _.isNumber(obj) && obj != +obj;
      };

      // Is a given value a boolean?
      _.isBoolean = function (obj) {
        return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
      };

      // Is a given value equal to null?
      _.isNull = function (obj) {
        return obj === null;
      };

      // Is a given variable undefined?
      _.isUndefined = function (obj) {
        return obj === void 0;
      };

      // Shortcut function for checking if an object has a given property directly
      // on itself (in other words, not on a prototype).
      _.has = function (obj, key) {
        return hasOwnProperty.call(obj, key);
      };

      // Utility Functions
      // -----------------

      // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
      // previous owner. Returns a reference to the Underscore object.
      _.noConflict = function () {
        root._ = previousUnderscore;
        return this;
      };

      // Keep the identity function around for default iterators.
      _.identity = function (value) {
        return value;
      };

      // Run a function **n** times.
      _.times = function (n, iterator, context) {
        var accum = Array(Math.max(0, n));
        for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
        return accum;
      };

      // Return a random integer between min and max (inclusive).
      _.random = function (min, max) {
        if (max == null) {
          max = min;
          min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
      };

      // List of HTML entities for escaping.
      var entityMap = {
        escape: {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;'
        }
      };
      entityMap.unescape = _.invert(entityMap.escape);

      // Regexes containing the keys and values listed immediately above.
      var entityRegexes = {
        escape: new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
        unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
      };

      // Functions for escaping and unescaping strings to/from HTML interpolation.
      _.each(['escape', 'unescape'], function (method) {
        _[method] = function (string) {
          if (string == null) return '';
          return ('' + string).replace(entityRegexes[method], function (match) {
            return entityMap[method][match];
          });
        };
      });

      // If the value of the named `property` is a function then invoke it with the
      // `object` as context; otherwise, return it.
      _.result = function (object, property) {
        if (object == null) return void 0;
        var value = object[property];
        return _.isFunction(value) ? value.call(object) : value;
      };

      // Add your own custom functions to the Underscore object.
      _.mixin = function (obj) {
        each(_.functions(obj), function (name) {
          var func = _[name] = obj[name];
          _.prototype[name] = function () {
            var args = [this._wrapped];
            push.apply(args, arguments);
            return result.call(this, func.apply(_, args));
          };
        });
      };

      // Generate a unique integer id (unique within the entire client session).
      // Useful for temporary DOM ids.
      var idCounter = 0;
      _.uniqueId = function (prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
      };

      // By default, Underscore uses ERB-style template delimiters, change the
      // following template settings to use alternative delimiters.
      _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };

      // When customizing `templateSettings`, if you don't want to define an
      // interpolation, evaluation or escaping regex, we need one that is
      // guaranteed not to match.
      var noMatch = /(.)^/;

      // Certain characters need to be escaped so that they can be put into a
      // string literal.
      var escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        '\t': 't',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
      };

      var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

      // JavaScript micro-templating, similar to John Resig's implementation.
      // Underscore templating handles arbitrary delimiters, preserves whitespace,
      // and correctly escapes quotes within interpolated code.
      _.template = function (text, data, settings) {
        var render;
        settings = _.defaults({}, settings, _.templateSettings);

        // Combine delimiters into one regular expression via alternation.
        var matcher = new RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
          source += text.slice(index, offset).replace(escaper, function (match) {
            return '\\' + escapes[match];
          });

          if (escape) {
            source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
          }
          if (interpolate) {
            source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
          }
          if (evaluate) {
            source += "';\n" + evaluate + "\n__p+='";
          }
          index = offset + match.length;
          return match;
        });
        source += "';\n";

        // If a variable is not specified, place data values in local scope.
        if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";

        try {
          render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
          e.source = source;
          throw e;
        }

        if (data) return render(data, _);
        var template = function (data) {
          return render.call(this, data, _);
        };

        // Provide the compiled function source as a convenience for precompilation.
        template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

        return template;
      };

      // Add a "chain" function, which will delegate to the wrapper.
      _.chain = function (obj) {
        return _(obj).chain();
      };

      // OOP
      // ---------------
      // If Underscore is called as a function, it returns a wrapped object that
      // can be used OO-style. This wrapper holds altered versions of all the
      // underscore functions. Wrapped objects may be chained.

      // Helper function to continue chaining intermediate results.
      var result = function (obj) {
        return this._chain ? _(obj).chain() : obj;
      };

      // Add all of the Underscore functions to the wrapper object.
      _.mixin(_);

      // Add all mutator Array functions to the wrapper.
      each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
          var obj = this._wrapped;
          method.apply(obj, arguments);
          if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
          return result.call(this, obj);
        };
      });

      // Add all accessor Array functions to the wrapper.
      each(['concat', 'join', 'slice'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
          return result.call(this, method.apply(this._wrapped, arguments));
        };
      });

      _.extend(_.prototype, {

        // Start chaining a wrapped Underscore object.
        chain: function () {
          this._chain = true;
          return this;
        },

        // Extracts the result from a wrapped and chained object.
        value: function () {
          return this._wrapped;
        }

      });
    }).call(this);

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                                       //
    // packages/underscore/post.js                                                                           //
    //                                                                                                       //
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // This exports object was created in pre.js.  Now copy the `_` object from it
    // into the package-scope variable `_`, which will get exported.
    _ = _exports._;

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("underscore", {
    _: _
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

	/* Imports */
	var Meteor = Package.meteor.Meteor;
	var global = Package.meteor.global;
	var meteorEnv = Package.meteor.meteorEnv;
	var $ = Package.jquery.$;
	var jQuery = Package.jquery.jQuery;
	var _ = Package.underscore._;

	(function () {

		////////////////////////////////////////////////////////////////////////////////////////////////////
		//                                                                                                //
		// packages/mrt_external-file-loader/packages/mrt_external-file-loader.js                         //
		//                                                                                                //
		////////////////////////////////////////////////////////////////////////////////////////////////////
		//
		(function () {

			//////////////////////////////////////////////////////////////////////////////////////////////
			//                                                                                          //
			// packages/mrt:external-file-loader/lib/external-file-loader.js                            //
			//                                                                                          //
			//////////////////////////////////////////////////////////////////////////////////////////////
			//
			// external-file-loader.js                                                                  // 1
			// 2
			(function () {
				// 3
				// 4
				var Loader = function () {
					// 5
					this.loadedUrls = {}; // 6
				}; // 7
				// 8
				// Callback must be of the jquery success callback form: function(data, textStatus, jqxhr) // 9
				Loader.prototype.loadJs = function (url, callback) {
					// 10
					var self = this; // 11
					// 12
					// Prevent duplicate URLs from being loaded.                                              // 13
					if (self.loaded(url)) {
						// 14
						return false; // 15
					} // 16
					// 17
					self.loadedUrls[url] = false; // 18
					// 19
					$.getScript(url, function (data, textStatus, jqxhr) {
						// 20
						self.loadedUrls[url] = true; // 21
						if (callback) {
							// 22
							callback(data, textStatus, jqxhr); // 23
						} // 24
					}); // 25
				}; // 26
				// 27
				Loader.prototype.loadCss = function (url) {
					// 28
					var self = this; // 29
					// Prevent duplicate URLs from being loaded.                                              // 30
					if (self.loaded(url)) {
						// 31
						return false; // 32
					} // 33
					// 34
					var css = document.createElement('link'); // 35
					css.setAttribute('rel', 'stylesheet'); // 36
					css.setAttribute('type', 'text/css'); // 37
					css.setAttribute('href', url); // 38
					document.getElementsByTagName("head")[0].appendChild(css); // 39
					// 40
					self.loadedUrls[url] = true; // 41
				}; // 42
				// 43
				Loader.prototype.loaded = function (url) {
					// 44
					var self = this; // 45
					return _.has(self.loadedUrls, url) && self.loadedUrls[url]; // 46
				}; // 47
				// 48
				// Only use this method for testing.                                                       // 49
				Loader.prototype.resetUrls = function () {
					// 50
					this.loadedUrls = {}; // 51
				}; // 52
				// 53
				Meteor.Loader = new Loader(); // 54
				// 55
			})(); // 56
			//////////////////////////////////////////////////////////////////////////////////////////////
		}).call(this);

		////////////////////////////////////////////////////////////////////////////////////////////////////
	}).call(this);

	/* Exports */
	Package._define("mrt:external-file-loader");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var ValidationError;

  var _require = meteorInstall({ "node_modules": { "meteor": { "mdg:validation-error": { "validation-error.js": function _module() {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/mdg_validation-error/validation-error.js                                                                   //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // The "details" property of the ValidationError must be an array of objects
            // containing at least two properties. The "name" and "type" properties are
            // required.
            const errorsPattern = [Match.ObjectIncluding({
              name: String,
              type: String
            })];
            ValidationError = class extends Meteor.Error {
              constructor(errors) {
                let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ValidationError.DEFAULT_MESSAGE;
                check(errors, errorsPattern);
                check(message, String);
                return super(ValidationError.ERROR_CODE, message, errors);
              } // Static method checking if a given Meteor.Error is an instance of
              // ValidationError.


              static is(err) {
                return err instanceof Meteor.Error && err.error === ValidationError.ERROR_CODE;
              }

            }; // Universal validation error code to be use in applications and packages.

            ValidationError.ERROR_CODE = 'validation-error'; // Default validation error message that can be changed globally.

            ValidationError.DEFAULT_MESSAGE = 'Validation failed';
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/mdg:validation-error/validation-error.js");

  /* Exports */
  Package._define("mdg:validation-error", {
    ValidationError: ValidationError
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var DDP = Package['ddp-client'].DDP;
  var Mongo = Package.mongo.Mongo;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var LocalCollection = Package.minimongo.LocalCollection;
  var Minimongo = Package.minimongo.Minimongo;
  var EJSON = Package.ejson.EJSON;
  var ValidationError = Package['mdg:validation-error'].ValidationError;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var extendDefinition;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "jagi:astronomy": { "lib": { "main.js": function module(_require, _exports, _module) {

              ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                                    //
              // packages/jagi_astronomy/lib/main.js                                                                                //
              //                                                                                                                    //
              ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              !function (module1) {
                module1.export({
                  Astro: () => Astro,
                  Module: () => Module,
                  Class: () => Class,
                  Enum: () => Enum,
                  Union: () => Union,
                  Type: () => Type,
                  Field: () => Field,
                  ScalarField: () => ScalarField,
                  ObjectField: () => ObjectField,
                  ListField: () => ListField,
                  Behavior: () => Behavior,
                  Validator: () => Validator,
                  Validators: () => Validators,
                  ValidationError: () => ValidationError,
                  Event: () => Event,
                  reservedKeywords: () => reservedKeywords
                });
                module1.link("./core/ejson.js");
                module1.link("./modules/core/module.js");
                module1.link("./modules/storage/module.js");
                module1.link("./modules/behaviors/module.js");
                module1.link("./modules/events/module.js");
                module1.link("./modules/methods/module.js");
                module1.link("./modules/helpers/module.js");
                module1.link("./modules/fields/module.js");
                module1.link("./modules/indexes/module.js");
                module1.link("./modules/validators/module.js");
                let Config;
                module1.link("./core/config.js", {
                  default(v) {
                    Config = v;
                  }

                }, 0);
                let Module;
                module1.link("./core/module.js", {
                  default(v) {
                    Module = v;
                  }

                }, 1);
                let Class;
                module1.link("./core/class.js", {
                  default(v) {
                    Class = v;
                  }

                }, 2);
                let reservedKeywords;
                module1.link("./core/reserved_keywords.js", {
                  default(v) {
                    reservedKeywords = v;
                  }

                }, 3);
                let Enum;
                module1.link("./modules/fields/Enum.js", {
                  default(v) {
                    Enum = v;
                  }

                }, 4);
                let Union;
                module1.link("./modules/fields/Union.js", {
                  default(v) {
                    Union = v;
                  }

                }, 5);
                let Type;
                module1.link("./modules/fields/type.js", {
                  default(v) {
                    Type = v;
                  }

                }, 6);
                let Field;
                module1.link("./modules/fields/Field", {
                  default(v) {
                    Field = v;
                  }

                }, 7);
                let ScalarField;
                module1.link("./modules/fields/ScalarField", {
                  default(v) {
                    ScalarField = v;
                  }

                }, 8);
                let ObjectField;
                module1.link("./modules/fields/ObjectField", {
                  default(v) {
                    ObjectField = v;
                  }

                }, 9);
                let ListField;
                module1.link("./modules/fields/ListField", {
                  default(v) {
                    ListField = v;
                  }

                }, 10);
                let Behavior;
                module1.link("./modules/behaviors/behavior.js", {
                  default(v) {
                    Behavior = v;
                  }

                }, 11);
                let Validator;
                module1.link("./modules/validators/validator.js", {
                  default(v) {
                    Validator = v;
                  }

                }, 12);
                let Validators;
                module1.link("./modules/validators/validators.js", {
                  default(v) {
                    Validators = v;
                  }

                }, 13);
                let ValidationError;
                module1.link("meteor/mdg:validation-error", {
                  ValidationError(v) {
                    ValidationError = v;
                  }

                }, 14);
                let Event;
                module1.link("./modules/events/event.js", {
                  default(v) {
                    Event = v;
                  }

                }, 15);
                const Astro = {
                  config: Config,
                  Config,
                  Module,
                  Class,
                  Enum,
                  Union,
                  Type,
                  Field,
                  ScalarField,
                  ObjectField,
                  ListField,
                  Behavior,
                  Validator,
                  Validators,
                  ValidationError,
                  Event,
                  reservedKeywords
                };
              }.call(this, _module);
              ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            }, "core": { "class.js": function module(_require3, _exports3, _module2) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // packages/jagi_astronomy/lib/core/class.js                                                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                !function (module1) {
                  let _concat;

                  module1.link("lodash/concat", {
                    default(v) {
                      _concat = v;
                    }

                  }, 0);

                  let _defaults;

                  module1.link("lodash/defaults", {
                    default(v) {
                      _defaults = v;
                    }

                  }, 1);

                  let _each;

                  module1.link("lodash/each", {
                    default(v) {
                      _each = v;
                    }

                  }, 2);

                  let _has;

                  module1.link("lodash/has", {
                    default(v) {
                      _has = v;
                    }

                  }, 3);

                  let _includes;

                  module1.link("lodash/includes", {
                    default(v) {
                      _includes = v;
                    }

                  }, 4);

                  let _intersection;

                  module1.link("lodash/intersection", {
                    default(v) {
                      _intersection = v;
                    }

                  }, 5);

                  let _isNumber;

                  module1.link("lodash/isNumber", {
                    default(v) {
                      _isNumber = v;
                    }

                  }, 6);
                  let EJSON;
                  module1.link("meteor/ejson", {
                    EJSON(v) {
                      EJSON = v;
                    }

                  }, 7);
                  let config;
                  module1.link("./config", {
                    default(v) {
                      config = v;
                    }

                  }, 8);
                  let throwParseError;
                  module1.link("../modules/core/utils/throw_parse_error", {
                    default(v) {
                      throwParseError = v;
                    }

                  }, 9);
                  let cloneDefinition;
                  module1.link("../modules/core/utils/cloneDefinition", {
                    default(v) {
                      cloneDefinition = v;
                    }

                  }, 10);
                  let castNested;
                  module1.link("../modules/fields/utils/castNested", {
                    default(v) {
                      castNested = v;
                    }

                  }, 11);
                  let Module;
                  module1.link("./module", {
                    default(v) {
                      Module = v;
                    }

                  }, 12);
                  let Event;
                  module1.link("../modules/events/event", {
                    default(v) {
                      Event = v;
                    }

                  }, 13);
                  let Type;
                  module1.link("../modules/fields/type", {
                    default(v) {
                      Type = v;
                    }

                  }, 14);
                  let Validators;
                  module1.link("../modules/validators/validators", {
                    default(v) {
                      Validators = v;
                    }

                  }, 15);
                  let warn;
                  module1.link("../modules/core/utils/warn", {
                    default(v) {
                      warn = v;
                    }

                  }, 16);

                  let initClass = function (Class) {
                    // Create and store the schema "definition" object in the class constructor.
                    // It's a combination of all parent definitions and a definition that
                    // created this class. It's used to create child classes.
                    Class.definition = {}; // Create and store the "schema" object in the class constructor. It's an
                    // object that contains all the data related with a given class. The
                    // "schema" object contains "computed" data of the schema "definition".
                    // Thanks to that, Astronomy does not need to compute data on the fly and
                    // everything works faster.

                    Class.schema = {}; // Create empty array for storing child classes.

                    Class.children = []; // Init the class schema and schema definition.

                    Module.forEach(_module3 => {
                      _module3.onInitSchema(Class.schema, Class.getName());
                      _module3.onInitDefinition(Class.definition, Class.getName());
                    }); // We have to call the "onInitClass" hooks in the separate loop after
                    // initiation of the schema and schema definition, because some
                    // "onInitClass" hooks can execute the "Class.extend" method which requires
                    // schema and schama definition to be initalized.

                    Module.forEach(_module4 => {
                      _module4.onInitClass(Class, Class.getName());
                    });
                  };

                  class Class {
                    constructor() {
                      let rawDoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                      // Set default options.
                      _defaults(options, {
                        // From version 2.3.0, we can turn off setting default values on fetching
                        // so it will not populate fields that were excluded on find.
                        defaults: config.defaults,
                        // We clone values on document construction, but this option is overridden
                        // in the "find" method and set to false, so it does not unnecessary clone
                        // clone raw values.
                        clone: true,
                        cast: false
                      });

                      const doc = this;
                      const Class = doc.constructor;

                      if (!Class.getName()) {
                        throw new Error('Can not create instance of the "Class" class');
                      } // If there is the "_isNew" property passed to the class constructor, the
                      // we use it to determine if a document is stored in collection. Otherwise
                      // document is a new one.


                      if (Class.getCollection()) {
                        doc._isNew = _has(rawDoc, "_isNew") ? rawDoc._isNew : true;
                      } // Trigger the "beforeInit" event handlers.


                      doc.dispatchEvent(new Event("beforeInit")); // Set values in a document.

                      _each(Class.getFieldsNames(), fieldName => {
                        doc.set(fieldName, rawDoc[fieldName], options);
                      }); // Trigger the "afterInit" event handlers.


                      doc.dispatchEvent(new Event("afterInit"));
                    } // Method needed for EJSONification.


                    typeName() {
                      return "Astronomy";
                    }

                    toJSONValue(args) {
                      let doc = this;
                      let Class = doc.constructor;
                      let json = {
                        class: Class.getName()
                      }; // Trigger the "toJSONValue" event handlers.

                      doc.dispatchEvent(new Event("toJSONValue", {
                        json: json
                      }));
                      return json;
                    }

                    static getName() {
                      return this.className;
                    }

                    static getParent() {
                      if (this.parentClassName) {
                        return this.get(this.parentClassName);
                      }
                    }
                    /**
                     * @param {(Number|Boolean)} depth - The depth to which look for children, or "true" to get all children.
                     */

                    static getChildren() {
                      let depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                      const classes = [];

                      if (!depth) {
                        return classes;
                      }

                      classes.push(...this.children);

                      if (_isNumber(depth)) {
                        depth--;
                      }

                      _each(this.children, Child => {
                        classes.push(...Child.getChildren(depth));
                      });

                      return classes;
                    }

                    static create(definition) {
                      // Get class name.
                      let className = definition.name; // Warn about class duplicate.

                      if (_has(this.classes, className)) {
                        warn("Duplicate of the \"".concat(className, "\" class"));
                      } // Extend the Class class.


                      let Class = this.classes[className] = class Class extends this {}; // Store the class name in the constructor.

                      Class.className = className; // Initialize class.

                      initClass(Class); // Extend class with a definition.

                      Class.extend(definition); // Register a new type.

                      Type.create({
                        name: className,
                        class: Class,

                        validate(args) {
                          // Add current class as a param of validator.
                          args.param = Class;
                          Validators.class(args);
                        }

                      });
                      return Class;
                    }

                    static inherit(definition) {
                      const Parent = this;
                      const className = definition.name; // Warn about class duplicate.

                      if (_has(this.classes, className)) {
                        warn("Duplicate of the \"".concat(className, "\" class"));
                      } // Extend the parent class.


                      const Class = this.classes[className] = class Class extends Parent {}; // Store the class name in the constructor.

                      Class.className = className; // Store the parent class name in the constructor.

                      Class.parentClassName = Parent.getName(); // Initialize class.

                      initClass(Class); // Store child class in the parent class.

                      Parent.children.push(Class); // Extend class with the parent class definition.

                      Class.extend(Parent.definition); // Extend class with the definition.

                      Class.extend(definition); // Register a new type.

                      Type.create({
                        name: className,
                        class: Class,

                        validate(args) {
                          // Add current class as a param of validator.
                          args.param = Class;
                          Validators.class(args);
                        }

                      });
                      return Class;
                    }

                    static extend(extendDefinition) {
                      let onlyModules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

                      if (typeof onlyModules === "string") {
                        onlyModules = [onlyModules];
                      }

                      if (!Match.test(onlyModules, [String])) {
                        throwParseError([{
                          class: this.getName()
                        }, {
                          method: "extend"
                        }, "The second argument has to be a string or an array of strings"]);
                      } // Clone definition to not modify the original one.


                      extendDefinition = cloneDefinition(extendDefinition);
                      Module.forEach(_module5 => {
                        // If the second argument was passed, then we only run module hooks for
                        // modules that were listed in the second argument.
                        if (onlyModules.length > 0 && !_includes(onlyModules, _module5.name) && _intersection(onlyModules, _module5.aliases).length === 0) {
                          return;
                        } // Initialize parsed definition.


                        let parsedDefinition = {};
                        _module5.onInitDefinition(parsedDefinition, Class.getName()); // Parse the extending definition and put parsed properties in the parsed
                        // definition.

                        _module5.onParseDefinition(parsedDefinition, extendDefinition, this.getName()); // Apply parsed definition.

                        _module5.onApplyDefinition(this, parsedDefinition, this.getName()); // Merge parsed definition with a class definition.

                        _module5.onMergeDefinitions(this.definition, parsedDefinition, this.getName()); // Finalize class creation.

                        _module5.onFinalizeClass(this, this.getName());
                      }); // Extend children.

                      const children = this.getChildren();

                      _each(children, ChildClass => {
                        ChildClass.extend(extendDefinition, onlyModules);
                      });
                    }

                    static get(className) {
                      return this.classes[className];
                    }

                    static has(className) {
                      return _has(this.classes, className);
                    }

                    static includes(Class) {
                      return _includes(this.classes, Class);
                    }

                    static isParentOf(Class) {
                      if (!Class || !Class.prototype) {
                        return false;
                      }

                      return this.prototype.isPrototypeOf(Class.prototype);
                    }

                    static isChildOf(Class) {
                      if (!Class || !Class.prototype) {
                        return false;
                      }

                      return Class.prototype.isPrototypeOf(this.prototype);
                    }

                    static isNew(doc, isNew) {
                      if (arguments.length === 2) {
                        doc._isNew = isNew;
                      } else {
                        return doc._isNew;
                      }
                    }

                  }

                  Class.classes = {};
                  module1.exportDefault(Class);
                }.call(this, _module2);
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "config.js": function module(_require4, _exports4, _module6) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // packages/jagi_astronomy/lib/core/config.js                                                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                const Config = {
                  verbose: true,
                  resolving: true,
                  defaults: true
                };
                _module6.exportDefault(Config);
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "ejson.js": function module(_require5, _exports5, _module7) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // packages/jagi_astronomy/lib/core/ejson.js                                                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                let AstroClass;
                _module7.link("./class.js", {
                  default(v) {
                    AstroClass = v;
                  }

                }, 0);
                let Event;
                _module7.link("../modules/events/event.js", {
                  default(v) {
                    Event = v;
                  }

                }, 1);
                EJSON.addType('Astronomy', function (json) {
                  let Class = AstroClass.get(json.class);
                  let doc = new Class(); // Trigger the "fromJSONValue" event handlers.

                  doc.dispatchEvent(new Event('fromJSONValue', {
                    json: json
                  }));
                  return doc;
                });
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "module.js": function module(_require6, _exports6, _module8) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // packages/jagi_astronomy/lib/core/module.js                                                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                !function (module1) {
                  let _each;

                  module1.link("lodash/each", {
                    default(v) {
                      _each = v;
                    }

                  }, 0);
                  let throwParseError;
                  module1.link("../modules/core/utils/throw_parse_error.js", {
                    default(v) {
                      throwParseError = v;
                    }

                  }, 1);

                  class Module {
                    constructor(definition) {
                      if (!Match.test(definition, Object)) {
                        throwParseError(['Module definition has to be an object']);
                      } // Set module name.


                      if (!Match.test(definition.name, String)) {
                        throwParseError(['Module name has to be a string']);
                      }

                      this.name = definition.name; // Set module aliases.

                      if (!Match.test(definition.aliases, Match.Maybe([String]))) {
                        throwParseError(["Module aliases has to be an array of strings in the \"".concat(this.name, "\" module")]);
                      }

                      this.aliases = definition.aliases; // Set module hooks.

                      _each(['onInitSchema', 'onInitDefinition', 'onInitClass', 'onParseDefinition', 'onApplyDefinition', 'onMergeDefinitions', 'onFinalizeClass'], hookName => {
                        if (definition[hookName] === undefined) {
                          return;
                        }

                        if (!Match.test(definition[hookName], Function)) {
                          throwParseError([{
                            'module': this.name
                          }, {
                            'property': hookName
                          }, "The \"".concat(hookName, "\" hook has to be a function")]);
                        }

                        this[hookName] = definition[hookName];
                      }); // Set module utils.


                      if (definition.utils) {
                        if (!Match.test(definition.utils, Object)) {
                          throwParseError([{
                            'module': this.name
                          }, {
                            'property': 'utils'
                          }, 'Utilities definition has to be an object']);
                        }

                        this.utils = {};

                        _each(definition.utils, (method, methodName) => {
                          if (!Match.test(method, Function)) {
                            throwParseError([{
                              'module': this.name
                            }, {
                              'property': 'utils'
                            }, {
                              'method': methodName
                            }, 'Utility has to be a function']);
                          }

                          this.utils[methodName] = method;
                        });
                      }
                    }

                    onInitSchema(schema, className) {}

                    onInitDefinition(definition, className) {}

                    onInitClass(Class, className) {}

                    onParseDefinition(parsedDefinition, definition, className) {}

                    onApplyDefinition(Class, definition, className) {}

                    onMergeDefinitions(targetDefinition, sourceDefinition, className) {}

                    onFinalizeClass(Class, className) {}

                    static create(definition) {
                      let _module9 = new this(definition);
                      this.modules[_module9.name] = _module9;
                      this.modulesOrder.push(_module9.name);
                      return _module9;
                    }

                    static get(moduleName) {
                      return this.modules[moduleName];
                    }

                    static forEach(iteratee) {
                      if (!Match.test(iteratee, Function)) {
                        throwParseError(['The first argument of the "Module.forEach" method has to be a function']);
                      }

                      _each(this.modulesOrder, moduleName => {
                        iteratee(this.modules[moduleName]);
                      });
                    }

                  }

                  ;
                  Module.modules = {};
                  Module.modulesOrder = [];
                  module1.exportDefault(Module);
                }.call(this, _module8);
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "reserved_keywords.js": function module(_require7, _exports7, _module10) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // packages/jagi_astronomy/lib/core/reserved_keywords.js                                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                const reservedNames = ['_isNew', 'copy', 'dispatchEvent', 'get', 'getModified', 'getModifiedValues', 'getModifier', 'isModified', 'raw', 'reload', 'remove', 'save', 'set', 'toJSONValue', 'typeName', 'validate', 'validateAll'];
                _module10.exportDefault(reservedNames);
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              } }, "modules": { "behaviors": { "behavior.js": function module(_require8, _exports8, _module11) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/behaviors/behavior.js                                                          //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _has;

                  _module11.link("lodash/has", {
                    default(v) {
                      _has = v;
                    }

                  }, 0);

                  let _extend;

                  _module11.link("lodash/extend", {
                    default(v) {
                      _extend = v;
                    }

                  }, 1);
                  let throwParseError;
                  _module11.link("../core/utils/throw_parse_error.js", {
                    default(v) {
                      throwParseError = v;
                    }

                  }, 2);

                  const checkDefinition = function (definition) {
                    // Check parameters validity.
                    if (!Match.test(definition, Object)) {
                      throwParseError(['Behavior definition has to be an object']);
                    } // Check if behavior name is provided and is a string.


                    if (!Match.test(definition.name, String)) {
                      throwParseError(['Behavior has to be named']);
                    } // Check if behavior with a given name already exists.


                    if (_has(Behavior.behaviors, definition.name)) {
                      throwParseError([{
                        'behavior': definition.name
                      }, 'Behavior already exists']);
                    }
                  };

                  class Behavior {
                    constructor(options) {
                      this.options = _extend({}, this.options, options);
                    }

                    createClassDefinition() {}

                    apply(Class) {
                      let definition = this.createClassDefinition();

                      if (definition) {
                        Class.extend(definition);
                      }
                    }

                    static create(definition) {
                      checkDefinition(definition); // Get behavior name.

                      let behaviorName = definition.name; // Extend the Behavior class.

                      let Behavior = this.behaviors[behaviorName] = class Behavior extends this {}; // Store definition in behavior class.

                      Behavior.definition = definition; // Extend prototype with a definition.

                      _extend(Behavior.prototype, definition);

                      return Behavior;
                    }

                    static get(behaviorName) {
                      return this.behaviors[behaviorName];
                    }

                    static has(behaviorName) {
                      return _has(this.behaviors, behaviorName);
                    }

                  }

                  ;
                  Behavior.behaviors = {};
                  _module11.exportDefault(Behavior);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "module.js": function module(_require9, _exports9, _module12) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/behaviors/module.js                                                            //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 1);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 2);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 3);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 4);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 5);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 6);
                    Module.create({
                      name: 'behaviors',
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass
                    });
                  }.call(this, _module12);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_static_methods": { "get_behavior.js": function module(_require10, _exports10, _module13) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/class_static_methods/get_behavior.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getBehavior(behaviorName) {
                      return this.schema.behaviors[behaviorName];
                    }

                    ;
                    _module13.exportDefault(getBehavior);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_behaviors.js": function module(_require11, _exports11, _module14) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/class_static_methods/get_behaviors.js                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getBehaviors() {
                      return this.schema.behaviors;
                    }

                    ;
                    _module14.exportDefault(getBehaviors);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "has_behavior.js": function module(_require12, _exports12, _module15) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/class_static_methods/has_behavior.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module15.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasBehavior(behaviorName) {
                      return _has(this.schema.behaviors, behaviorName);
                    }

                    ;
                    _module15.exportDefault(hasBehavior);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require13, _exports13, _module16) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/apply_definition.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module16.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let Behavior;
                    _module16.link("../behavior.js", {
                      default(v) {
                        Behavior = v;
                      }

                    }, 1);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      let schema = Class.schema; // Add behaviors to the class.

                      _each(parsedDefinition.behaviors, (behaviorsOptions, behaviorName) => {
                        // Get the behavior class.
                        let BehaviorClass = Behavior.get(behaviorName);

                        _each(behaviorsOptions, behaviorOptions => {
                          // Create the behavior instance passing behavior options.
                          let behavior = new BehaviorClass(behaviorOptions); // Add behavior to the schema.

                          schema.behaviors[behaviorName] = schema.behaviors[behaviorName] || [];
                          schema.behaviors[behaviorName].push(behavior); // Apply behavior to the class.

                          behavior.apply(Class);
                        });
                      });
                    }

                    ;
                    _module16.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require14, _exports14, _module17) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/init_class.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getBehavior;
                    _module17.link("../class_static_methods/get_behavior.js", {
                      default(v) {
                        getBehavior = v;
                      }

                    }, 0);
                    let getBehaviors;
                    _module17.link("../class_static_methods/get_behaviors.js", {
                      default(v) {
                        getBehaviors = v;
                      }

                    }, 1);
                    let hasBehavior;
                    _module17.link("../class_static_methods/has_behavior.js", {
                      default(v) {
                        hasBehavior = v;
                      }

                    }, 2);

                    function onInitClass(Class, className) {
                      Class.getBehavior = getBehavior;
                      Class.getBehaviors = getBehaviors;
                      Class.hasBehavior = hasBehavior;
                    }

                    ;
                    _module17.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require15, _exports15, _module18) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/init_definition.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.behaviors = {};
                    }

                    ;
                    _module18.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require16, _exports16, _module19) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/init_schema.js                                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.behaviors = {};
                    }

                    ;
                    _module19.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require17, _exports17, _module20) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/merge_definitions.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module20.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, ClassName) {
                      _each(sourceDefinition.behaviors, (behaviors, behaviorName) => {
                        targetDefinition.behaviors[behaviorName] = targetDefinition.behaviors[behaviorName] || [];
                        targetDefinition.behaviors[behaviorName].push(...behaviors);
                      });
                    }

                    ;
                    _module20.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require18, _exports18, _module21) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/behaviors/hooks/parse_definition.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module21.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let throwParseError;
                    _module21.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 1);
                    let Behavior;
                    _module21.link("../behavior.js", {
                      default(v) {
                        Behavior = v;
                      }

                    }, 2);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      // Check existence of the "behaviors" property.
                      if (definition.behaviors !== undefined) {
                        if (!Match.test(definition.behaviors, Match.OneOf([String], Object))) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'behaviors'
                          }, "Behaviors definition has to be an array of behaviors' names or an " + "object with behaviors' options"]);
                        }

                        _each(definition.behaviors, function (behaviorOptions, behaviorName) {
                          // If we deal with an array of behaviors' names, then behavior options is
                          // an empty object.
                          if (typeof behaviorOptions === 'string') {
                            behaviorName = behaviorOptions;
                            behaviorOptions = [{}];
                          } // Check if behavior with a given name exists.


                          if (!Behavior.has(behaviorName)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'behavior': behaviorName
                            }, 'Behavior does not exist']);
                          } // Behavior options has to be an object or an array of objects, when we
                          // are adding multiple behaviors of the same type.


                          if (!Match.test(behaviorOptions, Match.OneOf(Object, [Object]))) {
                            throwParseError([{
                              'class': className
                            }, {
                              'behavior': behaviorName
                            }, 'Behavior options have to be an object or an array of objects']);
                          } // Make sure that behavior options is an array of objects.


                          if (!Match.test(behaviorOptions, Array)) {
                            behaviorOptions = [behaviorOptions];
                          }

                          parsedDefinition.behaviors[behaviorName] = behaviorOptions;
                        });
                      }
                    }

                    ;
                    _module21.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "core": { "module.js": function module(_require19, _exports19, _module22) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/core/module.js                                                                 //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let cloneDefinition;
                    module1.link("./utils/cloneDefinition", {
                      default(v) {
                        cloneDefinition = v;
                      }

                    }, 1);
                    let deprecated;
                    module1.link("./utils/deprecated.js", {
                      default(v) {
                        deprecated = v;
                      }

                    }, 2);
                    let overrideMethod;
                    module1.link("./utils/override_method.js", {
                      default(v) {
                        overrideMethod = v;
                      }

                    }, 3);
                    let throwParseError;
                    module1.link("./utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 4);
                    let warn;
                    module1.link("./utils/warn.js", {
                      default(v) {
                        warn = v;
                      }

                    }, 5);
                    Module.create({
                      name: 'core',
                      utils: {
                        cloneDefinition,
                        deprecated,
                        overrideMethod,
                        throwParseError,
                        warn
                      }
                    });
                  }.call(this, _module22);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "utils": { "cloneDefinition.js": function module(_require20, _exports20, _module23) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/core/utils/cloneDefinition.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _cloneDeepWith;

                    _module23.link("lodash/cloneDeepWith", {
                      default(v) {
                        _cloneDeepWith = v;
                      }

                    }, 0);

                    let _isPlainObject;

                    _module23.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 1);

                    let _isArray;

                    _module23.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 2);

                    function cloneDefinition(definition) {
                      return _cloneDeepWith(definition, value => {
                        if (!_isPlainObject(value) && !_isArray(value)) {
                          return value;
                        }
                      });
                    }

                    _module23.exportDefault(cloneDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "deprecated.js": function module(_require21, _exports21, _module24) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/core/utils/deprecated.js                                                       //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let config;
                    _module24.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 0);
                    let warn;
                    _module24.link("./warn", {
                      default(v) {
                        warn = v;
                      }

                    }, 1);

                    function deprecated(message) {
                      // Be silent and do not log any warnings.
                      if (!config.verbose) {
                        return;
                      } // Print message to the console.


                      warn("Deprecation warning: ".concat(message));
                    }

                    _module24.exportDefault(deprecated);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "override_method.js": function module(_require22, _exports22, _module25) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/core/utils/override_method.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _toArray;

                    _module25.link("lodash/toArray", {
                      default(v) {
                        _toArray = v;
                      }

                    }, 0);

                    function overrideMethod(object, methodName, overridingMethod, param) {
                      // Get original method.
                      let originalMethod = object[methodName]; // Override original method.

                      object[methodName] = function () {
                        // Convert arguments to array.
                        let args = _toArray(arguments); // Execute overriding method passing arguments, original method and extra
                        // parameters.


                        return overridingMethod.call(this, args, originalMethod, param);
                      };
                    }

                    ;
                    _module25.exportDefault(overrideMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "throw_parse_error.js": function module(_require23, _exports23, _module26) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/core/utils/throw_parse_error.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module26.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _isObject;

                    _module26.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 1);

                    function throwParseError(details) {
                      let message = '';

                      _each(details, detail => {
                        if (_isObject(detail)) {
                          _each(detail, (value, key) => {
                            message += '["' + value + '" ' + key + ']';
                          });
                        } else if (typeof detail === 'string') {
                          message += ' ' + detail;
                        }
                      });

                      throw new TypeError(message);
                    }

                    ;
                    _module26.exportDefault(throwParseError);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "warn.js": function module(_require24, _exports24, _module27) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/core/utils/warn.js                                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let config;
                    _module27.link("../../../core/config.js", {
                      default(v) {
                        config = v;
                      }

                    }, 0);

                    function warn(warning) {
                      // Be silent and do not log any warnings.
                      if (!config.verbose) {
                        return;
                      }

                      try {
                        console.warn(warning);
                      } catch (error) {}
                    }

                    _module27.exportDefault(warn);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "events": { "event.js": function module(_require25, _exports25, _module28) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/events/event.js                                                                //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _extend;

                  _module28.link("lodash/extend", {
                    default(v) {
                      _extend = v;
                    }

                  }, 0);

                  class Event {
                    constructor(type, data) {
                      this.cancelable = false;
                      this.propagates = false;

                      _extend(this, data);

                      this.type = type.toLowerCase();
                      this.timeStamp = Date.now();
                      this.target = null;
                      this.currentTarget = null;
                      this.defaultPrevented = false;
                      this.propagationStopped = false;
                      this.immediatePropagationStopped = false;
                    }

                    preventDefault() {
                      this.defaultPrevented = true;
                    }

                    stopPropagation() {
                      this.propagationStopped = true;
                    }

                    stopImmediatePropagation() {
                      this.immediatePropagationStopped = true;
                      this.stopPropagation();
                    }

                  }

                  ;
                  _module28.exportDefault(Event);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "module.js": function module(_require26, _exports26, _module29) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/events/module.js                                                               //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 1);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 2);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 3);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 4);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 5);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 6);
                    Module.create({
                      name: 'events',
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass
                    });
                  }.call(this, _module29);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_prototype_methods": { "dispatch_event.js": function module(_require27, _exports27, _module30) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/class_prototype_methods/dispatch_event.js                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module30.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _every;

                    _module30.link("lodash/every", {
                      default(v) {
                        _every = v;
                      }

                    }, 1);

                    let _isArray;

                    _module30.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 2);
                    let Event;
                    _module30.link("../event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 3);
                    let throwParseError;
                    _module30.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 4);
                    let AstroClass;
                    _module30.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 5);

                    function returnFromDispatchEvent(event) {
                      // If an event is cancelable and it had been canceled with the
                      // "preventDefault" method call, then we return false.
                      if (event.cancelable) {
                        return !event.defaultPrevented;
                      }

                      return true;
                    }

                    function dispatchEvent(event) {
                      const doc = this;
                      const Class = doc.constructor;

                      if (!Match.test(event, Event)) {
                        throwParseError([{
                          'class': Class.getName()
                        }, {
                          'method': 'dispatchEvent'
                        }, 'The first argument has to be an event object']);
                      } // Attach a document to the event as a target.


                      if (event.target === null) {
                        event.target = doc;
                      }

                      if (event.currentTarget === null) {
                        event.currentTarget = doc;
                      } // Get all event handlers of a given type.


                      const eventHandlers = Class.getEvents(event.type);

                      _every(eventHandlers, function (eventHandler) {
                        eventHandler(event); // Stop execution of the following event handlers, if a flag is set.

                        return !event.immediatePropagationStopped;
                      }); // If propagation was stopped or bubbling is turned off, then we don't go
                      // deeper into nested fields.


                      if (event.propagationStopped || !event.propagates) {
                        return returnFromDispatchEvent(event);
                      } // Object fields.


                      _each(Class.getObjectFields(), function (field) {
                        let value = doc[field.name];

                        if (value instanceof AstroClass) {
                          event.currentTarget = value;
                          value.dispatchEvent(event);
                        }
                      }); // List fields.


                      _each(Class.getListFields(), function (field) {
                        let value = doc[field.name];

                        if (field.isClass && _isArray(value)) {
                          _each(value, function (element) {
                            if (element instanceof AstroClass) {
                              event.currentTarget = element;
                              element.dispatchEvent(event);
                            }
                          });
                        }
                      });

                      return returnFromDispatchEvent(event);
                    }

                    _module30.exportDefault(dispatchEvent);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_static_methods": { "dispatch_event.js": function module(_require28, _exports28, _module31) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/class_static_methods/dispatch_event.js                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _every;

                    _module31.link("lodash/every", {
                      default(v) {
                        _every = v;
                      }

                    }, 0);
                    let Event;
                    _module31.link("../event", {
                      default(v) {
                        Event = v;
                      }

                    }, 1);
                    let throwParseError;
                    _module31.link("../../core/utils/throw_parse_error", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 2);

                    function returnFromDispatchEvent(event) {
                      // If an event is cancelable and it had been canceled with the
                      // "preventDefault" method call, then we return false.
                      if (event.cancelable) {
                        return !event.defaultPrevented;
                      }

                      return true;
                    }

                    function dispatchEvent(event) {
                      const Class = this; // Get all event handlers of a given type.

                      const eventHandlers = Class.getEvents(event.type); // If there are no event of a fiven type, then just return true.

                      if (eventHandlers.length === 0) {
                        return true;
                      } // Attach a document to the event as a target.


                      if (event.target === null) {
                        event.target = Class;
                      }

                      if (event.currentTarget === null) {
                        event.currentTarget = Class;
                      }

                      _every(eventHandlers, eventHandler => {
                        eventHandler(event); // Stop execution of the following event handlers, if a flag is set.

                        return !event.immediatePropagationStopped;
                      });

                      return returnFromDispatchEvent(event);
                    }

                    _module31.exportDefault(dispatchEvent);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_events.js": function module(_require29, _exports29, _module32) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/class_static_methods/get_events.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getEvents(eventName) {
                      let Class = this;

                      if (eventName) {
                        eventName = eventName.toLowerCase();
                        return Class.schema.events[eventName] || [];
                      }

                      return Class.schema.events;
                    }

                    _module32.exportDefault(getEvents);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "hasEvent.js": function module(_require30, _exports30, _module33) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/class_static_methods/hasEvent.js                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _get;

                    _module33.link("lodash/get", {
                      default(v) {
                        _get = v;
                      }

                    }, 0);

                    let _has;

                    _module33.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 1);

                    let _includes;

                    _module33.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 2);

                    function hasEvent(eventName, eventHandler) {
                      const Class = this;
                      eventName = eventName.toLowerCase();

                      if (arguments.length === 2) {
                        return _includes(_get(Class.schema.events, eventName), eventHandler);
                      } else if (arguments.length === 1) {
                        return _has(Class.schema.events, eventName);
                      }
                    }

                    _module33.exportDefault(hasEvent);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require31, _exports31, _module34) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/apply_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module34.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _each;

                    _module34.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _uniq;

                    _module34.link("lodash/uniq", {
                      default(v) {
                        _uniq = v;
                      }

                    }, 2);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      const schema = Class.schema; // Add events to the event manager.

                      _each(parsedDefinition.events, function (eventHandlers, eventName) {
                        eventName = eventName.toLowerCase(); // By default events list should be an empty array.

                        _defaults(schema.events, {
                          [eventName]: []
                        }); // Add all events to the list.


                        schema.events[eventName].push(...eventHandlers); // Make sure that there are no duplicates.

                        schema.events[eventName] = _uniq(schema.events[eventName]);
                      });
                    }

                    ;
                    _module34.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require32, _exports32, _module35) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/init_class.js                                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let dispatchEvent;
                    _module35.link("../class_static_methods/dispatch_event.js", {
                      default(v) {
                        dispatchEvent = v;
                      }

                    }, 0);
                    let getEvents;
                    _module35.link("../class_static_methods/get_events.js", {
                      default(v) {
                        getEvents = v;
                      }

                    }, 1);
                    let hasEvent;
                    _module35.link("../class_static_methods/hasEvent", {
                      default(v) {
                        hasEvent = v;
                      }

                    }, 2);
                    let dispatchEventProto;
                    _module35.link("../class_prototype_methods/dispatch_event.js", {
                      default(v) {
                        dispatchEventProto = v;
                      }

                    }, 3);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.dispatchEvent = dispatchEvent;
                      Class.getEvents = getEvents;
                      Class.hasEvent = hasEvent; // Class prototype methods.

                      Class.prototype.dispatchEvent = dispatchEventProto;
                    }

                    _module35.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require33, _exports33, _module36) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/init_definition.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.events = {};
                    }

                    ;
                    _module36.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require34, _exports34, _module37) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/init_schema.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.events = {};
                    }

                    ;
                    _module37.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require35, _exports35, _module38) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/merge_definitions.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module38.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _each;

                    _module38.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _uniq;

                    _module38.link("lodash/uniq", {
                      default(v) {
                        _uniq = v;
                      }

                    }, 2);

                    function onMergeDefinitions(trgDefinition, srcDefinition, ClassName) {
                      _each(srcDefinition.events, function (eventHandlers, eventName) {
                        eventName = eventName.toLowerCase(); // By default events list should be an empty array.

                        _defaults(trgDefinition.events, {
                          [eventName]: []
                        }); // Add all events to the list.


                        trgDefinition.events[eventName].push(...eventHandlers); // Make sure that there are no duplicates.

                        trgDefinition.events[eventName] = _uniq(trgDefinition.events[eventName]);
                      });
                    }

                    ;
                    _module38.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require36, _exports36, _module39) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/events/hooks/parse_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module39.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let throwParseError;
                    _module39.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 1);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      // Check existence and validity of the "events" property.
                      if (definition.events !== undefined) {
                        _each(definition.events, function (eventHandlers, eventName) {
                          eventName = eventName.toLowerCase(); // Check if the event definition is an array of functions.

                          if (!Match.test(eventHandlers, Match.OneOf(Function, [Function]))) {
                            throwParseError([{
                              'class': className
                            }, {
                              'event': eventName
                            }, 'Event handler has to be a function or an array of functions']);
                          } // Convert function to array of functions.


                          if (Match.test(eventHandlers, Function)) {
                            eventHandlers = [eventHandlers];
                          }

                          parsedDefinition.events[eventName] = eventHandlers;
                        });
                      }
                    }

                    ;
                    _module39.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "fields": { "Enum.js": function module(_require37, _exports37, _module40) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/Enum.js                                                                 //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _zipObject;

                  _module40.link("lodash/zipObject", {
                    default(v) {
                      _zipObject = v;
                    }

                  }, 0);

                  let _range;

                  _module40.link("lodash/range", {
                    default(v) {
                      _range = v;
                    }

                  }, 1);

                  let _forOwn;

                  _module40.link("lodash/forOwn", {
                    default(v) {
                      _forOwn = v;
                    }

                  }, 2);

                  let _isNil;

                  _module40.link("lodash/isNil", {
                    default(v) {
                      _isNil = v;
                    }

                  }, 3);

                  let _isNumber;

                  _module40.link("lodash/isNumber", {
                    default(v) {
                      _isNumber = v;
                    }

                  }, 4);

                  let _values;

                  _module40.link("lodash/values", {
                    default(v) {
                      _values = v;
                    }

                  }, 5);

                  let _keys;

                  _module40.link("lodash/keys", {
                    default(v) {
                      _keys = v;
                    }

                  }, 6);

                  let _indexOf;

                  _module40.link("lodash/indexOf", {
                    default(v) {
                      _indexOf = v;
                    }

                  }, 7);

                  let _each;

                  _module40.link("lodash/each", {
                    default(v) {
                      _each = v;
                    }

                  }, 8);
                  let Type;
                  _module40.link("./type.js", {
                    default(v) {
                      Type = v;
                    }

                  }, 9);
                  let Validators;
                  _module40.link("../validators/validators.js", {
                    default(v) {
                      Validators = v;
                    }

                  }, 10);
                  let check, Match;
                  _module40.link("meteor/check", {
                    check(v) {
                      check = v;
                    },

                    Match(v) {
                      Match = v;
                    }

                  }, 11);
                  const enumDefinitionPattern = {
                    name: String,
                    identifiers: Match.OneOf(Array, Object)
                  };
                  const Enum = {
                    create(definition) {
                      check(definition, enumDefinitionPattern); // Get identifiers and values.

                      let identifiers;

                      if (Match.test(definition.identifiers, Array)) {
                        identifiers = _zipObject(definition.identifiers, _range(definition.identifiers.length));
                      } else if (Match.test(definition.identifiers, Object)) {
                        identifiers = definition.identifiers;
                        let i = 0;

                        _forOwn(identifiers, function (value, key) {
                          if (_isNil(value)) {
                            identifiers[key] = i;
                            i++;
                          } else if (_isNumber(value)) {
                            i = value + 1;
                          }
                        });
                      }

                      const values = _values(identifiers);

                      const keys = _keys(identifiers); // Create a new Enum constructor.


                      const Enum = function Enum(identifier) {
                        return Enum[identifier];
                      };

                      Enum.getValues = function () {
                        return values;
                      };

                      Enum.getIdentifiers = function () {
                        return keys;
                      };

                      Enum.getIdentifier = function (value) {
                        const index = _indexOf(values, value);

                        return keys[index];
                      }; // Set identifiers properties in the class.


                      _each(identifiers, (value, name) => {
                        if (Object.defineProperty) {
                          Object.defineProperty(Enum, name, {
                            writable: false,
                            enumerable: true,
                            value
                          });
                        } else {
                          Enum[name] = value;
                        }
                      }); // Create type definition for the given enum.


                      Type.create({
                        name: definition.name,
                        class: Enum,

                        validate(args) {
                          args.param = values;
                          Validators.choice(args);
                        }

                      }); // Store enum in the enums list.

                      this.enums[definition.name] = Enum;
                      return Enum;
                    },

                    enums: {}
                  };
                  _module40.exportDefault(Enum);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "Field.js": function module(_require38, _exports38, _module41) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/Field.js                                                                //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _defaults;

                  _module41.link("lodash/defaults", {
                    default(v) {
                      _defaults = v;
                    }

                  }, 0);

                  let _extend;

                  _module41.link("lodash/extend", {
                    default(v) {
                      _extend = v;
                    }

                  }, 1);

                  let _isNil;

                  _module41.link("lodash/isNil", {
                    default(v) {
                      _isNil = v;
                    }

                  }, 2);
                  let Validators;
                  _module41.link("../validators/validators.js", {
                    default(v) {
                      Validators = v;
                    }

                  }, 3);

                  class Field {
                    constructor() {
                      let definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                      _defaults(definition, {
                        optional: false,
                        immutable: false,
                        transient: false
                      });

                      _extend(this, definition);
                    }

                    getDefault(doc) {
                      const value = typeof this.default === 'function' ? this.default(doc) : this.default;
                      return this.castValue(value, {
                        cast: true
                      });
                    }

                    getOptional(doc) {
                      if (typeof this.optional === 'function') {
                        return this.optional(doc);
                      }

                      return this.optional;
                    }

                    validate(args) {
                      // If a field is not optional (required) then it has to have value.
                      if (!this.getOptional(args.doc)) {
                        Validators.required(args);
                      }
                    }

                    castValue(value, options) {
                      if (!_isNil(value)) {
                        return this.cast(value, options);
                      }

                      return value;
                    }

                    resolveValue(rawDoc) {
                      if (!rawDoc) {
                        return;
                      }

                      if (typeof this.resolve === 'function') {
                        return this.resolve(rawDoc);
                      }

                      return rawDoc[this.name];
                    }

                  }

                  ;
                  _module41.exportDefault(Field);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "ListField.js": function module(_require39, _exports39, _module42) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/ListField.js                                                            //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _each;

                  _module42.link("lodash/each", {
                    default(v) {
                      _each = v;
                    }

                  }, 0);

                  let _isArray;

                  _module42.link("lodash/isArray", {
                    default(v) {
                      _isArray = v;
                    }

                  }, 1);

                  let _isNil;

                  _module42.link("lodash/isNil", {
                    default(v) {
                      _isNil = v;
                    }

                  }, 2);

                  let _isPlainObject;

                  _module42.link("lodash/isPlainObject", {
                    default(v) {
                      _isPlainObject = v;
                    }

                  }, 3);

                  let _map;

                  _module42.link("lodash/map", {
                    default(v) {
                      _map = v;
                    }

                  }, 4);
                  let Field;
                  _module42.link("./Field", {
                    default(v) {
                      Field = v;
                    }

                  }, 5);
                  let AstroClass;
                  _module42.link("../../core/class", {
                    default(v) {
                      AstroClass = v;
                    }

                  }, 6);
                  let Validators;
                  _module42.link("../validators/validators", {
                    default(v) {
                      Validators = v;
                    }

                  }, 7);
                  let castToClass;
                  _module42.link("./utils/castToClass", {
                    default(v) {
                      castToClass = v;
                    }

                  }, 8);
                  let resolveValues;
                  _module42.link("./utils/resolveValues", {
                    default(v) {
                      resolveValues = v;
                    }

                  }, 9);

                  class ListField extends Field {
                    constructor() {
                      let definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      super(definition);
                      this.isClass = AstroClass.isParentOf(this.type.class);
                    }

                    validate(args) {
                      super.validate(args);
                      var {
                        doc,
                        name,
                        value
                      } = args; // If a value is not empty.

                      if (!_isNil(value)) {
                        Validators.array(args);

                        _each(value, (element, index) => {
                          this.type.validate({
                            doc,
                            name: name + '.' + index,
                            value: element
                          });
                        });
                      }
                    }

                    cast(value, options) {
                      if (options.element) {
                        return this.type.cast(value, options);
                      }

                      if (value === '' && this.optional) {
                        return null;
                      } else if (_isArray(value)) {
                        return _map(value, element => {
                          // Class type.
                          if (this.isClass) {
                            // We only cast if a value is a plain object.
                            if (_isPlainObject(element)) {
                              // Cast value to an instance of the class.
                              return castToClass({
                                Class: this.type.class,
                                rawDoc: element,
                                options
                              });
                            }

                            return element;
                          } // Scalar type.
                          else {
                              // The "cast" option is only passed to the ObjectFields and ListFields.
                              // Here we have to check if it's set, so we don't cast if user don't
                              // want to.
                              if (options.cast) {
                                return this.type.cast.call(this, element);
                              }

                              return element;
                            }
                        });
                      }

                      return value;
                    }

                    resolveValue(rawDoc) {
                      const resolvedValues = super.resolveValue(rawDoc);

                      if (!this.isClass) {
                        return resolvedValues;
                      }

                      return _map(resolvedValues, nestedRawDoc => {
                        return resolveValues({
                          Class: this.type.class,
                          rawDoc: nestedRawDoc
                        });
                      });
                    }

                  }

                  ;
                  _module42.exportDefault(ListField);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "ObjectField.js": function module(_require40, _exports40, _module43) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/ObjectField.js                                                          //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _isPlainObject;

                  _module43.link("lodash/isPlainObject", {
                    default(v) {
                      _isPlainObject = v;
                    }

                  }, 0);
                  let Field;
                  _module43.link("./Field", {
                    default(v) {
                      Field = v;
                    }

                  }, 1);
                  let castToClass;
                  _module43.link("./utils/castToClass", {
                    default(v) {
                      castToClass = v;
                    }

                  }, 2);
                  let resolveValues;
                  _module43.link("./utils/resolveValues", {
                    default(v) {
                      resolveValues = v;
                    }

                  }, 3);

                  class ObjectField extends Field {
                    validate(args) {
                      super.validate(args);
                      this.type.validate(args);
                    }

                    cast(value, options) {
                      if (value === '' && this.optional) {
                        return null;
                      } // We only cast if a value is a plain object.
                      else if (_isPlainObject(value)) {
                          // Cast value to an instance of the class.
                          return castToClass({
                            Class: this.type.class,
                            rawDoc: value,
                            options
                          });
                        }

                      return value;
                    }

                    resolveValue(rawDoc) {
                      return resolveValues({
                        Class: this.type.class,
                        rawDoc: super.resolveValue(rawDoc)
                      });
                    }

                  }

                  ;
                  _module43.exportDefault(ObjectField);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "ScalarField.js": function module(_require41, _exports41, _module44) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/ScalarField.js                                                          //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _isNil;

                  _module44.link("lodash/isNil", {
                    default(v) {
                      _isNil = v;
                    }

                  }, 0);
                  let Field;
                  _module44.link("./Field", {
                    default(v) {
                      Field = v;
                    }

                  }, 1);

                  class ScalarField extends Field {
                    cast(value) {
                      return this.type.cast.call(this, value);
                    }

                    validate(args) {
                      super.validate(args);
                      var {
                        value
                      } = args;

                      if (!_isNil(value)) {
                        return this.type.validate(args);
                      }
                    }

                  }

                  ;
                  _module44.exportDefault(ScalarField);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "Union.js": function module(_require42, _exports42, _module45) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/Union.js                                                                //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _clone;

                  _module45.link("lodash/clone", {
                    default(v) {
                      _clone = v;
                    }

                  }, 0);

                  let _some;

                  _module45.link("lodash/some", {
                    default(v) {
                      _some = v;
                    }

                  }, 1);
                  let Type;
                  _module45.link("./type.js", {
                    default(v) {
                      Type = v;
                    }

                  }, 2);
                  let Validators;
                  _module45.link("../validators/validators.js", {
                    default(v) {
                      Validators = v;
                    }

                  }, 3);
                  let check, Match;
                  _module45.link("meteor/check", {
                    check(v) {
                      check = v;
                    },

                    Match(v) {
                      Match = v;
                    }

                  }, 4);
                  const unionDefinitionPattern = {
                    name: String,
                    types: [Function],
                    cast: Match.Optional(Function)
                  };
                  const Union = {
                    create(definition) {
                      check(definition, unionDefinitionPattern); // Create a new Union constructor.

                      const Union = function Union(identifier) {
                        return Union[identifier];
                      }; // Copy list of types to the union constructor.


                      Union.types = _clone(definition.types); // Copy casting function to the union constructor if defined.

                      if (typeof definition.cast === 'function') {
                        Union.cast = definition.cast;
                      } // Create type definition for the given enum.


                      Type.create({
                        name: definition.name,
                        class: Union,

                        cast(value) {
                          return Union.cast ? Union.cast(value) : value;
                        },

                        validate(args) {
                          const caughtErrors = []; // Check if a value will pass validation executed by any of the union
                          // types.

                          if (!_some(Union.types, TypeClass => {
                            const AstroType = Type.find(TypeClass);

                            try {
                              AstroType.validate(args);
                              return true;
                            } catch (err) {
                              caughtErrors.push(err);
                              return false;
                            }
                          })) {
                            throw caughtErrors[0];
                          }
                        }

                      }); // Store enum in the unions list.

                      this.unions[definition.name] = Union;
                      return Union;
                    },

                    unions: {}
                  };
                  _module45.exportDefault(Union);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "module.js": function module(_require43, _exports43, _module46) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/module.js                                                               //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    module1.link("./types/boolean.js");
                    module1.link("./types/date.js");
                    module1.link("./types/mongo_object_id.js");
                    module1.link("./types/number.js");
                    module1.link("./types/object.js");
                    module1.link("./types/string.js");
                    let castNested;
                    module1.link("./utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 1);
                    let getAll;
                    module1.link("./utils/getAll", {
                      default(v) {
                        getAll = v;
                      }

                    }, 2);
                    let getMany;
                    module1.link("./utils/getMany", {
                      default(v) {
                        getMany = v;
                      }

                    }, 3);
                    let getOne;
                    module1.link("./utils/getOne", {
                      default(v) {
                        getOne = v;
                      }

                    }, 4);
                    let isNestedFieldName;
                    module1.link("./utils/isNestedFieldName", {
                      default(v) {
                        isNestedFieldName = v;
                      }

                    }, 5);
                    let rawAll;
                    module1.link("./utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 6);
                    let rawMany;
                    module1.link("./utils/rawMany", {
                      default(v) {
                        rawMany = v;
                      }

                    }, 7);
                    let rawOne;
                    module1.link("./utils/rawOne", {
                      default(v) {
                        rawOne = v;
                      }

                    }, 8);
                    let setAll;
                    module1.link("./utils/set_all.js", {
                      default(v) {
                        setAll = v;
                      }

                    }, 9);
                    let setMany;
                    module1.link("./utils/set_many.js", {
                      default(v) {
                        setMany = v;
                      }

                    }, 10);
                    let setOne;
                    module1.link("./utils/set_one.js", {
                      default(v) {
                        setOne = v;
                      }

                    }, 11);
                    let traverse;
                    module1.link("./utils/traverse.js", {
                      default(v) {
                        traverse = v;
                      }

                    }, 12);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 13);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 14);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 15);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 16);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 17);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 18);
                    Module.create({
                      name: 'fields',
                      onInitSchema,
                      onInitDefinition,
                      onParseDefinition,
                      onMergeDefinitions,
                      onApplyDefinition,
                      onInitClass,
                      utils: {
                        castNested,
                        getAll,
                        getMany,
                        getOne,
                        isNestedFieldName,
                        rawAll,
                        rawMany,
                        rawOne,
                        setAll,
                        setMany,
                        setOne,
                        traverse
                      }
                    });
                  }.call(this, _module46);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "type.js": function module(_require44, _exports44, _module47) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/fields/type.js                                                                 //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let _find;

                  _module47.link("lodash/find", {
                    default(v) {
                      _find = v;
                    }

                  }, 0);

                  let _has;

                  _module47.link("lodash/has", {
                    default(v) {
                      _has = v;
                    }

                  }, 1);
                  let Validators;
                  _module47.link("../validators/validators.js", {
                    default(v) {
                      Validators = v;
                    }

                  }, 2);
                  let warn;
                  _module47.link("../core/utils/warn", {
                    default(v) {
                      warn = v;
                    }

                  }, 3);
                  const typeDefinitionPattern = {
                    name: String,
                    class: Match.Any,
                    cast: Match.Optional(Function),
                    validate: Match.Optional(Function)
                  };
                  const enumDefinitionPattern = {
                    name: String,
                    options: Object
                  };

                  class Type {
                    constructor(definition) {
                      check(definition, typeDefinitionPattern);
                      this.name = definition.name;
                      this.class = definition.class;

                      if (typeof definition.validate === "function") {
                        this.validate = definition.validate;
                      }

                      if (typeof definition.cast === "function") {
                        this.cast = definition.cast;
                      }
                    }

                    cast(value) {
                      return value;
                    }

                    validate(doc, fieldName) {
                      return true;
                    }

                    static create(definition) {
                      let type = new Type(definition); // Warn about class duplicate.

                      if (_has(this.types, type.name)) {
                        warn("Duplicate of the \"".concat(type.name, "\" type"));
                      }

                      this.types[type.name] = type;
                    }

                    static get(name) {
                      return this.types[name];
                    }

                    static has(name) {
                      return _has(this.types, name);
                    }

                    static find(Class) {
                      return _find(this.types, type => {
                        return type.class.prototype === Class.prototype;
                      });
                    }

                  }

                  Type.types = {};
                  _module47.exportDefault(Type);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_events": { "from_json_value.js": function module(_require45, _exports45, _module48) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_events/from_json_value.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function fromJSONValue(e) {
                      let doc = e.currentTarget;
                      doc.set(EJSON.parse(e.json.values), {
                        defaults: false,
                        clone: false,
                        cast: false
                      });
                    }

                    _module48.exportDefault(fromJSONValue);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "to_json_value.js": function module(_require46, _exports46, _module49) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_events/to_json_value.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getAll;
                    _module49.link("../utils/getAll", {
                      default(v) {
                        getAll = v;
                      }

                    }, 0);

                    function toJSONValue(e) {
                      let doc = e.currentTarget;
                      e.json.values = EJSON.stringify(getAll(doc));
                    }

                    ;
                    _module49.exportDefault(toJSONValue);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_prototype_methods": { "get.js": function module(_require47, _exports47, _module50) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_prototype_methods/get.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isArray;

                    _module50.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 0);

                    let _isPlainObject;

                    _module50.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 1);
                    let getAll;
                    _module50.link("../utils/getAll", {
                      default(v) {
                        getAll = v;
                      }

                    }, 2);
                    let getMany;
                    _module50.link("../utils/getMany", {
                      default(v) {
                        getMany = v;
                      }

                    }, 3);
                    let getOne;
                    _module50.link("../utils/getOne", {
                      default(v) {
                        getOne = v;
                      }

                    }, 4);

                    function get() {
                      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                      }

                      if (args.length === 0) {
                        return getAll(this);
                      } else if (args.length >= 1) {
                        if (typeof args[0] === 'string') {
                          return getOne(this, ...args);
                        } else if (_isArray(args[0])) {
                          return getMany(this, ...args);
                        } else if (_isPlainObject(args[0])) {
                          return getAll(this, ...args);
                        }
                      }
                    }

                    ;
                    _module50.exportDefault(get);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "raw.js": function module(_require48, _exports48, _module51) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_prototype_methods/raw.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isArray;

                    _module51.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 0);

                    let _isPlainObject;

                    _module51.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 1);
                    let rawAll;
                    _module51.link("../utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 2);
                    let rawMany;
                    _module51.link("../utils/rawMany", {
                      default(v) {
                        rawMany = v;
                      }

                    }, 3);
                    let rawOne;
                    _module51.link("../utils/rawOne", {
                      default(v) {
                        rawOne = v;
                      }

                    }, 4);

                    function raw() {
                      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                      }

                      if (args.length === 0) {
                        return rawAll(this);
                      } else if (args.length >= 1) {
                        if (typeof args[0] === 'string') {
                          return rawOne(this, ...args);
                        } else if (_isArray(args[0])) {
                          return rawMany(this, ...args);
                        } else if (_isPlainObject(args[0])) {
                          return rawAll(this, ...args);
                        }
                      }
                    }

                    ;
                    _module51.exportDefault(raw);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "set.js": function module(_require49, _exports49, _module52) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_prototype_methods/set.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module52.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _extend;

                    _module52.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 1);

                    let _isArray;

                    _module52.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 2);

                    let _isPlainObject;

                    _module52.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 3);
                    let config;
                    _module52.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 4);
                    let setMany;
                    _module52.link("../utils/set_many", {
                      default(v) {
                        setMany = v;
                      }

                    }, 5);
                    let setOne;
                    _module52.link("../utils/set_one", {
                      default(v) {
                        setOne = v;
                      }

                    }, 6);
                    let castNested;
                    _module52.link("../utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 7);

                    function merge(doc) {
                      const result = {};

                      _each(doc, (fieldValue, fieldName) => {
                        // If a field value is an object then we prefix each nested field name with
                        // a field name of the parent object. However, we can not do it for arrays
                        // as it's not obvious how we would like to merge arrays - concat/replace?
                        if (_isPlainObject(fieldValue) && !_isArray(fieldValue)) {
                          _each(merge(fieldValue), (nestedFieldValue, nestedFieldName) => {
                            result["".concat(fieldName, ".").concat(nestedFieldName)] = nestedFieldValue;
                          });
                        } else {
                          result[fieldName] = fieldValue;
                        }
                      });

                      return result;
                    }

                    function set() {
                      const doc = this; // Default options.

                      const options = {
                        defaults: config.defaults,
                        clone: true,
                        cast: false,
                        merge: false
                      }; // Setting single field.

                      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string' && arguments.length >= 2) {
                        // The last argument is an options object.
                        if (_isPlainObject(arguments.length <= 2 ? undefined : arguments[2])) {
                          _extend(options, arguments.length <= 2 ? undefined : arguments[2]);
                        } // Do not override values if the "merge" option is set and instead merge
                        // nested objects.


                        if (options.merge && _isPlainObject(arguments.length <= 1 ? undefined : arguments[1])) {
                          setMany(doc, merge({
                            [arguments.length <= 0 ? undefined : arguments[0]]: arguments.length <= 1 ? undefined : arguments[1]
                          }), options);
                        } else {
                          setOne(doc, arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], options);
                        }
                      } // Setting multiple fields at once.
                      else if (_isPlainObject(arguments.length <= 0 ? undefined : arguments[0]) && arguments.length >= 1) {
                          // The last argument is an options object.
                          if (_isPlainObject(arguments.length <= 1 ? undefined : arguments[1])) {
                            _extend(options, arguments.length <= 1 ? undefined : arguments[1]);
                          } // Do not override values if the "merge" option is set and instead merge
                          // nested objects.


                          if (options.merge) {
                            setMany(doc, merge(arguments.length <= 0 ? undefined : arguments[0]), options);
                          } else {
                            setMany(doc, arguments.length <= 0 ? undefined : arguments[0], options);
                          }
                        }
                    }

                    ;
                    _module52.exportDefault(set);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_static_methods": { "get_field.js": function module(_require50, _exports50, _module53) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_field.js                                       //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getField(fieldName) {
                      return this.schema.fields[fieldName];
                    }

                    _module53.exportDefault(getField);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_fields.js": function module(_require51, _exports51, _module54) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_fields.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _values;

                    _module54.link("lodash/values", {
                      default(v) {
                        _values = v;
                      }

                    }, 0);

                    function getFields() {
                      return _values(this.schema.fields);
                    }

                    ;
                    _module54.exportDefault(getFields);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_fields_names.js": function module(_require52, _exports52, _module55) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_fields_names.js                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module55.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _each;

                    _module55.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    function getFieldsNames() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                      // Prepare options.
                      _defaults(options, {
                        transient: true,
                        immutable: true
                      });

                      const fieldsNames = [];

                      _each(this.schema.fields, (field, name) => {
                        // Don't get a transient field.
                        if (!options.transient && field.transient) {
                          return;
                        } // Don't get an immutable field.


                        if (!options.immutable && field.immutable) {
                          return;
                        }

                        fieldsNames.push(name);
                      });

                      return fieldsNames;
                    }

                    ;
                    _module55.exportDefault(getFieldsNames);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_list_fields.js": function module(_require53, _exports53, _module56) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_list_fields.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _filter;

                    _module56.link("lodash/filter", {
                      default(v) {
                        _filter = v;
                      }

                    }, 0);
                    let ListField;
                    _module56.link("../ListField", {
                      default(v) {
                        ListField = v;
                      }

                    }, 1);

                    function getListFields() {
                      let classOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                      return _filter(this.getFields(), function (field) {
                        if (classOnly) {
                          return field instanceof ListField && field.isClass;
                        }

                        return field instanceof ListField;
                      });
                    }

                    ;
                    _module56.exportDefault(getListFields);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_object_fields.js": function module(_require54, _exports54, _module57) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_object_fields.js                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _filter;

                    _module57.link("lodash/filter", {
                      default(v) {
                        _filter = v;
                      }

                    }, 0);
                    let ObjectField;
                    _module57.link("../ObjectField", {
                      default(v) {
                        ObjectField = v;
                      }

                    }, 1);

                    function getObjectFields() {
                      return _filter(this.getFields(), function (field) {
                        return field instanceof ObjectField;
                      });
                    }

                    ;
                    _module57.exportDefault(getObjectFields);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_scalar_fields.js": function module(_require55, _exports55, _module58) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/get_scalar_fields.js                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _filter;

                    _module58.link("lodash/filter", {
                      default(v) {
                        _filter = v;
                      }

                    }, 0);
                    let ScalarField;
                    _module58.link("../ScalarField", {
                      default(v) {
                        ScalarField = v;
                      }

                    }, 1);

                    function getScalarFields() {
                      return _filter(this.getFields(), function (field) {
                        return field instanceof ScalarField;
                      });
                    }

                    ;
                    _module58.exportDefault(getScalarFields);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "has_field.js": function module(_require56, _exports56, _module59) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/class_static_methods/has_field.js                                       //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module59.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasField(fieldName) {
                      return _has(this.schema.fields, fieldName);
                    }

                    ;
                    _module59.exportDefault(hasField);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require57, _exports57, _module60) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/apply_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module60.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _extend;

                    _module60.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 1);
                    let throwParseError;
                    _module60.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 2);
                    let Type;
                    _module60.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 3);
                    let AstroClass;
                    _module60.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 4);
                    let ScalarField;
                    _module60.link("../ScalarField", {
                      default(v) {
                        ScalarField = v;
                      }

                    }, 5);
                    let ObjectField;
                    _module60.link("../ObjectField", {
                      default(v) {
                        ObjectField = v;
                      }

                    }, 6);
                    let ListField;
                    _module60.link("../ListField", {
                      default(v) {
                        ListField = v;
                      }

                    }, 7);

                    function checkTypeExistence(type, className, fieldName) {
                      if (!type) {
                        throwParseError([{
                          'class': className
                        }, {
                          'property': 'fields'
                        }, {
                          'field': fieldName
                        }, 'Type does not exist']);
                      }
                    }

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      _each(parsedDefinition.fields, function (fieldDefinition, fieldName) {
                        // Prepare field variable.
                        let field; // List field.

                        if (Match.test(fieldDefinition.type, Array)) {
                          let type = Type.find(fieldDefinition.type[0]);
                          checkTypeExistence(type, className, fieldDefinition.name);

                          if (AstroClass.isParentOf(type.class)) {
                            field = new ListField(_extend({}, fieldDefinition, {
                              type: type
                            }));
                          } else {
                            field = new ListField(_extend({}, fieldDefinition, {
                              type: type
                            }));
                          }
                        } // Scalar or object field.
                        else {
                            let type = Type.find(fieldDefinition.type);
                            checkTypeExistence(type, className, fieldDefinition.name);

                            if (AstroClass.isParentOf(type.class)) {
                              field = new ObjectField(_extend({}, fieldDefinition, {
                                type: type
                              }));
                            } else {
                              field = new ScalarField(_extend({}, fieldDefinition, {
                                type: type
                              }));
                            }
                          } // Add a field object to the fields list.


                        Class.schema.fields[fieldName] = field;
                        Class.schema.fieldsNames.push(fieldName);
                      });
                    }

                    _module60.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require58, _exports58, _module61) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/init_class.js                                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getField;
                    _module61.link("../class_static_methods/get_field.js", {
                      default(v) {
                        getField = v;
                      }

                    }, 0);
                    let getFieldsNames;
                    _module61.link("../class_static_methods/get_fields_names.js", {
                      default(v) {
                        getFieldsNames = v;
                      }

                    }, 1);
                    let getFields;
                    _module61.link("../class_static_methods/get_fields.js", {
                      default(v) {
                        getFields = v;
                      }

                    }, 2);
                    let getObjectFields;
                    _module61.link("../class_static_methods/get_object_fields.js", {
                      default(v) {
                        getObjectFields = v;
                      }

                    }, 3);
                    let getListFields;
                    _module61.link("../class_static_methods/get_list_fields.js", {
                      default(v) {
                        getListFields = v;
                      }

                    }, 4);
                    let getScalarFields;
                    _module61.link("../class_static_methods/get_scalar_fields.js", {
                      default(v) {
                        getScalarFields = v;
                      }

                    }, 5);
                    let hasField;
                    _module61.link("../class_static_methods/has_field.js", {
                      default(v) {
                        hasField = v;
                      }

                    }, 6);
                    let get;
                    _module61.link("../class_prototype_methods/get.js", {
                      default(v) {
                        get = v;
                      }

                    }, 7);
                    let raw;
                    _module61.link("../class_prototype_methods/raw.js", {
                      default(v) {
                        raw = v;
                      }

                    }, 8);
                    let set;
                    _module61.link("../class_prototype_methods/set.js", {
                      default(v) {
                        set = v;
                      }

                    }, 9);
                    let fromJSONValue;
                    _module61.link("../class_events/from_json_value.js", {
                      default(v) {
                        fromJSONValue = v;
                      }

                    }, 10);
                    let toJSONValue;
                    _module61.link("../class_events/to_json_value.js", {
                      default(v) {
                        toJSONValue = v;
                      }

                    }, 11);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.getField = getField;
                      Class.getFieldsNames = getFieldsNames;
                      Class.getFields = getFields;
                      Class.getObjectFields = getObjectFields;
                      Class.getListFields = getListFields;
                      Class.getScalarFields = getScalarFields;
                      Class.hasField = hasField; // Class prototype methods.

                      Class.prototype.get = get;
                      Class.prototype.raw = raw;
                      Class.prototype.set = set; // Class events.

                      Class.extend({
                        events: {
                          fromJSONValue,
                          toJSONValue
                        }
                      }, ['events']);
                    }

                    ;
                    _module61.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require59, _exports59, _module62) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/init_definition.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.fields = {};
                    }

                    ;
                    _module62.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require60, _exports60, _module63) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/init_schema.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.fields = {};
                      schema.fieldsNames = [];
                    }

                    ;
                    _module63.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require61, _exports61, _module64) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/merge_definitions.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module64.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, className) {
                      _each(sourceDefinition.fields, function (fieldDefinition, fieldName) {
                        targetDefinition.fields[fieldName] = fieldDefinition;
                      });
                    }

                    ;
                    _module64.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require62, _exports62, _module65) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/hooks/parse_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module65.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _extend;

                    _module65.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 1);

                    let _includes;

                    _module65.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 2);
                    let throwParseError;
                    _module65.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 3);
                    let Class;
                    _module65.link("../../../core/class.js", {
                      default(v) {
                        Class = v;
                      }

                    }, 4);
                    let Type;
                    _module65.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 5);
                    let reservedKeywords;
                    _module65.link("../../../core/reserved_keywords.js", {
                      default(v) {
                        reservedKeywords = v;
                      }

                    }, 6);
                    const typePattern = Match.OneOf(Function, [Function]);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      if (definition.fields === undefined) {
                        return;
                      } // Fields definition has to be an object.


                      if (!Match.test(definition.fields, Object)) {
                        throwParseError([{
                          'class': className
                        }, {
                          'property': 'fields'
                        }, 'Fields definition has to be an object']);
                      }

                      _each(definition.fields, function (fieldDefinition, fieldName) {
                        if (Match.test(fieldDefinition, typePattern)) {
                          fieldDefinition = {
                            name: fieldName,
                            type: fieldDefinition
                          };
                        } else if (Match.test(fieldDefinition, Object)) {
                          fieldDefinition = _extend(fieldDefinition, {
                            name: fieldName
                          });
                        } else {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'fields'
                          }, {
                            'field': fieldName
                          }, 'Field definition has to be an object or type']);
                        } // Check if a field name is not reserved keyword.


                        if (_includes(reservedKeywords, fieldName)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'method': fieldName
                          }, 'Reserved keyword']);
                        }

                        parsedDefinition.fields[fieldDefinition.name] = fieldDefinition;
                      });
                    }

                    ;
                    _module65.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "types": { "boolean.js": function module(_require63, _exports63, _module66) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/boolean.js                                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isObject;

                    _module66.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 0);
                    let Type;
                    _module66.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 1);
                    let Validators;
                    _module66.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 2);
                    Type.create({
                      name: 'Boolean',
                      class: Boolean,

                      cast(value) {
                        if (typeof value === 'boolean' && _isObject(value)) {
                          return value;
                        } else if (typeof value === 'string') {
                          if (value === '') {
                            // The "this" context is a field.
                            if (this.optional) {
                              return null;
                            } else {
                              return false;
                            }
                          } else if (value.toLowerCase() === 'false' || value === '0') {
                            return false;
                          }
                        }

                        return Boolean(value);
                      },

                      validate(args) {
                        Validators.boolean(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "date.js": function module(_require64, _exports64, _module67) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/date.js                                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isNaN;

                    _module67.link("lodash/isNaN", {
                      default(v) {
                        _isNaN = v;
                      }

                    }, 0);

                    let _isNumber;

                    _module67.link("lodash/isNumber", {
                      default(v) {
                        _isNumber = v;
                      }

                    }, 1);
                    let Type;
                    _module67.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 2);
                    let Validators;
                    _module67.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 3);
                    Type.create({
                      name: 'Date',
                      class: Date,

                      cast(value) {
                        if (_isNumber(value)) {
                          return new Date(value);
                        } else if (typeof value === 'string') {
                          if (value === '') {
                            // The "this" context is a field.
                            if (this.optional) {
                              return null;
                            }
                          } else if (/^[0-9]+$/.test(value)) {
                            return new Date(parseInt(value, 10));
                          } else {
                            const time = Date.parse(value);

                            if (!_isNaN(time)) {
                              return new Date(time);
                            }
                          }
                        }

                        return value;
                      },

                      validate(args) {
                        Validators.date(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "mongo_object_id.js": function module(_require65, _exports65, _module68) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/mongo_object_id.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Type;
                    _module68.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 0);
                    let Validators;
                    _module68.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 1);
                    let Mongo;
                    _module68.link("meteor/mongo", {
                      Mongo(v) {
                        Mongo = v;
                      }

                    }, 2);
                    Type.create({
                      name: 'MongoObjectID',
                      class: Mongo.ObjectID,

                      validate(args) {
                        Validators.mongoObjectID(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "number.js": function module(_require66, _exports66, _module69) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/number.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isNaN;

                    _module69.link("lodash/isNaN", {
                      default(v) {
                        _isNaN = v;
                      }

                    }, 0);

                    let _isNumber;

                    _module69.link("lodash/isNumber", {
                      default(v) {
                        _isNumber = v;
                      }

                    }, 1);

                    let _isObject;

                    _module69.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 2);
                    let Type;
                    _module69.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 3);
                    let Validators;
                    _module69.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 4);
                    Type.create({
                      name: 'Number',
                      class: Number,

                      cast(value) {
                        if (typeof value === 'string') {
                          if (value === '') {
                            // The "this" context is a field.
                            if (this.optional) {
                              return null;
                            } else {
                              return 0;
                            }
                          }
                        } else if (_isObject(value)) {
                          return value;
                        } else if (!_isNaN(value) && _isNumber(value)) {
                          return value;
                        }

                        const number = Number(value);
                        return !_isNaN(number) ? number : value;
                      },

                      validate(args) {
                        Validators.number(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "object.js": function module(_require67, _exports67, _module70) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/object.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Type;
                    _module70.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 0);
                    let Validators;
                    _module70.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 1);
                    Type.create({
                      name: 'Object',
                      class: Object,

                      validate(args) {
                        Validators.object(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "string.js": function module(_require68, _exports68, _module71) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/types/string.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isObject;

                    _module71.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 0);
                    let Type;
                    _module71.link("../type.js", {
                      default(v) {
                        Type = v;
                      }

                    }, 1);
                    let Validators;
                    _module71.link("../../validators/validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 2);
                    Type.create({
                      name: 'String',
                      class: String,

                      cast(value) {
                        if (typeof value === 'string' || _isObject(value)) {
                          return value;
                        }

                        return String(value);
                      },

                      validate(args) {
                        Validators.string(args);
                      }

                    });
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "utils": { "castNested.js": function module(_require69, _exports69, _module72) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/castNested.js                                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module72.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let ObjectField;
                    _module72.link("../ObjectField", {
                      default(v) {
                        ObjectField = v;
                      }

                    }, 1);
                    let ListField;
                    _module72.link("../ListField", {
                      default(v) {
                        ListField = v;
                      }

                    }, 2);

                    function castNested() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        doc,
                        options
                      } = args;
                      const Class = doc.constructor;

                      _each(Class.getFields(), field => {
                        if (field instanceof ObjectField || field instanceof ListField && field.isClass) {
                          doc[field.name] = field.castValue(doc[field.name], options);
                        }
                      });
                    }

                    ;
                    _module72.exportDefault(castNested);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "castToClass.js": function module(_require70, _exports70, _module73) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/castToClass.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getChildClass;
                    _module73.link("./getChildClass", {
                      default(v) {
                        getChildClass = v;
                      }

                    }, 0);

                    function castToClass() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        Class,
                        rawDoc,
                        options
                      } = args; // If the class has a type field, then we have to check if we are
                      // casting to some of the nested classes.

                      const ChildClass = getChildClass({
                        Class,
                        rawDoc
                      }); // Create instance of an original class or some of its childs.

                      return new ChildClass(rawDoc, options);
                    }

                    _module73.exportDefault(castToClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getAll.js": function module(_require71, _exports71, _module74) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/getAll.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module74.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);
                    let getMany;
                    _module74.link("./getMany", {
                      default(v) {
                        getMany = v;
                      }

                    }, 1);

                    function getAll(doc) {
                      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true,
                        undefined: true
                      });

                      const Class = doc.constructor; // Get list of fields and their values.

                      return getMany(doc, Class.getFieldsNames(options), options);
                    }

                    ;
                    _module74.exportDefault(getAll);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getChildClass.js": function module(_require72, _exports72, _module75) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/getChildClass.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let config;
                    _module75.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 0);

                    function getChildClass() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        Class,
                        rawDoc
                      } = args;
                      const typeField = Class.getTypeField(); // If a class does not have a type field, then we just return an original
                      // class.

                      if (!typeField) {
                        return Class;
                      } // If a class has a type field, then we have to check if a raw document
                      // contains information about child class type.


                      const ChildClass = Class.get(rawDoc[typeField]); // Return a child class if it exists and in fact it's a child of an original
                      // class.

                      if (ChildClass && ChildClass.isChildOf(Class)) {
                        return ChildClass;
                      } // Otherwise just return original class.


                      return Class;
                    }

                    _module75.exportDefault(getChildClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getMany.js": function module(_require73, _exports73, _module76) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/getMany.js                                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module76.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _map;

                    _module76.link("lodash/map", {
                      default(v) {
                        _map = v;
                      }

                    }, 1);

                    let _omitBy;

                    _module76.link("lodash/omitBy", {
                      default(v) {
                        _omitBy = v;
                      }

                    }, 2);

                    let _zipObject;

                    _module76.link("lodash/zipObject", {
                      default(v) {
                        _zipObject = v;
                      }

                    }, 3);
                    let getOne;
                    _module76.link("./getOne", {
                      default(v) {
                        getOne = v;
                      }

                    }, 4);

                    function getMany(doc, fieldsNames) {
                      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true,
                        undefined: true
                      });

                      const values = _zipObject(fieldsNames, _map(fieldsNames, fieldName => {
                        return getOne(doc, fieldName, options);
                      }));

                      if (options.undefined) {
                        return values;
                      } else {
                        return _omitBy(values, value => value === undefined);
                      }
                    }

                    ;
                    _module76.exportDefault(getMany);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getOne.js": function module(_require74, _exports74, _module77) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/getOne.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module77.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);
                    let traverse;
                    _module77.link("./traverse.js", {
                      default(v) {
                        traverse = v;
                      }

                    }, 1);

                    function getOne(doc, fieldName) {
                      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true
                      });

                      return traverse(doc, fieldName, function (nestedDoc, nestedFieldName, field) {
                        // If a field does not exist than we don't return anything.
                        if (!field) {
                          return;
                        } // Don't get a transient field.


                        if (!options.transient && field.transient) {
                          return;
                        } // Don't get an immutable field.


                        if (!options.immutable && field.immutable) {
                          return;
                        } // Just return value.


                        return nestedDoc[nestedFieldName];
                      });
                    }

                    ;
                    _module77.exportDefault(getOne);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "isNestedFieldName.js": function module(_require75, _exports75, _module78) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/isNestedFieldName.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function isNestedFieldName(fieldPattern) {
                      return fieldPattern.indexOf('.') !== -1;
                    }

                    ;
                    _module78.exportDefault(isNestedFieldName);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "rawAll.js": function module(_require76, _exports76, _module79) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/rawAll.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module79.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);
                    let rawMany;
                    _module79.link("./rawMany", {
                      default(v) {
                        rawMany = v;
                      }

                    }, 1);

                    function rawAll(doc) {
                      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true,
                        undefined: true
                      });

                      const Class = doc.constructor; // Get list of fields and their values.

                      return rawMany(doc, Class.getFieldsNames(options), options);
                    }

                    ;
                    _module79.exportDefault(rawAll);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "rawMany.js": function module(_require77, _exports77, _module80) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/rawMany.js                                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module80.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _map;

                    _module80.link("lodash/map", {
                      default(v) {
                        _map = v;
                      }

                    }, 1);

                    let _omitBy;

                    _module80.link("lodash/omitBy", {
                      default(v) {
                        _omitBy = v;
                      }

                    }, 2);

                    let _zipObject;

                    _module80.link("lodash/zipObject", {
                      default(v) {
                        _zipObject = v;
                      }

                    }, 3);
                    let rawOne;
                    _module80.link("./rawOne", {
                      default(v) {
                        rawOne = v;
                      }

                    }, 4);

                    function rawMany(doc, fieldsNames) {
                      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true,
                        undefined: true
                      });

                      const values = _zipObject(fieldsNames, _map(fieldsNames, fieldName => {
                        return rawOne(doc, fieldName, options);
                      }));

                      if (options.undefined) {
                        return values;
                      } else {
                        return _omitBy(values, value => value === undefined);
                      }
                    }

                    ;
                    _module80.exportDefault(rawMany);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "rawOne.js": function module(_require78, _exports78, _module81) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/rawOne.js                                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module81.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _isArray;

                    _module81.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 1);

                    let _map;

                    _module81.link("lodash/map", {
                      default(v) {
                        _map = v;
                      }

                    }, 2);
                    let AstroClass;
                    _module81.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 3);
                    let traverse;
                    _module81.link("./traverse.js", {
                      default(v) {
                        traverse = v;
                      }

                    }, 4);
                    let rawAll;
                    _module81.link("./rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 5);

                    function rawOne(doc, fieldName) {
                      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                      // Prepare default options values.
                      _defaults(options, {
                        transient: true,
                        immutable: true,
                        // We still need the "undefined" options in the "rawOne" util, because we
                        // might want to get nested document that may have undefined fields.
                        undefined: true
                      });

                      return traverse(doc, fieldName, function (nestedDoc, nestedFieldName, field) {
                        // If a field does not exist than we don't return anything.
                        if (!field) {
                          return;
                        } // Don't get a transient field.


                        if (!options.transient && field.transient) {
                          return;
                        } // Don't get an immutable field.


                        if (!options.immutable && field.immutable) {
                          return;
                        } // Get field's value.


                        const fieldValue = nestedDoc[nestedFieldName];

                        if (fieldValue instanceof AstroClass) {
                          return rawAll(fieldValue, options);
                        } else if (_isArray(fieldValue)) {
                          return _map(fieldValue, function (element) {
                            if (element instanceof AstroClass) {
                              return rawAll(element, options);
                            } else {
                              return element;
                            }
                          });
                        } else {
                          return fieldValue;
                        }
                      });
                    }

                    ;
                    _module81.exportDefault(rawOne);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "resolveValues.js": function module(_require79, _exports79, _module82) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/resolveValues.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _fromPairs;

                    _module82.link("lodash/fromPairs", {
                      default(v) {
                        _fromPairs = v;
                      }

                    }, 0);

                    let _map;

                    _module82.link("lodash/map", {
                      default(v) {
                        _map = v;
                      }

                    }, 1);
                    let config;
                    _module82.link("../../../core/config.js", {
                      default(v) {
                        config = v;
                      }

                    }, 2);
                    let getChildClass;
                    _module82.link("./getChildClass", {
                      default(v) {
                        getChildClass = v;
                      }

                    }, 3);

                    function resolveValues() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        Class,
                        rawDoc
                      } = args; // We can not resolve when dealing with non object value or the "resolving"
                      // config param is turned off.

                      if (!rawDoc || !config.resolving) {
                        return rawDoc;
                      } // When resolving values, we need to get resolve method for a child class
                      // if a given document is actually an instance of child class.


                      const ChildClass = getChildClass({
                        Class,
                        rawDoc
                      }); // Construct resolved document from key-value pairs.

                      return _fromPairs(_map(ChildClass.getFields(), field => {
                        return [field.name, field.resolveValue(rawDoc)];
                      }));
                    }

                    _module82.exportDefault(resolveValues);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "set_all.js": function module(_require80, _exports80, _module83) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/set_all.js                                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _difference;

                    _module83.link("lodash/difference", {
                      default(v) {
                        _difference = v;
                      }

                    }, 0);

                    let _each;

                    _module83.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _forOwn;

                    _module83.link("lodash/forOwn", {
                      default(v) {
                        _forOwn = v;
                      }

                    }, 2);

                    let _keys;

                    _module83.link("lodash/keys", {
                      default(v) {
                        _keys = v;
                      }

                    }, 3);
                    let setOne;
                    _module83.link("./set_one.js", {
                      default(v) {
                        setOne = v;
                      }

                    }, 4);

                    function setAll(doc, fieldsValues, options) {
                      const Class = doc.constructor; // Get names of the fields that are not present in the fieldsValues variable.

                      const fieldsNames = _difference(Class.getFieldsNames(), _keys(fieldsValues));

                      _each(fieldsNames, fieldName => {
                        setOne(doc, fieldName, undefined, options);
                      });

                      _forOwn(fieldsValues, (fieldValue, fieldName) => {
                        setOne(doc, fieldName, fieldValue, options);
                      });
                    }

                    ;
                    _module83.exportDefault(setAll);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "set_many.js": function module(_require81, _exports81, _module84) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/set_many.js                                                       //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _forOwn;

                    _module84.link("lodash/forOwn", {
                      default(v) {
                        _forOwn = v;
                      }

                    }, 0);
                    let setOne;
                    _module84.link("./set_one.js", {
                      default(v) {
                        setOne = v;
                      }

                    }, 1);

                    function setMany(doc, fieldsValues, options) {
                      // Set multiple fields.
                      _forOwn(fieldsValues, (setValue, fieldName) => {
                        setOne(doc, fieldName, setValue, options);
                      });
                    }

                    ;
                    _module84.exportDefault(setMany);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "set_one.js": function module(_require82, _exports82, _module85) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/set_one.js                                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isObject;

                    _module85.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 0);
                    let EJSON;
                    _module85.link("meteor/ejson", {
                      EJSON(v) {
                        EJSON = v;
                      }

                    }, 1);
                    let traverse;
                    _module85.link("../utils/traverse", {
                      default(v) {
                        traverse = v;
                      }

                    }, 2);
                    let warn;
                    _module85.link("../../core/utils/warn", {
                      default(v) {
                        warn = v;
                      }

                    }, 3);
                    let ObjectField;
                    _module85.link("../ObjectField", {
                      default(v) {
                        ObjectField = v;
                      }

                    }, 4);
                    let ListField;
                    _module85.link("../ListField", {
                      default(v) {
                        ListField = v;
                      }

                    }, 5);

                    function setOne(doc, fieldPattern, fieldValue, options) {
                      // If the "clone" option was set and the value being set is an object,
                      // then we clone value using the "EJSON.clone" function.
                      if (options.clone && _isObject(fieldValue)) {
                        fieldValue = EJSON.clone(fieldValue);
                      }

                      return traverse(doc, fieldPattern, (nestedDoc, nestedFieldName, field) => {
                        // If a field does not exist than we don't return anything.
                        if (!field) {
                          const Class = doc.constructor;
                          const className = Class.getName();
                          warn("[\"".concat(className, "\" class][\"").concat(fieldPattern, "\" field] ") + 'Trying to set a value of the field that does not exist in the class');
                          return;
                        } // Cast value if the "cast" option was set or if a field is instance of
                        // ObjectField or ListField.


                        if (options.cast || field instanceof ObjectField || field instanceof ListField && field.isClass) {
                          // If the "cast" option is set and we're casting array's element.
                          if (options.cast && field instanceof ListField && /\d+/.test(nestedFieldName)) {
                            options.element = true;
                          }

                          fieldValue = field.castValue(fieldValue, options);
                        } // Set default value if the "defualts" option was set.


                        if (fieldValue === undefined && options.defaults) {
                          fieldValue = field.getDefault(nestedDoc);
                        } // Finally set casted/cloned/untouched value.


                        nestedDoc[nestedFieldName] = fieldValue;
                      });
                    }

                    _module85.exportDefault(setOne);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "traverse.js": function module(_require83, _exports83, _module86) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/fields/utils/traverse.js                                                       //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isObject;

                    _module86.link("lodash/isObject", {
                      default(v) {
                        _isObject = v;
                      }

                    }, 0);
                    let isNestedFieldName;
                    _module86.link("./isNestedFieldName", {
                      default(v) {
                        isNestedFieldName = v;
                      }

                    }, 1);
                    let AstroClass;
                    _module86.link("../../../core/class", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 2);

                    function traverse(doc, name, callback) {
                      if (!doc) {
                        return;
                      }

                      let Class;
                      let field; // Check whether the given field name is a nested field name.

                      if (!isNestedFieldName(name)) {
                        // Get a class.
                        let Class = doc.constructor; // Get a field definition.

                        let field = Class.getField(name); // Execute the callback function passing the last nested document, the last
                        // segment name and a field object.

                        return callback(doc, name, field);
                      } // Split the nested field pattern name by the "." character.


                      let segments = name.split('.'); // Get the last and one before the last index.

                      let lastIndex = segments.length - 1; // Traverse nested fields until reaching the last one from the pattern.

                      let next = function (nestedDoc, segmentIndex) {
                        segmentIndex = segmentIndex || 0; // Get a nested field name under the given index.

                        let segment = segments[segmentIndex]; // Check if a nested document is an instance of the Astronomy class and get
                        // a field object for a given field name;

                        if (nestedDoc instanceof AstroClass) {
                          // Get a class for of a nested document.
                          Class = nestedDoc.constructor; // Get a field object from the nested class.

                          field = Class.getField(segment);
                        }

                        if (segmentIndex === lastIndex) {
                          // Execute the callback function, if we reached the last nested document.
                          return callback(nestedDoc, segment, field);
                        } else if (_isObject(nestedDoc[segment])) {
                          // Go deeper if a value of the current nested document is an object.
                          return next(nestedDoc[segment], segmentIndex + 1);
                        }
                      }; // Start traversing nested fields.


                      return next(doc);
                    }

                    ;
                    _module86.exportDefault(traverse);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "helpers": { "module.js": function module(_require84, _exports84, _module87) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/helpers/module.js                                                              //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let onInitSchema;
                    module1.link("./hooks/onInitSchema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 1);
                    let onInitDefinition;
                    module1.link("./hooks/onInitDefinition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 2);
                    let onParseDefinition;
                    module1.link("./hooks/onParseDefinition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 3);
                    let onMergeDefinitions;
                    module1.link("./hooks/onMergeDefinitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 4);
                    let onApplyDefinition;
                    module1.link("./hooks/onApplyDefinition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 5);
                    let onInitClass;
                    module1.link("./hooks/onInitClass.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 6);
                    Module.create({
                      name: 'methods',
                      aliases: ['helpers'],
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass
                    });
                  }.call(this, _module87);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_static_methods": { "getHelper.js": function module(_require85, _exports85, _module88) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/class_static_methods/getHelper.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getHelper(helperName) {
                      return this.schema.helpers[helperName];
                    }

                    ;
                    _module88.exportDefault(getHelper);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getHelpers.js": function module(_require86, _exports86, _module89) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/class_static_methods/getHelpers.js                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getHelpers() {
                      return this.schema.helpers;
                    }

                    ;
                    _module89.exportDefault(getHelpers);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "hasHelper.js": function module(_require87, _exports87, _module90) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/class_static_methods/hasHelper.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module90.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasHelper(helperName) {
                      return _has(this.schema.helpers, helperName);
                    }

                    ;
                    _module90.exportDefault(hasHelper);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "onApplyDefinition.js": function module(_require88, _exports88, _module91) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onApplyDefinition.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module91.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      let schema = Class.schema; // Add helpers to the class.

                      _each(parsedDefinition.helpers, (helper, helperName) => {
                        schema.helpers[helperName] = helper;
                        Class.prototype[helperName] = helper;
                      });
                    }

                    ;
                    _module91.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitClass.js": function module(_require89, _exports89, _module92) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onInitClass.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let deprecated;
                    _module92.link("../../core/utils/deprecated", {
                      default(v) {
                        deprecated = v;
                      }

                    }, 0);
                    let getHelper;
                    _module92.link("../class_static_methods/getHelper.js", {
                      default(v) {
                        getHelper = v;
                      }

                    }, 1);
                    let getHelpers;
                    _module92.link("../class_static_methods/getHelpers.js", {
                      default(v) {
                        getHelpers = v;
                      }

                    }, 2);
                    let hasHelper;
                    _module92.link("../class_static_methods/hasHelper.js", {
                      default(v) {
                        hasHelper = v;
                      }

                    }, 3);

                    function onInitClass(Class, className) {
                      Class.getHelper = getHelper;
                      Class.getHelpers = getHelpers;
                      Class.hasHelper = hasHelper; // Class static helpers.

                      Class.getMethod = function () {
                        deprecated("Methods have been renamed to helpers. Please use the " + "\"".concat(className, ".getHelper\" function."));

                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                          args[_key] = arguments[_key];
                        }

                        return this.getHelper.apply(this, args);
                      };

                      Class.getMethods = function () {
                        deprecated("Methods have been renamed to helpers. Please use the " + "\"".concat(className, ".getHelpers\" function."));

                        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                          args[_key2] = arguments[_key2];
                        }

                        return this.getHelpers.apply(this, args);
                      };

                      Class.hasMethod = function () {
                        deprecated("Methods have been renamed to helpers. Please use the " + "\"".concat(className, ".hasHelper\" function."));

                        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                          args[_key3] = arguments[_key3];
                        }

                        return this.hasHelper.apply(this, args);
                      };
                    }

                    ;
                    _module92.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitDefinition.js": function module(_require90, _exports90, _module93) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onInitDefinition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.helpers = {};
                    }

                    ;
                    _module93.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitSchema.js": function module(_require91, _exports91, _module94) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onInitSchema.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.helpers = {};
                    }

                    ;
                    _module94.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onMergeDefinitions.js": function module(_require92, _exports92, _module95) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onMergeDefinitions.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module95.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, ClassName) {
                      _each(sourceDefinition.helpers, function (helper, helperName) {
                        targetDefinition.helpers[helperName] = helper;
                      });
                    }

                    ;
                    _module95.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onParseDefinition.js": function module(_require93, _exports93, _module96) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/helpers/hooks/onParseDefinition.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module96.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    let _each;

                    _module96.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _includes;

                    _module96.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 2);
                    let deprecated;
                    _module96.link("../../core/utils/deprecated", {
                      default(v) {
                        deprecated = v;
                      }

                    }, 3);
                    let throwParseError;
                    _module96.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 4);
                    let reservedKeywords;
                    _module96.link("../../../core/reserved_keywords.js", {
                      default(v) {
                        reservedKeywords = v;
                      }

                    }, 5);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      if (definition.methods) {
                        definition.helpers = definition.helpers || {};
                        deprecated("Methods have been renamed to helpers. Please use the \"helpers\" " + "section in the \"".concat(className, "\" class definition."));

                        _each(definition.methods, (method, methodName) => {
                          if (_has(definition.helpers, methodName)) {
                            deprecated("Methods have been renamed to helpers. Please move the " + "\"".concat(methodName, "\" method to the \"helpers\" section in the ") + "\"".concat(className, "\" class definition."));
                          } else {
                            definition.helpers[methodName] = method;
                          }
                        });
                      } // Check existence and validity of the "helpers" property.


                      if (definition.helpers !== undefined) {
                        if (!Match.test(definition.helpers, Object)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'helpers'
                          }, 'Helpers definition has to be an object']);
                        }

                        _each(definition.helpers, (helper, helperName) => {
                          if (!Match.test(helper, Function)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'helper': helperName
                            }, 'Helper has to be a function']);
                          }

                          if (_includes(reservedKeywords, helperName)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'helper': helperName
                            }, 'Reserved keyword']);
                          }

                          parsedDefinition.helpers[helperName] = helper;
                        });
                      }
                    }

                    ;
                    _module96.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "indexes": { "module.js": function module(_require94, _exports94, _module97) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/indexes/module.js                                                              //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 1);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 2);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 3);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 4);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 5);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 6);
                    Module.create({
                      name: 'indexes',
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass
                    });
                  }.call(this, _module97);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_static_methods": { "get_index.js": function module(_require95, _exports95, _module98) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/class_static_methods/get_index.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getIndex(indexName) {
                      return this.schema.indexes[indexName];
                    }

                    ;
                    _module98.exportDefault(getIndex);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_indexes.js": function module(_require96, _exports96, _module99) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/class_static_methods/get_indexes.js                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getIndexes() {
                      return this.schema.indexes;
                    }

                    ;
                    _module99.exportDefault(getIndexes);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "has_index.js": function module(_require97, _exports97, _module100) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/class_static_methods/has_index.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module100.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasIndex(indexName) {
                      return _has(this.schema.indexes, indexName);
                    }

                    ;
                    _module100.exportDefault(hasIndex);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require98, _exports98, _module101) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/apply_definition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _concat;

                    _module101.link("lodash/concat", {
                      default(v) {
                        _concat = v;
                      }

                    }, 0);

                    let _each;

                    _module101.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _extend;

                    _module101.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 2);

                    let _includes;

                    _module101.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 3);

                    let _mapKeys;

                    _module101.link("lodash/mapKeys", {
                      default(v) {
                        _mapKeys = v;
                      }

                    }, 4);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      const Collection = Class.getCollection();

                      if (!Meteor.isServer || !Collection || Collection && !Collection._connection) {
                        return;
                      }

                      const schema = Class.schema;

                      function prefixIndexes(indexes, fieldName) {
                        // Prefix the fields property.
                        _each(indexes, (index, indexName) => {
                          index.fields = _mapKeys(index.fields, (value, key) => {
                            return "".concat(fieldName, ".").concat(key);
                          });

                          _extend(index.options, {
                            name: "".concat(fieldName, ".").concat(indexName)
                          });
                        }); // Prefix object keys.


                        indexes = _mapKeys(indexes, (index, indexName) => {
                          return "".concat(fieldName, ".").concat(indexName);
                        });
                        return indexes;
                      } // Add indexes to the collection from nested classes.


                      const checkedClasses = [];

                      function collectNestedIndexes(Class) {
                        // Stop checking if a given class was already checked.
                        if (_includes(checkedClasses, Class)) {
                          return;
                        }

                        checkedClasses.push(Class);
                        const indexes = {};

                        const fields = _concat(Class.getObjectFields(), Class.getListFields(true));

                        _each(fields, field => {
                          _extend(indexes, prefixIndexes(field.type.class.definition.indexes, field.name), prefixIndexes(collectNestedIndexes(field.type.class), field.name));
                        });

                        return indexes;
                      }

                      const indexes = _extend({}, parsedDefinition.indexes, collectNestedIndexes(Class));

                      _each(indexes, (index, indexName) => {
                        schema.indexes[indexName] = index;

                        Collection._ensureIndex(index.fields, index.options);
                      });
                    }

                    ;
                    _module101.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require99, _exports99, _module102) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/init_class.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getIndex;
                    _module102.link("../class_static_methods/get_index.js", {
                      default(v) {
                        getIndex = v;
                      }

                    }, 0);
                    let getIndexes;
                    _module102.link("../class_static_methods/get_indexes.js", {
                      default(v) {
                        getIndexes = v;
                      }

                    }, 1);
                    let hasIndex;
                    _module102.link("../class_static_methods/has_index.js", {
                      default(v) {
                        hasIndex = v;
                      }

                    }, 2);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.getIndex = getIndex;
                      Class.getIndexes = getIndexes;
                      Class.hasIndex = hasIndex;
                    }

                    ;
                    _module102.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require100, _exports100, _module103) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/init_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.indexes = {};
                    }

                    ;
                    _module103.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require101, _exports101, _module104) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/init_schema.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.indexes = {};
                    }

                    ;
                    _module104.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require102, _exports102, _module105) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/merge_definitions.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module105.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, ClassName) {
                      _each(sourceDefinition.indexes, function (index, indexName) {
                        targetDefinition.indexes[indexName] = index;
                      });
                    }

                    ;
                    _module105.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require103, _exports103, _module106) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/indexes/hooks/parse_definition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module106.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let throwParseError;
                    _module106.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 1);
                    const fieldDefinitionPattern = Match.ObjectIncluding({
                      index: Match.OneOf(1, -1, String)
                    });

                    function onParseDefinition(parsedDefinition, definition, className) {
                      // Check existence and validity of the "indexes" property.
                      if (definition.indexes !== undefined) {
                        _each(definition.indexes, (index, indexName) => {
                          if (!Match.test(index, Object)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'index': indexName
                            }, 'Indexes definition has to be an object']);
                          }

                          index = {
                            fields: index.fields,
                            options: index.options || {}
                          };
                          index.options.name = index.options.name || indexName;
                          parsedDefinition.indexes[indexName] = index;
                        });
                      }

                      if (definition.fields !== undefined) {
                        _each(definition.fields, (fieldDefinition, fieldName) => {
                          // Stop if a field definition does not contain index information.
                          if (!Match.test(fieldDefinition, fieldDefinitionPattern)) {
                            return;
                          } // Prepare an index definition.


                          let indexDefinition = {
                            fields: {},
                            options: {
                              name: fieldName
                            }
                          };
                          indexDefinition.fields[fieldName] = fieldDefinition.index;
                          parsedDefinition.indexes[fieldName] = indexDefinition;
                        });
                      }
                    }

                    ;
                    _module106.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "methods": { "module.js": function module(_require104, _exports104, _module107) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/methods/module.js                                                              //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let onInitSchema;
                    module1.link("./hooks/onInitSchema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 1);
                    let onInitDefinition;
                    module1.link("./hooks/onInitDefinition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 2);
                    let onParseDefinition;
                    module1.link("./hooks/onParseDefinition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 3);
                    let onMergeDefinitions;
                    module1.link("./hooks/onMergeDefinitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 4);
                    let onApplyDefinition;
                    module1.link("./hooks/onApplyDefinition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 5);
                    let onInitClass;
                    module1.link("./hooks/onInitClass.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 6);
                    let onFinalizeClass;
                    module1.link("./hooks/onFinalizeClass.js", {
                      default(v) {
                        onFinalizeClass = v;
                      }

                    }, 7);
                    Module.create({
                      name: 'meteorMethods',
                      onInitSchema,
                      onInitDefinition,
                      onParseDefinition,
                      onMergeDefinitions,
                      onApplyDefinition,
                      onInitClass,
                      onFinalizeClass
                    });
                  }.call(this, _module107);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_prototype_methods": { "applyMethod.js": function module(_require105, _exports105, _module108) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/class_prototype_methods/applyMethod.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let callMeteorMethod;
                    _module108.link("../../storage/utils/call_meteor_method", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 0);
                    let rawAll;
                    _module108.link("../../fields/utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 1);

                    function applyMethod(methodName, methodArgs, callback) {
                      const doc = this;
                      const Class = doc.constructor; // Prepare arguments to be sent to the "/Astronomy/execute" method.

                      const meteorMethodArgs = {
                        className: Class.getName(),
                        methodName,
                        methodArgs,
                        rawDoc: rawAll(doc, {
                          transient: false
                        })
                      };

                      try {
                        return callMeteorMethod(Class, "/Astronomy/execute", [meteorMethodArgs], callback);
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module108.exportDefault(applyMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "callMethod.js": function module(_require106, _exports106, _module109) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/class_prototype_methods/callMethod.js                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _last;

                    _module109.link("lodash/last", {
                      default(v) {
                        _last = v;
                      }

                    }, 0);
                    let applyMethod;
                    _module109.link("./applyMethod", {
                      default(v) {
                        applyMethod = v;
                      }

                    }, 1);

                    function callMethod(methodName) {
                      for (var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        methodArgs[_key - 1] = arguments[_key];
                      }

                      // Get the last argument.
                      let callback = _last(methodArgs); // If the last argument is a callback function, then remove the last
                      // argument.


                      if (typeof callback === 'function') {
                        methodArgs.pop();
                      } // If the last argument is not a callback function, then clear the
                      // "callback" variable.
                      else {
                          callback = undefined;
                        }

                      return applyMethod.call(this, methodName, methodArgs, callback);
                    }

                    ;
                    _module109.exportDefault(callMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_static_methods": { "getMeteorMethod.js": function module(_require107, _exports107, _module110) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/class_static_methods/getMeteorMethod.js                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getMethod(methodName) {
                      return this.schema.methods[methodName];
                    }

                    ;
                    _module110.exportDefault(getMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getMeteorMethods.js": function module(_require108, _exports108, _module111) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/class_static_methods/getMeteorMethods.js                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getMethods() {
                      return this.schema.methods;
                    }

                    ;
                    _module111.exportDefault(getMethods);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "hasMeteorMethod.js": function module(_require109, _exports109, _module112) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/class_static_methods/hasMeteorMethod.js                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module112.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasMethod(methodName) {
                      return _has(this.schema.methods, methodName);
                    }

                    ;
                    _module112.exportDefault(hasMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "onApplyDefinition.js": function module(_require110, _exports110, _module113) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onApplyDefinition.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module113.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      const schema = Class.schema; // Add Meteor methods to the class schema.

                      _each(parsedDefinition.meteorMethods, (method, methodName) => {
                        schema.methods[methodName] = method;
                      });
                    }

                    ;
                    _module113.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onFinalizeClass.js": function module(_require111, _exports111, _module114) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onFinalizeClass.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _zipObject;

                    _module114.link("lodash/zipObject", {
                      default(v) {
                        _zipObject = v;
                      }

                    }, 0);

                    let _each;

                    _module114.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);
                    let wrapMethod;
                    _module114.link("../utils/wrapMethod", {
                      default(v) {
                        wrapMethod = v;
                      }

                    }, 2);
                    let hasMeteorMethod;
                    _module114.link("../../storage/utils/has_meteor_method", {
                      default(v) {
                        hasMeteorMethod = v;
                      }

                    }, 3);
                    let astronomyExecute;
                    _module114.link("../meteor_methods/astronomyExecute", {
                      default(v) {
                        astronomyExecute = v;
                      }

                    }, 4);
                    let applyMethod;
                    _module114.link("../class_prototype_methods/applyMethod", {
                      default(v) {
                        applyMethod = v;
                      }

                    }, 5);
                    let callMethod;
                    _module114.link("../class_prototype_methods/callMethod", {
                      default(v) {
                        callMethod = v;
                      }

                    }, 6);

                    function onFinalizeClass(Class, className) {
                      const schema = Class.schema;

                      if (schema.collection) {
                        const Collection = schema.collection;
                        const connection = Collection._connection || Meteor.connection || Meteor.server;

                        if (connection) {
                          if (!hasMeteorMethod(connection, "/Astronomy/execute")) {
                            // Add Meteor method.
                            connection.methods({
                              "/Astronomy/execute": astronomyExecute
                            });
                          }
                        } // Add Meteor methods to the class.


                        _each(schema.methods, (method, methodName) => {
                          Class.prototype[methodName] = wrapMethod(methodName);
                        }); // Add universal "applyMethod" and "callMethod" methods that can invoke any
                        // method even if only defined on the server.


                        Class.prototype.applyMethod = applyMethod;
                        Class.prototype.callMethod = callMethod;
                      }
                    }

                    _module114.exportDefault(onFinalizeClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitClass.js": function module(_require112, _exports112, _module115) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onInitClass.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getMeteorMethod;
                    _module115.link("../class_static_methods/getMeteorMethod.js", {
                      default(v) {
                        getMeteorMethod = v;
                      }

                    }, 0);
                    let getMeteorMethods;
                    _module115.link("../class_static_methods/getMeteorMethods.js", {
                      default(v) {
                        getMeteorMethods = v;
                      }

                    }, 1);
                    let hasMeteorMethod;
                    _module115.link("../class_static_methods/hasMeteorMethod.js", {
                      default(v) {
                        hasMeteorMethod = v;
                      }

                    }, 2);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.getMeteorMethod = getMeteorMethod;
                      Class.getMeteorMethods = getMeteorMethods;
                      Class.hasMeteorMethod = hasMeteorMethod;
                    }

                    ;
                    _module115.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitDefinition.js": function module(_require113, _exports113, _module116) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onInitDefinition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.meteorMethods = {};
                    }

                    ;
                    _module116.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onInitSchema.js": function module(_require114, _exports114, _module117) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onInitSchema.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.methods = {};
                    }

                    ;
                    _module117.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onMergeDefinitions.js": function module(_require115, _exports115, _module118) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onMergeDefinitions.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module118.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, className) {
                      _each(sourceDefinition.meteorMethods, function (method, methodName) {
                        targetDefinition.meteorMethods[methodName] = method;
                      });
                    }

                    ;
                    _module118.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "onParseDefinition.js": function module(_require116, _exports116, _module119) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/hooks/onParseDefinition.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module119.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _includes;

                    _module119.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 1);
                    let throwParseError;
                    _module119.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 2);
                    let reservedKeywords;
                    _module119.link("../../../core/reserved_keywords.js", {
                      default(v) {
                        reservedKeywords = v;
                      }

                    }, 3);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      // Check existence and validity of the "meteorMethods" property.
                      if (definition.meteorMethods !== undefined) {
                        if (!Match.test(definition.meteorMethods, Object)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'meteorMethods'
                          }, 'meteorMethods definition has to be an object']);
                        }

                        _each(definition.meteorMethods, function (meteorMethod, meteorMethodName) {
                          if (!Match.test(meteorMethod, Function)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'meteorMethod': meteorMethodName
                            }, 'Meteor method has to be a function']);
                          }

                          if (_includes(reservedKeywords, meteorMethodName)) {
                            throwParseError([{
                              'class': className
                            }, {
                              'meteorMethod': meteorMethodName
                            }, 'Reserved keyword']);
                          }

                          parsedDefinition.meteorMethods[meteorMethodName] = meteorMethod;
                        });
                      }
                    }

                    ;
                    _module119.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "meteor_methods": { "astronomyExecute.js": function module(_require117, _exports117, _module120) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/meteor_methods/astronomyExecute.js                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let AstroClass;
                    _module120.link("../../../core/class", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 0);

                    function astronomyExecute() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      check(args, Match.Any);
                      const {
                        className,
                        rawDoc,
                        methodName,
                        methodArgs
                      } = args;
                      const Class = AstroClass.get(className);
                      let doc;

                      if (rawDoc._id) {
                        doc = Class.findOne(rawDoc._id);
                      }

                      if (doc) {
                        doc.set(rawDoc);
                      } else {
                        doc = new Class(rawDoc, {
                          clone: false
                        });
                      } // Get a method from the class. In some cases method may not be present,
                      // because it might be defined only on the server.


                      const method = Class.getMeteorMethod(methodName);

                      if (!method) {
                        return;
                      }

                      return method.apply(doc, methodArgs);
                    }

                    ;
                    _module120.exportDefault(astronomyExecute);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "utils": { "wrapMethod.js": function module(_require118, _exports118, _module121) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/methods/utils/wrapMethod.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _last;

                    _module121.link("lodash/last", {
                      default(v) {
                        _last = v;
                      }

                    }, 0);
                    let callMeteorMethod;
                    _module121.link("../../storage/utils/call_meteor_method", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 1);
                    let rawAll;
                    _module121.link("../../fields/utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 2);

                    function wrapMethod(methodName) {
                      return function () {
                        const doc = this;
                        const Class = doc.constructor; // Get the last argument.

                        for (var _len = arguments.length, methodArgs = new Array(_len), _key = 0; _key < _len; _key++) {
                          methodArgs[_key] = arguments[_key];
                        }

                        let callback = _last(methodArgs); // If the last argument is a callback function, then remove the last
                        // argument.


                        if (typeof callback === "function") {
                          methodArgs.pop();
                        } else {
                          // If the last argument is not a callback function, then clear the
                          // "callback" variable.
                          callback = undefined;
                        } // Call the "/Astronomy/execute" method.


                        return doc.applyMethod(methodName, methodArgs, callback);
                      };
                    }

                    _module121.exportDefault(wrapMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "storage": { "module.js": function module(_require119, _exports119, _module122) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/storage/module.js                                                              //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    let applyModifier;
                    module1.link("./utils/apply_modifier.js", {
                      default(v) {
                        applyModifier = v;
                      }

                    }, 1);
                    let callMeteorMethod;
                    module1.link("./utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 2);
                    let classInsert;
                    module1.link("./utils/class_insert.js", {
                      default(v) {
                        classInsert = v;
                      }

                    }, 3);
                    let classUpdate;
                    module1.link("./utils/class_update.js", {
                      default(v) {
                        classUpdate = v;
                      }

                    }, 4);
                    let classRemove;
                    module1.link("./utils/class_remove.js", {
                      default(v) {
                        classRemove = v;
                      }

                    }, 5);
                    let documentInsert;
                    module1.link("./utils/document_insert.js", {
                      default(v) {
                        documentInsert = v;
                      }

                    }, 6);
                    let documentUpdate;
                    module1.link("./utils/document_update.js", {
                      default(v) {
                        documentUpdate = v;
                      }

                    }, 7);
                    let documentRemove;
                    module1.link("./utils/document_remove.js", {
                      default(v) {
                        documentRemove = v;
                      }

                    }, 8);
                    let getModified;
                    module1.link("./utils/getModified", {
                      default(v) {
                        getModified = v;
                      }

                    }, 9);
                    let getModifier;
                    module1.link("./utils/getModifier", {
                      default(v) {
                        getModifier = v;
                      }

                    }, 10);
                    let hasMeteorMethod;
                    module1.link("./utils/has_meteor_method.js", {
                      default(v) {
                        hasMeteorMethod = v;
                      }

                    }, 11);
                    let isModified;
                    module1.link("./utils/isModified", {
                      default(v) {
                        isModified = v;
                      }

                    }, 12);
                    let isRemote;
                    module1.link("./utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 13);
                    let omitUndefined;
                    module1.link("./utils/omit_undefined.js", {
                      default(v) {
                        omitUndefined = v;
                      }

                    }, 14);
                    let throwIfSelectorIsNotId;
                    module1.link("./utils/throw_if_selector_is_not_id.js", {
                      default(v) {
                        throwIfSelectorIsNotId = v;
                      }

                    }, 15);
                    let transformToClass;
                    module1.link("./utils/transformToClass", {
                      default(v) {
                        transformToClass = v;
                      }

                    }, 16);
                    let triggerBeforeSave;
                    module1.link("./utils/trigger_before_save.js", {
                      default(v) {
                        triggerBeforeSave = v;
                      }

                    }, 17);
                    let triggerBeforeInsert;
                    module1.link("./utils/trigger_before_insert.js", {
                      default(v) {
                        triggerBeforeInsert = v;
                      }

                    }, 18);
                    let triggerBeforeUpdate;
                    module1.link("./utils/trigger_before_update.js", {
                      default(v) {
                        triggerBeforeUpdate = v;
                      }

                    }, 19);
                    let triggerBeforeRemove;
                    module1.link("./utils/trigger_before_remove.js", {
                      default(v) {
                        triggerBeforeRemove = v;
                      }

                    }, 20);
                    let triggerAfterSave;
                    module1.link("./utils/trigger_after_save.js", {
                      default(v) {
                        triggerAfterSave = v;
                      }

                    }, 21);
                    let triggerAfterInsert;
                    module1.link("./utils/trigger_after_insert.js", {
                      default(v) {
                        triggerAfterInsert = v;
                      }

                    }, 22);
                    let triggerAfterUpdate;
                    module1.link("./utils/trigger_after_update.js", {
                      default(v) {
                        triggerAfterUpdate = v;
                      }

                    }, 23);
                    let triggerAfterRemove;
                    module1.link("./utils/trigger_after_remove.js", {
                      default(v) {
                        triggerAfterRemove = v;
                      }

                    }, 24);
                    let wrapTransform;
                    module1.link("./utils/wrapTransform.js", {
                      default(v) {
                        wrapTransform = v;
                      }

                    }, 25);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 26);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 27);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 28);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 29);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 30);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 31);
                    Module.create({
                      name: "storage",
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass,
                      utils: {
                        applyModifier,
                        callMeteorMethod,
                        classInsert,
                        classUpdate,
                        classRemove,
                        documentInsert,
                        documentUpdate,
                        documentRemove,
                        getModified,
                        getModifier,
                        hasMeteorMethod,
                        isModified,
                        isRemote,
                        omitUndefined,
                        throwIfSelectorIsNotId,
                        transformToClass,
                        triggerBeforeSave,
                        triggerBeforeInsert,
                        triggerBeforeUpdate,
                        triggerBeforeRemove,
                        triggerAfterSave,
                        triggerAfterInsert,
                        triggerAfterUpdate,
                        triggerAfterRemove,
                        wrapTransform
                      }
                    });
                  }.call(this, _module122);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_events": { "fromJSONValue.js": function module(_require120, _exports120, _module123) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_events/fromJSONValue.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function fromJSONValue(e) {
                      const doc = e.currentTarget;
                      doc._isNew = e.json.isNew;
                    }

                    ;
                    _module123.exportDefault(fromJSONValue);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "toJSONValue.js": function module(_require121, _exports121, _module124) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_events/toJSONValue.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function toJSONValue(e) {
                      const doc = e.currentTarget;
                      e.json.isNew = doc._isNew;
                    }

                    ;
                    _module124.exportDefault(toJSONValue);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_prototype_methods": { "copy.js": function module(_require122, _exports122, _module125) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/copy.js                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function copy(save) {
                      const doc = this;
                      save = save || false; // Use EJSON to clone object.

                      const copy = EJSON.clone(doc); // Clear the "_id" field so when saving it will store it as a new document
                      // instead of updating the old one.

                      copy._id = null;
                      copy._isNew = true;

                      if (save) {
                        copy.save();
                      }

                      return copy;
                    }

                    ;
                    _module125.exportDefault(copy);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getModified.js": function module(_require123, _exports123, _module126) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/getModified.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let utilGetModified;
                    _module126.link("../utils/getModified", {
                      default(v) {
                        utilGetModified = v;
                      }

                    }, 0);

                    function getModified() {
                      let doc = this;
                      return utilGetModified({
                        doc,
                        transient: true
                      });
                    }

                    ;
                    _module126.exportDefault(getModified);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getModifiedValues.js": function module(_require124, _exports124, _module127) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/getModifiedValues.js                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module127.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);
                    let utilGetModified;
                    _module127.link("../utils/getModified", {
                      default(v) {
                        utilGetModified = v;
                      }

                    }, 1);
                    let rawOne;
                    _module127.link("../../fields/utils/rawOne", {
                      default(v) {
                        rawOne = v;
                      }

                    }, 2);

                    function getModifiedValues() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let {
                        old = false,
                        raw = false
                      } = options;
                      let doc = this;
                      const Class = doc.constructor; // Get list of modified fields.

                      const modified = utilGetModified({
                        doc,
                        transient: true
                      }); // Get old or new values of a document.

                      if (old) {
                        doc = Class.findOne(doc._id);

                        if (!doc) {
                          doc = new Class();
                        }
                      } // Collect values for each field.


                      const values = {};

                      _each(modified, name => {
                        if (raw) {
                          values[name] = rawOne(doc, name);
                        } else {
                          values[name] = doc.get(name);
                        }
                      });

                      return values;
                    }

                    ;
                    _module127.exportDefault(getModifiedValues);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getModifier.js": function module(_require125, _exports125, _module128) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/getModifier.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let utilGetModifier;
                    _module128.link("../utils/getModifier", {
                      default(v) {
                        utilGetModifier = v;
                      }

                    }, 0);

                    function getModifier() {
                      let doc = this;
                      return utilGetModifier({
                        doc
                      });
                    }

                    ;
                    _module128.exportDefault(getModifier);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "isModified.js": function module(_require126, _exports126, _module129) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/isModified.js                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let utilIsModified;
                    _module129.link("../utils/isModified", {
                      default(v) {
                        utilIsModified = v;
                      }

                    }, 0);

                    function isModified(pattern) {
                      let doc = this;
                      return utilIsModified({
                        doc,
                        pattern,
                        transient: true
                      });
                    }

                    ;
                    _module129.exportDefault(isModified);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "reload.js": function module(_require127, _exports127, _module130) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/reload.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let castNested;
                    _module130.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 0);
                    let resolveValues;
                    _module130.link("../../fields/utils/resolveValues", {
                      default(v) {
                        resolveValues = v;
                      }

                    }, 1);
                    let Event;
                    _module130.link("../../events/event", {
                      default(v) {
                        Event = v;
                      }

                    }, 2);

                    function reload() {
                      const doc = this;
                      const Class = doc.constructor; // The document has to be already saved in the collection.
                      // Get a document from the collection without transformation.

                      const rawDoc = Class.findOne(doc._id, {
                        transform: null
                      });

                      if (rawDoc) {
                        // Trigger the "beforeInit" event handlers.
                        doc.dispatchEvent(new Event('beforeInit')); // Set all fields.

                        doc.set(resolveValues({
                          Class,
                          rawDoc
                        })); // Trigger the "afterInit" event handlers.

                        doc.dispatchEvent(new Event('afterInit'));
                      }
                    }

                    ;
                    _module130.exportDefault(reload);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "remove.js": function module(_require128, _exports128, _module131) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/remove.js                                      //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let documentRemove;
                    _module131.link("../utils/document_remove.js", {
                      default(v) {
                        documentRemove = v;
                      }

                    }, 0);
                    let isRemote;
                    _module131.link("../utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 1);
                    let callMeteorMethod;
                    _module131.link("../utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 2);

                    function remove() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let callback = arguments.length > 1 ? arguments[1] : undefined;
                      let doc = this;
                      let Class = doc.constructor; // If the first argument is callback function then reassign values.

                      if (arguments.length === 1 && Match.test(args, Function)) {
                        callback = args;
                        args = {};
                      } // Get variables from the first argument.


                      let {
                        simulation = true
                      } = args; // If we are dealing with a remote collection and we are not on the server.

                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        let methodName = '/Astronomy/remove'; // Prepare arguments for the meteor method.

                        let methodArgs = {
                          className: Class.getName(),
                          selector: {
                            _id: doc._id
                          },
                          simulation
                        };

                        try {
                          // Run meteor method.
                          let result = callMeteorMethod(Class, methodName, [methodArgs], callback); // Change the "_isNew" flag to "true". After removing a document can be
                          // saved again as a new one.

                          doc._isNew = true; // Return result of the meteor method call.

                          return result;
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just remove a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Prepare arguments.
                        let methodArgs = {
                          doc,
                          simulation,
                          trusted: true
                        };
                        let result = documentRemove(methodArgs);

                        if (callback) {
                          callback(undefined, result);
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module131.exportDefault(remove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "save.js": function module(_require129, _exports129, _module132) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_prototype_methods/save.js                                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module132.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _each;

                    _module132.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);

                    let _extend;

                    _module132.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 2);

                    let _omit;

                    _module132.link("lodash/omit", {
                      default(v) {
                        _omit = v;
                      }

                    }, 3);
                    let DDP;
                    _module132.link("meteor/ddp", {
                      DDP(v) {
                        DDP = v;
                      }

                    }, 4);
                    let documentInsert;
                    _module132.link("../utils/document_insert", {
                      default(v) {
                        documentInsert = v;
                      }

                    }, 5);
                    let documentUpdate;
                    _module132.link("../utils/document_update", {
                      default(v) {
                        documentUpdate = v;
                      }

                    }, 6);
                    let isRemote;
                    _module132.link("../utils/is_remote", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 7);
                    let callMeteorMethod;
                    _module132.link("../utils/call_meteor_method", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 8);
                    let rawAll;
                    _module132.link("../../fields/utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 9);
                    let castNested;
                    _module132.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 10);
                    let getModifier;
                    _module132.link("../../storage/utils/getModifier", {
                      default(v) {
                        getModifier = v;
                      }

                    }, 11);

                    function save() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let callback = arguments.length > 1 ? arguments[1] : undefined;
                      const doc = this;
                      const Class = doc.constructor;
                      const Collection = Class.getCollection(); // If the first argument is callback function then reassign values.

                      if (arguments.length === 1 && Match.test(options, Function)) {
                        callback = options;
                        options = {};
                      } // Set default options.


                      _defaults(options, {
                        stopOnFirstError: true,
                        simulation: true,
                        forceUpdate: false
                      }); // Cast all fields.


                      if (options.cast) {
                        _each(Class.getFields(), field => {
                          doc[field.name] = field.castValue(doc[field.name], {
                            clone: false,
                            cast: true
                          });
                        });
                      } // Cast only nested fields.
                      else {
                          castNested({
                            doc,
                            options: {
                              clone: false
                            }
                          });
                        } // Detect which operation we are executing.


                      const inserting = doc._isNew; // Generate ID if not provided.

                      if (inserting && !doc._id) {
                        let generateId = true; // Don't generate the id if we're the client and the 'outermost' call.
                        // This optimization saves us passing both the randomSeed and the id.
                        // Passing both is redundant.

                        if (Collection._isRemoteCollection()) {
                          const enclosing = DDP._CurrentInvocation.get();

                          if (!enclosing) {
                            generateId = false;
                          }
                        }

                        if (generateId) {
                          doc._id = Collection._makeNewID();
                        }
                      } // If we are dealing with a remote collection and we are not on the server.


                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        const methodName = '/Astronomy/' + (inserting ? 'insert' : 'update'); // Prepare arguments for meteor method.

                        const methodArgs = {
                          className: Class.getName(),
                          stopOnFirstError: options.stopOnFirstError,
                          simulation: options.simulation
                        }; // Inserting.

                        if (inserting) {
                          _extend(methodArgs, {
                            rawDoc: rawAll(doc, {
                              transient: false
                            })
                          });
                        } // Updating.
                        else {
                            // If the "forceUpdate" option was set then we don't run the "getModifier"
                            // function to get modifier and instead we just take entire raw object and
                            // remove the "_id" field as we can't update it.
                            const modifier = options.forceUpdate ? _omit(doc.raw(), ['_id']) : getModifier({
                              doc
                            });

                            _extend(methodArgs, {
                              selector: {
                                _id: doc._id
                              },
                              modifier,
                              options: {},
                              fields: options.fields
                            });
                          }

                        try {
                          // Run Meteor method.
                          const result = callMeteorMethod(Class, methodName, [methodArgs], callback);

                          if (result && inserting) {
                            // In the insert operation the value return from the meteor method is
                            // a document ID.
                            doc._id = result;
                          } // Document is not new anymore.


                          doc._isNew = false;
                          return result;
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just insert a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Prepare arguments.
                        let methodArgs = {
                          doc,
                          stopOnFirstError: options.stopOnFirstError,
                          simulation: options.simulation,
                          trusted: true
                        };

                        if (inserting) {
                          let result = documentInsert(methodArgs);

                          if (callback) {
                            callback(undefined, result);
                          }

                          return result;
                        } else {
                          methodArgs.fields = options.fields;
                          let result = documentUpdate(methodArgs);

                          if (callback) {
                            callback(undefined, result);
                          }

                          return result;
                        }
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module132.exportDefault(save);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_static_methods": { "find.js": function module(_require130, _exports130, _module133) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/find.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    _module133.export({
                      find: () => find,
                      findOne: () => findOne
                    });

                    let _defaults;

                    _module133.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _has;

                    _module133.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 1);

                    let _isNull;

                    _module133.link("lodash/isNull", {
                      default(v) {
                        _isNull = v;
                      }

                    }, 2);

                    let _map;

                    _module133.link("lodash/map", {
                      default(v) {
                        _map = v;
                      }

                    }, 3);
                    let config;
                    _module133.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 4);
                    let wrapTransform;
                    _module133.link("../utils/wrapTransform", {
                      default(v) {
                        wrapTransform = v;
                      }

                    }, 5);
                    let transformToClass;
                    _module133.link("../utils/transformToClass", {
                      default(v) {
                        transformToClass = v;
                      }

                    }, 6);
                    let Event;
                    _module133.link("../../events/event", {
                      default(v) {
                        Event = v;
                      }

                    }, 7);
                    let Mongo;
                    _module133.link("meteor/mongo", {
                      Mongo(v) {
                        Mongo = v;
                      }

                    }, 8);

                    function createMethod(methodName) {
                      return function (selector, options) {
                        let Class = this;
                        let Collection = Class.getCollection(); // Get selector from arguments.

                        if (arguments.length === 0) {
                          selector = {};
                        } else {
                          selector = arguments[0];
                        } // If selector is null then just proceed to collection's find method.


                        if (_isNull(selector)) {
                          return Collection[methodName](selector, options);
                        } // Rewrite selector to make it an object.


                        selector = Mongo.Collection._rewriteSelector(selector); // Set default options.

                        options = _defaults({}, options, {
                          defaults: config.defaults,
                          children: true,
                          // We don't want to clone raw object in the "find" method.
                          clone: false
                        }); // Modify selector and options using the "beforeFind" event handlers.

                        if (!options.disableEvents) {
                          Class.dispatchEvent(new Event('beforeFind', {
                            selector,
                            options
                          }));
                        }

                        const typeField = Class.getTypeField();

                        if ( // If it's an inherited class, then get only documents being instances of
                        // the subclass...
                        typeField && // ... however do not override a type property in selector when
                        // developer provided it and wants to deal with it by him/herself.
                        !_has(selector, typeField)) {
                          // If a class has child classes then we have to fetch document being
                          // instances of the parent and child classes depending on a value of
                          // the "children" option.
                          const children = Class.getChildren(options.children);

                          if (options.children && children.length > 0) {
                            children.push(Class);
                            selector[typeField] = {
                              $in: _map(children, Child => Child.getName())
                            };
                          } else {
                            selector[typeField] = Class.getName();
                          }
                        }

                        const classTransform = Class.getTransform();

                        if (options.transform !== null && classTransform !== null) {
                          // Wrap the transform function with the "wrapTransform" function, which
                          // resolves values.
                          options.transform = wrapTransform({
                            Class,
                            // First, try getting the transform function passed to the "find"
                            // method. Later, check if the transform function is defined in the
                            // class definition. If none of them contains a transform function, then
                            // get the default one.
                            transform: options.transform || classTransform || transformToClass({
                              Class,
                              options
                            })
                          });
                        } // Execute the original method.


                        let result = Collection[methodName](selector, options); // Modify a query result using the "afterFind" event handlers.

                        if (!options.disableEvents) {
                          Class.dispatchEvent(new Event('afterFind', {
                            selector,
                            options,
                            result
                          }));
                        }

                        return result;
                      };
                    }

                    const find = createMethod('find');
                    const findOne = createMethod('findOne');
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_collection.js": function module(_require131, _exports131, _module134) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/get_collection.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getCollection() {
                      return this.schema.collection;
                    }

                    ;
                    _module134.exportDefault(getCollection);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_transform.js": function module(_require132, _exports132, _module135) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/get_transform.js                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Class;
                    _module135.link("../../../core/class", {
                      default(v) {
                        Class = v;
                      }

                    }, 0);

                    function getTransform() {
                      return this.schema.transform;
                    }

                    _module135.exportDefault(getTransform);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_type_field.js": function module(_require133, _exports133, _module136) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/get_type_field.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getTypeField() {
                      return this.schema.typeField;
                    }

                    ;
                    _module136.exportDefault(getTypeField);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "insert.js": function module(_require134, _exports134, _module137) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/insert.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let isRemote;
                    _module137.link("../utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 0);
                    let callMeteorMethod;
                    _module137.link("../utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 1);
                    let classInsert;
                    _module137.link("../utils/class_insert.js", {
                      default(v) {
                        classInsert = v;
                      }

                    }, 2);

                    function insert(rawDoc, callback) {
                      const Class = this;
                      const Collection = Class.getCollection(); // Prepare arguments.

                      const args = {
                        className: Class.getName(),
                        rawDoc
                      }; // Generate ID if not provided.

                      if (!rawDoc._id) {
                        let generateId = true; // Don't generate the id if we're the client and the 'outermost' call.
                        // This optimization saves us passing both the randomSeed and the id.
                        // Passing both is redundant.

                        if (Collection._isRemoteCollection()) {
                          const enclosing = DDP._CurrentInvocation.get();

                          if (!enclosing) {
                            generateId = false;
                          }
                        }

                        if (generateId) {
                          rawDoc._id = Collection._makeNewID();
                        }
                      } // If we are dealing with a remote collection and we are not on the server.


                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        const methodName = '/Astronomy/insert';

                        try {
                          // Run Meteor method.
                          return callMeteorMethod(Class, methodName, [args], callback);
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just insert a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Set the "trusted" argument to true.
                        args.trusted = true; // Insert a document.

                        let result = classInsert(args);

                        if (callback) {
                          callback(undefined, result);
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module137.exportDefault(insert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "is_secured.js": function module(_require135, _exports135, _module138) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/is_secured.js                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module138.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function isSecured(operation) {
                      if (_has(this.schema.secured, operation)) {
                        return this.schema.secured[operation];
                      } else {
                        let common = this.schema.secured.common;
                        return common !== undefined ? common : true;
                      }
                    }

                    ;
                    _module138.exportDefault(isSecured);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "remove.js": function module(_require136, _exports136, _module139) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/remove.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let isRemote;
                    _module139.link("../utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 0);
                    let callMeteorMethod;
                    _module139.link("../utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 1);
                    let classRemove;
                    _module139.link("../utils/class_remove.js", {
                      default(v) {
                        classRemove = v;
                      }

                    }, 2);

                    function remove(selector, options, callback) {
                      const Class = this; // If we omit options argument then it may be a callback function.

                      if (options instanceof Function) {
                        callback = options;
                        options = {};
                      } // Make sure that options is at least an empty object.


                      options = options || {}; // Prepare arguments.

                      const args = {
                        className: Class.getName(),
                        selector,
                        options
                      }; // If we are dealing with a remote collection and we are not on the server.

                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        const methodName = '/Astronomy/remove';

                        try {
                          // Run Meteor method.
                          return callMeteorMethod(Class, methodName, [args], callback);
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just remove a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Set the "trusted" argument to true.
                        args.trusted = true; // Remove a document.

                        let result = classRemove(args);

                        if (callback) {
                          callback(undefined, result);
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module139.exportDefault(remove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "update.js": function module(_require137, _exports137, _module140) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/update.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let isRemote;
                    _module140.link("../utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 0);
                    let callMeteorMethod;
                    _module140.link("../utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 1);
                    let classUpdate;
                    _module140.link("../utils/class_update.js", {
                      default(v) {
                        classUpdate = v;
                      }

                    }, 2);

                    function update(selector, modifier, options, callback) {
                      const Class = this; // If we omit options argument then it may be a callback function.

                      if (options instanceof Function) {
                        callback = options;
                        options = {};
                      } // Make sure that options is at least an empty object.


                      options = options || {}; // Prepare arguments.

                      const args = {
                        className: Class.getName(),
                        selector,
                        modifier,
                        options
                      }; // If we are dealing with a remote collection and we are not on the server.

                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        const methodName = '/Astronomy/update';

                        try {
                          // Run Meteor method.
                          return callMeteorMethod(Class, methodName, [args], callback);
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just remove a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Set the "trusted" argument to true.
                        args.trusted = true; // Remove a document.

                        let result = classUpdate(args);

                        if (callback) {
                          callback(undefined, result);
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module140.exportDefault(update);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "upsert.js": function module(_require138, _exports138, _module141) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/class_static_methods/upsert.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let isRemote;
                    _module141.link("../utils/is_remote.js", {
                      default(v) {
                        isRemote = v;
                      }

                    }, 0);
                    let callMeteorMethod;
                    _module141.link("../utils/call_meteor_method.js", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 1);
                    let classUpsert;
                    _module141.link("../utils/class_upsert.js", {
                      default(v) {
                        classUpsert = v;
                      }

                    }, 2);

                    function upsert(selector, modifier, options, callback) {
                      const Class = this; // If we omit options argument then it may be a callback function.

                      if (options instanceof Function) {
                        callback = options;
                        options = {};
                      } // Make sure that options is at least an empty object.


                      options = options || {}; // Prepare arguments.

                      const args = {
                        className: Class.getName(),
                        selector,
                        modifier,
                        options
                      }; // If we are dealing with a remote collection and we are not on the server.

                      if (isRemote(Class)) {
                        // Prepare meteor method name to be called.
                        const methodName = '/Astronomy/upsert';

                        try {
                          // Run Meteor method.
                          return callMeteorMethod(Class, methodName, [args], callback);
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just remove a document without calling the meteor method. We may
                      // be on the server or the collection may be local.


                      try {
                        // Set the "trusted" argument to true.
                        args.trusted = true; // Remove a document.

                        let result = classUpsert(args);

                        if (callback) {
                          callback(undefined, result);
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module141.exportDefault(upsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require139, _exports139, _module142) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/apply_definition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module142.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _extend;

                    _module142.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 1);

                    let _zipObject;

                    _module142.link("lodash/zipObject", {
                      default(v) {
                        _zipObject = v;
                      }

                    }, 2);
                    let resolveValues;
                    _module142.link("../../fields/utils/resolveValues", {
                      default(v) {
                        resolveValues = v;
                      }

                    }, 3);
                    let hasMeteorMethod;
                    _module142.link("../utils/has_meteor_method", {
                      default(v) {
                        hasMeteorMethod = v;
                      }

                    }, 4);
                    let find, findOne;
                    _module142.link("../class_static_methods/find", {
                      find(v) {
                        find = v;
                      },

                      findOne(v) {
                        findOne = v;
                      }

                    }, 5);
                    let insert;
                    _module142.link("../class_static_methods/insert", {
                      default(v) {
                        insert = v;
                      }

                    }, 6);
                    let update;
                    _module142.link("../class_static_methods/update", {
                      default(v) {
                        update = v;
                      }

                    }, 7);
                    let upsert;
                    _module142.link("../class_static_methods/upsert", {
                      default(v) {
                        upsert = v;
                      }

                    }, 8);
                    let remove;
                    _module142.link("../class_static_methods/remove", {
                      default(v) {
                        remove = v;
                      }

                    }, 9);
                    let protoSave;
                    _module142.link("../class_prototype_methods/save", {
                      default(v) {
                        protoSave = v;
                      }

                    }, 10);
                    let protoRemove;
                    _module142.link("../class_prototype_methods/remove", {
                      default(v) {
                        protoRemove = v;
                      }

                    }, 11);
                    let protoReload;
                    _module142.link("../class_prototype_methods/reload", {
                      default(v) {
                        protoReload = v;
                      }

                    }, 12);
                    let protoCopy;
                    _module142.link("../class_prototype_methods/copy", {
                      default(v) {
                        protoCopy = v;
                      }

                    }, 13);
                    let protoGetModifier;
                    _module142.link("../class_prototype_methods/getModifier", {
                      default(v) {
                        protoGetModifier = v;
                      }

                    }, 14);
                    let protoGetModified;
                    _module142.link("../class_prototype_methods/getModified", {
                      default(v) {
                        protoGetModified = v;
                      }

                    }, 15);
                    let protoGetModifiedValues;
                    _module142.link("../class_prototype_methods/getModifiedValues", {
                      default(v) {
                        protoGetModifiedValues = v;
                      }

                    }, 16);
                    let protoIsModified;
                    _module142.link("../class_prototype_methods/isModified", {
                      default(v) {
                        protoIsModified = v;
                      }

                    }, 17);
                    let meteorInsert;
                    _module142.link("../meteor_methods/insert", {
                      default(v) {
                        meteorInsert = v;
                      }

                    }, 18);
                    let meteorUpdate;
                    _module142.link("../meteor_methods/update", {
                      default(v) {
                        meteorUpdate = v;
                      }

                    }, 19);
                    let meteorUpsert;
                    _module142.link("../meteor_methods/upsert", {
                      default(v) {
                        meteorUpsert = v;
                      }

                    }, 20);
                    let meteorRemove;
                    _module142.link("../meteor_methods/remove", {
                      default(v) {
                        meteorRemove = v;
                      }

                    }, 21);
                    let fromJSONValue;
                    _module142.link("../class_events/fromJSONValue", {
                      default(v) {
                        fromJSONValue = v;
                      }

                    }, 22);
                    let toJSONValue;
                    _module142.link("../class_events/toJSONValue", {
                      default(v) {
                        toJSONValue = v;
                      }

                    }, 23);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      const schema = Class.schema;

                      if (parsedDefinition.collection) {
                        const Collection = schema.collection = parsedDefinition.collection; // Get type of the "_id" field.

                        const id = Collection._makeNewID();

                        const IdType = id.constructor;
                        Class.extend({
                          // Add the "_id" field if not already added.
                          fields: {
                            _id: {
                              name: '_id',
                              type: IdType,
                              optional: true
                            }
                          },
                          // Add storage events.
                          events: {
                            toJSONValue: [toJSONValue],
                            fromJSONValue: [fromJSONValue]
                          }
                        }, ['fields', 'events']); // If it's a remote collection then we register methods on the connection
                        // object of the collection.

                        const connection = Collection._connection;

                        if (connection) {
                          // Prepare meteor methods to be added.
                          const meteorMethods = {
                            '/Astronomy/insert': meteorInsert,
                            '/Astronomy/update': meteorUpdate,
                            '/Astronomy/upsert': meteorUpsert,
                            '/Astronomy/remove': meteorRemove
                          };

                          _each(meteorMethods, (meteorMethod, methodName) => {
                            if (!hasMeteorMethod(connection, methodName)) {
                              // Add meteor method.
                              connection.methods(_zipObject([methodName], [meteorMethod]));
                            }
                          });
                        } // Class static methods.


                        Class.find = find;
                        Class.findOne = findOne;
                        Class.insert = insert;
                        Class.update = update;
                        Class.upsert = upsert;
                        Class.remove = remove; // Class prototype methods.

                        Class.prototype.save = protoSave;
                        Class.prototype.remove = protoRemove;
                        Class.prototype.reload = protoReload;
                        Class.prototype.copy = protoCopy;
                        Class.prototype.getModifier = protoGetModifier;
                        Class.prototype.getModified = protoGetModified;
                        Class.prototype.getModifiedValues = protoGetModifiedValues;
                        Class.prototype.isModified = protoIsModified;
                      } // Apply type field.


                      if (parsedDefinition.typeField) {
                        const typeField = schema.typeField = parsedDefinition.typeField; // Add the type field if not already added.

                        if (!Class.hasField(typeField)) {
                          Class.extend({
                            fields: {
                              [typeField]: {
                                type: String,
                                index: 1
                              }
                            },
                            events: {
                              afterInit(e) {
                                const doc = e.currentTarget;
                                const Class = doc.constructor;
                                doc[typeField] = Class.getName();
                              }

                            }
                          }, ['fields', 'events']);
                        }

                        if (parsedDefinition.typeField) {
                          schema.typeField = parsedDefinition.typeField;
                        }
                      } // If class has already assigned collection.


                      const Collection = Class.getCollection();

                      if (Collection) {
                        // Apply the "transform" property only if it's a function or equal null.
                        if (typeof parsedDefinition.transform === 'function' || parsedDefinition.transform === null) {
                          schema.transform = parsedDefinition.transform;
                        }

                        if (parsedDefinition.secured !== undefined) {
                          _extend(schema.secured, parsedDefinition.secured);
                        }
                      }
                    }

                    ;
                    _module142.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require140, _exports140, _module143) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/init_class.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getCollection;
                    _module143.link("../class_static_methods/get_collection.js", {
                      default(v) {
                        getCollection = v;
                      }

                    }, 0);
                    let getTypeField;
                    _module143.link("../class_static_methods/get_type_field.js", {
                      default(v) {
                        getTypeField = v;
                      }

                    }, 1);
                    let getTransform;
                    _module143.link("../class_static_methods/get_transform.js", {
                      default(v) {
                        getTransform = v;
                      }

                    }, 2);
                    let isSecured;
                    _module143.link("../class_static_methods/is_secured.js", {
                      default(v) {
                        isSecured = v;
                      }

                    }, 3);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.getCollection = getCollection;
                      Class.getTypeField = getTypeField;
                      Class.getTransform = getTransform;
                      Class.isSecured = isSecured;
                    }

                    ;
                    _module143.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require141, _exports141, _module144) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/init_definition.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.collection = undefined;
                      definition.typeField = undefined;
                      definition.transform = undefined;
                      definition.secured = undefined;
                    }

                    ;
                    _module144.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require142, _exports142, _module145) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/init_schema.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.collection = undefined;
                      schema.typeField = undefined;
                      schema.transform = undefined;
                      schema.secured = {
                        common: true
                      };
                    }

                    ;
                    _module145.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require143, _exports143, _module146) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/merge_definitions.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _extend;

                    _module146.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, ClassName) {
                      if (sourceDefinition.collection) {
                        targetDefinition.collection = sourceDefinition.collection;
                      }

                      if (sourceDefinition.typeField) {
                        targetDefinition.typeField = sourceDefinition.typeField;
                      }

                      if (sourceDefinition.transform !== undefined) {
                        targetDefinition.transform = sourceDefinition.transform;
                      }

                      if (sourceDefinition.secured !== undefined) {
                        targetDefinition.secured = _extend({}, targetDefinition.secured, sourceDefinition.secured);
                      }
                    }

                    ;
                    _module146.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require144, _exports144, _module147) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/hooks/parse_definition.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let throwParseError;
                    _module147.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 0);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      // Check existence and validity of the "collection" property.
                      if (definition.collection !== undefined) {
                        // The "collection" property has to be an instance of the
                        // "Mongo.Collection".
                        if (!(definition.collection instanceof Mongo.Collection)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'collection'
                          }, 'Property value has to be an instance of "Mongo.Collection"']);
                        }

                        parsedDefinition.collection = definition.collection;
                      } // Check existence and validity of the "typeField" property.


                      if (definition.typeField !== undefined) {
                        // The "typeField" property has to be a string.
                        if (!Match.test(definition.typeField, String)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'typeField'
                          }, 'Property value has to be a string']);
                        }

                        parsedDefinition.typeField = definition.typeField;
                      } // Check existence and validity of the "transform" property.


                      if (definition.transform !== undefined) {
                        // The "transform" property has to be a function.
                        if (!Match.test(definition.transform, Match.OneOf(Function, null))) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'transform'
                          }, 'Property value has to be a function or null']);
                        }

                        parsedDefinition.transform = definition.transform;
                      } // Check existence and validity of the "secured" property.


                      if (definition.secured !== undefined) {
                        if (!Match.test(definition.secured, Match.OneOf(Boolean, Object))) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'secured'
                          }, 'Property value has to be a boolean or an object with keys being ' + 'method name and values being boolean']);
                        }

                        if (typeof definition.secured === 'boolean') {
                          parsedDefinition.secured = {
                            common: definition.secured
                          };
                        } else {
                          parsedDefinition.secured = definition.secured;
                        }
                      }
                    }

                    ;
                    _module147.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "meteor_methods": { "insert.js": function module(_require145, _exports145, _module148) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/meteor_methods/insert.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let classInsert;
                    _module148.link("../utils/class_insert.js", {
                      default(v) {
                        classInsert = v;
                      }

                    }, 0);
                    let check, Match;
                    _module148.link("meteor/check", {
                      check(v) {
                        check = v;
                      },

                      Match(v) {
                        Match = v;
                      }

                    }, 1);

                    function insert(args) {
                      check(args, Match.Any);
                      return classInsert(args);
                    }

                    ;
                    _module148.exportDefault(insert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "remove.js": function module(_require146, _exports146, _module149) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/meteor_methods/remove.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let classRemove;
                    _module149.link("../utils/class_remove.js", {
                      default(v) {
                        classRemove = v;
                      }

                    }, 0);
                    let check, Match;
                    _module149.link("meteor/check", {
                      check(v) {
                        check = v;
                      },

                      Match(v) {
                        Match = v;
                      }

                    }, 1);

                    function remove(args) {
                      check(args, Match.Any);
                      return classRemove(args);
                    }

                    ;
                    _module149.exportDefault(remove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "update.js": function module(_require147, _exports147, _module150) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/meteor_methods/update.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let classUpdate;
                    _module150.link("../utils/class_update.js", {
                      default(v) {
                        classUpdate = v;
                      }

                    }, 0);
                    let check, Match;
                    _module150.link("meteor/check", {
                      check(v) {
                        check = v;
                      },

                      Match(v) {
                        Match = v;
                      }

                    }, 1);

                    function update(args) {
                      check(args, Match.Any);
                      return classUpdate(args);
                    }

                    ;
                    _module150.exportDefault(update);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "upsert.js": function module(_require148, _exports148, _module151) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/meteor_methods/upsert.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let classUpsert;
                    _module151.link("../utils/class_upsert.js", {
                      default(v) {
                        classUpsert = v;
                      }

                    }, 0);
                    let check, Match;
                    _module151.link("meteor/check", {
                      check(v) {
                        check = v;
                      },

                      Match(v) {
                        Match = v;
                      }

                    }, 1);

                    function upsert(args) {
                      check(args, Match.Any);
                      return classUpsert(args);
                    }

                    ;
                    _module151.exportDefault(upsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "utils": { "already_in_simulation.js": function module(_require149, _exports149, _module152) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/already_in_simulation.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let DDP;
                    _module152.link("meteor/ddp", {
                      DDP(v) {
                        DDP = v;
                      }

                    }, 0);

                    function alreadyInSimulation() {
                      const enclosing = DDP._CurrentInvocation.get();

                      return enclosing && enclosing.isSimulation;
                    }

                    _module152.exportDefault(alreadyInSimulation);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "apply_modifier.js": function module(_require150, _exports150, _module153) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/apply_modifier.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _size;

                    _module153.link("lodash/size", {
                      default(v) {
                        _size = v;
                      }

                    }, 0);
                    let config;
                    _module153.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 1);
                    let castNested;
                    _module153.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 2);
                    let setAll;
                    _module153.link("../../fields/utils/set_all", {
                      default(v) {
                        setAll = v;
                      }

                    }, 3);
                    let LocalCollection;
                    _module153.link("meteor/minimongo", {
                      LocalCollection(v) {
                        LocalCollection = v;
                      }

                    }, 4);

                    function applyModifier() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        doc,
                        modifier,
                        options
                      } = args; // Apply modifier only if provided.

                      if (modifier && _size(modifier) > 0) {
                        // Get raw object because the "_modify" method can only work with plain
                        // objects.
                        const rawDoc = doc.raw(); // Use Minimongo's the "_modify" method to apply modifier.

                        LocalCollection._modify(rawDoc, modifier, options); // Set all values back again on a document.


                        setAll(doc, rawDoc, {
                          defaults: config.defaults,
                          clone: false,
                          cast: false
                        });
                      }
                    }

                    ;
                    _module153.exportDefault(applyModifier);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "call_meteor_method.js": function module(_require151, _exports151, _module154) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/call_meteor_method.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    const callMeteorMethod = (Class, methodName, methodArgs, callback) => {
                      const Collection = Class.getCollection();
                      let connection = Collection && Collection._connection;

                      if (!connection && (!Collection || !Collection._name)) {
                        connection = Meteor.connection || Meteor.server;
                      } // Prepare meteor method options.


                      const methodOptions = {
                        throwStubExceptions: true,
                        returnStubValue: true
                      };
                      return connection.apply(methodName, methodArgs, methodOptions, callback);
                    };

                    _module154.exportDefault(callMeteorMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "class_insert.js": function module(_require152, _exports152, _module155) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/class_insert.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let AstroClass;
                    _module155.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 0);
                    let documentInsert;
                    _module155.link("./document_insert.js", {
                      default(v) {
                        documentInsert = v;
                      }

                    }, 1);

                    function classInsert() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        className,
                        rawDoc,
                        stopOnFirstError,
                        fields,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      }

                      const Class = AstroClass.get(className); // Create a new document.

                      const doc = new Class(rawDoc); // Insert a document.

                      return documentInsert({
                        doc,
                        stopOnFirstError,
                        simulation,
                        trusted
                      });
                    }

                    ;
                    _module155.exportDefault(classInsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "class_remove.js": function module(_require153, _exports153, _module156) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/class_remove.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let AstroClass;
                    _module156.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 0);
                    let alreadyInSimulation;
                    _module156.link("./already_in_simulation.js", {
                      default(v) {
                        alreadyInSimulation = v;
                      }

                    }, 1);
                    let throwIfSelectorIsNotId;
                    _module156.link("./throw_if_selector_is_not_id.js", {
                      default(v) {
                        throwIfSelectorIsNotId = v;
                      }

                    }, 2);
                    let documentRemove;
                    _module156.link("./document_remove.js", {
                      default(v) {
                        documentRemove = v;
                      }

                    }, 3);

                    function classRemove() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        className,
                        selector,
                        options,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      } // Throw exception if we are trying to perform an operation on more than one
                      // document at once and it's not trusted call.


                      if (!trusted && !alreadyInSimulation()) {
                        throwIfSelectorIsNotId(selector, 'remove');
                      }

                      const Class = AstroClass.get(className); // Get all documents matching selector.

                      const docs = Class.find(selector, options); // Prepare result of the method execution.

                      let result = 0;
                      docs.forEach(doc => {
                        // Update a document.
                        result += documentRemove({
                          doc,
                          simulation,
                          trusted
                        });
                      });
                      return result;
                    }

                    ;
                    _module156.exportDefault(classRemove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "class_update.js": function module(_require154, _exports154, _module157) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/class_update.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _extend;

                    _module157.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 0);

                    let _mapKeys;

                    _module157.link("lodash/mapKeys", {
                      default(v) {
                        _mapKeys = v;
                      }

                    }, 1);
                    let AstroClass;
                    _module157.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 2);
                    let alreadyInSimulation;
                    _module157.link("./already_in_simulation.js", {
                      default(v) {
                        alreadyInSimulation = v;
                      }

                    }, 3);
                    let throwIfSelectorIsNotId;
                    _module157.link("./throw_if_selector_is_not_id.js", {
                      default(v) {
                        throwIfSelectorIsNotId = v;
                      }

                    }, 4);
                    let documentUpdate;
                    _module157.link("./document_update.js", {
                      default(v) {
                        documentUpdate = v;
                      }

                    }, 5);
                    let applyModifier;
                    _module157.link("./apply_modifier.js", {
                      default(v) {
                        applyModifier = v;
                      }

                    }, 6);
                    let Minimongo;
                    _module157.link("meteor/minimongo", {
                      Minimongo(v) {
                        Minimongo = v;
                      }

                    }, 7);

                    function classUpdate() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        className,
                        selector,
                        modifier,
                        options,
                        stopOnFirstError,
                        fields,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      } // Throw exception if we are trying to perform an operation on more than one
                      // document at once and it's not trusted call.


                      if (!trusted && !alreadyInSimulation()) {
                        throwIfSelectorIsNotId(selector, 'update');
                      }

                      const Class = AstroClass.get(className); // Get all documents matching selector.

                      let docs;
                      let oldDocs;

                      if (options.multi) {
                        docs = Class.find(selector, options); // Get all old documents in one batched query so that performance is
                        // improved when updating many documents. Map all documents to an object
                        // where properites are documents' IDs.

                        oldDocs = _mapKeys(Class.find(selector, _extend(options, {
                          defaults: false
                        })).fetch(), oldDoc => oldDoc._id);
                      } else {
                        docs = Class.find(selector, _extend(options, {
                          limit: 1
                        })); // Get all old documents in one batched query so that performance is
                        // improved when updating many documents. Map all documents to an object
                        // where properites are documents' IDs.

                        oldDocs = _mapKeys(Class.find(selector, _extend(options, {
                          limit: 1,
                          defaults: false
                        })).fetch(), oldDoc => oldDoc._id);
                      } // Create a minimongo matcher object to find array indexes on the projection
                      // operator use.


                      const matcher = new Minimongo.Matcher(selector); // Prepare result of the method execution.

                      let result = 0;
                      docs.forEach(doc => {
                        const oldDoc = oldDocs[doc._id]; // Use matcher to find array indexes in a given document that needs updating
                        // on the projection operator use.

                        let queryResult = matcher.documentMatches(doc); // Apply modifier.

                        applyModifier({
                          doc,
                          modifier,
                          options: queryResult.arrayIndices ? {
                            arrayIndices: queryResult.arrayIndices
                          } : {}
                        }); // Update a document.

                        result += documentUpdate({
                          doc,
                          stopOnFirstError,
                          simulation,
                          fields,
                          trusted,
                          oldDoc
                        });
                      });
                      return result;
                    }

                    ;
                    _module157.exportDefault(classUpdate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "class_upsert.js": function module(_require155, _exports155, _module158) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/class_upsert.js                                                  //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _extend;

                    _module158.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 0);
                    let AstroClass;
                    _module158.link("../../../core/class.js", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 1);
                    let alreadyInSimulation;
                    _module158.link("./already_in_simulation.js", {
                      default(v) {
                        alreadyInSimulation = v;
                      }

                    }, 2);
                    let throwIfSelectorIsNotId;
                    _module158.link("./throw_if_selector_is_not_id.js", {
                      default(v) {
                        throwIfSelectorIsNotId = v;
                      }

                    }, 3);
                    let documentInsert;
                    _module158.link("./document_insert.js", {
                      default(v) {
                        documentInsert = v;
                      }

                    }, 4);
                    let documentUpdate;
                    _module158.link("./document_update.js", {
                      default(v) {
                        documentUpdate = v;
                      }

                    }, 5);
                    let applyModifier;
                    _module158.link("./apply_modifier.js", {
                      default(v) {
                        applyModifier = v;
                      }

                    }, 6);
                    let Minimongo, LocalCollection;
                    _module158.link("meteor/minimongo", {
                      Minimongo(v) {
                        Minimongo = v;
                      },

                      LocalCollection(v) {
                        LocalCollection = v;
                      }

                    }, 7);

                    function classUpsert() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        className,
                        selector,
                        modifier,
                        options,
                        stopOnFirstError,
                        fields,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      } // Throw exception if we are trying to perform an operation on more than one
                      // document at once and it's not trusted call.


                      if (!trusted && !alreadyInSimulation()) {
                        throwIfSelectorIsNotId(selector, 'upsert');
                      }

                      const Class = AstroClass.get(className); // Get all documents matching selector.

                      let docs;

                      if (options.multi) {
                        docs = Class.find(selector, options);
                      } else {
                        docs = Class.find(selector, _extend(options, {
                          limit: 1
                        }));
                      } // Create a minimongo matcher object to find array indexes on the projection
                      // operator use.


                      const matcher = new Minimongo.Matcher(selector); // Prepare result of the method execution.

                      const result = {
                        numberAffected: 0,
                        insertedId: null
                      };

                      if (docs.count() > 0) {
                        docs.forEach(doc => {
                          // Use matcher to find array indexes in a given document that needs updating
                          // on the projection operator use.
                          let queryResult = matcher.documentMatches(doc); // Apply modifier.

                          applyModifier({
                            doc,
                            modifier,
                            options: queryResult.arrayIndices ? {
                              arrayIndices: queryResult.arrayIndices
                            } : {}
                          }); // Update a document.

                          result.numberAffected += documentUpdate({
                            doc,
                            stopOnFirstError,
                            simulation,
                            fields,
                            trusted
                          });
                        });
                      } else {
                        let doc; // Create a new document from selector.

                        if (LocalCollection._createUpsertDocument) {
                          doc = new Class(LocalCollection._createUpsertDocument(selector, modifier));
                        } else if (LocalCollection._removeDollarOperators) {
                          doc = new Class(LocalCollection._removeDollarOperators(selector)); // Apply modifier for the insert operation.

                          applyModifier({
                            doc,
                            modifier,
                            options: {
                              isInsert: true
                            }
                          });
                        } // Insert a document.


                        result.insertedId = documentInsert({
                          doc,
                          stopOnFirstError,
                          simulation,
                          trusted
                        });
                      }

                      return result;
                    }

                    ;
                    _module158.exportDefault(classUpsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "diff.js": function module(_require156, _exports156, _module159) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/diff.js                                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module159.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _isArray;

                    _module159.link("lodash/isArray", {
                      default(v) {
                        _isArray = v;
                      }

                    }, 1);

                    let _isPlainObject;

                    _module159.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 2);

                    let _keys;

                    _module159.link("lodash/keys", {
                      default(v) {
                        _keys = v;
                      }

                    }, 3);

                    let _noop;

                    _module159.link("lodash/noop", {
                      default(v) {
                        _noop = v;
                      }

                    }, 4);

                    let _union;

                    _module159.link("lodash/union", {
                      default(v) {
                        _union = v;
                      }

                    }, 5);
                    let EJSON;
                    _module159.link("meteor/ejson", {
                      EJSON(v) {
                        EJSON = v;
                      }

                    }, 6);

                    function diff() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        fieldName,
                        newDoc,
                        oldDoc,
                        prefix = '',
                        result,
                        onDiff = _noop,
                        onObjectDiff = _noop,
                        onListDiff = _noop,
                        onScalarDiff = _noop
                      } = args; // Combine fields from old and new document.

                      const fieldsNames = _union(_keys(oldDoc), _keys(newDoc)); // Loop through all fields and check if they differ.


                      _each(fieldsNames, function (fieldName) {
                        const oldValue = oldDoc[fieldName];
                        const newValue = newDoc[fieldName];

                        if (!EJSON.equals(oldValue, newValue)) {
                          const nestedPrefix = (prefix && prefix + '.') + fieldName;
                          onDiff({
                            oldValue,
                            newValue,
                            prefix: nestedPrefix,
                            result
                          }); // Compare two objects.

                          if (_isPlainObject(oldValue) && _isPlainObject(newValue)) {
                            onObjectDiff({
                              oldDoc: oldValue,
                              newDoc: newValue,
                              prefix: nestedPrefix,
                              result
                            });
                          } // Compare two lists.
                          else if (_isArray(oldValue) && _isArray(newValue)) {
                              onListDiff({
                                oldList: oldValue,
                                newList: newValue,
                                prefix: nestedPrefix,
                                result
                              });
                            } // Compare two scalars.
                            else {
                                onScalarDiff({
                                  oldValue,
                                  newValue,
                                  prefix: nestedPrefix,
                                  result
                                });
                              }
                        }
                      });
                    }

                    _module159.exportDefault(diff);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "document_insert.js": function module(_require157, _exports157, _module160) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/document_insert.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _omitBy;

                    _module160.link("lodash/omitBy", {
                      default(v) {
                        _omitBy = v;
                      }

                    }, 0);
                    let castNested;
                    _module160.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 1);
                    let rawAll;
                    _module160.link("../../fields/utils/rawAll", {
                      default(v) {
                        rawAll = v;
                      }

                    }, 2);
                    let triggerBeforeSave;
                    _module160.link("./trigger_before_save", {
                      default(v) {
                        triggerBeforeSave = v;
                      }

                    }, 3);
                    let triggerBeforeInsert;
                    _module160.link("./trigger_before_insert", {
                      default(v) {
                        triggerBeforeInsert = v;
                      }

                    }, 4);
                    let triggerAfterSave;
                    _module160.link("./trigger_after_save", {
                      default(v) {
                        triggerAfterSave = v;
                      }

                    }, 5);
                    let triggerAfterInsert;
                    _module160.link("./trigger_after_insert", {
                      default(v) {
                        triggerAfterInsert = v;
                      }

                    }, 6);
                    let documentValidate;
                    _module160.link("../../validators/utils/document_validate", {
                      default(v) {
                        documentValidate = v;
                      }

                    }, 7);

                    function documentInsert() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        doc,
                        stopOnFirstError,
                        fields,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      }

                      const Class = doc.constructor;
                      const Collection = Class.getCollection(); // Generate ID if not provided.

                      if (!doc._id) {
                        doc._id = Collection._makeNewID();
                      } // Check if a class is secured.


                      if (Class.isSecured('insert') && Meteor.isServer && !trusted) {
                        throw new Meteor.Error(403, 'Inserting from the client is not allowed');
                      } // Cast nested documents.


                      castNested({
                        doc,
                        options: {
                          clone: false
                        }
                      }); // Trigger before events.

                      triggerBeforeSave(doc, trusted);
                      triggerBeforeInsert(doc, trusted); // Cast nested documents.

                      castNested({
                        doc,
                        options: {
                          clone: false
                        }
                      }); // Validate a document.

                      documentValidate({
                        doc,
                        fields,
                        stopOnFirstError,
                        simulation
                      }); // Get plain values of all fields. Pick only values that we want to save.

                      let values = rawAll(doc, {
                        transient: false
                      });
                      values = _omitBy(values, value => value === undefined); // Insert a document.

                      try {
                        // There is a difference in what the insert method returns depending on the
                        // environment. On the client it returns an inserted document id, on the
                        // server it returns array of inserted documents. So we always return the
                        // generated id. We can't send an entire document because it could be a
                        // security issue if we are not subscribed to all fields of a document.
                        Collection._collection.insert(values); // Change the "_isNew" flag to "false". Mark a document as not new.


                        doc._isNew = false; // Trigger after events.

                        triggerAfterInsert(doc, trusted);
                        triggerAfterSave(doc, trusted);
                        return doc._id;
                      } catch (err) {
                        if (err.name === 'MongoError' || err.name === 'MinimongoError') {
                          throw new Meteor.Error(409, err.toString());
                        } else {
                          throw err;
                        }
                      }
                    }

                    ;
                    _module160.exportDefault(documentInsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "document_remove.js": function module(_require158, _exports158, _module161) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/document_remove.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let triggerBeforeRemove;
                    _module161.link("./trigger_before_remove.js", {
                      default(v) {
                        triggerBeforeRemove = v;
                      }

                    }, 0);
                    let triggerAfterRemove;
                    _module161.link("./trigger_after_remove.js", {
                      default(v) {
                        triggerAfterRemove = v;
                      }

                    }, 1);

                    function documentRemove() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        doc,
                        simulation = true,
                        trusted = false
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      }

                      const Class = doc.constructor;
                      const Collection = Class.getCollection(); // Remove only when document has the "_id" field (it's persisted).

                      if (doc._isNew) {
                        return 0;
                      } // Check if a class is secured.


                      if (Class.isSecured('remove') && Meteor.isServer && !trusted) {
                        throw new Meteor.Error(403, 'Removing from the client is not allowed');
                      } // Trigger before events.


                      triggerBeforeRemove(doc, trusted); // Remove a document.

                      try {
                        const result = Collection._collection.remove({
                          _id: doc._id
                        }); // Mark a document as new, so it will be possible to save it again.


                        doc._isNew = true; // Trigger after events.

                        triggerAfterRemove(doc, trusted);
                        return result;
                      } catch (err) {
                        if (err.name === 'MongoError' || err.name === 'MinimongoError') {
                          throw new Meteor.Error(409, err.toString());
                        } else {
                          throw err;
                        }
                      }
                    }

                    ;
                    _module161.exportDefault(documentRemove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "document_update.js": function module(_require159, _exports159, _module162) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/document_update.js                                               //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _omit;

                    _module162.link("lodash/omit", {
                      default(v) {
                        _omit = v;
                      }

                    }, 0);

                    let _size;

                    _module162.link("lodash/size", {
                      default(v) {
                        _size = v;
                      }

                    }, 1);
                    let castNested;
                    _module162.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 2);
                    let triggerBeforeSave;
                    _module162.link("./trigger_before_save", {
                      default(v) {
                        triggerBeforeSave = v;
                      }

                    }, 3);
                    let triggerBeforeUpdate;
                    _module162.link("./trigger_before_update", {
                      default(v) {
                        triggerBeforeUpdate = v;
                      }

                    }, 4);
                    let triggerAfterSave;
                    _module162.link("./trigger_after_save", {
                      default(v) {
                        triggerAfterSave = v;
                      }

                    }, 5);
                    let triggerAfterUpdate;
                    _module162.link("./trigger_after_update", {
                      default(v) {
                        triggerAfterUpdate = v;
                      }

                    }, 6);
                    let isModified;
                    _module162.link("./isModified", {
                      default(v) {
                        isModified = v;
                      }

                    }, 7);
                    let getModifier;
                    _module162.link("./getModifier", {
                      default(v) {
                        getModifier = v;
                      }

                    }, 8);
                    let documentValidate;
                    _module162.link("../../validators/utils/document_validate", {
                      default(v) {
                        documentValidate = v;
                      }

                    }, 9);

                    function documentUpdate() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let {
                        doc,
                        stopOnFirstError,
                        fields,
                        simulation = true,
                        forceUpdate = false,
                        trusted = false,
                        oldDoc
                      } = args; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      }

                      let Class = doc.constructor;
                      let Collection = Class.getCollection(); // Return if there were no modifications.

                      if (!isModified({
                        doc,
                        fields
                      })) {
                        // Validate a document even if there were no modifications.
                        documentValidate({
                          doc,
                          fields,
                          stopOnFirstError,
                          simulation
                        }); // 0 documents were modified.

                        return 0;
                      } // Check if a class is secured.


                      if (Class.isSecured('update') && Meteor.isServer && !trusted) {
                        throw new Meteor.Error(403, 'Updating from the client is not allowed');
                      } // Cast nested documents.


                      castNested({
                        doc,
                        options: {
                          clone: false
                        }
                      }); // Trigger before events.

                      triggerBeforeSave(doc, trusted);
                      triggerBeforeUpdate(doc, trusted); // Cast nested documents.

                      castNested({
                        doc,
                        options: {
                          clone: false
                        }
                      }); // Validate a document.

                      documentValidate({
                        doc,
                        fields,
                        stopOnFirstError,
                        simulation
                      }); // Get modifier.
                      // If the "forceUpdate" option was set then we don't run the "getModifier"
                      // function to get modifier and instead we just take entire raw object and
                      // remove the "_id" field as we can't update it.

                      const modifier = forceUpdate ? _omit(doc.raw(), ['_id']) : getModifier({
                        doc,
                        fields,
                        oldDoc
                      }); // Stop execution is a modifier is empty.

                      if (_size(modifier) === 0) {
                        return 0;
                      } // Update a document.


                      try {
                        const result = Collection._collection.update({
                          _id: doc._id
                        }, modifier); // Trigger after events.


                        triggerAfterUpdate(doc, trusted);
                        triggerAfterSave(doc, trusted);
                        return result;
                      } catch (err) {
                        if (err.name === 'MongoError' || err.name === 'MinimongoError') {
                          throw new Meteor.Error(409, err.toString());
                        } else {
                          throw err;
                        }
                      }
                    }

                    ;
                    _module162.exportDefault(documentUpdate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getModified.js": function module(_require160, _exports160, _module163) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/getModified.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    !function (module1) {
                      let _objectSpread;

                      module1.link("@babel/runtime/helpers/objectSpread2", {
                        default(v) {
                          _objectSpread = v;
                        }

                      }, 0);

                      let _each;

                      module1.link("lodash/each", {
                        default(v) {
                          _each = v;
                        }

                      }, 0);

                      let _isPlainObject;

                      module1.link("lodash/isPlainObject", {
                        default(v) {
                          _isPlainObject = v;
                        }

                      }, 1);

                      let _range;

                      module1.link("lodash/range", {
                        default(v) {
                          _range = v;
                        }

                      }, 2);
                      let EJSON;
                      module1.link("meteor/ejson", {
                        EJSON(v) {
                          EJSON = v;
                        }

                      }, 3);
                      let throwParseError;
                      module1.link("../../core/utils/throw_parse_error.js", {
                        default(v) {
                          throwParseError = v;
                        }

                      }, 4);
                      let rawMany;
                      module1.link("../../fields/utils/rawMany", {
                        default(v) {
                          rawMany = v;
                        }

                      }, 5);
                      let diff;
                      module1.link("./diff", {
                        default(v) {
                          diff = v;
                        }

                      }, 6);
                      const handlers = {};

                      handlers.onDiff = function (_ref) {
                        let {
                          prefix,
                          result
                        } = _ref;
                        result.push(prefix);
                      };

                      handlers.onObjectDiff = function (_ref2) {
                        let {
                          oldDoc,
                          newDoc,
                          prefix,
                          result
                        } = _ref2;
                        diff(_objectSpread({
                          oldDoc,
                          newDoc,
                          prefix,
                          result
                        }, handlers));
                      };

                      handlers.onListDiff = function (_ref3) {
                        let {
                          oldList,
                          newList,
                          prefix,
                          result
                        } = _ref3;
                        const maxLength = Math.max(oldList.length, newList.length);

                        _each(_range(maxLength), function (index) {
                          const arrayPrefix = "".concat(prefix, ".").concat(index);
                          const oldElement = oldList[index];
                          const newElement = newList[index];

                          if (!EJSON.equals(oldElement, newElement)) {
                            result.push(arrayPrefix); // If both array elements are object, then we perform diff between
                            // them.

                            if (_isPlainObject(oldElement) && _isPlainObject(newElement)) {
                              // Get a difference between elements.
                              diff(_objectSpread({
                                oldDoc: oldElement,
                                newDoc: newElement,
                                prefix: arrayPrefix,
                                result
                              }, handlers));
                            }
                          }
                        });
                      };

                      function getModified() {
                        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        let {
                          doc: newDoc,
                          transient = false,
                          immutable = false,
                          fields
                        } = options;
                        const Class = newDoc.constructor;
                        const opts = {
                          defaults: false
                        };
                        let oldDoc = Class.findOne(newDoc._id, opts);

                        if (!oldDoc) {
                          oldDoc = new Class({}, opts);
                        } // If there is no document before modifications that may mean that we are not
                        // subscribed to the publication publishing given document or we modified the
                        // _id of a document.


                        if (!oldDoc) {
                          throwParseError([{
                            'module': 'storage'
                          }, {
                            'utility': 'getModified'
                          }, "Can not get a document before modifications. You are not subscribed " + "to the publication publishing a \"".concat(Class.getName(), "\" document with ") + "the id \"".concat(newDoc._id, "\" or you have modified the \"_id\" field")]);
                        } // If there are not fields specified, then get all of them.


                        if (!fields) {
                          fields = Class.getFieldsNames();
                        }

                        const result = [];
                        diff(_objectSpread({
                          // Get raw data from the docs.
                          oldDoc: rawMany(oldDoc, fields, {
                            transient,
                            immutable,
                            undefined: false
                          }),
                          newDoc: rawMany(newDoc, fields, {
                            transient,
                            immutable,
                            undefined: false
                          }),
                          result
                        }, handlers));
                        return result;
                      }

                      ;
                      module1.exportDefault(getModified);
                    }.call(this, _module163);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "getModifier.js": function module(_require161, _exports161, _module164) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/getModifier.js                                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    !function (module1) {
                      let _objectSpread;

                      module1.link("@babel/runtime/helpers/objectSpread2", {
                        default(v) {
                          _objectSpread = v;
                        }

                      }, 0);

                      let _each;

                      module1.link("lodash/each", {
                        default(v) {
                          _each = v;
                        }

                      }, 0);

                      let _isNumber;

                      module1.link("lodash/isNumber", {
                        default(v) {
                          _isNumber = v;
                        }

                      }, 1);

                      let _isPlainObject;

                      module1.link("lodash/isPlainObject", {
                        default(v) {
                          _isPlainObject = v;
                        }

                      }, 2);

                      let _omitBy;

                      module1.link("lodash/omitBy", {
                        default(v) {
                          _omitBy = v;
                        }

                      }, 3);

                      let _size;

                      module1.link("lodash/size", {
                        default(v) {
                          _size = v;
                        }

                      }, 4);
                      let EJSON;
                      module1.link("meteor/ejson", {
                        EJSON(v) {
                          EJSON = v;
                        }

                      }, 5);
                      let throwParseError;
                      module1.link("../../core/utils/throw_parse_error.js", {
                        default(v) {
                          throwParseError = v;
                        }

                      }, 6);
                      let rawMany;
                      module1.link("../../fields/utils/rawMany", {
                        default(v) {
                          rawMany = v;
                        }

                      }, 7);
                      let diff;
                      module1.link("./diff", {
                        default(v) {
                          diff = v;
                        }

                      }, 8);
                      const handlers = {};

                      handlers.onObjectDiff = function (_ref) {
                        let {
                          oldDoc,
                          newDoc,
                          prefix,
                          result
                        } = _ref;
                        diff(_objectSpread({
                          oldDoc,
                          newDoc,
                          prefix,
                          result
                        }, handlers));
                      };

                      handlers.onListDiff = function (_ref2) {
                        let {
                          oldList,
                          newList,
                          prefix,
                          result
                        } = _ref2;

                        // NOTE: We need check a new array size. If its length increased or stayed the
                        // same then all changes can be registered using the $set modifier. If an
                        // array length decreased, then we should slice it. However it may not be
                        // possible if some element has also changed. In such situation we have to
                        // override entire array.
                        // Array length decreased.
                        if (newList.length < oldList.length) {
                          // Due to an error in MiniMongo it's not possible to apply $push modifier
                          // with the $slice operator set to positive number. That's why we have to
                          // override entire array when it was shrinked.
                          result.$set[prefix] = newList;
                        } // Array length increased or stayed the same.
                        else if (newList.length >= oldList.length) {
                            let modified = false; // Compare up to number of elements in the new list.

                            _each(newList, (newElement, index) => {
                              const arrayPrefix = "".concat(prefix, ".").concat(index);
                              const oldElement = oldList[index]; // When iterating over elements up to old array length.

                              if (index < oldList.length) {
                                if (!EJSON.equals(oldElement, newElement)) {
                                  modified = true; // If both array elements are object, then we perform diff.

                                  if (_isPlainObject(oldElement) && _isPlainObject(newElement)) {
                                    // Get a difference between elements.
                                    diff(_objectSpread({
                                      oldDoc: oldElement,
                                      newDoc: newElement,
                                      prefix: arrayPrefix,
                                      result
                                    }, handlers));
                                  } else {
                                    result.$set[arrayPrefix] = newElement;
                                  }
                                }
                              } // When iterating over newly added array elements.
                              else {
                                  // Elements up to the old array length were modified, so we can not
                                  // use the $push operator in conjunction with the $set operator.
                                  if (modified) {
                                    // If both array elements are object, then we perform diff.
                                    if (_isPlainObject(oldElement) && _isPlainObject(newElement)) {
                                      // Get a difference between elements.
                                      diff(_objectSpread({
                                        oldDoc: oldElement,
                                        newDoc: newElement,
                                        prefix: arrayPrefix,
                                        result
                                      }, handlers));
                                    } else {
                                      result.$set[arrayPrefix] = newElement;
                                    }
                                  } // Elements up to the old array length were not modified, so if there
                                  // is any new array element added, we can insert it with the $push
                                  // operator.
                                  else {
                                      // We have to check if there is only one element being pushed or
                                      // more. If there is only one element then we use
                                      // $push[prefix]: element
                                      if (newList.length - oldList.length === 1) {
                                        result.$push[prefix] = newElement;
                                      } // If there are more elements we have to use
                                      // $push: { [prefix]: { $each: elements } }
                                      else {
                                          result.$push[prefix] = {
                                            $each: newList.slice(index)
                                          }; // We have to break each loop here. We don't need to check any
                                          // more elements.

                                          return false;
                                        }
                                    }
                                }
                            });
                          }
                      };

                      handlers.onScalarDiff = function (_ref3) {
                        let {
                          oldValue,
                          newValue,
                          prefix,
                          result
                        } = _ref3;

                        if (newValue !== undefined) {
                          if (_isNumber(oldValue) && _isNumber(newValue)) {
                            result.$inc[prefix] = newValue - oldValue;
                          } else {
                            result.$set[prefix] = newValue;
                          }
                        } else {
                          result.$unset[prefix] = '';
                        }
                      };

                      const getModifier = function () {
                        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        let {
                          doc: newDoc,
                          transient = false,
                          immutable = false,
                          fields,
                          oldDoc
                        } = options;
                        const Class = newDoc.constructor;
                        const opts = {
                          defaults: false
                        };

                        if (!oldDoc) {
                          oldDoc = Class.findOne(newDoc._id, opts);
                        }

                        if (!oldDoc) {
                          oldDoc = new Class({}, opts);
                        } // If there is no document before modifications that may mean that we are not
                        // subscribed to the publication publishing given document or we modified the
                        // _id of a document.


                        if (!oldDoc) {
                          throwParseError([{
                            'module': 'storage'
                          }, {
                            'utility': 'getModified'
                          }, "Can not get a document before modifications. You are not subscribed " + "to the publication publishing a \"".concat(Class.getName(), "\" document with ") + "the id \"".concat(newDoc._id, "\" or you have modified the \"_id\" field")]);
                        } // If there are not fields specified, then get all of them.


                        if (!fields) {
                          fields = Class.getFieldsNames();
                        }

                        const result = {
                          $set: {},
                          $inc: {},
                          $unset: {},
                          $push: {}
                        };
                        diff(_objectSpread({
                          // Get raw data from the docs.
                          oldDoc: rawMany(oldDoc, fields, {
                            transient,
                            immutable,
                            undefined: false
                          }),
                          newDoc: rawMany(newDoc, fields, {
                            transient,
                            immutable,
                            undefined: false
                          }),
                          result
                        }, handlers)); // Return only non empty modifiers.

                        return _omitBy(result, modifier => {
                          return _size(modifier) === 0;
                        });
                      };

                      module1.exportDefault(getModifier);
                    }.call(this, _module164);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "has_meteor_method.js": function module(_require162, _exports162, _module165) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/has_meteor_method.js                                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _has;

                    _module165.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 0);

                    function hasMeteorMethod(connection, methodName) {
                      // There is inconsistency between client and server. On the client connection
                      // object contains the "_methodHandlers" property and on the server the
                      // "method_handlers" property.
                      let methodHandlers = connection._methodHandlers || connection.method_handlers;
                      return _has(methodHandlers, methodName);
                    }

                    ;
                    _module165.exportDefault(hasMeteorMethod);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "isModified.js": function module(_require163, _exports163, _module166) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/isModified.js                                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _includes;

                    _module166.link("lodash/includes", {
                      default(v) {
                        _includes = v;
                      }

                    }, 0);
                    let getModified;
                    _module166.link("./getModified", {
                      default(v) {
                        getModified = v;
                      }

                    }, 1);

                    function isModified() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let {
                        doc,
                        pattern,
                        transient = false,
                        immutable = false
                      } = options;
                      let modified = getModified({
                        doc,
                        transient,
                        immutable
                      });

                      if (pattern) {
                        return _includes(modified, pattern);
                      } else {
                        return modified.length > 0;
                      }
                    }

                    ;
                    _module166.exportDefault(isModified);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "is_remote.js": function module(_require164, _exports164, _module167) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/is_remote.js                                                     //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function isRemote(Class) {
                      const Collection = Class.getCollection();

                      if (!Collection) {
                        return false;
                      }

                      const connection = Collection._connection;
                      return connection && connection !== Meteor.server;
                    }

                    _module167.exportDefault(isRemote);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "omit_undefined.js": function module(_require165, _exports165, _module168) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/omit_undefined.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _isPlainObject;

                    _module168.link("lodash/isPlainObject", {
                      default(v) {
                        _isPlainObject = v;
                      }

                    }, 0);

                    let _transform;

                    _module168.link("lodash/transform", {
                      default(v) {
                        _transform = v;
                      }

                    }, 1);

                    function omitUndefined(obj) {
                      return _transform(obj, function (result, value, key) {
                        if (_isPlainObject(value)) {
                          result[key] = omitUndefined(value);
                        } else if (value !== undefined) {
                          result[key] = value;
                        }
                      });
                    }

                    _module168.exportDefault(omitUndefined);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "throw_if_selector_is_not_id.js": function module(_require166, _exports166, _module169) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/throw_if_selector_is_not_id.js                                   //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let LocalCollection;
                    _module169.link("meteor/minimongo", {
                      LocalCollection(v) {
                        LocalCollection = v;
                      }

                    }, 0);

                    function throwIfSelectorIsNotId(selector, methodName) {
                      if (!LocalCollection._selectorIsIdPerhapsAsObject(selector)) {
                        throw new Meteor.Error(403, "Not permitted. Untrusted code may only ".concat(methodName, " documents by ID."));
                      }
                    }

                    ;
                    _module169.exportDefault(throwIfSelectorIsNotId);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "transformToClass.js": function module(_require167, _exports167, _module170) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/transformToClass.js                                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module170.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);
                    let config;
                    _module170.link("../../../core/config", {
                      default(v) {
                        config = v;
                      }

                    }, 1);
                    let wrapTransform;
                    _module170.link("./wrapTransform", {
                      default(v) {
                        wrapTransform = v;
                      }

                    }, 2);
                    let castToClass;
                    _module170.link("../../fields/utils/castToClass", {
                      default(v) {
                        castToClass = v;
                      }

                    }, 3);
                    let resolveValues;
                    _module170.link("../../fields/utils/resolveValues", {
                      default(v) {
                        resolveValues = v;
                      }

                    }, 4);

                    function transformToClass() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        Class,
                        options = {}
                      } = args; // When fetching document from collection we don't want to clone raw document
                      // and we want default values to be set.

                      _defaults(options, {
                        defaults: config.defaults,
                        clone: false,
                        cast: false
                      });

                      return function (rawDoc) {
                        const doc = castToClass({
                          Class,
                          rawDoc,
                          options
                        });
                        return doc;
                      };
                    }

                    ;
                    _module170.exportDefault(transformToClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_after_insert.js": function module(_require168, _exports168, _module171) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_after_insert.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module171.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerAfterInsert(doc, trusted) {
                      // Trigger the "afterInsert" event handlers.
                      doc.dispatchEvent(new Event('afterInsert', {
                        propagates: true,
                        trusted: trusted
                      }));
                    }

                    ;
                    _module171.exportDefault(triggerAfterInsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_after_remove.js": function module(_require169, _exports169, _module172) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_after_remove.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module172.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerAfterRemove(doc, trusted) {
                      // Trigger the "afterRemove" event handlers.
                      doc.dispatchEvent(new Event('afterRemove', {
                        propagates: true,
                        trusted: trusted
                      }));
                    }

                    ;
                    _module172.exportDefault(triggerAfterRemove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_after_save.js": function module(_require170, _exports170, _module173) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_after_save.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module173.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerAfterSave(doc, trusted) {
                      // Trigger the "afterSave" event handlers.
                      doc.dispatchEvent(new Event('afterSave', {
                        propagates: true,
                        trusted: trusted
                      }));
                    }

                    ;
                    _module173.exportDefault(triggerAfterSave);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_after_update.js": function module(_require171, _exports171, _module174) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_after_update.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module174.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerAfterUpdate(doc, trusted) {
                      // Trigger the "afterUpdate" event handlers.
                      doc.dispatchEvent(new Event('afterUpdate', {
                        propagates: true,
                        trusted: trusted
                      }));
                    }

                    ;
                    _module174.exportDefault(triggerAfterUpdate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_before_insert.js": function module(_require172, _exports172, _module175) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_before_insert.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module175.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerBeforeInsert(doc, trusted) {
                      // Trigger the "beforeInsert" event handlers.
                      if (!doc.dispatchEvent(new Event('beforeInsert', {
                        cancelable: true,
                        propagates: true,
                        trusted: trusted
                      }))) {
                        // If an event was prevented, then we stop here.
                        throw new Meteor.Error('prevented', 'Operation prevented', {
                          eventName: 'beforeInsert'
                        });
                      }
                    }

                    ;
                    _module175.exportDefault(triggerBeforeInsert);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_before_remove.js": function module(_require173, _exports173, _module176) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_before_remove.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module176.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerBeforeRemove(doc, trusted) {
                      // Trigger the "beforeRemove" event handlers.
                      if (!doc.dispatchEvent(new Event('beforeRemove', {
                        cancelable: true,
                        propagates: true,
                        trusted: trusted
                      }))) {
                        // If an event was prevented, then we stop here.
                        throw new Meteor.Error('prevented', 'Operation prevented', {
                          eventName: 'beforeRemove'
                        });
                      }
                    }

                    ;
                    _module176.exportDefault(triggerBeforeRemove);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_before_save.js": function module(_require174, _exports174, _module177) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_before_save.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module177.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerBeforeSave(doc, trusted) {
                      // Trigger the "beforeSave" event handlers.
                      if (!doc.dispatchEvent(new Event('beforeSave', {
                        cancelable: true,
                        propagates: true,
                        trusted: trusted
                      }))) {
                        // If an event was prevented, then we stop here.
                        throw new Meteor.Error('prevented', 'Operation prevented', {
                          eventName: 'beforeSave'
                        });
                      }
                    }

                    ;
                    _module177.exportDefault(triggerBeforeSave);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "trigger_before_update.js": function module(_require175, _exports175, _module178) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/trigger_before_update.js                                         //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Event;
                    _module178.link("../../events/event.js", {
                      default(v) {
                        Event = v;
                      }

                    }, 0);

                    function triggerBeforeUpdate(doc, trusted) {
                      // Trigger the "beforeUpdate" event handlers.
                      if (!doc.dispatchEvent(new Event('beforeUpdate', {
                        cancelable: true,
                        propagates: true,
                        trusted: trusted
                      }))) {
                        // If an event was prevented, then we stop here.
                        throw new Meteor.Error('prevented', 'Operation prevented', {
                          eventName: 'beforeUpdate'
                        });
                      }
                    }

                    ;
                    _module178.exportDefault(triggerBeforeUpdate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "wrapTransform.js": function module(_require176, _exports176, _module179) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/storage/utils/wrapTransform.js                                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let resolveValues;
                    _module179.link("../../fields/utils/resolveValues", {
                      default(v) {
                        resolveValues = v;
                      }

                    }, 0);

                    function wrapTransform() {
                      let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      const {
                        Class,
                        transform
                      } = args;
                      return function (rawDoc) {
                        const resolvedValues = resolveValues({
                          Class,
                          rawDoc
                        });
                        resolvedValues._isNew = false;
                        return transform(resolvedValues);
                      };
                    }

                    _module179.exportDefault(wrapTransform);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } } }, "validators": { "module.js": function module(_require177, _exports177, _module180) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/validators/module.js                                                           //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  !function (module1) {
                    let Module;
                    module1.link("../../core/module.js", {
                      default(v) {
                        Module = v;
                      }

                    }, 0);
                    module1.link("./validators/comparison/choice.js");
                    module1.link("./validators/comparison/email.js");
                    module1.link("./validators/comparison/equal.js");
                    module1.link("./validators/comparison/not_equal.js");
                    module1.link("./validators/comparison/regexp.js");
                    module1.link("./validators/existence/null.js");
                    module1.link("./validators/existence/not_null.js");
                    module1.link("./validators/existence/required.js");
                    module1.link("./validators/logical/and.js");
                    module1.link("./validators/logical/or.js");
                    module1.link("./validators/nested/every.js");
                    module1.link("./validators/nested/has.js");
                    module1.link("./validators/nested/includes.js");
                    module1.link("./validators/size/gt.js");
                    module1.link("./validators/size/gte.js");
                    module1.link("./validators/size/length.js");
                    module1.link("./validators/size/lt.js");
                    module1.link("./validators/size/lte.js");
                    module1.link("./validators/size/max_length.js");
                    module1.link("./validators/size/min_length.js");
                    module1.link("./validators/type/array.js");
                    module1.link("./validators/type/boolean.js");
                    module1.link("./validators/type/class.js");
                    module1.link("./validators/type/date.js");
                    module1.link("./validators/type/integer.js");
                    module1.link("./validators/type/mongo_object_id.js");
                    module1.link("./validators/type/number.js");
                    module1.link("./validators/type/object.js");
                    module1.link("./validators/type/string.js");
                    let documentValidate;
                    module1.link("./utils/document_validate.js", {
                      default(v) {
                        documentValidate = v;
                      }

                    }, 1);
                    let parseValidators;
                    module1.link("./utils/parse_validators.js", {
                      default(v) {
                        parseValidators = v;
                      }

                    }, 2);
                    let onInitSchema;
                    module1.link("./hooks/init_schema.js", {
                      default(v) {
                        onInitSchema = v;
                      }

                    }, 3);
                    let onInitDefinition;
                    module1.link("./hooks/init_definition.js", {
                      default(v) {
                        onInitDefinition = v;
                      }

                    }, 4);
                    let onParseDefinition;
                    module1.link("./hooks/parse_definition.js", {
                      default(v) {
                        onParseDefinition = v;
                      }

                    }, 5);
                    let onMergeDefinitions;
                    module1.link("./hooks/merge_definitions.js", {
                      default(v) {
                        onMergeDefinitions = v;
                      }

                    }, 6);
                    let onApplyDefinition;
                    module1.link("./hooks/apply_definition.js", {
                      default(v) {
                        onApplyDefinition = v;
                      }

                    }, 7);
                    let onInitClass;
                    module1.link("./hooks/init_class.js", {
                      default(v) {
                        onInitClass = v;
                      }

                    }, 8);
                    Module.create({
                      name: 'validators',
                      onInitSchema: onInitSchema,
                      onInitDefinition: onInitDefinition,
                      onParseDefinition: onParseDefinition,
                      onMergeDefinitions: onMergeDefinitions,
                      onApplyDefinition: onApplyDefinition,
                      onInitClass: onInitClass,
                      utils: {
                        documentValidate: documentValidate,
                        parseValidators: parseValidators
                      }
                    });
                  }.call(this, _module180);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "validator.js": function module(_require178, _exports178, _module181) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/validators/validator.js                                                        //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  let ValidationError;
                  _module181.link("meteor/mdg:validation-error", {
                    ValidationError(v) {
                      ValidationError = v;
                    }

                  }, 0);
                  let Validators;
                  _module181.link("./validators.js", {
                    default(v) {
                      Validators = v;
                    }

                  }, 1);

                  class Validator {
                    constructor(definition) {
                      this.name = definition.name;

                      if (definition.parseParam) {
                        this.parseParam = definition.parseParam;
                      }

                      if (definition.isValid) {
                        this.isValid = definition.isValid;
                      }

                      if (definition.validate) {
                        this.validate = definition.validate;
                      }

                      if (definition.resolveError) {
                        this.resolveError = definition.resolveError;
                      }
                    }

                    validate(_ref) {
                      let {
                        doc,
                        name,
                        nestedName,
                        value,
                        param,
                        resolveParam,
                        message,
                        resolveError
                      } = _ref;
                      // Get the class name, which will be used later for letting know what class
                      // thrown error.
                      const className = doc.constructor.getName(); // Resolve param is the "resolveParam" function is provided.

                      if (Match.test(resolveParam, Function)) {
                        param = resolveParam({
                          doc,
                          name,
                          nestedName,
                          value
                        });
                      } // Parse param type if validator has parsing function.


                      if (Match.test(this.parseParam, Function)) {
                        this.parseParam(param);
                      } // Prepare data for validation.


                      const args = {
                        className,
                        doc,
                        name,
                        nestedName,
                        value,
                        param,
                        validator: this.name
                      }; // Perform validation.

                      if (!this.isValid(args)) {
                        // Prepare function for throwing validation error.
                        const throwError = message => {
                          // Throw error only if the error message has been successfully
                          // generated.
                          if (!message) {
                            return;
                          } // Throw error.


                          throw new ValidationError([{
                            className,
                            type: this.name,
                            name,
                            nestedName,
                            value,
                            param,
                            message
                          }], message);
                        }; // Generate error message using the "resolveError" function if provided.


                        if (Match.test(resolveError, Function)) {
                          throwError(resolveError(args));
                        } // Get error message from the string if provided.


                        if (Match.test(message, String)) {
                          throwError(message);
                        } // Get error by executing a class level "resolveError" function.


                        let Class = doc.constructor;
                        let classResolveError = Class.getResolveError();

                        if (classResolveError instanceof Function) {
                          throwError(classResolveError(args));
                        } // Get default error message.


                        if (this.resolveError instanceof Function) {
                          throwError(this.resolveError(args));
                        }

                        throwError(ValidationError.DEFAULT_REASON);
                      }
                    }

                    static create(definition) {
                      let validator = new Validator(definition);
                      Validator.validators[validator.name] = validator; // Create a validation function.

                      return Validators[validator.name] = function (options) {
                        validator.validate(options);
                      };
                    }

                  }

                  ;
                  Validator.validators = {};
                  _module181.exportDefault(Validator);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "validators.js": function module(_require179, _exports179, _module182) {

                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //                                                                                                                    //
                  // packages/jagi_astronomy/lib/modules/validators/validators.js                                                       //
                  //                                                                                                                    //
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  //
                  const Validators = {};
                  _module182.exportDefault(Validators);
                  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                }, "class_prototype_methods": { "validate.js": function module(_require180, _exports180, _module183) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_prototype_methods/validate.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _defaults;

                    _module183.link("lodash/defaults", {
                      default(v) {
                        _defaults = v;
                      }

                    }, 0);

                    let _each;

                    _module183.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 1);
                    let castNested;
                    _module183.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 2);
                    let documentValidate;
                    _module183.link("../utils/document_validate", {
                      default(v) {
                        documentValidate = v;
                      }

                    }, 3);
                    let callMeteorMethod;
                    _module183.link("../../storage/utils/call_meteor_method", {
                      default(v) {
                        callMeteorMethod = v;
                      }

                    }, 4);

                    function validate() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let callback = arguments.length > 1 ? arguments[1] : undefined;
                      const doc = this;
                      const Class = doc.constructor;
                      const Collection = Class.getCollection();
                      let connection = Collection && Collection._connection;

                      if (!connection && (!Collection || !Collection._name)) {
                        connection = Meteor.connection;
                      } // If the first argument is callback function then reassign values.


                      if (arguments.length === 1 && Match.test(options, Function)) {
                        callback = options;
                        options = {};
                      } // Set default options.


                      _defaults(options, {
                        fields: Class.getValidationOrder(),
                        modified: false,
                        stopOnFirstError: true,
                        simulation: true
                      }); // If a fields property is a string then put it into array.


                      if (Match.test(options.fields, String)) {
                        options.fields = [options.fields];
                      } // Cast all fields.


                      if (options.cast) {
                        _each(Class.getFields(), field => {
                          doc[field.name] = field.castValue(doc[field.name], {
                            clone: false,
                            cast: true
                          });
                        });
                      } // Cast only nested fields.
                      else {
                          castNested({
                            doc,
                            options: {
                              clone: false
                            }
                          });
                        } // Prepare arguments for meteor method and utility.


                      let methodArgs = {
                        doc,
                        fields: options.fields,
                        modified: options.modified,
                        stopOnFirstError: options.stopOnFirstError,
                        simulation: options.simulation
                      }; // If we are dealing with a remote collection and we are not on the server.

                      if (connection && connection !== Meteor.server) {
                        // Prepare arguments for meteor method.
                        let methodName = '/Astronomy/validate';

                        try {
                          // Run Meteor method.
                          return callMeteorMethod(Class, methodName, [methodArgs], callback);
                        } // Catch stub exceptions.
                        catch (err) {
                          if (callback) {
                            callback(err);
                            return null;
                          }

                          throw err;
                        }
                      } // If we can just validate a document without calling the meteor method. We
                      // may be on the server or the collection may be local.


                      try {
                        // Validate a document.
                        let result = documentValidate(methodArgs);

                        if (callback) {
                          callback();
                        }

                        return result;
                      } catch (err) {
                        if (callback) {
                          callback(err);
                          return null;
                        }

                        throw err;
                      }
                    }

                    _module183.exportDefault(validate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "validate_all.js": function module(_require181, _exports181, _module184) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_prototype_methods/validate_all.js                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _extend;

                    _module184.link("lodash/extend", {
                      default(v) {
                        _extend = v;
                      }

                    }, 0);

                    function validateAll() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let callback = arguments.length > 1 ? arguments[1] : undefined;
                      let doc = this;
                      let Class = doc.constructor; // If the first argument is callback function then reassign values.

                      if (arguments.length === 1 && Match.test(options, Function)) {
                        callback = options;
                        options = {};
                      }

                      _extend(options, {
                        fields: Class.getValidationOrder(),
                        stopOnFirstError: false
                      });

                      doc.validate(options, callback);
                    }

                    ;
                    _module184.exportDefault(validateAll);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "class_static_methods": { "getCheckPattern.js": function module(_require182, _exports182, _module185) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/getCheckPattern.js                             //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let Match;
                    _module185.link("meteor/check", {
                      Match(v) {
                        Match = v;
                      }

                    }, 0);
                    let ValidationError;
                    _module185.link("meteor/mdg:validation-error", {
                      ValidationError(v) {
                        ValidationError = v;
                      }

                    }, 1);

                    function getCheckPattern() {
                      const Class = this;
                      return Match.Where(function (doc) {
                        try {
                          doc.validate();
                        } catch (err) {
                          if (ValidationError.is(err)) {
                            const firstError = err.details[0];
                            const matchError = new Match.Error(firstError.message);
                            matchError.sanitizedError = err;
                            throw matchError;
                          } else {
                            throw err;
                          }
                        }

                        return true;
                      });
                    }

                    ;
                    _module185.exportDefault(getCheckPattern);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_resolve_error.js": function module(_require183, _exports183, _module186) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/get_resolve_error.js                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getResolveError() {
                      let Class = this;
                      return Class.schema.resolveError;
                    }

                    ;
                    _module186.exportDefault(getResolveError);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_validation_order.js": function module(_require184, _exports184, _module187) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/get_validation_order.js                        //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _difference;

                    _module187.link("lodash/difference", {
                      default(v) {
                        _difference = v;
                      }

                    }, 0);

                    function getValidationOrder() {
                      let Class = this; // Get all validators.

                      let validators = Class.getValidators(); // Get fields names for defined validators.

                      let fieldsNames = Class.getFieldsNames(); // Make variable name shorter.

                      let validationOrder = Class.schema.validationOrder; // If there is a validation order provided, then combine fields provided in
                      // the validation order with the order of validators.

                      if (validationOrder) {
                        // Detect what fields are not present in the validation order.
                        let diff = _difference(fieldsNames, validationOrder); // Combine validation order with fields that left.


                        return validationOrder.concat(diff);
                      } // If there is no validation order, then just return fields names in the order
                      // in which validators were defined.
                      else {
                          return fieldsNames;
                        }
                    }

                    ;
                    _module187.exportDefault(getValidationOrder);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "get_validators.js": function module(_require185, _exports185, _module188) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/get_validators.js                              //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function getValidators(fieldName) {
                      let Class = this;

                      if (!Match.test(fieldName, Match.Optional(String))) {
                        throw TypeError('The first argument of the "getValidators" function has to be a string ' + 'or left empty');
                      }

                      if (fieldName) {
                        return Class.schema.validators[fieldName];
                      } else {
                        return Class.schema.validators;
                      }
                    }

                    ;
                    _module188.exportDefault(getValidators);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "validate.js": function module(_require186, _exports186, _module189) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/validate.js                                    //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _tail;

                    _module189.link("lodash/tail", {
                      default(v) {
                        _tail = v;
                      }

                    }, 0);

                    function validate(rawDoc) {
                      const Class = this;
                      const doc = new Class(rawDoc);

                      const args = _tail(arguments);

                      return doc.validate.apply(doc, args);
                    }

                    ;
                    _module189.exportDefault(validate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "validateAll.js": function module(_require187, _exports187, _module190) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/class_static_methods/validateAll.js                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _tail;

                    _module190.link("lodash/tail", {
                      default(v) {
                        _tail = v;
                      }

                    }, 0);

                    function validateAll(rawDoc) {
                      const Class = this;
                      const doc = new Class(rawDoc);

                      const args = _tail(arguments);

                      return doc.validateAll.apply(doc, args);
                    }

                    ;
                    _module190.exportDefault(validateAll);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "hooks": { "apply_definition.js": function module(_require188, _exports188, _module191) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/apply_definition.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module191.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _zipObject;

                    _module191.link("lodash/zipObject", {
                      default(v) {
                        _zipObject = v;
                      }

                    }, 1);
                    let hasMeteorMethod;
                    _module191.link("../../storage/utils/has_meteor_method.js", {
                      default(v) {
                        hasMeteorMethod = v;
                      }

                    }, 2);
                    let meteorValidate;
                    _module191.link("../meteor_methods/validate.js", {
                      default(v) {
                        meteorValidate = v;
                      }

                    }, 3);

                    function onApplyDefinition(Class, parsedDefinition, className) {
                      _each(parsedDefinition.validators, function (validators, fieldName) {
                        Class.schema.validators[fieldName] = Class.schema.validators[fieldName] || [];

                        _each(validators, function (validator) {
                          Class.schema.validators[fieldName] = Class.schema.validators[fieldName].concat(validator);
                        });
                      }); // Add the "/Astronomy/validate" meteor method only when a class has assigned
                      // collection.


                      let Collection = Class.getCollection(); // If it's a remote collection then we register methods on the connection
                      // object of the collection.

                      let connection = Collection && Collection._connection; // If it's not a remote collection than use main Meteor connection.

                      if (!connection && (!Collection || !Collection._name)) {
                        connection = Meteor.connection || Meteor.server;
                      }

                      if (connection) {
                        // Prepare meteor methods to be added.
                        let meteorMethods = {
                          '/Astronomy/validate': meteorValidate
                        };

                        _each(meteorMethods, (meteorMethod, methodName) => {
                          if (!hasMeteorMethod(connection, methodName)) {
                            // Add meteor method.
                            connection.methods(_zipObject([methodName], [meteorMethod]));
                          }
                        });
                      }

                      Class.schema.resolveError = parsedDefinition.resolveError;
                    }

                    ;
                    _module191.exportDefault(onApplyDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_class.js": function module(_require189, _exports189, _module192) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/init_class.js                                                 //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let getResolveError;
                    _module192.link("../class_static_methods/get_resolve_error.js", {
                      default(v) {
                        getResolveError = v;
                      }

                    }, 0);
                    let getValidationOrder;
                    _module192.link("../class_static_methods/get_validation_order.js", {
                      default(v) {
                        getValidationOrder = v;
                      }

                    }, 1);
                    let getValidators;
                    _module192.link("../class_static_methods/get_validators.js", {
                      default(v) {
                        getValidators = v;
                      }

                    }, 2);
                    let validateStatic;
                    _module192.link("../class_static_methods/validate.js", {
                      default(v) {
                        validateStatic = v;
                      }

                    }, 3);
                    let validateAllStatic;
                    _module192.link("../class_static_methods/validateAll.js", {
                      default(v) {
                        validateAllStatic = v;
                      }

                    }, 4);
                    let getCheckPatternStatic;
                    _module192.link("../class_static_methods/getCheckPattern.js", {
                      default(v) {
                        getCheckPatternStatic = v;
                      }

                    }, 5);
                    let validate;
                    _module192.link("../class_prototype_methods/validate.js", {
                      default(v) {
                        validate = v;
                      }

                    }, 6);
                    let validateAll;
                    _module192.link("../class_prototype_methods/validate_all.js", {
                      default(v) {
                        validateAll = v;
                      }

                    }, 7);

                    function onInitClass(Class, className) {
                      // Class static methods.
                      Class.getResolveError = getResolveError;
                      Class.getValidationOrder = getValidationOrder;
                      Class.getValidators = getValidators;
                      Class.validate = validateStatic;
                      Class.validateAll = validateAllStatic;
                      Class.getCheckPattern = getCheckPatternStatic; // Class prototype methods.

                      Class.prototype.validate = validate;
                      Class.prototype.validateAll = validateAll;
                    }

                    ;
                    _module192.exportDefault(onInitClass);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_definition.js": function module(_require190, _exports190, _module193) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/init_definition.js                                            //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitDefinition(definition, className) {
                      definition.validators = {};
                      definition.resolveError = undefined;
                    }

                    ;
                    _module193.exportDefault(onInitDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "init_schema.js": function module(_require191, _exports191, _module194) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/init_schema.js                                                //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    function onInitSchema(schema, className) {
                      schema.validators = {};
                      schema.resolveError = undefined;
                    }

                    ;
                    _module194.exportDefault(onInitSchema);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "merge_definitions.js": function module(_require192, _exports192, _module195) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/merge_definitions.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module195.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    function onMergeDefinitions(targetDefinition, sourceDefinition, ClassName) {
                      _each(sourceDefinition.validators, function (validators, fieldName) {
                        targetDefinition.validators[fieldName] = targetDefinition.validators[fieldName] || [];
                        targetDefinition.validators[fieldName] = targetDefinition.validators[fieldName].concat(validators);
                      });

                      targetDefinition.resolveError = sourceDefinition.resolveError;
                    }

                    ;
                    _module195.exportDefault(onMergeDefinitions);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_definition.js": function module(_require193, _exports193, _module196) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/hooks/parse_definition.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module196.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _has;

                    _module196.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 1);
                    let throwParseError;
                    _module196.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 2);
                    let parseValidators;
                    _module196.link("../utils/parse_validators.js", {
                      default(v) {
                        parseValidators = v;
                      }

                    }, 3);

                    function onParseDefinition(parsedDefinition, definition, className) {
                      if (definition.resolveError) {
                        if (!Match.test(definition.resolveError, Function)) {
                          throwParseError([{
                            'class': className
                          }, {
                            'property': 'resolveError'
                          }, 'Property values has to be a function']);
                        }

                        parsedDefinition.resolveError = definition.resolveError;
                      }

                      if (definition.fields) {
                        _each(definition.fields, function (fieldDefinition, fieldName) {
                          if (_has(fieldDefinition, 'validators')) {
                            parseValidators(fieldDefinition.validators, [{
                              'class': className
                            }, {
                              'property': 'fields'
                            }, {
                              'field': fieldName
                            }, {
                              'property': 'validators'
                            }]);
                            parsedDefinition.validators[fieldName] = fieldDefinition.validators;
                            fieldDefinition.validators = undefined;
                          }
                        });
                      }

                      if (definition.validators) {
                        _each(definition.validators, function (validators, fieldName) {
                          parseValidators(validators, [{
                            'class': className
                          }, {
                            'property': 'validators'
                          }]);
                          parsedDefinition.validators[fieldName] = validators;
                        });
                      }
                    }

                    ;
                    _module196.exportDefault(onParseDefinition);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "meteor_methods": { "validate.js": function module(_require194, _exports194, _module197) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/meteor_methods/validate.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let documentValidate;
                    _module197.link("../utils/document_validate.js", {
                      default(v) {
                        documentValidate = v;
                      }

                    }, 0);
                    let check, Match;
                    _module197.link("meteor/check", {
                      check(v) {
                        check = v;
                      },

                      Match(v) {
                        Match = v;
                      }

                    }, 1);

                    function validate(options) {
                      check(options, Match.Any);
                      return documentValidate(options);
                    }

                    ;
                    _module197.exportDefault(validate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "utils": { "document_validate.js": function module(_require195, _exports195, _module198) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/utils/document_validate.js                                          //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module198.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _intersection;

                    _module198.link("lodash/intersection", {
                      default(v) {
                        _intersection = v;
                      }

                    }, 1);

                    let _isNil;

                    _module198.link("lodash/isNil", {
                      default(v) {
                        _isNil = v;
                      }

                    }, 2);
                    let AstroClass;
                    _module198.link("../../../core/class", {
                      default(v) {
                        AstroClass = v;
                      }

                    }, 3);
                    let throwParseError;
                    _module198.link("../../core/utils/throw_parse_error", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 4);
                    let castNested;
                    _module198.link("../../fields/utils/castNested", {
                      default(v) {
                        castNested = v;
                      }

                    }, 5);
                    let isNestedFieldName;
                    _module198.link("../../fields/utils/isNestedFieldName", {
                      default(v) {
                        isNestedFieldName = v;
                      }

                    }, 6);
                    let traverse;
                    _module198.link("../../fields/utils/traverse", {
                      default(v) {
                        traverse = v;
                      }

                    }, 7);
                    let ObjectField;
                    _module198.link("../../fields/ObjectField", {
                      default(v) {
                        ObjectField = v;
                      }

                    }, 8);
                    let ListField;
                    _module198.link("../../fields/ListField", {
                      default(v) {
                        ListField = v;
                      }

                    }, 9);
                    let Validators;
                    _module198.link("../validators", {
                      default(v) {
                        Validators = v;
                      }

                    }, 10);
                    let ValidationError;
                    _module198.link("meteor/mdg:validation-error", {
                      ValidationError(v) {
                        ValidationError = v;
                      }

                    }, 11);

                    function documentValidate() {
                      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                      let {
                        doc,
                        fields,
                        modified = false,
                        prefix = '',
                        stopOnFirstError = true,
                        simulation = true
                      } = options; // Stop execution, if we are not on the server, when the "simulation" flag is
                      // not set.

                      if (!simulation && !Meteor.isServer) {
                        return;
                      }

                      let Class = doc.constructor; // Cast nested fields.

                      castNested({
                        doc,
                        options: {
                          clone: false
                        }
                      }); // Prepare array for storing errors list.

                      let errors = []; // Helper function for catching and collecting errors.

                      const catchValidationError = func => {
                        try {
                          func();
                        } catch (err) {
                          // If it's ValidationError.
                          if (ValidationError.is(err)) {
                            // If we stop on first error then just throw error again.
                            if (stopOnFirstError) {
                              throw err;
                            } // Otherwise we collect errors.
                            else {
                                _each(err.details, details => {
                                  errors.push(details);
                                });
                              }
                          } // It it's not ValidationError, then we throw error again.
                          else {
                              throw err;
                            }
                        }
                      }; // If no fields were passed to validation, then we pick default validation
                      // order.


                      if (!fields) {
                        fields = Class.getValidationOrder();
                      } // Validate only modified fields.


                      if (modified && Class.getCollection()) {
                        fields = _intersection(fields, doc.getModified());
                      }

                      _each(fields, name => {
                        // If it is a nested field pattern name then we have to look for the most
                        // nested document and validate the nested field.
                        if (isNestedFieldName(name)) {
                          traverse(doc, name, (nestedDoc, nestedName, field) => {
                            catchValidationError(() => {
                              documentValidate({
                                doc: nestedDoc,
                                fields: [nestedName],
                                prefix: prefix + name.substr(0, name.lastIndexOf(nestedName)),
                                stopOnFirstError,
                                simulation
                              });
                            });
                          });
                          return;
                        }

                        let field = Class.getField(name); // Move to the next one if a field does not exist.

                        if (!field) {
                          return;
                        } // We do not validate transient fields.


                        if (field.transient) {
                          return;
                        } // Get value of the field.


                        let value = doc.get(name); // If a field is optional and value is undefined then we do not validate.

                        if (field.getOptional(doc) && _isNil(value)) {
                          return;
                        } // Execute validation in the try-catch block. That's because we want to
                        // continue validation if the "stopOnFirstError" flag is set to false.


                        catchValidationError(() => {
                          // First, execute type level validators.
                          field.validate({
                            doc,
                            name: prefix + name,
                            nestedName: name,
                            value
                          }); // Get validators for a given field.

                          let validators = Class.getValidators(name);

                          _each(validators, _ref => {
                            let {
                              type,
                              param,
                              resolveParam,
                              message,
                              resolveError
                            } = _ref;
                            // Get validation helper function.
                            let validationFunction = Validators[type]; // Execute single validator.

                            validationFunction({
                              doc,
                              name: prefix + name,
                              nestedName: name,
                              value,
                              param,
                              resolveParam,
                              message,
                              resolveError
                            });
                          });
                        }); // If it is the object field then validate it.

                        if (field instanceof ObjectField) {
                          if (value instanceof AstroClass) {
                            catchValidationError(() => {
                              documentValidate({
                                doc: value,
                                fields: value.constructor.getValidationOrder(),
                                prefix: prefix + field.name + '.',
                                stopOnFirstError
                              });
                            });
                          }
                        } // If it is the list field then validate each one.
                        else if (field instanceof ListField && field.isClass) {
                            _each(value, (element, index) => {
                              if (element instanceof AstroClass) {
                                catchValidationError(() => {
                                  documentValidate({
                                    doc: element,
                                    fields: element.constructor.getValidationOrder(),
                                    prefix: prefix + field.name + '.' + index + '.',
                                    stopOnFirstError
                                  });
                                });
                              }
                            });
                          }
                      }); // If we have not thrown any error yet then it means that there are no errors
                      // or we do not throw on the first error.


                      if (errors.length > 0) {
                        throw new ValidationError(errors, errors[0].message);
                      }
                    }

                    ;
                    _module198.exportDefault(documentValidate);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  }, "parse_validators.js": function module(_require196, _exports196, _module199) {

                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //                                                                                                                    //
                    // packages/jagi_astronomy/lib/modules/validators/utils/parse_validators.js                                           //
                    //                                                                                                                    //
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    //
                    let _each;

                    _module199.link("lodash/each", {
                      default(v) {
                        _each = v;
                      }

                    }, 0);

                    let _has;

                    _module199.link("lodash/has", {
                      default(v) {
                        _has = v;
                      }

                    }, 1);

                    let _union;

                    _module199.link("lodash/union", {
                      default(v) {
                        _union = v;
                      }

                    }, 2);
                    let throwParseError;
                    _module199.link("../../core/utils/throw_parse_error.js", {
                      default(v) {
                        throwParseError = v;
                      }

                    }, 3);
                    let Validators;
                    _module199.link("../validators.js", {
                      default(v) {
                        Validators = v;
                      }

                    }, 4);
                    const validatorsPattern = [{
                      type: String,
                      param: Match.Optional(Match.Any),
                      resolveParam: Match.Optional(Function),
                      message: Match.Optional(String),
                      resolveError: Match.Optional(Function)
                    }];

                    function parseValidators(validators, parseContext) {
                      // Validators list is an array of object that should include at least the
                      // "type" property.
                      if (validators && !Match.test(validators, validatorsPattern)) {
                        throwParseError(_union(parseContext, ['Validators definition has to be an array of objects']));
                      }

                      _each(validators, function (validator) {
                        // Check if a validator of a given type exists.
                        if (!_has(Validators, validator.type)) {
                          throwParseError(_union(parseContext, ["There is no \"".concat(validator.type, "\" validator")]));
                        }
                      });
                    }

                    ;
                    _module199.exportDefault(parseValidators);
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                  } }, "validators": { "comparison": { "choice.js": function module(_require197, _exports197, _module200) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/comparison/choice.js                                     //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _includes;

                      _module200.link("lodash/includes", {
                        default(v) {
                          _includes = v;
                        }

                      }, 0);
                      let Validator;
                      _module200.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'choice',

                        parseParam(param) {
                          if (!Match.test(param, [Match.Any])) {
                            throw new TypeError("Parameter for the \"choice\" validator has to be an array of values");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return _includes(param, value);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          var choices = param.join(', ');
                          return "\"".concat(name, "\" has to be one of the values ").concat(choices);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "email.js": function module(_require198, _exports198, _module201) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/comparison/email.js                                      //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module201.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      // The e-mail address regular expression from http://emailregex.com/.
                      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      Validator.create({
                        name: 'email',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return re.test(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" should be a valid email address");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "equal.js": function module(_require199, _exports199, _module202) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/comparison/equal.js                                      //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module202.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'equal',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return EJSON.equals(value, param);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" should be equal ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "not_equal.js": function module(_require200, _exports200, _module203) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/comparison/not_equal.js                                  //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module203.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'notEqual',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return !EJSON.equals(value, param);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" should not to be equal ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "regexp.js": function module(_require201, _exports201, _module204) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/comparison/regexp.js                                     //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module204.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'regexp',

                        parseParam(param) {
                          if (!Match.test(param, RegExp)) {
                            throw new TypeError("Parameter for the \"regexp\" validator has to be a regular expression");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return param.test(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" does not match the \"").concat(param.toString(), "\" regular expression");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } }, "existence": { "not_null.js": function module(_require202, _exports202, _module205) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/existence/not_null.js                                    //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module205.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'notNull',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return value !== null;
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" should not be null");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "null.js": function module(_require203, _exports203, _module206) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/existence/null.js                                        //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module206.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'null',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return value === null;
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" should be null");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "required.js": function module(_require204, _exports204, _module207) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/existence/required.js                                    //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module207.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'required',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return value !== null && value !== undefined;
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" is required");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } }, "logical": { "and.js": function module(_require205, _exports205, _module208) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/logical/and.js                                           //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _each;

                      _module208.link("lodash/each", {
                        default(v) {
                          _each = v;
                        }

                      }, 0);
                      let parseValidators;
                      _module208.link("../../utils/parse_validators.js", {
                        default(v) {
                          parseValidators = v;
                        }

                      }, 1);
                      let Validator;
                      _module208.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 2);
                      let Validators;
                      _module208.link("../../validators.js", {
                        default(v) {
                          Validators = v;
                        }

                      }, 3);
                      Validator.create({
                        name: 'and',

                        parseParam(param) {
                          parseValidators(param);
                        },

                        validate(_ref) {
                          let {
                            doc,
                            name,
                            value,
                            param: validators
                          } = _ref;

                          _each(validators, function (validator) {
                            // Get validator.
                            const validationFunction = Validators[validator.type]; // Execute single validator.

                            validationFunction({
                              doc,
                              name,
                              value,
                              param: validator.param
                            });
                          });
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "or.js": function module(_require206, _exports206, _module209) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/logical/or.js                                            //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _some;

                      _module209.link("lodash/some", {
                        default(v) {
                          _some = v;
                        }

                      }, 0);
                      let parseValidators;
                      _module209.link("../../utils/parse_validators.js", {
                        default(v) {
                          parseValidators = v;
                        }

                      }, 1);
                      let Validator;
                      _module209.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 2);
                      let Validators;
                      _module209.link("../../validators.js", {
                        default(v) {
                          Validators = v;
                        }

                      }, 3);
                      let ValidationError;
                      _module209.link("meteor/mdg:validation-error", {
                        ValidationError(v) {
                          ValidationError = v;
                        }

                      }, 4);
                      Validator.create({
                        name: 'or',

                        parseParam(param) {
                          parseValidators(param);
                        },

                        validate(_ref) {
                          let {
                            doc,
                            name,
                            value,
                            param: validators
                          } = _ref;
                          let firstError;

                          const isValid = _some(validators, function (validator) {
                            // Get validator.
                            const validationFunction = Validators[validator.type]; // Execute single validator.

                            try {
                              validationFunction({
                                doc,
                                name,
                                value,
                                param: validator.param
                              });
                              return true;
                            } catch (err) {
                              if (ValidationError.is(err)) {
                                // Collect only the first error that occured.
                                if (!firstError) {
                                  firstError = err;
                                }

                                return false;
                              } else {
                                throw err;
                              }
                            }
                          });

                          if (!isValid) {
                            throw firstError;
                          }
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } }, "nested": { "every.js": function module(_require207, _exports207, _module210) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/nested/every.js                                          //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _each;

                      _module210.link("lodash/each", {
                        default(v) {
                          _each = v;
                        }

                      }, 0);

                      let _isArray;

                      _module210.link("lodash/isArray", {
                        default(v) {
                          _isArray = v;
                        }

                      }, 1);
                      let parseValidators;
                      _module210.link("../../utils/parse_validators.js", {
                        default(v) {
                          parseValidators = v;
                        }

                      }, 2);
                      let Validator;
                      _module210.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 3);
                      let Validators;
                      _module210.link("../../validators.js", {
                        default(v) {
                          Validators = v;
                        }

                      }, 4);
                      Validator.create({
                        name: 'every',

                        parseParam(param) {
                          parseValidators(param);
                        },

                        validate(_ref) {
                          let {
                            doc,
                            name,
                            nestedName,
                            value,
                            param: validators
                          } = _ref;

                          if (!_isArray(value)) {
                            throw new TypeError("The \"every\" validator can only work with arrays");
                          } // Execute validators for each array element.


                          _each(value, function (element, index) {
                            // Execute each validator.
                            _each(validators, function (validator) {
                              // Get validator.
                              const validationFunction = Validators[validator.type]; // Execute single validator.

                              validationFunction({
                                doc,
                                name: "".concat(name, ".").concat(index),
                                nestedName: "".concat(nestedName, ".").concat(index),
                                value: element,
                                param: validator.param
                              });
                            });
                          });
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "has.js": function module(_require208, _exports208, _module211) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/nested/has.js                                            //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isObject;

                      _module211.link("lodash/isObject", {
                        default(v) {
                          _isObject = v;
                        }

                      }, 0);

                      let _has;

                      _module211.link("lodash/has", {
                        default(v) {
                          _has = v;
                        }

                      }, 1);
                      let Validator;
                      _module211.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 2);
                      Validator.create({
                        name: 'has',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;

                          if (!_isObject(value)) {
                            throw new TypeError("The \"has\" validator can only work with objects");
                          }

                          return _has(value, param);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "The \"".concat(name, "\" field does not have the \"").concat(param, "\" property");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "includes.js": function module(_require209, _exports209, _module212) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/nested/includes.js                                       //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _includes;

                      _module212.link("lodash/includes", {
                        default(v) {
                          _includes = v;
                        }

                      }, 0);

                      let _isArray;

                      _module212.link("lodash/isArray", {
                        default(v) {
                          _isArray = v;
                        }

                      }, 1);

                      let _isObject;

                      _module212.link("lodash/isObject", {
                        default(v) {
                          _isObject = v;
                        }

                      }, 2);
                      let Validator;
                      _module212.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 3);
                      Validator.create({
                        name: 'includes',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;

                          if (!_isArray(value) && !_isObject(value)) {
                            throw new TypeError("The \"includes\" validator can only work with arrays and objects");
                          }

                          return _includes(value, param);
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "The \"".concat(name, "\" field does not contain the \"").concat(param, "\" value");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } }, "size": { "gt.js": function module(_require210, _exports210, _module213) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/gt.js                                               //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module213.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'gt',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return value > param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" has to be greater than ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "gte.js": function module(_require211, _exports211, _module214) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/gte.js                                              //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module214.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'gte',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return value >= param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" has to be greater than or equal ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "length.js": function module(_require212, _exports212, _module215) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/length.js                                           //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _has;

                      _module215.link("lodash/has", {
                        default(v) {
                          _has = v;
                        }

                      }, 0);
                      let Validator;
                      _module215.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'length',

                        parseParam(param) {
                          if (!Match.test(param, Number)) {
                            throw new TypeError("Parameter for the \"length\" validator has to be a number");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;

                          if (!_has(value, 'length')) {
                            throw new TypeError("Length of the value can not be measured");
                          }

                          return value.length === param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "Length of \"".concat(name, "\" has to be ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "lt.js": function module(_require213, _exports213, _module216) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/lt.js                                               //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module216.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'lt',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return value < param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" has to be less than ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "lte.js": function module(_require214, _exports214, _module217) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/lte.js                                              //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module217.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'lte',

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;
                          return value <= param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "\"".concat(name, "\" has to be less than or equal ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "max_length.js": function module(_require215, _exports215, _module218) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/max_length.js                                       //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _has;

                      _module218.link("lodash/has", {
                        default(v) {
                          _has = v;
                        }

                      }, 0);
                      let Validator;
                      _module218.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'maxLength',

                        parseParam(param) {
                          if (!Match.test(param, Number)) {
                            throw new TypeError("Parameter for the \"maxLength\" validator has to be a number");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;

                          if (!_has(value, 'length')) {
                            return false;
                          }

                          return value.length <= param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "Length of \"".concat(name, "\" has to be at most ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "min_length.js": function module(_require216, _exports216, _module219) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/size/min_length.js                                       //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _has;

                      _module219.link("lodash/has", {
                        default(v) {
                          _has = v;
                        }

                      }, 0);
                      let Validator;
                      _module219.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'minLength',

                        parseParam(param) {
                          if (!Match.test(param, Number)) {
                            throw new TypeError("Parameter for the \"minLength\" validator has to be a number");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param
                          } = _ref;

                          if (!_has(value, 'length')) {
                            return false;
                          }

                          return value.length >= param;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param
                          } = _ref2;
                          return "Length of \"".concat(name, "\" has to be at least ").concat(param);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } }, "type": { "array.js": function module(_require217, _exports217, _module220) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/array.js                                            //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isArray;

                      _module220.link("lodash/isArray", {
                        default(v) {
                          _isArray = v;
                        }

                      }, 0);
                      let Validator;
                      _module220.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'array',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return _isArray(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be an array");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "boolean.js": function module(_require218, _exports218, _module221) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/boolean.js                                          //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module221.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'boolean',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return typeof value === 'boolean';
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be a boolean");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "class.js": function module(_require219, _exports219, _module222) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/class.js                                            //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module222.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      let AstroClass;
                      _module222.link("../../../../core/class.js", {
                        default(v) {
                          AstroClass = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'class',

                        parseParam(param) {
                          if (!AstroClass.isParentOf(param)) {
                            throw new TypeError("Parameter for the \"class\" validator has to be an Astronomy class");
                          }
                        },

                        isValid(_ref) {
                          let {
                            value,
                            param: Class
                          } = _ref;
                          return value instanceof Class;
                        },

                        resolveError(_ref2) {
                          let {
                            name,
                            param: Class
                          } = _ref2;
                          let className = Class.getName();
                          return "\"".concat(name, "\" has to be ").concat(className);
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "date.js": function module(_require220, _exports220, _module223) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/date.js                                             //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isDate;

                      _module223.link("lodash/isDate", {
                        default(v) {
                          _isDate = v;
                        }

                      }, 0);
                      let Validator;
                      _module223.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'date',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return _isDate(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be a date");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "integer.js": function module(_require221, _exports221, _module224) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/integer.js                                          //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isInteger;

                      _module224.link("lodash/isInteger", {
                        default(v) {
                          _isInteger = v;
                        }

                      }, 0);
                      let Validator;
                      _module224.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'integer',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return _isInteger(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be an integer");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "mongo_object_id.js": function module(_require222, _exports222, _module225) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/mongo_object_id.js                                  //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module225.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      let Match;
                      _module225.link("meteor/check", {
                        Match(v) {
                          Match = v;
                        }

                      }, 1);
                      let Mongo;
                      _module225.link("meteor/mongo", {
                        Mongo(v) {
                          Mongo = v;
                        }

                      }, 2);
                      Validator.create({
                        name: 'mongoObjectID',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return Match.test(value, Mongo.ObjectID);
                          ;
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be a Mongo.ObjectID");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "number.js": function module(_require223, _exports223, _module226) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/number.js                                           //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isNaN;

                      _module226.link("lodash/isNaN", {
                        default(v) {
                          _isNaN = v;
                        }

                      }, 0);

                      let _isNumber;

                      _module226.link("lodash/isNumber", {
                        default(v) {
                          _isNumber = v;
                        }

                      }, 1);
                      let Validator;
                      _module226.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 2);
                      Validator.create({
                        name: 'number',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return !_isNaN(value) && _isNumber(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be a number");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "object.js": function module(_require224, _exports224, _module227) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/object.js                                           //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let _isObject;

                      _module227.link("lodash/isObject", {
                        default(v) {
                          _isObject = v;
                        }

                      }, 0);
                      let Validator;
                      _module227.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 1);
                      Validator.create({
                        name: 'object',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return _isObject(value);
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be an object");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    }, "string.js": function module(_require225, _exports225, _module228) {

                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //                                                                                                                    //
                      // packages/jagi_astronomy/lib/modules/validators/validators/type/string.js                                           //
                      //                                                                                                                    //
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      //
                      let Validator;
                      _module228.link("../../validator.js", {
                        default(v) {
                          Validator = v;
                        }

                      }, 0);
                      Validator.create({
                        name: 'string',

                        isValid(_ref) {
                          let {
                            value
                          } = _ref;
                          return typeof value === 'string';
                        },

                        resolveError(_ref2) {
                          let {
                            name
                          } = _ref2;
                          return "\"".concat(name, "\" has to be a string");
                        }

                      });
                      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    } } } } } }, "node_modules": { "lodash": { "concat.js": function module(_require226, _exports226, _module229) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/concat.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayPush = _require226('./_arrayPush'),
                    baseFlatten = _require226('./_baseFlatten'),
                    copyArray = _require226('./_copyArray'),
                    isArray = _require226('./isArray');

                /**
                 * Creates a new array concatenating `array` with any additional arrays
                 * and/or values.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Array
                 * @param {Array} array The array to concatenate.
                 * @param {...*} [values] The values to concatenate.
                 * @returns {Array} Returns the new concatenated array.
                 * @example
                 *
                 * var array = [1];
                 * var other = _.concat(array, 2, [3], [[4]]);
                 *
                 * console.log(other);
                 * // => [1, 2, 3, [4]]
                 *
                 * console.log(array);
                 * // => [1]
                 */
                function concat() {
                  var length = arguments.length;
                  if (!length) {
                    return [];
                  }
                  var args = Array(length - 1),
                      array = arguments[0],
                      index = length;

                  while (index--) {
                    args[index - 1] = arguments[index];
                  }
                  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
                }

                _module229.exports = concat;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayPush.js": function module(_require227, _exports227, _module230) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayPush.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Appends the elements of `values` to `array`.
                 *
                 * @private
                 * @param {Array} array The array to modify.
                 * @param {Array} values The values to append.
                 * @returns {Array} Returns `array`.
                 */
                function arrayPush(array, values) {
                  var index = -1,
                      length = values.length,
                      offset = array.length;

                  while (++index < length) {
                    array[offset + index] = values[index];
                  }
                  return array;
                }

                _module230.exports = arrayPush;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseFlatten.js": function module(_require228, _exports228, _module231) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseFlatten.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayPush = _require228('./_arrayPush'),
                    isFlattenable = _require228('./_isFlattenable');

                /**
                 * The base implementation of `_.flatten` with support for restricting flattening.
                 *
                 * @private
                 * @param {Array} array The array to flatten.
                 * @param {number} depth The maximum recursion depth.
                 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
                 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
                 * @param {Array} [result=[]] The initial result value.
                 * @returns {Array} Returns the new flattened array.
                 */
                function baseFlatten(array, depth, predicate, isStrict, result) {
                  var index = -1,
                      length = array.length;

                  predicate || (predicate = isFlattenable);
                  result || (result = []);

                  while (++index < length) {
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                      if (depth > 1) {
                        // Recursively flatten arrays (susceptible to call stack limits).
                        baseFlatten(value, depth - 1, predicate, isStrict, result);
                      } else {
                        arrayPush(result, value);
                      }
                    } else if (!isStrict) {
                      result[result.length] = value;
                    }
                  }
                  return result;
                }

                _module231.exports = baseFlatten;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isFlattenable.js": function module(_require229, _exports229, _module232) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isFlattenable.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require229('./_Symbol'),
                    isArguments = _require229('./isArguments'),
                    isArray = _require229('./isArray');

                /** Built-in value references. */
                var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

                /**
                 * Checks if `value` is a flattenable `arguments` object or array.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
                 */
                function isFlattenable(value) {
                  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
                }

                _module232.exports = isFlattenable;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Symbol.js": function module(_require230, _exports230, _module233) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Symbol.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var root = _require230('./_root');

                /** Built-in value references. */
                var Symbol = root.Symbol;

                _module233.exports = Symbol;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_root.js": function module(_require231, _exports231, _module234) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_root.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var freeGlobal = _require231('./_freeGlobal');

                /** Detect free variable `self`. */
                var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

                /** Used as a reference to the global object. */
                var root = freeGlobal || freeSelf || Function('return this')();

                _module234.exports = root;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_freeGlobal.js": function module(_require232, _exports232, _module235) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_freeGlobal.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Detect free variable `global` from Node.js. */
                var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

                _module235.exports = freeGlobal;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isArguments.js": function module(_require233, _exports233, _module236) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isArguments.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsArguments = _require233('./_baseIsArguments'),
                    isObjectLike = _require233('./isObjectLike');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Built-in value references. */
                var propertyIsEnumerable = objectProto.propertyIsEnumerable;

                /**
                 * Checks if `value` is likely an `arguments` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                 *  else `false`.
                 * @example
                 *
                 * _.isArguments(function() { return arguments; }());
                 * // => true
                 *
                 * _.isArguments([1, 2, 3]);
                 * // => false
                 */
                var isArguments = baseIsArguments(function () {
                  return arguments;
                }()) ? baseIsArguments : function (value) {
                  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
                };

                _module236.exports = isArguments;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsArguments.js": function module(_require234, _exports234, _module237) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsArguments.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require234('./_baseGetTag'),
                    isObjectLike = _require234('./isObjectLike');

                /** `Object#toString` result references. */
                var argsTag = '[object Arguments]';

                /**
                 * The base implementation of `_.isArguments`.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
                 */
                function baseIsArguments(value) {
                  return isObjectLike(value) && baseGetTag(value) == argsTag;
                }

                _module237.exports = baseIsArguments;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseGetTag.js": function module(_require235, _exports235, _module238) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseGetTag.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require235('./_Symbol'),
                    getRawTag = _require235('./_getRawTag'),
                    objectToString = _require235('./_objectToString');

                /** `Object#toString` result references. */
                var nullTag = '[object Null]',
                    undefinedTag = '[object Undefined]';

                /** Built-in value references. */
                var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

                /**
                 * The base implementation of `getTag` without fallbacks for buggy environments.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the `toStringTag`.
                 */
                function baseGetTag(value) {
                  if (value == null) {
                    return value === undefined ? undefinedTag : nullTag;
                  }
                  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
                }

                _module238.exports = baseGetTag;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getRawTag.js": function module(_require236, _exports236, _module239) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getRawTag.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require236('./_Symbol');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Used to resolve the
                 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                 * of values.
                 */
                var nativeObjectToString = objectProto.toString;

                /** Built-in value references. */
                var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

                /**
                 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the raw `toStringTag`.
                 */
                function getRawTag(value) {
                  var isOwn = hasOwnProperty.call(value, symToStringTag),
                      tag = value[symToStringTag];

                  try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                  } catch (e) {}

                  var result = nativeObjectToString.call(value);
                  if (unmasked) {
                    if (isOwn) {
                      value[symToStringTag] = tag;
                    } else {
                      delete value[symToStringTag];
                    }
                  }
                  return result;
                }

                _module239.exports = getRawTag;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_objectToString.js": function module(_require237, _exports237, _module240) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_objectToString.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /**
                 * Used to resolve the
                 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
                 * of values.
                 */
                var nativeObjectToString = objectProto.toString;

                /**
                 * Converts `value` to a string using `Object.prototype.toString`.
                 *
                 * @private
                 * @param {*} value The value to convert.
                 * @returns {string} Returns the converted string.
                 */
                function objectToString(value) {
                  return nativeObjectToString.call(value);
                }

                _module240.exports = objectToString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isObjectLike.js": function module(_require238, _exports238, _module241) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isObjectLike.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is object-like. A value is object-like if it's not `null`
                 * and has a `typeof` result of "object".
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
                 * @example
                 *
                 * _.isObjectLike({});
                 * // => true
                 *
                 * _.isObjectLike([1, 2, 3]);
                 * // => true
                 *
                 * _.isObjectLike(_.noop);
                 * // => false
                 *
                 * _.isObjectLike(null);
                 * // => false
                 */
                function isObjectLike(value) {
                  return value != null && typeof value == 'object';
                }

                _module241.exports = isObjectLike;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isArray.js": function module(_require239, _exports239, _module242) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isArray.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is classified as an `Array` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
                 * @example
                 *
                 * _.isArray([1, 2, 3]);
                 * // => true
                 *
                 * _.isArray(document.body.children);
                 * // => false
                 *
                 * _.isArray('abc');
                 * // => false
                 *
                 * _.isArray(_.noop);
                 * // => false
                 */
                var isArray = Array.isArray;

                _module242.exports = isArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_copyArray.js": function module(_require240, _exports240, _module243) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_copyArray.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Copies the values of `source` to `array`.
                 *
                 * @private
                 * @param {Array} source The array to copy values from.
                 * @param {Array} [array=[]] The array to copy values to.
                 * @returns {Array} Returns `array`.
                 */
                function copyArray(source, array) {
                  var index = -1,
                      length = source.length;

                  array || (array = Array(length));
                  while (++index < length) {
                    array[index] = source[index];
                  }
                  return array;
                }

                _module243.exports = copyArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "defaults.js": function module(_require241, _exports241, _module244) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/defaults.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var apply = _require241('./_apply'),
                    assignInWith = _require241('./assignInWith'),
                    baseRest = _require241('./_baseRest'),
                    customDefaultsAssignIn = _require241('./_customDefaultsAssignIn');

                /**
                 * Assigns own and inherited enumerable string keyed properties of source
                 * objects to the destination object for all destination properties that
                 * resolve to `undefined`. Source objects are applied from left to right.
                 * Once a property is set, additional values of the same property are ignored.
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @see _.defaultsDeep
                 * @example
                 *
                 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                 * // => { 'a': 1, 'b': 2 }
                 */
                var defaults = baseRest(function (args) {
                  args.push(undefined, customDefaultsAssignIn);
                  return apply(assignInWith, undefined, args);
                });

                _module244.exports = defaults;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_apply.js": function module(_require242, _exports242, _module245) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_apply.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A faster alternative to `Function#apply`, this function invokes `func`
                 * with the `this` binding of `thisArg` and the arguments of `args`.
                 *
                 * @private
                 * @param {Function} func The function to invoke.
                 * @param {*} thisArg The `this` binding of `func`.
                 * @param {Array} args The arguments to invoke `func` with.
                 * @returns {*} Returns the result of `func`.
                 */
                function apply(func, thisArg, args) {
                  switch (args.length) {
                    case 0:
                      return func.call(thisArg);
                    case 1:
                      return func.call(thisArg, args[0]);
                    case 2:
                      return func.call(thisArg, args[0], args[1]);
                    case 3:
                      return func.call(thisArg, args[0], args[1], args[2]);
                  }
                  return func.apply(thisArg, args);
                }

                _module245.exports = apply;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "assignInWith.js": function module(_require243, _exports243, _module246) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/assignInWith.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require243('./_copyObject'),
                    createAssigner = _require243('./_createAssigner'),
                    keysIn = _require243('./keysIn');

                /**
                 * This method is like `_.assignIn` except that it accepts `customizer`
                 * which is invoked to produce the assigned values. If `customizer` returns
                 * `undefined`, assignment is handled by the method instead. The `customizer`
                 * is invoked with five arguments: (objValue, srcValue, key, object, source).
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @alias extendWith
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} sources The source objects.
                 * @param {Function} [customizer] The function to customize assigned values.
                 * @returns {Object} Returns `object`.
                 * @see _.assignWith
                 * @example
                 *
                 * function customizer(objValue, srcValue) {
                 *   return _.isUndefined(objValue) ? srcValue : objValue;
                 * }
                 *
                 * var defaults = _.partialRight(_.assignInWith, customizer);
                 *
                 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
                 * // => { 'a': 1, 'b': 2 }
                 */
                var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
                  copyObject(source, keysIn(source), object, customizer);
                });

                _module246.exports = assignInWith;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_copyObject.js": function module(_require244, _exports244, _module247) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_copyObject.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assignValue = _require244('./_assignValue'),
                    baseAssignValue = _require244('./_baseAssignValue');

                /**
                 * Copies properties of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy properties from.
                 * @param {Array} props The property identifiers to copy.
                 * @param {Object} [object={}] The object to copy properties to.
                 * @param {Function} [customizer] The function to customize copied values.
                 * @returns {Object} Returns `object`.
                 */
                function copyObject(source, props, object, customizer) {
                  var isNew = !object;
                  object || (object = {});

                  var index = -1,
                      length = props.length;

                  while (++index < length) {
                    var key = props[index];

                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

                    if (newValue === undefined) {
                      newValue = source[key];
                    }
                    if (isNew) {
                      baseAssignValue(object, key, newValue);
                    } else {
                      assignValue(object, key, newValue);
                    }
                  }
                  return object;
                }

                _module247.exports = copyObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_assignValue.js": function module(_require245, _exports245, _module248) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_assignValue.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseAssignValue = _require245('./_baseAssignValue'),
                    eq = _require245('./eq');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Assigns `value` to `key` of `object` if the existing value is not equivalent
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {string} key The key of the property to assign.
                 * @param {*} value The value to assign.
                 */
                function assignValue(object, key, value) {
                  var objValue = object[key];
                  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
                    baseAssignValue(object, key, value);
                  }
                }

                _module248.exports = assignValue;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseAssignValue.js": function module(_require246, _exports246, _module249) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseAssignValue.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var defineProperty = _require246('./_defineProperty');

                /**
                 * The base implementation of `assignValue` and `assignMergeValue` without
                 * value checks.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {string} key The key of the property to assign.
                 * @param {*} value The value to assign.
                 */
                function baseAssignValue(object, key, value) {
                  if (key == '__proto__' && defineProperty) {
                    defineProperty(object, key, {
                      'configurable': true,
                      'enumerable': true,
                      'value': value,
                      'writable': true
                    });
                  } else {
                    object[key] = value;
                  }
                }

                _module249.exports = baseAssignValue;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_defineProperty.js": function module(_require247, _exports247, _module250) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_defineProperty.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require247('./_getNative');

                var defineProperty = function () {
                  try {
                    var func = getNative(Object, 'defineProperty');
                    func({}, '', {});
                    return func;
                  } catch (e) {}
                }();

                _module250.exports = defineProperty;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getNative.js": function module(_require248, _exports248, _module251) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getNative.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsNative = _require248('./_baseIsNative'),
                    getValue = _require248('./_getValue');

                /**
                 * Gets the native function at `key` of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {string} key The key of the method to get.
                 * @returns {*} Returns the function if it's native, else `undefined`.
                 */
                function getNative(object, key) {
                  var value = getValue(object, key);
                  return baseIsNative(value) ? value : undefined;
                }

                _module251.exports = getNative;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsNative.js": function module(_require249, _exports249, _module252) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsNative.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isFunction = _require249('./isFunction'),
                    isMasked = _require249('./_isMasked'),
                    isObject = _require249('./isObject'),
                    toSource = _require249('./_toSource');

                /**
                 * Used to match `RegExp`
                 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
                 */
                var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

                /** Used to detect host constructors (Safari). */
                var reIsHostCtor = /^\[object .+?Constructor\]$/;

                /** Used for built-in method references. */
                var funcProto = Function.prototype,
                    objectProto = Object.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Used to detect if a method is native. */
                var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

                /**
                 * The base implementation of `_.isNative` without bad shim checks.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a native function,
                 *  else `false`.
                 */
                function baseIsNative(value) {
                  if (!isObject(value) || isMasked(value)) {
                    return false;
                  }
                  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                  return pattern.test(toSource(value));
                }

                _module252.exports = baseIsNative;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isFunction.js": function module(_require250, _exports250, _module253) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isFunction.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require250('./_baseGetTag'),
                    isObject = _require250('./isObject');

                /** `Object#toString` result references. */
                var asyncTag = '[object AsyncFunction]',
                    funcTag = '[object Function]',
                    genTag = '[object GeneratorFunction]',
                    proxyTag = '[object Proxy]';

                /**
                 * Checks if `value` is classified as a `Function` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
                 * @example
                 *
                 * _.isFunction(_);
                 * // => true
                 *
                 * _.isFunction(/abc/);
                 * // => false
                 */
                function isFunction(value) {
                  if (!isObject(value)) {
                    return false;
                  }
                  // The use of `Object#toString` avoids issues with the `typeof` operator
                  // in Safari 9 which returns 'object' for typed arrays and other constructors.
                  var tag = baseGetTag(value);
                  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
                }

                _module253.exports = isFunction;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isObject.js": function module(_require251, _exports251, _module254) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isObject.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is the
                 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
                 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
                 * @example
                 *
                 * _.isObject({});
                 * // => true
                 *
                 * _.isObject([1, 2, 3]);
                 * // => true
                 *
                 * _.isObject(_.noop);
                 * // => true
                 *
                 * _.isObject(null);
                 * // => false
                 */
                function isObject(value) {
                  var type = typeof value;
                  return value != null && (type == 'object' || type == 'function');
                }

                _module254.exports = isObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isMasked.js": function module(_require252, _exports252, _module255) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isMasked.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var coreJsData = _require252('./_coreJsData');

                /** Used to detect methods masquerading as native. */
                var maskSrcKey = function () {
                  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                  return uid ? 'Symbol(src)_1.' + uid : '';
                }();

                /**
                 * Checks if `func` has its source masked.
                 *
                 * @private
                 * @param {Function} func The function to check.
                 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
                 */
                function isMasked(func) {
                  return !!maskSrcKey && maskSrcKey in func;
                }

                _module255.exports = isMasked;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_coreJsData.js": function module(_require253, _exports253, _module256) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_coreJsData.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var root = _require253('./_root');

                /** Used to detect overreaching core-js shims. */
                var coreJsData = root['__core-js_shared__'];

                _module256.exports = coreJsData;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_toSource.js": function module(_require254, _exports254, _module257) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_toSource.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used for built-in method references. */
                var funcProto = Function.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /**
                 * Converts `func` to its source code.
                 *
                 * @private
                 * @param {Function} func The function to convert.
                 * @returns {string} Returns the source code.
                 */
                function toSource(func) {
                  if (func != null) {
                    try {
                      return funcToString.call(func);
                    } catch (e) {}
                    try {
                      return func + '';
                    } catch (e) {}
                  }
                  return '';
                }

                _module257.exports = toSource;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getValue.js": function module(_require255, _exports255, _module258) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getValue.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Gets the value at `key` of `object`.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {string} key The key of the property to get.
                 * @returns {*} Returns the property value.
                 */
                function getValue(object, key) {
                  return object == null ? undefined : object[key];
                }

                _module258.exports = getValue;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "eq.js": function module(_require256, _exports256, _module259) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/eq.js                                                       //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Performs a
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * comparison between two values to determine if they are equivalent.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                 * @example
                 *
                 * var object = { 'a': 1 };
                 * var other = { 'a': 1 };
                 *
                 * _.eq(object, object);
                 * // => true
                 *
                 * _.eq(object, other);
                 * // => false
                 *
                 * _.eq('a', 'a');
                 * // => true
                 *
                 * _.eq('a', Object('a'));
                 * // => false
                 *
                 * _.eq(NaN, NaN);
                 * // => true
                 */
                function eq(value, other) {
                  return value === other || value !== value && other !== other;
                }

                _module259.exports = eq;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createAssigner.js": function module(_require257, _exports257, _module260) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createAssigner.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseRest = _require257('./_baseRest'),
                    isIterateeCall = _require257('./_isIterateeCall');

                /**
                 * Creates a function like `_.assign`.
                 *
                 * @private
                 * @param {Function} assigner The function to assign values.
                 * @returns {Function} Returns the new assigner function.
                 */
                function createAssigner(assigner) {
                  return baseRest(function (object, sources) {
                    var index = -1,
                        length = sources.length,
                        customizer = length > 1 ? sources[length - 1] : undefined,
                        guard = length > 2 ? sources[2] : undefined;

                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                      customizer = length < 3 ? undefined : customizer;
                      length = 1;
                    }
                    object = Object(object);
                    while (++index < length) {
                      var source = sources[index];
                      if (source) {
                        assigner(object, source, index, customizer);
                      }
                    }
                    return object;
                  });
                }

                _module260.exports = createAssigner;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseRest.js": function module(_require258, _exports258, _module261) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseRest.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var identity = _require258('./identity'),
                    overRest = _require258('./_overRest'),
                    setToString = _require258('./_setToString');

                /**
                 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @param {number} [start=func.length-1] The start position of the rest parameter.
                 * @returns {Function} Returns the new function.
                 */
                function baseRest(func, start) {
                  return setToString(overRest(func, start, identity), func + '');
                }

                _module261.exports = baseRest;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "identity.js": function module(_require259, _exports259, _module262) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/identity.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This method returns the first argument it receives.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Util
                 * @param {*} value Any value.
                 * @returns {*} Returns `value`.
                 * @example
                 *
                 * var object = { 'a': 1 };
                 *
                 * console.log(_.identity(object) === object);
                 * // => true
                 */
                function identity(value) {
                  return value;
                }

                _module262.exports = identity;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_overRest.js": function module(_require260, _exports260, _module263) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_overRest.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var apply = _require260('./_apply');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * A specialized version of `baseRest` which transforms the rest array.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @param {number} [start=func.length-1] The start position of the rest parameter.
                 * @param {Function} transform The rest array transform.
                 * @returns {Function} Returns the new function.
                 */
                function overRest(func, start, transform) {
                  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                  return function () {
                    var args = arguments,
                        index = -1,
                        length = nativeMax(args.length - start, 0),
                        array = Array(length);

                    while (++index < length) {
                      array[index] = args[start + index];
                    }
                    index = -1;
                    var otherArgs = Array(start + 1);
                    while (++index < start) {
                      otherArgs[index] = args[index];
                    }
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                  };
                }

                _module263.exports = overRest;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_setToString.js": function module(_require261, _exports261, _module264) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_setToString.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseSetToString = _require261('./_baseSetToString'),
                    shortOut = _require261('./_shortOut');

                /**
                 * Sets the `toString` method of `func` to return `string`.
                 *
                 * @private
                 * @param {Function} func The function to modify.
                 * @param {Function} string The `toString` result.
                 * @returns {Function} Returns `func`.
                 */
                var setToString = shortOut(baseSetToString);

                _module264.exports = setToString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseSetToString.js": function module(_require262, _exports262, _module265) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseSetToString.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var constant = _require262('./constant'),
                    defineProperty = _require262('./_defineProperty'),
                    identity = _require262('./identity');

                /**
                 * The base implementation of `setToString` without support for hot loop shorting.
                 *
                 * @private
                 * @param {Function} func The function to modify.
                 * @param {Function} string The `toString` result.
                 * @returns {Function} Returns `func`.
                 */
                var baseSetToString = !defineProperty ? identity : function (func, string) {
                  return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                  });
                };

                _module265.exports = baseSetToString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "constant.js": function module(_require263, _exports263, _module266) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/constant.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Creates a function that returns `value`.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.4.0
                 * @category Util
                 * @param {*} value The value to return from the new function.
                 * @returns {Function} Returns the new constant function.
                 * @example
                 *
                 * var objects = _.times(2, _.constant({ 'a': 1 }));
                 *
                 * console.log(objects);
                 * // => [{ 'a': 1 }, { 'a': 1 }]
                 *
                 * console.log(objects[0] === objects[1]);
                 * // => true
                 */
                function constant(value) {
                  return function () {
                    return value;
                  };
                }

                _module266.exports = constant;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_shortOut.js": function module(_require264, _exports264, _module267) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_shortOut.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to detect hot functions by number of calls within a span of milliseconds. */
                var HOT_COUNT = 800,
                    HOT_SPAN = 16;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeNow = Date.now;

                /**
                 * Creates a function that'll short out and invoke `identity` instead
                 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
                 * milliseconds.
                 *
                 * @private
                 * @param {Function} func The function to restrict.
                 * @returns {Function} Returns the new shortable function.
                 */
                function shortOut(func) {
                  var count = 0,
                      lastCalled = 0;

                  return function () {
                    var stamp = nativeNow(),
                        remaining = HOT_SPAN - (stamp - lastCalled);

                    lastCalled = stamp;
                    if (remaining > 0) {
                      if (++count >= HOT_COUNT) {
                        return arguments[0];
                      }
                    } else {
                      count = 0;
                    }
                    return func.apply(undefined, arguments);
                  };
                }

                _module267.exports = shortOut;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isIterateeCall.js": function module(_require265, _exports265, _module268) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isIterateeCall.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var eq = _require265('./eq'),
                    isArrayLike = _require265('./isArrayLike'),
                    isIndex = _require265('./_isIndex'),
                    isObject = _require265('./isObject');

                /**
                 * Checks if the given arguments are from an iteratee call.
                 *
                 * @private
                 * @param {*} value The potential iteratee value argument.
                 * @param {*} index The potential iteratee index or key argument.
                 * @param {*} object The potential iteratee object argument.
                 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
                 *  else `false`.
                 */
                function isIterateeCall(value, index, object) {
                  if (!isObject(object)) {
                    return false;
                  }
                  var type = typeof index;
                  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                    return eq(object[index], value);
                  }
                  return false;
                }

                _module268.exports = isIterateeCall;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isArrayLike.js": function module(_require266, _exports266, _module269) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isArrayLike.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isFunction = _require266('./isFunction'),
                    isLength = _require266('./isLength');

                /**
                 * Checks if `value` is array-like. A value is considered array-like if it's
                 * not a function and has a `value.length` that's an integer greater than or
                 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
                 * @example
                 *
                 * _.isArrayLike([1, 2, 3]);
                 * // => true
                 *
                 * _.isArrayLike(document.body.children);
                 * // => true
                 *
                 * _.isArrayLike('abc');
                 * // => true
                 *
                 * _.isArrayLike(_.noop);
                 * // => false
                 */
                function isArrayLike(value) {
                  return value != null && isLength(value.length) && !isFunction(value);
                }

                _module269.exports = isArrayLike;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isLength.js": function module(_require267, _exports267, _module270) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isLength.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used as references for various `Number` constants. */
                var MAX_SAFE_INTEGER = 9007199254740991;

                /**
                 * Checks if `value` is a valid array-like length.
                 *
                 * **Note:** This method is loosely based on
                 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
                 * @example
                 *
                 * _.isLength(3);
                 * // => true
                 *
                 * _.isLength(Number.MIN_VALUE);
                 * // => false
                 *
                 * _.isLength(Infinity);
                 * // => false
                 *
                 * _.isLength('3');
                 * // => false
                 */
                function isLength(value) {
                  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
                }

                _module270.exports = isLength;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isIndex.js": function module(_require268, _exports268, _module271) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isIndex.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used as references for various `Number` constants. */
                var MAX_SAFE_INTEGER = 9007199254740991;

                /** Used to detect unsigned integer values. */
                var reIsUint = /^(?:0|[1-9]\d*)$/;

                /**
                 * Checks if `value` is a valid array-like index.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
                 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
                 */
                function isIndex(value, length) {
                  length = length == null ? MAX_SAFE_INTEGER : length;
                  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
                }

                _module271.exports = isIndex;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "keysIn.js": function module(_require269, _exports269, _module272) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/keysIn.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayLikeKeys = _require269('./_arrayLikeKeys'),
                    baseKeysIn = _require269('./_baseKeysIn'),
                    isArrayLike = _require269('./isArrayLike');

                /**
                 * Creates an array of the own and inherited enumerable property names of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.keysIn(new Foo);
                 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
                 */
                function keysIn(object) {
                  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
                }

                _module272.exports = keysIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayLikeKeys.js": function module(_require270, _exports270, _module273) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayLikeKeys.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseTimes = _require270('./_baseTimes'),
                    isArguments = _require270('./isArguments'),
                    isArray = _require270('./isArray'),
                    isBuffer = _require270('./isBuffer'),
                    isIndex = _require270('./_isIndex'),
                    isTypedArray = _require270('./isTypedArray');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Creates an array of the enumerable property names of the array-like `value`.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @param {boolean} inherited Specify returning inherited property names.
                 * @returns {Array} Returns the array of property names.
                 */
                function arrayLikeKeys(value, inherited) {
                  var isArr = isArray(value),
                      isArg = !isArr && isArguments(value),
                      isBuff = !isArr && !isArg && isBuffer(value),
                      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                      skipIndexes = isArr || isArg || isBuff || isType,
                      result = skipIndexes ? baseTimes(value.length, String) : [],
                      length = result.length;

                  for (var key in value) {
                    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
                    // Safari 9 has enumerable `arguments.length` in strict mode.
                    key == 'length' ||
                    // Node.js 0.10 has enumerable non-index properties on buffers.
                    isBuff && (key == 'offset' || key == 'parent') ||
                    // PhantomJS 2 has enumerable non-index properties on typed arrays.
                    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
                    // Skip index properties.
                    isIndex(key, length)))) {
                      result.push(key);
                    }
                  }
                  return result;
                }

                _module273.exports = arrayLikeKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseTimes.js": function module(_require271, _exports271, _module274) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseTimes.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.times` without support for iteratee shorthands
                 * or max array length checks.
                 *
                 * @private
                 * @param {number} n The number of times to invoke `iteratee`.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the array of results.
                 */
                function baseTimes(n, iteratee) {
                  var index = -1,
                      result = Array(n);

                  while (++index < n) {
                    result[index] = iteratee(index);
                  }
                  return result;
                }

                _module274.exports = baseTimes;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isBuffer.js": function module(_require272, _exports272, _module275) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isBuffer.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var root = _require272('./_root'),
                    stubFalse = _require272('./stubFalse');

                /** Detect free variable `exports`. */
                var freeExports = typeof _exports272 == 'object' && _exports272 && !_exports272.nodeType && _exports272;

                /** Detect free variable `module`. */
                var freeModule = freeExports && typeof _module275 == 'object' && _module275 && !_module275.nodeType && _module275;

                /** Detect the popular CommonJS extension `module.exports`. */
                var moduleExports = freeModule && freeModule.exports === freeExports;

                /** Built-in value references. */
                var Buffer = moduleExports ? root.Buffer : undefined;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

                /**
                 * Checks if `value` is a buffer.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.3.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
                 * @example
                 *
                 * _.isBuffer(new Buffer(2));
                 * // => true
                 *
                 * _.isBuffer(new Uint8Array(2));
                 * // => false
                 */
                var isBuffer = nativeIsBuffer || stubFalse;

                _module275.exports = isBuffer;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "stubFalse.js": function module(_require273, _exports273, _module276) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/stubFalse.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This method returns `false`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.13.0
                 * @category Util
                 * @returns {boolean} Returns `false`.
                 * @example
                 *
                 * _.times(2, _.stubFalse);
                 * // => [false, false]
                 */
                function stubFalse() {
                  return false;
                }

                _module276.exports = stubFalse;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isTypedArray.js": function module(_require274, _exports274, _module277) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isTypedArray.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsTypedArray = _require274('./_baseIsTypedArray'),
                    baseUnary = _require274('./_baseUnary'),
                    nodeUtil = _require274('./_nodeUtil');

                /* Node.js helper references. */
                var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

                /**
                 * Checks if `value` is classified as a typed array.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                 * @example
                 *
                 * _.isTypedArray(new Uint8Array);
                 * // => true
                 *
                 * _.isTypedArray([]);
                 * // => false
                 */
                var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

                _module277.exports = isTypedArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsTypedArray.js": function module(_require275, _exports275, _module278) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsTypedArray.js                                        //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require275('./_baseGetTag'),
                    isLength = _require275('./isLength'),
                    isObjectLike = _require275('./isObjectLike');

                /** `Object#toString` result references. */
                var argsTag = '[object Arguments]',
                    arrayTag = '[object Array]',
                    boolTag = '[object Boolean]',
                    dateTag = '[object Date]',
                    errorTag = '[object Error]',
                    funcTag = '[object Function]',
                    mapTag = '[object Map]',
                    numberTag = '[object Number]',
                    objectTag = '[object Object]',
                    regexpTag = '[object RegExp]',
                    setTag = '[object Set]',
                    stringTag = '[object String]',
                    weakMapTag = '[object WeakMap]';

                var arrayBufferTag = '[object ArrayBuffer]',
                    dataViewTag = '[object DataView]',
                    float32Tag = '[object Float32Array]',
                    float64Tag = '[object Float64Array]',
                    int8Tag = '[object Int8Array]',
                    int16Tag = '[object Int16Array]',
                    int32Tag = '[object Int32Array]',
                    uint8Tag = '[object Uint8Array]',
                    uint8ClampedTag = '[object Uint8ClampedArray]',
                    uint16Tag = '[object Uint16Array]',
                    uint32Tag = '[object Uint32Array]';

                /** Used to identify `toStringTag` values of typed arrays. */
                var typedArrayTags = {};
                typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
                typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

                /**
                 * The base implementation of `_.isTypedArray` without Node.js optimizations.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
                 */
                function baseIsTypedArray(value) {
                  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
                }

                _module278.exports = baseIsTypedArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseUnary.js": function module(_require276, _exports276, _module279) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseUnary.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.unary` without support for storing metadata.
                 *
                 * @private
                 * @param {Function} func The function to cap arguments for.
                 * @returns {Function} Returns the new capped function.
                 */
                function baseUnary(func) {
                  return function (value) {
                    return func(value);
                  };
                }

                _module279.exports = baseUnary;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_nodeUtil.js": function module(_require277, _exports277, _module280) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_nodeUtil.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var freeGlobal = _require277('./_freeGlobal');

                /** Detect free variable `exports`. */
                var freeExports = typeof _exports277 == 'object' && _exports277 && !_exports277.nodeType && _exports277;

                /** Detect free variable `module`. */
                var freeModule = freeExports && typeof _module280 == 'object' && _module280 && !_module280.nodeType && _module280;

                /** Detect the popular CommonJS extension `module.exports`. */
                var moduleExports = freeModule && freeModule.exports === freeExports;

                /** Detect free variable `process` from Node.js. */
                var freeProcess = moduleExports && freeGlobal.process;

                /** Used to access faster Node.js helpers. */
                var nodeUtil = function () {
                  try {
                    return freeProcess && freeProcess.binding && freeProcess.binding('util');
                  } catch (e) {}
                }();

                _module280.exports = nodeUtil;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseKeysIn.js": function module(_require278, _exports278, _module281) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseKeysIn.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isObject = _require278('./isObject'),
                    isPrototype = _require278('./_isPrototype'),
                    nativeKeysIn = _require278('./_nativeKeysIn');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function baseKeysIn(object) {
                  if (!isObject(object)) {
                    return nativeKeysIn(object);
                  }
                  var isProto = isPrototype(object),
                      result = [];

                  for (var key in object) {
                    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
                      result.push(key);
                    }
                  }
                  return result;
                }

                _module281.exports = baseKeysIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isPrototype.js": function module(_require279, _exports279, _module282) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isPrototype.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /**
                 * Checks if `value` is likely a prototype object.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
                 */
                function isPrototype(value) {
                  var Ctor = value && value.constructor,
                      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

                  return value === proto;
                }

                _module282.exports = isPrototype;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_nativeKeysIn.js": function module(_require280, _exports280, _module283) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_nativeKeysIn.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This function is like
                 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                 * except that it includes inherited enumerable properties.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function nativeKeysIn(object) {
                  var result = [];
                  if (object != null) {
                    for (var key in Object(object)) {
                      result.push(key);
                    }
                  }
                  return result;
                }

                _module283.exports = nativeKeysIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_customDefaultsAssignIn.js": function module(_require281, _exports281, _module284) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_customDefaultsAssignIn.js                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var eq = _require281('./eq');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
                 * of source objects to the destination object for all destination properties
                 * that resolve to `undefined`.
                 *
                 * @private
                 * @param {*} objValue The destination value.
                 * @param {*} srcValue The source value.
                 * @param {string} key The key of the property to assign.
                 * @param {Object} object The parent object of `objValue`.
                 * @returns {*} Returns the value to assign.
                 */
                function customDefaultsAssignIn(objValue, srcValue, key, object) {
                  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                    return srcValue;
                  }
                  return objValue;
                }

                _module284.exports = customDefaultsAssignIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "each.js": function module(_require282, _exports282, _module285) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/each.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                _module285.exports = _require282('./forEach');

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "forEach.js": function module(_require283, _exports283, _module286) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/forEach.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayEach = _require283('./_arrayEach'),
                    baseEach = _require283('./_baseEach'),
                    castFunction = _require283('./_castFunction'),
                    isArray = _require283('./isArray');

                /**
                 * Iterates over elements of `collection` and invokes `iteratee` for each element.
                 * The iteratee is invoked with three arguments: (value, index|key, collection).
                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                 *
                 * **Note:** As with other "Collections" methods, objects with a "length"
                 * property are iterated like arrays. To avoid this behavior use `_.forIn`
                 * or `_.forOwn` for object iteration.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @alias each
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Array|Object} Returns `collection`.
                 * @see _.forEachRight
                 * @example
                 *
                 * _.forEach([1, 2], function(value) {
                 *   console.log(value);
                 * });
                 * // => Logs `1` then `2`.
                 *
                 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
                 *   console.log(key);
                 * });
                 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                 */
                function forEach(collection, iteratee) {
                  var func = isArray(collection) ? arrayEach : baseEach;
                  return func(collection, castFunction(iteratee));
                }

                _module286.exports = forEach;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayEach.js": function module(_require284, _exports284, _module287) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayEach.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.forEach` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns `array`.
                 */
                function arrayEach(array, iteratee) {
                  var index = -1,
                      length = array == null ? 0 : array.length;

                  while (++index < length) {
                    if (iteratee(array[index], index, array) === false) {
                      break;
                    }
                  }
                  return array;
                }

                _module287.exports = arrayEach;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseEach.js": function module(_require285, _exports285, _module288) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseEach.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseForOwn = _require285('./_baseForOwn'),
                    createBaseEach = _require285('./_createBaseEach');

                /**
                 * The base implementation of `_.forEach` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array|Object} Returns `collection`.
                 */
                var baseEach = createBaseEach(baseForOwn);

                _module288.exports = baseEach;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseForOwn.js": function module(_require286, _exports286, _module289) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseForOwn.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseFor = _require286('./_baseFor'),
                    keys = _require286('./keys');

                /**
                 * The base implementation of `_.forOwn` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The object to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Object} Returns `object`.
                 */
                function baseForOwn(object, iteratee) {
                  return object && baseFor(object, iteratee, keys);
                }

                _module289.exports = baseForOwn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseFor.js": function module(_require287, _exports287, _module290) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseFor.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var createBaseFor = _require287('./_createBaseFor');

                /**
                 * The base implementation of `baseForOwn` which iterates over `object`
                 * properties returned by `keysFunc` and invokes `iteratee` for each property.
                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                 *
                 * @private
                 * @param {Object} object The object to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @param {Function} keysFunc The function to get the keys of `object`.
                 * @returns {Object} Returns `object`.
                 */
                var baseFor = createBaseFor();

                _module290.exports = baseFor;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createBaseFor.js": function module(_require288, _exports288, _module291) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createBaseFor.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
                 *
                 * @private
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new base function.
                 */
                function createBaseFor(fromRight) {
                  return function (object, iteratee, keysFunc) {
                    var index = -1,
                        iterable = Object(object),
                        props = keysFunc(object),
                        length = props.length;

                    while (length--) {
                      var key = props[fromRight ? length : ++index];
                      if (iteratee(iterable[key], key, iterable) === false) {
                        break;
                      }
                    }
                    return object;
                  };
                }

                _module291.exports = createBaseFor;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "keys.js": function module(_require289, _exports289, _module292) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/keys.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayLikeKeys = _require289('./_arrayLikeKeys'),
                    baseKeys = _require289('./_baseKeys'),
                    isArrayLike = _require289('./isArrayLike');

                /**
                 * Creates an array of the own enumerable property names of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects. See the
                 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
                 * for more details.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.keys(new Foo);
                 * // => ['a', 'b'] (iteration order is not guaranteed)
                 *
                 * _.keys('hi');
                 * // => ['0', '1']
                 */
                function keys(object) {
                  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
                }

                _module292.exports = keys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseKeys.js": function module(_require290, _exports290, _module293) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseKeys.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isPrototype = _require290('./_isPrototype'),
                    nativeKeys = _require290('./_nativeKeys');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names.
                 */
                function baseKeys(object) {
                  if (!isPrototype(object)) {
                    return nativeKeys(object);
                  }
                  var result = [];
                  for (var key in Object(object)) {
                    if (hasOwnProperty.call(object, key) && key != 'constructor') {
                      result.push(key);
                    }
                  }
                  return result;
                }

                _module293.exports = baseKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_nativeKeys.js": function module(_require291, _exports291, _module294) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_nativeKeys.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var overArg = _require291('./_overArg');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeKeys = overArg(Object.keys, Object);

                _module294.exports = nativeKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_overArg.js": function module(_require292, _exports292, _module295) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_overArg.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Creates a unary function that invokes `func` with its argument transformed.
                 *
                 * @private
                 * @param {Function} func The function to wrap.
                 * @param {Function} transform The argument transform.
                 * @returns {Function} Returns the new function.
                 */
                function overArg(func, transform) {
                  return function (arg) {
                    return func(transform(arg));
                  };
                }

                _module295.exports = overArg;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createBaseEach.js": function module(_require293, _exports293, _module296) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createBaseEach.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isArrayLike = _require293('./isArrayLike');

                /**
                 * Creates a `baseEach` or `baseEachRight` function.
                 *
                 * @private
                 * @param {Function} eachFunc The function to iterate over a collection.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new base function.
                 */
                function createBaseEach(eachFunc, fromRight) {
                  return function (collection, iteratee) {
                    if (collection == null) {
                      return collection;
                    }
                    if (!isArrayLike(collection)) {
                      return eachFunc(collection, iteratee);
                    }
                    var length = collection.length,
                        index = fromRight ? length : -1,
                        iterable = Object(collection);

                    while (fromRight ? index-- : ++index < length) {
                      if (iteratee(iterable[index], index, iterable) === false) {
                        break;
                      }
                    }
                    return collection;
                  };
                }

                _module296.exports = createBaseEach;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_castFunction.js": function module(_require294, _exports294, _module297) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_castFunction.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var identity = _require294('./identity');

                /**
                 * Casts `value` to `identity` if it's not a function.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {Function} Returns cast function.
                 */
                function castFunction(value) {
                  return typeof value == 'function' ? value : identity;
                }

                _module297.exports = castFunction;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "has.js": function module(_require295, _exports295, _module298) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/has.js                                                      //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseHas = _require295('./_baseHas'),
                    hasPath = _require295('./_hasPath');

                /**
                 * Checks if `path` is a direct property of `object`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 * @example
                 *
                 * var object = { 'a': { 'b': 2 } };
                 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
                 *
                 * _.has(object, 'a');
                 * // => true
                 *
                 * _.has(object, 'a.b');
                 * // => true
                 *
                 * _.has(object, ['a', 'b']);
                 * // => true
                 *
                 * _.has(other, 'a');
                 * // => false
                 */
                function has(object, path) {
                  return object != null && hasPath(object, path, baseHas);
                }

                _module298.exports = has;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseHas.js": function module(_require296, _exports296, _module299) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseHas.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * The base implementation of `_.has` without support for deep paths.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {Array|string} key The key to check.
                 * @returns {boolean} Returns `true` if `key` exists, else `false`.
                 */
                function baseHas(object, key) {
                  return object != null && hasOwnProperty.call(object, key);
                }

                _module299.exports = baseHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hasPath.js": function module(_require297, _exports297, _module300) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hasPath.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var castPath = _require297('./_castPath'),
                    isArguments = _require297('./isArguments'),
                    isArray = _require297('./isArray'),
                    isIndex = _require297('./_isIndex'),
                    isLength = _require297('./isLength'),
                    toKey = _require297('./_toKey');

                /**
                 * Checks if `path` exists on `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @param {Function} hasFunc The function to check properties.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 */
                function hasPath(object, path, hasFunc) {
                  path = castPath(path, object);

                  var index = -1,
                      length = path.length,
                      result = false;

                  while (++index < length) {
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) {
                      break;
                    }
                    object = object[key];
                  }
                  if (result || ++index != length) {
                    return result;
                  }
                  length = object == null ? 0 : object.length;
                  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
                }

                _module300.exports = hasPath;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_castPath.js": function module(_require298, _exports298, _module301) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_castPath.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isArray = _require298('./isArray'),
                    isKey = _require298('./_isKey'),
                    stringToPath = _require298('./_stringToPath'),
                    toString = _require298('./toString');

                /**
                 * Casts `value` to a path array if it's not one.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @param {Object} [object] The object to query keys on.
                 * @returns {Array} Returns the cast property path array.
                 */
                function castPath(value, object) {
                  if (isArray(value)) {
                    return value;
                  }
                  return isKey(value, object) ? [value] : stringToPath(toString(value));
                }

                _module301.exports = castPath;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isKey.js": function module(_require299, _exports299, _module302) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isKey.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isArray = _require299('./isArray'),
                    isSymbol = _require299('./isSymbol');

                /** Used to match property names within property paths. */
                var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                    reIsPlainProp = /^\w*$/;

                /**
                 * Checks if `value` is a property name and not a property path.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @param {Object} [object] The object to query keys on.
                 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
                 */
                function isKey(value, object) {
                  if (isArray(value)) {
                    return false;
                  }
                  var type = typeof value;
                  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
                    return true;
                  }
                  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
                }

                _module302.exports = isKey;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isSymbol.js": function module(_require300, _exports300, _module303) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isSymbol.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require300('./_baseGetTag'),
                    isObjectLike = _require300('./isObjectLike');

                /** `Object#toString` result references. */
                var symbolTag = '[object Symbol]';

                /**
                 * Checks if `value` is classified as a `Symbol` primitive or object.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
                 * @example
                 *
                 * _.isSymbol(Symbol.iterator);
                 * // => true
                 *
                 * _.isSymbol('abc');
                 * // => false
                 */
                function isSymbol(value) {
                  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
                }

                _module303.exports = isSymbol;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stringToPath.js": function module(_require301, _exports301, _module304) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stringToPath.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var memoizeCapped = _require301('./_memoizeCapped');

                /** Used to match property names within property paths. */
                var reLeadingDot = /^\./,
                    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

                /** Used to match backslashes in property paths. */
                var reEscapeChar = /\\(\\)?/g;

                /**
                 * Converts `string` to a property path array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the property path array.
                 */
                var stringToPath = memoizeCapped(function (string) {
                  var result = [];
                  if (reLeadingDot.test(string)) {
                    result.push('');
                  }
                  string.replace(rePropName, function (match, number, quote, string) {
                    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
                  });
                  return result;
                });

                _module304.exports = stringToPath;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_memoizeCapped.js": function module(_require302, _exports302, _module305) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_memoizeCapped.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var memoize = _require302('./memoize');

                /** Used as the maximum memoize cache size. */
                var MAX_MEMOIZE_SIZE = 500;

                /**
                 * A specialized version of `_.memoize` which clears the memoized function's
                 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
                 *
                 * @private
                 * @param {Function} func The function to have its output memoized.
                 * @returns {Function} Returns the new memoized function.
                 */
                function memoizeCapped(func) {
                  var result = memoize(func, function (key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) {
                      cache.clear();
                    }
                    return key;
                  });

                  var cache = result.cache;
                  return result;
                }

                _module305.exports = memoizeCapped;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "memoize.js": function module(_require303, _exports303, _module306) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/memoize.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var MapCache = _require303('./_MapCache');

                /** Error message constants. */
                var FUNC_ERROR_TEXT = 'Expected a function';

                /**
                 * Creates a function that memoizes the result of `func`. If `resolver` is
                 * provided, it determines the cache key for storing the result based on the
                 * arguments provided to the memoized function. By default, the first argument
                 * provided to the memoized function is used as the map cache key. The `func`
                 * is invoked with the `this` binding of the memoized function.
                 *
                 * **Note:** The cache is exposed as the `cache` property on the memoized
                 * function. Its creation may be customized by replacing the `_.memoize.Cache`
                 * constructor with one whose instances implement the
                 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
                 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to have its output memoized.
                 * @param {Function} [resolver] The function to resolve the cache key.
                 * @returns {Function} Returns the new memoized function.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': 2 };
                 * var other = { 'c': 3, 'd': 4 };
                 *
                 * var values = _.memoize(_.values);
                 * values(object);
                 * // => [1, 2]
                 *
                 * values(other);
                 * // => [3, 4]
                 *
                 * object.a = 2;
                 * values(object);
                 * // => [1, 2]
                 *
                 * // Modify the result cache.
                 * values.cache.set(object, ['a', 'b']);
                 * values(object);
                 * // => ['a', 'b']
                 *
                 * // Replace `_.memoize.Cache`.
                 * _.memoize.Cache = WeakMap;
                 */
                function memoize(func, resolver) {
                  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
                    throw new TypeError(FUNC_ERROR_TEXT);
                  }
                  var memoized = function () {
                    var args = arguments,
                        key = resolver ? resolver.apply(this, args) : args[0],
                        cache = memoized.cache;

                    if (cache.has(key)) {
                      return cache.get(key);
                    }
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                  };
                  memoized.cache = new (memoize.Cache || MapCache)();
                  return memoized;
                }

                // Expose `MapCache`.
                memoize.Cache = MapCache;

                _module306.exports = memoize;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_MapCache.js": function module(_require304, _exports304, _module307) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_MapCache.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var mapCacheClear = _require304('./_mapCacheClear'),
                    mapCacheDelete = _require304('./_mapCacheDelete'),
                    mapCacheGet = _require304('./_mapCacheGet'),
                    mapCacheHas = _require304('./_mapCacheHas'),
                    mapCacheSet = _require304('./_mapCacheSet');

                /**
                 * Creates a map cache object to store key-value pairs.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function MapCache(entries) {
                  var index = -1,
                      length = entries == null ? 0 : entries.length;

                  this.clear();
                  while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                  }
                }

                // Add methods to `MapCache`.
                MapCache.prototype.clear = mapCacheClear;
                MapCache.prototype['delete'] = mapCacheDelete;
                MapCache.prototype.get = mapCacheGet;
                MapCache.prototype.has = mapCacheHas;
                MapCache.prototype.set = mapCacheSet;

                _module307.exports = MapCache;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapCacheClear.js": function module(_require305, _exports305, _module308) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapCacheClear.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Hash = _require305('./_Hash'),
                    ListCache = _require305('./_ListCache'),
                    Map = _require305('./_Map');

                /**
                 * Removes all key-value entries from the map.
                 *
                 * @private
                 * @name clear
                 * @memberOf MapCache
                 */
                function mapCacheClear() {
                  this.size = 0;
                  this.__data__ = {
                    'hash': new Hash(),
                    'map': new (Map || ListCache)(),
                    'string': new Hash()
                  };
                }

                _module308.exports = mapCacheClear;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Hash.js": function module(_require306, _exports306, _module309) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Hash.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var hashClear = _require306('./_hashClear'),
                    hashDelete = _require306('./_hashDelete'),
                    hashGet = _require306('./_hashGet'),
                    hashHas = _require306('./_hashHas'),
                    hashSet = _require306('./_hashSet');

                /**
                 * Creates a hash object.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function Hash(entries) {
                  var index = -1,
                      length = entries == null ? 0 : entries.length;

                  this.clear();
                  while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                  }
                }

                // Add methods to `Hash`.
                Hash.prototype.clear = hashClear;
                Hash.prototype['delete'] = hashDelete;
                Hash.prototype.get = hashGet;
                Hash.prototype.has = hashHas;
                Hash.prototype.set = hashSet;

                _module309.exports = Hash;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hashClear.js": function module(_require307, _exports307, _module310) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hashClear.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var nativeCreate = _require307('./_nativeCreate');

                /**
                 * Removes all key-value entries from the hash.
                 *
                 * @private
                 * @name clear
                 * @memberOf Hash
                 */
                function hashClear() {
                  this.__data__ = nativeCreate ? nativeCreate(null) : {};
                  this.size = 0;
                }

                _module310.exports = hashClear;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_nativeCreate.js": function module(_require308, _exports308, _module311) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_nativeCreate.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require308('./_getNative');

                /* Built-in method references that are verified to be native. */
                var nativeCreate = getNative(Object, 'create');

                _module311.exports = nativeCreate;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hashDelete.js": function module(_require309, _exports309, _module312) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hashDelete.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Removes `key` and its value from the hash.
                 *
                 * @private
                 * @name delete
                 * @memberOf Hash
                 * @param {Object} hash The hash to modify.
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function hashDelete(key) {
                  var result = this.has(key) && delete this.__data__[key];
                  this.size -= result ? 1 : 0;
                  return result;
                }

                _module312.exports = hashDelete;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hashGet.js": function module(_require310, _exports310, _module313) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hashGet.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var nativeCreate = _require310('./_nativeCreate');

                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = '__lodash_hash_undefined__';

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Gets the hash value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf Hash
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function hashGet(key) {
                  var data = this.__data__;
                  if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                  }
                  return hasOwnProperty.call(data, key) ? data[key] : undefined;
                }

                _module313.exports = hashGet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hashHas.js": function module(_require311, _exports311, _module314) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hashHas.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var nativeCreate = _require311('./_nativeCreate');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Checks if a hash value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf Hash
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function hashHas(key) {
                  var data = this.__data__;
                  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
                }

                _module314.exports = hashHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hashSet.js": function module(_require312, _exports312, _module315) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hashSet.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var nativeCreate = _require312('./_nativeCreate');

                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = '__lodash_hash_undefined__';

                /**
                 * Sets the hash `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf Hash
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the hash instance.
                 */
                function hashSet(key, value) {
                  var data = this.__data__;
                  this.size += this.has(key) ? 0 : 1;
                  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                  return this;
                }

                _module315.exports = hashSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_ListCache.js": function module(_require313, _exports313, _module316) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_ListCache.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var listCacheClear = _require313('./_listCacheClear'),
                    listCacheDelete = _require313('./_listCacheDelete'),
                    listCacheGet = _require313('./_listCacheGet'),
                    listCacheHas = _require313('./_listCacheHas'),
                    listCacheSet = _require313('./_listCacheSet');

                /**
                 * Creates an list cache object.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function ListCache(entries) {
                  var index = -1,
                      length = entries == null ? 0 : entries.length;

                  this.clear();
                  while (++index < length) {
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                  }
                }

                // Add methods to `ListCache`.
                ListCache.prototype.clear = listCacheClear;
                ListCache.prototype['delete'] = listCacheDelete;
                ListCache.prototype.get = listCacheGet;
                ListCache.prototype.has = listCacheHas;
                ListCache.prototype.set = listCacheSet;

                _module316.exports = ListCache;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_listCacheClear.js": function module(_require314, _exports314, _module317) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_listCacheClear.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Removes all key-value entries from the list cache.
                 *
                 * @private
                 * @name clear
                 * @memberOf ListCache
                 */
                function listCacheClear() {
                  this.__data__ = [];
                  this.size = 0;
                }

                _module317.exports = listCacheClear;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_listCacheDelete.js": function module(_require315, _exports315, _module318) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_listCacheDelete.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assocIndexOf = _require315('./_assocIndexOf');

                /** Used for built-in method references. */
                var arrayProto = Array.prototype;

                /** Built-in value references. */
                var splice = arrayProto.splice;

                /**
                 * Removes `key` and its value from the list cache.
                 *
                 * @private
                 * @name delete
                 * @memberOf ListCache
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function listCacheDelete(key) {
                  var data = this.__data__,
                      index = assocIndexOf(data, key);

                  if (index < 0) {
                    return false;
                  }
                  var lastIndex = data.length - 1;
                  if (index == lastIndex) {
                    data.pop();
                  } else {
                    splice.call(data, index, 1);
                  }
                  --this.size;
                  return true;
                }

                _module318.exports = listCacheDelete;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_assocIndexOf.js": function module(_require316, _exports316, _module319) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_assocIndexOf.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var eq = _require316('./eq');

                /**
                 * Gets the index at which the `key` is found in `array` of key-value pairs.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} key The key to search for.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function assocIndexOf(array, key) {
                  var length = array.length;
                  while (length--) {
                    if (eq(array[length][0], key)) {
                      return length;
                    }
                  }
                  return -1;
                }

                _module319.exports = assocIndexOf;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_listCacheGet.js": function module(_require317, _exports317, _module320) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_listCacheGet.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assocIndexOf = _require317('./_assocIndexOf');

                /**
                 * Gets the list cache value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf ListCache
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function listCacheGet(key) {
                  var data = this.__data__,
                      index = assocIndexOf(data, key);

                  return index < 0 ? undefined : data[index][1];
                }

                _module320.exports = listCacheGet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_listCacheHas.js": function module(_require318, _exports318, _module321) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_listCacheHas.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assocIndexOf = _require318('./_assocIndexOf');

                /**
                 * Checks if a list cache value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf ListCache
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function listCacheHas(key) {
                  return assocIndexOf(this.__data__, key) > -1;
                }

                _module321.exports = listCacheHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_listCacheSet.js": function module(_require319, _exports319, _module322) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_listCacheSet.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assocIndexOf = _require319('./_assocIndexOf');

                /**
                 * Sets the list cache `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf ListCache
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the list cache instance.
                 */
                function listCacheSet(key, value) {
                  var data = this.__data__,
                      index = assocIndexOf(data, key);

                  if (index < 0) {
                    ++this.size;
                    data.push([key, value]);
                  } else {
                    data[index][1] = value;
                  }
                  return this;
                }

                _module322.exports = listCacheSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Map.js": function module(_require320, _exports320, _module323) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Map.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require320('./_getNative'),
                    root = _require320('./_root');

                /* Built-in method references that are verified to be native. */
                var Map = getNative(root, 'Map');

                _module323.exports = Map;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapCacheDelete.js": function module(_require321, _exports321, _module324) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapCacheDelete.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getMapData = _require321('./_getMapData');

                /**
                 * Removes `key` and its value from the map.
                 *
                 * @private
                 * @name delete
                 * @memberOf MapCache
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function mapCacheDelete(key) {
                  var result = getMapData(this, key)['delete'](key);
                  this.size -= result ? 1 : 0;
                  return result;
                }

                _module324.exports = mapCacheDelete;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getMapData.js": function module(_require322, _exports322, _module325) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getMapData.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isKeyable = _require322('./_isKeyable');

                /**
                 * Gets the data for `map`.
                 *
                 * @private
                 * @param {Object} map The map to query.
                 * @param {string} key The reference key.
                 * @returns {*} Returns the map data.
                 */
                function getMapData(map, key) {
                  var data = map.__data__;
                  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
                }

                _module325.exports = getMapData;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isKeyable.js": function module(_require323, _exports323, _module326) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isKeyable.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is suitable for use as unique object key.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
                 */
                function isKeyable(value) {
                  var type = typeof value;
                  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
                }

                _module326.exports = isKeyable;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapCacheGet.js": function module(_require324, _exports324, _module327) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapCacheGet.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getMapData = _require324('./_getMapData');

                /**
                 * Gets the map value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf MapCache
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function mapCacheGet(key) {
                  return getMapData(this, key).get(key);
                }

                _module327.exports = mapCacheGet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapCacheHas.js": function module(_require325, _exports325, _module328) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapCacheHas.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getMapData = _require325('./_getMapData');

                /**
                 * Checks if a map value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf MapCache
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function mapCacheHas(key) {
                  return getMapData(this, key).has(key);
                }

                _module328.exports = mapCacheHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapCacheSet.js": function module(_require326, _exports326, _module329) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapCacheSet.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getMapData = _require326('./_getMapData');

                /**
                 * Sets the map `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf MapCache
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the map cache instance.
                 */
                function mapCacheSet(key, value) {
                  var data = getMapData(this, key),
                      size = data.size;

                  data.set(key, value);
                  this.size += data.size == size ? 0 : 1;
                  return this;
                }

                _module329.exports = mapCacheSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "toString.js": function module(_require327, _exports327, _module330) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/toString.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseToString = _require327('./_baseToString');

                /**
                 * Converts `value` to a string. An empty string is returned for `null`
                 * and `undefined` values. The sign of `-0` is preserved.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {string} Returns the converted string.
                 * @example
                 *
                 * _.toString(null);
                 * // => ''
                 *
                 * _.toString(-0);
                 * // => '-0'
                 *
                 * _.toString([1, 2, 3]);
                 * // => '1,2,3'
                 */
                function toString(value) {
                  return value == null ? '' : baseToString(value);
                }

                _module330.exports = toString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseToString.js": function module(_require328, _exports328, _module331) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseToString.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require328('./_Symbol'),
                    arrayMap = _require328('./_arrayMap'),
                    isArray = _require328('./isArray'),
                    isSymbol = _require328('./isSymbol');

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolToString = symbolProto ? symbolProto.toString : undefined;

                /**
                 * The base implementation of `_.toString` which doesn't convert nullish
                 * values to empty strings.
                 *
                 * @private
                 * @param {*} value The value to process.
                 * @returns {string} Returns the string.
                 */
                function baseToString(value) {
                  // Exit early for strings to avoid a performance hit in some environments.
                  if (typeof value == 'string') {
                    return value;
                  }
                  if (isArray(value)) {
                    // Recursively convert values (susceptible to call stack limits).
                    return arrayMap(value, baseToString) + '';
                  }
                  if (isSymbol(value)) {
                    return symbolToString ? symbolToString.call(value) : '';
                  }
                  var result = value + '';
                  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }

                _module331.exports = baseToString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayMap.js": function module(_require329, _exports329, _module332) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayMap.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.map` for arrays without support for iteratee
                 * shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 */
                function arrayMap(array, iteratee) {
                  var index = -1,
                      length = array == null ? 0 : array.length,
                      result = Array(length);

                  while (++index < length) {
                    result[index] = iteratee(array[index], index, array);
                  }
                  return result;
                }

                _module332.exports = arrayMap;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_toKey.js": function module(_require330, _exports330, _module333) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_toKey.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isSymbol = _require330('./isSymbol');

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /**
                 * Converts `value` to a string key if it's not a string or symbol.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {string|symbol} Returns the key.
                 */
                function toKey(value) {
                  if (typeof value == 'string' || isSymbol(value)) {
                    return value;
                  }
                  var result = value + '';
                  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }

                _module333.exports = toKey;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "includes.js": function module(_require331, _exports331, _module334) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/includes.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIndexOf = _require331('./_baseIndexOf'),
                    isArrayLike = _require331('./isArrayLike'),
                    isString = _require331('./isString'),
                    toInteger = _require331('./toInteger'),
                    values = _require331('./values');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Checks if `value` is in `collection`. If `collection` is a string, it's
                 * checked for a substring of `value`, otherwise
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * is used for equality comparisons. If `fromIndex` is negative, it's used as
                 * the offset from the end of `collection`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object|string} collection The collection to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
                 * @returns {boolean} Returns `true` if `value` is found, else `false`.
                 * @example
                 *
                 * _.includes([1, 2, 3], 1);
                 * // => true
                 *
                 * _.includes([1, 2, 3], 1, 2);
                 * // => false
                 *
                 * _.includes({ 'a': 1, 'b': 2 }, 1);
                 * // => true
                 *
                 * _.includes('abcd', 'bc');
                 * // => true
                 */
                function includes(collection, value, fromIndex, guard) {
                  collection = isArrayLike(collection) ? collection : values(collection);
                  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

                  var length = collection.length;
                  if (fromIndex < 0) {
                    fromIndex = nativeMax(length + fromIndex, 0);
                  }
                  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
                }

                _module334.exports = includes;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIndexOf.js": function module(_require332, _exports332, _module335) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIndexOf.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseFindIndex = _require332('./_baseFindIndex'),
                    baseIsNaN = _require332('./_baseIsNaN'),
                    strictIndexOf = _require332('./_strictIndexOf');

                /**
                 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} fromIndex The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function baseIndexOf(array, value, fromIndex) {
                  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
                }

                _module335.exports = baseIndexOf;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseFindIndex.js": function module(_require333, _exports333, _module336) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseFindIndex.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.findIndex` and `_.findLastIndex` without
                 * support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {Function} predicate The function invoked per iteration.
                 * @param {number} fromIndex The index to search from.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function baseFindIndex(array, predicate, fromIndex, fromRight) {
                  var length = array.length,
                      index = fromIndex + (fromRight ? 1 : -1);

                  while (fromRight ? index-- : ++index < length) {
                    if (predicate(array[index], index, array)) {
                      return index;
                    }
                  }
                  return -1;
                }

                _module336.exports = baseFindIndex;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsNaN.js": function module(_require334, _exports334, _module337) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsNaN.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.isNaN` without support for number objects.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                 */
                function baseIsNaN(value) {
                  return value !== value;
                }

                _module337.exports = baseIsNaN;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_strictIndexOf.js": function module(_require335, _exports335, _module338) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_strictIndexOf.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.indexOf` which performs strict equality
                 * comparisons of values, i.e. `===`.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} fromIndex The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 */
                function strictIndexOf(array, value, fromIndex) {
                  var index = fromIndex - 1,
                      length = array.length;

                  while (++index < length) {
                    if (array[index] === value) {
                      return index;
                    }
                  }
                  return -1;
                }

                _module338.exports = strictIndexOf;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isString.js": function module(_require336, _exports336, _module339) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isString.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require336('./_baseGetTag'),
                    isArray = _require336('./isArray'),
                    isObjectLike = _require336('./isObjectLike');

                /** `Object#toString` result references. */
                var stringTag = '[object String]';

                /**
                 * Checks if `value` is classified as a `String` primitive or object.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
                 * @example
                 *
                 * _.isString('abc');
                 * // => true
                 *
                 * _.isString(1);
                 * // => false
                 */
                function isString(value) {
                  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
                }

                _module339.exports = isString;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "toInteger.js": function module(_require337, _exports337, _module340) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/toInteger.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var toFinite = _require337('./toFinite');

                /**
                 * Converts `value` to an integer.
                 *
                 * **Note:** This method is loosely based on
                 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {number} Returns the converted integer.
                 * @example
                 *
                 * _.toInteger(3.2);
                 * // => 3
                 *
                 * _.toInteger(Number.MIN_VALUE);
                 * // => 0
                 *
                 * _.toInteger(Infinity);
                 * // => 1.7976931348623157e+308
                 *
                 * _.toInteger('3.2');
                 * // => 3
                 */
                function toInteger(value) {
                  var result = toFinite(value),
                      remainder = result % 1;

                  return result === result ? remainder ? result - remainder : result : 0;
                }

                _module340.exports = toInteger;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "toFinite.js": function module(_require338, _exports338, _module341) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/toFinite.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var toNumber = _require338('./toNumber');

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0,
                    MAX_INTEGER = 1.7976931348623157e+308;

                /**
                 * Converts `value` to a finite number.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.12.0
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {number} Returns the converted number.
                 * @example
                 *
                 * _.toFinite(3.2);
                 * // => 3.2
                 *
                 * _.toFinite(Number.MIN_VALUE);
                 * // => 5e-324
                 *
                 * _.toFinite(Infinity);
                 * // => 1.7976931348623157e+308
                 *
                 * _.toFinite('3.2');
                 * // => 3.2
                 */
                function toFinite(value) {
                  if (!value) {
                    return value === 0 ? value : 0;
                  }
                  value = toNumber(value);
                  if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                  }
                  return value === value ? value : 0;
                }

                _module341.exports = toFinite;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "toNumber.js": function module(_require339, _exports339, _module342) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/toNumber.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isObject = _require339('./isObject'),
                    isSymbol = _require339('./isSymbol');

                /** Used as references for various `Number` constants. */
                var NAN = 0 / 0;

                /** Used to match leading and trailing whitespace. */
                var reTrim = /^\s+|\s+$/g;

                /** Used to detect bad signed hexadecimal string values. */
                var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

                /** Used to detect binary string values. */
                var reIsBinary = /^0b[01]+$/i;

                /** Used to detect octal string values. */
                var reIsOctal = /^0o[0-7]+$/i;

                /** Built-in method references without a dependency on `root`. */
                var freeParseInt = parseInt;

                /**
                 * Converts `value` to a number.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to process.
                 * @returns {number} Returns the number.
                 * @example
                 *
                 * _.toNumber(3.2);
                 * // => 3.2
                 *
                 * _.toNumber(Number.MIN_VALUE);
                 * // => 5e-324
                 *
                 * _.toNumber(Infinity);
                 * // => Infinity
                 *
                 * _.toNumber('3.2');
                 * // => 3.2
                 */
                function toNumber(value) {
                  if (typeof value == 'number') {
                    return value;
                  }
                  if (isSymbol(value)) {
                    return NAN;
                  }
                  if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                  }
                  if (typeof value != 'string') {
                    return value === 0 ? value : +value;
                  }
                  value = value.replace(reTrim, '');
                  var isBinary = reIsBinary.test(value);
                  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
                }

                _module342.exports = toNumber;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "values.js": function module(_require340, _exports340, _module343) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/values.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseValues = _require340('./_baseValues'),
                    keys = _require340('./keys');

                /**
                 * Creates an array of the own enumerable string keyed property values of `object`.
                 *
                 * **Note:** Non-object values are coerced to objects.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property values.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.values(new Foo);
                 * // => [1, 2] (iteration order is not guaranteed)
                 *
                 * _.values('hi');
                 * // => ['h', 'i']
                 */
                function values(object) {
                  return object == null ? [] : baseValues(object, keys(object));
                }

                _module343.exports = values;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseValues.js": function module(_require341, _exports341, _module344) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseValues.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayMap = _require341('./_arrayMap');

                /**
                 * The base implementation of `_.values` and `_.valuesIn` which creates an
                 * array of `object` property values corresponding to the property names
                 * of `props`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array} props The property names to get values for.
                 * @returns {Object} Returns the array of property values.
                 */
                function baseValues(object, props) {
                  return arrayMap(props, function (key) {
                    return object[key];
                  });
                }

                _module344.exports = baseValues;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "intersection.js": function module(_require342, _exports342, _module345) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/intersection.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayMap = _require342('./_arrayMap'),
                    baseIntersection = _require342('./_baseIntersection'),
                    baseRest = _require342('./_baseRest'),
                    castArrayLikeObject = _require342('./_castArrayLikeObject');

                /**
                 * Creates an array of unique values that are included in all given arrays
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons. The order and references of result values are
                 * determined by the first array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {...Array} [arrays] The arrays to inspect.
                 * @returns {Array} Returns the new array of intersecting values.
                 * @example
                 *
                 * _.intersection([2, 1], [2, 3]);
                 * // => [2]
                 */
                var intersection = baseRest(function (arrays) {
                  var mapped = arrayMap(arrays, castArrayLikeObject);
                  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
                });

                _module345.exports = intersection;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIntersection.js": function module(_require343, _exports343, _module346) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIntersection.js                                        //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var SetCache = _require343('./_SetCache'),
                    arrayIncludes = _require343('./_arrayIncludes'),
                    arrayIncludesWith = _require343('./_arrayIncludesWith'),
                    arrayMap = _require343('./_arrayMap'),
                    baseUnary = _require343('./_baseUnary'),
                    cacheHas = _require343('./_cacheHas');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMin = Math.min;

                /**
                 * The base implementation of methods like `_.intersection`, without support
                 * for iteratee shorthands, that accepts an array of arrays to inspect.
                 *
                 * @private
                 * @param {Array} arrays The arrays to inspect.
                 * @param {Function} [iteratee] The iteratee invoked per element.
                 * @param {Function} [comparator] The comparator invoked per element.
                 * @returns {Array} Returns the new array of shared values.
                 */
                function baseIntersection(arrays, iteratee, comparator) {
                  var includes = comparator ? arrayIncludesWith : arrayIncludes,
                      length = arrays[0].length,
                      othLength = arrays.length,
                      othIndex = othLength,
                      caches = Array(othLength),
                      maxLength = Infinity,
                      result = [];

                  while (othIndex--) {
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) {
                      array = arrayMap(array, baseUnary(iteratee));
                    }
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                  }
                  array = arrays[0];

                  var index = -1,
                      seen = caches[0];

                  outer: while (++index < length && result.length < maxLength) {
                    var value = array[index],
                        computed = iteratee ? iteratee(value) : value;

                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                      othIndex = othLength;
                      while (--othIndex) {
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                          continue outer;
                        }
                      }
                      if (seen) {
                        seen.push(computed);
                      }
                      result.push(value);
                    }
                  }
                  return result;
                }

                _module346.exports = baseIntersection;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_SetCache.js": function module(_require344, _exports344, _module347) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_SetCache.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var MapCache = _require344('./_MapCache'),
                    setCacheAdd = _require344('./_setCacheAdd'),
                    setCacheHas = _require344('./_setCacheHas');

                /**
                 *
                 * Creates an array cache object to store unique values.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [values] The values to cache.
                 */
                function SetCache(values) {
                  var index = -1,
                      length = values == null ? 0 : values.length;

                  this.__data__ = new MapCache();
                  while (++index < length) {
                    this.add(values[index]);
                  }
                }

                // Add methods to `SetCache`.
                SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
                SetCache.prototype.has = setCacheHas;

                _module347.exports = SetCache;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_setCacheAdd.js": function module(_require345, _exports345, _module348) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_setCacheAdd.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to stand-in for `undefined` hash values. */
                var HASH_UNDEFINED = '__lodash_hash_undefined__';

                /**
                 * Adds `value` to the array cache.
                 *
                 * @private
                 * @name add
                 * @memberOf SetCache
                 * @alias push
                 * @param {*} value The value to cache.
                 * @returns {Object} Returns the cache instance.
                 */
                function setCacheAdd(value) {
                  this.__data__.set(value, HASH_UNDEFINED);
                  return this;
                }

                _module348.exports = setCacheAdd;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_setCacheHas.js": function module(_require346, _exports346, _module349) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_setCacheHas.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is in the array cache.
                 *
                 * @private
                 * @name has
                 * @memberOf SetCache
                 * @param {*} value The value to search for.
                 * @returns {number} Returns `true` if `value` is found, else `false`.
                 */
                function setCacheHas(value) {
                  return this.__data__.has(value);
                }

                _module349.exports = setCacheHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayIncludes.js": function module(_require347, _exports347, _module350) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayIncludes.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIndexOf = _require347('./_baseIndexOf');

                /**
                 * A specialized version of `_.includes` for arrays without support for
                 * specifying an index to search from.
                 *
                 * @private
                 * @param {Array} [array] The array to inspect.
                 * @param {*} target The value to search for.
                 * @returns {boolean} Returns `true` if `target` is found, else `false`.
                 */
                function arrayIncludes(array, value) {
                  var length = array == null ? 0 : array.length;
                  return !!length && baseIndexOf(array, value, 0) > -1;
                }

                _module350.exports = arrayIncludes;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayIncludesWith.js": function module(_require348, _exports348, _module351) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayIncludesWith.js                                       //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This function is like `arrayIncludes` except that it accepts a comparator.
                 *
                 * @private
                 * @param {Array} [array] The array to inspect.
                 * @param {*} target The value to search for.
                 * @param {Function} comparator The comparator invoked per element.
                 * @returns {boolean} Returns `true` if `target` is found, else `false`.
                 */
                function arrayIncludesWith(array, value, comparator) {
                  var index = -1,
                      length = array == null ? 0 : array.length;

                  while (++index < length) {
                    if (comparator(value, array[index])) {
                      return true;
                    }
                  }
                  return false;
                }

                _module351.exports = arrayIncludesWith;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cacheHas.js": function module(_require349, _exports349, _module352) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cacheHas.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if a `cache` value for `key` exists.
                 *
                 * @private
                 * @param {Object} cache The cache to query.
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function cacheHas(cache, key) {
                  return cache.has(key);
                }

                _module352.exports = cacheHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_castArrayLikeObject.js": function module(_require350, _exports350, _module353) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_castArrayLikeObject.js                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isArrayLikeObject = _require350('./isArrayLikeObject');

                /**
                 * Casts `value` to an empty array if it's not an array like object.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @returns {Array|Object} Returns the cast array-like object.
                 */
                function castArrayLikeObject(value) {
                  return isArrayLikeObject(value) ? value : [];
                }

                _module353.exports = castArrayLikeObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isArrayLikeObject.js": function module(_require351, _exports351, _module354) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isArrayLikeObject.js                                        //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isArrayLike = _require351('./isArrayLike'),
                    isObjectLike = _require351('./isObjectLike');

                /**
                 * This method is like `_.isArrayLike` except that it also checks if `value`
                 * is an object.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an array-like object,
                 *  else `false`.
                 * @example
                 *
                 * _.isArrayLikeObject([1, 2, 3]);
                 * // => true
                 *
                 * _.isArrayLikeObject(document.body.children);
                 * // => true
                 *
                 * _.isArrayLikeObject('abc');
                 * // => false
                 *
                 * _.isArrayLikeObject(_.noop);
                 * // => false
                 */
                function isArrayLikeObject(value) {
                  return isObjectLike(value) && isArrayLike(value);
                }

                _module354.exports = isArrayLikeObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isNumber.js": function module(_require352, _exports352, _module355) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isNumber.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require352('./_baseGetTag'),
                    isObjectLike = _require352('./isObjectLike');

                /** `Object#toString` result references. */
                var numberTag = '[object Number]';

                /**
                 * Checks if `value` is classified as a `Number` primitive or object.
                 *
                 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
                 * classified as numbers, use the `_.isFinite` method.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
                 * @example
                 *
                 * _.isNumber(3);
                 * // => true
                 *
                 * _.isNumber(Number.MIN_VALUE);
                 * // => true
                 *
                 * _.isNumber(Infinity);
                 * // => true
                 *
                 * _.isNumber('3');
                 * // => false
                 */
                function isNumber(value) {
                  return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
                }

                _module355.exports = isNumber;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "cloneDeepWith.js": function module(_require353, _exports353, _module356) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/cloneDeepWith.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseClone = _require353('./_baseClone');

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_SYMBOLS_FLAG = 4;

                /**
                 * This method is like `_.cloneWith` except that it recursively clones `value`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to recursively clone.
                 * @param {Function} [customizer] The function to customize cloning.
                 * @returns {*} Returns the deep cloned value.
                 * @see _.cloneWith
                 * @example
                 *
                 * function customizer(value) {
                 *   if (_.isElement(value)) {
                 *     return value.cloneNode(true);
                 *   }
                 * }
                 *
                 * var el = _.cloneDeepWith(document.body, customizer);
                 *
                 * console.log(el === document.body);
                 * // => false
                 * console.log(el.nodeName);
                 * // => 'BODY'
                 * console.log(el.childNodes.length);
                 * // => 20
                 */
                function cloneDeepWith(value, customizer) {
                  customizer = typeof customizer == 'function' ? customizer : undefined;
                  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
                }

                _module356.exports = cloneDeepWith;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseClone.js": function module(_require354, _exports354, _module357) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseClone.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Stack = _require354('./_Stack'),
                    arrayEach = _require354('./_arrayEach'),
                    assignValue = _require354('./_assignValue'),
                    baseAssign = _require354('./_baseAssign'),
                    baseAssignIn = _require354('./_baseAssignIn'),
                    cloneBuffer = _require354('./_cloneBuffer'),
                    copyArray = _require354('./_copyArray'),
                    copySymbols = _require354('./_copySymbols'),
                    copySymbolsIn = _require354('./_copySymbolsIn'),
                    getAllKeys = _require354('./_getAllKeys'),
                    getAllKeysIn = _require354('./_getAllKeysIn'),
                    getTag = _require354('./_getTag'),
                    initCloneArray = _require354('./_initCloneArray'),
                    initCloneByTag = _require354('./_initCloneByTag'),
                    initCloneObject = _require354('./_initCloneObject'),
                    isArray = _require354('./isArray'),
                    isBuffer = _require354('./isBuffer'),
                    isObject = _require354('./isObject'),
                    keys = _require354('./keys');

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_FLAT_FLAG = 2,
                    CLONE_SYMBOLS_FLAG = 4;

                /** `Object#toString` result references. */
                var argsTag = '[object Arguments]',
                    arrayTag = '[object Array]',
                    boolTag = '[object Boolean]',
                    dateTag = '[object Date]',
                    errorTag = '[object Error]',
                    funcTag = '[object Function]',
                    genTag = '[object GeneratorFunction]',
                    mapTag = '[object Map]',
                    numberTag = '[object Number]',
                    objectTag = '[object Object]',
                    regexpTag = '[object RegExp]',
                    setTag = '[object Set]',
                    stringTag = '[object String]',
                    symbolTag = '[object Symbol]',
                    weakMapTag = '[object WeakMap]';

                var arrayBufferTag = '[object ArrayBuffer]',
                    dataViewTag = '[object DataView]',
                    float32Tag = '[object Float32Array]',
                    float64Tag = '[object Float64Array]',
                    int8Tag = '[object Int8Array]',
                    int16Tag = '[object Int16Array]',
                    int32Tag = '[object Int32Array]',
                    uint8Tag = '[object Uint8Array]',
                    uint8ClampedTag = '[object Uint8ClampedArray]',
                    uint16Tag = '[object Uint16Array]',
                    uint32Tag = '[object Uint32Array]';

                /** Used to identify `toStringTag` values supported by `_.clone`. */
                var cloneableTags = {};
                cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
                cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

                /**
                 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
                 * traversed objects.
                 *
                 * @private
                 * @param {*} value The value to clone.
                 * @param {boolean} bitmask The bitmask flags.
                 *  1 - Deep clone
                 *  2 - Flatten inherited properties
                 *  4 - Clone symbols
                 * @param {Function} [customizer] The function to customize cloning.
                 * @param {string} [key] The key of `value`.
                 * @param {Object} [object] The parent object of `value`.
                 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
                 * @returns {*} Returns the cloned value.
                 */
                function baseClone(value, bitmask, customizer, key, object, stack) {
                  var result,
                      isDeep = bitmask & CLONE_DEEP_FLAG,
                      isFlat = bitmask & CLONE_FLAT_FLAG,
                      isFull = bitmask & CLONE_SYMBOLS_FLAG;

                  if (customizer) {
                    result = object ? customizer(value, key, object, stack) : customizer(value);
                  }
                  if (result !== undefined) {
                    return result;
                  }
                  if (!isObject(value)) {
                    return value;
                  }
                  var isArr = isArray(value);
                  if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) {
                      return copyArray(value, result);
                    }
                  } else {
                    var tag = getTag(value),
                        isFunc = tag == funcTag || tag == genTag;

                    if (isBuffer(value)) {
                      return cloneBuffer(value, isDeep);
                    }
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                      result = isFlat || isFunc ? {} : initCloneObject(value);
                      if (!isDeep) {
                        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                      }
                    } else {
                      if (!cloneableTags[tag]) {
                        return object ? value : {};
                      }
                      result = initCloneByTag(value, tag, baseClone, isDeep);
                    }
                  }
                  // Check for circular references and return its corresponding clone.
                  stack || (stack = new Stack());
                  var stacked = stack.get(value);
                  if (stacked) {
                    return stacked;
                  }
                  stack.set(value, result);

                  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

                  var props = isArr ? undefined : keysFunc(value);
                  arrayEach(props || value, function (subValue, key) {
                    if (props) {
                      key = subValue;
                      subValue = value[key];
                    }
                    // Recursively populate clone (susceptible to call stack limits).
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                  });
                  return result;
                }

                _module357.exports = baseClone;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Stack.js": function module(_require355, _exports355, _module358) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Stack.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var ListCache = _require355('./_ListCache'),
                    stackClear = _require355('./_stackClear'),
                    stackDelete = _require355('./_stackDelete'),
                    stackGet = _require355('./_stackGet'),
                    stackHas = _require355('./_stackHas'),
                    stackSet = _require355('./_stackSet');

                /**
                 * Creates a stack cache object to store key-value pairs.
                 *
                 * @private
                 * @constructor
                 * @param {Array} [entries] The key-value pairs to cache.
                 */
                function Stack(entries) {
                  var data = this.__data__ = new ListCache(entries);
                  this.size = data.size;
                }

                // Add methods to `Stack`.
                Stack.prototype.clear = stackClear;
                Stack.prototype['delete'] = stackDelete;
                Stack.prototype.get = stackGet;
                Stack.prototype.has = stackHas;
                Stack.prototype.set = stackSet;

                _module358.exports = Stack;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stackClear.js": function module(_require356, _exports356, _module359) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stackClear.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var ListCache = _require356('./_ListCache');

                /**
                 * Removes all key-value entries from the stack.
                 *
                 * @private
                 * @name clear
                 * @memberOf Stack
                 */
                function stackClear() {
                  this.__data__ = new ListCache();
                  this.size = 0;
                }

                _module359.exports = stackClear;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stackDelete.js": function module(_require357, _exports357, _module360) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stackDelete.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Removes `key` and its value from the stack.
                 *
                 * @private
                 * @name delete
                 * @memberOf Stack
                 * @param {string} key The key of the value to remove.
                 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
                 */
                function stackDelete(key) {
                  var data = this.__data__,
                      result = data['delete'](key);

                  this.size = data.size;
                  return result;
                }

                _module360.exports = stackDelete;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stackGet.js": function module(_require358, _exports358, _module361) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stackGet.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Gets the stack value for `key`.
                 *
                 * @private
                 * @name get
                 * @memberOf Stack
                 * @param {string} key The key of the value to get.
                 * @returns {*} Returns the entry value.
                 */
                function stackGet(key) {
                  return this.__data__.get(key);
                }

                _module361.exports = stackGet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stackHas.js": function module(_require359, _exports359, _module362) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stackHas.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if a stack value for `key` exists.
                 *
                 * @private
                 * @name has
                 * @memberOf Stack
                 * @param {string} key The key of the entry to check.
                 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
                 */
                function stackHas(key) {
                  return this.__data__.has(key);
                }

                _module362.exports = stackHas;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stackSet.js": function module(_require360, _exports360, _module363) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stackSet.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var ListCache = _require360('./_ListCache'),
                    Map = _require360('./_Map'),
                    MapCache = _require360('./_MapCache');

                /** Used as the size to enable large array optimizations. */
                var LARGE_ARRAY_SIZE = 200;

                /**
                 * Sets the stack `key` to `value`.
                 *
                 * @private
                 * @name set
                 * @memberOf Stack
                 * @param {string} key The key of the value to set.
                 * @param {*} value The value to set.
                 * @returns {Object} Returns the stack cache instance.
                 */
                function stackSet(key, value) {
                  var data = this.__data__;
                  if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                      pairs.push([key, value]);
                      this.size = ++data.size;
                      return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                  }
                  data.set(key, value);
                  this.size = data.size;
                  return this;
                }

                _module363.exports = stackSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseAssign.js": function module(_require361, _exports361, _module364) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseAssign.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require361('./_copyObject'),
                    keys = _require361('./keys');

                /**
                 * The base implementation of `_.assign` without support for multiple sources
                 * or `customizer` functions.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @returns {Object} Returns `object`.
                 */
                function baseAssign(object, source) {
                  return object && copyObject(source, keys(source), object);
                }

                _module364.exports = baseAssign;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseAssignIn.js": function module(_require362, _exports362, _module365) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseAssignIn.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require362('./_copyObject'),
                    keysIn = _require362('./keysIn');

                /**
                 * The base implementation of `_.assignIn` without support for multiple sources
                 * or `customizer` functions.
                 *
                 * @private
                 * @param {Object} object The destination object.
                 * @param {Object} source The source object.
                 * @returns {Object} Returns `object`.
                 */
                function baseAssignIn(object, source) {
                  return object && copyObject(source, keysIn(source), object);
                }

                _module365.exports = baseAssignIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneBuffer.js": function module(_require363, _exports363, _module366) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneBuffer.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var root = _require363('./_root');

                /** Detect free variable `exports`. */
                var freeExports = typeof _exports363 == 'object' && _exports363 && !_exports363.nodeType && _exports363;

                /** Detect free variable `module`. */
                var freeModule = freeExports && typeof _module366 == 'object' && _module366 && !_module366.nodeType && _module366;

                /** Detect the popular CommonJS extension `module.exports`. */
                var moduleExports = freeModule && freeModule.exports === freeExports;

                /** Built-in value references. */
                var Buffer = moduleExports ? root.Buffer : undefined,
                    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

                /**
                 * Creates a clone of  `buffer`.
                 *
                 * @private
                 * @param {Buffer} buffer The buffer to clone.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Buffer} Returns the cloned buffer.
                 */
                function cloneBuffer(buffer, isDeep) {
                  if (isDeep) {
                    return buffer.slice();
                  }
                  var length = buffer.length,
                      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

                  buffer.copy(result);
                  return result;
                }

                _module366.exports = cloneBuffer;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_copySymbols.js": function module(_require364, _exports364, _module367) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_copySymbols.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require364('./_copyObject'),
                    getSymbols = _require364('./_getSymbols');

                /**
                 * Copies own symbols of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy symbols from.
                 * @param {Object} [object={}] The object to copy symbols to.
                 * @returns {Object} Returns `object`.
                 */
                function copySymbols(source, object) {
                  return copyObject(source, getSymbols(source), object);
                }

                _module367.exports = copySymbols;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getSymbols.js": function module(_require365, _exports365, _module368) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getSymbols.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayFilter = _require365('./_arrayFilter'),
                    stubArray = _require365('./stubArray');

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Built-in value references. */
                var propertyIsEnumerable = objectProto.propertyIsEnumerable;

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeGetSymbols = Object.getOwnPropertySymbols;

                /**
                 * Creates an array of the own enumerable symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of symbols.
                 */
                var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
                  if (object == null) {
                    return [];
                  }
                  object = Object(object);
                  return arrayFilter(nativeGetSymbols(object), function (symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                  });
                };

                _module368.exports = getSymbols;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayFilter.js": function module(_require366, _exports366, _module369) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayFilter.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.filter` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 */
                function arrayFilter(array, predicate) {
                  var index = -1,
                      length = array == null ? 0 : array.length,
                      resIndex = 0,
                      result = [];

                  while (++index < length) {
                    var value = array[index];
                    if (predicate(value, index, array)) {
                      result[resIndex++] = value;
                    }
                  }
                  return result;
                }

                _module369.exports = arrayFilter;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "stubArray.js": function module(_require367, _exports367, _module370) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/stubArray.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This method returns a new empty array.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.13.0
                 * @category Util
                 * @returns {Array} Returns the new empty array.
                 * @example
                 *
                 * var arrays = _.times(2, _.stubArray);
                 *
                 * console.log(arrays);
                 * // => [[], []]
                 *
                 * console.log(arrays[0] === arrays[1]);
                 * // => false
                 */
                function stubArray() {
                  return [];
                }

                _module370.exports = stubArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_copySymbolsIn.js": function module(_require368, _exports368, _module371) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_copySymbolsIn.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require368('./_copyObject'),
                    getSymbolsIn = _require368('./_getSymbolsIn');

                /**
                 * Copies own and inherited symbols of `source` to `object`.
                 *
                 * @private
                 * @param {Object} source The object to copy symbols from.
                 * @param {Object} [object={}] The object to copy symbols to.
                 * @returns {Object} Returns `object`.
                 */
                function copySymbolsIn(source, object) {
                  return copyObject(source, getSymbolsIn(source), object);
                }

                _module371.exports = copySymbolsIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getSymbolsIn.js": function module(_require369, _exports369, _module372) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getSymbolsIn.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayPush = _require369('./_arrayPush'),
                    getPrototype = _require369('./_getPrototype'),
                    getSymbols = _require369('./_getSymbols'),
                    stubArray = _require369('./stubArray');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeGetSymbols = Object.getOwnPropertySymbols;

                /**
                 * Creates an array of the own and inherited enumerable symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of symbols.
                 */
                var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
                  var result = [];
                  while (object) {
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                  }
                  return result;
                };

                _module372.exports = getSymbolsIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getPrototype.js": function module(_require370, _exports370, _module373) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getPrototype.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var overArg = _require370('./_overArg');

                /** Built-in value references. */
                var getPrototype = overArg(Object.getPrototypeOf, Object);

                _module373.exports = getPrototype;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getAllKeys.js": function module(_require371, _exports371, _module374) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getAllKeys.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetAllKeys = _require371('./_baseGetAllKeys'),
                    getSymbols = _require371('./_getSymbols'),
                    keys = _require371('./keys');

                /**
                 * Creates an array of own enumerable property names and symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function getAllKeys(object) {
                  return baseGetAllKeys(object, keys, getSymbols);
                }

                _module374.exports = getAllKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseGetAllKeys.js": function module(_require372, _exports372, _module375) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseGetAllKeys.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayPush = _require372('./_arrayPush'),
                    isArray = _require372('./isArray');

                /**
                 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
                 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
                 * symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Function} keysFunc The function to get the keys of `object`.
                 * @param {Function} symbolsFunc The function to get the symbols of `object`.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                  var result = keysFunc(object);
                  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
                }

                _module375.exports = baseGetAllKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getAllKeysIn.js": function module(_require373, _exports373, _module376) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getAllKeysIn.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetAllKeys = _require373('./_baseGetAllKeys'),
                    getSymbolsIn = _require373('./_getSymbolsIn'),
                    keysIn = _require373('./keysIn');

                /**
                 * Creates an array of own and inherited enumerable property names and
                 * symbols of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the array of property names and symbols.
                 */
                function getAllKeysIn(object) {
                  return baseGetAllKeys(object, keysIn, getSymbolsIn);
                }

                _module376.exports = getAllKeysIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getTag.js": function module(_require374, _exports374, _module377) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getTag.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var DataView = _require374('./_DataView'),
                    Map = _require374('./_Map'),
                    Promise = _require374('./_Promise'),
                    Set = _require374('./_Set'),
                    WeakMap = _require374('./_WeakMap'),
                    baseGetTag = _require374('./_baseGetTag'),
                    toSource = _require374('./_toSource');

                /** `Object#toString` result references. */
                var mapTag = '[object Map]',
                    objectTag = '[object Object]',
                    promiseTag = '[object Promise]',
                    setTag = '[object Set]',
                    weakMapTag = '[object WeakMap]';

                var dataViewTag = '[object DataView]';

                /** Used to detect maps, sets, and weakmaps. */
                var dataViewCtorString = toSource(DataView),
                    mapCtorString = toSource(Map),
                    promiseCtorString = toSource(Promise),
                    setCtorString = toSource(Set),
                    weakMapCtorString = toSource(WeakMap);

                /**
                 * Gets the `toStringTag` of `value`.
                 *
                 * @private
                 * @param {*} value The value to query.
                 * @returns {string} Returns the `toStringTag`.
                 */
                var getTag = baseGetTag;

                // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
                if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
                  getTag = function (value) {
                    var result = baseGetTag(value),
                        Ctor = result == objectTag ? value.constructor : undefined,
                        ctorString = Ctor ? toSource(Ctor) : '';

                    if (ctorString) {
                      switch (ctorString) {
                        case dataViewCtorString:
                          return dataViewTag;
                        case mapCtorString:
                          return mapTag;
                        case promiseCtorString:
                          return promiseTag;
                        case setCtorString:
                          return setTag;
                        case weakMapCtorString:
                          return weakMapTag;
                      }
                    }
                    return result;
                  };
                }

                _module377.exports = getTag;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_DataView.js": function module(_require375, _exports375, _module378) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_DataView.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require375('./_getNative'),
                    root = _require375('./_root');

                /* Built-in method references that are verified to be native. */
                var DataView = getNative(root, 'DataView');

                _module378.exports = DataView;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Promise.js": function module(_require376, _exports376, _module379) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Promise.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require376('./_getNative'),
                    root = _require376('./_root');

                /* Built-in method references that are verified to be native. */
                var Promise = getNative(root, 'Promise');

                _module379.exports = Promise;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Set.js": function module(_require377, _exports377, _module380) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Set.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require377('./_getNative'),
                    root = _require377('./_root');

                /* Built-in method references that are verified to be native. */
                var Set = getNative(root, 'Set');

                _module380.exports = Set;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_WeakMap.js": function module(_require378, _exports378, _module381) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_WeakMap.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getNative = _require378('./_getNative'),
                    root = _require378('./_root');

                /* Built-in method references that are verified to be native. */
                var WeakMap = getNative(root, 'WeakMap');

                _module381.exports = WeakMap;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_initCloneArray.js": function module(_require379, _exports379, _module382) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_initCloneArray.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * Initializes an array clone.
                 *
                 * @private
                 * @param {Array} array The array to clone.
                 * @returns {Array} Returns the initialized clone.
                 */
                function initCloneArray(array) {
                  var length = array.length,
                      result = array.constructor(length);

                  // Add properties assigned by `RegExp#exec`.
                  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                  }
                  return result;
                }

                _module382.exports = initCloneArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_initCloneByTag.js": function module(_require380, _exports380, _module383) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_initCloneByTag.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var cloneArrayBuffer = _require380('./_cloneArrayBuffer'),
                    cloneDataView = _require380('./_cloneDataView'),
                    cloneMap = _require380('./_cloneMap'),
                    cloneRegExp = _require380('./_cloneRegExp'),
                    cloneSet = _require380('./_cloneSet'),
                    cloneSymbol = _require380('./_cloneSymbol'),
                    cloneTypedArray = _require380('./_cloneTypedArray');

                /** `Object#toString` result references. */
                var boolTag = '[object Boolean]',
                    dateTag = '[object Date]',
                    mapTag = '[object Map]',
                    numberTag = '[object Number]',
                    regexpTag = '[object RegExp]',
                    setTag = '[object Set]',
                    stringTag = '[object String]',
                    symbolTag = '[object Symbol]';

                var arrayBufferTag = '[object ArrayBuffer]',
                    dataViewTag = '[object DataView]',
                    float32Tag = '[object Float32Array]',
                    float64Tag = '[object Float64Array]',
                    int8Tag = '[object Int8Array]',
                    int16Tag = '[object Int16Array]',
                    int32Tag = '[object Int32Array]',
                    uint8Tag = '[object Uint8Array]',
                    uint8ClampedTag = '[object Uint8ClampedArray]',
                    uint16Tag = '[object Uint16Array]',
                    uint32Tag = '[object Uint32Array]';

                /**
                 * Initializes an object clone based on its `toStringTag`.
                 *
                 * **Note:** This function only supports cloning values with tags of
                 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                 *
                 * @private
                 * @param {Object} object The object to clone.
                 * @param {string} tag The `toStringTag` of the object to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the initialized clone.
                 */
                function initCloneByTag(object, tag, cloneFunc, isDeep) {
                  var Ctor = object.constructor;
                  switch (tag) {
                    case arrayBufferTag:
                      return cloneArrayBuffer(object);

                    case boolTag:
                    case dateTag:
                      return new Ctor(+object);

                    case dataViewTag:
                      return cloneDataView(object, isDeep);

                    case float32Tag:case float64Tag:
                    case int8Tag:case int16Tag:case int32Tag:
                    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
                      return cloneTypedArray(object, isDeep);

                    case mapTag:
                      return cloneMap(object, isDeep, cloneFunc);

                    case numberTag:
                    case stringTag:
                      return new Ctor(object);

                    case regexpTag:
                      return cloneRegExp(object);

                    case setTag:
                      return cloneSet(object, isDeep, cloneFunc);

                    case symbolTag:
                      return cloneSymbol(object);
                  }
                }

                _module383.exports = initCloneByTag;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneArrayBuffer.js": function module(_require381, _exports381, _module384) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneArrayBuffer.js                                        //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Uint8Array = _require381('./_Uint8Array');

                /**
                 * Creates a clone of `arrayBuffer`.
                 *
                 * @private
                 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
                 * @returns {ArrayBuffer} Returns the cloned array buffer.
                 */
                function cloneArrayBuffer(arrayBuffer) {
                  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                  return result;
                }

                _module384.exports = cloneArrayBuffer;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_Uint8Array.js": function module(_require382, _exports382, _module385) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_Uint8Array.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var root = _require382('./_root');

                /** Built-in value references. */
                var Uint8Array = root.Uint8Array;

                _module385.exports = Uint8Array;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneDataView.js": function module(_require383, _exports383, _module386) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneDataView.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var cloneArrayBuffer = _require383('./_cloneArrayBuffer');

                /**
                 * Creates a clone of `dataView`.
                 *
                 * @private
                 * @param {Object} dataView The data view to clone.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned data view.
                 */
                function cloneDataView(dataView, isDeep) {
                  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
                }

                _module386.exports = cloneDataView;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneMap.js": function module(_require384, _exports384, _module387) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneMap.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var addMapEntry = _require384('./_addMapEntry'),
                    arrayReduce = _require384('./_arrayReduce'),
                    mapToArray = _require384('./_mapToArray');

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1;

                /**
                 * Creates a clone of `map`.
                 *
                 * @private
                 * @param {Object} map The map to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned map.
                 */
                function cloneMap(map, isDeep, cloneFunc) {
                  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
                  return arrayReduce(array, addMapEntry, new map.constructor());
                }

                _module387.exports = cloneMap;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_addMapEntry.js": function module(_require385, _exports385, _module388) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_addMapEntry.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Adds the key-value `pair` to `map`.
                 *
                 * @private
                 * @param {Object} map The map to modify.
                 * @param {Array} pair The key-value pair to add.
                 * @returns {Object} Returns `map`.
                 */
                function addMapEntry(map, pair) {
                  // Don't return `map.set` because it's not chainable in IE 11.
                  map.set(pair[0], pair[1]);
                  return map;
                }

                _module388.exports = addMapEntry;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayReduce.js": function module(_require386, _exports386, _module389) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayReduce.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.reduce` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @param {*} [accumulator] The initial value.
                 * @param {boolean} [initAccum] Specify using the first element of `array` as
                 *  the initial value.
                 * @returns {*} Returns the accumulated value.
                 */
                function arrayReduce(array, iteratee, accumulator, initAccum) {
                  var index = -1,
                      length = array == null ? 0 : array.length;

                  if (initAccum && length) {
                    accumulator = array[++index];
                  }
                  while (++index < length) {
                    accumulator = iteratee(accumulator, array[index], index, array);
                  }
                  return accumulator;
                }

                _module389.exports = arrayReduce;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_mapToArray.js": function module(_require387, _exports387, _module390) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_mapToArray.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Converts `map` to its key-value pairs.
                 *
                 * @private
                 * @param {Object} map The map to convert.
                 * @returns {Array} Returns the key-value pairs.
                 */
                function mapToArray(map) {
                  var index = -1,
                      result = Array(map.size);

                  map.forEach(function (value, key) {
                    result[++index] = [key, value];
                  });
                  return result;
                }

                _module390.exports = mapToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneRegExp.js": function module(_require388, _exports388, _module391) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneRegExp.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to match `RegExp` flags from their coerced string values. */
                var reFlags = /\w*$/;

                /**
                 * Creates a clone of `regexp`.
                 *
                 * @private
                 * @param {Object} regexp The regexp to clone.
                 * @returns {Object} Returns the cloned regexp.
                 */
                function cloneRegExp(regexp) {
                  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                  result.lastIndex = regexp.lastIndex;
                  return result;
                }

                _module391.exports = cloneRegExp;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneSet.js": function module(_require389, _exports389, _module392) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneSet.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var addSetEntry = _require389('./_addSetEntry'),
                    arrayReduce = _require389('./_arrayReduce'),
                    setToArray = _require389('./_setToArray');

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1;

                /**
                 * Creates a clone of `set`.
                 *
                 * @private
                 * @param {Object} set The set to clone.
                 * @param {Function} cloneFunc The function to clone values.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned set.
                 */
                function cloneSet(set, isDeep, cloneFunc) {
                  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
                  return arrayReduce(array, addSetEntry, new set.constructor());
                }

                _module392.exports = cloneSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_addSetEntry.js": function module(_require390, _exports390, _module393) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_addSetEntry.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Adds `value` to `set`.
                 *
                 * @private
                 * @param {Object} set The set to modify.
                 * @param {*} value The value to add.
                 * @returns {Object} Returns `set`.
                 */
                function addSetEntry(set, value) {
                  // Don't return `set.add` because it's not chainable in IE 11.
                  set.add(value);
                  return set;
                }

                _module393.exports = addSetEntry;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_setToArray.js": function module(_require391, _exports391, _module394) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_setToArray.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Converts `set` to an array of its values.
                 *
                 * @private
                 * @param {Object} set The set to convert.
                 * @returns {Array} Returns the values.
                 */
                function setToArray(set) {
                  var index = -1,
                      result = Array(set.size);

                  set.forEach(function (value) {
                    result[++index] = value;
                  });
                  return result;
                }

                _module394.exports = setToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneSymbol.js": function module(_require392, _exports392, _module395) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneSymbol.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require392('./_Symbol');

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

                /**
                 * Creates a clone of the `symbol` object.
                 *
                 * @private
                 * @param {Object} symbol The symbol object to clone.
                 * @returns {Object} Returns the cloned symbol object.
                 */
                function cloneSymbol(symbol) {
                  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
                }

                _module395.exports = cloneSymbol;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_cloneTypedArray.js": function module(_require393, _exports393, _module396) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_cloneTypedArray.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var cloneArrayBuffer = _require393('./_cloneArrayBuffer');

                /**
                 * Creates a clone of `typedArray`.
                 *
                 * @private
                 * @param {Object} typedArray The typed array to clone.
                 * @param {boolean} [isDeep] Specify a deep clone.
                 * @returns {Object} Returns the cloned typed array.
                 */
                function cloneTypedArray(typedArray, isDeep) {
                  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
                }

                _module396.exports = cloneTypedArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_initCloneObject.js": function module(_require394, _exports394, _module397) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_initCloneObject.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseCreate = _require394('./_baseCreate'),
                    getPrototype = _require394('./_getPrototype'),
                    isPrototype = _require394('./_isPrototype');

                /**
                 * Initializes an object clone.
                 *
                 * @private
                 * @param {Object} object The object to clone.
                 * @returns {Object} Returns the initialized clone.
                 */
                function initCloneObject(object) {
                  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
                }

                _module397.exports = initCloneObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseCreate.js": function module(_require395, _exports395, _module398) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseCreate.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isObject = _require395('./isObject');

                /** Built-in value references. */
                var objectCreate = Object.create;

                /**
                 * The base implementation of `_.create` without support for assigning
                 * properties to the created object.
                 *
                 * @private
                 * @param {Object} proto The object to inherit from.
                 * @returns {Object} Returns the new object.
                 */
                var baseCreate = function () {
                  function object() {}
                  return function (proto) {
                    if (!isObject(proto)) {
                      return {};
                    }
                    if (objectCreate) {
                      return objectCreate(proto);
                    }
                    object.prototype = proto;
                    var result = new object();
                    object.prototype = undefined;
                    return result;
                  };
                }();

                _module398.exports = baseCreate;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isPlainObject.js": function module(_require396, _exports396, _module399) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isPlainObject.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require396('./_baseGetTag'),
                    getPrototype = _require396('./_getPrototype'),
                    isObjectLike = _require396('./isObjectLike');

                /** `Object#toString` result references. */
                var objectTag = '[object Object]';

                /** Used for built-in method references. */
                var funcProto = Function.prototype,
                    objectProto = Object.prototype;

                /** Used to resolve the decompiled source of functions. */
                var funcToString = funcProto.toString;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /** Used to infer the `Object` constructor. */
                var objectCtorString = funcToString.call(Object);

                /**
                 * Checks if `value` is a plain object, that is, an object created by the
                 * `Object` constructor or one with a `[[Prototype]]` of `null`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.8.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 * }
                 *
                 * _.isPlainObject(new Foo);
                 * // => false
                 *
                 * _.isPlainObject([1, 2, 3]);
                 * // => false
                 *
                 * _.isPlainObject({ 'x': 0, 'y': 0 });
                 * // => true
                 *
                 * _.isPlainObject(Object.create(null));
                 * // => true
                 */
                function isPlainObject(value) {
                  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
                    return false;
                  }
                  var proto = getPrototype(value);
                  if (proto === null) {
                    return true;
                  }
                  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
                }

                _module399.exports = isPlainObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "extend.js": function module(_require397, _exports397, _module400) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/extend.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                _module400.exports = _require397('./assignIn');

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "assignIn.js": function module(_require398, _exports398, _module401) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/assignIn.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var copyObject = _require398('./_copyObject'),
                    createAssigner = _require398('./_createAssigner'),
                    keysIn = _require398('./keysIn');

                /**
                 * This method is like `_.assign` except that it iterates over own and
                 * inherited source properties.
                 *
                 * **Note:** This method mutates `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @alias extend
                 * @category Object
                 * @param {Object} object The destination object.
                 * @param {...Object} [sources] The source objects.
                 * @returns {Object} Returns `object`.
                 * @see _.assign
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 * }
                 *
                 * function Bar() {
                 *   this.c = 3;
                 * }
                 *
                 * Foo.prototype.b = 2;
                 * Bar.prototype.d = 4;
                 *
                 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
                 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
                 */
                var assignIn = createAssigner(function (object, source) {
                  copyObject(source, keysIn(source), object);
                });

                _module401.exports = assignIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isNil.js": function module(_require399, _exports399, _module402) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isNil.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is `null` or `undefined`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
                 * @example
                 *
                 * _.isNil(null);
                 * // => true
                 *
                 * _.isNil(void 0);
                 * // => true
                 *
                 * _.isNil(NaN);
                 * // => false
                 */
                function isNil(value) {
                  return value == null;
                }

                _module402.exports = isNil;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "fromPairs.js": function module(_require400, _exports400, _module403) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/fromPairs.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The inverse of `_.toPairs`; this method returns an object composed
                 * from key-value `pairs`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Array
                 * @param {Array} pairs The key-value pairs.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * _.fromPairs([['a', 1], ['b', 2]]);
                 * // => { 'a': 1, 'b': 2 }
                 */
                function fromPairs(pairs) {
                  var index = -1,
                      length = pairs == null ? 0 : pairs.length,
                      result = {};

                  while (++index < length) {
                    var pair = pairs[index];
                    result[pair[0]] = pair[1];
                  }
                  return result;
                }

                _module403.exports = fromPairs;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "map.js": function module(_require401, _exports401, _module404) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/map.js                                                      //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayMap = _require401('./_arrayMap'),
                    baseIteratee = _require401('./_baseIteratee'),
                    baseMap = _require401('./_baseMap'),
                    isArray = _require401('./isArray');

                /**
                 * Creates an array of values by running each element in `collection` thru
                 * `iteratee`. The iteratee is invoked with three arguments:
                 * (value, index|key, collection).
                 *
                 * Many lodash methods are guarded to work as iteratees for methods like
                 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
                 *
                 * The guarded methods are:
                 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
                 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
                 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
                 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 * @example
                 *
                 * function square(n) {
                 *   return n * n;
                 * }
                 *
                 * _.map([4, 8], square);
                 * // => [16, 64]
                 *
                 * _.map({ 'a': 4, 'b': 8 }, square);
                 * // => [16, 64] (iteration order is not guaranteed)
                 *
                 * var users = [
                 *   { 'user': 'barney' },
                 *   { 'user': 'fred' }
                 * ];
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.map(users, 'user');
                 * // => ['barney', 'fred']
                 */
                function map(collection, iteratee) {
                  var func = isArray(collection) ? arrayMap : baseMap;
                  return func(collection, baseIteratee(iteratee, 3));
                }

                _module404.exports = map;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIteratee.js": function module(_require402, _exports402, _module405) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIteratee.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseMatches = _require402('./_baseMatches'),
                    baseMatchesProperty = _require402('./_baseMatchesProperty'),
                    identity = _require402('./identity'),
                    isArray = _require402('./isArray'),
                    property = _require402('./property');

                /**
                 * The base implementation of `_.iteratee`.
                 *
                 * @private
                 * @param {*} [value=_.identity] The value to convert to an iteratee.
                 * @returns {Function} Returns the iteratee.
                 */
                function baseIteratee(value) {
                  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
                  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
                  if (typeof value == 'function') {
                    return value;
                  }
                  if (value == null) {
                    return identity;
                  }
                  if (typeof value == 'object') {
                    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                  }
                  return property(value);
                }

                _module405.exports = baseIteratee;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseMatches.js": function module(_require403, _exports403, _module406) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseMatches.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsMatch = _require403('./_baseIsMatch'),
                    getMatchData = _require403('./_getMatchData'),
                    matchesStrictComparable = _require403('./_matchesStrictComparable');

                /**
                 * The base implementation of `_.matches` which doesn't clone `source`.
                 *
                 * @private
                 * @param {Object} source The object of property values to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function baseMatches(source) {
                  var matchData = getMatchData(source);
                  if (matchData.length == 1 && matchData[0][2]) {
                    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                  }
                  return function (object) {
                    return object === source || baseIsMatch(object, source, matchData);
                  };
                }

                _module406.exports = baseMatches;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsMatch.js": function module(_require404, _exports404, _module407) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsMatch.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Stack = _require404('./_Stack'),
                    baseIsEqual = _require404('./_baseIsEqual');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * The base implementation of `_.isMatch` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The object to inspect.
                 * @param {Object} source The object of property values to match.
                 * @param {Array} matchData The property names, values, and compare flags to match.
                 * @param {Function} [customizer] The function to customize comparisons.
                 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
                 */
                function baseIsMatch(object, source, matchData, customizer) {
                  var index = matchData.length,
                      length = index,
                      noCustomizer = !customizer;

                  if (object == null) {
                    return !length;
                  }
                  object = Object(object);
                  while (index--) {
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                      return false;
                    }
                  }
                  while (++index < length) {
                    data = matchData[index];
                    var key = data[0],
                        objValue = object[key],
                        srcValue = data[1];

                    if (noCustomizer && data[2]) {
                      if (objValue === undefined && !(key in object)) {
                        return false;
                      }
                    } else {
                      var stack = new Stack();
                      if (customizer) {
                        var result = customizer(objValue, srcValue, key, object, source, stack);
                      }
                      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                        return false;
                      }
                    }
                  }
                  return true;
                }

                _module407.exports = baseIsMatch;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsEqual.js": function module(_require405, _exports405, _module408) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsEqual.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsEqualDeep = _require405('./_baseIsEqualDeep'),
                    isObjectLike = _require405('./isObjectLike');

                /**
                 * The base implementation of `_.isEqual` which supports partial comparisons
                 * and tracks traversed objects.
                 *
                 * @private
                 * @param {*} value The value to compare.
                 * @param {*} other The other value to compare.
                 * @param {boolean} bitmask The bitmask flags.
                 *  1 - Unordered comparison
                 *  2 - Partial comparison
                 * @param {Function} [customizer] The function to customize comparisons.
                 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
                 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
                 */
                function baseIsEqual(value, other, bitmask, customizer, stack) {
                  if (value === other) {
                    return true;
                  }
                  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
                    return value !== value && other !== other;
                  }
                  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
                }

                _module408.exports = baseIsEqual;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsEqualDeep.js": function module(_require406, _exports406, _module409) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsEqualDeep.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Stack = _require406('./_Stack'),
                    equalArrays = _require406('./_equalArrays'),
                    equalByTag = _require406('./_equalByTag'),
                    equalObjects = _require406('./_equalObjects'),
                    getTag = _require406('./_getTag'),
                    isArray = _require406('./isArray'),
                    isBuffer = _require406('./isBuffer'),
                    isTypedArray = _require406('./isTypedArray');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1;

                /** `Object#toString` result references. */
                var argsTag = '[object Arguments]',
                    arrayTag = '[object Array]',
                    objectTag = '[object Object]';

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * A specialized version of `baseIsEqual` for arrays and objects which performs
                 * deep comparisons and tracks traversed objects enabling objects with circular
                 * references to be compared.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                  var objIsArr = isArray(object),
                      othIsArr = isArray(other),
                      objTag = objIsArr ? arrayTag : getTag(object),
                      othTag = othIsArr ? arrayTag : getTag(other);

                  objTag = objTag == argsTag ? objectTag : objTag;
                  othTag = othTag == argsTag ? objectTag : othTag;

                  var objIsObj = objTag == objectTag,
                      othIsObj = othTag == objectTag,
                      isSameTag = objTag == othTag;

                  if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) {
                      return false;
                    }
                    objIsArr = true;
                    objIsObj = false;
                  }
                  if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack());
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                  }
                  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
                        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

                    if (objIsWrapped || othIsWrapped) {
                      var objUnwrapped = objIsWrapped ? object.value() : object,
                          othUnwrapped = othIsWrapped ? other.value() : other;

                      stack || (stack = new Stack());
                      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                  }
                  if (!isSameTag) {
                    return false;
                  }
                  stack || (stack = new Stack());
                  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
                }

                _module409.exports = baseIsEqualDeep;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_equalArrays.js": function module(_require407, _exports407, _module410) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_equalArrays.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var SetCache = _require407('./_SetCache'),
                    arraySome = _require407('./_arraySome'),
                    cacheHas = _require407('./_cacheHas');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * A specialized version of `baseIsEqualDeep` for arrays with support for
                 * partial deep comparisons.
                 *
                 * @private
                 * @param {Array} array The array to compare.
                 * @param {Array} other The other array to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `array` and `other` objects.
                 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
                 */
                function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                      arrLength = array.length,
                      othLength = other.length;

                  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
                    return false;
                  }
                  // Assume cyclic values are equal.
                  var stacked = stack.get(array);
                  if (stacked && stack.get(other)) {
                    return stacked == other;
                  }
                  var index = -1,
                      result = true,
                      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

                  stack.set(array, other);
                  stack.set(other, array);

                  // Ignore non-index properties.
                  while (++index < arrLength) {
                    var arrValue = array[index],
                        othValue = other[index];

                    if (customizer) {
                      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    }
                    if (compared !== undefined) {
                      if (compared) {
                        continue;
                      }
                      result = false;
                      break;
                    }
                    // Recursively compare arrays (susceptible to call stack limits).
                    if (seen) {
                      if (!arraySome(other, function (othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                          return seen.push(othIndex);
                        }
                      })) {
                        result = false;
                        break;
                      }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                      result = false;
                      break;
                    }
                  }
                  stack['delete'](array);
                  stack['delete'](other);
                  return result;
                }

                _module410.exports = equalArrays;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arraySome.js": function module(_require408, _exports408, _module411) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arraySome.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.some` for arrays without support for iteratee
                 * shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 */
                function arraySome(array, predicate) {
                  var index = -1,
                      length = array == null ? 0 : array.length;

                  while (++index < length) {
                    if (predicate(array[index], index, array)) {
                      return true;
                    }
                  }
                  return false;
                }

                _module411.exports = arraySome;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_equalByTag.js": function module(_require409, _exports409, _module412) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_equalByTag.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require409('./_Symbol'),
                    Uint8Array = _require409('./_Uint8Array'),
                    eq = _require409('./eq'),
                    equalArrays = _require409('./_equalArrays'),
                    mapToArray = _require409('./_mapToArray'),
                    setToArray = _require409('./_setToArray');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /** `Object#toString` result references. */
                var boolTag = '[object Boolean]',
                    dateTag = '[object Date]',
                    errorTag = '[object Error]',
                    mapTag = '[object Map]',
                    numberTag = '[object Number]',
                    regexpTag = '[object RegExp]',
                    setTag = '[object Set]',
                    stringTag = '[object String]',
                    symbolTag = '[object Symbol]';

                var arrayBufferTag = '[object ArrayBuffer]',
                    dataViewTag = '[object DataView]';

                /** Used to convert symbols to primitives and strings. */
                var symbolProto = Symbol ? Symbol.prototype : undefined,
                    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

                /**
                 * A specialized version of `baseIsEqualDeep` for comparing objects of
                 * the same `toStringTag`.
                 *
                 * **Note:** This function only supports comparing values with tags of
                 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {string} tag The `toStringTag` of the objects to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                  switch (tag) {
                    case dataViewTag:
                      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                        return false;
                      }
                      object = object.buffer;
                      other = other.buffer;

                    case arrayBufferTag:
                      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                        return false;
                      }
                      return true;

                    case boolTag:
                    case dateTag:
                    case numberTag:
                      // Coerce booleans to `1` or `0` and dates to milliseconds.
                      // Invalid dates are coerced to `NaN`.
                      return eq(+object, +other);

                    case errorTag:
                      return object.name == other.name && object.message == other.message;

                    case regexpTag:
                    case stringTag:
                      // Coerce regexes to strings and treat strings, primitives and objects,
                      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                      // for more details.
                      return object == other + '';

                    case mapTag:
                      var convert = mapToArray;

                    case setTag:
                      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                      convert || (convert = setToArray);

                      if (object.size != other.size && !isPartial) {
                        return false;
                      }
                      // Assume cyclic values are equal.
                      var stacked = stack.get(object);
                      if (stacked) {
                        return stacked == other;
                      }
                      bitmask |= COMPARE_UNORDERED_FLAG;

                      // Recursively compare objects (susceptible to call stack limits).
                      stack.set(object, other);
                      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                      stack['delete'](object);
                      return result;

                    case symbolTag:
                      if (symbolValueOf) {
                        return symbolValueOf.call(object) == symbolValueOf.call(other);
                      }
                  }
                  return false;
                }

                _module412.exports = equalByTag;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_equalObjects.js": function module(_require410, _exports410, _module413) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_equalObjects.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var getAllKeys = _require410('./_getAllKeys');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1;

                /** Used for built-in method references. */
                var objectProto = Object.prototype;

                /** Used to check objects for own properties. */
                var hasOwnProperty = objectProto.hasOwnProperty;

                /**
                 * A specialized version of `baseIsEqualDeep` for objects with support for
                 * partial deep comparisons.
                 *
                 * @private
                 * @param {Object} object The object to compare.
                 * @param {Object} other The other object to compare.
                 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
                 * @param {Function} customizer The function to customize comparisons.
                 * @param {Function} equalFunc The function to determine equivalents of values.
                 * @param {Object} stack Tracks traversed `object` and `other` objects.
                 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
                 */
                function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                      objProps = getAllKeys(object),
                      objLength = objProps.length,
                      othProps = getAllKeys(other),
                      othLength = othProps.length;

                  if (objLength != othLength && !isPartial) {
                    return false;
                  }
                  var index = objLength;
                  while (index--) {
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
                      return false;
                    }
                  }
                  // Assume cyclic values are equal.
                  var stacked = stack.get(object);
                  if (stacked && stack.get(other)) {
                    return stacked == other;
                  }
                  var result = true;
                  stack.set(object, other);
                  stack.set(other, object);

                  var skipCtor = isPartial;
                  while (++index < objLength) {
                    key = objProps[index];
                    var objValue = object[key],
                        othValue = other[key];

                    if (customizer) {
                      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    }
                    // Recursively compare objects (susceptible to call stack limits).
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                      result = false;
                      break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                  }
                  if (result && !skipCtor) {
                    var objCtor = object.constructor,
                        othCtor = other.constructor;

                    // Non `Object` object instances with different constructors are not equal.
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
                      result = false;
                    }
                  }
                  stack['delete'](object);
                  stack['delete'](other);
                  return result;
                }

                _module413.exports = equalObjects;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_getMatchData.js": function module(_require411, _exports411, _module414) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_getMatchData.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isStrictComparable = _require411('./_isStrictComparable'),
                    keys = _require411('./keys');

                /**
                 * Gets the property names, values, and compare flags of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @returns {Array} Returns the match data of `object`.
                 */
                function getMatchData(object) {
                  var result = keys(object),
                      length = result.length;

                  while (length--) {
                    var key = result[length],
                        value = object[key];

                    result[length] = [key, value, isStrictComparable(value)];
                  }
                  return result;
                }

                _module414.exports = getMatchData;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_isStrictComparable.js": function module(_require412, _exports412, _module415) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_isStrictComparable.js                                      //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isObject = _require412('./isObject');

                /**
                 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` if suitable for strict
                 *  equality comparisons, else `false`.
                 */
                function isStrictComparable(value) {
                  return value === value && !isObject(value);
                }

                _module415.exports = isStrictComparable;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_matchesStrictComparable.js": function module(_require413, _exports413, _module416) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_matchesStrictComparable.js                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `matchesProperty` for source values suitable
                 * for strict equality comparisons, i.e. `===`.
                 *
                 * @private
                 * @param {string} key The key of the property to get.
                 * @param {*} srcValue The value to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function matchesStrictComparable(key, srcValue) {
                  return function (object) {
                    if (object == null) {
                      return false;
                    }
                    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
                  };
                }

                _module416.exports = matchesStrictComparable;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseMatchesProperty.js": function module(_require414, _exports414, _module417) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseMatchesProperty.js                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsEqual = _require414('./_baseIsEqual'),
                    get = _require414('./get'),
                    hasIn = _require414('./hasIn'),
                    isKey = _require414('./_isKey'),
                    isStrictComparable = _require414('./_isStrictComparable'),
                    matchesStrictComparable = _require414('./_matchesStrictComparable'),
                    toKey = _require414('./_toKey');

                /** Used to compose bitmasks for value comparisons. */
                var COMPARE_PARTIAL_FLAG = 1,
                    COMPARE_UNORDERED_FLAG = 2;

                /**
                 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
                 *
                 * @private
                 * @param {string} path The path of the property to get.
                 * @param {*} srcValue The value to match.
                 * @returns {Function} Returns the new spec function.
                 */
                function baseMatchesProperty(path, srcValue) {
                  if (isKey(path) && isStrictComparable(srcValue)) {
                    return matchesStrictComparable(toKey(path), srcValue);
                  }
                  return function (object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                  };
                }

                _module417.exports = baseMatchesProperty;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "get.js": function module(_require415, _exports415, _module418) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/get.js                                                      //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGet = _require415('./_baseGet');

                /**
                 * Gets the value at `path` of `object`. If the resolved value is
                 * `undefined`, the `defaultValue` is returned in its place.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.7.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path of the property to get.
                 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
                 * @returns {*} Returns the resolved value.
                 * @example
                 *
                 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
                 *
                 * _.get(object, 'a[0].b.c');
                 * // => 3
                 *
                 * _.get(object, ['a', '0', 'b', 'c']);
                 * // => 3
                 *
                 * _.get(object, 'a.b.c', 'default');
                 * // => 'default'
                 */
                function get(object, path, defaultValue) {
                  var result = object == null ? undefined : baseGet(object, path);
                  return result === undefined ? defaultValue : result;
                }

                _module418.exports = get;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseGet.js": function module(_require416, _exports416, _module419) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseGet.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var castPath = _require416('./_castPath'),
                    toKey = _require416('./_toKey');

                /**
                 * The base implementation of `_.get` without support for default values.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path of the property to get.
                 * @returns {*} Returns the resolved value.
                 */
                function baseGet(object, path) {
                  path = castPath(path, object);

                  var index = 0,
                      length = path.length;

                  while (object != null && index < length) {
                    object = object[toKey(path[index++])];
                  }
                  return index && index == length ? object : undefined;
                }

                _module419.exports = baseGet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "hasIn.js": function module(_require417, _exports417, _module420) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/hasIn.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseHasIn = _require417('./_baseHasIn'),
                    hasPath = _require417('./_hasPath');

                /**
                 * Checks if `path` is a direct or inherited property of `object`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The object to query.
                 * @param {Array|string} path The path to check.
                 * @returns {boolean} Returns `true` if `path` exists, else `false`.
                 * @example
                 *
                 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
                 *
                 * _.hasIn(object, 'a');
                 * // => true
                 *
                 * _.hasIn(object, 'a.b');
                 * // => true
                 *
                 * _.hasIn(object, ['a', 'b']);
                 * // => true
                 *
                 * _.hasIn(object, 'b');
                 * // => false
                 */
                function hasIn(object, path) {
                  return object != null && hasPath(object, path, baseHasIn);
                }

                _module420.exports = hasIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseHasIn.js": function module(_require418, _exports418, _module421) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseHasIn.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.hasIn` without support for deep paths.
                 *
                 * @private
                 * @param {Object} [object] The object to query.
                 * @param {Array|string} key The key to check.
                 * @returns {boolean} Returns `true` if `key` exists, else `false`.
                 */
                function baseHasIn(object, key) {
                  return object != null && key in Object(object);
                }

                _module421.exports = baseHasIn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "property.js": function module(_require419, _exports419, _module422) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/property.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseProperty = _require419('./_baseProperty'),
                    basePropertyDeep = _require419('./_basePropertyDeep'),
                    isKey = _require419('./_isKey'),
                    toKey = _require419('./_toKey');

                /**
                 * Creates a function that returns the value at `path` of a given object.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.4.0
                 * @category Util
                 * @param {Array|string} path The path of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 * @example
                 *
                 * var objects = [
                 *   { 'a': { 'b': 2 } },
                 *   { 'a': { 'b': 1 } }
                 * ];
                 *
                 * _.map(objects, _.property('a.b'));
                 * // => [2, 1]
                 *
                 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
                 * // => [1, 2]
                 */
                function property(path) {
                  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
                }

                _module422.exports = property;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseProperty.js": function module(_require420, _exports420, _module423) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseProperty.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.property` without support for deep paths.
                 *
                 * @private
                 * @param {string} key The key of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 */
                function baseProperty(key) {
                  return function (object) {
                    return object == null ? undefined : object[key];
                  };
                }

                _module423.exports = baseProperty;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_basePropertyDeep.js": function module(_require421, _exports421, _module424) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_basePropertyDeep.js                                        //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGet = _require421('./_baseGet');

                /**
                 * A specialized version of `baseProperty` which supports deep paths.
                 *
                 * @private
                 * @param {Array|string} path The path of the property to get.
                 * @returns {Function} Returns the new accessor function.
                 */
                function basePropertyDeep(path) {
                  return function (object) {
                    return baseGet(object, path);
                  };
                }

                _module424.exports = basePropertyDeep;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseMap.js": function module(_require422, _exports422, _module425) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseMap.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseEach = _require422('./_baseEach'),
                    isArrayLike = _require422('./isArrayLike');

                /**
                 * The base implementation of `_.map` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} iteratee The function invoked per iteration.
                 * @returns {Array} Returns the new mapped array.
                 */
                function baseMap(collection, iteratee) {
                  var index = -1,
                      result = isArrayLike(collection) ? Array(collection.length) : [];

                  baseEach(collection, function (value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                  });
                  return result;
                }

                _module425.exports = baseMap;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "find.js": function module(_require423, _exports423, _module426) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/find.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var createFind = _require423('./_createFind'),
                    findIndex = _require423('./findIndex');

                /**
                 * Iterates over elements of `collection`, returning the first element
                 * `predicate` returns truthy for. The predicate is invoked with three
                 * arguments: (value, index|key, collection).
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to inspect.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {*} Returns the matched element, else `undefined`.
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney',  'age': 36, 'active': true },
                 *   { 'user': 'fred',    'age': 40, 'active': false },
                 *   { 'user': 'pebbles', 'age': 1,  'active': true }
                 * ];
                 *
                 * _.find(users, function(o) { return o.age < 40; });
                 * // => object for 'barney'
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.find(users, { 'age': 1, 'active': true });
                 * // => object for 'pebbles'
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.find(users, ['active', false]);
                 * // => object for 'fred'
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.find(users, 'active');
                 * // => object for 'barney'
                 */
                var find = createFind(findIndex);

                _module426.exports = find;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createFind.js": function module(_require424, _exports424, _module427) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createFind.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIteratee = _require424('./_baseIteratee'),
                    isArrayLike = _require424('./isArrayLike'),
                    keys = _require424('./keys');

                /**
                 * Creates a `_.find` or `_.findLast` function.
                 *
                 * @private
                 * @param {Function} findIndexFunc The function to find the collection index.
                 * @returns {Function} Returns the new find function.
                 */
                function createFind(findIndexFunc) {
                  return function (collection, predicate, fromIndex) {
                    var iterable = Object(collection);
                    if (!isArrayLike(collection)) {
                      var iteratee = baseIteratee(predicate, 3);
                      collection = keys(collection);
                      predicate = function (key) {
                        return iteratee(iterable[key], key, iterable);
                      };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                  };
                }

                _module427.exports = createFind;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "findIndex.js": function module(_require425, _exports425, _module428) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/findIndex.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseFindIndex = _require425('./_baseFindIndex'),
                    baseIteratee = _require425('./_baseIteratee'),
                    toInteger = _require425('./toInteger');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * This method is like `_.find` except that it returns the index of the first
                 * element `predicate` returns truthy for instead of the element itself.
                 *
                 * @static
                 * @memberOf _
                 * @since 1.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {number} Returns the index of the found element, else `-1`.
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney',  'active': false },
                 *   { 'user': 'fred',    'active': false },
                 *   { 'user': 'pebbles', 'active': true }
                 * ];
                 *
                 * _.findIndex(users, function(o) { return o.user == 'barney'; });
                 * // => 0
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.findIndex(users, { 'user': 'fred', 'active': false });
                 * // => 1
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.findIndex(users, ['active', false]);
                 * // => 0
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.findIndex(users, 'active');
                 * // => 2
                 */
                function findIndex(array, predicate, fromIndex) {
                  var length = array == null ? 0 : array.length;
                  if (!length) {
                    return -1;
                  }
                  var index = fromIndex == null ? 0 : toInteger(fromIndex);
                  if (index < 0) {
                    index = nativeMax(length + index, 0);
                  }
                  return baseFindIndex(array, baseIteratee(predicate, 3), index);
                }

                _module428.exports = findIndex;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "toArray.js": function module(_require426, _exports426, _module429) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/toArray.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Symbol = _require426('./_Symbol'),
                    copyArray = _require426('./_copyArray'),
                    getTag = _require426('./_getTag'),
                    isArrayLike = _require426('./isArrayLike'),
                    isString = _require426('./isString'),
                    iteratorToArray = _require426('./_iteratorToArray'),
                    mapToArray = _require426('./_mapToArray'),
                    setToArray = _require426('./_setToArray'),
                    stringToArray = _require426('./_stringToArray'),
                    values = _require426('./values');

                /** `Object#toString` result references. */
                var mapTag = '[object Map]',
                    setTag = '[object Set]';

                /** Built-in value references. */
                var symIterator = Symbol ? Symbol.iterator : undefined;

                /**
                 * Converts `value` to an array.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Lang
                 * @param {*} value The value to convert.
                 * @returns {Array} Returns the converted array.
                 * @example
                 *
                 * _.toArray({ 'a': 1, 'b': 2 });
                 * // => [1, 2]
                 *
                 * _.toArray('abc');
                 * // => ['a', 'b', 'c']
                 *
                 * _.toArray(1);
                 * // => []
                 *
                 * _.toArray(null);
                 * // => []
                 */
                function toArray(value) {
                  if (!value) {
                    return [];
                  }
                  if (isArrayLike(value)) {
                    return isString(value) ? stringToArray(value) : copyArray(value);
                  }
                  if (symIterator && value[symIterator]) {
                    return iteratorToArray(value[symIterator]());
                  }
                  var tag = getTag(value),
                      func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;

                  return func(value);
                }

                _module429.exports = toArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_iteratorToArray.js": function module(_require427, _exports427, _module430) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_iteratorToArray.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Converts `iterator` to an array.
                 *
                 * @private
                 * @param {Object} iterator The iterator to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function iteratorToArray(iterator) {
                  var data,
                      result = [];

                  while (!(data = iterator.next()).done) {
                    result.push(data.value);
                  }
                  return result;
                }

                _module430.exports = iteratorToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stringToArray.js": function module(_require428, _exports428, _module431) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stringToArray.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var asciiToArray = _require428('./_asciiToArray'),
                    hasUnicode = _require428('./_hasUnicode'),
                    unicodeToArray = _require428('./_unicodeToArray');

                /**
                 * Converts `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function stringToArray(string) {
                  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
                }

                _module431.exports = stringToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_asciiToArray.js": function module(_require429, _exports429, _module432) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_asciiToArray.js                                            //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Converts an ASCII `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function asciiToArray(string) {
                  return string.split('');
                }

                _module432.exports = asciiToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_hasUnicode.js": function module(_require430, _exports430, _module433) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_hasUnicode.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to compose unicode character classes. */
                var rsAstralRange = '\\ud800-\\udfff',
                    rsComboMarksRange = '\\u0300-\\u036f',
                    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
                    rsComboSymbolsRange = '\\u20d0-\\u20ff',
                    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
                    rsVarRange = '\\ufe0e\\ufe0f';

                /** Used to compose unicode capture groups. */
                var rsZWJ = '\\u200d';

                /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
                var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

                /**
                 * Checks if `string` contains Unicode symbols.
                 *
                 * @private
                 * @param {string} string The string to inspect.
                 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
                 */
                function hasUnicode(string) {
                  return reHasUnicode.test(string);
                }

                _module433.exports = hasUnicode;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_unicodeToArray.js": function module(_require431, _exports431, _module434) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_unicodeToArray.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to compose unicode character classes. */
                var rsAstralRange = '\\ud800-\\udfff',
                    rsComboMarksRange = '\\u0300-\\u036f',
                    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
                    rsComboSymbolsRange = '\\u20d0-\\u20ff',
                    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
                    rsVarRange = '\\ufe0e\\ufe0f';

                /** Used to compose unicode capture groups. */
                var rsAstral = '[' + rsAstralRange + ']',
                    rsCombo = '[' + rsComboRange + ']',
                    rsFitz = '\\ud83c[\\udffb-\\udfff]',
                    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
                    rsNonAstral = '[^' + rsAstralRange + ']',
                    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
                    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
                    rsZWJ = '\\u200d';

                /** Used to compose unicode regexes. */
                var reOptMod = rsModifier + '?',
                    rsOptVar = '[' + rsVarRange + ']?',
                    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
                    rsSeq = rsOptVar + reOptMod + rsOptJoin,
                    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

                /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
                var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

                /**
                 * Converts a Unicode `string` to an array.
                 *
                 * @private
                 * @param {string} string The string to convert.
                 * @returns {Array} Returns the converted array.
                 */
                function unicodeToArray(string) {
                  return string.match(reUnicode) || [];
                }

                _module434.exports = unicodeToArray;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "size.js": function module(_require432, _exports432, _module435) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/size.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseKeys = _require432('./_baseKeys'),
                    getTag = _require432('./_getTag'),
                    isArrayLike = _require432('./isArrayLike'),
                    isString = _require432('./isString'),
                    stringSize = _require432('./_stringSize');

                /** `Object#toString` result references. */
                var mapTag = '[object Map]',
                    setTag = '[object Set]';

                /**
                 * Gets the size of `collection` by returning its length for array-like
                 * values or the number of own enumerable string keyed properties for objects.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object|string} collection The collection to inspect.
                 * @returns {number} Returns the collection size.
                 * @example
                 *
                 * _.size([1, 2, 3]);
                 * // => 3
                 *
                 * _.size({ 'a': 1, 'b': 2 });
                 * // => 2
                 *
                 * _.size('pebbles');
                 * // => 7
                 */
                function size(collection) {
                  if (collection == null) {
                    return 0;
                  }
                  if (isArrayLike(collection)) {
                    return isString(collection) ? stringSize(collection) : collection.length;
                  }
                  var tag = getTag(collection);
                  if (tag == mapTag || tag == setTag) {
                    return collection.size;
                  }
                  return baseKeys(collection).length;
                }

                _module435.exports = size;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_stringSize.js": function module(_require433, _exports433, _module436) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_stringSize.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var asciiSize = _require433('./_asciiSize'),
                    hasUnicode = _require433('./_hasUnicode'),
                    unicodeSize = _require433('./_unicodeSize');

                /**
                 * Gets the number of symbols in `string`.
                 *
                 * @private
                 * @param {string} string The string to inspect.
                 * @returns {number} Returns the string size.
                 */
                function stringSize(string) {
                  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
                }

                _module436.exports = stringSize;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_asciiSize.js": function module(_require434, _exports434, _module437) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_asciiSize.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseProperty = _require434('./_baseProperty');

                /**
                 * Gets the size of an ASCII `string`.
                 *
                 * @private
                 * @param {string} string The string inspect.
                 * @returns {number} Returns the string size.
                 */
                var asciiSize = baseProperty('length');

                _module437.exports = asciiSize;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_unicodeSize.js": function module(_require435, _exports435, _module438) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_unicodeSize.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Used to compose unicode character classes. */
                var rsAstralRange = '\\ud800-\\udfff',
                    rsComboMarksRange = '\\u0300-\\u036f',
                    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
                    rsComboSymbolsRange = '\\u20d0-\\u20ff',
                    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
                    rsVarRange = '\\ufe0e\\ufe0f';

                /** Used to compose unicode capture groups. */
                var rsAstral = '[' + rsAstralRange + ']',
                    rsCombo = '[' + rsComboRange + ']',
                    rsFitz = '\\ud83c[\\udffb-\\udfff]',
                    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
                    rsNonAstral = '[^' + rsAstralRange + ']',
                    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
                    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
                    rsZWJ = '\\u200d';

                /** Used to compose unicode regexes. */
                var reOptMod = rsModifier + '?',
                    rsOptVar = '[' + rsVarRange + ']?',
                    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
                    rsSeq = rsOptVar + reOptMod + rsOptJoin,
                    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

                /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
                var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

                /**
                 * Gets the size of a Unicode `string`.
                 *
                 * @private
                 * @param {string} string The string inspect.
                 * @returns {number} Returns the string size.
                 */
                function unicodeSize(string) {
                  var result = reUnicode.lastIndex = 0;
                  while (reUnicode.test(string)) {
                    ++result;
                  }
                  return result;
                }

                _module438.exports = unicodeSize;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "difference.js": function module(_require436, _exports436, _module439) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/difference.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseDifference = _require436('./_baseDifference'),
                    baseFlatten = _require436('./_baseFlatten'),
                    baseRest = _require436('./_baseRest'),
                    isArrayLikeObject = _require436('./isArrayLikeObject');

                /**
                 * Creates an array of `array` values not included in the other given arrays
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons. The order and references of result values are
                 * determined by the first array.
                 *
                 * **Note:** Unlike `_.pullAll`, this method returns a new array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @param {...Array} [values] The values to exclude.
                 * @returns {Array} Returns the new array of filtered values.
                 * @see _.without, _.xor
                 * @example
                 *
                 * _.difference([2, 1], [2, 3]);
                 * // => [1]
                 */
                var difference = baseRest(function (array, values) {
                  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
                });

                _module439.exports = difference;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseDifference.js": function module(_require437, _exports437, _module440) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseDifference.js                                          //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var SetCache = _require437('./_SetCache'),
                    arrayIncludes = _require437('./_arrayIncludes'),
                    arrayIncludesWith = _require437('./_arrayIncludesWith'),
                    arrayMap = _require437('./_arrayMap'),
                    baseUnary = _require437('./_baseUnary'),
                    cacheHas = _require437('./_cacheHas');

                /** Used as the size to enable large array optimizations. */
                var LARGE_ARRAY_SIZE = 200;

                /**
                 * The base implementation of methods like `_.difference` without support
                 * for excluding multiple arrays or iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {Array} values The values to exclude.
                 * @param {Function} [iteratee] The iteratee invoked per element.
                 * @param {Function} [comparator] The comparator invoked per element.
                 * @returns {Array} Returns the new array of filtered values.
                 */
                function baseDifference(array, values, iteratee, comparator) {
                  var index = -1,
                      includes = arrayIncludes,
                      isCommon = true,
                      length = array.length,
                      result = [],
                      valuesLength = values.length;

                  if (!length) {
                    return result;
                  }
                  if (iteratee) {
                    values = arrayMap(values, baseUnary(iteratee));
                  }
                  if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                  } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                  }
                  outer: while (++index < length) {
                    var value = array[index],
                        computed = iteratee == null ? value : iteratee(value);

                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                      var valuesIndex = valuesLength;
                      while (valuesIndex--) {
                        if (values[valuesIndex] === computed) {
                          continue outer;
                        }
                      }
                      result.push(value);
                    } else if (!includes(values, computed, comparator)) {
                      result.push(value);
                    }
                  }
                  return result;
                }

                _module440.exports = baseDifference;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "forOwn.js": function module(_require438, _exports438, _module441) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/forOwn.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseForOwn = _require438('./_baseForOwn'),
                    castFunction = _require438('./_castFunction');

                /**
                 * Iterates over own enumerable string keyed properties of an object and
                 * invokes `iteratee` for each property. The iteratee is invoked with three
                 * arguments: (value, key, object). Iteratee functions may exit iteration
                 * early by explicitly returning `false`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.3.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Object} Returns `object`.
                 * @see _.forOwnRight
                 * @example
                 *
                 * function Foo() {
                 *   this.a = 1;
                 *   this.b = 2;
                 * }
                 *
                 * Foo.prototype.c = 3;
                 *
                 * _.forOwn(new Foo, function(value, key) {
                 *   console.log(key);
                 * });
                 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
                 */
                function forOwn(object, iteratee) {
                  return object && baseForOwn(object, castFunction(iteratee));
                }

                _module441.exports = forOwn;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "omitBy.js": function module(_require439, _exports439, _module442) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/omitBy.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIteratee = _require439('./_baseIteratee'),
                    negate = _require439('./negate'),
                    pickBy = _require439('./pickBy');

                /**
                 * The opposite of `_.pickBy`; this method creates an object composed of
                 * the own and inherited enumerable string keyed properties of `object` that
                 * `predicate` doesn't return truthy for. The predicate is invoked with two
                 * arguments: (value, key).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {Function} [predicate=_.identity] The function invoked per property.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.omitBy(object, _.isNumber);
                 * // => { 'b': '2' }
                 */
                function omitBy(object, predicate) {
                  return pickBy(object, negate(baseIteratee(predicate)));
                }

                _module442.exports = omitBy;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "negate.js": function module(_require440, _exports440, _module443) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/negate.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /** Error message constants. */
                var FUNC_ERROR_TEXT = 'Expected a function';

                /**
                 * Creates a function that negates the result of the predicate `func`. The
                 * `func` predicate is invoked with the `this` binding and arguments of the
                 * created function.
                 *
                 * @static
                 * @memberOf _
                 * @since 3.0.0
                 * @category Function
                 * @param {Function} predicate The predicate to negate.
                 * @returns {Function} Returns the new negated function.
                 * @example
                 *
                 * function isEven(n) {
                 *   return n % 2 == 0;
                 * }
                 *
                 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
                 * // => [1, 3, 5]
                 */
                function negate(predicate) {
                  if (typeof predicate != 'function') {
                    throw new TypeError(FUNC_ERROR_TEXT);
                  }
                  return function () {
                    var args = arguments;
                    switch (args.length) {
                      case 0:
                        return !predicate.call(this);
                      case 1:
                        return !predicate.call(this, args[0]);
                      case 2:
                        return !predicate.call(this, args[0], args[1]);
                      case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                    }
                    return !predicate.apply(this, args);
                  };
                }

                _module443.exports = negate;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "pickBy.js": function module(_require441, _exports441, _module444) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/pickBy.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayMap = _require441('./_arrayMap'),
                    baseIteratee = _require441('./_baseIteratee'),
                    basePickBy = _require441('./_basePickBy'),
                    getAllKeysIn = _require441('./_getAllKeysIn');

                /**
                 * Creates an object composed of the `object` properties `predicate` returns
                 * truthy for. The predicate is invoked with two arguments: (value, key).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {Function} [predicate=_.identity] The function invoked per property.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.pickBy(object, _.isNumber);
                 * // => { 'a': 1, 'c': 3 }
                 */
                function pickBy(object, predicate) {
                  if (object == null) {
                    return {};
                  }
                  var props = arrayMap(getAllKeysIn(object), function (prop) {
                    return [prop];
                  });
                  predicate = baseIteratee(predicate);
                  return basePickBy(object, props, function (value, path) {
                    return predicate(value, path[0]);
                  });
                }

                _module444.exports = pickBy;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_basePickBy.js": function module(_require442, _exports442, _module445) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_basePickBy.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGet = _require442('./_baseGet'),
                    baseSet = _require442('./_baseSet'),
                    castPath = _require442('./_castPath');

                /**
                 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Object} object The source object.
                 * @param {string[]} paths The property paths to pick.
                 * @param {Function} predicate The function invoked per property.
                 * @returns {Object} Returns the new object.
                 */
                function basePickBy(object, paths, predicate) {
                  var index = -1,
                      length = paths.length,
                      result = {};

                  while (++index < length) {
                    var path = paths[index],
                        value = baseGet(object, path);

                    if (predicate(value, path)) {
                      baseSet(result, castPath(path, object), value);
                    }
                  }
                  return result;
                }

                _module445.exports = basePickBy;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseSet.js": function module(_require443, _exports443, _module446) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseSet.js                                                 //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assignValue = _require443('./_assignValue'),
                    castPath = _require443('./_castPath'),
                    isIndex = _require443('./_isIndex'),
                    isObject = _require443('./isObject'),
                    toKey = _require443('./_toKey');

                /**
                 * The base implementation of `_.set`.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {Array|string} path The path of the property to set.
                 * @param {*} value The value to set.
                 * @param {Function} [customizer] The function to customize path creation.
                 * @returns {Object} Returns `object`.
                 */
                function baseSet(object, path, value, customizer) {
                  if (!isObject(object)) {
                    return object;
                  }
                  path = castPath(path, object);

                  var index = -1,
                      length = path.length,
                      lastIndex = length - 1,
                      nested = object;

                  while (nested != null && ++index < length) {
                    var key = toKey(path[index]),
                        newValue = value;

                    if (index != lastIndex) {
                      var objValue = nested[key];
                      newValue = customizer ? customizer(objValue, key, nested) : undefined;
                      if (newValue === undefined) {
                        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                      }
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                  }
                  return object;
                }

                _module446.exports = baseSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "zipObject.js": function module(_require444, _exports444, _module447) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/zipObject.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var assignValue = _require444('./_assignValue'),
                    baseZipObject = _require444('./_baseZipObject');

                /**
                 * This method is like `_.fromPairs` except that it accepts two arrays,
                 * one of property identifiers and one of corresponding values.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.4.0
                 * @category Array
                 * @param {Array} [props=[]] The property identifiers.
                 * @param {Array} [values=[]] The property values.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * _.zipObject(['a', 'b'], [1, 2]);
                 * // => { 'a': 1, 'b': 2 }
                 */
                function zipObject(props, values) {
                  return baseZipObject(props || [], values || [], assignValue);
                }

                _module447.exports = zipObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseZipObject.js": function module(_require445, _exports445, _module448) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseZipObject.js                                           //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
                 *
                 * @private
                 * @param {Array} props The property identifiers.
                 * @param {Array} values The property values.
                 * @param {Function} assignFunc The function to assign values.
                 * @returns {Object} Returns the new object.
                 */
                function baseZipObject(props, values, assignFunc) {
                  var index = -1,
                      length = props.length,
                      valsLength = values.length,
                      result = {};

                  while (++index < length) {
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                  }
                  return result;
                }

                _module448.exports = baseZipObject;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "mapKeys.js": function module(_require446, _exports446, _module449) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/mapKeys.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseAssignValue = _require446('./_baseAssignValue'),
                    baseForOwn = _require446('./_baseForOwn'),
                    baseIteratee = _require446('./_baseIteratee');

                /**
                 * The opposite of `_.mapValues`; this method creates an object with the
                 * same values as `object` and keys generated by running each own enumerable
                 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
                 * with three arguments: (value, key, object).
                 *
                 * @static
                 * @memberOf _
                 * @since 3.8.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @returns {Object} Returns the new mapped object.
                 * @see _.mapValues
                 * @example
                 *
                 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
                 *   return key + value;
                 * });
                 * // => { 'a1': 1, 'b2': 2 }
                 */
                function mapKeys(object, iteratee) {
                  var result = {};
                  iteratee = baseIteratee(iteratee, 3);

                  baseForOwn(object, function (value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                  });
                  return result;
                }

                _module449.exports = mapKeys;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "omit.js": function module(_require447, _exports447, _module450) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/omit.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayMap = _require447('./_arrayMap'),
                    baseClone = _require447('./_baseClone'),
                    baseUnset = _require447('./_baseUnset'),
                    castPath = _require447('./_castPath'),
                    copyObject = _require447('./_copyObject'),
                    customOmitClone = _require447('./_customOmitClone'),
                    flatRest = _require447('./_flatRest'),
                    getAllKeysIn = _require447('./_getAllKeysIn');

                /** Used to compose bitmasks for cloning. */
                var CLONE_DEEP_FLAG = 1,
                    CLONE_FLAT_FLAG = 2,
                    CLONE_SYMBOLS_FLAG = 4;

                /**
                 * The opposite of `_.pick`; this method creates an object composed of the
                 * own and inherited enumerable property paths of `object` that are not omitted.
                 *
                 * **Note:** This method is considerably slower than `_.pick`.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Object
                 * @param {Object} object The source object.
                 * @param {...(string|string[])} [paths] The property paths to omit.
                 * @returns {Object} Returns the new object.
                 * @example
                 *
                 * var object = { 'a': 1, 'b': '2', 'c': 3 };
                 *
                 * _.omit(object, ['a', 'c']);
                 * // => { 'b': '2' }
                 */
                var omit = flatRest(function (object, paths) {
                  var result = {};
                  if (object == null) {
                    return result;
                  }
                  var isDeep = false;
                  paths = arrayMap(paths, function (path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                  });
                  copyObject(object, getAllKeysIn(object), result);
                  if (isDeep) {
                    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                  }
                  var length = paths.length;
                  while (length--) {
                    baseUnset(result, paths[length]);
                  }
                  return result;
                });

                _module450.exports = omit;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseUnset.js": function module(_require448, _exports448, _module451) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseUnset.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var castPath = _require448('./_castPath'),
                    last = _require448('./last'),
                    parent = _require448('./_parent'),
                    toKey = _require448('./_toKey');

                /**
                 * The base implementation of `_.unset`.
                 *
                 * @private
                 * @param {Object} object The object to modify.
                 * @param {Array|string} path The property path to unset.
                 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
                 */
                function baseUnset(object, path) {
                  path = castPath(path, object);
                  object = parent(object, path);
                  return object == null || delete object[toKey(last(path))];
                }

                _module451.exports = baseUnset;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "last.js": function module(_require449, _exports449, _module452) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/last.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Gets the last element of `array`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to query.
                 * @returns {*} Returns the last element of `array`.
                 * @example
                 *
                 * _.last([1, 2, 3]);
                 * // => 3
                 */
                function last(array) {
                  var length = array == null ? 0 : array.length;
                  return length ? array[length - 1] : undefined;
                }

                _module452.exports = last;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_parent.js": function module(_require450, _exports450, _module453) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_parent.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGet = _require450('./_baseGet'),
                    baseSlice = _require450('./_baseSlice');

                /**
                 * Gets the parent value at `path` of `object`.
                 *
                 * @private
                 * @param {Object} object The object to query.
                 * @param {Array} path The path to get the parent value of.
                 * @returns {*} Returns the parent value.
                 */
                function parent(object, path) {
                  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
                }

                _module453.exports = parent;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseSlice.js": function module(_require451, _exports451, _module454) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseSlice.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * The base implementation of `_.slice` without an iteratee call guard.
                 *
                 * @private
                 * @param {Array} array The array to slice.
                 * @param {number} [start=0] The start position.
                 * @param {number} [end=array.length] The end position.
                 * @returns {Array} Returns the slice of `array`.
                 */
                function baseSlice(array, start, end) {
                  var index = -1,
                      length = array.length;

                  if (start < 0) {
                    start = -start > length ? 0 : length + start;
                  }
                  end = end > length ? length : end;
                  if (end < 0) {
                    end += length;
                  }
                  length = start > end ? 0 : end - start >>> 0;
                  start >>>= 0;

                  var result = Array(length);
                  while (++index < length) {
                    result[index] = array[index + start];
                  }
                  return result;
                }

                _module454.exports = baseSlice;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_customOmitClone.js": function module(_require452, _exports452, _module455) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_customOmitClone.js                                         //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isPlainObject = _require452('./isPlainObject');

                /**
                 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
                 * objects.
                 *
                 * @private
                 * @param {*} value The value to inspect.
                 * @param {string} key The key of the property to inspect.
                 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
                 */
                function customOmitClone(value) {
                  return isPlainObject(value) ? undefined : value;
                }

                _module455.exports = customOmitClone;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_flatRest.js": function module(_require453, _exports453, _module456) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_flatRest.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var flatten = _require453('./flatten'),
                    overRest = _require453('./_overRest'),
                    setToString = _require453('./_setToString');

                /**
                 * A specialized version of `baseRest` which flattens the rest array.
                 *
                 * @private
                 * @param {Function} func The function to apply a rest parameter to.
                 * @returns {Function} Returns the new function.
                 */
                function flatRest(func) {
                  return setToString(overRest(func, undefined, flatten), func + '');
                }

                _module456.exports = flatRest;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "flatten.js": function module(_require454, _exports454, _module457) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/flatten.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseFlatten = _require454('./_baseFlatten');

                /**
                 * Flattens `array` a single level deep.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to flatten.
                 * @returns {Array} Returns the new flattened array.
                 * @example
                 *
                 * _.flatten([1, [2, [3, [4]], 5]]);
                 * // => [1, 2, [3, [4]], 5]
                 */
                function flatten(array) {
                  var length = array == null ? 0 : array.length;
                  return length ? baseFlatten(array, 1) : [];
                }

                _module457.exports = flatten;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "range.js": function module(_require455, _exports455, _module458) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/range.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var createRange = _require455('./_createRange');

                /**
                 * Creates an array of numbers (positive and/or negative) progressing from
                 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
                 * `start` is specified without an `end` or `step`. If `end` is not specified,
                 * it's set to `start` with `start` then set to `0`.
                 *
                 * **Note:** JavaScript follows the IEEE-754 standard for resolving
                 * floating-point values which can produce unexpected results.
                 *
                 * @static
                 * @since 0.1.0
                 * @memberOf _
                 * @category Util
                 * @param {number} [start=0] The start of the range.
                 * @param {number} end The end of the range.
                 * @param {number} [step=1] The value to increment or decrement by.
                 * @returns {Array} Returns the range of numbers.
                 * @see _.inRange, _.rangeRight
                 * @example
                 *
                 * _.range(4);
                 * // => [0, 1, 2, 3]
                 *
                 * _.range(-4);
                 * // => [0, -1, -2, -3]
                 *
                 * _.range(1, 5);
                 * // => [1, 2, 3, 4]
                 *
                 * _.range(0, 20, 5);
                 * // => [0, 5, 10, 15]
                 *
                 * _.range(0, -4, -1);
                 * // => [0, -1, -2, -3]
                 *
                 * _.range(1, 4, 0);
                 * // => [1, 1, 1]
                 *
                 * _.range(0);
                 * // => []
                 */
                var range = createRange();

                _module458.exports = range;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createRange.js": function module(_require456, _exports456, _module459) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createRange.js                                             //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseRange = _require456('./_baseRange'),
                    isIterateeCall = _require456('./_isIterateeCall'),
                    toFinite = _require456('./toFinite');

                /**
                 * Creates a `_.range` or `_.rangeRight` function.
                 *
                 * @private
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Function} Returns the new range function.
                 */
                function createRange(fromRight) {
                  return function (start, end, step) {
                    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
                      end = step = undefined;
                    }
                    // Ensure the sign of `-0` is preserved.
                    start = toFinite(start);
                    if (end === undefined) {
                      end = start;
                      start = 0;
                    } else {
                      end = toFinite(end);
                    }
                    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                    return baseRange(start, end, step, fromRight);
                  };
                }

                _module459.exports = createRange;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseRange.js": function module(_require457, _exports457, _module460) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseRange.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeCeil = Math.ceil,
                    nativeMax = Math.max;

                /**
                 * The base implementation of `_.range` and `_.rangeRight` which doesn't
                 * coerce arguments.
                 *
                 * @private
                 * @param {number} start The start of the range.
                 * @param {number} end The end of the range.
                 * @param {number} step The value to increment or decrement by.
                 * @param {boolean} [fromRight] Specify iterating from right to left.
                 * @returns {Array} Returns the range of numbers.
                 */
                function baseRange(start, end, step, fromRight) {
                  var index = -1,
                      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
                      result = Array(length);

                  while (length--) {
                    result[fromRight ? length : ++index] = start;
                    start += step;
                  }
                  return result;
                }

                _module460.exports = baseRange;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "noop.js": function module(_require458, _exports458, _module461) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/noop.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * This method returns `undefined`.
                 *
                 * @static
                 * @memberOf _
                 * @since 2.3.0
                 * @category Util
                 * @example
                 *
                 * _.times(2, _.noop);
                 * // => [undefined, undefined]
                 */
                function noop() {
                  // No operation performed.
                }

                _module461.exports = noop;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "union.js": function module(_require459, _exports459, _module462) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/union.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseFlatten = _require459('./_baseFlatten'),
                    baseRest = _require459('./_baseRest'),
                    baseUniq = _require459('./_baseUniq'),
                    isArrayLikeObject = _require459('./isArrayLikeObject');

                /**
                 * Creates an array of unique values, in order, from all given arrays using
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {...Array} [arrays] The arrays to inspect.
                 * @returns {Array} Returns the new array of combined values.
                 * @example
                 *
                 * _.union([2], [1, 2]);
                 * // => [2, 1]
                 */
                var union = baseRest(function (arrays) {
                  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
                });

                _module462.exports = union;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseUniq.js": function module(_require460, _exports460, _module463) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseUniq.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var SetCache = _require460('./_SetCache'),
                    arrayIncludes = _require460('./_arrayIncludes'),
                    arrayIncludesWith = _require460('./_arrayIncludesWith'),
                    cacheHas = _require460('./_cacheHas'),
                    createSet = _require460('./_createSet'),
                    setToArray = _require460('./_setToArray');

                /** Used as the size to enable large array optimizations. */
                var LARGE_ARRAY_SIZE = 200;

                /**
                 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array} array The array to inspect.
                 * @param {Function} [iteratee] The iteratee invoked per element.
                 * @param {Function} [comparator] The comparator invoked per element.
                 * @returns {Array} Returns the new duplicate free array.
                 */
                function baseUniq(array, iteratee, comparator) {
                  var index = -1,
                      includes = arrayIncludes,
                      length = array.length,
                      isCommon = true,
                      result = [],
                      seen = result;

                  if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                  } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) {
                      return setToArray(set);
                    }
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache();
                  } else {
                    seen = iteratee ? [] : result;
                  }
                  outer: while (++index < length) {
                    var value = array[index],
                        computed = iteratee ? iteratee(value) : value;

                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                      var seenIndex = seen.length;
                      while (seenIndex--) {
                        if (seen[seenIndex] === computed) {
                          continue outer;
                        }
                      }
                      if (iteratee) {
                        seen.push(computed);
                      }
                      result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                      if (seen !== result) {
                        seen.push(computed);
                      }
                      result.push(value);
                    }
                  }
                  return result;
                }

                _module463.exports = baseUniq;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_createSet.js": function module(_require461, _exports461, _module464) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_createSet.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var Set = _require461('./_Set'),
                    noop = _require461('./noop'),
                    setToArray = _require461('./_setToArray');

                /** Used as references for various `Number` constants. */
                var INFINITY = 1 / 0;

                /**
                 * Creates a set object of `values`.
                 *
                 * @private
                 * @param {Array} values The values to add to the set.
                 * @returns {Object} Returns the new set.
                 */
                var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
                  return new Set(values);
                };

                _module464.exports = createSet;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "transform.js": function module(_require462, _exports462, _module465) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/transform.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayEach = _require462('./_arrayEach'),
                    baseCreate = _require462('./_baseCreate'),
                    baseForOwn = _require462('./_baseForOwn'),
                    baseIteratee = _require462('./_baseIteratee'),
                    getPrototype = _require462('./_getPrototype'),
                    isArray = _require462('./isArray'),
                    isBuffer = _require462('./isBuffer'),
                    isFunction = _require462('./isFunction'),
                    isObject = _require462('./isObject'),
                    isTypedArray = _require462('./isTypedArray');

                /**
                 * An alternative to `_.reduce`; this method transforms `object` to a new
                 * `accumulator` object which is the result of running each of its own
                 * enumerable string keyed properties thru `iteratee`, with each invocation
                 * potentially mutating the `accumulator` object. If `accumulator` is not
                 * provided, a new object with the same `[[Prototype]]` will be used. The
                 * iteratee is invoked with four arguments: (accumulator, value, key, object).
                 * Iteratee functions may exit iteration early by explicitly returning `false`.
                 *
                 * @static
                 * @memberOf _
                 * @since 1.3.0
                 * @category Object
                 * @param {Object} object The object to iterate over.
                 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
                 * @param {*} [accumulator] The custom accumulator value.
                 * @returns {*} Returns the accumulated value.
                 * @example
                 *
                 * _.transform([2, 3, 4], function(result, n) {
                 *   result.push(n *= n);
                 *   return n % 2 == 0;
                 * }, []);
                 * // => [4, 9]
                 *
                 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
                 *   (result[value] || (result[value] = [])).push(key);
                 * }, {});
                 * // => { '1': ['a', 'c'], '2': ['b'] }
                 */
                function transform(object, iteratee, accumulator) {
                  var isArr = isArray(object),
                      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

                  iteratee = baseIteratee(iteratee, 4);
                  if (accumulator == null) {
                    var Ctor = object && object.constructor;
                    if (isArrLike) {
                      accumulator = isArr ? new Ctor() : [];
                    } else if (isObject(object)) {
                      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                    } else {
                      accumulator = {};
                    }
                  }
                  (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
                    return iteratee(accumulator, value, index, object);
                  });
                  return accumulator;
                }

                _module465.exports = transform;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isNull.js": function module(_require463, _exports463, _module466) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isNull.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * Checks if `value` is `null`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
                 * @example
                 *
                 * _.isNull(null);
                 * // => true
                 *
                 * _.isNull(void 0);
                 * // => false
                 */
                function isNull(value) {
                  return value === null;
                }

                _module466.exports = isNull;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "uniq.js": function module(_require464, _exports464, _module467) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/uniq.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseUniq = _require464('./_baseUniq');

                /**
                 * Creates a duplicate-free version of an array, using
                 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons, in which only the first occurrence of each element
                 * is kept. The order of result values is determined by the order they occur
                 * in the array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @returns {Array} Returns the new duplicate free array.
                 * @example
                 *
                 * _.uniq([2, 1, 2]);
                 * // => [2, 1]
                 */
                function uniq(array) {
                  return array && array.length ? baseUniq(array) : [];
                }

                _module467.exports = uniq;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "every.js": function module(_require465, _exports465, _module468) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/every.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayEvery = _require465('./_arrayEvery'),
                    baseEvery = _require465('./_baseEvery'),
                    baseIteratee = _require465('./_baseIteratee'),
                    isArray = _require465('./isArray'),
                    isIterateeCall = _require465('./_isIterateeCall');

                /**
                 * Checks if `predicate` returns truthy for **all** elements of `collection`.
                 * Iteration is stopped once `predicate` returns falsey. The predicate is
                 * invoked with three arguments: (value, index|key, collection).
                 *
                 * **Note:** This method returns `true` for
                 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
                 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
                 * elements of empty collections.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                 * @returns {boolean} Returns `true` if all elements pass the predicate check,
                 *  else `false`.
                 * @example
                 *
                 * _.every([true, 1, null, 'yes'], Boolean);
                 * // => false
                 *
                 * var users = [
                 *   { 'user': 'barney', 'age': 36, 'active': false },
                 *   { 'user': 'fred',   'age': 40, 'active': false }
                 * ];
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.every(users, { 'user': 'barney', 'active': false });
                 * // => false
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.every(users, ['active', false]);
                 * // => true
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.every(users, 'active');
                 * // => false
                 */
                function every(collection, predicate, guard) {
                  var func = isArray(collection) ? arrayEvery : baseEvery;
                  if (guard && isIterateeCall(collection, predicate, guard)) {
                    predicate = undefined;
                  }
                  return func(collection, baseIteratee(predicate, 3));
                }

                _module468.exports = every;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_arrayEvery.js": function module(_require466, _exports466, _module469) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_arrayEvery.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                /**
                 * A specialized version of `_.every` for arrays without support for
                 * iteratee shorthands.
                 *
                 * @private
                 * @param {Array} [array] The array to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if all elements pass the predicate check,
                 *  else `false`.
                 */
                function arrayEvery(array, predicate) {
                  var index = -1,
                      length = array == null ? 0 : array.length;

                  while (++index < length) {
                    if (!predicate(array[index], index, array)) {
                      return false;
                    }
                  }
                  return true;
                }

                _module469.exports = arrayEvery;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseEvery.js": function module(_require467, _exports467, _module470) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseEvery.js                                               //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseEach = _require467('./_baseEach');

                /**
                 * The base implementation of `_.every` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if all elements pass the predicate check,
                 *  else `false`
                 */
                function baseEvery(collection, predicate) {
                  var result = true;
                  baseEach(collection, function (value, index, collection) {
                    result = !!predicate(value, index, collection);
                    return result;
                  });
                  return result;
                }

                _module470.exports = baseEvery;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isNaN.js": function module(_require468, _exports468, _module471) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isNaN.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var isNumber = _require468('./isNumber');

                /**
                 * Checks if `value` is `NaN`.
                 *
                 * **Note:** This method is based on
                 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
                 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
                 * `undefined` and other non-number values.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
                 * @example
                 *
                 * _.isNaN(NaN);
                 * // => true
                 *
                 * _.isNaN(new Number(NaN));
                 * // => true
                 *
                 * isNaN(undefined);
                 * // => true
                 *
                 * _.isNaN(undefined);
                 * // => false
                 */
                function isNaN(value) {
                  // An `NaN` primitive is the only value that is not equal to itself.
                  // Perform the `toStringTag` check first to avoid errors with some
                  // ActiveX objects in IE.
                  return isNumber(value) && value != +value;
                }

                _module471.exports = isNaN;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "filter.js": function module(_require469, _exports469, _module472) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/filter.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arrayFilter = _require469('./_arrayFilter'),
                    baseFilter = _require469('./_baseFilter'),
                    baseIteratee = _require469('./_baseIteratee'),
                    isArray = _require469('./isArray');

                /**
                 * Iterates over elements of `collection`, returning an array of all elements
                 * `predicate` returns truthy for. The predicate is invoked with three
                 * arguments: (value, index|key, collection).
                 *
                 * **Note:** Unlike `_.remove`, this method returns a new array.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 * @see _.reject
                 * @example
                 *
                 * var users = [
                 *   { 'user': 'barney', 'age': 36, 'active': true },
                 *   { 'user': 'fred',   'age': 40, 'active': false }
                 * ];
                 *
                 * _.filter(users, function(o) { return !o.active; });
                 * // => objects for ['fred']
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.filter(users, { 'age': 36, 'active': true });
                 * // => objects for ['barney']
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.filter(users, ['active', false]);
                 * // => objects for ['fred']
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.filter(users, 'active');
                 * // => objects for ['barney']
                 */
                function filter(collection, predicate) {
                  var func = isArray(collection) ? arrayFilter : baseFilter;
                  return func(collection, baseIteratee(predicate, 3));
                }

                _module472.exports = filter;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseFilter.js": function module(_require470, _exports470, _module473) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseFilter.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseEach = _require470('./_baseEach');

                /**
                 * The base implementation of `_.filter` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {Array} Returns the new filtered array.
                 */
                function baseFilter(collection, predicate) {
                  var result = [];
                  baseEach(collection, function (value, index, collection) {
                    if (predicate(value, index, collection)) {
                      result.push(value);
                    }
                  });
                  return result;
                }

                _module473.exports = baseFilter;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "some.js": function module(_require471, _exports471, _module474) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/some.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var arraySome = _require471('./_arraySome'),
                    baseIteratee = _require471('./_baseIteratee'),
                    baseSome = _require471('./_baseSome'),
                    isArray = _require471('./isArray'),
                    isIterateeCall = _require471('./_isIterateeCall');

                /**
                 * Checks if `predicate` returns truthy for **any** element of `collection`.
                 * Iteration is stopped once `predicate` returns truthy. The predicate is
                 * invoked with three arguments: (value, index|key, collection).
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Collection
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} [predicate=_.identity] The function invoked per iteration.
                 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 * @example
                 *
                 * _.some([null, 0, 'yes', false], Boolean);
                 * // => true
                 *
                 * var users = [
                 *   { 'user': 'barney', 'active': true },
                 *   { 'user': 'fred',   'active': false }
                 * ];
                 *
                 * // The `_.matches` iteratee shorthand.
                 * _.some(users, { 'user': 'barney', 'active': false });
                 * // => false
                 *
                 * // The `_.matchesProperty` iteratee shorthand.
                 * _.some(users, ['active', false]);
                 * // => true
                 *
                 * // The `_.property` iteratee shorthand.
                 * _.some(users, 'active');
                 * // => true
                 */
                function some(collection, predicate, guard) {
                  var func = isArray(collection) ? arraySome : baseSome;
                  if (guard && isIterateeCall(collection, predicate, guard)) {
                    predicate = undefined;
                  }
                  return func(collection, baseIteratee(predicate, 3));
                }

                _module474.exports = some;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseSome.js": function module(_require472, _exports472, _module475) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseSome.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseEach = _require472('./_baseEach');

                /**
                 * The base implementation of `_.some` without support for iteratee shorthands.
                 *
                 * @private
                 * @param {Array|Object} collection The collection to iterate over.
                 * @param {Function} predicate The function invoked per iteration.
                 * @returns {boolean} Returns `true` if any element passes the predicate check,
                 *  else `false`.
                 */
                function baseSome(collection, predicate) {
                  var result;

                  baseEach(collection, function (value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                  });
                  return !!result;
                }

                _module475.exports = baseSome;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isDate.js": function module(_require473, _exports473, _module476) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isDate.js                                                   //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIsDate = _require473('./_baseIsDate'),
                    baseUnary = _require473('./_baseUnary'),
                    nodeUtil = _require473('./_nodeUtil');

                /* Node.js helper references. */
                var nodeIsDate = nodeUtil && nodeUtil.isDate;

                /**
                 * Checks if `value` is classified as a `Date` object.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                 * @example
                 *
                 * _.isDate(new Date);
                 * // => true
                 *
                 * _.isDate('Mon April 23 2012');
                 * // => false
                 */
                var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

                _module476.exports = isDate;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "_baseIsDate.js": function module(_require474, _exports474, _module477) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/_baseIsDate.js                                              //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseGetTag = _require474('./_baseGetTag'),
                    isObjectLike = _require474('./isObjectLike');

                /** `Object#toString` result references. */
                var dateTag = '[object Date]';

                /**
                 * The base implementation of `_.isDate` without Node.js optimizations.
                 *
                 * @private
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
                 */
                function baseIsDate(value) {
                  return isObjectLike(value) && baseGetTag(value) == dateTag;
                }

                _module477.exports = baseIsDate;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "isInteger.js": function module(_require475, _exports475, _module478) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/isInteger.js                                                //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var toInteger = _require475('./toInteger');

                /**
                 * Checks if `value` is an integer.
                 *
                 * **Note:** This method is based on
                 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Lang
                 * @param {*} value The value to check.
                 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
                 * @example
                 *
                 * _.isInteger(3);
                 * // => true
                 *
                 * _.isInteger(Number.MIN_VALUE);
                 * // => false
                 *
                 * _.isInteger(Infinity);
                 * // => false
                 *
                 * _.isInteger('3');
                 * // => false
                 */
                function isInteger(value) {
                  return typeof value == 'number' && value == toInteger(value);
                }

                _module478.exports = isInteger;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "tail.js": function module(_require476, _exports476, _module479) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/tail.js                                                     //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseSlice = _require476('./_baseSlice');

                /**
                 * Gets all but the first element of `array`.
                 *
                 * @static
                 * @memberOf _
                 * @since 4.0.0
                 * @category Array
                 * @param {Array} array The array to query.
                 * @returns {Array} Returns the slice of `array`.
                 * @example
                 *
                 * _.tail([1, 2, 3]);
                 * // => [2, 3]
                 */
                function tail(array) {
                  var length = array == null ? 0 : array.length;
                  return length ? baseSlice(array, 1, length) : [];
                }

                _module479.exports = tail;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "indexOf.js": function module(_require477, _exports477, _module480) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/indexOf.js                                                  //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseIndexOf = _require477('./_baseIndexOf'),
                    toInteger = _require477('./toInteger');

                /* Built-in method references for those with the same name as other `lodash` methods. */
                var nativeMax = Math.max;

                /**
                 * Gets the index at which the first occurrence of `value` is found in `array`
                 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
                 * for equality comparisons. If `fromIndex` is negative, it's used as the
                 * offset from the end of `array`.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Array
                 * @param {Array} array The array to inspect.
                 * @param {*} value The value to search for.
                 * @param {number} [fromIndex=0] The index to search from.
                 * @returns {number} Returns the index of the matched value, else `-1`.
                 * @example
                 *
                 * _.indexOf([1, 2, 1, 2], 2);
                 * // => 1
                 *
                 * // Search from the `fromIndex`.
                 * _.indexOf([1, 2, 1, 2], 2, 2);
                 * // => 3
                 */
                function indexOf(array, value, fromIndex) {
                  var length = array == null ? 0 : array.length;
                  if (!length) {
                    return -1;
                  }
                  var index = fromIndex == null ? 0 : toInteger(fromIndex);
                  if (index < 0) {
                    index = nativeMax(length + index, 0);
                  }
                  return baseIndexOf(array, value, index);
                }

                _module480.exports = indexOf;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              }, "clone.js": function module(_require478, _exports478, _module481) {

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //                                                                                                                    //
                // node_modules/meteor/jagi_astronomy/node_modules/lodash/clone.js                                                    //
                //                                                                                                                    //
                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                //
                var baseClone = _require478('./_baseClone');

                /** Used to compose bitmasks for cloning. */
                var CLONE_SYMBOLS_FLAG = 4;

                /**
                 * Creates a shallow clone of `value`.
                 *
                 * **Note:** This method is loosely based on the
                 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
                 * and supports cloning arrays, array buffers, booleans, date objects, maps,
                 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
                 * arrays. The own enumerable properties of `arguments` objects are cloned
                 * as plain objects. An empty object is returned for uncloneable values such
                 * as error objects, functions, DOM nodes, and WeakMaps.
                 *
                 * @static
                 * @memberOf _
                 * @since 0.1.0
                 * @category Lang
                 * @param {*} value The value to clone.
                 * @returns {*} Returns the cloned value.
                 * @see _.cloneDeep
                 * @example
                 *
                 * var objects = [{ 'a': 1 }, { 'b': 2 }];
                 *
                 * var shallow = _.clone(objects);
                 * console.log(shallow[0] === objects[0]);
                 * // => true
                 */
                function clone(value) {
                  return baseClone(value, CLONE_SYMBOLS_FLAG);
                }

                _module481.exports = clone;

                ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              } } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/jagi:astronomy/lib/main.js");

  /* Exports */
  Package._define("jagi:astronomy", _exports2);
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require3 = meteorInstall({ "node_modules": { "meteor": { "jagi:astronomy-timestamp-behavior": { "lib": { "main.js": function module(_require, _exports, _module) {

              //////////////////////////////////////////////////////////////////////////
              //                                                                      //
              // packages/jagi_astronomy-timestamp-behavior/lib/main.js               //
              //                                                                      //
              //////////////////////////////////////////////////////////////////////////
              //
              _module.link("./behavior/behavior.js");
              //////////////////////////////////////////////////////////////////////////
            }, "behavior": { "behavior.js": function module(_require2, _exports2, _module2) {

                //////////////////////////////////////////////////////////////////////////
                //                                                                      //
                // packages/jagi_astronomy-timestamp-behavior/lib/behavior/behavior.js  //
                //                                                                      //
                //////////////////////////////////////////////////////////////////////////
                //
                let Behavior;
                _module2.link("meteor/jagi:astronomy", {
                  Behavior(v) {
                    Behavior = v;
                  }

                }, 0);
                Behavior.create({
                  name: 'timestamp',
                  options: {
                    hasCreatedField: true,
                    createdFieldName: 'createdAt',
                    hasUpdatedField: true,
                    updatedFieldName: 'updatedAt'
                  },
                  createClassDefinition: function () {
                    const definition = {
                      fields: {},
                      events: {
                        beforeInsert: e => {
                          var doc = e.currentTarget;
                          var Class = doc.constructor;
                          this.setCreationDate(doc);
                        },
                        beforeUpdate: e => {
                          var doc = e.currentTarget;
                          var Class = doc.constructor;
                          this.setModificationDate(doc);
                        }
                      }
                    };

                    if (this.options.hasCreatedField) {
                      // Add a field for storing a creation date.
                      definition.fields[this.options.createdFieldName] = {
                        type: Date,
                        immutable: true,
                        optional: true
                      };
                    }

                    if (this.options.hasUpdatedField) {
                      // Add a field for storing an update date.
                      definition.fields[this.options.updatedFieldName] = {
                        type: Date,
                        optional: true
                      };
                    }

                    return definition;
                  },
                  apply: function (Class) {
                    Class.extend(this.createClassDefinition(), ['fields', 'events']);
                  },
                  setCreationDate: function (doc) {
                    // Get current date.
                    const date = new Date(); // If the "hasCreatedField" option is set.

                    if (this.options.hasCreatedField) {
                      // Set value for created field.
                      doc[this.options.createdFieldName] = date;
                    }

                    if (this.options.hasUpdatedField) {
                      // Set value for the "updatedAt" field.
                      doc[this.options.updatedFieldName] = date;
                    }
                  },
                  setModificationDate: function (doc) {
                    // Get current date.
                    const date = new Date(); // If the "hasUpdatedField" option is set.

                    if (this.options.hasUpdatedField) {
                      // Set value for the "updatedAt" field.
                      doc[this.options.updatedFieldName] = date;
                    }
                  }
                });
                //////////////////////////////////////////////////////////////////////////
              } } } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports3 = _require3("/node_modules/meteor/jagi:astronomy-timestamp-behavior/lib/main.js");

  /* Exports */
  Package._define("jagi:astronomy-timestamp-behavior", _exports3);
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require = meteorInstall({ "node_modules": { "meteor": { "grove:call-async": { "lib": { "call-async.js": function _module() {

              //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //                                                                                                              //
              // packages/grove_call-async/lib/call-async.js                                                                  //
              //                                                                                                              //
              //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              //
              Meteor.callAsync = function (method) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key];
                }

                return Meteor.applyAsync(method, args);
              };

              Meteor.applyAsync = function (method, args) {
                let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                // Not checking argument types, hopefully no one is passing a callback here
                // If there is a stub and there is an error, it should throw an exception
                options.throwStubExceptions = true;
                return new Promise((resolve, reject) => {
                  Meteor.apply(method, args, options, (err, res) => {
                    if (err) reject(err);else resolve(res);
                  });
                });
              };
              //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            } } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/grove:call-async/lib/call-async.js");

  /* Exports */
  Package._define("grove:call-async");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var Reload = Package.reload.Reload;
  var Base64 = Package.base64.Base64;
  var URL = Package.url.URL;
  var URLSearchParams = Package.url.URLSearchParams;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var OAuth, Oauth;

  var _require = meteorInstall({ "node_modules": { "meteor": { "oauth": { "oauth_client.js": function _module() {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/oauth/oauth_client.js                                                                                      //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // credentialToken -> credentialSecret. You must provide both the
            // credentialToken and the credentialSecret to retrieve an access token from
            // the _pendingCredentials collection.
            const credentialSecrets = {};
            OAuth = {};

            OAuth.showPopup = (url, callback, dimensions) => {
              throw new Error("OAuth.showPopup must be implemented on this arch.");
            }; // Determine the login style (popup or redirect) for this login flow.
            //
            //


            OAuth._loginStyle = (service, config, options) => {
              if (Meteor.isCordova) {
                return "popup";
              }

              let loginStyle = options && options.loginStyle || config.loginStyle || 'popup';
              if (!["popup", "redirect"].includes(loginStyle)) throw new Error("Invalid login style: ".concat(loginStyle)); // If we don't have session storage (for example, Safari in private
              // mode), the redirect login flow won't work, so fallback to the
              // popup style.

              if (loginStyle === 'redirect') {
                try {
                  sessionStorage.setItem('Meteor.oauth.test', 'test');
                  sessionStorage.removeItem('Meteor.oauth.test');
                } catch (e) {
                  loginStyle = 'popup';
                }
              }

              return loginStyle;
            };

            OAuth._stateParam = (loginStyle, credentialToken, redirectUrl) => {
              var _Meteor$settings, _Meteor$settings$publ, _Meteor$settings$publ2, _Meteor$settings$publ3;

              const state = {
                loginStyle,
                credentialToken,
                isCordova: Meteor.isCordova
              };

              if (loginStyle === 'redirect' || (_Meteor$settings = Meteor.settings) !== null && _Meteor$settings !== void 0 && (_Meteor$settings$publ = _Meteor$settings.public) !== null && _Meteor$settings$publ !== void 0 && (_Meteor$settings$publ2 = _Meteor$settings$publ.packages) !== null && _Meteor$settings$publ2 !== void 0 && (_Meteor$settings$publ3 = _Meteor$settings$publ2.oauth) !== null && _Meteor$settings$publ3 !== void 0 && _Meteor$settings$publ3.setRedirectUrlWhenLoginStyleIsPopup && loginStyle === 'popup') {
                state.redirectUrl = redirectUrl || '' + window.location;
              } // Encode base64 as not all login services URI-encode the state
              // parameter when they pass it back to us.
              // Use the 'base64' package here because 'btoa' isn't supported in IE8/9.


              return Base64.encode(JSON.stringify(state));
            }; // At the beginning of the redirect login flow, before we redirect to
            // the login service, save the credential token for this login attempt
            // in the reload migration data.
            //


            OAuth.saveDataForRedirect = (loginService, credentialToken) => {
              Reload._onMigrate('oauth', () => [true, {
                loginService,
                credentialToken
              }]);

              Reload._migrate(null, {
                immediateMigration: true
              });
            }; // At the end of the redirect login flow, when we've redirected back
            // to the application, retrieve the credentialToken and (if the login
            // was successful) the credentialSecret.
            //
            // Called at application startup.  Returns null if this is normal
            // application startup and we weren't just redirected at the end of
            // the login flow.
            //


            OAuth.getDataAfterRedirect = () => {
              const migrationData = Reload._migrationData('oauth');

              if (!(migrationData && migrationData.credentialToken)) return null;
              const {
                credentialToken
              } = migrationData;
              const key = OAuth._storageTokenPrefix + credentialToken;
              let credentialSecret;

              try {
                credentialSecret = sessionStorage.getItem(key);
                sessionStorage.removeItem(key);
              } catch (e) {
                Meteor._debug('error retrieving credentialSecret', e);
              }

              return {
                loginService: migrationData.loginService,
                credentialToken,
                credentialSecret
              };
            }; // Launch an OAuth login flow.  For the popup login style, show the
            // popup.  For the redirect login style, save the credential token for
            // this login attempt in the reload migration data, and redirect to
            // the service for the login.
            //
            // options:
            //  loginService: "facebook", "google", etc.
            //  loginStyle: "popup" or "redirect"
            //  loginUrl: The URL at the login service provider to start the OAuth flow.
            //  credentialRequestCompleteCallback: for the popup flow, call when the popup
            //    is closed and we have the credential from the login service.
            //  credentialToken: our identifier for this login flow.
            //


            OAuth.launchLogin = options => {
              if (!options.loginService) throw new Error('loginService required');

              if (options.loginStyle === 'popup') {
                OAuth.showPopup(options.loginUrl, options.credentialRequestCompleteCallback.bind(null, options.credentialToken), options.popupOptions);
              } else if (options.loginStyle === 'redirect') {
                OAuth.saveDataForRedirect(options.loginService, options.credentialToken);
                window.location = options.loginUrl;
              } else {
                throw new Error('invalid login style');
              }
            }; // XXX COMPAT WITH 0.7.0.1
            // Private interface but probably used by many oauth clients in atmosphere.


            OAuth.initiateLogin = (credentialToken, url, callback, dimensions) => {
              OAuth.showPopup(url, callback.bind(null, credentialToken), dimensions);
            }; // Called by the popup when the OAuth flow is completed, right before
            // the popup closes.


            OAuth._handleCredentialSecret = (credentialToken, secret) => {
              check(credentialToken, String);
              check(secret, String);

              if (!Object.prototype.hasOwnProperty.call(credentialSecrets, credentialToken)) {
                credentialSecrets[credentialToken] = secret;
              } else {
                throw new Error("Duplicate credential token from OAuth login");
              }
            }; // Used by accounts-oauth, which needs both a credentialToken and the
            // corresponding to credential secret to call the `login` method over DDP.


            OAuth._retrieveCredentialSecret = credentialToken => {
              // First check the secrets collected by OAuth._handleCredentialSecret,
              // then check localStorage. This matches what we do in
              // end_of_login_response.html.
              let secret = credentialSecrets[credentialToken];

              if (!secret) {
                const localStorageKey = OAuth._storageTokenPrefix + credentialToken;
                secret = Meteor._localStorage.getItem(localStorageKey);

                Meteor._localStorage.removeItem(localStorageKey);
              } else {
                delete credentialSecrets[credentialToken];
              }

              return secret;
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "oauth_browser.js": function _module2() {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/oauth/oauth_browser.js                                                                                     //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // Browser specific code for the OAuth package.
            // Open a popup window, centered on the screen, and call a callback when it
            // closes.
            //
            // @param url {String} url to show
            // @param callback {Function} Callback function to call on completion. Takes no
            //   arguments.
            // @param dimensions {optional Object(width, height)} The dimensions of
            //   the popup. If not passed defaults to something sane.
            OAuth.showPopup = (url, callback, dimensions) => {
              // default dimensions that worked well for facebook and google
              const popup = openCenteredPopup(url, dimensions && dimensions.width || 650, dimensions && dimensions.height || 331);
              const checkPopupOpen = setInterval(() => {
                let popupClosed;

                try {
                  // Fix for #328 - added a second test criteria (popup.closed === undefined)
                  // to humour this Android quirk:
                  // http://code.google.com/p/android/issues/detail?id=21061
                  popupClosed = popup.closed || popup.closed === undefined;
                } catch (e) {
                  // For some unknown reason, IE9 (and others?) sometimes (when
                  // the popup closes too quickly?) throws "SCRIPT16386: No such
                  // interface supported" when trying to read 'popup.closed'. Try
                  // again in 100ms.
                  return;
                }

                if (popupClosed) {
                  clearInterval(checkPopupOpen);
                  callback();
                }
              }, 100);
            };

            const openCenteredPopup = function (url, width, height) {
              const screenX = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft;
              const screenY = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop;
              const outerWidth = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.body.clientWidth;
              const outerHeight = typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.body.clientHeight - 22; // XXX what is the 22?
              // Use `outerWidth - width` and `outerHeight - height` for help in
              // positioning the popup centered relative to the current window

              const left = screenX + (outerWidth - width) / 2;
              const top = screenY + (outerHeight - height) / 2;
              const features = "width=".concat(width, ",height=").concat(height) + ",left=".concat(left, ",top=").concat(top, ",scrollbars=yes");
              const newwindow = window.open(url, 'Login', features);

              if (typeof newwindow === 'undefined') {
                // blocked by a popup blocker maybe?
                const err = new Error("The login popup was blocked by the browser");
                err.attemptedUrl = url;
                throw err;
              }

              if (newwindow.focus) newwindow.focus();
              return newwindow;
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "oauth_common.js": function module(_require2, _exports, _module3) {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/oauth/oauth_common.js                                                                                      //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module3.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            OAuth._storageTokenPrefix = "Meteor.oauth.credentialSecret-";

            OAuth._redirectUri = (serviceName, config, params, absoluteUrlOptions) => {
              // XXX COMPAT WITH 0.9.0
              // The redirect URI used to have a "?close" query argument.  We
              // detect whether we need to be backwards compatible by checking for
              // the absence of the `loginStyle` field, which wasn't used in the
              // code which had the "?close" argument.
              // This logic is duplicated in the tool so that the tool can do OAuth
              // flow with <= 0.9.0 servers (tools/auth.js).
              const query = config.loginStyle ? null : "close"; // Clone because we're going to mutate 'params'. The 'cordova' and
              // 'android' parameters are only used for picking the host of the
              // redirect URL, and not actually included in the redirect URL itself.

              let isCordova = false;
              let isAndroid = false;

              if (params) {
                params = _objectSpread({}, params);
                isCordova = params.cordova;
                isAndroid = params.android;
                delete params.cordova;
                delete params.android;

                if (Object.keys(params).length === 0) {
                  params = undefined;
                }
              }

              if (Meteor.isServer && isCordova) {
                const url = Npm.require('url');

                let rootUrl = process.env.MOBILE_ROOT_URL || __meteor_runtime_config__.ROOT_URL;

                if (isAndroid) {
                  // Match the replace that we do in cordova boilerplate
                  // (boilerplate-generator package).
                  // XXX Maybe we should put this in a separate package or something
                  // that is used here and by boilerplate-generator? Or maybe
                  // `Meteor.absoluteUrl` should know how to do this?
                  const parsedRootUrl = url.parse(rootUrl);

                  if (parsedRootUrl.hostname === "localhost") {
                    parsedRootUrl.hostname = "10.0.2.2";
                    delete parsedRootUrl.host;
                  }

                  rootUrl = url.format(parsedRootUrl);
                }

                absoluteUrlOptions = _objectSpread(_objectSpread({}, absoluteUrlOptions), {}, {
                  // For Cordova clients, redirect to the special Cordova root url
                  // (likely a local IP in development mode).
                  rootUrl
                });
              }

              return URL._constructUrl(Meteor.absoluteUrl("_oauth/".concat(serviceName), absoluteUrlOptions), query, params);
            };
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "deprecated.js": function _module4() {

            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                     //
            // packages/oauth/deprecated.js                                                                                        //
            //                                                                                                                     //
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // XXX COMPAT WITH 0.8.0
            Oauth = OAuth;
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/oauth/oauth_client.js");
  _require("/node_modules/meteor/oauth/oauth_browser.js");
  _require("/node_modules/meteor/oauth/oauth_common.js");
  _require("/node_modules/meteor/oauth/deprecated.js");

  /* Exports */
  Package._define("oauth", {
    OAuth: OAuth,
    Oauth: Oauth
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Accounts = Package['accounts-base'].Accounts;
  var OAuth = Package.oauth.OAuth;
  var Oauth = Package.oauth.Oauth;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require = meteorInstall({ "node_modules": { "meteor": { "accounts-oauth": { "oauth_common.js": function _module() {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                       //
            // packages/accounts-oauth/oauth_common.js                                                               //
            //                                                                                                       //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            Accounts.oauth = {};
            const services = {};
            const hasOwn = Object.prototype.hasOwnProperty; // Helper for registering OAuth based accounts packages.
            // On the server, adds an index to the user collection.

            Accounts.oauth.registerService = name => {
              if (hasOwn.call(services, name)) throw new Error("Duplicate service: ".concat(name));
              services[name] = true;

              if (Meteor.server) {
                // Accounts.updateOrCreateUserFromExternalService does a lookup by this id,
                // so this should be a unique index. You might want to add indexes for other
                // fields returned by your service (eg services.github.login) but you can do
                // that in your app.
                Meteor.users._ensureIndex("services.".concat(name, ".id"), {
                  unique: true,
                  sparse: true
                });
              }
            }; // Removes a previously registered service.
            // This will disable logging in with this service, and serviceNames() will not
            // contain it.
            // It's worth noting that already logged in users will remain logged in unless
            // you manually expire their sessions.


            Accounts.oauth.unregisterService = name => {
              if (!hasOwn.call(services, name)) throw new Error("Service not found: ".concat(name));
              delete services[name];
            };

            Accounts.oauth.serviceNames = () => Object.keys(services);
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "oauth_client.js": function _module2() {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                       //
            // packages/accounts-oauth/oauth_client.js                                                               //
            //                                                                                                       //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            // Documentation for Meteor.loginWithExternalService

            /**
             * @name loginWith<ExternalService>
             * @memberOf Meteor
             * @function
             * @summary Log the user in using an external service.
             * @locus Client
             * @param {Object} [options]
             * @param {String[]} options.requestPermissions A list of permissions to request from the user.
             * @param {Boolean} options.requestOfflineToken If true, asks the user for permission to act on their behalf when offline. This stores an additional offline token in the `services` field of the user document. Currently only supported with Google.
             * @param {Object} options.loginUrlParameters Provide additional parameters to the authentication URI. Currently only supported with Google. See [Google Identity Platform documentation](https://developers.google.com/identity/protocols/OpenIDConnect#authenticationuriparameters).
             * @param {String} options.loginHint An email address that the external service will use to pre-fill the login prompt. Currently only supported with Meteor developer accounts and Google accounts. If used with Google, the Google User ID can also be passed.
             * @param {String} options.loginStyle Login style ("popup" or "redirect", defaults to the login service configuration).  The "popup" style opens the login page in a separate popup window, which is generally preferred because the Meteor application doesn't need to be reloaded.  The "redirect" style redirects the Meteor application's window to the login page, and the login service provider redirects back to the Meteor application which is then reloaded.  The "redirect" style can be used in situations where a popup window can't be opened, such as in a mobile UIWebView.  The "redirect" style however relies on session storage which isn't available in Safari private mode, so the "popup" style will be forced if session storage can't be used.
             * @param {String} options.redirectUrl If using "redirect" login style, the user will be returned to this URL after authorisation has been completed.
             * @param {Function} [callback] Optional callback. Called with no arguments on success, or with a single `Error` argument on failure. The callback cannot be called if you are using the "redirect" `loginStyle`, because the app will have reloaded in the meantime; try using [client-side login hooks](#accounts_onlogin) instead.
             * @importFromPackage meteor
             */
            // Allow server to specify a specify subclass of errors. We should come
            // up with a more generic way to do this!
            const convertError = err => {
              if (err && err instanceof Meteor.Error && err.error === Accounts.LoginCancelledError.numericError) return new Accounts.LoginCancelledError(err.reason);else return err;
            }; // For the redirect login flow, the final step is that we're
            // redirected back to the application.  The credentialToken for this
            // login attempt is stored in the reload migration data, and the
            // credentialSecret for a successful login is stored in session
            // storage.


            Meteor.startup(() => {
              const oauth = OAuth.getDataAfterRedirect();
              if (!oauth) return; // We'll only have the credentialSecret if the login completed
              // successfully.  However we still call the login method anyway to
              // retrieve the error if the login was unsuccessful.

              const methodName = 'login';
              const {
                credentialToken,
                credentialSecret
              } = oauth;
              const methodArguments = [{
                oauth: {
                  credentialToken,
                  credentialSecret
                }
              }];
              Accounts.callLoginMethod({
                methodArguments,
                userCallback: err => {
                  // The redirect login flow is complete.  Construct an
                  // `attemptInfo` object with the login result, and report back
                  // to the code which initiated the login attempt
                  // (e.g. accounts-ui, when that package is being used).
                  err = convertError(err);

                  Accounts._pageLoadLogin({
                    type: oauth.loginService,
                    allowed: !err,
                    error: err,
                    methodName,
                    methodArguments
                  });
                }
              });
            }); // Send an OAuth login method to the server. If the user authorized
            // access in the popup this should log the user in, otherwise
            // nothing should happen.

            Accounts.oauth.tryLoginAfterPopupClosed = (credentialToken, callback) => {
              const credentialSecret = OAuth._retrieveCredentialSecret(credentialToken) || null;
              Accounts.callLoginMethod({
                methodArguments: [{
                  oauth: {
                    credentialToken,
                    credentialSecret
                  }
                }],
                userCallback: callback && (err => callback(convertError(err)))
              });
            };

            Accounts.oauth.credentialRequestCompleteHandler = callback => credentialTokenOrError => {
              if (credentialTokenOrError && credentialTokenOrError instanceof Error) {
                callback && callback(credentialTokenOrError);
              } else {
                Accounts.oauth.tryLoginAfterPopupClosed(credentialTokenOrError, callback);
              }
            };
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/accounts-oauth/oauth_common.js");
  _require("/node_modules/meteor/accounts-oauth/oauth_client.js");

  /* Exports */
  Package._define("accounts-oauth");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Accounts = Package['accounts-base'].Accounts;
  var Mongo = Package.mongo.Mongo;

  /* Package-scope variables */
  var ServiceConfiguration;

  (function () {

    ////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                    //
    // packages/service-configuration/service_configuration_common.js                     //
    //                                                                                    //
    ////////////////////////////////////////////////////////////////////////////////////////
    //
    if (typeof ServiceConfiguration === 'undefined') {
      ServiceConfiguration = {};
    }

    // Table containing documents with configuration options for each
    // login service
    ServiceConfiguration.configurations = new Mongo.Collection("meteor_accounts_loginServiceConfiguration", {
      _preventAutopublish: true,
      connection: Meteor.isClient ? Accounts.connection : Meteor.connection
    });
    // Leave this collection open in insecure mode. In theory, someone could
    // hijack your oauth connect requests to a different endpoint or appId,
    // but you did ask for 'insecure'. The advantage is that it is much
    // easier to write a configuration wizard that works only in insecure
    // mode.


    // Thrown when trying to use a login service which is not configured
    ServiceConfiguration.ConfigError = function (serviceName) {
      if (Meteor.isClient && !Accounts.loginServicesConfigured()) {
        this.message = "Login service configuration not yet loaded";
      } else if (serviceName) {
        this.message = "Service " + serviceName + " not configured";
      } else {
        this.message = "Service not configured";
      }
    };
    ServiceConfiguration.ConfigError.prototype = new Error();
    ServiceConfiguration.ConfigError.prototype.name = 'ServiceConfiguration.ConfigError';

    ////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("service-configuration", {
    ServiceConfiguration: ServiceConfiguration
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("oauth2");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var OAuth = Package.oauth.OAuth;
  var Oauth = Package.oauth.Oauth;
  var Random = Package.random.Random;
  var ServiceConfiguration = Package['service-configuration'].ServiceConfiguration;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Facebook;

  var _require = meteorInstall({ "node_modules": { "meteor": { "facebook-oauth": { "facebook_client.js": function _module() {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                  //
            // packages/facebook-oauth/facebook_client.js                                                                       //
            //                                                                                                                  //
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            Facebook = {}; // Request Facebook credentials for the user
            //
            // @param options {optional}
            // @param credentialRequestCompleteCallback {Function} Callback function to call on
            //   completion. Takes one argument, credentialToken on success, or Error on
            //   error.

            Facebook.requestCredential = (options, credentialRequestCompleteCallback) => {
              var _Meteor$settings, _Meteor$settings$publ, _Meteor$settings$publ2, _Meteor$settings$publ3;

              // support both (options, callback) and (callback).
              if (!credentialRequestCompleteCallback && typeof options === 'function') {
                credentialRequestCompleteCallback = options;
                options = {};
              }

              const config = ServiceConfiguration.configurations.findOne({
                service: 'facebook'
              });

              if (!config) {
                credentialRequestCompleteCallback && credentialRequestCompleteCallback(new ServiceConfiguration.ConfigError());
                return;
              }

              const credentialToken = Random.secret();
              const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
              const display = mobile ? 'touch' : 'popup';
              let scope = "email";
              if (options && options.requestPermissions) scope = options.requestPermissions.join(',');

              const loginStyle = OAuth._loginStyle('facebook', config, options);

              const API_VERSION = ((_Meteor$settings = Meteor.settings) === null || _Meteor$settings === void 0 ? void 0 : (_Meteor$settings$publ = _Meteor$settings.public) === null || _Meteor$settings$publ === void 0 ? void 0 : (_Meteor$settings$publ2 = _Meteor$settings$publ.packages) === null || _Meteor$settings$publ2 === void 0 ? void 0 : (_Meteor$settings$publ3 = _Meteor$settings$publ2['facebook-oauth']) === null || _Meteor$settings$publ3 === void 0 ? void 0 : _Meteor$settings$publ3.apiVersion) || '10.0';
              let loginUrl = "https://www.facebook.com/v".concat(API_VERSION, "/dialog/oauth?client_id=").concat(config.appId) + "&redirect_uri=".concat(OAuth._redirectUri('facebook', config, options.params, options.absoluteUrlOptions)) + "&display=".concat(display, "&scope=").concat(scope) + "&state=".concat(OAuth._stateParam(loginStyle, credentialToken, options && options.redirectUrl)); // Handle authentication type (e.g. for force login you need auth_type: "reauthenticate")

              if (options && options.auth_type) {
                loginUrl += "&auth_type=".concat(encodeURIComponent(options.auth_type));
              }

              OAuth.launchLogin({
                loginService: "facebook",
                loginStyle,
                loginUrl,
                credentialRequestCompleteCallback,
                credentialToken
              });
            };
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/facebook-oauth/facebook_client.js");

  /* Exports */
  Package._define("facebook-oauth", {
    Facebook: Facebook
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Accounts = Package['accounts-base'].Accounts;
  var Facebook = Package['facebook-oauth'].Facebook;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  var _require = meteorInstall({ "node_modules": { "meteor": { "accounts-facebook": { "notice.js": function _module() {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                       //
            // packages/accounts-facebook/notice.js                                                                  //
            //                                                                                                       //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            if (Package['accounts-ui'] && !Package['service-configuration'] && !Object.prototype.hasOwnProperty.call(Package, 'facebook-config-ui')) {
              console.warn("Note: You're using accounts-ui and accounts-facebook,\n" + "but didn't install the configuration UI for the Facebook\n" + "OAuth. You can install it with:\n" + "\n" + "    meteor add facebook-config-ui" + "\n");
            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "facebook.js": function _module2() {

            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                       //
            // packages/accounts-facebook/facebook.js                                                                //
            //                                                                                                       //
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            Accounts.oauth.registerService('facebook');

            if (Meteor.isClient) {
              const loginWithFacebook = (options, callback) => {
                // support a callback without options
                if (!callback && typeof options === "function") {
                  callback = options;
                  options = null;
                }

                const credentialRequestCompleteCallback = Accounts.oauth.credentialRequestCompleteHandler(callback);
                Facebook.requestCredential(options, credentialRequestCompleteCallback);
              };

              Accounts.registerClientLoginFunction('facebook', loginWithFacebook);

              Meteor.loginWithFacebook = function () {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                return Accounts.applyLoginFunction('facebook', args);
              };
            } else {
              Accounts.addAutopublishFields({
                // publish all fields including access token, which can legitimately
                // be used from the client (if transmitted over ssl or on
                // localhost). https://developers.facebook.com/docs/concepts/login/access-tokens-and-types/,
                // "Sharing of Access Tokens"
                forLoggedInUser: ['services.facebook'],
                forOtherUsers: [// https://www.facebook.com/help/167709519956542
                'services.facebook.id', 'services.facebook.username', 'services.facebook.gender']
              });
            }
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  _require("/node_modules/meteor/accounts-facebook/notice.js");
  _require("/node_modules/meteor/accounts-facebook/facebook.js");

  /* Exports */
  Package._define("accounts-facebook");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var _ = Package.underscore._;
  var check = Package.check.check;
  var Match = Package.check.Match;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var ReactiveVar = Package['reactive-var'].ReactiveVar;

  /* Package-scope variables */
  var Slingshot, matchAllowedFileTypes;

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                      //
    // packages/ivadey_slingshot/lib/restrictions.js                                        //
    //                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////
    //
    /**
     * @module meteor-slingshot
     */

    Slingshot = {};

    /* global matchAllowedFileTypes: true */
    matchAllowedFileTypes = Match.OneOf(String, [String], RegExp, null);

    /**
     * List of configured restrictions by name.
     *
     * @type {Object.<String, Function>}
     * @private
     */

    Slingshot._restrictions = {};

    /**
     * Creates file upload restrictions for a specific directive.
     *
     * @param {string} name - A unique identifier of the directive.
     * @param {Object} restrictions - The file upload restrictions.
     * @returns {Object}
     */

    Slingshot.fileRestrictions = function (name, restrictions) {
      check(restrictions, {
        authorize: Match.Optional(Function),
        maxSize: Match.Optional(Match.OneOf(Number, null)),
        allowedFileTypes: Match.Optional(matchAllowedFileTypes)
      });

      if (Meteor.isServer) {
        var directive = Slingshot.getDirective(name);
        if (directive) {
          _.extend(directive._directive, restrictions);
        }
      }

      return Slingshot._restrictions[name] = _.extend(Slingshot._restrictions[name] || {}, restrictions);
    };

    /**
     * @param {string} name - The unique identifier of the directive to
     * retrieve the restrictions for.
     * @returns {Object}
     */

    Slingshot.getRestrictions = function (name) {
      return this._restrictions[name] || {};
    };

    //////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                      //
    // packages/ivadey_slingshot/lib/validators.js                                          //
    //                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////
    //
    Slingshot.Validators = {

      /**
       *
       * @method checkAll
       *
       * @throws Meteor.Error
       *
       * @param {Object} context
       * @param {FileInfo} file
       * @param {Object} [meta]
       * @param {Object} [restrictions]
       *
       * @returns {Boolean}
       */

      checkAll: function (context, file, meta, restrictions) {
        return this.checkFileSize(file.size, restrictions.maxSize) && this.checkFileType(file.type, restrictions.allowedFileTypes) && (typeof restrictions.authorize !== 'function' || restrictions.authorize.call(context, file, meta));
      },

      /**
       * @throws Meteor.Error
       *
       * @param {Number} size - Size of file in bytes.
       * @param {Number} maxSize - Max size of file in bytes.
       * @returns {boolean}
       */

      checkFileSize: function (size, maxSize) {
        maxSize = Math.min(maxSize, Infinity);

        if (maxSize && size > maxSize) throw new Meteor.Error("Upload denied", "File exceeds allowed size of " + formatBytes(maxSize));

        return true;
      },

      /**
       *
       * @throws Meteor.Error
       *
       * @param {String} type - Mime type
       * @param {(RegExp|Array|String)} [allowed] - Allowed file type(s)
       * @returns {boolean}
       */

      checkFileType: function (type, allowed) {
        if (allowed instanceof RegExp) {

          if (!allowed.test(type)) throw new Meteor.Error("Upload denied", type + " is not an allowed file type");

          return true;
        }

        if (_.isArray(allowed)) {
          if (allowed.indexOf(type) < 0) {
            throw new Meteor.Error("Upload denied", type + " is not one of the followed allowed file types: " + allowed.join(", "));
          }

          return true;
        }

        if (allowed && allowed !== type) {
          throw new Meteor.Error("Upload denied", "Only files of type " + allowed + " can be uploaded");
        }

        return true;
      }
    };

    /** Human readable data-size in bytes.
     *
     * @param size {Number}
     * @returns {string}
     */

    function formatBytes(size) {
      var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'],
          unit = units.shift();

      while (size >= 0x400 && units.length) {
        size /= 0x400;
        unit = units.shift();
      }

      return Math.round(size * 100) / 100 + " " + unit;
    }

    //////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  (function () {

    //////////////////////////////////////////////////////////////////////////////////////////
    //                                                                                      //
    // packages/ivadey_slingshot/lib/upload.js                                              //
    //                                                                                      //
    //////////////////////////////////////////////////////////////////////////////////////////
    //
    /**
     * @fileOverview Defines client side API in which files can be uploaded.
     */

    /**
     *
     * @param {string} directive - Name of server-directive to use.
     * @param {object} [metaData] - Data to be sent to directive.
     * @constructor
     */

    Slingshot.Upload = function (directive, metaData) {

      if (!window.File || !window.FormData) {
        throw new Error("Browser does not support HTML5 uploads");
      }

      var self = this,
          loaded = new ReactiveVar(),
          total = new ReactiveVar(),
          status = new ReactiveVar("idle"),
          dataUri,
          preloaded;

      function buildFormData() {
        var formData = new window.FormData();

        _.each(self.instructions.postData, function (field) {
          formData.append(field.name, field.value);
        });

        formData.append("file", self.file);

        return formData;
      }

      _.extend(self, {

        /**
         * @returns {string}
         */

        status: function () {
          return status.get();
        },

        /**
         * @returns {number}
         */

        progress: function () {
          return self.uploaded() / total.get() || 0;
        },

        /**
         * @returns {number}
         */

        uploaded: function () {
          return loaded.get();
        },

        /**
         * @param {File} file
         * @returns {null|Error} Returns null on success, Error on failure.
         */

        validate: function (file) {
          var context = {
            userId: Meteor.userId && Meteor.userId()
          };
          try {
            var validators = Slingshot.Validators,
                restrictions = Slingshot.getRestrictions(directive);

            validators.checkAll(context, file, metaData, restrictions) && null;
          } catch (error) {
            return error;
          }
        },

        /**
         * @param {(File|Blob)} file
         * @param {Function} [callback]
         * @returns {Slingshot.Upload}
         */

        send: function (file, callback) {
          if (!(file instanceof window.File) && !(file instanceof window.Blob)) throw new Error("Not a file");

          self.file = file;

          self.request(function (error, instructions) {
            if (error) {
              return callback(error);
            }

            self.instructions = instructions;

            self.transfer(callback);
          });

          return self;
        },

        /**
         * @param {Function} [callback]
         * @returns {Slingshot.Upload}
         */

        request: function (callback) {

          if (!self.file) {
            callback(new Error("No file to request upload for"));
          }

          var file = _.pick(self.file, "name", "size", "type");

          status.set("authorizing");

          var error = this.validate(file);
          if (error) {
            status.set("failed");
            callback(error);
            return self;
          }

          Meteor.call("slingshot/uploadRequest", directive, file, metaData, function (error, instructions) {
            status.set(error ? "failed" : "authorized");
            callback(error, instructions);
          });

          return self;
        },

        /**
         * @param {Function} [callback]
         *
         * @returns {Slingshot.Upload}
         */

        transfer: function (callback) {
          if (status.curValue !== "authorized") {
            throw new Error("Cannot transfer file at upload status: " + status.curValue);
          }

          status.set("transferring");
          loaded.set(0);

          var xhr = new XMLHttpRequest();

          xhr.upload.addEventListener("progress", function (event) {
            if (event.lengthComputable) {
              loaded.set(event.loaded);
              total.set(event.total);
            }
          }, false);

          function getError() {
            return new Meteor.Error(xhr.statusText + " - " + xhr.status, "Failed to upload file to cloud storage");
          }

          xhr.addEventListener("load", function () {

            if (xhr.status < 400) {
              status.set("done");
              loaded.set(total.get());
              callback(null, self.instructions.download);
            } else {
              status.set("failed");
              callback(getError());
            }
          });

          xhr.addEventListener("error", function () {
            status.set("failed");
            callback(getError());
          });

          xhr.addEventListener("abort", function () {
            status.set("aborted");
            callback(new Meteor.Error("Aborted", "The upload has been aborted by the user"));
          });

          xhr.open(self.instructions.method || "POST", self.instructions.upload, true);

          _.each(self.instructions.headers, function (value, key) {
            xhr.setRequestHeader(key, value);
          });

          if (self.instructions.method === 'PUT') {
            xhr.overrideMimeType(self.file.type);
            xhr.send(self.file);
          } else {
            xhr.send(buildFormData());
          }

          self.xhr = xhr;

          return self;
        },

        /**
         * @returns {boolean}
         */

        isImage: function () {
          self.status(); //React to status change.
          return Boolean(self.file && self.file.type.split("/")[0] === "image");
        },

        /**
         * Latency compensated url of the file to be uploaded.
         *
         * @param {boolean} preload
         *
         * @returns {string}
         */

        url: function (preload) {
          if (!dataUri) {
            var localUrl = new ReactiveVar(),
                URL = window.URL || window.webkitURL;

            dataUri = new ReactiveVar();

            Tracker.nonreactive(function () {

              /*
               It is important that we generate the local url not more than once
               throughout the entire lifecycle of `self` to prevent flickering.
               */

              var previewRequirement = new Tracker.Dependency();

              Tracker.autorun(function (computation) {
                if (self.file) {
                  if (URL) {
                    localUrl.set(URL.createObjectURL(self.file));
                    computation.stop();
                  } else if (Tracker.active && window.FileReader) {
                    readDataUrl(self.file, function (result) {
                      localUrl.set(result);
                      computation.stop();
                    });
                  }
                } else {
                  previewRequirement.depend();
                }
              });

              Tracker.autorun(function (computation) {
                var status = self.status();

                if (self.instructions && status === "done") {
                  computation.stop();
                  dataUri.set(self.instructions.download);
                } else if (status === "failed" || status === "aborted") {
                  computation.stop();
                } else if (self.file && !dataUri.curValue) {
                  previewRequirement.changed();
                  dataUri.set(localUrl.get());
                }
              });
            });
          }

          if (preload) {

            if (self.file && !self.isImage()) throw new Error("Cannot pre-load anything other than images");

            if (!preloaded) {
              Tracker.nonreactive(function () {
                preloaded = new ReactiveVar();

                Tracker.autorun(function (computation) {
                  var url = dataUri.get();

                  if (self.instructions) {
                    preloadImage(url, function () {
                      computation.stop();
                      preloaded.set(url);
                    });
                  } else preloaded.set(url);
                });
              });
            }

            return preloaded.get();
          } else return dataUri.get();
        },

        /** Gets an upload parameter for the directive.
         *
         * @param {String} name
         * @returns {String|Number|Undefined}
         */

        param: function (name) {
          self.status(); //React to status changes.

          var data = self.instructions && self.instructions.postData,
              field = data && _.findWhere(data, { name: name });

          return field && field.value;
        }

      });
    };

    /**
     *
     * @param {String} image - URL of image to preload.
     * @param {Function} callback
     */

    function preloadImage(image, callback) {
      var preloader = new window.Image();

      preloader.onload = callback;

      preloader.src = image;
    }

    function readDataUrl(file, callback) {
      var reader = new window.FileReader();

      reader.onloadend = function () {
        callback(reader.result);
      };

      reader.readAsDataURL(file);
    }

    //////////////////////////////////////////////////////////////////////////////////////////
  }).call(this);

  /* Exports */
  Package._define("ivadey:slingshot", {
    Slingshot: Slingshot
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var WebApp;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "webapp": { "webapp_client.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                                    //
            // packages/webapp/webapp_client.js                                                                                   //
            //                                                                                                                    //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              WebApp: () => WebApp
            });
            const WebApp = {
              _isCssLoaded() {
                if (document.styleSheets.length === 0) {
                  return true;
                }

                return Array.prototype.find.call(document.styleSheets, sheet => {
                  if (sheet.cssText && !sheet.cssRules) {
                    // IE8
                    return !sheet.cssText.match(/meteor-css-not-found-error/);
                  }

                  return !Array.prototype.find.call(sheet.cssRules, rule => rule.selectorText === '.meteor-css-not-found-error');
                });
              }

            };
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/webapp/webapp_client.js");

  /* Exports */
  Package._define("webapp", _exports2, {
    WebApp: WebApp
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var DDP = Package['ddp-client'].DDP;

  /* Package-scope variables */
  var LivedataTest;

  /* Exports */
  Package._define("livedata", {
    DDP: DDP,
    LivedataTest: LivedataTest
  });
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Exports */
  Package._define("hot-code-push");
})();//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

  /* Imports */
  var Meteor = Package.meteor.Meteor;
  var global = Package.meteor.global;
  var meteorEnv = Package.meteor.meteorEnv;
  var Tracker = Package.tracker.Tracker;
  var Deps = Package.tracker.Deps;
  var Retry = Package.retry.Retry;
  var DDP = Package['ddp-client'].DDP;
  var meteorInstall = Package.modules.meteorInstall;
  var Promise = Package.promise.Promise;

  /* Package-scope variables */
  var Autoupdate;

  var _require2 = meteorInstall({ "node_modules": { "meteor": { "autoupdate": { "autoupdate_client.js": function module(_require, _exports, _module) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                            //
            // packages/autoupdate/autoupdate_client.js                                                                   //
            //                                                                                                            //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            _module.export({
              Autoupdate: () => Autoupdate
            });
            let ClientVersions;
            _module.link("./client_versions.js", {
              ClientVersions(v) {
                ClientVersions = v;
              }

            }, 0);
            const clientArch = Meteor.isCordova ? "web.cordova" : Meteor.isModern ? "web.browser" : "web.browser.legacy";
            const autoupdateVersions = ((__meteor_runtime_config__.autoupdate || {}).versions || {})[clientArch] || {
              version: "unknown",
              versionRefreshable: "unknown",
              versionNonRefreshable: "unknown",
              assets: []
            };
            const Autoupdate = {};
            // Stores acceptable client versions.
            const clientVersions = Autoupdate._clientVersions = // Used by a self-test.
            new ClientVersions();
            Meteor.connection.registerStore("meteor_autoupdate_clientVersions", clientVersions.createStore());

            Autoupdate.newClientAvailable = function () {
              return clientVersions.newClientAvailable(clientArch, ["versionRefreshable", "versionNonRefreshable"], autoupdateVersions);
            }; // Set to true if the link.onload callback ever fires for any <link> node.


            let knownToSupportCssOnLoad = false;
            const retry = new Retry({
              // Unlike the stream reconnect use of Retry, which we want to be instant
              // in normal operation, this is a wacky failure. We don't want to retry
              // right away, we can start slowly.
              //
              // A better way than timeconstants here might be to use the knowledge
              // of when we reconnect to help trigger these retries. Typically, the
              // server fixing code will result in a restart and reconnect, but
              // potentially the subscription could have a transient error.
              minCount: 0,
              // don't do any immediate retries
              baseTimeout: 30 * 1000 // start with 30s

            });
            let failures = 0;

            Autoupdate._retrySubscription = () => {
              Meteor.subscribe("meteor_autoupdate_clientVersions", {
                onError(error) {
                  Meteor._debug("autoupdate subscription failed", error);

                  failures++;
                  retry.retryLater(failures, function () {
                    // Just retry making the subscription, don't reload the whole
                    // page. While reloading would catch more cases (for example,
                    // the server went back a version and is now doing old-style hot
                    // code push), it would also be more prone to reload loops,
                    // which look really bad to the user. Just retrying the
                    // subscription over DDP means it is at least possible to fix by
                    // updating the server.
                    Autoupdate._retrySubscription();
                  });
                },

                onReady() {
                  // Call checkNewVersionDocument with a slight delay, so that the
                  // const handle declaration is guaranteed to be initialized, even if
                  // the added or changed callbacks are called synchronously.
                  const resolved = Promise.resolve();

                  function check(doc) {
                    resolved.then(() => checkNewVersionDocument(doc));
                  }

                  const stop = clientVersions.watch(check);

                  function checkNewVersionDocument(doc) {
                    if (doc._id !== clientArch) {
                      return;
                    }

                    if (doc.versionNonRefreshable !== autoupdateVersions.versionNonRefreshable) {
                      // Non-refreshable assets have changed, so we have to reload the
                      // whole page rather than just replacing <link> tags.
                      if (stop) stop();

                      if (Package.reload) {
                        // The reload package should be provided by ddp-client, which
                        // is provided by the ddp package that autoupdate depends on.
                        Package.reload.Reload._reload();
                      }

                      return;
                    }

                    if (doc.versionRefreshable !== autoupdateVersions.versionRefreshable) {
                      autoupdateVersions.versionRefreshable = doc.versionRefreshable; // Switch out old css links for the new css links. Inspired by:
                      // https://github.com/guard/guard-livereload/blob/master/js/livereload.js#L710

                      var newCss = doc.assets || [];
                      var oldLinks = [];
                      Array.prototype.forEach.call(document.getElementsByTagName('link'), function (link) {
                        if (link.className === '__meteor-css__') {
                          oldLinks.push(link);
                        }
                      });

                      function waitUntilCssLoads(link, callback) {
                        var called;

                        link.onload = function () {
                          knownToSupportCssOnLoad = true;

                          if (!called) {
                            called = true;
                            callback();
                          }
                        };

                        if (!knownToSupportCssOnLoad) {
                          var id = Meteor.setInterval(function () {
                            if (link.sheet) {
                              if (!called) {
                                called = true;
                                callback();
                              }

                              Meteor.clearInterval(id);
                            }
                          }, 50);
                        }
                      }

                      let newLinksLeftToLoad = newCss.length;

                      function removeOldLinks() {
                        if (oldLinks.length > 0 && --newLinksLeftToLoad < 1) {
                          oldLinks.splice(0).forEach(link => {
                            link.parentNode.removeChild(link);
                          });
                        }
                      }

                      if (newCss.length > 0) {
                        newCss.forEach(css => {
                          const newLink = document.createElement("link");
                          newLink.setAttribute("rel", "stylesheet");
                          newLink.setAttribute("type", "text/css");
                          newLink.setAttribute("class", "__meteor-css__");
                          newLink.setAttribute("href", css.url);
                          waitUntilCssLoads(newLink, function () {
                            Meteor.setTimeout(removeOldLinks, 200);
                          });
                          const head = document.getElementsByTagName("head").item(0);
                          head.appendChild(newLink);
                        });
                      } else {
                        removeOldLinks();
                      }
                    }
                  }
                }

              });
            };

            Autoupdate._retrySubscription();
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          }, "client_versions.js": function module(_require3, _exports3, _module2) {

            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //                                                                                                            //
            // packages/autoupdate/client_versions.js                                                                     //
            //                                                                                                            //
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //
            let _objectSpread;

            _module2.link("@babel/runtime/helpers/objectSpread2", {
              default(v) {
                _objectSpread = v;
              }

            }, 0);
            _module2.export({
              ClientVersions: () => ClientVersions
            });
            let Tracker;
            _module2.link("meteor/tracker", {
              Tracker(v) {
                Tracker = v;
              }

            }, 0);

            class ClientVersions {
              constructor() {
                this._versions = new Map();
                this._watchCallbacks = new Set();
              } // Creates a Livedata store for use with `Meteor.connection.registerStore`.
              // After the store is registered, document updates reported by Livedata are
              // merged with the documents in this `ClientVersions` instance.


              createStore() {
                return {
                  update: _ref => {
                    let {
                      id,
                      msg,
                      fields
                    } = _ref;

                    if (msg === "added" || msg === "changed") {
                      this.set(id, fields);
                    }
                  }
                };
              }

              hasVersions() {
                return this._versions.size > 0;
              }

              get(id) {
                return this._versions.get(id);
              } // Adds or updates a version document and invokes registered callbacks for the
              // added/updated document. If a document with the given ID already exists, its
              // fields are merged with `fields`.


              set(id, fields) {
                let version = this._versions.get(id);

                let isNew = false;

                if (version) {
                  Object.assign(version, fields);
                } else {
                  version = _objectSpread({
                    _id: id
                  }, fields);
                  isNew = true;

                  this._versions.set(id, version);
                }

                this._watchCallbacks.forEach(_ref2 => {
                  let {
                    fn,
                    filter
                  } = _ref2;

                  if (!filter || filter === version._id) {
                    fn(version, isNew);
                  }
                });
              } // Registers a callback that will be invoked when a version document is added
              // or changed. Calling the function returned by `watch` removes the callback.
              // If `skipInitial` is true, the callback isn't be invoked for existing
              // documents. If `filter` is set, the callback is only invoked for documents
              // with ID `filter`.


              watch(fn) {
                let {
                  skipInitial,
                  filter
                } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (!skipInitial) {
                  const resolved = Promise.resolve();

                  this._versions.forEach(version => {
                    if (!filter || filter === version._id) {
                      resolved.then(() => fn(version, true));
                    }
                  });
                }

                const callback = {
                  fn,
                  filter
                };

                this._watchCallbacks.add(callback);

                return () => this._watchCallbacks.delete(callback);
              } // A reactive data source for `Autoupdate.newClientAvailable`.


              newClientAvailable(id, fields, currentVersion) {
                function isNewVersion(version) {
                  return version._id === id && fields.some(field => version[field] !== currentVersion[field]);
                }

                const dependency = new Tracker.Dependency();
                const version = this.get(id);
                dependency.depend();
                const stop = this.watch(version => {
                  if (isNewVersion(version)) {
                    dependency.changed();
                    stop();
                  }
                }, {
                  skipInitial: true
                });
                return !!version && isNewVersion(version);
              }

            }
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          } } } } }, {
    "extensions": [".js", ".json"]
  });

  var _exports2 = _require2("/node_modules/meteor/autoupdate/autoupdate_client.js");

  /* Exports */
  Package._define("autoupdate", _exports2, {
    Autoupdate: Autoupdate
  });
})();/* Imports for global scope */

Mongo = Package.mongo.Mongo;
Tracker = Package.tracker.Tracker;
Deps = Package.tracker.Deps;
Roles = Package['alanning:roles'].Roles;
HTTP = Package.http.HTTP;
Slingshot = Package['ivadey:slingshot'].Slingshot;
Meteor = Package.meteor.Meteor;
global = Package.meteor.global;
meteorEnv = Package.meteor.meteorEnv;
WebApp = Package.webapp.WebApp;
DDP = Package['ddp-client'].DDP;
Accounts = Package['accounts-base'].Accounts;
Facebook = Package['facebook-oauth'].Facebook;
Autoupdate = Package.autoupdate.Autoupdate;
Reload = Package.reload.Reload;// Disable hot-code-push
if (Package.reload) {
  Package.reload.Reload._onMigrate(function () {
    return [false];
  });
}